webpackJsonp([1],{

/***/ "++Hh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("LShn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53aecfee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("e9Of");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("XBeV")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53aecfee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53aecfee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53aecfee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+4WN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUTH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUTH_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUTH_LOGOUT; });
var AUTH_REQUEST = 'AUTH_REQUEST';
var AUTH_SUCCESS = 'AUTH_SUCCESS';
var AUTH_ERROR = 'AUTH_ERROR';
var AUTH_LOGOUT = 'AUTH_LOGOUT';
// /* global localStorage */

// import User from '@/models/User'
// import * as MutationTypes from './mutation-types'

// const state = {
//   user: User.from(localStorage.token)
// }

// const mutations = {
//   [MutationTypes.LOGIN] (state) {
//     state.user = User.from(localStorage.token)
//   },
//   [MutationTypes.LOGOUT] (state) {
//     state.user = null
//   }
// }

// const getters = {
//   currentUser (state) {
//     return state.user
//   }
// }

// const actions = {
//   login ({ commit }) {
//     commit(MutationTypes.LOGIN)
//   },

//   logout ({ commit }) {
//     commit(MutationTypes.LOGOUT)
//   }
// }

// export default {
//   state,
//   mutations,
//   getters,
//   actions
// }

/***/ }),

/***/ "+B1h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"black","dark":"","small":"","round":""},on:{"click":function($event){_vm.add_new_dialog=true}}},[_vm._v("+")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"900px"},model:{value:(_vm.add_new_dialog),callback:function ($$v) {_vm.add_new_dialog=$$v},expression:"add_new_dialog"}},[_c('v-card',{staticClass:"elevation-0 xs12 pa-4"},[_c('v-card-title',{staticClass:"headline"},[_vm._v("Add New Tag")]),_vm._v(" "),(_vm.c_user.edit)?_c('v-card-title',{class:{
            'my-0': true,
            black: _vm.save_tag_form_display || _vm.save_tag_category_form_display
          }},[_c('v-btn-toggle',{attrs:{"mandatory":""},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}},[_c('v-btn',{attrs:{"flat":"","value":"concept"}},[_c('span',[_vm._v("Conceptual")])]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","value":"cataloguing"}},[_c('span',[_vm._v("Cataloguing")])]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","value":"private"}},[_c('span',[_vm._v("Private")])])],1)],1):_vm._e(),_vm._v(" "),_c('v-card-title',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs6":"","mx-2":""}},[_c('v-combobox',{attrs:{"items":_vm.all_categories,"label":"Tag Category"},model:{value:(_vm.subcategory),callback:function ($$v) {_vm.subcategory=$$v},expression:"subcategory"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mx-2":""}},[_c('v-text-field',{staticClass:"input-group mt-4 py-0",attrs:{"label":"Tag Title","flat":"","value":"","dark":_vm.save_tag_form_display},model:{value:(_vm.tag_title),callback:function ($$v) {_vm.tag_title=$$v},expression:"tag_title"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"black"},on:{"click":function($event){_vm.add_new_dialog=false}}},[_vm._v("Cancel")]),_vm._v(" "),(this.tag_title.length > 0)?_c('v-btn',{attrs:{"outline":"","color":"green"},on:{"click":_vm.create_tag}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(_vm.save_tag_category_form_display)?_c('v-list-tile',[_c('v-layout',{attrs:{"row":"","my-0":"","py-0":"","mx-0":""}},[_c('v-flex',{attrs:{"xs12":"","my-0":"","py-0":""}},[_c('v-text-field',{staticClass:"input-group dark mt-4 py-0 mr-3",attrs:{"solo":"","value":"","color":"white","dark":_vm.save_tag_category_form_display},model:{value:(_vm.tag_category_name),callback:function ($$v) {_vm.tag_category_name=$$v},expression:"tag_category_name"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"black"},on:{"click":function($event){_vm.add_new_dialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),(this.tag_category_name.length > 0)?_c('v-btn',{attrs:{"outline":"","color":"green"},on:{"click":_vm.create_tag_category}},[_vm._v("Save")]):_vm._e()],1):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "+KPd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('toolbar'),_vm._v(" "),_c('v-content',[_c('v-container',{staticClass:"fill-height px-0 pt-0",attrs:{"fluid":"","white":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "+KYf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{staticClass:"px-2 navbar",staticStyle:{"position":"fixed","top":"0px"},attrs:{"width":_vm.filter_view != 'filter' ? 900 : 600,"fixed":"","absolute":"","temporary":"","right":"","dark":"","hide-overlay":""},model:{value:(_vm.options_c),callback:function ($$v) {_vm.options_c=$$v},expression:"options_c"}},[_c('v-layout',{attrs:{"row":"","pt-0":"","mt-2":"","pl-2":"","white--text":""}},[_c('v-flex',{class:[
          {
            xs3: _vm.filter_view == 'data',
            xs6: _vm.filter_view == 'filter',
          },
          'pl-2 pt-3 pb-0 ml-1' ]},[_c('a',{class:[
            {
              'grey--text text--darken-2': _vm.filter_view != 'filter',
              'white--text': _vm.filter_view == 'filter',
            },
            'font-weight-regular headline font-weight-thin' ],on:{"click":function($event){_vm.filter_view = 'filter'}}},[_vm._v("Filter Artworks")])]),_vm._v(" "),_c('v-flex',{class:[
          {
            xs3: _vm.filter_view == 'data',
            xs6: _vm.filter_view == 'filter',
          },
          'pl-3 pt-3 pb-0' ]},[_c('a',{class:[
            {
              'grey--text text--darken-2': _vm.filter_view != 'data',
              'white--text': _vm.filter_view == 'data',
            },
            'font-weight-regular headline font-weight-thin' ],on:{"click":function($event){_vm.filter_view = 'data'}}},[_vm._v("Export")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-2 mt-3",attrs:{"icon":"","color":""},on:{"click":function($event){return _vm.closeOptions()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.filter_view == 'filter'),expression:"filter_view == 'filter'"}],attrs:{"row":"","wrap":"","pt-0":"","px-3":"","ml-2":"","mt-2":""}},[_c('v-flex',{staticClass:"text-xs-left mr-0 white--text",attrs:{"xs12":""}},[_c('p-check',{attrs:{"color":"white"},model:{value:(_vm.use_current_selection),callback:function ($$v) {_vm.use_current_selection=$$v},expression:"use_current_selection"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v("Use artworks in current selection ("+_vm._s(this.currentSelection.length)+")")])]),_vm._v(" "),_c('p-check',{attrs:{"color":"white"},model:{value:(_vm.add_current_selection),callback:function ($$v) {_vm.add_current_selection=$$v},expression:"add_current_selection"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v("Add artworks in current selection to artworks filtered below ("+_vm._s(this.currentSelection.length)+")")])]),_vm._v(" "),_c('p-check',{attrs:{"color":"white"},model:{value:(_vm.use_current_list_selection),callback:function ($$v) {_vm.use_current_list_selection=$$v},expression:"use_current_list_selection"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v("Use checked artworks in filtered selection bellow ("+_vm._s(this.currentListSelection.length)+")")])])],1),_vm._v(" "),(_vm.filter_view == 'filter')?_c('v-divider',{staticClass:"mx-1 pb-0 my-3 white"}):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"xs12 pt-3 pb-2 px-1 font-weight-regular display-1 white--text"},[_c('v-autocomplete',{attrs:{"items":_vm.all_properties,"label":"Select field to filter by:","item-text":"name","single-line":"","menu-props":"bottom"},model:{value:(_vm.filteredProperty),callback:function ($$v) {_vm.filteredProperty=$$v},expression:"filteredProperty"}})],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredProperty == 'location_history'),expression:"filteredProperty == 'location_history'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.locations,"item-text":"name","item-value":"id","label":"Select Location"},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{staticClass:"pr-2",attrs:{"label":"Date from","placeholder":"YYYY-MM-DD"},model:{value:(_vm.query_from),callback:function ($$v) {_vm.query_from=$$v},expression:"query_from"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Date to","placeholder":"YYYY-MM-DD"},model:{value:(_vm.query_to),callback:function ($$v) {_vm.query_to=$$v},expression:"query_to"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 pt-0 pb-2 font-weight-regular display-1 white--text"},[_c('v-text-field',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.text_properties.some(function (tp) {
              return tp.value == _vm.filteredProperty
            })
          ),expression:"\n            text_properties.some((tp) => {\n              return tp.value == filteredProperty\n            })\n          "}],attrs:{"xs12":"","label":"Enter value"},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}}),_vm._v(" "),_vm._l((this.constants.ACQUISITION_METHODS),function(c){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredProperty == 'acquisition_method'),expression:"filteredProperty == 'acquisition_method'"}],key:'as' + c.id},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"color":"white","hide-details":"","label":c.name,"value":c.id},model:{value:(_vm.query_array),callback:function ($$v) {_vm.query_array=$$v},expression:"query_array"}})],1)],1)}),_vm._v(" "),_vm._l((this.$store.getters.my_ownerships),function(c){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredProperty == 'ownership'),expression:"filteredProperty == 'ownership'"}],key:c.id},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"color":"white","hide-details":"","label":c.name,"value":c.id},model:{value:(_vm.query_array),callback:function ($$v) {_vm.query_array=$$v},expression:"query_array"}})],1)],1)}),_vm._v(" "),_vm._l((this.constants.OWNERSHIP_STATUSES),function(c){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredProperty == 'acquired'),expression:"filteredProperty == 'acquired'"}],key:c.name},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"color":"white","hide-details":"","label":c.name,"value":c.id},model:{value:(_vm.query_array),callback:function ($$v) {_vm.query_array=$$v},expression:"query_array"}})],1)],1)}),_vm._v(" "),_vm._l((this.constants.VISA_STATUSES),function(c){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredProperty == 'visa_status'),expression:"filteredProperty == 'visa_status'"}],key:c.name},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-checkbox',{attrs:{"color":"white","hide-details":"","label":c.name,"value":c.id},model:{value:(_vm.query_array),callback:function ($$v) {_vm.query_array=$$v},expression:"query_array"}})],1)],1)}),_vm._v(" "),_c('v-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredProperty == 'type_of_work_id'),expression:"filteredProperty == 'type_of_work_id'"}],attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((this.constants.TYPES_OF_WORK),function(c){return _c('v-flex',{key:c.id,attrs:{"xs12":"","lg6":""}},[_c('v-checkbox',{attrs:{"color":"white","hide-details":"","label":c.name,"value":c.value},model:{value:(_vm.query_array),callback:function ($$v) {_vm.query_array=$$v},expression:"query_array"}})],1)}),1)],1),_vm._v(" "),_c('v-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredProperty == 'tags'),expression:"filteredProperty == 'tags'"}],attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"hide-details":"","label":"Tags","multiple":"","chips":"","items":_vm.select_tags_assign,"item-text":"name","item-value":"id"},model:{value:(_vm.query_array),callback:function ($$v) {_vm.query_array=$$v},expression:"query_array"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.filteredProperty == 'acquisition_date' ||
            _vm.filteredProperty == 'import_date'
          ),expression:"\n            filteredProperty == 'acquisition_date' ||\n            filteredProperty == 'import_date'\n          "}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-menu',{ref:"menu_acq_from",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu_acq_from),callback:function ($$v) {_vm.menu_acq_from=$$v},expression:"menu_acq_from"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.query_from),callback:function ($$v) {_vm.query_from=$$v},expression:"query_from"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"max":new Date().toISOString().substr(0, 10),"min":"1956-01-01","color":"black"},model:{value:(_vm.query_from),callback:function ($$v) {_vm.query_from=$$v},expression:"query_from"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-menu',{ref:"menu_acq_to",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu_acq_to),callback:function ($$v) {_vm.menu_acq_to=$$v},expression:"menu_acq_to"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.query_to),callback:function ($$v) {_vm.query_to=$$v},expression:"query_to"}}),_vm._v(" "),_c('v-date-picker',{ref:"picker",attrs:{"max":new Date().toISOString().substr(0, 10),"color":"black","min":"1956-01-01"},model:{value:(_vm.query_to),callback:function ($$v) {_vm.query_to=$$v},expression:"query_to"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.filteredProperty == 'production_date_new' ||
            _vm.filteredProperty == 'deaccession_date'
          ),expression:"\n            filteredProperty == 'production_date_new' ||\n            filteredProperty == 'deaccession_date'\n          "}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{staticClass:"pr-2",attrs:{"label":"Year from"},model:{value:(_vm.query_from),callback:function ($$v) {_vm.query_from=$$v},expression:"query_from"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"label":"Year to"},model:{value:(_vm.query_to),callback:function ($$v) {_vm.query_to=$$v},expression:"query_to"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredProperty == 'artwork_location_id'),expression:"filteredProperty == 'artwork_location_id'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.locations,"item-text":"name","item-value":"id","label":"Select Locations","multiple":"","chips":""},model:{value:(_vm.query_array),callback:function ($$v) {_vm.query_array=$$v},expression:"query_array"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredProperty == 'accession_number'),expression:"filteredProperty == 'accession_number'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md3":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"Enter value 1","color":"white"},model:{value:(_vm.anquery1),callback:function ($$v) {_vm.anquery1=$$v},expression:"anquery1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Enter value 2","color":"white"},model:{value:(_vm.anquery2),callback:function ($$v) {_vm.anquery2=$$v},expression:"anquery2"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md3":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"Enter value 3","color":"white"},model:{value:(_vm.anquery3),callback:function ($$v) {_vm.anquery3=$$v},expression:"anquery3"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Enter value 4","color":"white"},model:{value:(_vm.anquery4),callback:function ($$v) {_vm.anquery4=$$v},expression:"anquery4"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredProperty == 'exhibitions'),expression:"filteredProperty == 'exhibitions'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":this.exhibitions,"item-text":"select_text","item-value":"id","label":"Select Exhibitions","chips":"","multiple":""},model:{value:(_vm.query_array),callback:function ($$v) {_vm.query_array=$$v},expression:"query_array"}})],1)],1),_vm._v(" "),_c('v-switch',{directives:[{name:"show",rawName:"v-show",value:(
            _vm.bool_properties.some(function (tp) {
              return tp.value == _vm.filteredProperty
            })
          ),expression:"\n            bool_properties.some((tp) => {\n              return tp.value == filteredProperty\n            })\n          "}],staticClass:"pt-3 ml-3",attrs:{"label":_vm.filteredProperty,"color":"black"},model:{value:(_vm.query),callback:function ($$v) {_vm.query=$$v},expression:"query"}})],2),_vm._v(" "),(_vm.filteredProperty != 0)?_c('v-flex',{attrs:{"xs12":"","text-xs-center":"","mb-2":""}},[_c('v-btn',{staticClass:"mt-2",attrs:{"outline":"","elevation-2":"","mb-0":""},on:{"click":function($event){$event.preventDefault();return _vm.addFilter.apply(null, arguments)}}},[_vm._v("ACTIVATE FILTER")])],1):_vm._e()],1),_vm._v(" "),_c('v-list',{directives:[{name:"show",rawName:"v-show",value:(_vm.filter_view == 'filter' && this.activeFilters.length > 0),expression:"filter_view == 'filter' && this.activeFilters.length > 0"}],staticClass:"white--text mx-3 pt-2 mt-0",staticStyle:{"background-color":"#444"}},[_c('v-flex',{attrs:{"ml-3":""}},[_c('h3',{staticClass:"font-weight-regular display-0 white--text"},[_vm._v("\n          Active Filters\n        ")])]),_vm._v(" "),_vm._l((_vm.activeFilters),function(filter,index){return _c('v-list-tile',{key:index,staticStyle:{"padding-top":"20px","height":"auto !important","border-spacing":"10px","margin-bottom":"15px"}},[_c('v-layout',{staticStyle:{"border":"1px solid #ddd","padding":"10px"},attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{staticStyle:{"width":"150px"}},[_vm._v(_vm._s(filter.name.toUpperCase())+":")]),_vm._v(" "),_c('v-flex',{attrs:{"align-start":"","justify-start":"","fill-height":""}},[(
                _vm.bool_properties.some(function (tp) {
                  return tp.value == filter.name
                })
              )?_c('span',[_vm._v(_vm._s(filter.value ? 'YES' : 'NO'))]):_vm._e(),_vm._v(" "),(
                _vm.text_properties.some(function (tp) {
                  return tp.value == filter.name
                })
              )?_c('span',[_vm._v(_vm._s(filter.value))]):_vm._e(),_vm._v(" "),(
                [
                  'production_date_new',
                  'acquisition_date',
                  'import_date',
                  'deaccession_date' ].includes(filter.name)
              )?_c('span',[_vm._v(_vm._s(filter.value_from)+" - "+_vm._s(filter.value_to))]):_vm._e(),_vm._v(" "),(['classification'].includes(filter.name))?_c('span',[_vm._v(_vm._s(filter.value_array))]):_vm._e(),_vm._v(" "),(['classification_new_id'].includes(filter.name))?_c('span',[_vm._v(_vm._s(filter.value_array))]):_vm._e(),_vm._v(" "),(['type_of_work_id'].includes(filter.name))?_c('span',[_vm._v(_vm._s(filter.value_array))]):_vm._e(),_vm._v(" "),(['artwork_location_id'].includes(filter.name))?_c('span',_vm._l((_vm.keys2sentence(filter.value_array, filter.name)),function(t){return _c('v-chip',{key:t,attrs:{"small":""}},[_vm._v(_vm._s(t))])}),1):_vm._e(),_vm._v(" "),(filter.name == 'visa_status')?_c('span',[_vm._v(_vm._s(_vm.keys2sentence(filter.value_array, filter.name)))]):_vm._e(),_vm._v(" "),(filter.name == 'acquisition_method')?_c('span',[_vm._v(_vm._s(_vm.keys2sentence(filter.value_array, filter.name)))]):_vm._e(),_vm._v(" "),(filter.name == 'accession_number')?_c('span',[_vm._v(_vm._s(_vm.anquery1)+" "+_vm._s(_vm.anquery2)+" "+_vm._s(_vm.anquery3)+"\n              "+_vm._s(_vm.anquery4))]):_vm._e(),_vm._v(" "),(filter.name == 'exhibitions')?_c('span',[_vm._v(_vm._s(filter.value_array.length))]):_vm._e(),_vm._v(" "),(filter.name == 'tags')?_c('span',[_vm._v(_vm._s(_vm.keys2sentence(filter.value_array, filter.name)))]):_vm._e(),_vm._v(" "),(filter.name == 'ownership')?_c('span',_vm._l((filter.value_array),function(f){return _c('i',{key:f},[_vm._v("\n                "+_vm._s(_vm.$store.getters.my_ownerships.find(function (o) {
                    return o.id === f
                  }).name)+"\n                "),_c('br')])}),0):_vm._e(),_vm._v(" "),(filter.name == 'acquired')?_c('span',_vm._l((filter.value_array),function(f){return _c('i',{key:f},[_vm._v("\n                "+_vm._s(_vm.constants.OWNERSHIP_STATUSES.find(function (o) {
                    return o.id === f
                  }).name)+"\n                "),_c('br')])}),0):_vm._e(),_vm._v(" "),_c('span',{staticClass:"right mx-2"},[_c('v-checkbox',{directives:[{name:"show",rawName:"v-show",value:(
                  [
                    'production_date_new',
                    'acquisition_date',
                    'import_date' ].includes(filter.name)
                ),expression:"\n                  [\n                    'production_date_new',\n                    'acquisition_date',\n                    'import_date',\n                  ].includes(filter.name)\n                "}],staticClass:"right",attrs:{"hide-details":"","color":filter.inverse ? 'red' : 'green'},on:{"click":function($event){$event.preventDefault();return _vm.inverse(index)}},model:{value:(filter.inverse),callback:function ($$v) {_vm.$set(filter, "inverse", $$v)},expression:"filter.inverse"}})],1)]),_vm._v(" "),_c('v-flex',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(
                [
                  'production_date_new',
                  'acquisition_date',
                  'import_date' ].includes(filter.name)
              ),expression:"\n                [\n                  'production_date_new',\n                  'acquisition_date',\n                  'import_date',\n                ].includes(filter.name)\n              "}],staticClass:"right"},[_vm._v("NOT")])]),_vm._v(" "),_c('v-flex',[_c('span',{staticClass:"rigth"},[_c('v-btn',{staticClass:"right",attrs:{"small":"","icon":"","color":"error"},on:{"click":function($event){$event.preventDefault();return _vm.removeFilter(index)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("remove")])],1)],1)])],1)],1)})],2),_vm._v(" "),(_vm.filter_view == 'filter')?_c('v-flex',{attrs:{"xs12":"","my-2":"","mr-2":"","mt-5":""}},[_c('v-btn',{staticClass:"right",attrs:{"outline":""},on:{"click":function($event){$event.preventDefault();return _vm.addToSelection(_vm.filteredArtworks)}}},[_vm._v("Add Filtered to Current Selection ("+_vm._s(_vm.filteredArtworks.length)+")")])],1):_vm._e(),_vm._v(" "),(_vm.filter_view == 'data')?_c('v-layout',{staticClass:"font-weight-regular body-2 white--text",attrs:{"row":"","wrap":"","mt-0":"","mx-3":"","pt-2":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","pr-0":"","pl-2":""}},[_c('v-text-field',{attrs:{"label":"Title","box":"","dark":"","clearable":"","color":"grey"},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","px-2":""}},[_c('v-text-field',{staticClass:"pl-2",attrs:{"label":"Subtitle","clearable":"","box":"","color":"grey"},model:{value:(_vm.subtitle),callback:function ($$v) {_vm.subtitle=$$v},expression:"subtitle"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","px-2":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","mt-0":"","pt-0":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"\n                body-2\n                grey--text\n                text--darken-2 text-uppercase\n                font-weight-thin\n                mb-1\n              "},[_vm._v("\n              Show\n            ")]),_vm._v(" "),_c('p-check',{attrs:{"color":"white"},model:{value:(_vm.image),callback:function ($$v) {_vm.image=$$v},expression:"image"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v("Image")])]),_vm._v(" "),_c('p-check',{attrs:{"color":"white"},model:{value:(_vm.page_no),callback:function ($$v) {_vm.page_no=$$v},expression:"page_no"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v("Page No.")])]),_vm._v(" "),_c('p-check',{attrs:{"color":"white"},model:{value:(_vm.showNoOfArtworks),callback:function ($$v) {_vm.showNoOfArtworks=$$v},expression:"showNoOfArtworks"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v("No. of Artworks")])]),_vm._v(" "),_c('p-check',{attrs:{"color":"white"},model:{value:(_vm.created_by),callback:function ($$v) {_vm.created_by=$$v},expression:"created_by"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v("Created by")])]),_vm._v(" "),_c('p-check',{attrs:{"color":"white"},model:{value:(_vm.created_at),callback:function ($$v) {_vm.created_at=$$v},expression:"created_at"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v("Created at")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"\n                body-2\n                grey--text\n                text--darken-2 text-uppercase\n                font-weight-thin\n                mb-1\n              "},[_vm._v("\n              Sizing\n            ")]),_vm._v(" "),_c('p-radio',{attrs:{"value":"table","color":"white"},model:{value:(_vm.view),callback:function ($$v) {_vm.view=$$v},expression:"view"}},[_vm._v("Table View")]),_vm._v(" "),_c('p-radio',{attrs:{"value":"compact","color":"white"},model:{value:(_vm.view),callback:function ($$v) {_vm.view=$$v},expression:"view"}},[_vm._v("Compact View")]),_vm._v(" "),_c('p-radio',{attrs:{"value":"full","color":"white"},model:{value:(_vm.view),callback:function ($$v) {_vm.view=$$v},expression:"view"}},[_vm._v("Full View")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-4":""}},[_c('v-flex',{attrs:{"xs6":"","pr-2":""}},[_c('div',{staticClass:"\n                body-2\n                grey--text\n                text--darken-2 text-uppercase\n                font-weight-thin\n                mb-1\n              "},[_vm._v("\n              Image Size\n            ")]),_vm._v(" "),_c('p-radio',{attrs:{"color":"white","label":"","value":"50"},on:{"change":function($event){return _vm.pdf(false)}},model:{value:(_vm.imageSize2),callback:function ($$v) {_vm.imageSize2=$$v},expression:"imageSize2"}},[_vm._v("Small")]),_c('br'),_vm._v(" "),_c('p-radio',{attrs:{"color":"white","label":"","value":"100"},on:{"change":function($event){return _vm.pdf(false)}},model:{value:(_vm.imageSize2),callback:function ($$v) {_vm.imageSize2=$$v},expression:"imageSize2"}},[_vm._v("Normal")]),_c('br'),_vm._v(" "),_c('p-radio',{attrs:{"color":"white","label":"","value":"170"},on:{"change":function($event){return _vm.pdf(false)}},model:{value:(_vm.imageSize2),callback:function ($$v) {_vm.imageSize2=$$v},expression:"imageSize2"}},[_vm._v("Big")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-3":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"\n                body-2\n                grey--text\n                text--darken-2 text-uppercase\n                font-weight-thin\n                mb-1\n              "},[_vm._v("\n              Sorting\n            ")]),_vm._v(" "),_c('p-radio',{attrs:{"value":"title","color":"white"},model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}},[_vm._v("Title")]),_c('br'),_vm._v(" "),_c('p-radio',{attrs:{"value":"sort_name","color":"white"},model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}},[_vm._v("Artist")]),_c('br'),_vm._v(" "),_c('p-radio',{attrs:{"value":"collection","color":"white"},model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}},[_vm._v("Collection")]),_vm._v(" "),_c('p-radio',{attrs:{"value":"accession_number","color":"white"},model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}},[_vm._v("Accession No.")]),_vm._v(" "),_c('p-radio',{attrs:{"value":"production_date_new","color":"white"},model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}},[_vm._v("Production Date")]),_vm._v(" "),_c('p-radio',{attrs:{"value":"location_name","color":"white"},model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}},[_vm._v("Artwork Location")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('div',{staticClass:"\n                body-2\n                grey--text\n                text--darken-2 text-uppercase\n                font-weight-thin\n                mb-1\n              "},[_vm._v("\n              Secondary Sorting\n            ")]),_vm._v(" "),_c('p-radio',{attrs:{"value":"production_date_new","color":"white"},model:{value:(_vm.subsort),callback:function ($$v) {_vm.subsort=$$v},expression:"subsort"}},[_vm._v("Production Date")]),_c('br'),_vm._v(" "),_c('p-radio',{attrs:{"value":"classification","color":"white"},model:{value:(_vm.subsort),callback:function ($$v) {_vm.subsort=$$v},expression:"subsort"}},[_vm._v("Classification")]),_c('br'),_vm._v(" "),_c('p-radio',{attrs:{"value":"accession_number","color":"white"},model:{value:(_vm.subsort),callback:function ($$v) {_vm.subsort=$$v},expression:"subsort"}},[_vm._v("Accession No.")]),_c('br'),_vm._v(" "),_c('p-radio',{attrs:{"value":"sort_name","color":"white"},model:{value:(_vm.subsort),callback:function ($$v) {_vm.subsort=$$v},expression:"subsort"}},[_vm._v("Artist")]),_c('br')],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pl-3":"","mt-0":"","pr-2":""}},[_c('span',{staticClass:"\n            body-2\n            grey--text\n            text--darken-2 text-uppercase\n            font-weight-thin\n          "},[_vm._v("Output Fields\n        ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mt-0":""}},[_c('v-flex',{attrs:{"xs12":"","mt-0":"","pt-0":""}},[_c('v-combobox',_vm._g(_vm._b({staticClass:"pb-0 mb-0 mt-0 pt-0",attrs:{"items":_vm.items_calc,"placeholder":"Select Output Fields here and reorder below","color":"black","hide-selected":"","multiple":"","clearable":"","dense":"","item-value":"item","item-text":"title","search-input":_vm.search},on:{"change":_vm.saveToStore,"blur":function($event){_vm.search = ''},"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},scopedSlots:_vm._u([{key:"selection",fn:function(){return [(_vm.selected.length > 0)?_c('div',{on:{"click":function($event){$event.stopPropagation();_vm.selected = []}}}):_vm._e()]},proxy:true}],null,false,395250631),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},'v-combobox',_vm.$attrs,false),_vm.$listeners))],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-0":"","pt-0":"","pb-0":""}},[_c('div',{staticClass:"\n                body-2\n                grey--text\n                text--darken-2 text-uppercase\n                font-weight-thin\n                mb-0\n              "},[_vm._v("\n              Output field options\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pl-0":"","mt-0":"","pt-0":""}},[_c('v-data-table',{ref:"sortableTable",staticClass:"elevation-0",attrs:{"items":_vm.selected,"hide-actions":"","no-data-text":"Select Output Fields above and reorder here.","hide-headers":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{key:props.item['id'],staticClass:"sortableRow"},[_c('td',{staticClass:"px-0",staticStyle:{"width":"0.1%"}},[_c('v-btn',{staticClass:"sortHandle",staticStyle:{"cursor":"move"},attrs:{"icon":""}},[_c('v-icon',[_vm._v("drag_handle")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.title))])])]}}],null,false,374174963),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-2":""}},[_c('v-divider',{staticClass:"xs12 mx-0 pb-0 mb-0 white mt-4"})],1),_vm._v(" "),_c('v-layout',{attrs:{"xs12":"","mx-0":"","px-0":"","mb-2":"","d-flex":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"mr-0",attrs:{"small":"","icon":""},on:{"click":function($event){$event.preventDefault();return _vm.pdf(false)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("refresh")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"mx-0",attrs:{"small":"","loading":_vm.loading,"disabled":_vm.loading},nativeOn:{"click":function($event){_vm.loading = true
              _vm.pdf_call(true)}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("mdi-file-pdf")]),_vm._v("\n            LIST\n          ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('labels',{attrs:{"small":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","small":""}},[_c('labels-small',{attrs:{"small":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","small":""}},[_c('labels-small-text',{attrs:{"small":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","small":""}},[_c('solo',{attrs:{"small":"","title":_vm.title,"subtitle":_vm.subtitle,"sort":_vm.sort,"subsort":_vm.subsort,"columns":_vm.selected}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","small":""}},[_c('solo-ext',{attrs:{"small":"","title":_vm.title,"subtitle":_vm.subtitle,"sort":_vm.sort,"subsort":_vm.subsort,"columns":_vm.selected}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","small":""}},[_c('excel',{attrs:{"small":"","data":_vm.excelArtworks,"name":"List","columns":_vm.selected,"fileName":"list"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.filter_view == 'data' && _vm.show_preview_pane),expression:"filter_view == 'data' && show_preview_pane"}],staticClass:"mx-0 px-0 my-0 py-0",attrs:{"color":"","flat":""}},[_c('iframe',{staticStyle:{"width":"100%","height":"640px","border":"0px"},attrs:{"id":"pdfV"}})])],1),_vm._v(" "),_c('v-flex',{attrs:{"md12":"","xs12":"","mx-3":""}},[_c('v-form',{ref:"form"},[_c('v-card',{attrs:{"color":"red","flat":""}},[_c('v-card-text',{staticClass:"mb-0 px-0 mt-0 pt-0 white"},[_c('v-container',{attrs:{"fluid":"","px-2":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('filter-box',{attrs:{"use_current_selection":_vm.use_current_selection,"artworks":_vm.unfiltered_artworks_for_list}})],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "+R/v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list-tile',{on:{"click":function($event){return _vm.pdfLabelsCall(_vm.artwork)}}},[_c('v-list-tile-title',[_vm._v("\n      Download Exhibition History\n    ")])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "+UUQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EditFieldHeader',
  data: function data() {
    return {};
  },

  props: ['field', 'artist', 'placeholder', 'label', 'name', 'value'],
  methods: {},
  computed: {
    f_field: function f_field() {
      return this.field;
    },
    f_artist: function f_artist() {
      return this.artist;
    }
  }
});

/***/ }),

/***/ "+hVl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRelated_vue__ = __webpack_require__("720i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5923adf6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelated_vue__ = __webpack_require__("6wHJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Sbrr")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5923adf6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRelated_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5923adf6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelated_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5923adf6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelated_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+lYf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilterCheckbox__ = __webpack_require__("AoDk");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      filteredProperty: 'title',
      query: '',
      activeFilters: [],
      filters: ['classification'],
      s_ownership: [],
      classification: ['fvs'],
      ownership: [],
      category: [],
      accession_number: []
    };
  },

  components: {
    FilterCheckbox: __WEBPACK_IMPORTED_MODULE_0__FilterCheckbox__["a" /* default */]
  },
  computed: {
    filtered_artworks: function filtered_artworks() {
      var a = this.$store.state.artworks;
      var filtered = a;
      var t = this;
      // console.log(this.filters)
      this.filters.forEach(function (filter) {
        var filter_value = eval('t.' + filter);
        // console.log('filtered_artworks')
        filtered = filtered.filter(function (record) {
          // console.log(filter)
          // console.log(record[filter])
          // console.log('filterr = ' + filter_value)
          // return true
          return filter === 'accession_number' ? new RegExp(filter_value, 'i').test(record[filter]) : filter_value.some(function (r) {
            return record[filter].includes(r);
          });
        });
      });
      this.$store.dispatch('postFilterResults', filtered);
      return filtered;
    }
  }
});

/***/ }),

/***/ "+nr0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Array.prototype.contains = function(v) {
//   for (var i = 0; i < this.length; i++) {
//     if (this[i] === v) return true;
//   }
//   return false;
// };

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      selected_tags_assign: [],
      selected: [],
      showUpload: false,
      showTags: [false, false, false, false, false, false, false, false],
      show: false,
      tag_categories: [{ id: 1, name: 'TBA21 Exhibition', color: 'red', position: 2 }, { id: 2, name: 'TBA21 Production', color: 'green', position: 3 }, { id: 3, name: 'FTB Sorting', color: 'blue', position: 1 }, { id: 4, name: 'TBA21 Projects', color: 'yellow', position: 4 }, { id: 5, name: 'TBA21 Events', color: 'pink', position: 5 }, { id: 6, name: 'Exhibitions', color: 'grey', position: 6 }, { id: 7, name: 'Institutions', color: 'purple', position: 7 }],
      tag: {
        description: '',
        title: ''
      },
      tags_local: []
    };
  },
  created: function created() {
    this.tags_local = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.tags);
  },

  methods: {
    customFilter: function customFilter(item, queryText, itemText) {
      var textOne = item.name.toLowerCase().replace(/ /g, '_').replace('...', '').replace(/ /g, '_').replace(/\//g, '_').replace(/\(\//g, '_');
      var textTwo = item.category ? textOne + '_' + item.category.toLowerCase().replace(/ /g, '_').replace('...', '').replace(/\//g, '_') : textOne;
      var searchText = queryText.toLowerCase();
      // var setOfSearchStrings = queryText.split(' ');

      // for(var i = 0; i < setOfSearchStrings.length; i++){
      //   if(mainString.indexOf(setOfSearchStrings[i]) != -1)
      //       stringExists = true;
      // }
      // let re = new RegExp('^(?=.*\\b' + textOne + '\\b)(?=.*\\b' + textTwo + '\\b).*$')
      // var rer = re.exec(queryText)
      // return rer
      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
    },
    deleteTag: function deleteTag(id) {
      var _this = this;

      this.$emit('showSnackbar', 'Deleting Tag from this Artwork…');
      var url = this.$globals.apiserver + '/artworks/' + this.artwork.id + '.json';
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, {
        // artwork: {
        tag_id: id,
        delete_tag: 1
        // }
      }).then(function (response) {
        _this.errors = {};
        // this.selected_tags_assign = []
        _this.artwork.tags = response.data;
        _this.$emit('showSnackbar', 'Tag Deleted from this Artwork.', 'green');
        // this.$store.commit('ADD_COST', response.data)
      }).catch(function (error) {
        _this.errors = error.response.data;
      });
    },
    assignTagsToArtwork: function assignTagsToArtwork() {
      var _this2 = this;

      this.$emit('showSnackbar', 'Saving Tags…');
      if (this.artwork.tags.length > 0) {
        var a = this.artwork.tags.map(function (t) {
          return t.id;
        });
        var c = a.concat(this.selected_tags_assign);
        var d = c.filter(function (item, pos) {
          return c.indexOf(item) == pos;
        });
      } else {
        var d = this.selected_tags_assign;
      }
      if (!this.artwork.tags) {
        this.artwork.tags = [];
      }
      var url = this.$globals.apiserver + '/artworks/' + this.artwork.id + '.json';
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, {
        artwork: {
          tags: d,
          save_tags: 1
        }
      }).then(function (response) {
        _this2.errors = {};
        _this2.selected_tags_assign = [];
        _this2.artwork.tags = response.data;
        _this2.$emit('showSnackbar', 'Tags saved.', 'green');
        // this.$store.commit('ADD_COST', response.data)
      }).catch(function (error) {
        _this2.errors = error.response.data;
      });
      // this.tag = {
      //   description: '',
      //   title: ''
      // }
    },
    delete_tag: function delete_tag() {},
    ctags: function ctags(cid) {
      var tags = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.tags);
      var out = [];
      // tags.forEach(tag => {
      out = tags.filter(function (t) {
        return cid == t.tag_category_id;
      });
      // console.log(out)
      return out;
    },
    assign_tag_colors: function assign_tag_colors() {
      // var stc = this.selected_tag_categories
      var tc = this.tag_categories;
      var tags = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.tags);
      var out = [];
      tags.forEach(function (tag) {
        var a = tc.filter(function (tagc) {
          return tagc.id == tag.tag_category_id;
        });
        if (a[0]) {
          tag.color = a[0].color + 'a';
        }
        out.push(tag);
      });
      out = out.sort(function (a, b) {
        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      // return out.filter(function(tag) { return stc.some(st => tag.tag_category_id==st)})
      return out;
    }
  }
  // computed: {
  // categories() {
  //   var out = []
  //   out.push(this.artwork.tags[0].tag_category_id)
  //   for (var t in this.artwork.tags) {
  //     if (!out.contains(this.artwork.tags[t].tag_category_id)) {
  //       out.push(t)
  //     }
  //   }
  //   return out
  // },
  // }
});

/***/ }),

/***/ "+xQW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfEh_vue__ = __webpack_require__("NABz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_163bc498_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfEh_vue__ = __webpack_require__("+R/v");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("XNgJ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PdfEh_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_163bc498_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfEh_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_163bc498_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PdfEh_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/9hj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__("W3Iv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_artworks_TagFilter_vue__ = __webpack_require__("72y9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_toolbar_items_LocationChangeDialog_vue__ = __webpack_require__("uYtP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_artworks_AttachTagToArtworksDialog_vue__ = __webpack_require__("5MJo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_full_user_fields__ = __webpack_require__("LKPg");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









function dynamicSort(property, property2) {
  // var sortOrder = 1
  if (property[0] === '-') {
    // sortOrder = -1
    property = property.substr(1);
  }
  return function (a, b) {
    // var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    if (a[property] > b[property]) return 1;
    if (a[property] < b[property]) return -1;
    if (a[property2] > b[property2]) return 1;
    if (a[property2] < b[property2]) return -1;
    // return result * sortOrder;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    search: function search(val) {
      this.$emit('saveSearchValue', val || '');
    },
    p: function p(val) {
      // this.$emit('saveArtworkPageValue', val || '')
      if (val.page > 0) {
        this.$store.dispatch('setPageNumber', {
          string: this.p.page,
          section: 'artworks'
        });
      }
    }
  },
  data: function data() {
    return {
      selectedTags: [],
      show_change_location_dialog: false,
      show_attach_tag_dialog: false,
      and: false,
      showSelection: false,
      constants: __WEBPACK_IMPORTED_MODULE_7__data_constants__["a" /* default */],
      showFilter: false,
      hasSaved: false,
      selected_filter_tags: [],
      fields: __WEBPACK_IMPORTED_MODULE_10__data_full_user_fields__["a" /* default */],
      ownerships: [],
      selectedOwnership: '',
      searchAll: false,
      append_notes: true,
      append_credit: true,
      locations: [],
      panel: [],
      menu2: false,
      artwork_location_log: {
        storage: '',
        note: '',
        change_date: '',
        artwork_location_id: '',
        copy: ''
      },
      commissions: 'all',
      properties: ['artwork_location_id', 'location_notes', 'credit', 'type_of_work_id', 'visa_status'],
      propertyToUpdate: 'location',
      propertyValue: '',
      showTags: false,
      save_tag_form_display: false,
      tag_title: '',
      selected_g: [],
      sort: 'title',
      subsort: 'accession_number',
      showSearch: this.$store.state.showSearch,
      view: this.$store.state.view,
      list_view: true,
      drawer2: null,
      options: this.$store.state.options,
      list: null,
      p: {
        sortBy: 'sort_name',
        page: this.$store.state.pageNumbers['artworks']
      },
      // fields: ["artwork_location_id", "type_of_work"],
      dialog: false,
      batchDialog: false,
      edited_artwork: {
        type_of_work_id: '',
        location_notes: '',
        artwork_location_id: '',
        credit: '',
        visa_status: ''
      },
      show_tag_filter: false,
      show_classifications: false,
      filter: {
        selected_classifications: [],
        selected_classification_negations: []
      },
      ta: [],
      selected_tags_assign: [],
      selected_tags: [],
      selected_tag_categories: [],
      selected: [],
      search: '',
      searchTags: '',
      headers: [{ sortable: false }, { value: 'id', sortable: false }, { text: 'Artist', value: 'name', align: 'center' }, { text: '', value: 'full_name', align: 'center' }, { text: '', value: 'sort_name', align: 'center' }, { text: '', value: 'location_name', align: 'center' }, { text: '', value: 'title', align: 'center' }, { text: 'Accession No.', value: 'accession_number_for_sorting', align: 'center' }, { text: 'Accession No.', value: 'accession_number', hidden: true },
      // { text: 'Classification', value: 'classification', align: 'center' },
      { text: 'Freeport', value: 'visa_status', align: 'center' }, {
        text: 'Todos',
        value: 'artwork_todos.filter(at => at.done != 1)',
        align: 'center'
      }],
      prevHeight: 0
    };
  },

  props: ['items'],
  methods: {
    /**
     * Custom tag filter function to filter items based on query text and item text.
     *
     * @param {any} item - The item to be filtered.
     * @param {string} queryText - The query text used for filtering.
     * @param {string} itemText - The text of the item to be filtered.
     * @return {boolean} True if the item passes the filter, false otherwise.
     */
    customTagFilter: function customTagFilter(item, queryText, itemText) {

      // console.log('customTagFilter' + item.label + queryText + typeof(itemText));
      var sanitizeText = function sanitizeText(text) {
        return text.toString().toLowerCase();
        // .replace(/\s+/g, '-')
        // .replace(/[^\w-]+/g, '')
        // .replace(/--+/g, '-')
        // .replace(/^-+/, '')
        // .replace(/-+$/, '');
      };

      var textOne = sanitizeText(item.label);
      var textTwo = sanitizeText(itemText);
      var searchText = sanitizeText(queryText);

      var setOfSearchStrings = searchText.split(' ');

      return setOfSearchStrings.every(function (searchString) {
        return textOne.includes(searchString);
      });
    },
    toggleShowAttachTagDialog: function toggleShowAttachTagDialog() {
      console.log('this.show_attach_tag_dialog');
      console.log(this.show_attach_tag_dialog);
      this.show_attach_tag_dialog = !this.show_attach_tag_dialog;
    },


    // findTagName(tag) {
    //   const a = this.$store.state.tags.find(i => i.id === tag)
    //   if (a) {
    //     return a.name
    //   } else {
    //     return ''
    //   }
    // },
    // findTagExists(tag) {
    //   // console.log(tag)
    //   const a = this.$store.state.tags.find(i => i.id == tag)
    //   // console.log(a)
    //   return a
    // },
    remove: function remove(item) {
      console.log('remove' + item);
      console.log(this.selectedTags);
      var index = this.selectedTags.indexOf(item);
      if (index >= 0) this.selectedTags.splice(index, 1);
    },
    toggleSelection: function toggleSelection() {
      this.selected = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.ids2o(this.$store.state.currentSelection));
      this.showSelection = !this.showSelection;
    },
    updateFilterTags: function updateFilterTags(tags) {
      console.log('updateFilterTags');
      console.log(tags);
      this.selectedTags = tags;
      this.selected_filter_tags = tags;
    },
    customFilter: function customFilter(item, queryText, itemText) {
      var textOne = item.name.toLowerCase().replace(/ /g, '_').replace('...', '').replace(/ /g, '_').replace(/\//g, '_').replace(/\(\//g, '_');
      var textTwo = item.category ? textOne + '_' + item.category.toLowerCase().replace(/ /g, '_').replace('...', '').replace(/\//g, '_') : textOne;
      var searchText = queryText.toLowerCase();
      // var setOfSearchStrings = queryText.split(' ');

      // for(var i = 0; i < setOfSearchStrings.length; i++){
      //   if(mainString.indexOf(setOfSearchStrings[i]) != -1)
      //       stringExists = true;
      // }
      // let re = new RegExp('^(?=.*\\b' + textOne + '\\b)(?=.*\\b' + textTwo + '\\b).*$')
      // var rer = re.exec(queryText)
      // return rer
      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
    },
    save: function save() {
      this.isEditing = !this.isEditing;
      this.hasSaved = true;
    },
    toggleOwnership: function toggleOwnership(o) {
      this.selectedOwnership = o;
      // console.log('this.selectedOwnership')
      // console.log(this.selectedOwnership)
      // this.$store.dispatch('setFilter', { section: 'deaccession', ownership: o.id })
      // if (o.id !== 'all') {
      //   console.log('toggle - ownership not all')
      //   this.filtered = this.items.filter(a =>
      //      a.ownership == o.id
      //   )
      // } else {
      //   console.log('toggle - ownership is all')
      // this.filtered = this.items
      // }
    },
    setSearchValue: function setSearchValue() {
      this.search = this.$store.state.searchString['artworks'];
    },
    setPageNumberValue: function setPageNumberValue() {
      this.p.page = this.$store.state.pageNumbers['artworks'];
      // console.log(this.p.page)
    },
    searchAllToggle: function searchAllToggle() {
      // console.log('searchAllToggle')
      // console.log(a)
      if (this.searchAll) {
        __WEBPACK_IMPORTED_MODULE_8__main__["serverBus"].$emit('setTitle', '');
        this.$emit('switchOwnershipTop');
        this.searchAll = false;
      } else {
        __WEBPACK_IMPORTED_MODULE_8__main__["serverBus"].$emit('setTitle', 'Searching All Artworks');
        this.$emit('switchOwnershipToAll');
        this.searchAll = true;
      }
    },
    imageUrlAlt: function imageUrlAlt(event) {
      event.target.src = '/static/no_image.jpg';
    },

    // modifyArtworks() {
    //   var props = this.properties.filter(
    //     (p) => this.edited_artwork[p] != null && this.edited_artwork[p] != ""
    //   );
    //   console.log(props);
    //   props.forEach((c) => {
    //     console.log(c);
    //     this.updateArtworks(c);
    //   });
    //   this.dialog = false;
    //   // this.contact = "";
    //   // this.artworks = [];
    //   // this.artworks2 = [];
    //   // this.selected = [];
    //   this.dialog = false;
    // },
    updateArtworks: function updateArtworks() {
      var _this = this;

      var ea = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(this.edited_artwork).reduce(function (a, _ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        return v ? (a[k] = v, a) : a;
      }, {});
      this.selected.forEach(function (c) {
        // this.edited_artwork.id = c.id;
        // console.log(c.credit);
        // console.log(this.edited_artwork.credit);
        if (c.credit) {
          ea.credit = c.credit + '\n' + ea.credit;
        }
        if (c.location_notes) {
          ea.location_notes = c.location_notes + '\n' + ea.location_notes;
        }
        // console.log(ea.credit);
        _this.$emit('showSnackbar', 'Updating Artwork: ' + c.title);
        setTimeout(function () {
          var url = _this.$globals.apiserver + '/artworks/' + c.id + '.json';
          // let url = `http://localhost:8080/artworks/${c.id}.json`;
          // console.log("updating artwork start");
          // console.log(url);
          // // console.log(property);
          // console.log(this.edited_artwork);
          // console.log(ea);
          // console.log(c);
          // console.log("updating artwork end");
          __WEBPACK_IMPORTED_MODULE_9_axios___default.a.put(url, {
            artwork: ea,
            // field_value: this.propertyValue,
            updated_by: _this.c_user.id
          }).then(function (response) {
            _this.$emit('showSnackbar', "Saved Artwork's ", 'green');
            _this.progress = false;
            _this.isEditing = false;
            _this.$store.dispatch('loadArtworks');
            _this.dialog = false;
            _this.edited_artwork = {
              type_of_work_id: '',
              location_notes: '',
              artwork_location_id: '',
              credit: '',
              visa_status: ''
            };
          }).catch(function (error) {
            // console.log(error)
            _this.$emit('showSnackbar', 'Error Saving Artwork ', 'red');
            _this.progress = false;
            _this.isEditing = false;
          });
        }, 1000);
      });
      // this.batchDialog = false;
      // this.contact = "";
      // this.artworks = [];
      // this.artworks2 = [];
      // this.selected = [];
    },
    resetSelected: function resetSelected() {
      this.selected = [];
      // this.artworks = [];
      // this.artworks2 = [];
    },
    showBatchUpdateDialog: function showBatchUpdateDialog() {
      // this.batchDialog = true;
      this.dialog = true;
      // this.artworks = this.$store.state.artworks.filter(a =>
      //   this.selected.map(a => a.id).includes(a.acquisition_source_id)
      // );
    },

    // showAttachTagDialog() {
    // this.batchDialog = true;
    // this.show_attach_tag_dialog = true
    // this.artworks = this.$store.state.artworks.filter(a =>
    //   this.selected.map(a => a.id).includes(a.acquisition_source_id)
    // );
    // },
    goToUrl: function goToUrl(url) {
      window.open(url, '_blank');
    },

    // getFiltered(e){
    //   // console.log(e) //output the filtered items
    // },
    close_save_tag_form: function close_save_tag_form() {
      // console.log(this.save_tag_form_display)
      this.save_tag_form_display = false;
      // console.log(this.save_tag_form_display)
      this.tag_title = '';
    },
    create_tag: function create_tag() {
      var _this2 = this;

      var url = this.$globals.apiserver + '/tags.json';
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.post(url, { tag: { name: this.tag_title } }).then(function (response) {
        _this2.$store.dispatch('loadTags');
        _this2.save_tag_form_display = false;
        _this2.tag_title = '';
        _this2.$router.push({
          name: 'EditArtist',
          // path: `/artists/edit/${this.artist.id}`,
          params: { id: _this2.artist.id, artist: _this2.artist }
        });
      }).catch(function (error) {
        // console.log(error)
      });
    },
    assignTagsToArtworks: function assignTagsToArtworks() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_8__main__["serverBus"].$emit('showSnackbar', 'Saving Tags to Artworks…');
      var url = this.$globals.apiserver + '/artworks/2.json';
      var artworks = this.selected.map(function (a) {
        return a.id;
      });
      __WEBPACK_IMPORTED_MODULE_9_axios___default.a.put(url, {
        artworks: artworks,
        tags: this.selected_tags_assign,
        save_tags_to_artworks: 1
      }).then(function (response) {
        _this3.$store.dispatch('loadArtworks');
        _this3.$emit('switchOwnershipTop');
        _this3.errors = {};
        _this3.selected_tags_assign = [];
        // for (var i in artworks) {
        //   if (artworks[i].value === value) {
        //     artworks[i].desc = desc
        //     break // Stop this loop, we found it!
        //   }
        // }
        // response.data.artworks
        // this.artwork.tags = response.data;
        __WEBPACK_IMPORTED_MODULE_8__main__["serverBus"].$emit('showSnackbar', 'Tags saved.', 'green');
        // this.$store.commit('ADD_COST', response.data)
      }).catch(function (error) {
        // console.log(error)
        // this.errors = error.response.data;
      });
      // this.tag = {
      //   description: '',
      //   title: ''
      // }
    },

    // refresh_list () {
    //   // console.log (this.table_artworks[0])
    //   return this.table_artworks
    //   // console.log (this.table_artworks[0])
    // },
    closeOptions: function closeOptions() {
      this.options = !this.options;
      this.$store.dispatch('saveOptions', !this.$store.state.options);
    },
    all_todos: function all_todos(artwork) {
      var todos = void 0;
      if (artwork.artwork_todos && artwork.artwork_todos.length > 0) {
        todos = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], artwork.artwork_todos);
      } else {
        todos = [];
      }
      var fields = [{ id: 'credit', f: 'credit', m: 'Missing Credit' }, { id: 'signature_new', f: 'signature_new', m: 'Missing Signature' }, {
        id: 'acquisition_date',
        f: 'acquisition_date',
        m: 'Missing Acquisition Date'
      }, {
        id: 'specs_on_space',
        f: 'specs_on_space',
        m: 'Missing Info on Space'
      }, { id: 'technician', f: 'technician', m: 'Missing Technician' }, {
        id: 'installation_time',
        f: 'installation_time',
        m: 'Days of Installation'
      }];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(fields), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var f = _step.value;

          if (artwork[f.f] == null || artwork[f.f] === '') {
            todos.push({ id: f.id, title: f.m, done: false, completed: false });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return todos;
    },
    get_type_of_work: function get_type_of_work(id) {
      return this.constants.TYPES_OF_WORK.find(function (tow) {
        return tow.id === id;
      }).name;
      // if (vss[0] != undefined) {
      //   return vss[0].id > 0 ? vss[0].name : ""
      // } else {
      //   return ""
      // }
    },

    // get_visa_status(artwork) {
    //   var vss = this.constants.VISA_STATUSES.filter(
    //     vs => vs.id === artwork.visa_status
    //   );
    //   if (vss[0] != undefined) {
    //     // console.log(vss[0].id)
    //     return vss[0].id > 0 ? vss[0].name : "";
    //   } else {
    //     return "";
    //   }
    // },
    // get_location_name(id) {
    //   var l = this.$store.state.locations.find(l => l.id === id);
    //   return l ? l.name : "";
    // },
    addField: function addField() {},
    switchSwitch: function switchSwitch() {
      this.show_tag_filter = !this.show_tag_filter;
      this.$emit('switchOwnershipTop', this.show_tag_filter);
    },
    clearFilters: function clearFilters() {
      this.selected_tags = [];
      this.selected_tag_categories = [];
    },
    clear_selection: function clear_selection() {
      this.$store.dispatch('clearCurrentSelection');
      this.selected = [];
    },
    addSelectedToSelection: function addSelectedToSelection() {},
    addAllToSelection: function addAllToSelection() {
      // this.selected = this.items
      // console.log(this.table_artworks)
      // console.log(this.selected)
      var tempSelection = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(tempSelection)
      // tempSelection = tempSelection.map(a => a.id)
      // console.log(tempSelection)
      this.table_artworks.forEach(function (a) {
        // if (!a) {
        if (!tempSelection.includes(a.id)) {
          tempSelection.push(a.id);
        }
        // } else {
        //   // console.log('false')
        //   var index = tempSelection.indexOf(b);
        //   // console.log('index = ' + index)
        //   tempSelection.splice(index,1)
        // }
      });
      // this.$store.state.currentSelection
      // console.log(tempSelection)
      // this.selected.forEach(s => {
      //   if (!tempSelection.includes(s)) {
      //     tempSelection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', tempSelection);
      // console.log(tempSelection)
    },
    addFilteredToSelection: function addFilteredToSelection() {
      var p = this.p.rowsPerPage;
      // console.log(this.$refs['dTable'].filteredItems)
      this.p.rowsPerPage = 100000;
      // console.log(this.$refs['dTable'].filteredItems)
      // this.selected = this.items
      // let items = this.$refs. dTable.$children[0].filteredItems;
      // let sortBy = this.$refs. dTable.$children[0].options.sortBy;
      // let sortDesc = this.$refs. dTable.$children[0].options.sortDesc;
      // let sorted = this.$refs. dTable.customSortWithHeaders(items, sortBy, sortDesc);
      // console.log(this.$refs.dTable.$children[0])
      // console.log(this.$refs.dTable.$children[0].filteredItems)
      // console.log(this.$refs.dTable.$children[0].options.sortDesc)
      // console.log(this.$refs.dTable.filteredItems)
      var tempSelection = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(tempSelection)
      // tempSelection = tempSelection.map(a => a.id)
      // console.log(tempSelection)
      this.$refs.dTable.filteredItems.forEach(function (a) {
        // if (!a) {
        if (!tempSelection.includes(a.id)) {
          tempSelection.push(a.id);
        }
        // } else {
        //   // console.log('false')
        //   var index = tempSelection.indexOf(b);
        //   // console.log('index = ' + index)
        //   tempSelection.splice(index,1)
        // }
      });
      this.p.rowsPerPage = p;
      // this.$store.state.currentSelection
      // console.log(tempSelection)
      // this.selected.forEach(s => {
      //   if (!tempSelection.includes(s)) {
      //     tempSelection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', tempSelection);
      // console.log(tempSelection)
    },

    // save_selection () {
    //   this.$store.dispatch('clearCurrentSelection')
    // },
    // tags_for_artwork(tags) {
    //   var ar = []
    //   // console.log(tags)
    //   tags.forEach(tag => {
    //     ar.push(this.$store.state.tags.filter(i => i.id === tag.id)[0].name)
    //   })
    //   // console.log(ar)
    //   return ar.join(', ')
    // },
    save_currently_selected: function save_currently_selected(a, b) {
      // console.log('///////////')
      // console.log('a = ' + a)
      // console.log('b.id = ' + b.id)
      // console.log(this.selected)
      // console.log(this.selected)
      // console.log(this.$store.state.currentSelection)
      // setTimeout(function () {
      var tempSelection = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // tempSelection = tempSelection.map(a => a.id)
      if (!a) {
        if (!tempSelection.includes(b.id)) {
          tempSelection.push(b.id);
        }
      } else {
        var index = tempSelection.indexOf(b.id);
        tempSelection.splice(index, 1);
      }
      // this.$store.state.currentSelection
      // console.log(tempSelection)
      // this.selected.forEach(s => {
      //   if (!tempSelection.includes(s)) {
      //     tempSelection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', tempSelection);
      // this.$store.dispatch('saveCurrentSelection',this.selected_ids)
      // console.log(tempSelection)
      // }.bind(this),1000)
    },
    save_currently_selected_gallery: function save_currently_selected_gallery(a, b) {
      // console.log('a = ' + a)
      // console.log('b = ' + b.id)
      // setTimeout(function () {
      var tempSelection = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      if (!a) {
        if (!tempSelection.includes(b)) {
          tempSelection.push(b.id);
        }
      } else {
        var index = tempSelection.indexOf(b.id);
        tempSelection.splice(index, 1);
      }
      this.$store.dispatch('saveCurrentSelection', tempSelection);
      // }.bind(this),1000)
    },

    // save_currently_selected_all (a) {
    //   // console.log('///////////')
    //   // console.log('a = ' + a)
    //   var tempSelection = Object.assign(
    //     [],
    //     this.$store.state.currentSelection
    //   )
    //   // console.log(tempSelection)
    //   if (!a) {
    //     // console.log('a true')
    //     if (!tempSelection.includes(b)) {
    //       // console.log('doesnt include')
    //       tempSelection.push(b)
    //     }
    //   } else {
    //     // console.log('false')
    //     var index = tempSelection.indexOf(b)
    //     // console.log('index = ' + index)
    //     tempSelection.splice(index, 1)
    //   }
    //   // this.$store.state.currentSelection
    //   // console.log(tempSelection)
    //   // this.selected.forEach(s => {
    //   //   if (!tempSelection.includes(s)) {
    //   //     tempSelection.push(s)
    //   //   }
    //   // })
    //   // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
    //   this.$store.dispatch('saveCurrentSelection', tempSelection)
    // },
    save_currently_selected_tags: function save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags);
      this.ta = this.tagged_artworks;
    },

    // assignTagsToArtworks() {
    //   // console.log('this.selected')
    //   // console.log(this.selected)
    //   // console.log(this.selected_tags_assign)
    // }

    // ANIMATIONS
    beforeLeave: function beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter: function enter(element) {
      var _getComputedStyle = getComputedStyle(element),
          height = _getComputedStyle.height;

      element.style.height = this.prevHeight;

      setTimeout(function () {
        element.style.height = height;
      });
    },
    afterEnter: function afterEnter(element) {
      element.style.height = 'auto';
    }
  },

  computed: {
    tags: function tags() {
      return this.$store.state.tags.filter(function (item) {
        return item.category == 'concept';
      });
    },
    tagNames: function tagNames() {
      return this.$store.getters.formattedTags;
    },
    tag_items: function tag_items() {
      return this.fields.tabs['basic'].fields.filter(function (item) {
        return !!item.tag;
      });
    },

    // locationsSorted: state => {
    //   return this.locations.sort(dynamicSort('name'))
    // },
    // selected_ids () {
    //   return this.selected.map(a => a.id)
    // },
    options_c: {
      get: function get() {
        return this.$store.state.options;
      },
      set: function set(value) {
        this.$store.dispatch('saveOptions', value);
      }
    },
    // artworks_selections() {
    // for (var b in this.$store.state.artworks_selections) {
    // console.log(this.$store.state.artworks_selections[b])
    // }
    //   return Object.assign([],this.$store.state.artworks_selections).reverse()
    // },
    currrent_path: function currrent_path() {
      return this.$route.params.ownership;
    },

    // saved_lists () {
    //   return [{id:1,title:'list1'}, {id:2,title:'list2'}]
    // },
    // selected_artworks () {
    //   return this.$store.state.currentSelection
    // },

    table_artworks: function table_artworks() {
      var _this4 = this;

      console.log('ArtworksTable.table_artworks');
      if (this.showSelection) {
        return this.selected;
      }

      var filteredArtworks = [];
      // Filter by section
      if (this.$route.fullPath === '/artworks/ownership/deaccession') {
        filteredArtworks = this.items.filter(function (artwork) {
          return artwork.deaccessioned === 1;
        });
      } else if (this.$route.fullPath === '/artworks/ownership/commissions') {
        // Filter for commissions - `tba`, `com_academy`, or all commissions
        if (this.commissions === 'tba') {
          filteredArtworks = this.items.filter(function (artwork) {
            return artwork.acquisition_method === 3 && artwork.acquired === 'acquired';
          });
        } else if (this.commissions === 'com_academy') {
          filteredArtworks = this.items.filter(function (artwork) {
            return artwork.acquired === 'com_academy';
          });
        } else {
          filteredArtworks = this.items;
        }
      } else {
        filteredArtworks = this.items;
      }
      // Filter by ownership
      console.log('this.selectedOwnership:');
      console.log(this.selectedOwnership);
      if (this.selectedOwnership.id !== 'all') {
        filteredArtworks = filteredArtworks.filter(function (artwork) {
          return artwork.ownership == _this4.selectedOwnership.id;
        });
      }

      // Filter by tags, if any OLD ! ! ! !
      // console.log('Filter by tags OLD')
      // console.log(this.selected_filter_tags)
      // if (this.selected_filter_tags.length > 0) {
      //   filteredArtworks = filteredArtworks.filter((artwork) =>
      //     artwork.tags.some((aTag) => this.selected_filter_tags.indexOf(aTag.id) > -1)
      //   );
      // }

      console.log('Filter by tags NEW');
      console.log(this.selectedTags.length);
      console.log(this.selectedTags);
      // console.log(this.selectedTags.indexOf('portrait'))
      if (this.selectedTags.length > 0) {
        filteredArtworks = filteredArtworks.filter(function (artwork) {
          // console.log('eeeeeeeese', artwork.id)
          var out = artwork.tags.some(function (aTag) {
            // console.log(aTag.name)
            return _this4.selectedTags.indexOf(aTag.id) > -1;
          });
          // console.log(out)
          return out;
        });
      }
      // if (this.selectedTags.length > 0) {
      //   filteredArtworks = filteredArtworks.filter((artwork) =>
      //     artwork.tags.some((aTag) => {
      //       const tagNames = [aTag.name, aTag.section];
      //       return tagNames.some((tagName) => this.selectedTags.includes(tagName));
      //     })
      //   );
      // }
      // if (this.selected_filter_tags.length > 0) {
      //   const andFilter = this.and;
      //   var filteredTags = [...this.selected_filter_tags];
      //   // Filter for concept tags
      //   this.$store.state.tags.filter((tag) => tag.concept_tag === 1).forEach((conceptTag) => {
      //     filteredTags = filteredTags.concat(
      //       this.$store.state.tags.filter((tag) => tag.category === conceptTag.name)
      //         .map((keywordTag) => keywordTag.id)
      //     );
      //   });

      //   // Apply tag filters
      //   if (andFilter) {
      //     filteredArtworks = filteredArtworks.filter((artwork) => {
      //       const artworkTagIds = artwork.tags.map((a) => a.id);
      //       const filteredTags = artworkTagIds.filter((value) =>
      //         filteredTags.includes(value)
      //       );
      //       return filteredTags.length === filteredTags.length;
      //     });
      //   } else {
      //     filteredArtworks = filteredArtworks.filter((artwork) => {
      //       return artwork.tags.some((aTag) => filteredTags.includes(aTag.id));
      //     });
      //   }
      // }


      return filteredArtworks;
    },


    // table_artworks() {
    //   // console.log('TABLE_ARTWORKS')
    //   // console.log(this.items)
    //   if (this.showSelection) {
    //     return this.selected
    //   }
    //   var filterTags = this.selected_filter_tags
    //   var afterSectionFilter = []
    //   var afterTagFilter = []
    //   var afterOwnershipFilter = []

    //   // filter for deaccessioned
    //   if (this.$route.fullPath === '/artworks/ownership/deaccession') {
    //     // console.log('toggle - deaccessioned')
    //     // console.log(this.selectedOwnership)

    //     afterSectionFilter = this.items.filter((a) => a.deaccessioned == 1)

    //     // filter for commissions
    //   } else if (
    //     this.$route.fullPath === '/artworks/ownership/commissions' &&
    //     this.commissions !== 'all'
    //   ) {
    //     // console.log("commissions - not all");

    //     if (this.commissions === 'not') {
    //       // console.log('not')
    //       afterSectionFilter = this.items.filter(
    //         (aa) => aa.acquired === 'commission'
    //       )
    //       // console.log(afterSectionFilter.length)
    //     } else if (this.commissions === 'tba') {
    //       // console.log('tba')
    //       afterSectionFilter = this.items.filter(
    //         (aa) => aa.acquisition_method === 3 && aa.acquired === 'acquired'
    //       )
    //     } else if (this.commissions === 'com_academy') {
    //       console.log('com_academy')
    //       console.log(this.items.length)
    //       afterSectionFilter = this.items.filter(
    //         (aa) => aa.acquired === 'com_academy'
    //       )
    //       console.log(afterSectionFilter.length)
    //     }

    //     // afterSectionFilter = this.items.filter(
    //     //   aa => aa.acquisition_method === (this.commissions === 'tba' ? 3 : 6)
    //     // )

    //     // else show all artworks
    //   } else {
    //     // console.log('toggle - not COMMISSION neither DEACCESSIONED')
    //     afterSectionFilter = this.items
    //   }

    //   // ak filtrujem by ownerships
    //   if (this.selectedOwnership.id !== 'all') {
    //     afterOwnershipFilter = afterSectionFilter.filter(
    //       (a) => a.ownership == this.selectedOwnership.id
    //     )
    //   } else {
    //     afterOwnershipFilter = afterSectionFilter
    //   }

    //   // ak filtrujem tagmi
    //   if (filterTags.length > 0) {
    //     // console.log('table_artworks - tags')
    //     this.and = filterTags.length === 1 ? (this.and = false) : this.and

    //     /// if there are any concept tags, i have to include all keyword tags in the filter
    //     /// i load all concept tags in var
    //     var conceptTags = []
    //     filterTags.forEach((ft) => {
    //       // console.log(ft)
    //       const found = this.$store.state.tags.find(
    //         (st) => st.id == ft && st.concept_tag == 1
    //       )
    //       if (found) {
    //         conceptTags.push(found)
    //       }
    //     })
    //     // console.log('conceptTags')
    //     // console.log(conceptTags)

    //     /// i search for related keyword tags and add them to temporary var array to filter by
    //     var outTags = Object.assign([], filterTags)
    //     conceptTags.forEach((ct) => {
    //       const keywordTags = this.$store.state.tags.filter(
    //         (st) => st.category == ct.name
    //       )
    //       // console.log('keywordTags')
    //       // console.log(keywordTags)
    //       const keywordTagsMapped = keywordTags.map((kt) => kt.id)
    //       outTags = outTags.concat(keywordTagsMapped)
    //     })
    //     // console.log(filterTags)
    //     // console.log('outTags')
    //     // console.log(outTags)

    //     if (this.and) {
    //       // console.log('AND')
    //       afterTagFilter = afterOwnershipFilter.filter((artwork) => {
    //         /// nacitam si idcka tagov artworku
    //         const artworkTagIds = artwork.tags.map((a) => a.id)
    //         // console.log('artworkTagIds')
    //         // console.log(artworkTagIds)
    //         // const filteringTagIds = filterTags.map(a => a.id)
    //         // console.log('filterTags')
    //         // console.log(filterTags)

    //         /// vyberiem z tagov artworku tie, ktore su vo filtri
    //         const filteredTags = artworkTagIds.filter((value) =>
    //           filterTags.includes(value)
    //         )
    //         // console.log(filteredTags)
    //         /// pocet tagov fo filtri a v artworku musi suhlasit aby bolo AND platne - toto funguje?
    //         const a = filteredTags.length === filterTags.length
    //         // overim, ci niektory z tagov artworku je vo vybranych tagoch
    //         // var a = artwork.tags.some(aTag => filterTags.indexOf(aTag.id) > -1)
    //         var b = a
    //         // if (
    //         //   this.$route.fullPath === '/artworks/ownership/commissions' &&
    //         //   this.commissions !== 'all'
    //         // ) {
    //         //   // console.log("tags - not all");
    //         //   b = a.filter(
    //         //     aa => aa.acquisition_method === (this.commissions === 'tba' ? 3 : 6)
    //         //   )
    //         // }
    //         // return Object.assign([],this.items).sort(dynamicSort(this.sort,this.subsort))
    //         return b
    //       })
    //     } else {
    //       // console.log('else')
    //       afterTagFilter = afterOwnershipFilter.filter((artwork) => {
    //         var a = artwork.tags.some((aTag) => outTags.indexOf(aTag.id) > -1)
    //         var b = a
    //         return b
    //       })
    //     }

    //     // no filters, return filtered after section filter
    //   } else {
    //     afterTagFilter = afterOwnershipFilter
    //   }
    //   return afterTagFilter
    //   // ak su tag filtre prazdne
    //   // }
    //   // else {
    //   //   console.log('no filters');
    //   //   var b = this.afterSectionFilter

    //   //   // if commissions
    //   //   if (
    //   //     this.$route.fullPath === '/artworks/ownership/commissions' &&
    //   //     this.commissions !== 'all'
    //   //   ) {
    //   //     // console.log('not all')
    //   //     // console.log(this.commissions)
    //   //     b = afterSectionFilter.filter(
    //   //       aa => aa.acquisition_method === (this.commissions === 'tba' ? 3 : 6)
    //   //     )
    //   //   // if route is DEACCESSIONED
    //   //   } else if (this.$route.fullPath === '/artworks/ownership/deaccession' && this.selectedOwnership.id !== 'all') {
    //   //     if (this.commissions === 'not') {
    //   //       // console.log('not')
    //   //       b = this.items.filter(
    //   //         aa => aa.acquired === 'commission'
    //   //       )
    //   //     } else if (this.commissions === 'tba') {
    //   //       // console.log('tba')
    //   //       b = this.items.filter(
    //   //         aa => aa.acquisition_method === 3 && aa.acquired === 'acquired'
    //   //       )
    //   //     }
    //   //     console.log(this.selectedOwnership.name)
    //   //   } else {
    //   //     b = afterSectionFilter
    //   //   }
    //   //   // return Object.assign([],this.items).sort(dynamicSort(this.sort,this.subsort))
    //   //   return b
    //   //   // $store.state.artworks
    //   // }
    // },
    tagged_artworks: function tagged_artworks() {
      var cst = this.$store.state.currentSelectionTags;
      return this.table_artworks.filter(function (artwork) {
        return artwork.tags.some(function (aTag) {
          return cst.indexOf(aTag.id) > -1;
        });
      });
    },
    select_tags: function select_tags() {
      var stc = this.selected_tag_categories;
      var tc = this.$store.state.tag_categories;
      var tags = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.$store.state.tags);
      var out = [];
      // add colors to tags from tag categories
      tags.forEach(function (tag) {
        var a = tc.filter(function (tagc) {
          return tagc.id === tag.tag_category_id;
        });
        if (a[0]) {
          tag.color = a[0].color;
        }
        out.push(tag);
      });
      // console.log(out)
      return out.filter(function (tag) {
        return stc.some(function (st) {
          return tag.tag_category_id === st;
        });
      });
      // return out
    },
    select_tags_assign: function select_tags_assign() {
      // var stc = this.selected_tag_categories
      var tc = this.$store.state.tag_categories;
      var tags = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.$store.state.tags);
      var out = [];
      tags.forEach(function (tag) {
        var a = tc.filter(function (tagc) {
          return tagc.id === tag.tag_category_id;
        });
        if (a[0]) {
          tag.color = a[0].color;
        }
        out.push(tag);
      });
      // return out.filter(function(tag) { return stc.some(st => tag.tag_category_id==st)})
      return out;
    }
  },
  // mounted() {},
  created: function created() {
    var _this5 = this;

    this.ownerships = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.$store.getters.my_ownerships);
    // console.log(this.ownerships)
    this.ownerships.unshift({ id: 'all', name: 'All' });
    // this.locations = Object.assign(
    //   [],
    //   this.$store.getters.current_locations
    // ).sort(dynamicSort('name'))
    this.$emit('switchOwnershipTop');
    this.selected = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.ids2o(this.$store.state.currentSelection));
    __WEBPACK_IMPORTED_MODULE_8__main__["serverBus"].$on('clearCurrentSelection', function (a) {
      _this5.selected = [];
    });
    // },
    // created: function() {
    // this.getArtists()
    // this.initialize();
    // this.filtered = this.artists;
    __WEBPACK_IMPORTED_MODULE_8__main__["serverBus"].$on('setSorting', function (a) {
      // console.log('receive')
      // console.log(a)
      _this5.p.sortBy = a;
      _this5.p.descending = !_this5.p.descending;
    });
    this.setSearchValue();
    this.setPageNumberValue();
    if (this.$route.fullPath === '/artworks/ownership/deaccession') {
      if (this.$store.state.filters['deaccession']) {
        // console.log('created store deacc')
        this.selectedOwnership = this.ownerships.find(function (o) {
          return o.id === _this5.$store.state.filters['deaccession'];
        });
      } else {
        // console.log('created no store deacc')
        this.selectedOwnership = { id: 'all', name: 'All' };
      }
    } else {
      // console.log('not in deacc')
      this.selectedOwnership = { id: 'all', name: 'All' };
    }
    // this.toggleOwnership(this.ownerships[0])
  },

  components: {
    TagFilter: __WEBPACK_IMPORTED_MODULE_4__components_artworks_TagFilter_vue__["a" /* default */],
    LocationChangeDialog: __WEBPACK_IMPORTED_MODULE_5__layout_toolbar_items_LocationChangeDialog_vue__["a" /* default */],
    AttachTagToArtworksDialog: __WEBPACK_IMPORTED_MODULE_6__components_artworks_AttachTagToArtworksDialog_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "/OND":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/ZRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork', 'uploadCategory', 'field', 'id'],
  data: function data() {
    return {
      previewDialog: false,
      prieviewFile: {},
      dialog: false,
      file_to_delete: '',
      showUpload: false,
      showUploadForm: false,
      show: false,
      count: 3
      // thumbnailWidth: 120,
      // thumbnailHeight: 120,
      // headers: { "artwork": "artwork.id" },
      // previewTemplate: `
      //   <div class="dz-preview dz-file-preview">
      //     <div class="dz-details">
      //       <input type="text" />
      //       <div class="dz-filename"><span data-dz-name></span></div>
      //       <div class="dz-size" data-dz-size></div>
      //       <img data-dz-thumbnail />
      //     </div>
      //     <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
      //     <div class="dz-success-mark"><span>✔</span></div>
      //     <div class="dz-error-mark"><span>✘</span></div>
      //     <div class="dz-error-message"><span data-dz-errormessage></span></div>
      //   </div>`
      // }
    };
  },
  computed: {
    categoryC: function categoryC() {
      return this.uploadCategory ? this.uploadCategory : this.field.name;
    },
    upload_relation_id: function upload_relation_id() {
      return this.artwork ? this.artwork.id : this.id ? this.id : null;
    },
    upload_rights: function upload_rights() {
      if (this.c_user && this.c_user.roles) {
        var a = this.c_user.roles.find(function (ur) {
          return ur.shortcut === 'file_u';
        });
        return a;
      } else {
        return false;
      }
    },
    download_rights: function download_rights() {
      if (this.field.name == 'artwork_literature') {
        return true;
      } else {
        if (this.c_user && this.c_user.roles) {
          var a = this.c_user.roles.find(function (ur) {
            return ur.shortcut === 'file_d';
          });
          return a;
        } else {
          return false;
        }
      }
    },
    files: function files() {
      var _this = this;

      // console.log(this.$store.state.users.users[2])
      if (this.artwork && this.artwork.file_uploads && this.artwork.file_uploads.length > 0 && this.field.category) {
        return this.artwork.file_uploads.filter(function (f) {
          return f.artwork_id === _this.artwork.id && f.category === _this.field.category;
        });
      } else if (this.artwork && this.artwork.file_uploads && this.artwork.file_uploads.length > 0 && this.uploadCategory) {
        return this.artwork.file_uploads.filter(function (f) {
          return f.artwork_id === _this.artwork.id && f.category === _this.uploadCategory;
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    view: function view(f) {
      this.prieviewFile = f;
      this.previewDialog = true;
    },
    closePreviewDialog: function closePreviewDialog() {
      this.previewDialog = false;
      this.prieviewFile = {};
    },
    delete_file: function delete_file(id) {
      this.dialog = true;
      this.file_to_delete = this.artwork.file_uploads.find(function (f) {
        return f.id === id;
      });
    },
    deleteItem: function deleteItem() {
      // const index = this.artwork.file_uploads.indexOf(this.file_to_delete)
      var i = this.artwork.file_uploads.indexOf(this.file_to_delete);
      if (i !== -1) {
        this.artwork.file_uploads.splice(i, 1);
      }
      this.$store.dispatch('deleteFileUpload', this.file_to_delete);
      this.file_to_delete = {};
      this.dialog = false;
    },
    cancelDelete: function cancelDelete() {
      this.dialog = false;
      this.file_to_delete = {};
    }
  }
});

/***/ }),

/***/ "/gnG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/iMw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/llq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_axios_js__ = __webpack_require__("81r7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_axios_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      valid: true,
      new_artwork_added: true,
      new_artist_added: true,
      artwork_modified: true,
      artist_modified: true
    };
  },
  methods: {
    submit: function submit() {
      if (this.$refs.form.validate()) {
        // Native form submission is not yet supported
        __WEBPACK_IMPORTED_MODULE_0__static_axios_js___default.a.post('/api/submit', {
          new_artwork_added: this.new_artwork_added,
          new_artist_added: this.new_artist_added,
          artwork_modified: this.artwork_modified,
          artist_modified: this.artist_modified
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),

/***/ "/nBd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Logout',
  created: function created() {
    delete localStorage.token;
    this.$store.dispatch('logout');
    this.$router.push('/');
  }
});

/***/ }),

/***/ "/pOa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facts_vue__ = __webpack_require__("hmyu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0740e527_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Facts_vue__ = __webpack_require__("bPpd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("KPIh")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0740e527"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0740e527_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Facts_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0740e527_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Facts_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/rCi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artist', 'artists', 'text_id'],
  computed: {
    table_artists: function table_artists() {
      var _this = this;

      // console.log('this.artists')
      // console.log(this.artists)
      // console.log(this.artists.map(am => am.id))
      // console.log(this.$store.state.artists.filter(a => (this.artists.map(am => am.id)).includes(a.id)))
      return this.$store.state.artists.filter(function (a) {
        return _this.artists.map(function (am) {
          return am.id;
        }).includes(a.id);
      });
    }
  },
  methods: {
    remove_from_text: function remove_from_text(artist_id) {
      var _this2 = this;

      // console.log(list_id)
      // console.log(artist_id)
      var text = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.texts.find(function (e) {
        return e.id == _this2.text_id;
      }));
      // console.log(list)
      text.artists = text.artists.filter(function (a) {
        return a != artist_id;
      });
      // let url = `${this.$globals.apiserver}/lists.json`
      // axios.post(url).then((response) => {
      //   this.loading = false;
      // this.resultsArtists = response.data
      this.$store.dispatch('removeArtistFromText', { e: this.text_id, a: artist_id });
      // this.displayedData = response.data

      // }).catch((error) => { console.log(error) })
      // console.log(text)
    },

    // artist_artworks (artist_id) {
    //   var a = Object.assign([],this.$store.state.artists)
    //   // console.log('artist_id')
    //   // console.log(artist_id)
    //   // console.log(a.artist_id == artist_id)
    //   var aa = a.filter(a => {
    //     // console.log('a.artist_id')
    //     // console.log(a.artist_id)
    //     // console.log(artist_id)
    //     return a.artist_id === artist_id}
    //   )
    //   // console.log(aa)
    //   return aa
    // },
    clear_selection: function clear_selection() {
      this.$store.dispatch('clearCurrentSelection');
      this.selected = [];
    },
    select_all: function select_all() {},
    save_currently_selected: function save_currently_selected(a, b) {
      // console.log('///////////')
      // console.log('a = ' + a)
      // console.log('b = ' + b.id)
      setTimeout(function () {
        var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
        //// console.log(temp_selection)
        if (!a) {
          // console.log('a true')
          if (!temp_selection.includes(b)) {
            // console.log('doesnt include')
            temp_selection.push(b);
          }
        } else {
          // console.log('false')
          var index = temp_selection.indexOf(b);
          // console.log('index = ' + index)
          temp_selection.splice(index, 1);
        }
        // this.$store.state.currentSelection
        // console.log(temp_selection)
        // this.selected.forEach(s => {
        //   if (!temp_selection.includes(s)) {
        //     temp_selection.push(s)
        //   }
        // })
        // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
        this.$store.dispatch('saveCurrentSelection', temp_selection);
      }.bind(this), 1000);
    },
    save_currently_selected_all: function save_currently_selected_all(a) {
      // console.log('///////////')
      // console.log('a = ' + a)
      var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(temp_selection)
      if (!a) {
        // console.log('a true')
        if (!temp_selection.includes(b)) {
          // console.log('doesnt include')
          temp_selection.push(b);
        }
      } else {
        // console.log('false')
        var index = temp_selection.indexOf(b);
        // console.log('index = ' + index)
        temp_selection.splice(index, 1);
      }
      // this.$store.state.currentSelection
      // console.log(temp_selection)
      // this.selected.forEach(s => {
      //   if (!temp_selection.includes(s)) {
      //     temp_selection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', temp_selection);
    },
    save_currently_selected_tags: function save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags);
      this.ta = this.tagged_artists;
    }
  }
});

/***/ }),

/***/ "/vtv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake__ = __webpack_require__("EWlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts__ = __webpack_require__("u1n8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts__);


//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      outputFields: ['classification'],
      output_fields: [],
      outputFieldsParams: [],
      valid: true,
      view: 'table',
      sort: 'full_name',
      title: 'LIST TITLE',
      subtitle: 'List description',
      pdf_artworks: []
    };
  },
  props: {
    light: Boolean,
    small: Boolean,
    item: Object,
    use_current_selection: Boolean
  },
  created: function created() {
    // this.pdfLabels()
  },


  methods: {
    // o2ids (array,prop) {
    //   return array.map(a => a[prop])
    // },
    // ids2o (array) {
    //   var objs = Object.assign([], this.$store.state.artworks)
    //   var out = objs.filter(a => {
    //     // console.log(array.includes(a.id))
    //     return (array.includes(a.id))
    //   })
    //   return out
    // },
    pdfLabelsCall: function pdfLabelsCall() {
      // console.log('pdfLabelsCall')
      this.loading = true;
      setTimeout(function () {
        setTimeout(function () {
          this.pdfLabels();
          this.loading = false;
        }.bind(this), 0);
      }.bind(this), 500);
    },
    pdfLabels: function pdfLabels() {
      var _this = this;

      var output_fields = this.output_fields;
      var use_current_selection = this.use_current_selection;
      function dynamicSort(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function (a, b) {
          var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
          return result * sortOrder;
        };
      }
      // console.log('labels small text')
      // console.log(this.item)
      if (this.item && this.item.artworks.length > 0) {
        this.pdf_artworks = this.item.artworks;
      } else {
        // console.log(this.use_current_selection)
        if (use_current_selection == true) {
          // this.pdf_artworks = Object.assign([], this.$store.state.currentSelection)
          if (this.$store.state.currentSelection.length > 0) {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], ids2o(this.$store.state.currentSelection)).sort(dynamicSort(this.sort));
          } else {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks).sort(dynamicSort(this.sort));
          }
        } else {
          if (this.$store.state.filterResults) {
            var objs = this.ids2o(this.$store.state.filterResults);
            this.pdf_artworks = objs.sort(dynamicSort(this.sort));
          } else {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks).sort(dynamicSort(this.sort));
          }
        }
      }
      var transformedULSData = [];
      this.pdf_artworks.forEach(function (a) {

        var o = '';
        if (typeof a == 'number') {
          o = _this.$store.state.artworks.find(function (f) {
            return f.id == a;
          });
        } else {
          o = a;
        }

        transformedULSData.push({
          "title": o.title,
          "full_name": o.full_name,
          "accession_number": o.accession_number,
          "production_date_new": o.production_date_new ? o.production_date_new : '',
          "dim": o.dim_f_json,
          "ownership": o.ownership
        });
      });
      // console.log(transformedULSData)
      // console.log('labels small text')

      var reportDate = function reportDate() {
        return new Date();
      };

      var createDocumentDefinition = function createDocumentDefinition(reportDate, subHeading) {
        for (var _len = arguments.length, contentParts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          contentParts[_key - 2] = arguments[_key];
        }

        var _docDefinition$conten;

        var baseDocDefinition = {
          pageSize: 'A4',
          pageMargins: [22, 55, 0, 0],
          info: {
            title: 'Text Labels A4',
            subject: 'Text Labels A4'
          },
          // defaultStyle: {
          //   font: 'HelveticaNeue'
          // },
          styles: {
            title: { fontSize: 9, bold: true, margin: [8, 2, 0, 0], width: 150 },
            title2: { fontSize: 9, bold: true, margin: [8, 2, 0, 25], width: 150 },
            artwork_title: { fontSize: 11, margin: [8, 0, 0, 0], width: 150 }
          },
          // fonts: {
          //   HelveticaNeue: {
          //     normal: ['HelveticaNeue.ttc', 'HelveticaNeue-Regular'],
          //     bold: ['HelveticaNeue.ttc', 'HelveticaNeue-Bold'],
          //     italics: ['HelveticaNeue.ttc', 'HelveticaNeue-Italic'],
          //     bolditalics: ['HelveticaNeue.ttc', 'HelveticaNeue-BoldItalic']
          //   }
          // },
          content: [{
            columns: []
          }]
        };
        var docDefinition = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(baseDocDefinition));
        // docDefinition.footer = baseDocDefinition.footer
        (_docDefinition$conten = docDefinition.content).push.apply(_docDefinition$conten, contentParts);
        return docDefinition;
      };

      var rowData = function rowData(a) {
        var stack = {
          stack: []
        };
        var title_and_year = a['title'] + ", " + a['production_date_new'];

        switch (a['ownership']) {
          case '6':
            stack.stack.push({ text: 'FRANCESCA VON HABSBURG', style: 'artwork_title' });
            stack.stack.push({ text: 'PRIVATE ART COLLECTION', style: 'artwork_title' });
            break;
          case '1':
            stack.stack.push({ text: 'TBA21 COLLECTION', style: 'artwork_title' });
            break;
          case '7':
            stack.stack.push({ text: 'FRANCESCA VON HABSBURG', style: 'artwork_title' });
            stack.stack.push({ text: 'PRIVATE DESIGN COLLECTION', style: 'artwork_title' });
            break;
          case '10':
            stack.stack.push({ text: 'PRIVATE ART COLLECTION MR', style: 'artwork_title' });
            break;
          case 'de':
            stack.stack.push({ text: 'DEACCESSION', style: 'artwork_title' });
            break;
          // case '9 ':
          //   stack.stack.push({text: 'OLD MASTERS', style: 'artwork_title'});
          //   break
          default:
            stack.stack.push({ text: 'OTHER', style: 'artwork_title' });
        }

        // stack.stack.push({text: 'FRANCESCA VON HABSBURG', style: 'artwork_title'});
        // stack.stack.push({text: 'PRIVATE COLLECTION', style: 'artwork_title'});
        stack.stack.push({ text: a['accession_number'], style: 'artwork_title' });
        stack.stack.push({ text: a['full_name'], style: 'artwork_title' });
        stack.stack.push({ text: a['dim'], style: 'artwork_title' });
        return stack;
      };

      var rowData2 = function rowData2(a, c) {
        // if (c==1) {
        //   var x = 10
        //   var y = 0
        // } else {
        //   var x = 300
        //   var y = 0
        // }
        var stack = {
          // absolutePosition: {x: x, y: y},
          stack: []
        };
        var title_and_year = a['title'] + ", " + a['production_date_new'];
        // if (c==2) {
        //   var style = 'artwork_title'
        // } else {
        //   var style = 'artwork_title'
        // }

        switch (a['ownership']) {
          case 6:
            stack.stack.push({ text: 'FRANCESCA VON HABSBURG', style: 'title' });
            stack.stack.push({ text: 'PRIVATE ART COLLECTION', style: 'title2' });
            break;
          case 1:
            stack.stack.push({ text: 'TBA21 COLLECTION', style: 'title2' });
            break;
          case 7:
            stack.stack.push({ text: 'FRANCESCA VON HABSBURG', style: 'title' });
            stack.stack.push({ text: 'PRIVATE DESIGN COLLECTION', style: 'title2' });
            break;
          case 10:
            stack.stack.push({ text: 'PRIVATE ART COLLECTION MR', style: 'title2' });
            break;
          case 'de':
            stack.stack.push({ text: 'DEACCESSION', style: 'title2' });
            break;
          // case '9 ':
          //   stack.stack.push({text: 'OLD MASTERS', style: 'title2'});
          //   break
          default:
            stack.stack.push({ text: 'OTHER', style: 'title2' });
        }
        // stack.stack.push({text: 'FRANCESCA VON HABSBURG', style: 'title'});
        // stack.stack.push({text: 'PRIVATE COLLECTION', style: 'title2'});
        stack.stack.push({ text: a['accession_number'], style: 'artwork_title' });
        stack.stack.push({ text: a['full_name'], style: 'artwork_title' });
        stack.stack.push({ text: title_and_year, style: 'artwork_title' });
        stack.stack.push({ text: a['dim'], style: 'artwork_title' });
        return stack;
      };

      makeUnderlyingLoanSummaryDoc();

      function makeUnderlyingLoanSummaryDoc() {
        var averyBody = function averyBody(dataRows) {
          var c = 1;
          var rows = [];
          var cols = [];
          dataRows.forEach(function (row, index) {
            cols.push(rowData2(row, c));
            c = c + 1;
            if (dataRows.length == 1) {
              c = 1;
              rows.push(cols);
              cols = [];
            } else {
              if (c == 3) {
                c = 1;
                rows.push(cols);
                cols = [];
              }
            }
          });
          return rows;
        };
        var tableColumnWidths = [290, 250];
        var tableData = {
          layout: 'noBorders',
          table: {
            heights: 192,
            dontBreakRows: true,
            widths: tableColumnWidths,
            body: averyBody(transformedULSData)
          }
        };
        var docDefinition = createDocumentDefinition(reportDate(), 'Summary', tableData);
        __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download('A4-small-text-labels.pdf');
      }
    }
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "05WY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5 mx-4 px-3"},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":"","mb-3":""}}),_vm._v(" "),_c('v-stepper',{staticClass:"elevation-1",model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 1,"step":"1"}},[_vm._v("Basic ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 2,"step":"2"}},[_vm._v(" Artworks")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3"}},[_vm._v("Summary")])],1),_vm._v(" "),(_vm.progress)?_c('v-progress-linear',{staticClass:"mt-0 pt-0",attrs:{"indeterminate":"","height":"2"}}):_vm._e(),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-3 elevation-0"},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-4",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Title"},model:{value:(_vm.exhibition.title),callback:function ($$v) {_vm.$set(_vm.exhibition, "title", $$v)},expression:"exhibition.title"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-4",attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":"Institution","items":_vm.institutions,"item-value":"id","item-text":"name"},model:{value:(_vm.exhibition.institution_id),callback:function ($$v) {_vm.$set(_vm.exhibition, "institution_id", $$v)},expression:"exhibition.institution_id"}}),_vm._v("\n                  "+_vm._s(_vm.exhibition.institution)+"\n                  ")],1),_vm._v(" "),_c('v-flex',{staticClass:"px-4",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"City"},model:{value:(_vm.exhibition.city),callback:function ($$v) {_vm.$set(_vm.exhibition, "city", $$v)},expression:"exhibition.city"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-4",attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"items":this.countries,"label":"Country"},model:{value:(_vm.exhibition.country),callback:function ($$v) {_vm.$set(_vm.exhibition, "country", $$v)},expression:"exhibition.country"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4 pr-3",attrs:{"xs12":"","sm4":"","md2":"","lg2":""}},[_c('v-text-field',{attrs:{"label":"Start Year","placeholder":"XXXX","type":"number","maxlength":4,"mask":"####","min":"1800","max":"2030"},model:{value:(_vm.exhibition.duration_start_year),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_start_year", $$v)},expression:"exhibition.duration_start_year"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":"","lg2":"","pl-4":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"Month","placeholder":"XX","type":"number","mask":"##","max":"12"},model:{value:(_vm.exhibition.duration_start_month),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_start_month", $$v)},expression:"exhibition.duration_start_month"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4 pr-4",attrs:{"xs6":"","sm4":"","md2":"","lg2":""}},[_c('v-text-field',{attrs:{"label":"Day","placeholder":"XX","type":"number","mask":"##","max":"31"},model:{value:(_vm.exhibition.duration_start_day),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_start_day", $$v)},expression:"exhibition.duration_start_day"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-4",attrs:{"xs12":"","sm4":"","md2":"","lg2":""}},[_c('v-text-field',{attrs:{"label":"End Year","placeholder":"XXXX","type":"number","mask":"####","min":"1800","max":"2030"},model:{value:(_vm.exhibition.duration_end_year),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_end_year", $$v)},expression:"exhibition.duration_end_year"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":"","lg2":"","pl-4":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"Month","placeholder":"XX","type":"number","mask":"##","max":"12"},model:{value:(_vm.exhibition.duration_end_month),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_end_month", $$v)},expression:"exhibition.duration_end_month"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":"","lg2":"","pl-4":"","pr-4":""}},[_c('v-text-field',{attrs:{"label":"Day","placeholder":"XX","type":"number","mask":"##","max":"31"},model:{value:(_vm.exhibition.duration_end_day),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_end_day", $$v)},expression:"exhibition.duration_end_day"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-4 pt-4 mt-2",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-btn-toggle',{model:{value:(_vm.exhibition.show_type),callback:function ($$v) {_vm.$set(_vm.exhibition, "show_type", $$v)},expression:"exhibition.show_type"}},[_c('v-btn',{key:"group",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"2","value":"2"}},[_c('span',[_vm._v(" Group Show ")])]),_vm._v(" "),_c('v-btn',{key:"solo",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"1","value":"1"}},[_c('span',[_vm._v(" Solo Show ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"px-5",attrs:{"xs12":"","sm6":"","md6":"","pt-3":""}},[_c('v-switch',{attrs:{"label":"Loan ","value":"1","color":"black"},model:{value:(_vm.exhibition.loan),callback:function ($$v) {_vm.$set(_vm.exhibition, "loan", $$v)},expression:"exhibition.loan"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","px-4":""}},[_c('v-textarea',{attrs:{"label":"Note","auto-grow":"","clearable":"","rows":"1"},model:{value:(_vm.exhibition.admin_note),callback:function ($$v) {_vm.$set(_vm.exhibition, "admin_note", $$v)},expression:"exhibition.admin_note"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-end":"","mt-5":""}},[_c('v-btn',{attrs:{"color":"primary","disabled":_vm.valid == ''},on:{"click":function($event){return _vm.saveExhibition()}}},[_vm._v("SAVE")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Cancel")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-5 pb-1",attrs:{"color":"grey lighten-4"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-autocomplete',{attrs:{"multiple":"","open-on-clear":"","auto-select-first":"","clearable":"","hide-details":"","items":_vm.artworks,"item-text":function (item) { return item.title +
                      ', ' +
                      item.accession_number +
                      ', ' +
                      item.name; },"label":"Select Artworks to add to this Exhibition.","item-value":"id","menu-props":"{\"closeOnClick\":true, \"closeOnContentClick\":false, \"openOnClick\":false, \"maxHeight\":600}"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{attrs:{"selected":data.selected,"close":""},on:{"input":function($event){return _vm.remove(data.item)}}},[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.title)}}),_vm._v(" \n                      "),_c('span',[_vm._v(_vm._s(data.item.accession_number)+" ")]),_vm._v(" \n                      "),_c('strong',{domProps:{"innerHTML":_vm._s(
                          data.item.artist
                            ? data.item.artist.name
                            : data.item.name
                        )}})])]}}]),model:{value:(_vm.exhibition_artworks_ori),callback:function ($$v) {_vm.exhibition_artworks_ori=$$v},expression:"exhibition_artworks_ori"}})],1)],1)],1),_vm._v(" "),(_vm.exhibition_artworks)?_c('div',{staticClass:"pt-0 ml-4 mb-2 mt-0",attrs:{"title":""}},[_c('h3',[_vm._v("Artworks in Exhibition ("+_vm._s(_vm.exhibition_artworks.length)+")")])]):_vm._e(),_vm._v(" "),_c('v-list',{staticClass:"mx-4 mb-4",attrs:{"two-line":""}},_vm._l((_vm.exhibition_artworks),function(item){return _c('v-list-tile',{key:item.id},[_c('v-list-tile-avatar',[(item.top_photo_id > 0)?_c('img',{attrs:{"src":((_vm.$globals.fileserver) + "/data/artwork/" + (item.id) + "/" + (item.top_photo_id) + "_th_big.jpg")}}):_vm._e()]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((item.title) + " (" + (item.production_date_new) + ")"))}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.full_name)}})],1)],1)}),1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 1}}},[_c('v-icon',{staticClass:"pr-2"},[_vm._v("mdi-arrow-left-bold-box")]),_vm._v("Back to\n          Basic")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},nativeOn:{"click":function($event){return _vm.updateExhibition.apply(null, arguments)}}},[_vm._v("Save and Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.$router.push('/exhibitions')}}},[_vm._v("Cancel & go to Exhibition List")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-5 pl-3 pr-3 pb-3",attrs:{"color":"grey lighten-4 elevation-0"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('br'),_vm._v(" "),_c('h3',{staticClass:"title mb-3"},[_vm._v("\n              "+_vm._s(_vm.exhibition.title)+"\n              "),(_vm.exhibition.loan)?_c('span',[_vm._v(" - (LOAN)")]):_vm._e(),_vm._v(" "),(_vm.exhibition.show_type == 1)?_c('span',[_vm._v(" - (SOLO)")]):_vm._e(),_vm._v(" "),(_vm.exhibition.show_type == 2)?_c('span',[_vm._v(" - (GROUP)")]):_vm._e()]),_vm._v(" "),_c('table',{staticClass:"mb-0 main"},[_c('tr',[_c('td',[_vm._v("Start Date:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.start_date))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("End Date:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.end_date))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Institution:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.exhibition.institution))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("City:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.exhibition.city))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Country:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.exhibition.country))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Note:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.exhibition.admin_note))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"height":"3em","vertical-align":"bottom"},attrs:{"colspan":"2"}},[_vm._v("\n                  Artworks:\n                ")])])]),_vm._v(" "),_c('v-list',{staticClass:"mx-0 mb-2",attrs:{"two-line":""}},_vm._l((_vm.exhibition.artworks),function(item){return _c('v-list-tile',{key:item.id},[_c('v-list-tile-avatar',[(item.top_photo_id > 0)?_c('img',{attrs:{"src":((this.$globals.apiserver) + "/data/artwork/" + (item.id) + "/" + (item.top_photo_id) + "_th_big.jpg")}}):_vm._e()]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((item.title) + " (" + (item.production_date_new) + ")"))}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.full_name)}})],1)],1)}),1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-arrow-left-bold-box")]),_vm._v("\n              Back to Artwork Selection\n            ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.$router.push('/exhibitions')}}},[_vm._v("go to Exhibition List")])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.push({
              name: 'EditExhibition',
              params: { id: _vm.exhibition.id, exhibition: _vm.exhibition },
              path: ("/exhibitions/edit/" + (_vm.exhibition.id))
            })}}},[_vm._v("\n          Go to Exhibition Edit Page\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "0HId":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__("RyBy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f94b0d38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__("6F6e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("50mt")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f94b0d38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f94b0d38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0JL3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    var _this = this;

    this.$store.dispatch("loadContacts");
    this.contacts = this.$store.state.contacts;
    this.ownerships = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.getters.my_ownerships);
    this.ownerships.unshift({ id: 'all', name: 'All' });
    // this.initialize();
    // this.filtered = this.exhibitions;
    __WEBPACK_IMPORTED_MODULE_2__main__["serverBus"].$on("setSorting", function (a) {
      // console.log('receive')
      // console.log(a)
      _this.pagination.sortBy = a;
      _this.pagination.descending = !_this.pagination.descending;
    });
    this.toggleOwnership(this.$store.state.filters['contacts'] ? this.$store.state.filters['contacts'] : this.ownerships[0]);
    // this.toggleOwnership(this.ownerships[0]);
  },
  data: function data() {
    return {
      dialog: false,
      ownerships: [],
      contacts: [],
      selectedOwnership: '',
      contact: "",
      contact2: {},
      selectedContact: "",
      artworks: [],
      artworks2: [],
      show_tag_filter: false,
      show_classifications: false,
      filter: {
        selected_classifications: [],
        selected_classification_negations: []
      },
      ta: [],
      selected_tags: [],
      selected_categories: [],
      selected: [],
      search: "",
      pagination: {
        rowsPerPage: 15,
        sortBy: "name"
      },
      headers: [{ sortable: false }, { text: "Name", value: "name", align: "left" }, { text: "Company", value: "company", align: "left" }, { text: "Category", value: "category", align: "left" }, { text: "Artworks", value: "artworks.length", align: "left" }]
    };
  },

  props: ["items"],
  methods: {
    toggleOwnership: function toggleOwnership(o) {
      // this.selectedOwnership = o;
      // if(this.selectedOwnership.id != 'all') {
      //   // console.log('not all')
      //   this.contacts = this.table_contacts.filter(c =>
      //     c.artworks.some(
      //       ca => ca.ownership == this.selectedOwnership.id
      //     )
      //   );
      // } else {
      //   this.contacts = this.table_contacts;
      // }
      this.$store.dispatch('setFilter', { section: 'contacts', ownership: o });

      this.selectedOwnership = o.name;
      if (o.id != 'all') {
        this.contacts = this.table_contacts.filter(function (a) {
          return a.artworks.some(function (ea) {
            return ea.ownership == o.id;
          });
        });
      } else {
        this.contacts = this.table_contacts;
      }
      // return this.$store.state.contacts.filter(
      //   c =>
      //     c.category == "artwork_acquisition_source" ||
      //     c.category == "registrar"
      // );

      // var array = [];
      // for (var i in ownerships) {
      //   // array.push(i);
      //   array.push(ownerships[i]);
      // }
      // console.log(array);
      // console.log(this.ownerships);
      // console.log(array.indexOf(this.s_ownership));
      // console.log(this.s_ownership);
      // console.log(this.ownerships.indexOf(this.s_ownership));
      // this.selectedOwnership = o.name;
      // if(o.id != 'all') {
      //   this.contacts = this.table_contacts.filter(a =>
      //     a.artworks.some(
      //       ea => ea.ownership == o.id
      //     )
      //   );
      // } else {
      //   this.contacts = this.table_contacts;
      // }
    },
    resetSelected: function resetSelected() {
      this.selected = [];
      this.artworks = [];
      this.artworks2 = [];
    },
    setContact2: function setContact2() {
      var _this2 = this;

      this.contact2 = this.$store.state.contacts.find(function (c) {
        return c.id === _this2.selectedContact;
      });
      this.artworks2 = this.$store.state.artworks.filter(function (a) {
        return a.acquisition_source_id === _this2.contact2.id;
      });
    },
    deleteContact: function deleteContact(c) {
      this.selected = [];
      this.selected.push(c);
      this.dialog = true;
      this.contact = c;
      this.artworks = this.$store.state.artworks.filter(function (a) {
        return c.id == a.acquisition_source_id;
      });
    },
    deleteContacts: function deleteContacts() {
      var _this3 = this;

      this.dialog = true;
      // this.contact = c;
      this.artworks = this.$store.state.artworks.filter(function (a) {
        return _this3.selected.map(function (a) {
          return a.id;
        }).includes(a.acquisition_source_id);
      });
    },
    deleteContact2: function deleteContact2() {
      var _this4 = this;

      this.artworks.forEach(function (c) {
        // console.log(c);
        _this4.$emit("showSnackbar", "Deleting Contact: " + c.title);
        setTimeout(function () {
          var url = _this4.$globals.apiserver + "/artworks/" + c.id + ".json";
          // console.log("updating artwork start");
          // console.log(url);
          // console.log(this.selectedContact);
          // console.log("updating artwork end");
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, {
            field_name: "acquisition_source_id",
            field_value: _this4.selectedContact,
            updated_by: _this4.c_user.id
          }).then(function (response) {
            _this4.$emit("showSnackbar", "Saved Artwork's Acquisition Source", "green");
            _this4.progress = false;
            _this4.isEditing = false;

            _this4.$store.dispatch("loadContacts");
            _this4.$store.dispatch("loadArtworks");
          }).catch(function (error) {
            _this4.$emit("showSnackbar", "Error Saving Artwork's Acquisition Source", "red");
            _this4.progress = false;
            _this4.isEditing = false;
          });
        }, 1000);
      });

      this.selected.forEach(function (c) {
        _this4.$emit("showSnackbar", "Deleting Contact: " + c.name);
        setTimeout(function () {
          var url = _this4.$globals.apiserver + "/contacts/" + c.id + ".json";
          // console.log("deleting contact start");
          // console.log(url);
          // console.log(c);
          // console.log("deleting contact end");
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.delete(url).then(function (response) {
            _this4.$emit("showSnackbar", "Deleted " + c.name, "green");
            _this4.progress = false;
            _this4.isEditing = false;

            _this4.$store.dispatch("loadContacts");
            _this4.$store.dispatch("loadArtworks");
          }).catch(function (error) {
            _this4.$emit("showSnackbar", "Error Deleting " + c.name, "red");
            _this4.progress = false;
            _this4.isEditing = false;
          });
        }, 1000);
      });

      this.dialog = false;
      this.contact = "";
      this.artworks = [];
      this.artworks2 = [];
      this.selected = [];
    }
  },
  computed: {
    // artworks2() {
    //   return this.$store.state.artworks.filter(
    //     (a) => a.acquisition_source_id === this.contact2.id
    //   );
    // },
    table_contacts: function table_contacts() {
      // if (this.contacts && this.contacts.length > 0) {
      //   return this.$store.state.contacts.filter(
      //     c =>
      //       (c.category == "artwork_acquisition_source" ||
      //         c.category == "registrar") &&
      //       this.contacts.includes(contact2)
      //   );
      // } else {

      // this.selectedOwnership = o.name;
      // if(this.selectedOwnership.id != 'all') {
      //   this.contacts = this.contacts.filter(a =>
      //     a.artworks.some(
      //       ea => ea.ownership == this.selectedOwnership.id
      //     )
      //   );
      // } else {
      //   this.contacts = this.contacts;
      // }

      return this.$store.state.contacts.filter(function (c) {
        return c.category == "artwork_acquisition_source" || c.category == "registrar" || c.category == "exhibition_institution";
      });
      // }
    }
  }
});
// if (this.selected_categories.length > 0) {
//   var cst = this.selected_categories
//   var a = this.$store.state.contacts.filter(function(contact) {
//     return cst.indexOf(contact.category) > -1
//   })
//   return this.$store.state.contacts.filter(function(contact) {
//     return cst.indexOf(contact.category) > -1
//   })
// } else {
//   return this.items
// }
// currrent_path() {
//   return this.$route.params.ownership;
// },
// saved_lists() {
//   return [
//     { id: 1, title: "list1" },
//     { id: 2, title: "list2" },
//   ];
// },
// selected_contacts() {
//   return this.$store.state.currentSelection;
// },
// tagged_contacts() {
//   var cst = this.$store.state.currentSelectionTags;
//   return this.table_contacts.filter(function (contact) {
//     return contact.tags.some((a_tag) => cst.indexOf(a_tag.id) > -1);
//   });
// },
// select_categories() {
//   var stc = this.selected_tag_categories;
//   var tc = this.tag_categories;
//   var tags = Object.assign([], this.$store.state.tags);
//   var out = [];
//   // console.log(tags)
//   tags.forEach((tag) => {
//     var a = tc.filter(function (tagc) {
//       return tagc.id == tag.tag_category_id;
//     });
//     // console.log(a[0].color)
//     tag.color = a[0].color;
//     out.push(tag);
//   });
//   // console.log(out)
//   return out.filter(function (tag) {
//     return stc.some((st) => tag.tag_category_id == st);
//   });
// },
// switchSwitch() {
//   // this.show_tag_filter = !this.show_tag_filter
//   this.$emit("switchOwnershipTop", this.show_tag_filter);
// },
// clearFilters() {
//   this.selected_tags = [];
//   this.selected_tag_categories = [];
// },
// clear_selection() {
//   this.$store.dispatch("clearCurrentSelection");
//   this.selected = [];
// },
// select_all() {
//   this.selected = this.table_contacts;
//   var temp_selection = Object.assign(
//     [],
//     this.$store.state.currentSelection
//   );
//   this.table_contacts.forEach((a) => {
//     if (!temp_selection.includes(a)) {
//       temp_selection.push(a);
//     }
//   });
//   this.$store.dispatch("saveCurrentSelection", temp_selection);
// },
// save_selection() {
//   this.$store.dispatch("clearCurrentSelection");
// },
// save_currently_selected(a, b) {
//   setTimeout(
//     function () {
//       var temp_selection = Object.assign(
//         [],
//         this.$store.state.currentSelection
//       );
//       //// console.log(temp_selection)
//       if (!a) {
//         // console.log('a true')
//         if (!temp_selection.includes(b)) {
//           // console.log('doesnt include')
//           temp_selection.push(b);
//         }
//       } else {
//         // console.log('false')
//         var index = temp_selection.indexOf(b);
//         // console.log('index = ' + index)
//         temp_selection.splice(index, 1);
//       }
//       this.$store.dispatch("saveCurrentSelection", temp_selection);
//     }.bind(this),
//     1000
//   );
// },
// save_currently_selected_all(a) {
//   // console.log('///////////')
//   // console.log('a = ' + a)
//   var temp_selection = Object.assign(
//     [],
//     this.$store.state.currentSelection
//   );
//   // console.log(temp_selection)
//   if (!a) {
//     // console.log('a true')
//     if (!temp_selection.includes(b)) {
//       // console.log('doesnt include')
//       temp_selection.push(b);
//     }
//   } else {
//     // console.log('false')
//     var index = temp_selection.indexOf(b);
//     // console.log('index = ' + index)
//     temp_selection.splice(index, 1);
//   }
//   // this.$store.state.currentSelection
//   // console.log(temp_selection)
//   // this.selected.forEach(s => {
//   //   if (!temp_selection.includes(s)) {
//   //     temp_selection.push(s)
//   //   }
//   // })
//   // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
//   this.$store.dispatch("saveCurrentSelection", temp_selection);
// },
// save_currently_selected_tags() {
//   this.$store.dispatch("saveCurrentSelectionTags", this.selected_tags);
//   this.ta = this.tagged_contacts;
// },
// contact_categories: [
//   { id: 1, name: "loan_borrower", color: "red", position: 2 },
//   { id: 3, name: "loan_contact_person", color: "blue", position: 1 },
//   { id: 7, name: "loan_insurance_company", color: "purple", position: 7 },
//   {
//     id: 2,
//     name: "artwork_acquisition_source",
//     color: "green",
//     position: 3,
//   },
//   { id: 4, name: "registrar", color: "yellow", position: 4 },
//   { id: 5, name: "staff", color: "pink", position: 5 },
//   {
//     id: 6,
//     name: "device_acquisition_company",
//     color: "grey",
//     position: 6,
//   },
//   { id: 8, name: "staff_external", color: "grey", position: 8 },
//   { id: 9, name: "trustee", color: "grey", position: 9 },
// ],

/***/ }),

/***/ "0KmK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0erb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.f_field.headline)?_c('div',{staticClass:"mt-0 pt-0 mb-3"},[_c('v-flex',{staticClass:"px-3 py-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#ddd"}},[_c('h3',{staticClass:"font-weight-bold body-2 xs12 flex"},[_vm._v("\n        "+_vm._s(_vm.f_field.title)+"\n      ")])])],1):(_vm.f_field.subheadline)?_c('div',{staticClass:"mt-2 mb-1"},[_c('v-flex',{staticClass:"px-3 pb-0 xs12"},[_c('h3',{staticClass:"xs12 flex"},[_vm._v("\n        "+_vm._s(_vm.f_field.title)+"\n        ")])])],1):_c('div',[(_vm.field_type == 'text-short')?_c('v-flex',{attrs:{"px-3":""}},[_c('v-flex',[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('v-text-field',{ref:_vm.f_field.name,attrs:{"readonly":!_vm.isEditing,"name":_vm.f_field.name,"value":_vm.f_artist[_vm.f_field.name] ? _vm.f_artist[_vm.f_field.name] : '',"hint":_vm.hint,"hide-details":"","suffix":_vm.f_field.suffix,"append-outer-icon":_vm.isEditing ? 'save' : 'edit'},on:{"click:append-outer":_vm.saveOrEdit},nativeOn:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),(_vm.an_exists)?_c('div',[_vm._v("This accession number already exists!")]):_vm._e(),_vm._v(" "),(_vm.saved)?_c('div',{staticClass:"ml-3"},[_vm._v("Value was saved!")]):_vm._e(),_vm._v(" "),(_vm.cannotSave)?_c('div',{staticClass:"ml-3"},[_vm._v("\n          Value already exists! Cannot save!\n        ")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.field_type == 'currency')?_c('v-flex',{attrs:{"px-3":"","xs12":"","sm6":"","md4":"","d-flex":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('v-text-field',{ref:_vm.f_field.name,attrs:{"readonly":!_vm.isEditing,"name":_vm.f_field.name,"value":("" + (_vm.f_artist[_vm.f_field.name])),"hint":("" + (_vm.f_field.title)),"persistent-hint":"","suffix":_vm.f_field.suffix,"append-outer-icon":_vm.isEditing ? 'save' : 'edit'},on:{"click:append-outer":_vm.saveOrEdit},nativeOn:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{ref:_vm.f_field.name,staticClass:"ml-0",attrs:{"name":"f_field.name+'_currency'","items":['EUR', 'USD', 'GBP', 'AUD', 'CHF', 'YEN', 'SIT'],"label":"","append-outer-icon":_vm.isEditing ? 'save' : 'edit',"value":_vm.f_artist[((_vm.f_field.name) + "_currency")],"hint":"Currency","persistent-hint":""},on:{"click:append-outer":_vm.saveOrEdit}}),_vm._v(" "),(_vm.an_exists)?_c('div',[_vm._v("This accession number already exists!")]):_vm._e(),_vm._v(" "),(_vm.saved)?_c('div',{staticClass:"ml-3"},[_vm._v("Value was saved!")]):_vm._e(),_vm._v(" "),(_vm.cannotSave)?_c('div',{staticClass:"ml-3"},[_vm._v("\n          Value already exists! Cannot save!\n        ")]):_vm._e()],1)],1):(this.field_type == 'text-long')?_c('v-flex',{staticClass:"my-0 py-0 px-3"},[_c('v-textarea',{ref:_vm.f_field.name,staticClass:"my-0",attrs:{"auto-grow":"","readonly":!_vm.isEditing,"name":_vm.f_field.name,"rows":"1","hide-details":"","value":_vm.f_artist[_vm.f_field.name] ? _vm.f_artist[_vm.f_field.name] : '',"hint":((_vm.f_field.title) + " - " + (_vm.f_field.hint ? _vm.f_field.hint : '')),"persistent-hint":"","append-outer-icon":_vm.isEditing ? 'save' : 'edit'},on:{"click:append-outer":_vm.saveOrEdit},nativeOn:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),(_vm.an_exists)?_c('div',[_vm._v("This accession number already exists!")]):_vm._e(),_vm._v(" "),(_vm.saved)?_c('div',{staticClass:"ml-3"},[_vm._v("Value was saved!")]):_vm._e(),_vm._v(" "),(_vm.cannotSave)?_c('div',{staticClass:"ml-3"},[_vm._v("\n        Value already exists! Cannot save!\n      ")]):_vm._e()],1):(this.field_type == 'date')?_c('v-flex',{class:((_vm.f_field.class) + " mt-3 py-0 px-3"),attrs:{"xs12":"","md12":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":32,"nudge-top":18,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.f_field.title,"prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.select_value),callback:function ($$v) {_vm.select_value=$$v},expression:"select_value"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.select_value),callback:function ($$v) {_vm.select_value=$$v},expression:"select_value"}})],1)],1):(this.field_type == 'bool')?_c('v-flex',{attrs:{"px-3":""}},[_c('v-switch',{attrs:{"value":("" + (_vm.f_artist[_vm.f_field.name])),"label":("" + (_vm.f_field.title)),"color":"black"}})],1):(this.field_type == 'radio')?_c('v-flex',{attrs:{"px-3":""}},[_c('v-radio-group',{attrs:{"label":("" + (_vm.f_field.title)),"column":_vm.f_field.column ? _vm.f_field.column : false,"value":_vm.value_radio,"refs":_vm.f_field.name}},_vm._l((_vm.f_field.selection),function(s){return _c('v-radio',{key:s.id ? s.id : s,staticClass:"ml-3",attrs:{"label":s.name ? s.name : s,"value":s.value ? s.value : s}})}),1)],1):(this.field_type == 'checkbox')?_c('v-flex',{attrs:{"px-3":""}},[_c('v-flex',[_c('h4',{staticClass:"sub-headline mt-3 ml-3"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_vm._l((_vm.f_field.selection),function(s){return _c('v-checkbox',{key:s.id ? s.id : s,staticClass:"left mr-3 ml-3",attrs:{"hide-details":"","label":s.name ? s.name : s,"refs":_vm.f_field.name}},[_vm._v(_vm._s(s.name ? s.name : s))])})],2)],1):(this.field_type == 'toggle')?_c('v-flex',{attrs:{"px-3":"","mb-2":""}},[_c('h4',{staticClass:"body-2 mt-3 ml-1"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_c('v-flex',{staticClass:"py-2",attrs:{"xs12":"","sm6":""}},[_c('v-btn-toggle',{on:{"change":_vm.save},model:{value:(_vm.toggle),callback:function ($$v) {_vm.toggle=$$v},expression:"toggle"}},_vm._l((_vm.f_field.selection),function(s){return _c('v-btn',{key:s.id ? s.value : s,staticClass:"px-2",attrs:{"small":"","flat":"","value":s.value}},[_c('span',[_vm._v(" "+_vm._s(s.name)+" ")])])}),1)],1)],1):(_vm.f_field.etype === 'select')?_c('v-layout',{attrs:{"px-3":"","mt-3":"","row":"","wrap":""}},[_c('v-flex',[(!_vm.f_field.just_text)?_c('v-select',{ref:_vm.f_field.related_field,attrs:{"value":_vm.value2,"items":_vm.selection_items,"label":("" + (_vm.f_field.title)),"item-text":"name","item-value":"id","name":_vm.f_field.name,"append-outer-icon":_vm.f_field.addNew ? 'add' : '',"preppend-icon":_vm.f_field.preicon},on:{"change":function($event){return _vm.checkSubfields($event)},"click:append-outer":_vm.showAddForm}}):_c('div',[_vm._v("\n          "+_vm._s(_vm.f_artist[_vm.f_field.name] ? _vm.f_artist[_vm.f_field.name].name : 'NOT FOUND')+"\n        ")]),_vm._v(" "),(
            _vm.f_field.name == 'classification_new_id' &&
            this.select_value == 'film'
          )?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Select Film Type","row":""},model:{value:(_vm.film.film_type),callback:function ($$v) {_vm.$set(_vm.film, "film_type", $$v)},expression:"film.film_type"}},_vm._l((['tape', 'film', 'digital born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e(),_vm._v(" "),(
            _vm.f_field.name == 'classification_new_id' &&
            this.select_value == 'inst'
          )?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-flex',{staticClass:"subheadline mt-4"},[_vm._v("Includes")]),_vm._v(" "),_vm._l(([
                'Objects',
                'Sound',
                'FilmVideoAV',
                'Slide',
                'Computer Program / Software / File',
                'Performance',
                'Light',
                'Other' ]),function(s){return _c('v-checkbox',{key:s,attrs:{"label":s,"value":s,"hide-details":"","xs12":"","md6":"","lg4":""},model:{value:(_vm.instalation_includes),callback:function ($$v) {_vm.instalation_includes=$$v},expression:"instalation_includes"}})})],2),_vm._v(" "),(this.instalation_includes.indexOf('FilmVideoAV') >= 0)?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-radio-group',{attrs:{"label":"Select Film Type","row":""},model:{value:(_vm.film.film_type),callback:function ($$v) {_vm.$set(_vm.film, "film_type", $$v)},expression:"film.film_type"}},_vm._l((['tape', 'film', 'digital born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e(),_vm._v(" "),(this.instalation_includes.indexOf('Other') >= 0)?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-text-field',{staticClass:"ml-3",attrs:{"name":"including_other","label":"Other","row":""},model:{value:(_vm.film.film_type),callback:function ($$v) {_vm.$set(_vm.film, "film_type", $$v)},expression:"film.film_type"}})],1):_vm._e()],1):_vm._e()],1)],1):(_vm.f_field.etype === 'autocomplete')?_c('v-flex',{attrs:{"mt-3":"","px-3":""}},[_c('v-autocomplete',{attrs:{"value":_vm.value2,"items":this.selection_items,"label":("" + (_vm.f_field.title)),"item-text":"name","item-value":"id","chips":_vm.f_field.chips,"multiple":_vm.f_field.multiple,"append-outer-icon":_vm.f_field.addNew ? 'add' : '',"clearable":"true"},on:{"click:append-outer":_vm.showAddForm}})],1):_vm._e()],1)])}
var staticRenderFns = []


/***/ }),

/***/ "0mR+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_artworks_EditField__ = __webpack_require__("b7zL");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      report: {
        date: ''
      },
      fields_conservation: [
      // {
      //   name: 'diagnosis_and_proposal',
      //   headline: true,
      //   title: 'Diagnosis and Proposal',
      //   section: 'diagnosis',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   ctype: 'text-long',
      //   name: 'accession_number',
      //   title: 'Description of Condition / Type of Damage',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   ctype: 'text-long',
      //   name: 'accession_number2',
      //   title: 'Concept (and planning) of Conservation',
      //   dynamic: true,
      //   section: 'diagnosis',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },

      {
        name: 'media_details',
        headline: true,
        title: 'Reading Devices',
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'computer',
        title: 'Computer',
        dynamic: true,
        section: 'media_details',
        selection: ['Server', 'Laptop', 'Desktop', 'Virtual', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'micro_controller',
        title: 'Micro Controller',
        dynamic: true,
        section: 'media_details',
        selection: ['LCD', 'LED-LCD', 'Plasma', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'film_projector',
        title: 'Film Projector',
        dynamic: true,
        section: 'media_details',
        selection: ['8 mm', '16mm', '35mm', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'slide_projector',
        title: 'Slide Projector',
        dynamic: true,
        section: 'media_details',
        selection: ['Single projecting', 'Slate', 'Carousel', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'video_tape_recorder',
        title: 'Video Tape Recorder',
        dynamic: true,
        section: 'media_details',
        selection: ['Open Reel (1/2“)', 'Umatic', 'Betacam/SP', 'VHS', 'Digital Betacam', 'DV  (1/4“)', 'HDCAM', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'bool',
        name: 'linear_tape_drive',
        title: 'Linear Tape Drive',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'bool',
        name: 'floppy',
        title: 'Disc Tape Drive (Floppy)',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'bool',
        name: 'dvd_player',
        title: 'DVD Player',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'bool',
        name: 'media_player',
        title: 'Media player',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'other_player',
        title: 'Other',
        dynamic: true,
        section: 'media_details',
        selection: ['Server', 'Laptop', 'Desktop', 'Virtual', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'brand',
        title: 'Brand',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'type_and_model',
        title: 'Type and Model',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'date',
        name: 'production_date_new',
        title: 'Date of Production',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'checkbox',
        name: 'interfaces',
        title: 'Interfaces',
        dynamic: true,
        section: 'media_details',
        selection: ['composite', 'component', 'SVideo', 'SDI', 'VGA', 'HDMI', 'DVI', 'IDE', 'SATA', 'USB 2.0', 'USB 3.0', 'FireWire', 'Thunderbolt', 'XLR Audio', 'unknown', 'other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'input_output',
        title: 'Input - Output',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'power-requirement',
        title: 'Power Requirement',
        dynamic: true,
        class: 'xs12 md6',
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'cooling_system',
        title: 'Cooling system',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'number_of_parts',
        title: 'Number of Parts',
        dynamic: true,
        section: 'media_details',
        class: 'xs12 md6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'specification_of_parts',
        title: 'Specification of parts',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'dimensions',
        title: 'Dimensions (cm) and weight',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'modification',
        title: 'Modification',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'installation_specification',
        title: 'Specifications on installation',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'peripherals',
        title: 'Peripherals',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'associated_items',
        title: 'Associated items',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'provided_spare_parts',
        title: 'Provided spare parts',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        name: 'conservation',
        headline: true,
        title: 'Conservation',
        section: 'conservation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'appearance',
        title: 'Appearance',
        dynamic: true,
        section: 'conservation',
        selection: ['Good', 'Acceptable', 'Poor'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'other',
        title: 'Other',
        dynamic: true,
        section: 'conservation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'operation',
        title: 'Operation',
        dynamic: true,
        section: 'conservation',
        selection: ['Working properly', 'Pretend to work properly', 'Not working at all', 'Not sure'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'troubleshooting',
        title: 'Troubleshooting',
        dynamic: true,
        section: 'conservation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      },
      // {
      //   ctype: 'text-long',
      //   name: 'spare_parts_necessary',
      //   title: 'Spare Parts necessary',
      //   dynamic: true,
      //   section: 'conservation',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      {
        ctype: 'radio',
        name: 'treatment_report',
        title: 'Treatment Report',
        dynamic: true,
        section: 'conservation',
        selection: ['Material treatment', 'Repaired parts', 'Replaced parts', 'Replaced device'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'maintenance_in_storage',
        title: 'Maintenance in Storage',
        dynamic: true,
        section: 'conservation',
        selection: ['Inspection regularly', 'Testing – turning on and off regularly', 'Other requirements'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'maintenance_in_exhibition',
        title: 'Maintenance in Exhibition',
        dynamic: true,
        section: 'conservation',
        selection: ['Inspection regularly', 'Testing – turning on and off regularly', 'Other requirements'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'spare_parts_necessary',
        title: 'Spare Parts necessary',
        dynamic: true,
        section: 'conservation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'provided_manuals',
        title: 'Provided manuals, warranty inf.',
        dynamic: true,
        section: 'conservation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'risk_of_obsolescence',
        title: 'Risk of Obsolescence',
        dynamic: true,
        section: 'conservation',
        selection: ['Still in manufacturing', 'Parts still available'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'are_replacements_possible',
        title: 'Are replacements possible',
        dynamic: true,
        section: 'conservation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        name: 'information_carrier',
        headline: true,
        title: 'Information Carrier',
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'status',
        title: 'Status',
        dynamic: true,
        section: 'information_carrier',
        selection: ["Artist's Original", 'Master Physical', 'Copy Master Physical', 'Physical Access Copy', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'optical_film_type',
        title: 'Type - Optical Film',
        dynamic: true,
        section: 'information_carrier',
        selection: ['8mm', '9,5mm', '16mm', '35mm', '70 mm', 'slide', 'negative small format', 'medium format', 'large format', 'microfilm', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'optical_disc_type',
        title: 'Type - Optical Disc',
        dynamic: true,
        section: 'information_carrier',
        selection: ['Laser Disc', 'DVD', 'CD', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'mechanical_type',
        title: 'Type - Mechanical',
        dynamic: true,
        section: 'information_carrier',
        selection: ['vinyl record', 'punch card', '35mm', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'magnetic_type',
        title: 'Type - Magnetic',
        dynamic: true,
        section: 'information_carrier',
        selection: ['Open Reel (1/2“)', 'Umatic', 'Betacam/SP', 'VHS', 'Digital Betacam', 'DV  (1/4“)', 'HDCAM', 'Floppy', 'external Hard Drive (HDD)', 'LTO', 'DLT', 'DAT', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'electronical_type',
        title: 'Type - Electronical',
        dynamic: true,
        section: 'information_carrier',
        selection: ['USB', 'Solid State Drive (SSD)', 'Read Only Memory (ROM)', 'Random Access Memory (RAM)', 'EEPROM', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'unknown_type',
        title: 'Type - Unknown',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'other_type',
        title: 'Type - Other',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'material',
        title: 'Material',
        dynamic: true,
        section: 'information_carrier',
        selection: ['nitrate', 'acetate', 'polyester', 'polycarbonate', 'other polymer', 'unknown', 'glass', 'metal', 'paper', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'brand',
        title: 'Brand',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'model',
        title: 'Model',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'specifications',
        title: 'Specifications',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'length',
        title: 'Length (capacity)',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'size',
        title: 'Size',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'number_parts_series',
        title: 'Number I Parts I Series',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'associated_devices_to_read',
        title: 'Associated Devices to Read',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'signal_processing_video',
        title: 'Signal Processing Video',
        dynamic: true,
        section: 'information_carrier',
        selection: ['FBAS', 'Y/C (S-Video I Dub)', 'YCrCb (digital)', 'YPbPr (analog)', 'RGB', 'unknown', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'signal_processing_audio',
        title: 'Signal Processing Audio',
        dynamic: true,
        section: 'information_carrier',
        selection: ['Optical', 'Magnetic', 'Longitudinal', 'FM', 'PCM', 'Dolby', 'unknown', 'Other'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'generation_copy',
        title: 'Generation I Copy',
        dynamic: true,
        section: 'information_carrier',
        selection: ['Camera Negative', 'Camera Positive', 'Inter positive', 'Inter negative', 'Revearsal'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      },
      // {
      //   ctype: 'date',
      //   name: 'production_date_new',
      //   title: 'Date of Production',
      //   dynamic: true,
      //   section: 'media_details',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      {
        ctype: 'text-long',
        name: 'specification_on_installation',
        title: 'Specification on Installation',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'shel_container_case',
        title: 'Shell | Container | Case',
        dynamic: true,
        section: 'information_carrier',
        selection: ['Signed by artist', 'Designed by artist', 'Non specific'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'modifications',
        title: 'Modifications',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'installation_specifications',
        title: 'Specifications on Installation',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        name: 'attached_documents',
        title: 'Attached documents',
        dynamic: true,
        section: 'information_carrier',
        selection: ['Certificate', 'Dub sheet', 'Vtr card', 'Installation Instruction', 'Contract', 'Photos'],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'associated_periphals',
        title: 'Associated periphals',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'associated_items',
        title: 'Associated items',
        dynamic: true,
        section: 'information_carrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }],
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 2.5,
        headers: { 'My-Awesome-Header': 'header value' }
      },
      success: false,
      condition_category: '',
      inharent: false,
      examined_by: '',
      examiner_title: '',
      eamination_location: '',
      examination_reason: '',
      selected_artwork: '',
      date: null,
      menu: false,
      modal: false,
      menu2: false,
      e1: 0,
      autosave: true,
      artwork_type: '',
      result: '',
      approved: true,
      settings1: false,
      settings2: false,
      settings3: false,
      settings4: false,
      damage_types: ['Abrasions Creases', 'Tear', 'Residue Discoloration Distortion Water damage Scratch', 'Tape', 'Fading', 'Mould', 'Flaking', 'Cracking', 'Dent', 'Puncture', 'Surface Dirt', 'Loss / Missing Area Smudge', 'Parasite', 'Adhesive Residue Stains', 'Warping', 'Brittle Yellowed Sticky Dust'].sort(),
      damage_categories: []
    };
  },

  methods: {
    add_field: function add_field(field) {
      // console.log('this[field]')
      // console.log(field)
      this[field['name']].show = true;
    },
    saveCurrentTab: function saveCurrentTab(tab) {
      this.$store.dispatch('saveCurrentTab', tab);
    },
    getArtwork: function getArtwork(id) {
      var _this = this;

      // console.log(id)
      var url = this.$globals.apiserver + '/artworks/' + id + '.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (response) {
        // this.loading = false;
        _this.result = response.data;
        // this.artwork = response.data
        // this.artist = response.data.artist
        // console.log(this.artist)
        // console.log(this.artwork)
      }).catch(function (error) {
        console.log(error);
      });
    },
    pdf: function pdf() {
      // download PDF
    }
  },
  computed: {
    processedArtwork: function processedArtwork() {
      var processedArtwork = this.result;
      return processedArtwork;
    },
    processedArtist: function processedArtist() {
      var processedArtist = this.result.artist;
      return processedArtist;
    },
    artworks: function artworks() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
    }
  },
  // vueDropzone: vue2Dropzone,
  components: {
    EditField: __WEBPACK_IMPORTED_MODULE_2__components_artworks_EditField__["a" /* default */]
  }
});

/***/ }),

/***/ "0rFo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx__ = __webpack_require__("uXZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xlsx__);

//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    data: Array,
    name: String,
    fileName: String,
    light: Boolean,
    small: Boolean,
    columns: Array
  },
  data: function data() {
    return {
      constants: __WEBPACK_IMPORTED_MODULE_1__data_constants__["a" /* default */]
    };
  },
  // async created () {
  //   this.Datas = await api.getDatas()
  // },
  methods: {
    getVisaStatus: function getVisaStatus(vs) {
      var out = __WEBPACK_IMPORTED_MODULE_1__data_constants__["a" /* default */].VISA_STATUSES.find(function (s) {
        return s.id == vs;
      });
      if (out) {
        return out.name;
      } else {
        return 'Visa status unknown';
      }
    },
    format_date: function format_date(date) {
      // console.log(date)
      var moment = __webpack_require__("PJh5");
      var ndate = new Date(date);
      // console.log(moment(ndate).format('YYYY-MM-DD'))
      return moment(ndate).format('YYYY-MM-DD');
    },
    onexport: function onexport() {
      var _this = this;

      // console.log(this.data[0])
      // var animalWS = XLSX.utils.json_to_sheet(this.Datas.animals)
      if (this.columns) {
        var col = ['id', 'title', 'subtitle', 'full_name', 'accession_number', 'production_date_new'].concat(this.columns.map(function (c) {
          return c.id;
        }));
        // , 'last_media_check'
        this.col = col.concat[('acquisition_date', 'acquisition_method_text', 'acquisition_source_text', 'name', 'classification', 'credit', 'edition_state', 'exhibitions', 'media_material_description', 'todos', 'last_media_check', 'visa_status_text')];
      } else {
        var col = ['id', 'title', 'subtitle', 'full_name', 'accession_number', 'production_date_new', 'acquisition_date', 'acquisition_method_text', 'acquisition_source_text', 'name', 'classification', 'credit', 'edition_state', 'exhibitions', 'media_material_description', 'todos', 'visa_status_text'];
      }
      var settings = {
        // skipHeader: true,
        origin: 'A2'
      };
      var transformedData = [];
      this.data.forEach(function (textRow) {
        var out = {};
        if (col.includes('todos')) {
          var todos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this.$store.state.todos.filter(function (t) {
            return textRow.id == t.artwork_id && t.done != 1;
          }));
          todos = todos.map(function (a) {
            return a.title;
          });
        }

        if (col.includes('packings')) {
          var packings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this.$store.state.packings.filter(function (t) {
            return textRow.id == t.artwork_id;
          }));
          // var packings_text = packings.map(a => {return a.colli})
        }

        if (col.includes('exhibitions')) {
          var exhibitions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this.$store.state.exhibitions.filter(function (t) {
            return t.artworks.map(function (a) {
              return a = a.id;
            }).includes(textRow.id);
          }));
          // var exhibitions_text = exhibitions.map(a => { return a.title + ' (' + a.duration_start + '–' + a.duration_end + ') ' + a.institution})
        }
        // console.log(exhibitions)
        // , 'conservator', 'last_media_check'
        var all_fields = ['id', 'title', 'paid_in_country', 'acquisition_source_text', 'import_export_notes', 'import_date', 'import_export_history', 'subtitle', 'full_name', 'top_photo_id', 'accession_number', 'production_date_new', 'acquisition_date', 'acquisition_method_text', 'visa_status_text', 'ownership_info', 'edition_state', 'certificate_new', 'media_material_description', 'location_name', 'location_notes', 'deaccessioned', 'credit', 'purchase_price', 'purchase_price_currency', 'insurance_value', 'insurance_value_currency', 'signature_new', 'dim', 'dim_details', 'todos', 'exhibitions', 'packings', 'technician', 'space_max_min', 'required_equipment', 'tools_and_gear', 'light', 'climate_and_conditions', 'power', 'spare_or_replacement_parts', 'display_notes_and_other_special_merged', 'projection', 'sound_and_acoustic', 'on_off_procedure', 'maintenance', 'security_and_safety_details', 'regular_inspection', 'cleaning_artwork', 'contacts_producers', 'hanging_devices', 'specifications_on_space', 'last_media_check'];
        // , 'conservator', 'last_media_check'
        var unformatted_fields = ['id', 'title', 'last_media_check', 'paid_in_country', 'import_export_notes', 'import_date', 'import_export_history', 'import_taxes', 'subtitle', 'full_name', 'top_photo_id', 'accession_number', 'production_date_new', 'acquisition_date', 'acquisition_method_text', 'edition_state', 'media_material_description', 'location_notes', 'credit', 'purchase_price', 'purchase_price_currency', 'insurance_value', 'insurance_value_currency', 'technician', 'space_max_min', 'required_equipment', 'tools_and_gear', 'light', 'climate_and_conditions', 'power', 'spare_or_replacement_parts', 'display_notes_and_other_special_merged', 'projection', 'sound_and_acoustic', 'on_off_procedure', 'maintenance', 'security_and_safety_details', 'regular_inspection', 'cleaning_artwork', 'contacts_producers', 'hanging_devices', 'specifications_on_space'];
        // console.log(col);
        col.forEach(function (f) {
          if (unformatted_fields.includes(f)) {
            out[f] = textRow[f] ? textRow[f] : '';
          } else {
            // nacitam text acq source
            var c = _this.$store.state.contacts.find(function (as) {
              return as.id === textRow.acquisition_source_id;
            });
            if (c) {
              var as = c.name;
            } else {
              var as = 'Not set';
            }

            if (f === 'dim') {
              out[f] = textRow.dim_f_json ? textRow.dim_f_json : '';
            } else if (f === 'dim_detail') {
              out['Height (cm)'] = textRow.dim_height;
              out['Width (cm)'] = textRow.dim_width;
              out['Depth (cm)'] = textRow.dim_depth;
              // if (textRow.dim_depth & textRow.dim_height & textRow.dim_width) {
              console.log(textRow.dim_height);
              console.log(textRow.dim_width);
              console.log(textRow.dim_depth);
              console.log(textRow.dim_depth * textRow.dim_height * textRow.dim_width);
              var x = (textRow.dim_depth * textRow.dim_height * textRow.dim_width / 1000000).toString();
              console.log('xxxxxx');
              console.log(x);
              console.log('xxxxxx');
              out['Space (m3)'] = x;
              // } else {
              //   out['Space (m3)'] = ''
              // }
              if (textRow.dim_depth & textRow.dim_width) {
                out['Footprint (m2)'] = textRow.dim_depth * textRow.dim_width / 10000;
              } else {
                out['Footprint (m2)'] = '';
              }
              out['Frame Height (cm)'] = textRow.dim_frame_height;
              out['Frame Width (cm)'] = textRow.dim_frame_width;
              out['Frame Depth (cm)'] = textRow.dim_frame_depth;
              if (textRow.dim_frame_height & textRow.dim_frame_width & textRow.dim_frame_depth) {
                out['Frame Space (m3)'] = textRow.dim_frame_height * textRow.dim_frame_width * textRow.dim_frame_depth / 1000000;
              } else {
                out['Frame Space (m3)'] = '';
              }
              if (textRow.dim_frame_width & textRow.dim_frame_depth) {
                out['Frame Footprint (m2)'] = textRow.dim_frame_width * textRow.dim_frame_depth / 10000;
              } else {
                out['Frame Footprint (m2)'] = '';
              }
              out['Diameter'] = textRow.diameter;

              // out[f] = getDimensionDetail(textRow)
            } else if (f === 'location_name') {
              out[f] = _this.get_location_name(textRow.artwork_location_id);
            } else if (f === 'classification') {
              out[f] = textRow.classification ? textRow.classification.toUpperCase() : '';
            } else if (f === 'type_of_work_id') {
              out[f] = textRow.type_of_work_id ? __WEBPACK_IMPORTED_MODULE_1__data_constants__["a" /* default */].TYPES_OF_WORK.find(function (t) {
                return t.id == textRow.type_of_work_id;
              }).name : '';
            } else if (f === 'ownership_info') {
              // console.log(textRow.ownership)
              if (!textRow.ownership) {
                out[f] = 'NOT SET';
              } else {
                var a = __WEBPACK_IMPORTED_MODULE_1__data_constants__["a" /* default */].OWNERSHIPS.find(function (o) {
                  return o.id == textRow.ownership;
                });
                out[f] = a ? a.name : 'NOT FOUND';
              }
            } else if (f === 'visa_status_text') {
              out[f] = _this.getVisaStatus(textRow.visa_status);
            } else if (f === 'acquisition_source_text') {
              out[f] = _this.get_contact(textRow.acquisition_source_id);
            } else if (f === 'insurance_value_text') {
              out['insurance_value'] = textRow.insurance_value;
              out['insurance_value_currency'] = textRow.insurance_value_currency;
            } else if (f === 'insurance_value_latest') {
              out['insurance_value_latest'] = _this.getLatestInsuranceValue(textRow.id);
              out['insurance_value_latest_currency'] = _this.getLatestInsuranceCurrency(textRow.id);
            } else if (f === 'purchase_price_text') {
              out['purchase_price'] = textRow.purchased_price;
              out['purchase_price_currency'] = textRow.purchased_price_currency;
            } else if (f === 'acquisition_date') {
              out[f] = textRow.acquisition_date ? _this.format_date(textRow.acquisition_date) : '';
            } else if (f === 'certificate_new') {
              out[f] = textRow.certificate_new == 1 ? 'Yes' : 'No';
            } else if (f === 'deaccessioned') {
              out[f] = textRow.deaccessioned == 1 ? 'Yes' : 'No';
            } else if (f === 'signature_new') {
              out[f] = textRow.signature_new == 1 ? 'Yes' : 'No';
            } else if (f === 'todos') {
              out[f] = todos.length > 0 ? 'ToDos: ' + todos.join(', ') : '';
              // } else if ( f === 'exhibitions') {
              //   out[f] = exhibitions.length > 0 ? ('Exhibitions: \n >> ' + (exhibitions_text.join('\n >> '))) : ''
              // } else if ( f === 'packings') {
              //   out[f] = packings.length > 0 ? (packings_text) : ''
            }
          }
        });

        // function getDimensionDetail(p) {
        //   if (p) {
        //     //  console.log(packings);
        //     var o = {}
        //     transformedData.push(o)

        //     o['Height (cm)'] = p.dim_height
        //     o['Width (cm)'] = p.dim_width
        //     o['Depth (cm)'] = p.dim_depth
        //     if (p.dim_depth & p.dim_height & p.dim_width) {
        //       o['Space (m3)'] =
        //         (p.dim_depth * p.dim_height * p.dim_width) / 1000000
        //     } else {
        //       o['Space (m3)'] = ''
        //     }
        //     if (p.dim_depth & p.dim_width) {
        //       o['Footprint (m2)'] = (p.dim_depth * p.dim_width) / 10000
        //     } else {
        //       o['Footprint (m2)'] = ''
        //     }
        //     o['Frame Height (cm)'] = p.dim_frame_height
        //     o['Frame Width (cm)'] = p.dim_frame_width
        //     o['Frame Depth (cm)'] = p.dim_frame_depth
        //     if (p.dim_frame_height & p.dim_frame_width & p.dim_frame_depth) {
        //       o['Frame Space (m3)'] =
        //         (p.dim_frame_height * p.dim_frame_width * p.dim_frame_depth) /
        //         1000000
        //     } else {
        //       o['Frame Space (m3)'] = ''
        //     }
        //     if (p.dim_frame_width & p.dim_frame_depth) {
        //       o['Frame Footprint (m2)'] =
        //         (p.dim_frame_width * p.dim_frame_depth) / 10000
        //     } else {
        //       o['Frame Footprint (m2)'] = ''
        //     }
        //     o['Diameter'] = p.diameter
        //     transformedData.push(o)
        //     o = {}
        //   }
        // }

        function getLocation(p, store) {
          var out = 'No Location Set';
          if (p.artwork_location_id > 0) {
            var loc = store.state.locations.find(function (l) {
              return l.id == p.artwork_location_id;
            });
            if (loc) {
              out = loc.name;
            } else {
              out = '';
            }
          } else {
            if (textRow['artwork_location_id'] > 0) {
              var loc = store.state.locations.find(function (l) {
                return l.id == textRow['artwork_location_id'];
              });
              if (loc) {
                out = loc.name;
              } else {
                out = '';
              }
              out = 'Artwork Location: ' + out;
            }
          }
          return out;
        }

        transformedData.push(out);

        if (packings) {
          //  console.log(packings);
          var o = {};
          packings.forEach(function (p) {
            o['Colli'] = p.colli;
            o['Packing'] = p.packing;
            o['Length'] = p['lenght'];
            o['Width'] = p.width;
            o['Height'] = p.height;
            o['Weight'] = p.weight;
            o['Contents'] = p.contents;
            o['Visa Status'] = _this.getVisaStatus(p.visa_status);
            o['Packing Location'] = getLocation(p, _this.$store);
            transformedData.push(o);
            o = {};
          });
        }

        if (exhibitions) {
          //  console.log(packings);
          var o = {};
          exhibitions.forEach(function (p) {
            o['Exhibition Title'] = p.title;
            o['Duration'] = p['duration_start'] + '–' + p['duration_end'];
            o['Institution'] = p.institution;
            transformedData.push(o);
            o = {};
          });
        }
      });
      // {
      // "id": (textRow.id),
      // "full_name": (textRow.full_name),
      // "top_photo_id": textRow.top_photo_id,
      // "acquisition_method_text": textRow.acquisition_method_text,
      // "visa_status_text": textRow.visa_status_text,
      // "ownership_info": textRow.ownership_info,
      // "edition_state": textRow.edition_state,
      // "media_material_description": textRow.media_material_description,
      // "location_name": textRow.location_name,
      // "location_notes": textRow.location_notes,
      // "credit": textRow.credit,
      // "purchase_price_text": textRow.purchase_price + ' ' + textRow.purchase_price_currency,
      // "purchase_price": textRow.purchased_price,
      // "purchase_price_currency": textRow.purchased_price_currency,
      // "insurance_value_text": textRow.insurance_value + ' ' + textRow.insurance_value_currency,
      // "insurance_value": textRow.insurance_value,
      // "insurance_value_currency": textRow.insurance_value_currency,
      // "title": textRow.title,
      //  +', ' + (textRow.production_date_new ? textRow.production_date_new : ''),
      // "accession_number": (textRow.accession_number ? textRow.accession_number : ''),
      // "production_date_new": (textRow.production_date_new ? textRow.production_date_new : ''),
      // "conservator": `${textRow.conservator}`,
      // "last_media_check": `${textRow.last_media_check}`,
      // "classification": (textRow.classification ? textRow.classification.toUpperCase() : ''),
      // "acquisition_date": this.format_date(textRow.acquisition_date),
      // "certificate_new": 'Certificate: ' + (textRow.certificate_new == 1 ? 'Yes' : 'No'),
      // "deaccessioned": ('Deaccessioned: ' + (textRow.deaccessioned == 1 ? 'Yes' : 'No')),
      // "signature_new": 'Signature: ' + (textRow.signature_new == 1 ? 'Yes' : 'No'),
      // "todos": todos.length > 0 ? ('ToDos: ' + (todos.join(', '))) : '',
      // "exhibitions": exhibitions.length > 0 ? ('Exhibitions: \n >> ' + (exhibitions.join('\n >> '))) : '',
      // "packings": packings.length > 0 ? (packings) : ''
      //   }
      // })
      // console.log(dd)
      // console.log(this.data)
      // console.log(col)
      // console.log(transformedData)
      var sheet = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(transformedData, settings);
      // var sheet = XLSX.utils.json_to_sheet(this.data)

      // A workbook is the name given to an Excel file
      var wb = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      // XLSX.utils.book_append_sheet(wb, animalWS, 'animals')
      // sheetAName is name of Worksheet
      __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, sheet, this.name);

      // export Excel file
      __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.writeFile(wb, this.fileName + '.xlsx'); // name of the file is 'book.xlsx'
    }
  }
});

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "12Kk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selected_artworks: [],
      search: '',
      menu3: false,
      todo: {
        related_todo_id: '',
        description: '',
        title: '',
        deadline: '',
        reminder: '',
        done: false,
        done_at: '',
        repeat: '',
        user_ids: [],
        notify: []
      },
      constants: __WEBPACK_IMPORTED_MODULE_3__data_constants__["a" /* default */],
      data: false,
      menu2: false,
      valid: true,
      menu: false,
      modal: false,
      autosave: true,
      result: '',
      approved: true
    };
  },

  methods: {
    remove: function remove(item) {
      var index = this.todo.user_ids.indexOf(item.id);
      if (index >= 0) this.todo.user_ids.splice(index, 1);
    },
    remove_artwork: function remove_artwork(item) {
      var index = this.selected_artworks.indexOf(item.id);
      if (index >= 0) this.selected_artworks.splice(index, 1);
    },
    new_todo: function new_todo() {
      this.editing = false;
      this.todo.deadline = ''; // this.format_date(Date.now())
      this.todo.reminder = ''; // this.format_date(Date.now())
      this.todo.user_ids = [];
      this.todo.user_ids.push(this.c_user.id);
      this.todo.notify = [];
      this.todo.notify.push(this.c_user);
      this.todo.created_by = this.c_user.id;
    },
    save_todo: function save_todo() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var related_todo_id, a;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'Adding new Todo …');
                related_todo_id = Number;

                _this.todo.done = 0;
                _this.todo.created_by = _this.c_user.id;

                if (!(_this.selected_artworks.length > 0)) {
                  _context.next = 16;
                  break;
                }

                _context.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(_this.selected_artworks);

              case 6:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 14;
                  break;
                }

                a = _context.t1.value;

                // SAVING NEW TODO
                _this.todo.artwork_id = _this.selected_artworks[a];
                if (related_todo_id > 0) {
                  _this.todo.related_todo_id = related_todo_id;
                }
                // this.$store.dispatch('saveTodo', this.editing)
                _context.next = 12;
                return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(_this.$globals.apiserver + '/artwork_todos.json', {
                  todo: _this.todo
                }).then(function (response) {
                  __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'Todo saved.', 'green');
                  _this.errors = {};
                  //console.log(response)
                  // this.active_todos = this.artwork.artwork_todos
                  _this.$store.dispatch('loadTodos');
                  related_todo_id = response.data.id;
                  // this.active_todos.push(response.data);
                  // this.todos.push(response.data)
                }).catch(function (error) {
                  __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'Problem occured while saving Todo. Try again or contact support.');
                  _this.errors = error.response.data;
                });

              case 12:
                _context.next = 6;
                break;

              case 14:
                _this.$store.dispatch('loadTodos');
                _this.todo = {
                  related_todo_id: '',
                  description: '',
                  title: '',
                  deadline: '',
                  done: 0,
                  done_at: '',
                  team: [],
                  notify: ''
                };

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  computed: {
    team_d: function team_d() {
      var f = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$store.state.users);
      return f.filter(function (u) {
        return u.enable == 'Y' && u.edit == 1;
      });
    },
    artworks: function artworks() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
    }
  }
});

/***/ }),

/***/ "1Dzk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1Nha":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1em3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1mgw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mx-0 editBG"},[_c('v-card',{staticClass:"editBG elevation-0"},[_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"black","flat":""},on:{"click":_vm.createArticle}},[_vm._v("Save")])],1),_vm._v(" "),_c('v-card-text',{attrs:{"mb-0":""}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Title"},model:{value:(_vm.article.title),callback:function ($$v) {_vm.$set(_vm.article, "title", $$v)},expression:"article.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Subtitle"},model:{value:(_vm.article.subtitle),callback:function ($$v) {_vm.$set(_vm.article, "subtitle", $$v)},expression:"article.subtitle"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Version"},model:{value:(_vm.article.version),callback:function ($$v) {_vm.$set(_vm.article, "version", $$v)},expression:"article.version"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Support"},model:{value:(_vm.article.support),callback:function ($$v) {_vm.$set(_vm.article, "support", $$v)},expression:"article.support"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Updates"},model:{value:(_vm.article.updates),callback:function ($$v) {_vm.$set(_vm.article, "updates", $$v)},expression:"article.updates"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Group"},model:{value:(_vm.article.group),callback:function ($$v) {_vm.$set(_vm.article, "group", $$v)},expression:"article.group"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"At Work"},model:{value:(_vm.article.at_work),callback:function ($$v) {_vm.$set(_vm.article, "at_work", $$v)},expression:"article.at_work"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Publish Date"},model:{value:(_vm.article.publish_date),callback:function ($$v) {_vm.$set(_vm.article, "publish_date", $$v)},expression:"article.publish_date"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Routes Array"},model:{value:(_vm.article.show_in_route),callback:function ($$v) {_vm.$set(_vm.article, "show_in_route", $$v)},expression:"article.show_in_route"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('text-editor',{attrs:{"value":_vm.article.body},on:{"input":function($event){_vm.article.body=$event}}}),_vm._v(" "),_c('v-divider',{staticClass:"my-4"})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "1q6t":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1tVI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artworks_vue__ = __webpack_require__("7mxo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef971e5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artworks_vue__ = __webpack_require__("KbaY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artworks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef971e5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artworks_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ef971e5_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artworks_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1wD+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1wRZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldBox_vue__ = __webpack_require__("S5f9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ffc4501_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldBox_vue__ = __webpack_require__("mBTR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("1em3")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ffc4501"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ffc4501_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldBox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ffc4501_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldBox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "29mE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2A7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []


/***/ }),

/***/ "2J1f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtworksTable_vue__ = __webpack_require__("/9hj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_caf0e2a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtworksTable_vue__ = __webpack_require__("fOOw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("7TSy")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-caf0e2a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArtworksTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_caf0e2a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtworksTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_caf0e2a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArtworksTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2VO/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import FieldBox from './FieldBox'
// import Images from './Images'
// import ExhibitionHistory from './ExhibitionHistory'
// import LoanHistory from './LoanHistory'



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      result: '',
      currentTab: this.$store.state.currentTab
      // artwork: '',
      // artist: ''
    };
  },

  props: ['field', 'artist', 'artwork'],
  // components: {HeaderArtwork},
  mounted: function mounted() {
    this.getArtwork();
  },

  // updated () {
  //   this.getArtwork()
  // },
  methods: {
    saveCurrentTab: function saveCurrentTab(tab) {
      setTimeout(function () {
        this.$store.dispatch("saveCurrentTab", tab);
      }.bind(this), 1000);
    },
    getArtwork: function getArtwork() {
      var _this = this;

      var url = this.$globals.apiserver + '/contacts/' + this.$route.params.id + '.json';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
        // this.loading = false;
        _this.result = response.data;
        // this.artwork = response.data
        // this.artist = response.data.artist
        // console.log(this.artist)
        // console.log(this.artwork)
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  computed: {
    processedArtwork: function processedArtwork() {
      // let processedArtwork = this.artwork
      // setTimeout(function () {
      var processedArtwork = this.result;
      // }.bind(this),0)

      // this.artwork.map(artwork => {
      //   let a = artwork
      //   artwork.first_name = a ? a.first_name : 'nema meno'
      // })
      // console.log(processedArtwork)
      return processedArtwork;
    },
    processedArtist: function processedArtist() {
      var processedArtist = this.result.artist;
      // let artist = this.result.artist
      // this.artist = this.result.artist
      // this.artwork.map(artwork => {
      //   let a = artwork
      //   artwork.first_name = a ? a.first_name : 'nema meno'
      // })
      // console.log(processedArtist)
      return processedArtist;
    }
  }
  // components: {FieldBox, Images, ExhibitionHistory, LoanHistory}
});

/***/ }),

/***/ "2WYp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-4"},[_c('div',{staticClass:"mt-4 mx-4 d-flex"},[_c('div',{staticClass:"pl-2",staticStyle:{"height":"58px","border":"1px solid rgba(0, 0, 0, 0.7)"}},[_c('v-autocomplete',{attrs:{"placeholder":"Assign tags to artworks","items":_vm.formattedTags,"multiple":"","chips":"","clearable":"","flat":"","item-text":"label","item-value":"id","hide-details":"","single-line":"","full-width":"","hide-selected":"","prepend-inner-icon":"tags","color":""},scopedSlots:_vm._u([{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',[(data.item.concept_tag == 1)?_c('span',{staticClass:"mr-2 px-0"},[_vm._v("★")]):_vm._e(),_vm._v(_vm._s(data.item.name))]),_vm._v(" "),(data.item.concept_tag != 1)?_c('v-list-tile-sub-title',{staticClass:"text-xs-right grey--text",domProps:{"innerHTML":_vm._s(data.item.category ? data.item.category : '')}}):_vm._e(),_vm._v(" "),_c('v-divider')],1)]}},{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi",attrs:{"selected":data.selected,"small":"","color":"primary","text-color":"white","dense":"","close":""},on:{"input":function($event){return _vm.remove(data.item)}}},[_vm._v("\n                          # "+_vm._s(data.item.label)+"\n                      ")])]}}]),model:{value:(_vm.selectedTags),callback:function ($$v) {_vm.selectedTags=$$v},expression:"selectedTags"}})],1),_vm._v(" "),_c('v-checkbox',{staticClass:"ml-4",attrs:{"label":"Replace","color":"black"},model:{value:(_vm.replace),callback:function ($$v) {_vm.replace=$$v},expression:"replace"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"ml-4",attrs:{"color":"primary","small":""},on:{"click":_vm.assignTags}},[_vm._v("Assign Tags")])],1)}
var staticRenderFns = []


/***/ }),

/***/ "2cZe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"headline"},[_vm._v("Settings / Notifications")]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{attrs:{"color":"grey lighten-4","flat":""}},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"label":"New artwork added"},model:{value:(_vm.new_artwork_added),callback:function ($$v) {_vm.new_artwork_added=$$v},expression:"new_artwork_added"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"label":"New artist added"},model:{value:(_vm.new_artist_added),callback:function ($$v) {_vm.new_artist_added=$$v},expression:"new_artist_added"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"label":"Artwork modified"},model:{value:(_vm.artwork_modified),callback:function ($$v) {_vm.artwork_modified=$$v},expression:"artwork_modified"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"label":"Artist modified"},model:{value:(_vm.artist_modified),callback:function ($$v) {_vm.artist_modified=$$v},expression:"artist_modified"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n      save changes\n    ")])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "2o9M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2yJh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewArtist_vue__ = __webpack_require__("dEZz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4927146d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewArtist_vue__ = __webpack_require__("8db/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("/iMw")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4927146d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewArtist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4927146d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewArtist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4927146d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewArtist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3cv1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3pbx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_artworks_NewExhibitionHistory__ = __webpack_require__("SCHX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_artworks_Texts__ = __webpack_require__("qGBU");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      view: 'advanced',
      edit_bio_dialog: false,
      show_form: false,
      show: true,
      dialog: false
      // exhibitions: this.exhibitions2
    };
  },
  // created () {
  //   this.reset_view()
  // },
  methods: {
    deleteExhibition: function deleteExhibition(e) {
      // var index = exhibition_artworks.indexOf(e);
      // console.log('index = ' + index)
      // exhibition_artworks.splice(index,1)
      this.$store.dispatch('deleteExhibition', e);
      this.dialog = false;
    },

    // reset_view () {
    //   var ee = this.store_e
    //   this.exhibitions = this.exhibitions2
    //   // console.log('reset_view')
    //   // console.log(this.exhibitions2)
    // }
    start_date: function start_date(e) {
      var out = e.duration_start_year;
      var options = { day: 'numeric', month: 'long', year: 'numeric' };
      if (e.duration_start_month && e.duration_start_day) {
        if (e.duration_start_month) {
          out = out + '-' + e.duration_start_month.toString().padStart(2, "0");
        }
        if (e.duration_start_day) {
          out = out + '-' + e.duration_start_day.toString().padStart(2, "0");
        }
        out = new Date(out).toLocaleDateString("en-US", options);
      }
      return out;
    },
    end_date: function end_date(e) {
      var out = e.duration_end_year;
      var options = { day: 'numeric', month: 'long', year: 'numeric' };
      if (e.duration_end_month && e.duration_end_day) {
        if (e.duration_end_month) {
          out = out + '-' + e.duration_end_month.toString().padStart(2, "0");
          // out = e.duration_end_month.toLocaleDateString("en-US", options)
        }
        if (e.duration_end_day) {
          out = out + '-' + e.duration_end_day.toString().padStart(2, "0");
        }
        out = new Date(out).toLocaleDateString("en-US", options);
      }
      return out;
    },
    full_date: function full_date(e) {
      var out = this.start_date(e);
      if (this.end_date(e)) {
        out = out + ' - ' + this.end_date(e);
      }
      return out;
    }
  },
  computed: {
    advanced_years: function advanced_years() {
      return this.exhibitions.map(function (a) {
        return a = a.duration_start_year;
      }).sort(function (a, b) {
        return a - b;
      }).reverse().filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
    },
    store_e: function store_e() {
      // console.log('store_e')
      return this.$store.state.exhibitions;
    },
    exhibitions: function exhibitions() {
      return this.artwork.exhibitions.filter(function (e) {
        return e.category != 'commissions';
      });
      // console.log('exa')
      //   return this.store_e.filter(t => {
      //     return t.artworks.map(a => a = a.artwork_id).includes(this.artwork.id)
      // }).sort(function(a, b) {
      //   return a.duration_start - b.duration_start;
      // })
    }
  },
  components: { NewExhibitionHistory: __WEBPACK_IMPORTED_MODULE_0__components_artworks_NewExhibitionHistory__["a" /* default */], Texts: __WEBPACK_IMPORTED_MODULE_1__components_artworks_Texts__["a" /* default */] }
});

/***/ }),

/***/ "4PWi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 px-0 mx-4"},[_c('contacts-table',{attrs:{"items":this.displayedData},on:{"switchOwnershipTop":function($event){return _vm.switchOwnershipTop($event)}}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "4aNr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("bpR0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43eabeb2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("pwbj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("CHii")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43eabeb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43eabeb2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43eabeb2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "4bG1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blue-grey lighten-4"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"800px","transition":"dialog-transition"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-flex',{staticClass:"xs12 ml-0 pl-4 pr-4 pt-4 pb-3 layout row wrap elevation-0 white"},[_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"insurance_value","label":"Insurance Value"},model:{value:(_vm.editedInsuranceLog.insurance_value),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "insurance_value", $$v)},expression:"editedInsuranceLog.insurance_value"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6 pr-3"},[_c('v-text-field',{attrs:{"name":"insurance_value_currency","label":"Currency"},model:{value:(_vm.editedInsuranceLog.insurance_value_currency),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "insurance_value_currency", $$v)},expression:"editedInsuranceLog.insurance_value_currency"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6"},[_c('v-text-field',{attrs:{"name":"insurance_valuer","label":"Valuer"},model:{value:(_vm.editedInsuranceLog.insurance_valuer),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "insurance_valuer", $$v)},expression:"editedInsuranceLog.insurance_valuer"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"insurance_value_note","label":"Note"},model:{value:(_vm.editedInsuranceLog.insurance_value_note),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "insurance_value_note", $$v)},expression:"editedInsuranceLog.insurance_value_note"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs6 mb-0 pl-3 mt-1 pt-3"},[_c('v-btn-toggle',{attrs:{"disabled":_vm.c_user.id != 67 && _vm.c_user.id != 1,"mandatory":"","active-class":"activeToggle"},model:{value:(_vm.editedInsuranceLog.storage),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "storage", $$v)},expression:"editedInsuranceLog.storage"}},[_c('v-btn',{staticClass:"px-3",attrs:{"value":"in","small":"","flat":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("call_received")]),_vm._v(" IN\n          ")],1),_vm._v(" "),_c('v-btn',{staticClass:"px-3",attrs:{"value":"out","small":"","flat":""}},[_vm._v("\n            OUT "),_c('v-icon',{attrs:{"small":""}},[_vm._v("call_made")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","d-flex":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-menu',{ref:"menu2a",attrs:{"disabled":_vm.c_user.id != 67 && _vm.c_user.id != 1,"close-on-content-click":true,"nudge-right":40,"lazy":"","landscape":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu2a),callback:function ($$v) {_vm.menu2a=$$v},expression:"menu2a"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.editedInsuranceLog.insurance_value_date),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "insurance_value_date", $$v)},expression:"editedInsuranceLog.insurance_value_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"persistent":"","color":"black"},model:{value:(_vm.editedInsuranceLog.insurance_value_date),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "insurance_value_date", $$v)},expression:"editedInsuranceLog.insurance_value_date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.editedInsuranceLog.change_time,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.editedInsuranceLog, "change_time", $event)},"update:return-value":function($event){return _vm.$set(_vm.editedInsuranceLog, "change_time", $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Picker time if needed","prepend-inner-icon":"access_time","readonly":""},model:{value:(_vm.editedInsuranceLog.change_time),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "change_time", $$v)},expression:"editedInsuranceLog.change_time"}},on))]}}]),model:{value:(_vm.menu_time),callback:function ($$v) {_vm.menu_time=$$v},expression:"menu_time"}},[_vm._v(" "),(_vm.menu_time)?_c('v-time-picker',{attrs:{"full-width":"","format":"24hr"},on:{"click:minute":function($event){return _vm.$refs.menu.save(_vm.editedInsuranceLog.change_time)}},model:{value:(_vm.editedInsuranceLog.change_time),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "change_time", $$v)},expression:"editedInsuranceLog.change_time"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-3":"","mb-0":""}},[_vm._v(_vm._s(_vm.editedInsuranceLog.copy)+"\n        ")]),_vm._v(" "),_c('v-flex',{staticClass:"xs12"}),_vm._v(" "),_c('v-flex',{staticClass:"xs12 pr-0 mr-0 mt-3",attrs:{"text-xs-right":""}},[_c('v-btn',{attrs:{"small":"","dark":!(
            _vm.editedInsuranceLog.insurance_value == null ||
            _vm.editedInsuranceLog.insurance_value == ''
          ) &&
          !(
            _vm.editedInsuranceLog.insurance_value_date == null ||
            _vm.editedInsuranceLog.insurance_value_date == ''
          ),"disabled":_vm.editedInsuranceLog.insurance_value == null ||
              _vm.editedInsuranceLog.insurance_value == '' ||
              _vm.editedInsuranceLog.insurance_value_date == null ||
              _vm.editedInsuranceLog.insurance_value_date == ''},on:{"click":_vm.save_edited_artwork_insurance_log}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{attrs:{"small":""},on:{"click":function($event){_vm.editDialog = !_vm.editDialog}}},[_vm._v("cancel")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-0",attrs:{"column":""}},[_c('v-flex',{attrs:{"ml-3":"","mt-2":""}},[(_vm.artwork.insurance_value)?_c('v-flex',{attrs:{"xs12":""}},[_c('b',[_vm._v("Latest Artwork Insurance Valuation")])]):_vm._e(),_vm._v(" "),(_vm.lastInsuranceLogArtwork)?_c('v-flex',{attrs:{"xs12":"","pt-2":""}},[_c('div',[_c('v-icon',{staticClass:"ml-0 mt-1",attrs:{"color":"black","small":""}},[_vm._v("verified")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.formatMoney(_vm.lastInsuranceLogArtwork.insurance_value))+" "+_vm._s(_vm.lastInsuranceLogArtwork.insurance_value_currency))]),_vm._v(" on \n          "),_c('b',[_vm._v(_vm._s(_vm.lastInsuranceLogArtwork.insurance_value_date)+" ")]),_vm._v("\n          by "),_c('b',[_vm._v(_vm._s(_vm.lastInsuranceLogArtwork.insurance_valuer)+" ")]),_c('br'),_vm._v(" "),(_vm.lastInsuranceLogArtwork.insurance_value_note)?_c('span',[_vm._v("("+_vm._s(_vm.lastInsuranceLogArtwork.insurance_value_note)+" )"),_c('br')]):_vm._e(),_vm._v(" "),(_vm.lastInsuranceLogArtwork.reason)?_c('span',[_vm._v("("+_vm._s(_vm.lastInsuranceLogArtwork.reason)+" )")]):_vm._e(),_vm._v(" "),(_vm.lastInsuranceLogArtwork.reason || _vm.lastInsuranceLogArtwork.insurance_value_note)?_c('span',[_vm._v("\n            ("+_vm._s(_vm.lastInsuranceLogArtwork.reason)+"\n            "),(_vm.lastInsuranceLogArtwork.insurance_value_note != _vm.lastInsuranceLogArtwork.reason)?_c('span',[_vm._v(_vm._s(_vm.lastInsuranceLogArtwork.insurance_value_note))]):_vm._e(),_vm._v(")\n          ")]):_vm._e()],1)]):_c('v-flex',{attrs:{"xs12":"","pt-2":""}},[_c('v-icon',{staticClass:"ml-0",attrs:{"color":"black","small":""}},[_vm._v("verified")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.formatMoney(_vm.artwork.insurance_value))+" "+_vm._s(_vm.artwork.insurance_value_currency))]),_vm._v(" "),_c('b',[_vm._v("("+_vm._s(_vm.artwork.insurance_value_date_year)+"-"+_vm._s(_vm.artwork.insurance_value_date_month)+"-"+_vm._s(_vm.artwork.insurance_value_date_day)+") ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"xs12":"","sm12":"","md12":"","mt-2":"","ml-0":"","mr-0":"","px-0":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs12":"","row":"","layout":""}},[(_vm.c_user.edit)?_c('v-btn',{staticClass:"mt-2 mb-0 ml-3 mr-0",attrs:{"round":"","flat":"","small":""},on:{"click":_vm.switch_change_dialog}},[_vm._v("\n            "+_vm._s(_vm.showUpload ? 'Cancel ' : 'Add Insurance Valuation'))]):_vm._e(),_vm._v(" "),_c('v-spacer',{staticClass:"pb-0 mb-0"}),_vm._v(" "),_c('v-btn',{staticClass:"pl-3 pr-2 mx-3",attrs:{"small":"","round":"","flat":""},on:{"click":function($event){_vm.showList = !_vm.showList}}},[_vm._v("\n            "+_vm._s(_vm.showList ? 'Hide' : 'Show')+" History\n            "),(!_vm.showList)?_c('v-icon',{staticClass:"pl-3"},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.showList)?_c('v-icon',{staticClass:"pl-3"},[_vm._v("expand_less")]):_vm._e()],1)],1),_vm._v(" "),(_vm.showUpload)?_c('v-card',{staticClass:"\n                            xs12\n                            ml-0\n                            mr-0\n                            mt-2\n                            mb-2\n                            elevation-0\n                            "},[_c('v-card-title',{staticClass:"blue-grey lighten-3 white--text xs12 py-2"},[_c('h3',[_vm._v("Add Insurance Valuation")])]),_vm._v(" "),_c('v-card-text',{staticClass:"pl-4\n                            pr-4\n                            pt-3\n                            pb-3 wrap row layout"},[_c('v-flex',{staticClass:"sm8 xs12 pr-3"},[_c('v-text-field',{attrs:{"name":"insurance_value","label":"Insurance Value"},model:{value:(_vm.artwork_insurance_log.insurance_value),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "insurance_value", $$v)},expression:"artwork_insurance_log.insurance_value"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm4 xs12"},[_c('v-select',{attrs:{"name":"insurance_value_currency","items":[
                    'EUR',
                    'USD',
                    'GBP',
                    'AUD',
                    'CHF',
                    'YEN',
                    'MYR',
                    'SIT',
                    'ATS (obsolete)',
                    'DEM (obsolete)',
                    'ESP (obsolete)',
                    'FRF (obsolete)',
                    'ITL (obsolete)',
                    'NLG (obsolete)',
                    'RM (obsolete)',
                    'Gift' ],"label":"Currency","hint":"Currency"},model:{value:(_vm.artwork_insurance_log.insurance_value_currency),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "insurance_value_currency", $$v)},expression:"artwork_insurance_log.insurance_value_currency"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 "},[_c('v-text-field',{staticClass:"mr-0",attrs:{"name":"reason","label":"Reason"},model:{value:(_vm.artwork_insurance_log.reason),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "reason", $$v)},expression:"artwork_insurance_log.reason"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6"},[_c('v-text-field',{staticClass:"mr-3",attrs:{"name":"insurance_valuer","label":"Valuer"},model:{value:(_vm.artwork_insurance_log.insurance_valuer),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "insurance_valuer", $$v)},expression:"artwork_insurance_log.insurance_valuer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","mb-0":"","pb-0":""}},[_c('v-menu',{ref:"menu2",attrs:{"disabled":!_vm.c_user.edit,"return-value":_vm.artwork_insurance_log.insurance_value_date,"close-on-content-click":true,"nudge-right":40,"lazy":"","landscape":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.artwork_insurance_log, "insurance_value_date", $event)},"update:return-value":function($event){return _vm.$set(_vm.artwork_insurance_log, "insurance_value_date", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Insurance Value Date","prepend-inner-icon":"event","readonly":"","persistent-hint":""},slot:"activator",model:{value:(_vm.artwork_insurance_log.insurance_value_date),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "insurance_value_date", $$v)},expression:"artwork_insurance_log.insurance_value_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"color":"black","persistent":""},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.artwork_insurance_log.insurance_value_date)}},model:{value:(_vm.artwork_insurance_log.insurance_value_date),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "insurance_value_date", $$v)},expression:"artwork_insurance_log.insurance_value_date"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"insurance_value_note","label":"Note"},model:{value:(_vm.artwork_insurance_log.insurance_value_note),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "insurance_value_note", $$v)},expression:"artwork_insurance_log.insurance_value_note"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"}),_vm._v(" "),_c('v-flex',{staticClass:"xs12 pr-0 mr-0 mt-3",attrs:{"text-xs-right":""}},[_c('v-btn',{attrs:{"small":"","flat":""},on:{"click":_vm.switch_change_dialog}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":!(
                  _vm.artwork_insurance_log.insurance_value == null ||
                  _vm.artwork_insurance_log.insurance_value == '' ||
                  _vm.artwork_insurance_log.insurance_value_currency == null ||
                  _vm.artwork_insurance_log.insurance_value_currency == ''
                ) &&
                !(
                  _vm.artwork_insurance_log.insurance_value == null ||
                  _vm.artwork_insurance_log.insurance_value == ''
                ),"disabled":_vm.artwork_insurance_log.insurance_value == null ||
                    _vm.artwork_insurance_log.insurance_value == '' ||
                    _vm.artwork_insurance_log.insurance_value == null ||
                    _vm.artwork_insurance_log.insurance_value == ''},on:{"click":_vm.showSaveDialog}},[_vm._v("save")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","overlay":true,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.saveDialog),callback:function ($$v) {_vm.saveDialog=$$v},expression:"saveDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"red white--text pb-2 pt-2",attrs:{"primary-title":""}},[_c('h2',[_vm._v("Review Changes")])]),_vm._v(" "),_c('v-card-text',[_c('h3',{staticClass:"mb-3"},[_vm._v(" New Insurance History entry will be created for:"),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.artwork.title))])]),_vm._v(" "),_c('div',[_vm._v("\n                Insurance Value Date: "),_c('b',[_vm._v(_vm._s(_vm.artwork_insurance_log.insurance_value_date))])]),_vm._v(" "),_c('div',[_vm._v("\n                Insurance Value: "),_c('b',[_vm._v(_vm._s(_vm.artwork_insurance_log.insurance_value)+" "+_vm._s(_vm.artwork_insurance_log.insurance_value_currency))])]),_vm._v(" "),_c('div',[_vm._v("\n                Insurance Valuer: "),_c('b',[_vm._v(_vm._s(_vm.artwork_insurance_log.insurance_valuer)+" ")])]),_vm._v(" "),_c('div',[_vm._v("\n                Reason: "),_c('b',[_vm._v(_vm._s(_vm.artwork_insurance_log.reason))])]),_vm._v(" "),_c('div',[_vm._v("\n                Note: "),_c('b',[_vm._v(_vm._s(_vm.artwork_insurance_log.insurance_value_note))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"cancel","small":""},on:{"click":function($event){_vm.saveDialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":"","disabled":_vm.artwork_insurance_log.insurance_value == null ||
                    _vm.artwork_insurance_log.insurance_value == '' ||
                    _vm.artwork_insurance_log.insurance_value_currency == '' ||
                    _vm.artwork_insurance_log.insurance_value_date == null ||
                    _vm.artwork_insurance_log.insurance_value_date == ''},on:{"click":_vm.save_artwork_insurance_log}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),(_vm.showList && (_vm.filtered_artwork_insurance_logs &&
          _vm.filtered_artwork_insurance_logs.length > 0))?_c('v-flex',{attrs:{"row":"","xs12":"","sm12":"","md12":"","mt-0":"","ml-0":"","mr-0":""}},[_c('v-list',{staticClass:"xs12 py-0 grey lighten-4",attrs:{"three-line":""}},[_c('v-flex',{attrs:{"my-0":"","pb-0":"","pt-2":""}},[_vm._l((_vm.filtered_artwork_insurance_logs),function(l){return [_c('v-flex',{key:l.id},[_c('v-flex',{attrs:{"px-3":"","py-0":""}},[_c('v-list-tile-title',{staticClass:"subheading font-weight-bold"},[_c('span',[_vm._v(_vm._s(l.insurance_value_date))]),_vm._v(" by "),_c('b',[_vm._v(_vm._s(l.insurance_valuer)+" ")]),_vm._v(" "),_c('small',{staticClass:"right font-weight-thin"},[(l.created_by != null)?_c('span',[_vm._v(_vm._s(_vm.get_abb(l.created_by))+" -")]):_vm._e(),_vm._v(" "),(l.created_at != null || l.created_at != '')?_c('span',[_vm._v(_vm._s(_vm.format_date(l.created_at)))]):_vm._e()])]),_vm._v(" "),_c('v-list-tile-title',[(_vm.c_user.edit)?_c('span',{staticClass:"right"},[_c('v-btn',{staticClass:"mt-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.delete_log(l)}}},[_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-btn',{key:l.id + 'b',staticClass:"mr-0 mt-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.editInsurance(l)}}},[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("edit")])],1)],1):(l.insurance_value_note == 'Created at Artwork record creation in CMS'
                      )?_c('span',[_vm._v("\n                    Created at Artwork record creation in CMS\n                  ")]):_vm._e(),_vm._v(" "),_c('span',{},[_vm._v("INSURANCE VALUE:")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.formatMoney(l.insurance_value))+" "+_vm._s(l.insurance_value_currency))]),_c('br')]),_vm._v(" "),(l.reason)?_c('v-list-tile-sub-title',{staticClass:"body-2"},[_c('span',{},[_vm._v("REASON:")]),_vm._v("\n                  "+_vm._s(l.reason)+"\n                ")]):_vm._e(),_vm._v(" "),(l.insurance_value_note &&
                  l.insurance_value_note != 'Created at Artwork record creation in CMS'
                  )?_c('v-list-tile-sub-title',{staticClass:"body-2"},[_c('span',{},[_vm._v("NOTE:")]),_vm._v("\n                  "+_vm._s(l.insurance_value_note)+"\n                ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-divider',{key:("a" + (l.id)),staticClass:"my-2"})]})],2)],1)],1):_vm._e(),_vm._v(" "),(_vm.showList && _vm.artwork.Valuation_Date_all)?_c('table',{staticClass:"mx-3 pa-2 mt-0 pa-0 mb-3 white"},[_c('tr',[_c('th',{staticStyle:{"text-align":"left"}},[_vm._v("Legacy")])]),_vm._v(" "),_vm._l((_vm.old_insurance_table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.date)+" ")]),_c('td',[_vm._v(" "+_vm._s(item.type)+" ")]),_c('td',[_vm._v(" "+_vm._s(item.method)+" ")])])})],2):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "4fi6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_artworks_TextEditor__ = __webpack_require__("JslP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // editedIndex: -1,
      // editedItem: {
      //   title:'',
      //   version: '',
      //   subtitle: '',
      //   updates: '',
      //   help: '',
      //   at_work: '',
      //   support: '',
      //   show_in_route: '',
      //   group: ''
      // },
      defaultItem: {
        title: '',
        version: '',
        subtitle: '',
        updates: '',
        help: '',
        at_work: '',
        support: '',
        show_in_route: '',
        group: ''
      },
      dialog: false,
      save_article_form_display: false,
      search: '',
      selected: [],
      new_article: { title: '', versio: '' },
      headers: [
      // { text: '', align: 'center', sortable: false },
      { text: 'Title', value: 'title', align: 'left' }, { text: 'Group', value: 'group', align: 'right' }, { text: 'Publish Date', value: 'publish_date', align: 'right' }, { text: 'V', value: 'version', align: 'right' }, { text: 'AW', value: 'at_work', align: 'right' }, { text: 'U', value: 'updates', align: 'right' }, { text: 'H', value: 'help', align: 'right' }, { text: '', align: 'right' }],
      articles: []
    };
  },

  created: function created() {
    // this.getArtists()
    this.initialize();
  },
  computed: {
    articles_d: function articles_d() {
      this.articles = this.$store.state.support_articles;
      return this.articles;
    }
  },
  methods: {
    initialize: function initialize() {
      this.articles = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.support_articles);
      this.$store.dispatch('loadSupportArticles');
    },
    openArticle: function openArticle(item) {
      // console.log(item)
      this.$router.push({
        name: 'EditArtist',
        // path: `/articles/edit/${item.id}`,
        params: { id: item.id, editedItem: item }
      });
    },

    // saveArticle () {
    // },
    createArticle: function createArticle() {
      var _this = this;

      // this.snackbar = true
      var url = this.$globals.apiserver + '/support_articles.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, this.newItem).then(function (response) {
        // this.result = response.data
        var o = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ name: _this.newItem.title });
        _this.$store.dispatch('createArticle', o);
        _this.save_user_form_display = false;
        _this.snackbar = false;
        _this.newItem = _this.defaultItem;
        // this.$router.push({path:`/users/edit/${this.result.id}`, params: {user: this.result}})
      }).catch(function (error) {
        // console.log(error)
      });
    },

    // close () {
    //   this.dialog = false
    //   setTimeout(() => {
    //     this.editedItem = Object.assign({}, this.defaultItem)
    //     this.editedIndex = -1
    //   }, 300)
    // },
    // save () {
    //   let url = `${this.$globals.apiserver}/support_articles/${this.editedItem.id}.json`
    //   axios.put(url,this.editedItem).then((response) => {
    //     this.result = response.data
    //     this.$store.dispatch('updateArticle', this.result)
    //     // this.snackbar = true
    //   }).catch((error) => { console.log(error) })
    //   // if (this.editedIndex > -1) {
    //   //   Object.assign(this.$store.state.support_articles[this.editedIndex], this.editedItem)
    //   // } else {
    //   //   this.$store.state.support_articles.push(this.editedItem)
    //   // }
    //   this.close()
    // },
    show_create_article_form: function show_create_article_form() {
      this.save_article_form_display = true;
    }
    // editItem (item) {
    //   // console.log(item)
    //   this.editedIndex = this.$store.state.support_articles.indexOf(item)
    //   // console.log(this.editedIndex)
    //   this.editedItem = Object.assign({}, item)
    //   // console.log(this.editedItem)
    //   this.dialog = true
    // }

  },
  components: { TextEditor: __WEBPACK_IMPORTED_MODULE_1__components_artworks_TextEditor__["a" /* default */] }
});

/***/ }),

/***/ "50M9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_artists_EditFieldHeader__ = __webpack_require__("Z/ya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_artists_ViewArtworks__ = __webpack_require__("eZui");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_full_user_fields__ = __webpack_require__("LKPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_artists_AddArtist__ = __webpack_require__("AnAQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_locations_AddLocation__ = __webpack_require__("CODS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_artworks_Upload__ = __webpack_require__("e4A6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artworks_Location__ = __webpack_require__("KK+U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_artworks_Electrical__ = __webpack_require__("sHT9");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import dynamic_fields from '@/data/dynamic_fields'





// import Films from '@/components/artworks/Films'

// import EditField from './EditField'

function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
function nl2br(str, is_xhtml) {
  var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-field-sub',
  data: function data() {
    return {
      channels: [{ id: '1', value: '1', name: 'Single-channel' }, { id: '2', value: '2', name: 'Two-channel' }, { id: '3', value: '3', name: 'Three-channel' }, { id: '4', value: '4', name: 'Four-channel' }, { id: '5', value: '5', name: 'Five-channel' }, { id: '6', value: '6', name: 'Six-channel' }, { id: '7', value: '7', name: 'Seven-channel' }, { id: '8', value: '8', name: 'Eight-channel' }, { id: '9', value: '9', name: 'Nine-channel' }, { id: '10', value: '10', name: 'Ten-channel' }, { id: '11', value: '11', name: '11-channel' }, { id: '12', value: '12', name: '12-channel' }, { id: '13', value: '13', name: '13-channel' }, { id: '14', value: '14', name: '14-channel' }, { id: '15', value: '15', name: '15-channel' }],
      count: 0,
      showingAddForm: false,
      showUpload: false,
      instalation_includes: [],
      film_type: '',
      isEditing: false,
      an_exists: false,
      saved: false,
      cannotSave: false,
      value_new: '',
      show: true,
      model: {},
      electrical: {
        monitor_specification: '',
        projector_specification: '',
        motor_specification: '',
        bulb_specification: '',
        switch: '',
        other: '',
        monitor_origin: '',
        projector_origin: '',
        motor_origin: '',
        bulb_origin: '',
        switch_origin: '',
        other_origin: '',
        interfaces: '',
        brand: '',
        sn: '',
        an: '',
        production_date: '',
        number_of_parts: '',
        power_requirement: '',
        height: '',
        width: '',
        depth: '',
        weight: '',
        specs: '',
        modification: '',
        periphals: '',
        associated_items: ''
        // model: "artwork_location"
        // model: "artwork_location"
        // this.f_field.show
      } };
  },

  props: ['field', 'artwork', 'placeholder', 'label', 'name', 'value', 'selection', 'title', 'reading_device', 'fields', 'film'],
  methods: {
    removeField: function removeField(f) {
      // console.log(f)
      document.getElementById(f.name).style.display = 'none';
    },
    updateValue: function updateValue(f) {
      // console.log(f)
      this.$emit('input', {
        value: this.$refs[f].value,
        field: f
      });
    },
    showAddForm: function showAddForm() {
      this.showingAddForm = !this.showingAddForm;
    },
    add_field: function add_field(field) {
      document.getElementById(field.name).style.display = 'block';
    },
    saveOrEdit: function saveOrEdit() {
      var _this = this;

      this.isEditing = !this.isEditing;
      this.$refs[this.f_field['name']].isFocused = true;
      if (this.an_exists == false) {
        if (this.isEditing == false) {
          this.saved = true;
          setTimeout(function () {
            _this.saved = false;
          }, 2000);
        }
      } else {
        this.cannotSave = true;
        setTimeout(function () {
          _this.cannotSave = false;
        }, 4000);
      }
    },

    // nefunguje tak ako chcem
    format_date: function format_date(date, format) {
      var moment = __webpack_require__("PJh5");
      var ndate = new Date(date);
      return moment(ndate).format(format);
    },
    check_an: function check_an(value) {
      if (this.f_field.name == 'accession_number' && this.isEditing == true) {
        var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
        var b = a.filter(function (aa) {
          return aa.accession_number == value;
        });
        this.an_exists = b.length > 0;
      }
    }
  },
  computed: {
    dynamic_field_list: function dynamic_field_list() {
      var _this2 = this;

      if (this.f_field.headline) {
        var c = [];
        if (this.report || this.reading_device) {
          var fields2 = this.fields;
        } else {
          var fields2 = __WEBPACK_IMPORTED_MODULE_3__data_full_user_fields__["a" /* default */]['tabs'][this.$store.state.currentTab.substr(4)]['fields'];
        }
        // var fields2 = fields['tabs'][this.$store.state.currentTab.substr(4)]['fields']
        c = fields2.filter(function (f) {
          return f.dynamic && f.section === _this2.f_field.section;
        });
        return c;
      } else {
        return [];
      }
    },
    field_type: function field_type() {
      return this.f_field.etype ? this.f_field.etype : this.f_field.ctype;
    },
    selection_items: function selection_items() {
      var _this3 = this;

      if (this.f_field.table) {
        if (this.f_field.table == 'contacts') {
          var contacts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.contacts);
          if (this.f_field.column) {
            return contacts.filter(function (c) {
              return c[_this3.f_field.column] == c[_this3.f_field.association];
            });
          } else {
            return contacts;
          }
        }
        if (this.f_field.table == 'artists') {
          var artists = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
          if (this.f_field.column) {
            return artists.filter(function (c) {
              return c[_this3.f_field.column] == c[_this3.f_field.association];
            });
          } else {
            return artists.sort(dynamicSort('name'));
          }
        }
        if (this.f_field.table == 'artwork_locations') {
          // console.log(this.f_field.table)
          // console.log('this.f_field.table')
          var artwork_locations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.locations);
          if (this.f_field.column) {
            return artwork_locations.filter(function (c) {
              return c[_this3.f_field.column] == c[_this3.f_field.association];
            });
          } else {
            return artwork_locations.sort(dynamicSort('name'));
          }
        }
      }
      if (this.f_field.selection && this.f_field.selection.length > 0) {
        return this.f_field.selection;
      }
    },
    f_field: function f_field() {
      var f = this.field;
      f.model_string_c = '';
      // console.log(this.field.model_string)
      // console.log(this.field.name)
      // console.log(this.electrical)
      f.model_string_c = this.field.model_string ? this.field.model_string + '.' + this.field.name : this.field.name;
      // console.log(f.model_string_c)
      // console.log(f)
      f.column = this.field.column ? this.field.column : false;
      // f.value_string = this.field.model_string ? this[this.field.model_string][this.field.name] : this.f_artwork[this.field.name]
      // f.value_string = f.value_string ? f.value_string : ''
      return f;
    },
    f_artwork: function f_artwork() {
      return this.artwork;
    }
  },
  components: { AddLocation: __WEBPACK_IMPORTED_MODULE_5__components_locations_AddLocation__["a" /* default */], AddArtist: __WEBPACK_IMPORTED_MODULE_4__components_artists_AddArtist__["a" /* default */], EditFieldHeader: __WEBPACK_IMPORTED_MODULE_1__components_artists_EditFieldHeader__["a" /* default */], ViewArtworks: __WEBPACK_IMPORTED_MODULE_2__components_artists_ViewArtworks__["a" /* default */], Upload: __WEBPACK_IMPORTED_MODULE_6__components_artworks_Upload__["a" /* default */], Location: __WEBPACK_IMPORTED_MODULE_7__components_artworks_Location__["a" /* default */], Electrical: __WEBPACK_IMPORTED_MODULE_8__components_artworks_Electrical__["a" /* default */]
    //Films,
  } });

/***/ }),

/***/ "50mt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "51Y4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "54WG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadingDevices_vue__ = __webpack_require__("HKJ0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1d517e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadingDevices_vue__ = __webpack_require__("6WKS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("6u99")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0d1d517e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadingDevices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1d517e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadingDevices_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d1d517e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadingDevices_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "57cu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Packings_vue__ = __webpack_require__("Im8P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c435d4b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Packings_vue__ = __webpack_require__("zheF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("toVw")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c435d4b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Packings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c435d4b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Packings_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c435d4b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Packings_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5MJo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttachTagToArtworksDialog_vue__ = __webpack_require__("Ij7b");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c69548_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttachTagToArtworksDialog_vue__ = __webpack_require__("2WYp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AttachTagToArtworksDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c69548_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttachTagToArtworksDialog_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76c69548_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AttachTagToArtworksDialog_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5RcA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EditField__ = __webpack_require__("paWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_artists_EditFieldHeader__ = __webpack_require__("Z/ya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_artists_ViewArtworks__ = __webpack_require__("eZui");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_artists_MultiArtist_vue__ = __webpack_require__("RKLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_countries__ = __webpack_require__("ER8n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__layout_SectionHeader_vue__ = __webpack_require__("u3wA");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import * as qs from 'querystring'





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      constants: __WEBPACK_IMPORTED_MODULE_7__data_constants__["a" /* default */],
      name_exists: false,
      // fields: fields.fields,
      // e1: 1,
      // countries: this.constants.COUNTRIES,
      countries: __WEBPACK_IMPORTED_MODULE_6__data_countries__["a" /* default */].countries,
      artists: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists).sort(),
      // artistFormData: Object.assign({}, this.artist),
      valid: true,
      currentTab: this.$store.state.currentTabArtist,
      menu2: false,
      artist: {
        name: '',
        first_name: '',
        last_name: '',
        sort_name: '',
        collective: '0',
        birth_date: '',
        birth_city: '',
        birth_country: ''
      }
    };
  },

  // props: ['artist', 'field'],
  beforeMount: function beforeMount() {
    this.result = this.$route.params.artist;
    // this.getArtist()
  },

  methods: {
    check_name: function check_name(value) {
      if (value) {
        var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
        var b = a.filter(function (aa) {
          return aa.name === value;
        });
        this.name_exists = b.length > 0;
      }
    },
    saveArtist: function saveArtist() {
      var _this = this;

      // if (this.$refs.form.validate()) {
      // console.log(this.artwork)
      if (this.artist.birth_date_year && this.artist.birth_date_month && this.artist.birth_date_day) {
        this.artist.birth_date = this.artist.birth_date_year + '-' + this.artist.birth_date_month + '-' + this.artist.birth_date_day;
      }
      var url = this.$globals.apiserver + '/artists.json';
      // console.log(url)
      this.artist.created_by = this.c_user.id;
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, this.artist).then(function (response) {
        // this.loading = false;
        // console.log(response.data)
        _this.result = response.data;
        _this.artist = response.data;
        _this.$store.dispatch('addArtist', response.data);
        // this.artwork = response.data
        // this.artist = response.data.artist
        // this.e1 = 3
        // console.log(this.artwork)
        _this.$router.push({
          name: 'EditArtist',
          // path: `/artists/edit/${this.artist.id}`,
          params: { id: _this.artist.id, artist: _this.artist }
        });
      }).catch(function (error) {
        // console.log(error)
      });
      // }
    },

    // submit () {
    //   const art = this.artistFormData
    //   const requestConfig = {
    //       url     : `http://www.tb-cms.org/artists/api_update/${this.$route.params.id}`,
    //       method  : "POST",
    //       // headers : { "Content-Type" : "application/x-www-form-urlencoded" },
    //       data : qs.stringify(art)
    //   }
    //   const response = axios.request(requestConfig)
    // },
    clear: function clear() {
      this.$refs.form.reset();
    },

    // updateForm (fieldName, value) {
    //   this.$set(this.artistFormData, fieldName, value)
    //   // this.$emit("input", this.artist);
    // },
    saveCurrentTab: function saveCurrentTab(tab) {
      this.$store.dispatch('saveCurrentTabArtist', tab);
    },
    getArtist: function getArtist() {
      var _this2 = this;

      // console.log('getArtist')
      var url = 'http://www.tb-cms.org/artists/' + this.$route.params.id + '.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (response) {
        // this.loading = false;
        _this2.result = response.data;
      }).catch(function (error) {
        // console.log(error)
      });
    }
  },
  computed: {
    processedArtist: function processedArtist() {
      var processedArtist = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.result);
      return processedArtist;
    }
  },
  components: {
    EditField: __WEBPACK_IMPORTED_MODULE_2__EditField__["a" /* default */],
    MultiArtist: __WEBPACK_IMPORTED_MODULE_5__components_artists_MultiArtist_vue__["a" /* default */],
    EditFieldHeader: __WEBPACK_IMPORTED_MODULE_3__components_artists_EditFieldHeader__["a" /* default */],
    ViewArtworks: __WEBPACK_IMPORTED_MODULE_4__components_artists_ViewArtworks__["a" /* default */],
    SectionHeader: __WEBPACK_IMPORTED_MODULE_8__layout_SectionHeader_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "5cyT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Programme_vue__ = __webpack_require__("oJE0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d7216a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Programme_vue__ = __webpack_require__("kWtg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("GuN8")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-12d7216a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Programme_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d7216a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Programme_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12d7216a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Programme_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5g8X":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5kfu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5sV0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"900px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"dark":""}},[_c('v-card-title',{staticClass:"mb-0 pb-0"},[_c('span',{staticClass:"headline mb-0 pb-0 ml-4 mt-3 font-weight-light"},[_vm._v("Merge into other Location before deleting")])]),_vm._v(" "),_c('v-card-text',{staticClass:"mt-0 pt-0"},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"title mb-2"},[_vm._v("Locations to delete:")]),_vm._v(" "),_vm._l((_vm.selected),function(c){return _c('div',{key:c.id,staticStyle:{"color":"red","font-size":"17px"}},[_vm._v("\n                "+_vm._s(c.name)+"\n                "),_c('span',{staticClass:"right"},[_vm._v("ID-"+_vm._s(c.id))])])})],2),_vm._v(" "),(_vm.artworks.length > 0)?_c('v-flex',{attrs:{"xs12":"","mt-3":""}},[_c('b',[_vm._v("Affected Artworks:")]),_vm._v(" "),_c('div',{staticStyle:{"color":"white","font-size":"17px"}},_vm._l((_vm.artworks),function(a){return _c('div',{key:a.id},[_c('b',[_vm._v(_vm._s(a.accession_number))]),_vm._v("\n                  - "+_vm._s(a.name)+" - "+_vm._s(a.title)+"\n                ")])}),0)]):_c('v-flex',{attrs:{"mt-3":""}},[_c('b',[_vm._v("NO ARTWORKS HAVE THIS LOCATION AS CURRENT LOCATION")])]),_vm._v(" "),(_vm.artworks.length > 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',[_c('div',{staticClass:"title mt-4"},[_vm._v("\n                  Select Location to set new Current Location to artworks\n                  below:\n                ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.sorted_locations,"item-text":"name","item-value":"id","label":""},on:{"change":_vm.setLocation2},scopedSlots:_vm._u([{key:"item",fn:function(data){return [_c('v-list-tile-content',{staticClass:"py-2"},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(data.item.name)}}),_vm._v(" "),(data.item.artworks)?_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(("Atworks Count: " + (data.item.artworks.length)))}}):_vm._e()],1),_vm._v(" "),_c('v-list-tile-action',[_vm._v("ID-"+_vm._s(data.item.id))])]}}],null,false,609442522),model:{value:(_vm.selectedLocation),callback:function ($$v) {_vm.selectedLocation=$$v},expression:"selectedLocation"}})],1),_vm._v(" "),(_vm.artworks2.length > 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('b',[_vm._v("Current Artworks af this Location:")]),_vm._v(" "),_c('ul',_vm._l((_vm.artworks2),function(a){return _c('li',{key:a.id},[_vm._v("\n                    "+_vm._s(a.accession_number)+" / "+_vm._s(a.name)+" / "+_vm._s(a.title)+"\n                  ")])}),0)]):_c('v-flex',[_c('b',[_vm._v("NO ARTWORKS")])])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pr-4 pb-4"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{attrs:{"color":"red","flat":""},on:{"click":_vm.deleteLocation2}},[_vm._v("Delete Location and move its artworks to Selected location")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mt-4 elevation-0"},[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","my-3":"","mx-1":""}},[_c('span',[_c('v-menu',{staticClass:"text-xs-right mx-4 my-0 py-0 align-center",attrs:{"offset-y":"","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-2 my-0 py-0",attrs:{"small":"","icon":"","color":"black","dark":""}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("supervisor_account")])],1)]}}])},[_vm._v(" "),_c('v-list',{attrs:{"value":"3"}},_vm._l((_vm.ownerships),function(item,index){return _c('v-list-tile',{key:index.id,on:{"click":function($event){return _vm.toggleOwnership(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)}),1)],1)],1),_vm._v(" "),_c('span',{staticClass:"text-xs-left mt-2 pt-1 title"},[_vm._v("\n          "+_vm._s(_vm.selectedOwnership.name)+"\n        ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),(_vm.selected.length > 0 && _vm.c_user.delete_rights)?_c('v-btn',{staticClass:"ml-2 mb-0 mt-3",attrs:{"small":"","color":"red","dark":""},on:{"click":_vm.deleteLocations}},[_vm._v("Delete Locations")]):_vm._e(),_vm._v(" "),(_vm.selected.length > 0 && _vm.c_user.delete_rights)?_c('v-btn',{staticClass:"ml-1 mr-5 mb-0 mt-3",attrs:{"small":"","color":"black","dark":""},on:{"click":_vm.resetSelected}},[_vm._v("Clear Selection")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.$store.state.showSearch)?_c('v-text-field',{attrs:{"prepend-inner-icon":"search","label":"Search ","clearable":"","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0 mx-4",attrs:{"headers":_vm.headers,"items":_vm.table_locations_with_artworks,"pagination":_vm.pagination2,"search":_vm.search,"item-key":"id","must-sort":"","rows-per-page-text":"Locations per page","no-data-text":"No Locations loaded from server. Please click Load Locations in Local Storage Management menu.","no-results-text":"No Locations match the criteria."},on:{"update:pagination":function($event){_vm.pagination2=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:{ black: props.expanded, 'white--text': props.expanded }},[_c('td',{staticStyle:{"width":"15px","padding":"0px","margin":"0px"}},[_c('v-checkbox',{attrs:{"color":"black","primary":"","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"title",class:{
                black: props.expanded,
                'white--text': props.expanded
              },attrs:{"to":{
                name: 'EditLocation',
                params: { id: props.item.id, location: props.item },
                path: ("/locations/edit/" + (props.item.id))
              }}},[_vm._v("\n              "+_vm._s(props.item.name)+"\n            ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.city))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.country_id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right",staticStyle:{"width":"30px"}},[_vm._v("\n            "+_vm._s(_vm.getNoOfArtworksAtLocation(props.item.artworks))+"\n            "),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){props.expanded = !props.expanded}}},[(!props.expanded)?_c('v-icon',{class:{ 'white--text': props.expanded }},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(props.expanded)?_c('v-icon',{class:{ 'white--text': props.expanded }},[_vm._v("expand_less")]):_vm._e()],1)],1)])]}},{key:"expand",fn:function(props){return [_c('v-data-table',{staticClass:"elevation-0",attrs:{"must-sort":"","pagination":_vm.pagination_related,"hide-headers":"","items":_vm.location_artworks(props.item.id),"search":_vm.search_related,"item-key":"id","no-data-text":"No Artworks at this location.","no-results-text":"No Artworks match the criteria."},on:{"update:pagination":function($event){_vm.pagination_related=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props_related){return [_c('tr',[_c('td',{staticStyle:{"text-align":"center","vertical-align":"text-top","width":"140px","padding":"7px 0 0 10px"}},[(props_related.item.top_photo_id > 0)?_c('img',{class:{
                    redBorder:
                      props_related.item.top_photo.width < 500 ||
                      props_related.item.top_photo.height < 500
                  },staticStyle:{"width":"120px","margin":"10px"},attrs:{"src":("\n                    " + (_vm.$globals.oldserver) + "/data/artwork/" + (props_related.item.id) + "/" + (props_related.item.top_photo_id) + "_th_big.jpg")},on:{"error":_vm.imageUrlAlt}}):_c('img',{staticStyle:{"width":"120px","margin":"10px"},attrs:{"src":_vm.imageUrlAlt},on:{"error":_vm.imageUrlAlt}})]),_vm._v(" "),_c('td',[_c('router-link',{staticClass:"subheading",attrs:{"to":{
                    name: 'EditArtwork',
                    params: {
                      id: props_related.item.id,
                      artwork: props_related.item
                    },
                    path: ("/artworks/edit/" + (props_related.item.id))
                  }}},[_vm._v("\n                  "+_vm._s(props_related.item.artist
                      ? props_related.item.artist.name
                      : props_related.item.name)+",\n                  "),_c('strong',[_vm._v(_vm._s(props_related.item.title))])])],1),_vm._v(" "),_c('td',{staticClass:"title",attrs:{"align":"right"}},[_vm._v("\n                "+_vm._s(props_related.item.accession_number)+"\n              ")])])]}}],null,true),model:{value:(_vm.selected_related),callback:function ($$v) {_vm.selected_related=$$v},expression:"selected_related"}}),_vm._v(" "),_c('v-flex',{staticClass:"px-3 py-1 my-0 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("   ")])])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" "),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Your search for \""+_vm._s(_vm.search)+"\" found no locations.\n      ")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "5vjN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderElements__ = __webpack_require__("oiZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ElementsTable__ = __webpack_require__("vCKh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EditFieldComp from './EditFieldComp'


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork', 'field'],
  data: function data() {
    return {
      dialog: false,
      electricals: [
        // { id:1, title: 'Bulb 1', bulb_origin: 1, bulb_specification: 'test specs'},
        // { id:3, title: 'Bulb 2', bulb_origin: 1, bulb_specification: 'test specs'},
        // { id:2, title: 'Bulb 3', bulb_origin: 1, bulb_specification: 'test specs'},
      ],
      categories: [{ id: 'monitor', name: 'Monitor', off_icon: 'mdi-monitor', on_icon: 'mdi-monitor' }, { id: 'projector', name: 'Projector', off_icon: 'mdi-projector', on_icon: 'mdi-projector' }, { id: 'motor', name: 'Motor', off_icon: 'mdi-engine', on_icon: 'mdi-engine' }, { id: 'bulb', name: 'Bulb', off_icon: 'mdi-lightbulb', on_icon: 'mdi-lightbulb' }, { id: 'switch', name: 'Switch', off_icon: 'mdi-nintendo-switch', on_icon: 'mdi-nintendo-switch' }],
      fields: [
        // {
        //   'ctype': 'radio',
        //   'selection': [{id: 1, name: 'monitor'},{id:2, name:'projector'},{id:3, name:'motor'}, {id:4, name:'bulb'}, {id:5, name:'switch'}],
        //   'name': 'category',
        //   'title': 'Category',
        //   column: false,
        //   class: 'xs12',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   'ctype': 'radio',
        //   'selection': [{id: 1, name: 'LCD'}, {id: 2, name: 'LED-LCD'}, {id: 3, name: 'Plasma'}, {id: 4, name: 'CRT'}, {id: 5, name: 'Other'}],
        //   condition: 'this.electrical.category=="monitor"',
        //   'name': 'monitor_specification',
        //   'title': 'Monitor Specification',
        //   category: 'monitor',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs12',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: '8mm'}, {id: 2, name: '16mm'}, {id: 3, name: '35mm'}, {id: 4, name: 'DLP'}, {id: 5, name: 'CRT'}, {id: 6, name: 'other'}],
        //   'name': 'projector_specification',
        //   'title': 'Projector Specification',
        //   category: 'projector',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'electric motor'}, {id: 2, name: 'pneumatic motor'}, {id: 3, name: 'hydraulic motor'}, {id: 4, name: 'other'}],
        //   'name': 'motor_specification',
        //   'title': 'Motor Specification',
        //   category: 'motor',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Incandescent light bulb'}, {id: 2, name: 'LED'}, {id: 3, name: 'Halogen'}, {id: 4, name: 'Arc lamp'}, {id: 5, name: 'Gas-discharged lamp (fluorescent, neon)'}, {id: 6, name: 'other'}],
        //   'name': 'bulb_specification',
        //   'title': 'Bulb Specification',
        //   category: 'bulb',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   name: 'switch',
        //   title: 'Switch, Counter - Specification',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   category: 'switch',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'other',
        //   title: 'Other - Specification',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   category: 'other',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   'ctype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'monitor_origin',
        //   'title': 'Monitor - Origin',
        //   category: 'monitor',
        //   no_edit: true,
        //   column: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },      
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'projector_origin',
        //   'title': 'Projector - Origin',
        //   category: 'projector',
        //   no_edit: true,
        //   column: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },      
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'motor_origin',
        //   'title': 'Motor - Origin',
        //   category: 'motor',
        //   no_edit: true,
        //   column: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },      
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'bulb_origin',
        //   'title': 'Bulb - Origin',
        //   category: 'bulb',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },      
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'switch_origin',
        //   'title': 'Switch, Counter - Origin',
        //   category: 'switch',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },      
        // {
        //   'ctype': 'radio',
        //   'etype': 'radio',
        //   'selection': [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        //   'name': 'other_origin',
        //   'title': 'Other- Specification - Origin',
        //   category: 'other',
        //   column: true,
        //   no_edit: true,
        //   class: 'xs6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        // {
        //   name: 'electrical.brand',
        //   title: 'Brand',
        //   ctype: 'text-short',
        //   class: 'xs12 md6',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'type_and_model',
        //   title: 'Type and Model',
        //   ctype: 'text-short',
        //   class: 'xs12 md6',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'sn',
        //   title: 'Serial Number',
        //   ctype: 'text-short',
        //   no_edit: true,
        //   class: 'xs12 md6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'an',
        //   title: 'Accession Number Tech Database TBA21',
        //   ctype: 'text-short',
        //   no_edit: true,
        //   class: 'xs12 md6',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'production_date',
        //   title: 'Date of Production',
        //   ctype: 'text-short',
        //   model_string: 'electrical',
        //   class: 'xs12 md6',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'interfaces',
        //   title: 'Interfaces',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'number_of_parts',
        //   title: 'Number of Parts',
        //   ctype: 'text-short',
        //   class: 'xs12 md6',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'power_requirement',
        //   title: 'Power Requirement',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'height',
        //   title: 'Height',
        //   ctype: 'text-short',
        //   'suffix': ' cm',
        //   'class': 'xs12 md4',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'width',
        //   title: 'Width',
        //   ctype: 'text-short',
        //   no_edit: true,
        //   'suffix': ' cm',
        //   'class': 'xs12 md4',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'depth',
        //   title: 'Depth',
        //   ctype: 'text-short',
        //   'suffix': ' cm',
        //   no_edit: true,
        //   'class': 'xs12 md4',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'weight',
        //   title: 'Weight',
        //   no_edit: true,
        //   ctype: 'text-short',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'specs',
        //   title: 'Specifications on installation',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'modification',
        //   title: 'Modification',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'periphals',
        //   title: 'Periphals',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
        // {
        //   name: 'associated_items',
        //   title: 'Associated items',
        //   ctype: 'text-long',
        //   no_edit: true,
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_rights: ['admin', 'manager']
        // },
      ],
      showUpload: false,
      show: false,
      showme: false,
      electrical: {
        category: '',
        monitor_specification: '',
        projector_specification: '',
        motor_specification: '',
        bulb_specification: '',
        switch: '',
        other: '',
        monitor_origin: '',
        projector_origin: '',
        motor_origin: '',
        bulb_origin: '',
        switch_origin: '',
        other_origin: '',
        interfaces: '',
        brand: '',
        sn: '',
        an: '',
        production_date: '',
        number_of_parts: '',
        power_requirement: '',
        height: '',
        width: '',
        depth: '',
        weight: '',
        specs: '',
        modification: '',
        periphals: '',
        associated_items: ''
      }
    };
  },
  computed: {
    all_electricals: function all_electricals() {
      return this.$store.state.electricals;
      // console.log(todos)
      // return todos
    }
  },
  methods: {
    // show_field (f) {
    //   if (f.condition) {
    //     this.showme = true
    //     var a = f.condition
    //     // console.log(a)
    //     return eval(a)
    //   } else {
    //     return true
    //   }
    // return Function('"use strict";return (a)')()
    // },
    download: function download() {},

    // add () {
    //   this.electricals.push(this.electrical)
    //   this.showUpload=!this.showUpload
    // },
    deleteDevice: function deleteDevice(d) {
      // var index = exhibition_artworks.indexOf(e);
      // console.log('index = ' + index)
      // exhibition_artworks.splice(index,1)
      this.$store.dispatch('deleteDevice', d);
      this.dialog = false;
    },
    delete_electrical: function delete_electrical() {},
    done_electrical: function done_electrical() {},
    save_electrical: function save_electrical() {
      this.electrical.artwork_id = this.artwork.id;
      // this.electrical.done = false
      this.electrical.id = this.findMinMax(this.all_electricals) + 1;
      this.$store.commit('ADD_ELECTRICAL', this.electrical);
      // this.all_electricals.push(this.electrical)
      this.showUpload = false;
      this.electrical = {
        description: '',
        title: '',
        deadline: '',
        done: false
        // var aelectrical = Object.keys(this.electrical).forEach(k => this.electrical[k]='')
        // console.log(aelectrical)
      };
    },
    findMinMax: function findMinMax(arr) {
      if (arr === undefined || arr.length === 0) {
        return 1;
      } else {
        var max = arr[0].id;
        for (var i = 1, len = arr.length; i < len; i++) {
          var v = arr[i].id;
          max = v > max ? v : max;
        }
        // console.log(max)
        return max;
      }
    }
  },
  components: { HeaderElements: __WEBPACK_IMPORTED_MODULE_0__HeaderElements__["a" /* default */], ElementsTable: __WEBPACK_IMPORTED_MODULE_1__ElementsTable__["a" /* default */] }
});

/***/ }),

/***/ "5yCE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-sm mr-1",class:{ 'filter-checkbox': true, active: _vm.checked },attrs:{"type":"button "},on:{"click":_vm.checkFilter}},[_vm._v(_vm._s(_vm.title))])}
var staticRenderFns = []


/***/ }),

/***/ "5yTA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Articles_vue__ = __webpack_require__("4fi6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_195dbdcb_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Articles_vue__ = __webpack_require__("6jOY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("PDQ3")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-195dbdcb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Articles_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_195dbdcb_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Articles_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_195dbdcb_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Articles_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6F6e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"align":"center"}},[_c('v-layout',{attrs:{"row":"","justify-center":"","align":"center","mt-5":""}},[_c('v-flex',{attrs:{"xs10":"","sm8":"","md6":"","lg4":"","mt-5":""}},[_c('form',{staticClass:"login",on:{"submit":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_c('v-card',[_c('div',{staticClass:"height-20 justify-center",attrs:{"color":"primary","dark":"","flat":""}},[_c('div',{staticClass:"justify-center py-3 black white--text text-uppercase font-weight-bold text-xs-center"},[_vm._v("Login into CMS")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1"})]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","pb-0":"","mb-0":""}},[_c('v-layout',{attrs:{"row":"","mb-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"flat":"","name":"login","label":"Username","prepend-inner-icon":"person"},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"name":"password","label":"Password","prepend-inner-icon":"lock","inner-icon-color":"black","flat":"","primary":"","counter":"","append-icon":_vm.e1 ? 'visibility' : 'visibility_off',"append-icon-cb":function () { return (_vm.e1 = !_vm.e1); },"type":_vm.e1 ? 'password' : 'text'},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),(_vm.error)?_c('v-layout',{attrs:{"row":""}},[_c('div',{staticClass:"pb-2 pt-3 alert alert-danger"},[_vm._v(_vm._s(_vm.error))])]):_vm._e()],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pb-5 pt-0 d-block mx-auto",attrs:{"flexbox":""}},[_c('v-btn',{staticClass:"mt-5",attrs:{"type":"submit","color":"primary","disabled":_vm.canLogin}},[_vm._v("Log me in")])],1),_vm._v(" "),(_vm.overlay)?_c('v-progress-linear',{attrs:{"height":"3","indeterminate":""}}):_vm._e()],1)],1)])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "6GTl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artist_vue__ = __webpack_require__("xPPZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_100c94c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artist_vue__ = __webpack_require__("hK9a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("yoWb")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-100c94c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_100c94c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_100c94c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6ITe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6Qpy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(_vm.location.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(_vm.location.category)}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',[_vm._v("chat_bubble")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "6WKS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"mt-4 ml-4",attrs:{"column":""}},[_c('header-elements',{attrs:{"icon":"mdi-glasses","title":"Reading Devices"},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),_c('elements-table',{attrs:{"items":_vm.all_devices,"title":"Reading Device"},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),(_vm.showUpload)?_c('v-card',{staticClass:"px-5 pt-4 elevation-5"},[_c('v-container',{attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-radio-group',{staticClass:"flex xs12 md6 mb-2",attrs:{"label":"Category"},model:{value:(_vm.reading_device.category),callback:function ($$v) {_vm.$set(_vm.reading_device, "category", $$v)},expression:"reading_device.category"}},_vm._l((_vm.constants.READING_DEVICE_TYPES),function(s){return _c('v-radio',{key:s.id,staticClass:"ml-0",attrs:{"label":s.name,"value":s.name}})}),1),_vm._v(" "),((_vm.reading_device.category==='computer'))?_c('v-flex',[_c('v-radio-group',{staticClass:"flex xs12 md6 mb-2",attrs:{"label":"Sub-Category"},model:{value:(_vm.reading_device.type),callback:function ($$v) {_vm.$set(_vm.reading_device, "type", $$v)},expression:"reading_device.type"}},_vm._l((_vm.constants.COMPUTERS),function(s){return _c('v-radio',{key:s.id,staticClass:"ml-0",attrs:{"label":s.name,"value":s.id}})}),1)],1):_vm._e(),_vm._v(" "),((_vm.reading_device.category==='micro_controller'))?_c('v-flex',[_c('v-radio-group',{staticClass:"flex xs12 mb-2",attrs:{"label":"Sub-Category"},model:{value:(_vm.reading_device.type),callback:function ($$v) {_vm.$set(_vm.reading_device, "type", $$v)},expression:"reading_device.type"}},_vm._l((_vm.constants.MICRO_CONTROLLERS),function(s){return _c('v-radio',{key:s.id,staticClass:"ml-0",attrs:{"label":s.name,"value":s.id}})}),1)],1):_vm._e(),_vm._v(" "),((_vm.reading_device.category==='film_projector'))?_c('v-flex',[_c('v-radio-group',{staticClass:"flex xs12 mb-2",attrs:{"label":"Sub-Category"},model:{value:(_vm.reading_device.type),callback:function ($$v) {_vm.$set(_vm.reading_device, "type", $$v)},expression:"reading_device.type"}},_vm._l((_vm.constants.FILM_PROJECTORS),function(s){return _c('v-radio',{key:s.id,staticClass:"ml-0",attrs:{"label":s.name,"value":s.id}})}),1)],1):_vm._e(),_vm._v(" "),((_vm.reading_device.category==='slide_projector'))?_c('v-flex',[_c('v-radio-group',{staticClass:"flex xs12 mb-2",attrs:{"label":"Sub-Category"},model:{value:(_vm.reading_device.type),callback:function ($$v) {_vm.$set(_vm.reading_device, "type", $$v)},expression:"reading_device.type"}},_vm._l((_vm.constants.SLIDE_PROJECTORS),function(s){return _c('v-radio',{key:s.id,staticClass:"ml-0",attrs:{"label":s.name,"value":s.id}})}),1)],1):_vm._e(),_vm._v(" "),((_vm.reading_device.category==='video_tape_recorder'))?_c('v-flex',[_c('v-radio-group',{staticClass:"flex xs12 mb-2",attrs:{"label":"Sub-Category"},model:{value:(_vm.reading_device.type),callback:function ($$v) {_vm.$set(_vm.reading_device, "type", $$v)},expression:"reading_device.type"}},_vm._l((_vm.constants.VIDEO_TAPE_RECORDERS),function(s){return _c('v-radio',{key:s.id,staticClass:"ml-0",attrs:{"label":s.name,"value":s.id}})}),1)],1):_vm._e(),_vm._v(" "),((_vm.reading_device.category==='other'))?_c('v-flex',[_c('v-text-field',{attrs:{"label":"Other"},model:{value:(_vm.reading_device.other),callback:function ($$v) {_vm.$set(_vm.reading_device, "other", $$v)},expression:"reading_device.other"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6 pr-3"},[_c('v-text-field',{attrs:{"label":"Brand"},model:{value:(_vm.reading_device.brand),callback:function ($$v) {_vm.$set(_vm.reading_device, "brand", $$v)},expression:"reading_device.brand"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6"},[_c('v-text-field',{attrs:{"label":"Type and Model"},model:{value:(_vm.reading_device.type_and_model),callback:function ($$v) {_vm.$set(_vm.reading_device, "type_and_model", $$v)},expression:"reading_device.type_and_model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{staticClass:"body-2"},[_vm._v("Date of Production")]),_vm._v(" "),_c('v-date-picker',{attrs:{"landscape":"","label":"Accession Date"},model:{value:(_vm.reading_device.production_date),callback:function ($$v) {_vm.$set(_vm.reading_device, "production_date", $$v)},expression:"reading_device.production_date"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 mt-5 mb-4"},[_c('h4',{staticClass:"body-2"},[_vm._v("Interfaces")]),_vm._v(" "),[_c('v-container',{staticClass:"py-0 px-0 mx-0 my-0",attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.constants.INTERFACES),function(s){return _c('v-flex',{key:s.id,attrs:{"xs6":"","sm4":"","md3":"","py-0":""}},[_c('v-checkbox',{staticClass:"ml-0 px-0",attrs:{"hide-details":"","label":s.name,"value":s.id},model:{value:(_vm.reading_device.interfaces),callback:function ($$v) {_vm.$set(_vm.reading_device, "interfaces", $$v)},expression:"reading_device.interfaces"}})],1)}),1)],1)]],2),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6 pr-3"},[_c('v-text-field',{attrs:{"label":"Number of Parts"},model:{value:(_vm.reading_device.number_of_parts),callback:function ($$v) {_vm.$set(_vm.reading_device, "number_of_parts", $$v)},expression:"reading_device.number_of_parts"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Power Requirement"},model:{value:(_vm.reading_device.power_requirement),callback:function ($$v) {_vm.$set(_vm.reading_device, "power_requirement", $$v)},expression:"reading_device.power_requirement"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Specifications on installation"},model:{value:(_vm.reading_device.installation_specifications),callback:function ($$v) {_vm.$set(_vm.reading_device, "installation_specifications", $$v)},expression:"reading_device.installation_specifications"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Modification"},model:{value:(_vm.reading_device.modification),callback:function ($$v) {_vm.$set(_vm.reading_device, "modification", $$v)},expression:"reading_device.modification"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Periphals"},model:{value:(_vm.reading_device.periphals),callback:function ($$v) {_vm.$set(_vm.reading_device, "periphals", $$v)},expression:"reading_device.periphals"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Associated items"},model:{value:(_vm.reading_device.associated_items),callback:function ($$v) {_vm.$set(_vm.reading_device, "associated_items", $$v)},expression:"reading_device.associated_items"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md3 pr-3"},[_c('v-text-field',{attrs:{"suffix":"cm","label":"Height"},model:{value:(_vm.reading_device.height),callback:function ($$v) {_vm.$set(_vm.reading_device, "height", $$v)},expression:"reading_device.height"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md3 pr-3"},[_c('v-text-field',{attrs:{"suffix":"cm","label":"Width"},model:{value:(_vm.reading_device.width),callback:function ($$v) {_vm.$set(_vm.reading_device, "width", $$v)},expression:"reading_device.width"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md3 pr-3"},[_c('v-text-field',{attrs:{"suffix":"cm","label":"Depth"},model:{value:(_vm.reading_device.depth),callback:function ($$v) {_vm.$set(_vm.reading_device, "depth", $$v)},expression:"reading_device.depth"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md3"},[_c('v-text-field',{attrs:{"suffix":"cm","label":"Weight"},model:{value:(_vm.reading_device.weight),callback:function ($$v) {_vm.$set(_vm.reading_device, "weight", $$v)},expression:"reading_device.weight"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 ml-3 mb-3"},[_c('v-btn',{on:{"click":_vm.save_reading_device}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_vm._v("cancel")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "6d6P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_artworks_MultiArtist_vue__ = __webpack_require__("u0d4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Images__ = __webpack_require__("lT+D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OwnershipHistory__ = __webpack_require__("QBky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ExhibitionHistory__ = __webpack_require__("WWEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LoanHistory__ = __webpack_require__("lKkF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CustomsHistory__ = __webpack_require__("BJgw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Packings__ = __webpack_require__("57cu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Selections__ = __webpack_require__("z8t4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Journals__ = __webpack_require__("MenD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Upload__ = __webpack_require__("e4A6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Conservation__ = __webpack_require__("SWdK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Todos__ = __webpack_require__("MNJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Tags__ = __webpack_require__("chLi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Texts__ = __webpack_require__("qGBU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Films__ = __webpack_require__("iuSU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Electrical__ = __webpack_require__("sHT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__NonElectrical__ = __webpack_require__("R4KG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ReadingDevices__ = __webpack_require__("54WG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Links__ = __webpack_require__("dpcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Timeline__ = __webpack_require__("vBUG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__data_full_user_fields__ = __webpack_require__("LKPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__EditField__ = __webpack_require__("b7zL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ReadField__ = __webpack_require__("O9GO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__PdfEh__ = __webpack_require__("+xQW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import ArtworkForm from './ArtworkForm'

// import FieldBox from './FieldBox'






// import { mapState } from 'vuex'

















// import ViewField from './ViewField'

// import * as qs from 'querystring'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      // gemini_check: "",
      snackbar: false,
      snackbarFieldName: '',
      snackbarColor: 'black',
      timeout: 4000,
      currentFields: [],
      selected: [],
      options: false,
      df2: [],
      fields: __WEBPACK_IMPORTED_MODULE_22__data_full_user_fields__["a" /* default */],
      artworkFormData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.artwork),
      editArtwork: false,
      // artwork: '',
      // result: "",
      currentTab: '',
      valid: true,
      film: {
        status: '',
        film_type: '',
        duration_min: '',
        duration_timecode: '',
        title: '',
        definition: '',
        color: '',
        sound: '',
        loop: '',
        language: '',
        subtitles: '',
        norm: '',
        aspect_ratio: '',
        fps: '',
        scan_type: '',
        vbr: '',
        file_size: '',
        audio: '',
        date_of_creation: '',
        film_controlling_master: '',
        film_controlling_archive_submaster: '',
        operator: '',
        controlling_date: '',
        controlling_software_2: '',
        controlling_software_1: '',
        operating_system: '',
        controlling_computer_2: '',
        controlling_computer_1: '',
        controling_device: '',
        format_migration_story: '',
        creation_date: ''
      }
    };
  },
  beforeMount: function beforeMount() {
    var _this = this;

    // console.log('----------------')
    // console.log(this.artwork)
    // console.log(this.$route.params.artwork);
    // console.log(this.$route.params.id);
    // this.gemini_check = this.artworkFormData.gemini_check;
    this.getArtwork();
    // console.log("----------------");
    if (!this.artwork) {
      // console.log('!this.artwork')
      if (this.$route.params.artwork) {
        // console.log('this.$route.params.artwork')
        this.artworkFormData = this.$route.params.artwork;
      } else {
        // console.log('ELSE this.$route.params.artwork')
        var result = this.$store.state.artworks.find(function (a) {
          return a.id === _this.$route.params.id;
        });
        this.artworkFormData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, result);
      }
    } else {
      // console.log('ELSE !this.artwork')
      this.artworkFormData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.artwork);
      // console.log(this.artworkFormData)
      // this.artwork = Object.assign({}, this.artwork);
      if (this.artwork.type_of_work_id === 0 || this.artwork.type_of_work_id == null) {
        // console.log('no type_of_work_id')
        this.setCurrentTab('basic');
        // this.currentTab = "basic";
      } else {
        if (this.$store.state.currentTab && this.c_user.roles && this.c_user.roles.find(function (f) {
          return f.shortcut === _this.$store.state.currentTab;
        })) {
          // console.log('before mount')
          // console.log(this.$store.state.currentTab.replace("tab-", ""));
          // console.log("before mount");
          this.setCurrentTab(this.$store.state.currentTab.replace('tab-', ''));
        } else {
          // console.log("before mount - ELSE@");
          this.setCurrentTab('basic');
          // this.currentTab = "basic";
        }
      }
    }
  },

  // beforeMount () {
  //   this.getArtwork()
  //   if (this.$route.params.artwork) {
  //     this.result = Object.assign({},this.$route.params.artwork)
  //   } else {
  //     this.result = this.$store.state.artworks.find(a => a.id == this.$route.params.id)
  //     this.artworkFormData = Object.assign({},this.$route.params.artwork)
  //     console.log('store')
  //   }
  //   this.artworkFormData = this.result
  //   this.setCurrentTab('basic')
  // },
  methods: {
    // toggleGemini(value_to_save) {
    //   // this.$emit("showSnackbar", "Saving Gemini check … ");
    //   // setTimeout(() => {
    //   let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`;
    //   axios
    //     .put(url, {
    //       field_name: "gemini_check",
    //       field_value: value_to_save,
    //       updated_by: this.c_user.id
    //     })
    //     .then(response => {
    //       // this.$emit("showSnackbar", "Gemini Check Saved.", "green");
    //       // this.progress = false;
    //       // this.isEditing = false;
    //       // this.$emit("getArtwork");
    //       this.getArtwork();
    //     })
    //     .catch(error => {
    //       this.$emit(
    //         "showSnackbar",
    //         "Error Saving  " + this.f_field.name,
    //         "red"
    //       );
    //       this.progress = false;
    //       this.isEditing = false;
    //     });
    //   // }, 1000);
    // },
    downloadEH: function downloadEH(a) {},
    showSnackbar: function showSnackbar(f, c) {
      var _this2 = this;

      // console.log("showSnackbar");
      // console.log(f);
      // console.log(c);
      this.snackbar = true;
      this.snackbarFieldName = f;
      if (c) {
        this.snackbarColor = c;
      }
      setTimeout(function () {
        _this2.snackbarColor = 'black';
      }, 5000);
    },
    show: function show(f) {
      if (this.df2.length === 0) {
        this.df2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.df);
      }
      // console.log(f)
      var i = this.df2.indexOf(f);
      // console.log(this.df2)
      this.df2.splice(i, 1);
      // console.log(i)
    },
    addToSelection: function addToSelection(a) {
      // console.log('a = ' + a)
      // setTimeout(function () {
      var tempSelection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(tempSelection)
      // if (!a) {
      // console.log('a true')
      if (!tempSelection.includes(a)) {
        // console.log('doesnt include')
        tempSelection.push(a);
      }
      // } else {
      // console.log('false')
      // var index = tempSelection.indexOf(a);
      // console.log('index = ' + index)
      // tempSelection.splice(index,1)
      // }
      // this.$store.state.currentSelection
      // console.log(tempSelection)
      // this.selected.forEach(s => {
      //   if (!tempSelection.includes(s)) {
      //     tempSelection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', tempSelection);
      // }.bind(this),1000)
    },
    verify_accession_no: function verify_accession_no() {
      return false;
    },
    setCurrentTab: function setCurrentTab(tab) {
      var _this3 = this;

      // console.log(tab)
      // console.log(this.fields.tabs['basic'])
      // console.log(this.field_list)
      if (this.fields.tabs[tab].fields) {
        var fields = this.fields.tabs[tab].fields;
        // console.log(fields)
        // console.log(this.artwork['classification'])

        // fields = fields.filter(f => f.edit_only === true)
        fields = fields.filter(function (f) {
          return f.work_types_new.some(function (wt) {
            return wt === _this3.artworkFormData['type_of_work_id'];
          });
        });
        this.currentFields = fields;
      }

      if (!this.currentFields) {
        this.currentFields = this.fields.tabs[tab];
      }
      // console.log("tab.substring");
      // console.log(tab.replace("tab-", ""));
      this.currentTab = tab;
      this.saveCurrentTab(tab);
      this.options_c = false;
    },
    saveCurrentTab: function saveCurrentTab(tab) {
      // setTimeout(function () {
      this.$store.dispatch('saveCurrentTab', tab);
      // }.bind(this),1000)
    },
    getArtwork: function getArtwork() {
      var _this4 = this;

      var url = this.$globals.apiserver + '/artworks/' + this.$route.params.id + '.json';
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url).then(function (response) {
        // this.result = response.data;
        // console.log('loading artwork')
        _this4.artworkFormData = response.data;
        // this.artwork = response.data
        // console.log(this.artworkFormData)
        _this4.df2 = _this4.df();
        // this.$store.dispatch("replaceArtwork", response.data);
        // if (this.$route.params.artwork) {
        //   this.result = this.$route.params.artwork;
        // } else {
        //   this.result = this.$store.state.artworks.find(
        //     a => a.id == this.$route.params.id
        //   );
        //   this.artworkFormData = this.result;
        // }
        if (_this4.artworkFormData.type_of_work_id === 0 || _this4.artworkFormData.type_of_work_id == null) {
          _this4.currentTab = 'basic';
        } else {
          if (_this4.$store.state.currentTab) {
            _this4.setCurrentTab(_this4.$store.state.currentTab.replace('tab-', ''));
          } else {
            _this4.currentTab = 'basic';
          }
        }
      }).catch(function (error) {
        _this4.artworkFormData = {
          id: _this4.$route.params.id,
          title: 'Artwork not found',
          type_of_work_id: 2
          // console.log(error)
        };
      });
      // if(this.$store.state.currentTab) {
      //   console.log('before mount')
      //   console.log(this.$store.state.currentTab.replace('tab-',''))
      //   this.setCurrentTab(this.$store.state.currentTab);
      // } else {
      //   this.setCurrentTab("basic");
      // }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },

    // submit() {
    //   const art = this.artworkFormData;
    //   const requestConfig = {
    //     url: `http://www.tb-cms.org/artworks/api_update/${this.$route.params.id}`,
    //     method: "POST",
    //     data: qs.stringify(art)
    //   };
    //   const response = axios.request(requestConfig);
    // },
    df: function df() {
      // var c = []
      // var b = []
      var x = [];
      var fields2 = [];
      fields2 = fields2.concat(__WEBPACK_IMPORTED_MODULE_22__data_full_user_fields__["a" /* default */]['tabs']['basic']['fields']);
      // console.log(fields2)
      fields2 = fields2.concat(__WEBPACK_IMPORTED_MODULE_22__data_full_user_fields__["a" /* default */]['tabs']['advanced']['fields']);
      // console.log(fields2)
      fields2 = fields2.concat(__WEBPACK_IMPORTED_MODULE_22__data_full_user_fields__["a" /* default */]['tabs']['acquisition']['fields']);
      // console.log(fields2)
      // console.log('fields2')
      // var fields2 = Object.values(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification])
      // console.log('test')
      // if (fields2.length > 0) {
      // var class_fields = fields2[this.f_artwork.classification]
      // c = fields2.filter(f => (f.dynamic && f.work_types && f.work_types.includes(this.artworkFormData.classification)))
      // console.log(c.length)
      // b = c.filter(f => (this.artworkFormData[f.name] == null || this.artworkFormData[f.name] == undefined || this.artworkFormData[f.name] == '') )
      // console.log(b.length)
      // b = b.map(f => f.name)
      // console.log(c)
      // console.log(b)
      // setTimeout(function () {
      // console.log(fields2)
      // console.log(this.artworkFormData.classification)
      for (var f in fields2) {
        // console.log(fields2[f].name)
        // console.log(fields2[f].dynamic)
        // console.log(this.artworkFormData[fields2[f].name])
        if (fields2[f].dynamic && fields2[f].work_types_new && fields2[f].work_types_new.includes(this.artworkFormData.type_of_work_id) && (this.artworkFormData[fields2[f].name] == null || this.artworkFormData[fields2[f].name] === undefined || this.artworkFormData[fields2[f].name] === '')) {
          // console.log(fields2[f])
          x.push(fields2[f].name);
        }
      }
      // }.bind(this),4000)
      // console.log(x)
      // console.log(this.artworkFormData.classification)
      // c = c.filter(f => (f.work_types && f.work_types.includes(this.artwork.classification)))
      // console.log(c)
      // }
      // console.log(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification].filter(f => f.dynamic))
      return x;
    },
    goToNextTab: function goToNextTab() {
      var _this5 = this;

      if (this.hasNextTab) {
        var ct = this.user_tabs.find(function (t) {
          return t.key === _this5.currentTab;
        });
        // console.log('ct')
        if (ct) {
          // console.log(this.user_tabs.indexOf(ct))
          this.setCurrentTab(this.user_tabs[this.user_tabs.indexOf(ct) + 1].key);
        } else {
          return null;
        }
        // this.saveCurrentTab(this.user_tabs[this.user_tabs.indexOf(ct) + 1].key);
      } else {
        return null;
      }
    },
    goToPreviousTab: function goToPreviousTab() {
      var _this6 = this;

      if (this.hasPreviousTab) {
        var ct = this.user_tabs.find(function (t) {
          return t.key === _this6.currentTab;
        });
        // console.log('ct')
        if (ct) {
          // console.log(this.user_tabs.indexOf(ct))
          this.setCurrentTab(this.user_tabs[this.user_tabs.indexOf(ct) - 1].key);
        } else {
          return null;
        }
        // this.saveCurrentTab(this.user_tabs[this.user_tabs.indexOf(ct) - 1].key);
        // this.setCurrentTab(this.user_tabs[this.user_tabs.indexOf(this.currentTab) - 1].key);
      } else {
        return null;
      }
    }
  },
  computed: {
    // lists all enabled field names - good for checking if fields exists in database
    // all_field_names() {
    //   var o = [];
    //   for (var t in this.fields["tabs"]) {
    //     console.log(t)
    //     for (var f in this.fields["tabs"][t]["fields"]) {
    //       console.log(f)
    //       if (!this.fields["tabs"][t]["fields"][f].component && !this.fields["tabs"][t]["fields"][f].headline && !this.fields["tabs"][t]["fields"][f].subheadline) {
    //         o.push(this.fields["tabs"][t]["fields"][f].name)
    //       }
    //     }
    //   }
    //   return o
    // },
    hasNextTab: function hasNextTab() {
      var _this7 = this;

      var ct = this.user_tabs.find(function (t) {
        return t.key === _this7.currentTab;
      });
      return this.user_tabs.length > this.user_tabs.indexOf(ct) + 1;
    },
    hasPreviousTab: function hasPreviousTab() {
      var _this8 = this;

      var ct = this.user_tabs.find(function (t) {
        return t.key === _this8.currentTab;
      });
      return this.user_tabs.indexOf(ct) !== 0;
    },
    user_tabs: function user_tabs() {
      var _this9 = this;

      var newf = [];
      // console.log('user_tabs')
      // console.log(this.c_user.roles)
      // console.log(this.fields.tabs["basic"]);
      // // console.log(tab.work_types)
      // console.log(this.artworkFormData.classification)
      // console.log('test1')
      var ar;
      if (this.artwork) {
        // console.log('///////////this.artwork')
        ar = this.artwork;
      } else {
        // console.log('no this.artwork')
        if (this.$route.params.artwork) {
          // console.log('this.$route.params.artwork')
          ar = this.$route.params.artwork;
        } else {
          // console.log('NO this.$route.params.artwork')
          ar = this.$store.state.artworks.find(function (a) {
            return a.id === _this9.$route.params.id;
          });
          // this.artworkFormData = this.result;
        }
      }
      if (!ar) {
        ar = this.artworkFormData;
      }
      // console.log('----------------2');
      // console.log(this.artwork);
      // console.log(this.$route.params.artwork);
      // console.log(this.$route.params.id);
      // console.log(ar)
      // console.log('----------------2');
      if (ar) {
        if (ar.type_of_work_id === 0 || ar.type_of_work_id == null) {
          return [this.fields.tabs['basic']];
        } else {
          for (var tab in this.fields.tabs) {
            if (this.c_user.roles && this.c_user.roles.find(function (f) {
              return f.shortcut === _this9.fields.tabs[tab].role;
            }) && this.fields.tabs[tab].work_types_new && this.fields.tabs[tab].work_types_new.includes(ar.type_of_work_id)) {
              newf.push(this.fields.tabs[tab]);
            }
          }
        }
      }
      return newf;
    },

    // c_user() {
    //   return this.$store.state.user.profile;
    // },
    options_c: {
      get: function get() {
        return this.$store.state.options;
      },
      set: function set(value) {
        this.$store.dispatch('saveOptions', value);
      }
    },
    currentTabShown: function currentTabShown() {
      // console.log('currentTabShown')
      // console.log(this.currentTab)
      // console.log(fields.tabs[this.currentTab])
      return __WEBPACK_IMPORTED_MODULE_22__data_full_user_fields__["a" /* default */].tabs[this.currentTab];
    },
    df3: function df3() {
      // var c = []
      var b = [];
      var x = [];
      var fields2 = [];
      fields2 = fields2.concat(__WEBPACK_IMPORTED_MODULE_22__data_full_user_fields__["a" /* default */]['tabs']['basic']['fields']);
      // console.log(fields2)
      fields2 = fields2.concat(__WEBPACK_IMPORTED_MODULE_22__data_full_user_fields__["a" /* default */]['tabs']['advanced']['fields']);
      // console.log(fields2)
      fields2 = fields2.concat(__WEBPACK_IMPORTED_MODULE_22__data_full_user_fields__["a" /* default */]['tabs']['acquisition']['fields']);
      // console.log(fields2)
      // console.log('fields2')
      // var fields2 = Object.values(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification])
      // console.log('test')
      // if (fields2.length > 0) {
      // var class_fields = fields2[this.f_artwork.classification]
      // c = fields2.filter(f => (f.dynamic && f.work_types && f.work_types.includes(this.artworkFormData.classification)))
      // console.log(c.length)
      // b = c.filter(f => (this.artworkFormData[f.name] == null || this.artworkFormData[f.name] == undefined || this.artworkFormData[f.name] == '') )
      // console.log(b.length)
      // b = b.map(f => f.name)
      // console.log(c)
      // console.log(b)
      // setTimeout(function () {
      // console.log(fields2)
      for (var f in fields2) {
        // console.log(fields2[f].name)
        // console.log(this.artworkFormData[fields2[f].name])
        if (fields2[f].dynamic && f.work_types_new && fields2[f].work_types_new.includes(this.artworkFormData.type_of_work_id) && (this.artworkFormData[fields2[f].name] == null || this.artworkFormData[fields2[f].name] === undefined || this.artworkFormData[fields2[f].name] === '')) {
          // console.log(fields2[f])
          x.push(f.name);
        }
      }
      // }.bind(this),4000)
      // console.log(x)
      // console.log(this.artworkFormData.classification)
      // c = c.filter(f => (f.work_types && f.work_types.includes(this.artwork.classification)))
      // console.log(c)
      // }
      // console.log(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification].filter(f => f.dynamic))
      return b;
    },
    field_list: function field_list() {
      var _this10 = this;

      // console.log(this.fields['tabs'].find(t => t.key == this.currentTab))
      // return this.fields['tabs'].find(t => t.key == this.currentTab)
      if (!this.fields['tabs'][this.currentTab.substr(4)].component) {
        // var current_user = { role: 'admin' }
        // var work_type = 'pppd'
        var out = [];
        var fields2 = __WEBPACK_IMPORTED_MODULE_22__data_full_user_fields__["a" /* default */]['tabs'][this.currentTab.substr(4)]['fields'];
        out = fields2.filter(function (f, i) {
          return f.work_types_new && f.work_types_new.includes(_this10.artworkFormData.type_of_work_id);
        });
        return out;
      } else {
        return [];
      }
    }
  },
  components: {
    Timeline: __WEBPACK_IMPORTED_MODULE_21__Timeline__["a" /* default */],
    ReadField: __WEBPACK_IMPORTED_MODULE_24__ReadField__["a" /* default */],
    EditField: __WEBPACK_IMPORTED_MODULE_23__EditField__["a" /* default */],
    Images: __WEBPACK_IMPORTED_MODULE_2__Images__["a" /* default */],
    ExhibitionHistory: __WEBPACK_IMPORTED_MODULE_4__ExhibitionHistory__["a" /* default */],
    CustomsHistory: __WEBPACK_IMPORTED_MODULE_6__CustomsHistory__["a" /* default */],
    LoanHistory: __WEBPACK_IMPORTED_MODULE_5__LoanHistory__["a" /* default */],
    MultiArtist: __WEBPACK_IMPORTED_MODULE_1__components_artworks_MultiArtist_vue__["a" /* default */],
    Packings: __WEBPACK_IMPORTED_MODULE_8__Packings__["a" /* default */],
    Selections: __WEBPACK_IMPORTED_MODULE_9__Selections__["a" /* default */],
    Journals: __WEBPACK_IMPORTED_MODULE_10__Journals__["a" /* default */],
    Upload: __WEBPACK_IMPORTED_MODULE_11__Upload__["a" /* default */],
    Todos: __WEBPACK_IMPORTED_MODULE_13__Todos__["a" /* default */],
    Tags: __WEBPACK_IMPORTED_MODULE_14__Tags__["a" /* default */],
    Texts: __WEBPACK_IMPORTED_MODULE_15__Texts__["a" /* default */],
    Films: __WEBPACK_IMPORTED_MODULE_16__Films__["a" /* default */],
    Electrical: __WEBPACK_IMPORTED_MODULE_17__Electrical__["a" /* default */],
    ReadingDevices: __WEBPACK_IMPORTED_MODULE_19__ReadingDevices__["a" /* default */],
    OwnershipHistory: __WEBPACK_IMPORTED_MODULE_3__OwnershipHistory__["a" /* default */],
    Links: __WEBPACK_IMPORTED_MODULE_20__Links__["a" /* default */],
    NonElectrical: __WEBPACK_IMPORTED_MODULE_18__NonElectrical__["a" /* default */],
    PdfEh: __WEBPACK_IMPORTED_MODULE_25__PdfEh__["a" /* default */],
    Conservation: __WEBPACK_IMPORTED_MODULE_12__Conservation__["a" /* default */]
  }
});

/***/ }),

/***/ "6gSs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabelsSmallText_vue__ = __webpack_require__("/vtv");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bde5ec98_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabelsSmallText_vue__ = __webpack_require__("CVtG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("bXxC")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bde5ec98"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabelsSmallText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bde5ec98_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabelsSmallText_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bde5ec98_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabelsSmallText_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "6jOY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mx-4 px-3"},[_c('v-card',{staticClass:"mx-0 elevation-0"},[_c('v-card-title',{staticClass:"mx-0 px-0 right"},[_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){return _vm.$router.push({ name: 'AddArticle', path: '/articles/new' })}}},[_vm._v("Add Article\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.$store.state.showSearch)?_c('v-text-field',{attrs:{"append-icon":"search","label":"Search ","single-line":"","hide-details":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.headers,"items":_vm.articles,"hide-actions":"","item-key":"id","loading":"true","search":_vm.search},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{attrs:{"active":props.selected},on:{"click":function($event){props.selected = !props.selected}}},[_c('td',[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.group))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.publish_date))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.version))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.at_work))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.updates))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.help))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{attrs:{"to":{
                name: 'EditArticle',
                params: { id: props.item.id, editedItem: props.item },
                path: ("/articles/edit/" + (props.item.id)),
              },"icon":""}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v(" edit ")])],1)],1)])]}}])})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "6tmr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-0",attrs:{"small":_vm.small,"light":_vm.light,"loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.pdfSoloCall.apply(null, arguments)}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":_vm.small}},[_vm._v("mdi-file-pdf")]),_vm._v(" Solo Ext")],1)}
var staticRenderFns = []


/***/ }),

/***/ "6u99":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6wHJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-2"},[(_vm.table_artworks.length > 0)?_c('v-list',{staticClass:"mx-0 px-0 mb-2"},[_vm._l((_vm.table_artworks),function(item,index){return [_c('v-list-tile',{key:item.id,staticStyle:{"height":"17px"}},[_c('v-list-tile-content',{staticClass:"ml-0 pl-0"},[_c('v-list-tile-sub-title',[_c('router-link',{staticStyle:{"width":"70px"},attrs:{"to":{
                name: 'EditArtwork',
                params: { id: item.id, artwork: item },
                path: ("/artworks/edit/" + (item.id))
              }}},[_vm._v("\n              "+_vm._s(index + 1)+".\n              ")]),_vm._v("\n            "+_vm._s(item.title)+" ["+_vm._s(item.accession_number)+"]\n            ")],1)],1)],1)]})],2):[_c('p',{staticClass:"my-0 mx-0 px-0 text-xs-left align-left justify-left"},[_vm._v("\n      No Artworks\n    ")])]],2)}
var staticRenderFns = []


/***/ }),

/***/ "720i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artist', 'artworks'],
  computed: {
    table_artworks: function table_artworks() {
      var _this = this;

      console.log('this.artworks');
      console.log(this.artworks);
      // console.log(this.artworks.map(am => am.id))
      // console.log(this.$store.state.artworks.filter(a => (this.artworks.map(am => am.id)).includes(a.id)))
      return this.$store.state.artworks.filter(function (a) {
        return _this.artworks.includes(a.id);
      });
    }
  },
  methods: {
    artist_artworks: function artist_artworks(artist_id) {
      var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
      // console.log('artist_id')
      // console.log(artist_id)
      // console.log(a.artist_id == artist_id)
      var aa = a.filter(function (a) {
        // console.log('a.artist_id')
        // console.log(a.artist_id)
        // console.log(artist_id)
        return a.artist_id === artist_id;
      });
      // console.log(aa)
      return aa;
    },
    clear_selection: function clear_selection() {
      this.$store.dispatch('clearCurrentSelection');
      this.selected = [];
    },
    select_all: function select_all() {},
    save_currently_selected: function save_currently_selected(a, b) {
      // console.log('///////////')
      // console.log('a = ' + a)
      // console.log('b = ' + b.id)
      setTimeout(function () {
        var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
        //// console.log(temp_selection)
        if (!a) {
          // console.log('a true')
          if (!temp_selection.includes(b)) {
            // console.log('doesnt include')
            temp_selection.push(b);
          }
        } else {
          // console.log('false')
          var index = temp_selection.indexOf(b);
          // console.log('index = ' + index)
          temp_selection.splice(index, 1);
        }
        // this.$store.state.currentSelection
        // console.log(temp_selection)
        // this.selected.forEach(s => {
        //   if (!temp_selection.includes(s)) {
        //     temp_selection.push(s)
        //   }
        // })
        // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
        this.$store.dispatch('saveCurrentSelection', temp_selection);
      }.bind(this), 1000);
    },
    save_currently_selected_all: function save_currently_selected_all(a) {
      // console.log('///////////')
      // console.log('a = ' + a)
      var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(temp_selection)
      if (!a) {
        // console.log('a true')
        if (!temp_selection.includes(b)) {
          // console.log('doesnt include')
          temp_selection.push(b);
        }
      } else {
        // console.log('false')
        var index = temp_selection.indexOf(b);
        // console.log('index = ' + index)
        temp_selection.splice(index, 1);
      }
      // this.$store.state.currentSelection
      // console.log(temp_selection)
      // this.selected.forEach(s => {
      //   if (!temp_selection.includes(s)) {
      //     temp_selection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', temp_selection);
    },
    save_currently_selected_tags: function save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags);
      this.ta = this.tagged_artworks;
    }
  }
});

/***/ }),

/***/ "72y9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagFilter_vue__ = __webpack_require__("lE9Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed00432_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagFilter_vue__ = __webpack_require__("yzwb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("YJbu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ed00432"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TagFilter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed00432_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagFilter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed00432_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TagFilter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "75l9":
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),

/***/ "79ZT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.c_user.edit || !_vm.field.edit_only)?_c('div',{staticClass:"mt-4"},[(_vm.artwork)?_c('v-dialog',{model:{value:(_vm.previewDialog),callback:function ($$v) {_vm.previewDialog=$$v},expression:"previewDialog"}},[_c('v-card',[(_vm.previewDialog && _vm.isImage(_vm.prieviewFile.fname))?_c('v-img',{staticClass:"grey lighten-2",attrs:{"src":((_vm.$globals.fileserver) + "/send_file_auth?path=/data/" + (_vm.prieviewFile.category) + "/" + (_vm.prieviewFile.artwork_id) + "/" + (_vm.prieviewFile.fname) + "&dtoken=IZcomzYtIPKvPPQWuyENLKmVkeNclv1e5"),"contain":""},on:{"click":_vm.closePreviewDialog},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-layout',{attrs:{"fill-height":"","align-center":"","justify-center":"","ma-0":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)]},proxy:true}],null,false,1258913907)}):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.download_rights)?_c('v-flex',{staticClass:"mt-2 mx-0 px-0 mb-4 py-0 elevation-0 xs12"},[_c('v-flex',{staticClass:"white--text text-uppercase body-2 elevation-0 mx-1",staticStyle:{"background-color":"#392939","border-radius":"25px","height":"30px"}},[_c('v-btn',{staticClass:"hidden-xs-only mt-1",attrs:{"icon":"","small":""},on:{"click":function($event){_vm.showUpload = !_vm.showUpload}}},[_c('v-icon',{attrs:{"color":!_vm.files || _vm.files.length == 0 ? 'red' : 'white',"small":""}},[_vm._v("cloud")])],1),_vm._v(" "),_c('span',{staticClass:"ml-0 pl-0"},[_vm._v(_vm._s(_vm.field.title)+" ")]),_vm._v(" "),(_vm.files && _vm.files.length > 0)?_c('span',[_vm._v("("+_vm._s(_vm.files ? _vm.files.length : 0)+" uploaded)")]):_vm._e(),_vm._v(" "),(_vm.files && _vm.files.length > 0)?_c('v-btn',{staticClass:"right mt-1 pt-0 mb-0 nounderline",attrs:{"icon":"","small":""},on:{"click":function($event){_vm.showUpload = !_vm.showUpload}}},[(!_vm.showUpload)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.showUpload)?_c('v-icon',{attrs:{"color":"white"}},[_vm._v("expand_less")]):_vm._e()],1):(_vm.upload_rights)?_c('v-btn',{staticClass:"black--text right mt-1 mr-1 mb-0 nounderline px-3 xs12",staticStyle:{"text-decoration":"none !important","background-color":"#392939"},attrs:{"round":"","target":"_blank","small":"","flat":"","href":((_vm.$globals.fileserver) + "/upload_files.html?id=" + _vm.upload_relation_id + "&category=" + _vm.categoryC + "&u=" + (_vm.c_user.id)),"color":"white","rel":"noopener noreferrer"}},[_c('v-icon',{staticClass:"nounderline mr-2",attrs:{"small":"","color":"white"}},[_vm._v("cloud_upload")]),_vm._v("\n        Upload New\n      ")],1):_vm._e()],1),_vm._v(" "),(_vm.showUpload)?_c('v-layout',{staticClass:"mt-0",staticStyle:{"background-color":"","color":"#fff"},attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-list',{staticClass:"mt-0 pl-0 xs12 elevation-0",staticStyle:{"background-color":"#efefef","color":"#fff"}},_vm._l((_vm.files),function(f){return _c('v-list-tile',{key:f.id,staticClass:"py-0 my-0 mx-0 px-0",staticStyle:{"border-bottom":"1px solid #b9a9b9"},attrs:{"avatar":""}},[_c('v-list-tile-avatar',{staticClass:"pl-0 ml-0"},[(_vm.isImage(f.fname))?_c('v-icon',{attrs:{"medium":"","color":"#392939"}},[_vm._v("photo")]):(
                  ['PDF', 'pdf'].includes(f.fname.substr(f.fname.length - 3))
                )?_c('v-icon',{attrs:{"color":"red","medium":""}},[_vm._v("mdi-file-pdf")]):(
                  [
                    'OCX',
                    'ocx',
                    'DOC',
                    'doc',
                    'rtf',
                    'RTF',
                    'txt',
                    'TXT' ].includes(f.fname.substr(f.fname.length - 3))
                )?_c('v-icon',{attrs:{"color":"#392939","medium":""}},[_vm._v("mdi-file-document")]):(
                  ['LSX', 'lsx', 'XLS', 'xls'].includes(
                    f.fname.substr(f.fname.length - 3)
                  )
                )?_c('v-icon',{attrs:{"color":"black","medium":""}},[_vm._v("mdi-file-document")]):(
                  ['AVI', 'avi', 'MOV', 'mov'].includes(
                    f.fname.substr(f.fname.length - 3)
                  )
                )?_c('v-icon',{attrs:{"color":"#392939","medium":""}},[_vm._v("theaters")]):(
                  ['WMA', 'wma'].includes(f.fname.substr(f.fname.length - 3))
                )?_c('v-icon',{attrs:{"color":"#392939","medium":""}},[_vm._v("mdi-film")]):(
                  ['ZIP', 'zip'].includes(f.fname.substr(f.fname.length - 3))
                )?_c('v-icon',{attrs:{"color":"#392939","medium":""}},[_vm._v("mdi-folder-zip")]):(
                  ['EML', 'eml'].includes(f.fname.substr(f.fname.length - 3))
                )?_c('v-icon',{attrs:{"color":"#392939","medium":""}},[_vm._v("mdi-email")]):(
                  ['NDD', 'ndd'].includes(f.fname.substr(f.fname.length - 3))
                )?_c('v-icon',{attrs:{"color":"#392939","medium":""}},[_vm._v("description")]):_c('v-icon',{attrs:{"color":"red","medium":""}},[_vm._v("help-center")])],1),_vm._v(" "),_c('v-list-tile-content',[(_vm.c_user.roles.find(function (f) { return f.shortcut == 'file_d'; }))?_c('v-list-tile-title',[_c('a',{staticStyle:{"font-weight":"500","color":"#392939"},attrs:{"href":((_vm.$globals.fileserver) + "/send_file_auth?path=/data/" + (f.category) + "//" + (f.artwork_id) + "/" + (f.fname) + "&dtoken=IZcomzYtIPKvPPQWuyENLKmVkeNclv1e5"),"download":f.fname,"target":"_blank"}},[_vm._v(_vm._s(f.name ? f.name : f.fname))])]):_c('v-list-tile-title',[_vm._v(_vm._s(f.fname))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"font-weight":"500","color":"#392939"}},[_vm._v("\n                Uploaded\n                "+_vm._s(new Date(f.created_at).toLocaleDateString('en-US'))+"\n                "),(f.uploaded_by > 0)?_c('span',[_vm._v("by "+_vm._s(_vm.get_abb(f.uploaded_by))+"\n                ")]):_vm._e()])],1),_vm._v(" "),_c('v-list-tile-action',{staticClass:"mr-0 pr-0 text-xs-right"},[_c('v-flex',{staticClass:"mr-0 pr-0",attrs:{"layout":""}},[(_vm.isImage(f.fname))?_c('v-flex',{staticClass:"mr-3"},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.view(f)}}},[_c('v-icon',{attrs:{"color":"#392939"}},[_vm._v("visibility")])],1)],1):_vm._e(),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-flex',{staticClass:"mr-0 pr-0"},[_c('v-btn',{staticClass:"mr-0 pr-0",attrs:{"icon":""},on:{"click":function($event){return _vm.delete_file(f.id)}}},[_c('v-icon',{attrs:{"color":"#392939"}},[_vm._v("delete")])],1)],1):_vm._e()],1)],1)],1)}),1),_vm._v(" "),(_vm.upload_rights)?_c('v-btn',{staticClass:"white--text right mt-0 mr-4 mb-2 px-3 xs12 nounderline",attrs:{"small":"","round":"","target":"_blank","href":((_vm.$globals.fileserver) + "/upload_files.html?id=" + _vm.upload_relation_id + "&category=" + _vm.categoryC + "&u=" + (_vm.c_user.id)),"color":"#392939","text--color":"","rel":"noopener noreferrer"}},[_c('v-icon',{staticClass:"mr-2 nounderline",attrs:{"small":"","color":"white"}},[_vm._v("cloud_upload")]),_vm._v("\n          Upload New\n        ")],1):_vm._e()],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.artwork)?_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Do you really want to delete this file?")]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"headline pt-2"},[_vm._v(_vm._s(_vm.file_to_delete.fname))]),_vm._v(" "),_c('br'),_vm._v("uploaded by\n        "),(_vm.file_to_delete.uploaded_by)?_c('b',[_vm._v(_vm._s(_vm.get_abb(_vm.file_to_delete.uploaded_by)))]):_vm._e(),_vm._v(" "),_c('br'),_vm._v("on\n        "),_c('b',[_vm._v(_vm._s(_vm.file_to_delete.created_at))]),_vm._v(" "),_c('br'),_vm._v("for artwork\n        "),_c('b',[_vm._v(_vm._s(_vm.artwork.title))]),_vm._v(" "),_c('br'),_vm._v("by artist\n        "),_c('b',[_vm._v(_vm._s(_vm.artwork.artist ? _vm.artwork.artist.name : 'no artist'))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","flat":""},on:{"click":_vm.deleteItem}},[_vm._v("Yes")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green","flat":""},on:{"click":_vm.cancelDelete}},[_vm._v("No")])],1)],1)],1):_vm._e()],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "7EMl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Costs_vue__ = __webpack_require__("TOgl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88abb35e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Costs_vue__ = __webpack_require__("Wv9D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("lPLT")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-88abb35e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Costs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88abb35e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Costs_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88abb35e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Costs_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7IY2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-snackbar',{attrs:{"auto-height":"","color":_vm.sColor,"timeout":_vm.sTimeout,"dismissible":"","right":"","top":"","vertical":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.humanize(_vm.sText))+"\n    "),_c('router-link',{directives:[{name:"show",rawName:"v-show",value:(_vm.sPath),expression:"sPath"}],staticClass:"my-3",attrs:{"to":{ params: _vm.sParams, path: _vm.sPath }}},[_vm._v(_vm._s(_vm.sTextLink))]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.sPath),expression:"sPath"}],attrs:{"flat":"","small":"","icon":""},on:{"click":function($event){return _vm.$router.push({ params: _vm.sParams, path: _vm.sPath })}}},[_c('v-icon',{attrs:{"color":"black","small":""}},[_vm._v("add")])],1)],1),_vm._v(" "),_c('location-change-dialog',{attrs:{"showDialog":_vm.show_change_location_dialog,"selected":_vm.selected},on:{"hideDialog":function($event){_vm.show_change_location_dialog = !_vm.show_change_location_dialog}}}),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"700px"},model:{value:(_vm.selections_dialog),callback:function ($$v) {_vm.selections_dialog=$$v},expression:"selections_dialog"}},[_c('v-card',{staticClass:"round mx-0",staticStyle:{"width":"700px"},attrs:{"elevation-0":""}},[_c('v-card-title',[_c('span',{staticClass:"title font-weight-light ml-3"},[_vm._v("Saved Artwork Selections")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){_vm.selections_dialog = false}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"mx-3 mt-0 pt-0"},[_c('v-text-field',{attrs:{"append-icon":"search","label":"Filter by Selection Names, Creation Date or No. of Artworks","single-line":"","hide-details":"","clearable":""},model:{value:(_vm.selectionSearch),callback:function ($$v) {_vm.selectionSearch=$$v},expression:"selectionSearch"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0",attrs:{"headers":_vm.listHeaders,"items":_vm.selections,"pagination":_vm.ps,"must-sort":"","item-key":"id","loading":"true","no-results-text":"No matching Selection found.","search":_vm.selectionSearch},on:{"update:pagination":function($event){_vm.ps=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',{staticStyle:{}},_vm._l((props.headers),function(header){return _c('th',{key:header.text,class:[
                'column sortable',
                _vm.ps.descending ? 'desc' : 'asc',
                header.value === _vm.ps.sortBy ? 'active' : '',
                ("text-xs-" + (header.align)),
                'pl-2 pr-4 my-0 py-0' ],attrs:{"align":props.align},on:{"click":function($event){return _vm.changeSortSelection(header.value)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("arrow_upward")]),_vm._v(" "),_c('span',{staticClass:"pr-2 pl-1"},[_vm._v(_vm._s(header.text))])],1)}),0)]}},{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticClass:"mx-0 px-0",attrs:{"colspan":"3"}},[_c('v-layout',{staticClass:"px-2 mt-3 pb-2 no-wrap",staticStyle:{"width":"675px"}},[_c('span',{staticClass:"\n                    title\n                    font-weight-light\n                    px-4\n                    no-wrap\n                    text-uppercase text-truncate\n                  "},[_vm._v(_vm._s(props.item.name)+" "+_vm._s(props.item.title)+" ["+_vm._s(props.item.artworks.length)+"]")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"ml-0 text-xs-right pl-0 no-wrap"},[_vm._v(_vm._s(_vm.format_date(props.item.created_at)))])],1),_vm._v(" "),_c('v-layout',{staticClass:"px-4 pb-2"},[_c('v-tooltip',{staticClass:"mr-3",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"black","icon":"","small":""},on:{"click":function($event){return _vm.loadSelection(props.item.artworks)}}},on),[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("apps")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Replace Current Selection with this saved Selection")])]),_vm._v(" "),_c('v-tooltip',{staticClass:"mr-3",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"black","icon":"","small":""},on:{"click":function($event){return _vm.addToSelection(props.item.artworks)}}},on),[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("add")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Add Artworks in this Selection to current Selection")])]),_vm._v(" "),_c('list-action-menu',{attrs:{"item":props.item,"ids":""}}),_vm._v(" "),_c('v-tooltip',{staticClass:"mr-3",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [(_vm.c_user.edit || _vm.c_user.delete_rights)?_c('v-btn',_vm._g({staticClass:"ml-4",attrs:{"icon":"","color":"red","small":"","outline":""},on:{"click":function($event){return _vm.removeFromSelections(props.item)}}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("delete")])],1):_vm._e()]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Delete Selection")])])],1)],1)])]}}])},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-alert',{attrs:{"value":true,"color":"error","icon":"warning"}},[_c('v-btn',{on:{"click":function($event){return _vm.reload_data('Lists')}}},[_vm._v("No Selection loaded, click here to load from the server.")])],1)],1)],2)],1)],1),_vm._v(" "),(_vm.isAuthenticated)?_c('v-toolbar',{staticClass:"pt-2 pb-0 elevation-0 white mb-0 px-2",attrs:{"app":"","extended":""},scopedSlots:_vm._u([{key:"extension",fn:function(){return [_c('v-layout',{attrs:{"row":"","wrap":"","pt-0":"","pb-0":"","my-0":"","mx-0":""}},[_c('v-flex',{staticClass:"px-0 mb-2 mx-0",attrs:{"xs12":""}},[_c('v-divider',{staticClass:"mx-0 my-0 py-0 black hidden-xs-only"})],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left mx-0 pl-2 my-0",staticStyle:{"padding-left":"3px"},attrs:{"xs3":""}},[_c('a',{staticClass:"\n              font-weight-regular\n              display-1\n              black--text\n              hidden-sm-and-down\n            ",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}},[_vm._v("Menu")]),_vm._v(" "),_c('a',{staticClass:"font-weight-regular hidden-md-and-up",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}},[_c('v-icon',{staticClass:"mt-2",attrs:{"color":"black"}},[_vm._v("menu")])],1)]),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-left px-0 mt-0 mx-0 pt-0",attrs:{"xs3":""}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearchButton),expression:"showSearchButton"}],staticClass:"\n              font-weight-regular\n              display-1\n              black--text\n              hidden-sm-and-down\n            ",on:{"click":function($event){$event.stopPropagation();return _vm.setShowSearch()}}},[_vm._v("Search")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearchButton),expression:"showSearchButton"}],staticClass:"font-weight-regular hidden-md-and-up",on:{"click":function($event){$event.stopPropagation();return _vm.setShowSearch()}}},[_c('v-icon',{staticClass:"mt-2",attrs:{"color":"black"}},[_vm._v("search")])],1)]),_vm._v(" "),_c('v-flex',{staticClass:"\n            text-xs-right\n            px-0\n            mx-0\n            pt-0\n            text-truncate\n            hidden-sm-and-down\n          ",attrs:{"xs3":""}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showViewButton),expression:"showViewButton"}],staticClass:"font-weight-regular display-1 black--text",on:{"click":function($event){$event.stopPropagation();return _vm.switchView()}}},[_vm._v(_vm._s(_vm.view == 'gallery' ? 'List' : 'Gallery')+" View")])]),_vm._v(" "),_c('v-layout',{staticClass:"justify-end xs3 text-xs-right px-1 mx-0 pt-0': true"},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOptionsButton),expression:"showOptionsButton"}],staticClass:"\n              font-weight-regular\n              display-1\n              black--text\n              hidden-sm-and-down\n            ",on:{"click":function($event){$event.stopPropagation();return _vm.showOptions()}}},[_vm._v("Options")]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOptionsButton),expression:"showOptionsButton"}],staticClass:"font-weight-regular hidden-md-and-up",on:{"click":function($event){$event.stopPropagation();return _vm.showOptions()}}},[_c('v-icon',{staticClass:"mt-2",attrs:{"color":"black"}},[_vm._v("settings")])],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSortButton),expression:"showSortButton"}],staticClass:"text-xs-right pr-1 mx-0 mt-1 mb-0 py-0",attrs:{"xs1":""}},[_c('v-menu',{staticClass:"text-xs-right mx-4 my-0 py-0 align-center",attrs:{"offset-y":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-1 my-0 py-0",attrs:{"small":"","icon":"","color":"black","dark":""}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("sort")])],1)]}}],null,false,970768266)},[_vm._v(" "),_c('v-list',{attrs:{"value":"last_name"}},_vm._l((_vm.sortingItems),function(item,index){return _c('v-list-tile',{key:index.column,on:{"click":function($event){return _vm.changeSort(item.column)}}},[(item.column == _vm.sorting)?_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("mdi-sort-ascending")])],1):_c('v-list-tile-avatar',[_c('v-icon')],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)}),1)],1)],1)])],1)]},proxy:true}],null,false,4114190156)},[_c('v-toolbar-title',{staticClass:"pt-3 mx-1 mb-0 pb-0"},[_c('router-link',{staticClass:"logo my-0 py-0",attrs:{"to":"/artworks/ownership/collection"}},[_c('span',{staticClass:"font-weight-regular display-1 hidden-xs-only"},[_vm._v("TBA21")])]),_vm._v(" "),_c('router-link',{staticClass:"logo my-0 py-0 text-truncate",attrs:{"to":_vm.page_link}},[_vm._v(_vm._s(_vm.page_title))])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right mb-0 pt-3"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-progress-circular',_vm._g({directives:[{name:"show",rawName:"v-show",value:(_vm.$store.getters.loading || _vm.progressON),expression:"$store.getters.loading || progressON"}],staticClass:"mr-5",attrs:{"indeterminate":"","size":"20","width":"2"}},on))]}}],null,false,2451309170)},[_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_artworks),expression:"$store.state.loading_artworks"}]},[_vm._v("Loading Artworks")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_artists),expression:"$store.state.loading_artists"}]},[_vm._v("Loading Artists")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_rules),expression:"$store.state.loading_rules"}]},[_vm._v("Loading Rules")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_contacts),expression:"$store.state.loading_contacts"}]},[_vm._v("Loading Contacts")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_lists),expression:"$store.state.loading_lists"}]},[_vm._v("Loading Lists")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_locations),expression:"$store.state.loading_locations"}]},[_vm._v("Loading Locations")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_exhibitions),expression:"$store.state.loading_exhibitions"}]},[_vm._v("\n          Loading Exhibitions\n        ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_packings),expression:"$store.state.loading_packings"}]},[_vm._v("Loading Packings")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_texts),expression:"$store.state.loading_texts"}]},[_vm._v("Loading Text")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_tags),expression:"$store.state.loading_tags"}]},[_vm._v("Loading Tags")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_tag_categories),expression:"$store.state.loading_tag_categories"}]},[_vm._v("\n          Loading Tag Categories\n        ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_todos),expression:"$store.state.loading_todos"}]},[_vm._v("Loading Todos")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_support_articles),expression:"$store.state.loading_support_articles"}]},[_vm._v("\n          Loading Support Articles\n        ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_journals),expression:"$store.state.loading_journals"}]},[_vm._v("Loading Journals")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.loading_questions),expression:"$store.state.loading_questions"}]},[_vm._v("Loading Questions")])]),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":"","close-on-content-click":false,"nudge-width":400},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-badge',{staticClass:"mt-2 pt-0 mr-3",attrs:{"overlap":"","value":_vm.selected.length,"color":"black"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.selected.length))])]},proxy:true}],null,true)},[_vm._v(" "),_c('v-btn',_vm._g({staticClass:"mt-0 mr-0",attrs:{"icon":""}},on),[_c('v-icon',{attrs:{"color":_vm.selected.length > 0 ? 'green' : 'black'}},[_vm._v("auto_awesome_motion")])],1)],1)]}}],null,false,3944596739),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-list',{staticClass:"px-2",attrs:{"two-line":""}},[_c('v-list-tile',{staticClass:"my-0"},[_c('v-btn',{attrs:{"outline":"","small":""},on:{"click":function($event){return _vm.openSelectionsdialog()}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("get_app")]),_vm._v("Load saved Artwork\n              Selection (list)\n            ")],1)],1),_vm._v(" "),(_vm.selected.length > 0 && _vm.c_user.edit)?_c('v-list-tile',{staticClass:"my-0"},[_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.show_change_location_dialog = true}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("edit_location")]),_vm._v("Change location of\n              selected\n            ")],1)],1):_vm._e(),_vm._v(" "),(_vm.selected.length > 0)?_c('v-list-tile',{staticClass:"my-0 py-0"},[_c('v-list-tile-title',{staticClass:"layout row wrap ml-0 my-0 py-0",staticStyle:{"height":"70px"}},[_c('v-flex',{attrs:{"xs2":"","pl-3":""}},[_c('list-action-menu',{attrs:{"use-current-selection":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","pt-2":"","text-xs-left":"","pl-3":""}},[_vm._v(_vm._s(_vm.selected.length)+" currently selected Artworks.")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.save_selection_form_display)?_c('v-list-tile',{staticClass:"ml-0 pl-1"},[(_vm.selected.length > 0)?_c('v-btn',{attrs:{"outline":"","small":"","color":"error"},on:{"click":_vm.clear_selection}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("clear")]),_vm._v("Clear selection\n            ")],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.selected.length > 0)?_c('v-btn',{attrs:{"dark":"","small":"","color":"primary"},on:{"click":function($event){_vm.save_selection_form_display = true}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("save")]),_vm._v("Save selection\n            ")],1):_vm._e()],1):_c('v-list-tile',[_c('v-flex',{attrs:{"xs12":"","mx-3":""}},[_c('v-text-field',{attrs:{"label":"Selection Title","value":""},model:{value:(_vm.selection_title),callback:function ($$v) {_vm.selection_title=$$v},expression:"selection_title"}})],1)],1),_vm._v(" "),(_vm.save_selection_form_display)?_c('v-list-tile',{staticClass:"layout justify-end mr-2"},[_c('v-btn',{attrs:{"outline":"","small":""},on:{"click":function($event){_vm.save_selection_form_display = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","small":""},on:{"click":_vm.saveCurrentSelectionToUser}},[_vm._v("Save")])],1):_vm._e(),_vm._v(" "),(_vm.save_selection_error)?_c('v-list-tile',{staticClass:"mx-4 mb-4 red"},[_vm._v(_vm._s(_vm.save_selection_error))]):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.c_user.edit)?_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mt-4 mr-3",attrs:{"icon":"","color":"black","flat":"","round":""}},on),[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("add")])],1)]}}],null,false,3193745869)},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.$router.push({ path: '/artworks/new' })}}},[_c('v-list-tile-title',[_vm._v("New Artwork")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.$router.push({ path: '/artists/new' })}}},[_c('v-list-tile-title',[_vm._v("New Artist")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.$router.push({ path: '/exhibitions/new' })}}},[_c('v-list-tile-title',[_vm._v("New Exhibition")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.add_new = !_vm.add_new}}},[_c('v-list-tile-title',[_vm._v("New User")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.$router.push({ path: '/locations/new' })}}},[_c('v-list-tile-title',[_vm._v("New Location")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.$router.push({ name: 'AddContact' })}}},[_c('v-list-tile-title',[_vm._v("New Contact")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.$router.push({ path: '/reports/new' })}}},[_c('v-list-tile-title',[_vm._v("New Report")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.$router.push({ path: '/texts/new' })}}},[_c('v-list-tile-title',[_vm._v("New Text")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.$router.push({ path: '/todos/new' })}}},[_c('v-list-tile-title',[_vm._v("New Todo")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.c_user.edit)?_c('v-menu',{attrs:{"offset-y":"","fixed":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-badge',{staticClass:"mt-4 mr-4 pt-0 mr-3",attrs:{"overlap":"","value":_vm.my_late_todos.length > 0 || _vm.messages.length > 0,"color":_vm.my_late_todos.length > 0 ? '#bc0000' : 'black'},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('span',[_vm._v(_vm._s(_vm.my_late_todos.length))])]},proxy:true}],null,true)},[_vm._v(" "),_c('v-btn',_vm._g({staticClass:"mt-0 mr-0",attrs:{"icon":""}},on),[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("notifications_none")])],1)],1)]}}],null,false,3184484239)},[_vm._v(" "),_c('v-card',{staticStyle:{"width":"650px"}},[(
            _vm.c_user &&
            _vm.c_user.roles &&
            _vm.c_user.roles.find(function (r) { return r.shortcut == 'todos'; })
          )?_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',{key:"sss",staticStyle:{"font-size":"20px","padding-left":"30px","background-color":"#eee","color":"#333"}},[_vm._v("\n            TODOS\n            "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{staticClass:"mb-3",attrs:{"prepend-inner-icon":"search","flat":"","clearable":"","hide-details":""},model:{value:(_vm.todoSearch),callback:function ($$v) {_vm.todoSearch=$$v},expression:"todoSearch"}}),_vm._v(" "),_c('span',{staticClass:"text-xs-right mr-0 mt-2 py-0",attrs:{"xs1":""}},[_c('v-btn',{staticClass:"text-xs-right mx-0 mt-2 my-0 py-0",attrs:{"icon":""},on:{"click":function($event){_vm.showAllTodos = !_vm.showAllTodos}}},[(_vm.showAllTodos)?_c('v-icon',{attrs:{"color":"red"}},[_vm._v("check_circle")]):_c('v-icon',{attrs:{"color":"grey","dark":""}},[_vm._v("check_circle_outline")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0",staticStyle:{"width":"650px"},attrs:{"pagination":_vm.tp,"must-sort":"","headers":_vm.todoHeaders,"items":_vm.my_todos,"item-key":"id","loading":"true","no-results-text":"No matching Todos found.","search":_vm.todoSearch},on:{"update:pagination":function($event){_vm.tp=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticClass:"elevation-0 mx-0 px-0",attrs:{"colspan":"4"}},[_c('v-list',{staticStyle:{"width":"650px"},attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"text-truncate text-uppercase",staticStyle:{"line-height":"2.5"}},[_c('b',[_vm._v(_vm._s(props.item.title))])]),_vm._v(" "),_c('v-list-tile-sub-title',[_c('router-link',{staticClass:"body-2 text-truncate",staticStyle:{"width":"120px"},attrs:{"to":{
                              name: 'EditArtwork',
                              params: {
                                id: props.item.artwork_id,
                                artwork: { id: props.item.artwork_id },
                              },
                              path: ("/artworks/edit/" + (props.item.artwork_id)),
                            }}},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"black","small":""}},[_vm._v("launch")]),_vm._v("\n                            "+_vm._s(_vm.getArtwork(props.item.artwork_id))+"\n                          ")],1)],1),_vm._v(" "),_c('v-list-tile-sub-title',{staticStyle:{"line-height":"2.5"}},[_c('span',{staticClass:"mr-5"},[_vm._v("Created:\n                            "+_vm._s(_vm.format_date(props.item.created_at)))]),_vm._v(" "),(props.item.done_at)?_c('span',{staticClass:"mr-5 green"},[_vm._v("Done at:\n                            "+_vm._s(_vm.format_date(props.item.done_at)))]):_vm._e(),_vm._v(" "),(props.item.deadline)?_c('v-icon',{attrs:{"small":"","color":_vm.getColor(props.item)}},[_vm._v("alarm_on")]):_vm._e(),_vm._v(" "),(props.item.deadline)?_c('span',[_vm._v(_vm._s(_vm.format_date(props.item.deadline)))]):_vm._e()],1)],1),_vm._v(" "),_c('v-list-tile-action',{staticClass:"px-2"},[_c('v-btn',{class:props.item.done ? 'dark' : '',attrs:{"icon":""},on:{"click":function($event){return _vm.toggleTodo(props.item)}}},[(props.item.done == 1)?_c('v-icon',{staticClass:"mr-0 pl-0 ml-0"},[_vm._v("check_box")]):_c('v-icon',{staticClass:"mr-0 pl-0 ml-0"},[_vm._v("check_box_outline_blank")])],1)],1)],1)],1)],1)])]}}],null,false,1602744554)})],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-menu',{staticStyle:{"background-color":"white","top":"80px","position":"fixed"},attrs:{"close-on-content-click":false,"offset-y":"","fixed":"","offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                            var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mt-4 mr-0",attrs:{"icon":""}},on),[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("person_outline")])],1)]}}],null,false,2862480980)},[_vm._v(" "),_c('v-card',{staticStyle:{"width":"650px"}},[_c('v-list',{staticClass:"pt-2 pl-2 pr-0"},[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"black","size":"35"}},[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"title mt-1"},[_vm._v(_vm._s(_vm.c_user.firstname)+" "+_vm._s(_vm.c_user.lastname)+" |\n                "+_vm._s(_vm.c_user.abb))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"icon":""},on:{"click":_vm.saveAsHomePage}},[_c('v-icon',{attrs:{"color":_vm.homePage_c ? 'yellow' : 'black'}},[_vm._v("star")])],1),_vm._v(" "),(_vm.isAuthenticated)?_c('v-btn',{staticClass:"mr-1",attrs:{"icon":""},on:{"click":_vm.logout}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("logout")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"mt-4 mr-2 hidden-sm-and-down",attrs:{"icon":""},on:{"click":function($event){_vm.sheet = true}}},[_c('v-icon',[_vm._v("help")])],1)],1):_vm._e(),_vm._v(" "),_c('v-navigation-drawer',{staticStyle:{"background-color":"#292929"},attrs:{"app":"","temporary":"","dark":"","hide-overlay":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-layout',{attrs:{"row":"","pt-3":"","pl-2":"","pb-2":""}},[_c('v-flex',[_c('v-subheader',{staticClass:"font-weight-regular display-1 white--text"},[_vm._v("\n          Menu\n          "),_c('v-spacer'),_vm._v(" "),_c('a',{staticClass:"font-weight-regular mr-2 display-1 white--text",on:{"click":function($event){_vm.drawer = false}}},[_vm._v("x")])],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-4 pb-0 mb-0"}),_vm._v(" "),_c('v-list',[_vm._l((_vm.user_items),function(item,i){return [(item.heading)?_c('v-layout',{key:i,attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[(item.heading)?_c('v-subheader',[_vm._v(_vm._s(item.heading))]):_vm._e()],1)],1):(item.children)?_c('v-list-group',{key:i,attrs:{"no-action":""},model:{value:(item.active),callback:function ($$v) {_vm.$set(item, "active", $$v)},expression:"item.active"}},[_c('v-list-tile',{staticStyle:{"padding-left":"8px"},attrs:{"slot":"activator","to":item.path},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.text))])],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i,staticClass:"pl-0 ml-0",attrs:{"to":child.path,"active-class":"default-class activeMenu"}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(child.text))])],1)],1)})],2):_c('v-list-tile',{directives:[{name:"shortkey",rawName:"v-shortkey",value:(item.shortkey),expression:"item.shortkey"}],key:i,attrs:{"to":item.path,"active-class":"default-class activeMenu"},on:{"shortkey":function($event){return _vm.$router.push({ path: item.path })}}},[_c('v-list-tile-content',{staticClass:"pl-2",staticStyle:{"color":"white"}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.text))])],1)],1),_vm._v(" "),_c('v-divider',{key:i + 1000,staticClass:"mx-4 pb-0 mb-0 white"})]}),_vm._v(" "),_c('v-list-group',[_c('v-list-tile',{staticStyle:{"padding-left":"8px"},attrs:{"to":"/facts"}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Facts & Figures")])],1)],1),_vm._v(" "),_c('v-list-tile',{staticStyle:{"padding-left":"8px"},attrs:{"slot":"activator","target":"_blank"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Local storage management")])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"shortkey",rawName:"v-shortkey.once",value:(['ctrl', 'r']),expression:"['ctrl', 'r']",modifiers:{"once":true}}],staticStyle:{"padding-left":"8px"},attrs:{"target":"_blank"},on:{"shortkey":function($event){return _vm.reset_store()},"click":function($event){return _vm.reset_store()}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Reset ALL local storage")])],1)],1),_vm._v(" "),_vm._l((this.sections),function(s){return _c('v-list-tile',{key:s,staticStyle:{"padding-left":"18px"},attrs:{"target":"_blank"},on:{"click":function($event){return _vm.reload_data(s)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Load "+_vm._s(s))])],1)],1)})],2),_vm._v(" "),_c('v-divider',{staticClass:"mx-4 pb-0 mb-0 white"}),_vm._v(" "),(_vm.c_user && _vm.c_user.admin)?_c('v-list-tile',{staticStyle:{"cursor":"pointer"},attrs:{"avatar":"","onclick":"window.open('https://api.tb-cms.org/artworks/generate_datauri_small')","target":"_blank"}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("photo")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Generate New Images")])],1)],1):_vm._e(),_vm._v(" "),(_vm.c_user.edit)?_c('v-list-tile',{attrs:{"avatar":"","href":"http://api.tb-cms.org","target":"_blank"}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("open_in_new")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Go to the old version")])],1)],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{staticClass:"dark",attrs:{"avatar":"","dark":""}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-list-tile-content',{staticClass:"pt-0 mt-0"},[_c('v-list-tile-title',{staticClass:"pt-0 mt-0"},[_vm._v("\n            "+_vm._s(this.c_user.firstname)+" "+_vm._s(this.c_user.lastname)+"\n            "),_c('v-btn',{staticClass:"pt-0 mt-0",attrs:{"small":"","icon":""},on:{"click":_vm.logout}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("open_in_new")])],1)],1)],1)],1),_vm._v(" "),_c('v-divider')],2)],1),_vm._v(" "),_c('div',[_c('v-bottom-sheet',{model:{value:(_vm.sheet),callback:function ($$v) {_vm.sheet=$$v},expression:"sheet"}},[_c('v-card',{attrs:{"ma-2":""}},[_c('v-card-title',[_c('v-btn',{attrs:{"depressed":_vm.show == 'help',"dark":_vm.show != 'help'},on:{"click":function($event){_vm.show = 'help'}}},[_vm._v("Help")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"depressed":_vm.show == 'form',"dark":_vm.show != 'form'},on:{"click":function($event){_vm.show = 'form'}}},[_vm._v("Ask question")]),_vm._v(" "),_c('span',{staticClass:"subheading red--text",domProps:{"innerHTML":_vm._s(_vm.message_error)}}),_vm._v(" "),_c('span',{staticClass:"subheading green--text",domProps:{"innerHTML":_vm._s(_vm.message_success)}})],1),_vm._v(" "),_c('v-progress-linear',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"ma-0 pa-0",attrs:{"indeterminate":"","height":"3"}})],1),_vm._v(" "),(_vm.show == 'help')?_c('v-card',{attrs:{"color":"grey lighten-4","flat":"","mt-0":""}},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","pa-0":"","ma-0":""}},[_c('v-flex',{attrs:{"xs12":"","mb-1":"","ma-0":""}},[_c('v-flex',{attrs:{"xs12":"","mb-1":""}},[(_vm.site_support_article)?_c('v-card',{staticClass:"elevation-0 pb-5 pt-4",attrs:{"outlined":"","color":"grey lighten-4"}},[_c('v-card-title',{staticClass:"py-0 my-0 title"},[_vm._v(_vm._s(_vm.site_support_article.title))]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"mb-3 subtitle-1",domProps:{"innerHTML":_vm._s(_vm.site_support_article.subtitle)}}),_vm._v(" "),_c('div',{staticClass:"body-1",domProps:{"innerHTML":_vm._s(_vm.site_support_article.body)}})])],1):_c('v-card',{staticClass:"elevation-0 pb-5",attrs:{"outlined":"","color":"grey lighten-4"}},[_c('v-card-title',{staticClass:"py-0 my-0 title"},[_vm._v("No Support Article yet")]),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"body-1"},[_vm._v("\n                      Please come back later.\n                      "),_c('br'),_vm._v("You can also contact support at\n                      "),_c('a',{attrs:{"href":"mailto:miro.zahorak@gmail.com"}},[_vm._v("miro.zahorak@gmail.com")]),_vm._v("\n                      or click Ask Question button above to write a support\n                      request.\n                    ")])])],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.show == 'form')?_c('v-card',{attrs:{"color":"grey lighten-4","flat":"","ma-0":"","pa-0":""}},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","ma-0":"","pa-0":""}},[_c('v-layout',{attrs:{"row":"","ma-0":"","pa-0":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 pb-5",attrs:{"outlined":"","color":"grey lighten-4"}},[_c('v-card-title',{staticClass:"py-0 my-0 title"},[_vm._v("Ask support group a question regarding problem in this\n                    section of CMS.")]),_vm._v(" "),_c('v-card-text',{staticClass:"mb-0 pb-0"},[_c('v-textarea',{attrs:{"label":"Ask your question here","outline":"","auto-grow":""},model:{value:(_vm.question),callback:function ($$v) {_vm.question=$$v},expression:"question"}})],1),_vm._v(" "),_c('v-card-actions',{staticClass:"mx-2 mt-0 pt-0"},[_c('v-btn',{attrs:{"enabled":!!_vm.question,"dark":""},on:{"click":_vm.send_question}},[_vm._v("Send")])],1)],1)],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),(_vm.c_user.edit && _vm.add_new)?_c('v-card',{staticClass:"black my-5",staticStyle:{"top":"145px"}},[_c('v-flex',[_c('v-form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();}}},[_c('v-layout',{attrs:{"pa-3":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","pl-4":"","pr-3":""}},[_c('v-text-field',{attrs:{"autocomplete":"off","readonly":"","onfocus":"this.removeAttribute('readonly');","hide-details":"","label":"login","solo":""},model:{value:(_vm.new_user.login),callback:function ($$v) {_vm.$set(_vm.new_user, "login", $$v)},expression:"new_user.login"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{staticClass:"input-group",attrs:{"autocomplete":"off","readonly":"","onfocus":"this.removeAttribute('readonly');","hide-details":"","label":"Password","type":"password","solo":""},model:{value:(_vm.new_user.password),callback:function ($$v) {_vm.$set(_vm.new_user, "password", $$v)},expression:"new_user.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":"","mt-1":"","ml-3":""}},[_c('v-btn',{attrs:{"outline":"","color":"white","disabled":!(_vm.new_user.login.length > 0 && _vm.new_user.password.length > 0)},on:{"click":_vm.create_user}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"white"},on:{"click":function($event){_vm.add_new = false}}},[_vm._v("Cancel")])],1)],1)],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "7NJ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-0",attrs:{"small":_vm.small,"light":_vm.light,"loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.pdfSoloCall.apply(null, arguments)}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":_vm.small}},[_vm._v("mdi-file-pdf")]),_vm._v(" Solo")],1)}
var staticRenderFns = []


/***/ }),

/***/ "7TSy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7mOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-4 px-3 pt-5"},[_c('h2',{attrs:{"xs8":"","sm8":"","md8":""}},[_vm._v("Condition Report: "+_vm._s(_vm.processedArtwork.title))]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":"","mb-3":""}}),_vm._v(" "),_c('v-stepper',{staticClass:"elevation-1",attrs:{"red":"","color":"black"},model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 1,"step":"1","color":"black"}},[_vm._v("Select Artwork\n      ")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 2,"step":"2","color":"black"}},[_vm._v("\n        Artwork Details")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 3,"step":"3","color":"black"}},[_vm._v("\n        Storage/Handling")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 4,"step":"4","color":"black"}},[_vm._v("\n        Diagnosis")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 5,"step":"5","color":"black"}},[_vm._v("\n        General")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 6,"step":"6","color":"black"}},[_vm._v("\n        Conservation")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 7,"step":"7","color":"black"}},[_vm._v("Photos")]),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"8"}},[_vm._v("Download PDF")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"elevation-0 mb-5"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.artworks,"item-text":"title","item-value":"id","label":"Select Artwork"},on:{"input":function($event){return _vm.getArtwork(_vm.selected_artwork)}},model:{value:(_vm.selected_artwork),callback:function ($$v) {_vm.selected_artwork=$$v},expression:"selected_artwork"}})],1)],1)],1),_vm._v(" "),(_vm.processedArtwork)?_c('div',{staticClass:"ml-3"},[(_vm.processedArtwork.top_photo_id > 0)?_c('v-img',{staticClass:"white--text",attrs:{"width":"150px","xs4":"","sm6":"","src":'https://api.tb-cms.org/data/artwork/' +
                _vm.processedArtwork.id +
                '/' +
                _vm.processedArtwork.top_photo_id +
                '_th.jpg',"height":"150px"}}):_vm._e(),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.processedArtwork.title))]),_vm._v(" "),_c('div',[_vm._v("\n                  "+_vm._s(_vm.processedArtwork.accession_number)+" "),_c('br'),_vm._v("\n                  "+_vm._s(_vm.processedArtist.name)),_c('br'),_vm._v(" "),_vm._v("\n                  Edition: "+_vm._s(_vm.processedArtwork.edition_state)),_c('br'),_vm._v("\n                  Signature: "+_vm._s(_vm.processedArtwork.signature_new)),_c('br'),_vm._v("\n                  Dimensions: "+_vm._s(this.selected_artwork.dim_f_json)),_c('br'),_vm._v("\n                  Packings: "+_vm._s(_vm.processedArtwork.packings)),_c('br'),_vm._v("\n                  Crate details: "+_vm._s(_vm.processedArtwork.crate_details)),_c('br')])])]),_vm._v(" "),_c('v-card-actions',[_c('v-checkbox',{staticClass:"ml-2",attrs:{"color":"black","label":"Yes, this is the one"},model:{value:(_vm.approved),callback:function ($$v) {_vm.approved=$$v},expression:"approved"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.approved,"flat":"","black":""},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-5 elevation-0"},[_c('v-container',{attrs:{"fluid":""}},[_c('v-expansion-panel',{attrs:{"focusable":""}},[_c('v-expansion-panel-content',{key:1},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Artwork Type")]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-4"},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-radio-group',{model:{value:(_vm.artwork_type),callback:function ($$v) {_vm.artwork_type=$$v},expression:"artwork_type"}},[_c('v-radio',{attrs:{"label":"Drawing","value":"1"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Painting","value":"2"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Photo | Print","value":"3"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Sculpture","value":"4"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Audio/Visual Installation","value":"5"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{key:2},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Dimensions")]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-4"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"name":"input-1","label":"Dimension Details","auto-grow":"","rows":"1"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"name":"input-1","label":"Description background of origin / Production process","auto-grow":"","rows":"1"}})],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{key:3},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Components")]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-4"})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""},nativeOn:{"click":function($event){_vm.e1 = 1}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""},nativeOn:{"click":function($event){_vm.e1 = 3}}},[_vm._v("Save and Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-5 elevation-0"},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-expansion-panel',{attrs:{"focusable":""}},[_c('v-expansion-panel-content',{key:1},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("1. Storage")]),_vm._v(" "),_c('v-flex',{staticClass:"pl-3 pr-3",attrs:{"xs12":""}},[_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","label":"Current packing material","rows":"1"}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","rows":"1","label":"Packed Dimensions"}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","rows":"1","label":"Special Storage conditions"}})],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{key:2},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("2. Handling and transportation")]),_vm._v(" "),_c('v-flex',{staticClass:"pl-3 pr-3",attrs:{"xs12":""}},[_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","rows":"1","label":"Handling Requirements"}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","rows":"1","label":"Pay particular attention to"}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","rows":"1","label":"Instructions for transportation"}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","rows":"1","label":"Method of handling of artwork"}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","rows":"1","label":"Courier / Assistant recommended"}})],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{key:3},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("3. Exhibition conditions")]),_vm._v(" "),_c('v-flex',{staticClass:"pl-3 pr-3",attrs:{"xs12":""}},[_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","rows":"1","label":"Requirements during exhibition"}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","rows":"1","label":"Special exhibition condition"}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","rows":"1","label":"Special maintenance during exhibitions"}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"auto-grow":"","name":"input-1","rows":"1","label":"Regular inspection of possible changes during exhibition"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 4}}},[_vm._v("Save and Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',{staticClass:"mb-5 elevation-0"},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-expansion-panel',{attrs:{"focusable":""}},[_c('v-expansion-panel-content',{key:1},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("1. Description of Condition")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pl-4":"","pr-4":""}},[_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"rows":"1","name":"input-1","label":"Description of Condition","auto-grow":""}})],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{key:2},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("2. Damage Category")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pl-4":"","pr-3":""}},_vm._l((_vm.damage_types),function(d){return _c('v-checkbox',{key:d,staticClass:"xs4 left mr-2",staticStyle:{"width":"280px"},attrs:{"small":"","label":d,"value":d,"hide-details":""},model:{value:(_vm.damage_categories),callback:function ($$v) {_vm.damage_categories=$$v},expression:"damage_categories"}},[_vm._v(_vm._s(d))])}),1)],1),_vm._v(" "),_c('v-expansion-panel-content',{key:3},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("3. Damage")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pl-4":"","pr-4":""}},[_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"rows":"1","name":"input-1","label":"Type of Damage","auto-grow":""}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"rows":"1","name":"input-1","label":"Visual Illustration","auto-grow":""}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"rows":"1","name":"input-1","label":"Preliminary examination","auto-grow":""}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"rows":"1","name":"input-1","label":"Material-technical options","auto-grow":""}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"rows":"1","name":"input-1","label":"Weighing the options for conservation","auto-grow":""}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"rows":"1","name":"input-1","label":"Preventive conservation/minimal conservation requirements","auto-grow":""}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"rows":"1","name":"input-1","label":"No conservation/restoration required","auto-grow":""}}),_vm._v(" "),_c('v-textarea',{staticClass:"mx-2 my-3",attrs:{"rows":"1","name":"input-1","label":"No conservation/restoration possible","auto-grow":""}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 3}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 5}}},[_vm._v("Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-card',{staticClass:"mb-3 pl-3 pr-3 elevation-0"},[_c('v-textarea',{staticClass:"pt-4",attrs:{"name":"input-1","label":"General Condition Notes","auto-grow":""}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Issues are inharent"},model:{value:(_vm.inharent),callback:function ($$v) {_vm.inharent=$$v},expression:"inharent"}}),_vm._v(" "),_c('v-select',{attrs:{"items":[
              'Excellent',
              'Very Good',
              'Good',
              'Fair',
              'Poor',
              'Very Poor' ],"label":"General Condition Category","single-line":""},model:{value:(_vm.condition_category),callback:function ($$v) {_vm.condition_category=$$v},expression:"condition_category"}}),_vm._v(" "),_c('v-text-field',{attrs:{"id":"examined_by","name":"input-1","label":"Examined by"}}),_vm._v(" "),_c('v-text-field',{attrs:{"id":"examiner_title","name":"input-1","label":"Examiner Title"}}),_vm._v(" "),_c('v-text-field',{attrs:{"id":"eamination_location","name":"input-1","label":"Examination Location"}}),_vm._v(" "),_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.date,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event},"update:return-value":function($event){_vm.date=$event}},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Examination Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.menu = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.$refs.menu.save(_vm.date)}}},[_vm._v("OK")])],1)],1),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"activator","label":"Reason for Examination"},slot:"activator",model:{value:(_vm.examination_reason),callback:function ($$v) {_vm.examination_reason=$$v},expression:"examination_reason"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""},nativeOn:{"click":function($event){_vm.e1 = 4}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""},nativeOn:{"click":function($event){_vm.e1 = 6}}},[_vm._v("Save and Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"6"}},[_c('v-card',{staticClass:"mb-3 pl-3 pr-3 elevation-0"},[_c('h3',{staticClass:"sub-headline pt-3"},[_vm._v("Diagnosis and Proposal")]),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Description of Condition / Type of Damage"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Concept (and planning) of Conservation"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Conservation required"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"General Condition Category"}}),_vm._v(" "),_c('h3',{staticClass:"sub-headline pt-3"},[_vm._v("Treatment")]),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Parts / Action"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"List of products used (brand names etc)"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Cleaning"}}),_vm._v(" "),_c('h3',{staticClass:"sub-headline pt-3"},[_vm._v("Packing and Handling")]),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Storage Conditions"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Art Handling | Transport"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Exhibition Conditions"}}),_vm._v(" "),_c('h3',{staticClass:"sub-headline pt-3"},[_vm._v("Comments and Notes")]),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Assessment of Greatest Risks"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Conservator's Comments"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Literature"}}),_vm._v(" "),_c('h3',{staticClass:"sub-headline pt-3"},[_vm._v("History")]),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Examined by"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Examiner Title"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Examination Date"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Examination Location"}}),_vm._v(" "),_c('v-textarea',{staticClass:"pt-2",attrs:{"name":"input-1","auto-grow":"","rows":"1","label":"Reason for Examination"}}),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.fields_conservation),function(field){return _c('edit-field',{directives:[{name:"show",rawName:"v-show",value:(!field.dynamic),expression:"!field.dynamic"}],key:field.key,class:'flex ' +
                  (field.class ? field.class : 'xs12') +
                  (field.dynamic ? ' red lighten-5' : ''),attrs:{"id":field.name,"name":field.name,"artwork":_vm.processedArtwork,"field":field,"fields_parent":_vm.fields_conservation,"report":_vm.report},on:{"add_field":_vm.add_field}})}),1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""},nativeOn:{"click":function($event){_vm.e1 = 5}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""},nativeOn:{"click":function($event){_vm.e1 = 7}}},[_vm._v("Save and Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"7"}},[_c('v-card',{staticClass:"mb-5 pl-3 pr-3 pb-3 elevation-0"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('br'),_vm._v(" "),_c('h3',{staticClass:"title mb-3"},[_vm._v("Upload photos")])])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""},nativeOn:{"click":function($event){_vm.e1 = 6}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""},nativeOn:{"click":function($event){_vm.e1 = 8}}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"8"}},[_c('v-card',{staticClass:"mb-5 pl-3 pr-3 pb-3 elevation-0"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('br'),_vm._v(" "),_c('h3',{staticClass:"title mb-3"},[_vm._v("Download Report")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.pdf.apply(null, arguments)}}},[_vm._v("Full PDF ")])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""},nativeOn:{"click":function($event){_vm.e1 = 6}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","black":""},nativeOn:{"click":function($event){_vm.e1 = 8}}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Cancel")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "7mxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_artworks_EditArtwork_vue__ = __webpack_require__("hD92");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_artworks_FilterBox__ = __webpack_require__("h4Ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_artworks_ArtworksTable__ = __webpack_require__("2J1f");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'



// import ArtworkItem from '@/components/artworks/ArtworkItem.vue'
// import ArtworksBox from '@/components/artworks/ArtworksBox'
// import ExifBox from '@/components/artworks/ExifBox'

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['ownership'],
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // this.$store.commit('routeChange')
    this.$store.dispatch('setSearchString', {
      string: this.search,
      section: 'artworks'
    });
    next();
  },

  data: function data() {
    return {
      currentOwnership: 'all',
      ownershipToAll: false,
      displayedData: [],
      filteredTextArtwork: '',
      filteredTextArtist: '',
      selectedFilter: '',
      artwork: {
        name: ''
      },
      artists: [],
      artworks: [],
      resultsArtworks: [],
      resultsArtists: [],
      editArtwork: false,
      filterText: ''
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   if (to.params.ownership) {
  //     next((vm) => vm.switchOwnership(to))
  //   }
  //   if (to.params.work_type) {
  //     next((vm) => vm.filterArtworks(to))
  //   }
  // },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  // beforeRouteUpdate(to, from, next) {
  //   this.displayedData = []
  //   // getPost(to.params.id, (err, post) => {
  //   this.switchOwnership(to)
  //   if (to.params.work_type) {
  //     this.filterArtworks(to)
  //   }
  //   next()
  //   // })
  // },
  created: function created() {
    //   // this.displayedData = this.$store.state.artworks
    this.$store.dispatch('loadArtworks');
    //   this.switchOwnership()
    //   // this.getArtworks(),
    //   // this.getArtists()

    //   //  this.switchOwnership(to)
    //   // {
    //     //   switch (router.currentRoute) {
    //     //     case 'collection':
    //     //     this.displayedData = this.$store.state.collection
    //     //     break
    //     //     case '6':
    //     //     this.displayedData = this.$store.state.pac_fvh
    //     //     break
    //     //     case '7':
    //     //     this.displayedData = this.$store.state.pdc_fvh
    //     //     break
    //     //     case '10':
    //     //     this.displayedData = this.$store.state.pac_mr
    //     //     break
    //     //     case '9':
    //     //     this.displayedData = this.$store.state.oldMasters
    //     //     break
    //     //     case 'deaccession':
    //     //     this.displayedData = this.$store.state.deaccession
    //     //     break
    //     //     default:
    //     //     this.displayedData = this.$store.state.collection
    //     //   }
    //   // },
  },
  methods: {
    saveSearchValue: function saveSearchValue(s) {
      this.search = s;
    },
    saveArtworkPageValue: function saveArtworkPageValue(p) {
      this.page = p;
    },


    // filter: function(name) {
    //   this.filterText = name;
    // },
    // _toggle () {
    //   this.editArtwork = true
    // },
    // getArtworks () {
    //   let url = 'http://localhost:3000/artworks.json'
    //   axios.get(url).then((response) => {
    //     // this.loading = false;
    //     this.resultsArtworks = response.data
    //   }).catch((error) => { console.log(error) })
    // },
    // filterArtworks(to) {
    //   var c = 0
    //   switch (to.params.work_type) {
    //     case 'paintings':
    //       c = 2
    //       break
    //     case 'drawings':
    //       c = 1
    //       break
    //     case 'photographs':
    //       c = 3
    //       break
    //     case 'videos':
    //       c = 7
    //       break
    //     case 'sound':
    //       c = 9
    //       break
    //     case 'objectsAndSculptures':
    //       c = 4
    //       break
    //     default:
    //       this.displayedData = this.$store.state.artworks
    //   }
    //   if (c > 0) {
    //     this.displayedData = this.$store.state.artworks.filter(function (a) {
    //       return a.type_of_work_id == c && a.deaccessioned != 1
    //     })
    //   } else {
    //   }
    // },
    switchOwnershipToAll: function switchOwnershipToAll(switchStatus) {
      console.log('switchOwnershipToAll');
      // console.log(switchStatus)
      this.ownershipToAll = true;
      this.switchOwnership(this.$route);
      // this.ownershipToAll = !this.ownershipToAll
      // this.displayedData = this.$store.state.artworks.filter(function (a) {
      //   return a.deaccessioned != 1
      // })
    },
    switchOwnershipTop: function switchOwnershipTop(switchStatus) {
      console.log('switchOwnershipTop');
      console.log(this.$route);
      this.ownershipToAll = false;
      // this.ownershipToAll = !this.ownershipToAll
      // if (switchStatus) {
      // } else {
      this.switchOwnership(this.$route);
      // }
    },
    switchOwnership: function switchOwnership() {
      var to = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route;

      if (!to) {
        to = this.$route;
      }
      // this.displayedData = this.$store.state.collection
      // console.log('switchOwnership')
      // console.log(this.displayedData)
      var to2 = '';
      if (to.params.ownership) {
        to2 = to.params.ownership;
      } else {
        to2 = this.$route.params.ownership;
      }
      this.currentOwnership = to2;

      // switch (to2) {
      //   case 'all':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.deaccessioned != 1
      //       // deaccessioned=0 and (ownership is NULL or (ownership<>6 and ownership<>7 and ownership<>8 and ownership<>9 and ownership<>10))')
      //     })
      //     break
      //   case 'collection':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return (
      //         // ![6, 7, 8, 9, 10, 11, 12, 15, 17].includes(a.ownership) &&
      //         a.ownership == 1 && a.deaccessioned != 1
      //         // a.acquired != 'nontba' &&
      //         // a.acquired != 'commission'
      //       )
      //       // artworks.enable=1 and (loaned_artwork is null or loaned_artwork=0) and
      //       // deaccessioned=0 and (ownership is NULL or (ownership<>6 and ownership<>7 and ownership<>8 and ownership<>9 and ownership<>10 and ownership<>11))')
      //     })
      //     break
      //   case 'pacEh':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 17 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'pacFvh':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 6 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'pdcFvh':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 7 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'pacMr':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 10 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'pcFT':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 19 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'oldMasters':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 9 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'deaccession':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.deaccessioned == 1
      //     })
      //     break
      //   case 'gemini':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 12 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'geminiCL':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 15 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'geminiCD':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 16
      //     })
      //     break
      //   case 'pcCA':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return a.ownership == 11 && a.deaccessioned != 1
      //     })
      //     break
      //   case 'commissions':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return (
      //         a.acquired == 'commission' ||
      //         (a.acquired == 'acquired' &&
      //           a.acquisition_method == 3 &&
      //           a.deaccessioned != 1)
      //       )
      //       // (a.acquisition_method == 6 || a.acquisition_method == 3)
      //     })
      //     break
      //   case 'com_academy':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return (
      //         a.acquired == 'com_academy' &&
      //           a.deaccessioned != 1
      //       )
      //       // (a.acquisition_method == 6 || a.acquisition_method == 3)
      //     })
      //     break
      //   case 'nonTba':
      //     this.displayedData = this.$store.state.artworks.filter(function (a) {
      //       return (
      //         a.deaccessioned != 1 &&
      //         (a.acquired == 'nontba' || a.loaned_artwork == 1)
      //       )
      //     })
      //     break
      //   default:
      //     this.displayedData = []
      // }
      // console.log(this.displayedData)
      // console.log('switchOwnership')
    },

    // getArtists () {
    //   if (this.$store.state.collection) {
    //     this.displayedData = this.$store.state.collection
    //   } else {
    //     let url = 'http://localhost:3000/artists.json?o=1'
    //     axios.get(url).then((response) => {
    //       // this.loading = false;
    //       this.resultsArtists = response.data
    //       this.$store.dispatch('saveArtists', response.data)
    //       this.displayedData = response.data

    //     }).catch((error) => { console.log(error) })
    //   }
    // },
    artworkPassesOwnershipFilter: function artworkPassesOwnershipFilter(artwork) {
      if (!this.ownership.length) {
        return true;
      } else {
        var artworkOwnerships = artwork.ownership.split(', ');
        var matched = true;
        this.ownership.forEach(function (ownership) {
          if (artworkOwnerships.indexOf(ownership) === -1) {
            matched = false;
          }
        });
        return matched;
      }
    }
  },
  computed: {
    filteredByOwnership: function filteredByOwnership() {
      var filteredByOwnership = [];
      var to = this.$route;
      console.log('filteredByOwnership ---------------');
      console.log('to.params.ownership');
      console.log(to.params.ownership);
      console.log('this.ownershipToAll');
      console.log(this.ownershipToAll);
      console.log(this.currentOwnership);

      // let to2 = ''
      // if (to.params.ownership) {
      //   to2 = to.params.ownership
      // } else {
      //   to2 = this.$route.params.ownership
      // }
      // console.log('to2')
      // console.log(to2)

      if (this.ownershipToAll) {
        return filteredByOwnership = this.$store.state.artworks;
      } else {

        filteredByOwnership = this.$store.state.artworks.filter(function (a) {
          switch (to.params.ownership) {
            // switch (this.currentOwnership) {
            case 'all':
              return a.deaccessioned != 1;
            // deaccessioned=0 and (ownership is NULL or (ownership<>6 and ownership<>7 and ownership<>8 and ownership<>9 and ownership<>10))')

            case 'collection':
              return a.ownership == 1 && a.deaccessioned != 1;
            // ![6, 7, 8, 9, 10, 11, 12, 15, 17].includes(a.ownership) &&
            // a.acquired != 'nontba' &&
            // a.acquired != 'commission'
            // artworks.enable=1 and (loaned_artwork is null or loaned_artwork=0) and
            // deaccessioned=0 and (ownership is NULL or (ownership<>6 and ownership<>7 and ownership<>8 and ownership<>9 and ownership<>10 and ownership<>11))')
            case 'pacEh':
              return a.ownership == 17 && a.deaccessioned != 1;
            case 'pacFvh':
              return a.ownership == 6 && a.deaccessioned != 1;
            case 'pdcFvh':
              return a.ownership == 7 && a.deaccessioned != 1;
            case 'pacMr':
              return a.ownership == 10 && a.deaccessioned != 1;
            case 'pcFT':
              return a.ownership == 19 && a.deaccessioned != 1;
            case 'oldMasters':
              return a.ownership == 9 && a.deaccessioned != 1;
            case 'deaccession':
              return a.deaccessioned == 1;
            case 'gemini':
              return a.ownership == 12 && a.deaccessioned != 1;
            case 'geminiCL':
              return a.ownership == 15 && a.deaccessioned != 1;
            case 'geminiCD':
              return a.ownership == 16;
            case 'pcCA':
              return a.ownership == 11 && a.deaccessioned != 1;
            case 'com_academy':
              return a.acquired == 'com_academy' && a.deaccessioned != 1;
            case 'commissions':
              return a.acquired == 'commission' || a.acquired == 'com_academy' || a.acquired == 'acquired' && a.acquisition_method == 3 && a.deaccessioned != 1;
            // (a.acquisition_method == 6 || a.acquisition_method == 3)
            case 'nonTba':
              return a.deaccessioned != 1 && (a.acquired == 'nontba' || a.loaned_artwork == 1);
            default:
              return [];
          }
        });
        console.log('filteredByOwnership22');
        console.log(filteredByOwnership.length);
      }

      var to = this.$route;

      if (to.params.work_type) {

        var c = 0;
        switch (to.params.work_type) {
          case 'paintings':
            c = 2;
            break;
          case 'drawings':
            c = 1;
            break;
          case 'photographs':
            c = 3;
            break;
          case 'videos':
            c = 7;
            break;
          case 'sound':
            c = 9;
            break;
          case 'objectsAndSculptures':
            c = 4;
            break;
          default:
            this.$store.state.artworks;
        }
        if (c > 0) {
          var out = filteredByOwnership.filter(function (a) {
            return a.type_of_work_id == c && a.deaccessioned != 1;
          });
        } else {}
        return out;
      } else {
        return filteredByOwnership;
      }
    },

    // artworks_d() {
    //   // console.log('artworks_d')
    //   // return
    //   if (this.displayedData.length == 0) {
    //     this.displayedData = this.$store.state.artworks
    //     this.switchOwnership(this.$route)
    //     return this.displayedData
    //   } else {
    //     return this.displayedData
    //   }
    // },
    filtered: function filtered() {
      return this.$store.state.filterResults;
    },
    columns: function columns() {
      return this.$store.state.artworkColumns;
    },
    processedArtists: function processedArtists() {
      var artists = this.resultsArtists;
      this.artists.map(function (artist) {
        var a = artist;
        artist.first_name = a ? a.first_name : 'nema meno';
      });
      return artists;
    },

    // storedData() {
    //   let sdata = ''
    //   if (this.$store.state.filterResults) {
    //     sdata = this.$store.state.filterResults
    //   } else {
    //     sdata = this.filteredData
    //     this.$store.dispatch('postFilterResults', sdata)
    //   }
    //   this.displayedData = sdata
    //   return sdata
    // },
    filteredData: function filteredData() {
      var searchString = this.filteredTextArtwork;

      if (this.filteredTextArtwork != '') {
        // vráť z "this.processedArtists" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "this.processedArtists"
        return this.processedArtists.filter(function (artist) {
          // vráť z "artist.artworks" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "artist.artworks" v premennej "q"
          return artist.artworks.filter(function (artwork) {
            // vráť (čítať odzadu) true - ak "title" atribút obsahuje "search" string
            return artwork.title.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
          }).length > 0;
        });
      } else {
        return this.processedArtists;
      }
    },

    filteredArtworks: function filteredArtworks() {
      var self = this;
      // return self.artworks.filter(function (artwork) {
      //   return artwork.ownership.indexOf(self.searchQuery) == -1
      // })
      // var self = this
      self.artworks.filter(function (artwork) {
        var searchRegex = new RegExp(4, 'i');
        return searchRegex.test(artwork.ownership);
      });
    }

  },
  filters: {
    capitalize: function capitalize(a) {
      if (!a) return '';
      a = a.toString();
      return a.charAt(0).toUpperCase() + a.slice(1);
    }
  },
  // ArtworkItem, ArtworksBox
  components: {
    EditArtwork: __WEBPACK_IMPORTED_MODULE_0__components_artworks_EditArtwork_vue__["a" /* default */],
    FilterBox: __WEBPACK_IMPORTED_MODULE_1__components_artworks_FilterBox__["a" /* default */],
    ArtworksTable: __WEBPACK_IMPORTED_MODULE_2__components_artworks_ArtworksTable__["a" /* default */]
  }
});

/***/ }),

/***/ "7rwU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditLocation_vue__ = __webpack_require__("G5/j");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_671d9ca3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditLocation_vue__ = __webpack_require__("9oj1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("lMmx")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-671d9ca3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditLocation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_671d9ca3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditLocation_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_671d9ca3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditLocation_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "80nQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["artwork"],
  data: function data() {
    return {
      editDialog: false,
      editedOwnershipHistory: {},
      artwork_ownership_history: {},
      selectedPackings: [],
      menu2: false,
      showUpload: false,
      showList: false,
      show: false,
      errors: "",
      artwork_ownership_log: {
        id: "",
        note: "",
        change_date: "",
        artwork_ownership_id: ""
      }
    };
  },
  computed: {
    ownerships: function ownerships() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.getters.my_ownerships).sort(dynamicSort("name"));
    }
  },
  methods: {
    editExhibitionHistory: function editExhibitionHistory(l) {
      this.editedOwnershipHistory = l;
      this.editDialog = true;
    },
    save_edited_artwork_ownership_history: function save_edited_artwork_ownership_history() {
      var _this = this;

      this.editedOwnershipHistory.last_update_by = this.c_user.id;
      this.editedOwnershipHistory.artwork_id = this.artwork.id;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(this.$globals.apiserver + "/artwork_ownership_logs/" + this.editedOwnershipHistory.id + ".json", {
        artwork_ownership_log: this.editedOwnershipHistory
      }).then(function (response) {
        _this.$emit("getArtwork");
        _this.errors = {};
        _this.artwork.artwork_ownership_logs = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.artwork.artwork_ownership_logs.filter(function (element) {
          return element.id !== response.data.id;
        })), [response.data]);
        // this.artwork.artwork_ownership_id = this.editedOwnershipHistory.artwork_ownership_id;
        // this.active_artwork_ownership_logs = this.$store.state.artwork_ownership_logs;
        _this.editedOwnershipHistory = {
          id: "",
          note: "",
          change_date: "",
          artwork_ownership_id: ""
        };
        _this.editDialog = false;
      }).catch(function (error) {
        // console.log(error);
      });
      // var aartwork_ownership_history = Object.keys(this.artwork_ownership_history).forEach(k => this.artwork_ownership_history[k]='')
      // console.log(aartwork_ownership_history)
    },

    // ownership_name(id) {
    //   // console.log(id)
    //   if (id > 0) {
    //     var a = this.$store.getters.my_ownerships.find(l => l.id === id);
    //     if (a) {
    //       return a.name;
    //     } else {
    //       return "Ownership not found in CMS.";
    //     }
    //   } else {
    //     return "Ownership not found in CMS.";
    //   }
    // },
    // download() {},
    delete_log: function delete_log() {},
    save_artwork_ownership_log: function save_artwork_ownership_log() {
      var _this2 = this;

      this.artwork_ownership_log.created_by = this.c_user.id;
      this.artwork_ownership_log.artwork_id = this.artwork.id;
      if (this.artwork_ownership_log.storage == "in") {
        this.artwork_ownership_log.storage_in = this.artwork_ownership_log.change_date;
      } else {
        this.artwork_ownership_log.storage_out = this.artwork_ownership_log.change_date;
      }
      // this.artwork_ownership_log.id = this.findMinMax(this.all_artwork_ownership_logs)+1
      if (!this.artwork.artwork_ownership_logs) {
        this.artwork.artwork_ownership_logs = [];
      }
      // this.$store.commit('ADD_TODO', this.artwork_ownership_log)
      // this.all_artwork_ownership_logs.push(this.artwork_ownership_log)
      if (this.artwork_ownership_log.copy == "packings" && this.selectedPackings && this.selectedPackings.length > 0) {
        // console.log('packings')
        for (var sp in this.selectedPackings) {
          // console.log(this.selectedPackings[sp].id)
          this.artwork_ownership_log.artwork_packing_id = this.selectedPackings[sp].id;
          // console.log(this.artwork_ownership_log);
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$globals.apiserver + "/artwork_ownership_logs.json", {
            artwork_ownership_log: this.artwork_ownership_log
          }).then(function (response) {
            _this2.errors = {};
            // this.artwork.artwork_ownership_logs.push(response.data);
            // @artwork.artwork_ownership_id = @artwork_ownership_log.id
            // elsif @artwork_ownership_log.copy = 'master_physical'
            // @artwork.master_physical_ownership_id = @artwork_ownership_log.id
            // elsif @artwork_ownership_log.copy = 'archive_master'
            // @artwork.archive_master_ownership_id = @artwork_ownership_log.id
            // elsif @artwork_ownership_log.copy = 'access_copy'
            // @artwork.access_copy_ownership_id = @artwork_ownership_log.id
            // this.active_artwork_ownership_logs = this.artwork.artwork_ownership_logs
            _this2.$store.commit("ADD_LOG", response.data);
            _this2.active_artwork_ownership_logs = _this2.$store.state.artwork_ownership_logs;
            _this2.showUpload = !_this2.showUpload;
          }).catch(function (error) {
            // console.log(error);
            // this.errors = error.response.data;
          });
        }
        this.artwork_ownership_log = {
          storage: "in",
          note: "",
          change_date: "",
          copy: "artwork",
          shipper: "",
          reason: "",
          artwork_ownership_id: "",
          artwork_packing_id: ""
        };
      } else {
        // console.log('single')
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$globals.apiserver + "/artwork_ownership_logs.json", {
          artwork_ownership_log: this.artwork_ownership_log
        }).then(function (response) {
          _this2.errors = {};
          _this2.artwork.artwork_ownership_logs.push(response.data);
          if (_this2.artwork_ownership_log.copy == "artwork") {
            _this2.artwork.artwork_ownership_id = _this2.artwork_ownership_log.artwork_ownership_id;
          } else if (_this2.artwork_ownership_log.copy == "master_physical") {
            _this2.artwork.master_physical_ownership_id = _this2.artwork_ownership_log.artwork_ownership_id;
          } else if (_this2.artwork_ownership_log.copy == "archive_master") {
            _this2.artwork.archive_master_ownership_id = _this2.artwork_ownership_log.artwork_ownership_id;
          } else if (_this2.artwork_ownership_log.copy == "access_copy") {
            _this2.artwork.access_copy_ownership_id = _this2.artwork_ownership_log.artwork_ownership_id;
          }
          _this2.$store.commit("ADD_LOG", response.data);
          _this2.active_artwork_ownership_logs = _this2.$store.state.artwork_ownership_logs;
          _this2.showUpload = !_this2.showUpload;
          _this2.artwork_ownership_log = {
            storage: "in",
            note: "",
            change_date: "",
            copy: "artwork",
            shipper: "",
            reason: "",
            artwork_ownership_id: "",
            artwork_packing_id: ""
          };
        }).catch(function (error) {
          // console.log(error);
        });
      }

      // var aartwork_ownership_log = Object.keys(this.artwork_ownership_log).forEach(k => this.artwork_ownership_log[k]='')
      // console.log(aartwork_ownership_log)
    }
  }
});

/***/ }),

/***/ "81r7":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/* axios v0.11.1 | (c) 2016 by Matt Zabriskie */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["axios"] = factory();
	else
		root["axios"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(2);
	var utils = __webpack_require__(3);
	var dispatchRequest = __webpack_require__(4);
	var InterceptorManager = __webpack_require__(13);
	var isAbsoluteURL = __webpack_require__(14);
	var combineURLs = __webpack_require__(15);
	var bind = __webpack_require__(16);
	var transformData = __webpack_require__(8);
	
	function Axios(defaultConfig) {
	  this.defaults = utils.merge({}, defaultConfig);
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Don't allow overriding defaults.withCredentials
	  config.withCredentials = config.withCredentials || this.defaults.withCredentials;
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	var defaultInstance = new Axios(defaults);
	var axios = module.exports = bind(Axios.prototype.request, defaultInstance);
	module.exports.Axios = Axios;
	
	// Expose properties from defaultInstance
	axios.defaults = defaultInstance.defaults;
	axios.interceptors = defaultInstance.interceptors;
	
	// Factory for creating new instances
	axios.create = function create(defaultConfig) {
	  return new Axios(defaultConfig);
	};
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(17);
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	  axios[method] = bind(Axios.prototype[method], defaultInstance);
	});


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(3);
	
	var PROTECTION_PREFIX = /^\)\]\}',?\n/;
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	module.exports = {
	  transformRequest: [function transformRequest(data, headers) {
	    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isStream(data)) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isObject(data) && !utils.isFile(data) && !utils.isBlob(data)) {
	      // Set application/json if no Content-Type has been specified
	      if (!utils.isUndefined(headers)) {
	        utils.forEach(headers, function processContentTypeHeader(val, key) {
	          if (key.toLowerCase() === 'content-type') {
	            headers['Content-Type'] = val;
	          }
	        });
	
	        if (utils.isUndefined(headers['Content-Type'])) {
	          headers['Content-Type'] = 'application/json;charset=utf-8';
	        }
	      }
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      data = data.replace(PROTECTION_PREFIX, '');
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  headers: {
	    common: {
	      'Accept': 'application/json, text/plain, */*'
	    },
	    patch: utils.merge(DEFAULT_CONTENT_TYPE),
	    post: utils.merge(DEFAULT_CONTENT_TYPE),
	    put: utils.merge(DEFAULT_CONTENT_TYPE)
	  },
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};


/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  typeof document.createElement -> undefined
	 */
	function isStandardBrowserEnv() {
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined' &&
	    typeof document.createElement === 'function'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object' && !isArray(obj)) {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  trim: trim
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Dispatch a request to the server using whichever adapter
	 * is supported by the current environment.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  return new Promise(function executor(resolve, reject) {
	    try {
	      var adapter;
	
	      if (typeof config.adapter === 'function') {
	        // For custom adapter support
	        adapter = config.adapter;
	      } else if (typeof XMLHttpRequest !== 'undefined') {
	        // For browsers use XHR adapter
	        adapter = __webpack_require__(5);
	      } else if (typeof process !== 'undefined') {
	        // For node use HTTP adapter
	        adapter = __webpack_require__(5);
	      }
	
	      if (typeof adapter === 'function') {
	        adapter(resolve, reject, config);
	      }
	    } catch (e) {
	      reject(e);
	    }
	  });
	};
	


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(3);
	var buildURL = __webpack_require__(6);
	var parseHeaders = __webpack_require__(7);
	var transformData = __webpack_require__(8);
	var isURLSameOrigin = __webpack_require__(9);
	var btoa = (typeof window !== 'undefined' && window.btoa) || __webpack_require__(10);
	var settle = __webpack_require__(11);
	
	module.exports = function xhrAdapter(resolve, reject, config) {
	  var requestData = config.data;
	  var requestHeaders = config.headers;
	
	  if (utils.isFormData(requestData)) {
	    delete requestHeaders['Content-Type']; // Let the browser set it
	  }
	
	  var request = new XMLHttpRequest();
	  var loadEvent = 'onreadystatechange';
	  var xDomain = false;
	
	  // For IE 8/9 CORS support
	  // Only supports POST and GET calls and doesn't returns the response headers.
	  // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	  if (("production") !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
	    request = new window.XDomainRequest();
	    loadEvent = 'onload';
	    xDomain = true;
	    request.onprogress = function handleProgress() {};
	    request.ontimeout = function handleTimeout() {};
	  }
	
	  // HTTP basic authentication
	  if (config.auth) {
	    var username = config.auth.username || '';
	    var password = config.auth.password || '';
	    requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	  }
	
	  request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	  // Set the request timeout in MS
	  request.timeout = config.timeout;
	
	  // Listen for ready state
	  request[loadEvent] = function handleLoad() {
	    if (!request || (request.readyState !== 4 && !xDomain)) {
	      return;
	    }
	
	    // The request errored out and we didn't get a response, this will be
	    // handled by onerror instead
	    if (request.status === 0) {
	      return;
	    }
	
	    // Prepare the response
	    var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	    var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	    var response = {
	      data: transformData(
	        responseData,
	        responseHeaders,
	        config.transformResponse
	      ),
	      // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
	      status: request.status === 1223 ? 204 : request.status,
	      statusText: request.status === 1223 ? 'No Content' : request.statusText,
	      headers: responseHeaders,
	      config: config,
	      request: request
	    };
	
	    settle(resolve, reject, response);
	
	    // Clean up request
	    request = null;
	  };
	
	  // Handle low level network errors
	  request.onerror = function handleError() {
	    // Real errors are hidden from us by the browser
	    // onerror should only fire if it's a network error
	    reject(new Error('Network Error'));
	
	    // Clean up request
	    request = null;
	  };
	
	  // Handle timeout
	  request.ontimeout = function handleTimeout() {
	    var err = new Error('timeout of ' + config.timeout + 'ms exceeded');
	    err.timeout = config.timeout;
	    err.code = 'ECONNABORTED';
	    reject(err);
	
	    // Clean up request
	    request = null;
	  };
	
	  // Add xsrf header
	  // This is only done if running in a standard browser environment.
	  // Specifically not if we're in a web worker, or react-native.
	  if (utils.isStandardBrowserEnv()) {
	    var cookies = __webpack_require__(12);
	
	    // Add xsrf header
	    var xsrfValue = config.withCredentials || isURLSameOrigin(config.url) ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	    if (xsrfValue) {
	      requestHeaders[config.xsrfHeaderName] = xsrfValue;
	    }
	  }
	
	  // Add headers to the request
	  if ('setRequestHeader' in request) {
	    utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	      if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	        // Remove Content-Type if data is undefined
	        delete requestHeaders[key];
	      } else {
	        // Otherwise add header to the request
	        request.setRequestHeader(key, val);
	      }
	    });
	  }
	
	  // Add withCredentials to request if needed
	  if (config.withCredentials) {
	    request.withCredentials = true;
	  }
	
	  // Add responseType to request if needed
	  if (config.responseType) {
	    try {
	      request.responseType = config.responseType;
	    } catch (e) {
	      if (request.responseType !== 'json') {
	        throw e;
	      }
	    }
	  }
	
	  // Handle progress if needed
	  if (config.progress) {
	    if (config.method === 'post' || config.method === 'put') {
	      request.upload.addEventListener('progress', config.progress);
	    } else if (config.method === 'get') {
	      request.addEventListener('progress', config.progress);
	    }
	  }
	
	  if (requestData === undefined) {
	    requestData = null;
	  }
	
	  // Send the request
	  request.send(requestData);
	};


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(3);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};
	


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(3);
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	    }
	  });
	
	  return parsed;
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(3);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(3);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ },
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ },
/* 11 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(response);
	  }
	};


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(3);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(3);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
	};


/***/ },
/* 16 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ },
/* 17 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }
/******/ ])
});
;
//# sourceMappingURL=axios.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "88K4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"mt-0 ml-4",attrs:{"column":""}},[_c('header-elements',{attrs:{"icon":"mdi-power-plug","title":"Electrical"},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),_c('elements-table',{attrs:{"items":_vm.all_electricals,"showUpload":_vm.showUpload,"title":"Electric Device","icons":true},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),(_vm.showUpload)?_c('v-card',{staticClass:"px-5 pt-0 elevation-1"},[_c('v-card-title',{staticClass:"px-0"},[_c('span',{staticClass:"subbheadline xs12"},[_vm._v("Add new Electrical Material ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"pr-0 mr-0",attrs:{"small":""},on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("close")]),_vm._v(" CANCEL")],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-radio-group',{staticClass:"flex xs12 mb-2",attrs:{"row":"","label":""},model:{value:(_vm.electrical.category),callback:function ($$v) {_vm.$set(_vm.electrical, "category", $$v)},expression:"electrical.category"}},_vm._l((_vm.categories),function(s){return _c('v-radio',{key:s.id,class:{ 'px-4 py-3 ml-0 mr-0 elevation-1': _vm.electrical.category != s.id, 'px-4 py-3 ml-0 mr-0 elevation-4': _vm.electrical.category == s.id },attrs:{"label":s.name,"value":s.id,"off-icon":s.off_icon,"on-icon":s.on_icon}})}),1),_vm._v(" "),(_vm.electrical.category=='monitor')?_c('v-flex',{attrs:{"xs12":"","mx-0":"","my-0":"","py-0":""}},[_c('v-radio-group',{attrs:{"row":"","label":""},model:{value:(_vm.electrical.specs),callback:function ($$v) {_vm.$set(_vm.electrical, "specs", $$v)},expression:"electrical.specs"}},_vm._l((_vm.constants.MONITORS),function(vs){return _c('v-radio',{key:vs.id,staticClass:"ml-3",attrs:{"value":vs.title,"label":vs.title}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.electrical.category=='projector')?_c('v-flex',{attrs:{"xs12":"","mx-0":""}},[_c('v-radio-group',{attrs:{"row":"","label":""},model:{value:(_vm.electrical.specs),callback:function ($$v) {_vm.$set(_vm.electrical, "specs", $$v)},expression:"electrical.specs"}},_vm._l((_vm.constants.PROJECTORS),function(vs){return _c('v-radio',{key:vs.id,staticClass:"ml-3",attrs:{"value":vs.title,"label":vs.title}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.electrical.category=='motor')?_c('v-flex',{attrs:{"xs12":"","mx-0":""}},[_c('v-radio-group',{attrs:{"row":"","label":""},model:{value:(_vm.electrical.specs),callback:function ($$v) {_vm.$set(_vm.electrical, "specs", $$v)},expression:"electrical.specs"}},_vm._l((_vm.constants.MOTORS),function(vs){return _c('v-radio',{key:vs.id,staticClass:"ml-3",attrs:{"value":vs.title,"label":vs.title}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.electrical.category=='bulb')?_c('v-flex',{attrs:{"xs12":"","mx-0":""}},[_c('v-radio-group',{attrs:{"row":"","label":""},model:{value:(_vm.electrical.specs),callback:function ($$v) {_vm.$set(_vm.electrical, "specs", $$v)},expression:"electrical.specs"}},_vm._l((_vm.constants.BULBS),function(vs){return _c('v-radio',{key:vs.id,staticClass:"ml-3",attrs:{"value":vs.title,"label":vs.title}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.electrical.specs=='Other')?_c('v-flex',{attrs:{"xs12":"","mx-3":""}},[_c('v-text-field',{attrs:{"label":"Other"},model:{value:(_vm.electrical.other),callback:function ($$v) {_vm.$set(_vm.electrical, "other", $$v)},expression:"electrical.other"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mx-0":""}},[_c('v-radio-group',{attrs:{"row":"","label":"Origin"},model:{value:(_vm.electrical.origin),callback:function ($$v) {_vm.$set(_vm.electrical, "origin", $$v)},expression:"electrical.origin"}},_vm._l((_vm.constants.ORIGINS),function(vs){return _c('v-radio',{key:vs.id,staticClass:"ml-3",attrs:{"value":vs.id,"label":vs.title}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"label":"Title"},model:{value:(_vm.electrical.title),callback:function ($$v) {_vm.$set(_vm.electrical, "title", $$v)},expression:"electrical.title"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6 pr-3"},[_c('v-text-field',{attrs:{"label":"Brand"},model:{value:(_vm.electrical.brand),callback:function ($$v) {_vm.$set(_vm.electrical, "brand", $$v)},expression:"electrical.brand"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6"},[_c('v-text-field',{attrs:{"label":"Type and Model"},model:{value:(_vm.electrical.type),callback:function ($$v) {_vm.$set(_vm.electrical, "type", $$v)},expression:"electrical.type"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6 pr-3"},[_c('v-text-field',{attrs:{"label":"Serial Number"},model:{value:(_vm.electrical.sn),callback:function ($$v) {_vm.$set(_vm.electrical, "sn", $$v)},expression:"electrical.sn"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6"},[_c('v-text-field',{attrs:{"label":"Accession Number Tech Database TBA21"},model:{value:(_vm.electrical.an),callback:function ($$v) {_vm.$set(_vm.electrical, "an", $$v)},expression:"electrical.an"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{staticClass:"body-2"},[_vm._v("Date of Production")]),_vm._v(" "),_c('v-date-picker',{attrs:{"landscape":"","label":"Accession Date"},model:{value:(_vm.electrical.production_date),callback:function ($$v) {_vm.$set(_vm.electrical, "production_date", $$v)},expression:"electrical.production_date"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Interfaces"},model:{value:(_vm.electrical.ionterfaces),callback:function ($$v) {_vm.$set(_vm.electrical, "ionterfaces", $$v)},expression:"electrical.ionterfaces"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6 pr-3"},[_c('v-text-field',{attrs:{"label":"Number of Parts"},model:{value:(_vm.electrical.number_of_parts),callback:function ($$v) {_vm.$set(_vm.electrical, "number_of_parts", $$v)},expression:"electrical.number_of_parts"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Power Requirement"},model:{value:(_vm.electrical.power_requirement),callback:function ($$v) {_vm.$set(_vm.electrical, "power_requirement", $$v)},expression:"electrical.power_requirement"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Specifications on installation"},model:{value:(_vm.electrical.installation_specifications),callback:function ($$v) {_vm.$set(_vm.electrical, "installation_specifications", $$v)},expression:"electrical.installation_specifications"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Modification"},model:{value:(_vm.electrical.modification),callback:function ($$v) {_vm.$set(_vm.electrical, "modification", $$v)},expression:"electrical.modification"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Periphals"},model:{value:(_vm.electrical.periphals),callback:function ($$v) {_vm.$set(_vm.electrical, "periphals", $$v)},expression:"electrical.periphals"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Associated items"},model:{value:(_vm.electrical.associated_items),callback:function ($$v) {_vm.$set(_vm.electrical, "associated_items", $$v)},expression:"electrical.associated_items"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md3 pr-3"},[_c('v-text-field',{attrs:{"suffix":"cm","label":"Height"},model:{value:(_vm.electrical.height),callback:function ($$v) {_vm.$set(_vm.electrical, "height", $$v)},expression:"electrical.height"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md3 pr-3"},[_c('v-text-field',{attrs:{"suffix":"cm","label":"Width"},model:{value:(_vm.electrical.width),callback:function ($$v) {_vm.$set(_vm.electrical, "width", $$v)},expression:"electrical.width"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md3 pr-3"},[_c('v-text-field',{attrs:{"suffix":"cm","label":"Depth"},model:{value:(_vm.electrical.depth),callback:function ($$v) {_vm.$set(_vm.electrical, "depth", $$v)},expression:"electrical.depth"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md3"},[_c('v-text-field',{attrs:{"suffix":"cm","label":"Weight"},model:{value:(_vm.electrical.weight),callback:function ($$v) {_vm.$set(_vm.electrical, "weight", $$v)},expression:"electrical.weight"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 ml-3 mb-3"},[_c('v-btn',{on:{"click":_vm.save_electrical}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_vm._v("cancel")])],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are you sure you want to delete this device?")]),_vm._v(" "),_c('v-card-text',[_vm._v(" This Device will be deleted. ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.deleteDevice}},[_vm._v(" Yes")])],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "8NsR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubSectionHeader_vue__ = __webpack_require__("L+VH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad4166b8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubSectionHeader_vue__ = __webpack_require__("Xz4u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("i9hz")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad4166b8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubSectionHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad4166b8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubSectionHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad4166b8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubSectionHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "8db/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticStyle:{"top":"65px","position":"fixed"},attrs:{"fixed":"","tabs":"","color":"white elevation-0"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.processedArtist.name)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm.processedArtist.last_name)+", "+_vm._s(_vm.processedArtist.first_name))]),_vm._v(" "),_c('v-tabs',{attrs:{"slot":"extension","color":"transparent","slider-color":"purple","align-with-title":""},slot:"extension",model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},_vm._l((this.constants.ARTIST.tabs),function(tab){return _c('v-tab',{key:tab.key,attrs:{"ripple":false,"href":'#tab-' + tab.key},on:{"click":function($event){return _vm.saveCurrentTab('tab-' + tab.key)}}},[_vm._v("\n        "+_vm._s(tab.title)+"\n      ")])}),1)],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},_vm._l((this.constants.ARTIST.tabs),function(tab){return _c('v-tab-item',{key:tab.key,attrs:{"id":'tab-' + tab.key}},[(!tab.component)?_c('v-card',{attrs:{"flat":""}},[(tab.fields)?_c('v-card-text',_vm._l((tab.fields),function(field){return _c('field-box',{key:field.key,attrs:{"artist":_vm.processedArtist,"field":field}})}),1):_vm._e()],1):_c('v-card',{attrs:{"flat":""}},[_c(tab.component,{tag:"component",attrs:{"artist":_vm.processedArtist}})],1)],1)}),1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "8hqa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-2"},[(_vm.table_artists.length > 0)?_c('v-list',{staticClass:"mx-0 px-0 mb-2",attrs:{"two-line":""}},[_vm._l((_vm.table_artists),function(item,index){return [_c('v-list-tile',{key:item.id},[_vm._v(_vm._s(item.key)+"\n        "),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-list-tile-avatar',[_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_c('span',_vm._g({},data.on),[_c('v-btn',{staticStyle:{"width":"20px","height":"20px"},attrs:{"round":"","color":"red","icon":"","small":"","dense":"","hint":"Remove Artist from Text"},on:{"click":function($event){return _vm.remove_from_text(item.id)}}},[_c('v-icon',{attrs:{"small":"","dense":"","color":"white"}},[_vm._v("remove")])],1)],1)]}}],null,true)},[_vm._v("\n            Remove Artist from Text\n          ")])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',{staticClass:"ml-0 pl-0"},[_c('v-list-tile-sub-title',{staticClass:"subheading"},[_c('router-link',{attrs:{"to":{ name: 'EditArtist', params: {id: item.id, artist: item}, path: ("/artists/edit/" + (item.id))}}},[_c('b',[_vm._v(_vm._s(item.name))])])],1),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n            "+_vm._s(_vm.get_location_name(item.artist_location_id))+"\n            ")])],1)],1)]})],2):[_c('p',{staticClass:"my-0 mx-0 px-0 text-xs-left align-left justify-left"},[_vm._v("No Artists")])]],2)}
var staticRenderFns = []


/***/ }),

/***/ "8prl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['items', 'icons', 'title', 'showUpload'],
  data: function data() {
    return {
      items2: '',
      editedItem: '',
      deletingItem: '',
      showUploadLocal: _this.showUpload,
      dialog: false
    };
  },
  methods: {
    category: function category(e) {
      var a = this.$store.state.categories.find(function (f) {
        return f == e.type;
      });
      if (a) {
        return a.name;
      } else {
        return '';
      }
      return;
    },
    showUploadForm: function showUploadForm() {
      this.showUploadLocal = !this.showUploadLocal;
      this.$emit('showUpload', !this.showUploadLocal);
    },
    deleteDevice: function deleteDevice(d) {
      // var index = exhibition_artworks.indexOf(e);
      // console.log('index = ' + index)
      // exhibition_artworks.splice(index,1)
      this.$store.dispatch('deleteDevice', d);
      this.dialog = false;
    },
    edit: function edit(e) {
      this.editedItem = e;
      this.showUpload = true;
    },
    deleteItem: function deleteItem(d) {
      // var index = exhibition_artworks.indexOf(e);
      // console.log('index = ' + index)
      // exhibition_artworks.splice(index,1)
      this.$store.dispatch('deleteDevice', d);
      this.dialog = false;
    },
    saveIteml: function saveIteml() {
      this.electrical.artwork_id = this.artwork.id;
      this.electrical.done = false;
      this.electrical.id = this.findMinMax(this.all_electricals) + 1;
      this.$store.commit('ADD_ELECTRICAL', this.electrical);
      // this.all_electricals.push(this.electrical)
      this.showUpload = !this.showUpload;
      this.electrical = {
        description: '',
        title: '',
        deadline: '',
        done: false
        // var aelectrical = Object.keys(this.electrical).forEach(k => this.electrical[k]='')
        // console.log(aelectrical)
      };
    }
  }
});

/***/ }),

/***/ "9++d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"mt-0 ml-4",attrs:{"column":""}},[_c('header-elements',{attrs:{"icon":"mdi-volume-high","title":"Audio"},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),_c('elements-table',{attrs:{"items":_vm.audios,"showUpload":_vm.showUpload,"title":"Audio"},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showUpload),expression:"showUpload"}],staticClass:"mt-0 mb-0 xs12"},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v("\n        Cancel\n      ")],1),_vm._v(" "),(_vm.showUpload)?_c('v-flex',[_c('v-container',{staticClass:"elevation-3",attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('h4',{staticClass:"headline"},[_vm._v("Add new audio")]),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"label":"Title"},model:{value:(_vm.audio.title),callback:function ($$v) {_vm.$set(_vm.audio, "title", $$v)},expression:"audio.title"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6 pr-3"},[_c('v-select',{staticClass:"ml-0",attrs:{"items":_vm.constants.CHANNELS,"item-value":"id","item-text":"name","label":"Channels"},model:{value:(_vm.audio.channels),callback:function ($$v) {_vm.$set(_vm.audio, "channels", $$v)},expression:"audio.channels"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6"},[_c('v-select',{staticClass:"ml-0",attrs:{"items":_vm.constants.AUDIO_RESOLUTIONS,"item-value":"id","item-text":"name","label":"Audio Resolution"},model:{value:(_vm.audio.audio_resolution),callback:function ($$v) {_vm.$set(_vm.audio, "audio_resolution", $$v)},expression:"audio.audio_resolution"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6 pr-3"},[_c('v-radio-group',{attrs:{"label":"Audio Bit","column":""},model:{value:(_vm.audio.audio_bit),callback:function ($$v) {_vm.$set(_vm.audio, "audio_bit", $$v)},expression:"audio.audio_bit"}},_vm._l((_vm.constants.AUDIO_BITS),function(s){return _c('v-radio',{key:s.id,staticClass:"ml-3",attrs:{"label":s.name,"value":s.id}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6"},[_c('v-text-field',{attrs:{"label":"Audio Container | Codec","hint":"MP3, AAC, AC3 etc."},model:{value:(_vm.audio.audio_container),callback:function ($$v) {_vm.$set(_vm.audio, "audio_container", $$v)},expression:"audio.audio_container"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6 pr-3"},[_c('v-text-field',{attrs:{"label":"Bitrate in Mbps","suffix":"Mbps"},model:{value:(_vm.audio.bitrate_mbps),callback:function ($$v) {_vm.$set(_vm.audio, "bitrate_mbps", $$v)},expression:"audio.bitrate_mbps"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6"},[_c('v-text-field',{attrs:{"label":"File Size","suffix":"MB"},model:{value:(_vm.audio.filesize),callback:function ($$v) {_vm.$set(_vm.audio, "filesize", $$v)},expression:"audio.filesize"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"label":"Other Specifications","auto-grow":"","rows":"1"},model:{value:(_vm.audio.other_specifications),callback:function ($$v) {_vm.$set(_vm.audio, "other_specifications", $$v)},expression:"audio.other_specifications"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"label":"Associated Information carriers (format migration story)","auto-grow":"","rows":"1"},model:{value:(_vm.audio.associated_information),callback:function ($$v) {_vm.$set(_vm.audio, "associated_information", $$v)},expression:"audio.associated_information"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"label":"Notes","auto-grow":"","rows":"1"},model:{value:(_vm.audio.notes),callback:function ($$v) {_vm.$set(_vm.audio, "notes", $$v)},expression:"audio.notes"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{staticClass:"body-2"},[_vm._v("Creation Date")]),_vm._v(" "),_c('v-date-picker',{attrs:{"landscape":"","label":"Creation Date"},model:{value:(_vm.audio.creation_date),callback:function ($$v) {_vm.$set(_vm.audio, "creation_date", $$v)},expression:"audio.creation_date"}})],1),_vm._v(" "),(_vm.audios && _vm.audios.length>0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-list',{staticClass:"xs12"},[_vm._l((_vm.audios),function(f){return _c('v-list-tile',{key:f.id},[_c('v-list-tile-title',[_c('b',[_vm._v(_vm._s(f.title))])]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("audio_container: "+_vm._s(f.audio_container))]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("bitrate: "+_vm._s(f.bitrate))]),_vm._v(" "),(_vm.c_user.edit)?_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.done_audio}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit")])],1)],1):_vm._e(),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.delete_audio}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("delete")])],1)],1):_vm._e()],1)}),_vm._v(" "),_c('v-divider')],2)],1):_vm._e()],1)],1),_vm._v(" "),(_vm.c_user.edit)?_c('v-btn',{on:{"click":_vm.add}},[_vm._v("save")]):_vm._e(),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_vm._v("cancel")])],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "92ck":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import moment from 'moment'

function nl2br(str, is_xhtml) {
  var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      f_field: this.field,
      f_artist: this.artist,
      f_artwork: this.artwork,
      item: {
        title: 'Artist',
        value: 'Artist name'
      }
    };
  },

  props: ['field', 'artist', 'artwork'],
  methods: {
    format_date: function format_date(date, format) {
      var moment = __webpack_require__("PJh5");
      var ndate = new Date(date);
      return moment(ndate).format(format);
      // console.log(ndate)
    }
  },
  computed: {
    value_calculated: function value_calculated() {
      var output = '';
      switch (this.f_field.table) {
        case 'artists':
          if (this.f_field.name) output = nl2br(this.f_artist[this.field.name]);else output = 'no artist name entered in cms';
          break;
        case 'artwork_locations':
          output = nl2br(this.f_artwork[this.f_field.association][this.f_field.name]);
          break;
        case 'contacts':
          output = nl2br(this.f_artwork[this.f_field.association][this.f_field.name]);
          break;
        default:
          output = nl2br(this.f_artwork[this.f_field.name]);
          if (this.f_field.suffix) {
            output += this.f_field.suffix;
          }
      }
      return output;
    },
    value_from_array: function value_from_array() {
      var v = this.value_calculated;
      return this.f_field.options[v];
    },
    value_calculated_empty: function value_calculated_empty() {
      var output = '';
      switch (this.f_field.table) {
        case 'artists':
          if (typeof this.f_artist !== 'undefined') {
            output = this.f_artist[this.f_field.name];
          } else {
            output = '';
          }
          break;
        case 'artwork_locations':
          if (typeof this.f_artwork[this.f_field.association] !== 'undefined') {
            output = this.f_artwork[this.f_field.association][this.f_field.name];
          } else {
            output = '';
          }
          break;
        case 'contacts':
          if (typeof this.f_artwork[this.f_field.association] !== 'undefined') {
            output = this.f_artwork[this.f_field.association][this.f_field.name];
          } else {
            output = '';
          }
          break;
        default:
          output = this.f_artwork[this.f_field.name];
      }
      var o = false;
      if (output == '' || output == undefined || output == null) {
        o = false;
      } else {
        o = true;
      }
      return o;
    }
  }
});

/***/ }),

/***/ "93eS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_artworks_NewExhibitionHistory__ = __webpack_require__("SCHX");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      view: 'advanced',
      show_form: false,
      dialog: false,
      show: true
      // exhibitions: this.exhibitions2
    };
  },
  // created () {
  //   this.reset_view()
  // },
  methods: {
    deleteExhibition: function deleteExhibition(e) {
      // var index = exhibition_artworks.indexOf(e);
      // console.log('index = ' + index)
      // exhibition_artworks.splice(index,1)
      this.$store.dispatch('deleteExhibition', e);
      this.dialog = false;
    }
    // reset_view () {
    //   var ee = this.store_e
    //   this.exhibitions = this.exhibitions2
    //   // console.log('reset_view')
    //   // console.log(this.exhibitions2)
    // }

  },
  computed: {
    store_e: function store_e() {
      // console.log('store_e')
      return this.$store.state.exhibitions;
    },
    exhibitions: function exhibitions() {
      var _this = this;

      // console.log('exa')
      var out = this.store_e.filter(function (t) {
        return t.artworks.map(function (a) {
          return a = a.artwork_id;
        }).includes(_this.artwork.id);
      });
      var out = out.filter(function (e) {
        return e.loan == 1;
      });
      return out;
    }
  },
  components: { NewExhibitionHistory: __WEBPACK_IMPORTED_MODULE_0__components_artworks_NewExhibitionHistory__["a" /* default */] }
});

/***/ }),

/***/ "9PtX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9Wdk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTodo_vue__ = __webpack_require__("12Kk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d94ffe46_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTodo_vue__ = __webpack_require__("RwQT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("MaEM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d94ffe46"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddTodo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d94ffe46_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTodo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d94ffe46_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddTodo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9eRG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9oj1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editBG pt-3 mt-4"},[_c('v-layout',{staticStyle:{"background-color":"white","height":"50px","width":"100%","top":"135px","position":"fixed","z-index":"1"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}})],1),_vm._v(" "),_c('v-toolbar',{staticClass:"elevation-1 mt-2",staticStyle:{"top":"155px","position":"fixed","z-index":"1"},attrs:{"tabs":"","color":"white"}},[_c('h4',{staticClass:"pl-3 headline font-weight-light",domProps:{"innerHTML":_vm._s(_vm.location_get.name)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":"","disabled":!_vm.valid,"right":""},on:{"click":_vm.save}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("save")])],1)],1),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{staticClass:"pl-2 pr-2 pt-4 mt-4 elevation-0 editBG"},[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-3 py-0 mx-2 my-3 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("Basic")])]),_vm._v(" "),_c('v-flex',{staticClass:"px-3 mt-1",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Location Name"},model:{value:(_vm.location_get.name),callback:function ($$v) {_vm.$set(_vm.location_get, "name", $$v)},expression:"location_get.name"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-3",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"city"},model:{value:(_vm.location_get.city),callback:function ($$v) {_vm.$set(_vm.location_get, "city", $$v)},expression:"location_get.city"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","px-3":""}},[_c('v-autocomplete',{attrs:{"items":this.countries,"label":"Select Country","clearable":""},model:{value:(_vm.location_get.country_id),callback:function ($$v) {_vm.$set(_vm.location_get, "country_id", $$v)},expression:"location_get.country_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","px-3":""}},[_c('v-textarea',{attrs:{"auto-grow":"","clearable":"","rows":"1","label":"Note"},model:{value:(_vm.location_get.admin_note),callback:function ($$v) {_vm.$set(_vm.location_get, "admin_note", $$v)},expression:"location_get.admin_note"}})],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xs":"","fluid":"","ml-3":"","pr-5":"","mt-0":"","pt-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h3',{staticClass:"pb-2"},[_vm._v("\n              List of artworks currently at this location ("+_vm._s(_vm.artworks.length)+")\n            ")]),_vm._v(" "),_c('v-list',{staticClass:"mr-2",attrs:{"two-line":""}},_vm._l((_vm.artworks),function(a){return _c('v-list-tile',{key:a.id},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('router-link',{attrs:{"to":{
                        name: 'EditArtwork',
                        params: { id: a.id, artwork: a },
                        path: ("/artworks/edit/" + (a.id))
                      }}},[_vm._v("\n                      "+_vm._s(a.title)+"\n                    ")]),_vm._v(" "),_c('a',{staticStyle:{"margin":"10px"},attrs:{"href":((_vm.$globals.oldserver) + "/artworks/edit/" + (a.id)),"icon":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("open_in_new")])],1)],1),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(a.full_name))])],1)],1)}),1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "AAWU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticStyle:{"top":"65px","position":"fixed"},attrs:{"tabs":"","color":"white elevation-2"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(this.artwork.title)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(this.artwork.artist.name))]),_vm._v(" "),_c('v-tabs',{attrs:{"slot":"extension","color":"transparent","slider-color":"yellow","align-with-title":""},slot:"extension",model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},_vm._l((this.fields.tabs),function(tab){return _c('v-tab',{key:tab.key,attrs:{"ripple":false,"href":'#tab-' + tab.key},on:{"click":function($event){return _vm.saveCurrentTab('tab-' + tab.key)}}},[_vm._v("\n        "+_vm._s(tab.title)+"\n      ")])}),1)],1),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"top":"120px"},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},_vm._l((this.fields.tabs),function(tab){return _c('v-tab-item',{key:tab.key,attrs:{"id":'tab-' + tab.key}},[(!tab.component)?_c('v-card',{attrs:{"flat":""}},[(tab.fields)?_c('v-card-text',_vm._l((tab.fields),function(field){return _c('field-box',{key:field.key,attrs:{"artwork":_vm.processedArtwork,"artist":_vm.processedArtwork.artist,"field":field}})}),1):_vm._e()],1):_c('v-card',{attrs:{"flat":""}},[_c(tab.component,{tag:"component",attrs:{"artwork":_vm.processedArtwork}})],1)],1)}),1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "AEQ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text', 'showAddLink'],
  methods: {
    showAdd: function showAdd() {
      this.$emit('showAdd');
    }
  }
});

/***/ }),

/***/ "AS+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editBG pt-0 mt-5 mx-0",staticStyle:{"min-height":"100%","margin":"0 auto"}},[_c('v-snackbar',{attrs:{"auto-height":"","color":_vm.snackbarColor,"right":"","top":"","timeout":_vm.timeout,"vertical":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(_vm._s(_vm.humanize(this.snackbarFieldName)))]),_vm._v(" "),_c('v-navigation-drawer',{staticClass:"px-2 navbar",staticStyle:{"position":"fixed","top":"0px"},attrs:{"width":"320","temporary":"","absolute":"","fixed":"","right":"","dark":"","hide-overlay":""},model:{value:(_vm.options_c),callback:function ($$v) {_vm.options_c=$$v},expression:"options_c"}},[_c('v-layout',{attrs:{"row":"","pt-3":"","pl-2":"","pb-2":""}},[_c('v-flex',[_c('v-subheader',{staticClass:"font-weight-regular display-1 white--text pl-0 ml-0"},[_c('v-spacer'),_vm._v(" "),(_vm.options_c)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.options_c = false}}},[_c('v-icon',{attrs:{"color":"white","x-large":""}},[_vm._v("chevron_right")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3 pb-0 mb-0 white"}),_vm._v(" "),_c('v-list',_vm._l((_vm.user_tabs),function(tab){return _c('v-list-tile',{key:tab.key,class:{
          activeMenu: tab.key == _vm.currentTab,
          'pl-0 ml-4 my-2 mr-4': true,
        },attrs:{"value":"true","avatar":"","active-class":"default-class activeMenu"},on:{"click":function($event){return _vm.setCurrentTab(tab['key'])}},model:{value:(tab.active),callback:function ($$v) {_vm.$set(tab, "active", $$v)},expression:"tab.active"}},[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v(_vm._s(tab.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(tab.title))])],1)],1)}),1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"background-color":"white","height":"50px","width":"100%","top":"120px","position":"fixed","z-index":"1"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}})],1),_vm._v(" "),_c('v-layout',{staticStyle:{"z-index":"1","top":"135px","position":"sticky","width":"100%","border-bottom":"1px solid #999","background-color":"#fff"},attrs:{"mx-0":"","px-3":"","ml-0":"","mt-0":"","pt-0":"","pb-3":""}},[_c('v-flex',{staticClass:"xs8 pl-4 ml-1 mr-0"},[_c('v-flex',{staticClass:"xs12 pb-0 mb-0"},[(_vm.artworkFormData.artist)?_c('h4',{staticClass:"headline font-weight-bold pt-2 pb-1 my-0"},[_c('router-link',{staticClass:"my-0 py-0",attrs:{"to":'/artists/edit/' + _vm.artworkFormData.artist_id}},[_vm._v(_vm._s(_vm.artworkFormData.artist.name))])],1):_c('h4',[_vm._v(_vm._s(_vm.artworkFormData.artist_name))])]),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('h4',{staticClass:"headline py-0 my-0 font-weight-light"},[_c('span',{class:{ 'red--text': _vm.artworkFormData.deaccessioned },domProps:{"innerHTML":_vm._s(
              ((_vm.artworkFormData.title) + ", " + (_vm.artworkFormData.production_date_new))
            )}})]),_vm._v(" "),(_vm.artworkFormData.subtitle)?_c('h4',{staticClass:"headline py-0 my-0 font-weight-light"},[_c('span',{class:{ 'red--text': _vm.artworkFormData.deaccessioned },domProps:{"innerHTML":_vm._s(_vm.artworkFormData.subtitle)}})]):_vm._e(),_vm._v(" "),_c('h4',{staticClass:"title py-0 mt-2 font-weight-light"},[_c('span',{domProps:{"innerHTML":_vm._s(("" + (_vm.artworkFormData.accession_number)))}})])])],1),_vm._v(" "),_c('v-layout',{staticClass:"xs4 my-0 pr-3 pt-1 justify-end column"},[_c('v-flex',{staticClass:"xs12 pr-0 mb-0 text-xs-right"},[_c('v-btn',{staticClass:"mx-0 mt-0",staticStyle:{"height":"30px !important"},attrs:{"icon":""},on:{"click":function($event){_vm.options = false
            _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"\n          headline\n          text-uppercase\n          grey--text\n          text--darken-3\n          font-weight-thin\n          text-xs-right\n        "},[(_vm.hasPreviousTab)?_c('v-btn',{staticClass:"mr-2 px-0 mt-0 py-0",staticStyle:{"height":"36px"},attrs:{"icon":""},on:{"click":function($event){return _vm.goToPreviousTab()}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("chevron_left")])],1):_vm._e(),_vm._v(" "),_c('a',{staticClass:"tabswitcher",on:{"click":function($event){_vm.options_c = true}}},[_c('span',[_vm._v(_vm._s(_vm.currentTab))])]),_vm._v(" "),(_vm.hasNextTab)?_c('v-btn',{staticClass:"ml-3 px-0 mr-0 mt-0 py-0",staticStyle:{"height":"36px"},attrs:{"icon":""},on:{"click":function($event){return _vm.goToNextTab()}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("chevron_right")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_vm._l((_vm.fields.tabs),function(tab){return _c('v-flex',{key:tab.key,staticClass:"grey lighten-3 elevation-0 ml-0 pl-0",staticStyle:{"position":"relative","z-index":"0","top":"20px"},attrs:{"id":'tab-' + tab.key}},[(tab.key == _vm.currentTab)?_c('div',[(
          tab.component &&
          _vm.c_user &&
          _vm.c_user.roles &&
          _vm.c_user.roles.find(function (f) { return f.shortcut == tab.role; })
        )?_c('v-card',{staticClass:"editBG mx-0 mt-0 xs12 sm6 elevation-0"},[_c('v-container',{staticClass:"xs12 sm6",attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{staticClass:"xs12",attrs:{"row":"","wrap":""}},[_c(tab.component,{tag:"component",staticClass:"xs12 mx-0 px-0",staticStyle:{"width":"100%"},attrs:{"film":_vm.film,"artwork":_vm.artworkFormData},on:{"showSnackbar":_vm.showSnackbar,"getArtwork":_vm.getArtwork}})],1)],1)],1):_c('v-card',{staticClass:"grey lighten-3 ml-0 pl-0 pr-0 pt-0 elevation-0"},[_c('v-container',{attrs:{"grid-list-xs":"","fluid":"","pt-0":"","px-4":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","px-2":""}},[_c('v-flex',{attrs:{"sm12":"","md6":"","order-sm2":"","order-md1":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.currentFields),function(field){return _c('v-flex',{key:field.name,class:'flex ' + (field.class ? field.class : 'xs12')},[(
                      _vm.c_user.edit &&
                      _vm.artworkFormData[field.condition_field] ==
                        field.condition_value &&
                      ([
                        'deaccession_date',
                        'comment_on_deaccession',
                        'new_ownership',
                        'deaccession_price_offer',
                        'deaccession_price_paid',
                        'invoice_deaccession_papers' ].includes(field.name)
                        ? _vm.artworkFormData.deaccessioned === 1
                        : field.name === 'fvs_subtitle'
                        ? _vm.artworkFormData.type_of_work_id === 7 ||
                          (_vm.artworkFormData.type_of_work_id === 6 &&
                            _vm.artworkFormData.including_film === 1)
                        : true)
                    )?_c('edit-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.df2.indexOf(field['name']) == -1),expression:"df2.indexOf(field['name']) == -1"}],key:field.name,attrs:{"id":field.name,"name":field.name,"artwork":_vm.artworkFormData,"field":field,"film":_vm.film},on:{"show":_vm.show,"showSnackbar":_vm.showSnackbar,"getArtwork":_vm.getArtwork}}):_vm._e(),_vm._v(" "),(_vm.c_user && (!_vm.c_user.edit || _vm.c_user.edit != 1))?_c('read-field',{key:field.name,class:'flex ' + (field.class ? field.class : 'xs12'),attrs:{"id":field.name,"name":field.name,"artwork":_vm.artworkFormData,"field":field,"film":_vm.film}}):_vm._e()],1)}),1)],1),_vm._v(" "),_c('v-flex',{class:{ 'pl-4': _vm.$vuetify.breakpoint.mdAndUp },attrs:{"sm12":"","md6":"","order-sm1":"","order-md2":"","pl-0":"","pr-0":"","mt-0":"","mb-2":""}},[_c('v-flex',{staticStyle:{"z-index":"1","top":"270px","position":"sticky","background-color":"white"},attrs:{"elevation-0":"","xs12":"","ml-0":""}},[(
                    _vm.artworkFormData.top_photo_id &&
                    _vm.artworkFormData.top_photo_id > 0
                  )?_c('v-flex',{staticClass:"mx-auto img white text-xs-center pt-2"},[(_vm.artworkFormData.top_photo_id > 0)?_c('img',{staticStyle:{"max-width":"100%","background-size":"contain"},attrs:{"src":((_vm.$globals.fileserver) + "/data/artwork/" + (_vm.artworkFormData.id) + "/" + (_vm.artworkFormData.top_photo_id) + "_th_big.jpg")}}):_vm._e()]):_c('v-flex',{staticClass:"text-xs-center my-5 py-5"},[_c('div',[_vm._v("No Image available")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text mt-4 px-3 xs12",attrs:{"small":"","round":"","target":"_blank","href":((_vm.$globals.fileserver) + "/upload_image.html?id=" + (_vm.artworkFormData.id) + "&u=" + (_vm.c_user.id)),"color":"black","text--color":"","rel":"noopener noreferrer"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"white"}},[_vm._v("cloud_upload")]),_vm._v("\n                    Upload New\n                  ")],1)],1)],1)],1)],1)],1)],1)],1):_vm._e()])})],2)}
var staticRenderFns = []


/***/ }),

/***/ "AnAQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddArtist_vue__ = __webpack_require__("5RcA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153f91ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArtist_vue__ = __webpack_require__("tpMB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("wBgt")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-153f91ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddArtist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153f91ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArtist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_153f91ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArtist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "AoDk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterCheckbox_vue__ = __webpack_require__("EiZN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26a15086_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterCheckbox_vue__ = __webpack_require__("5yCE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterCheckbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26a15086_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterCheckbox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26a15086_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterCheckbox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ApVW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AvzG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_full_user_fields__ = __webpack_require__("LKPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_constants__ = __webpack_require__("K30H");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EditField from '@/components/artworks/EditField'




function customSort(a, b) {
  var aParts = a.split('.');
  var bParts = b.split('.');
  // console.log(aParts);
  // console.log(bParts);

  var aYear = parseInt(aParts[0].split('_')[1]);
  var bYear = parseInt(bParts[0].split('_')[1]);
  // console.log(aYear);
  // console.log(bYear);

  var aNum = parseInt(aParts[1]);
  var bNum = parseInt(bParts[1]);
  // console.log(aNum);
  // console.log(bNum);

  if (aYear !== bYear) {
    return aYear - bYear;
  }

  if (aNum !== bNum) {
    return aNum - bNum;
  }

  // If there are additional numbers after the dot, sort them too
  if (aParts.length > 2 && bParts.length > 2) {
    var aExtraNum = parseInt(aParts[2]);
    var bExtraNum = parseInt(bParts[2]);

    if (aExtraNum !== bExtraNum) {
      return aExtraNum - bExtraNum;
    }
  }

  // If all criteria are the same, maintain original order
  return 0;
}

function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
// import vue2Dropzone from "vue2-dropzone";
// import "vue2-dropzone/dist/vue2Dropzone.min.css";

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      menu2: false,
      change_date: '',
      constants: __WEBPACK_IMPORTED_MODULE_4__data_constants__["a" /* default */],
      accession_numbers: [],
      // accession_numbers_limited: [],
      processedArtist: '',
      an_exists: false,
      fields: __WEBPACK_IMPORTED_MODULE_3__data_full_user_fields__["a" /* default */],
      valid: true,
      cloud_artwork_folder_name: '',
      cloud_artist_folder_name: '',
      film: {},
      artwork: {
        // id: '',
        // artist_id: '',
        title: '',
        acquired: 'acquired',
        // classification: '',
        initial_change_date: '',
        // change_date: '',
        ownership: '',
        accession_number: '',
        // artwork_location_id: '',
        credit: '',
        // production_date_new: '',
        // accession_date: '',
        // media_material_description: '',
        instalation_includes: [],
        instalation_includes_other: '',
        film_type: ''
      },
      report: {
        date: ''
      },
      success: false,
      menu: false,
      modal: false
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'menu2', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'e1', 1), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'autosave', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'result', ''), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'approved', true), _ref;
  },

  // watch: {
  //   artwork (val) {
  //     console.log('WATCH')
  //     this.get_all_an()
  //   }
  // },
  beforeMount: function beforeMount() {
    this.$store.dispatch('loadArtworks');
    this.artwork.acquired = 'acquired';
    this.get_all_an();
    this.set_an();
    // this.get_latest_an()
    // this.change_an()
    // this.get_all_an_limited()
  },

  methods: {
    set_an: function set_an() {
      this.artwork.accession_number = this.changed_an;
    },
    get_all_an: function get_all_an() {
      var _this = this;

      // console.log('GET_ALL_AN')
      if (this.artwork.acquired != 'acquired') {
        this.artwork.ownership = '';
      }
      var as = [];
      if (this.artwork.acquired === 'acquired') {
        // console.log('ACQUIRED')
        // console.log(this.artwork.ownership)
        // if (this.artwork.ownership === 6) {
        as = this.$store.state.artworks.filter(function (a) {
          return a.acquired === 'acquired' && a.ownership === _this.artwork.ownership && a.accession_number.substring(0, 3) !== 'DEC';
        });
        // } else if (
        //   this.artwork.ownership === 7 ||
        //   this.artwork.ownership === 8
        // ) {
        //   as = this.$store.state.artworks.filter(
        //     a =>
        //       a.acquired === 'acquired' &&
        //       a.ownership === this.artwork.ownership &&
        //       a.accession_number.substring(0, 3) !== 'DEC'
        //   )
        // } else if (this.artwork.ownership === 17) {
        //   as = this.$store.state.artworks.filter(
        //     a =>
        //       a.acquired === 'acquired' &&
        //       a.ownership === this.artwork.ownership &&
        //       a.accession_number.substring(0, 3) !== 'DEC'
        //   )
        // } else if (this.artwork.ownership === 10) {
        //   as = this.$store.state.artworks.filter(
        //     a =>
        //       a.acquired === 'acquired' &&
        //       a.ownership === this.artwork.ownership &&
        //       a.accession_number.substring(0, 3) !== 'DEC'
        //   )
        // } else if (this.artwork.ownership === 11) {
        //   as = this.$store.state.artworks.filter(
        //     a =>
        //       a.acquired === 'acquired' &&
        //       a.ownership === this.artwork.ownership &&
        //       a.accession_number.substring(0, 3) !== 'DEC'
        //   )
        // } else {
        //   as = this.$store.state.artworks.filter(
        //     a =>
        //       a.acquired === 'acquired' &&
        //       ![6, 7, 8, 10, 11, 17].includes(a.ownership) &&
        //       a.accession_number.substring(0, 3) !== 'DEC'
        //   )
        // }
      } else if (this.artwork.acquired === 'commission') {
        as = this.$store.state.artworks.filter(function (a) {
          return a.acquired === 'commission';
        });
      } else if (this.artwork.acquired === 'nontba') {
        as = this.$store.state.artworks.filter(function (a) {
          return a.acquired === 'nontba';
        });
      } else if (this.artwork.acquired === 'com_academy') {
        as = this.$store.state.artworks.filter(function (a) {
          return a.acquired === 'com_academy';
        });
      } else {
        as = this.$store.state.artworks;
      }
      // console.log('as')
      // console.log(as)
      this.accession_numbers = as.map(function (a) {
        return a.accession_number;
      }).sort(customSort).reverse();
      // console.log('this.accession_numbers')
      // console.log(this.accession_numbers)
      this.set_an();
    },
    reloadArtists: function reloadArtists() {
      this.artists = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
    },
    saveAndAddAnother: function saveAndAddAnother() {
      this.saveArtwork(0);
      this.artwork = {
        title: '',
        instalation_includes: [],
        instalation_includes_other: '',
        film_type: ''
      };
      this.e1 = 1;
      // this.$router.push('/artworks/new')
    },

    // saveAndEdit () {
    //   // console.log('saveAndEdit IN')
    //   this.saveArtwork ()
    //   // console.log(this.artwork)
    //   // console.log('saveAndEdit OUT')
    //   this.$router.push({ path:`/artworks/edit/${this.artwork.id}`, artwork: this.artwork})
    // },
    saveArtwork: function saveArtwork(a) {
      var _this2 = this;

      // this.artwork.artwork_location_logs_attributes = [];
      // var artwork_location_log = {};
      this.artwork.created_by = this.c_user.id;
      this.artwork.initial_change_date = this.initial_change_date ? this.initial_change_date : new Date().toISOString().substring(0, 10);

      // artwork_location_log.artwork_id = this.artwork.id;
      // artwork_location_log.storage = "in";
      // artwork_location_log.note = "Created at Artwork record creation in CMS";
      // artwork_location_log.change_date = Date.now;
      // artwork_location_log.artwork_location_id = "";
      // this.artwork.artwork_location_logs_attributes.push(artwork_location_log)

      // console.log('saveArtwork')
      // console.log(this.artwork);
      var url = this.$globals.apiserver + '/artworks.json';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, { artwork: this.artwork }).then(function (response) {
        // console.log(response.data);
        _this2.artwork = response.data;

        // var artwork_location_log = {
        //   created_by: this.c_user.id,
        //   storage: 'in',
        //   note: 'Initial Artwork Creation',
        //   change_date: this.initial_change_date ? this.initial_change_date : new Date.now,
        //   copy: 'artwork',
        //   // shipper: '',
        //   // reason: '',
        //   artwork_id: this.artwork.id,
        //   artwork_location_id: this.artwork.artwork_location_id,
        //   // artwork_packing_id: ''
        // }
        // axiosApi
        //   .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
        //     artwork_location_log: artwork_location_log
        //   })
        //   .then(response => {
        //     this.errors = {}
        //     this.artwork.artwork_location_logs.push(response.data)
        //     // if (this.artwork_location_log.copy === 'artwork') {
        //     //   this.artwork.artwork_location_id = this.artwork_location_log.artwork_location_id
        //     // } else if (this.artwork_location_log.copy === 'master_physical') {
        //     //   this.artwork.master_physical_location_id = this.artwork_location_log.artwork_location_id
        //     // } else if (this.artwork_location_log.copy === 'archive_master') {
        //     //   this.artwork.archive_master_location_id = this.artwork_location_log.artwork_location_id
        //     // } else if (this.artwork_location_log.copy === 'access_copy') {
        //     //   this.artwork.access_copy_location_id = this.artwork_location_log.artwork_location_id
        //     // }
        //     this.$store.commit('ADD_LOG', response.data)
        //     // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
        //   })
        //   .catch(error => {
        //     // console.log(error)
        //   })

        _this2.$store.dispatch('addArtwork', response.data);
        _this2.$store.dispatch('loadArtworks', response.data);
        if (a === 1) {
          // console.log('a === 1 + this.artwork')
          // console.log(this.artwork)
          _this2.$router.push({
            // path: `/artworks/edit/${this.artwork.id}`,
            name: 'EditArtwork',
            params: { id: _this2.artwork.id, artwork: _this2.artwork }
          });
        }
        // this.$store.dispatch('addArtwork',response.data)
        // this.artwork = response.data
        // this.artist = response.data.artist
        // this.e1 = 3
        // console.log(this.artwork)
      }).catch(function (error) {
        // console.log(error)
        // console.log(response.data);
      });
      // }
    },
    check_an: function check_an(value) {
      // console.log(value)
      // console.log(this.artwork)
      if (value) {
        var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
        var b = a.filter(function (aa) {
          return aa.accession_number === value;
        });
        this.an_exists = b.length > 0;
      }
    },
    add_field: function add_field(field) {
      // console.log('this[field]')
      // console.log(field)
      this[field['name']].show = true;
    },
    saveCurrentTab: function saveCurrentTab(tab) {
      this.$store.dispatch('saveCurrentTab', tab);
    },
    getArtist: function getArtist(id) {
      var _this3 = this;

      // console.log(id);
      var url = this.$globals.apiserver + '/artists/' + id + '.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
        // this.loading = false;
        // console.log("this.result");
        // console.log(response.data);
        // console.log(response.data);
        _this3.result = response.data;
        _this3.processedArtist = response.data;
        // this.artwork = response.data
        // this.artist = response.data.artist
        // console.log(this.artwork)
      }).catch(function (error) {
        // console.log(error)
      });
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    pdf: function pdf() {
      // download PDF
    }
  },
  computed: {
    changed_an: function changed_an() {
      var no = this.latest_an;
      var out = '';
      // console.log('CHANGED_AN')
      if (this.artwork.acquired === 'acquired') {
        if (this.artwork.ownership === 6) {
          out = 'D_' + new Date().getFullYear() + '.' + no;
        } else if (this.artwork.ownership === 7 || this.artwork.ownership === 8) {
          out = 'E_' + new Date().getFullYear() + '.' + no;
        } else if (this.artwork.ownership === 17) {
          out = 'EH_' + new Date().getFullYear() + '.' + no;
        } else if (this.artwork.ownership === 10) {
          out = 'MR_' + new Date().getFullYear() + '.' + no;
        } else if (this.artwork.ownership === 11) {
          out = 'CA_' + new Date().getFullYear() + '.' + no;
        } else {
          out = new Date().getFullYear() + '.' + no;
        }
      } else if (this.artwork.acquired === 'commission') {
        out = 'COM_' + new Date().getFullYear() + '.' + no;
      } else if (this.artwork.acquired === 'nontba') {
        out = 'EXH_' + new Date().getFullYear() + '.' + no;
      } else if (this.artwork.acquired === 'com_academy') {
        out = 'COM_' + new Date().getFullYear() + '.' + no;
      }
      // this.artwork.accession_number = out
      // console.log(this.artwork.accession_number)
      return out;
    },
    latest_an: function latest_an() {
      var _this4 = this;

      // console.log('LATEST_AN')
      var ans = this.accession_numbers;
      // console.log('ans')
      // console.log(ans)
      // var last = ans[ans.length - 1]
      // nacitam posledny artwork
      var last = ans[0];
      // console.log('last')
      // console.log(last)
      var prefix = '';
      var ownership;

      // ak user uz zvolil ownership, tak odfiltruj len zvoleny
      if (this.artwork.ownership && [6, 7, 10, 11, 17].includes(this.artwork.ownership)) {
        ownership = this.constants.OWNERSHIPS.find(function (o) {
          return o.id === _this4.artwork.ownership;
        });
        // console.log('ownership')
        // console.log(ownership)
      }
      // pripravim si regex
      prefix = ownership != null ? '(' + ownership.an_ext + '_' + ')' : '';
      var reg = '[A-Z,_]*(\\d*).(.*)';
      // console.log('reg')
      // console.log(reg)

      var r = RegExp(reg);
      var e = r.exec(last);
      // console.log('e')
      // console.log(e)
      // console.log(e[2])
      // console.log(new Date().getFullYear().toString())

      // ak regex nieco nasiel a je to tento rok, tak zvys o 1

      if (e && e[1] === new Date().getFullYear().toString()) {
        var lastNo = e[2];
        var o = (parseInt(lastNo) + 1).toString().padStart(2, 0);
        // console.log('o')
        // console.log(o)
        // INAK JE ASI PRVY V ROKU
      } else {
        var o = '01';
      }
      return o;
    },
    all_an_limited: function all_an_limited() {
      // console.log('ALL_ANN_LIMITED')
      if (this.accession_numbers) {
        // console.log('this.accession_numbers.length')
        // console.log(this.accession_numbers.length)
        // console.log('this.accession_numbers.splice(10, this.accession_numbers.length)')
        // console.log(this.accession_numbers.splice(0, 10))
        return this.accession_numbers.splice(0, 10);
      }
    },
    isValid: function isValid() {
      return !(this.artwork.type_of_work_id === null || this.artwork.type_of_work_id === '' || this.artwork.title === null || this.artwork.title === '');
    },
    locations: function locations() {
      var l = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.getters.enabled_locations);
      return l.sort(function (a, b) {
        return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
      });
    },
    df: function df() {
      // var c = []
      var fields2 = [];
      fields2 = this.fields['tabs']['basic']['fields'];
      fields2 = fields2.concat(this.fields['tabs']['advanced']['fields']);
      fields2 = fields2.concat(this.fields['tabs']['acquisition']['fields']);
      // console.log(fields2)
      // c = fields2
      // .filter(f => (f.dynamic && f.work_types && f.work_types.includes(this.artwork.classification)))
      // c = c.map(f => f.name)
      return fields2;
    },

    // field_list () {
    //   if (!fields['tabs']['acquisition'].component) {
    //     var current_user = { role: 'admin'}
    //     var work_type = 'pppd'
    //     var out = []
    //     var fields2 = fields['tabs']['acquisition']['fields']
    //     // console.log(fields2)
    //     out = fields2.filter((f,i) => f.work_types && f.work_types.includes(this.artwork.classification))
    //     return out
    //   } else {
    //     return []
    //   }
    // },
    // processedArtist () {
    //   return this.result
    // },
    // processedArtist () {
    //   let processedArtist = this.result.artist
    //   return processedArtist
    // },
    artists: function artists() {
      var as = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
      return as.sort(dynamicSort('name'));
    }
  }
});

/***/ }),

/***/ "BAys":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexTable_vue__ = __webpack_require__("CVbb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6846589c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexTable_vue__ = __webpack_require__("rRb3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("wEtE")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6846589c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndexTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6846589c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6846589c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IndexTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BJgw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomsHistory_vue__ = __webpack_require__("CpBu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494f08aa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomsHistory_vue__ = __webpack_require__("rETx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("UM8A")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-494f08aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomsHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494f08aa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomsHistory_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_494f08aa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomsHistory_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "BU/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_axios_js__ = __webpack_require__("81r7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_SectionHeader_vue__ = __webpack_require__("u3wA");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      collections_field_array: [],
      constants: __WEBPACK_IMPORTED_MODULE_2__data_constants__["a" /* default */],
      valid: true,
      after_login_page: '',
      remember_saved_artworks: false
      // links: Object.keys(ownerships).map(e => (ownerships[e])).concat(['Artists','Contacts'])
    };
  },
  methods: {
    save: function save() {},
    submit: function submit() {
      if (this.$refs.form.validate()) {
        // Native form submission is not yet supported
        __WEBPACK_IMPORTED_MODULE_1__static_axios_js___default.a.post('/api/submit', {
          new_artwork_added: this.new_artwork_added,
          new_artist_added: this.new_artist_added,
          artwork_modified: this.artwork_modified,
          artist_modified: this.artist_modified
        });
      }
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  },
  computed: {
    // artwork_fields () {
    //   var o = this.$store.state.artworks.first
    //   return o ? o.keys : []
    // },
    formatted_roles: function formatted_roles() {
      return [];
    },
    links: function links() {
      var o = __WEBPACK_IMPORTED_MODULE_2__data_constants__["a" /* default */].OWNERSHIPS;
      var out = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(o).map(function (e) {
        return o[e];
      });
      var out = o.map(function (o) {
        return o.name;
      });
      out.concat(['Artists', 'Contacts']);
      out.push('Lists');
      return out;
    }
  },
  components: { SectionHeader: __WEBPACK_IMPORTED_MODULE_3__components_layout_SectionHeader_vue__["a" /* default */] }
});

/***/ }),

/***/ "BUio":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_artworks_TextEditor__ = __webpack_require__("JslP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__artworks_Upload__ = __webpack_require__("e4A6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_SectionHeader__ = __webpack_require__("u3wA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__("NHnr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['editedItem'],
  data: function data() {
    return {
      autoUpdate: true,
      isUpdating: false,
      isUpdatingArtists: false,
      timeout: 3500,
      valid: true,
      countries: this.$store.state.countries,
      dialog: false,
      text: {
        loan: '',
        content: '',
        title: 'loading...',
        given_filename: '',
        institution: '',
        show_type: '',
        city: '',
        country: '',
        duration_start_year: null,
        duration_start_month: null,
        duration_start_day: null,
        duration_end_year: null,
        duration_end_month: null,
        duration_end_day: null,
        admin_note: ''
      },
      artists: this.$store.state.artists
    };
  },

  watch: {
    isUpdating: function isUpdating(val) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          return _this.isUpdating = false;
        }, 3000);
      }
    },
    isUpdatingArtists: function isUpdatingArtists(val) {
      var _this2 = this;

      if (val) {
        setTimeout(function () {
          return _this2.isUpdatingArtists = false;
        }, 3000);
      }
    }
  },
  methods: {
    // remove (item) {
    //   this.text.artworks.splice(this.text.artworks.indexOf(item), 1)
    //   this.text.artworks = [...this.text.artworks]
    // },
    remove: function remove(item) {
      // this.text.artworks.splice(this.text.artworks.indexOf(item), 1)
      // this.text.artworks = [...this.text.artworks]
      // console.log(item)
      // console.log(this.text.artworks)
      var index = this.text.artworks.indexOf(item);
      // console.log(index)
      if (index >= 0) this.text.artworks.splice(index, 1);
    },
    removeArtist: function removeArtist(item) {
      // this.text.artworks.splice(this.text.artworks.indexOf(item), 1)
      // this.text.artworks = [...this.text.artworks]
      // console.log(item)
      // console.log(this.text.artworks)
      var index = this.text.artists.indexOf(item);
      // console.log(index)
      if (index >= 0) this.text.artists.splice(index, 1);
    },
    saveText: function saveText() {
      var _this3 = this;

      if (this.text.duration_end_year && this.text.duration_end_month && this.text.duration_end_day) {
        this.text.duration_end = this.format_date(new Date(this.text.duration_end_year, this.text.duration_end_month - 1, this.text.duration_end_day), 'YYYY-MM-DD');
      }
      if (this.text.duration_start_year && this.text.duration_start_month && this.text.duration_start_day) {
        this.text.duration_start = this.format_date(new Date(this.text.duration_start_year, this.text.duration_start_month - 1, this.text.duration_start_day), 'YYYY-MM-DD');
      }
      // this.text.artworks = this.artwork_ids
      // console.log(this.text.artworks)

      this.text.artwork_ids = this.text.artworks;
      this.text.artist_ids = this.text.artists;
      // .map(a => a.id)
      // console.log(this.text)
      // this.text.artworks = this.text.artwork_ids
      var url = this.$globals.apiserver + '/artwork_texts/' + this.text.id + '.json';
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, { artwork_text: this.text }).then(function (response) {
        _this3.$store.dispatch('loadTexts');
        _this3.result = response.data;
        __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$emit('showSnackbar', 'Text was saved.', 'green');
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$emit('showSnackbar', 'Text was NOT saved. Error occured.', 'red');
        // console.log(error)
      });
    },
    deleteText: function deleteText() {
      var _this4 = this;

      var url = this.$globals.apiserver + '/artwork_texts/' + this.text.id + '.json';
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url, this.text).then(function (response) {
        _this4.result = response.data;
        __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$emit('showSnackbar', 'Text was deleted.', 'green');
        _this4.$router.push({ name: 'Texts' });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$emit('showSnackbar', 'Text was NOT deleted. Error occured.', 'red');
        // console.log(error)
      });
    },
    getText: function getText() {
      var _this5 = this;

      var url = this.$globals.apiserver + '/artwork_texts/' + this.$route.params.id + '.json';
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
        _this5.text = response.data;
        // MUSIM ZMENIT VALUE PRE RADIO GROUP NA STRING LEBO INAK TO NEFUNGUJE
        if (_this5.text.show_type) {
          _this5.text.show_type = _this5.text.show_type.toString();
        }
        _this5.text.artworks = _this5.text.artworks.map(function (a) {
          return a.id;
        });
      }).catch(function (error) {
        // console.log(error)
      });
    }
  },
  computed: {
    artworks: function artworks() {
      return this.$store.state.artworks;
    },
    artists_sorted: function artists_sorted() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.artists).sort(dynamicSort('name'));
    },
    artwork_ids: function artwork_ids() {
      var mm = [];
      this.text.artworks.forEach(function (a) {
        return mm.push({ id: a.id });
      });
      return mm;
    }
  },
  beforeMount: function beforeMount() {
    if (this.editedItem) {
      this.text = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.editedItem);
    }
    this.getText();
  },

  // beforeMount() {
  //   // this.text = Object.assign({},this.$route.params.text)
  //   this.getText();
  // },
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({ TextEditor: __WEBPACK_IMPORTED_MODULE_2__components_artworks_TextEditor__["a" /* default */], Upload: __WEBPACK_IMPORTED_MODULE_4__artworks_Upload__["a" /* default */], SectionHeader: __WEBPACK_IMPORTED_MODULE_5__layout_SectionHeader__["a" /* default */] }, 'TextEditor', __WEBPACK_IMPORTED_MODULE_2__components_artworks_TextEditor__["a" /* default */])

});

/***/ }),

/***/ "Bxt4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditField__ = __webpack_require__("paWh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ViewArtworks__ = __webpack_require__("eZui");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditFieldHeader__ = __webpack_require__("Z/ya");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artists_MultiArtist_vue__ = __webpack_require__("RKLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_countries__ = __webpack_require__("ER8n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__layout_SectionHeader_vue__ = __webpack_require__("u3wA");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      constants: __WEBPACK_IMPORTED_MODULE_9__data_constants__["a" /* default */],
      name_exists: false,
      snackbar: false,
      sText: 'Working ...',
      sColor: 'black',
      timeout: 5000,
      artistLink: {},
      countries: __WEBPACK_IMPORTED_MODULE_8__data_countries__["a" /* default */].countries,
      menu2: false,
      menu: false,
      drawer: false,
      artistFormData: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.artist),
      valid: true,
      valid2: true,
      currentTab: this.$store.state.currentTabArtist ? this.$store.state.currentTabArtist : 'basic'
    };
  },

  props: ['artist', 'field'],
  // beforeRouteEnter () {
  //   this.result = Object.assign({},this.$store.state.artists.find(a => a.is==this.$route.params.id))
  // },
  beforeMount: function beforeMount() {
    var _this = this;

    // console.log('beforemount')
    // console.log(this.artistFormData.nationality)
    this.artistFormData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.artist);
    if (this.$route.params.artist) {
      this.result = this.$route.params.artist;
    } else {
      this.result = this.$store.state.artists.find(function (a) {
        return a.id == _this.$route.params.id;
      });
      this.artistFormData = this.result;
    }
    this.getArtist();
    // console.log('beforemount after')
    // console.log(this.artistFormData.nationality)
  },

  methods: {
    check_name: function check_name(value) {
      if (value) {
        var a = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
        var b = a.filter(function (aa) {
          return aa.name === value;
        });
        this.name_exists = b.length > 0;
      }
    },
    setCurrentTab: function setCurrentTab(tab) {
      this.currentFields = this.constants.ARTIST.tabs.fields;
      // if (!this.currentFields) {
      //   this.currentFields = this.constants.ARTIST.tabs[tab].fields
      // }
      this.saveCurrentTab(tab);
      this.currentTab = tab;
    },
    saveCurrentTab: function saveCurrentTab(tab) {
      this.$store.dispatch('saveCurrentTabArtist', tab);
    },
    saveArtist: function saveArtist() {
      var _this2 = this;

      this.sColor = 'black';
      this.snackbar = true;
      this.sText = 'Saving Artist...';
      // if (this.$refs.form.validate()) {
      // console.log(this.artistFormData)
      // let url = `http://www.tb-cms.org/artists/api_update/${this.artistFormData.id}.json`
      var url = this.$globals.apiserver + '/artists/' + this.artistFormData.id + '.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url, this.artistFormData).then(function (response) {
        // this.loading = false;
        // console.log(response.data)
        _this2.result = response.data;
        // this.artistFormData = response.data
        _this2.$store.dispatch('saveArtist', response.data);
        // this.artwork = response.data
        // this.artist = response.data.artist
        // this.e1 = 3
        // console.log(this.artwork)
        _this2.snackbar = false;
        _this2.snackbar = true;
        _this2.sColor = 'green';
        _this2.sText = 'Artist Saved.';
        // this.$router.push({path:`/artists/edit/${this.artist.id}`, params: {artist: this.artist}})
      }).catch(function (error) {
        // console.log(error)
        _this2.sColor = 'red';
        _this2.sText = 'Problem Saving Artist. Try again or contact developer.';
      });
      // }
    },
    saveLink: function saveLink() {
      var _this3 = this;

      // if (this.$refs.form.validate()) {
      // console.log(this.artistLink)
      var prefix = 'http://';
      if (this.artistLink.url.substr(0, prefix.length) !== prefix) {
        this.artistLink.url = prefix + this.artistLink.url;
      }
      var url = this.$globals.apiserver + '/artist_links.json';
      this.artistLink.artist_id = this.artistFormData.id;
      // console.log(this.artistLink)

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, {
        artist_link: this.artistLink
      }).then(function (response) {
        // this.loading = false;
        // console.log(response.data)
        _this3.artistFormData.artist_links.push(response.data);
        _this3.result = response.data;
        _this3.artistLink = {};
        // this.artistFormData = response.data
        // this.$store.dispatch('addArtist',response.data)
        // this.artwork = response.data
        // this.artist = response.data.artist
        // this.e1 = 3
        // console.log(this.artwork)
        // this.$router.push({path:`/artists/edit/${this.artist.id}`, params: {artist: this.artist}})
      }).catch(function (error) {
        // console.log(error)
      });
      // }
    },
    deleteLink: function deleteLink(l) {
      var url = this.$globals.apiserver + '/artist_links/' + l.id + '.json';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(url, l.id).then(function (response) {}).catch(function (error) {
        // console.log(error)
      });
      var li = this.artistFormData.artist_links.indexOf(l);
      this.artistFormData.artist_links.splice(li);
      this.$store.dispatch('deleteArtistLink', l);
    },
    submit: function submit() {
      // if (this.$refs.form.validate()) {
      // Native form submission is not yet supported
      // console.log(this.artist)
      // var a = {
      //   artist: JSON.stringify(this.artist)
      // }
      //   var params = new URLSearchParams(a)

      // const params = {
      //   firstName: 'Fred',
      //   lastName: 'Flintstone'
      // }
      // console.log(this.artist)
      var art = this.artistFormData;
      // console.log(art)

      var requestConfig = {
        url: this.$globals.apiserver + '/artists/api_update/' + this.$route.params.id,
        method: 'POST',
        // headers : { "Content-Type" : "application/x-www-form-urlencoded" },
        data: __WEBPACK_IMPORTED_MODULE_6_querystring__["stringify"](art)
      };
      var response = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(requestConfig);
      console.log(requestConfig.method, requestConfig.url, response.status, response.statusText, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(response.data));
      // console.log(response.request._header);

      // const paramsd = new URLSearchParams();
      // paramsd.append('param1', 'value1');
      // paramsd.append('param2', 'value2');

      // axios({
      //   method: 'post',
      //   url: `http://www.tb-cms.org/artists/api_update/${this.$route.params.id}`,
      //   data: {
      //     firstName: 'Fred',
      //     lastName: 'Flintstone'
      //   }
      // })

      // axios.post(`http://www.tb-cms.org/artists/api_update/${this.$route.params.id}`,
      //   {params: paramsd},
      //   { headers: {
      //     'Content-type': 'application/x-www-form-urlencoded',
      //     }
      //   }).then(function (response) {
      //     // console.log(response);
      //   })
      //   .catch(function (error) {
      //     // console.log(error);
      //   })
      // axios.post(`http://www.tb-cms.org/artists/api_update/${this.$route.params.id}`, {
      //     // artist: this.artist,
      //     aaaaaaaaa: 'aaaaaaaa'
      //     // name: this.artist.first_name
      //   })
      //   .then(function (response) {
      //     // console.log(response);
      //   })
      //   .catch(function (error) {
      //     // console.log(error);
      //   })
      // }
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    updateForm: function updateForm(fieldName, value) {
      this.$set(this.artistFormData, fieldName, value);
      // this.$emit("input", this.artist);
    },
    getArtist: function getArtist() {
      var _this4 = this;

      var url = this.$globals.apiserver + '/artists/' + this.$route.params.id + '.json';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
        _this4.result = response.data;
        // console.log(response.data)
        _this4.artistFormData = response.data;
        // console.log('getartist')
        // console.log(this.artistFormData.nationality)
        // this.artist = response.data.artist
      }).catch(function (error) {
        // console.log(error)
      });
      // console.log(this.artistFormData)
    }
  },
  computed: {
    options_c: {
      get: function get() {
        return this.$store.state.options;
      },
      set: function set(value) {
        this.$store.dispatch('saveOptions', value);
      }
    },
    processedArtist: function processedArtist() {
      var processedArtist = this.result;
      // this.artwork.map(artwork => {
      //   let a = artwork
      //   artwork.first_name = a ? a.first_name : 'nema meno'
      // })
      // console.log(processedArtist)
      return processedArtist;
    }
  },
  components: {
    EditField: __WEBPACK_IMPORTED_MODULE_3__EditField__["a" /* default */],
    ViewArtworks: __WEBPACK_IMPORTED_MODULE_4__ViewArtworks__["a" /* default */],
    EditFieldHeader: __WEBPACK_IMPORTED_MODULE_5__EditFieldHeader__["a" /* default */],
    MultiArtist: __WEBPACK_IMPORTED_MODULE_7__components_artists_MultiArtist_vue__["a" /* default */],
    SectionHeader: __WEBPACK_IMPORTED_MODULE_10__layout_SectionHeader_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "C2KG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRelated_vue__ = __webpack_require__("k5cb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e7928c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelated_vue__ = __webpack_require__("VPhs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("WCQA")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-75e7928c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRelated_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e7928c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelated_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e7928c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelated_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CHii":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CODS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddLocation_vue__ = __webpack_require__("PwaE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ceaa50_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddLocation_vue__ = __webpack_require__("XUYi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("XJLE")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-16ceaa50"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddLocation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ceaa50_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddLocation_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16ceaa50_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddLocation_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "CVbb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ListRelated__ = __webpack_require__("JIzb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__artworks_ListActionMenu__ = __webpack_require__("O429");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      ownerships: [],
      filtered: [],
      exhibitions: [],
      selectedOwnership: {},
      // table_exhibitions: [],
      exhibition_to_delete: '',
      delete_dialog: false,
      delete_step: 0,
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'duration_start'
      },
      relatedShown: [],
      fields: ['artwork_location_id', 'type_of_work_id'],
      dialog: false,
      ta: [],
      selected: [],
      loan: '1',
      search: '',
      headers: [{ text: 'Start Year', sortable: true, value: 'duration_start' }, { text: 'End Year', sortable: true, value: 'duration_end' }, { text: 'Title', align: 'left', sortable: true, value: 'title' }, { text: 'Institution', sortable: true, value: 'institution' }, { sortable: false, value: 'city' }, { sortable: false, value: 'country' },
      // { text: 'Start-End', value: 'duration_start', align: 'right' },
      { text: '', value: 'artwork_text', sortable: false }, { text: '', sortable: false
        // { text: '', value: '', align: 'center', }
        // { text: 'Tags', value: 'tags', sortable: false }
      }]
    };
  },

  created: function created() {
    var _this = this;

    this.$store.dispatch('loadExhibitions');
    // this.exhibitions = Object.assign([], this.$store.state.exhibitions);
    this.ownerships = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.getters.my_ownerships);
    this.ownerships.unshift({ id: 'all', name: 'All' });
    // this.filtered = this.exhibitions;
    __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$on('setSorting', function (a) {
      _this.pagination.sortBy = a;
      _this.pagination.descending = !_this.pagination.descending;
    });
    console.log(this.$store.state.filters['exhibitions']);
    console.log(this.ownerships[0]);
    this.toggleOwnership(this.$store.state.filters['exhibitions'] ? this.ownerships.find(function (ow) {
      return ow.id == _this.$store.state.filters['exhibitions'];
    }) : this.ownerships[0]);
    // this.toggleOwnership(this.ownerships[0]);
  },
  methods: {
    loadSelection: function loadSelection(e) {
      var ids = e.map(function (ea) {
        return ea.id;
      });
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      this.$store.dispatch('saveCurrentSelection', ids);
      // } else {
      //   // console.log('no add')
      //   this.$store.dispatch('addToCurrentSelection',e)
      // }
    },
    addSelectionToExhibition: function addSelectionToExhibition(e) {
      // var ids = e.map(ea => ea.id)
      console.log(this.$store.state.currentSelection);
      this.$store.dispatch('addSelectionToExhibition', e);
    },
    addToSelection: function addToSelection(e) {
      // map only ids from e
      var ids = e.map(function (ea) {
        return ea.id;
      });

      console.log(ids);
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      // this.$store.dispatch('saveCurrentSelection',e)
      // } else {
      //   // console.log('no add')
      this.$store.dispatch('addToCurrentSelection', ids);
      // }
    },
    removeFromSelections: function removeFromSelections(e) {
      var ids = e.map(function (ea) {
        return ea.id;
      });
      // console.log(e)
      this.$store.dispatch('removeFromSelections', ids);
    },


    // getInstitutionName(id) {
    //   const i = this.$store.state.contacts.find(i => i.id == id)
    //   if (i) {
    //     return i.name
    //   } else {
    //     return 'institution not found'
    //   }
    // },
    toggleOwnership: function toggleOwnership(o) {
      console.log(o);
      // var array = [];
      // for (var i in ownerships) {
      //   // array.push(i);
      //   array.push(ownerships[i]);
      // }
      this.$store.dispatch('setFilter', {
        section: 'exhibitions',
        ownership: o.id
      });
      this.selectedOwnership = o;
    },
    delete_dialog_close: function delete_dialog_close() {
      this.delete_dialog = false;
      this.delete_step = 0;
    },
    deleteExhibition: function deleteExhibition(e) {
      if (this.delete_step == 0) {
        this.delete_dialog = true;
        this.delete_step = 1;
        this.exhibition_to_delete = e;
      } else {
        this.$store.dispatch('deleteExhibition', e);
        this.delete_dialog = false;
        this.delete_step = 0;
        // console.log('deleted')
      }
    },
    showRelated: function showRelated(id) {
      if (this.relatedShown[id] == true) {
        this.relatedShown[id] = false;
      } else {
        this.relatedShown[id] = true;
      }
      // console.log(this.relatedShown)
    },
    addField: function addField() {},
    switchSwitch: function switchSwitch() {
      // this.show_tag_filter = !this.show_tag_filter
      this.$emit('switchOwnershipTop', this.show_tag_filter);
    },
    clearFilters: function clearFilters() {
      this.selected_tags = [];
      this.selected_tag_categories = [];
    }
  },
  computed: {
    filtered_exhibitions: function filtered_exhibitions() {
      var _this2 = this;

      var filtered = [];
      if (this.selectedOwnership.id != 'all') {
        filtered = this.$store.state.exhibitions.filter(function (a) {
          return a.artworks.some(function (ea) {
            return ea.ownership == _this2.selectedOwnership.id;
          });
        });
      } else {
        filtered = this.$store.state.exhibitions;
      }

      // this.table_exhibitions = this.filtered;
      if (this.loan == 1) {
        filtered = filtered.filter(function (e) {
          return e.loan == 1;
        });
      } else if (this.loan == 0) {
        filtered = filtered.filter(function (e) {
          return e.loan != 1;
        });
      } else {
        filtered = filtered;
      }
      var out = [];
      filtered.forEach(function (te) {
        var aids = te.artworks.map(function (tea) {
          return tea.id;
        });
        var as = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this2.$store.state.artworks.filter(function (a) {
          return aids.includes(a.id);
        }));
        te.artwork_text = as.map(function (aa) {
          return aa.accession_number + ' ' + aa.title + ' ' + aa.name + ' ' + aa.artist_name;
        }).toString();
        out.push(te);
      });
      return out;
    },

    add_new: {
      get: function get() {
        return this.$store.state.add_new;
      },
      set: function set(value) {
        this.$store.dispatch('addNew', value);
      }
    },
    currrent_path: function currrent_path() {
      return this.$route.params.ownership;
    }
    // table_exhibitions () {
    //   // if (this.selected_tags.length > 0) {
    //   //   var cst = this.selected_tags
    //     return this.$store.state.exhibitions
    //     // .filter(function(artwork) {
    //   //     return artwork.tags.some(a_tag => cst.indexOf(a_tag.id) > -1)
    //   //   })
    //   // } else {
    //     // return this.items
    //     // $store.state.artworks
    //   // }
    // },

  },
  // components: { ListActionMenu, LocationChangeDialog },
  components: { ListRelated: __WEBPACK_IMPORTED_MODULE_2__ListRelated__["a" /* default */], ListActionMenu: __WEBPACK_IMPORTED_MODULE_3__artworks_ListActionMenu__["a" /* default */] }
});

/***/ }),

/***/ "CVtG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-0",attrs:{"small":_vm.small,"light":_vm.light,"loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.pdfLabelsCall()}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":_vm.small}},[_vm._v("mdi-file-pdf")]),_vm._v(" TEXT LABELS\n")],1)}
var staticRenderFns = []


/***/ }),

/***/ "CmKb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"ml-3 mr-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('transition',{attrs:{"name":"slide"}},[(_vm.showUpload)?_c('v-layout',{staticClass:"mx-1 mt-0 px-4 pt-4 mb-4",staticStyle:{"background-color":"#fff"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","pr-2":"","mt-2":""}},[_c('v-text-field',{staticClass:"ml-2",attrs:{"name":"description","label":"Description"},model:{value:(_vm.todo.title),callback:function ($$v) {_vm.$set(_vm.todo, "title", $$v)},expression:"todo.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":"","pl-2":"","pr-2":""}},[_c('v-menu',{ref:"menu2",staticClass:"my-1",attrs:{"return-value":_vm.todo.deadline,"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","nudge-right":0,"lazy":""},on:{"update:returnValue":function($event){return _vm.$set(_vm.todo, "deadline", $event)},"update:return-value":function($event){return _vm.$set(_vm.todo, "deadline", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","prepend-inner-icon":"event","readonly":"","label":"Deadline"},slot:"activator",model:{value:(_vm.todo.deadline),callback:function ($$v) {_vm.$set(_vm.todo, "deadline", $$v)},expression:"todo.deadline"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"min":_vm.format_date(Date.now()),"color":"black","first-day-of-week":"1"},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.todo.deadline)}},model:{value:(_vm.todo.deadline),callback:function ($$v) {_vm.$set(_vm.todo, "deadline", $$v)},expression:"todo.deadline"}})],1)],1),_vm._v(" "),(_vm.todo.deadline)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":"","pl-1":"","pr-2":""}},[_c('v-menu',{ref:"menu3",staticClass:"my-1",attrs:{"return-value":_vm.todo.reminder,"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","nudge-right":30,"lazy":"","landscape":""},on:{"update:returnValue":function($event){return _vm.$set(_vm.todo, "reminder", $event)},"update:return-value":function($event){return _vm.$set(_vm.todo, "reminder", $event)}},model:{value:(_vm.menu3),callback:function ($$v) {_vm.menu3=$$v},expression:"menu3"}},[_c('v-text-field',{attrs:{"slot":"activator","prepend-inner-icon":"event","readonly":"","label":"Reminder"},slot:"activator",model:{value:(_vm.todo.reminder),callback:function ($$v) {_vm.$set(_vm.todo, "reminder", $$v)},expression:"todo.reminder"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"color":"black","min":_vm.format_date(Date.now()),"scrollable":"","first-day-of-week":"1"},on:{"input":function($event){return _vm.$refs.menu3.save(_vm.todo.reminder)}},model:{value:(_vm.todo.reminder),callback:function ($$v) {_vm.$set(_vm.todo, "reminder", $$v)},expression:"todo.reminder"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{staticClass:"mx-2 my-2",attrs:{"auto-grow":"","rows":"1","name":"note","label":"Note"},model:{value:(_vm.todo.description),callback:function ($$v) {_vm.$set(_vm.todo, "description", $$v)},expression:"todo.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md2":"","mt-2":"","pr-3":""}},[_c('div',{staticClass:"ml-2"},[_vm._v("\n              Repeat every …\n            ")]),_vm._v(" "),_c('v-text-field',{staticClass:"ml-2 xs2",attrs:{"name":"frequency","prepend-inner-icon":"loop","hide-details":""},model:{value:(_vm.todo.frequency),callback:function ($$v) {_vm.$set(_vm.todo, "frequency", $$v)},expression:"todo.frequency"}}),_vm._v(" "),(_vm.todo.repeat && !_vm.todo.frequency)?_c('div',{staticClass:"red--text ml-2"},[_vm._v("\n              Must be filled!\n            ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":"","ml-0":"","mt-5":""}},[_c('v-btn-toggle',{staticClass:"mt-0",attrs:{"small":""},model:{value:(_vm.todo.repeat),callback:function ($$v) {_vm.$set(_vm.todo, "repeat", $$v)},expression:"todo.repeat"}},[_c('v-btn',{key:"group1",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"day","value":"day"}},[_c('span',[_vm._v("Days")])]),_vm._v(" "),_c('v-btn',{key:"group2",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"month","value":"month"}},[_c('span',[_vm._v("Months")])]),_vm._v(" "),_c('v-btn',{key:"group3",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"year","value":"year"}},[_c('span',[_vm._v("Years")])])],1),_vm._v(" "),(!_vm.todo.repeat && _vm.todo.frequency)?_c('div',{staticClass:"red--text ml-3"},[_vm._v("\n              Must be selected!\n            ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"pl-2":"","mt-3":"","sm12":"","md6":""}},[_c('v-flex',{attrs:{"xs12":"","pr-2":""}},[_c('v-autocomplete',{attrs:{"items":_vm.team_d,"chips":"","color":"blue-grey lighten-2","label":"Assigned to","item-text":"abb","item-value":"id","multiple":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi",attrs:{"selected":data.selected,"close":"","small":""},on:{"input":function($event){return _vm.remove(data.item)}}},[_c('v-avatar',{attrs:{"color":"black"}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(data.item.abb))])]),_vm._v("\n                    "+_vm._s(data.item.firstname)+" "+_vm._s(data.item.lastname)+"\n                  ")],1)]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.abb)+" - "+_vm._s(data.item.firstname)+"\n                        "+_vm._s(data.item.lastname))])],1)]]}}],null,false,2379578894),model:{value:(_vm.todo.user_ids),callback:function ($$v) {_vm.$set(_vm.todo, "user_ids", $$v)},expression:"todo.user_ids"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 layout my-2"},[(_vm.todo.created_at)?_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.format_date(_vm.todo.created_at))+" by\n              "+_vm._s(_vm.get_abb(_vm.todo.created_by)))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mb-3",attrs:{"small":"","flat":""},on:{"click":_vm.cancel}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":""},on:{"click":_vm.save_todo}},[_vm._v("create todo")])],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","xs12":"","mx-0":"","mt-2":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn-toggle',{staticClass:"mt-0 ml-4",attrs:{"small":"","mandatory":""},model:{value:(_vm.visibility),callback:function ($$v) {_vm.visibility=$$v},expression:"visibility"}},[_c('v-btn',{key:"group1",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"active","value":"active"}},[_c('span',[_vm._v("Active")])]),_vm._v(" "),_c('v-btn',{key:"group2",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"all","value":"all"}},[_c('span',[_vm._v("All")])]),_vm._v(" "),_c('v-btn',{key:"group3",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"completed","value":"completed"}},[_c('span',[_vm._v("Done")])])],1),_vm._v(" "),(!_vm.showUpload && _vm.c_user.edit)?_c('v-btn',{staticClass:"right primary mt-0 mb-0 mr-3 xs12",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.new_todo()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),(_vm.filteredTodos && _vm.filteredTodos.length == 0)?_c('v-flex',{staticClass:"xs12 text-xs-center my-5 mx-4 headline pa-5 elevation-2"},[_vm._v("\n      NO TODOS\n    ")]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","xs12":"","mx-3":"","mt-2":"","mb-5":""}},_vm._l((_vm.filteredTodos),function(t){return _c('v-flex',{key:t.id + 'todo',attrs:{"xs12":"","md12":"","lg6":"","xl4":""}},[_c('v-card',{staticClass:"mt-1 pa-0 ml-2 mb-1",staticStyle:{"cursor":"default"},attrs:{"xs12":"","color":t.done == 1 ? '#ddd' : '#fff',"hover":""}},[_c('v-layout',{attrs:{"xs12":"","row":"","pb-0":"","mb-0":""}},[_c('v-flex',{attrs:{"xs4":"","mt-1":"","pl-0":"","ml-0":"","mr-5":"","pb-0":"","mb-0":""}},[_c('v-btn',{class:t.done == 1 ? 'dark' : '',attrs:{"flat":""},on:{"click":function($event){return _vm.done_todo(t)}}},[(t.done != 1)?_c('v-icon',{staticClass:"mr-2 pl-0 ml-0",attrs:{"color":t.done == 1 ? 'black' : 'red'}},[_vm._v("check_box_outline_blank")]):_c('v-icon',{staticClass:"mr-2",attrs:{"color":"black"}},[_vm._v("check_box")]),_vm._v(" "),(t.done == 1)?_c('span',[_vm._v("DONE")]):_c('span',{staticClass:"red--text"},[_vm._v("ACTIVE")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","pr-4":"","mt-3":"","text-xs-center":""}},[(t.deadline != null)?_c('div',[(!t.done)?_c('span',{staticClass:"ma-0 pt-0"},[_c('v-icon',{attrs:{"small":"","color":_vm.getColor(t)}},[_vm._v("alarm_on")]),_vm._v("\n                "+_vm._s(_vm.format_date(t.deadline))+"\n              ")],1):_c('span',{staticClass:"ma-0 pt-0"},[_c('v-icon',{attrs:{"small":"","color":_vm.getColor(t)}},[_vm._v("check_circle")]),_vm._v(" "),(t.done_at != null)?_c('span',[_vm._v(_vm._s(_vm.format_date(t.done_at)))]):_vm._e()],1)]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","mt-1":"","text-xs-right":""}},[(_vm.c_user.edit == 1 || _vm.c_user.delete_rights == 1)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.delete_todo(t)}}},[_c('v-icon',{attrs:{"color":"red","small":""}},[_vm._v("mdi-trash-can-outline")])],1):_vm._e(),_vm._v(" "),(_vm.c_user.edit == 1)?_c('v-btn',{staticClass:"mr-3",attrs:{"icon":""},on:{"click":function($event){return _vm.edit_todo(t.id)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-pencil-outline")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"xs12 mt-0 pt-0 mb-3"}),_vm._v(" "),(t.title)?_c('v-card-text',{staticClass:"title font-weight-normal my-0 py-0 pl-4 pr-4 wrap"},[_vm._v(_vm._s(t.title.toUpperCase()))]):_vm._e(),_vm._v(" "),(t.description)?_c('v-card-text',{staticClass:"wrap pt-2 pl-4"},[_vm._v(_vm._s(t.description))]):_vm._e(),_vm._v(" "),_c('v-card-text',{staticClass:"wrap pt-2 pl-4"},[_vm._v("\n          "+_vm._s(_vm.format_date(t.created_at))+" by "+_vm._s(_vm.get_abb(t.created_by))+"\n        ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","xs12":"","align-end":"","justify-end":""}},[_c('v-container',{staticClass:"mb-2 mr-3 pr-0 pb-0",attrs:{"align-end":"","justify-end":"","text-xs-right":""}},[(t.users && t.users.length > 0)?_c('v-container',{attrs:{"ma-0":"","pa-0":"","mr-2":""}},_vm._l((t.users),function(u){return _c('v-chip',{key:u.id,attrs:{"color":!t.done ? 'black' : 'white',"text-color":t.done ? 'black' : 'white',"avatar":"","small":""}},[_vm._v(_vm._s(_vm.get_abb(u.id))+"\n              ")])}),1):_vm._e()],1)],1)],1)],1)}),1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "CpBu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CustomsHistory",
  props: ["artwork"],
  data: function data() {
    return {
      adding: false,
      editDialog: false,
      editedCustomsHistory: {},
      artwork_ownership_history: {},
      selectedPackings: [],
      menu2: false,
      showUpload: false,
      showList: false,
      show: false,
      errors: "",
      artwork_customs_log: {
        id: "",
        import_export_notes: "",
        import_date: "",
        main_visa_status: "",
        import_taxes: "",
        mover_importer: ""
      }
    };
  },
  // computed: {  },
  methods: {
    showAddDialog: function showAddDialog() {
      this.editDialog = true;
      this.adding = true;
    },
    cancelAddDialog: function cancelAddDialog() {
      this.editDialog = false;
      this.adding = false;
      this.editedCustomsHistory = {
        id: "",
        import_export_notes: "",
        import_date: "",
        main_visa_status: "",
        import_taxes: "",
        mover_importer: ""
      };
    },
    editCustomsHistory: function editCustomsHistory(l) {
      this.editedCustomsHistory = l;
      this.editDialog = true;
    },
    save_edited_artwork_customs_history: function save_edited_artwork_customs_history() {
      var _this = this;

      this.editedCustomsHistory.last_update_by = this.c_user.id;
      this.editedCustomsHistory.artwork_id = this.artwork.id;
      if (this.adding == true) {
        var url = this.$globals.apiserver + "/artwork_customs_logs.json";
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, {
          artwork_customs_log: this.editedCustomsHistory
        }).then(function (response) {
          _this.$emit("getArtwork");
          _this.errors = {};
          _this.artwork.artwork_customs_logs = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.artwork.artwork_customs_logs.filter(function (element) {
            return element.id !== response.data.id;
          })), [response.data]);
          // this.artwork.artwork_ownership_id = this.editedCustomsHistory.artwork_ownership_id;
          // this.active_artwork_customs_logs = this.$store.state.artwork_customs_logs;
          _this.editedCustomsHistory = {
            id: "",
            import_export_notes: "",
            import_date: "",
            main_visa_status: "",
            import_taxes: "",
            mover_importer: ""
          };
          _this.editDialog = false;
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        var url = this.$globals.apiserver + "/artwork_customs_logs/" + this.editedCustomsHistory.id + ".json";
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, {
          artwork_customs_log: this.editedCustomsHistory
        }).then(function (response) {
          _this.$emit("getArtwork");
          _this.errors = {};
          _this.artwork.artwork_customs_logs = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.artwork.artwork_customs_logs.filter(function (element) {
            return element.id !== response.data.id;
          })), [response.data]);
          // this.artwork.artwork_ownership_id = this.editedCustomsHistory.artwork_ownership_id;
          // this.active_artwork_customs_logs = this.$store.state.artwork_customs_logs;
          _this.editedCustomsHistory = {
            id: "",
            import_export_notes: "",
            import_date: "",
            main_visa_status: "",
            import_taxes: "",
            mover_importer: ""
          };
          _this.editDialog = false;
        }).catch(function (error) {
          console.log(error);
        });
      }

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, {
        artwork_customs_log: this.editedCustomsHistory
      }).then(function (response) {
        _this.$emit("getArtwork");
        _this.errors = {};
        _this.artwork.artwork_customs_logs = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this.artwork.artwork_customs_logs.filter(function (element) {
          return element.id !== response.data.id;
        })), [response.data]);
        // this.artwork.artwork_ownership_id = this.editedCustomsHistory.artwork_ownership_id;
        // this.active_artwork_customs_logs = this.$store.state.artwork_customs_logs;
        _this.editedCustomsHistory = {
          id: "",
          import_export_notes: "",
          import_date: "",
          main_visa_status: "",
          import_taxes: "",
          mover_importer: ""
        };
        _this.editDialog = false;
      }).catch(function (error) {
        // console.log(error);
      });
      // var aartwork_ownership_history = Object.keys(this.artwork_ownership_history).forEach(k => this.artwork_ownership_history[k]='')
      // console.log(aartwork_ownership_history)
    },
    delete_log: function delete_log() {},
    save_artwork_customs_log: function save_artwork_customs_log() {
      var _this2 = this;

      this.artwork_customs_log.created_by = this.c_user.id;
      this.artwork_customs_log.artwork_id = this.artwork.id;
      if (this.artwork_customs_log.storage == "in") {
        this.artwork_customs_log.storage_in = this.artwork_customs_log.import_date;
      } else {
        this.artwork_customs_log.storage_out = this.artwork_customs_log.import_date;
      }
      // this.artwork_customs_log.id = this.findMinMax(this.all_artwork_customs_logs)+1
      if (!this.artwork.artwork_customs_logs) {
        this.artwork.artwork_customs_logs = [];
      }
      // this.$store.commit('ADD_TODO', this.artwork_customs_log)
      // this.all_artwork_customs_logs.push(this.artwork_customs_log)
      if (this.artwork_customs_log.copy == "packings" && this.selectedPackings && this.selectedPackings.length > 0) {
        // console.log('packings')
        for (var sp in this.selectedPackings) {
          // console.log(this.selectedPackings[sp].id)
          this.artwork_customs_log.artwork_packing_id = this.selectedPackings[sp].id;
          // console.log(this.artwork_customs_log);
          __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$globals.apiserver + "/artwork_customs_logs.json", {
            artwork_customs_log: this.artwork_customs_log
          }).then(function (response) {
            _this2.errors = {};
            // this.artwork.artwork_customs_logs.push(response.data);
            // this.$store.commit("ADD_LOG", response.data);
            _this2.active_artwork_customs_logs = _this2.$store.state.artwork_customs_logs;
            _this2.showUpload = !_this2.showUpload;
          }).catch(function (error) {
            // console.log(error);
            // this.errors = error.response.data;
          });
        }
        this.artwork_customs_log = {
          import_export_notes: "",
          import_date: "",
          main_visa_status: "",
          import_taxes: "",
          mover_importer: ""
        };
      } else {
        // console.log('single')
        __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$globals.apiserver + "/artwork_customs_logs.json", {
          artwork_customs_log: this.artwork_customs_log
        }).then(function (response) {
          _this2.errors = {};
          _this2.artwork.artwork_customs_logs.push(response.data);
          // this.$store.commit("ADD_LOG", response.data);
          // this.active_artwork_customs_logs = this.$store.state.artwork_customs_logs;
          _this2.showUpload = !_this2.showUpload;
          _this2.artwork_customs_log = {
            import_export_notes: "",
            import_date: "",
            main_visa_status: "",
            import_taxes: "",
            mover_importer: ""
          };
        }).catch(function (error) {
          // console.log(error);
        });
      }

      // var aartwork_customs_log = Object.keys(this.artwork_customs_log).forEach(k => this.artwork_customs_log[k]='')
      // console.log(aartwork_customs_log)
    }
  }
});

/***/ }),

/***/ "CqVZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_auth__ = __webpack_require__("+4WN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_user__ = __webpack_require__("yLEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_api__ = __webpack_require__("VsUZ");



var _actions, _mutations;

/* eslint-disable promise/param-names */


// import Vue from 'vue'


var state = { token: localStorage.getItem('user-token') || '', status: '', hasLoadedOnce: false };

var getters = {
  isAuthenticated: function isAuthenticated(state) {
    return !!state.token;
  },
  authStatus: function authStatus(state) {
    return state.status;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["c" /* AUTH_REQUEST */], function (_ref, user) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    // console.log('test2')
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_auth__["c" /* AUTH_REQUEST */]);
    // console.log('state')
    // console.log(state)
    // console.log('state')
    // console.log(user)
    Object(__WEBPACK_IMPORTED_MODULE_4__utils_api__["a" /* default */])({ url: '/auth', method: 'POST', user: user }).then(function (resp) {
      // console.log('test4')
      localStorage.setItem('user-token', resp.user.id);
      // console.log(resp.user.id)
      localStorage.setItem('user-id', resp.user.id);
      // Vue.set(state, 'profile.user_token', resp.token)
      // Vue.set(state, 'user.profile', resp.user)
      // Vue.set(state, 'profile', resp.user)
      // console.log('AUTH_REQUEST')
      // console.log(resp.token)
      // console.log(localStorage.getItem('user-id'))
      // console.log('AUTH_REQUEST')
      // console.log(user)
      // console.log('resp')
      // Here set the header of your ajax library to the token value.
      // example with axios
      // axios.defaults.headers.common['Authorization'] = resp.token
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_auth__["d" /* AUTH_SUCCESS */], resp);
      dispatch(__WEBPACK_IMPORTED_MODULE_3__actions_user__["b" /* USER_REQUEST */]);
      resolve(resp);
      dispatch('setUserId', resp.user.id, { root: true });
      dispatch('loadAll', { root: true });
      // dispatch('loadArtworks')
      // dispatch('loadExhibitions')
      // dispatch('loadTexts')
      // console.log(localStorage.getItem('user-token'))
      // console.log('>>>>>>>this.$store.getters.isAuthenticated')
      // console.log(this.$store.getters.isAuthenticated)
      // console.log(this.$store.getters.isAuthenticated)
      // console.log(this.$store.getters.isAuthenticated)
      // console.log('=====this.$store.getters.isAuthenticated')
    }).catch(function (err) {
      // console.log(err)
      commit(__WEBPACK_IMPORTED_MODULE_2__actions_auth__["a" /* AUTH_ERROR */], err);
      localStorage.removeItem('user-token');
      localStorage.removeItem('user-id');
      reject(err);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["b" /* AUTH_LOGOUT */], function (_ref2) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_auth__["b" /* AUTH_LOGOUT */]);
    // console.log('AUTH_LOGOUT')
    localStorage.removeItem('user-id');
    localStorage.removeItem('user-token');
    resolve();
  });
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["c" /* AUTH_REQUEST */], function (state) {
  state.status = 'loading';
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["d" /* AUTH_SUCCESS */], function (state, resp) {
  state.status = 'success';
  // state.token = resp.token
  state.profile = resp.user;
  // state.user.profile = resp.user
  state.user_id = resp.user.id;
  state.token = resp.user.id;
  // state.token = resp.id
  state.hasLoadedOnce = true;
  console.log('AUTH_SUCCESS');
  console.log(state.user_id);
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["a" /* AUTH_ERROR */], function (state) {
  state.status = 'error';
  state.hasLoadedOnce = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_auth__["b" /* AUTH_LOGOUT */], function (state) {
  state.token = '';
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "D2Yk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Light_vue__ = __webpack_require__("Q2Z5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8feb72a2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Light_vue__ = __webpack_require__("ayPc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("cq8u")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8feb72a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Light_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8feb72a2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Light_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8feb72a2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Light_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DHjl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditField__ = __webpack_require__("b7zL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeaderElements__ = __webpack_require__("oiZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ElementsTable__ = __webpack_require__("vCKh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import languages from '@/data/languages'


var show_field = function show_field(field) {
  if (field.condition && audio) {
    // var theInstructions = field.condition
    var F = function F(theInstructions) {};
    return F();
  } else {
    return true;
  }
};
// const channels = [
//   {id: 1, value: '1', name: 'Single-channel'},
//   {id: 2, value: '2', name: 'Two-channel'},
//   {id: 3, value: '3', name: 'Three-channel'},
//   {id: 4, value: '4', name: 'Four-channel'},
//   {id: 5, value: '5', name: 'Five-channel'},
//   {id: 6, value: '6', name: 'Six-channel'},
//   {id: 7, value: '7', name: 'Seven-channel'},
//   {id: 8, value: '8', name: 'Eight-channel'},
//   {id: 9, value: '9', name: 'Nine-channel'},
//   {id: 10, value: '10', name: 'Ten-channel'},
//   {id: 11, value: '11', name: '11-channel'},
//   {id: 12, value: '12', name: '12-channel'},
//   {id: 13, value: '13', name: '13-channel'},
//   {id: 14, value: '14', name: '14-channel'},
//   {id: 15, value: '15', name: '15-channel'}
// ]
/* harmony default export */ __webpack_exports__["a"] = ({

  props: ['artwork'],
  data: function data() {
    return {
      audios: [],
      audio: {
        channels: 0,
        title: '',
        audio_resolution: '',
        bitrate: '',
        audio_container: '',
        bitrate_mbps: '',
        filesize: '',
        other_specifications: '',
        associated_information: '',
        creation_date: '',
        notes: ''
      },
      showUpload: false,
      show: false,
      fields: [{
        'ctype': 'text-short',
        'name': 'audio.title',
        'title': 'Title',
        column: true,
        class: 'xs12',
        edit: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'etype': 'select',
        'selection': [{ id: '1', value: '1', name: 'Single-channel' }, { id: '2', value: '2', name: 'Two-channel' }, { id: '3', value: '3', name: 'Three-channel' }, { id: '4', value: '4', name: 'Four-channel' }, { id: '5', value: '5', name: 'Five-channel' }, { id: '6', value: '6', name: 'Six-channel' }, { id: '7', value: '7', name: 'Seven-channel' }, { id: '8', value: '8', name: 'Eight-channel' }, { id: '9', value: '9', name: 'Nine-channel' }, { id: '10', value: '10', name: 'Ten-channel' }, { id: '11', value: '11', name: '11-channel' }, { id: '12', value: '12', name: '12-channel' }, { id: '13', value: '13', name: '13-channel' }, { id: '14', value: '14', name: '14-channel' }, { id: '15', value: '15', name: '15-channel' }],
        'name': 'audio.channels',
        'title': 'channels',
        class: 'xs6',
        work_types: ['fvs'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'etype': 'select',
        'selection': ['32 kHz', '44,1 kHz', '48 kHz', '96 kHz', '192 kHz'],
        'name': 'audio.audio_resolution',
        'title': 'Audio Resolution',
        class: 'xs6',
        work_types: ['fvs'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'etype': 'select',
        'selection': ['16 Bit', '20 Bit', '24 Bit'],
        'name': 'audio.bitrate',
        'title': 'Bitrate',
        class: 'xs6',
        work_types: ['fvs'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'audio.audio_container',
        'title': 'Audio Container | Codec',
        column: true,
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'audio.bitrate_mbps',
        'title': 'Bitrate in Mbps',
        column: true,
        suffix: 'Mbps',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'audio.filesize',
        'title': 'File Size',
        column: true,
        suffix: 'MB',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'audio.title',
        'title': 'Title',
        column: true,
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-long',
        'name': 'audio.other_specifications',
        'title': 'Other Specifications',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-long',
        'name': 'audio.associated_information',
        'title': 'Associated Information carriers (format migration story)',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'date',
        'name': 'audio.creation_date',
        'title': 'Creation Date)',
        column: true,
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-long',
        'name': 'audio.notes',
        'title': 'Notes)',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }]
    };
  },
  methods: {
    set_input: function set_input(f) {
      audio[f] = f;
    },
    download: function download() {},
    add: function add() {
      this.audios.push(this.audio);
      this.showUpload = !this.showUpload;
    },
    delete_audio: function delete_audio() {},
    done_audio: function done_audio() {},
    show_field_c: function show_field_c(field) {
      // console.log(this.audio)
      return show_field(field, this.audio);
    }
  },
  computed: {
    c_user: function c_user() {
      return this.$store.state.user.profile;
    }
  },
  components: {
    'edit-field-a': __WEBPACK_IMPORTED_MODULE_0__EditField__["a" /* default */], HeaderElements: __WEBPACK_IMPORTED_MODULE_1__HeaderElements__["a" /* default */], ElementsTable: __WEBPACK_IMPORTED_MODULE_2__ElementsTable__["a" /* default */]
  }
});

/***/ }),

/***/ "DM5G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DVzf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{staticClass:"px-3 py-1 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v(_vm._s(_vm.f_field.title))])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "Djl1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "E5D/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-title',[_c('v-toolbar-title',{staticClass:"elevation-0 ml-3 pt-3 pb-0"},[_vm._v("Selections containing this Artwork ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{staticClass:"mr-3",attrs:{"append-icon":"search","label":"Search ","single-line":"","clearable":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-2 mx-4",attrs:{"search":_vm.search,"headers":_vm.headers,"items":_vm.selections,"item-key":"id","pagination":_vm.p},on:{"update:pagination":function($event){_vm.p=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"py-2 text-xs-left px-4"},[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"py-2 text-xs-center px-4"},[_vm._v("\n        "+_vm._s(props.item.artworks.length)+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"py-2 text-xs-center px-4"},[_vm._v("\n        "+_vm._s(_vm.get_user(props.item.created_by))+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"py-2 text-xs-center px-4"},[_vm._v("\n        "+_vm._s(_vm.format_date(props.item.created_at))+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"py-2 text-xs-center px-4"},[(props.item.updated_at)?_c('span',[_vm._v(_vm._s(_vm.format_date(props.item.updated_at)))]):_vm._e()])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('center',[_vm._v("No data available")])],1)],2)],1)}
var staticRenderFns = []


/***/ }),

/***/ "E5Zb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgottenPassword_vue__ = __webpack_require__("bWPW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398ef1ae_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgottenPassword_vue__ = __webpack_require__("MjL8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("uQG6")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-398ef1ae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgottenPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398ef1ae_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgottenPassword_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_398ef1ae_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgottenPassword_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EIYF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("Rzgd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e04a1d02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("Xaup");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("51Y4")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e04a1d02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e04a1d02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e04a1d02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ER8n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
  countries: [{
    'name': {
      'common': 'Aruba',
      'official': 'Aruba',
      'native': {
        'nld': {
          'official': 'Aruba',
          'common': 'Aruba'
        },
        'pap': {
          'official': 'Aruba',
          'common': 'Aruba'
        }
      }
    },
    'tld': ['.aw'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDE6\uD83C\uDDFC'

  }, {
    'name': {
      'common': 'Afghanistan',
      'official': 'Islamic Republic of Afghanistan',
      'native': {
        'prs': {
          'official': '\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646',
          'common': '\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646'
        },
        'pus': {
          'official': '\u062F \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646 \u0627\u0633\u0644\u0627\u0645\u064A \u062C\u0645\u0647\u0648\u0631\u06CC\u062A',
          'common': '\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646'
        },
        'tuk': {
          'official': 'Owganystan Yslam Respublikasy',
          'common': 'Owganystan'
        }
      }
    },
    'tld': ['.af'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'flag': '\uD83C\uDDE6\uD83C\uDDEB'

  }, {
    'name': {
      'common': 'Angola',
      'official': 'Republic of Angola',
      'native': {
        'por': {
          'official': 'Rep\xFAblica de Angola',
          'common': 'Angola'
        }
      }
    },
    'tld': ['.ao'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'flag': '\uD83C\uDDE6\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Anguilla',
      'official': 'Anguilla',
      'native': {
        'eng': {
          'official': 'Anguilla',
          'common': 'Anguilla'
        }
      }
    },
    'tld': ['.ai'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDE6\uD83C\uDDEE'

  }, {
    'name': {
      'common': '\xC5land Islands',
      'official': '\xC5land Islands',
      'native': {
        'swe': {
          'official': 'Landskapet \xC5land',
          'common': '\xC5land'
        }
      }
    },
    'tld': ['.ax'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDE6\uD83C\uDDFD'

  }, {
    'name': {
      'common': 'Albania',
      'official': 'Republic of Albania',
      'native': {
        'sqi': {
          'official': 'Republika e Shqip\xEBris\xEB',
          'common': 'Shqip\xEBria'
        }
      }
    },
    'tld': ['.al'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDE6\uD83C\uDDF1'

  }, {
    'name': {
      'common': 'Andorra',
      'official': 'Principality of Andorra',
      'native': {
        'cat': {
          'official': "Principat d'Andorra",
          'common': 'Andorra'
        }
      }
    },
    'tld': ['.ad'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDE6\uD83C\uDDE9'

  }, {
    'name': {
      'common': 'United Arab Emirates',
      'official': 'United Arab Emirates',
      'native': {
        'ara': {
          'official': '\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629',
          'common': '\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629'
        }
      }
    },
    'tld': ['.ae', '\u0627\u0645\u0627\u0631\u0627\u062A.'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDE6\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Argentina',
      'official': 'Argentine Republic',
      'native': {
        'grn': {
          'official': 'Argentine Republic',
          'common': 'Argentina'
        },
        'spa': {
          'official': 'Rep\xFAblica Argentina',
          'common': 'Argentina'
        }
      }
    },
    'tld': ['.ar'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDE6\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Armenia',
      'official': 'Republic of Armenia',
      'native': {
        'hye': {
          'official': '\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576\u056B \u0540\u0561\u0576\u0580\u0561\u057A\u0565\u057F\u0578\u0582\u0569\u0575\u0578\u0582\u0576',
          'common': '\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576'
        }
      }
    },
    'tld': ['.am'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDE6\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'American Samoa',
      'official': 'American Samoa',
      'native': {
        'eng': {
          'official': 'American Samoa',
          'common': 'American Samoa'
        },
        'smo': {
          'official': 'S\u0101moa Amelika',
          'common': 'S\u0101moa Amelika'
        }
      }
    },
    'tld': ['.as'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'flag': '\uD83C\uDDE6\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'Antarctica',
      'official': 'Antarctica',
      'native': {}
    },
    'tld': ['.aq'],
    'region': 'Antarctic',
    'subregion': '',
    'flag': '\uD83C\uDDE6\uD83C\uDDF6'

  }, {
    'name': {
      'common': 'French Southern and Antarctic Lands',
      'official': 'Territory of the French Southern and Antarctic Lands',
      'native': {
        'fra': {
          'official': 'Territoire des Terres australes et antarctiques fran\xE7aises',
          'common': 'Terres australes et antarctiques fran\xE7aises'
        }
      }
    },
    'tld': ['.tf'],
    'region': 'Antarctic',
    'subregion': '',
    'flag': '\uD83C\uDDF9\uD83C\uDDEB'

  }, {
    'name': {
      'common': 'Antigua and Barbuda',
      'official': 'Antigua and Barbuda',
      'native': {
        'eng': {
          'official': 'Antigua and Barbuda',
          'common': 'Antigua and Barbuda'
        }
      }
    },
    'tld': ['.ag'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDE6\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'Australia',
      'official': 'Commonwealth of Australia',
      'native': {
        'eng': {
          'official': 'Commonwealth of Australia',
          'common': 'Australia'
        }
      }
    },
    'tld': ['.au'],
    'region': 'Oceania',
    'subregion': 'Australia and New Zealand',
    'flag': '\uD83C\uDDE6\uD83C\uDDFA'

  }, {
    'name': {
      'common': 'Austria',
      'official': 'Republic of Austria',
      'native': {
        'bar': {
          'official': 'Republik \xD6sterreich',
          'common': '\xD6sterreich'
        }
      }
    },
    'tld': ['.at'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'flag': '\uD83C\uDDE6\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'Azerbaijan',
      'official': 'Republic of Azerbaijan',
      'native': {
        'aze': {
          'official': 'Az\u0259rbaycan Respublikas\u0131',
          'common': 'Az\u0259rbaycan'
        },
        'rus': {
          'official': '\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430',
          'common': '\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043D'
        }
      }
    },
    'tld': ['.az'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDE6\uD83C\uDDFF'

  }, {
    'name': {
      'common': 'Burundi',
      'official': 'Republic of Burundi',
      'native': {
        'fra': {
          'official': 'R\xE9publique du Burundi',
          'common': 'Burundi'
        },
        'run': {
          'official': "Republika y'Uburundi ",
          'common': 'Uburundi'
        }
      }
    },
    'tld': ['.bi'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDE7\uD83C\uDDEE'

  }, {
    'name': {
      'common': 'Belgium',
      'official': 'Kingdom of Belgium',
      'native': {
        'deu': {
          'official': 'K\xF6nigreich Belgien',
          'common': 'Belgien'
        },
        'fra': {
          'official': 'Royaume de Belgique',
          'common': 'Belgique'
        },
        'nld': {
          'official': 'Koninkrijk Belgi\xEB',
          'common': 'Belgi\xEB'
        }
      }
    },
    'tld': ['.be'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'flag': '\uD83C\uDDE7\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Benin',
      'official': 'Republic of Benin',
      'native': {
        'fra': {
          'official': 'R\xE9publique du B\xE9nin',
          'common': 'B\xE9nin'
        }
      }
    },
    'tld': ['.bj'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDE7\uD83C\uDDEF'

  }, {
    'name': {
      'common': 'Burkina Faso',
      'official': 'Burkina Faso',
      'native': {
        'fra': {
          'official': 'R\xE9publique du Burkina',
          'common': 'Burkina Faso'
        }
      }
    },
    'tld': ['.bf'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDE7\uD83C\uDDEB'

  }, {
    'name': {
      'common': 'Bangladesh',
      'official': "People's Republic of Bangladesh",
      'native': {
        'ben': {
          'official': '\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6 \u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0',
          'common': '\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6'
        }
      }
    },
    'tld': ['.bd'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'flag': '\uD83C\uDDE7\uD83C\uDDE9'

  }, {
    'name': {
      'common': 'Bulgaria',
      'official': 'Republic of Bulgaria',
      'native': {
        'bul': {
          'official': '\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F',
          'common': '\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F'
        }
      }
    },
    'tld': ['.bg'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDE7\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'Bahrain',
      'official': 'Kingdom of Bahrain',
      'native': {
        'ara': {
          'official': '\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0628\u062D\u0631\u064A\u0646',
          'common': '\u200F\u0627\u0644\u0628\u062D\u0631\u064A\u0646'
        }
      }
    },
    'tld': ['.bh'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDE7\uD83C\uDDED'

  }, {
    'name': {
      'common': 'Bahamas',
      'official': 'Commonwealth of the Bahamas',
      'native': {
        'eng': {
          'official': 'Commonwealth of the Bahamas',
          'common': 'Bahamas'
        }
      }
    },
    'tld': ['.bs'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDE7\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'Bosnia and Herzegovina',
      'official': 'Bosnia and Herzegovina',
      'native': {
        'bos': {
          'official': 'Bosna i Hercegovina',
          'common': 'Bosna i Hercegovina'
        },
        'hrv': {
          'official': 'Bosna i Hercegovina',
          'common': 'Bosna i Hercegovina'
        },
        'srp': {
          'official': '\u0411\u043E\u0441\u043Da \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430',
          'common': '\u0411\u043E\u0441\u043Da \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430'
        }
      }
    },
    'tld': ['.ba'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDE7\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'Saint Barth\xE9lemy',
      'official': 'Collectivity of Saint Barth\xE9lemy',
      'native': {
        'fra': {
          'official': 'Collectivit\xE9 de Saint-Barth\xE9lemy',
          'common': 'Saint-Barth\xE9lemy'
        }
      }
    },
    'tld': ['.bl'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDE7\uD83C\uDDF1'

  }, {
    'name': {
      'common': 'Saint Helena, Ascension and Tristan da Cunha',
      'official': 'Saint Helena, Ascension and Tristan da Cunha',
      'native': {
        'eng': {
          'official': 'Saint Helena, Ascension and Tristan da Cunha',
          'common': 'Saint Helena, Ascension and Tristan da Cunha'
        }
      }
    },
    'tld': ['.sh', '.ac'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDF8\uD83C\uDDED'

  }, {
    'name': {
      'common': 'Belarus',
      'official': 'Republic of Belarus',
      'native': {
        'bel': {
          'official': '\u0420\u044D\u0441\u043F\u0443\u0431\u043B\u0456\u043A\u0430 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C',
          'common': '\u0411\u0435\u043B\u0430\u0440\u0443\u0301\u0441\u044C'
        },
        'rus': {
          'official': '\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C',
          'common': '\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C'
        }
      }
    },
    'tld': ['.by'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDE7\uD83C\uDDFE'

  }, {
    'name': {
      'common': 'Belize',
      'official': 'Belize',
      'native': {
        'bjz': {
          'official': 'Belize',
          'common': 'Belize'
        },
        'eng': {
          'official': 'Belize',
          'common': 'Belize'
        },
        'spa': {
          'official': 'Belice',
          'common': 'Belice'
        }
      }
    },
    'tld': ['.bz'],
    'region': 'Americas',
    'subregion': 'Central America',
    'flag': '\uD83C\uDDE7\uD83C\uDDFF'

  }, {
    'name': {
      'common': 'Bermuda',
      'official': 'Bermuda',
      'native': {
        'eng': {
          'official': 'Bermuda',
          'common': 'Bermuda'
        }
      }
    },
    'tld': ['.bm'],
    'region': 'Americas',
    'subregion': 'North America',
    'flag': '\uD83C\uDDE7\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Bolivia',
      'official': 'Plurinational State of Bolivia',
      'native': {
        'aym': {
          'official': 'Wuliwya Suyu',
          'common': 'Wuliwya'
        },
        'grn': {
          'official': 'Tet\xE3 Vol\xEDvia',
          'common': 'Vol\xEDvia'
        },
        'que': {
          'official': 'Buliwya Mamallaqta',
          'common': 'Buliwya'
        },
        'spa': {
          'official': 'Estado Plurinacional de Bolivia',
          'common': 'Bolivia'
        }
      }
    },
    'tld': ['.bo'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDE7\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Caribbean Netherlands',
      'official': 'Bonaire, Sint Eustatius and Saba',
      'native': {
        'nld': {
          'official': 'Bonaire, Sint Eustatius en Saba',
          'common': 'Caribisch Nederland'
        },
        'pap': {
          'official': 'Boneiru, Sint Eustatius y Saba',
          'common': 'Boneiru, Sint Eustatius y Saba'
        }
      }
    },
    'tld': ['.bq', '.nl'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': ''

  }, {
    'name': {
      'common': 'Brazil',
      'official': 'Federative Republic of Brazil',
      'native': {
        'por': {
          'official': 'Rep\xFAblica Federativa do Brasil',
          'common': 'Brasil'
        }
      }
    },
    'tld': ['.br'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDE7\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Barbados',
      'official': 'Barbados',
      'native': {
        'eng': {
          'official': 'Barbados',
          'common': 'Barbados'
        }
      }
    },
    'tld': ['.bb'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDE7\uD83C\uDDE7'

  }, {
    'name': {
      'common': 'Brunei',
      'official': 'Nation of Brunei, Abode of Peace',
      'native': {
        'msa': {
          'official': 'Nation of Brunei, Abode Damai',
          'common': 'Negara Brunei Darussalam'
        }
      }
    },
    'tld': ['.bn'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'flag': '\uD83C\uDDE7\uD83C\uDDF3'

  }, {
    'name': {
      'common': 'Bhutan',
      'official': 'Kingdom of Bhutan',
      'native': {
        'dzo': {
          'official': '\u0F60\u0F56\u0FB2\u0F74\u0F42\u0F0B\u0F62\u0F92\u0FB1\u0F63\u0F0B\u0F41\u0F56\u0F0B',
          'common': '\u0F60\u0F56\u0FB2\u0F74\u0F42\u0F0B\u0F61\u0F74\u0F63\u0F0B'
        }
      }
    },
    'tld': ['.bt'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'flag': '\uD83C\uDDE7\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'Bouvet Island',
      'official': 'Bouvet Island',
      'native': {
        'nor': {
          'official': 'Bouvet\xF8ya',
          'common': 'Bouvet\xF8ya'
        }
      }
    },
    'tld': ['.bv'],
    'region': 'Antarctic',
    'subregion': '',
    'flag': '\uD83C\uDDE7\uD83C\uDDFB'

  }, {
    'name': {
      'common': 'Botswana',
      'official': 'Republic of Botswana',
      'native': {
        'eng': {
          'official': 'Republic of Botswana',
          'common': 'Botswana'
        },
        'tsn': {
          'official': 'Lefatshe la Botswana',
          'common': 'Botswana'
        }
      }
    },
    'tld': ['.bw'],
    'region': 'Africa',
    'subregion': 'Southern Africa',
    'flag': '\uD83C\uDDE7\uD83C\uDDFC'

  }, {
    'name': {
      'common': 'Central African Republic',
      'official': 'Central African Republic',
      'native': {
        'fra': {
          'official': 'R\xE9publique centrafricaine',
          'common': 'R\xE9publique centrafricaine'
        },
        'sag': {
          'official': 'K\xF6d\xF6r\xF6s\xEAse t\xEE B\xEAafr\xEEka',
          'common': 'B\xEAafr\xEEka'
        }
      }
    },
    'tld': ['.cf'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'flag': '\uD83C\uDDE8\uD83C\uDDEB'

  }, {
    'name': {
      'common': 'Canada',
      'official': 'Canada',
      'native': {
        'eng': {
          'official': 'Canada',
          'common': 'Canada'
        },
        'fra': {
          'official': 'Canada',
          'common': 'Canada'
        }
      }
    },
    'tld': ['.ca'],
    'region': 'Americas',
    'subregion': 'North America',
    'flag': '\uD83C\uDDE8\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'Cocos (Keeling) Islands',
      'official': 'Territory of the Cocos (Keeling) Islands',
      'native': {
        'eng': {
          'official': 'Territory of the Cocos (Keeling) Islands',
          'common': 'Cocos (Keeling) Islands'
        }
      }
    },
    'tld': ['.cc'],
    'region': 'Oceania',
    'subregion': 'Australia and New Zealand',
    'flag': '\uD83C\uDDE8\uD83C\uDDE8'

  }, {
    'name': {
      'common': 'Switzerland',
      'official': 'Swiss Confederation',
      'native': {
        'fra': {
          'official': 'Conf\xE9d\xE9ration suisse',
          'common': 'Suisse'
        },
        'gsw': {
          'official': 'Schweizerische Eidgenossenschaft',
          'common': 'Schweiz'
        },
        'ita': {
          'official': 'Confederazione Svizzera',
          'common': 'Svizzera'
        },
        'roh': {
          'official': 'Confederaziun svizra',
          'common': 'Svizra'
        }
      }
    },
    'tld': ['.ch'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'flag': '\uD83C\uDDE8\uD83C\uDDED'

  }, {
    'name': {
      'common': 'Chile',
      'official': 'Republic of Chile',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica de Chile',
          'common': 'Chile'
        }
      }
    },
    'tld': ['.cl'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDE8\uD83C\uDDF1'

  }, {
    'name': {
      'common': 'China',
      'official': "People's Republic of China",
      'native': {
        'zho': {
          'official': '\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD',
          'common': '\u4E2D\u56FD'
        }
      }
    },
    'tld': ['.cn', '.\u4E2D\u56FD', '.\u4E2D\u570B', '.\u516C\u53F8', '.\u7F51\u7EDC'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'flag': '\uD83C\uDDE8\uD83C\uDDF3'

  }, {
    'name': {
      'common': 'Ivory Coast',
      'official': 'Republic of C\xF4te d\'Ivoire',
      'native': {
        'fra': {
          'official': 'R\xE9publique de C\xF4te d\'Ivoire',
          'common': 'C\xF4te d\'Ivoire'
        }
      }
    },
    'tld': ['.ci'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDE8\uD83C\uDDEE'

  }, {
    'name': {
      'common': 'Cameroon',
      'official': 'Republic of Cameroon',
      'native': {
        'eng': {
          'official': 'Republic of Cameroon',
          'common': 'Cameroon'
        },
        'fra': {
          'official': 'R\xE9publique du Cameroun',
          'common': 'Cameroun'
        }
      }
    },
    'tld': ['.cm'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'flag': '\uD83C\uDDE8\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'DR Congo',
      'official': 'Democratic Republic of the Congo',
      'native': {
        'fra': {
          'official': 'R\xE9publique d\xE9mocratique du Congo',
          'common': 'RD Congo'
        },
        'kon': {
          'official': 'Repubilika ya Kongo Demokratiki',
          'common': 'Repubilika ya Kongo Demokratiki'
        },
        'lin': {
          'official': 'Republiki ya Kong\xF3 Demokratiki',
          'common': 'Republiki ya Kong\xF3 Demokratiki'
        },
        'lua': {
          'official': 'Ditunga dia Kongu wa Mungalaata',
          'common': 'Ditunga dia Kongu wa Mungalaata'
        },
        'swa': {
          'official': 'Jamhuri ya Kidemokrasia ya Kongo',
          'common': 'Jamhuri ya Kidemokrasia ya Kongo'
        }
      }
    },
    'tld': ['.cd'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'flag': '\uD83C\uDDE8\uD83C\uDDE9'

  }, {
    'name': {
      'common': 'Republic of the Congo',
      'official': 'Republic of the Congo',
      'native': {
        'fra': {
          'official': 'R\xE9publique du Congo',
          'common': 'R\xE9publique du Congo'
        },
        'kon': {
          'official': 'Repubilika ya Kongo',
          'common': 'Repubilika ya Kongo'
        },
        'lin': {
          'official': 'Republ\xEDki ya Kong\xF3',
          'common': 'Republ\xEDki ya Kong\xF3'
        }
      }
    },
    'tld': ['.cg'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'flag': '\uD83C\uDDE8\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'Cook Islands',
      'official': 'Cook Islands',
      'native': {
        'eng': {
          'official': 'Cook Islands',
          'common': 'Cook Islands'
        },
        'rar': {
          'official': 'K\u016Bki \'\u0100irani',
          'common': 'K\u016Bki \'\u0100irani'
        }
      }
    },
    'tld': ['.ck'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'flag': '\uD83C\uDDE8\uD83C\uDDF0'

  }, {
    'name': {
      'common': 'Colombia',
      'official': 'Republic of Colombia',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica de Colombia',
          'common': 'Colombia'
        }
      }
    },
    'tld': ['.co'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDE8\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Comoros',
      'official': 'Union of the Comoros',
      'native': {
        'ara': {
          'official': '\u0627\u0644\u0627\u062A\u062D\u0627\u062F \u0627\u0644\u0642\u0645\u0631\u064A',
          'common': '\u0627\u0644\u0642\u0645\u0631\u200E'
        },
        'fra': {
          'official': 'Union des Comores',
          'common': 'Comores'
        },
        'zdj': {
          'official': 'Udzima wa Komori',
          'common': 'Komori'
        }
      }
    },
    'tld': ['.km'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDF0\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Cape Verde',
      'official': 'Republic of Cabo Verde',
      'native': {
        'por': {
          'official': 'Rep\xFAblica de Cabo Verde',
          'common': 'Cabo Verde'
        }
      }
    },
    'tld': ['.cv'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDE8\uD83C\uDDFB'

  }, {
    'name': {
      'common': 'Costa Rica',
      'official': 'Republic of Costa Rica',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica de Costa Rica',
          'common': 'Costa Rica'
        }
      }
    },
    'tld': ['.cr'],
    'region': 'Americas',
    'subregion': 'Central America',
    'flag': '\uD83C\uDDE8\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Cuba',
      'official': 'Republic of Cuba',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica de Cuba',
          'common': 'Cuba'
        }
      }
    },
    'tld': ['.cu'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDE8\uD83C\uDDFA'

  }, {
    'name': {
      'common': 'Cura\xE7ao',
      'official': 'Country of Cura\xE7ao',
      'native': {
        'eng': {
          'official': 'Country of Cura\xE7ao',
          'common': 'Cura\xE7ao'
        },
        'nld': {
          'official': 'Land Cura\xE7ao',
          'common': 'Cura\xE7ao'
        },
        'pap': {
          'official': 'Pais K\xF2rsou',
          'common': 'Pais K\xF2rsou'
        }
      }
    },
    'tld': ['.cw'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDE8\uD83C\uDDFC'

  }, {
    'name': {
      'common': 'Christmas Island',
      'official': 'Territory of Christmas Island',
      'native': {
        'eng': {
          'official': 'Territory of Christmas Island',
          'common': 'Christmas Island'
        }
      }
    },
    'tld': ['.cx'],
    'region': 'Oceania',
    'subregion': 'Australia and New Zealand',
    'flag': '\uD83C\uDDE8\uD83C\uDDFD'

  }, {
    'name': {
      'common': 'Cayman Islands',
      'official': 'Cayman Islands',
      'native': {
        'eng': {
          'official': 'Cayman Islands',
          'common': 'Cayman Islands'
        }
      }
    },
    'tld': ['.ky'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDF0\uD83C\uDDFE'

  }, {
    'name': {
      'common': 'Cyprus',
      'official': 'Republic of Cyprus',
      'native': {
        'ell': {
          'official': '\u0394\u03B7\u03BC\u03BF\u03BA\u03C1\u03B1\u03C4\u03AF\u03B1 \u03C4\u03B7\u03C2 \u039A\u03CD\u03C0\u03C1\u03BF\u03C2',
          'common': '\u039A\u03CD\u03C0\u03C1\u03BF\u03C2'
        },
        'tur': {
          'official': 'K\u0131br\u0131s Cumhuriyeti',
          'common': 'K\u0131br\u0131s'
        }
      }
    },
    'tld': ['.cy'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDE8\uD83C\uDDFE'

  }, {
    'name': {
      'common': 'Czechia',
      'official': 'Czech Republic',
      'native': {
        'ces': {
          'official': '\u010Desk\xE1 republika',
          'common': '\u010Cesko'
        },
        'slk': {
          'official': '\u010Cesk\xE1 republika',
          'common': '\u010Cesko'
        }
      }
    },
    'tld': ['.cz'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDE8\uD83C\uDDFF'

  }, {
    'name': {
      'common': 'Germany',
      'official': 'Federal Republic of Germany',
      'native': {
        'deu': {
          'official': 'Bundesrepublik Deutschland',
          'common': 'Deutschland'
        }
      }
    },
    'tld': ['.de'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'flag': '\uD83C\uDDE9\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Djibouti',
      'official': 'Republic of Djibouti',
      'native': {
        'ara': {
          'official': '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u062C\u064A\u0628\u0648\u062A\u064A',
          'common': '\u062C\u064A\u0628\u0648\u062A\u064A\u200E'
        },
        'fra': {
          'official': 'R\xE9publique de Djibouti',
          'common': 'Djibouti'
        }
      }
    },
    'tld': ['.dj'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDE9\uD83C\uDDEF'

  }, {
    'name': {
      'common': 'Dominica',
      'official': 'Commonwealth of Dominica',
      'native': {
        'eng': {
          'official': 'Commonwealth of Dominica',
          'common': 'Dominica'
        }
      }
    },
    'tld': ['.dm'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDE9\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Denmark',
      'official': 'Kingdom of Denmark',
      'native': {
        'dan': {
          'official': 'Kongeriget Danmark',
          'common': 'Danmark'
        }
      }
    },
    'tld': ['.dk'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDE9\uD83C\uDDF0'

  }, {
    'name': {
      'common': 'Dominican Republic',
      'official': 'Dominican Republic',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica Dominicana',
          'common': 'Rep\xFAblica Dominicana'
        }
      }
    },
    'tld': ['.do'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDE9\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Algeria',
      'official': "People's Democratic Republic of Algeria",
      'native': {
        'ara': {
          'official': '\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062F\u064A\u0645\u0642\u0631\u0627\u0637\u064A\u0629 \u0627\u0644\u0634\u0639\u0628\u064A\u0629 \u0627\u0644\u062C\u0632\u0627\u0626\u0631\u064A\u0629',
          'common': '\u0627\u0644\u062C\u0632\u0627\u0626\u0631'
        }
      }
    },
    'tld': ['.dz', '\u0627\u0644\u062C\u0632\u0627\u0626\u0631.'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'flag': '\uD83C\uDDE9\uD83C\uDDFF'

  }, {
    'name': {
      'common': 'Ecuador',
      'official': 'Republic of Ecuador',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica del Ecuador',
          'common': 'Ecuador'
        }
      }
    },
    'tld': ['.ec'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDEA\uD83C\uDDE8'

  }, {
    'name': {
      'common': 'Egypt',
      'official': 'Arab Republic of Egypt',
      'native': {
        'ara': {
          'official': '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0645\u0635\u0631 \u0627\u0644\u0639\u0631\u0628\u064A\u0629',
          'common': '\u0645\u0635\u0631'
        }
      }
    },
    'tld': ['.eg', '.\u0645\u0635\u0631'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'flag': '\uD83C\uDDEA\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'Eritrea',
      'official': 'State of Eritrea',
      'native': {
        'ara': {
          'official': '\u062F\u0648\u0644\u0629 \u0625\u0631\u062A\u0631\u064A\u0627',
          'common': '\u0625\u0631\u062A\u0631\u064A\u0627\u200E'
        },
        'eng': {
          'official': 'State of Eritrea',
          'common': 'Eritrea'
        },
        'tir': {
          'official': '\u1203\u1308\u1228 \u12A4\u122D\u1275\u122B',
          'common': '\u12A4\u122D\u1275\u122B'
        }
      }
    },
    'tld': ['.er'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDEA\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Western Sahara',
      'official': 'Sahrawi Arab Democratic Republic',
      'native': {
        'ber': {
          'official': 'Sahrawi Arab Democratic Republic',
          'common': 'Western Sahara'
        },
        'mey': {
          'official': '\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0635\u062D\u0631\u0627\u0648\u064A\u0629 \u0627\u0644\u062F\u064A\u0645\u0642\u0631\u0627\u0637\u064A\u0629',
          'common': '\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629'
        },
        'spa': {
          'official': 'Rep\xFAblica \xC1rabe Saharaui Democr\xE1tica',
          'common': 'Sahara Occidental'
        }
      }
    },
    'tld': ['.eh'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'flag': '\uD83C\uDDEA\uD83C\uDDED'

  }, {
    'name': {
      'common': 'Spain',
      'official': 'Kingdom of Spain',
      'native': {
        'spa': {
          'official': 'Reino de Espa\xF1a',
          'common': 'Espa\xF1a'
        }
      }
    },
    'tld': ['.es'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDEA\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'Estonia',
      'official': 'Republic of Estonia',
      'native': {
        'est': {
          'official': 'Eesti Vabariik',
          'common': 'Eesti'
        }
      }
    },
    'tld': ['.ee'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDEA\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Ethiopia',
      'official': 'Federal Democratic Republic of Ethiopia',
      'native': {
        'amh': {
          'official': '\u12E8\u12A2\u1275\u12EE\u1335\u12EB \u134C\u12F4\u122B\u120B\u12CA \u12F2\u121E\u12AD\u122B\u1232\u12EB\u12CA \u122A\u1350\u1265\u120A\u12AD',
          'common': '\u12A2\u1275\u12EE\u1335\u12EB'
        }
      }
    },
    'tld': ['.et'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDEA\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'Finland',
      'official': 'Republic of Finland',
      'native': {
        'fin': {
          'official': 'Suomen tasavalta',
          'common': 'Suomi'
        },
        'swe': {
          'official': 'Republiken Finland',
          'common': 'Finland'
        }
      }
    },
    'tld': ['.fi'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDEB\uD83C\uDDEE'

  }, {
    'name': {
      'common': 'Fiji',
      'official': 'Republic of Fiji',
      'native': {
        'eng': {
          'official': 'Republic of Fiji',
          'common': 'Fiji'
        },
        'fij': {
          'official': 'Matanitu Tugalala o Viti',
          'common': 'Viti'
        },
        'hif': {
          'official': '\u0930\u093F\u092A\u092C\u094D\u0932\u093F\u0915 \u0911\u092B \u092B\u0940\u091C\u0940',
          'common': '\u092B\u093F\u091C\u0940'
        }
      }
    },
    'tld': ['.fj'],
    'region': 'Oceania',
    'subregion': 'Melanesia',
    'flag': '\uD83C\uDDEB\uD83C\uDDEF'

  }, {
    'name': {
      'common': 'Falkland Islands',
      'official': 'Falkland Islands',
      'native': {
        'eng': {
          'official': 'Falkland Islands',
          'common': 'Falkland Islands'
        }
      }
    },
    'tld': ['.fk'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDEB\uD83C\uDDF0'

  }, {
    'name': {
      'common': 'France',
      'official': 'French Republic',
      'native': {
        'fra': {
          'official': 'R\xE9publique fran\xE7aise',
          'common': 'France'
        }
      }
    },
    'tld': ['.fr'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'flag': '\uD83C\uDDEB\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Faroe Islands',
      'official': 'Faroe Islands',
      'native': {
        'dan': {
          'official': 'F\xE6r\xF8erne',
          'common': 'F\xE6r\xF8erne'
        },
        'fao': {
          'official': 'F\xF8royar',
          'common': 'F\xF8royar'
        }
      }
    },
    'tld': ['.fo'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDEB\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Micronesia',
      'official': 'Federated States of Micronesia',
      'native': {
        'eng': {
          'official': 'Federated States of Micronesia',
          'common': 'Micronesia'
        }
      }
    },
    'tld': ['.fm'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'flag': '\uD83C\uDDEB\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Gabon',
      'official': 'Gabonese Republic',
      'native': {
        'fra': {
          'official': 'R\xE9publique gabonaise',
          'common': 'Gabon'
        }
      }
    },
    'tld': ['.ga'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'flag': '\uD83C\uDDEC\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'United Kingdom',
      'official': 'United Kingdom of Great Britain and Northern Ireland',
      'native': {
        'eng': {
          'official': 'United Kingdom of Great Britain and Northern Ireland',
          'common': 'United Kingdom'
        }
      }
    },
    'tld': ['.uk'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDEC\uD83C\uDDE7'

  }, {
    'name': {
      'common': 'Georgia',
      'official': 'Georgia',
      'native': {
        'kat': {
          'official': '\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD',
          'common': '\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD'
        }
      }
    },
    'tld': ['.ge'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDEC\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Guernsey',
      'official': 'Bailiwick of Guernsey',
      'native': {
        'eng': {
          'official': 'Bailiwick of Guernsey',
          'common': 'Guernsey'
        },
        'fra': {
          'official': 'Bailliage de Guernesey',
          'common': 'Guernesey'
        },
        'nfr': {
          'official': 'Dg\xE8rn\xE9siais',
          'common': 'Dg\xE8rn\xE9siais'
        }
      }
    },
    'tld': ['.gg'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDEC\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'Ghana',
      'official': 'Republic of Ghana',
      'native': {
        'eng': {
          'official': 'Republic of Ghana',
          'common': 'Ghana'
        }
      }
    },
    'tld': ['.gh'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDEC\uD83C\uDDED'

  }, {
    'name': {
      'common': 'Gibraltar',
      'official': 'Gibraltar',
      'native': {
        'eng': {
          'official': 'Gibraltar',
          'common': 'Gibraltar'
        }
      }
    },
    'tld': ['.gi'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDEC\uD83C\uDDEE'

  }, {
    'name': {
      'common': 'Guinea',
      'official': 'Republic of Guinea',
      'native': {
        'fra': {
          'official': 'R\xE9publique de Guin\xE9e',
          'common': 'Guin\xE9e'
        }
      }
    },
    'tld': ['.gn'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDEC\uD83C\uDDF3'

  }, {
    'name': {
      'common': 'Guadeloupe',
      'official': 'Guadeloupe',
      'native': {
        'fra': {
          'official': 'Guadeloupe',
          'common': 'Guadeloupe'
        }
      }
    },
    'tld': ['.gp'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDEC\uD83C\uDDF5'

  }, {
    'name': {
      'common': 'Gambia',
      'official': 'Republic of the Gambia',
      'native': {
        'eng': {
          'official': 'Republic of the Gambia',
          'common': 'Gambia'
        }
      }
    },
    'tld': ['.gm'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDEC\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Guinea-Bissau',
      'official': 'Republic of Guinea-Bissau',
      'native': {
        'por': {
          'official': 'Rep\xFAblica da Guin\xE9-Bissau',
          'common': 'Guin\xE9-Bissau'
        },
        'pov': {
          'official': 'Rep\xFAblica da Guin\xE9-Bissau',
          'common': 'Guin\xE9-Bissau'
        }
      }
    },
    'tld': ['.gw'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDEC\uD83C\uDDFC'

  }, {
    'name': {
      'common': 'Equatorial Guinea',
      'official': 'Republic of Equatorial Guinea',
      'native': {
        'fra': {
          'official': 'R\xE9publique de la Guin\xE9e \xC9quatoriale',
          'common': 'Guin\xE9e \xE9quatoriale'
        },
        'por': {
          'official': 'Rep\xFAblica da Guin\xE9 Equatorial',
          'common': 'Guin\xE9 Equatorial'
        },
        'spa': {
          'official': 'Rep\xFAblica de Guinea Ecuatorial',
          'common': 'Guinea Ecuatorial'
        }
      }
    },
    'tld': ['.gq'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'flag': '\uD83C\uDDEC\uD83C\uDDF6'

  }, {
    'name': {
      'common': 'Greece',
      'official': 'Hellenic Republic',
      'native': {
        'ell': {
          'official': '\u0395\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AE \u0394\u03B7\u03BC\u03BF\u03BA\u03C1\u03B1\u03C4\u03AF\u03B1',
          'common': '\u0395\u03BB\u03BB\u03AC\u03B4\u03B1'
        }
      }
    },
    'tld': ['.gr'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDEC\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Grenada',
      'official': 'Grenada',
      'native': {
        'eng': {
          'official': 'Grenada',
          'common': 'Grenada'
        }
      }
    },
    'tld': ['.gd'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDEC\uD83C\uDDE9'

  }, {
    'name': {
      'common': 'Greenland',
      'official': 'Greenland',
      'native': {
        'kal': {
          'official': 'Kalaallit Nunaat',
          'common': 'Kalaallit Nunaat'
        }
      }
    },
    'tld': ['.gl'],
    'region': 'Americas',
    'subregion': 'North America',
    'flag': '\uD83C\uDDEC\uD83C\uDDF1'

  }, {
    'name': {
      'common': 'Guatemala',
      'official': 'Republic of Guatemala',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica de Guatemala',
          'common': 'Guatemala'
        }
      }
    },
    'tld': ['.gt'],
    'region': 'Americas',
    'subregion': 'Central America',
    'flag': '\uD83C\uDDEC\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'French Guiana',
      'official': 'Guiana',
      'native': {
        'fra': {
          'official': 'Guyane',
          'common': 'Guyane fran\xE7aise'
        }
      }
    },
    'tld': ['.gf'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDEC\uD83C\uDDEB'

  }, {
    'name': {
      'common': 'Guam',
      'official': 'Guam',
      'native': {
        'cha': {
          'official': 'Gu\xE5h\xE5n',
          'common': 'Gu\xE5h\xE5n'
        },
        'eng': {
          'official': 'Guam',
          'common': 'Guam'
        },
        'spa': {
          'official': 'Guam',
          'common': 'Guam'
        }
      }
    },
    'tld': ['.gu'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'flag': '\uD83C\uDDEC\uD83C\uDDFA'

  }, {
    'name': {
      'common': 'Guyana',
      'official': 'Co-operative Republic of Guyana',
      'native': {
        'eng': {
          'official': 'Co-operative Republic of Guyana',
          'common': 'Guyana'
        }
      }
    },
    'tld': ['.gy'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDEC\uD83C\uDDFE'

  }, {
    'name': {
      'common': 'Hong Kong',
      'official': "Hong Kong Special Administrative Region of the People's Republic of China",
      'native': {
        'eng': {
          'official': "Hong Kong Special Administrative Region of the People's Republic of China",
          'common': 'Hong Kong'
        },
        'zho': {
          'official': '\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u9999\u6E2F\u7279\u522B\u884C\u653F\u533A',
          'common': '\u9999\u6E2F'
        }
      }
    },
    'tld': ['.hk', '.\u9999\u6E2F'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'flag': '\uD83C\uDDED\uD83C\uDDF0'

  }, {
    'name': {
      'common': 'Heard Island and McDonald Islands',
      'official': 'Heard Island and McDonald Islands',
      'native': {
        'eng': {
          'official': 'Heard Island and McDonald Islands',
          'common': 'Heard Island and McDonald Islands'
        }
      }
    },
    'tld': ['.hm', '.aq'],
    'region': 'Antarctic',
    'subregion': '',
    'flag': '\uD83C\uDDED\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Honduras',
      'official': 'Republic of Honduras',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica de Honduras',
          'common': 'Honduras'
        }
      }
    },
    'tld': ['.hn'],
    'region': 'Americas',
    'subregion': 'Central America',
    'flag': '\uD83C\uDDED\uD83C\uDDF3'

  }, {
    'name': {
      'common': 'Croatia',
      'official': 'Republic of Croatia',
      'native': {
        'hrv': {
          'official': 'Republika Hrvatska',
          'common': 'Hrvatska'
        }
      }
    },
    'tld': ['.hr'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDED\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Haiti',
      'official': 'Republic of Haiti',
      'native': {
        'fra': {
          'official': 'R\xE9publique d\'Ha\xEFti',
          'common': 'Ha\xEFti'
        },
        'hat': {
          'official': 'Repiblik Ayiti',
          'common': 'Ayiti'
        }
      }
    },
    'tld': ['.ht'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDED\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'Hungary',
      'official': 'Hungary',
      'native': {
        'hun': {
          'official': 'Magyarorsz\xE1g',
          'common': 'Magyarorsz\xE1g'
        }
      }
    },
    'tld': ['.hu'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDED\uD83C\uDDFA'

  }, {
    'name': {
      'common': 'Indonesia',
      'official': 'Republic of Indonesia',
      'native': {
        'ind': {
          'official': 'Republik Indonesia',
          'common': 'Indonesia'
        }
      }
    },
    'tld': ['.id'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'flag': '\uD83C\uDDEE\uD83C\uDDE9'

  }, {
    'name': {
      'common': 'Isle of Man',
      'official': 'Isle of Man',
      'native': {
        'eng': {
          'official': 'Isle of Man',
          'common': 'Isle of Man'
        },
        'glv': {
          'official': 'Ellan Vannin or Mannin',
          'common': 'Mannin'
        }
      }
    },
    'tld': ['.im'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDEE\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'India',
      'official': 'Republic of India',
      'native': {
        'eng': {
          'official': 'Republic of India',
          'common': 'India'
        },
        'hin': {
          'official': '\u092D\u093E\u0930\u0924 \u0917\u0923\u0930\u093E\u091C\u094D\u092F',
          'common': '\u092D\u093E\u0930\u0924'
        },
        'tam': {
          'official': '\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0B95\u0BCD \u0B95\u0BC1\u0B9F\u0BBF\u0BAF\u0BB0\u0B9A\u0BC1',
          'common': '\u0B87\u0BA8\u0BCD\u0BA4\u0BBF\u0BAF\u0BBE'
        }
      }
    },
    'tld': ['.in'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'flag': '\uD83C\uDDEE\uD83C\uDDF3'

  }, {
    'name': {
      'common': 'British Indian Ocean Territory',
      'official': 'British Indian Ocean Territory',
      'native': {
        'eng': {
          'official': 'British Indian Ocean Territory',
          'common': 'British Indian Ocean Territory'
        }
      }
    },
    'tld': ['.io'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDEE\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Ireland',
      'official': 'Republic of Ireland',
      'native': {
        'eng': {
          'official': 'Republic of Ireland',
          'common': 'Ireland'
        },
        'gle': {
          'official': 'Poblacht na h\xC9ireann',
          'common': '\xC9ire'
        }
      }
    },
    'tld': ['.ie'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDEE\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Iran',
      'official': 'Islamic Republic of Iran',
      'native': {
        'fas': {
          'official': '\u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u06CC\u0631\u0627\u0646',
          'common': '\u0627\u06CC\u0631\u0627\u0646'
        }
      }
    },
    'tld': ['.ir', '\u0627\u06CC\u0631\u0627\u0646.'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'flag': '\uD83C\uDDEE\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Iraq',
      'official': 'Republic of Iraq',
      'native': {
        'ara': {
          'official': '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0639\u0631\u0627\u0642',
          'common': '\u0627\u0644\u0639\u0631\u0627\u0642'
        },
        'arc': {
          'official': '\u0729\u0718\u073C\u071B\u0722\u0735\u0710 \u0710\u071D\u073C\u072A\u0732\u0729',
          'common': '\u0729\u0718\u073C\u071B\u0722\u0735\u0710'
        },
        'ckb': {
          'official': '\u06A9\u06C6\u0645\u0627\u0631\u06CC \u0639\u06CE\u0631\u0627\u0642',
          'common': '\u06A9\u06C6\u0645\u0627\u0631\u06CC'
        }
      }
    },
    'tld': ['.iq'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDEE\uD83C\uDDF6'

  }, {
    'name': {
      'common': 'Iceland',
      'official': 'Iceland',
      'native': {
        'isl': {
          'official': '\xCDsland',
          'common': '\xCDsland'
        }
      }
    },
    'tld': ['.is'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDEE\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'Israel',
      'official': 'State of Israel',
      'native': {
        'ara': {
          'official': '\u062F\u0648\u0644\u0629 \u0625\u0633\u0631\u0627\u0626\u064A\u0644',
          'common': '\u0625\u0633\u0631\u0627\u0626\u064A\u0644'
        },
        'heb': {
          'official': '\u05DE\u05D3\u05D9\u05E0\u05EA \u05D9\u05E9\u05E8\u05D0\u05DC',
          'common': '\u05D9\u05E9\u05E8\u05D0\u05DC'
        }
      }
    },
    'tld': ['.il'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDEE\uD83C\uDDF1'

  }, {
    'name': {
      'common': 'Italy',
      'official': 'Italian Republic',
      'native': {
        'ita': {
          'official': 'Repubblica italiana',
          'common': 'Italia'
        }
      }
    },
    'tld': ['.it'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDEE\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'Jamaica',
      'official': 'Jamaica',
      'native': {
        'eng': {
          'official': 'Jamaica',
          'common': 'Jamaica'
        },
        'jam': {
          'official': 'Jamaica',
          'common': 'Jamaica'
        }
      }
    },
    'tld': ['.jm'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDEF\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Jersey',
      'official': 'Bailiwick of Jersey',
      'native': {
        'eng': {
          'official': 'Bailiwick of Jersey',
          'common': 'Jersey'
        },
        'fra': {
          'official': 'Bailliage de Jersey',
          'common': 'Jersey'
        },
        'nrf': {
          'official': 'Bailliage d\xE9 J\xE8rri',
          'common': 'J\xE8rri'
        }
      }
    },
    'tld': ['.je'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDEF\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Jordan',
      'official': 'Hashemite Kingdom of Jordan',
      'native': {
        'ara': {
          'official': '\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0623\u0631\u062F\u0646\u064A\u0629 \u0627\u0644\u0647\u0627\u0634\u0645\u064A\u0629',
          'common': '\u0627\u0644\u0623\u0631\u062F\u0646'
        }
      }
    },
    'tld': ['.jo', '\u0627\u0644\u0627\u0631\u062F\u0646.'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDEF\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Japan',
      'official': 'Japan',
      'native': {
        'jpn': {
          'official': '\u65E5\u672C',
          'common': '\u65E5\u672C'
        }
      }
    },
    'tld': ['.jp', '.\u307F\u3093\u306A'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'flag': '\uD83C\uDDEF\uD83C\uDDF5'

  }, {
    'name': {
      'common': 'Kazakhstan',
      'official': 'Republic of Kazakhstan',
      'native': {
        'kaz': {
          'official': '\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0441\u044B',
          'common': '\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D'
        },
        'rus': {
          'official': '\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D',
          'common': '\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D'
        }
      }
    },
    'tld': ['.kz', '.\u049B\u0430\u0437'],
    'region': 'Asia',
    'subregion': 'Central Asia',
    'flag': '\uD83C\uDDF0\uD83C\uDDFF'

  }, {
    'name': {
      'common': 'Kenya',
      'official': 'Republic of Kenya',
      'native': {
        'eng': {
          'official': 'Republic of Kenya',
          'common': 'Kenya'
        },
        'swa': {
          'official': 'Republic of Kenya',
          'common': 'Kenya'
        }
      }
    },
    'tld': ['.ke'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDF0\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Kyrgyzstan',
      'official': 'Kyrgyz Republic',
      'native': {
        'kir': {
          'official': '\u041A\u044B\u0440\u0433\u044B\u0437 \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0441\u044B',
          'common': '\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D'
        },
        'rus': {
          'official': '\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u043A\u0430\u044F \u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430',
          'common': '\u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F'
        }
      }
    },
    'tld': ['.kg'],
    'region': 'Asia',
    'subregion': 'Central Asia',
    'flag': '\uD83C\uDDF0\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'Cambodia',
      'official': 'Kingdom of Cambodia',
      'native': {
        'khm': {
          'official': '\u1796\u17D2\u179A\u17C7\u179A\u17B6\u1787\u17B6\u178E\u17B6\u1785\u1780\u17D2\u179A\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6',
          'common': 'K\xE2mp\u016Dch\xE9a'
        }
      }
    },
    'tld': ['.kh'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'flag': '\uD83C\uDDF0\uD83C\uDDED'

  }, {
    'name': {
      'common': 'Kiribati',
      'official': 'Independent and Sovereign Republic of Kiribati',
      'native': {
        'eng': {
          'official': 'Independent and Sovereign Republic of Kiribati',
          'common': 'Kiribati'
        },
        'gil': {
          'official': 'Ribaberiki Kiribati',
          'common': 'Kiribati'
        }
      }
    },
    'tld': ['.ki'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'flag': '\uD83C\uDDF0\uD83C\uDDEE'

  }, {
    'name': {
      'common': 'Saint Kitts and Nevis',
      'official': 'Federation of Saint Christopher and Nevis',
      'native': {
        'eng': {
          'official': 'Federation of Saint Christopher and Nevis',
          'common': 'Saint Kitts and Nevis'
        }
      }
    },
    'tld': ['.kn'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDF0\uD83C\uDDF3'

  }, {
    'name': {
      'common': 'South Korea',
      'official': 'Republic of Korea',
      'native': {
        'kor': {
          'official': '\uB300\uD55C\uBBFC\uAD6D',
          'common': '\uD55C\uAD6D'
        }
      }
    },
    'tld': ['.kr', '.\uD55C\uAD6D'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'flag': '\uD83C\uDDF0\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Kosovo',
      'official': 'Republic of Kosovo',
      'native': {
        'sqi': {
          'official': 'Republika e Kosov\xEBs',
          'common': 'Kosova'
        },
        'srp': {
          'official': '\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u041A\u043E\u0441\u043E\u0432\u043E',
          'common': '\u041A\u043E\u0441\u043E\u0432\u043E'
        }
      }
    },
    'tld': [],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDFD\uD83C\uDDF0'

  }, {
    'name': {
      'common': 'Kuwait',
      'official': 'State of Kuwait',
      'native': {
        'ara': {
          'official': '\u062F\u0648\u0644\u0629 \u0627\u0644\u0643\u0648\u064A\u062A',
          'common': '\u0627\u0644\u0643\u0648\u064A\u062A'
        }
      }
    },
    'tld': ['.kw'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDF0\uD83C\uDDFC'

  }, {
    'name': {
      'common': 'Laos',
      'official': "Lao People's Democratic Republic",
      'native': {
        'lao': {
          'official': '\u0EAA\u0EB2\u0E97\u0EB2\u0EA5\u0EB0\u0E99\u0EB0 \u0E8A\u0EB2\u0E97\u0EB4\u0E9B\u0EB0\u0EC4\u0E95 \u0E84\u0EBB\u0E99\u0EA5\u0EB2\u0EA7 \u0E82\u0EAD\u0E87',
          'common': '\u0EAA\u0E9B\u0E9B\u0EA5\u0EB2\u0EA7'
        }
      }
    },
    'tld': ['.la'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'flag': '\uD83C\uDDF1\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'Lebanon',
      'official': 'Lebanese Republic',
      'native': {
        'ara': {
          'official': '\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0644\u0628\u0646\u0627\u0646\u064A\u0629',
          'common': '\u0644\u0628\u0646\u0627\u0646'
        },
        'fra': {
          'official': 'R\xE9publique libanaise',
          'common': 'Liban'
        }
      }
    },
    'tld': ['.lb'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDF1\uD83C\uDDE7'

  }, {
    'name': {
      'common': 'Liberia',
      'official': 'Republic of Liberia',
      'native': {
        'eng': {
          'official': 'Republic of Liberia',
          'common': 'Liberia'
        }
      }
    },
    'tld': ['.lr'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDF1\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Libya',
      'official': 'State of Libya',
      'native': {
        'ara': {
          'official': '\u0627\u0644\u062F\u0648\u0644\u0629 \u0644\u064A\u0628\u064A\u0627',
          'common': '\u200F\u0644\u064A\u0628\u064A\u0627'
        }
      }
    },
    'tld': ['.ly'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'flag': '\uD83C\uDDF1\uD83C\uDDFE'

  }, {
    'name': {
      'common': 'Saint Lucia',
      'official': 'Saint Lucia',
      'native': {
        'eng': {
          'official': 'Saint Lucia',
          'common': 'Saint Lucia'
        }
      }
    },
    'tld': ['.lc'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDF1\uD83C\uDDE8'

  }, {
    'name': {
      'common': 'Liechtenstein',
      'official': 'Principality of Liechtenstein',
      'native': {
        'deu': {
          'official': 'F\xFCrstentum Liechtenstein',
          'common': 'Liechtenstein'
        }
      }
    },
    'tld': ['.li'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'flag': '\uD83C\uDDF1\uD83C\uDDEE'

  }, {
    'name': {
      'common': 'Sri Lanka',
      'official': 'Democratic Socialist Republic of Sri Lanka',
      'native': {
        'sin': {
          'official': '\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF \u0DB4\u0DCA\u200D\u0DBB\u0DA2\u0DCF\u0DAD\u0DCF\u0DB1\u0DCA\u0DAD\u0DCA\u200D\u0DBB\u0DD2\u0D9A \u0DC3\u0DB8\u0DCF\u0DA2\u0DC0\u0DCF\u0DAF\u0DD3 \u0DA2\u0DB1\u0DBB\u0DA2\u0DBA',
          'common': '\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0'
        },
        'tam': {
          'official': '\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8 \u0B9A\u0BA9\u0BA8\u0BBE\u0BAF\u0B95 \u0B9A\u0BCB\u0B9A\u0BB2\u0BBF\u0B9A\u0B95\u0BCD \u0B95\u0BC1\u0B9F\u0BBF\u0BAF\u0BB0\u0B9A\u0BC1',
          'common': '\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8'
        }
      }
    },
    'tld': ['.lk', '.\u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8', '.\u0DBD\u0D82\u0D9A\u0DCF'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'flag': '\uD83C\uDDF1\uD83C\uDDF0'

  }, {
    'name': {
      'common': 'Lesotho',
      'official': 'Kingdom of Lesotho',
      'native': {
        'eng': {
          'official': 'Kingdom of Lesotho',
          'common': 'Lesotho'
        },
        'sot': {
          'official': 'Kingdom of Lesotho',
          'common': 'Lesotho'
        }
      }
    },
    'tld': ['.ls'],
    'region': 'Africa',
    'subregion': 'Southern Africa',
    'flag': '\uD83C\uDDF1\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'Lithuania',
      'official': 'Republic of Lithuania',
      'native': {
        'lit': {
          'official': 'Lietuvos Respublikos',
          'common': 'Lietuva'
        }
      }
    },
    'tld': ['.lt'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDF1\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'Luxembourg',
      'official': 'Grand Duchy of Luxembourg',
      'native': {
        'deu': {
          'official': 'Gro\xDFherzogtum Luxemburg',
          'common': 'Luxemburg'
        },
        'fra': {
          'official': 'Grand-Duch\xE9 de Luxembourg',
          'common': 'Luxembourg'
        },
        'ltz': {
          'official': 'Groussherzogtum L\xEBtzebuerg',
          'common': 'L\xEBtzebuerg'
        }
      }
    },
    'tld': ['.lu'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'flag': '\uD83C\uDDF1\uD83C\uDDFA'

  }, {
    'name': {
      'common': 'Latvia',
      'official': 'Republic of Latvia',
      'native': {
        'lav': {
          'official': 'Latvijas Republikas',
          'common': 'Latvija'
        }
      }
    },
    'tld': ['.lv'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDF1\uD83C\uDDFB'

  }, {
    'name': {
      'common': 'Macau',
      'official': "Macao Special Administrative Region of the People's Republic of China",
      'native': {
        'por': {
          'official': 'Regi\xE3o Administrativa Especial de Macau da Rep\xFAblica Popular da China',
          'common': 'Macau'
        },
        'zho': {
          'official': '\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u6FB3\u95E8\u7279\u522B\u884C\u653F\u533A',
          'common': '\u6FB3\u95E8'
        }
      }
    },
    'tld': ['.mo'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'flag': '\uD83C\uDDF2\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Saint Martin',
      'official': 'Saint Martin',
      'native': {
        'fra': {
          'official': 'Saint-Martin',
          'common': 'Saint-Martin'
        }
      }
    },
    'tld': ['.fr', '.gp'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDF2\uD83C\uDDEB'

  }, {
    'name': {
      'common': 'Morocco',
      'official': 'Kingdom of Morocco',
      'native': {
        'ara': {
          'official': '\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0645\u063A\u0631\u0628\u064A\u0629',
          'common': '\u0627\u0644\u0645\u063A\u0631\u0628'
        },
        'ber': {
          'official': '\u2D5C\u2D30\u2D33\u2D4D\u2D37\u2D49\u2D5C \u2D4F \u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31',
          'common': '\u2D4D\u2D4E\u2D30\u2D56\u2D54\u2D49\u2D31'
        }
      }
    },
    'tld': ['.ma', '\u0627\u0644\u0645\u063A\u0631\u0628.'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'flag': '\uD83C\uDDF2\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'Monaco',
      'official': 'Principality of Monaco',
      'native': {
        'fra': {
          'official': 'Principaut\xE9 de Monaco',
          'common': 'Monaco'
        }
      }
    },
    'tld': ['.mc'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'flag': '\uD83C\uDDF2\uD83C\uDDE8'

  }, {
    'name': {
      'common': 'Moldova',
      'official': 'Republic of Moldova',
      'native': {
        'ron': {
          'official': 'Republica Moldova',
          'common': 'Moldova'
        }
      }
    },
    'tld': ['.md'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDF2\uD83C\uDDE9'

  }, {
    'name': {
      'common': 'Madagascar',
      'official': 'Republic of Madagascar',
      'native': {
        'fra': {
          'official': 'R\xE9publique de Madagascar',
          'common': 'Madagascar'
        },
        'mlg': {
          'official': "Repoblikan'i Madagasikara",
          'common': 'Madagasikara'
        }
      }
    },
    'tld': ['.mg'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDF2\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'Maldives',
      'official': 'Republic of the Maldives',
      'native': {
        'div': {
          'official': '\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0783\u07A7\u0787\u07B0\u0796\u07AD\u078E\u07AC \u0796\u07AA\u0789\u07B0\u0780\u07AB\u0783\u07A8\u0787\u07B0\u0794\u07A7',
          'common': '\u078B\u07A8\u0788\u07AC\u0780\u07A8\u0783\u07A7\u0787\u07B0\u0796\u07AD\u078E\u07AC'
        }
      }
    },
    'tld': ['.mv'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'flag': '\uD83C\uDDF2\uD83C\uDDFB'

  }, {
    'name': {
      'common': 'Mexico',
      'official': 'United Mexican States',
      'native': {
        'spa': {
          'official': 'Estados Unidos Mexicanos',
          'common': 'M\xE9xico'
        }
      }
    },
    'tld': ['.mx'],
    'region': 'Americas',
    'subregion': 'North America',
    'flag': '\uD83C\uDDF2\uD83C\uDDFD'

  }, {
    'name': {
      'common': 'Marshall Islands',
      'official': 'Republic of the Marshall Islands',
      'native': {
        'eng': {
          'official': 'Republic of the Marshall Islands',
          'common': 'Marshall Islands'
        },
        'mah': {
          'official': 'Republic of the Marshall Islands',
          'common': 'M\u0327aje\u013C'
        }
      }
    },
    'tld': ['.mh'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'flag': '\uD83C\uDDF2\uD83C\uDDED'

  }, {
    'name': {
      'common': 'North Macedonia',
      'official': 'Republic of North Macedonia',
      'native': {
        'mkd': {
          'official': '\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0435\u0432\u0435\u0440\u043D\u0430 \u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430',
          'common': '\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430'
        }
      }
    },
    'tld': ['.mk'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDF2\uD83C\uDDF0'

  }, {
    'name': {
      'common': 'Mali',
      'official': 'Republic of Mali',
      'native': {
        'fra': {
          'official': 'R\xE9publique du Mali',
          'common': 'Mali'
        }
      }
    },
    'tld': ['.ml'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDF2\uD83C\uDDF1'

  }, {
    'name': {
      'common': 'Malta',
      'official': 'Republic of Malta',
      'native': {
        'eng': {
          'official': 'Republic of Malta',
          'common': 'Malta'
        },
        'mlt': {
          'official': "Repubblika ta ' Malta",
          'common': 'Malta'
        }
      }
    },
    'tld': ['.mt'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDF2\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'Myanmar',
      'official': 'Republic of the Union of Myanmar',
      'native': {
        'mya': {
          'official': '\u1015\u103C\u100A\u103A\u1011\u1031\u102C\u1004\u103A\u1005\u102F \u101E\u1019\u1039\u1019\u1010 \u1019\u103C\u1014\u103A\u1019\u102C\u1014\u102D\u102F\u1004\u103A\u1004\u1036\u1010\u1031\u102C\u103A',
          'common': '\u1019\u103C\u1014\u103A\u1019\u102C'
        }
      }
    },
    'tld': ['.mm'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'flag': '\uD83C\uDDF2\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Montenegro',
      'official': 'Montenegro',
      'native': {
        'srp': {
          'official': '\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430',
          'common': '\u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430'
        }
      }
    },
    'tld': ['.me'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDF2\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Mongolia',
      'official': 'Mongolia',
      'native': {
        'mon': {
          'official': '\u041C\u043E\u043D\u0433\u043E\u043B \u0443\u043B\u0441',
          'common': '\u041C\u043E\u043D\u0433\u043E\u043B \u0443\u043B\u0441'
        }
      }
    },
    'tld': ['.mn'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'flag': '\uD83C\uDDF2\uD83C\uDDF3'

  }, {
    'name': {
      'common': 'Northern Mariana Islands',
      'official': 'Commonwealth of the Northern Mariana Islands',
      'native': {
        'cal': {
          'official': 'Commonwealth of the Northern Mariana Islands',
          'common': 'Northern Mariana Islands'
        },
        'cha': {
          'official': 'Sankattan Siha Na Islas Mari\xE5nas',
          'common': 'Na Islas Mari\xE5nas'
        },
        'eng': {
          'official': 'Commonwealth of the Northern Mariana Islands',
          'common': 'Northern Mariana Islands'
        }
      }
    },
    'tld': ['.mp'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'flag': '\uD83C\uDDF2\uD83C\uDDF5'

  }, {
    'name': {
      'common': 'Mozambique',
      'official': 'Republic of Mozambique',
      'native': {
        'por': {
          'official': 'Rep\xFAblica de Mo\xE7ambique',
          'common': 'Mo\xE7ambique'
        }
      }
    },
    'tld': ['.mz'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDF2\uD83C\uDDFF'

  }, {
    'name': {
      'common': 'Mauritania',
      'official': 'Islamic Republic of Mauritania',
      'native': {
        'ara': {
          'official': '\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0625\u0633\u0644\u0627\u0645\u064A\u0629 \u0627\u0644\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0629',
          'common': '\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627'
        }
      }
    },
    'tld': ['.mr'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDF2\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Montserrat',
      'official': 'Montserrat',
      'native': {
        'eng': {
          'official': 'Montserrat',
          'common': 'Montserrat'
        }
      }
    },
    'tld': ['.ms'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDF2\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'Martinique',
      'official': 'Martinique',
      'native': {
        'fra': {
          'official': 'Martinique',
          'common': 'Martinique'
        }
      }
    },
    'tld': ['.mq'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDF2\uD83C\uDDF6'

  }, {
    'name': {
      'common': 'Mauritius',
      'official': 'Republic of Mauritius',
      'native': {
        'eng': {
          'official': 'Republic of Mauritius',
          'common': 'Mauritius'
        },
        'fra': {
          'official': 'R\xE9publique de Maurice',
          'common': 'Maurice'
        },
        'mfe': {
          'official': 'Republik Moris',
          'common': 'Moris'
        }
      }
    },
    'tld': ['.mu'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDF2\uD83C\uDDFA'

  }, {
    'name': {
      'common': 'Malawi',
      'official': 'Republic of Malawi',
      'native': {
        'eng': {
          'official': 'Republic of Malawi',
          'common': 'Malawi'
        },
        'nya': {
          'official': 'Chalo cha Malawi, Dziko la Mala\u0175i',
          'common': 'Mala\u0175i'
        }
      }
    },
    'tld': ['.mw'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDF2\uD83C\uDDFC'

  }, {
    'name': {
      'common': 'Malaysia',
      'official': 'Malaysia',
      'native': {
        'eng': {
          'official': 'Malaysia',
          'common': 'Malaysia'
        },
        'msa': {
          'official': '\u0645\u0644\u064A\u0633\u064A\u0627',
          'common': '\u0645\u0644\u064A\u0633\u064A\u0627'
        }
      }
    },
    'tld': ['.my'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'flag': '\uD83C\uDDF2\uD83C\uDDFE'

  }, {
    'name': {
      'common': 'Mayotte',
      'official': 'Department of Mayotte',
      'native': {
        'fra': {
          'official': 'D\xE9partement de Mayotte',
          'common': 'Mayotte'
        }
      }
    },
    'tld': ['.yt'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDFE\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'Namibia',
      'official': 'Republic of Namibia',
      'native': {
        'afr': {
          'official': 'Republiek van Namibi\xEB',
          'common': 'Namibi\xEB'
        },
        'deu': {
          'official': 'Republik Namibia',
          'common': 'Namibia'
        },
        'eng': {
          'official': 'Republic of Namibia',
          'common': 'Namibia'
        },
        'her': {
          'official': 'Republic of Namibia',
          'common': 'Namibia'
        },
        'hgm': {
          'official': 'Republic of Namibia',
          'common': 'Namibia'
        },
        'kwn': {
          'official': 'Republic of Namibia',
          'common': 'Namibia'
        },
        'loz': {
          'official': 'Republic of Namibia',
          'common': 'Namibia'
        },
        'ndo': {
          'official': 'Republic of Namibia',
          'common': 'Namibia'
        },
        'tsn': {
          'official': 'Lefatshe la Namibia',
          'common': 'Namibia'
        }
      }
    },
    'tld': ['.na'],
    'region': 'Africa',
    'subregion': 'Southern Africa',
    'flag': '\uD83C\uDDF3\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'New Caledonia',
      'official': 'New Caledonia',
      'native': {
        'fra': {
          'official': 'Nouvelle-Cal\xE9donie',
          'common': 'Nouvelle-Cal\xE9donie'
        }
      }
    },
    'tld': ['.nc'],
    'region': 'Oceania',
    'subregion': 'Melanesia',
    'flag': '\uD83C\uDDF3\uD83C\uDDE8'

  }, {
    'name': {
      'common': 'Niger',
      'official': 'Republic of Niger',
      'native': {
        'fra': {
          'official': 'R\xE9publique du Niger',
          'common': 'Niger'
        }
      }
    },
    'tld': ['.ne'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDF3\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Norfolk Island',
      'official': 'Territory of Norfolk Island',
      'native': {
        'eng': {
          'official': 'Territory of Norfolk Island',
          'common': 'Norfolk Island'
        },
        'pih': {
          'official': "Teratri of Norf'k Ailen",
          'common': "Norf'k Ailen"
        }
      }
    },
    'tld': ['.nf'],
    'region': 'Oceania',
    'subregion': 'Australia and New Zealand',
    'flag': '\uD83C\uDDF3\uD83C\uDDEB'

  }, {
    'name': {
      'common': 'Nigeria',
      'official': 'Federal Republic of Nigeria',
      'native': {
        'eng': {
          'official': 'Federal Republic of Nigeria',
          'common': 'Nigeria'
        }
      }
    },
    'tld': ['.ng'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDF3\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'Nicaragua',
      'official': 'Republic of Nicaragua',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica de Nicaragua',
          'common': 'Nicaragua'
        }
      }
    },
    'tld': ['.ni'],
    'region': 'Americas',
    'subregion': 'Central America',
    'flag': '\uD83C\uDDF3\uD83C\uDDEE'

  }, {
    'name': {
      'common': 'Niue',
      'official': 'Niue',
      'native': {
        'eng': {
          'official': 'Niue',
          'common': 'Niue'
        },
        'niu': {
          'official': 'Niu\u0113',
          'common': 'Niu\u0113'
        }
      }
    },
    'tld': ['.nu'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'flag': '\uD83C\uDDF3\uD83C\uDDFA'

  }, {
    'name': {
      'common': 'Netherlands',
      'official': 'Kingdom of the Netherlands',
      'native': {
        'nld': {
          'official': 'Koninkrijk der Nederlanden',
          'common': 'Nederland'
        }
      }
    },
    'tld': ['.nl'],
    'region': 'Europe',
    'subregion': 'Western Europe',
    'flag': '\uD83C\uDDF3\uD83C\uDDF1'

  }, {
    'name': {
      'common': 'Norway',
      'official': 'Kingdom of Norway',
      'native': {
        'nno': {
          'official': 'Kongeriket Noreg',
          'common': 'Noreg'
        },
        'nob': {
          'official': 'Kongeriket Norge',
          'common': 'Norge'
        },
        'smi': {
          'official': 'Norgga gonagasriika',
          'common': 'Norgga'
        }
      }
    },
    'tld': ['.no'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDF3\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Nepal',
      'official': 'Federal Democratic Republic of Nepal',
      'native': {
        'nep': {
          'official': '\u0928\u0947\u092A\u093E\u0932 \u0938\u0902\u0918\u0940\u092F \u0932\u094B\u0915\u0924\u093E\u0928\u094D\u0924\u094D\u0930\u093F\u0915 \u0917\u0923\u0924\u0928\u094D\u0924\u094D\u0930',
          'common': '\u0928\u0947\u092A\u093E\u0932'
        }
      }
    },
    'tld': ['.np'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'flag': '\uD83C\uDDF3\uD83C\uDDF5'

  }, {
    'name': {
      'common': 'Nauru',
      'official': 'Republic of Nauru',
      'native': {
        'eng': {
          'official': 'Republic of Nauru',
          'common': 'Nauru'
        },
        'nau': {
          'official': 'Republic of Nauru',
          'common': 'Nauru'
        }
      }
    },
    'tld': ['.nr'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'flag': '\uD83C\uDDF3\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'New Zealand',
      'official': 'New Zealand',
      'native': {
        'eng': {
          'official': 'New Zealand',
          'common': 'New Zealand'
        },
        'mri': {
          'official': 'Aotearoa',
          'common': 'Aotearoa'
        },
        'nzs': {
          'official': 'New Zealand',
          'common': 'New Zealand'
        }
      }
    },
    'tld': ['.nz'],
    'region': 'Oceania',
    'subregion': 'Australia and New Zealand',
    'flag': '\uD83C\uDDF3\uD83C\uDDFF'

  }, {
    'name': {
      'common': 'Oman',
      'official': 'Sultanate of Oman',
      'native': {
        'ara': {
          'official': '\u0633\u0644\u0637\u0646\u0629 \u0639\u0645\u0627\u0646',
          'common': '\u0639\u0645\u0627\u0646'
        }
      }
    },
    'tld': ['.om'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDF4\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Pakistan',
      'official': 'Islamic Republic of Pakistan',
      'native': {
        'eng': {
          'official': 'Islamic Republic of Pakistan',
          'common': 'Pakistan'
        },
        'urd': {
          'official': '\u0627\u0633\u0644\u0627\u0645\u06CC \u062C\u0645\u06C1\u0648\u0631\u06CC\u06C2 \u067E\u0627\u0643\u0633\u062A\u0627\u0646',
          'common': '\u067E\u0627\u0643\u0633\u062A\u0627\u0646'
        }
      }
    },
    'tld': ['.pk'],
    'region': 'Asia',
    'subregion': 'Southern Asia',
    'flag': '\uD83C\uDDF5\uD83C\uDDF0'

  }, {
    'name': {
      'common': 'Panama',
      'official': 'Republic of Panama',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica de Panam\xE1',
          'common': 'Panam\xE1'
        }
      }
    },
    'tld': ['.pa'],
    'region': 'Americas',
    'subregion': 'Central America',
    'flag': '\uD83C\uDDF5\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'Pitcairn Islands',
      'official': 'Pitcairn Group of Islands',
      'native': {
        'eng': {
          'official': 'Pitcairn Group of Islands',
          'common': 'Pitcairn Islands'
        }
      }
    },
    'tld': ['.pn'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'flag': '\uD83C\uDDF5\uD83C\uDDF3'

  }, {
    'name': {
      'common': 'Peru',
      'official': 'Republic of Peru',
      'native': {
        'aym': {
          'official': 'Piruw Suyu',
          'common': 'Piruw'
        },
        'que': {
          'official': 'Piruw Ripuwlika',
          'common': 'Piruw'
        },
        'spa': {
          'official': 'Rep\xFAblica del Per\xFA',
          'common': 'Per\xFA'
        }
      }
    },
    'tld': ['.pe'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDF5\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Philippines',
      'official': 'Republic of the Philippines',
      'native': {
        'eng': {
          'official': 'Republic of the Philippines',
          'common': 'Philippines'
        },
        'fil': {
          'official': 'Republic of the Philippines',
          'common': 'Pilipinas'
        }
      }
    },
    'tld': ['.ph'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'flag': '\uD83C\uDDF5\uD83C\uDDED'

  }, {
    'name': {
      'common': 'Palau',
      'official': 'Republic of Palau',
      'native': {
        'eng': {
          'official': 'Republic of Palau',
          'common': 'Palau'
        },
        'pau': {
          'official': 'Beluu er a Belau',
          'common': 'Belau'
        }
      }
    },
    'tld': ['.pw'],
    'region': 'Oceania',
    'subregion': 'Micronesia',
    'flag': '\uD83C\uDDF5\uD83C\uDDFC'

  }, {
    'name': {
      'common': 'Papua New Guinea',
      'official': 'Independent State of Papua New Guinea',
      'native': {
        'eng': {
          'official': 'Independent State of Papua New Guinea',
          'common': 'Papua New Guinea'
        },
        'hmo': {
          'official': 'Independen Stet bilong Papua Niugini',
          'common': 'Papua Niu Gini'
        },
        'tpi': {
          'official': 'Independen Stet bilong Papua Niugini',
          'common': 'Papua Niugini'
        }
      }
    },
    'tld': ['.pg'],
    'region': 'Oceania',
    'subregion': 'Melanesia',
    'flag': '\uD83C\uDDF5\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'Poland',
      'official': 'Republic of Poland',
      'native': {
        'pol': {
          'official': 'Rzeczpospolita Polska',
          'common': 'Polska'
        }
      }
    },
    'tld': ['.pl'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDF5\uD83C\uDDF1'

  }, {
    'name': {
      'common': 'Puerto Rico',
      'official': 'Commonwealth of Puerto Rico',
      'native': {
        'eng': {
          'official': 'Commonwealth of Puerto Rico',
          'common': 'Puerto Rico'
        },
        'spa': {
          'official': 'Estado Libre Asociado de Puerto Rico',
          'common': 'Puerto Rico'
        }
      }
    },
    'tld': ['.pr'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDF5\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'North Korea',
      'official': "Democratic People's Republic of Korea",
      'native': {
        'kor': {
          'official': '\uC870\uC120\uBBFC\uC8FC\uC8FC\uC758\uC778\uBBFC\uACF5\uD654\uAD6D',
          'common': '\uC870\uC120'
        }
      }
    },
    'tld': ['.kp'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'flag': '\uD83C\uDDF0\uD83C\uDDF5'

  }, {
    'name': {
      'common': 'Portugal',
      'official': 'Portuguese Republic',
      'native': {
        'por': {
          'official': 'Rep\xFAblica portugu\xEAs',
          'common': 'Portugal'
        }
      }
    },
    'tld': ['.pt'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDF5\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'Paraguay',
      'official': 'Republic of Paraguay',
      'native': {
        'grn': {
          'official': 'Tet\xE3 Paragu\xE1i',
          'common': 'Paragu\xE1i'
        },
        'spa': {
          'official': 'Rep\xFAblica de Paraguay',
          'common': 'Paraguay'
        }
      }
    },
    'tld': ['.py'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDF5\uD83C\uDDFE'

  }, {
    'name': {
      'common': 'Palestine',
      'official': 'State of Palestine',
      'native': {
        'ara': {
          'official': '\u062F\u0648\u0644\u0629 \u0641\u0644\u0633\u0637\u064A\u0646',
          'common': '\u0641\u0644\u0633\u0637\u064A\u0646'
        }
      }
    },
    'tld': ['.ps', '\u0641\u0644\u0633\u0637\u064A\u0646.'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDF5\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'French Polynesia',
      'official': 'French Polynesia',
      'native': {
        'fra': {
          'official': 'Polyn\xE9sie fran\xE7aise',
          'common': 'Polyn\xE9sie fran\xE7aise'
        }
      }
    },
    'tld': ['.pf'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'flag': '\uD83C\uDDF5\uD83C\uDDEB'

  }, {
    'name': {
      'common': 'Qatar',
      'official': 'State of Qatar',
      'native': {
        'ara': {
          'official': '\u062F\u0648\u0644\u0629 \u0642\u0637\u0631',
          'common': '\u0642\u0637\u0631'
        }
      }
    },
    'tld': ['.qa', '\u0642\u0637\u0631.'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDF6\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'R\xE9union',
      'official': 'R\xE9union Island',
      'native': {
        'fra': {
          'official': 'Ile de la R\xE9union',
          'common': 'La R\xE9union'
        }
      }
    },
    'tld': ['.re'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDF7\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Romania',
      'official': 'Romania',
      'native': {
        'ron': {
          'official': 'Rom\xE2nia',
          'common': 'Rom\xE2nia'
        }
      }
    },
    'tld': ['.ro'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDF7\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Russia',
      'official': 'Russian Federation',
      'native': {
        'rus': {
          'official': '\u0420\u043E\u0441\u0441\u0438\u0439\u0441\u043A\u0430\u044F \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044F',
          'common': '\u0420\u043E\u0441\u0441\u0438\u044F'
        }
      }
    },
    'tld': ['.ru', '.su', '.\u0440\u0444'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDF7\uD83C\uDDFA'

  }, {
    'name': {
      'common': 'Rwanda',
      'official': 'Republic of Rwanda',
      'native': {
        'eng': {
          'official': 'Republic of Rwanda',
          'common': 'Rwanda'
        },
        'fra': {
          'official': 'R\xE9publique rwandaise',
          'common': 'Rwanda'
        },
        'kin': {
          'official': "Repubulika y'u Rwanda",
          'common': 'Rwanda'
        }
      }
    },
    'tld': ['.rw'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDF7\uD83C\uDDFC'

  }, {
    'name': {
      'common': 'Saudi Arabia',
      'official': 'Kingdom of Saudi Arabia',
      'native': {
        'ara': {
          'official': '\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629',
          'common': '\u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629'
        }
      }
    },
    'tld': ['.sa', '.\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDF8\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'Sudan',
      'official': 'Republic of the Sudan',
      'native': {
        'ara': {
          'official': '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0633\u0648\u062F\u0627\u0646',
          'common': '\u0627\u0644\u0633\u0648\u062F\u0627\u0646'
        },
        'eng': {
          'official': 'Republic of the Sudan',
          'common': 'Sudan'
        }
      }
    },
    'tld': ['.sd'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'flag': '\uD83C\uDDF8\uD83C\uDDE9'

  }, {
    'name': {
      'common': 'Senegal',
      'official': 'Republic of Senegal',
      'native': {
        'fra': {
          'official': 'R\xE9publique du S\xE9n\xE9gal',
          'common': 'S\xE9n\xE9gal'
        }
      }
    },
    'tld': ['.sn'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDF8\uD83C\uDDF3'

  }, {
    'name': {
      'common': 'Singapore',
      'official': 'Republic of Singapore',
      'native': {
        'zho': {
          'official': '\u65B0\u52A0\u5761\u5171\u548C\u56FD',
          'common': '\u65B0\u52A0\u5761'
        },
        'eng': {
          'official': 'Republic of Singapore',
          'common': 'Singapore'
        },
        'msa': {
          'official': 'Republik Singapura',
          'common': 'Singapura'
        },
        'tam': {
          'official': '\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD \u0B95\u0BC1\u0B9F\u0BBF\u0BAF\u0BB0\u0B9A\u0BC1',
          'common': '\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD'
        }
      }
    },
    'tld': ['.sg', '.\u65B0\u52A0\u5761', '.\u0B9A\u0BBF\u0B99\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0BC2\u0BB0\u0BCD'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'flag': '\uD83C\uDDF8\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'South Georgia',
      'official': 'South Georgia and the South Sandwich Islands',
      'native': {
        'eng': {
          'official': 'South Georgia and the South Sandwich Islands',
          'common': 'South Georgia'
        }
      }
    },
    'tld': ['.gs'],
    'region': 'Antarctic',
    'subregion': '',
    'flag': '\uD83C\uDDEC\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'Svalbard and Jan Mayen',
      'official': 'Svalbard og Jan Mayen',
      'native': {
        'nor': {
          'official': 'Svalbard og Jan Mayen',
          'common': 'Svalbard og Jan Mayen'
        }
      }
    },
    'tld': ['.sj'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDF8\uD83C\uDDEF'

  }, {
    'name': {
      'common': 'Solomon Islands',
      'official': 'Solomon Islands',
      'native': {
        'eng': {
          'official': 'Solomon Islands',
          'common': 'Solomon Islands'
        }
      }
    },
    'tld': ['.sb'],
    'region': 'Oceania',
    'subregion': 'Melanesia',
    'flag': '\uD83C\uDDF8\uD83C\uDDE7'

  }, {
    'name': {
      'common': 'Sierra Leone',
      'official': 'Republic of Sierra Leone',
      'native': {
        'eng': {
          'official': 'Republic of Sierra Leone',
          'common': 'Sierra Leone'
        }
      }
    },
    'tld': ['.sl'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDF8\uD83C\uDDF1'

  }, {
    'name': {
      'common': 'El Salvador',
      'official': 'Republic of El Salvador',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica de El Salvador',
          'common': 'El Salvador'
        }
      }
    },
    'tld': ['.sv'],
    'region': 'Americas',
    'subregion': 'Central America',
    'flag': '\uD83C\uDDF8\uD83C\uDDFB'

  }, {
    'name': {
      'common': 'San Marino',
      'official': 'Most Serene Republic of San Marino',
      'native': {
        'ita': {
          'official': 'Serenissima Repubblica di San Marino',
          'common': 'San Marino'
        }
      }
    },
    'tld': ['.sm'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDF8\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Somalia',
      'official': 'Federal Republic of Somalia',
      'native': {
        'ara': {
          'official': '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0635\u0648\u0645\u0627\u0644\u200E\u200E',
          'common': '\u0627\u0644\u0635\u0648\u0645\u0627\u0644\u200E\u200E'
        },
        'som': {
          'official': 'Jamhuuriyadda Federaalka Soomaaliya',
          'common': 'Soomaaliya'
        }
      }
    },
    'tld': ['.so'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDF8\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Saint Pierre and Miquelon',
      'official': 'Saint Pierre and Miquelon',
      'native': {
        'fra': {
          'official': 'Collectivit\xE9 territoriale de Saint-Pierre-et-Miquelon',
          'common': 'Saint-Pierre-et-Miquelon'
        }
      }
    },
    'tld': ['.pm'],
    'region': 'Americas',
    'subregion': 'North America',
    'flag': '\uD83C\uDDF5\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Serbia',
      'official': 'Republic of Serbia',
      'native': {
        'srp': {
          'official': '\u0420\u0435\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0421\u0440\u0431\u0438\u0458\u0430',
          'common': '\u0421\u0440\u0431\u0438\u0458\u0430'
        }
      }
    },
    'tld': ['.rs', '.\u0441\u0440\u0431'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDF7\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'South Sudan',
      'official': 'Republic of South Sudan',
      'native': {
        'eng': {
          'official': 'Republic of South Sudan',
          'common': 'South Sudan'
        }
      }
    },
    'tld': ['.ss'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'flag': '\uD83C\uDDF8\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'S\xE3o Tom\xE9 and Pr\xEDncipe',
      'official': 'Democratic Republic of S\xE3o Tom\xE9 and Pr\xEDncipe',
      'native': {
        'por': {
          'official': 'Rep\xFAblica Democr\xE1tica do S\xE3o Tom\xE9 e Pr\xEDncipe',
          'common': 'S\xE3o Tom\xE9 e Pr\xEDncipe'
        }
      }
    },
    'tld': ['.st'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'flag': '\uD83C\uDDF8\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'Suriname',
      'official': 'Republic of Suriname',
      'native': {
        'nld': {
          'official': 'Republiek Suriname',
          'common': 'Suriname'
        }
      }
    },
    'tld': ['.sr'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDF8\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Slovakia',
      'official': 'Slovak Republic',
      'native': {
        'slk': {
          'official': 'Slovensk\xE1 republika',
          'common': 'Slovensko'
        }
      }
    },
    'tld': ['.sk'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDF8\uD83C\uDDF0'

  }, {
    'name': {
      'common': 'Slovenia',
      'official': 'Republic of Slovenia',
      'native': {
        'slv': {
          'official': 'Republika Slovenija',
          'common': 'Slovenija'
        }
      }
    },
    'tld': ['.si'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDF8\uD83C\uDDEE'

  }, {
    'name': {
      'common': 'Sweden',
      'official': 'Kingdom of Sweden',
      'native': {
        'swe': {
          'official': 'Konungariket Sverige',
          'common': 'Sverige'
        }
      }
    },
    'tld': ['.se'],
    'region': 'Europe',
    'subregion': 'Northern Europe',
    'flag': '\uD83C\uDDF8\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'Eswatini',
      'official': 'Kingdom of Eswatini',
      'native': {
        'eng': {
          'official': 'Kingdom of Eswatini',
          'common': 'Eswatini'
        },
        'ssw': {
          'official': 'Umbuso weSwatini',
          'common': 'eSwatini'
        }
      }
    },
    'tld': ['.sz'],
    'region': 'Africa',
    'subregion': 'Southern Africa',
    'flag': '\uD83C\uDDF8\uD83C\uDDFF'

  }, {
    'name': {
      'common': 'Sint Maarten',
      'official': 'Sint Maarten',
      'native': {
        'eng': {
          'official': 'Sint Maarten',
          'common': 'Sint Maarten'
        },
        'fra': {
          'official': 'Saint-Martin',
          'common': 'Saint-Martin'
        },
        'nld': {
          'official': 'Sint Maarten',
          'common': 'Sint Maarten'
        }
      }
    },
    'tld': ['.sx'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDF8\uD83C\uDDFD'

  }, {
    'name': {
      'common': 'Seychelles',
      'official': 'Republic of Seychelles',
      'native': {
        'crs': {
          'official': 'Repiblik Sesel',
          'common': 'Sesel'
        },
        'eng': {
          'official': 'Republic of Seychelles',
          'common': 'Seychelles'
        },
        'fra': {
          'official': 'R\xE9publique des Seychelles',
          'common': 'Seychelles'
        }
      }
    },
    'tld': ['.sc'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDF8\uD83C\uDDE8'

  }, {
    'name': {
      'common': 'Syria',
      'official': 'Syrian Arab Republic',
      'native': {
        'ara': {
          'official': '\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0648\u0631\u064A\u0629',
          'common': '\u0633\u0648\u0631\u064A\u0627'
        }
      }
    },
    'tld': ['.sy', '\u0633\u0648\u0631\u064A\u0627.'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDF8\uD83C\uDDFE'

  }, {
    'name': {
      'common': 'Turks and Caicos Islands',
      'official': 'Turks and Caicos Islands',
      'native': {
        'eng': {
          'official': 'Turks and Caicos Islands',
          'common': 'Turks and Caicos Islands'
        }
      }
    },
    'tld': ['.tc'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDF9\uD83C\uDDE8'

  }, {
    'name': {
      'common': 'Chad',
      'official': 'Republic of Chad',
      'native': {
        'ara': {
          'official': '\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u062A\u0634\u0627\u062F',
          'common': '\u062A\u0634\u0627\u062F\u200E'
        },
        'fra': {
          'official': 'R\xE9publique du Tchad',
          'common': 'Tchad'
        }
      }
    },
    'tld': ['.td'],
    'region': 'Africa',
    'subregion': 'Middle Africa',
    'flag': '\uD83C\uDDF9\uD83C\uDDE9'

  }, {
    'name': {
      'common': 'Togo',
      'official': 'Togolese Republic',
      'native': {
        'fra': {
          'official': 'R\xE9publique togolaise',
          'common': 'Togo'
        }
      }
    },
    'tld': ['.tg'],
    'region': 'Africa',
    'subregion': 'Western Africa',
    'flag': '\uD83C\uDDF9\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'Thailand',
      'official': 'Kingdom of Thailand',
      'native': {
        'tha': {
          'official': '\u0E23\u0E32\u0E0A\u0E2D\u0E32\u0E13\u0E32\u0E08\u0E31\u0E01\u0E23\u0E44\u0E17\u0E22',
          'common': '\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22'
        }
      }
    },
    'tld': ['.th', '.\u0E44\u0E17\u0E22'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'flag': '\uD83C\uDDF9\uD83C\uDDED'

  }, {
    'name': {
      'common': 'Tajikistan',
      'official': 'Republic of Tajikistan',
      'native': {
        'rus': {
          'official': '\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D',
          'common': '\u0422\u0430\u0434\u0436\u0438\u043A\u0438\u0441\u0442\u0430\u043D'
        },
        'tgk': {
          'official': '\u04B6\u0443\u043C\u04B3\u0443\u0440\u0438\u0438 \u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D',
          'common': '\u0422\u043E\u04B7\u0438\u043A\u0438\u0441\u0442\u043E\u043D'
        }
      }
    },
    'tld': ['.tj'],
    'region': 'Asia',
    'subregion': 'Central Asia',
    'flag': '\uD83C\uDDF9\uD83C\uDDEF'

  }, {
    'name': {
      'common': 'Tokelau',
      'official': 'Tokelau',
      'native': {
        'eng': {
          'official': 'Tokelau',
          'common': 'Tokelau'
        },
        'smo': {
          'official': 'Tokelau',
          'common': 'Tokelau'
        },
        'tkl': {
          'official': 'Tokelau',
          'common': 'Tokelau'
        }
      }
    },
    'tld': ['.tk'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'flag': '\uD83C\uDDF9\uD83C\uDDF0'

  }, {
    'name': {
      'common': 'Turkmenistan',
      'official': 'Turkmenistan',
      'native': {
        'rus': {
          'official': '\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u0441\u0442\u0430\u043D',
          'common': '\u0422\u0443\u0440\u043A\u043C\u0435\u043D\u0438\u044F'
        },
        'tuk': {
          'official': 'T\xFCrkmenistan',
          'common': 'T\xFCrkmenistan'
        }
      }
    },
    'tld': ['.tm'],
    'region': 'Asia',
    'subregion': 'Central Asia',
    'flag': '\uD83C\uDDF9\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Timor-Leste',
      'official': 'Democratic Republic of Timor-Leste',
      'native': {
        'por': {
          'official': 'Rep\xFAblica Democr\xE1tica de Timor-Leste',
          'common': 'Timor-Leste'
        },
        'tet': {
          'official': 'Rep\xFAblika Demokr\xE1tika Tim\xF3r-Leste',
          'common': 'Tim\xF3r-Leste'
        }
      }
    },
    'tld': ['.tl'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'flag': '\uD83C\uDDF9\uD83C\uDDF1'

  }, {
    'name': {
      'common': 'Tonga',
      'official': 'Kingdom of Tonga',
      'native': {
        'eng': {
          'official': 'Kingdom of Tonga',
          'common': 'Tonga'
        },
        'ton': {
          'official': 'Kingdom of Tonga',
          'common': 'Tonga'
        }
      }
    },
    'tld': ['.to'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'flag': '\uD83C\uDDF9\uD83C\uDDF4'

  }, {
    'name': {
      'common': 'Trinidad and Tobago',
      'official': 'Republic of Trinidad and Tobago',
      'native': {
        'eng': {
          'official': 'Republic of Trinidad and Tobago',
          'common': 'Trinidad and Tobago'
        }
      }
    },
    'tld': ['.tt'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDF9\uD83C\uDDF9'

  }, {
    'name': {
      'common': 'Tunisia',
      'official': 'Tunisian Republic',
      'native': {
        'ara': {
          'official': '\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u062A\u0648\u0646\u0633\u064A\u0629',
          'common': '\u062A\u0648\u0646\u0633'
        }
      }
    },
    'tld': ['.tn'],
    'region': 'Africa',
    'subregion': 'Northern Africa',
    'flag': '\uD83C\uDDF9\uD83C\uDDF3'

  }, {
    'name': {
      'common': 'Turkey',
      'official': 'Republic of Turkey',
      'native': {
        'tur': {
          'official': 'T\xFCrkiye Cumhuriyeti',
          'common': 'T\xFCrkiye'
        }
      }
    },
    'tld': ['.tr'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDF9\uD83C\uDDF7'

  }, {
    'name': {
      'common': 'Tuvalu',
      'official': 'Tuvalu',
      'native': {
        'eng': {
          'official': 'Tuvalu',
          'common': 'Tuvalu'
        },
        'tvl': {
          'official': 'Tuvalu',
          'common': 'Tuvalu'
        }
      }
    },
    'tld': ['.tv'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'flag': '\uD83C\uDDF9\uD83C\uDDFB'

  }, {
    'name': {
      'common': 'Taiwan',
      'official': 'Republic of China (Taiwan)',
      'native': {
        'zho': {
          'official': '\u4E2D\u83EF\u6C11\u570B',
          'common': '\u53F0\u7063'
        }
      }
    },
    'tld': ['.tw', '.\u53F0\u7063', '.\u53F0\u6E7E'],
    'region': 'Asia',
    'subregion': 'Eastern Asia',
    'flag': '\uD83C\uDDF9\uD83C\uDDFC'

  }, {
    'name': {
      'common': 'Tanzania',
      'official': 'United Republic of Tanzania',
      'native': {
        'eng': {
          'official': 'United Republic of Tanzania',
          'common': 'Tanzania'
        },
        'swa': {
          'official': 'Jamhuri ya Muungano wa Tanzania',
          'common': 'Tanzania'
        }
      }
    },
    'tld': ['.tz'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDF9\uD83C\uDDFF'

  }, {
    'name': {
      'common': 'Uganda',
      'official': 'Republic of Uganda',
      'native': {
        'eng': {
          'official': 'Republic of Uganda',
          'common': 'Uganda'
        },
        'swa': {
          'official': 'Republic of Uganda',
          'common': 'Uganda'
        }
      }
    },
    'tld': ['.ug'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDFA\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'Ukraine',
      'official': 'Ukraine',
      'native': {
        'ukr': {
          'official': '\u0423\u043A\u0440\u0430\u0457\u043D\u0430',
          'common': '\u0423\u043A\u0440\u0430\u0457\u043D\u0430'
        }
      }
    },
    'tld': ['.ua', '.\u0443\u043A\u0440'],
    'region': 'Europe',
    'subregion': 'Eastern Europe',
    'flag': '\uD83C\uDDFA\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'United States Minor Outlying Islands',
      'official': 'United States Minor Outlying Islands',
      'native': {
        'eng': {
          'official': 'United States Minor Outlying Islands',
          'common': 'United States Minor Outlying Islands'
        }
      }
    },
    'tld': ['.us'],
    'region': 'Americas',
    'subregion': 'North America',
    'flag': '\uD83C\uDDFA\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Uruguay',
      'official': 'Oriental Republic of Uruguay',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica Oriental del Uruguay',
          'common': 'Uruguay'
        }
      }
    },
    'tld': ['.uy'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDFA\uD83C\uDDFE'

  }, {
    'name': {
      'common': 'United States',
      'official': 'United States of America',
      'native': {
        'eng': {
          'official': 'United States of America',
          'common': 'United States'
        }
      }
    },
    'tld': ['.us'],
    'region': 'Americas',
    'subregion': 'North America',
    'flag': '\uD83C\uDDFA\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'Uzbekistan',
      'official': 'Republic of Uzbekistan',
      'native': {
        'rus': {
          'official': '\u0420\u0435\u0441\u043F\u0443\u0431\u043B\u0438\u043A\u0430 \u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D',
          'common': '\u0423\u0437\u0431\u0435\u043A\u0438\u0441\u0442\u0430\u043D'
        },
        'uzb': {
          'official': "O'zbekiston Respublikasi",
          'common': 'O\u2018zbekiston'
        }
      }
    },
    'tld': ['.uz'],
    'region': 'Asia',
    'subregion': 'Central Asia',
    'flag': '\uD83C\uDDFA\uD83C\uDDFF'

  }, {
    'name': {
      'common': 'Vatican City',
      'official': 'Vatican City State',
      'native': {
        'ita': {
          'official': 'Stato della Citt\xE0 del Vaticano',
          'common': 'Vaticano'
        },
        'lat': {
          'official': 'Status Civitatis Vatican\xE6',
          'common': 'Vatican\xE6'
        }
      }
    },
    'tld': ['.va'],
    'region': 'Europe',
    'subregion': 'Southern Europe',
    'flag': '\uD83C\uDDFB\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'Saint Vincent and the Grenadines',
      'official': 'Saint Vincent and the Grenadines',
      'native': {
        'eng': {
          'official': 'Saint Vincent and the Grenadines',
          'common': 'Saint Vincent and the Grenadines'
        }
      }
    },
    'tld': ['.vc'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDFB\uD83C\uDDE8'

  }, {
    'name': {
      'common': 'Venezuela',
      'official': 'Bolivarian Republic of Venezuela',
      'native': {
        'spa': {
          'official': 'Rep\xFAblica Bolivariana de Venezuela',
          'common': 'Venezuela'
        }
      }
    },
    'tld': ['.ve'],
    'region': 'Americas',
    'subregion': 'South America',
    'flag': '\uD83C\uDDFB\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'British Virgin Islands',
      'official': 'Virgin Islands',
      'native': {
        'eng': {
          'official': 'Virgin Islands',
          'common': 'British Virgin Islands'
        }
      }
    },
    'tld': ['.vg'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDFB\uD83C\uDDEC'

  }, {
    'name': {
      'common': 'United States Virgin Islands',
      'official': 'Virgin Islands of the United States',
      'native': {
        'eng': {
          'official': 'Virgin Islands of the United States',
          'common': 'United States Virgin Islands'
        }
      }
    },
    'tld': ['.vi'],
    'region': 'Americas',
    'subregion': 'Caribbean',
    'flag': '\uD83C\uDDFB\uD83C\uDDEE'

  }, {
    'name': {
      'common': 'Vietnam',
      'official': 'Socialist Republic of Vietnam',
      'native': {
        'vie': {
          'official': 'C\u1ED9ng h\xF2a x\xE3 h\u1ED9i ch\u1EE7 ngh\u0129a Vi\u1EC7t Nam',
          'common': 'Vi\u1EC7t Nam'
        }
      }
    },
    'tld': ['.vn'],
    'region': 'Asia',
    'subregion': 'South-Eastern Asia',
    'flag': '\uD83C\uDDFB\uD83C\uDDF3'

  }, {
    'name': {
      'common': 'Vanuatu',
      'official': 'Republic of Vanuatu',
      'native': {
        'bis': {
          'official': 'Ripablik blong Vanuatu',
          'common': 'Vanuatu'
        },
        'eng': {
          'official': 'Republic of Vanuatu',
          'common': 'Vanuatu'
        },
        'fra': {
          'official': 'R\xE9publique de Vanuatu',
          'common': 'Vanuatu'
        }
      }
    },
    'tld': ['.vu'],
    'region': 'Oceania',
    'subregion': 'Melanesia',
    'flag': '\uD83C\uDDFB\uD83C\uDDFA'

  }, {
    'name': {
      'common': 'Wallis and Futuna',
      'official': 'Territory of the Wallis and Futuna Islands',
      'native': {
        'fra': {
          'official': 'Territoire des \xEEles Wallis et Futuna',
          'common': 'Wallis et Futuna'
        }
      }
    },
    'tld': ['.wf'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'flag': '\uD83C\uDDFC\uD83C\uDDEB'

  }, {
    'name': {
      'common': 'Samoa',
      'official': 'Independent State of Samoa',
      'native': {
        'eng': {
          'official': 'Independent State of Samoa',
          'common': 'Samoa'
        },
        'smo': {
          'official': 'Malo Sa\u02BBoloto Tuto\u02BBatasi o S\u0101moa',
          'common': 'S\u0101moa'
        }
      }
    },
    'tld': ['.ws'],
    'region': 'Oceania',
    'subregion': 'Polynesia',
    'flag': '\uD83C\uDDFC\uD83C\uDDF8'

  }, {
    'name': {
      'common': 'Yemen',
      'official': 'Republic of Yemen',
      'native': {
        'ara': {
          'official': '\u0627\u0644\u062C\u0645\u0647\u0648\u0631\u064A\u0629 \u0627\u0644\u064A\u0645\u0646\u064A\u0629',
          'common': '\u0627\u0644\u064A\u064E\u0645\u064E\u0646'
        }
      }
    },
    'tld': ['.ye'],
    'region': 'Asia',
    'subregion': 'Western Asia',
    'flag': '\uD83C\uDDFE\uD83C\uDDEA'

  }, {
    'name': {
      'common': 'South Africa',
      'official': 'Republic of South Africa',
      'native': {
        'afr': {
          'official': 'Republiek van Suid-Afrika',
          'common': 'South Africa'
        },
        'eng': {
          'official': 'Republic of South Africa',
          'common': 'South Africa'
        },
        'nbl': {
          'official': 'IRiphabliki yeSewula Afrika',
          'common': 'Sewula Afrika'
        },
        'nso': {
          'official': 'Rephaboliki ya Afrika-Borwa ',
          'common': 'Afrika-Borwa'
        },
        'sot': {
          'official': 'Rephaboliki ya Afrika Borwa',
          'common': 'Afrika Borwa'
        },
        'ssw': {
          'official': 'IRiphabhulikhi yeNingizimu Afrika',
          'common': 'Ningizimu Afrika'
        },
        'tsn': {
          'official': 'Rephaboliki ya Aforika Borwa',
          'common': 'Aforika Borwa'
        },
        'tso': {
          'official': 'Riphabliki ra Afrika Dzonga',
          'common': 'Afrika Dzonga'
        },
        'ven': {
          'official': 'Riphabu\u1E3Diki ya Afurika Tshipembe',
          'common': 'Afurika Tshipembe'
        },
        'xho': {
          'official': 'IRiphabliki yaseMzantsi Afrika',
          'common': 'Mzantsi Afrika'
        },
        'zul': {
          'official': 'IRiphabliki yaseNingizimu Afrika',
          'common': 'Ningizimu Afrika'
        }
      }
    },
    'tld': ['.za'],
    'region': 'Africa',
    'subregion': 'Southern Africa',
    'flag': '\uD83C\uDDFF\uD83C\uDDE6'

  }, {
    'name': {
      'common': 'Zambia',
      'official': 'Republic of Zambia',
      'native': {
        'eng': {
          'official': 'Republic of Zambia',
          'common': 'Zambia'
        }
      }
    },
    'tld': ['.zm'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDFF\uD83C\uDDF2'

  }, {
    'name': {
      'common': 'Zimbabwe',
      'official': 'Republic of Zimbabwe',
      'native': {
        'bwg': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'eng': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'kck': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'khi': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'ndc': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'nde': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'nya': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'sna': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'sot': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'toi': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'tsn': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'tso': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'ven': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'xho': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        },
        'zib': {
          'official': 'Republic of Zimbabwe',
          'common': 'Zimbabwe'
        }
      }
    },
    'tld': ['.zw'],
    'region': 'Africa',
    'subregion': 'Eastern Africa',
    'flag': '\uD83C\uDDFF\uD83C\uDDFC'
  }]
}));

/***/ }),

/***/ "EiZN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      checked: false
    };
  },

  props: ['title', 'category'],
  methods: {
    checkFilter: function checkFilter() {
      this.checked = !this.checked;
      // this.$bus.$emit('check-filter', this.category, this.title, this.checked);
    }
  }
});

/***/ }),

/***/ "EmY/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Eq8m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',[_vm._m(0),_vm._v(" "),_vm._l((this.$store.state.artworks),function(artwork){return _c('tr',{key:artwork.id},[_c('td',[_vm._v(" "+_vm._s(artwork.id))]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(artwork.accession_number))]),_vm._v(" "),_c('td',[_vm._v(" "+_vm._s(artwork.artwork_location_id))]),_vm._v(" "),_c('td',[(_vm.getArtworkPackings(artwork.id).length > 0)?_c('div',[_c('table',_vm._l((_vm.getArtworkPackings(artwork.id)),function(ap){return _c('tr',{key:ap.id},[_c('td',[_vm._v(_vm._s(ap.colli))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(ap.location_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(ap.artwork_location_id))])])}),0)]):_vm._e()]),_vm._v(" "),_c('td',[_c('table',_vm._l((_vm.getArtworkLocationHistory(artwork.id)),function(all){return _c('tr',{key:all.id},[_c('td',[_vm._v(_vm._s(all.created))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(all.storage))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(all.location_id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(all.change_date))])])}),0)])])})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("AN")]),_vm._v(" "),_c('th',[_vm._v("ALID:")]),_vm._v(" "),_c('th',[_vm._v("PACKINGS:")]),_vm._v(" "),_c('th',[_vm._v("HISTORY:")])])}]


/***/ }),

/***/ "FMlp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"800px","transition":"dialog-transition"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-flex',{staticClass:"xs12 ml-0 pl-4 pr-4 pt-4 pb-3 layout row wrap elevation-0 white"},[_c('v-subheader',{staticClass:"headline ml-0 pl-0 mb-3 black--text"},[(_vm.editedLocationLog.copy)?_c('span',[_vm._v(_vm._s(_vm.editedLocationLog.copy.toUpperCase())+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.editedLocationLog.artwork_packing_id)?_c('span',[_vm._v("\n            - "+_vm._s(_vm.getPacking(_vm.editedLocationLog.artwork_packing_id).packing)+"\n            "+_vm._s(_vm.getPacking(_vm.editedLocationLog.artwork_packing_id).colli))]):_vm._e()]),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-autocomplete',{attrs:{"disabled":_vm.c_user.id != 67 && _vm.c_user.id != 1,"label":"New Location","items":_vm.locations,"item-text":"name","item-value":"id","cache-items":"","dense":"","clearable":""},model:{value:(_vm.editedLocationLog.artwork_location_id),callback:function ($$v) {_vm.$set(_vm.editedLocationLog, "artwork_location_id", $$v)},expression:"editedLocationLog.artwork_location_id"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6 pr-3"},[_c('v-text-field',{attrs:{"name":"reason","label":"Reason"},model:{value:(_vm.editedLocationLog.reason),callback:function ($$v) {_vm.$set(_vm.editedLocationLog, "reason", $$v)},expression:"editedLocationLog.reason"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6"},[_c('v-text-field',{attrs:{"name":"shipper","label":"Shipper"},model:{value:(_vm.editedLocationLog.shipper),callback:function ($$v) {_vm.$set(_vm.editedLocationLog, "shipper", $$v)},expression:"editedLocationLog.shipper"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"note","label":"Note"},model:{value:(_vm.editedLocationLog.note),callback:function ($$v) {_vm.$set(_vm.editedLocationLog, "note", $$v)},expression:"editedLocationLog.note"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs6 mb-0 pl-3 mt-1 pt-3"},[_c('v-btn-toggle',{attrs:{"disabled":_vm.c_user.id != 67 && _vm.c_user.id != 1,"mandatory":"","active-class":"activeToggle"},model:{value:(_vm.editedLocationLog.storage),callback:function ($$v) {_vm.$set(_vm.editedLocationLog, "storage", $$v)},expression:"editedLocationLog.storage"}},[_c('v-btn',{staticClass:"px-3",attrs:{"value":"in","small":"","flat":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("call_received")]),_vm._v(" IN\n            ")],1),_vm._v(" "),_c('v-btn',{staticClass:"px-3",attrs:{"value":"out","small":"","flat":""}},[_vm._v("\n              OUT "),_c('v-icon',{attrs:{"small":""}},[_vm._v("call_made")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","d-flex":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-menu',{ref:"menu2a",attrs:{"disabled":_vm.c_user.id != 67 && _vm.c_user.id != 1,"close-on-content-click":true,"nudge-right":40,"lazy":"","landscape":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu2a),callback:function ($$v) {_vm.menu2a=$$v},expression:"menu2a"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.editedLocationLog.change_date),callback:function ($$v) {_vm.$set(_vm.editedLocationLog, "change_date", $$v)},expression:"editedLocationLog.change_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"persistent":"","color":"black"},model:{value:(_vm.editedLocationLog.change_date),callback:function ($$v) {_vm.$set(_vm.editedLocationLog, "change_date", $$v)},expression:"editedLocationLog.change_date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.editedLocationLog.change_time,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.editedLocationLog, "change_time", $event)},"update:return-value":function($event){return _vm.$set(_vm.editedLocationLog, "change_time", $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Picker time if needed","prepend-inner-icon":"access_time","readonly":""},model:{value:(_vm.editedLocationLog.change_time),callback:function ($$v) {_vm.$set(_vm.editedLocationLog, "change_time", $$v)},expression:"editedLocationLog.change_time"}},on))]}}]),model:{value:(_vm.menu_time),callback:function ($$v) {_vm.menu_time=$$v},expression:"menu_time"}},[_vm._v(" "),(_vm.menu_time)?_c('v-time-picker',{attrs:{"full-width":"","format":"24hr"},on:{"click:minute":function($event){return _vm.$refs.menu.save(_vm.editedLocationLog.change_time)}},model:{value:(_vm.editedLocationLog.change_time),callback:function ($$v) {_vm.$set(_vm.editedLocationLog, "change_time", $$v)},expression:"editedLocationLog.change_time"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-3":"","mb-0":""}},[_vm._v(_vm._s(_vm.editedLocationLog.copy)+"\n          ")]),_vm._v(" "),_c('v-flex',{staticClass:"xs12"}),_vm._v(" "),_c('v-flex',{staticClass:"xs12 pr-0 mr-0 mt-3",attrs:{"text-xs-right":""}},[_c('v-btn',{attrs:{"small":""},on:{"click":function($event){_vm.editDialog = !_vm.editDialog}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":!(
              _vm.editedLocationLog.artwork_location_id == null ||
              _vm.editedLocationLog.artwork_location_id == ''
            ) &&
            !(
              _vm.editedLocationLog.change_date == null ||
              _vm.editedLocationLog.change_date == ''
            ),"disabled":_vm.editedLocationLog.artwork_location_id == null ||
  _vm.editedLocationLog.artwork_location_id == '' ||
  _vm.editedLocationLog.change_date == null ||
  _vm.editedLocationLog.change_date == ''},on:{"click":_vm.save_edited_artwork_location_log}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-0",attrs:{"column":""}},[_c('v-flex',{attrs:{"ml-2":""}},[(_vm.artwork.artwork_location_id)?_c('v-flex',{attrs:{"xs12":"","mb-2":""}},[_c('b',[_vm._v("Current Artwork Location")]),_vm._v(" "),_c('v-icon',{staticClass:"ml-2",attrs:{"color":"red","small":""}},[_vm._v("adjust")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.get_location_name(_vm.artwork.artwork_location_id)))]),_vm._v(" "),(_vm.lastLocationLogArtwork && _vm.lastLocationLogArtwork.artwork_location_id != _vm.artwork.artwork_location_id)?_c('b',{staticClass:"red--text"},[_c('br'),_vm._v("Current Location of Artwork is different from latest Location History entry."),_c('br')]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.lastLocationLogArtwork)?_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('b',[_vm._v("Latest Artwork Location Change: ")]),_c('br'),_vm._v(" "),_c('v-icon',{staticClass:"mr-1 mt-1",attrs:{"color":"black","small":""}},[_vm._v("today")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.lastLocationLogArtwork.change_date)+" ")]),_vm._v(" "),_c('v-icon',{staticClass:"ml-2",attrs:{"color":"red","small":""}},[_vm._v("adjust")]),_vm._v("\n            "+_vm._s(_vm.get_location_name(_vm.lastLocationLogArtwork.artwork_location_id))+"\n            "),(_vm.lastLocationLogArtwork.storage)?_c('span',{staticClass:"mr-3 pl-0"},[_c('v-icon',{staticClass:"ml-3",attrs:{"color":"black","small":""}},[_vm._v(_vm._s(_vm.lastLocationLogArtwork.storage == 'in'
                ? 'call_received'
                : 'call_made'))]),_vm._v(" "),_c('b',[_vm._v("Storage "+_vm._s(_vm.lastLocationLogArtwork.storage.toUpperCase()))])],1):_vm._e(),_vm._v(" "),(_vm.lastLocationLogArtwork.reason || _vm.lastLocationLogArtwork.note)?_c('span',[_vm._v("\n              ("+_vm._s(_vm.lastLocationLogArtwork.reason)+"\n              "),(_vm.lastLocationLogArtwork.note != _vm.lastLocationLogArtwork.reason)?_c('span',[_vm._v(_vm._s(_vm.lastLocationLogArtwork.note))]):_vm._e(),_vm._v(")\n            ")]):_vm._e()],1)]):_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',{staticClass:"ml-2",attrs:{"color":"black","small":""}},[_vm._v("adjust")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.get_location_name(_vm.artwork.artwork_location_id)))])],1),_vm._v(" "),(_vm.lastLocationLogMasterPhysical)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit_location")]),_vm._v("Master Physical\n          "),_c('v-icon',{staticClass:"ml-0",attrs:{"small":""}},[_vm._v("adjust")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.get_location_name(_vm.artwork.master_physical_location_id)))]),_vm._v(" "),(_vm.lastLocationLogMasterPhysical.storage)?_c('span',[_c('v-icon',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v(_vm._s(_vm.lastLocationLogMasterPhysical.storage == 'in'
              ? 'call_received'
              : 'call_made'))]),_vm._v("\n            Storage "+_vm._s(_vm.lastLocationLogMasterPhysical.storage.toUpperCase())+":\n          ")],1):_vm._e(),_vm._v(" "),_c('v-icon',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("today")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.lastLocationLogMasterPhysical.change_date)+" ")]),_vm._v(" ("+_vm._s(_vm.lastLocationLogMasterPhysical.note)+")\n        ")],1):_vm._e(),_vm._v(" "),(_vm.lastLocationLogArchiveMaster)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit_location")]),_vm._v("Archive Master\n          "),_c('v-icon',{staticClass:"ml-0",attrs:{"small":""}},[_vm._v("adjust")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.get_location_name(_vm.artwork.archive_master_location_id)))]),_vm._v(" "),(_vm.lastLocationLogArchiveMaster.storage)?_c('span',[_c('v-icon',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v(_vm._s(_vm.lastLocationLogArchiveMaster.storage == 'in'
              ? 'call_received'
              : 'call_made'))]),_vm._v("\n            Storage "+_vm._s(_vm.lastLocationLogArchiveMaster.storage.toUpperCase())+":\n          ")],1):_vm._e(),_vm._v(" "),_c('v-icon',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("today")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.lastLocationLogArchiveMaster.change_date))]),_vm._v("\n          ("+_vm._s(_vm.lastLocationLogArchiveMaster.note)+")\n        ")],1):_vm._e(),_vm._v(" "),(_vm.lastLocationLogAccessCopy)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit_location")]),_vm._v("Access Copy\n          "),_c('v-icon',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("adjust")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.get_location_name(_vm.artwork.access_copy_location_id)))]),_vm._v(" "),(_vm.lastLocationLogAccessCopy.storage)?_c('span',[_c('v-icon',{staticClass:"ml-0 pl-0",attrs:{"small":""}},[_vm._v(_vm._s(_vm.lastLocationLogAccessCopy.storage == 'in'
              ? 'call_received'
              : 'call_made'))]),_vm._v("\n            Storage "+_vm._s(_vm.lastLocationLogAccessCopy.storage.toUpperCase())+":\n          ")],1):_vm._e(),_vm._v(" "),_c('v-icon',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("today")]),_vm._v("\n          "+_vm._s(_vm.lastLocationLogAccessCopy.change_date)+" ("+_vm._s(_vm.lastLocationLogAccessCopy.note)+")\n        ")],1):_vm._e(),_vm._v(" "),(_vm.artwork.artwork_packings)?_c('v-flex',{attrs:{"mt-2":"","xs12":""}},[_c('b',[_vm._v("Latest Packing Location Changes: ")]),_vm._v(" "),_vm._l((_vm.artwork.artwork_packings),function(p){return _c('v-flex',{key:p.id,attrs:{"ml-0":"","px-0":""}},[(p.artwork_location_id)?_c('v-flex',{attrs:{"mx-0":"","px-0":""}},[_c('v-icon',{staticClass:"mr-1 mt-1",attrs:{"color":"black","small":""}},[_vm._v("today")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.lastLocationLogArtworkPacking(p.id).change_date)+" ")]),_vm._v(" "),_c('v-icon',{staticClass:"mx-1",attrs:{"color":"black","small":""}},[_vm._v("mdi-archive")]),_vm._v(_vm._s(p.packing)+" "+_vm._s(p.colli)+"\n              "),_c('v-icon',{staticClass:"ml-2",attrs:{"color":"red","small":""}},[_vm._v("adjust")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.get_location_name(_vm.lastLocationLogArtworkPacking(p.id).artwork_location_id)))])],1):_c('v-flex',[_vm._v("\n              Packing has no location entered.\n            ")])],1)})],2):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"xs12":"","sm12":"","md12":"","mt-2":"","ml-0":"","mr-0":"","px-0":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs12":"","row":"","layout":""}},[(_vm.c_user.edit)?_c('v-btn',{staticClass:"mt-2 mb-0 ml-1 mr-0",attrs:{"round":"","flat":"","small":""},on:{"click":_vm.switch_change_dialog}},[_c('v-icon',{staticClass:"mr-1",attrs:{"small":""}},[_vm._v("near_me")]),_vm._v("\n              "+_vm._s(_vm.showUpload ? 'Cancel Changing location' : 'Change current Location'))],1):_vm._e(),_vm._v(" "),_c('v-spacer',{staticClass:"pb-0 mb-0"}),_vm._v(" "),_c('v-btn',{staticClass:"pl-3 pr-2 mx-0",attrs:{"small":"","round":"","flat":""},on:{"click":function($event){_vm.showList = !_vm.showList}}},[_vm._v("\n              "+_vm._s(_vm.showList ? 'Hide' : 'Show')+" History\n              "),(!_vm.showList)?_c('v-icon',{staticClass:"pl-3"},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.showList)?_c('v-icon',{staticClass:"pl-3"},[_vm._v("expand_less")]):_vm._e()],1)],1),_vm._v(" "),(_vm.showUpload)?_c('v-card',{staticClass:"\n                              xs12\n                              ml-2\n                              mr-0\n                              mt-2\n                              mb-2\n                              elevation-0\n                              "},[_c('v-card-title',{staticClass:"red white--text xs12 py-2"},[_c('h3',[_vm._v("Add Location History Entry and Change Location")])]),_vm._v(" "),_c('v-card-text',{staticClass:"pl-4\n                              pr-4\n                              pt-3\n                              pb-3 wrap row layout"},[_c('v-flex',{staticClass:"xs12"},[_c('v-autocomplete',{attrs:{"disable":!_vm.c_user.edit,"label":"New Location","items":_vm.locations,"item-text":"name","item-value":"id","cache-items":"","clearable":"","persistent-hint":"","hint":("Latest Artwork Location History entry: " + (_vm.get_location_name(_vm.lastLocationLogArtwork.artwork_location_id)))},model:{value:(_vm.artwork_location_log.artwork_location_id),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "artwork_location_id", $$v)},expression:"artwork_location_log.artwork_location_id"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6"},[_c('v-text-field',{staticClass:"mr-2",attrs:{"name":"reason","label":"Reason"},model:{value:(_vm.artwork_location_log.reason),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "reason", $$v)},expression:"artwork_location_log.reason"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6"},[_c('v-text-field',{attrs:{"name":"shipper","label":"Shipper"},model:{value:(_vm.artwork_location_log.shipper),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "shipper", $$v)},expression:"artwork_location_log.shipper"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"note","label":"Note"},model:{value:(_vm.artwork_location_log.note),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "note", $$v)},expression:"artwork_location_log.note"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 sm6 mb-0 pt-3"},[_c('v-btn-toggle',{attrs:{"mandatory":"","active-class":"activeToggle"},model:{value:(_vm.artwork_location_log.storage),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "storage", $$v)},expression:"artwork_location_log.storage"}},[_c('v-btn',{staticClass:"px-3",attrs:{"value":"in","small":"","flat":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("call_received")]),_vm._v(" IN\n                  ")],1),_vm._v(" "),_c('v-btn',{staticClass:"px-3",attrs:{"value":"out","small":"","flat":""}},[_vm._v("\n                    OUT "),_c('v-icon',{attrs:{"small":""}},[_vm._v("call_made")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","mb-0":"","pb-0":""}},[_c('v-menu',{ref:"menu2",attrs:{"disabled":!_vm.c_user.edit,"return-value":_vm.artwork_location_log.change_date,"close-on-content-click":true,"nudge-right":40,"lazy":"","landscape":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.artwork_location_log, "change_date", $event)},"update:return-value":function($event){return _vm.$set(_vm.artwork_location_log, "change_date", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-inner-icon":"event","readonly":"","persistent-hint":"","hint":this.artwork_location_log.change_date != '' && !_vm.shouldUpdateArtworksLocation ? 'Date is before or the same as the last change, artwork location will not be updated.' : ''},slot:"activator",model:{value:(_vm.artwork_location_log.change_date),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "change_date", $$v)},expression:"artwork_location_log.change_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"color":"black","persistent":""},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.artwork_location_log.change_date)}},model:{value:(_vm.artwork_location_log.change_date),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "change_date", $$v)},expression:"artwork_location_log.change_date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-3":"","mb-0":""}},[_c('v-btn-toggle',{attrs:{"flat":"","mandatory":"","active-class":"activeToggle"},model:{value:(_vm.artwork_location_log.copy),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "copy", $$v)},expression:"artwork_location_log.copy"}},[(_vm.artwork.artwork_packings.length > 0)?_c('v-btn',{staticClass:"px-2",attrs:{"small":"","flat":"","value":"packings","disabled":_vm.artwork.artwork_packings.length == 0}},[_vm._v("Parts\n                  ")]):_vm._e(),_vm._v(" "),(_vm.artwork.artwork_packings.length == 0)?_c('v-btn',{staticClass:"px-2",attrs:{"small":"","flat":"","value":"artwork"}},[_vm._v("Artwork\n                  ")]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"px-2",attrs:{"small":"","flat":"","value":"master_physical"}},[_vm._v("Master Physical\n                  ")]),_vm._v(" "),_c('v-btn',{staticClass:"px-2",attrs:{"small":"","flat":"","value":"archive_master"}},[_vm._v("Archive Master\n                  ")]),_vm._v(" "),_c('v-btn',{staticClass:"px-2",attrs:{"small":"","flat":"","value":"access_copy"}},[_vm._v("Access Copy\n                  ")])],1)],1),_vm._v(" "),(_vm.artwork_location_log.copy == 'packings')?_c('v-flex',{attrs:{"pa-0":"","ma-0":"","d-flex":""}},[_c('v-checkbox',{attrs:{"label":"Change All Parts","color":"black"},model:{value:(_vm.changeAllParts),callback:function ($$v) {_vm.changeAllParts=$$v},expression:"changeAllParts"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Change Also Artwork Location","color":"black"},model:{value:(_vm.changeArtworkLocation),callback:function ($$v) {_vm.changeArtworkLocation=$$v},expression:"changeArtworkLocation"}})],1):_vm._e(),_vm._v(" "),(_vm.artwork_location_log.copy == 'packings')?_c('v-data-table',{staticClass:"elevation-0 mx-0 mt-0",staticStyle:{"width":"100%"},attrs:{"items":_vm.artwork.artwork_packings,"item-key":"id","hide-actions":"","hide-headers":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticClass:"py-2 text-xs-left px-0"},[_c('v-container',{attrs:{"grid-list-xs":"","text-xs-left":"","pa-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-checkbox',{staticClass:"pa-0",attrs:{"color":"black","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"font-weight":"bold","overflow":"auto"},attrs:{"xs6":"","pr-2":""}},[_vm._v("\n                            "+_vm._s(props.item.colli)),_c('br'),_vm._v("\n                            "+_vm._s(props.item.packing)+"\n                          ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","px-1":""}},[_vm._v("\n                            "+_vm._s(props.item.height)+" x "+_vm._s(props.item.width)+" x\n                            "+_vm._s(props.item.lenght)+" cm "),_c('br'),_vm._v("\n                            "+_vm._s(props.item.weight)+" kg\n                          ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}}),_vm._v(" "),_c('v-flex',{staticStyle:{"overflow":"hidden"},attrs:{"xs6":"","pr-2":""}},[_vm._v("\n                            "+_vm._s(_vm.get_location_name(props.item.artwork_location_id))+"\n                            "),_c('br'),_vm._v("\n                            "+_vm._s(_vm.get_visa_status(props.item.visa_status))+"\n                          ")]),_vm._v(" "),_c('v-flex',{staticStyle:{"overflow":"hidden"},attrs:{"xs5":"","px-1":""}},[_vm._v("\n                            "+_vm._s(props.item.contents)+"\n                          ")])],1)],1)],1)])]}}],null,false,3763472428),model:{value:(_vm.selectedPackings),callback:function ($$v) {_vm.selectedPackings=$$v},expression:"selectedPackings"}},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('center',[_vm._v("No Packings for this artwork.")])],1)],2):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"xs12"}),_vm._v(" "),_c('v-flex',{staticClass:"xs12 pr-0 mr-0 mt-3",attrs:{"text-xs-right":""}},[_c('v-btn',{attrs:{"small":"","flat":""},on:{"click":_vm.switch_change_dialog}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":!(
                    _vm.artwork_location_log.artwork_location_id == null ||
                    _vm.artwork_location_log.artwork_location_id == ''
                  ) &&
                  !(
                    _vm.artwork_location_log.copy == 'packings' &&
                    _vm.selectedPackings.length < 1
                  ) &&
                  !(
                    _vm.artwork_location_log.change_date == null ||
                    _vm.artwork_location_log.change_date == ''
                  ),"disabled":_vm.artwork_location_log.artwork_location_id == null ||
  _vm.artwork_location_log.artwork_location_id == '' ||
  (_vm.artwork_location_log.copy == 'packings' &&
    _vm.selectedPackings.length < 1) ||
  _vm.artwork_location_log.change_date == null ||
  _vm.artwork_location_log.change_date == ''},on:{"click":_vm.showSaveDialog}},[_vm._v("save")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","overlay":true,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.saveDialog),callback:function ($$v) {_vm.saveDialog=$$v},expression:"saveDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"red white--text pb-2 pt-2",attrs:{"primary-title":""}},[_c('h2',[_vm._v("Review Changes")])]),_vm._v(" "),(_vm.changeArtworkLocation || _vm.artwork_location_log.copy == 'artwork')?_c('v-card-text',[_c('h3',{staticClass:"mb-3"},[_vm._v(" New Location History entry will be created for:"),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.artwork.title)+", "+_vm._s(_vm.artwork.accession_number)+"\n                ")])]),_vm._v(" "),_c('div',[_vm._v("\n                  Change Date: "),_c('b',[_vm._v(_vm._s(_vm.artwork_location_log.change_date))]),_vm._v("\n                  ---- "+_vm._s(_vm.lastLocationLogArtwork.change_date)+"----\n                ")]),_vm._v(" "),_c('div',[_vm._v("\n                  Location: "),_c('b',[_vm._v(_vm._s(_vm.get_location_name(_vm.artwork_location_log.artwork_location_id)))])]),_vm._v(" "),(_vm.shouldUpdateArtworksLocation)?_c('h3',[_vm._v(" \n                  Artwork's Current Location will also be changed..")]):_vm._e(),_vm._v(" "),(_vm.lastLocationLogArtwork && _vm.artwork_location_log.change_date <= _vm.lastLocationLogArtwork.change_date)?_c('h3',{staticClass:"red--text"},[_vm._v(" Artwork's Current Location will "),_c('b',[_vm._v("NOT")]),_vm._v(" be changed, because a location\n                  history entry with newer Change Date exists.")]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.selectedPackings.length > 0)?_c('v-card-text',[_c('h3',{staticClass:"pb-2"},[_vm._v(" New Location History entry will be created for these Packings:")]),_vm._v(" "),_vm._l((_vm.selectedPackings),function(sp){return _c('div',{staticClass:"py-2"},[_c('b',[_vm._v(_vm._s(sp.colli))]),_vm._v(" "),(_vm.lastLocationLogArtworkPacking(sp.id) == '' || (_vm.artwork_location_log.change_date > _vm.lastLocationLogArtworkPacking(sp.id).change_date))?_c('span',[_vm._v("\n                    => "+_vm._s(_vm.get_location_name(_vm.artwork_location_log.artwork_location_id))+"\n                  ")]):_c('span',{staticClass:"red--text"},[_vm._v("\n                    This packing's current location will "),_c('b',[_vm._v("NOT")]),_vm._v(" be changed, because a location\n                    history entry  with newer Change Date exists.\n                  ")]),_vm._v(" "),_c('v-divider',{staticClass:"mt-2"})],1)}),_vm._v(" "),_c('div',[_vm._v("\n                  Change Date: "),_c('b',[_vm._v(_vm._s(_vm.artwork_location_log.change_date))])])],2):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"cancel","small":"","gray":""},on:{"click":function($event){_vm.saveDialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":!(
                    _vm.artwork_location_log.artwork_location_id == null ||
                    _vm.artwork_location_log.artwork_location_id == ''
                  ) &&
                  !(
                    _vm.artwork_location_log.copy == 'packings' &&
                    _vm.selectedPackings.length < 1
                  ) &&
                  !(
                    _vm.artwork_location_log.change_date == null ||
                    _vm.artwork_location_log.change_date == ''
                  ),"disabled":_vm.artwork_location_log.artwork_location_id == null ||
  _vm.artwork_location_log.artwork_location_id == '' ||
  (_vm.artwork_location_log.copy == 'packings' &&
    _vm.selectedPackings.length < 1) ||
  _vm.artwork_location_log.change_date == null ||
  _vm.artwork_location_log.change_date == ''},on:{"click":_vm.save_artwork_location_log}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(
            (_vm.artwork.artwork_location_logs &&
              _vm.artwork.artwork_location_logs.length > 0) ||
            (_vm.artwork.location_history && !_vm.showUpload)
          )?_c('v-flex',{attrs:{"mt-0":"","d-flex":"","text-xs-right":""}},[_c('v-spacer'),_vm._v(" "),(_vm.showList)?_c('span',{staticClass:"mt-0 mr-0"},[_c('v-menu',{staticClass:"text-xs-right mx-0",attrs:{"offset-y":"","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-0 my-0 py-0 px-3",attrs:{"small":"","round":"","flat":""}},on),[_c('span',{staticClass:"text-uppercase mr-3"},[_vm._v(_vm._s(_vm.selectedFilter))]),_vm._v(" "),_c('v-icon',{attrs:{"small":""}},[_vm._v("filter_list")])],1)]}}],null,false,1640477794)},[_vm._v(" "),_c('v-list',{attrs:{"value":"artwork"}},_vm._l(([
                    'artwork',
                    'packings',
                    'master_physical',
                    'archive_master',
                    'access_copy' ]),function(item,index){return _c('v-list-tile',{key:index.id,on:{"click":function($event){return _vm.toggleCopyFilter(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item))])],1)}),1)],1),_vm._v(" "),(_vm.selectedFilter == 'packings')?_c('span',{staticClass:"mt-0 mr-0"},[_c('v-menu',{staticClass:"text-xs-right mx-0",attrs:{"offset-y":"","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 px-3",attrs:{"flat":"","small":"","round":""}},on),[_c('span',{staticClass:"text-uppercase mr-3"},[_vm._v("Filter by Packing: "+_vm._s(_vm.selectedPackingFilter != 'all' ? _vm.selectedPackingFilter.colli : 'all'))]),_vm._v(" "),_c('v-icon',{attrs:{"small":""}},[_vm._v("inventory_2")])],1)]}}],null,false,204428425)},[_vm._v(" "),_c('v-list',{attrs:{"value":_vm.artwork.artwork_packings[0]}},[_c('v-list-tile',{key:"all",on:{"click":function($event){return _vm.togglePackingFilter('all')}}},[_c('v-list-tile-title',[_vm._v("all")])],1),_vm._v(" "),_vm._l((_vm.artwork.artwork_packings),function(item,index){return _c('v-list-tile',{key:index.id,on:{"click":function($event){return _vm.togglePackingFilter(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.colli))])],1)})],2)],1)],1):_vm._e()],1):_vm._e()],1):_vm._e()],1)],1),_vm._v(" "),(_vm.showList)?_c('v-flex',{attrs:{"row":"","xs12":"","sm12":"","md12":"","mt-0":"","ml-1":"","mr-0":""}},[(
          (_vm.artwork.artwork_location_logs &&
            _vm.artwork.artwork_location_logs.length > 0) ||
          (_vm.artwork.location_history && _vm.artwork.id < 2352)
        )?_c('v-list',{staticClass:"xs12 py-0 grey lighten-4",attrs:{"three-line":""}},[_c('v-flex',{attrs:{"my-0":"","pb-0":"","pt-2":""}},[_vm._l((_vm.filtered_artwork_location_logs),function(l){return [_c('v-flex',{key:l.id},[_c('v-flex',{attrs:{"px-3":"","py-0":""}},[_c('v-list-tile-title',{staticClass:"subheading font-weight-bold"},[(l.storage_out)?_c('span',[_vm._v(_vm._s(l.storage_out))]):_vm._e(),_vm._v(" "),(l.storage_in)?_c('span',[_vm._v(_vm._s(l.storage_in))]):_vm._e(),_vm._v(" "),(!l.storage_in && !l.storage_out)?_c('span',[_vm._v(_vm._s(l.change_date))]):_vm._e(),_vm._v(" "),(
                      l.storage_in == null &&
                      l.storage_out == null &&
                      l.change_date == null
                    )?_c('span',{staticClass:"red--text"},[_vm._v("NO DATE")]):_vm._e(),_vm._v(" "),(l.storage)?_c('span',[_vm._v(_vm._s(l.copy.toUpperCase())+"\n                      "+_vm._s(l.storage.toUpperCase()))]):_vm._e(),_vm._v(" "),(l.artwork_packing_id)?_c('span',[_vm._v("("+_vm._s(_vm.getPacking(l.artwork_packing_id).packing)+"\n                      "+_vm._s(_vm.getPacking(l.artwork_packing_id).colli)+")")]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"right font-weight-thin"},[(l.created_by != null)?_c('span',[_vm._v(_vm._s(_vm.get_abb(l.created_by))+" -")]):_vm._e(),_vm._v(" "),(l.created_at != null || l.created_at != '')?_c('span',[_vm._v(_vm._s(_vm.format_date(l.created_at)))]):_vm._e()])]),_vm._v(" "),_c('v-list-tile-title',[(_vm.c_user.edit)?_c('span',{staticClass:"right"},[_c('v-btn',{staticClass:"mt-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.delete_log(l)}}},[_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-btn',{key:l.id + 'b',staticClass:"mr-0 mt-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.editLocation(l)}}},[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("edit")])],1)],1):(
                      l.note == 'Created at Artwork record creation in CMS'
                    )?_c('span',[_vm._v("\n                      Created at Artwork record creation in CMS\n                    ")]):_vm._e(),_vm._v(" "),_c('span',{},[_vm._v("TO:")]),_vm._v("\n                    "+_vm._s(_vm.get_location_name(l.artwork_location_id))+"\n                  ")]),_vm._v(" "),(l.reason)?_c('v-list-tile-sub-title',{staticClass:"body-2"},[_c('span',{},[_vm._v("REASON:")]),_vm._v("\n                    "+_vm._s(l.reason)+"\n                  ")]):_vm._e(),_vm._v(" "),(
                    l.note &&
                    l.note != 'Created at Artwork record creation in CMS'
                  )?_c('v-list-tile-sub-title',{staticClass:"body-2"},[_c('span',{},[_vm._v("NOTE:")]),_vm._v("\n                    "+_vm._s(l.note)+"\n                  ")]):_vm._e(),_vm._v(" "),(l.shipper)?_c('v-list-tile-sub-title',{staticClass:"body-2"},[_c('span',{},[_vm._v("SHIPPER:")]),_vm._v("\n                    "+_vm._s(l.shipper)+"\n                  ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-divider',{key:("a" + (l.id)),staticClass:"my-2"})]})],2)],1):_vm._e(),_vm._v(" "),(_vm.artwork.location_history && _vm.artwork.id < 2352)?_c('v-flex',{staticClass:"ml-3 mt-3 pa-0",domProps:{"innerHTML":_vm._s(_vm.nl2br(_vm.artwork.location_history))}}):_vm._e()],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "FNi1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"900px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"dark":""}},[_c('v-card-title',{staticClass:"mb-0 pb-0"},[_c('span',{staticClass:"headline mb-0 pb-0 ml-4 mt-3 font-weight-light"},[_vm._v("Merge into other Contact before deleting")])]),_vm._v(" "),_c('v-card-text',{staticClass:"mt-0 pt-0"},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"title mb-2"},[_vm._v("Contacts to delete:")]),_vm._v(" "),_vm._l((_vm.selected),function(c){return _c('div',{key:c.id,staticStyle:{"color":"red","font-size":"17px"}},[_vm._v("\n                "+_vm._s(c.name)+"\n                "),_c('span',{staticClass:"right"},[_vm._v("ID-"+_vm._s(c.id))])])})],2),_vm._v(" "),(_vm.artworks.length > 0)?_c('v-flex',{attrs:{"xs12":"","mt-3":""}},[_c('b',[_vm._v("Affected Artworks:")]),_vm._v(" "),_c('div',{staticStyle:{"color":"white","font-size":"17px"}},_vm._l((_vm.artworks),function(a){return _c('div',{key:a.id},[_c('b',[_vm._v(_vm._s(a.accession_number))]),_vm._v("\n                  - "+_vm._s(a.name)+" - "+_vm._s(a.title)+"\n                ")])}),0)]):_c('v-flex',{attrs:{"mt-3":""}},[_c('b',[_vm._v("NO ARTWORKS HAVE THIS CONTACT AS ACQUISITION SOURCE")])]),_vm._v(" "),(_vm.artworks.length > 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',[_c('div',{staticClass:"title mt-4"},[_vm._v("\n                  Select Contact to set new Acquisition Source to artworks\n                  below:\n                ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.table_contacts,"item-text":"name","item-value":"id","label":""},on:{"change":_vm.setContact2},scopedSlots:_vm._u([{key:"item",fn:function(data){return [_c('v-list-tile-content',{staticClass:"py-2"},[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(data.item.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(("Atworks Count: " + (data.item.artworks.length)))}})],1),_vm._v(" "),_c('v-list-tile-action',[_vm._v("ID-"+_vm._s(data.item.id))])]}}],null,false,921350357),model:{value:(_vm.selectedContact),callback:function ($$v) {_vm.selectedContact=$$v},expression:"selectedContact"}})],1),_vm._v(" "),(_vm.artworks2.length > 0)?_c('v-flex',{attrs:{"xs12":""}},[_c('b',[_vm._v("Current Artworks af this Contact:")]),_vm._v(" "),_c('ul',_vm._l((_vm.artworks2),function(a){return _c('li',{key:a.id},[_vm._v("\n                    "+_vm._s(a.accession_number)+" / "+_vm._s(a.name)+" / "+_vm._s(a.title)+"\n                  ")])}),0)]):_c('v-flex',[_c('b',[_vm._v("NO ARTWORKS")])])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pr-4 pb-4"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Close")]),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{attrs:{"color":"red","flat":""},on:{"click":_vm.deleteContact2}},[_vm._v("Delete")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mx-0 px-0 elevation-0"},[_c('v-card-title',[(_vm.selected.length > 0 && _vm.c_user.delete_rights)?_c('v-btn',{staticClass:"mx-0 mb-0",attrs:{"small":"","color":"red","dark":""},on:{"click":_vm.deleteContacts}},[_vm._v("Delete Contacts")]):_vm._e(),_vm._v(" "),(_vm.selected.length > 0 && _vm.c_user.delete_rights)?_c('v-btn',{staticClass:"mx-3 mb-0",attrs:{"small":"","color":"black","dark":""},on:{"click":_vm.resetSelected}},[_vm._v("Clear Selection")]):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","my-3":"","mx-1":""}},[_c('span',[_c('v-menu',{staticClass:"text-xs-right mx-4 my-0 py-0 align-center",attrs:{"offset-y":"","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-2 my-0 py-0",attrs:{"small":"","icon":"","color":"black","dark":""}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("supervisor_account")])],1)]}}])},[_vm._v(" "),_c('v-list',{attrs:{"value":"2"}},_vm._l((_vm.ownerships),function(item,index){return _c('v-list-tile',{key:index.id,on:{"click":function($event){return _vm.toggleOwnership(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)}),1)],1)],1),_vm._v(" "),_c('span',{staticClass:"text-xs-left mt-2 pt-1 title"},[_vm._v("\n          "+_vm._s(_vm.selectedOwnership)+"\n        ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.$store.state.showSearch)?_c('v-text-field',{staticClass:"mr-3",attrs:{"prepend-inner-icon":"search","label":"Search ","single-line":"","clearable":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0 mx-4",staticStyle:{"border-top":"1px solid #ccc"},attrs:{"headers":_vm.headers,"items":_vm.contacts,"search":_vm.search,"hide-headers":"","pagination":_vm.pagination,"item-key":"id","must-sort":"","rows-per-page-text":"Contacts per page","no-results-text":"No Contacts match the criteria.","rows-per-page-items":[10, 20, 30]},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticStyle:{"width":"15px","padding":"0px","margin":"0px"}},[_c('v-checkbox',{attrs:{"color":"black","primary":"","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',{staticClass:"title font-weight-light py-3"},[_c('router-link',{attrs:{"to":{ name: 'EditContact', params: {id: props.item.id, contact: props.item}, path: ("/contacts/edit/" + (props.item.id))}}},[_vm._v("\n            "+_vm._s(props.item.name)+"\n            ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.company))]),_vm._v(" "),_c('td',[_vm._v("\n            "+_vm._s(props.item.category == "artwork_acquisition_source" ? "A.S." : "")+"\n            "+_vm._s(props.item.category == "registrar" ? "R" : "")+"\n            "+_vm._s(props.item.category == "exhibition_institution" ? "E.I" : "")+"\n          ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.artworks.length))])])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("Your search for \""+_vm._s(_vm.search)+"\" found no results.")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "FOKY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FaVa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddContact_vue__ = __webpack_require__("s486");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce93fbb8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddContact_vue__ = __webpack_require__("wn6m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("sKaU")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce93fbb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddContact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce93fbb8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddContact_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ce93fbb8_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddContact_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FbSb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G+NM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "G5/j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      constants: __WEBPACK_IMPORTED_MODULE_1__data_constants__["a" /* default */],
      location_get: {},
      valid: true,
      // snackbarFieldName: 'Location',
      // snackbarColor: 'green',
      // snackbar: false,
      timeout: 3000,
      countries: __WEBPACK_IMPORTED_MODULE_1__data_constants__["a" /* default */].COUNTRIES,
      editContact: false,
      artworks: this.$store.state.artworks.filter(function (a) {
        return a.artwork_location_id == _this.location.id;
      })
    };
  },
  beforeMount: function beforeMount() {
    this.getLocation();
  },

  computed: {
    location_local: function location_local() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.location);
    }
  },
  methods: {
    getLocation: function getLocation() {
      var _this2 = this;

      var url = this.$globals.apiserver + '/artwork_locations/' + this.location.id + '.json';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
        _this2.location_get = response.data;
      }).catch(function (error) {
        // console.log(error)
      });
    },
    humanize: function humanize(t) {
      return t.replace(/_/g, ' ').replace(/(?: |\b)(\w)/g, function (t) {
        return t.toUpperCase();
      });
    },
    save: function save() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Saving location.', 'green');
      /// kvoli mazaniu aktualnej hodnoty - autocomplete totiz vracia undefined ak je prazdny a potom neposle field vobec a preto nevymaze v rails hodnotu
      this.location_get.country_id = this.location_get.country_id ? this.location_get.country_id : '';
      this.location_get.updated_by = this.c_user.id;
      var url = this.$globals.apiserver + '/artwork_locations/' + this.location.id + '.json';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url, this.location_get).then(function (response) {
        _this3.result = response.data;
        __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Location saved.', 'green');
        // this.snackbar = true
        // this.snackbarColor = 'green'
        _this3.$store.dispatch('replaceObject', {
          item: { item: response.data, table: 'contacts' }
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Error occured.', 'red');
        // console.log(error)
      });
    }
  },
  props: ['location']
});

/***/ }),

/***/ "GbdC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list-tile',[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(_vm.contact.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(_vm.contact.category)}})],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-icon',[_vm._v("chat_bubble")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "Gk4k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestList_vue__ = __webpack_require__("zdkS");
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_415f2e2c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestList_vue__ = __webpack_require__("h7z0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TestList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_415f2e2c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_415f2e2c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TestList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),

/***/ "GuN8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H/o8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_axios_js__ = __webpack_require__("81r7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_artists_Artist_vue__ = __webpack_require__("6GTl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_artists_EditArtist_vue__ = __webpack_require__("jukP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_artists_ViewArtworks_vue__ = __webpack_require__("eZui");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__("NHnr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedOwnership: '',
      showMore: false,
      ownerships: [],
      s_ownership: 1,
      show_add_artist_form: false,
      pagination2: {
        rowsPerPage: 15,
        sortBy: 'first_name'
      },
      artist: {
        name: '',
        first_name: '',
        last_name: ''
      },
      // sortingItems: [ 'name', 'first_name', 'last_name' ],
      alert: false,
      alert_message: '',
      alert_success: '',
      // color: "",
      mode: '',
      timeout: 10000,
      selected: [],
      filtered: [],
      artists: [],
      results: [],
      editArtist: false,
      new_artist: {},
      search: '',
      headers: [
      // { text: '', align: 'left', sortable: false },
      { text: 'First Name', value: 'first_name', align: 'left' }, { text: 'Last Name', value: 'last_name', align: 'left' }, { text: '', value: 'sort_name', align: 'center' }, { text: 'Name', value: 'name', align: 'left'
        // { text: 'Collective Name', value: 'collective', align: 'left' },
        // { text: 'Company', value: 'company', align: 'left' },
        // { text: 'Artworks', sortable: false }
      }]
    };
  },
  mounted: function mounted() {
    if (this.c_user.expand_artist_artworks) {
      for (var i = 0; i < this.filtered.length; i += 1) {
        var item = this.filtered[i];
        this.$set(this.$refs.dTable.expanded, item.id, true);
      }
    }
  },

  created: function created() {
    var _this = this;

    // this.getArtists()
    this.ownerships = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.getters.my_ownerships);
    this.ownerships.unshift({ id: 'all', name: 'All' });
    this.initialize();
    this.filtered = this.artists;
    __WEBPACK_IMPORTED_MODULE_5__main__["serverBus"].$on('setSorting', function (a) {
      // console.log('receive')
      // console.log(a)
      _this.pagination2.sortBy = a;
      _this.pagination2.descending = !_this.pagination2.descending;
    });
    this.toggleOwnership(this.$store.state.filters['artists'] ? this.$store.state.filters['artists'] : this.ownerships[0]);
  },
  methods: {
    toggleOwnership: function toggleOwnership(o) {
      var _this2 = this;

      // var array = [];
      // for (var i in ownerships) {
      //   // array.push(i);
      //   array.push(ownerships[i]);
      // }
      // console.log(array);
      // console.log(this.ownerships);
      // console.log(array.indexOf(this.s_ownership));
      // console.log(this.s_ownership);
      // console.log(this.ownerships.indexOf(this.s_ownership));
      this.selectedOwnership = o.name;
      this.$store.dispatch('setFilter', { section: 'artists', ownership: o });
      if (o.id != 'all') {
        this.filtered = this.artists.filter(function (a) {
          return _this2.$store.state.artworks.some(function (ar) {
            return ar.artist_id == a.id && ar.ownership == o.id;
          });
        });
      } else {
        this.filtered = this.artists;
      }
    },
    create_artist: function create_artist() {
      var _this3 = this;

      // if (this.$refs.form.validate()) {
      // console.log(this.artwork)
      var url = this.$globals.apiserver + '/artists.json';
      // console.log(url)
      this.artist.created_by = this.c_user.id;
      __WEBPACK_IMPORTED_MODULE_1__static_axios_js___default.a.post(url, this.artist).then(function (response) {
        // this.loading = false;
        // console.log(response.data)
        _this3.result = response.data;
        _this3.artist = response.data;
        _this3.$store.dispatch('addArtist', response.data);
        // this.artwork = response.data
        // this.artist = response.data.artist
        // this.e1 = 3
        // console.log(this.artwork)
        _this3.$router.push({
          name: 'EditArtist',
          // path: `/artists/edit/${this.artist.id}`,
          params: { id: _this3.artist.id, artist: _this3.artist }
        });
      }).catch(function (error) {
        // console.log(error)
      });
      // }
    },

    // create_artist () {},
    initialize: function initialize() {
      this.artists = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
      this.$store.dispatch('loadArtists');
    },
    duplicateArtwork: function duplicateArtwork(id) {
      var _this4 = this;

      var url = this.$globals.apiserver + '/artists/duplicate/' + id + '.json';
      __WEBPACK_IMPORTED_MODULE_1__static_axios_js___default.a.get(url).then(function (response) {
        // console.log(response.data);
        _this4.new_artist = response.data;
        // this.results.push(response.data)
        _this4.artists.push(response.data);
        _this4.$store.dispatch('addArtist', response.data);
        _this4.alert = true;
        _this4.alert_message = 'Creating duplicate successfull.';
        _this4.alert_success = 'success';
        _this4.artists = _this4.artists.sort(function (a, b) {
          return b.first_name - a.first_name;
        });
      }).catch(function (error) {
        // console.log(error)
        _this4.alert = true;
        _this4.alert_message = 'Creating duplicate failed.';
        _this4.alert_success = 'error';
      });
    },
    _toggle: function _toggle() {
      this.editArtist = true;
    },

    reverseMessage: function reverseMessage() {
      this.artist.name = this.artist.name.split('').reverse().join('');
    },
    getArtists: function getArtists() {
      this.results = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
      // console.log('test output getPosts')
      // let url = 'http://www.tb-cms.org/artists.json?artists=artists'
      // console.log(url)
      // axios.get(url).then((response) => {
      // this.loading = false;
      // this.results = response.data
      // }).catch((error) => { console.log(error) })
    },
    clear_selection: function clear_selection() {
      this.$store.dispatch('clearCurrentSelection');
      this.selected = [];
    },
    select_all: function select_all() {},
    save_currently_selected: function save_currently_selected(a, b) {
      // console.log('///////////')
      // console.log('a = ' + a)
      // console.log('b = ' + b.id)
      setTimeout(function () {
        var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
        //// console.log(temp_selection)
        if (!a) {
          // console.log('a true')
          if (!temp_selection.includes(b)) {
            // console.log('doesnt include')
            temp_selection.push(b);
          }
        } else {
          // console.log('false')
          var index = temp_selection.indexOf(b);
          // console.log('index = ' + index)
          temp_selection.splice(index, 1);
        }
        // this.$store.state.currentSelection
        // console.log(temp_selection)
        // this.selected.forEach(s => {
        //   if (!temp_selection.includes(s)) {
        //     temp_selection.push(s)
        //   }
        // })
        // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
        this.$store.dispatch('saveCurrentSelection', temp_selection);
      }.bind(this), 1000);
    },
    save_currently_selected_all: function save_currently_selected_all(a) {
      // console.log('///////////')
      // console.log('a = ' + a)
      var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(temp_selection)
      if (!a) {
        // console.log('a true')
        if (!temp_selection.includes(b)) {
          // console.log('doesnt include')
          temp_selection.push(b);
        }
      } else {
        // console.log('false')
        var index = temp_selection.indexOf(b);
        // console.log('index = ' + index)
        temp_selection.splice(index, 1);
      }
      // this.$store.state.currentSelection
      // console.log(temp_selection)
      // this.selected.forEach(s => {
      //   if (!temp_selection.includes(s)) {
      //     temp_selection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', temp_selection);
    },
    save_currently_selected_tags: function save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags);
      this.ta = this.tagged_artworks;
    }
  },
  computed: {
    // pagination2 () {
    //   var pagination2 = { rowsPerPage: 10, sortBy: "last_name" }
    //   return pagination2
    //   // get () {
    //   //   // console.log('sssssss')
    //   //   // console.log(this.$store.state.sorting['artists'])
    //   //   // console.log('artistsssss')
    //   //   // { rowsPerPage: 10, sortBy: 'last_name' }
    //   //   // return { rowsPerPage: 10, sortBy: (this.$store.state.sorting['artists'] ? this.$store.state.sorting['artists'] : 'last_name') }
    //   // },
    //   // set (value) {
    //   //   // this.$store.dispatch('setSorting', value)
    //   //   this.$store.dispatch('setSorting', { sorting: {column: this.sorting.sortBy, section: 'artists' }})

    //   // }
    // },
    add_new: {
      get: function get() {
        return this.$store.state.add_new;
      },
      set: function set(value) {
        this.$store.dispatch('addNew', value);
      }
    },
    processedArtists: function processedArtists() {
      var artists = this.results;
      this.artists.map(function (artist) {
        var a = artist;
        artist.first_name = a ? a.first_name : 'nema meno';
      });
      // console.log(artists)
      return artists;
    }
  },
  filters: {
    capitalize: function capitalize(a) {
      if (!a) return '';
      a = a.toString();
      return a.charAt(0).toUpperCase() + a.slice(1);
    }
  },
  components: {
    Artist: __WEBPACK_IMPORTED_MODULE_2__components_artists_Artist_vue__["a" /* default */],
    EditArtist: __WEBPACK_IMPORTED_MODULE_3__components_artists_EditArtist_vue__["a" /* default */],
    ViewArtworks: __WEBPACK_IMPORTED_MODULE_4__components_artists_ViewArtworks_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "HKJ0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeaderElements__ = __webpack_require__("oiZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ElementsTable__ = __webpack_require__("vCKh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EditFieldSub from './EditFieldSub'



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork', 'field'],
  data: function data() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
      reading_device: {
        name: ''
      },
      reading_devices: [],
      // categories: ['computer','micro_controller','film_projector','slide_projector', 'video_tape_recorder', 'linear_tape_drive','disc_tape_drive','dvd_player','media_player','other'],
      // fields: [
      // {
      //   'ctype': 'radio',
      //   'selection': [{id: 1, name: 'monitor'},{id:2, name:'projector'},{id:3, name:'motor'}, {id:4, name:'bulb'}, {id:5, name:'switch'}],
      //   'name': 'category',
      //   'title': 'Category',
      //   column: false,
      //   class: 'xs12',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   ctype: 'text-long',
      //   name: 'brand',
      //   title: 'Brand',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   ctype: 'text-long',
      //   name: 'type_and_model',
      //   title: 'Type and Model',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   ctype: 'date',
      //   name: 'production_date',
      //   title: 'Date of Production',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   name: 'headline_fields',
      //   headline: true,
      //   section: 'fields',
      //   title: 'Basic',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_rights: ['admin', 'manager']
      // },
      // {
      //   ctype: 'radio',
      //   name: 'computer',
      //   title: 'Computer',
      //   dynamic: true,
      //   section: 'fields',
      //   selection: [{id: 1, name:'Server'},{id: 2, name:'Laptop'},{id: 3, name:'Desktop'},{id: 4, name:'Virtual'},{id: 5, name:'Other'}],
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   ctype: 'radio',
      //   name: 'micro_controller',
      //   title: 'Micro Controller',
      //   dynamic: true,
      //   section: 'fields',
      //   selection: [{id: 1, name:'LCD'},{id: 2, name:'LED-LCD'},{id: 3, name:'Plasma'},{id: 4, name:'Other'}],
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   ctype: 'radio',
      //   name: 'film_projector',
      //   title: 'Film Projector',
      //   dynamic: true,
      //   section: 'fields',
      //   selection: [{id: 1, name:'8 mm'},{id: 2, name:'16mm'},{id: 3, name:'35mm'},{id: 4, name:'Other'}],
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   ctype: 'radio',
      //   name: 'slide_projector',
      //   title: 'Slide Projector',
      //   dynamic: true,
      //   section: 'fields',
      //   selection: [{id: 1, name:'Single projecting'},{id: 2, name:'Slate'},{id: 3, name:'Carousel'},{id: 4, name:'Other'}],
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   ctype: 'radio',
      //   name: 'video_tape_recorder',
      //   title: 'Video Tape Recorder',
      //   dynamic: true,
      //   section: 'fields',
      //   selection: ['Open Reel (1/2“)','Umatic','Betacam/SP','VHS','Digital Betacam','DV  (1/4“)','HDCAM','Other'],
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   ctype: 'bool',
      //   name: 'linear_tape_drive',
      //   title: 'Linear Tape Drive',
      //   dynamic: true,
      //   section: 'fields',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      //   {
      //     ctype: 'bool',
      //     name: 'floppy',
      //     title: 'Disc Tape Drive (Floppy)',
      //     dynamic: true,
      //     section: 'fields',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'bool',
      //     name: 'dvd_player',
      //     title: 'DVD Player',
      //     dynamic: true,
      //     section: 'fields',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'bool',
      //     name: 'media_player',
      //     title: 'Media player',
      //     dynamic: true,
      //     section: 'fields',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'other_player',
      //     title: 'Other',
      //     dynamic: true,
      //     section: 'fields',
      //     selection: ['Server','Laptop','Desktop','Virtual','Other'],
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     name: 'headline_brand',
      //     headline: true,
      //     section: 'brand',
      //     title: 'Details',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_rights: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'checkbox',
      //     name: 'interfaces',
      //     title: 'Interfaces',
      //     dynamic: true,
      //     section: 'brand',
      //     selection: ['composite','component','SVideo','SDI','VGA','HDMI','DVI','IDE','SATA','USB 2.0','USB 3.0','FireWire','Thunderbolt','XLR Audio','unknown','other'],
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'input_output',
      //     title: 'Input - Output',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-short',
      //     name: 'power-requirement',
      //     title: 'Power Requirement',
      //     dynamic: true,
      //     class: 'xs12 md6',
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'cooling_system',
      //     title: 'Cooling system',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-short',
      //     name: 'number_of_parts',
      //     title: 'Number of Parts',
      //     dynamic: true,
      //     section: 'brand',
      //     class: 'xs12 md6',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'specification_of_parts',
      //     title: 'Specification of parts',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'dimensions',
      //     title: 'Dimensions (cm) and weight',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'modification',
      //     title: 'Modification',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'installation_specification',
      //     title: 'Specifications on installation',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'peripherals',
      //     title: 'Peripherals',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'associated_items',
      //     title: 'Associated items',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   },
      //   {
      //     ctype: 'text-long',
      //     name: 'provided_spare_parts',
      //     title: 'Provided spare parts',
      //     dynamic: true,
      //     section: 'brand',
      //     work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //     user_groups: ['admin', 'manager']
      //   }
      // ],
      showUpload: false,
      show: false,
      showme: false
    }, 'reading_device', {
      category: '',
      monitor_specification: '',
      projector_specification: '',
      motor_specification: '',
      bulb_specification: '',
      switch: '',
      other: '',
      monitor_origin: '',
      projector_origin: '',
      motor_origin: '',
      bulb_origin: '',
      switch_origin: '',
      other_origin: '',
      interfaces: '',
      brand: '',
      sn: '',
      an: '',
      production_date: '',
      number_of_parts: '',
      power_requirement: '',
      height: '',
      width: '',
      depth: '',
      weight: '',
      specs: '',
      modification: '',
      periphals: '',
      associated_items: ''
    });
  },
  computed: {
    all_devices: function all_devices() {
      return this.$store.state.reading_devices;
      // console.log(todos)
      // return todos
    }
  },
  methods: {
    // show_field (f) {
    //   if (f.condition) {
    //     this.showme = true
    //     var a = f.condition
    //     // console.log(a)
    //     return eval(a)
    //   } else {
    //     return true
    //   }
    // return Function('"use strict";return (a)')()
    // },
    download: function download() {},

    // add () {
    //   this.reading_device.push(this.reading_device)
    //   this.showUpload=!this.showUpload
    // },
    delete_reading_device: function delete_reading_device() {},
    done_reading_device: function done_reading_device() {},
    save_reading_device: function save_reading_device() {
      this.reading_device.artwork_id = this.artwork.id;
      this.reading_device.done = false;
      this.reading_device.id = this.findMinMax(this.all_devices) + 1;
      this.$store.commit('ADD_READING_DEVICE', this.reading_device);
      // this.all_reading_device.push(this.reading_device)
      this.showUpload = !this.showUpload;
      this.reading_device = {
        description: '',
        title: '',
        deadline: '',
        done: false
        // var areading_device = Object.keys(this.reading_device).forEach(k => this.reading_device[k]='')
        // console.log(areading_device)
      };
    },
    findMinMax: function findMinMax(arr) {
      if (arr === undefined || arr.length === 0) {
        return 1;
      } else {
        var max = arr[0].id;
        for (var i = 1, len = arr.length; i < len; i++) {
          var v = arr[i].id;
          max = v > max ? v : max;
        }
        // console.log(max)
        return max;
      }
    }
  },
  components: { HeaderElements: __WEBPACK_IMPORTED_MODULE_1__HeaderElements__["a" /* default */], ElementsTable: __WEBPACK_IMPORTED_MODULE_2__ElementsTable__["a" /* default */] }
});

/***/ }),

/***/ "HexB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__("NHnr");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import ListRelated from "./ListRelated";
// import ListActionMenu from "../artworks/ListActionMenu";

// import IndexTable from '@/components/todos/IndexTable'
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      userFilter: null,
      selectedUser: {},
      selectedUsers: [],
      visibility: 'active',
      active_todos: [],
      itemToDelete: {},
      deleteDialog: false,
      // todo_store: [],
      myTodos: false,
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'created_at'
      },
      pagination_related: {
        descending: true,
        // rowsPerPage: 10,
        sortBy: 'title'
      },
      search: '',
      search_related: '',
      selected: [],
      selected_related: [],
      headers: [{ text: 'Todo', value: 'title' }, { text: 'Artwork Title', value: 'artwork.title', align: 'left' }, {
        text: 'Accession No.',
        value: 'artwork.accession_number',
        align: 'left'
      }, { text: 'Date Created', value: 'created_at', align: 'center' }, { text: 'Created By', value: 'created_by', align: 'center' }, { text: '', align: 'right' }],
      headers_related: [{ text: 'Artwork Title', sortable: true, value: 'title' }, { text: 'Accession Number', value: 'accession_number', align: 'right' }],
      table_lists: this.$store.state.lists,
      loading: false,
      displayedData: [],
      filteredTextArtwork: '',
      filteredTextArtist: '',
      selectedFilter: '',
      artwork: {
        name: ''
      },
      artists: [],
      artworks: [],
      resultsArtworks: [],
      resultsArtists: [],
      editArtwork: false,
      filterText: ''
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_5__main__["serverBus"].$on('setSorting', function (a) {
      _this.pagination.sortBy = a;
      _this.pagination.descending = !_this.pagination.descending;
    });
    this.$store.dispatch('loadTodos');
    // this.todo_store = this.$store.state.lists
  },
  methods: {
    toggleUser: function toggleUser(u) {
      this.userFilter = u;
      if (!this.selectedUsers.includes(u)) {
        this.selectedUsers.push(u);
      }
    },
    delete_todo: function delete_todo(todo) {
      var _this2 = this;

      var url = this.$globals.apiserver + '/artwork_todos/' + todo.id + '.json';
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url, todo).then(function (response) {
        _this2.errors = {};
        var index = _this2.todos.indexOf(todo);
        if (index >= 0) _this2.todos.splice(index, 1);
        // this.artwork.artwork_todos.push(response.data);
        // this.artwork.artwork_todos = [
        //   ...this.artwork.artwork_todos.map(item =>
        //     item.id !== this.todo.id ? item : { ...item, ...this.todo }
        //   )
        // ];
        // console.log(this.artwork.artwork_todos);
        // this.todos = this.artwork.artwork_todos;
        // this.all_todos = Object.assign([],this.artwork.artwork_todos)
        // this.active_todos.push(response.data);
        // this.todos.push(response.data);
        // this.editing = false;
        _this2.$store.dispatch('updateArtwork', todo.artwork_id);
        _this2.$store.dispatch('loadTodos');
        _this2.$store.dispatch('loadArtworks');
        // this.artwork = this.$store.state.artworks.find(
        //   a => (a.id = this.artwork.id)
        // );
      }).catch(function (error) {
        _this2.errors = error.response.data;
      });
    },
    done_todo: function done_todo(tt) {
      var _this3 = this;

      this.$emit('showSnackbar', 'Toggling Todo.', 'black');
      // const todoIndex = this.todos.indexOf(t);
      // console.log(tt)
      var t = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, tt);
      if (t.done == 0 || t.done == '') {
        t.done = 1;
        t.done_at = this.format_date(Date.now());
      } else {
        t.done = 0;
        t.done_at = null;
      }
      var url = this.$globals.apiserver + '/artwork_todos/' + t.id + '.json';
      // this.$store.dispatch('toggleTodo', t)
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, {
        todo: { done: t.done, done_at: t.done_at }
      }).then(function (response) {
        _this3.$emit('showSnackbar', 'Todo saved.', 'green');
        // console.log('after axios')
        _this3.$store.dispatch('loadTodos');
        _this3.errors = {};
        // this.artwork.artwork_todos.push(response.data);
        // this.todos = [
        //   ...this.todos.map(item =>
        //     item.id !== this.todo.id ? item : { ...item, ...this.todo }
        //   )
        // ];
        // console.log(this.artwork.artwork_todos);
        // this.todos = this.artwork.artwork_todos;
        // this.all_todos = Object.assign([],this.artwork.artwork_todos)
        // this.active_todos.push(response.data);
        // this.todos.push(response.data);
        _this3.editing = false;
        // this.$store.dispatch("updateArtwork", this.artwork.id);
        // this.artwork = this.$store.state.artworks.find(
        //   a => (a.id = this.artwork.id)
        // );
      }).catch(function (error) {
        _this3.errors = error.response.data;
      });
      // this.editing = false;
    },
    goToList: function goToList() {
      this.$router.push({
        name: 'Lists',
        params: { loadCurrent: '1' }
      });
    },
    loadTodo: function loadTodo(e) {
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      this.$store.dispatch('saveCurrentTodo', e);
      // } else {
      //   // console.log('no add')
      //   this.$store.dispatch('addToCurrentTodo',e)
      // }
    },
    addToTodo: function addToTodo(e) {
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      // this.$store.dispatch('saveCurrentTodo',e)
      // } else {
      //   // console.log('no add')
      this.$store.dispatch('addToCurrentTodo', e);
      // }
    },
    showDeleteDialog: function showDeleteDialog(p) {
      this.itemToDelete = p;
      this.deleteDialog = true;
    },
    deleteItem: function deleteItem() {
      var index = this.todos.indexOf(this.itemToDelete);
      var i = this.todos.indexOf(this.itemToDelete);
      // if (i != -1) {
      //   this.todos.splice(i, 1);
      // }
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      this.$store.dispatch('deleteTodo', this.itemToDelete);
      this.itemToDelete = null;
      this.deleteDialog = false;
    },
    cancelDelete: function cancelDelete() {
      this.deleteDialog = false;
      this.itemToDelete = null;
    },
    remove_from_todo: function remove_from_todo(list_id, artwork_id) {
      var list = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.$store.state.lists.find(function (list) {
        return list.id == list_id;
      }));
      list.artworks = list.artworks.filter(function (a) {
        return a != artwork_id;
      });
      this.$store.dispatch('removeArtworkFromList', {
        l: list_id,
        a: artwork_id
      });
    },
    table_artworks: function table_artworks(as) {
      return this.$store.state.artworks.filter(function (a) {
        return as.includes(a.id);
      });
    }
  },
  computed: {
    assignedUsers: function assignedUsers() {
      var out = this.todos.map(function (t) {
        return t.users.length > 0 ? t.users.map(function (u) {
          return u.id;
        }) : null;
      }).filter(function (o) {
        return o != null;
      }).flat();
      var unique = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(out)));
      var out2 = this.$store.state.users.filter(function (u) {
        return unique.includes(u.id);
      });
      return out2;
    },

    filteredTodos: function filteredTodos() {
      var _this4 = this;

      var afterStatusFilter = [];
      if (this.visibility == 'all') {
        afterStatusFilter = this.todos;
      } else if (this.visibility == 'active') {
        afterStatusFilter = this.todos.filter(function (t) {
          return t.done != 1;
        });
      } else if (this.visibility == 'completed') {
        afterStatusFilter = this.todos.filter(function (t) {
          return t.done == 1;
        });
      }
      if (this.userFilter) {
        return afterStatusFilter.filter(function (t) {
          return (
            // t.created_by == this.userFilter ||
            t.users && t.users.map(function (u) {
              return u.id;
            }).includes(_this4.userFilter)
          );
        });
      } else {
        return afterStatusFilter;
      }
    },
    todos: function todos() {
      var _this5 = this;

      // this.c_user.id
      var a = [];
      if (this.myTodos) {
        // return this.todo_store.filter(j => j.created_by === this.c_user.id)
        a = this.$store.getters.user_todos;
      } else {
        a = this.$store.state.todos;
      }
      // Results.map(obj=> ({ ...obj, Active: 'false' }))

      return a.map(function (aa) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, aa, {
          artwork: _this5.$store.state.artworks.find(function (aaa) {
            return aaa.id == aa.artwork_id;
          })
        });
      });
    },

    // table_lists () {
    // return this.todo_store
    // return this.$store.state.lists
    // },
    filtered: function filtered() {
      return this.$store.state.filterResults;
    },
    title: function title() {
      var title = '';
      // if (this.$route.fullPath == "/artworks/oldMasters") {
      //   title = "Old Masters";
      // } else
      if (this.$route.fullPath == '/artworks/deaccession') {
        title = 'Deaccessioned';
      } else if (this.$route.fullPath == '/artworks/collection') {
        title = 'TBA21 Collection';
      } else if (this.$route.fullPath == '/artworks/pacFvh') {
        title = 'Private Art Collection FTB';
      } else if (this.$route.fullPath == '/artworks/pdcFvh') {
        title = 'Private Design Collection FTB';
      } else if (this.$route.fullPath == '/artworks/pdcFvh') {
        title = 'Private Collection FT';
      } else if (this.$route.fullPath == '/artworks/pcFT') {
        title = 'Private Art Collection MR';
      }
      return title;
    },
    columns: function columns() {
      return this.$store.state.artworkColumns;
    },
    processedArtists: function processedArtists() {
      var artists = this.resultsArtists;
      this.artists.map(function (artist) {
        var a = artist;
        artist.first_name = a ? a.first_name : 'nema meno';
      });
      return artists;
    },
    storedData: function storedData() {
      var sdata = '';
      if (this.$store.state.filterResults) {
        sdata = this.$store.state.filterResults;
      } else {
        sdata = this.filteredData;
        // console.log(sdata)
        this.$store.dispatch('postFilterResults', sdata);
      }
      this.displayedData = sdata;
      return sdata;
    },
    filteredData: function filteredData() {
      var searchString = this.filteredTextArtwork;

      if (this.filteredTextArtwork != '') {
        // vráť z "this.processedArtists" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "this.processedArtists"
        return this.processedArtists.filter(function (artist) {
          // vráť z "artist.artworks" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "artist.artworks" v premennej "q"
          return artist.artworks.filter(function (artwork) {
            // vráť (čítať odzadu) true - ak "title" atribút obsahuje "search" string
            return artwork.title.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
          }).length > 0;
        });
      } else {
        return this.processedArtists;
      }
    },

    filteredArtworks: function filteredArtworks() {
      var self = this;
      // console.log(self)
      // return self.artworks.filter(function (artwork) {
      //   return artwork.ownership.indexOf(self.searchQuery) == -1
      // })
      // var self = this
      self.artworks.filter(function (artwork) {
        // console.log(artwork)
        var searchRegex = new RegExp(4, 'i');
        // console.log(searchRegex)
        return searchRegex.test(artwork.ownership);
      });
    }

    // processedArtworks () {
    //   let artworks = this.resultsArtworks
    //   this.artworks.map(artwork => {
    //     let a = artwork
    //     artwork.first_name = a ? a.first_name : 'nema meno'
    //   })
    //   return artworks
    // },
    // filteredArtworks () {
    //   return this.artworks
    //     .filter(this.artworkPassesOwnershipFilter)
    // },

    // return this.processedArtists.filter(function(obj) {
    //   return obj.artworks.title(function(item){
    //     return item.indexOf('a') >= 0;
    //   });
    // });
    // function getResult(filterBy, objList) {
    //   return objList.hightlights.filter(function(obj) {
    //   return obj.queries.some(function(item){
    //     return item.indexOf(filterBy) >= 0;
    //   });
    // });
    // }
    //   const x = 'title',
    //     filter = new RegExp(this.filteredText, 'i')
    //   return this.processedArtists.filter(el => {
    //     if (el[x] !== undefined) { return el[x].match(filter) }
    //     else return true;
    //   })
    // }
  }
  // filters: {
  //   capitalize: function (a) {
  //     if (!a) return ''
  //     a = a.toString()
  //     return a.charAt(0).toUpperCase() + a.slice(1)
  //   }
  // },
  // components: {
  //   ListRelated,
  //   ListActionMenu,
  // },
});

/***/ }),

/***/ "HlYC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AddNew',
  data: function data() {
    return {
      save_tag_form_display: false,
      save_tag_category_form_display: false,
      add_new_dialog: false,
      tag_title: '',
      tag_category_id: '',
      tag_category_name: '',
      // all_categories: [],
      category: "concept",
      subcategory: ""
    };
  },
  methods: {
    show_save_tag_form: function show_save_tag_form() {
      this.save_tag_form_display = !this.save_tag_form_display;
    },
    show_save_tag_category_form: function show_save_tag_category_form() {
      this.save_tag_category_form_display = !this.save_tag_category_form_display;
    },
    create_tag: function create_tag() {
      var _this = this;

      var url = this.$globals.apiserver + '/tags.json';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, {
        tag: {
          name: this.tag_title,
          category: this.category,
          section: this.category,
          subcategory: this.subcategory,
          tag_category_id: "",
          created_by: this.$store.state.user_id
        }
      }).then(function (response) {
        _this.$store.dispatch('loadTags');
        _this.save_tag_form_display = false;
        _this.tag_title = '';
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  computed: {
    all_categories: function all_categories() {
      if (this.category === "concept") {
        // return this.categories.filter(category => category.type === "concept");
        return this.$store.getters.conceptual_tag_categories.map(function (t) {
          return t.subcategory;
        });
      } else if (this.category === "cataloguing") {
        return this.$store.getters.cataloguing_tag_subcategories.map(function (a) {
          return a.subcategory;
        }).sort();
        // return this.categories.filter(category => category.type === "cataloguing");
      } else if (this.category === "private") {
        return ["private"];
        // return this.categories.filter(category => category.type === "private");
      }
    },
    categories: function categories() {
      return this.$store.state.conceptual_tag_categories;
    },
    subcategories: function subcategories() {
      return this.$store.state.tag_subcategories;
    }
  }
});

/***/ }),

/***/ "HneA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HuDx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      multi_artists: [],
      collective_name: '',
      artists: this.$store.state.artists
    };
  },
  methods: {
    ids2o: function ids2o(array) {
      if (array.length > 0) {
        var objs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
        var out = objs.filter(function (a) {
          return array.includes(a.id);
        });
        return out;
      }
    }
  }
});

/***/ }),

/***/ "IQoj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
/* harmony default export */ __webpack_exports__["a"] = ({
  // mixins: [ CommonMixin ],
  created: function created() {
    this.selectedSorting = 'created_at';
    this.getJournals();
    // this.journals_store = this.$store.state.journals.filter(
    //   j => j.journaled_id == this.artwork.id
    // );
  },

  props: ['artwork'],
  data: function data() {
    return {
      selectedSorting: 'created_at',
      restore_dialog: false,
      journal_to_restore: '',
      version_to_restore: '',
      view: '',
      oldNew: '',
      view_dialog: false,
      journals_store: [],
      selected: [],
      search: '',
      menu_storage_out: false,
      menu_storage_in: false,
      dialog: false,
      deleteDialog: false,
      itemToDelete: null,
      dialog2: false,
      headers: [{ text: 'Date', align: 'left', sortable: true, value: 'created_at' }, {
        text: 'CMS',
        align: 'left',
        sortable: true,
        value: 'cms'
      }, {
        text: 'Changed by',
        align: 'left',
        value: 'created_by',
        sortable: true
      }, { text: 'Field', align: 'left ', sortable: true, value: 'value_name' }, {
        text: 'Old value',
        align: 'left',
        value: 'old_value',
        sortable: true
      }, {
        text: 'New value',
        align: 'left',
        value: 'new_value',
        sortable: true
        // { text: "Actions", align: "right", sortable: false, align: "center" }
      }],
      editedIndex: -1,
      show: false,
      showUpload: false,
      p: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'created_at'
      }
    };
  },
  computed: {
    selections: function selections() {
      var _this = this;

      return this.$store.state.lists.filter(function (s) {
        return s.artworks.includes(_this.artwork.id);
      });
    },

    // visa_status () {
    //   this.constants.VISA_STATUSES.find(this.artwork.visa_status)
    // },
    all_packings: function all_packings() {
      return this.$store.state.packings;
      // console.log(todos)
      // return todos
    }
  },
  methods: {
    changeSort: function changeSort(column) {
      this.selectedSorting = column;
      if (this.p.sortBy === column) {
        this.p.descending = !this.p.descending;
      } else {
        this.p.sortBy = column;
        this.p.descending = false;
      }
    },
    copy2c: function copy2c(t) {
      navigator.clipboard.writeText(t).then(function () {
        // console.log('Async: Copying to clipboard was successful!');
      }, function (err) {
        console.error('Async: Could not copy text: ', err);
      });
    },
    getJournals: function getJournals() {
      var _this2 = this;

      setTimeout(function () {
        var url = _this2.$globals.apiserver + '/journals/index_artwork/' + _this2.artwork.id + '.json';
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(url).then(function (response) {
          _this2.journals_store = response.data;
          _this2.progress = false;
        }).catch(function (error) {
          // console.log(error)
        });
      }, 1000);
    },
    viewText: function viewText(text, oldNew) {
      this.view = text;
      this.oldNew = oldNew;
      this.view_dialog = true;
    },
    restoreValue: function restoreValue(journal, version) {
      this.journal_to_restore = journal;
      this.version_to_restore = version;
      this.restore_dialog = true;
    },
    format_journal_artwork: function format_journal_artwork(j) {
      var a = this.$store.state.artworks.find(function (a) {
        return a.id == j.journaled_id;
      });
      // var u = this.$store.state.users.find(u => u.id == j.user_id)
      // console.log(a)
      if (a) {
        return j.class_name + ':<b> ' + a.title + '</b>, ' + a.full_name;
      } else {
        return '';
      }
    },
    format_journal_journal: function format_journal_journal(j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      // var u = this.$store.state.users.find(u => u.id == j.user_id)
      return '"' + j.value_name + '" changed from "' + j.old_value + '" to "' + j.new_value;
    },
    format_journal_user: function format_journal_user(j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      if (j.user_id) {
        var u = this.$store.state.users.find(function (u) {
          return u.id == j.user_id;
        });
        return u.firstname + ' ' + u.lastname;
      } else {
        return 'unknown';
      }
    },
    format_date: function format_date(date) {
      var moment = __webpack_require__("PJh5");
      var ndate = new Date(date);
      return moment(ndate).format('YYYY-MM-DD hh:mm');
    },
    newItem: function newItem() {
      this.dialog = true;
      this.packing = {
        packing: '',
        height: '',
        lenght: '',
        width: '',
        weight: '',
        contents: '',
        colli: '',
        visa_status: '',
        artwork_id: '',
        artwork_location_id: ''
      };
    },
    editItem: function editItem(i) {
      this.packing = {
        packing: '',
        height: '',
        lenght: '',
        width: '',
        weight: '',
        contents: '',
        colli: '',
        visa_status: '',
        artwork_id: '',
        artwork_location_id: ''
      };
      this.saving = false;
      this.editing = true;
      this.dialog = true;
      try {
        this.packing = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.artwork.artwork_packings.find(function (t) {
          return t.id == i.id;
        }));
      } catch (error) {
        // console.log(error.message)
      }
    },
    saveField: function saveField() {
      var _this3 = this;

      setTimeout(function () {
        var url = _this3.$globals.apiserver + '/artworks/' + _this3.artwork.id + '.json';
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, {
          field_name: 'transport_history',
          field_value: _this3.artwork.transport_history
        }).then(function (response) {
          _this3.progress = false;
        }).catch(function (error) {
          // console.log(error)
        });
      }, 1000);
    },
    close: function close() {
      this.dialog = false;
    },

    // initialize () {},
    showDeleteDialog: function showDeleteDialog(p) {
      this.itemToDelete = p;
      this.deleteDialog = true;
    },
    deleteItem: function deleteItem() {
      // const index = this.artwork.artwork_packings.indexOf(this.itemToDelete)
      var i = this.artwork.artwork_packings.indexOf(this.itemToDelete);
      if (i != -1) {
        this.artwork.artwork_packings.splice(i, 1);
      }
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      this.$store.dispatch('deletePacking', this.itemToDelete);
      this.itemToDelete = null;
      this.deleteDialog = false;
    },
    cancelDelete: function cancelDelete() {
      this.deleteDialog = false;
      this.itemToDelete = null;
    },

    // delete_packing () {},
    get_visa_status: function get_visa_status(packing) {
      var vss = constants.VISA_STATUSES.filter(function (vs) {
        return vs.id === packing.visa_status;
      });
      if (vss[0] != undefined) {
        // console.log(vss[0].id)
        return vss[0].id > 0 ? vss[0].name : '';
      } else {
        return '';
      }
    },

    // get_location_name (packing) {
    //   var l = this.$store.state.locations.find(
    //     l => l.id === packing.artwork_location_id
    //   )
    //   return l ? l.name : ''
    // },
    duplicateItem: function duplicateItem(p) {
      var _this4 = this;

      // console.log(p)
      var packing = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, p);
      delete packing.id;
      // console.log(this.packing)
      packing.artwork_id = this.artwork.id;
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      // this.packing.reject { |k,v| k == :id }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$globals.apiserver + '/artwork_packings.json', {
        packing: packing
      }).then(function (response) {
        _this4.errors = {};
        _this4.artwork.artwork_packings.push(response.data);
        _this4.$store.commit('ADD_PACKING', response.data);
      }).catch(function (error) {
        _this4.errors = error.response.data;
      });
      // console.log(this.packing)
      // this.all_packings.push(this.packing)
      this.showUpload = !this.showUpload;
      this.dialog = false;
      this.packing = {
        packing: '',
        height: '',
        width: '',
        lenght: '',
        weight: '',
        contents: '',
        note: '',
        visa_status: 0,
        colli: '',
        artwork_location_id: ''
      };
    },
    save: function save() {
      var _this5 = this;

      this.saving = true;
      this.packing.artwork_id = this.artwork.id;
      // this.packing.id = this.findMinMax(this.all_packings)+1
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      // this.artwork.artwork_packings.push(this.packing)
      if (this.editing) {
        var url = this.$globals.apiserver + '/artwork_packings/' + this.packing.id + '.json';
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, {
          packing: this.packing
        }).then(function (response) {
          _this5.errors = {};
          _this5.artwork.artwork_packings = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this5.artwork.artwork_packings.map(function (item) {
            return item.id !== response.data.id ? item : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, response.data);
          })));
          _this5.$store.commit('SAVE_PACKING', response.data);
          _this5.dialog = false;
          _this5.packing = {
            packing: '',
            height: '',
            width: '',
            lenght: '',
            weight: '',
            contents: '',
            note: '',
            visa_status: 0,
            colli: '',
            artwork_location_id: ''
          };
          _this5.saving = false;
          _this5.editing = false;
        }).catch(function (error) {
          // console.log(error)
          _this5.save_error = true;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$globals.apiserver + '/artwork_packings.json', {
          packing: this.packing
        }).then(function (response) {
          _this5.errors = {};
          _this5.artwork.artwork_packings.push(response.data);
          _this5.$store.commit('ADD_PACKING', response.data);
        }).catch(function (error) {
          _this5.errors = error.response.data;
        });
        // console.log(this.packing)
        // this.all_packings.push(this.packing)
        this.dialog = false;
        this.packing = {
          packing: '',
          height: '',
          width: '',
          lenght: '',
          weight: '',
          contents: '',
          note: '',
          visa_status: 0,
          colli: '',
          artwork_location_id: ''
        };
      }
    },
    update_multiple: function update_multiple() {
      var _this6 = this;

      this.updated_packing.artwork_id = this.artwork.id;
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(this.$globals.apiserver + '/artwork_packings/update_multiple.json', {
        updated_packing: this.updated_packing,
        selected: this.selected
      }).then(function (response) {
        _this6.errors = {};
        _this6.artwork.artwork_packings = [];
        _this6.artwork.artwork_packings.push(response.data);
        // this.$store.commit('REPLACE_PACKING', response.data)
      }).catch(function (error) {
        _this6.errors = error.response.data;
      });
      this.dialog2 = !this.dialog2;
      // this.dialog = false
      this.updated_packing = {
        packing: '',
        height: '',
        width: '',
        length: '',
        weigth: '',
        contents: '',
        note: '',
        visa_status: 0
      };
    }
  }
});

/***/ }),

/***/ "IWvq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_querystring__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['user'],
  data: function data() {
    return {
      constants: __WEBPACK_IMPORTED_MODULE_6__data_constants__["a" /* default */],
      dialogJpg: '',
      dialogImage: false,
      roles_array: [],
      search: '',
      headers: [{ text: 'Date', align: 'left', sortable: true, value: 'created_at' }, {
        text: 'CMS',
        align: 'left',
        sortable: true,
        value: 'cms'
      }, {
        text: 'Changed by',
        align: 'left',
        value: 'created_by',
        sortable: true
      }, { text: 'Field', align: 'left ', sortable: true, value: 'value_name' }, {
        text: 'Old value',
        align: 'left',
        value: 'old_value',
        sortable: true
      }, {
        text: 'New value',
        align: 'left',
        value: 'new_value',
        sortable: true
      }],
      p: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'created_at'
      },
      show3: true,
      journals: [],
      roles: [],
      snackbar: false,
      loading: false,
      snackbar_text: '',
      snackbar_color: 'black',
      selected: [],
      options: false,
      userFormData: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.user),
      editUser: false,
      result: '',
      currentTab: 'basic',
      valid: true
    };
  },

  // watch: {
  //   userFormData: {
  //     handler: 'save',
  //     immediate: false,
  //     deep: true
  //     // console.log('new: %s, old: %s', val, oldVal)
  //   },
  // },
  beforeMount: function beforeMount() {
    this.getUser();
    // console.log('this.$route.params')
    // console.log(this.$route.params)
    if (this.$route.params.user) {
      this.userFormData = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.$route.params.user);
      // console.log(this.$route.params.user)
    } else {}
      // this.result = this.c_user;
      // this.userFormData = this.c_user;
      // this.user = this.c_user
      // console.log('this.user')
      // console.log(this.user)

      // setTimeout(function () {
      // }.bind(this),4000)
      // this.userFormData = Object.assign({},this.result)
    this.setCurrentTab('Details');
    // this.df2 = Object.assign([],this.df)
    this.$store.dispatch('loadRoles');
  },
  mounted: function mounted() {
    // this.df2 = Object.assign([],this.df)
    this.initialize();
    // this.$store.dispatch("loadJournals");
    // if (!this.user) {
    //   this.userFormData = this.c_user;
    // }
  },

  // mounted() {
  // this.df2 = Object.assign([],this.df)
  // },
  methods: {
    setAllCollections: function setAllCollections() {
      var _this = this;

      // console.log('setAllCollections')
      this.formatted_roles.filter(function (fr) {
        return [1, 17, 18, 19, 20, 21, 22, 31, 32, 40, 41, 43, 46].includes(fr.id);
      }).forEach(function (r) {
        // console.log(r)
        _this.roles_array.push(r.id);
        !_this.roles_array.includes(r.id) ? _this.userFormData.roles.push({ id: r.id, shortcut: r.shortcut }) : {};
      });
    },
    showHelp: function showHelp(jpg) {
      this.dialogJpg = jpg;
      this.dialogImage = !this.dialogImage;
    },
    save: function save() {
      var _this2 = this;

      this.loading = true;
      // this.after_login_page = this.userFormData.after_login_page;
      // if (this.$refs.form.validate()) {
      // console.log(this.roles_array)
      var url = this.$globals.apiserver + '/users/' + this.userFormData.id + '.json';
      // this.artistLink.artist_id = this.artistFormData.id
      if (this.userFormData.password == '') {
        delete this.userFormData.pw_clear;
        delete this.userFormData.password;
      } else {
        this.userFormData.pw_clear = this.userFormData.password;
      }
      // this.userFormData.role_ids = this.userFormData.roles.map(r => r.id)
      this.userFormData.roles = this.roles_array;
      this.userFormData.role_ids = this.roles_array;
      // console.log(this.userFormData);
      delete this.userFormData.domains;
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, {
        user: this.userFormData
      }).then(function (response) {
        _this2.snackbar_color = 'green';
        _this2.snackbar_text = 'User data saved.';
        _this2.$store.dispatch('loadUsers');
        _this2.snackbar = true;
        // this.$store.dispatch("setCurrentUser", response.data);
        // this.$store.dispatch("updateUser", response.data);
        _this2.$store.dispatch('replaceObject', {
          item: { item: response.data, table: 'users' }
        });
        // this.userFormData = response.data
        _this2.loading = false;
      }).catch(function (error) {
        _this2.loading = false;
        _this2.snackbar = true;
        _this2.snackbar_color = 'red';
        _this2.snackbar_text = 'Data not saved, please test your internet connection or contact developer.';
        // console.log(error)
      });
    },
    remove_role: function remove_role(item) {
      // console.log(item);
      var index = this.userFormData.roles.indexOf(item);
      if (index >= 0) this.userFormData.roles.splice(index, 1);
    },
    initialize: function initialize() {
      // console.log(this.userFormData)
      this.roles_array = this.userFormData.roles.map(function (r) {
        return r.id;
      });
      this.roles = this.$store.state.roles;
      // this.journals = this.$store.state.journals;
      this.getJournals();
    },
    remove_id: function remove_id(item) {
      // console.log(item)
      // console.log(this.userFormData.roles)
      var index = this.userFormData.roles.findIndex(function (r) {
        return r.id === item;
      });
      // console.log(index)
      if (index >= 0) this.userFormData.roles.splice(index, 1);
    },
    remove: function remove(item) {
      // console.log(item)
      // console.log(this.userFormData.roles)
      // console.log(this.formatted_roles)
      var index = this.userFormData.roles.findIndex(function (r) {
        return r.id === item;
      });
      // console.log(index)
      if (index >= 0) this.userFormData.roles.splice(index, 1);
      if (item == 2) {
        this.setAllCollections();
      }
    },
    format_date: function format_date(date) {
      var moment = __webpack_require__("PJh5");
      var ndate = new Date(date);
      return moment(ndate).format('YYYY-MM-DD hh:mm');
    },
    format_journal_artwork: function format_journal_artwork(j) {
      var a = this.$store.state.artworks.find(function (a) {
        return a.id == j.journaled_id;
      });
      // var u = this.$store.state.users.find(u => u.id == j.user_id)
      // console.log(a);
      if (a) {
        return j.class_name + ': <br />' + a.title + ' [' + a.full_name + ']';
      } else {
        return '';
      }
    },
    format_journal_journal: function format_journal_journal(j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      // var u = this.$store.state.users.find(u => u.id == j.user_id)
      return '"' + j.value_name + '" changed from "' + j.old_value + '" to "' + j.new_value;
    },
    format_journal_user: function format_journal_user(j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      if (j.user_id) {
        var u = this.$store.state.users.find(function (u) {
          return u.id == j.user_id;
        });
        return u.firstname + ' ' + u.lastname;
      } else {
        return 'unknown';
      }
    },
    getJournals: function getJournals() {
      var _this3 = this;

      setTimeout(function () {
        var url = _this3.$globals.apiserver + '/journals/index_user/' + _this3.userFormData.id + '.json';
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url).then(function (response) {
          _this3.journals = response.data;
          // this.progress = false;
        }).catch(function (error) {
          // console.log(error)
        });
      }, 1000);
    },

    // loadRoles() {
    //   this.roles = Object.assign([],this.$store.state.roles)
    //   return this.roles
    // },
    formatDate: function formatDate(date) {
      date = new Date(date);
      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      var day = date.getDate();
      var monthIndex = date.getMonth();
      var year = date.getFullYear();

      return day + ' ' + monthNames[monthIndex] + ' ' + year;
    },
    addToSelection: function addToSelection(a) {
      // console.log('a = ' + a)
      // setTimeout(function () {
      var tempSelection = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(tempSelection)
      // if (!a) {
      // console.log('a true')
      if (!tempSelection.includes(a)) {
        // console.log('doesnt include')
        tempSelection.push(a);
      }
      // } else {
      // console.log('false')
      // var index = tempSelection.indexOf(a);
      // console.log('index = ' + index)
      // tempSelection.splice(index,1)
      // }
      // this.$store.state.currentSelection
      // console.log(tempSelection)
      // this.selected.forEach(s => {
      //   if (!tempSelection.includes(s)) {
      //     tempSelection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', tempSelection);
      // }.bind(this),1000)
    },
    setCurrentTab: function setCurrentTab(tab) {
      // console.log(tab)
      // console.log(this.fields.tabs['basic'])
      // console.log(this.field_list)
      // this.currentFields = this.fields.tabs[tab].fields
      // console.log(this.fields.tabs)
      // if (!this.currentFields) {
      //   this.currentFields = this.fields.tabs[tab]
      // }
      // console.log(this.currentFields)
      // this.saveCurrentTab (tab)
      this.currentTab = tab;
    },

    // saveCurrentTab (tab) {
    //   // setTimeout(function () {
    //     this.$store.dispatch("saveCurrentTab", tab)
    //   // }.bind(this),1000)
    // },
    getUser: function getUser() {
      var _this4 = this;

      var url = this.$globals.apiserver + '/users/' + this.$route.params.id + '.json';
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url).then(function (response) {
        // this.loading = false;
        _this4.result = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, response.data);
        _this4.userFormData = response.data;
      }).catch(function (error) {
        // console.log(error)
      });
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    submit: function submit() {
      var art = this.userFormData;
      var requestConfig = {
        url: this.$globals.apiserver + '/users/api_update/' + this.$route.params.id,
        method: 'POST',
        data: __WEBPACK_IMPORTED_MODULE_7_querystring__["stringify"](art)
      };
      var response = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.request(requestConfig);
    }
  },
  computed: {
    links: function links() {
      var o = this.constants.OWNERSHIPS;
      var out = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(o).map(function (e) {
        return o[e].name;
      }).concat(['Artists', 'Contacts']);
      out.push('Lists');
      return out;
    },

    // c_user () {
    //   return this.$store.state.user.profile
    // },
    user_journal: function user_journal() {
      var _this5 = this;

      var js = this.journals.filter(function (j) {
        return j.user_id == _this5.userFormData.id;
      });
      return js;
    },
    formatted_roles: function formatted_roles() {
      var rs = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.roles);
      var newrs = [];
      rs.sort(function (a, b) {
        return a.group < b.group;
      });
      // console.log(rs)
      var group = '';

      rs.forEach(function (val) {
        if (group != val.group) {
          // newrs.push({ divider: true });
          newrs.push({ header: val.group, image: val.image });
        }
        newrs.push(val);
        group = val.group;
      });
      // console.log(newrs);
      return newrs;
    },
    domains_to_string: function domains_to_string() {
      if (this.result.domains) {
        return this.result.domains.replace(/ /g, '<br />');
      }
    },

    options_c: {
      get: function get() {
        return this.$store.state.options;
      },
      set: function set(value) {
        this.$store.dispatch('saveOptions', value);
      }
    },
    // currentTabShown () {
    //   console.log('currentTabShown')
    //   console.log(this.currentTab)
    //   console.log(fields.tabs[this.currentTab])
    //   return fields.tabs[this.currentTab]
    // },
    processedUser: function processedUser() {
      // console.log('processedUser')
      var artwork = this.result;
      if (artwork && artwork.artwork_photos) {
        artwork.keywords = [];
        for (var ap in artwork.artwork_photos) {
          if (artwork.artwork_photos[ap].keywords) {
            try {
              artwork.artwork_photos[ap].keywords = JSON.parse(artwork.artwork_photos[ap].keywords).map(function (k) {
                return k = k.toString();
              });
            } catch (err) {
              // console.log('error while parsing keywords')
            }
          } else {
            artwork.artwork_photos[ap].keywords = [];
          }
          artwork.keywords = artwork.keywords.concat(artwork.artwork_photos[ap].keywords.map(function (k) {
            return k = k.toString();
          }));
        }
      }
      if (artwork && artwork.keywords) {
        artwork.keywords = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(artwork.keywords)));
        artwork.keywords = artwork.keywords.sort(function (a, b) {
          return a.toUpperCase().localeCompare(b.toUpperCase());
        });
      }
      return artwork;
    }
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_js_yaml__ = __webpack_require__("QKd8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_user__ = __webpack_require__("bREw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__main__ = __webpack_require__("NHnr");





var _this2 = this;










function dynamicSort(property, property2) {
  // var sortOrder = 1
  if (property[0] === '-') {
    // sortOrder = -1
    property = property.substr(1);
  }
  return function (a, b) {
    // var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    if (a[property] > b[property]) return 1;
    if (a[property] < b[property]) return -1;
    if (a[property2] > b[property2]) return 1;
    if (a[property2] < b[property2]) return -1;
    // return result * sortOrder;
  };
}

function getAge(dateString) {
  var today = new Date();
  var birthDate = new Date(dateString);
  var age = today.getFullYear() - birthDate.getFullYear();
  var m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) {
    age--;
  }
  return age;
}

function updateArtworkTags(artworkId, tagIds) {
  var url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artworks/' + artworkId + '/update_tags';

  // Prepare the data to be sent in the request
  var data = {
    tag_ids: tagIds
  };

  // Make the API call
  __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, data).then(function (response) {
    // Handle success
    console.log('Tags updated successfully', response.data);
    // Optionally, update the Vuex store or local component state
  }).catch(function (error) {
    // Handle error
    console.error('Error updating tags', error);
  });
}

var capitalize = function capitalize(s) {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

var toCamel = function toCamel(s) {
  return s.replace(/([-_][a-z])/gi, function ($1) {
    return $1.toUpperCase().replace('-', '').replace('_', '');
  });
};
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);
var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */].Store({
  state: {
    sorting: {
      artists: 'sort_name',
      artworks: 'title',
      exhibitions: 'name',
      texts: 'given_filename',
      todos: 'title',
      tags: 'name',
      contacts: 'name'
    },
    searchString: {
      artists: '',
      artworks: '',
      texts: '',
      tags: '',
      todos: '',
      contacts: '',
      locations: '',
      users: '',
      articles: '',
      selections: '',
      exhibitions: ''
    },
    pageNumbers: {
      artists: 1,
      artworks: 1,
      texts: 1,
      tags: 1,
      todos: 1,
      contacts: 1,
      locations: 1,
      users: 1,
      articles: 1,
      selections: 1,
      exhibitions: 1
    },
    showSearch: {
      artists: false,
      artworks: false,
      texts: false,
      tags: false,
      todos: false,
      contacts: false,
      locations: false,
      users: false,
      articles: false,
      selections: false,
      exhibitions: false
    },
    rowsPerPage: {},
    // tag_categories: [],
    token: localStorage.getItem('user-token') || '',
    profile: {},
    status: '',
    locations: [],
    packings: [],
    support_articles: [],
    journals: [],
    questions: [],
    todos: [],
    tags: [],
    roles: [],
    view: 'list',
    add_new: false,
    options: false,
    users: [],
    file_uploads: [],
    non_electricals: [],
    lists: [],
    includes: [{ title: 'Objects', field: 'including_objects' }, { title: 'Sound', field: 'including_sound' }, { title: 'Film / Video / AV', field: 'including_film' }, { title: 'Slide', field: 'including_slide' }, {
      title: 'Computer Program / Software / File',
      field: 'including_computer'
    }, { title: 'Performance', field: 'including_performance' }, { title: 'Light', field: 'including_light' }, { title: 'Other', field: 'including_other' }],
    currentUser: {},
    // { id: 3, username: 'simone', password: 'simone', avatar: 'simone.png', abb: 'SIM', tabs: ['basic'], allowed_fields: ['title'], allowed_functions: ['download_pdf'] },
    reading_devices: [],
    electricals: [],
    exhibitions: [],
    contacts: [],
    texts: [],
    artworks: [],
    artworks_for_pdf: [],
    artworks_selections: [],
    artwork_location_logs: [],
    artwork_insurance_logs: [],
    links: [],
    // loading: false,
    loading_artworks: false,
    loading_rules: false,
    loading_artists: false,
    loading_contacts: false,
    loading_users: false,
    loading_lists: false,
    loading_locations: false,
    loading_exhibitions: false,
    loading_packings: false,
    loading_texts: false,
    loading_tags: false,
    loading_tag_categories: false,
    loading_todos: false,
    loading_support_articles: false,
    loading_journals: false,
    loading_questions: false,
    // store_date: new Date(),
    selected_columns_for_pdf: [],
    api_server: 'http://api.tb-cms.org',
    currentTab: '',
    artworkColumns: ['Title', 'Accession Number', 'Name', 'Location'],
    filterResults: [],
    currentSelection: [],
    currentListSelection: [],
    currentOutputFieldsSelection: [],
    artists: [],
    collection: [],
    pac_fvh: [],
    pdc_fvh: [],
    pac_mr: [],
    deaccession: [],
    oldMasters: [],
    // user: [],
    limited_user_fields: [],
    user_rights: {
      view_only: {
        artworks_select: 'ownership=1'
      }
    },
    categories: [{
      id: 'monitor',
      name: 'Monitor',
      off_icon: 'mdi-monitor',
      on_icon: 'mdi-monitor'
    }, {
      id: 'projector',
      name: 'Projector',
      off_icon: 'mdi-projector',
      on_icon: 'mdi-projector'
    }, {
      id: 'motor',
      name: 'Motor',
      off_icon: 'mdi-engine',
      on_icon: 'mdi-engine'
    }, {
      id: 'bulb',
      name: 'Bulb',
      off_icon: 'mdi-lightbulb',
      on_icon: 'mdi-lightbulb'
    }, {
      id: 'switch',
      name: 'Switch',
      off_icon: 'mdi-nintendo-switch',
      on_icon: 'mdi-nintendo-switch'
    }],
    filters: []
  },
  mutations: {
    SET_USER_ID: function SET_USER_ID(state, user_id) {
      state.user_id = user_id;
    },
    REPLACE_ARTWORK: function REPLACE_ARTWORK(state, artwork) {
      state.artworks = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(state.artworks.filter(function (element) {
        return element.id !== artwork.id;
      })), [artwork]);
    },

    /// item.item, item.table
    REPLACE_OBJECT: function REPLACE_OBJECT(state, item) {
      // console.log(item.item.item)
      state[item.item.table] = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(state[item.item.table].filter(function (element) {
        return element.id !== [item.item.item].id;
      })), [item.item.item]);
    },
    LOGIN_USER: function LOGIN_USER(state, currentUser) {
      state.currentUser = currentUser;
    },
    initialiseStore: function initialiseStore(state) {
      console.log('initialiseStore');
      // Check if the ID exists
      // if (localStorage.getItem('store')) {
      // console.log('stored >>> ' + this.state.store_date)
      // console.log('actual >>> ' + new Date())
      // if (this.state.store_date < new Date()) {
      //   this.dispatch('loadArtworks')
      //   this.dispatch('loadTags')
      //   this.state.store_date = new Date()
      //   console.log('saved new date >>> ' + this.state.store_date)
      // }
      // Replace the state object with the stored item


      if (localStorage.getItem('user-token') != null) {
        // this.replaceState(
        state.token = localStorage.getItem('user-token');
        // )
        // console.log('token reloaded from localStorage')
      } else {
          // console.log('token doesnt exist in localStorage')
        }

      if (localStorage.getItem('currentTab') != null) {
        // this.replaceState(
        state.currentTab = localStorage.getItem('currentTab');
        // )
        // console.log('currentTab reloaded from localStorage')
      } else {
          // console.log('currentTab doesnt exist in localStorage')
        }

      if (localStorage.getItem('user-id') != null) {
        // this.replaceState(
        state.user_id = localStorage.getItem('user-id');
        // )
        // console.log('user-id reloaded from localStorage')
      } else {
          // console.log('user-id doesnt exist in localStorage')
        }

      if (localStorage.getItem('profile') != null) {
        // this.replaceState(
        state.profile = JSON.parse(localStorage.getItem('profile'));
        // )
        // console.log('profile reloaded from localStorage')
      } else {}
        // console.log('profile doesnt exist in localStorage')


        // if user is logged in, load all data
      if (state.user_id != null) {
        this.dispatch('loadAll');
      }
    },
    LOAD_ALL: function LOAD_ALL(state) {
      var _this = this;

      console.log('LOAD_ALL');
      var dataToLoadFromServer = ['tags',
      // 'tag_categories',
      'roles', 'file_uploads', 'artists', 'lists', 'todos', 'packings', 'artwork_location_logs', 'artwork_insurance_logs', 'locations', 'exhibitions', 'contacts', 'users', 'support_articles', 'artworks'
      // 'journals'
      ];
      var dataToLoadFromStorage = ['artists', 'locations'];

      dataToLoadFromStorage.forEach(function (a) {
        // console.log(a)
        var b = localStorage.getItem(a);
        if (b != null) {
          if (b.length > 0) {
            state[a] = JSON.parse(localStorage.getItem(a));
            // console.log(state[a])
            // console.log(a + ' reloaded from localStorage')
          }
        }
      });
      dataToLoadFromServer.forEach(function (a) {
        // check if loading is not already in progress
        var loading_status = 'loading_' + a;
        if (!state[loading_status]) {
          var mutation = 'load' + capitalize(toCamel(a));
          console.log(mutation);
          _this.dispatch(mutation);
        } else {
          console.log('VUEX: ' + a + ' already loading');
        }
      });
    },

    SET_SORTING: function SET_SORTING(state, sorting) {
      // console.log(sorting.sorting)
      if (!!sorting.sorting) {
        // console.log(`Set sorting state of ${sorting.sorting.section} to ${sorting.sorting.column}`)
        // console.log(state.sorting[sorting.sorting.section])
        state.sorting[sorting.sorting.section] = sorting.sorting.column;
      } else {
        // console.log('ERROR')
      }
    },
    SET_FILTER: function SET_FILTER(state, filter) {
      if (!!filter.ownership) {
        // console.log(filter)
        state.filters[filter.section] = filter.ownership;
      } else {
        // console.log('ERROR')
      }
    },
    SET_LOADING: function SET_LOADING(state, section) {
      // console.log(`Set loading state of ${section} to true`)
      state['loading_' + section] = true;
    },
    UNSET_LOADING: function UNSET_LOADING(state, section) {
      // console.log(`Set loading state of ${section} to false`)
      state['loading_' + section] = false;
    },
    SAVE_OPTIONS: function SAVE_OPTIONS(state, loading) {
      // console.log('Set options state to', loading)
      state.options = loading;
    },
    ADD_NEW: function ADD_NEW(state, addNew) {
      // console.log('Set Add New state to', addNew)
      state.add_new = addNew;
    },
    SAVE_SHOW_SEARCH: function SAVE_SHOW_SEARCH(state, s) {
      // console.log('Set showSearch state to', s)
      state.showSearch = s;
    },
    SAVE_SEARCH_STRING: function SAVE_SEARCH_STRING(state, s) {
      // console.log('Set showSearch state to', s)
      state.searchString[s.section] = s.string ? s.string : '';
    },
    SAVE_PAGE_NUMBER: function SAVE_PAGE_NUMBER(state, s) {
      // console.log('Set current page number state to', s)
      state.pageNumbers[s.section] = s.string ? s.string : '';
    },
    SAVE_VIEW: function SAVE_VIEW(state, loading) {
      // console.log('Set view state to', loading)
      state.view = loading;
    },
    SET_USER: function SET_USER(state, datas) {
      // console.log('Set user to', datas)
      state.currentUser = datas;
    },
    // UPDATE_USER: (state, datas) => {
    //   console.log('Set user to', datas)
    //   state.currentUser = datas
    //   localStorage.setItem('profile', JSON.stringify(datas))
    //   state.profile = datas
    // },
    SET_COLLECTION: function SET_COLLECTION(state, datas) {
      state.collection = datas;
    },
    SET_TAGS: function SET_TAGS(state, datas) {
      state.tags = datas;
    },
    SET_TAG_CATEGORIES: function SET_TAG_CATEGORIES(state, datas) {
      state.tag_categories = datas;
    },
    SET_TEXTS: function SET_TEXTS(state, datas) {
      state.texts = datas;
    },
    SET_ARTISTS: function SET_ARTISTS(state, datas) {
      state.artists = datas;
    },
    SET_LISTS: function SET_LISTS(state, datas) {
      for (var index in datas) {
        datas[index].artworks = __WEBPACK_IMPORTED_MODULE_7_js_yaml__["a" /* default */].load(datas[index].artworks);
        // yaml.load(this.$store.state.lists[0].artworks)
      }
      state.artworks_selections = datas;
      state.lists = datas;
    },
    SET_TODOS: function SET_TODOS(state, datas) {
      state.todos = datas;
    },
    ADD_TODO: function ADD_TODO(state, datas) {
      // console.log(state.todos)
      state.todos.push(datas);
      // console.log(state.todos)
    },
    TOGGLE_TODO: function TOGGLE_TODO(state, datas) {
      var i = state.todos.findIndex(function (t) {
        return t.id === datas.id;
      });
      datas.done = !datas.done;
      state.todos.splice(i, 1, datas);
      // console.log('store toggle')
      // console.log(i)
      // state.todos[i].done = !state.todos[i].done
      // state.todos = [
      //   ...state.todos.map(item =>
      //     item.id !== datas.id ? item : { ...item, ...datas }
      //     )
      //   ]
      // console.log(state.todos)
      // state.todos.push(datas)
    },
    SAVE_TODO: function SAVE_TODO(state, datas) {
      var i = state.todos.findIndex(function (t) {
        return t.id === datas.id;
      });
      // datas.done = !datas.done
      state.todos.splice(i, 1, datas);
      // console.log('store save')
      // console.log(i)
      // state.todos[i].done = !state.todos[i].done
      // state.todos = [
      //   ...state.todos.map(item =>
      //     item.id !== datas.id ? item : { ...item, ...datas }
      //     )
      //   ]
      // console.log(state.todos)
      // state.todos.push(datas)
    },
    ADD_LOG: function ADD_LOG(state, datas) {
      state.artwork_location_logs.push(datas);
    },
    ADD_INSURANCE_LOG: function ADD_INSURANCE_LOG(state, datas) {
      state.artwork_insurance_logs.push(datas);
    },
    ADD_CONSERVATION: function ADD_CONSERVATION(state, datas) {
      var artwork = state.artworks.find(function (aa) {
        return aa.id === datas.artwork_id;
      });
      var i = state.artworks.indexOf(artwork);
      if (i !== -1) {
        if (state.artworks[i].conservations) {
          state.artworks[i].conservations.push(datas);
        } else {
          state.artworks[i].conservations = [];
          state.artworks[i].conservations.push(datas);
        }
      }
    },
    ADD_LINK: function ADD_LINK(state, datas) {
      state.links.push(datas);
    },
    ADD_TEXT: function ADD_TEXT(state, datas) {
      state.texts.push(datas);
    },
    ADD_ARTWORK: function ADD_ARTWORK(state, datas) {
      state.artworks.push(datas);
    },
    ADD_ARTIST: function ADD_ARTIST(state, datas) {
      state.artists.push(datas);
    },
    ADD_PACKING: function ADD_PACKING(state, datas) {
      state.packings.push(datas);
    },
    SET_CONTACTS: function SET_CONTACTS(state, datas) {
      state.contacts = datas;
    },
    SET_EXHIBITIONS: function SET_EXHIBITIONS(state, datas) {
      state.exhibitions = datas;
    },
    ADD_EXHIBITION: function ADD_EXHIBITION(state, datas) {
      state.exhibitions.push(datas);
    },
    ADD_READING_DEVICE: function ADD_READING_DEVICE(state, datas) {
      state.reading_devices.push(datas);
    },
    ADD_ELECTRICAL: function ADD_ELECTRICAL(state, datas) {
      state.electricals.push(datas);
    },
    ADD_NON_ELECTRICAL: function ADD_NON_ELECTRICAL(state, datas) {
      state.non_electricals.push(datas);
    },
    DELETE_EXHIBITION: function DELETE_EXHIBITION(state, datas) {
      var i = state.exhibitions.indexOf(datas);
      state.exhibitions.splice(i, 1);
    },
    DELETE_DEVICE: function DELETE_DEVICE(state, datas) {
      var i = state.devices.indexOf(datas);
      state.devices.splice(i, 1);
    },
    // ADD_EXHIBITION_TO_ARTWORK: (state, datas) => {
    //   var ar = state.exhibitions.find(function (a) { return a.id === datas.exhibition_id })
    //   ar.exhibition_artworks.push()
    //   state.artworks.forEach((a, index) => {
    //     if (a.id === datas.artwork_id) {
    //       Vue.set(state.artworks, index, datas)
    //     }
    //  })
    //   ar.exhibition_artworks.push(datas.id)
    //   state.exhibitions.push(datas)
    // },
    SET_USERS: function SET_USERS(state, datas) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'users', datas);
    },
    SET_LOCATIONS: function SET_LOCATIONS(state, datas) {
      state.locations = datas;
    },
    SET_PACKINGS: function SET_PACKINGS(state, datas) {
      state.packings = datas;
    },
    SET_TAGGINGS: function SET_TAGGINGS(state, datas) {
      state.taggings = datas;
    },
    CREATE_TAG: function CREATE_TAG(state, datas) {
      state.tags.push(datas);
    },
    DELETE_TAG: function DELETE_TAG(state, datas) {
      var i = state.tags.indexOf(datas);
      state.tags.splice(i, 1);
    },
    REMOVE_TEXT: function REMOVE_TEXT(state, datas) {
      var i = state.texts.indexOf(datas);
      state.texts.splice(i, 1);
    },
    SET_ROLES: function SET_ROLES(state, datas) {
      state.roles = datas;
    },
    SET_ARTWORKS_FAST: function SET_ARTWORKS_FAST(state, datas) {
      state.artworks = datas;
    },
    SET_ARTWORKS: function SET_ARTWORKS(state, datas) {
      // state.artworks = datas
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'artworks', datas);
    },
    SET_ARTWORK_LOCATION_LOGS: function SET_ARTWORK_LOCATION_LOGS(state, datas) {
      // state.artworks = datas
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'artwork_location_logs', datas);
    },
    SET_ARTWORK_INSURANCE_LOGS: function SET_ARTWORK_INSURANCE_LOGS(state, datas) {
      // state.artworks = datas
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'artwork_insurance_logs', datas);
    },
    SET_SUPPORT_ARTICLES: function SET_SUPPORT_ARTICLES(state, datas) {
      state.support_articles = datas;
    },
    SET_JOURNALS: function SET_JOURNALS(state, datas) {
      state.journals = datas;
    },
    SET_QUESTIONS: function SET_QUESTIONS(state, datas) {
      state.questions = datas;
    },
    SET_FILE_UPLOADS: function SET_FILE_UPLOADS(state, datas) {
      state.file_uploads = datas;
    },
    SET_FILTER_RESULTS: function SET_FILTER_RESULTS(state, datas) {
      state.filterResults = datas;
    },
    SET_CURRENT_LIST_SELECTION: function SET_CURRENT_LIST_SELECTION(state, datas) {
      state.currentListSelection = datas;
    },
    SET_ARTWORKS_FOR_PDF: function SET_ARTWORKS_FOR_PDF(state, datas) {
      state.artworks_for_pdf = datas;
    },
    SET_CURRENT_OUTPUT_FIELDS_SELECTION: function SET_CURRENT_OUTPUT_FIELDS_SELECTION(state, datas) {
      state.currentOutputFieldsSelection = datas;
    },
    // CURRENT_SELECTION - artworks selected in toolbar
    REMOVE_FROM_CURRENT_SELECTION: function REMOVE_FROM_CURRENT_SELECTION(state, datas) {
      var i = state.currentSelection.indexOf(datas);
      state.currentSelection.splice(i, 1);
    },
    ADD_ARTIST_LINK: function ADD_ARTIST_LINK(state, link) {
      // console.log(state.artists)
      var artist = state.artists.find(function (aa) {
        return aa.id === link.artist_id;
      });
      var i = state.artists.indexOf(artist);
      if (i !== -1) {
        if (state.artists[i].artist_links) {
          state.artists[i].artist_links.push(link);
        } else {
          state.artists[i].artist_links = [];
          state.artists[i].artist_links.push(link);
        }
        // console.log(state.artists[i])
      }
    },
    DELETE_ARTIST_LINK: function DELETE_ARTIST_LINK(state, link) {
      // console.log(state.artists)
      var artist = state.artists.find(function (aa) {
        return aa.id === link.artist_id;
      });
      var i = state.artists.indexOf(artist);
      if (i !== -1) {
        if (state.artists[i].artist_links) {
          var li = state.artists[i].artist_links.indexOf(link);
          state.artists[i].artist_links.splice(li);
        }
      }
      // console.log(state.artists[i])
    },
    SET_CURRENT_SELECTION: function SET_CURRENT_SELECTION(state, datas) {
      state.currentSelection = datas;
    },
    ADD_TO_CURRENT_SELECTION: function ADD_TO_CURRENT_SELECTION(state, datas) {
      var tempSelection = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], state.currentSelection);
      if (datas) {
        for (var d in datas) {
          if (!tempSelection.includes(datas[d])) {
            tempSelection.push(datas[d]);
          }
        }
      }
      // this.$store.dispatch('saveCurrentSelection',temp_selection)
      state.currentSelection = tempSelection;
    },
    CLEAR_CURRENT_SELECTION: function CLEAR_CURRENT_SELECTION(state) {
      state.currentSelection = [];
    },
    CLEAR_CURRENT_SELECTION_LISTS: function CLEAR_CURRENT_SELECTION_LISTS(state) {
      state.currentListSelection = [];
    },
    // artwork LISTS - saved artworks selections
    SAVE_CURRENT_SELECTION_TO_USER: function SAVE_CURRENT_SELECTION_TO_USER(state, datas) {
      state.artworks_selections.push(datas);
    },
    REMOVE_FROM_SELECTIONS: function REMOVE_FROM_SELECTIONS(state, datas) {
      var i = state.artworks_selections.indexOf(datas);
      state.artworks_selections.splice(i, 1);
    },
    // NOT FINISHED !!!
    ADD_TO_SELECTION: function ADD_TO_SELECTION(state, datas) {
      var i = state.artworks_selections.indexOf(datas);
      state.artworks_selections.splice(i, 1);
    },
    SET_CURRENT_SELECTION_TAGS: function SET_CURRENT_SELECTION_TAGS(state, datas) {
      state.currentSelectionTags = datas;
    },
    SET_CURRENT_TAB: function SET_CURRENT_TAB(state, datas) {
      state.currentTab = datas;
      localStorage.setItem('currentTab', datas);
    },
    SET_CURRENT_TAB_ARTIST: function SET_CURRENT_TAB_ARTIST(state, datas) {
      state.currentTabArtist = datas;
    },
    SET_SELECTED_COLUMNS_FOR_PDF: function SET_SELECTED_COLUMNS_FOR_PDF(state, datas) {
      state.selected_columns_for_pdf = datas;
    },
    REMOVE_ARTWORK_FROM_LIST: function REMOVE_ARTWORK_FROM_LIST(state, datas) {
      // console.log('store')
      console.log(datas);
      // console.log(datas.a)
      var listindex = state.lists.findIndex(function (l) {
        return l.id === datas.l;
      });
      // console.log(listindex)
      var originalArtworks = state.lists.find(function (l) {
        return l.id === datas.l;
      }).artworks;
      // console.log(originalArtworks)
      var removedArtworks = originalArtworks.filter(function (oa) {
        return oa !== datas.a;
      });
      // console.log(removedArtworks)
      // console.log(state.lists[listindex].artworks)
      state.lists[listindex].artworks = removedArtworks;
      // console.log(state.lists[listindex].artworks)
      var list = state.lists[listindex];

      var list_for_submit = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, state.lists[listindex]);
      list_for_submit.artworks = '[' + removedArtworks + ']';

      var url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/lists/' + datas.l + '.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, list_for_submit).then(function (response) {
        // console.log(response.data)
        // this.result = response.data
        // this.snackbar = true
      }).catch(function (error) {
        // console.log(error)
      });
    },
    REMOVE_ARTWORK_FROM_EXHIBITION: function REMOVE_ARTWORK_FROM_EXHIBITION(state, datas) {
      // console.log(datas)
      var listindex = state.exhibitions.findIndex(function (l) {
        return l.id === datas.e;
      });
      var originalArtworks = state.exhibitions.find(function (l) {
        return l.id === datas.e;
      }).artworks;
      var removedArtworks = originalArtworks.filter(function (oa) {
        return oa.id !== datas.a;
      });
      // console.log('originalArtworks')
      // console.log(originalArtworks)
      // console.log('removedArtworks')
      // console.log(state.exhibitions[listindex])
      state.exhibitions[listindex].artworks = removedArtworks;
      // console.log(state.exhibitions[listindex])
      var exhibition = state.exhibitions[listindex];

      delete exhibition.artworks;
      exhibition.artwork_ids = removedArtworks.map(function (ea) {
        return ea.id;
      });
      exhibition.artworks = exhibition.artwork_ids;
      // console.log('exhibition')
      // console.log(exhibition)

      var url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/exhibitions/' + datas.e + '.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, { exhibition: exhibition }).then(function (response) {
        // console.log(response.data)
        // this.result = response.data
        // this.snackbar = true
      }).catch(function (error) {
        // console.log(error)
      });
    },
    SAVE_HOME_PAGE_TO_USER: function SAVE_HOME_PAGE_TO_USER(state, datas) {
      // console.log(state.profile)
      localStorage.setItem('profile', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(datas));
      state.profile = datas;
      // console.log(state.profile)
    },
    ADD_ALL_RIGHTS_TO_USER: function ADD_ALL_RIGHTS_TO_USER(state, datas) {
      var user = state.users.find(function (u) {
        return u.id === datas;
      });
      var rs = state.roles.map(function (r) {
        return r.id;
      });
      user.roles = state.roles;
      user.role_ids = rs;
      var url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/users/' + user.id + '.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, { user: user }).then(function (response) {}).catch(function (error) {
        // console.log(error)
      });
    },
    INVERSE_DELETE_RIGHTS: function INVERSE_DELETE_RIGHTS(state, datas) {
      var user = state.users.find(function (u) {
        return u.id === datas;
      });
      user.delete_rights = !user.delete_rights;
      var url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/users/' + user.id + '.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, { user: user }).then(function (response) {}).catch(function (error) {
        // console.log(error)
      });
    },
    // INVERSE_DISABLE: (state, datas) => {
    // const user = state.users.find(u => u.id === datas)
    // user.enable = user.enable === 'Y' ? 'N' : 'Y'
    // let url = `${Vue.prototype.$globals.apiserver}/users/${user.id}.json`
    // axios
    //   .put(url, { user: user })
    //   .then(response => {
    //     this.dispatch('loadUsers')
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
    // },
    REMOVE_ALL_RIGHTS_TO_USER: function REMOVE_ALL_RIGHTS_TO_USER(state, datas) {
      var user = state.users.find(function (u) {
        return u.id === datas;
      });
      // let rs = state.roles.map(r => r.id)
      user.roles = [];
      user.role_ids = [];
      var url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/users/' + user.id + '.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, { user: user }).then(function (response) {}).catch(function (error) {
        // console.log(error)
      });
    },
    TOGGLE_ADMIN: function TOGGLE_ADMIN(state, datas) {
      var user = state.users.find(function (u) {
        return u.id === datas;
      });
      // console.log(roles)
      if (user.admin === 0 || user.admin === null) {
        user.edit = 1;
      } else {
        user.edit = 0;
      }
    },
    // ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, { id }) => {
    //   const tag = state.tags.find(t => t.id === id);
    //   state.currentSelection.forEach(selectionId => {
    //     const index = state.artworks.findIndex(a => a.id === selectionId);
    //     if (index !== -1) {
    //       const artwork = state.artworks[index];
    //       const updatedTags = artwork.tags ? [...artwork.tags, tag] : [tag];
    //       Vue.set(state.artworks, index, { ...artwork, tags: updatedTags });
    //     }
    //   });
    // },
    ASSIGN_MULTIPLE_TAGS_TO_SELECTION: function ASSIGN_MULTIPLE_TAGS_TO_SELECTION(state, _ref) {
      var tags = _ref.tags;

      var artworksToUpdate = state.currentSelection.map(function (selectionId) {
        return state.artworks.find(function (a) {
          return a.id === selectionId;
        });
      });

      artworksToUpdate.forEach(function (artwork) {
        if (artwork) {
          // Deduplicate and add new tags
          var newTags = tags.filter(function (tag) {
            return !artwork.tags.some(function (t) {
              return t.id === tag.id;
            });
          });
          var updatedTags = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(artwork.tags), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(newTags));
          __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(artwork, 'tags', updatedTags);
        }
      });
    },

    ADD_TAG_TO_CURRENT_SELECTION: function ADD_TAG_TO_CURRENT_SELECTION(state, tag) {
      state.currentSelection.forEach(function (selectionId) {
        var artwork = state.artworks.find(function (a) {
          return a.id === selectionId;
        });
        if (artwork) {
          // Ensure artwork.tags is an array
          if (!artwork.tags) {
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(artwork, 'tags', []);
          }
          // Check if the tag is already present
          if (!artwork.tags.some(function (t) {
            return t.id === tag.id;
          })) {
            // Create a new array with the new tag to ensure reactivity
            __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(artwork, 'tags', [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(artwork.tags), [tag]));
          }
        }
      });
    },
    // ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, { id }) => {
    //   const tag = state.tags.find(t => t.id === id);

    //   // Convert artworks array to a Map for faster access
    //   const artworksMap = new Map(state.artworks.map(artwork => [artwork.id, artwork]));

    //   state.currentSelection.forEach(selectionId => {
    //     if (artworksMap.has(selectionId)) {
    //       const artwork = artworksMap.get(selectionId);

    //       // Initialize tags array if it doesn't exist
    //       if (!artwork.tags) {
    //         artwork.tags = [];
    //       }

    //       // Check if the tag is already in the artwork's tags
    //       if (!artwork.tags.some(existingTag => existingTag.id === tag.id)) {
    //         // Add the tag to the artwork's tags
    //         const updatedTags = [...artwork.tags, tag];
    //         // Update the artwork in the Map
    //         artworksMap.set(selectionId, { ...artwork, tags: updatedTags });
    //       }
    //     }
    //   });
    //   // Convert the Map back to an array and update the state once
    //   Vue.set(state, 'artworks', Array.from(artworksMap.values()));

    // },

    // ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, { id }) => {
    //   const tag = state.tags.find(t => t.id === id);
    //   state.currentSelection.forEach(selectionId => {
    //     const artwork = state.artworks.find(a => a.id === selectionId);
    //     if (artwork) {
    //       artwork.tags = artwork.tags || [];
    //       if (!artwork.tags.includes(tag)) {
    //         artwork.tags.push(tag);
    //       }
    //     }
    //   });
    // },

    // ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, datas) => {
    //   console.log(datas)
    //   console.log(state.currentSelection)
    //   const artworkIds = state.currentSelection;
    //   console.log(artworkIds)
    //   const filteredArtworks = state.artworks.filter((artwork) => artworkIds.includes(artwork.id));
    //   console.log(filteredArtworks.length)

    //   for (const artwork of filteredArtworks) {
    //     if (!artwork.tags) {
    //       artwork.tags = [];
    //     }
    //     artwork.tags.push(datas);
    //     console.log(artwork.tags);
    //   }
    //   ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, datas) => {
    //     const artworkIds = state.currentSelection;
    //     const filteredArtworks = state.artworks.filter((artwork) => artworkIds.includes(artwork.id));

    //     for (const artwork of filteredArtworks) {
    //       if (!artwork.tags) {
    //         artwork.tags = [];
    //       }
    //       artwork.tags.push(datas);
    //     }
    //   },

    // UPDATE THE SERVER
    // let ts = artwork.tags.map(tag => tag.id)
    // // artwork.tag_ids = ts
    // artwork.tags = ts
    // artwork.save_tags = 1
    // let url = `${Vue.prototype.$globals.apiserver}/artworks/${artwork.id}.json`
    // axios
    //   .put(url, { artwork: artwork, user_id: state.currentUser.id })
    //   .then(response => {
    //     // commit('SAVE_HOME_PAGE_TO_USER', response.data)
    //     // console.log('response.data')
    //     // console.log(response.data)
    //     // console.log(response)
    //     // state.profile = response.data
    //   })
    //   .catch(error => {
    //     // console.log(error)
    //   })
    // },

    // ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION: (state, datas) => {
    //   console.log(datas)
    //   console.log(state.currentSelection)
    //   // console.log(state.artworks)
    //   var tag = state.tags.find(t => t.id === datas.id)
    //   console.log(tag)
    //   for (let csa in state.currentSelection) {
    //     // console.log(state.currentSelection[csa])
    //     var artwork = state.artworks.find(
    //       a => state.currentSelection[csa] === a.id
    //     )
    //     // console.log(artwork)
    //     if (!artwork.tags) {
    //       artwork.tags = []
    //       artwork.tags.push(tag)
    //     } else {
    //       artwork.tags.push(tag)
    //     }
    //     console.log(artwork.tags)
    //     // artwork.tags.push(tag)
    //     // console.log(state.artworks.find(a => state.currentSelection[csa] === a.id))

    //     // UPDATE THE SERVER
    //     let ts = artwork.tags.map(tag => tag.id)
    //     // artwork.tag_ids = ts
    //     artwork.tags = ts
    //     artwork.save_tags = 1
    //     // let url = `${Vue.prototype.$globals.apiserver}/artworks/${artwork.id}.json`
    //     // axios
    //     //   .put(url, { artwork: artwork, user_id: state.currentUser.id })
    //     //   .then(response => {
    //     //     // commit('SAVE_HOME_PAGE_TO_USER', response.data)
    //     //     // console.log('response.data')
    //     //     // console.log(response.data)
    //     //     // console.log(response)
    //     //     // state.profile = response.data
    //     //   })
    //     //   .catch(error => {
    //     //     // console.log(error)
    //     //   })
    //   }
    // },
    // setAge: (state, payload) => {
    //   const { age, name } = payload
    //   const person = state.people.find(p => p.Name === name)
    //   person.age = age
    // }
    UPDATE_ARTWORK: function UPDATE_ARTWORK(state, datas) {
      state.artworks = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(state.artworks.map(function (item) {
        return item.id !== datas.id ? item : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, datas);
      })));
    },
    DELETE_LINK: function DELETE_LINK(state, datas) {
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/links/' + datas.id + '.json', {
        id: datas.id
      }).then(function (response) {
        _this2.errors = {};
        var artwork = state.artworks.find(function (aa) {
          return aa.id === datas.artwork_id;
        });
        var i = state.artworks.indexOf(artwork);
        if (i !== -1) {
          if (state.artworks[i].links) {
            state.artworks[i].links.splice(i, 1);
          }
        }
      });
    },
    DELETE_PACKING: function DELETE_PACKING(state, datas) {
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artwork_packings/' + datas.id + '.json', {
        id: datas.id
      }).then(function (response) {
        _this2.errors = {};
        var artwork = state.artworks.find(function (aa) {
          return aa.id === datas.artwork_id;
        });
        var i = state.artworks.indexOf(artwork);
        if (i !== -1) {
          if (state.artworks[i].artwork_packings) {
            state.artworks[i].artwork_packings.splice(i, 1);
          }
        }
      });
    },
    DELETE_FILE_UPLOAD: function DELETE_FILE_UPLOAD(state, datas) {
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/file_uploads/' + datas.id + '.json', {
        id: datas.id
      }).then(function (response) {
        _this2.errors = {};
        var artwork = state.artworks.find(function (aa) {
          return aa.id === datas.artwork_id;
        });
        var i = state.artworks.indexOf(artwork);
        if (i !== -1) {
          if (state.artworks[i].file_uploads) {
            state.artworks[i].file_uploads.splice(i, 1);
          }
        }
      });
    },
    DELETE_SELECTION: function DELETE_SELECTION(state, datas) {
      // let selection = state.lists.find(s => s.id === datas.id)
      // console.log(selection)
      // console.log(state.lists)
      // var i = state.lists.indexOf(selection)
      // console.log(state.lists.length)
      // console.log(i)
      state.lists = state.lists.filter(function (l) {
        return l.id !== datas.id;
      });
      // if (i !== -1) {
      //   state.lists.splice(i, 1)
      // }
      // console.log(state.lists.length)
    },
    // add selection to exhibition in this.store.exhibitions
    ADD_SELECTION_TO_EXHIBITION: function ADD_SELECTION_TO_EXHIBITION(state, datas) {
      console_log(datas);
    }
    // DELETE_ITEM: (state, item) => state.items = state.items.filter(t => item.id !== t.id),
    // DELETE_SELECTION_SERVER: (state, datas) => {

    // },
  },
  actions: {
    loadAll: function loadAll(_ref2) {
      var commit = _ref2.commit;

      commit('LOAD_ALL');
    },
    setUserId: function setUserId(_ref3, user_id) {
      var commit = _ref3.commit;

      commit('SET_USER_ID', user_id);
    },
    replaceObject: function replaceObject(_ref4, datas) {
      var commit = _ref4.commit;

      commit('REPLACE_OBJECT', datas);
    },
    replaceArtwork: function replaceArtwork(_ref5, datas) {
      var commit = _ref5.commit;

      commit('REPLACE_ARTWORK', datas);
    },
    replaceUser: function replaceUser(_ref6, datas) {
      var commit = _ref6.commit;

      commit('REPLACE_USER', datas);
    },
    deleteSelection: function deleteSelection(_ref7, datas) {
      var _this3 = this;

      var commit = _ref7.commit;

      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/lists/' + datas.id + '.json', {
        id: datas.id
      }).then(function (response) {
        _this3.errors = {};
        commit('DELETE_SELECTION', datas);
        // this.dispatch('loadLists')
      });
      // delete_text(t) {
      // console.log(datas)
      // this.artwork.links = this.artwork.links.filter(at => {
      //   return at.id != datas.id
      // })
      // commit('DELETE_SELECTION_SERVER', datas)
      // .catch(error => { console.log(error) })
    },
    deletePacking: function deletePacking(_ref8, datas) {
      var commit = _ref8.commit,
          state = _ref8.state;

      // delete_text(t) {
      // console.log(datas)
      // this.artwork.links = this.artwork.links.filter(at => {
      //   return at.id != datas.id
      // })
      commit('DELETE_PACKING', datas);
      // .catch(error => { console.log(error) })
    },
    deleteFileUpload: function deleteFileUpload(_ref9, datas) {
      var commit = _ref9.commit,
          state = _ref9.state;

      // delete_text(t) {
      // console.log(datas)
      // this.artwork.links = this.artwork.links.filter(at => {
      //   return at.id != datas.id
      // })
      commit('DELETE_FILE_UPLOAD', datas);
      // .catch(error => { console.log(error) })
    },
    deleteLink: function deleteLink(_ref10, datas) {
      var commit = _ref10.commit,
          state = _ref10.state;

      // delete_text(t) {
      // console.log(datas)
      // this.artwork.links = this.artwork.links.filter(at => {
      //   return at.id != datas.id
      // })
      commit('DELETE_LINK', datas);
      // .catch(error => { console.log(error) })
    },
    addSelectionToExhibition: function addSelectionToExhibition(_ref11, datas) {
      var _this4 = this;

      var commit = _ref11.commit,
          state = _ref11.state;

      console.log(datas);
      // commit('ADD_SELECTION_TO_EXHIBITION', datas)
      var url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/exhibitions/' + datas.id + '/selections.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(url, { selection: state.currentSelection }).then(function (response) {
        _this4.result = response.data;
        // commit('ADD_SELECTION_TO_EXHIBITION', response.data)
        _this4.dispatch('loadExhibitions');
      }).catch(function (error) {
        // console.log(error)
      });
    },
    updateArtwork: function updateArtwork(_ref12, datas) {
      var _this5 = this;

      var commit = _ref12.commit,
          state = _ref12.state;

      var url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artworks/' + datas + '.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(url).then(function (response) {
        _this5.result = response.data;
        commit('UPDATE_ARTWORK', response.data);
      }).catch(function (error) {
        // console.log(error)
      });
    },
    saveTodo: function saveTodo(_ref13, datas) {
      var commit = _ref13.commit,
          state = _ref13.state;

      commit('SAVE_TODO', datas);
    },
    toggleTodo: function toggleTodo(_ref14, datas) {
      var commit = _ref14.commit,
          state = _ref14.state;

      commit('TOGGLE_TODO', datas);
    },

    // addAllRights ({ commit, state }, user) {
    //   user.roles = state.roles
    //   var new_user = state.users.find(u => u.id === user.id)
    //   state.users
    // },
    assignMultipleTagsToCurrentSelection: function assignMultipleTagsToCurrentSelection(_ref15, selectedTags) {
      var commit = _ref15.commit;

      commit('ASSIGN_MULTIPLE_TAGS_TO_SELECTION', { tags: selectedTags });
      // Add your API call logic here if necessary
    },
    addTagsToCurrentSelection: function addTagsToCurrentSelection(_ref16, selectedTags) {
      var commit = _ref16.commit,
          state = _ref16.state;

      // Process each tag and artwork only once
      selectedTags.forEach(function (tag) {
        commit('ADD_TAG_TO_CURRENT_SELECTION', tag);
      });

      // Make the API call to update the backend after processing all tags
      // Assume updateArtworkTags is an API call function you've defined
      // const updatedArtworks = state.currentSelection.map(selectionId => 
      //   state.artworks.find(artwork => artwork.id === selectionId)
      // );
      // updatedArtworks.forEach(artwork => {
      //   const tagIds = artwork.tags.map(tag => tag.id);
      //   updateArtworkTags(artwork.id, tagIds);
      // });
    },
    addTagToCurrentSelection: function addTagToCurrentSelection(_ref17, datas) {
      var commit = _ref17.commit,
          state = _ref17.state;

      commit('ADD_TAG_TO_ARTWORKS_IN_CURRENT_SELECTION', datas);
      var artwork = this.$store.state.artworks.find(function (a) {
        return a.id === artworkId;
      });
      var tagIds = artwork.tags.map(function (tag) {
        return tag.id;
      });

      updateArtworkTags(artworkId, tagIds);
    },
    saveHomePage: function saveHomePage(_ref18, path) {
      var _this6 = this;

      var commit = _ref18.commit,
          state = _ref18.state;

      var p = state.profile;
      // console.log('p')
      // console.log(p)
      // console.log(state.profile)
      var url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/users/' + p.id + '.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, { user: { after_login_page: path } }).then(function (response) {
        commit('SAVE_HOME_PAGE_TO_USER', response.data);
        // console.log('response.data')
        // console.log(response.data)
        // console.log(response)
        // state.profile = response.data
        _this6.dispatch('loadUsers');
      }).catch(function (error) {
        // console.log(error)
      });
    },
    loadUser: function loadUser(_ref19, currentUser) {
      var commit = _ref19.commit;

      commit('LOGIN_USER', currentUser);
    },
    addAllRolesToUser: function addAllRolesToUser(_ref20, datas) {
      var commit = _ref20.commit,
          state = _ref20.state;

      commit('ADD_ALL_RIGHTS_TO_USER', datas);
      this.dispatch('loadUsers');
    },
    inverseDeleteRights: function inverseDeleteRights(_ref21, datas) {
      var commit = _ref21.commit,
          state = _ref21.state;

      commit('INVERSE_DELETE_RIGHTS', datas);
      this.dispatch('loadUsers');
    },
    inverseDisable: function inverseDisable(_ref22, datas) {
      var _this7 = this;

      var commit = _ref22.commit,
          state = _ref22.state;

      var u = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, state.users.find(function (u) {
        return u.id === datas;
      }));
      u.enable = u.enable === 'Y' ? 'N' : 'Y';
      var url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/users/' + u.id + '.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, { user: u }).then(function (response) {
        _this7.dispatch('loadUsers');
      }).catch(function (error) {
        // console.log(error)
      });
      // commit('INVERSE_DISABLE', datas)
    },
    removeAllRolesFromUser: function removeAllRolesFromUser(_ref23, datas) {
      var commit = _ref23.commit,
          state = _ref23.state;

      commit('REMOVE_ALL_RIGHTS_TO_USER', datas);
      this.dispatch('loadUsers');
    },
    saveOptions: function saveOptions(_ref24, datas) {
      var commit = _ref24.commit,
          state = _ref24.state;

      commit('SAVE_OPTIONS', datas);
    },
    addNew: function addNew(_ref25, datas) {
      var commit = _ref25.commit,
          state = _ref25.state;

      commit('ADD_NEW', datas);
    },
    setShowSearch: function setShowSearch(_ref26, datas) {
      var commit = _ref26.commit,
          state = _ref26.state;

      commit('SAVE_SHOW_SEARCH', datas);
    },
    setSearchString: function setSearchString(_ref27, datas) {
      var commit = _ref27.commit,
          state = _ref27.state;

      commit('SAVE_SEARCH_STRING', datas);
    },
    setPageNumber: function setPageNumber(_ref28, datas) {
      var commit = _ref28.commit,
          state = _ref28.state;

      commit('SAVE_PAGE_NUMBER', datas);
    },
    saveView: function saveView(_ref29, datas) {
      var commit = _ref29.commit,
          state = _ref29.state;

      commit('SAVE_VIEW', datas);
    },
    setCurrentUser: function setCurrentUser(_ref30, datas) {
      var commit = _ref30.commit,
          state = _ref30.state;

      commit('SET_USER', datas);
    },

    // updateUser({ commit, state }, datas) {
    //   commit('UPDATE_USER', datas)
    // },
    saveArtists: function saveArtists(_ref31, datas) {
      var commit = _ref31.commit,
          state = _ref31.state;

      commit('SET_ARTISTS', datas);
    },
    createTag: function createTag(_ref32, datas) {
      var commit = _ref32.commit,
          state = _ref32.state;

      commit('CREATE_TAG', datas);
    },
    deleteTag: function deleteTag(_ref33, datas) {
      var commit = _ref33.commit,
          state = _ref33.state;

      // console.log(datas)
      commit('DELETE_TAG', datas);
    },
    postFilterResults: function postFilterResults(_ref34, datas) {
      var commit = _ref34.commit,
          state = _ref34.state;

      commit('SET_FILTER_RESULTS', datas);
    },


    // CURRENT SELECTION
    addToCurrentSelection: function addToCurrentSelection(_ref35, datas) {
      var commit = _ref35.commit,
          state = _ref35.state;

      commit('ADD_TO_CURRENT_SELECTION', datas);
    },
    saveCurrentSelection: function saveCurrentSelection(_ref36, datas) {
      var commit = _ref36.commit,
          state = _ref36.state;

      commit('SET_CURRENT_SELECTION', datas);
    },
    clearCurrentSelection: function clearCurrentSelection(_ref37) {
      var commit = _ref37.commit;

      commit('CLEAR_CURRENT_SELECTION');
    },
    clearCurrentSelectionLists: function clearCurrentSelectionLists(_ref38) {
      var commit = _ref38.commit;

      commit('CLEAR_CURRENT_SELECTION_LISTS');
    },
    removeFromCurrentSelection: function removeFromCurrentSelection(_ref39, datas) {
      var commit = _ref39.commit,
          state = _ref39.state;

      commit('REMOVE_FROM_CURRENT_SELECTION', datas);
    },
    saveCurrentListSelection: function saveCurrentListSelection(_ref40, datas) {
      var commit = _ref40.commit,
          state = _ref40.state;

      commit('SET_CURRENT_LIST_SELECTION', datas);
    },


    // LISTS / SELECTION
    removeArtworkFromList: function removeArtworkFromList(_ref41, datas) {
      var commit = _ref41.commit,
          state = _ref41.state;

      commit('REMOVE_ARTWORK_FROM_LIST', datas);
    },
    removeArtworkFromExhibition: function removeArtworkFromExhibition(_ref42, datas) {
      var commit = _ref42.commit,
          state = _ref42.state;

      commit('REMOVE_ARTWORK_FROM_EXHIBITION', datas);
      this.dispatch('loadExhibitions');
    },


    // PDF
    saveArtworksForPdf: function saveArtworksForPdf(_ref43, datas) {
      var commit = _ref43.commit,
          state = _ref43.state;

      commit('SET_ARTWORKS_FOR_PDF', datas);
    },
    saveCurrentOutputFieldsSelection: function saveCurrentOutputFieldsSelection(_ref44, datas) {
      var commit = _ref44.commit,
          state = _ref44.state;

      commit('SET_CURRENT_OUTPUT_FIELDS_SELECTION', datas);
    },
    saveCurrentSelectionToUser: function saveCurrentSelectionToUser(_ref45, datas) {
      var commit = _ref45.commit,
          state = _ref45.state;

      commit('SAVE_CURRENT_SELECTION_TO_USER', datas);
    },
    removeFromSelections: function removeFromSelections(_ref46, datas) {
      var commit = _ref46.commit,
          state = _ref46.state;

      commit('REMOVE_FROM_SELECTIONS', datas);
    },
    saveCurrentSelectionTags: function saveCurrentSelectionTags(_ref47, datas) {
      var commit = _ref47.commit,
          state = _ref47.state;

      commit('SET_CURRENT_SELECTION_TAGS', datas);
    },
    saveCurrentTab: function saveCurrentTab(_ref48, datas) {
      var commit = _ref48.commit,
          state = _ref48.state;

      commit('SET_CURRENT_TAB', datas);
    },
    saveCurrentTabArtist: function saveCurrentTabArtist(_ref49, datas) {
      var commit = _ref49.commit,
          state = _ref49.state;

      commit('SET_CURRENT_TAB_ARTIST', datas);
    },
    saveSelectedColumnsForPdf: function saveSelectedColumnsForPdf(_ref50, datas) {
      var commit = _ref50.commit,
          state = _ref50.state;

      commit('SET_SELECTED_COLUMNS_FOR_PDF', datas);
    },
    addTodo: function addTodo(_ref51, datas) {
      var commit = _ref51.commit,
          state = _ref51.state;

      commit('ADD_TODO', datas);
    },
    addLog: function addLog(_ref52, datas) {
      var commit = _ref52.commit,
          state = _ref52.state;

      commit('ADD_LOG', datas);
    },
    addLink: function addLink(_ref53, datas) {
      var commit = _ref53.commit,
          state = _ref53.state;

      commit('ADD_LINK', datas);
    },
    addArtistLink: function addArtistLink(_ref54, datas) {
      var commit = _ref54.commit,
          state = _ref54.state;

      commit('ADD_ARTIST_LINK', datas);
    },
    deleteArtistLink: function deleteArtistLink(_ref55, datas) {
      var commit = _ref55.commit,
          state = _ref55.state;

      commit('DELETE_ARTIST_LINK', datas);
    },
    addText: function addText(_ref56, datas) {
      var commit = _ref56.commit,
          state = _ref56.state;

      commit('ADD_TEXT', datas);
    },
    addPacking: function addPacking(_ref57, datas) {
      var commit = _ref57.commit,
          state = _ref57.state;

      commit('ADD_PACKING', datas);
    },
    addExhibition: function addExhibition(_ref58, datas) {
      var commit = _ref58.commit,
          state = _ref58.state;

      commit('ADD_EXHIBITION', datas);
    },
    addReadingDevice: function addReadingDevice(_ref59, datas) {
      var commit = _ref59.commit,
          state = _ref59.state;

      commit('ADD_READING_DEVICE', datas);
    },
    addElectrical: function addElectrical(_ref60, datas) {
      var commit = _ref60.commit,
          state = _ref60.state;

      commit('ADD_ELECTRICAL', datas);
    },
    deleteExhibition: function deleteExhibition(_ref61, datas) {
      var _this8 = this;

      var commit = _ref61.commit,
          state = _ref61.state;

      commit('DELETE_EXHIBITION', datas);
      var url = __WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/exhibitions/' + datas.id + '.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(url, datas).then(function (response) {
        _this8.getExhibitions;
        __WEBPACK_IMPORTED_MODULE_11__main__["serverBus"].$emit('showSnackbar', 'Exhibition deleted.', 'rgba(0, 125, 0, 0.8)');
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_11__main__["serverBus"].$emit('showSnackbar', 'Error occuredd while deleting Exhibition.', 'rgba(125, 0, 0, 0.8)');
        console.log(error);
      });
    },
    deleteDevice: function deleteDevice(_ref62, datas) {
      var commit = _ref62.commit,
          state = _ref62.state;

      commit('DELETE_DEVICE', datas);
    },
    addArtwork: function addArtwork(_ref63, datas) {
      var commit = _ref63.commit,
          state = _ref63.state;

      commit('ADD_ARTWORK', datas);
    },
    addArtist: function addArtist(_ref64, datas) {
      var commit = _ref64.commit,
          state = _ref64.state;

      commit('ADD_ARTIST', datas);
    },
    removeText: function removeText(_ref65, datas) {
      var commit = _ref65.commit,
          state = _ref65.state;

      commit('REMOVE_TEXT', datas);
    },
    setSorting: function setSorting(_ref66, datas) {
      var commit = _ref66.commit,
          state = _ref66.state;

      commit('SET_SORTING', datas);
    },
    setFilter: function setFilter(_ref67, datas) {
      var commit = _ref67.commit,
          state = _ref67.state;

      // console.log(datas)
      commit('SET_FILTER', datas);
    },
    loadRoles: function loadRoles(_ref68) {
      var commit = _ref68.commit;

      commit('SET_LOADING', 'roles');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/roles.json').then(function (r) {
        return r.data;
      }).then(function (Roles) {
        commit('SET_ROLES', Roles);
        commit('UNSET_LOADING', 'roles');
        // localStorage.setItem('roles', JSON.stringify(Roles))
        // console.log('Roles loaded')
      });
    },
    loadArtworkInsuranceLogs: function loadArtworkInsuranceLogs(_ref69) {
      var commit = _ref69.commit,
          state = _ref69.state;

      // if (localStorage.getItem('user-token')) {
      if (!state.loading_artwork_insurance_logs) {
        commit('SET_LOADING', 'artwork_insurance_logs');
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artwork_insurance_logs.json', {
          params: {
            user_id: 1
            // localStorage.getItem('user-token')
          }
        }).then(function (r) {
          return r.data;
        }).then(function (artwork_insurance_logs) {
          commit('SET_ARTWORK_INSURANCE_LOGS', artwork_insurance_logs);
          commit('UNSET_LOADING', 'artwork_insurance_logs');
          // try {
          //   localStorage.setItem('artworks', JSON.stringify(Artworks))
          // } catch (error) {
          //   console.log('VUEX ERROR!!! COULD NOT SAVE ARTWORKS TO LOCAL STORAGE')
          //   console.log(error)
          // }
          console.log('Artwork Insurance Logs loaded');
        });
      } else {
        console.log('VUEX: ARTWORK Insurance Logs ALREADY LOADING');
      }
      // }
    },
    loadArtworkLocationLogs: function loadArtworkLocationLogs(_ref70) {
      var commit = _ref70.commit,
          state = _ref70.state;

      // if (localStorage.getItem('user-token')) {
      if (!state.loading_artwork_location_logs) {
        commit('SET_LOADING', 'artwork_location_logs');
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artwork_location_logs.json', {
          params: {
            user_id: 1
            // localStorage.getItem('user-token')
          }
        }).then(function (r) {
          return r.data;
        }).then(function (ArtworkLocationLogs) {
          commit('SET_ARTWORK_LOCATION_LOGS', ArtworkLocationLogs);
          commit('UNSET_LOADING', 'artwork_location_logs');
          // try {
          //   localStorage.setItem('artworks', JSON.stringify(Artworks))
          // } catch (error) {
          //   console.log('VUEX ERROR!!! COULD NOT SAVE ARTWORKS TO LOCAL STORAGE')
          //   console.log(error)
          // }
          console.log('Artwork Location Logs loaded');
        });
      } else {
        console.log('VUEX: ARTWORK Location Logs ALREADY LOADING');
      }
      // }
    },
    loadArtworks: function loadArtworks(_ref71) {
      var commit = _ref71.commit,
          state = _ref71.state;

      // if (localStorage.getItem('user-token')) {
      if (!state.loading_artworks) {
        commit('SET_LOADING', 'artworks');
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artworks.json', {
          params: {
            user_id: state.user_id
            // user_id: 1
            // localStorage.getItem('user-token')
          }
        }).then(function (r) {
          return r.data;
        })
        // add to each artwork new atribute accession_number_for_sorting consisting of the first number in the accession_number and 
        // the number after dot with leading zeros added to the number after dot so that it always has 3 digits
        .then(function (Artworks) {
          Artworks.forEach(function (artwork) {
            var accession_number_for_sorting = artwork.accession_number.match(/\d+/g);
            if (accession_number_for_sorting) {
              accession_number_for_sorting = accession_number_for_sorting[0] + '.' + ('000' + accession_number_for_sorting[1]).slice(-3);
            } else {
              accession_number_for_sorting = '0.000';
            }
            artwork.accession_number_for_sorting = accession_number_for_sorting;
          });

          commit('SET_ARTWORKS', Artworks);
          commit('UNSET_LOADING', 'artworks');
          try {
            localStorage.setItem('artworks', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(Artworks));
          } catch (error) {
            console.log('VUEX ERROR!!! COULD NOT SAVE ARTWORKS TO LOCAL STORAGE');
            console.log(error);
          }
          console.log('Slow Artworks loaded');
        });
      } else {
        console.log('VUEX: ARTWORKS ALREADY LOADING');
      }
      // }
    },
    loadArtworksFast: function loadArtworksFast(_ref72) {
      var commit = _ref72.commit,
          state = _ref72.state;

      if (state.user.id) {
        commit('SET_LOADING', 'artworks');
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artworks_index_fast.json', {
          params: {
            user_id: state.user_id
          }
        }).then(function (r) {
          return r.data;
        }).then(function (Artworks) {
          commit('SET_ARTWORKS_FAST', Artworks);
          commit('UNSET_LOADING', 'artworks');
          // localStorage.setItem('artworks', JSON.stringify(Artworks))
          // console.log('Fast Artworks loaded')
        });
      }
    },
    loadFileUploads: function loadFileUploads(_ref73) {
      var commit = _ref73.commit;

      commit('SET_LOADING', true);
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/file_uploads.json').then(function (r) {
        return r.data;
      }).then(function (FileUploads) {
        commit('SET_FILE_UPLOADS', FileUploads);
        commit('SET_LOADING', false);
      });
    },
    loadUsers: function loadUsers(_ref74) {
      var commit = _ref74.commit;

      commit('SET_LOADING', 'users');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/users.json').then(function (r) {
        return r.data;
      }).then(function (Users) {
        commit('SET_USERS', Users);
        commit('UNSET_LOADING', 'users');
        // localStorage.setItem('users', JSON.stringify(Users))
        // console.log('Users loaded')
      });
    },
    loadLocations: function loadLocations(_ref75) {
      var commit = _ref75.commit;

      commit('SET_LOADING', 'locations');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artwork_locations.json').then(function (r) {
        return r.data;
      }).then(function (Locations) {
        commit('SET_LOCATIONS', Locations);
        commit('UNSET_LOADING', 'locations');
        // localStorage.setItem('locations', JSON.stringify(Locations))
        console.log('Locations loaded');
      });
    },
    loadContacts: function loadContacts(_ref76) {
      var commit = _ref76.commit;

      commit('SET_LOADING', 'contacts');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/contacts.json').then(function (r) {
        return r.data;
      }).then(function (Contacts) {
        commit('SET_CONTACTS', Contacts);
        commit('UNSET_LOADING', 'contacts');
        // localStorage.setItem('contacts', JSON.stringify(Contacts))
        console.log('Contacts loaded');
      });
    },
    loadExhibitions: function loadExhibitions(_ref77) {
      var commit = _ref77.commit,
          state = _ref77.state;

      // if (localStorage.getItem('user-token')) {
      commit('SET_LOADING', 'exhibitions');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/exhibitions.json', {
        params: {
          user_id: 1
          // localStorage.getItem('user-token')
        }
      })
      // .get(`${Vue.prototype.$globals.apiserver}/exhibitions.json`)
      .then(function (r) {
        return r.data;
      }).then(function (Exhibitions) {
        commit('SET_EXHIBITIONS', Exhibitions);
        commit('UNSET_LOADING', 'exhibitions');
        // localStorage.setItem('exhibitions', JSON.stringify(Exhibitions))
        console.log('Exhibitions loaded');
      });
      // }
    },
    loadArtists: function loadArtists(_ref78) {
      var commit = _ref78.commit,
          state = _ref78.state;

      commit('SET_LOADING', 'artists');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artists.json', {
        params: {
          user_id: localStorage.getItem('user-token')
        }
      }).then(function (r) {
        return r.data;
      }).then(function (Artists) {
        commit('SET_ARTISTS', Artists);
        commit('UNSET_LOADING', 'artists');
        localStorage.setItem('artists', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(Artists));
        console.log('Artists loaded');
      });
    },
    loadLists: function loadLists(_ref79) {
      var commit = _ref79.commit;

      commit('SET_LOADING', 'lists');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/lists.json').then(function (r) {
        return r.data;
      }).then(function (Lists) {
        commit('SET_LISTS', Lists);
        commit('UNSET_LOADING', 'lists');
        // localStorage.setItem('lists', JSON.stringify(Lists))
        console.log('Lists loaded');
      });
    },
    loadTodos: function loadTodos(_ref80) {
      var commit = _ref80.commit;

      commit('SET_LOADING', 'todos');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artwork_todos.json').then(function (r) {
        return r.data;
      }).then(function (Todos) {
        commit('SET_TODOS', Todos);
        commit('UNSET_LOADING', 'todos');
        // localStorage.setItem('todos', JSON.stringify(Todos))
        console.log('Todos loaded');
      });
    },
    loadTags: function loadTags(_ref81) {
      var commit = _ref81.commit;

      commit('SET_LOADING', 'tags');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/tags.json').then(function (r) {
        return r.data;
      }).then(function (tags) {
        commit('SET_TAGS', tags);
        commit('UNSET_LOADING', 'tags');
        // localStorage.setItem('tags', JSON.stringify(tags))
        console.log('Tags loaded');
      });
    },
    loadTagCategories: function loadTagCategories(_ref82) {
      var commit = _ref82.commit;

      commit('SET_LOADING', 'tag_categories');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/tag_categories.json').then(function (r) {
        return r.data;
      }).then(function (tagCategories) {
        commit('SET_TAG_CATEGORIES', tagCategories);
        commit('UNSET_LOADING', 'tag_categories');
        // localStorage.setItem('tags', JSON.stringify(tags))
        console.log('Tag categories loaded');
      });
    },
    loadTexts: function loadTexts(_ref83) {
      var commit = _ref83.commit,
          state = _ref83.state;

      if (localStorage.getItem('user-token')) {
        commit('SET_LOADING', 'texts');
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artwork_texts.json', {
          params: {
            user_id: localStorage.getItem('user-token')
          }
        })
        // .get(`${Vue.prototype.$globals.apiserver}/artwork_texts.json`)
        .then(function (r) {
          return r.data;
        }).then(function (texts) {
          commit('SET_TEXTS', texts);
          commit('UNSET_LOADING', 'texts');
          // localStorage.setItem('texts', JSON.stringify(texts))
          console.log('Texts loaded');
        });
      }
    },
    loadPackings: function loadPackings(_ref84) {
      var commit = _ref84.commit;

      commit('SET_LOADING', 'packings');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/artwork_packings.json').then(function (r) {
        return r.data;
      }).then(function (packings) {
        commit('SET_PACKINGS', packings);
        commit('UNSET_LOADING', 'packings');
        // localStorage.setItem('packings', JSON.stringify(packings))
        console.log('Packings loaded');
      });
    },
    loadSupportArticles: function loadSupportArticles(_ref85) {
      var commit = _ref85.commit;

      commit('SET_LOADING', 'support_articles');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/support_articles.json').then(function (r) {
        return r.data;
      }).then(function (supportArticles) {
        commit('SET_SUPPORT_ARTICLES', supportArticles);
        commit('UNSET_LOADING', 'support_articles');
        localStorage.setItem('support_articles', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(supportArticles));
        console.log('Support Articles loaded');
        // console.log(supportArticles)
      });
    },
    loadJournals: function loadJournals(_ref86) {
      var commit = _ref86.commit;

      commit('SET_LOADING', 'journals');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/journals.json').then(function (r) {
        return r.data;
      }).then(function (Journals) {
        commit('SET_JOURNALS', Journals);
        commit('UNSET_LOADING', 'journals');
        // localStorage.setItem('journals', JSON.stringify(Journals))
        console.log('Journals loaded');
      });
    },
    loadQuestions: function loadQuestions(_ref87) {
      var commit = _ref87.commit;

      commit('SET_LOADING', 'questions');
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].prototype.$globals.apiserver + '/questions.json').then(function (r) {
        return r.data;
      }).then(function (Questions) {
        commit('SET_QUESTIONS', Questions);
        commit('UNSET_LOADING', 'questions');
        // localStorage.setItem('questions', JSON.stringify(Questions))
        console.log('Questions loaded');
      });
    }
  },
  getters: {
    formattedTags: function formattedTags(state) {
      // console.log(this.$store.getters.conceptual_tags.length);
      // console.log(this.$store.getters.cataloguing_tags.length);

      var tags = state.tags.filter(function (t) {
        return t.section == 'cataloguing' || t.section == 'concept';
      }).sort(function (a, b) {
        return a.subcategory.localeCompare(b.subcategory);
      })
      // var con_tags = state.getters.conceptual_tags.sort((a, b) => a.subcategory.localeCompare(b.subcategory))
      .map(function (tag) {
        return {
          label: tag.subcategory + ' #' + tag.name,
          subcategory: tag.subcategory,
          section: tag.section,
          name: tag.name,
          id: tag.id
        };
      });
      // var cat_tags = state.getters.cataloguing_tags.sort((a, b) => a.subcategory.localeCompare(b.subcategory))
      //     .map((tag) => ({
      //         label: `${tag.subcategory} #${tag.name}`,
      //         name: tag.name,
      //         id: tag.id,
      //     }));
      // return con_tags.concat(cat_tags).sort((a, b) => a.name.localeCompare(b.name));
      return tags;
    },

    tagNames: function tagNames(state) {
      return state.tags.map(function (tag) {
        return tag.section + ' - ' + tag.subcategory + ' #' + tag.name;
      }).filter(function (name) {
        return name !== null;
      });
    },
    cataloguing_tags: function cataloguing_tags(state) {
      return state.tags.filter(function (t) {
        return t.section == 'cataloguing';
      }).sort();
    },
    cataloguing_tag_subcategories: function cataloguing_tag_subcategories(state) {
      // return unique subcategories of tags in section "cataloguing"
      var array = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], state.tags.filter(function (t) {
        return t.section == 'cataloguing';
      }));
      var unique = [];
      var distinct = [];
      for (var i = 0; i < array.length; i++) {
        if (!unique[array[i].subcategory]) {
          if (array[i].subcategory != null) {
            distinct.push({ subcategory: array[i].subcategory, section: array[i].section });
            unique[array[i].subcategory] = 1;
          }
        }
      }
      return distinct.sort();
      // return state.tags.filter(t => t.section == 'concept' && t.concept_tag == 1).sort()
      // return state.tags.filter(t => t.section == 'cataloguing' && t.subcategory == t.name).sort()
    },
    conceptual_tags: function conceptual_tags(state) {
      return state.tags.filter(function (t) {
        return t.section == 'concept';
      }).sort();
    },
    conceptual_tag_categories: function conceptual_tag_categories(state) {
      // return state.tags.filter(t => t.section == 'concept' && t.concept_tag == 1).sort()
      return state.tags.filter(function (t) {
        return t.section == 'concept' && t.subcategory == t.name;
      }).sort();
    },
    // conceptual_tag_categories: state => {
    //   var array = Object.assign([], this.conceptual_tags)
    //   var unique = [];
    //   var distinct = [];
    //   for ( let i = 0; i < array.length; i++ ) {
    //       if ( !unique[array[i].category]) {
    //           if (array[i].category != null) {
    //               distinct.push({ category: array[i].category, section: array[i].section });
    //               unique[array[i].category] = 1;
    //           }
    //       }
    //   }
    //   return distinct.sort()
    // },
    tag_categories: function tag_categories(state) {
      var array = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], state.tags);
      var unique = [];
      var distinct = [];
      for (var i = 0; i < array.length; i++) {
        if (!unique[array[i].category]) {
          if (array[i].category != null) {
            distinct.push({ category: array[i].category, section: array[i].section });
            unique[array[i].category] = 1;
          }
        }
      }
      return distinct.sort();
    },
    tag_sections: function tag_sections(state) {
      var array = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], state.tags.filter(function (t) {
        return t.section != 'concept';
      }));
      var unique = [];
      var distinct = [];
      for (var i = 0; i < array.length; i++) {
        if (!unique[array[i].section]) {
          if (array[i].section != null) {
            distinct.push(array[i].section);
            unique[array[i].section] = 1;
          }
        }
      }
      return distinct.sort();
    },
    tag_sections_relation: function tag_sections_relation(state) {
      var array = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], state.tags.filter(function (t) {
        return t.section == 'exhibition';
      }));
      var unique = [];
      var distinct = [];
      for (var i = 0; i < array.length; i++) {
        if (!unique[array[i].section]) {
          if (array[i].section != null) {
            distinct.push(array[i].section);
            unique[array[i].section] = 1;
          }
        }
      }
      return distinct.sort();
    },
    locationsSorted: function locationsSorted(state) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], state.locations).sort(dynamicSort('name'));
    },
    current_locations: function current_locations(state) {
      return state.locations.filter(function (l) {
        return l.id > 458 || l.id < 233 || l.id === 237 || l.id === 273;
      });
    },
    enabled_locations: function enabled_locations(state) {
      return state.locations.filter(function (l) {
        return l.disabled != 1;
      });
    },
    my_ownerships: function my_ownerships(state) {
      if (state.user.profile.roles) {
        return __WEBPACK_IMPORTED_MODULE_10__data_constants__["a" /* default */].OWNERSHIPS.filter(function (o) {
          return state.user.profile.roles.find(function (ur) {
            return ur.shortcut === o.role;
          });
        });
      } else {
        return []; // 'no user roles'
      }
    },
    // isAuthenticated: state => !!state.token,
    // authStatus: state => state.status,
    // texts: state => {
    //   return state.texts
    // },
    loading: function loading(state) {
      return state.loading_artworks || state.loading_rules || state.loading_artists || state.loading_contacts || state.loading_users || state.loading_lists || state.loading_locations || state.loading_exhibitions || state.loading_packings || state.loading_texts || state.loading_tags || state.loading_tag_categories || state.loading_todos || state.loading_journals || state.loading_support_articles || state.loading_questions;
    },
    loans: function loans(state) {
      return state.exhibitions.filter(function (a) {
        return a.loan === 1;
      });
    },
    exhibitions: function exhibitions(state) {
      return state.exhibitions.filter(function (a) {
        return a.loan !== 1;
      });
    },
    paintings: function paintings(state) {
      return state.artworks.filter(function (a) {
        return a.classification_new_id === 2;
      });
    },
    drawings: function drawings(state) {
      return state.artworks.filter(function (a) {
        return a.classification_new_id === 1;
      });
    },
    videos: function videos(state) {
      return state.artworks.filter(function (a) {
        return a.classification_new_id === 7;
      });
    },
    sound: function sound(state) {
      return state.artworks.filter(function (a) {
        return a.classification_new_id === 9;
      });
    },
    objectsAndSculptures: function objectsAndSculptures(state) {
      return state.artworks.filter(function (a) {
        return a.classification_new_id === 4;
      });
    },
    // sculptures: state => {
    //   return state.artworks.filter(a => a.classification_new_id === 4)
    // },
    photographs: function photographs(state) {
      return state.artworks.filter(function (a) {
        return a.classification_new_id === 3;
      });
    },
    collection: function collection(state) {
      return state.artworks.filter(function (a) {
        return a.classification_new_id > 0 && a.classification_new_id < 10;
      });
    },
    artistsYoung: function artistsYoung(state) {
      return state.artists.filter(function (a) {
        return getAge(a.birth_date) < 31;
      });
    },
    artistsMid: function artistsMid(state) {
      return state.artists.filter(function (a) {
        return getAge(a.birth_date) > 30 && getAge(a.birth_date) < 51;
      });
    },
    artistsOld: function artistsOld(state) {
      return state.artists.filter(function (a) {
        return getAge(a.birth_date) > 50;
      });
    },
    user_lists: function user_lists(state) {
      return state.lists.filter(function (l) {
        return l.created_by === state.profile.id;
      });
    },
    user_todos: function user_todos(state) {
      return state.todos.filter(function (l) {
        return l.created_by === state.profile.id;
      });
    }
  },
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_8__modules_user__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_9__modules_auth__["a" /* default */]
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
}));
// types_of_work: [
//   // THIS IS AS IN THE TABLE ARTWORK_TYPES
//   { id: 1, value: 1, name: 'Drawing' },
//   { id: 2, value: 2, name: 'Painting' },
//   { id: 3, value: 3, name: 'Photo / Print' },
//   { id: 5, value: 5, name: 'Architecture' },
//   { id: 4, value: 4, name: 'Object / Sculpture' },
//   { id: 10, value: 10, name: 'Furniture' },
//   { id: 6, value: 6, name: 'Installation' },
//   { id: 7, value: 7, name: 'Film / Video' },
//   { id: 9, value: 9, name: 'Sound' },
//   { id: 8, value: 8, name: 'Performance' },
//   { id: 11, value: 11, name: 'Concept' },
//   { id: 12, value: 12, name: 'Metalworks' },
//   { id: 13, value: 13, name: 'Vertu' },
//   { id: 14, value: 14, name: 'Oriental' },
//   { id: 15, value: 15, name: 'Silverware' },
//   { id: 17, value: 17, name: 'Jewellery' },
//   { id: 16, value: 16, name: 'Textiles' },
//   { id: 18, value: 18, name: 'Collage' }
// ],

// import CommonMixin from './../mixins/CommonMixin.js'
// Vue.mixin(CommonMixin)
// import * as actions from './actions'
// import * as getters from './getters'
// import list from './modules/list'
// import users from './modules/users/users.module'

// function dynamicSort (property) {
//   var sortOrder = 1
//   if (property[0] === '-') {
//     sortOrder = -1
//     property = property.substr(1)
//   }
//   return function (a, b) {
//     var result =
//       a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
//     return result * sortOrder
//   }
// }

// function humanize (str) {
//   var frags = str.split('_')
//   for (let i = 0; i < frags.length; i++) {
//     frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
//   }
//   return frags.join(' ')
// }
// tag_categories: [
//   { id: 1, name: 'TBA21 Exhibition', color: 'red', position: 2 },
//   { id: 2, name: 'TBA21 Production', color: 'green', position: 3 },
//   { id: 3, name: 'FTB Sorting', color: 'blue', position: 1 },
//   { id: 4, name: 'TBA21 Projects', color: 'yellow', position: 4 },
//   { id: 5, name: 'TBA21 Events', color: 'pink', position: 5 },
//   { id: 6, name: 'Exhibitions', color: 'grey', position: 6 },
//   { id: 7, name: 'Institutions', color: 'purple', position: 7 }
// ],

/***/ }),

/***/ "Iie8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Ij7b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            selectedTags: [],
            tags: [],
            replace: false
        };
    },

    computed: {
        formattedTags: function formattedTags() {
            console.log(this.$store.getters.conceptual_tags.length);
            console.log(this.$store.getters.cataloguing_tags.length);
            var con_tags = this.$store.getters.conceptual_tags.sort(function (a, b) {
                return a.subcategory.localeCompare(b.subcategory);
            }).map(function (tag) {
                return {
                    label: tag.subcategory + ' #' + tag.name,
                    name: tag.name,
                    id: tag.id
                };
            });
            var cat_tags = this.$store.getters.cataloguing_tags.sort(function (a, b) {
                return a.subcategory.localeCompare(b.subcategory);
            }).map(function (tag) {
                return {
                    label: tag.subcategory + ' #' + tag.name,
                    name: tag.name,
                    id: tag.id
                };
            });
            return con_tags.concat(cat_tags).sort(function (a, b) {
                return a.name.localeCompare(b.name);
            });
        }
    },
    mounted: function mounted() {
        this.tags = this.$store.getters.conceptual_tags;
    },

    methods: {
        remove: function remove(item) {
            // find index of item in selectedTags by id of item
            var index = this.selectedTags.indexOf(item.id);
            if (index >= 0) this.selectedTags.splice(index, 1);
        },
        assignTags: function assignTags() {
            var _this = this;

            // load whole tag objects from store from tag ids in this.selectedTags
            var selectedTagsObjects = [];
            for (var i = 0; i < this.selectedTags.length; i++) {
                selectedTagsObjects[i] = this.formattedTags.find(function (tag) {
                    return tag.id === _this.selectedTags[i];
                });
            }

            this.$store.dispatch('assignMultipleTagsToCurrentSelection', selectedTagsObjects);

            var payload = {
                selectedArtworks: this.$store.state.currentSelection, // Array of selected artwork IDs
                selectedTags: this.selectedTags, // Array of selected tag IDs
                replace: this.replace // Boolean indicating whether to replace or add tags
            };

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$globals.apiserver + '/artworks/update_tags', payload).then(function (response) {
                // Handle success
                console.log('Tags updated successfully', response);
            }).catch(function (error) {
                // Handle error
                console.error('Error updating tags', error);
            });
        }
    }
});

/***/ }),

/***/ "Ik33":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"xs12":""}},[(_vm.artist_artworks(_vm.artist.id).length > 0)?_c('v-container',{staticClass:"py-0 mt-0 mb-3 pl-0 pr-0",attrs:{"fluid":"","xs12":""}},[_c('v-layout',{staticClass:"xs12 mx-0 px-0 my-0 row wrap"},_vm._l((_vm.artist_artworks(_vm.artist.id)),function(item,index){return _c('v-flex',{key:index,attrs:{"xs12":"","mt-3":""}},[_c('v-layout',{staticClass:"justify-end row fill-height/"},[_c('v-flex',{staticClass:"shrink ml-0 pl-0 subheading justify-start text-truncate font-weight-light"},[_c('router-link',{staticClass:"link",attrs:{"to":{ name: 'EditArtwork', params: {id: item.id, artwork: item}, path: ("/artworks/edit/" + (item.id))}}},[_c('b',[_vm._v(_vm._s(item.title)+" ")]),_c('v-icon',{staticStyle:{"padding-bottom":"2px","padding-left":"4px"},attrs:{"small":"","color":"black"}},[_vm._v("open_in_new")])],1),_vm._v(" "),_c('div',{staticStyle:{"line-height":"2em","border-top":"1px solid black","margin-top":"5px"}},[_vm._v("\n                  "+_vm._s(item.accession_number)+" - "+_vm._s(_vm.getOwnershipName(item.ownership))),_c('br')])],1),_vm._v(" "),_c('v-flex',{attrs:{"grow":"","text-xs-right":"","ml-4":""}},[(_vm.get_texts(item.id).length > 0)?_c('v-menu',{staticClass:"elevation-0",attrs:{"offset-y":"","close-on-content-click":false,"nudge-width":0,"bottom":"","left":""}},[_c('template',{slot:"activator"},[_c('v-btn',{staticClass:"mt-2",attrs:{"small":"","icon":"","color":"black"}},[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("mdi-text-subject")])],1)],1),_vm._v(" "),_c('v-list',{staticClass:"px-0",attrs:{"one-line":"","elevation-0":""}},_vm._l((_vm.get_texts(item.id)),function(text){return _c('v-list-tile',{key:text.id,staticClass:"my-0 py-0",on:{"click":function($event){return _vm.download_text(text,item)}}},[_c('v-btn',{attrs:{"small":"","icon":"","color":"black"}},[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("mdi-download")])],1),_vm._v("\n                      "+_vm._s(text.title)+"\n                    ")],1)}),1)],2):_vm._e()],1)],1)],1)}),1)],1):_c('div',{staticClass:"align-items-start justify-start flex"},[_c('span',{staticClass:"my-0 body-1 py-0 mx-0 px-1 text-xs-left flex align-start justify-start"},[_vm._v("No Artworks")])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "Im8P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ExcelPackings__ = __webpack_require__("YTmu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__("NHnr");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      sorting: 'colli',
      editing: false,
      constants: __WEBPACK_IMPORTED_MODULE_4__data_constants__["a" /* default */],
      selected: [],
      menu_storage_out: false,
      menu_storage_in: false,
      dialog: false,
      editDialog: false,
      deleteDialog: false,
      itemToDelete: null,
      dialog2: false,
      p: {
        sortBy: 'colli',
        rowsPerPage: -1
      },
      headers: [{ text: 'Colli', align: 'left', sortable: true, value: 'colli' }, { text: 'Packing', align: 'left', value: 'packing', sortable: true }, {
        text: 'Location',
        align: 'center',
        value: 'artwork_location_id',
        sortable: true
      }, { text: 'Contents', align: 'left', value: 'contents', sortable: true }, {
        text: 'Visa Status',
        align: 'center',
        value: 'visa_status',
        sortable: true
      }, {
        text: 'H x W x L',
        align: 'center',
        value: 'height',
        sortable: true
      }, { text: 'Weight (kg)', align: 'center', value: 'weight', sortable: true }, { text: '', align: 'right', sortable: false }],
      editedIndex: -1,
      show: false,
      showUpload: false,
      packing: {
        packing: '',
        height: '',
        lenght: '',
        width: '',
        weight: '',
        contents: '',
        created_by: '',
        colli: '',
        visa_status: '',
        artwork_id: '',
        location_id: '',
        artwork_location_id: ''
      },
      updated_packing: {
        packing: '',
        height: '',
        length: '',
        width: '',
        weigth: '',
        contents: '',
        created_by: '',
        colli: '',
        // note: '',
        visa_status: '',
        artwork_id: '',
        location_id: '',
        artwork_location_id: ''
      }
    };
  },
  computed: {
    all_packings: function all_packings() {
      return this.$store.state.packings;
    },
    selection_items: function selection_items() {
      var artworkLocations = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.getters.enabled_locations);
      return artworkLocations.sort(dynamicSort('name'));
    }
  },
  methods: {
    setSorting: function setSorting(s) {
      // console.log('receive')
      // console.log(s)
      this.sorting = s;
      this.p.sortBy = s;
      this.p.descending = !this.p.descending;
    },
    newItem: function newItem() {
      this.dialog = true;
      this.packing = {
        packing: '',
        height: '',
        lenght: '',
        width: '',
        weight: '',
        contents: '',
        colli: '',
        created_by: '',
        location_id: '',
        visa_status: '',
        artwork_id: '',
        artwork_location_id: this.artwork.artwork_location_id
      };
    },
    editItem: function editItem(i) {
      ;this.packing = i,
      //  {
      //   packing: '',
      //   height: '',
      //   lenght: '',
      //   width: '',
      //   weight: '',
      //   contents: '',
      //   colli: '',
      //   visa_status: '',
      //   artwork_id: '',
      //   artwork_location_id: ''
      // }
      this.saving = false;
      this.editing = true;
      this.dialog = true;
      // try {
      //   this.packing = Object.assign(
      //     {},
      //     this.artwork.artwork_packings.find(t => t.id == i.id)
      //   )
      //   this.showDialog = true
      // } catch (error) {
      //   // console.log(error.message)
      // }
    },

    // saveOrEdit (){
    //     this.progress = true
    //     var value_to_save = this.field_value
    //     if (this.field_type == 'toggle'){
    //       value_to_save = this.toggle
    //     }
    //     if (saveOK) {
    //       // console.log('saveOK')
    //       this.saveField(value_to_save)
    //     } else {
    //       this.cannotSave = true
    //         setTimeout(() => {
    //           this.cannotSave = false
    //         }, 4000);
    //     }
    //   }
    // },
    saveField: function saveField() {
      var _this = this;

      this.$emit('showSnackbar', 'Saving Packing Specification.', 'black');
      setTimeout(function () {
        var url = _this.$globals.apiserver + '/artworks/' + _this.artwork.id + '.json';
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url, {
          field_name: 'transport_history',
          field_value: _this.artwork.transport_history
        }).then(function (response) {
          _this.progress = false;
          _this.$emit('showSnackbar', 'Packing Specification saved.', 'green');
        }).catch(function (error) {
          // console.log(error)
        });
      }, 1000);
    },
    close: function close() {
      this.dialog = false;
      this.editing = false;
      this.resetPacking();
    },

    // initialize () {},
    showDeleteDialog: function showDeleteDialog(p) {
      this.itemToDelete = p;
      this.deleteDialog = true;
    },
    deleteItem: function deleteItem() {
      var index = this.artwork.artwork_packings.indexOf(this.itemToDelete);
      var i = this.artwork.artwork_packings.indexOf(this.itemToDelete);
      if (i != -1) {
        this.artwork.artwork_packings.splice(i, 1);
      }
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      this.$store.dispatch('deletePacking', this.itemToDelete);
      this.itemToDelete = null;
      this.deleteDialog = false;
    },
    cancelDelete: function cancelDelete() {
      this.deleteDialog = false;
      this.itemToDelete = null;
    },

    // delete_packing () {},
    duplicateItem: function duplicateItem(p) {
      var _this2 = this;

      // console.log(p)
      var packing = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, p);
      delete packing.id;
      // console.log(this.packing)
      packing.artwork_id = this.artwork.id;
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      // this.packing.reject { |k,v| k == :id }
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.$globals.apiserver + '/artwork_packings.json', {
        artwork_packing: packing
      }).then(function (response) {
        _this2.errors = {};
        _this2.artwork.artwork_packings.push(response.data);
        _this2.$store.commit('ADD_PACKING', response.data);
        _this2.$emit('showSnackbar', 'Packing Duplicated.', 'green');
      }).catch(function (error) {
        _this2.errors = error.response.data;
      });
      // console.log(this.packing)
      // this.all_packings.push(this.packing)
      this.showUpload = !this.showUpload;
      this.dialog = false;
      this.resetPacking();
    },
    save: function save() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$emit('showSnackbar', 'Saving Packing', 'black');
      // this.$emit('showSnackbar', 'Saving Packing.', 'black')
      this.saving = true;
      this.packing.artwork_id = this.artwork.id;
      // this.packing.id = this.findMinMax(this.all_packings)+1
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      // this.artwork.artwork_packings.push(this.packing)
      if (this.editing) {
        var url = this.$globals.apiserver + '/artwork_packings/' + this.packing.id + '.json';
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url, {
          artwork_packing: this.packing
        }).then(function (response) {
          _this3.resetPacking();
          _this3.saving = false;
          _this3.editing = false;
          __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$emit('showSnackbar', 'Packing Saved', 'green');
          // this.$emit('showSnackbar', 'Packing Saved.', 'green')
          _this3.$emit('getArtwork');
          _this3.errors = {};
          _this3.artwork.artwork_packings = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this3.artwork.artwork_packings.map(function (item) {
            return item.id !== response.data.id ? item : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, response.data);
          })));
          _this3.close();
          _this3.$store.commit('SAVE_PACKING', response.data);
        }).catch(function (error) {
          // console.log(error)
          _this3.save_error = true;
        });
      } else {
        this.packing.created_by = this.c_user.id;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.$globals.apiserver + '/artwork_packings.json', {
          artwork_packing: this.packing
        }).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$emit('showSnackbar', 'Packing Saved.', 'green');
          _this3.createLocationLogEntry(response.data);
          _this3.$emit('getArtwork');
          _this3.resetPacking();
          _this3.saving = false;
          _this3.close();
          // this.editing = false
          _this3.errors = {};
          _this3.artwork.artwork_packings.push(response.data);
          _this3.$store.commit('ADD_PACKING', response.data);
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$emit('showSnackbar', 'Error creating Packing.', 'red');
          console.log(error);
          // this.errors = error.response.data
        });
        // console.log(this.packing)
        // this.all_packings.push(this.packing)
        this.dialog = false;
        this.packing = {
          packing: '',
          height: '',
          width: '',
          lenght: '',
          weight: '',
          contents: '',
          note: '',
          visa_status: 0,
          colli: '',
          created_by: '',
          location_id: '',
          artwork_location_id: this.artwork.artwork_location_id
        };
      }
    },
    createLocationLogEntry: function createLocationLogEntry(p) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.$globals.apiserver + '/artwork_location_logs.json', {
        artwork_location_log: {
          artwork_packing_id: p.id,
          created_by: this.c_user.id,
          artwork_location_id: p.artwork_location_id,
          artwork_id: p.artwork_id,
          note: 'Initial Packing creation',
          copy: 'packings',
          storage: p.storage_in ? 'in' : p.storage_out ? 'out' : '',
          storage_in: p.storage_in ? p.storage_in : '',
          storage_out: p.storage_out ? p.storage_out : '',
          change_date: p.storage_in ? p.storage_in : p.storage_out ? p.storage_out : new Date().toISOString().slice(0, 10)
        }
      }).then(function (response) {
        // console.log('Location update SUCCESSFUL --------- ' + a.title)
        _this4.errors = {};
        // serverBus.$emit('showSnackbar', 'Initial Location Log of Packing saved.', 'green')
        _this4.$store.commit('ADD_LOG', response.data);
        // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
        // this.showUpload = !this.showUpload
      }).catch(function (error) {
        // console.log('Location update FAILED --------- ' + a.title)
        // console.log(error)
        __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$emit('showSnackbar', 'Error occured while updating location.', 'red');
        // this.errors = error.response.data;
      });
    },
    resetPacking: function resetPacking() {
      this.packing = {
        packing: '',
        height: '',
        width: '',
        lenght: '',
        weight: '',
        created_by: '',
        contents: '',
        note: '',
        visa_status: 0,
        colli: '',
        artwork_location_id: '',
        location_id: ''
      };
    },
    update_multiple: function update_multiple() {
      var _this5 = this;

      this.updated_packing.artwork_id = this.artwork.id;
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(this.$globals.apiserver + '/artwork_packings/update_multiple.json', {
        updated_packing: this.updated_packing,
        selected: this.selected
      }).then(function (response) {
        _this5.errors = {};
        _this5.artwork.artwork_packings = [];
        _this5.artwork.artwork_packings.push(response.data);
        // this.$store.commit('REPLACE_PACKING', response.data)
      }).catch(function (error) {
        _this5.errors = error.response.data;
      });
      this.dialog2 = !this.dialog2;
      // this.dialog = false
      this.updated_packing = {
        packing: '',
        height: '',
        width: '',
        length: '',
        weigth: '',
        contents: '',
        note: '',
        visa_status: 0
      };
    }
    // NEPOUZIVANE
    // findMinMax(arr) {
    //   let max = arr[0].id
    //   for (let i = 1, len=arr.length; i < len; i++) {
    //     let v = arr[i].id
    //     max = (v > max) ? v : max
    //   }
    //   return max
    // }

  },
  components: { ExcelPackings: __WEBPACK_IMPORTED_MODULE_3__ExcelPackings__["a" /* default */] }
});

/***/ }),

/***/ "IyLy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tags_vue__ = __webpack_require__("tCMm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b0a07c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tags_vue__ = __webpack_require__("LN2U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("OK5g")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8b0a07c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b0a07c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tags_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b0a07c0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tags_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "J0aq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JIzb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRelated_vue__ = __webpack_require__("hDkH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3082f298_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelated_vue__ = __webpack_require__("iGlC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("yxwD")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3082f298"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRelated_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3082f298_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelated_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3082f298_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelated_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "JTfk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"mt-3",attrs:{"column":""}},[(!this.field.sub_field)?_c('section-header',{attrs:{"text":"Links","showAddLink":true},on:{"showAdd":function($event){_vm.showEditDialog=true}}}):_c('subsection-header',{attrs:{"text":"Links","link":"true","showAddLink":true},on:{"showAdd":function($event){_vm.showEditDialog=true}}}),_vm._v(" "),_c('v-flex',{class:[{'mx-2': this.field.sub_field}, 'xs12', 'sm12', 'md12', 'mt-0', 'pt-0']},[(_vm.links)?_c('v-list',{staticClass:"xs12 pl-0",staticStyle:{"background-color":"#ececec"},attrs:{"two-line":""}},_vm._l((_vm.links),function(f){return _c('v-list-tile',{key:f.id,staticClass:"pl-0 ml-0"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{staticClass:"px-0 ml-0",attrs:{"round":"","flat":"","small":"","href":f.www,"target":"_blank"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("launch")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(f.title ? f.title : f.www))])],1)]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text-no-wrap"},[_vm._v(_vm._s(f.description))])],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.edit_link(f)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit")])],1)],1),_vm._v(" "),(_vm.c_user.edit)?_c('v-flex',[_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.delete_link(f)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("delete")])],1)],1):_vm._e(),_vm._v(" "),_c('hr')],1)}),1):_vm._e(),_vm._v(" "),(_vm.c_user.edit)?_c('v-flex',[(_vm.showEditDialog)?_c('v-flex',[_c('v-container',{staticClass:"elevation-1 white mt-3",attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","px-3":""}},[_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"label":"URL *","prepend-inner-icon":"launch"},model:{value:(_vm.link.www),callback:function ($$v) {_vm.$set(_vm.link, "www", $$v)},expression:"link.www"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"label":"Title"},model:{value:(_vm.link.title),callback:function ($$v) {_vm.$set(_vm.link, "title", $$v)},expression:"link.title"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Description"},model:{value:(_vm.link.description),callback:function ($$v) {_vm.$set(_vm.link, "description", $$v)},expression:"link.description"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[(_vm.saving)?_c('v-progress-linear',{attrs:{"width":"2","indeterminate":"","color":_vm.save_error ? 'red' : 'black'}}):_vm._e(),_vm._v(" "),(!_vm.editing)?_c('v-btn',{staticClass:"right black white--text",attrs:{"disabled":_vm.link.www.length < 3},on:{"click":_vm.save_link}},[_vm._v("save")]):_vm._e(),_vm._v(" "),(_vm.editing)?_c('v-btn',{staticClass:"right black white--text",attrs:{"disabled":_vm.link.www.length < 3},on:{"click":_vm.save_edited_link}},[_vm._v("save")]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"right",attrs:{"flat":""},on:{"click":function($event){_vm.showEditDialog=!_vm.showEditDialog}}},[_vm._v("cancel")])],1)],1)],1)],1):_vm._e()],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "JWtN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editBG pt-3 mt-4"},[_c('v-snackbar',{attrs:{"auto-height":"","color":_vm.sColor,"right":"","top":"","timeout":_vm.timeout,"vertical":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(_vm._s(_vm.sText))]),_vm._v(" "),_c('v-navigation-drawer',{staticClass:"px-2 navbar",staticStyle:{"position":"fixed","top":"224px"},attrs:{"width":"420","temporary":"","absolute":"","fixed":"","right":"","dark":"","hide-overlay":""},model:{value:(_vm.options_c),callback:function ($$v) {_vm.options_c=$$v},expression:"options_c"}},[_c('v-layout',{attrs:{"row":"","pt-3":"","pl-2":"","pb-2":""}},[_c('v-flex',[_c('v-subheader',{staticClass:"font-weight-regular display-1 white--text pl-0 ml-2"},[_vm._v("\n          Options\n          "),_c('v-spacer'),_vm._v(" "),_c('a',{staticClass:"font-weight-regular display-1 white--text",on:{"click":function($event){_vm.options_c = false}}},[_vm._v("\n            X")])],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3 pb-0 mb-0 white"}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","pt-0":"","mt-0":""}},[_c('v-flex',[_c('v-subheader',{staticClass:"white--text"},[_vm._v("\n          Editing Artist\n          "),_c('v-spacer')],1)],1)],1),_vm._v(" "),_c('v-list',_vm._l((this.constants.ARTIST.tabs),function(tab){return _c('v-list-tile',{key:tab.key,staticClass:"pl-0 ml-4",on:{"click":function($event){return _vm.setCurrentTab(tab['key'])}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(tab.title)+" ")])],1)],1)}),1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3 pb-0 mb-0 white"}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","pt-0":"","mt-0":""}},[_c('v-flex',[_c('v-subheader',{staticClass:"white--text"},[_vm._v("\n          Export PDF for:\n          "),_c('v-spacer'),_vm._v(" "),_c('a',{on:{"click":function($event){}}},[_vm._v("Export")])],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"background-color":"white","height":"50px","width":"100%","top":"135px","position":"fixed","z-index":"1"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}})],1),_vm._v(" "),_c('v-toolbar',{staticClass:"elevation-1 mt-2",staticStyle:{"top":"155px","position":"fixed","z-index":"1"},attrs:{"tabs":"","color":"white"}},[_c('v-toolbar-title',{staticClass:"pl-4"},[(_vm.artistFormData.collective == '1')?_c('v-icon',{staticClass:"hidden-sm-and-down mr-3",attrs:{"color":"black"}},[_vm._v("people")]):_vm._e(),_vm._v(" "),(_vm.artistFormData.collective != '1')?_c('v-icon',{staticClass:"hidden-sm-and-down mr-3",attrs:{"color":"black"}},[_vm._v("person")]):_vm._e(),_vm._v("\n      "+_vm._s(_vm.artistFormData.name)+"\n    ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.c_user.edit)?_c('v-btn',{attrs:{"icon":"","small":"","disabled":!_vm.valid,"right":""},on:{"click":_vm.saveArtist}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("save")])],1):_vm._e()],1),_vm._v(" "),(_vm.currentTab == 'basic')?_c('v-form',{ref:"form",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{staticClass:"px-3 mt-4 elevation-0 editBG pt-3"},[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('section-header',{attrs:{"text":"Basic"}}),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","pt-3":"","xs12":"","md6":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"hint":"used for all views","label":_vm.artistFormData.collective == 1
                  ? 'Collective Name'
                  : 'Full Name'},on:{"keyup":function($event){return _vm.check_name($event.target.value)}},model:{value:(_vm.artistFormData.name),callback:function ($$v) {_vm.$set(_vm.artistFormData, "name", $$v)},expression:"artistFormData.name"}}):_c('v-flex',{attrs:{"mt-4":""}},[_c('code',[_vm._v(_vm._s(_vm.artistFormData.name))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v(_vm._s(_vm.artistFormData.collective == 1
                  ? 'Collective Name'
                  : 'Full Name'))])])],1),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","pt-3":"","md6":"","xs12":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Sort Name","hint":"used for sorting in list views"},model:{value:(_vm.artistFormData.sort_name),callback:function ($$v) {_vm.$set(_vm.artistFormData, "sort_name", $$v)},expression:"artistFormData.sort_name"}}):_c('v-flex',{attrs:{"mt-4":""}},[_c('code',[_vm._v(_vm._s(_vm.artistFormData.sort_name))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Sort Name")])])],1),_vm._v(" "),(!_vm.artistFormData.collective == 1)?_c('v-flex',{attrs:{"px-3":"","pb-3":"","xs12":"","md6":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"First Name","persistent-hint":""},model:{value:(_vm.artistFormData.first_name),callback:function ($$v) {_vm.$set(_vm.artistFormData, "first_name", $$v)},expression:"artistFormData.first_name"}}):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.artistFormData.first_name))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("First Name")])])],1):_vm._e(),_vm._v(" "),(!_vm.artistFormData.collective == 1)?_c('v-flex',{attrs:{"px-3":"","pb-3":"","xs12":"","md6":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Last Name","persistent-hint":""},model:{value:(_vm.artistFormData.last_name),callback:function ($$v) {_vm.$set(_vm.artistFormData, "last_name", $$v)},expression:"artistFormData.last_name"}}):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.artistFormData.last_name))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Last Name")])])],1):_vm._e(),_vm._v(" "),(!_vm.artistFormData.collective == 1)?_c('v-flex',{attrs:{"px-3":"","pb-1":"","xs12":"","md6":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Birth Name","hide-details":""},model:{value:(_vm.artistFormData.birth_name),callback:function ($$v) {_vm.$set(_vm.artistFormData, "birth_name", $$v)},expression:"artistFormData.birth_name"}}):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.artistFormData.birth_name))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Birth Name")])])],1):_vm._e(),_vm._v(" "),_c('section-header',{attrs:{"text":"Birth & Death / Formation"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":"","pl-0":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","pl-3":"","py-3":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Year","placeholder":"0000","mask":"####","type":"number","maxlength":4},model:{value:(_vm.artistFormData.birth_date_year),callback:function ($$v) {_vm.$set(_vm.artistFormData, "birth_date_year", $$v)},expression:"artistFormData.birth_date_year"}}):_c('v-flex',{attrs:{"mt-4":""}},[_c('code',[_vm._v(_vm._s(_vm.artistFormData.birth_date_year))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Year")])]),_vm._v("\n\n              Decade: "+_vm._s(_vm.getDecade(_vm.artistFormData.birth_date_year))+"\n            ")],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","mt-0":"","py-3":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Month","mask":"##","placeholder":"00","type":"number"},model:{value:(_vm.artistFormData.birth_date_month),callback:function ($$v) {_vm.$set(_vm.artistFormData, "birth_date_month", $$v)},expression:"artistFormData.birth_date_month"}}):_c('v-flex',{attrs:{"mt-4":""}},[_c('code',[_vm._v(_vm._s(_vm.artistFormData.birth_date_month))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Month")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","mt-0":"","py-3":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Day","mask":"##","placeholder":"00","type":"number"},model:{value:(_vm.artistFormData.birth_date_day),callback:function ($$v) {_vm.$set(_vm.artistFormData, "birth_date_day", $$v)},expression:"artistFormData.birth_date_day"}}):_c('v-flex',{attrs:{"mt-4":""}},[_c('code',[_vm._v(_vm._s(_vm.artistFormData.birth_date_day))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Day")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":""}},[(
                _vm.artistFormData.death_date_only_year == 1 ||
                _vm.artistFormData.collective == 1
              )?_c('v-flex',{staticClass:"mt-3 py-0 pl-3",attrs:{"xs6":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"clearable":"","mask":"####","label":"Death Year","prepend-inner-icon":"event"},model:{value:(_vm.artistFormData.death_date_year),callback:function ($$v) {_vm.$set(_vm.artistFormData, "death_date_year", $$v)},expression:"artistFormData.death_date_year"}}):_c('v-flex',{attrs:{"mt-4":""}},[_c('code',[_vm._v(_vm._s(_vm.artistFormData.death_date_year))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Death Year")])])],1):_c('v-flex',{staticClass:"mt-3 py-0 pl-3",attrs:{"xs6":""}},[(
                  !_vm.artistFormData.death_date_only_year ||
                  _vm.artistFormData.death_date_only_year == 0 ||
                  _vm.artistFormData.death_date_only_year == '' ||
                  _vm.artistFormData.death_date_only_year == false ||
                  !_vm.artistFormData.collective == 1
                )?_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":32,"nudge-top":18,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[(
                    _vm.artistFormData.death_date_only_year ||
                    _vm.artistFormData.death_date_only_year == 0 ||
                    _vm.artistFormData.death_date_only_year == '' ||
                    _vm.artistFormData.death_date_only_year == false ||
                    !_vm.artistFormData.collective == 1
                  )?_c('v-text-field',{attrs:{"slot":"activator","disabled":!_vm.c_user.edit,"label":"Death Date","prepend-inner-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.artistFormData.death_date),callback:function ($$v) {_vm.$set(_vm.artistFormData, "death_date", $$v)},expression:"artistFormData.death_date"}}):_vm._e(),_vm._v(" "),_c('v-date-picker',{attrs:{"disabled":!_vm.c_user.edit},on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.artistFormData.death_date),callback:function ($$v) {_vm.$set(_vm.artistFormData, "death_date", $$v)},expression:"artistFormData.death_date"}})],1):_vm._e()],1),_vm._v(" "),(!_vm.artistFormData.collective == 1)?_c('v-flex',{staticClass:"mt-3 py-0 px-3",attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"disabled":!_vm.c_user.edit,"color":"black","label":"Only Year"},model:{value:(_vm.artistFormData.death_date_only_year),callback:function ($$v) {_vm.$set(_vm.artistFormData, "death_date_only_year", $$v)},expression:"artistFormData.death_date_only_year"}})],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"pl-3":"","pr-2":"","xs12":"","sm6":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":_vm.artistFormData.collective == 1
                  ? 'Formation place'
                  : 'Birth place',"hide-details":""},model:{value:(_vm.artistFormData.birthplace),callback:function ($$v) {_vm.$set(_vm.artistFormData, "birthplace", $$v)},expression:"artistFormData.birthplace"}}):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.artistFormData.birthplace))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v(_vm._s(_vm.artistFormData.collective == 1
                  ? 'Formation place'
                  : 'Birth place'))])])],1),_vm._v(" "),_c('v-flex',{staticClass:"px-3",attrs:{"xs12":"","md6":""}},[(_vm.c_user.edit)?_c('v-autocomplete',{attrs:{"items":this.countries,"item-value":function (item) { return item.name.common; },"item-text":function (item) { return item.name.common; },"label":"Nationality"},model:{value:(_vm.artistFormData.nationality),callback:function ($$v) {_vm.$set(_vm.artistFormData, "nationality", $$v)},expression:"artistFormData.nationality"}}):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.artistFormData.nationality))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Nationality")])]),_vm._v(" "),(
                !_vm.artistFormData.nationality &&
                _vm.artistFormData.nationality != 0 &&
                _vm.artistFormData.nationality != '' &&
                _vm.artistFormData.nationality != null
              )?_c('small',{staticClass:"pt-1 grey--text"},[_vm._v("\n              "+_vm._s(this.countries.find(
                  function (c) { return c.name.common === _vm.artistFormData.nationality; }
                ).region)+"\n              /\n              "+_vm._s(this.countries.find(
                  function (c) { return c.name.common === _vm.artistFormData.nationality; }
                ).subregion)+"\n            ")]):_vm._e(),_vm._v(" "),(
                !this.countries.find(
                  function (c) { return c.name.common === _vm.artistFormData.nationality; }
                )
              )?_c('small',{staticClass:"pt-1 grey--text"},[_vm._v("\n              "+_vm._s(_vm.artistFormData.nationality)+"\n            ")]):_vm._e()],1),_vm._v(" "),(!_vm.artistFormData.collective == 1)?_c('v-flex',{attrs:{"px-3":"","xs12":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Death Place","hide-details":""},model:{value:(_vm.artistFormData.death_place),callback:function ($$v) {_vm.$set(_vm.artistFormData, "death_place", $$v)},expression:"artistFormData.death_place"}}):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.artistFormData.death_place))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Death Place")])])],1):_vm._e(),_vm._v(" "),_c('section-header',{attrs:{"text":"Other"}}),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","my-3":"","xs12":""}},[(_vm.c_user.edit)?_c('v-textarea',{staticClass:"my-0",attrs:{"auto-grow":"","box":"","rows":"1","hide-details":"","label":"Lives & Works"},model:{value:(_vm.artistFormData.livesandworks),callback:function ($$v) {_vm.$set(_vm.artistFormData, "livesandworks", $$v)},expression:"artistFormData.livesandworks"}}):_c('v-flex',{attrs:{"mt-4":""}},[_c('code',[_vm._v(_vm._s(_vm.artistFormData.livesandworks))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Lives & Works")])])],1),_vm._v(" "),(!_vm.artistFormData.collective == 1)?_c('v-flex',{attrs:{"px-3":"","my-3":"","xs12":""}},[(_vm.c_user.edit)?_c('v-textarea',{staticClass:"my-0",attrs:{"auto-grow":"","box":"","rows":"1","hide-details":"","label":"Bio"},model:{value:(_vm.artistFormData.bio),callback:function ($$v) {_vm.$set(_vm.artistFormData, "bio", $$v)},expression:"artistFormData.bio"}}):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.artistFormData.bio))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Bio")])])],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","xs12":"","my-3":""}},[(_vm.c_user.edit)?_c('v-textarea',{staticClass:"my-0",attrs:{"auto-grow":"","rows":"1","box":"","hide-details":"","label":"Note"},model:{value:(_vm.artistFormData.birth_date_text),callback:function ($$v) {_vm.$set(_vm.artistFormData, "birth_date_text", $$v)},expression:"artistFormData.birth_date_text"}}):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.artistFormData.birth_date_text))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Note")])])],1),_vm._v(" "),(!_vm.artistFormData.collective == 1)?_c('v-flex',{staticClass:"mx-3 mt-3 py-2",attrs:{"xs6":""}},[(_vm.c_user.edit)?_c('v-btn-toggle',{attrs:{"disabled":!_vm.c_user.edit},model:{value:(_vm.artistFormData.gender),callback:function ($$v) {_vm.$set(_vm.artistFormData, "gender", $$v)},expression:"artistFormData.gender"}},_vm._l((_vm.constants.GENDERS),function(s){return _c('v-btn',{key:s.name,staticClass:"px-2",attrs:{"small":"","flat":"","value":s.name}},[_c('span',[_vm._v(" "+_vm._s(s.name)+" ")])])}),1):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.artistFormData.gender))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Gender")])])],1):_vm._e(),_vm._v(" "),(
              _vm.c_user.edit ||
              (!_vm.c_user.edit && _vm.artistFormData.artist_links.length > 0)
            )?_c('section-header',{attrs:{"text":"Links"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.artistFormData.artist_links),function(al){return _c('v-flex',{key:al.id,staticClass:"px-3 py-1 mt-0 elevation-0 xs12"},[_c('a',{staticClass:"pb-0",staticStyle:{"line-height":"40px"},attrs:{"href":al.url,"target":"_blank"}},[_c('v-icon',{staticClass:"pt-1 mr-2",staticStyle:{"line-height":"15px"},attrs:{"color":"black"}},[_vm._v("open_in_new")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(al.name))]),_vm._v(" - "+_vm._s(al.url)+"\n            ")],1),_vm._v(" "),(_vm.c_user.edit || _vm.c_user.delete_rights)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.deleteLink(al)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1):_vm._e()],1)}),_vm._v(" "),(_vm.c_user.edit)?_c('v-card-title',{},[_c('v-list-tile',{staticClass:"xs12"},[_c('v-layout',{attrs:{"row":"","my-0":"","py-0":"","mr-3":""}},[_c('v-flex',{attrs:{"xs12":"","md2":"","mr-2":""}},[_c('h4',{staticClass:"ml-2 mt-2 pt-2 mr-0 black--text"},[_vm._v("Add Link")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":"","mr-2":""}},[_c('v-text-field',{attrs:{"color":"white","solo":"","dark":"","label":"Name","hide-details":""},model:{value:(_vm.artistLink.name),callback:function ($$v) {_vm.$set(_vm.artistLink, "name", $$v)},expression:"artistLink.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":"","mr-2":""}},[_c('v-text-field',{attrs:{"color":"white","solo":"","dark":"","label":"URL","hide-details":"","placeholder":"f.e. \"tb-cms.org\""},model:{value:(_vm.artistLink.url),callback:function ($$v) {_vm.$set(_vm.artistLink, "url", $$v)},expression:"artistLink.url"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":"","mr-2":""}},[_c('v-btn',{attrs:{"disabled":!_vm.valid2,"small":""},on:{"click":_vm.saveLink}},[_vm._v("\n                    save link\n                  ")])],1)],1)],1)],1):_vm._e()],2)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.currentTab == 'artworks')?_c('v-card',{staticClass:"px-3 pt-4 mt-4 elevation-0",attrs:{"flat":""}},[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{staticClass:"xs12",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-2 py-0 xs12",staticStyle:{"background-color":"#292929","color":"#ddd","line-height":"22px"}},[_c('h3',{staticClass:"font-weight-bold body-2 xs12 flex"},[_vm._v("Artist Artworks")])]),_vm._v(" "),_c('view-artworks',{staticClass:"xs12",attrs:{"artist":_vm.artistFormData}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.currentTab == 'multi_artist')?_c('v-card',{staticClass:"px-3 pt-4 mt-4 elevation-0",attrs:{"flat":""}},[_c('v-container',{staticClass:"xs12",attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{staticClass:"xs12",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-2 py-0 xs12",staticStyle:{"background-color":"#292929","color":"#ddd","line-height":"22px"}},[_c('h3',{staticClass:"font-weight-bold body-2 xs12 flex"},[_vm._v("Multi-Artist")])]),_vm._v(" "),_c('multi-artist',{staticClass:"xs12",attrs:{"artist":_vm.artistFormData}})],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "Ja8h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__("EWlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_ListsMixin__ = __webpack_require__("ml9J");


//
//
//
//
//
//
//
//
//
//
//
//



// import pdfFonts from 'pdfmake/build/vfs_fonts'
// import { serverBus } from '../../main'



// pdfMake.vfs = pdfFonts.pdfMake.vfs

function dynamicSort(property, property2) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    // var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    if (a[property] > b[property]) return 1;
    if (a[property] < b[property]) return -1;
    if (a[property2] > b[property2]) return 1;
    if (a[property2] < b[property2]) return -1;
    // return result * sortOrder;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_ListsMixin__["a" /* default */]],
  props: ['item', 'small', 'light', 'title', 'subtitle', 'created_by', 'created_at', 'page_no', 'showNoOfArtworks', 'sort', 'subsort', 'columns'],
  data: function data() {
    return {
      // output_fields: [],
      constants: __WEBPACK_IMPORTED_MODULE_2__data_constants__["a" /* default */],
      loading: false,
      outputFields: ['classification', 'ownership'],
      output_fields: [],
      list_settings: {
        use_current_selection: false,
        use_current_list_selection: false,
        financial_information: false,
        image: false,
        compact: false,
        table: true,
        view: 'table',
        sort: 'sort_name',
        add_empty_column: false
      },
      add_empty_column: false,
      imageSize1: '430',
      imageSize2: '390',
      pdf_artworks: []
    };
  },
  // props: ['list', 'index', 'se', 'disable'],
  // created () {
  //   this.pdf(false)
  // },
  mounted: function mounted() {
    this.output_fields = this.columns;
    // Object.assign(
    //   [],
    //   this.$store.state.currentOutputFieldsSelection
    // )
  },

  methods: {
    pdfSoloCall: function pdfSoloCall(full) {
      this.loading = true;
      setTimeout(function () {
        setTimeout(function () {
          this.pdf(full);
          this.loading = false;
        }.bind(this), 0);
      }.bind(this), 500);
    },
    pdf: function pdf(full) {
      // console.log(this.columns)
      if (!full) {
        this.show_preview_pane = true;
      }
      var heights = 700;
      var margins = [0, 0, 0, 0];
      var image = this.image;
      var created = new Date().toISOString().slice(0, 10);
      var username = this.c_user.abb;
      var list_name = this.title ? this.title.toUpperCase() : 'LIST';
      var subtitle = this.subtitle ? this.subtitle.toUpperCase() : '';
      var full_title = list_name + (subtitle != '' ? '\n' + subtitle : '');
      var full_title_style = subtitle != '' ? 'titleS' : 'title';
      var image_size = [this.imageSize1, this.imageSize2];
      var output_fields = this.columns;
      var imageSize3 = parseInt(this.imageSize2);
      // var rectPosX = 220 - imageSize3
      var use_current_selection = this.use_current_selection;
      // var noOfArtworks = 0
      var logoImage = this.getLogo();
      logoImage = logoImage.split('\n');
      var tempArtworks = [];

      if (this.item && this.item.artworks.length > 0) {
        this.pdf_artworks = this.item.artworks;
      } else {
        // console.log(this.use_current_selection)
        if (use_current_selection == true) {
          // this.pdf_artworks = Object.assign([], this.$store.state.currentSelection)
          if (this.$store.state.currentSelection.length > 0) {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.ids2o(this.$store.state.currentSelection)).sort(dynamicSort(this.sort));
          } else {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks).sort(dynamicSort(this.sort));
          }
        } else {
          if (this.$store.state.filterResults) {
            var objs = this.ids2o(this.$store.state.filterResults);
            this.pdf_artworks = objs.sort(dynamicSort(this.sort));
          } else {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks).sort(dynamicSort(this.sort));
          }
        }
      }

      // this.pdf_artworks = this.pdf_artworks.slice(0,5)
      var artworks = this.pdf_artworks;

      if (this.sort == 'collection') {
        var collectionsIds = [1, 12, 15, 6, 7, 17, 10];
        this.pdf_artworks = this.customDoubleSort(this.pdf_artworks, collectionsIds, 'ownership', this.subsort);
      } else {
        this.pdf_artworks = this.pdf_artworks.sort(dynamicSort(this.sort, this.subsort));
      }
      var transformedData = this.formatListData(this.pdf_artworks, output_fields);
      // console.log(transformedData)

      // console.log(transformedData)

      var creationDate = function creationDate() {
        return new Date();
      };

      function getImagefromAPI(top_photo_id, id) {
        var request = new XMLHttpRequest();
        var requestER = new XMLHttpRequest();
        var src = '';
        // console.log('id')
        // console.log(id)
        // console.log(top_photo_id)
        // console.log('id')
        if (id) {
          // console.log(id)
          src = 'https://api.tb-cms.org/vueimages/' + id + '_big.txt';
          request.open('GET', src, false);
          request.send(null);
          if (request.readyState === 4) {
            if (request.status === 200 && request.statusText === 'OK') {
              // console.log('status OK')
              var type = request.getResponseHeader('Content-Type');
              if (type.indexOf('text') !== 1) {
                // console.log('text OK')
                return request.responseText;
              }
            } else {
              // console.log('status not OK')
              requestER.open('GET', 'https://api.tb-cms.org/vueimages/ir.txt', false);
              requestER.send(null);
              if (requestER.readyState === 4) {
                // console.log('status not OK - 4')
                if (requestER.status === 200 && requestER.statusText === 'OK') {
                  // console.log('status not OK - 4 - OK')
                  var type = requestER.getResponseHeader('Content-Type');
                  if (type.indexOf('text') !== 1) {
                    return requestER.responseText;
                  }
                } else {
                  return '';
                }
              }
            }
          }
        } else {
          // console.log('ir')
          requestER.open('GET', 'https://api.tb-cms.org/vueimages/ir.txt', false);
          requestER.send(null);
          if (requestER.readyState === 4) {
            // console.log('status not OK - 4')
            if (requestER.status === 200 && requestER.statusText === 'OK') {
              // console.log('status not OK - 4 - OK')
              var type = requestER.getResponseHeader('Content-Type');
              if (type.indexOf('text') !== 1) {
                return requestER.responseText;
              }
            } else {
              return '';
            }
          }
        }
      }

      var createDocumentDefinition = function createDocumentDefinition() {
        var _docDefinition$conten;

        var baseDocDefinition = {
          pageMargins: [40, 40, 40, 40],
          defaultFileName: 'list.pdf',
          pageSize: 'A4',
          // footer: (currentPage, pageCount) => {
          //   return {
          //     ...(this.page_no == true && {
          //       text:
          //         'Page ' +
          //         currentPage.toString() +
          //         ' of ' +
          //         pageCount.toString(),
          //       alignment: 'center',
          //       fontSize: 7
          //     })
          //     // text: `Page ${currentPage.toString()} of ${pageCount.toString()}`, alignment: 'center', fontSize: 7
          //   }
          // },
          info: {
            title: list_name,
            author: username,
            subject: list_name,
            keywords: 'artwork names, artist names',
            creationDate: created
          },
          styles: {
            title: {
              fontSize: 14,
              all_caps: true,
              alignment: 'right',
              bold: true,
              margin: [0, 33, 0, 0]
            },
            titleS: {
              fontSize: 14,
              all_caps: true,
              alignment: 'right',
              margin: [0, 33, 0, 0]
            },
            titleSub: { fontSize: 9, all_caps: true, alignment: 'right' },
            titleDate: { fontSize: 9, alignment: 'right', bold: false },
            createdAt: { fontSize: 9, alignment: 'right' },
            createdBy: { fontSize: 9, alignment: 'right' },
            bold: { fontSize: 9, bold: false },
            normal: { fontSize: 9, bold: false },
            artwork_title: { fontSize: 9, bold: true, margin: [44, 0, 0, 0] },
            artwork_title_top: {
              fontSize: 9,
              bold: false,
              margin: [44, 0, 0, 0]
            },
            artist_name: { fontSize: 9, italic: true, margin: [0, 25, 0, 0] },
            image: { alignment: 'center', margin: [0, 0, 40, 0] },
            logo: { alignment: 'left', margin: [0, 0, 0, 40] }
          },
          content: [
            // {
            //   columns: [
            //     // { text: list_name, style: 'title', width: 'auto' },
            //     // {
            //     //   text:
            //     //     (this.created_by == true
            //     //       ? 'Created by : ' + username
            //     //       : '') +
            //     //     (this.created_at == true ? '\n' + created : '') ,
            //     //   style: 'createdBy'
            //     // }
            //     // { text: ((this.showNoOfArtworks == true) ? 'No. of Artworks: '  + this.pdf_artworks.length : ''), style: 'createdBy'}
            //     // {...(this.created_by == true) && { text: '\nCreated by ' + username, style: 'createdBy'}},
            //     // {...(this.created_at == true) && { text: created, style: 'createdAt'}}
            //   ]
            // },
            // { text: `${this.subtitle}\n\n`, style: 'titleSub' }
          ]
        };
        var docDefinition = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(baseDocDefinition));
        // docDefinition.footer = baseDocDefinition.footer
        (_docDefinition$conten = docDefinition.content).push.apply(_docDefinition$conten, arguments);
        // console.log(contentParts)
        // console.log(docDefinition)
        return docDefinition;
      };

      var rowData = function rowData(a) {
        var stack = {
          stack: [],
          stack2: []
          // var stacks = {
          //   stack: []
          // }
          // stacks.stack.push({
          //   text: list_name, style: 'title', width: '*'
          // }),
          // stacks.stack.push({
          //   text: subtitle, style: 'title', width: '*'
          // })
        };var columns = output_fields;
        // this.$store.state.selected_columns_for_pdf
        // ['title','accession_number'];
        // console.log(artworks[0]['title'])
        // console.log(a['title'])
        stack.stack.push(
        // { image: logoImage, fit: [170, 90], style: 'logo', width: '*' }
        {
          columns: [{ image: logoImage, fit: [180, 80], style: 'logo', width: '*' }, {
            text: a['title'] === artworks[0]['title'] + ', ' + artworks[0]['production_date_new'] ? full_title : '',
            style: full_title_style,
            width: '*'
          }]
          // text: `${subtitle}\n\n`, style: 'titleSub'
        }), stack.stack.push({
          text: a['accession_number'],
          style: 'artwork_title_top'
        });
        stack.stack.push({ text: a['full_name'], style: 'artwork_title' });
        stack.stack.push({ text: a['title'], style: 'artwork_title' });
        stack.stack.push({ text: a['subtitle'], style: 'artwork_title' });
        // stack.stack.push({ text: currentPage, style: 'artwork_title' })

        // console.log('columns')
        // console.log(columns)
        columns.forEach(function (column, index) {
          var columnData = a[column.id];
          var cp = [];
          if (columnData != null && columnData.trim().length != 0) {
            stack.stack.push({ text: columnData, style: 'artwork_title' });
          }
        });

        var imagefromAPI = getImagefromAPI(a.top_photo, a.top_photo_id);
        imagefromAPI = imagefromAPI.split('\n');
        if (imagefromAPI.length == 2) {
          imagefromAPI = imagefromAPI.filter(function (el) {
            return el != '';
          });
        }
        stack.stack.push({
          margins: [0, 0, 0, 0],
          image: imagefromAPI,
          fit: image_size,
          style: 'image',
          absolutePosition: { x: 45, y: 330 }
        });

        return stack;
      };

      createPdfDoc();

      function createPdfDoc() {
        var fontSize = 6;

        var tableBody = function tableBody(dataRows) {
          // console.log(currentPage)
          var body = [];
          dataRows.forEach(function (row, index) {
            var tableRow = [];

            tableRow.push(rowData(row, transformedData));
            // console.log(tableRow)

            body.push(tableRow);
          });
          return body;
        };
        var tableColumnWidths = ['*'];
        var tableData = {
          layout: 'noBorders',
          table: {
            heights: heights,
            dontBreakRows: true,
            margins: margins,
            widths: tableColumnWidths,
            body: tableBody(transformedData)
          }
        };
        var docDefinition = createDocumentDefinition(tableData);

        if (full == false) {
          var pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(docDefinition);

          // function download() {
          //   pdfDocGenerator.download('A4-list.pdf');
          // }
          pdfDocGenerator.getDataUrl(function (dataUrl) {
            var targetElement = document.querySelector('#pdfV');
            // const iframe = document.createElement('iframe')
            targetElement.src = dataUrl;
            // targetElement.appendChild(iframe)
            // this.loading = false
          });
        } else {
          if (list_name) {
            var t = list_name;
          } else {
            var t = 'listSolo.pdf';
          }
          // this.loading = false
          __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download(t);
        }
        // this.loading = false
      }
      // this.loading = false
    }
  }
});

/***/ }),

/***/ "Ji5s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['contact'],
  computed: {
    full_name: function full_name() {
      return this.contact.first_name + ' ' + this.contact.last_name;
    },

    link: function link() {
      return '/contacts/edit/' + this.contact.id;
    }
  }
});

/***/ }),

/***/ "JkNV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}})],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "JslP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextEditor_vue__ = __webpack_require__("wIw6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17c6ce2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextEditor_vue__ = __webpack_require__("rjPQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("5kfu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TextEditor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17c6ce2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextEditor_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a17c6ce2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TextEditor_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K30H":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// formerly "acquired"

var ARTWORK_FIELDS = ['id', 'artist_id', 'visa_status', 'media_material_description',
// 'conservator',
// 'last_media_check',
'created_at',
// 'dimensions_formatted',
'dim_height', 'dim_width', 'dim_depth', 'dim_diameter', 'edition_state', 'certificate_new', 'signature_new', 'credit', 'artwork_location', 'top_photo_id', 'type_of_work_id', 'production_date_new', 'acquisition_date', 'ownership', 'accession_number', 'classification', 'classification_new_id', 'acquisition_source_id', 'acquired', 'deaccessioned', 'deaccession_date', 'location_notes', 'artwork_location_id', 'insurance_value', 'insurance_value_currency', 'purchased_price', 'purchased_price_currency', 'title', 'subtitle', 'tags', 'artwork_todos', 'top_photo', 'width', 'height', 'full_name', 'last_name', 'sort_name', 'location_name', 'ownership_info', 'dim_f_json', 'acquisition_method', 'acquisition_method_text', 'purchase_price_text', 'insurance_value_text', 'import_date', 'import_export_notes', 'paid_in_country', 'import_export_history', 'name'];

var TOOLBAR_MENU_ITEMS = [{
  icon: 'contacts',
  'icon-alt': 'contacts',
  text: 'Collections',
  children: [{
    icon: 'people',
    text: 'All Collections',
    path: '/artworks/ownership/all',
    shortkey: ['ctrl', 'c'],
    role: 'all_coll'
  }, {
    icon: 'people',
    text: 'TBA21 Collection',
    path: '/artworks/ownership/collection',
    role: 'coll'
  }, {
    icon: 'people',
    text: 'Gemini Masters Limited',
    path: '/artworks/ownership/gemini',
    role: 'gemini'
  }, {
    icon: 'people',
    text: 'Gemini Collections Limited',
    path: '/artworks/ownership/geminiCL',
    role: 'geminiCL'
  },
  // {
  //   icon: "people",
  //   text: "Gemini Collections Deaccessioned",
  //   path: "/artworks/ownership/geminiCD",
  //   role: "geminiCD",
  // },
  {
    icon: 'people',
    text: 'Private Art Collection FTB',
    path: '/artworks/ownership/pacFvh',
    active: true,
    role: 'pacFvh'
  }, {
    icon: 'people',
    text: 'Private Design Collection FTB',
    path: '/artworks/ownership/pdcFvh',
    role: 'pdcFvh'
  }, {
    icon: 'people',
    text: 'Private Art Collection EH',
    path: '/artworks/ownership/pacEh',
    role: 'pacEh'
  }, {
    icon: 'people',
    text: 'Private Art Collection MR',
    path: '/artworks/ownership/pacMr',
    role: 'pacMr'
  }, {
    icon: 'people',
    text: 'Private Design Casa Austria',
    path: '/artworks/ownership/pcCA',
    role: 'pcCA'
  }, {
    icon: 'people',
    text: 'Private Collection FT',
    path: '/artworks/ownership/pcFT',
    role: 'pcFT'
  }, {
    icon: 'people',
    text: 'Deaccession',
    path: '/artworks/ownership/deaccession',
    role: 'deac'
    // {
    //   icon: "people",
    //   text: "Old Masters",
    //   path: "/artworks/ownership/oldMasters",
    //   role: "old_masters",
    // },
    // {
    //   icon: "people",
    //   text: "Foreign Artworks",
    //   path: "/artworks/ownership/foreign",
    //   role: "foreign",
    // },
  }]
}, {
  icon: 'burst_mode',
  text: 'Commissions',
  path: '/artworks/ownership/commissions',
  role: 'commissions'
}, {
  icon: 'burst_mode',
  text: 'Non-TBA21',
  path: '/artworks/ownership/nonTba',
  role: 'nonTba'
}, {
  icon: 'burst_mode',
  text: 'TBA21 Academy Commissions',
  path: '/artworks/ownership/com_academy',
  role: 'com_academy'
},
// { icon: 'people', text: 'Lists', path: '/lists' },
// {
//   icon: "burst_mode",
//   text: "Facts and Figures",
//   path: "/facts",
//   shortkey: ["ctrl", "f"]
// },
{
  icon: 'burst_mode',
  text: 'Lists',
  path: '/lists',
  shortkey: ['ctrl', 'l'],
  role: 'lists'
}, {
  icon: 'burst_mode',
  text: 'Selections',
  path: '/selections',
  shortkey: ['ctrl', 's'],
  role: 'selections'
}, {
  icon: 'todo',
  text: 'Todos',
  path: '/todos',
  role: 'todos'
}, {
  icon: 'people',
  text: 'Artists',
  path: '/artists',
  shortkey: ['ctrl', 'a'],
  role: 'artists'
}, {
  icon: 'contacts',
  text: 'Exhibitions',
  path: '/exhibitions',
  shortkey: ['ctrl', 'e'],
  role: 'exhibitions'
}, {
  icon: 'text',
  text: 'Texts',
  path: '/texts',
  role: 'texts'
}, {
  icon: 'burst_mode',
  text: 'Tags',
  path: '/tags',
  shortkey: ['ctrl', 't'],
  role: 'tags'
}, {
  icon: 'contact_phone',
  text: 'Contacts',
  path: '/contacts',
  shortkey: ['ctrl', 'o'],
  role: 'contacts',
  edit_only: true
}, {
  icon: 'location_city',
  text: 'Locations',
  path: '/locations',
  shortkey: ['ctrl', 'n'],
  role: 'locations'
}, {
  icon: 'people',
  text: 'CMS Users',
  path: '/users',
  shortkey: ['ctrl', 'u'],
  role: 'users',
  edit_only: true
}, {
  icon: 'settings',
  text: 'CMS Articles',
  path: '/articles',
  role: 'support',
  edit_only: true
},
// {
//   icon: 'keyboard_arrow_up',
//   'icon-alt': 'keyboard_arrow_down', text: 'Value Lists',
//   children: [
//     { icon: 'format_list_bulleted', text: 'Ownerships' },
//     { icon: 'fiber_smart_record', text: 'Tags' },
//     { icon: 'photo_size_select_actual', text: 'Artwork' }
//   ]
// },
// {
//   icon: "keyboard_arrow_up",
//   "icon-alt": "keyboard_arrow_down",
//   text: "Add new...",
//   model: false,
//   edit_only: true,
//   children: [
//     { icon: "people", text: "Artist", path: "/artists/new" },
//     { icon: "art_track", text: "Artwork", path: "/artworks/new" },
//     { icon: "person_add", text: "User", path: "/users/new" },
//     { icon: "add_location", text: "Location", path: "/locations/new" },
//     { icon: "person_add", text: "Contact", path: "/contacts/new" },
//     { icon: "burst_mode", text: "CR", path: "/reports/new" },
//     {
//       icon: "burst_mode",
//       text: "IM",
//       path: "/reports/wizzard_instalation_manual",
//     },
//     { icon: "text", text: "Text", path: "/texts/new" },
//   ],
// },
// {
//   icon: 'keyboard_arrow_up',
//   'icon-alt': 'keyboard_arrow_down',
//   text: 'More',
//   model: false,
//   children: [
//     { text: 'wip' },
//     { text: 'Export' }
//   ]
// },
{
  icon: 'keyboard_arrow_up',
  text: 'My Settings',
  path: '/account_settings',
  'icon-alt': 'keyboard_arrow_down'
  // children: [
  //   {
  //     icon: "account_circle",
  //     text: "Account info",
  //     path: "/account_settings",
  //     role: "contacts"
  //   },
  // {
  //   icon: "notifications",
  //   text: "Notifications",
  //   role: "contacts",
  //   path: "/notification_settings"
  // },
  //   { icon: "home", text: "Home Page", path: "/home_page_settings" }
  // ]

  // { icon: 'history', text: 'Change History' },
  // { icon: 'chat_bubble', text: 'Send feedback' },
  // { icon: 'help', text: 'Help' }
  // { icon: 'phonelink', text: 'App downloads' },
}]; // end of toolbar menu items

var OWNERSHIP_STATUSES = [{ id: 'nontba', value: 'nontba', name: 'Non-TBA' }, { id: 'commission', value: 'commission', name: 'Commission' }, { id: 'acquired', value: 'acquired', name: 'Acquired' }, {
  id: 'com_academy',
  value: 'com_academy',
  name: 'TBA21-Academy Commission'
}];

var TYPES_OF_WORK = [{ id: 5, value: 5, name: 'Architecture' }, { id: 18, value: 18, name: 'Collage' }, { id: 11, value: 11, name: 'Concept' }, { id: 1, value: 1, name: 'Drawing' }, { id: 7, value: 7, name: 'Film / Video' }, { id: 10, value: 10, name: 'Furniture' }, { id: 6, value: 6, name: 'Installation' },
// { id: 17, value: 17, name: 'Jewellery' },
// { id: 12, value: 12, name: 'Metalworks' },
{ id: 4, value: 4, name: 'Object / Sculpture' },
// { id: 14, value: 14, name: 'Oriental' },
{ id: 2, value: 2, name: 'Painting' }, { id: 8, value: 8, name: 'Performance' }, { id: 3, value: 3, name: 'Photo / Print' },
// { id: 15, value: 15, name: 'Silverware' },
{ id: 9, value: 9, name: 'Sound' }, { id: 16, value: 16, name: 'Textiles'
  // { id: 13, value: 13, name: 'Vertu' }
}];

var LANGUAGES = [{ id: 1, name: 'English', 'iso_639-1': 'en', position: 1 }, { id: 2, name: 'Afar', 'iso_639-1': 'aa', position: 2 }, { id: 3, name: 'Abkhazian', 'iso_639-1': 'ab', position: 3 }, { id: 4, name: 'Afrikaans', 'iso_639-1': 'af', position: 4 }, { id: 5, name: 'Amharic', 'iso_639-1': 'am', position: 5 }, { id: 6, name: 'Arabic', 'iso_639-1': 'ar', position: 6 }, { id: 7, name: 'Assamese', 'iso_639-1': 'as', position: 7 }, { id: 8, name: 'Aymara', 'iso_639-1': 'ay', position: 8 }, { id: 9, name: 'Azerbaijani', 'iso_639-1': 'az', position: 9 }, { id: 10, name: 'Bashkir', 'iso_639-1': 'ba', position: 10 }, { id: 11, name: 'Belarusian', 'iso_639-1': 'be', position: 11 }, { id: 12, name: 'Bulgarian', 'iso_639-1': 'bg', position: 12 }, { id: 13, name: 'Bihari', 'iso_639-1': 'bh', position: 13 }, { id: 14, name: 'Bislama', 'iso_639-1': 'bi', position: 14 }, { id: 15, name: 'Bengali/Bangla', 'iso_639-1': 'bn', position: 15 }, { id: 16, name: 'Tibetan', 'iso_639-1': 'bo', position: 16 }, { id: 17, name: 'Breton', 'iso_639-1': 'br', position: 17 }, { id: 18, name: 'Catalan', 'iso_639-1': 'ca', position: 18 }, { id: 19, name: 'Corsican', 'iso_639-1': 'co', position: 19 }, { id: 20, name: 'Czech', 'iso_639-1': 'cs', position: 20 }, { id: 21, name: 'Welsh', 'iso_639-1': 'cy', position: 21 }, { id: 22, name: 'Danish', 'iso_639-1': 'da', position: 22 }, { id: 23, name: 'German', 'iso_639-1': 'de', position: 23 }, { id: 24, name: 'Bhutani', 'iso_639-1': 'dz', position: 24 }, { id: 25, name: 'Greek', 'iso_639-1': 'el', position: 25 }, { id: 26, name: 'Esperanto', 'iso_639-1': 'eo', position: 26 }, { id: 27, name: 'Spanish', 'iso_639-1': 'es', position: 27 }, { id: 28, name: 'Estonian', 'iso_639-1': 'et', position: 28 }, { id: 29, name: 'Basque', 'iso_639-1': 'eu', position: 29 }, { id: 30, name: 'Persian', 'iso_639-1': 'fa', position: 30 }, { id: 31, name: 'Finnish', 'iso_639-1': 'fi', position: 31 }, { id: 32, name: 'Fiji', 'iso_639-1': 'fj', position: 32 }, { id: 33, name: 'Faeroese', 'iso_639-1': 'fo', position: 33 }, { id: 34, name: 'French', 'iso_639-1': 'fr', position: 34 }, { id: 35, name: 'Frisian', 'iso_639-1': 'fy', position: 35 }, { id: 36, name: 'Irish', 'iso_639-1': 'ga', position: 36 }, { id: 37, name: 'Scots/Gaelic', 'iso_639-1': 'gd', position: 37 }, { id: 38, name: 'Galician', 'iso_639-1': 'gl', position: 38 }, { id: 39, name: 'Guarani', 'iso_639-1': 'gn', position: 39 }, { id: 40, name: 'Gujarati', 'iso_639-1': 'gu', position: 40 }, { id: 41, name: 'Hausa', 'iso_639-1': 'ha', position: 41 }, { id: 42, name: 'Hindi', 'iso_639-1': 'hi', position: 42 }, { id: 43, name: 'Croatian', 'iso_639-1': 'hr', position: 43 }, { id: 44, name: 'Hungarian', 'iso_639-1': 'hu', position: 44 }, { id: 45, name: 'Armenian', 'iso_639-1': 'hy', position: 45 }, { id: 46, name: 'Interlingua', 'iso_639-1': 'ia', position: 46 }, { id: 47, name: 'Interlingue', 'iso_639-1': 'ie', position: 47 }, { id: 48, name: 'Inupiak', 'iso_639-1': 'ik', position: 48 }, { id: 49, name: 'Indonesian', 'iso_639-1': 'in', position: 49 }, { id: 50, name: 'Icelandic', 'iso_639-1': 'is', position: 50 }, { id: 51, name: 'Italian', 'iso_639-1': 'it', position: 51 }, { id: 52, name: 'Hebrew', 'iso_639-1': 'iw', position: 52 }, { id: 53, name: 'Japanese', 'iso_639-1': 'ja', position: 53 }, { id: 54, name: 'Yiddish', 'iso_639-1': 'ji', position: 54 }, { id: 55, name: 'Javanese', 'iso_639-1': 'jw', position: 55 }, { id: 56, name: 'Georgian', 'iso_639-1': 'ka', position: 56 }, { id: 57, name: 'Kazakh', 'iso_639-1': 'kk', position: 57 }, { id: 58, name: 'Greenlandic', 'iso_639-1': 'kl', position: 58 }, { id: 59, name: 'Cambodian', 'iso_639-1': 'km', position: 59 }, { id: 60, name: 'Kannada', 'iso_639-1': 'kn', position: 60 }, { id: 61, name: 'Korean', 'iso_639-1': 'ko', position: 61 }, { id: 62, name: 'Kashmiri', 'iso_639-1': 'ks', position: 62 }, { id: 63, name: 'Kurdish', 'iso_639-1': 'ku', position: 63 }, { id: 64, name: 'Kirghiz', 'iso_639-1': 'ky', position: 64 }, { id: 65, name: 'Latin', 'iso_639-1': 'la', position: 65 }, { id: 66, name: 'Lingala', 'iso_639-1': 'ln', position: 66 }, { id: 67, name: 'Laothian', 'iso_639-1': 'lo', position: 67 }, { id: 68, name: 'Lithuanian', 'iso_639-1': 'lt', position: 68 }, { id: 69, name: 'Latvian/Lettish', 'iso_639-1': 'lv', position: 69 }, { id: 70, name: 'Malagasy', 'iso_639-1': 'mg', position: 70 }, { id: 71, name: 'Maori', 'iso_639-1': 'mi', position: 71 }, { id: 72, name: 'Macedonian', 'iso_639-1': 'mk', position: 72 }, { id: 73, name: 'Malayalam', 'iso_639-1': 'ml', position: 73 }, { id: 74, name: 'Mongolian', 'iso_639-1': 'mn', position: 74 }, { id: 75, name: 'Moldavian', 'iso_639-1': 'mo', position: 75 }, { id: 76, name: 'Marathi', 'iso_639-1': 'mr', position: 76 }, { id: 77, name: 'Malay', 'iso_639-1': 'ms', position: 77 }, { id: 78, name: 'Maltese', 'iso_639-1': 'mt', position: 78 }, { id: 79, name: 'Burmese', 'iso_639-1': 'my', position: 79 }, { id: 80, name: 'Nauru', 'iso_639-1': 'na', position: 80 }, { id: 81, name: 'Nepali', 'iso_639-1': 'ne', position: 81 }, { id: 82, name: 'Dutch', 'iso_639-1': 'nl', position: 82 }, { id: 83, name: 'Norwegian', 'iso_639-1': 'no', position: 83 }, { id: 84, name: 'Occitan', 'iso_639-1': 'oc', position: 84 }, { id: 85, name: '(Afan)/Oromoor/Oriya', 'iso_639-1': 'om', position: 85 }, { id: 86, name: 'Punjabi', 'iso_639-1': 'pa', position: 86 }, { id: 87, name: 'Polish', 'iso_639-1': 'pl', position: 87 }, { id: 88, name: 'Pashto/Pushto', 'iso_639-1': 'ps', position: 88 }, { id: 89, name: 'Portuguese', 'iso_639-1': 'pt', position: 89 }, { id: 90, name: 'Quechua', 'iso_639-1': 'qu', position: 90 }, { id: 91, name: 'Rhaeto-Romance', 'iso_639-1': 'rm', position: 91 }, { id: 92, name: 'Kirundi', 'iso_639-1': 'rn', position: 92 }, { id: 93, name: 'Romanian', 'iso_639-1': 'ro', position: 93 }, { id: 94, name: 'Russian', 'iso_639-1': 'ru', position: 94 }, { id: 95, name: 'Kinyarwanda', 'iso_639-1': 'rw', position: 95 }, { id: 96, name: 'Sanskrit', 'iso_639-1': 'sa', position: 96 }, { id: 97, name: 'Sindhi', 'iso_639-1': 'sd', position: 97 }, { id: 98, name: 'Sangro', 'iso_639-1': 'sg', position: 98 }, { id: 99, name: 'Serbo-Croatian', 'iso_639-1': 'sh', position: 99 }, { id: 100, name: 'Singhalese', 'iso_639-1': 'si', position: 100 }, { id: 101, name: 'Slovak', 'iso_639-1': 'sk', position: 101 }, { id: 102, name: 'Slovenian', 'iso_639-1': 'sl', position: 102 }, { id: 103, name: 'Samoan', 'iso_639-1': 'sm', position: 103 }, { id: 104, name: 'Shona', 'iso_639-1': 'sn', position: 104 }, { id: 105, name: 'Somali', 'iso_639-1': 'so', position: 105 }, { id: 106, name: 'Albanian', 'iso_639-1': 'sq', position: 106 }, { id: 107, name: 'Serbian', 'iso_639-1': 'sr', position: 107 }, { id: 108, name: 'Siswati', 'iso_639-1': 'ss', position: 108 }, { id: 109, name: 'Sesotho', 'iso_639-1': 'st', position: 109 }, { id: 110, name: 'Sundanese', 'iso_639-1': 'su', position: 110 }, { id: 111, name: 'Swedish', 'iso_639-1': 'sv', position: 111 }, { id: 112, name: 'Swahili', 'iso_639-1': 'sw', position: 112 }, { id: 113, name: 'Tamil', 'iso_639-1': 'ta', position: 113 }, { id: 114, name: 'Telugu', 'iso_639-1': 'te', position: 114 }, { id: 115, name: 'Tajik', 'iso_639-1': 'tg', position: 115 }, { id: 116, name: 'Thai', 'iso_639-1': 'th', position: 116 }, { id: 117, name: 'Tigrinya', 'iso_639-1': 'ti', position: 117 }, { id: 118, name: 'Turkmen', 'iso_639-1': 'tk', position: 118 }, { id: 119, name: 'Tagalog', 'iso_639-1': 'tl', position: 119 }, { id: 120, name: 'Setswana', 'iso_639-1': 'tn', position: 120 }, { id: 121, name: 'Tonga', 'iso_639-1': 'to', position: 121 }, { id: 122, name: 'Turkish', 'iso_639-1': 'tr', position: 122 }, { id: 123, name: 'Tsonga', 'iso_639-1': 'ts', position: 123 }, { id: 124, name: 'Tatar', 'iso_639-1': 'tt', position: 124 }, { id: 125, name: 'Twi', 'iso_639-1': 'tw', position: 125 }, { id: 126, name: 'Ukrainian', 'iso_639-1': 'uk', position: 126 }, { id: 127, name: 'Urdu', 'iso_639-1': 'ur', position: 127 }, { id: 128, name: 'Uzbek', 'iso_639-1': 'uz', position: 128 }, { id: 129, name: 'Vietnamese', 'iso_639-1': 'vi', position: 129 }, { id: 130, name: 'Volapuk', 'iso_639-1': 'vo', position: 130 }, { id: 131, name: 'Wolof', 'iso_639-1': 'wo', position: 131 }, { id: 132, name: 'Xhosa', 'iso_639-1': 'xh', position: 132 }, { id: 133, name: 'Yoruba', 'iso_639-1': 'yo', position: 133 }, { id: 134, name: 'Chinese', 'iso_639-1': 'zh', position: 134 }, { id: 135, name: 'Zulu', 'iso_639-1': 'zu', position: 135 }];

var CONTACT_CATEGORIES = [{
  icon: 'people',
  text: 'Artwork acquisition source',
  path: '/contacts/artwork_acquisition_source',
  name: 'artwork_acquisition_source'
}, {
  icon: 'people',
  text: 'Device acquisition company',
  path: '/contacts/device_acquisition_company',
  name: 'device_acquisition_company'
}, {
  icon: 'people',
  text: 'Loan borrower',
  path: '/contacts/loan_borrower',
  name: 'loan_borrower'
}, {
  icon: 'people',
  text: 'Loan contact person',
  path: '/contacts/loan_contact_person',
  name: 'loan_contact_person'
}, {
  icon: 'people',
  text: 'Press registrant',
  path: '/contacts/press_registrant',
  name: 'press_registrant'
}, {
  icon: 'people',
  text: 'Newsletter registrant',
  path: '/contacts/newsletter_registrant',
  name: 'newsletter_registrant'
}, {
  icon: 'people',
  text: 'Loan insurance company',
  path: '/contacts/deaccession',
  name: 'deaccession'
}, {
  icon: 'people',
  text: 'Registrar',
  path: '/contacts/registrar',
  name: 'registrar'
}, { icon: 'people', text: 'Staff', path: '/contacts/staff', name: 'staff' }, {
  icon: 'people',
  text: 'Staff external',
  path: '/contacts/staff_external',
  name: 'staff_external'
}, {
  icon: 'people',
  text: 'Trustee',
  path: '/contacts/trustee',
  name: 'trustee'
}];

var ACQUISITION_METHODS = [{ id: 1, name: 'Purchase' }, { id: 2, name: 'Auction sale' }, { id: 3, name: 'Commission' }, { id: 4, name: 'Gift' }, { id: 5, name: 'Rededication' }, { id: 7, name: 'Private Sale' }, { id: 8, name: 'Unknown' }];

var VISA_STATUSES = [{ id: 1, name: 'NON EU' }, { id: 2, name: 'EU' }, { id: 3, name: 'FREEPORT' }];

var OPTICAL_FILMS = [{ id: 1, name: '8 mm' }, { id: 2, name: '9.5 mm' }, { id: 3, name: '16mm' }, { id: 4, name: '35mm' }, { id: 5, name: '70mm' }, { id: 6, name: 'Slide' }, { id: 7, name: 'Negative Small Format' }, { id: 8, name: 'Medium Format' }, { id: 9, name: 'Large Format' }, { id: 10, name: 'Microfilm' }, { id: 11, name: 'Other' }];

var OPTICAL_DISCS = [{ id: 1, name: 'Laser Disc' }, { id: 2, name: 'DVD' }, { id: 3, name: 'CD' }, { id: 4, name: 'Other' }];

var MECHANICAL = [{ id: 1, name: 'vinyl record' }, { id: 2, name: 'punch card' }, { id: 3, name: '35mm' }, { id: 4, name: 'Other' }];

var MAGNETIC = [{ id: 1, name: 'Open Reel (1/2“)' }, { id: 2, name: 'Umatic' }, { id: 3, name: 'Betacam/SP' }, { id: 4, name: 'VHS' }, { id: 5, name: 'Digital Betacam' }, { id: 6, name: 'DV  (1/4“)' }, { id: 7, name: 'HDCAM' }, { id: 8, name: 'Other' }];

var ELECTRONICAL = [{ id: 1, name: 'USB' }, { id: 2, name: 'Solid State Drive (SSD)' }, { id: 3, name: 'Read Only Memory (ROM)' }, { id: 4, name: 'Random Access Memory (RAM)' }, { id: 5, name: 'EEPROM' }, { id: 6, name: 'Other' }];

var MATERIALS = [{ id: 1, name: 'nitrate' }, { id: 2, name: 'acetate' }, { id: 3, name: 'polyester' }, { id: 4, name: 'polycarbonate' }, { id: 5, name: 'other polymer' }, { id: 6, name: 'unknown' }, { id: 7, name: 'glass' }, { id: 8, name: 'metal' }, { id: 9, name: 'paper' }, { id: 10, name: 'Other' }];

var VIDEO_SIGNALS = [{ id: 1, name: 'FBAS' }, { id: 2, name: 'Y/C (S-Video I Dub)' }, { id: 3, name: 'YCrCb (digital)' }, { id: 4, name: 'YPbPr (analog)' }, { id: 5, name: 'RGB' }, { id: 6, name: 'unknown' }, { id: 7, name: 'Other' }];

var AUDIO_SIGNALS = [{ id: 1, name: 'Optical' }, { id: 2, name: 'Magnetic' }, { id: 3, name: 'Longitudinal' }, { id: 4, name: 'FM' }, { id: 5, name: 'PCM' }, { id: 6, name: 'Dolby' }, { id: 7, name: 'unknown' }, { id: 8, name: 'Other' }];

var GENERATIONS = [{ id: 1, name: 'Camera Negative' }, { id: 2, name: 'Camera Positive' }, { id: 3, name: 'Inter positive' }, { id: 4, name: 'Inter negative' }, { id: 5, name: 'Revearsal' }];

var STATUSES = [{ id: 1, name: 'Artist\'s Original' }, { id: 2, name: 'Master Physical' }, { id: 3, name: 'Copy Master Physical' }, { id: 4, name: 'Physical Access Copy' }, { id: 5, name: 'Other' }];

var SHELLS = [{ id: 1, name: 'Signed by artist' }, { id: 2, name: 'Designed by artist' }, { id: 3, name: 'Non specific' }];

var ATTACHEMENTS = [{ id: 1, name: 'Certificate' }, { id: 2, name: 'Dub sheet' }, { id: 3, name: 'Vtr card' }, { id: 4, name: 'Installation Instruction' }, { id: 5, name: 'Contract' }, { id: 6, name: 'Photos' }];

var DAMAGE_TYPES = [{ id: 1, name: 'Abrasions Creases' }, { id: 2, name: 'Tear' }, { id: 3, name: 'Residue Discoloration Distortion Water damage Scratch' }, { id: 4, name: 'Tape' }, { id: 5, name: 'Fading' }, { id: 6, name: 'Mould' }, { id: 7, name: 'Flaking' }, { id: 8, name: 'Cracking' }, { id: 9, name: 'Dent' }, { id: 10, name: 'Puncture' }, { id: 11, name: 'Surface Dirt' }, { id: 12, name: 'Loss / Missing Area Smudge' }, { id: 13, name: 'Parasite' }, { id: 14, name: 'Adhesive Residue Stains' }, { id: 15, name: 'Warping' }, { id: 16, name: 'Brittle Yellowed Sticky Dust' }];

var READING_DEVICE_TYPES = [{ id: 1, name: 'computer' }, { id: 2, name: 'micro_controller' }, { id: 3, name: 'film_projector' }, { id: 4, name: 'slide_projector' }, { id: 5, name: 'video_tape_recorder' }, { id: 6, name: 'linear_tape_drive' }, { id: 7, name: 'disc_tape_drive' }, { id: 8, name: 'dvd_player' }, { id: 9, name: 'media_player' }, { id: 10, name: 'other' }];

var COMPUTERS = [{ id: 1, name: 'Server' }, { id: 2, name: 'Laptop' }, { id: 3, name: 'Desktop' }, { id: 4, name: 'Virtual' }, { id: 5, name: 'Other' }];

var MICRO_CONTROLLERS = [{ id: 1, name: 'LCD' }, { id: 2, name: 'LED-LCD' }, { id: 3, name: 'Plasma' }, { id: 4, name: 'Other' }];

var FILM_PROJECTORS = [{ id: 1, name: '8 mm' }, { id: 2, name: '16mm' }, { id: 3, name: '35mm' }, { id: 4, name: 'Other' }];

var SLIDE_PROJECTORS = [{ id: 1, name: 'Single projecting' }, { id: 2, name: 'Slate' }, { id: 3, name: 'Carousel' }, { id: 4, name: 'Other' }];

var VIDEO_TAPE_RECORDERS = [{ id: 1, name: 'Open Reel (1/2“)' }, { id: 2, name: 'Umatic' }, { id: 3, name: 'Betacam/SP' }, { id: 4, name: 'VHS' }, { id: 5, name: 'Digital Betacam' }, { id: 6, name: 'DV (1/4“)' }, { id: 7, name: 'HDCAM' }, { id: 8, name: 'Other' }];

var MONITORS = [{ id: 1, title: 'LCD' }, { id: 2, title: 'LED-LCD' }, { id: 3, title: 'Plasma' }, { id: 4, title: 'CRT' }, { id: 5, title: 'Other' }];

var PROJECTORS = [{ id: 1, title: '8mm' }, { id: 2, title: '16mm' }, { id: 3, title: '35mm' }, { id: 4, title: 'DLP' }, { id: 5, title: 'CRT' }, { id: 6, title: 'Other' }];

var MOTORS = [{ id: 1, title: 'electric motor' }, { id: 2, title: 'pneumatic motor' }, { id: 3, title: 'hydraulic motor' }, { id: 4, title: 'Other' }];

var BULBS = [{ id: 1, title: 'Incandescent light bulb' }, { id: 2, title: 'LED' }, { id: 3, title: 'Halogen' }, { id: 4, title: 'Arc lamp' }, { id: 5, title: 'Gas-discharged lamp (fluorescent, neon)' }, { id: 6, title: 'Other' }];

var ORIGINS = [{ id: 1, title: 'Unique' }, { id: 2, title: 'Dedicated' }, { id: 3, title: 'Historic Dedicated' }, { id: 4, title: 'Non-dedicated' }];

var CHANNELS = [{ id: 1, value: '1', name: 'Single-channel' }, { id: 2, value: '2', name: 'Two-channel' }, { id: 3, value: '3', name: 'Three-channel' }, { id: 4, value: '4', name: 'Four-channel' }, { id: 5, value: '5', name: 'Five-channel' }, { id: 6, value: '6', name: 'Six-channel' }, { id: 7, value: '7', name: 'Seven-channel' }, { id: 8, value: '8', name: 'Eight-channel' }, { id: 9, value: '9', name: 'Nine-channel' }, { id: 10, value: '10', name: 'Ten-channel' }, { id: 11, value: '11', name: '11-channel' }, { id: 12, value: '12', name: '12-channel' }, { id: 13, value: '13', name: '13-channel' }, { id: 14, value: '14', name: '14-channel' }, { id: 15, value: '15', name: '15-channel' }, { id: 16, value: '16', name: '16-channel' }, { id: 17, value: '17', name: '17-channel' }, { id: 18, value: '18', name: '18-channel' }, { id: 19, value: '19', name: '19-channel' }, { id: 20, value: '20', name: '20-channel' }, { id: 21, value: '21', name: '21-channel' }, { id: 22, value: '22', name: '22-channel' }, { id: 23, value: '23', name: '23-channel' }, { id: 24, value: '24', name: '24-channel' }, { id: 25, value: '25', name: '25-channel' }, { id: 26, value: '26', name: '26-channel' }, { id: 27, value: '27', name: '27-channel' }, { id: 28, value: '28', name: '28-channel' }, { id: 29, value: '29', name: '29-channel' }, { id: 30, value: '30', name: '30-channel' }, { id: 31, value: '31', name: '31-channel' }, { id: 32, value: '32', name: '32-channel' }, { id: 33, value: '33', name: '33-channel' }, { id: 34, value: '34', name: '34-channel' }, { id: 35, value: '35', name: '35-channel' }, { id: 36, value: '36', name: '36-channel' }, { id: 37, value: '37', name: '37-channel' }, { id: 38, value: '38', name: '38-channel' }, { id: 39, value: '39', name: '39-channel' }, { id: 40, value: '40', name: '40-channel' }];

var AUDIO_RESOLUTIONS = [{ id: 1, value: '1', name: '32 kHz' }, { id: 2, value: '2', name: '44,1 kHz' }, { id: 3, value: '3', name: '48 kHz' }, { id: 4, value: '4', name: '96 kHz' }, { id: 5, value: '5', name: '192 kHz' }];

var AUDIO_BITS = [{ id: 1, value: '1', name: '16 Bit' }, { id: 2, value: '2', name: '20 Bit' }, { id: 3, value: '3', name: '24 Bit' }];

var INTERFACES = [{ id: 1, name: 'composite' }, { id: 2, name: 'component' }, { id: 3, name: 'SVideo' }, { id: 4, name: 'SDI' }, { id: 5, name: 'VGA' }, { id: 6, name: 'HDMI' }, { id: 7, name: 'DVI' }, { id: 8, name: 'IDE' }, { id: 9, name: 'SATA' }, { id: 10, name: 'USB 2.0' }, { id: 11, name: 'USB 3.0' }, { id: 12, name: 'FireWire' }, { id: 13, name: 'Thunderbolt' }, { id: 14, name: 'XLR Audio' }, { id: 15, name: 'unknown' }, { id: 16, name: 'other' }];

// const CLASSIFICATIONS = [
//   { id: 1, title: 'pppd' },
//   { id: 2, title: 'fvs - digital born' },
//   { id: 3, title: 'fvs - tape' },
//   { id: 4, title: 'fvs - film' },
//   { id: 5, title: 'iao' },
//   { id: 6, title: 'iao including fvs - digital born' },
//   { id: 7, title: 'iao including fvs - tape' },
//   { id: 8, title: 'iao including fvs - film' },
//   { id: 9, title: 'arch' },
//   { id: 10, title: 'furn' }
// ]

// const CLASSIFICATIONS_TEMP = ['pppd', 'fvs', 'iao', 'arch', 'furn']

var TEXT_CATEGORIES = [{ id: 'pr', name: 'PR' }, { id: 'article', name: 'Article' }, { id: 'artwork_text', name: 'Artwork Text' }, { id: 'artist_documents', name: 'Artist Documents' }, { id: 'transcript', name: 'Transcript' }, { id: 'work_text', name: 'Work Text' }, { id: 'notes', name: 'Notes' }, { id: 'publication', name: 'Publication' }];

var GENDERS = [{ id: 'Male', value: 'Male', name: 'Male' }, { id: 'Female', value: 'Female', name: 'Female' }, { id: 'Non-binary', value: 'Non-binary', name: 'Non-binary' }, { id: 'Transgender', value: 'Transgender', name: 'Transgender' }];

// should not be used probably because we check for user rigts in the store and output my_ownerships
var OWNERSHIPS = [{
  id: 1,
  name: 'TBA21 Collection',
  role: 'coll'
}, {
  id: 12,
  name: 'Gemini Masters Limited',
  role: 'gemini'
}, {
  id: 15,
  name: 'Gemini Collections Limited',
  role: 'geminiCL'
},
// {
//   id: 16,
//   name: 'Gemini Collections Deaccessioned',
//   role: 'geminiCD'
//   // },
//   // {
//   //   id: 13,
//   //   name: 'Baron Thyssen'
//   // },
//   // {
//   //   id: 14,
//   //   name: 'FTB'
// },
{
  id: 6,
  name: 'Private Art Collection FTB',
  role: 'pacFvh',
  an_ext: 'D'
}, {
  id: 7,
  name: 'Private Design Collection FTB',
  role: 'pdcFvh',
  an_ext: 'E'
}, {
  id: 17,
  name: 'Private Art Collection EH',
  role: 'pacEh',
  an_ext: 'EH'
}, {
  id: 10,
  name: 'Private Art Collection MR',
  role: 'pacMr',
  an_ext: 'MR'
}, {
  id: 'de',
  role: 'deac',
  name: 'Deaccession'
}, {
  id: '19',
  role: 'pcFT',
  name: 'Private Collection FT”'
},
// {
//   id: 9,
//   name: 'Old Masters',
//   role: 'old_masters'
// },
{
  id: 11,
  name: 'Private Collection Casa Austria',
  role: 'pcCA',
  an_ext: 'CA'
  // {
  //   id: 18,
  //   name: 'NON-TBA21',
  //   role: 'nonTba'
  // }
}];

var ARTIST = {
  tabs: {
    basic: {
      title: 'Basic',
      key: 'basic',
      fields: {
        headline_names: {
          headline: true,
          title: 'Names',
          component: 'EditFieldHeader',
          class: 'xs12'
        },
        name: {
          ctype: 'text-short',
          name: 'name',
          title: 'Name',
          component: 'EditField',
          class: 'xs12'
        },
        first_name: {
          ctype: 'text-short',
          name: 'first_name',
          title: 'First Name',
          component: 'EditField',
          class: 'xs12 md6'
        },
        last_name: {
          ctype: 'text-short',
          name: 'last_name',
          title: 'Last Name',
          component: 'EditField',
          class: 'xs12 md6'
        },
        sort_name: {
          ctype: 'text-short',
          name: 'sort_name',
          title: 'Sort Name',
          component: 'EditField',
          class: 'xs12 md6'
        },
        birth_name: {
          ctype: 'text-short',
          name: 'birthname',
          title: 'Birth Name',
          component: 'EditField',
          class: 'xs12 md6'
        },
        headline_birth: {
          headline: true,
          title: 'Birth',
          component: 'EditFieldHeader',
          class: 'xs12'
        },
        birth_date: {
          ctype: 'date',
          name: 'birth_date',
          title: 'Birth Date',
          component: 'EditField',
          class: 'xs12 md6'
        },
        birth_place: {
          ctype: 'text-short',
          name: 'birthplace',
          title: 'Birth Place',
          component: 'EditField',
          class: 'xs12 md6'
        },
        birthdate_note: {
          ctype: 'text-long',
          name: 'birthdate_note',
          title: 'Birth Date Note',
          component: 'EditField',
          class: 'xs12'
        },
        headline_other: {
          headline: true,
          title: 'Other',
          component: 'EditFieldHeader',
          class: 'xs12'
        },
        death_date: {
          ctype: 'date',
          name: 'death_date',
          title: 'Death date',
          component: 'EditField',
          class: 'xs12 md6'
        },
        gender: {
          ctype: 'radio',
          name: 'gender',
          title: 'Gender',
          component: 'EditField',
          class: 'xs12 md6',
          selection: [{ id: 1, value: 1, name: 'Male' }, { id: 2, value: 2, name: 'Female' }, { id: 3, value: 3, name: 'Non-binary' }, { id: 4, value: 4, name: 'Transgender' }]
        },
        headline_texts: {
          headline: true,
          title: 'Info',
          component: 'EditFieldHeader',
          class: 'xs12'
        },
        livesandworks: {
          ctype: 'text-long',
          name: 'livesandworks',
          title: 'Lives and works',
          component: 'EditField',
          class: 'xs12'
        },
        bio: {
          ctype: 'text-long',
          name: 'bio',
          title: 'Bio',
          component: 'EditField',
          class: 'xs12'
        }
      }
    },
    artworks: {
      title: 'Artworks',
      key: 'artworks',
      component: 'ViewArtworks'
    },
    multi_artist: {
      title: 'Collective',
      key: 'multi_artist',
      component: 'MultiArtist'
    }
  }
};

var COUNTRIES = ['Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia, Plurinational State of', 'Bonaire, Sint Eustatius and Saba', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, the Democratic Republic of the', 'Cook Islands', 'Costa Rica', 'Côte d\'Ivoire', 'Croatia', 'Cuba', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and McDonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic of', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, Democratic People\'s Republic of', 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan', 'Lao People\'s Democratic Republic', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia, the Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine, State of', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Barthélemy', 'Saint Helena, Ascension and Tristan da Cunha', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin (French part)', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten (Dutch part)', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan, Province of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'USA', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela, Bolivarian Republic of', 'Viet Nam', 'Virgin Islands, British', 'Virgin Islands, U.S.', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'];

/* harmony default export */ __webpack_exports__["a"] = ({
  TOOLBAR_MENU_ITEMS: TOOLBAR_MENU_ITEMS,
  OWNERSHIP_STATUSES: OWNERSHIP_STATUSES,
  TYPES_OF_WORK: TYPES_OF_WORK,
  OWNERSHIPS: OWNERSHIPS,
  LANGUAGES: LANGUAGES,
  CONTACT_CATEGORIES: CONTACT_CATEGORIES,
  VISA_STATUSES: VISA_STATUSES,
  ACQUISITION_METHODS: ACQUISITION_METHODS,
  OPTICAL_FILMS: OPTICAL_FILMS,
  OPTICAL_DISCS: OPTICAL_DISCS,
  MECHANICAL: MECHANICAL,
  MAGNETIC: MAGNETIC,
  ELECTRONICAL: ELECTRONICAL,
  MATERIALS: MATERIALS,
  VIDEO_SIGNALS: VIDEO_SIGNALS,
  AUDIO_SIGNALS: AUDIO_SIGNALS,
  GENERATIONS: GENERATIONS,
  STATUSES: STATUSES,
  SHELLS: SHELLS,
  ATTACHEMENTS: ATTACHEMENTS,
  DAMAGE_TYPES: DAMAGE_TYPES,
  READING_DEVICE_TYPES: READING_DEVICE_TYPES,
  COMPUTERS: COMPUTERS,
  MICRO_CONTROLLERS: MICRO_CONTROLLERS,
  FILM_PROJECTORS: FILM_PROJECTORS,
  SLIDE_PROJECTORS: SLIDE_PROJECTORS,
  VIDEO_TAPE_RECORDERS: VIDEO_TAPE_RECORDERS,
  MONITORS: MONITORS,
  PROJECTORS: PROJECTORS,
  MOTORS: MOTORS,
  BULBS: BULBS,
  ORIGINS: ORIGINS,
  CHANNELS: CHANNELS,
  AUDIO_RESOLUTIONS: AUDIO_RESOLUTIONS,
  AUDIO_BITS: AUDIO_BITS,
  INTERFACES: INTERFACES,
  // CLASSIFICATIONS: CLASSIFICATIONS,
  // CLASSIFICATIONS_TEMP: CLASSIFICATIONS_TEMP,
  TEXT_CATEGORIES: TEXT_CATEGORIES,
  GENDERS: GENDERS,
  ARTIST: ARTIST,
  COUNTRIES: COUNTRIES,
  ARTWORK_FIELDS: ARTWORK_FIELDS
});

/***/ }),

/***/ "KDuV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      // dialog: false,
      image: '',
      filter: [],
      keywords: [],
      artwork_photos: [],
      // showUpload: false,
      show: false
      // dropzoneOptions: {
      //   url: 'http://www.tb-cms.org/artworks/multi_uploaded_photo/132',
      //   thumbnailWidth: 150,
      //   maxFilesize: 2.5,
      //   headers: { "Header": "header value" },
      //   params: { "artwork": "artwork.id" },
      //   autoProcessQueue: false,
      //   id: 'dropzone',
      //   // thumbnailWidth: 120,
      //   // thumbnailHeight: 120,
      //   // headers: { "artwork": "artwork.id" },
      //   // previewTemplate: `
      //   //   <div class="dz-preview dz-file-preview">
      //   //     <div class="dz-details">
      //   //       <input type="text" />
      //   //       <div class="dz-filename"><span data-dz-name></span></div>
      //   //       <div class="dz-size" data-dz-size></div>
      //   //       <img data-dz-thumbnail />
      //   //     </div>
      //   //     <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
      //   //     <div class="dz-success-mark"><span>✔</span></div>
      //   //     <div class="dz-error-mark"><span>✘</span></div>
      //   //     <div class="dz-error-message"><span data-dz-errormessage></span></div>
      //   //   </div>`
      // }
    };
  },
  computed: {
    photos: function photos() {
      return this.artwork_photos;
    },
    keywords_calc: function keywords_calc() {
      var artwork = this.artwork;
      if (artwork && artwork.artwork_photos) {
        this.keywords = [];
        for (var ap in artwork.artwork_photos) {
          if (artwork.artwork_photos[ap].keywords) {
            try {
              artwork.artwork_photos[ap].keywords = JSON.parse(artwork.artwork_photos[ap].keywords).map(function (k) {
                return k = k.toString();
              });
            } catch (err) {
              // console.log('error while parsing keywords')
            }
          } else {
            artwork.artwork_photos[ap].keywords = [];
          }
          this.keywords = this.keywords.concat(artwork.artwork_photos[ap].keywords.map(function (k) {
            return k = k.toString();
          }));
        }
      }
      if (artwork && this.keywords) {
        this.keywords = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(this.keywords)));
        this.keywords = this.keywords.sort(function (a, b) {
          return a.toUpperCase().localeCompare(b.toUpperCase());
        });
      }
      // console.log('artwork')
      // console.log(artwork)
      return this.keywords;
    }
  },
  methods: {
    show_photo: function show_photo(id) {
      this.dialog = true;
      this.image = this.artwork.artwork_photos.find(function (p) {
        return p.id === id;
      });
    },
    filter_photos: function filter_photos(tag) {
      // console.log(typeof(tag))
      this.artwork_photos = this.artwork.artwork_photos;
      if (tag != 'all') {
        // console.log(this.photos)
        this.artwork_photos = this.photos.filter(function (p) {
          return p.keywords.indexOf(tag.toString()) != -1;
        });
        // console.log(this.photos)
      }
    }
  },
  mounted: function mounted() {
    this.filter_photos('all');
    // console.log('mounted')
    // console.log(this.artwork_photos)
    // this.artwork_photos = this.artwork.artwork_photos
    // this.artwork_photos = this.artwork.artwork_photos
  }
  // components: {vueDropzone: vue2Dropzone}

});

/***/ }),

/***/ "KK+U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Location_vue__ = __webpack_require__("RgRh");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee889ca_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__ = __webpack_require__("FMlp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("wpdr")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7ee889ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Location_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee889ca_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ee889ca_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "KKja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mx-0 editBG"},[_c('v-card',{staticClass:"editBG elevation-0"},[_c('v-card-text',{attrs:{"mb-0":""}},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","mr-0":"","pr-0":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"black","flat":""},on:{"click":_vm.save}},[_vm._v("Save")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Title"},model:{value:(_vm.article.title),callback:function ($$v) {_vm.$set(_vm.article, "title", $$v)},expression:"article.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Subtitle"},model:{value:(_vm.article.subtitle),callback:function ($$v) {_vm.$set(_vm.article, "subtitle", $$v)},expression:"article.subtitle"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Version"},model:{value:(_vm.article.version),callback:function ($$v) {_vm.$set(_vm.article, "version", $$v)},expression:"article.version"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Support"},model:{value:(_vm.article.support),callback:function ($$v) {_vm.$set(_vm.article, "support", $$v)},expression:"article.support"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Update"},model:{value:(_vm.article.updates),callback:function ($$v) {_vm.$set(_vm.article, "updates", $$v)},expression:"article.updates"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Group"},model:{value:(_vm.article.group),callback:function ($$v) {_vm.$set(_vm.article, "group", $$v)},expression:"article.group"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"At Work"},model:{value:(_vm.article.at_work),callback:function ($$v) {_vm.$set(_vm.article, "at_work", $$v)},expression:"article.at_work"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Publish Date"},model:{value:(_vm.article.publish_date),callback:function ($$v) {_vm.$set(_vm.article, "publish_date", $$v)},expression:"article.publish_date"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Routes Array"},model:{value:(_vm.article.show_in_route),callback:function ($$v) {_vm.$set(_vm.article, "show_in_route", $$v)},expression:"article.show_in_route"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('text-editor',{attrs:{"value":_vm.article.body},on:{"input":function($event){_vm.article.body=$event}}}),_vm._v(" "),_c('v-divider',{staticClass:"my-4"})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "KPIh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KVRz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // showMore: false,
      ownerships: this.$store.getters.my_ownerships
    };
  },

  props: ['artist'],
  methods: {
    getOwnershipName: function getOwnershipName(ao) {
      // console.log(ao)
      var aoo = this.ownerships.find(function (o) {
        return o.id == ao;
      });
      if (aoo) {
        return aoo.name;
      } else {
        return 'Not Set';
      }
    },
    download_text: function download_text(text, item) {
      this.exportHTML(text, item);
    },
    get_texts: function get_texts(artwork_id) {
      var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.texts);
      // console.log('artwork_id')
      // console.log(artwork_id)
      // console.log(a.artist_id == artist_id)
      var aa = a.filter(function (a) {
        return a.artwork_id === artwork_id;
      });
      return aa;
    },
    artist_artworks: function artist_artworks(artist_id) {
      var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
      // console.log('artist_id')
      // console.log(artist_id)
      // console.log(a.artist_id == artist_id)
      var aa = a.filter(function (a) {
        // console.log('a.artist_id')
        // console.log(a.artist_id)
        // console.log(artist_id)
        return a.artist_id === artist_id;
      });
      // console.log(aa)
      return aa;
    },
    clear_selection: function clear_selection() {
      this.$store.dispatch('clearCurrentSelection');
      this.selected = [];
    },
    select_all: function select_all() {},
    save_currently_selected: function save_currently_selected(a, b) {
      // console.log('///////////')
      // console.log('a = ' + a)
      // console.log('b = ' + b.id)
      setTimeout(function () {
        var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
        //// console.log(temp_selection)
        if (!a) {
          // console.log('a true')
          if (!temp_selection.includes(b)) {
            // console.log('doesnt include')
            temp_selection.push(b);
          }
        } else {
          // console.log('false')
          var index = temp_selection.indexOf(b);
          // console.log('index = ' + index)
          temp_selection.splice(index, 1);
        }
        // this.$store.state.currentSelection
        // console.log(temp_selection)
        // this.selected.forEach(s => {
        //   if (!temp_selection.includes(s)) {
        //     temp_selection.push(s)
        //   }
        // })
        // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
        this.$store.dispatch('saveCurrentSelection', temp_selection);
      }.bind(this), 1000);
    },
    save_currently_selected_all: function save_currently_selected_all(a) {
      // console.log('///////////')
      // console.log('a = ' + a)
      var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(temp_selection)
      if (!a) {
        // console.log('a true')
        if (!temp_selection.includes(b)) {
          // console.log('doesnt include')
          temp_selection.push(b);
        }
      } else {
        // console.log('false')
        var index = temp_selection.indexOf(b);
        // console.log('index = ' + index)
        temp_selection.splice(index, 1);
      }
      // this.$store.state.currentSelection
      // console.log(temp_selection)
      // this.selected.forEach(s => {
      //   if (!temp_selection.includes(s)) {
      //     temp_selection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', temp_selection);
    },
    save_currently_selected_tags: function save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags);
      this.ta = this.tagged_artworks;
    }
  }
});

/***/ }),

/***/ "KbaY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mx-3"},[_c('artworks-table',{attrs:{"items":_vm.filteredByOwnership},on:{"switchOwnershipToAll":function($event){return _vm.switchOwnershipToAll($event)},"switchOwnershipTop":function($event){return _vm.switchOwnershipTop($event)},"saveSearchValue":function($event){return _vm.saveSearchValue($event)}}},[_vm._v("\n    @saveArtworkPageValue=\"saveArtworkPageValue($event)\">\n  ")])],1)}
var staticRenderFns = []


/***/ }),

/***/ "L+VH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['text'],
  methods: {
    showAdd: function showAdd() {
      this.$emit('showAdd');
    }
  }
});

/***/ }),

/***/ "L642":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LKPg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

// this file contains field definitions for artwork section
// sections and fields are shown here in order of their appearance in CMS
// component = shows_component = means that field definition is in separate document with that name
// field_title = name under which field can be find in the CMS

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()({
  tabs: {
    basic: {
      title: 'Basic',
      key: 'basic',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      role: 'basic',
      icon: 'fa-palette',
      fields: [{
        name: 'headline_details',
        headline: true,
        title: 'Artwork Details',
        section: 'details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'accession_number',
        title: 'Accession Number',
        tag: 'accession_number',
        obligatory: true,
        desirable: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        etype: 'autocomplete',
        name: 'artist_id',
        obligatory: true,
        desirable: true,
        related_field: 'artist_id',
        title: 'Artist (Full Artist Name)',
        table: 'artists',
        class: 'xs12',
        addNew: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'secondary_maker',
        section: 'details',
        dynamic: true,
        title: 'Secondary Maker',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'title',
        title: 'Title',
        tag: 'title',
        desirable: true,
        obligatory: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'subtitle',
        title: 'Subtitle',
        tag: 'subtitle',
        section: 'details',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'title_notes',
        title: 'Title Notes',
        section: 'details',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'production_date_new',
        title: 'Production Date',
        desirable: true,
        tag: 'production_date',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
        // 'mask': '####'
      }, {
        ctype: 'text-auto',
        name: 'century',
        title: 'Century',
        tag: 'century',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
        // 'mask': '####'
      }, {
        ctype: 'text-auto',
        name: 'decade',
        title: 'Decade',
        tag: 'decade',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
        // 'mask': '####'
      },
      // {
      //   'ctype': 'text-short',
      //   'name': 'production_date_end',
      //   'title': 'Production Date End',
      //   'class': 'xs12 md4',
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      //   'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   'user_groups': ['admin', 'manager']
      // },
      // {
      //   'ctype': 'text-long',
      //   'name': 'production_date_text',
      //   'title': 'Production Date Text',
      //   'section': 'details',
      //   'dynamic': true,
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      //   'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   'user_groups': ['admin', 'manager']
      // },
      {
        ctype: 'text-long',
        name: 'media_material_description',
        title: 'Media Material Description',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'radio',
        etype: 'select',
        selection: [{ id: 1, value: '1', name: 'Single-channel' }, { id: 2, value: '2', name: 'Two-channel' }, { id: 3, value: '3', name: 'Three-channel' }, { id: 4, value: '4', name: 'Four-channel' }, { id: 5, value: '5', name: 'Five-channel' }, { id: 6, value: '6', name: 'Six-channel' }, { id: 7, value: '7', name: 'Seven-channel' }, { id: 8, value: '8', name: 'Eight-channel' }, { id: 9, value: '9', name: 'Nine-channel' }, { id: 10, value: '10', name: 'Ten-channel' }, { id: 11, value: '11', name: '11-channel' }, { id: 12, value: '12', name: '12-channel' }, { id: 13, value: '13', name: '13-channel' }, { id: 14, value: '14', name: '14-channel' }, { id: 15, value: '15', name: '15-channel' }, { id: 16, value: '16', name: '16-channel' }, { id: 17, value: '17', name: '17-channel' }, { id: 18, value: '18', name: '18-channel' }, { id: 19, value: '19', name: '19-channel' }, { id: 20, value: '20', name: '20-channel' }, { id: 21, value: '21', name: '21-channel' }, { id: 22, value: '22', name: '22-channel' }, { id: 23, value: '23', name: '23-channel' }, { id: 24, value: '24', name: '24-channel' }, { id: 25, value: '25', name: '25-channel' }, { id: 26, value: '26', name: '26-channel' }, { id: 27, value: '27', name: '27-channel' }, { id: 28, value: '28', name: '28-channel' }, { id: 29, value: '29', name: '29-channel' }, { id: 30, value: '30', name: '30-channel' }, { id: 31, value: '31', name: '31-channel' }, { id: 32, value: '32', name: '32-channel' }, { id: 33, value: '33', name: '33-channel' }, { id: 34, value: '34', name: '34-channel' }, { id: 35, value: '35', name: '35-channel' }, { id: 36, value: '36', name: '36-channel' }, { id: 37, value: '37', name: '37-channel' }, { id: 38, value: '38', name: '38-channel' }, { id: 39, value: '39', name: '39-channel' }, { id: 40, value: '40', name: '40-channel' }],
        name: 'fvs_channel_id',
        tag: 'fvs_channel_id',
        title: 'Film-channels',
        class: 'xs12',
        work_types: ['fvs'],
        work_types_new: [7, 9, 6],
        user_groups: ['admin', 'manager']
      },
      // {
      //   'ctype': 'text-long',
      //   'name': 'fvs_media_material_description',
      //   'title': 'FVS Media Material Description',
      //   'work_types': ['fvs'],
      //   'user_groups': ['admin', 'manager']
      // },
      {
        ctype: 'text-short',
        name: 'dim_height',
        title: 'Height',
        suffix: ' cm',
        class: 'xs12 md4',
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 5, 10, 6, 4, 7, 8, 9, 11],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'dim_frame_height',
        title: 'Height with Frame',
        suffix: ' cm',
        class: 'xs12 md6',
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'dim_width',
        title: 'Width',
        suffix: ' cm',
        class: 'xs12 md4',
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 5, 10, 6, 4, 7, 8, 9, 11],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'dim_frame_width',
        title: 'Width with Frame',
        suffix: ' cm',
        class: 'xs12 md6',
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'dim_depth',
        title: 'Depth',
        suffix: ' cm',
        class: 'xs12 md4',
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 5, 10, 6, 4, 7, 8, 9, 11],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'dim_frame_depth',
        title: 'Depth with Frame',
        suffix: ' cm',
        class: 'xs12 md6',
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'dim_diameter',
        title: 'Diameter',
        suffix: ' cm',
        section: 'details',
        dynamic: true,
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 5, 4, 10],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'dimensions_notes',
        title: 'Dimensions Notes',
        section: 'details',
        // 'dynamic': true,
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 5, 4, 10, 6, 4, 7, 8, 9, 11],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'series',
        title: 'Series',
        section: 'details',
        tag: 'series',
        dynamic: true,
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 5, 4, 8, 10],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'weight',
        title: 'Weight',
        suffix: ' kg',
        class: 'xs12 md6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
        // },
        // {
        //   'name': 'films',
        //   'component': 'Films',
        //   'title': 'Films',
        //   'work_types': ['fvs'],
        //   'user_groups': ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'edition_state',
        title: 'Edition',
        hint: 'Examples: <br> Edition 1/5 + 2 AP <br> AP 1/2 (Edition of 3)',
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'credit',
        title: 'Credit',
        tag: 'credit',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        headline: true,
        title: 'System',
        section: 'system',
        no_dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      },
      // {
      //   ctype: 'toggle',
      //   selection: [
      //     { id: 'pppd', value: 'pppd', name: 'PPPD' },
      //     { id: 'iao', value: 'iao', name: 'IAO' },
      //     { id: 'fvs', value: 'fvs', name: 'FVS' },
      //     { id: 'arch', value: 'arch', name: 'ARCH' },
      //     { id: 'furn', value: 'furn', name: 'FURN' }
      //   ],
      //   name: 'classification',
      //   title: 'Classification',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   user_groups: ['admin', 'manager']
      // },
      // {
      //   'ctype': 'radio',
      //   'etype': 'select',
      //   'selection': [
      //     { 'id': 'drawing', 'value': 'drawing', 'name': 'Drawing'},
      //     { 'id': 'painting', 'value': 'painting', 'name': 'Painting'},
      //     { 'id': 'photo', 'value': 'photo', 'name': 'Photo / Print'},
      //     { 'id': 'arch', 'value': 'arch', 'name': 'Architecture'},
      //     { 'id': 'object', 'value': 'object', 'name': 'Object / Sculpture'},
      //     { 'id': 'furn', 'value': 'furn', 'name': 'Furniture'},
      //     { 'id': 'inst', 'value': 'inst', 'name': 'Installation'},
      //     { 'id': 'film', 'value': 'film', 'name': 'Film / Video'},
      //     { 'id': 'sound', 'value': 'sound', 'name': 'Sound'},
      //     { 'id': 'performance', 'value': 'performance', 'name': 'Performance'}
      //   ],
      //   'name': 'classification_new_id',
      //   'title': 'Type of Work OLD',
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 9],
      //   'user_groups': ['admin', 'manager']
      // },
      {
        // this one is adjusted according the table artwork_work_types
        ctype: 'select',
        etype: 'select',
        constant_selection: 'TYPES_OF_WORK',
        name: 'type_of_work_id',
        title: 'Type of Work',
        obligatory: true,
        desirable: true,
        tag: 'type_of_work_id',
        // selection: [
        //   { id: 1, value: 1, name: 'Drawing' },
        //   { id: 2, value: 2, name: 'Painting' },
        //   { id: 3, value: 3, name: 'Photo / Print' },
        //   { id: 5, value: 5, name: 'Architecture' },
        //   { id: 4, value: 4, name: 'Object / Sculpture' },
        //   { id: 10, value: 10, name: 'Furniture' },
        //   { id: 6, value: 6, name: 'Installation' },
        //   { id: 7, value: 7, name: 'Film / Video' },
        //   { id: 9, value: 9, name: 'Sound' },
        //   { id: 8, value: 8, name: 'Performance' },
        //   { id: 11, value: 11, name: 'Concept' }
        // ],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      },
      // {
      //   'ctype': 'text-short',
      //   'name': 'including_other',
      //   'title': 'Other',
      //   'class': 'px-4',
      //   // 'section': 'customs',
      //   // 'dynamic': true,
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   'user_groups': ['admin', 'manager']
      // },

      {
        headline: true,
        title: 'Customs',
        section: 'customs',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'component',
        name: 'customs_history',
        title: 'Customs History',
        // 'table': 'artwork_location_logs',
        // 'association': 'artwork_id',
        // 'addNew': true,
        component: 'CustomsHistory',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'toggle',
        name: 'visa_status',
        title: 'Main Visa Status',
        desirable: true,
        selection: [{ id: 'non_eu', value: 1, name: 'NON EU' }, { id: 'eu_definite', value: 2, name: 'EU' }, { id: 'freeport', value: 3, name: 'FREEPORT' }],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'visa',
        title: 'Visa',
        section: 'customs',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'visa_type',
        title: 'Visa Type',
        section: 'customs',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'date',
        name: 'import_date',
        vernon_check: 'visa_import_export_full_details2',
        title: 'Import Date',
        format: 'YYYY-MM-DD',
        class: 'xs12',
        section: 'customs',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      },
      // {
      //   'ctype': 'date',
      //   'name': 'visa_expiry_date',
      //   'title': 'Visa Expiry Date',
      //   'format': 'YYYY-MM-DD',
      //   'class': 'xs12 md6',
      //   'section': 'customs',
      //   'dynamic': true,
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 9],
      //   'user_groups': ['admin', 'manager']
      // },
      {
        ctype: 'text-short',
        name: 'import_taxes',
        title: 'Import Taxes',
        suffix: ' EUR',
        class: 'xs12 md6',
        section: 'customs',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'clearance_paper_number',
        title: 'Clearance Paper Number',
        class: 'xs12 md6',
        section: 'customs',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'mover_importer',
        title: 'Mover Importer',
        class: 'xs12 md6',
        section: 'customs',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'upload_clearance_papers',
        title: 'Upload Clearance Paper',
        section: 'customs',
        component: 'upload',
        dynamic: true,
        role: 'file_u',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager'],
        edit_only: true
      }, {
        ctype: 'text-long',
        name: 'import_export_history',
        title: 'Import Export History',
        section: 'customs',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'import_export_notes',
        title: 'Import Export Notes',
        section: 'customs',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        headline: true,
        title: 'Location',
        desirable: true,
        obligatory: true,
        section: 'location',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      },
      // {
      //   'ctype': 'text-short',
      //   'etype': 'select',
      //   'name': 'artwork_location',
      //   'title': 'Location',
      //   'table': 'artwork_locations',
      //   'association': 'artwork_location',
      //   just_text: true,
      //   'addNew': true,
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   'user_groups': ['admin', 'manager']
      // },
      {
        ctype: 'component',
        name: 'location_history',
        title: 'Location History',
        // 'table': 'artwork_location_logs',
        // 'association': 'artwork_id',
        // 'addNew': true,
        component: 'Location',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      },
      // {
      //   'ctype': 'text-short',
      //   'etype': 'select',
      //   'name': 'location_master_physical',
      //   'title': 'Location Master Physical',
      //   'table': 'artwork_locations',
      //   'association': 'location_master_physical',
      //   'addNew': true,
      //   'work_types': ['fvs'],
      //   'user_groups': ['admin', 'manager']
      // },
      // {
      //   'ctype': 'text-short',
      //   'etype': 'select',
      //   'name': 'location_archive_master',
      //   'title': 'Location Archive Master (digital copy of Master Physical)',
      //   'table': 'artwork_locations',
      //   'association': 'location_archive_master',
      //   'addNew': true,
      //   'work_types': ['fvs'],
      //   'user_groups': ['admin', 'manager']
      // },
      // {
      //   'ctype': 'text-short',
      //   'etype': 'select',
      //   'name': 'location_access_copy',
      //   'title': 'Location Access Copy',
      //   'table': 'artwork_locations',
      //   'association': 'location_access_copy',
      //   'addNew': true,
      //   'work_types': ['fvs'],
      //   'user_groups': ['admin', 'manager']
      // },
      // {
      //   'ctype': 'text-long',
      //   'name': 'packing_specifications',
      //   'title': 'Packing Specifications',
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   'user_groups': ['admin', 'manager']
      // },
      // 'artwork_location_copy_id': {
      //   'ctype': 'text-short',
      //   'name': 'name',
      //   'title': 'Location Copy/Replica',
      //   'table': 'artwork_locations',
      //   'association': 'artwork_location_copy'
      // },
      {
        ctype: 'text-long',
        name: 'location_notes',
        title: 'Location Notes',
        section: 'location',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      },
      // 'dim_diameter': {
      //   'ctype': 'text-short',
      //   'name': 'dim_diameter',
      //   'title': 'Diameter',
      //   'suffix': ' cm'
      // },
      // 'dimensions_notes': {
      //   'ctype': 'text-long',
      //   'name': 'dimensions_notes',
      //   'title': 'Dimensions Notes'
      // },

      {
        headline: true,
        title: 'Authentication',
        no_dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'signature',
        desirable: true,
        title: 'Signature',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        // 'ctype': 'upload',
        component: 'upload',
        name: 'certificate_new',
        desirable: true,
        category: 'artwork_certificate',
        title: 'Certificate',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager'],
        edit_only: true
      }, {
        ctype: 'toggle',
        name: 'signature_new',
        title: 'Signed?',
        selection: [{ id: '0', value: 0, name: 'No' }, { id: '1', value: 1, name: 'Yes' }],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      },
      // {
      //   ctype: "text-long",
      //   name: "duration",
      //   title: "Duration",
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   user_groups: ["admin", "manager"]
      // },
      // {
      //   ctype: "text-long",
      //   name: "duration_notes",
      //   title: "Duration Notes",
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   user_groups: ["admin", "manager"]
      // },

      {
        headline: true,
        title: 'Notes',
        section: 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'additional_comments',
        title: 'Additional Comments',
        dynamic: true,
        section: 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      },

      // {
      //   'headline': true,
      //   'title': 'Media Details',
      //   'no_dynamic': true,
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   'user_groups': ['admin', 'manager']
      // },
      // {
      //   'ctype': 'text-short',
      //   'name': 'fvs',
      //   'title': 'Container (codec video | audio',
      //   'section': 'media_details',
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   'user_groups': ['admin', 'manager']
      // },
      {
        name: 'links',
        component: 'links',
        title: 'Links',
        category: 'artwork',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }]
    },
    advanced: {
      title: 'Advanced',
      key: 'advanced',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      role: 'adv',
      icon: 'fa-sliders-h',
      fields: [{
        name: 'headline_media_details',
        section: 'media_details',
        headline: true,
        title: 'Media details',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'media_details',
        ctype: 'text-long',
        title: 'Basic Narrative Description',
        hint: 'brief description of the artwork considering the different parts and their functions / the technical aspects of the artwork / content if related to the function or needed to explain the functionality (= brief description of work and what is important)',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'dimension_details',
        ctype: 'text-long',
        title: 'Dimension Details',
        hint: 'number of parts, list of components, including dimensions and weights',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'background_of_origin',
        etype: 'text-long',
        ctype: 'text-long',
        title: 'Description background of origin / Production process',
        section: 'media_details',
        dynamic: true,
        hint: 'Description of how the media elements were made: eg. the work was shot on 16 mm film by the artist, the footage was telecined prior to editing... for display the gallery has provided a standard definition DVD which was encoded...)',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'frame',
        ctype: 'text-long',
        title: 'Frame',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1],
        user_groups: ['admin', 'manager']
      }, {
        name: 'glass',
        ctype: 'text-long',
        title: 'Glass',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1],
        user_groups: ['admin', 'manager']
      }, {
        name: 'photo_studio',
        ctype: 'text-long',
        title: 'Photo-studio',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1],
        user_groups: ['admin', 'manager']
      }, {
        name: 'paper',
        ctype: 'text-long',
        title: 'Paper',
        dynamic: true,
        section: 'media_details',
        work_types: ['pppd', 'iao', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1],
        user_groups: ['admin', 'manager']
      },
      // {
      //   'name': 'electrical',
      //   'component': 'electrical',
      //   'title': 'Electrical',
      //   'work_types': ['fvs'],
      //   'user_groups': ['admin', 'manager']
      // },
      {
        ctype: 'text-long',
        name: 'exhibition_copy',
        dynamic: true,
        section: 'media_details',
        title: 'Exhibition Copy',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'toggle',
        name: 'definition',
        dynamic: true,
        section: 'media_details',
        selection: [{ id: '1', value: 1, name: 'Standard (SD)' }, { id: '2', value: 2, name: 'High (HD)' }],
        title: 'Definition',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [6, 7, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'toggle',
        name: 'color',
        dynamic: true,
        section: 'media_details',
        selection: [{ id: '0', value: 0, name: 'No' }, { id: '1', value: 1, name: 'Yes' }],
        title: 'Color',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [6, 7, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'toggle',
        name: 'sound',
        dynamic: true,
        section: 'media_details',
        selection: [{ id: '0', value: 0, name: 'No' }, { id: '1', value: 1, name: 'Yes' }],
        title: 'Sound',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [6, 7, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'toggle',
        name: 'loop',
        dynamic: true,
        section: 'media_details',
        selection: [{ id: '0', value: 0, name: 'No' }, { id: '1', value: 1, name: 'Yes' }],
        title: 'Loop',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [6, 7, 9],
        user_groups: ['admin', 'manager']
      },
      // {
      //   ctype: "text-short",
      //   name: "language_id",
      //   dynamic: true,
      //   section: "media_details",
      //   selection: [
      //     { id: "0", value: 0, name: "No" },
      //     { id: "1", value: 1, name: "Yes" }
      //   ],
      //   vernon: false,
      //   title: "Language",
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   user_groups: ["admin", "manager"]
      // },
      {
        ctype: 'text-short',
        etype: 'autocomplete',
        dynamic: true,
        section: 'media_details',
        name: 'language_id',
        related_field: 'language_id',
        title: 'Language OLD',
        table: 'languages',
        class: 'xs12',
        addNew: false,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [6, 7, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        etype: 'text-short',
        dynamic: true,
        section: 'media_details',
        name: 'language',
        title: 'Language',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [6, 7, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'toggle',
        name: 'fvs_subtitle',
        // dynamic: true,
        section: 'media_details',
        selection: [{ id: '0', value: 0, name: 'No' }, { id: '1', value: 1, name: 'Yes' }],
        title: 'Subtitles',
        work_types: ['pppd', 'iao', 'fvs'],
        work_types_new: [6, 7, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'fvs_subtitle_text',
        dynamic: true,
        section: 'media_details',
        title: 'Subtitle Text',
        work_types: ['pppd', 'iao', 'fvs'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'headline_installation',
        headline: true,
        section: 'installation',
        title: 'Installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'subheadline_installation_requirements',
        subheadline: true,
        section: 'installation_requirements',
        title: 'Requirements',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'technician',
        ctype: 'text-long',
        title: 'Technicians, Contacts & Days for installation and de-installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'space_max_min',
        ctype: 'text-long',
        title: 'Space (max/min)',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'specs_on_space',
        ctype: 'text-long',
        title: 'Space (Floor, Walls, Furniture)',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'required_equipment',
        ctype: 'text-long',
        title: 'Technical Equipment',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'tools_and_gear',
        ctype: 'text-long',
        title: 'Tools & Gear',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'light',
        ctype: 'text-long',
        title: 'Light',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'climate_and_conditions',
        ctype: 'text-long',
        title: 'Climate & Conditions',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'power',
        ctype: 'text-long',
        title: 'Power',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'spare_or_replacement_parts',
        ctype: 'text-long',
        title: 'Spare or replacement parts',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'display_notes_and_other_special_merged',
        ctype: 'text-long',
        title: 'Other / Special',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      },
      // {
      //   'name': 'other_special',
      //   'ctype': 'text-long',
      //   'title': 'Other / Special',
      //   'dynamic': true,
      //   'section': 'installation',
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      //   'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 9],
      //   'user_groups': ['admin', 'manager']
      // },
      // {
      //   'name': 'display_notes',
      //   'ctype': 'text-long',
      //   'title': 'Special Requirement”',
      //   'dynamic': true,
      //   'section': 'installation',
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      //   'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 9],
      //   'user_groups': ['admin', 'manager']
      // },
      {
        name: 'projection',
        ctype: 'text-long',
        title: 'Projection (Size, height, distance, screens)',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'sound_and_acoustic',
        ctype: 'text-long',
        title: 'Sound and acoustic specifications',
        dynamic: true,
        section: 'installation',
        separator: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      },
      // {
      //   'name': 'sound_and_acoustic',
      //   'ctype': 'flex-separator',
      //   'title': 'sound_and_acoustic',
      //   'dynamic': true,
      //   'section': 'installation',
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      //   'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   'user_groups': ['admin', 'manager']
      // },

      {
        name: 'subheadline_existing_equipment',
        subheadline: true,
        section: 'installation_requirements',
        title: 'Existing Equipment',
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        name: 'existing_equipment',
        ctype: 'text-long',
        title: 'Existing Equipment',
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        name: 'subheadline_installation_maintenance',
        subheadline: true,
        section: 'installation_maintenance',
        title: 'Maintenance',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'on_off_procedure',
        ctype: 'text-long',
        title: 'On-and Off-Procedure',
        section: 'installation',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'maintenance',
        ctype: 'text-long',
        title: 'Maintenance',
        section: 'installation',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'security_and_safety_details',
        ctype: 'text-long',
        title: 'Security and Safety Details',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'regular_inspection',
        ctype: 'text-long',
        title: 'Regular inspection/ Pay attention to',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'cleaning_artwork',
        ctype: 'text-long',
        title: 'Cleaning Artwork (how/ what products/ how often)',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'contacts_producers',
        ctype: 'text-long',
        title: 'Contacts / Producers',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager'],
        separator: true
      }, {
        name: 'subheadline_installation_display',
        subheadline: true,
        section: 'installation_display',
        title: 'Display',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'hanging_devices',
        ctype: 'text-long',
        title: 'Hanging Devices',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'specifications_on_space',
        ctype: 'text-long',
        title: 'Specification on hanging/display/ presentation in space',
        dynamic: true,
        section: 'installation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'subheadline_installation_manual',
        subheadline: true,
        section: 'installation_manual',
        title: 'Manual',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        'name': 'links_installation',
        component: 'links',
        'title': 'Links',
        category: 'installation',
        sub_field: true,
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        name: 'installation_manual',
        component: 'upload',
        category: 'video_metadata',
        title: 'Video Metadata',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
        // edit_only: true
      }, {
        name: 'installation_manual',
        component: 'upload',
        category: 'instalman',
        title: 'Installation Manual',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
        // edit_only: true
      }, {
        name: 'installation_related_documents',
        component: 'upload',
        category: 'instalreq',
        title: 'Installation Related Documents',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
        // edit_only: true
      }, {
        name: 'headline_notes',
        headline: true,
        section: 'notes',
        title: 'Notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'statements_of_significance',
        ctype: 'text-long',
        title: 'Statements of Significance',
        dynamic: true,
        section: 'notes',
        hint: 'based on the views of the artist, the curator, the conservator as to what is important about the work / the aim is to provide a statement which will help guide future decisions about the ongoing care and display of the work.',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'notes_merged',
        ctype: 'text-long',
        title: 'Registrar Comments',
        dynamic: true,
        section: 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'other',
        ctype: 'text-long',
        title: 'Other',
        dynamic: true,
        section: 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager']
      }, {
        name: 'correspondences',
        component: 'upload',
        title: 'Correspondences',
        category: 'artwork_corespondence',
        section: 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9, 8],
        user_groups: ['admin', 'manager'],
        edit_only: true
      }]
    },
    elements: {
      title: 'Elements',
      key: 'elements',
      work_types: ['fvs'],
      work_types_new: [7, 9],
      role: 'elem',
      user_rights: ['admin', 'manager'],
      icon: 'fa-plug',
      fields: [
      // {
      //   headline: true,
      //   title: "Material",
      //   no_dynamic: true,
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   user_groups: ["admin", "manager"]
      // },
      // {
      //   name: "electrical",
      //   title: "Electrical",
      //   component: "electrical",
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   user_rights: ["admin", "manager"]
      // },
      // {
      //   name: "non_electrical",
      //   title: "Non-Electrical Materials",
      //   component: "non-electrical",
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   user_rights: ["admin", "manager"]
      // },
      // // {
      // //   'name': 'films',
      // //   'title': 'Films',
      // //   'component': 'Films',
      // //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      // // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      // //   'user_rights': ['admin', 'manager']
      // // },
      // {
      //   name: "reading_devices",
      //   title: "Reading Devices",
      //   component: "reading-devices",
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   user_rights: ["admin", "manager"]
      // },

      // {
      //   headline: true,
      //   title: "Information-Related",
      //   no_dynamic: true,
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   user_groups: ["admin", "manager"]
      // },
      // {
      //   name: "films",
      //   title: "Films",
      //   component: "Films",
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   user_rights: ["admin", "manager"]
      // },
      // {
      //   name: "audio",
      //   title: "Audio",
      //   component: "Audio",
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   user_rights: ["admin", "manager"]
      // },
      // {
      //   name: "lights",
      //   title: "Lights",
      //   component: "Light",
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   user_rights: ["admin", "manager"]
      // },
      // {
      //   name: "programme_software",
      //   title: "Programme / Software",
      //   component: "Programme",
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      //   user_rights: ["admin", "manager"]
      // },

      {
        headline: true,
        title: 'Information Carrier',
        no_dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'information_carrier',
        title: 'Information Carrier',
        component: 'InformationCarrier',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }]
    },

    acquisition: {
      title: 'Acquisition',
      key: 'acquisition',
      role: 'acq',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [1, 2, 3, 5, 4, 6, 7, 8, 9, 10, 11, 18, 16],
      icon: 'euro',
      fields: [{
        name: 'headline_registration',
        headline: true,
        title: 'Registration',
        no_dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'registration_date',
        ctype: 'date',
        title: 'Registration Date',
        format: 'YYYY-MM-DD',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'registrar_id',
        // 'ctype': 'text-short',
        etype: 'select',
        title: 'Registrar',
        table: 'contacts',
        association: 'registrar',
        related_field: 'registrar_id',
        column: 'category',
        add: false,
        preicon: 'person',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'acquired',
        title: 'Ownership Status',
        ctype: 'toggle',
        selection: [{ id: 'nontba', value: 'nontba', name: 'Non-TBA' }, { id: 'commission', value: 'commission', name: 'Commission' }, { id: 'acquired', value: 'acquired', name: 'Acquired' }, { id: 'com_academy', value: 'com_academy', name: 'COMMISSION TBA21-ACADEMY' }],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'acquisition_method',
        title: 'Acquisition Method',
        etype: 'select',
        ctype: 'select',
        selection: [{ id: 1, value: 1, name: 'Purchase' }, { id: 2, value: 2, name: 'Auction sale' }, { id: 3, value: 3, name: 'Commission' }, { id: 4, value: 4, name: 'Gift' }, { id: 5, value: 5, name: 'Rededication' }, { id: 7, value: 7, name: 'Private Sale' }, { id: 8, value: 8, name: 'Unknown' }],
        condition_field: 'acquired',
        condition_value: 'acquired',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        ctype: 'date',
        name: 'acquisition_date',
        title: 'Acquisition Date',
        format: 'YYYY-MM-DD',
        condition_field: 'acquired',
        condition_value: 'acquired',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'purchase_agreement',
        title: 'Agreement',
        component: 'Upload',
        category: 'artwork_purchase',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager'],
        edit_only: true
      }, {
        name: 'headline_provenance',
        section: 'provenance',
        headline: true,
        title: 'Provenance',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'acquisition_source_id',
        title: 'Source',
        etype: 'autocomplete',
        ctype: 'text-short',
        table: 'contacts',
        association: 'artwork_acquisition_source',
        related_field: 'acquisition_source_id',
        column: 'category',
        add: false,
        preicon: 'person',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'provenance_history',
        title: 'Provenance History',
        // 'dynamic': true,
        etype: 'text-long',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'other_reference_number',
        title: 'Other Reference Number',
        class: 'xs12',
        section: 'provenance',
        dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager'],
        edit_only: true
      }, {
        name: 'headline_system',
        headline: true,
        section: 'system',
        // 'no_dynamic': true,
        title: 'Ownership',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'ownership',
        title: 'Ownership',
        ctype: 'select',
        etype: 'select',
        selection: [{ id: 18, value: 1, name: 'Non-TBA21' }, { id: 1, value: 1, name: 'TBA21 Collection' }, { id: 6, value: 6, name: 'Private Art FTB' }, { id: 7, value: 7, name: 'Private Design FTB' }, { id: 10, value: 10, name: 'Private Art MR' }, { id: 17, value: 17, name: 'Private Art Collection EH' }, { id: 19, value: 19, name: 'Private Collection FT' }, { id: 11, value: 11, name: 'Private Collection Casa Austria' }, { id: 12, value: 12, name: 'Gemini Masters Limited' }, { id: 15, value: 15, name: 'Gemini Collections Limited' }, { id: '', value: '', name: 'None'
          // { id: 16, value: 16, name: "Gemini Collections Deaccessioned" }
          // { id: 9, value: 9, name: "Old Master" }
        }],
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'ownership_history',
        title: 'Ownership history',
        ctype: 'text-long',
        etype: 'text-long',
        // 'dynamic': true,
        // 'section': 'system',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'comment_on_ownership',
        title: 'Comment on Ownership',
        ctype: 'text-long',
        etype: 'text-long',
        dynamic: true,
        section: 'system',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        ctype: 'component',
        name: 'ownership_history2',
        title: 'Ownership History',
        component: 'OwnershipHistory',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'headline_purchase',
        headline: true,
        no_dynamic: false,
        section: 'purchase',
        title: 'Purchase',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'purchase_offer',
        // mask: '############',
        title: 'Purchase Offer',
        ctype: 'currency',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'discount',
        title: 'Discount (percentage)',
        // mask: '#####',
        suffix: ' %',
        ctype: 'text-short',
        class: 'xs12 ',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'discount_sum',
        title: 'Discount (Sum)',
        ctype: 'currency',
        // ctype: "text-short",
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      },
      // {
      //   name: "discount_man",
      //   vernon: false,
      //   title: "Discount manually",
      //   // 'ctype': 'text-short',
      //   ctype: "currency",
      //   class: "xs12",
      //   work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
      //   work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   user_rights: ["admin", "manager"]
      // },

      {
        name: 'purchase_offer_vat',
        suffix: ' %',
        title: 'VAT',
        // mask: '###',
        ctype: 'text-short',
        class: 'xs12 sm4',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'vat_manual',
        title: 'VAT (Sum)',
        ctype: 'currency',
        class: 'xs12 sm8',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        etype: 'autocomplete',
        name: 'paid_in_country',
        // related_field: 'paid_in_country',
        title: 'VAT Paid in Country',
        table: 'countries',
        class: 'xs12 mt-0 pt-0',
        addNew: false,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'purchased_price',
        title: 'Purchase Price',
        ctype: 'text-short',
        // mask: '############',
        etype: 'currency',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'purchase_notes',
        title: 'Purchase Notes',
        section: 'purchase',
        dynamic: true,
        ctype: 'text-long',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      },
      // {
      //   'name': 'invoice_number',
      //   'title': 'Invoice Number',
      //   'ctype': 'text-short',
      //   // 'etype': 'currency',
      //   'class': 'xs6 md4',
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   'user_rights': ['admin', 'manager']
      // },
      {
        name: 'invoice_date',
        title: 'Invoice Date',
        ctype: 'date',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'invoice_signed',
        title: 'Invoice Signed',
        ctype: 'bool',
        class: 'xs12 md6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'invoice_upload',
        title: 'Invoice',
        component: 'Upload',
        category: 'artwork_invoice',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager'],
        edit_only: true
      },
      // {
      //   'name': 'invoice',
      //   'title': 'Invoice Exists',
      //   'ctype': 'bool',
      //   'class': 'xs12 md6',
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   'user_rights': ['admin', 'manager']
      // },

      {
        name: 'headline_insurance',
        headline: true,
        no_dynamic: true,
        title: 'Insurance',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        ctype: 'component',
        name: 'insurance_history',
        title: 'Insurance History',
        // 'table': 'artwork_location_logs',
        // 'association': 'artwork_id',
        // 'addNew': true,
        component: 'Insurance',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'insurance_value',
        title: 'Insurance Value',
        // mask: '############',
        ctype: 'text-short',
        disabled: true,
        etype: 'currency',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'insurance_value_date',
        title: 'Insurance Value Date',
        ctype: 'date_separated',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'insurance_valuer',
        title: 'Insurance Valuer',
        ctype: 'text-short',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'insurance_notes',
        title: 'Insurance Notes',
        ctype: 'text-long',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'headline_market',
        headline: true,
        no_dynamic: true,
        title: 'Market Value History',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        ctype: 'component',
        name: 'market_history',
        title: 'Market Value History',
        // 'table': 'artwork_location_logs',
        // 'association': 'artwork_id',
        // 'addNew': true,
        component: 'MarketValueHistory',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'market_value_low',
        title: 'Market Value',
        ctype: 'text-short',
        // etype: "text-short",
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'market_value_low_currency',
        title: 'Market Value Currency',
        ctype: 'currency_only',
        // etype: "text-short",
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'market_value_date',
        title: 'Market Value Date',
        ctype: 'date_separated',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'market_value_high',
        title: 'Market Valuer',
        ctype: 'text-short',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'market_notes',
        title: 'Market Notes',
        ctype: 'text-long',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'research_on_value',
        title: 'Research on Value',
        component: 'Upload',
        category: 'artwork_research_on_value',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager'],
        edit_only: true
      }, {
        name: 'headline_costs',
        headline: true,
        title: 'Costs',
        no_dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      },
      // {
      //   'name': 'costs',
      //   'title': 'Costs',
      //   'ctype': 'text-short',
      //   'work_types': ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      // 'work_types_new': [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      //   'user_rights': ['admin', 'manager']
      // },,
      {
        name: 'costs',
        title: 'Costs',
        component: 'Costs',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'headline_loan_conditions',
        headline: true,
        title: 'Loan Conditions',
        no_dynamic: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'loan_conditions',
        title: 'Loan Conditions',
        component: 'LoanConditions',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'headline_deaccession',
        headline: true,
        no_dynamic: true,
        title: 'Deaccession',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'deaccessioned',
        title: 'Deaccessioned',
        ctype: 'bool',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'deaccession_date',
        title: 'Deaccession Date',
        ctype: 'date',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'comment_on_deaccession',
        title: 'Comment on Deaccession',
        ctype: 'text-long',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'new_ownership',
        title: 'New Ownership',
        ctype: 'text-short',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'deaccession_price_offer',
        title: 'Deaccession Price / Offer',
        ctype: 'text-short',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'deaccession_price_paid',
        title: 'Deaccession Price / Paid',
        ctype: 'text-short',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager']
      }, {
        name: 'invoice_deaccession_papers',
        title: 'Invoice/Deaccession Papers',
        component: 'Upload',
        category: 'artwork_deaccession_papers',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager'],
        edit_only: true
      }]
    },
    images: {
      title: 'Images',
      key: 'images',
      role: 'images',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      component: 'Images',
      class: 'mt-5',
      icon: 'fa-images'
    },
    exhibition_history: {
      title: 'Exhibition History',
      key: 'exhibition_history',
      component: 'ExhibitionHistory',
      role: 'eh',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 4, 5, 6, 7, 8, 9, 10],
      icon: 'fa-history'
    },
    loan_history: {
      title: 'Loan History',
      key: 'loan_history',
      component: 'LoanHistory',
      role: 'a_loan_history',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 4, 5, 6, 7, 8, 9, 10],
      icon: 'fa-history'
    },
    work_history: {
      title: 'Work History',
      key: 'work_history',
      role: 'wh',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      icon: 'fa-history',
      fields: [{
        name: 'production_history',
        title: 'Production History',
        component: 'Upload',
        category: 'artwork_productio_history',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_rights: ['admin', 'manager'],
        edit_only: true
      }, {
        name: 'co_producer',
        ctype: 'text-long',
        title: 'Co-producer',
        // 'dynamic': true,
        section: 'notes',
        class: 'mt-3',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'production_credits',
        ctype: 'text-long',
        title: 'Production Credits',
        // 'dynamic': true,
        // 'section': 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'photostudio',
        ctype: 'text-long',
        title: 'Photostudio',
        // 'dynamic': true,
        // 'section': 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'developing_process',
        ctype: 'text-long',
        title: 'Developing Process',
        // 'dynamic': true,
        // 'section': 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'production_place_original',
        ctype: 'text-short',
        title: 'Production Place - Original',
        // 'dynamic': true,
        // 'section': 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'production_place_copy',
        ctype: 'text-short',
        title: 'Production Place - Copy',
        // 'dynamic': true,
        // 'section': 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'production_date_original',
        ctype: 'text-short',
        title: 'Production Date - Original',
        // 'dynamic': true,
        // 'section': 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'production_date_copy',
        ctype: 'text-short',
        title: 'Production Date - Copy/Replica',
        // 'dynamic': true,
        // 'section': 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'reason_for_production_of_copy',
        ctype: 'text-long',
        title: 'Reason for Production of Copy/Replica',
        // 'dynamic': true,
        // 'section': 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        name: 'production_notes',
        ctype: 'text-long',
        title: 'Production Notes',
        // 'dynamic': true,
        // 'section': 'notes',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }]
    },
    timeline: {
      title: 'Timeline',
      key: 'timeline',
      component: 'Timeline',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 4, 5, 6, 7, 8, 9, 10, 11],
      icon: 'timeline'
    },
    texts: {
      title: 'Texts',
      key: 'texts',
      role: 'texts_tab',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      component: 'Texts',
      icon: 'subject'
    },
    selections: {
      title: 'Selections',
      key: 'selections',
      role: 'selections',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      component: 'Selections',
      icon: 'subject'
    },
    journals: {
      title: 'Journals',
      key: 'journals',
      role: 'journals',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      component: 'Journals',
      icon: 'published_with_changes'
    },
    packing: {
      title: 'Packing',
      key: 'packing',
      role: 'packing',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 8, 5, 4, 10, 11, 9],
      component: 'Packings',
      icon: 'fa-archive'
    },
    todos: {
      title: 'Todos',
      key: 'todos',
      role: 'todos_tab',
      component: 'Todos',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 4, 5, 6, 7, 8, 9, 10, 11],
      icon: 'fa-list-ol'
    },
    // films: {
    //   'title': 'Films',
    //   'key': 'films',
    //   'component': 'Films'
    // },
    tags: {
      title: 'Tags',
      key: 'tags',
      role: 'tags',
      component: 'Tags',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 4, 5, 6, 7, 8, 9, 10, 11],
      icon: 'fa-tags'
    },
    conservation: {
      title: 'Conservation',
      key: 'conservation',
      role: 'cons',
      work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
      work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
      icon: 'mdi-toolbox',
      fields: [{
        name: 'headline_conservation',
        no_dynamic: true,
        headline: true,
        title: 'Conservation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst', 'furn'],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ['admin', 'manager']
      }, {
        ctype: "component",
        name: "conservation",
        title: "Conservation",
        component: "Conservation",
        work_types: ["pppd", "iao", "fvs", "arch", "inst", "furn"],
        work_types_new: [2, 18, 3, 1, 16, 6, 7, 5, 4, 10, 11, 9],
        user_groups: ["admin", "manager"]
      }]
    }
  }
}));
// specifications: {
//   'ctype': 'text-long',
//   'name': 'specifications',
//   'title': 'Existing Equipment'
// },
// special_requirements: {
//   'ctype': 'text-long',
//   'name': 'special_requirements',
//   'title': 'Special Requirements'
// },

// headline_notes: {
//   'headline': true,
//   'title': 'Notes'
// },
// notes_merged: {
//   'ctype': 'text-long',
//   'name': 'notes_merged',
//   'title': 'Notes Merged'
// }

/***/ }),

/***/ "LN2U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{staticClass:"px-2 navbar",staticStyle:{"position":"fixed","top":"80px"},attrs:{"width":"420","temporary":"","absolute":"","fixed":"","right":"","dark":"","hide-overlay":""},model:{value:(_vm.options_c),callback:function ($$v) {_vm.options_c=$$v},expression:"options_c"}},[_c('v-layout',{attrs:{"row":"","pt-3":"","pl-2":"","pb-2":""}},[_c('v-flex',[_c('v-subheader',{staticClass:"font-weight-regular display-1 white--text pl-0 ml-2"},[_vm._v("\n          Options\n          "),_c('v-spacer'),_vm._v(" "),_c('a',{staticClass:"font-weight-regular display-1 white--text",on:{"click":function($event){_vm.options_c = false}}},[_vm._v("\n            X")])],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3 pb-0 mb-0 white"}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","pt-0":"","my-3":""}},[_c('v-flex',[_c('v-subheader',{staticClass:"white--text"},[_c('v-btn',{attrs:{"outline":""},on:{"click":_vm.exportExcel}},[_vm._v("Download artworks with tags in Excel")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"590"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are your sure to delete \""),_c('strong',[_vm._v(_vm._s(_vm.tagToDelete.name))]),_vm._v("\" tag?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        This tag and all it's assignemts to artwroks will be deleted.\n      ")]),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('div',{staticClass:"flex-grow-1"}),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","text":""},on:{"click":function($event){return _vm.deleteTag(_vm.tagToDelete.id)}}},[_vm._v("\n          Delete Tag\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"700px"},model:{value:(_vm.edit_dialog),callback:function ($$v) {_vm.edit_dialog=$$v},expression:"edit_dialog"}},[_c('v-card',{staticClass:"pb-2"},[_c('v-card-title',[_c('span',{staticClass:"headline mx-4 mt-3"},[_vm._v("#"+_vm._s(_vm.editedItem.name))])]),_vm._v(" "),_c('v-card-text',{staticClass:"my-0 py-0"},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Tag Name"},model:{value:(_vm.editedItem.name),callback:function ($$v) {_vm.$set(_vm.editedItem, "name", $$v)},expression:"editedItem.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Alternatives"},model:{value:(_vm.editedItem.alternatives),callback:function ($$v) {_vm.$set(_vm.editedItem, "alternatives", $$v)},expression:"editedItem.alternatives"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Subcateogry"},model:{value:(_vm.editedItem.subcategory),callback:function ($$v) {_vm.$set(_vm.editedItem, "subcategory", $$v)},expression:"editedItem.subcategory"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":['concept', 'cataloguing'],"label":"Section","single-line":""},model:{value:(_vm.editedItem.section),callback:function ($$v) {_vm.$set(_vm.editedItem, "section", $$v)},expression:"editedItem.section"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"mx-3 pb-4 pt-0 mb-0"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"","outline":"","flat":""},on:{"click":_vm.close}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"black","dark":"","flat":""},on:{"click":_vm.save}},[_vm._v("Save")])],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"elevation-0 mx-3 py-5"},[_c('v-card-title',[_c('v-layout',{attrs:{"row":"","my-3":"","ml-2":"","mr-3":""}},[_c('v-flex',{staticClass:"mt-2 ml-0 pl-0"},[_c('v-btn-toggle',{attrs:{"mandatory":""},model:{value:(_vm.tag_filter),callback:function ($$v) {_vm.tag_filter=$$v},expression:"tag_filter"}},[_c('v-btn',{key:"all",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"all","value":"all"}},[_c('span',[_vm._v(" All ")])]),_vm._v(" "),_c('v-btn',{key:"concept",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"concept","value":"concept"}},[_c('span',[_vm._v(" concept ")])]),_vm._v(" "),_c('v-btn',{key:"cataloguing",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"cataloguing","value":"cataloguing"}},[_c('span',[_vm._v(" cataloguing ")])]),_vm._v(" "),_c('v-btn',{key:"private",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"private","value":"private"}},[_c('span',[_vm._v(" private ")])])],1)],1),_vm._v(" "),_c('add-new'),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.$store.state.showSearch)?_c('v-text-field',{attrs:{"append-icon":"search","label":"Search Tags ","single-line":"","hide-details":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0 mx-4 px-0",attrs:{"pagination":_vm.pagination,"headers":_vm.headers,"items":_vm.filteredTags,"search":_vm.search,"item-key":"id","must-sort":"","expand":"","rows-per-page-text":"Tags per page","no-results-text":"No Tags match the criteria."},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:{
            'py-2': true,
            'px-0': true,
            black: props.expanded,
            'white--text': props.expanded
          }},[_c('td',{staticClass:"pl-0 ",on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('a',{staticClass:"subheading font-weight-bold",on:{"click":function($event){return _vm.editItem(props.item)}}},[_vm._v("#"+_vm._s(props.item.name))]),_c('br'),_vm._v("\n            "+_vm._s(props.item.subcategory)+" \n          ")]),_vm._v(" "),_c('td',{staticClass:"subheading",attrs:{"color":props.item.color}},[_vm._v("\n             "+_vm._s(_vm.tag_category(props.item.tag_category_id))+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"px-4 pb-2"},[_c('v-tooltip',{staticClass:"mr-3",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"black","icon":"","small":""},on:{"click":function($event){return _vm.loadSelection(props.item.id)}}},on),[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("apps")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Add Tag to Artworks in Current Selection ("+_vm._s(_vm.currentSelection.length)+") ")])]),_vm._v(" "),_c('v-tooltip',{staticClass:"mr-3",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"black","icon":"","small":""},on:{"click":function($event){return _vm.addToSelection(props.item.id)}}},on),[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("add")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Add Artworks in this Selection to current Selection")])])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[(_vm.anySelected)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","alt":"Add this Tag to artworks in Current Selection"},on:{"click":function($event){return _vm.add_tag_to_current_selection(props.item.id)}}},on),[_c('v-icon',{attrs:{"color":"green lighten-1"}},[_vm._v("mdi-tag-plus")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Add this Tag "),_c('br'),_vm._v("to artworks "),_c('br'),_vm._v("in Current\n                Selection")])]):_vm._e(),_vm._v(" "),(_vm.anySelected)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":"primary","dark":""}},on),[_vm._v("home")]),_vm._v(" "),_c('v-btn',_vm._g({attrs:{"icon":"","alt":"Add all artworks with this tag to selection"},on:{"click":function($event){_vm.add_artworks_to_selection(_vm.filteredArtworks(props.item.id))}}},on),[_c('v-icon',{attrs:{"color":"green lighten-1"}},[_vm._v("mdi-tag-multiple")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Add artworks with this Tag "),_c('br'),_vm._v("to Current Selection")])]):_vm._e(),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.showConfDeleteTag(props.item.id)}}},[_c('v-icon',{attrs:{"small":"","color":"red lighten-1"}},[_vm._v("delete")])],1):_vm._e()],1)])]}},{key:"expand",fn:function(props){return [_c('v-flex',{staticClass:"px-3 py-1 my-0 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("   ")])])]}}])},[_vm._v(" "),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Your search for \""+_vm._s(_vm.search)+"\" found no results.\n      ")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "LShn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_exhibitions_IndexTable__ = __webpack_require__("BAys");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // displayedData: [],
      // ownerships,
      // filteredTextArtwork: '',
      // filteredTextArtist: '',
      // selectedFilter: '',
      // artwork: {
      //   name: ''
      // },
      // artists: [],
      // artworks: [],
      // resultsArtworks: [],
      // resultsArtists: [],
      // editArtwork: false,
      // filterText: ''
    };
  },
  components: {
    IndexTable: __WEBPACK_IMPORTED_MODULE_0__components_exhibitions_IndexTable__["a" /* default */]
  }
});

/***/ }),

/***/ "Ly+y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__("/nBd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eef94486_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__("2A7+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("J0aq")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eef94486"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eef94486_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eef94486_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M21a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBox_vue__ = __webpack_require__("gC1K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50b1ea92_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBox_vue__ = __webpack_require__("Sh4X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fPbq")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-50b1ea92"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50b1ea92_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_50b1ea92_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M8Lx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticStyle:{"top":"65px","position":"fixed"},attrs:{"fixed":"","tabs":"","color":"white elevation-2"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("arrow_back")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(this.artwork.title)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(this.artwork.artist.name))]),_vm._v(" "),_c('v-tabs',{attrs:{"slot":"extension","color":"transparent","slider-color":"yellow","align-with-title":""},slot:"extension",model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},_vm._l((this.$store.state.users.full_user_fields.tabs),function(tab){return _c('v-tab',{key:tab.key,attrs:{"ripple":false,"href":'#tab-' + tab.key},on:{"click":function($event){return _vm.saveCurrentTab('tab-' + tab.key)}}},[_vm._v("\n        "+_vm._s(tab.title)+"\n      ")])}),1)],1),_vm._v(" "),_c('v-tabs-items',{staticStyle:{"top":"120px"},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},_vm._l((this.$store.state.users.full_user_fields.tabs),function(tab){return _c('v-tab-item',{key:tab.key,attrs:{"id":'tab-' + tab.key}},[(!tab.component)?_c('v-card',{attrs:{"flat":""}},[(tab.fields)?_c('v-card-text',_vm._l((tab.fields[_vm.processedArtwork.classification]),function(field){return _c('field-box',{key:field.key,attrs:{"artwork":_vm.processedArtwork,"artist":_vm.processedArtwork.artist,"field":field}})}),1):_vm._e()],1):_c('v-card',{attrs:{"flat":""}},[_c(tab.component,{tag:"component",attrs:{"artwork":_vm.processedArtwork}})],1)],1)}),1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d7c7c8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("+KPd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Qi+p")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d7c7c8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_04d7c7c8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MBU1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-0",attrs:{"small":_vm.small,"light":_vm.light,"loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.pdfLabelsCall.apply(null, arguments)}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":_vm.small}},[_vm._v("mdi-file-pdf")]),_vm._v(" a5 LABELS")],1)}
var staticRenderFns = []


/***/ }),

/***/ "MCIr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":"","mx-3":""}},[_c('v-flex',{staticClass:"mb-3 px-3 py-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#ddd"}},[_c('h3',{staticClass:"font-weight-bold xs12 flex"},[_vm._v("\n        Artwork Image\n        "),_c('v-btn',{staticClass:"white--text right mt-0 mr-0 mb-0 px-3 xs12",attrs:{"small":"","round":"","target":"_blank","href":((_vm.$globals.fileserver) + "/upload_image.html?id=" + (_vm.artwork.id) + "&u=" + (_vm.c_user.id)),"color":"black","text--color":"","rel":"noopener noreferrer"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"white"}},[_vm._v("cloud_upload")]),_vm._v("\n          Upload New\n        ")],1)],1)]),_vm._v(" "),_c('v-flex',{staticClass:"px-0 mx-0 mb-5",attrs:{"xs12":""}},[(_vm.artwork.top_photo_id)?_c('v-img',{staticStyle:{"max-width":"100%","background-size":"contain"},attrs:{"contain":"","height":"400","src":((_vm.$globals.oldserver) + "/data/artwork/" + (_vm.artwork.id) + "/" + (_vm.artwork.top_photo_id) + "_th_big.jpg")}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "MH8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grey lighten-3 pt-0 mt-5",staticStyle:{"min-height":"100%","margin":"0 auto"}},[_c('v-layout',{staticStyle:{"background-color":"white","height":"50px","width":"100%","top":"135px","position":"fixed","z-index":"1"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}})],1),_vm._v(" "),_c('v-toolbar',{staticClass:"elevation-1  mt-2",staticStyle:{"top":"155px","position":"fixed","z-index":"1"},attrs:{"color":"white","tabs":""}},[_c('v-toolbar-title',{staticClass:"pl-3 headline",domProps:{"innerHTML":_vm._s(_vm.text.given_filename)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.deleteText()}}},[_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":"","disabled":!_vm.valid,"right":""},on:{"click":_vm.saveText}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("save")])],1)],1),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-xs":"","mx-3":"","pt-5":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","mr-4":"","mt-4":""}},[_c('SectionHeader',{staticClass:"mb-2",attrs:{"text":"Basic"}}),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"File Name"},model:{value:(_vm.text.given_filename),callback:function ($$v) {_vm.$set(_vm.text, "given_filename", $$v)},expression:"text.given_filename"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Title Publication"},model:{value:(_vm.text.title),callback:function ($$v) {_vm.$set(_vm.text, "title", $$v)},expression:"text.title"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Editor"},model:{value:(_vm.text.editor),callback:function ($$v) {_vm.$set(_vm.text, "editor", $$v)},expression:"text.editor"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Author(s)"},model:{value:(_vm.text.authors),callback:function ($$v) {_vm.$set(_vm.text, "authors", $$v)},expression:"text.authors"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Year","mask":"####"},model:{value:(_vm.text.year),callback:function ($$v) {_vm.$set(_vm.text, "year", $$v)},expression:"text.year"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Place"},model:{value:(_vm.text.place),callback:function ($$v) {_vm.$set(_vm.text, "place", $$v)},expression:"text.place"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Publisher"},model:{value:(_vm.text.publisher),callback:function ($$v) {_vm.$set(_vm.text, "publisher", $$v)},expression:"text.publisher"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"URL (link)"},model:{value:(_vm.text.url),callback:function ($$v) {_vm.$set(_vm.text, "url", $$v)},expression:"text.url"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-2",attrs:{"xs12":"","md6":""}},[_c('h4',{staticClass:"body-2 mt-0 ml-0 mb-1 grey--text text--darken-2"},[_vm._v("Format")]),_vm._v(" "),_c('v-btn-toggle',{model:{value:(_vm.text.text_type),callback:function ($$v) {_vm.$set(_vm.text, "text_type", $$v)},expression:"text.text_type"}},[_c('v-btn',{key:"print",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"print","value":"print"}},[_c('span',[_vm._v(" Print ")])]),_vm._v(" "),_c('v-btn',{key:"online",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"online","value":"online"}},[_c('span',[_vm._v(" Online ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"py-2 mb-3",attrs:{"xs12":"","md6":""}},[_c('h4',{staticClass:"body-2 mt-0 ml-0 mb-1 grey--text text--darken-2"},[_vm._v("Ownership")]),_vm._v(" "),_c('v-btn-toggle',{model:{value:(_vm.text.tba),callback:function ($$v) {_vm.$set(_vm.text, "tba", $$v)},expression:"text.tba"}},[_c('v-btn',{key:"tba",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"tba","value":"tba"}},[_c('span',[_vm._v(" TBA ")])]),_vm._v(" "),_c('v-btn',{key:"nontba",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"nontba","value":"nontba"}},[_c('span',[_vm._v(" NON TBA ")])])],1)],1),_vm._v(" "),_c('SectionHeader',{attrs:{"text":"Type of text / resource"}}),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","my-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Article (magazine, journal, etc)"},model:{value:(_vm.text.article),callback:function ($$v) {_vm.$set(_vm.text, "article", $$v)},expression:"text.article"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","my-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Text on artwork (exhibition, website, social media etc)"},model:{value:(_vm.text.artwork_text),callback:function ($$v) {_vm.$set(_vm.text, "artwork_text", $$v)},expression:"text.artwork_text"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","my-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Press release"},model:{value:(_vm.text.pr),callback:function ($$v) {_vm.$set(_vm.text, "pr", $$v)},expression:"text.pr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","my-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Documents received from artist, gallery, etc"},model:{value:(_vm.text.artist_documents),callback:function ($$v) {_vm.$set(_vm.text, "artist_documents", $$v)},expression:"text.artist_documents"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","my-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Transcription"},model:{value:(_vm.text.transcript),callback:function ($$v) {_vm.$set(_vm.text, "transcript", $$v)},expression:"text.transcript"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","mb-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Work inherent text (part of artwork)"},model:{value:(_vm.text.work_text),callback:function ($$v) {_vm.$set(_vm.text, "work_text", $$v)},expression:"text.work_text"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","mb-5":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Publication"},model:{value:(_vm.text.publication),callback:function ($$v) {_vm.$set(_vm.text, "publication", $$v)},expression:"text.publication"}})],1),_vm._v(" "),_c('SectionHeader',{attrs:{"text":"Assigned Artworks/Artists"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-2":"","mt-3":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.isUpdating,"items":_vm.artworks,"box":"","chips":"","color":"grey lighten-1","label":"Selected Artworks","item-value":"id","multiple":"","item-text":function (item) { return item.title + ', ' + item.accession_number + ', ' + item.name; }},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi white--text chip--select-multi",attrs:{"selected":data.selected,"close":"","color":"black"},on:{"input":function($event){return _vm.remove(data.item.id)}}},[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.title)}}),_vm._v(" \n                  "),_c('span',[_vm._v(_vm._s(data.item.accession_number)+" ")]),_vm._v(" \n                  "),_c('strong',{domProps:{"innerHTML":_vm._s(data.item.name)}})])]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.title)}}),_vm._v(" \n                    "),_c('span',[_vm._v(_vm._s(data.item.accession_number)+" ")]),_vm._v(" \n                    "),_c('strong',{domProps:{"innerHTML":_vm._s(data.item.name)}})]),_vm._v(" "),_c('v-list-tile-sub-title')],1)]}}]),model:{value:(_vm.text.artworks),callback:function ($$v) {_vm.$set(_vm.text, "artworks", $$v)},expression:"text.artworks"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-2":""}},[_c('v-autocomplete',{attrs:{"disabled":_vm.isUpdatingArtists,"items":_vm.artists_sorted,"box":"","chips":"","color":"grey lighten-1","label":"Selected Artists","item-value":"id","multiple":"","item-text":function (item) { return item.name; }},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi white--text chip--select-multi",attrs:{"selected":data.selected,"close":"","color":"black"},on:{"input":function($event){return _vm.removeArtist(data.item.id)}}},[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.name)}}),_vm._v(" \n                  ")])]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.name)}}),_vm._v(" \n                    ")]),_vm._v(" "),_c('v-list-tile-sub-title')],1)]}}]),model:{value:(_vm.text.artists),callback:function ($$v) {_vm.$set(_vm.text, "artists", $$v)},expression:"text.artists"}})],1),_vm._v(" "),_c('SectionHeader',{staticClass:"mb-2",attrs:{"text":"Notes"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","px-0":"","mx-2":""}},[_c('v-textarea',{attrs:{"outline":"","label":"Notes","auto-grow":"","clearable":"","rows":"1"},model:{value:(_vm.text.notes),callback:function ($$v) {_vm.$set(_vm.text, "notes", $$v)},expression:"text.notes"}})],1),_vm._v(" "),_c('SectionHeader',{staticClass:"mr-0 mt-5 mb-2",attrs:{"text":"Text"}}),_vm._v(" "),_c('text-editor',{attrs:{"value":_vm.text.content,"text":_vm.text},on:{"input":function($event){_vm.text.content=$event}}})],1),_vm._v(" "),(_vm.c_user && _vm.c_user.roles && _vm.c_user.roles.find(function (r) { return r.shortcut == 'file_u'; }))?_c('div',{staticClass:"mt-5"},[_c('SectionHeader',{staticClass:"mr-4",attrs:{"text":"Uploads"}}),_vm._v(" "),_c('upload',{staticClass:"xs12 mr-4 mt-2",attrs:{"field":{id: 'artwork_literature', title:'Text uploads'},"uploadCategory":"artwork_literature","id":_vm.text.id}})],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "MNJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Todos_vue__ = __webpack_require__("khgZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec917172_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Todos_vue__ = __webpack_require__("CmKb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Todos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec917172_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Todos_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ec917172_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Todos_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MS0j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":"","mx-3":""}},[_c('v-flex',{staticClass:"mb-5 row  px-3 py-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#ddd"}},[_c('span',{staticClass:"font-weight-bold left subheading"},[_vm._v("Timeline  ")])]),_vm._v(" "),_c('v-flex',[_c('v-timeline',{attrs:{"dense":""}},_vm._l((this.advanced_years),function(n){return _c('v-timeline-item',{key:n,attrs:{"color":"black","fill-dot":"","icon":"dot","small":""}},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.a))]),_vm._v(" "),_c('v-card-text',_vm._l((_vm.exhibitions.filter(function (e) { return e.duration_start_year == n })),function(e){return _c('v-flex',{key:e.id},[_c('v-card',{staticClass:"elevation-0",attrs:{"color":"grey lighten-3"}},[_c('v-card-title',{staticClass:"ml-0 pl-2"},[_c('h4',{staticClass:"ml-0 pl-0"},[_vm._v("Exhibition - "+_vm._s(e.show_type == 0 ? "Solo show" : "Group show")+": "+_vm._s(e.title))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("\n                          "+_vm._s(e.institution)+", "+_vm._s(e.city)+", "+_vm._s(e.country)+" "),_c('br'),_vm._v("\n                          "+_vm._s(_vm.full_date(e))+" \n                        ")])],1)],1)],1)],1)}),1)],1)],1)}),1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "MaEM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MenD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Journals_vue__ = __webpack_require__("IQoj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48fbc6c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Journals_vue__ = __webpack_require__("yO6x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("9eRG")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-48fbc6c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Journals_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48fbc6c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Journals_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48fbc6c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Journals_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MjL8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-link',{attrs:{"to":_vm.login}},[_vm._v("Log in")])],1)}
var staticRenderFns = []


/***/ }),

/***/ "Ml6F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NABz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_pdfmake__ = __webpack_require__("EWlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_vfs_fonts__ = __webpack_require__("u1n8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_vfs_fonts__);

//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_1_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      loading: false,
      outputFieldsParams: [],
      sort: 'full_name',
      title: 'Exhibition History',
      subtitle: 'Artwork Title'
    };
  },
  methods: {
    pdfLabelsCall: function pdfLabelsCall() {
      this.loading = true;
      setTimeout(function () {
        setTimeout(function () {
          this.pdfLabels();
          this.loading = false;
        }.bind(this), 0);
      }.bind(this), 500);
    },
    pdfLabels: function pdfLabels() {
      var _this = this;

      var reportDate = function reportDate() {
        return new Date();
      };
      var createDocumentDefinition = function createDocumentDefinition(reportDate, subHeading) {
        for (var _len = arguments.length, contentParts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          contentParts[_key - 2] = arguments[_key];
        }

        var _docDefinition$conten;

        var baseDocDefinition = {
          pageSize: 'A4',
          pageMargins: [22, 55, 0, 0],
          info: {
            title: 'Exhibition History A4',
            subject: 'Exhibition History A4'
          },
          styles: {
            title: { fontSize: 9, bold: true, margin: [8, 2, 0, 0], width: 150 },
            title2: { fontSize: 9, bold: true, margin: [8, 2, 0, 25], width: 150 },
            artwork_title: { fontSize: 12, margin: [8, 2, 0, 0], width: 250 }
          },
          content: [{ columns: [] }]
        };
        var docDefinition = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(baseDocDefinition));
        // docDefinition.footer = baseDocDefinition.footer
        (_docDefinition$conten = docDefinition.content).push.apply(_docDefinition$conten, contentParts);
        return docDefinition;
      };

      var stack = {
        stack: []
      };
      var title_and_year = this.artwork['title'] + ", " + this.artwork['production_date_new'];
      var exhibitions = this.artwork.exhibitions;

      function start_date(e) {
        var out = e.duration_start_year;
        var options = { day: 'numeric', month: 'long', year: 'numeric' };
        if (e.duration_start_month) {
          out = out + '-' + e.duration_start_month.toString().padStart(2, "0");
        }
        if (e.duration_start_day) {
          out = out + '-' + e.duration_start_day.toString().padStart(2, "0");
        }
        out = new Date(out).toLocaleDateString("en-US", options);

        return out;
      }
      function end_date(e) {
        var out = e.duration_end_year;
        var options = { day: 'numeric', month: 'long', year: 'numeric' };

        if (e.duration_end_month) {
          out = out + '-' + e.duration_end_month.toString().padStart(2, "0");
          // out = e.duration_end_month.toLocaleDateString("en-US", options)
        }
        if (e.duration_end_day) {
          out = out + '-' + e.duration_end_day.toString().padStart(2, "0");
        }
        out = new Date(out).toLocaleDateString("en-US", options);
        return out;
      }
      function full_date(e) {
        var out = start_date(e);
        if (end_date(e)) {
          out = out + ' - ' + end_date(e);
        }
        return out;
      }
      var store_e = function store_e() {
        // console.log('store_e')
        return _this.$store.state.exhibitions;
      };
      var exhibitions = function exhibitions() {
        return store_e().filter(function (t) {
          // console.log(t)
          return t.artworks.map(function (a) {
            return a = a.artwork_id;
          }).includes(_this.artwork.id);
        });
      };
      // console.log(exhibitions())
      // stack.stack.push({text: 'FRANCESCA VON HABSBURG', style: 'artwork_title'});
      // stack.stack.push({text: 'PRIVATE ART COLLECTION', style: 'artwork_title'});
      stack.stack.push({ text: this.artwork['accession_number'], style: 'title' });
      stack.stack.push({ text: this.artwork['full_name'], style: 'title' });
      stack.stack.push({ text: this.artwork['title'], style: 'artwork_title' });
      stack.stack.push({ text: 'Production Date:' + this.artwork['production_date_new'], style: 'title' });
      stack.stack.push({ text: 'Exhibitions:', style: 'artwork_title' });
      for (var e in exhibitions()) {
        // console.log(exhibitions()[e])
        // stack.stack.push({text: 'e.title', style: 'title'});
        stack.stack.push({ text: exhibitions()[e].title, style: 'title' });
        stack.stack.push({ text: exhibitions()[e].show_type == 0 ? "Solo show" : "Group show", style: 'title' });
        stack.stack.push({ text: exhibitions()[e].institution + " " + exhibitions()[e].city + " " + exhibitions()[e].country, style: 'title' });
        stack.stack.push({ text: full_date(exhibitions()[e]), style: 'title' });
        stack.stack.push({ text: exhibitions()[e].admin_note, style: 'title' });
      }

      // var rowData2 = function rowData2 (a,c) {
      //   var stack = {
      //     stack: [],
      //   };
      // var title_and_year = `${a['title']}, ${a['production_date_new']}`

      var docDefinition = createDocumentDefinition(reportDate(), 'Summary', stack);
      __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download('A4-Exhibition-History.pdf');
      // }
    }
  }
});

/***/ }),

/***/ "NEcE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_artworks_TextEditor__ = __webpack_require__("JslP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      editedIndex: -1,
      article: {
        title: '',
        version: '',
        subtitle: '',
        updates: '',
        help: '',
        at_work: '',
        support: '',
        show_in_route: '',
        group: ''
      },
      defaultItem: {
        title: '',
        version: '',
        subtitle: '',
        updates: '',
        help: '',
        at_work: '',
        support: '',
        show_in_route: '',
        group: '',
        body: ''
      }
    };
  },

  // beforeMount () {
  //   // console.log(this.editedItem)
  //   if (this.editedItem) {
  //     this.article = Object.assign({},this.editedItem)
  //   } 
  //   this.getArticle()
  // },
  methods: {
    createArticle: function createArticle() {
      var _this = this;

      // this.snackbar = true
      var url = this.$globals.apiserver + '/support_articles.json';
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, { article: this.article }).then(function (response) {
        // this.result = response.data
        // var o = Object.assign({ name: this.newItem.title})
        _this.$store.dispatch('createArticle', response.data);
        // this.snackbar = false
        _this.article = _this.defaultItem;
        _this.$router.push({ path: '/articles' });
        // this.$router.push({path:`/users/edit/${this.result.id}`, params: {user: this.result}})
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  components: { TextEditor: __WEBPACK_IMPORTED_MODULE_0__components_artworks_TextEditor__["a" /* default */] }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serverBus", function() { return serverBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_dist_vuetify_css__ = __webpack_require__("QCv7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pretty_checkbox_vue__ = __webpack_require__("zmct");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_pretty_checkbox_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_pretty_checkbox_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mdi_font_css_materialdesignicons_css__ = __webpack_require__("csSS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__mdi_font_css_materialdesignicons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_CommonMixin_js__ = __webpack_require__("P+z9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_artworks_CustomsHistory_vue__ = __webpack_require__("BJgw");












__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_10__mixins_CommonMixin_js__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('CustomsHistory', __WEBPACK_IMPORTED_MODULE_11__components_artworks_CustomsHistory_vue__["a" /* default */]);

// Vue.use(mdi)
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vuetify___default.a, {
  theme: {
    primary: '#000',
    secondary: '#b0bec5',
    accent: '#8c9eff',
    error: '#b71c1c'
  }
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__webpack_require__("m0IH"));
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_pretty_checkbox_vue___default.a);

if (true) {
  __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$globals = {
    apiserver: 'https://api.tb-cms.org',
    // apiserver: 'https://tbaapi.local',
    oldserver: 'https://api.tb-cms.org',
    // fileserver: 'http://api.misia.sk'
    fileserver: 'https://api.tb-cms.org'
  };
} else {
  Vue.prototype.$globals = {
    // apiserver: 'https://api.tb-cms.org',
    apiserver: 'http://localhost:3000',
    // apiserver: 'https://tbaapi.local',
    oldserver: 'https://api.tb-cms.org',
    // fileserver: 'http://api.misia.sk'
    fileserver: 'https://api.tb-cms.org'
  };
}
// Vue.prototype.$globals = { apiserver: 'http://api.tb-cms.org:8078' }
// } else {
//   Vue.prototype.$globals = { apiserver: 'http://192.168.0.217:3000' }
// }

var serverBus = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]();

// Vue.config.productionTip = false
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.performance = true;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  beforeCreate: function beforeCreate() {
    this.$store.commit('initialiseStore');
  },
  afterCreate: function afterCreate() {
    // this.$store.dispatch('loadCollection')
    // this.$store.dispatch('loadPacFvh')
  },

  el: '#app',
  data: {
    filters: []
  },
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  axios: __WEBPACK_IMPORTED_MODULE_0_axios___default.a,
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]);
  }
});
// if (localStorage.getItem('profile') != null) {
// Vue.set(store.state, 'profile', JSON.parse(localStorage.getItem('profile')))
// }

// store.subscribe((mutation, state) => {
//   // Store the state object as a JSON string
//   localStorage.setItem('store', JSON.stringify(state))
//   console.log('state saved to localStorage')
// })

/***/ }),

/***/ "NfPN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldBox_vue__ = __webpack_require__("92ck");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_103fae16_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldBox_vue__ = __webpack_require__("jTEo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("PHsT")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-103fae16"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FieldBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_103fae16_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldBox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_103fae16_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FieldBox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NhnZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__ = __webpack_require__("YZqf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac2a4aaa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__ = __webpack_require__("ejqX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("HneA")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac2a4aaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Users_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac2a4aaa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac2a4aaa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Users_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nl7g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O429":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListActionMenu_vue__ = __webpack_require__("dGlE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e3abe1c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListActionMenu_vue__ = __webpack_require__("njj+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("T2Xd")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8e3abe1c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListActionMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e3abe1c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListActionMenu_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8e3abe1c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListActionMenu_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "O8mt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__("NHnr");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function dynamicSort(property, property2) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    if (a[property] > b[property]) return 1 * sortOrder;
    if (a[property] < b[property]) return -1 * sortOrder;

    // Secondary sort using property2
    if (property2 && a[property2] && b[property2]) {
      if (a[property2] > b[property2]) return 1;
      if (a[property2] < b[property2]) return -1;
    }

    return 0;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    var _artwork_insurance_lo;

    return {
      saveDialog: false,
      selectedFilter: 'artwork',
      // selectedPackingFilter: 'all',
      // historyFilter: 'artwork',
      changeArtworkInsurance: false,
      // changeAllParts: false,
      editDialog: false,
      menu_time: false,
      time: null,
      editedInsuranceLog: {},
      selectedPackings: [],
      menu2: false,
      menu2a: false,
      showUpload: false,
      showList: false,
      show: false,
      errors: '',
      artwork_insurance_log: (_artwork_insurance_lo = {
        created_by: '',
        insurance_value: '',
        insurance_value_currency: '',
        insurance_value_note: '',
        insurance_value_date: ''
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_artwork_insurance_lo, 'insurance_value', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_artwork_insurance_lo, 'copy', 'artwork'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_artwork_insurance_lo, 'artwork_packing_id', ''), _artwork_insurance_lo)
    };
  },
  computed: {
    old_insurance_table: function old_insurance_table() {
      var a1 = this.artwork.Valuation_Type_all.split(', ');
      var a2 = this.artwork.Valuation_Method_all.split(', ');
      var a3 = this.artwork.Valuation_Date_all.split(', ');

      var result_array = a1.map(function (item, index) {
        return {
          id: index,
          type: a1[index],
          method: a2[index],
          date: a3[index]
        };
      });
      return result_array;
    },
    old_insurance_from_date_and_copy: function old_insurance_from_date_and_copy() {
      var _this = this;

      // var current = { insurance_value_date: this.artwork_insurance_log.insurance_value_date, copy: this.artwork_insurance_log.copy, artwork_id: this.artwork.id }
      if (this.artwork_insurance_log.insurance_value_date && this.artwork_insurance_log.copy) {
        // this.artwork_insurance_log.old_insurance = this.get_old_insurance(current)
        if (this.artwork_insurance_log.copy == 'packings') {
          this.artwork_insurance_log.artwork_id = '';
          return 'Previous Insurance cannot be calculated for packings';
        } else if (['artwork', 'master_physical', 'archive_master'].includes(this.artwork_insurance_log.copy)) {
          this.artwork_insurance_log.artwork_id = this.artwork.id;
          var olderArtworkLogs = this.sorted_artwork_insurance_logs.filter(function (l) {
            return l.copy == _this.artwork_insurance_log.copy && l.insurance_value_date < _this.artwork_insurance_log.insurance_value_date;
          });
          console.log(olderArtworkLogs);
          if (olderArtworkLogs.length > 1) {
            // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_insurance_log')
            var previous = olderArtworkLogs[0];
            if (previous) {
              this.artwork_insurance_log.old_insurance = previous.insurance_value;
              return previous.insurance_value;
            } else {
              this.artwork_insurance_log.old_insurance = 465;
              return 465;
            }
          } else {
            this.artwork_insurance_log.old_insurance = 465;
            return 465;
          }
        }
      } else {
        return 'Copy and Change Date must be selected before calculating old Insurance';
      }
    },
    sorted_artwork_insurance_logs: function sorted_artwork_insurance_logs() {
      return this.artwork.artwork_insurance_logs.sort(dynamicSort('insurance_value_date')).reverse();
    },
    filtered_artwork_insurance_logs: function filtered_artwork_insurance_logs() {
      var o = this.sorted_artwork_insurance_logs.filter(function (l) {
        return l.market_insurance == 'insurance';
      });
      // console.log(o)
      return o;
    },
    insurances: function insurances() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.getters.enabled_insurances).sort(dynamicSort('name'));
    },
    lastInsuranceLogArtwork: function lastInsuranceLogArtwork() {
      return this.getLastLog(this.artwork.artwork_insurance_logs, 'artwork');
    }
  },
  watch: {
    changeAllParts: function changeAllParts() {
      this.selectAllParts();
    },
    artwork_insurance_log: {
      handler: function handler(val) {
        console.log('watch');
        if (this.artwork_insurance_log.insurance_value_date) {
          this.artwork_insurance_log.old_insurance == this.old_insurance_from_date_and_copy;
        }
      },

      deep: true
    }
  },
  methods: {
    // lastInsuranceLogArtworkPacking(id) {
    //   return this.getLastLog(this.artwork.artwork_insurance_logs, 'packings', id)
    // },
    switch_change_dialog: function switch_change_dialog() {
      this.showUpload = !this.showUpload;
      if (this.showUpload) {
        this.artwork_insurance_log.old_insurance = this.old_insurance_from_date_and_copy;
      }
    },

    // get_old_insurance_from_date_and_copy() {
    //   // var current = { insurance_value_date: this.artwork_insurance_log.insurance_value_date, copy: this.artwork_insurance_log.copy, artwork_id: this.artwork.id }
    //   if(this.artwork_insurance_log.insurance_value_date && this.artwork_insurance_log.copy) {
    //     // this.artwork_insurance_log.old_insurance = this.get_old_insurance(current)
    //     if (this.artwork_insurance_log.copy == 'packings') {
    //         return 'Previous Insurance cannot be calculated for packings'
    //     } else if (['artwork','master_physical','archive_master'].includes(this.artwork_insurance_log.copy)) {
    //       var olderArtworkLogs = this.sorted_artwork_insurance_logs
    //         .filter(l => l.artwork_id = this.artwork_insurance_log.artwork_id
    //           && l.copy == this.artwork_insurance_log.copy
    //           && l.insurance_value_date < this.artwork_insurance_log.insurance_value_date)
    //       if (olderArtworkLogs.length > 1) {
    //         // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_insurance_log')
    //         var previous = olderArtworkLogs[0]
    //         if(previous) {
    //           this.artwork_insurance_log.old_insurance = previous.artwork_insurance_id
    //           return  previous.artwork_insurance_id
    //         } else {
    //           return 'no previous log for this packing'
    //         }
    //       } else {
    //         return 'no previous log for this packing'
    //       }
    //     }
    //   } else {
    //     return 'Copy and Change Date must be selected before calculating old Insurance'
    //   }
    // },
    get_old_insurance: function get_old_insurance(log) {
      if (log.copy == 'packings') {
        var packingLogs = this.sorted_artwork_insurance_logs.filter(function (l) {
          return l.artwork_packing_id = log.artwork_packing_id;
        });
        if (packingLogs.length > 1) {
          var indexOfcurrent = packingLogs.indexOf(log);
          var previous = packingLogs[indexOfcurrent + 1];
          return previous ? previous.artwork_insurance_id : 'no previous log for this packing';
        } else {
          return 'no previous log for this packing';
        }
      } else if (['artwork', 'master_physical', 'archive_master'].includes(log.copy)) {
        var artworkLogs = this.sorted_artwork_insurance_logs.filter(function (l) {
          return l.artwork_id = log.artwork_id && l.copy == log.copy;
        });
        if (artworkLogs.length > 1) {
          var indexOfcurrent = artworkLogs.indexOf(log);
          var previous = artworkLogs[indexOfcurrent + 1];
          return previous ? previous.artwork_insurance_id : 'no previous log for this packing';
        } else {
          return 'no previous log for this packing';
        }
      }
      // insurance_value
    },
    toggleCopyFilter: function toggleCopyFilter(c) {
      console.log(c);
      this.selectedFilter = c;
      if (c == 'packings') {
        this.selectedPackingFilter = 'all';
      }
    },
    togglePackingFilter: function togglePackingFilter(c) {
      this.selectedPackingFilter = c;
    },
    selectAllParts: function selectAllParts() {
      var _this2 = this;

      if (this.changeAllParts) {
        this.artwork.artwork_packings.forEach(function (p) {
          if (!_this2.selectedPackings.includes(p)) {
            _this2.selectedPackings.push(p);
          }
        });
      } else {
        this.selectedPackings = [];
      }
    },
    getLastLog: function getLastLog(logs, copy, id) {
      if (logs && logs.length > 0) {
        // .filter((ll) => true)
        var out = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], logs).sort(function (a, b) {
          if (a.insurance_value_date > b.insurance_value_date) {
            return -1;
          }
          if (a.insurance_value_date < b.insurance_value_date) {
            return 1;
          }
          return 0;
        })[0];
        if (out) {
          return out;
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    getPacking: function getPacking(id) {
      return this.artwork.artwork_packings.find(function (ap) {
        return ap.id === id;
      });
    },
    editInsurance: function editInsurance(l) {
      console.log(l);
      this.editedInsuranceLog = l;
      this.editDialog = true;
    },

    // insurance_name (id) {
    //   // console.log(id)
    //   if (id > 0) {
    //     var a = this.$store.state.insurances.find(l => l.id === id)
    //     if (a) {
    //       return a.name
    //     } else {
    //       return 'Insurance not found in CMS.'
    //     }
    //   } else {
    //     return 'Insurance not found in CMS.'
    //   }
    // },
    download: function download() {},
    delete_log: function delete_log(item) {
      var r = confirm('Are you sure you want to delete this Insurance History entry?');
      if (r) {
        this.delete_log_action(item);
      }
    },
    delete_log_action: function delete_log_action(item) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'Deleting Insurance history.', 'black');
      var url = this.$globals.apiserver + '/artwork_insurance_logs/' + item.id + '.json';
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url, item).then(function (response) {
        _this3.$store.dispatch('updateArtwork', _this3.artwork.id);
        __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'Insurance history Deleted.', 'green');
        _this3.errors = {};
        var index = _this3.artwork.artwork_insurance_logs.indexOf(item);
        if (index >= 0) _this3.artwork.artwork_insurance_logs.splice(index, 1);
        // const index = this.artwork.artwork_costs.indexOf(item)
        // this.artwork.artwork_insurance_logs.push(response.data);
        // @artwork.insurance_value = @artwork_insurance_log.id
        // elsif @artwork_insurance_log.copy = 'master_physical'
        // @artwork.master_physical_insurance_id = @artwork_insurance_log.id
        // elsif @artwork_insurance_log.copy = 'archive_master'
        // @artwork.archive_master_insurance_id = @artwork_insurance_log.id
        // elsif @artwork_insurance_log.copy = 'access_copy'
        // @artwork.access_copy_insurance_id = @artwork_insurance_log.id
        // this.active_artwork_insurance_logs = this.artwork.artwork_insurance_logs
        // this.$store.commit('DELETE_LOG', response.data)
        _this3.active_artwork_insurance_logs = _this3.$store.state.artwork_insurance_logs;
        // this.showUpload = !this.showUpload
        return false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'There was an Error deleting Cost.', 'red');
        // console.log(error)
        _this3.errors = error.response.data;
      });
    },
    showSaveDialog: function showSaveDialog() {
      this.saveDialog = true;
    },
    save_artwork_insurance_log: function save_artwork_insurance_log() {
      var _this4 = this;

      this.saveDialog = false;
      // console.log('save_artwork_insurance_log')
      __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'Saving Insurance History Entry\u2026', 'green');

      // NASETUJEM LOG BASICS
      this.artwork_insurance_log.created_by = this.c_user.id;
      this.artwork_insurance_log.artwork_id = this.artwork.id;

      // ZMENIM LOGS ARTWORKU NA POLE, AK BOLO NULL, ABY SOM MOHOL OD NEHO PRIDAVAT
      if (!this.artwork.artwork_insurance_logs) {
        this.artwork.artwork_insurance_logs = [];
      }

      // IF I AM CHANGING PACKINGS - MUST BE SOME SELECTED
      // if (
      //   this.artwork_insurance_log.copy === 'packings' &&
      //   this.selectedPackings &&
      //   this.selectedPackings.length > 0
      // ) {

      //   // FOR EACH PACKING CREATE LOG AND CHANGE ITS INSURANCE
      //   for (const sp in this.selectedPackings) {
      //     // console.log(this.selectedPackings[sp].id)
      //     this.artwork_insurance_log.artwork_packing_id = this.selectedPackings[sp].id

      //     // ADD LOG FOR THIS PACKING - PACKING ITSELF IS CHANGED ON THE SERVER
      //     // console.log(this.artwork_insurance_log)
      //     axios
      //       .post(`${this.$globals.apiserver}/artwork_insurance_logs.json`, {
      //         artwork_insurance_log: this.artwork_insurance_log,
      //       })
      //       .then((response) => {
      //         this.errors = {}
      //         // this.artwork.artwork_insurance_logs.push(response.data);
      //         // @artwork.insurance_value = @artwork_insurance_log.id
      //         // elsif @artwork_insurance_log.copy = 'master_physical'
      //         // @artwork.master_physical_insurance_id = @artwork_insurance_log.id
      //         // elsif @artwork_insurance_log.copy = 'archive_master'
      //         // @artwork.archive_master_insurance_id = @artwork_insurance_log.id
      //         // elsif @artwork_insurance_log.copy = 'access_copy'
      //         // @artwork.access_copy_insurance_id = @artwork_insurance_log.id
      //         // this.active_artwork_insurance_logs = this.artwork.artwork_insurance_logs
      //         // this.$store.commit('ADD_LOG', response.data)
      //         // this.active_artwork_insurance_logs = this.$store.state.artwork_insurance_logs
      //         this.showUpload = !this.showUpload
      //       })
      //       .catch((error) => {
      //         console.log(error)
      //         // this.errors = error.response.data;
      //       })
      //     this.artwork_insurance_log.artwork_packing_id = null
      //   }

      // IF ALSO ARTWORK INSURANCE IS SELECTED TO BE CHANGED
      // if (this.changeArtworkInsurance) {
      // console.log('changeArtworkInsurance')

      // SAVE NEW ARTWORK INSURANCE - only if insurance_value_date is later than latest log
      // if (this.artwork_insurance_log.insurance_value_date > this.lastInsuranceLogArtwork.insurance_value_date) {
      //   // console.log(this.artwork_insurance_log.insurance_value_date)
      //   // console.log(this.lastInsuranceLogArtwork.insurance_value_date)
      //   axios
      //     .put(
      //       `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`,
      //       {
      //         artwork: {
      //           insurance_value:
      //             this.artwork_insurance_log.insurance_value,
      //         },
      //       }
      //     )
      //     .then((response) => {
      //       console.log('changeArtworkInsurance response change artwork')

      //       this.errors = {}
      //       this.artwork.artwork_insurance_logs.push(response.data)

      //       // ON SAVE SUCCESS SET CURRENT ARTWORK'S INSURANCE TO NEW INSURANCE
      //       // if (this.artwork_insurance_log.copy === 'artwork') {
      //       //   this.artwork.insurance_value = this.artwork_insurance_log.insurance_value
      //       // } else if (this.artwork_insurance_log.copy === 'master_physical') {
      //       //   this.artwork.master_physical_insurance_id = this.artwork_insurance_log.insurance_value
      //       // } else if (this.artwork_insurance_log.copy === 'archive_master') {
      //       //   this.artwork.archive_master_insurance_id = this.artwork_insurance_log.insurance_value
      //       // } else if (this.artwork_insurance_log.copy === 'access_copy') {
      //       //   this.artwork.access_copy_insurance_id = this.artwork_insurance_log.insurance_value
      //       // }
      //       // this.$store.commit('ADD_LOG', response.data)
      //       // this.active_artwork_insurance_logs = this.$store.state.artwork_insurance_logs
      //       this.changeArtworkInsurance = false
      //     })
      // }

      // ADD LOG FOR ARTWORK
      this.artwork_insurance_log.copy = 'artwork';
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$globals.apiserver + '/artwork_insurance_logs.json', {
        artwork_insurance_log: this.artwork_insurance_log
      }).then(function (response) {
        console.log('changeArtworkInsurance response add log');

        _this4.errors = {};
        _this4.artwork.artwork_insurance_logs.push(response.data);
        _this4.artwork.insurance_value = _this4.artwork_insurance_log.insurance_value;
        _this4.$store.commit('ADD_INSURANCE_LOG', response.data);
        _this4.active_artwork_insurance_logs = _this4.$store.state.artwork_insurance_logs;
        // this.showUpload = !this.showUpload
        _this4.artwork_insurance_log = {
          insurance_value: '',
          insurance_value_currency: '',
          insurance_value_note: '',
          insurance_value_date: '',
          insurance_valuer: '',
          reason: '',
          created_by: _this4.c_user.id
        };
      }).catch(function (error) {
        // console.log(error)
      });
      this.changeAllParts = false;
      // }

      // this.$store.dispatch('loadPackings')
      this.$emit('getArtwork');
      // } else {
      //   console.log('single')
      //   // ADD LOG FOR ARTWORK
      //   axios
      //     .post(`${this.$globals.apiserver}/artwork_insurance_logs.json`, {
      //       artwork_insurance_log: this.artwork_insurance_log,
      //     })
      //     .then((response) => {
      //       this.errors = {}
      //       this.artwork.artwork_insurance_logs.push(response.data)
      //       this.artwork.insurance_value =
      //           this.artwork_insurance_log.insurance_value

      //       this.$store.commit('ADD_LOG', response.data)
      //       this.active_artwork_insurance_logs =
      //         this.$store.state.artwork_insurance_logs
      //       this.showUpload = !this.showUpload
      //       this.artwork_insurance_log = {
      //         created_by: this.c_user.id,
      //         storage: 'in',
      //         insurance_value_note: '',
      //         insurance_value_date: '',
      //         copy: 'artwork',
      //         valuer: '',
      //         reason: '',
      //         insurance_value: '',
      //         artwork_packing_id: '',
      //       }
      //     })
      //     .catch((error) => {
      //       // console.log(error)
      //     })

      // this.$emit('getArtwork')
      // }
      // this.selectedPackings = []
      this.editDialog = false;
      this.saveDialog = false;
      this.showUpload = false;
      // var aartwork_insurance_log = Object.keys(this.artwork_insurance_log).forEach(k => this.artwork_insurance_log[k]='')
      // console.log(aartwork_insurance_log)
    },
    save_edited_artwork_insurance_log: function save_edited_artwork_insurance_log() {
      var _this5 = this;

      this.editedInsuranceLog.last_update_by = this.c_user.id;
      this.editedInsuranceLog.artwork_id = this.artwork.id;
      if (this.editedInsuranceLog.storage === 'in') {
        this.editedInsuranceLog.storage_in = this.editedInsuranceLog.insurance_value_date;
      } else {
        this.editedInsuranceLog.storage_out = this.editedInsuranceLog.insurance_value_date;
      }
      __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'Saving Insurance History Entry\u2026', 'green');

      if (this.editedInsuranceLog.copy === 'packings' && this.selectedPackings && this.selectedPackings.length > 0) {
        for (var sp in this.selectedPackings) {
          this.editedInsuranceLog.artwork_packing_id = this.selectedPackings[sp].id;
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$globals.apiserver + '/artwork_insurance_logs.json', {
            artwork_insurance_log: this.editedInsuranceLog
          }).then(function (response) {
            _this5.errors = {};
            // this.artwork.artwork_insurance_logs.push(response.data);
            // @artwork.insurance_value = @editedInsuranceLog.id
            // elsif @editedInsuranceLog.copy = 'master_physical'
            // @artwork.master_physical_insurance_id = @editedInsuranceLog.id
            // elsif @editedInsuranceLog.copy = 'archive_master'
            // @artwork.archive_master_insurance_id = @editedInsuranceLog.id
            // elsif @editedInsuranceLog.copy = 'access_copy'
            // @artwork.access_copy_insurance_id = @editedInsuranceLog.id
            // this.active_artwork_insurance_logs = this.artwork.artwork_insurance_logs
            _this5.$store.commit('UPDATE_LOG', response.data);
            _this5.active_artwork_insurance_logs = _this5.$store.state.artwork_insurance_logs;
            _this5.showUpload = !_this5.showUpload;
          }).catch(function (error) {
            // console.log(error)
            // this.errors = error.response.data;
          });
        }
        this.artwork_insurance_log = {
          storage: 'in',
          insurance_value_note: '',
          insurance_value_date: '',
          copy: 'artwork',
          insurance_valuer: '',
          reason: '',
          insurance_value: '',
          artwork_packing_id: ''
        };
      } else {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(this.$globals.apiserver + '/artwork_insurance_logs/' + this.editedInsuranceLog.id + '.json', {
          artwork_insurance_log: this.editedInsuranceLog
        }).then(function (response) {
          _this5.$emit('getArtwork');
          _this5.errors = {};
          _this5.artwork.artwork_insurance_logs = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this5.artwork.artwork_insurance_logs.filter(function (element) {
            return element.id !== response.data.id;
          })), [response.data]);
          _this5.artwork.insurance_value = _this5.editedInsuranceLog.insurance_value;
          // this.$store.commit("UPDATE_LOG", response.data);
          _this5.active_artwork_insurance_logs = _this5.$store.state.artwork_insurance_logs;
          // this.showUpload = !this.showUpload;
          _this5.editedInsuranceLog = {
            storage: 'in',
            insurance_value_note: '',
            insurance_value_date: '',
            change_time: '',
            copy: 'artwork',
            insurance_valuer: '',
            reason: '',
            insurance_value: '',
            artwork_packing_id: ''
          };
          _this5.editDialog = false;
        }).catch(function (error) {
          // console.log(error)
        });
      }
      // var aartwork_insurance_log = Object.keys(this.artwork_insurance_log).forEach(k => this.artwork_insurance_log[k]='')
      // console.log(aartwork_insurance_log)
    }
  }
});

/***/ }),

/***/ "O9GO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadField_vue__ = __webpack_require__("flFZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1815cb2b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadField_vue__ = __webpack_require__("d0Kb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("2o9M")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1815cb2b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1815cb2b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadField_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1815cb2b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReadField_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "OK5g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OUKN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"small":_vm.small,"light":_vm.light,"type":"button"},on:{"click":_vm.onexport}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":_vm.small}},[_vm._v(" mdi-microsoft-excel")]),_vm._v("Excel\n  ")],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "OYT2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function dynamicSort(property, property2) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    if (a[property] > b[property]) return 1;
    if (a[property] < b[property]) return -1;
    if (a[property2] && b[property2]) {
      if (a[property2] > b[property2]) return 1;
      if (a[property2] < b[property2]) return -1;
    }
    return result * sortOrder;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // artworks: this.$store.state.artworks
    };
  },
  computed: {
    old_location_from_date_and_copy: function old_location_from_date_and_copy() {
      var _this = this;

      // var current = { change_date: this.artwork_location_log.change_date, copy: this.artwork_location_log.copy, artwork_id: this.artwork.id }
      if (this.artwork_location_log.change_date && this.artwork_location_log.copy) {
        // this.artwork_location_log.old_location = this.get_old_location(current)
        if (this.artwork_location_log.copy == 'packings') {
          this.artwork_location_log.artwork_id = '';
          return 'Previous Location cannot be calculated for packings';
        } else if (['artwork', 'master_physical', 'archive_master'].includes(this.artwork_location_log.copy)) {
          this.artwork_location_log.artwork_id = this.artwork.id;
          var olderArtworkLogs = this.sorted_artwork_location_logs.filter(function (l) {
            return l.copy == _this.artwork_location_log.copy && l.change_date < _this.artwork_location_log.change_date;
          });
          console.log(olderArtworkLogs);
          if (olderArtworkLogs.length > 1) {
            // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_location_log')
            var previous = olderArtworkLogs[0];
            if (previous) {
              this.artwork_location_log.old_location = previous.artwork_location_id;
              return previous.artwork_location_id;
            } else {
              this.artwork_location_log.old_location = 465;
              return 465;
            }
          } else {
            this.artwork_location_log.old_location = 465;
            return 465;
          }
        }
      } else {
        return 'Copy and Change Date must be selected before calculating old Location';
      }
    },
    sorted_artwork_location_logs: function sorted_artwork_location_logs() {
      return this.artwork.artwork_location_logs.sort(dynamicSort('change_date', 'change_time')).reverse();
    },
    filtered_artwork_location_logs: function filtered_artwork_location_logs() {
      var _this2 = this;

      return this.sorted_artwork_location_logs.filter(function (l) {
        return l.copy == _this2.selectedFilter;
      });
    },
    locations: function locations() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.getters.enabled_locations).sort(dynamicSort('name'));
    },
    lastLocationLogArtwork: function lastLocationLogArtwork() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'artwork');
    },
    lastLocationLogMasterPhysical: function lastLocationLogMasterPhysical() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'master_physical');
    },
    lastLocationLogArchiveMaster: function lastLocationLogArchiveMaster() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'archive_master');
    },
    lastLocationLogAccessCopy: function lastLocationLogAccessCopy() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'access_copy');
    }
  },
  watch: {
    changeAllParts: function changeAllParts() {
      this.selectAllParts();
    },
    artwork_location_log: {
      handler: function handler(val) {
        console.log('watch');
        if (this.artwork_location_log.change_date) {
          this.artwork_location_log.old_location == this.old_location_from_date_and_copy;
        }
      },

      deep: true
    }
  },
  methods: {
    switch_change_dialog: function switch_change_dialog() {
      this.showUpload = !this.showUpload;
      if (this.showUpload) {
        this.artwork_location_log.old_location = this.old_location_from_date_and_copy;
      }
    },

    // get_old_location_from_date_and_copy() {
    //   // var current = { change_date: this.artwork_location_log.change_date, copy: this.artwork_location_log.copy, artwork_id: this.artwork.id }
    //   if(this.artwork_location_log.change_date && this.artwork_location_log.copy) {
    //     // this.artwork_location_log.old_location = this.get_old_location(current)
    //     if (this.artwork_location_log.copy == 'packings') {
    //         return 'Previous Location cannot be calculated for packings'
    //     } else if (['artwork','master_physical','archive_master'].includes(this.artwork_location_log.copy)) {
    //       var olderArtworkLogs = this.sorted_artwork_location_logs
    //         .filter(l => l.artwork_id = this.artwork_location_log.artwork_id
    //           && l.copy == this.artwork_location_log.copy
    //           && l.change_date < this.artwork_location_log.change_date)
    //       if (olderArtworkLogs.length > 1) {
    //         // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_location_log')
    //         var previous = olderArtworkLogs[0]
    //         if(previous) {
    //           this.artwork_location_log.old_location = previous.artwork_location_id
    //           return  previous.artwork_location_id
    //         } else {
    //           return 'no previous log for this packing'
    //         }
    //       } else {
    //         return 'no previous log for this packing'
    //       }
    //     }
    //   } else {
    //     return 'Copy and Change Date must be selected before calculating old Location'
    //   }
    // },
    getArtworkPackings: function getArtworkPackings(id) {
      return this.$store.state.packings.filter(function (ap) {
        return ap.artwork_id === id;
      });
    },
    getArtworkLocationHistory: function getArtworkLocationHistory(id) {
      return this.$store.state.artwork_location_logs.filter(function (all) {
        return all.artwork_id === id;
      });
    },
    get_old_location: function get_old_location(log) {
      if (log.copy == 'packings') {
        var packingLogs = this.sorted_artwork_location_logs.filter(function (l) {
          return l.artwork_packing_id = log.artwork_packing_id;
        });
        if (packingLogs.length > 1) {
          var indexOfcurrent = packingLogs.indexOf(log);
          var previous = packingLogs[indexOfcurrent + 1];
          return previous ? this.get_location_name(previous.artwork_location_id) : 'no previous log for this packing';
        } else {
          return 'no previous log for this packing';
        }
      } else if (['artwork', 'master_physical', 'archive_master'].includes(log.copy)) {
        var artworkLogs = this.sorted_artwork_location_logs.filter(function (l) {
          return l.artwork_id = log.artwork_id && l.copy == log.copy;
        });
        if (artworkLogs.length > 1) {
          var indexOfcurrent = artworkLogs.indexOf(log);
          var previous = artworkLogs[indexOfcurrent + 1];
          return previous ? this.get_location_name(previous.artwork_location_id) : 'no previous log for this packing';
        } else {
          return 'no previous log for this packing';
        }
      }
      // artwork_location_id
    },
    toggleCopy: function toggleCopy(c) {
      this.selectedFilter = c;
    },
    selectAllParts: function selectAllParts() {
      var _this3 = this;

      if (this.changeAllParts) {
        this.artwork.artwork_packings.forEach(function (p) {
          if (!_this3.selectedPackings.includes(p)) {
            _this3.selectedPackings.push(p);
          }
        });
      } else {
        this.selectedPackings = [];
      }
    },
    getLastLog: function getLastLog(logs, copy) {
      if (logs && logs.length > 0) {
        var out = logs.filter(function (ll) {
          return ll.copy === copy;
        }).sort(function (a, b) {
          if (a.change_date > b.change_date) {
            return -1;
          }
          if (a.change_date < b.change_date) {
            return 1;
          }
          return 0;
        })[0];
        if (out) {
          return out;
        } else {
          return '';
        }
      } else {
        return '';
      }
    },
    getPacking: function getPacking(id) {
      return this.artwork.artwork_packings.find(function (ap) {
        return ap.id === id;
      });
    },
    editLocation: function editLocation(l) {
      this.editedLocationLog = l;
      this.editDialog = true;
    },

    // location_name (id) {
    //   // console.log(id)
    //   if (id > 0) {
    //     var a = this.$store.state.locations.find(l => l.id === id)
    //     if (a) {
    //       return a.name
    //     } else {
    //       return 'Location not found in CMS.'
    //     }
    //   } else {
    //     return 'Location not found in CMS.'
    //   }
    // },
    download: function download() {},
    delete_log: function delete_log(item) {
      var r = confirm('Are you sure you want to delete this Location History entry?');
      if (r) {
        this.delete_log_action(item);
      }
    },
    delete_log_action: function delete_log_action(item) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Deleting Location history.', 'black');
      var url = this.$globals.apiserver + '/artwork_location_logs/' + item.id + '.json';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.delete(url, item).then(function (response) {
        _this4.$store.dispatch('updateArtwork', _this4.artwork.id);
        __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Location history Deleted.', 'green');
        _this4.errors = {};
        var index = _this4.artwork.artwork_location_logs.indexOf(item);
        if (index >= 0) _this4.artwork.artwork_location_logs.splice(index, 1);
        // const index = this.artwork.artwork_costs.indexOf(item)
        // this.artwork.artwork_location_logs.push(response.data);
        // @artwork.artwork_location_id = @artwork_location_log.id
        // elsif @artwork_location_log.copy = 'master_physical'
        // @artwork.master_physical_location_id = @artwork_location_log.id
        // elsif @artwork_location_log.copy = 'archive_master'
        // @artwork.archive_master_location_id = @artwork_location_log.id
        // elsif @artwork_location_log.copy = 'access_copy'
        // @artwork.access_copy_location_id = @artwork_location_log.id
        // this.active_artwork_location_logs = this.artwork.artwork_location_logs
        // this.$store.commit('DELETE_LOG', response.data)
        _this4.active_artwork_location_logs = _this4.$store.state.artwork_location_logs;
        // this.showUpload = !this.showUpload
        return false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'There was an Error deleting Cost.', 'red');
        // console.log(error)
        _this4.errors = error.response.data;
      });
    },
    save_artwork_location_log: function save_artwork_location_log() {
      var _this5 = this;

      this.artwork_location_log.created_by = this.c_user.id;
      this.artwork_location_log.artwork_id = this.artwork.id;
      this.artwork_location_log.location_id = this.artwork_location_log.artwork_location_id;
      if (this.artwork_location_log.storage === 'in') {
        this.artwork_location_log.storage_in = this.artwork_location_log.change_date;
      } else {
        this.artwork_location_log.storage_out = this.artwork_location_log.change_date;
      }
      // this.artwork_location_log.id = this.findMinMax(this.all_artwork_location_logs)+1
      if (!this.artwork.artwork_location_logs) {
        this.artwork.artwork_location_logs = [];
      }
      // this.$store.commit('ADD_TODO', this.artwork_location_log)
      // this.all_artwork_location_logs.push(this.artwork_location_log)
      if (this.artwork_location_log.copy === 'packings' && this.selectedPackings && this.selectedPackings.length > 0) {
        // console.log('packings')
        for (var sp in this.selectedPackings) {
          // console.log(this.selectedPackings[sp].id)
          this.artwork_location_log.artwork_packing_id = this.selectedPackings[sp].id;
          console.log(this.artwork_location_log);
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$globals.apiserver + '/artwork_location_logs.json', {
            artwork_location_log: this.artwork_location_log
          }).then(function (response) {
            _this5.errors = {};
            // this.artwork.artwork_location_logs.push(response.data);
            // @artwork.artwork_location_id = @artwork_location_log.id
            // elsif @artwork_location_log.copy = 'master_physical'
            // @artwork.master_physical_location_id = @artwork_location_log.id
            // elsif @artwork_location_log.copy = 'archive_master'
            // @artwork.archive_master_location_id = @artwork_location_log.id
            // elsif @artwork_location_log.copy = 'access_copy'
            // @artwork.access_copy_location_id = @artwork_location_log.id
            // this.active_artwork_location_logs = this.artwork.artwork_location_logs
            _this5.$store.commit('ADD_LOG', response.data);
            _this5.active_artwork_location_logs = _this5.$store.state.artwork_location_logs;
            _this5.showUpload = !_this5.showUpload;
          }).catch(function (error) {
            // console.log(error)
            // this.errors = error.response.data;
          });
        }

        if (this.changeArtworkLocation) {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(this.$globals.apiserver + '/artworks/' + this.artwork.id + '.json', {
            artwork: {
              artwork_location_id: this.artwork_location_log.artwork_location_id
            }
          }).then(function (response) {
            _this5.errors = {};
            _this5.artwork.artwork_location_logs.push(response.data);
            if (_this5.artwork_location_log.copy === 'artwork') {
              _this5.artwork.artwork_location_id = _this5.artwork_location_log.artwork_location_id;
            } else if (_this5.artwork_location_log.copy === 'master_physical') {
              _this5.artwork.master_physical_location_id = _this5.artwork_location_log.artwork_location_id;
            } else if (_this5.artwork_location_log.copy === 'archive_master') {
              _this5.artwork.archive_master_location_id = _this5.artwork_location_log.artwork_location_id;
            } else if (_this5.artwork_location_log.copy === 'access_copy') {
              _this5.artwork.access_copy_location_id = _this5.artwork_location_log.artwork_location_id;
            }
            _this5.$store.commit('ADD_LOG', response.data);
            _this5.active_artwork_location_logs = _this5.$store.state.artwork_location_logs;
            _this5.changeArtworkLocation = false;
          });
        }

        this.artwork_location_log = {
          created_by: this.c_user.id,
          storage: 'in',
          note: '',
          change_date: '',
          copy: 'artwork',
          shipper: '',
          reason: '',
          artwork_location_id: '',
          artwork_packing_id: ''
        };
        this.$store.dispatch('loadPackings');
        this.$emit('getArtwork');
      } else {
        // console.log('single')
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$globals.apiserver + '/artwork_location_logs.json', {
          artwork_location_log: this.artwork_location_log
        }).then(function (response) {
          _this5.errors = {};
          _this5.artwork.artwork_location_logs.push(response.data);
          if (_this5.artwork_location_log.copy === 'artwork') {
            _this5.artwork.artwork_location_id = _this5.artwork_location_log.artwork_location_id;
          } else if (_this5.artwork_location_log.copy === 'master_physical') {
            _this5.artwork.master_physical_location_id = _this5.artwork_location_log.artwork_location_id;
          } else if (_this5.artwork_location_log.copy === 'archive_master') {
            _this5.artwork.archive_master_location_id = _this5.artwork_location_log.artwork_location_id;
          } else if (_this5.artwork_location_log.copy === 'access_copy') {
            _this5.artwork.access_copy_location_id = _this5.artwork_location_log.artwork_location_id;
          }
          _this5.$store.commit('ADD_LOG', response.data);
          _this5.active_artwork_location_logs = _this5.$store.state.artwork_location_logs;
          _this5.showUpload = !_this5.showUpload;
          _this5.artwork_location_log = {
            created_by: _this5.c_user.id,
            storage: 'in',
            note: '',
            change_date: '',
            copy: 'artwork',
            shipper: '',
            reason: '',
            artwork_location_id: '',
            artwork_packing_id: ''
          };
        }).catch(function (error) {
          // console.log(error)
        });
        this.$emit('getArtwork');
      }
      this.selectedPackings = [];
      this.editDialog = false;
      // var aartwork_location_log = Object.keys(this.artwork_location_log).forEach(k => this.artwork_location_log[k]='')
      // console.log(aartwork_location_log)
    },
    save_edited_artwork_location_log: function save_edited_artwork_location_log() {
      var _this6 = this;

      this.editedLocationLog.last_update_by = this.c_user.id;
      this.editedLocationLog.artwork_id = this.artwork.id;
      if (this.editedLocationLog.storage === 'in') {
        this.editedLocationLog.storage_in = this.editedLocationLog.change_date;
      } else {
        this.editedLocationLog.storage_out = this.editedLocationLog.change_date;
      }
      if (this.editedLocationLog.copy === 'packings' && this.selectedPackings && this.selectedPackings.length > 0) {
        for (var sp in this.selectedPackings) {
          this.editedLocationLog.artwork_packing_id = this.selectedPackings[sp].id;
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(this.$globals.apiserver + '/artwork_location_logs.json', {
            artwork_location_log: this.editedLocationLog
          }).then(function (response) {
            _this6.errors = {};
            // this.artwork.artwork_location_logs.push(response.data);
            // @artwork.artwork_location_id = @editedLocationLog.id
            // elsif @editedLocationLog.copy = 'master_physical'
            // @artwork.master_physical_location_id = @editedLocationLog.id
            // elsif @editedLocationLog.copy = 'archive_master'
            // @artwork.archive_master_location_id = @editedLocationLog.id
            // elsif @editedLocationLog.copy = 'access_copy'
            // @artwork.access_copy_location_id = @editedLocationLog.id
            // this.active_artwork_location_logs = this.artwork.artwork_location_logs
            _this6.$store.commit('UPDATE_LOG', response.data);
            _this6.active_artwork_location_logs = _this6.$store.state.artwork_location_logs;
            _this6.showUpload = !_this6.showUpload;
          }).catch(function (error) {
            // console.log(error)
            // this.errors = error.response.data;
          });
        }
        this.artwork_location_log = {
          storage: 'in',
          note: '',
          change_date: '',
          copy: 'artwork',
          shipper: '',
          reason: '',
          artwork_location_id: '',
          artwork_packing_id: ''
        };
      } else {
        __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(this.$globals.apiserver + '/artwork_location_logs/' + this.editedLocationLog.id + '.json', {
          artwork_location_log: this.editedLocationLog
        }).then(function (response) {
          _this6.$emit('getArtwork');
          _this6.errors = {};
          _this6.artwork.artwork_location_logs = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this6.artwork.artwork_location_logs.filter(function (element) {
            return element.id !== response.data.id;
          })), [response.data]);
          if (_this6.editedLocationLog.copy === 'artwork') {
            _this6.artwork.artwork_location_id = _this6.editedLocationLog.artwork_location_id;
          } else if (_this6.editedLocationLog.copy === 'master_physical') {
            _this6.artwork.master_physical_location_id = _this6.editedLocationLog.artwork_location_id;
          } else if (_this6.editedLocationLog.copy === 'archive_master') {
            _this6.artwork.archive_master_location_id = _this6.editedLocationLog.artwork_location_id;
          } else if (_this6.editedLocationLog.copy === 'access_copy') {
            _this6.artwork.access_copy_location_id = _this6.editedLocationLog.artwork_location_id;
          }
          // this.$store.commit("UPDATE_LOG", response.data);
          _this6.active_artwork_location_logs = _this6.$store.state.artwork_location_logs;
          // this.showUpload = !this.showUpload;
          _this6.editedLocationLog = {
            storage: 'in',
            note: '',
            change_date: '',
            change_time: '',
            copy: 'artwork',
            shipper: '',
            reason: '',
            artwork_location_id: '',
            artwork_packing_id: ''
          };
          _this6.editDialog = false;
        }).catch(function (error) {
          // console.log(error)
        });
      }
      // var aartwork_location_log = Object.keys(this.artwork_location_log).forEach(k => this.artwork_location_log[k]='')
      // console.log(aartwork_location_log)
    }
  }
});

/***/ }),

/***/ "OxAN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P+z9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CommonMixin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_constants__ = __webpack_require__("K30H");





function hex2string(hex) {
  var i = 0;
  var ascii = "";
  while (i < hex.length / 2) {
    ascii = ascii + String.fromCharCode(parseInt(hex.substr(i * 2, 2), 16));
    i++;
  }
  return ascii;
}
var CommonMixin = {
  data: function data() {
    return {
      //     c_user:  this.$store.state.profile
      constants: __WEBPACK_IMPORTED_MODULE_3__data_constants__["a" /* default */]
    };
  },

  computed: {
    c_user: function c_user() {
      if (this.$store.state.profile) {
        return this.$store.getters.getProfile;
      } else {
        this.$store.dispatch(USER_REQUEST);
        return this.$store.getters.getProfile;
      }
    }
  },
  methods: {
    getInstitutionName: function getInstitutionName(id) {
      var i = this.$store.state.contacts.find(function (i) {
        return i.id == id;
      });
      if (i) {
        return i.name;
      } else {
        return 'institution not found';
      }
    },

    // findPositionByAtribute(array, attr, value) {
    //   for(var i = 0; i < array.length; i += 1) {
    //       if(array[i][attr] === value) {
    //           return i;
    //       }
    //   }
    //   return -1;
    // },
    dimension_formatted: function dimension_formatted(a) {
      console.log('dimension_formatted');
      var out = ' ';
      if (a.dim_height != null && a.dim_width != null) {
        console.log('1AAAA');
        out = out + (a.dim_height + ' x ' + a.dim_width);

        console.log(a.dim_height);
        console.log(a.dim_width);
        console.log(out);

        if (a.dim_depth != null && a.dim_depth != '') {
          out = out + (' x ' + a.dim_depth);
        }
        out = out + ' cm';

        if (a.dim_diameter != null && a.dim_diameter != '') {
          console.log('a.dim_diameter');
          console.log(a.dim_diameter);
          out = out + ' Ø ' + a.dim_diameter + ' cm';
        }
      } else {
        console.log('BBBBB');

        if (a.dim_diameter != null && a.dim_diameter != '') {
          out = out + (' Ø ' + a.dim_diameter);
          if (a.dim_depth != null && a.dim_depth != '') {
            out = out + ' cm';
          } else {
            out = out + ' x ';
          }
          console.log('dim_depth');
          console.log(out);
        }

        if (a.dim_depth != null) {
          out = out + (a.dim_depth + ' cm');
          console.log('dim_diameter');
          console.log(out);
        }
      }

      if (a.dimensions_notes != null && a.dimensions_notes != '') {
        out = out + a.dimensions_notes;
        console.log('dimensions_notes');
        console.log(out);
      }

      if (a.dim_frame_width != null && a.dim_frame_height != null) {
        if (hex2string(out[0]) != null) {
          out = out + ', ';
        }
        console.log('hex2string');
        console.log(out);
        out = out + (a.dim_frame_height + ' x ' + a.dim_frame_width);
        if (a.dim_frame_depth != null && a.dim_frame_depth != '') {
          out = out + (' x ' + a.dim_frame_depth);
          console.log('dim_frame_depth');
          console.log(out);
        }
        out = out + (' cm' + ' (framed)');
      }
      console.log('out222');
      console.log(out);
      if (a.dim_height != null && a.dim_width != null && a.dim_frame_width != null && a.dim_frame_height != null && a.dimensions_notes != null && a.dim_diameter != null) {
        out = out + '<br />';
      }

      var out2 = out != null ? out.replace('<br />', "\n").strip : '';
      console.log('out');
      console.log(out);
      out2 = out.replace('<br>', "\n");
      console.log('out2');
      console.log(out2);
      return out2;
    },

    /// requires array of values to sort by as second argument
    customDoubleSort: function customDoubleSort(array, sortValues, customSortField, regularSortField) {
      return array.sort(function (a, b) {
        if (sortValues.indexOf(a[customSortField]) < sortValues.indexOf(b[customSortField])) return -1;
        if (sortValues.indexOf(a[customSortField]) > sortValues.indexOf(b[customSortField])) return 1;
        if (a[regularSortField] > b[regularSortField]) return 1;
        if (a[regularSortField] < b[regularSortField]) return -1;
        return 0;
      });
    },

    // customSort (array, sortValues, field) {
    //   return array.sort((a, b) => sortValues.indexOf(a[field]) - sortValues.indexOf(b[field]));
    // },
    value2string: function value2string(value, field) {
      var out = '';
      switch (field) {
        case 'invoice_signed':
        case 'including_slide':
        case 'including_film':
        case 'including_light':
        case 'including_computer':
        case 'including_other':
        case 'including_objects':
        case 'including_sound':
        case 'including_performance':
        case 'deaccessioned':
          out = value === '1' ? 'YES' : 'NO';
          break;
        case 'type_of_work':
          out = this.constants.TYPES_OF_WORK.find(function (a) {
            return a.id == value;
          }).name;
          break;
        case 'visa_status':
          out = this.constants.VISA_STATUSES.find(function (a) {
            return a.id == value;
          }).name;
          break;
        case 'artist':
          out = this.$store.state.artists.find(function (a) {
            return a.id == value;
          }).name;
          break;
        case 'artwork_location_id':
          var a = this.$store.state.locations.find(function (a) {
            return a.id == value;
          });
          out = a ? a.name : 'location not found';
          break;
        default:
          out = value;
          break;
      }
      return out;
    },
    snake2title: function snake2title(t) {
      if (t) {
        var s = t.split('_');
        for (var i = 0; i < s.length; i++) {
          s[i] = s[i][0].toUpperCase() + s[i].slice(1);
        }
        return s.join(' ');
      } else {
        return '';
      }
    },
    getDecade: function getDecade(year) {
      return Math.floor(year / 10) * 10 + 's';
    },
    formatMoney: function formatMoney(amount) {
      var thousands = ',';
      var decimal = '.';
      var decimalCount = 2;
      var amountF = parseFloat(amount);
      try {
        // decimalCount = Math.abs(decimalCount)
        // decimalCount = isNaN(decimalCount) ? 2 : decimalCount
        var i = parseInt(amountF = Math.abs(Number(amountF) || 0).toFixed(decimalCount)).toString();
        var j = i.length > 3 ? i.length % 3 : 0;
        return (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousands) + (decimalCount ? decimal + Math.abs(amountF - i).toFixed(decimalCount).slice(2) : '');
      } catch (e) {
        // console.log(e)
      }
    },
    nl2br: function nl2br(str, is_xhtml) {
      var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    humanize: function humanize(t) {
      return t.replace(/_/g, ' ').replace(/(?: |\b)(\w)/g, function (t) {
        return t.toUpperCase();
      });
    },
    isImage: function isImage(filename) {
      return ['png', 'PNG', 'eps', 'EPS', 'gif', 'GIF', 'bmp', 'BMP', 'JPG', 'jpg', 'peg', 'PEG', 'IFF', 'iff', 'TIF', 'tif'].includes(filename.substr(filename.length - 3));
    },
    exportHTML: function exportHTML(text, title) {
      var ltitle = title || text.title || 'TextDownload';
      var content = text.content || text ? text : 'Text Content not provided';
      this.composeHTML(content, ltitle);
    },
    composeHTML: function composeHTML(content, title) {
      var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " + "xmlns:w='urn:schemas-microsoft-com:office:word' " + "xmlns='http://www.w3.org/TR/REC-html40'>" + "<head><meta charset='utf-8'><title>" + title + '</title></head><body>';
      var footer = '</body></html>';
      // var sourceHTML = header + document.getElementById("source-html").innerHTML + footer
      var sourceHTML = header + content + footer;
      var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
      var fileDownload = document.createElement('a');
      document.body.appendChild(fileDownload);
      fileDownload.href = source;
      fileDownload.download = title + '.doc';
      fileDownload.click();
      document.body.removeChild(fileDownload);
    },
    stripHtml: function stripHtml(s) {
      return s.replace(/<\/?[^>]+(>|$)/g, ' ');
    },
    capitalize: function capitalize(s) {
      if (typeof s !== 'string') return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    o2ids: function o2ids(array, prop) {
      return array.map(function (a) {
        return a[prop];
      });
    },
    ids2o: function ids2o(array) {
      var objs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
      // console.log(objs)
      var out = objs.filter(function (a) {
        // console.log(array.includes(a.id))
        return array.includes(a.id);
      });
      return out;
    },
    get_user: function get_user(userId) {
      if (this.$store.state.users && this.$store.state.users.length > 0) {
        var user = this.$store.state.users.find(function (u) {
          return u.id === userId;
        });
        if (user) {
          return user.firstname + ' ' + user.lastname;
        } else {
          return '??';
        }
      }
    },
    get_contact: function get_contact(id) {
      if (this.$store.state.contacts && this.$store.state.contacts.length > 0) {
        var c = this.$store.state.contacts.find(function (u) {
          return u.id === id;
        });
        if (c) {
          return c.name;
        } else {
          return 'not found';
        }
      }
    },
    get_abb: function get_abb(userId) {
      if (this.$store.state.users && this.$store.state.users.length > 0 && userId > 0) {
        var user = this.$store.state.users.find(function (u) {
          return u.id === userId;
        });
        if (user) {
          return '' + user.abb;
        } else {
          return 'unknown';
        }
      }
    },
    get_visa_status: function get_visa_status(visa_status) {
      if (visa_status != undefined) {
        var vss = this.constants.VISA_STATUSES.filter(function (vs) {
          return vs.id === visa_status;
        });
        if (vss[0] != undefined) {
          // console.log(vss[0].id)
          return vss[0].id > 0 ? vss[0].name : '';
        } else {
          return '';
        }
      }
    },
    get_location_name: function get_location_name(id) {
      if (id != 465) {
        var l = this.$store.state.locations.find(function (l) {
          return l.id === id;
        });
        return l ? l.name : '';
      }
    },
    formatNumber: function formatNumber(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getLatestInsurance: function getLatestInsurance(id) {
      var l = this.$store.state.artwork_insurance_logs.filter(function (l) {
        return l.artwork_id === id;
      });
      if (l.length > 0) {
        l = this.sort_by_date(l, 'insurance_value_date')[0];
        return l;
      } else {
        return '';
      }
    },
    getLatestInsuranceValueText: function getLatestInsuranceValueText(id) {
      var l = this.getLatestInsurance(id);
      // var l = this.$store.state.artwork_insurance_logs.filter(l => l.artwork_id === id)
      // console.log(this.$store.state.artwork_insurance_logs.length)
      // console.log(l)
      if (l) {
        // l = this.sort_by_date(l, 'change_date')[0]
        var date = l.insurance_value_date ? '(' + l.insurance_value_date + ')' : '';
        var currency = l.insurance_value_currency ? l.insurance_value_currency : '';
        return this.formatNumber(l.insurance_value) + ' ' + currency + ' ';
      } else {
        return '';
      }
    },
    getLatestInsuranceValue: function getLatestInsuranceValue(id) {
      var l = this.getLatestInsurance(id);
      // var l = this.$store.state.artwork_insurance_logs.filter(l => l.artwork_id === id)
      // console.log(this.$store.state.artwork_insurance_logs.length)
      // console.log(l)
      if (l) {
        // l = this.sort_by_date(l, 'change_date')[0]
        return l.insurance_value;
      } else {
        return '';
      }
    },
    getLatestInsuranceCurrency: function getLatestInsuranceCurrency(id) {
      var l = this.getLatestInsurance(id);
      // var l = this.$store.state.artwork_insurance_logs.filter(l => l.artwork_id === id)
      // console.log(this.$store.state.artwork_insurance_logs.length)
      // console.log(l)
      if (l) {
        // l = this.sort_by_date(l, 'change_date')[0]
        return l.insurance_value_currency;
      } else {
        return '';
      }
    },
    sort_by_date: function sort_by_date(datas, field) {
      // console.log(datas)
      datas.sort(function (a, b) {
        var dateA = new Date(a[field]);
        var dateB = new Date(b[field]);

        // subtract dates to get a value that's either negative, positive, or zero
        return dateB - dateA; // sort in descending order
      });
      return datas;
    },
    get_exhibition_name: function get_exhibition_name(id) {
      if (id) {
        var l = this.$store.state.exhibitions.find(function (l) {
          return l.id === id;
        });
        return l ? l.name : '';
      } else {
        return '';
      }
    },
    getOwnershipName: function getOwnershipName(o) {
      // console.log(this.constants)
      var out = this.constants.OWNERSHIPS.find(function (s) {
        return s.id == o;
      });
      if (out) {
        return out.name;
      } else {
        return 'Ownership NOT SET';
      }
    },
    getArtwork: function getArtwork(artworkId) {
      if (this.$store.state.artworks.length > 0) {
        var artwork = this.$store.state.artworks.find(function (u) {
          return u.id === artworkId;
        });
        if (artwork) {
          return artwork.name + ', ' + artwork.title + ', ' + artwork.accession_number;
        } else {
          return 'Not found';
        }
      }
    },
    format_date: function format_date(date) {
      var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';

      var moment = __webpack_require__("PJh5");
      var ndate = new Date(date);
      return moment(ndate).format(format);
    },
    findMinMax: function findMinMax(arr) {
      // console.log(arr)
      var max = arr[0].id;
      for (var i = 1, len = arr.length; i < len; i++) {
        var v = arr[i].id;
        max = v > max ? v : max;
      }
      return max;
    },
    formatAddress: function formatAddress(address) {}
  },
  filters: {
    formattedAddress: function formattedAddress(address) {
      return this.formatAddress(address);
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (CommonMixin);

// getVisaStatus (vs) {
//   var out = this.constants.VISA_STATUSES.find(s => s.id == vs)
//   if (out) {
//     return out.name
//   } else {
//     return 'Visa status unknown'
//   }
// },

/***/ }),

/***/ "P/By":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P7M7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoanConditions_vue__ = __webpack_require__("UuKG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7342d04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanConditions_vue__ = __webpack_require__("bgEy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("3cv1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e7342d04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoanConditions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7342d04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanConditions_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7342d04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanConditions_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PDQ3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PGjU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PHsT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PmKx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editBG pt-0 mt-4"},[_c('v-toolbar',{staticClass:"elevation-1 mt-0",attrs:{"tabs":"","color":"white"}},[_c('h4',{staticClass:"pl-3 headline font-weight-light"},[_vm._v("\n      My CMS settings\n    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":"","disabled":!_vm.valid,"right":""},on:{"click":_vm.save}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("save")])],1)],1),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{staticClass:"editBG elevation-0 px-2"},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.links,"label":"Where to go after login?"},model:{value:(_vm.after_login_page),callback:function ($$v) {_vm.after_login_page=$$v},expression:"after_login_page"}})],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-checkbox',{attrs:{"label":"Remember saved artworks accross sessions"},model:{value:(_vm.remember_saved_artworks),callback:function ($$v) {_vm.remember_saved_artworks=$$v},expression:"remember_saved_artworks"}})],1)],1)],1)],1),_vm._v(" "),_c('section-header',{staticClass:"mx-4",attrs:{"text":"Artwork Fields Shown in Collections"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-0":""}},[_c('v-container',{attrs:{"fluid":"","pa-0":"","ma-0":"","grid-list-xs":"","text-xs-left":""}},[_c('v-layout',{staticClass:"grey lighten-2 pb-4",attrs:{"row":"","wrap":"","pa-0":"","ma-0":""}},_vm._l((_vm.constants.ARTWORK_FIELDS),function(r){return _c('v-flex',{key:r,class:{
                  xs12: r.header || r.divider,
                  'xs12 sm6 md4 lg3': !(r.header || r.divider),
                  'px-2 py-0 my-0': true
                }},[(r.header || r.divider)?_c('v-flex',{attrs:{"xs12":"","pt-3":"","pl-3":"","pb-0":"","mb-0":"","mt-4":""}},[_c('h2',[_c('span',[_vm._v(_vm._s(r.header))]),_vm._v(" "),(r.image)?_c('v-btn',{staticClass:"right mt-0 pt-0 pb-2",attrs:{"icon":""},on:{"click":function($event){return _vm.showHelp(r.image)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("help")])],1):_vm._e()],1),_vm._v(" "),_c('v-divider',{staticClass:"py-0 my-0"})],1):_c('v-flex',{attrs:{"xs12":"","py-0":"","pt-0":"","my-0":"","pl-3":""}},[_c('v-checkbox',{attrs:{"color":"","label":r,"value":r,"hide-details":""},on:{"change":function($event){return _vm.remove(r)}},model:{value:(_vm.collections_field_array),callback:function ($$v) {_vm.collections_field_array=$$v},expression:"collections_field_array"}})],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.valid},on:{"click":_vm.submit}},[_vm._v("\n      save changes\n    ")])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "Pucp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xlsx__ = __webpack_require__("uXZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_constants__ = __webpack_require__("K30H");
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['data', 'name', 'fileName', 'columns', 'small'],
  data: function data() {
    return {
      constants: __WEBPACK_IMPORTED_MODULE_1__data_constants__["a" /* default */]
    };
  },
  // async created () {
  //   this.Datas = await api.getDatas()
  // },
  methods: {
    humanize: function humanize(str) {
      var frags = str.split('_');
      for (var i = 0; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
      }
      return frags.join(' ');
    },
    get_visa_status: function get_visa_status(packing) {
      var _this = this;

      var vss = __WEBPACK_IMPORTED_MODULE_1__data_constants__["a" /* default */].VISA_STATUSES.filter(function (vs) {
        return vs.id == (!packing.visa_status ? _this.data.visa_status : packing.visa_status);
      });
      if (vss[0] != undefined) {
        return vss[0].id > 0 ? vss[0].name : '';
      } else {
        return '';
      }
    },
    format_date: function format_date(date) {
      var moment = __webpack_require__("PJh5");
      var ndate = new Date(date);
      return moment(ndate).format('YYYY-MM-DD');
    },
    onexport: function onexport() {
      var _this2 = this;

      // console.log('exhibitions')
      var col = ['id', 'title'].concat(this.columns);
      var settings = {
        // skipHeader: true,
        origin: 'A2'
      };
      var artist = this.$store.state.artists.find(function (a) {
        return a.id === _this2.data.artist.id;
      });
      var transformedData = this.data.artwork_packings.map(function (textRow) {
        // var todos = Object.assign([], this.$store.state.todos.filter(t => { return textRow.id == t.artwork_id}))
        // tod os = todos.map(a => {return a.title})
        // var packings = data.artwork_packings
        // packings = packings.map(a => {return a.colli})
        // var exhibitions = Object.assign([], this.$store.state.exhibitions.filter(t => {
        //   return t.artworks.map(a => a = a.id ).includes(textRow.id)
        // }))
        // exhibitions = exhibitions.map(a => {return a.title})

        // ARTWORK DIMENSIONS
        var arr = [_this2.data.dim_length, _this2.data.dim_width, _this2.data.dim_height, _this2.data.dim_depth];
        var dim = arr.filter(function (a) {
          return a != null && a != '';
        }).join(' x ');
        dim = dim ? dim + ' cm ' : null;
        var dimensions = dim + (_this2.data.dim_diameter ? 'ø' + _this2.data.dim_diameter : '');

        return {
          // Accession Number, Artist Full Name, Title, Year, Medium, Dimensions
          Artist: artist.name ? artist.name : '',
          Title: _this2.data.title + ', ' + (_this2.data.production_date ? _this2.data.production_date_new : ''),
          'Accession Number': _this2.data.accession_number ? _this2.data.accession_number : '',
          'Production Date': _this2.data.production_date_new ? _this2.data.production_date_new : '',
          'Visa Status': _this2.get_visa_status(textRow),
          Colli: textRow.colli,
          Packing: textRow.packing,
          Height: textRow.height,
          Length: textRow.lenght,
          Width: textRow.width,
          Weigth: textRow.weight,
          // Depth: textRow.depth,
          Location: textRow.artwork_location_id ? _this2.$store.state.locations.find(function (l) {
            return l.id === textRow.artwork_location_id;
          }).name : '',
          'Media Material Description': _this2.data.media_material_description,
          'Artwork Dimensions (cm)': dimensions,
          // 'Artwork Heigth (cm)': this.data.dim_height,
          // 'Artwork Depth (cm)': this.data.dim_depth,
          // 'Artwork Diameter (cm)': this.data.dim_diameter,
          Contents: textRow.contents,
          Note: textRow.note
          // "classification": (textRow.classification ? textRow.classification.toUpperCase() : ''),
          // "todos": todos.length > 0 ? ('ToDos: ' + (todos.join(', '))) : '',
          // "exhibitions": exhibitions.length > 0 ? ('Exhibitions: \n >> ' + (exhibitions.join('\n >> '))) : '',
          // "packings": packings.length > 0 ? (packings) : ''
        };
      });
      var sheet = __WEBPACK_IMPORTED_MODULE_0_xlsx___default.a.utils.json_to_sheet(transformedData, settings);
      var wb = __WEBPACK_IMPORTED_MODULE_0_xlsx___default.a.utils.book_new(); // make Workbook of Excel
      __WEBPACK_IMPORTED_MODULE_0_xlsx___default.a.utils.book_append_sheet(wb, sheet, this.name);
      __WEBPACK_IMPORTED_MODULE_0_xlsx___default.a.writeFile(wb, this.fileName + '.xlsx'); // name of the file is 'book.xlsx'

      // export Excel file
      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      // XLSX.utils.book_append_sheet(wb, animalWS, 'animals')
      // sheetAName is name of Worksheet
      // var sheet = XLSX.utils.json_to_sheet(this.data)
      // A workbook is the name given to an Excel file
    }
  }
});

/***/ }),

/***/ "PwaE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import * as qs from "querystring";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      artwork_location: { name: '' },
      // fields: [
      //   {
      //     'name': {
      //       'ctype': 'text-short',
      //       'name': 'name',
      //       'title': 'Name',
      //       'class': 'xs12 md6'
      //     }
      //   }
      // ],
      // artistFormData: Object.assign({},this.artist),
      valid: true,
      location_exists: false,
      cannotSave: false,
      saved: false
    };
  },

  methods: {
    check_location: function check_location(value) {
      var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artwork_locations);
      var b = a.filter(function (aa) {
        return aa.name == value;
      });
      this.location_exists = b.length > 0;
    },

    // submit () {
    //   // const art = this.artistFormData
    //   const requestConfig = {
    //       url     : `${this.$globals.apiserver}/artwork_locations.json`,
    //       method  : "POST",
    //       // headers : { "Content-Type" : "application/x-www-form-urlencoded" },
    //       // data : qs.stringify(art)
    //       artwork_location: this.location
    //   }
    //   const response = axios.request(requestConfig)
    // },
    saveLocation: function saveLocation() {
      var _this = this;

      this.artwork_location.created_by = this.c_user.id;

      var url = this.$globals.apiserver + '/artwork_locations.json';

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, this.artwork_location).then(function (response) {
        _this.result = response.data;
        _this.artwork_location = response.data;
        // this.$store.dispatch('addExhibition',response.data)
        _this.e1 = 2;
      }).then(function (response) {
        _this.$store.dispatch("loadLocations");
        _this.$emit("showSnackbar", "Location '" + _this.artwork_location.name + "' Saved ", "green");
        _this.progress = false;
        _this.isEditing = false;
        _this.$router.push({ name: "Locations" });
      }).catch(function (error) {
        _this.$emit("showSnackbar", "Problem saving Location '" + _this.artwork_location.name + "' ", "red");
        // console.log(error);
      });
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  },
  computed: {}
});

/***/ }),

/***/ "PzvK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { mapState } from "vuex";
// import * as qs from "querystring";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["contact", "id"],
  data: function data() {
    return {
      contactFormData: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.contact),
      snackbar: false,
      snackbarFieldName: "",
      snackbarColor: '',
      snackbarText: '',
      timeout: 3000,
      editContact: false,
      result: "",
      currentTabContact: this.$store.state.currentTabContact,
      valid: true
    };
  },


  // mounted () {
  //   this.$nextTick(() => {
  //     $('.container').hide()
  //     $('.container').fadeIn()
  //   })
  // },
  beforeMount: function beforeMount() {
    this.result = this.$route.params.contact;
    // setTimeout(
    //   function() {
    //   }.bind(this),
    //   4000
    // );
    if (!this.result) {
      this.result = this.contact;
    }
    this.contactFormData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.result);
    this.getContact();
  },

  methods: {
    humanize: function humanize(t) {
      return t.replace(/_/g, " ").replace(/(?: |\b)(\w)/g, function (t) {
        return t.toUpperCase();
      });
    },
    verify_accession_no: function verify_accession_no() {
      return false;
    },
    saveCurrentTab: function saveCurrentTab(tab) {
      setTimeout(function () {
        this.$store.dispatch("saveCurrentTab", tab);
      }.bind(this), 1000);
    },
    getContact: function getContact() {
      var _this = this;

      // console.log('test output getcontact')
      var url = this.$globals.apiserver + "/contacts/" + this.contactFormData.id + ".json";
      // let url = `http://www.tba21.org/contact.json?id={{contact.id}}`
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (response) {
        // this.loading = false;
        _this.contactFormData = response.data;
      }).catch(function (error) {
        // console.log(error);
      });
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    submit: function submit() {
      var _this2 = this;

      // const c = this.contactFormData
      // const requestConfig = {
      //     url     : `${this.$globals.apiserver}/contacts/api_update/${this.$route.params.id}`,
      //     method  : "POST",
      //     data : qs.stringify(c)
      // }
      // const response = axios.request(requestConfig)

      var url = this.$globals.apiserver + "/contacts/" + this.contactFormData.id + ".json";
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, { contact: this.contactFormData })
      // {
      //   name: this.contactFormData.name,
      //   category: this.contactFormData.category,
      //   company: this.contactFormData.company,
      //   first_name: this.contactFormData.first_name,
      //   last_name: this.contactFormData.last_name,
      //   id: this.contactFormData.id
      // })
      .then(function (response) {
        _this2.snackbar = true;
        _this2.snackbarColor = 'green';
        _this2.snackbarText = 'Contact was saved.';
        // this.loading = false;
        // console.log(response.data)
        // this.result = response.data
        // this.artwork = response.data
        // this.$store.dispatch('addArtwork',response.data)
        // this.artwork = response.data
        // this.artist = response.data.artist
        // this.e1 = 3
        // console.log(this.artwork)
      }).catch(function (error) {
        _this2.snackbar = true;
        _this2.snackbarColor = 'red';
        _this2.snackbarText = 'Error Occured while saving Contact';
        // console.log(error);
      });
    }
  }
  // computed: {
  //   contact2() {
  //     let contact = this.result;
  //     // console.log(contact)
  //     // this.contact.map(contact => {
  //     //   let a = contact
  //     //   contact.first_name = a ? a.first_name : 'nema meno'
  //     // })
  //     // console.log(this.contact)
  //     return contact;
  //   }
  // }
});

/***/ }),

/***/ "Q2Z5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditFieldComp__ = __webpack_require__("YBR5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeaderElements__ = __webpack_require__("oiZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ElementsTable__ = __webpack_require__("vCKh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var show_field = function show_field(field) {
  if (field.condition && light) {
    var theInstructions = field.condition;
    var F = function F(theInstructions) {};
    return F();
  } else {
    return true;
  }
};



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      lights: [],
      light: {
        duration: 0,
        frequency: '',
        color: '',
        temperature: '',
        filesize: '',
        other_specifications: '',
        associated_programme: '',
        associated_information: '',
        creation_date: '',
        notes: ''
      },
      showUpload: false,
      show: false,
      fields: [{
        'ctype': 'text-short',
        'name': 'light.title',
        'title': 'Title',
        column: true,
        class: 'xs12',
        edit: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'etype': 'radio',
        'selection': [{ id: '1', value: '1', name: 'Endless' }, { id: '2', value: '2', name: 'Looped' }, { id: '3', value: '3', name: 'Time' }, { id: '4', value: '4', name: 'Blinking' }],
        'name': 'light.duration',
        'title': 'Duration',
        class: 'xs12',
        work_types: ['fvs'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'light.frequency',
        'title': 'Frequency',
        hint: '50 Hz, 60 Hz …',
        suffix: 'Hz',
        class: 'xs6',
        work_types: ['fvs'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'light.color',
        'title': 'Color',
        column: true,
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'light.temperature',
        'title': 'Temperature',
        column: true,
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'light.associated_programme',
        'title': 'Associated Programme',
        column: true,
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'light.filesize',
        'title': 'File Size',
        column: true,
        suffix: 'MB',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-long',
        'name': 'light.other_specifications',
        'title': 'Other Specifications',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-long',
        'name': 'light.associated_information',
        'title': 'Associated Information carriers (format migration story)',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'date',
        'name': 'light.creation_date',
        'title': 'Creation Date)',
        column: true,
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-long',
        'name': 'light.notes',
        'title': 'Notes)',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }]
    };
  },
  methods: {
    set_input: function set_input(f) {
      light[f] = f;
    },
    download: function download() {},
    add: function add() {
      this.lights.push(this.light);
      this.showUpload = !this.showUpload;
    },
    delete_light: function delete_light() {},
    done_light: function done_light() {},
    show_field_c: function show_field_c(field) {
      // console.log(this.light)
      return show_field(field, this.light);
    }
  },
  computed: {},
  components: { EditFieldComp: __WEBPACK_IMPORTED_MODULE_0__EditFieldComp__["a" /* default */], HeaderElements: __WEBPACK_IMPORTED_MODULE_1__HeaderElements__["a" /* default */], ElementsTable: __WEBPACK_IMPORTED_MODULE_2__ElementsTable__["a" /* default */] }
});

/***/ }),

/***/ "QBky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OwnershipHistory_vue__ = __webpack_require__("80nQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b73a5b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OwnershipHistory_vue__ = __webpack_require__("lsII");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("/gnG")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17b73a5b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OwnershipHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b73a5b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OwnershipHistory_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17b73a5b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OwnershipHistory_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QCv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QJDQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__ = __webpack_require__("/llq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8781e0ec_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__ = __webpack_require__("2cZe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("1q6t")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8781e0ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8781e0ec_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8781e0ec_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Notifications_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QKd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CORE_SCHEMA */
/* unused harmony export DEFAULT_SCHEMA */
/* unused harmony export FAILSAFE_SCHEMA */
/* unused harmony export JSON_SCHEMA */
/* unused harmony export Schema */
/* unused harmony export Type */
/* unused harmony export YAMLException */
/* unused harmony export dump */
/* unused harmony export load */
/* unused harmony export loadAll */
/* unused harmony export safeDump */
/* unused harmony export safeLoad */
/* unused harmony export safeLoadAll */
/* unused harmony export types */

/*! js-yaml 4.1.0 https://github.com/nodeca/js-yaml @license MIT */
function isNothing(subject) {
  return (typeof subject === 'undefined') || (subject === null);
}


function isObject(subject) {
  return (typeof subject === 'object') && (subject !== null);
}


function toArray(sequence) {
  if (Array.isArray(sequence)) return sequence;
  else if (isNothing(sequence)) return [];

  return [ sequence ];
}


function extend(target, source) {
  var index, length, key, sourceKeys;

  if (source) {
    sourceKeys = Object.keys(source);

    for (index = 0, length = sourceKeys.length; index < length; index += 1) {
      key = sourceKeys[index];
      target[key] = source[key];
    }
  }

  return target;
}


function repeat(string, count) {
  var result = '', cycle;

  for (cycle = 0; cycle < count; cycle += 1) {
    result += string;
  }

  return result;
}


function isNegativeZero(number) {
  return (number === 0) && (Number.NEGATIVE_INFINITY === 1 / number);
}


var isNothing_1      = isNothing;
var isObject_1       = isObject;
var toArray_1        = toArray;
var repeat_1         = repeat;
var isNegativeZero_1 = isNegativeZero;
var extend_1         = extend;

var common = {
	isNothing: isNothing_1,
	isObject: isObject_1,
	toArray: toArray_1,
	repeat: repeat_1,
	isNegativeZero: isNegativeZero_1,
	extend: extend_1
};

// YAML error class. http://stackoverflow.com/questions/8458984


function formatError(exception, compact) {
  var where = '', message = exception.reason || '(unknown reason)';

  if (!exception.mark) return message;

  if (exception.mark.name) {
    where += 'in "' + exception.mark.name + '" ';
  }

  where += '(' + (exception.mark.line + 1) + ':' + (exception.mark.column + 1) + ')';

  if (!compact && exception.mark.snippet) {
    where += '\n\n' + exception.mark.snippet;
  }

  return message + ' ' + where;
}


function YAMLException$1(reason, mark) {
  // Super constructor
  Error.call(this);

  this.name = 'YAMLException';
  this.reason = reason;
  this.mark = mark;
  this.message = formatError(this, false);

  // Include stack trace in error object
  if (Error.captureStackTrace) {
    // Chrome and NodeJS
    Error.captureStackTrace(this, this.constructor);
  } else {
    // FF, IE 10+ and Safari 6+. Fallback for others
    this.stack = (new Error()).stack || '';
  }
}


// Inherit from Error
YAMLException$1.prototype = Object.create(Error.prototype);
YAMLException$1.prototype.constructor = YAMLException$1;


YAMLException$1.prototype.toString = function toString(compact) {
  return this.name + ': ' + formatError(this, compact);
};


var exception = YAMLException$1;

// get snippet for a single line, respecting maxLength
function getLine(buffer, lineStart, lineEnd, position, maxLineLength) {
  var head = '';
  var tail = '';
  var maxHalfLength = Math.floor(maxLineLength / 2) - 1;

  if (position - lineStart > maxHalfLength) {
    head = ' ... ';
    lineStart = position - maxHalfLength + head.length;
  }

  if (lineEnd - position > maxHalfLength) {
    tail = ' ...';
    lineEnd = position + maxHalfLength - tail.length;
  }

  return {
    str: head + buffer.slice(lineStart, lineEnd).replace(/\t/g, '→') + tail,
    pos: position - lineStart + head.length // relative position
  };
}


function padStart(string, max) {
  return common.repeat(' ', max - string.length) + string;
}


function makeSnippet(mark, options) {
  options = Object.create(options || null);

  if (!mark.buffer) return null;

  if (!options.maxLength) options.maxLength = 79;
  if (typeof options.indent      !== 'number') options.indent      = 1;
  if (typeof options.linesBefore !== 'number') options.linesBefore = 3;
  if (typeof options.linesAfter  !== 'number') options.linesAfter  = 2;

  var re = /\r?\n|\r|\0/g;
  var lineStarts = [ 0 ];
  var lineEnds = [];
  var match;
  var foundLineNo = -1;

  while ((match = re.exec(mark.buffer))) {
    lineEnds.push(match.index);
    lineStarts.push(match.index + match[0].length);

    if (mark.position <= match.index && foundLineNo < 0) {
      foundLineNo = lineStarts.length - 2;
    }
  }

  if (foundLineNo < 0) foundLineNo = lineStarts.length - 1;

  var result = '', i, line;
  var lineNoLength = Math.min(mark.line + options.linesAfter, lineEnds.length).toString().length;
  var maxLineLength = options.maxLength - (options.indent + lineNoLength + 3);

  for (i = 1; i <= options.linesBefore; i++) {
    if (foundLineNo - i < 0) break;
    line = getLine(
      mark.buffer,
      lineStarts[foundLineNo - i],
      lineEnds[foundLineNo - i],
      mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo - i]),
      maxLineLength
    );
    result = common.repeat(' ', options.indent) + padStart((mark.line - i + 1).toString(), lineNoLength) +
      ' | ' + line.str + '\n' + result;
  }

  line = getLine(mark.buffer, lineStarts[foundLineNo], lineEnds[foundLineNo], mark.position, maxLineLength);
  result += common.repeat(' ', options.indent) + padStart((mark.line + 1).toString(), lineNoLength) +
    ' | ' + line.str + '\n';
  result += common.repeat('-', options.indent + lineNoLength + 3 + line.pos) + '^' + '\n';

  for (i = 1; i <= options.linesAfter; i++) {
    if (foundLineNo + i >= lineEnds.length) break;
    line = getLine(
      mark.buffer,
      lineStarts[foundLineNo + i],
      lineEnds[foundLineNo + i],
      mark.position - (lineStarts[foundLineNo] - lineStarts[foundLineNo + i]),
      maxLineLength
    );
    result += common.repeat(' ', options.indent) + padStart((mark.line + i + 1).toString(), lineNoLength) +
      ' | ' + line.str + '\n';
  }

  return result.replace(/\n$/, '');
}


var snippet = makeSnippet;

var TYPE_CONSTRUCTOR_OPTIONS = [
  'kind',
  'multi',
  'resolve',
  'construct',
  'instanceOf',
  'predicate',
  'represent',
  'representName',
  'defaultStyle',
  'styleAliases'
];

var YAML_NODE_KINDS = [
  'scalar',
  'sequence',
  'mapping'
];

function compileStyleAliases(map) {
  var result = {};

  if (map !== null) {
    Object.keys(map).forEach(function (style) {
      map[style].forEach(function (alias) {
        result[String(alias)] = style;
      });
    });
  }

  return result;
}

function Type$1(tag, options) {
  options = options || {};

  Object.keys(options).forEach(function (name) {
    if (TYPE_CONSTRUCTOR_OPTIONS.indexOf(name) === -1) {
      throw new exception('Unknown option "' + name + '" is met in definition of "' + tag + '" YAML type.');
    }
  });

  // TODO: Add tag format check.
  this.options       = options; // keep original options in case user wants to extend this type later
  this.tag           = tag;
  this.kind          = options['kind']          || null;
  this.resolve       = options['resolve']       || function () { return true; };
  this.construct     = options['construct']     || function (data) { return data; };
  this.instanceOf    = options['instanceOf']    || null;
  this.predicate     = options['predicate']     || null;
  this.represent     = options['represent']     || null;
  this.representName = options['representName'] || null;
  this.defaultStyle  = options['defaultStyle']  || null;
  this.multi         = options['multi']         || false;
  this.styleAliases  = compileStyleAliases(options['styleAliases'] || null);

  if (YAML_NODE_KINDS.indexOf(this.kind) === -1) {
    throw new exception('Unknown kind "' + this.kind + '" is specified for "' + tag + '" YAML type.');
  }
}

var type = Type$1;

/*eslint-disable max-len*/





function compileList(schema, name) {
  var result = [];

  schema[name].forEach(function (currentType) {
    var newIndex = result.length;

    result.forEach(function (previousType, previousIndex) {
      if (previousType.tag === currentType.tag &&
          previousType.kind === currentType.kind &&
          previousType.multi === currentType.multi) {

        newIndex = previousIndex;
      }
    });

    result[newIndex] = currentType;
  });

  return result;
}


function compileMap(/* lists... */) {
  var result = {
        scalar: {},
        sequence: {},
        mapping: {},
        fallback: {},
        multi: {
          scalar: [],
          sequence: [],
          mapping: [],
          fallback: []
        }
      }, index, length;

  function collectType(type) {
    if (type.multi) {
      result.multi[type.kind].push(type);
      result.multi['fallback'].push(type);
    } else {
      result[type.kind][type.tag] = result['fallback'][type.tag] = type;
    }
  }

  for (index = 0, length = arguments.length; index < length; index += 1) {
    arguments[index].forEach(collectType);
  }
  return result;
}


function Schema$1(definition) {
  return this.extend(definition);
}


Schema$1.prototype.extend = function extend(definition) {
  var implicit = [];
  var explicit = [];

  if (definition instanceof type) {
    // Schema.extend(type)
    explicit.push(definition);

  } else if (Array.isArray(definition)) {
    // Schema.extend([ type1, type2, ... ])
    explicit = explicit.concat(definition);

  } else if (definition && (Array.isArray(definition.implicit) || Array.isArray(definition.explicit))) {
    // Schema.extend({ explicit: [ type1, type2, ... ], implicit: [ type1, type2, ... ] })
    if (definition.implicit) implicit = implicit.concat(definition.implicit);
    if (definition.explicit) explicit = explicit.concat(definition.explicit);

  } else {
    throw new exception('Schema.extend argument should be a Type, [ Type ], ' +
      'or a schema definition ({ implicit: [...], explicit: [...] })');
  }

  implicit.forEach(function (type$1) {
    if (!(type$1 instanceof type)) {
      throw new exception('Specified list of YAML types (or a single Type object) contains a non-Type object.');
    }

    if (type$1.loadKind && type$1.loadKind !== 'scalar') {
      throw new exception('There is a non-scalar type in the implicit list of a schema. Implicit resolving of such types is not supported.');
    }

    if (type$1.multi) {
      throw new exception('There is a multi type in the implicit list of a schema. Multi tags can only be listed as explicit.');
    }
  });

  explicit.forEach(function (type$1) {
    if (!(type$1 instanceof type)) {
      throw new exception('Specified list of YAML types (or a single Type object) contains a non-Type object.');
    }
  });

  var result = Object.create(Schema$1.prototype);

  result.implicit = (this.implicit || []).concat(implicit);
  result.explicit = (this.explicit || []).concat(explicit);

  result.compiledImplicit = compileList(result, 'implicit');
  result.compiledExplicit = compileList(result, 'explicit');
  result.compiledTypeMap  = compileMap(result.compiledImplicit, result.compiledExplicit);

  return result;
};


var schema = Schema$1;

var str = new type('tag:yaml.org,2002:str', {
  kind: 'scalar',
  construct: function (data) { return data !== null ? data : ''; }
});

var seq = new type('tag:yaml.org,2002:seq', {
  kind: 'sequence',
  construct: function (data) { return data !== null ? data : []; }
});

var map = new type('tag:yaml.org,2002:map', {
  kind: 'mapping',
  construct: function (data) { return data !== null ? data : {}; }
});

var failsafe = new schema({
  explicit: [
    str,
    seq,
    map
  ]
});

function resolveYamlNull(data) {
  if (data === null) return true;

  var max = data.length;

  return (max === 1 && data === '~') ||
         (max === 4 && (data === 'null' || data === 'Null' || data === 'NULL'));
}

function constructYamlNull() {
  return null;
}

function isNull(object) {
  return object === null;
}

var _null = new type('tag:yaml.org,2002:null', {
  kind: 'scalar',
  resolve: resolveYamlNull,
  construct: constructYamlNull,
  predicate: isNull,
  represent: {
    canonical: function () { return '~';    },
    lowercase: function () { return 'null'; },
    uppercase: function () { return 'NULL'; },
    camelcase: function () { return 'Null'; },
    empty:     function () { return '';     }
  },
  defaultStyle: 'lowercase'
});

function resolveYamlBoolean(data) {
  if (data === null) return false;

  var max = data.length;

  return (max === 4 && (data === 'true' || data === 'True' || data === 'TRUE')) ||
         (max === 5 && (data === 'false' || data === 'False' || data === 'FALSE'));
}

function constructYamlBoolean(data) {
  return data === 'true' ||
         data === 'True' ||
         data === 'TRUE';
}

function isBoolean(object) {
  return Object.prototype.toString.call(object) === '[object Boolean]';
}

var bool = new type('tag:yaml.org,2002:bool', {
  kind: 'scalar',
  resolve: resolveYamlBoolean,
  construct: constructYamlBoolean,
  predicate: isBoolean,
  represent: {
    lowercase: function (object) { return object ? 'true' : 'false'; },
    uppercase: function (object) { return object ? 'TRUE' : 'FALSE'; },
    camelcase: function (object) { return object ? 'True' : 'False'; }
  },
  defaultStyle: 'lowercase'
});

function isHexCode(c) {
  return ((0x30/* 0 */ <= c) && (c <= 0x39/* 9 */)) ||
         ((0x41/* A */ <= c) && (c <= 0x46/* F */)) ||
         ((0x61/* a */ <= c) && (c <= 0x66/* f */));
}

function isOctCode(c) {
  return ((0x30/* 0 */ <= c) && (c <= 0x37/* 7 */));
}

function isDecCode(c) {
  return ((0x30/* 0 */ <= c) && (c <= 0x39/* 9 */));
}

function resolveYamlInteger(data) {
  if (data === null) return false;

  var max = data.length,
      index = 0,
      hasDigits = false,
      ch;

  if (!max) return false;

  ch = data[index];

  // sign
  if (ch === '-' || ch === '+') {
    ch = data[++index];
  }

  if (ch === '0') {
    // 0
    if (index + 1 === max) return true;
    ch = data[++index];

    // base 2, base 8, base 16

    if (ch === 'b') {
      // base 2
      index++;

      for (; index < max; index++) {
        ch = data[index];
        if (ch === '_') continue;
        if (ch !== '0' && ch !== '1') return false;
        hasDigits = true;
      }
      return hasDigits && ch !== '_';
    }


    if (ch === 'x') {
      // base 16
      index++;

      for (; index < max; index++) {
        ch = data[index];
        if (ch === '_') continue;
        if (!isHexCode(data.charCodeAt(index))) return false;
        hasDigits = true;
      }
      return hasDigits && ch !== '_';
    }


    if (ch === 'o') {
      // base 8
      index++;

      for (; index < max; index++) {
        ch = data[index];
        if (ch === '_') continue;
        if (!isOctCode(data.charCodeAt(index))) return false;
        hasDigits = true;
      }
      return hasDigits && ch !== '_';
    }
  }

  // base 10 (except 0)

  // value should not start with `_`;
  if (ch === '_') return false;

  for (; index < max; index++) {
    ch = data[index];
    if (ch === '_') continue;
    if (!isDecCode(data.charCodeAt(index))) {
      return false;
    }
    hasDigits = true;
  }

  // Should have digits and should not end with `_`
  if (!hasDigits || ch === '_') return false;

  return true;
}

function constructYamlInteger(data) {
  var value = data, sign = 1, ch;

  if (value.indexOf('_') !== -1) {
    value = value.replace(/_/g, '');
  }

  ch = value[0];

  if (ch === '-' || ch === '+') {
    if (ch === '-') sign = -1;
    value = value.slice(1);
    ch = value[0];
  }

  if (value === '0') return 0;

  if (ch === '0') {
    if (value[1] === 'b') return sign * parseInt(value.slice(2), 2);
    if (value[1] === 'x') return sign * parseInt(value.slice(2), 16);
    if (value[1] === 'o') return sign * parseInt(value.slice(2), 8);
  }

  return sign * parseInt(value, 10);
}

function isInteger(object) {
  return (Object.prototype.toString.call(object)) === '[object Number]' &&
         (object % 1 === 0 && !common.isNegativeZero(object));
}

var int = new type('tag:yaml.org,2002:int', {
  kind: 'scalar',
  resolve: resolveYamlInteger,
  construct: constructYamlInteger,
  predicate: isInteger,
  represent: {
    binary:      function (obj) { return obj >= 0 ? '0b' + obj.toString(2) : '-0b' + obj.toString(2).slice(1); },
    octal:       function (obj) { return obj >= 0 ? '0o'  + obj.toString(8) : '-0o'  + obj.toString(8).slice(1); },
    decimal:     function (obj) { return obj.toString(10); },
    /* eslint-disable max-len */
    hexadecimal: function (obj) { return obj >= 0 ? '0x' + obj.toString(16).toUpperCase() :  '-0x' + obj.toString(16).toUpperCase().slice(1); }
  },
  defaultStyle: 'decimal',
  styleAliases: {
    binary:      [ 2,  'bin' ],
    octal:       [ 8,  'oct' ],
    decimal:     [ 10, 'dec' ],
    hexadecimal: [ 16, 'hex' ]
  }
});

var YAML_FLOAT_PATTERN = new RegExp(
  // 2.5e4, 2.5 and integers
  '^(?:[-+]?(?:[0-9][0-9_]*)(?:\\.[0-9_]*)?(?:[eE][-+]?[0-9]+)?' +
  // .2e4, .2
  // special case, seems not from spec
  '|\\.[0-9_]+(?:[eE][-+]?[0-9]+)?' +
  // .inf
  '|[-+]?\\.(?:inf|Inf|INF)' +
  // .nan
  '|\\.(?:nan|NaN|NAN))$');

function resolveYamlFloat(data) {
  if (data === null) return false;

  if (!YAML_FLOAT_PATTERN.test(data) ||
      // Quick hack to not allow integers end with `_`
      // Probably should update regexp & check speed
      data[data.length - 1] === '_') {
    return false;
  }

  return true;
}

function constructYamlFloat(data) {
  var value, sign;

  value  = data.replace(/_/g, '').toLowerCase();
  sign   = value[0] === '-' ? -1 : 1;

  if ('+-'.indexOf(value[0]) >= 0) {
    value = value.slice(1);
  }

  if (value === '.inf') {
    return (sign === 1) ? Number.POSITIVE_INFINITY : Number.NEGATIVE_INFINITY;

  } else if (value === '.nan') {
    return NaN;
  }
  return sign * parseFloat(value, 10);
}


var SCIENTIFIC_WITHOUT_DOT = /^[-+]?[0-9]+e/;

function representYamlFloat(object, style) {
  var res;

  if (isNaN(object)) {
    switch (style) {
      case 'lowercase': return '.nan';
      case 'uppercase': return '.NAN';
      case 'camelcase': return '.NaN';
    }
  } else if (Number.POSITIVE_INFINITY === object) {
    switch (style) {
      case 'lowercase': return '.inf';
      case 'uppercase': return '.INF';
      case 'camelcase': return '.Inf';
    }
  } else if (Number.NEGATIVE_INFINITY === object) {
    switch (style) {
      case 'lowercase': return '-.inf';
      case 'uppercase': return '-.INF';
      case 'camelcase': return '-.Inf';
    }
  } else if (common.isNegativeZero(object)) {
    return '-0.0';
  }

  res = object.toString(10);

  // JS stringifier can build scientific format without dots: 5e-100,
  // while YAML requres dot: 5.e-100. Fix it with simple hack

  return SCIENTIFIC_WITHOUT_DOT.test(res) ? res.replace('e', '.e') : res;
}

function isFloat(object) {
  return (Object.prototype.toString.call(object) === '[object Number]') &&
         (object % 1 !== 0 || common.isNegativeZero(object));
}

var float = new type('tag:yaml.org,2002:float', {
  kind: 'scalar',
  resolve: resolveYamlFloat,
  construct: constructYamlFloat,
  predicate: isFloat,
  represent: representYamlFloat,
  defaultStyle: 'lowercase'
});

var json = failsafe.extend({
  implicit: [
    _null,
    bool,
    int,
    float
  ]
});

var core = json;

var YAML_DATE_REGEXP = new RegExp(
  '^([0-9][0-9][0-9][0-9])'          + // [1] year
  '-([0-9][0-9])'                    + // [2] month
  '-([0-9][0-9])$');                   // [3] day

var YAML_TIMESTAMP_REGEXP = new RegExp(
  '^([0-9][0-9][0-9][0-9])'          + // [1] year
  '-([0-9][0-9]?)'                   + // [2] month
  '-([0-9][0-9]?)'                   + // [3] day
  '(?:[Tt]|[ \\t]+)'                 + // ...
  '([0-9][0-9]?)'                    + // [4] hour
  ':([0-9][0-9])'                    + // [5] minute
  ':([0-9][0-9])'                    + // [6] second
  '(?:\\.([0-9]*))?'                 + // [7] fraction
  '(?:[ \\t]*(Z|([-+])([0-9][0-9]?)' + // [8] tz [9] tz_sign [10] tz_hour
  '(?::([0-9][0-9]))?))?$');           // [11] tz_minute

function resolveYamlTimestamp(data) {
  if (data === null) return false;
  if (YAML_DATE_REGEXP.exec(data) !== null) return true;
  if (YAML_TIMESTAMP_REGEXP.exec(data) !== null) return true;
  return false;
}

function constructYamlTimestamp(data) {
  var match, year, month, day, hour, minute, second, fraction = 0,
      delta = null, tz_hour, tz_minute, date;

  match = YAML_DATE_REGEXP.exec(data);
  if (match === null) match = YAML_TIMESTAMP_REGEXP.exec(data);

  if (match === null) throw new Error('Date resolve error');

  // match: [1] year [2] month [3] day

  year = +(match[1]);
  month = +(match[2]) - 1; // JS month starts with 0
  day = +(match[3]);

  if (!match[4]) { // no hour
    return new Date(Date.UTC(year, month, day));
  }

  // match: [4] hour [5] minute [6] second [7] fraction

  hour = +(match[4]);
  minute = +(match[5]);
  second = +(match[6]);

  if (match[7]) {
    fraction = match[7].slice(0, 3);
    while (fraction.length < 3) { // milli-seconds
      fraction += '0';
    }
    fraction = +fraction;
  }

  // match: [8] tz [9] tz_sign [10] tz_hour [11] tz_minute

  if (match[9]) {
    tz_hour = +(match[10]);
    tz_minute = +(match[11] || 0);
    delta = (tz_hour * 60 + tz_minute) * 60000; // delta in mili-seconds
    if (match[9] === '-') delta = -delta;
  }

  date = new Date(Date.UTC(year, month, day, hour, minute, second, fraction));

  if (delta) date.setTime(date.getTime() - delta);

  return date;
}

function representYamlTimestamp(object /*, style*/) {
  return object.toISOString();
}

var timestamp = new type('tag:yaml.org,2002:timestamp', {
  kind: 'scalar',
  resolve: resolveYamlTimestamp,
  construct: constructYamlTimestamp,
  instanceOf: Date,
  represent: representYamlTimestamp
});

function resolveYamlMerge(data) {
  return data === '<<' || data === null;
}

var merge = new type('tag:yaml.org,2002:merge', {
  kind: 'scalar',
  resolve: resolveYamlMerge
});

/*eslint-disable no-bitwise*/





// [ 64, 65, 66 ] -> [ padding, CR, LF ]
var BASE64_MAP = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=\n\r';


function resolveYamlBinary(data) {
  if (data === null) return false;

  var code, idx, bitlen = 0, max = data.length, map = BASE64_MAP;

  // Convert one by one.
  for (idx = 0; idx < max; idx++) {
    code = map.indexOf(data.charAt(idx));

    // Skip CR/LF
    if (code > 64) continue;

    // Fail on illegal characters
    if (code < 0) return false;

    bitlen += 6;
  }

  // If there are any bits left, source was corrupted
  return (bitlen % 8) === 0;
}

function constructYamlBinary(data) {
  var idx, tailbits,
      input = data.replace(/[\r\n=]/g, ''), // remove CR/LF & padding to simplify scan
      max = input.length,
      map = BASE64_MAP,
      bits = 0,
      result = [];

  // Collect by 6*4 bits (3 bytes)

  for (idx = 0; idx < max; idx++) {
    if ((idx % 4 === 0) && idx) {
      result.push((bits >> 16) & 0xFF);
      result.push((bits >> 8) & 0xFF);
      result.push(bits & 0xFF);
    }

    bits = (bits << 6) | map.indexOf(input.charAt(idx));
  }

  // Dump tail

  tailbits = (max % 4) * 6;

  if (tailbits === 0) {
    result.push((bits >> 16) & 0xFF);
    result.push((bits >> 8) & 0xFF);
    result.push(bits & 0xFF);
  } else if (tailbits === 18) {
    result.push((bits >> 10) & 0xFF);
    result.push((bits >> 2) & 0xFF);
  } else if (tailbits === 12) {
    result.push((bits >> 4) & 0xFF);
  }

  return new Uint8Array(result);
}

function representYamlBinary(object /*, style*/) {
  var result = '', bits = 0, idx, tail,
      max = object.length,
      map = BASE64_MAP;

  // Convert every three bytes to 4 ASCII characters.

  for (idx = 0; idx < max; idx++) {
    if ((idx % 3 === 0) && idx) {
      result += map[(bits >> 18) & 0x3F];
      result += map[(bits >> 12) & 0x3F];
      result += map[(bits >> 6) & 0x3F];
      result += map[bits & 0x3F];
    }

    bits = (bits << 8) + object[idx];
  }

  // Dump tail

  tail = max % 3;

  if (tail === 0) {
    result += map[(bits >> 18) & 0x3F];
    result += map[(bits >> 12) & 0x3F];
    result += map[(bits >> 6) & 0x3F];
    result += map[bits & 0x3F];
  } else if (tail === 2) {
    result += map[(bits >> 10) & 0x3F];
    result += map[(bits >> 4) & 0x3F];
    result += map[(bits << 2) & 0x3F];
    result += map[64];
  } else if (tail === 1) {
    result += map[(bits >> 2) & 0x3F];
    result += map[(bits << 4) & 0x3F];
    result += map[64];
    result += map[64];
  }

  return result;
}

function isBinary(obj) {
  return Object.prototype.toString.call(obj) ===  '[object Uint8Array]';
}

var binary = new type('tag:yaml.org,2002:binary', {
  kind: 'scalar',
  resolve: resolveYamlBinary,
  construct: constructYamlBinary,
  predicate: isBinary,
  represent: representYamlBinary
});

var _hasOwnProperty$3 = Object.prototype.hasOwnProperty;
var _toString$2       = Object.prototype.toString;

function resolveYamlOmap(data) {
  if (data === null) return true;

  var objectKeys = [], index, length, pair, pairKey, pairHasKey,
      object = data;

  for (index = 0, length = object.length; index < length; index += 1) {
    pair = object[index];
    pairHasKey = false;

    if (_toString$2.call(pair) !== '[object Object]') return false;

    for (pairKey in pair) {
      if (_hasOwnProperty$3.call(pair, pairKey)) {
        if (!pairHasKey) pairHasKey = true;
        else return false;
      }
    }

    if (!pairHasKey) return false;

    if (objectKeys.indexOf(pairKey) === -1) objectKeys.push(pairKey);
    else return false;
  }

  return true;
}

function constructYamlOmap(data) {
  return data !== null ? data : [];
}

var omap = new type('tag:yaml.org,2002:omap', {
  kind: 'sequence',
  resolve: resolveYamlOmap,
  construct: constructYamlOmap
});

var _toString$1 = Object.prototype.toString;

function resolveYamlPairs(data) {
  if (data === null) return true;

  var index, length, pair, keys, result,
      object = data;

  result = new Array(object.length);

  for (index = 0, length = object.length; index < length; index += 1) {
    pair = object[index];

    if (_toString$1.call(pair) !== '[object Object]') return false;

    keys = Object.keys(pair);

    if (keys.length !== 1) return false;

    result[index] = [ keys[0], pair[keys[0]] ];
  }

  return true;
}

function constructYamlPairs(data) {
  if (data === null) return [];

  var index, length, pair, keys, result,
      object = data;

  result = new Array(object.length);

  for (index = 0, length = object.length; index < length; index += 1) {
    pair = object[index];

    keys = Object.keys(pair);

    result[index] = [ keys[0], pair[keys[0]] ];
  }

  return result;
}

var pairs = new type('tag:yaml.org,2002:pairs', {
  kind: 'sequence',
  resolve: resolveYamlPairs,
  construct: constructYamlPairs
});

var _hasOwnProperty$2 = Object.prototype.hasOwnProperty;

function resolveYamlSet(data) {
  if (data === null) return true;

  var key, object = data;

  for (key in object) {
    if (_hasOwnProperty$2.call(object, key)) {
      if (object[key] !== null) return false;
    }
  }

  return true;
}

function constructYamlSet(data) {
  return data !== null ? data : {};
}

var set = new type('tag:yaml.org,2002:set', {
  kind: 'mapping',
  resolve: resolveYamlSet,
  construct: constructYamlSet
});

var _default = core.extend({
  implicit: [
    timestamp,
    merge
  ],
  explicit: [
    binary,
    omap,
    pairs,
    set
  ]
});

/*eslint-disable max-len,no-use-before-define*/







var _hasOwnProperty$1 = Object.prototype.hasOwnProperty;


var CONTEXT_FLOW_IN   = 1;
var CONTEXT_FLOW_OUT  = 2;
var CONTEXT_BLOCK_IN  = 3;
var CONTEXT_BLOCK_OUT = 4;


var CHOMPING_CLIP  = 1;
var CHOMPING_STRIP = 2;
var CHOMPING_KEEP  = 3;


var PATTERN_NON_PRINTABLE         = /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x84\x86-\x9F\uFFFE\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;
var PATTERN_NON_ASCII_LINE_BREAKS = /[\x85\u2028\u2029]/;
var PATTERN_FLOW_INDICATORS       = /[,\[\]\{\}]/;
var PATTERN_TAG_HANDLE            = /^(?:!|!!|![a-z\-]+!)$/i;
var PATTERN_TAG_URI               = /^(?:!|[^,\[\]\{\}])(?:%[0-9a-f]{2}|[0-9a-z\-#;\/\?:@&=\+\$,_\.!~\*'\(\)\[\]])*$/i;


function _class(obj) { return Object.prototype.toString.call(obj); }

function is_EOL(c) {
  return (c === 0x0A/* LF */) || (c === 0x0D/* CR */);
}

function is_WHITE_SPACE(c) {
  return (c === 0x09/* Tab */) || (c === 0x20/* Space */);
}

function is_WS_OR_EOL(c) {
  return (c === 0x09/* Tab */) ||
         (c === 0x20/* Space */) ||
         (c === 0x0A/* LF */) ||
         (c === 0x0D/* CR */);
}

function is_FLOW_INDICATOR(c) {
  return c === 0x2C/* , */ ||
         c === 0x5B/* [ */ ||
         c === 0x5D/* ] */ ||
         c === 0x7B/* { */ ||
         c === 0x7D/* } */;
}

function fromHexCode(c) {
  var lc;

  if ((0x30/* 0 */ <= c) && (c <= 0x39/* 9 */)) {
    return c - 0x30;
  }

  /*eslint-disable no-bitwise*/
  lc = c | 0x20;

  if ((0x61/* a */ <= lc) && (lc <= 0x66/* f */)) {
    return lc - 0x61 + 10;
  }

  return -1;
}

function escapedHexLen(c) {
  if (c === 0x78/* x */) { return 2; }
  if (c === 0x75/* u */) { return 4; }
  if (c === 0x55/* U */) { return 8; }
  return 0;
}

function fromDecimalCode(c) {
  if ((0x30/* 0 */ <= c) && (c <= 0x39/* 9 */)) {
    return c - 0x30;
  }

  return -1;
}

function simpleEscapeSequence(c) {
  /* eslint-disable indent */
  return (c === 0x30/* 0 */) ? '\x00' :
        (c === 0x61/* a */) ? '\x07' :
        (c === 0x62/* b */) ? '\x08' :
        (c === 0x74/* t */) ? '\x09' :
        (c === 0x09/* Tab */) ? '\x09' :
        (c === 0x6E/* n */) ? '\x0A' :
        (c === 0x76/* v */) ? '\x0B' :
        (c === 0x66/* f */) ? '\x0C' :
        (c === 0x72/* r */) ? '\x0D' :
        (c === 0x65/* e */) ? '\x1B' :
        (c === 0x20/* Space */) ? ' ' :
        (c === 0x22/* " */) ? '\x22' :
        (c === 0x2F/* / */) ? '/' :
        (c === 0x5C/* \ */) ? '\x5C' :
        (c === 0x4E/* N */) ? '\x85' :
        (c === 0x5F/* _ */) ? '\xA0' :
        (c === 0x4C/* L */) ? '\u2028' :
        (c === 0x50/* P */) ? '\u2029' : '';
}

function charFromCodepoint(c) {
  if (c <= 0xFFFF) {
    return String.fromCharCode(c);
  }
  // Encode UTF-16 surrogate pair
  // https://en.wikipedia.org/wiki/UTF-16#Code_points_U.2B010000_to_U.2B10FFFF
  return String.fromCharCode(
    ((c - 0x010000) >> 10) + 0xD800,
    ((c - 0x010000) & 0x03FF) + 0xDC00
  );
}

var simpleEscapeCheck = new Array(256); // integer, for fast access
var simpleEscapeMap = new Array(256);
for (var i = 0; i < 256; i++) {
  simpleEscapeCheck[i] = simpleEscapeSequence(i) ? 1 : 0;
  simpleEscapeMap[i] = simpleEscapeSequence(i);
}


function State$1(input, options) {
  this.input = input;

  this.filename  = options['filename']  || null;
  this.schema    = options['schema']    || _default;
  this.onWarning = options['onWarning'] || null;
  // (Hidden) Remove? makes the loader to expect YAML 1.1 documents
  // if such documents have no explicit %YAML directive
  this.legacy    = options['legacy']    || false;

  this.json      = options['json']      || false;
  this.listener  = options['listener']  || null;

  this.implicitTypes = this.schema.compiledImplicit;
  this.typeMap       = this.schema.compiledTypeMap;

  this.length     = input.length;
  this.position   = 0;
  this.line       = 0;
  this.lineStart  = 0;
  this.lineIndent = 0;

  // position of first leading tab in the current line,
  // used to make sure there are no tabs in the indentation
  this.firstTabInLine = -1;

  this.documents = [];

  /*
  this.version;
  this.checkLineBreaks;
  this.tagMap;
  this.anchorMap;
  this.tag;
  this.anchor;
  this.kind;
  this.result;*/

}


function generateError(state, message) {
  var mark = {
    name:     state.filename,
    buffer:   state.input.slice(0, -1), // omit trailing \0
    position: state.position,
    line:     state.line,
    column:   state.position - state.lineStart
  };

  mark.snippet = snippet(mark);

  return new exception(message, mark);
}

function throwError(state, message) {
  throw generateError(state, message);
}

function throwWarning(state, message) {
  if (state.onWarning) {
    state.onWarning.call(null, generateError(state, message));
  }
}


var directiveHandlers = {

  YAML: function handleYamlDirective(state, name, args) {

    var match, major, minor;

    if (state.version !== null) {
      throwError(state, 'duplication of %YAML directive');
    }

    if (args.length !== 1) {
      throwError(state, 'YAML directive accepts exactly one argument');
    }

    match = /^([0-9]+)\.([0-9]+)$/.exec(args[0]);

    if (match === null) {
      throwError(state, 'ill-formed argument of the YAML directive');
    }

    major = parseInt(match[1], 10);
    minor = parseInt(match[2], 10);

    if (major !== 1) {
      throwError(state, 'unacceptable YAML version of the document');
    }

    state.version = args[0];
    state.checkLineBreaks = (minor < 2);

    if (minor !== 1 && minor !== 2) {
      throwWarning(state, 'unsupported YAML version of the document');
    }
  },

  TAG: function handleTagDirective(state, name, args) {

    var handle, prefix;

    if (args.length !== 2) {
      throwError(state, 'TAG directive accepts exactly two arguments');
    }

    handle = args[0];
    prefix = args[1];

    if (!PATTERN_TAG_HANDLE.test(handle)) {
      throwError(state, 'ill-formed tag handle (first argument) of the TAG directive');
    }

    if (_hasOwnProperty$1.call(state.tagMap, handle)) {
      throwError(state, 'there is a previously declared suffix for "' + handle + '" tag handle');
    }

    if (!PATTERN_TAG_URI.test(prefix)) {
      throwError(state, 'ill-formed tag prefix (second argument) of the TAG directive');
    }

    try {
      prefix = decodeURIComponent(prefix);
    } catch (err) {
      throwError(state, 'tag prefix is malformed: ' + prefix);
    }

    state.tagMap[handle] = prefix;
  }
};


function captureSegment(state, start, end, checkJson) {
  var _position, _length, _character, _result;

  if (start < end) {
    _result = state.input.slice(start, end);

    if (checkJson) {
      for (_position = 0, _length = _result.length; _position < _length; _position += 1) {
        _character = _result.charCodeAt(_position);
        if (!(_character === 0x09 ||
              (0x20 <= _character && _character <= 0x10FFFF))) {
          throwError(state, 'expected valid JSON character');
        }
      }
    } else if (PATTERN_NON_PRINTABLE.test(_result)) {
      throwError(state, 'the stream contains non-printable characters');
    }

    state.result += _result;
  }
}

function mergeMappings(state, destination, source, overridableKeys) {
  var sourceKeys, key, index, quantity;

  if (!common.isObject(source)) {
    throwError(state, 'cannot merge mappings; the provided source object is unacceptable');
  }

  sourceKeys = Object.keys(source);

  for (index = 0, quantity = sourceKeys.length; index < quantity; index += 1) {
    key = sourceKeys[index];

    if (!_hasOwnProperty$1.call(destination, key)) {
      destination[key] = source[key];
      overridableKeys[key] = true;
    }
  }
}

function storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode,
  startLine, startLineStart, startPos) {

  var index, quantity;

  // The output is a plain object here, so keys can only be strings.
  // We need to convert keyNode to a string, but doing so can hang the process
  // (deeply nested arrays that explode exponentially using aliases).
  if (Array.isArray(keyNode)) {
    keyNode = Array.prototype.slice.call(keyNode);

    for (index = 0, quantity = keyNode.length; index < quantity; index += 1) {
      if (Array.isArray(keyNode[index])) {
        throwError(state, 'nested arrays are not supported inside keys');
      }

      if (typeof keyNode === 'object' && _class(keyNode[index]) === '[object Object]') {
        keyNode[index] = '[object Object]';
      }
    }
  }

  // Avoid code execution in load() via toString property
  // (still use its own toString for arrays, timestamps,
  // and whatever user schema extensions happen to have @@toStringTag)
  if (typeof keyNode === 'object' && _class(keyNode) === '[object Object]') {
    keyNode = '[object Object]';
  }


  keyNode = String(keyNode);

  if (_result === null) {
    _result = {};
  }

  if (keyTag === 'tag:yaml.org,2002:merge') {
    if (Array.isArray(valueNode)) {
      for (index = 0, quantity = valueNode.length; index < quantity; index += 1) {
        mergeMappings(state, _result, valueNode[index], overridableKeys);
      }
    } else {
      mergeMappings(state, _result, valueNode, overridableKeys);
    }
  } else {
    if (!state.json &&
        !_hasOwnProperty$1.call(overridableKeys, keyNode) &&
        _hasOwnProperty$1.call(_result, keyNode)) {
      state.line = startLine || state.line;
      state.lineStart = startLineStart || state.lineStart;
      state.position = startPos || state.position;
      throwError(state, 'duplicated mapping key');
    }

    // used for this specific key only because Object.defineProperty is slow
    if (keyNode === '__proto__') {
      Object.defineProperty(_result, keyNode, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: valueNode
      });
    } else {
      _result[keyNode] = valueNode;
    }
    delete overridableKeys[keyNode];
  }

  return _result;
}

function readLineBreak(state) {
  var ch;

  ch = state.input.charCodeAt(state.position);

  if (ch === 0x0A/* LF */) {
    state.position++;
  } else if (ch === 0x0D/* CR */) {
    state.position++;
    if (state.input.charCodeAt(state.position) === 0x0A/* LF */) {
      state.position++;
    }
  } else {
    throwError(state, 'a line break is expected');
  }

  state.line += 1;
  state.lineStart = state.position;
  state.firstTabInLine = -1;
}

function skipSeparationSpace(state, allowComments, checkIndent) {
  var lineBreaks = 0,
      ch = state.input.charCodeAt(state.position);

  while (ch !== 0) {
    while (is_WHITE_SPACE(ch)) {
      if (ch === 0x09/* Tab */ && state.firstTabInLine === -1) {
        state.firstTabInLine = state.position;
      }
      ch = state.input.charCodeAt(++state.position);
    }

    if (allowComments && ch === 0x23/* # */) {
      do {
        ch = state.input.charCodeAt(++state.position);
      } while (ch !== 0x0A/* LF */ && ch !== 0x0D/* CR */ && ch !== 0);
    }

    if (is_EOL(ch)) {
      readLineBreak(state);

      ch = state.input.charCodeAt(state.position);
      lineBreaks++;
      state.lineIndent = 0;

      while (ch === 0x20/* Space */) {
        state.lineIndent++;
        ch = state.input.charCodeAt(++state.position);
      }
    } else {
      break;
    }
  }

  if (checkIndent !== -1 && lineBreaks !== 0 && state.lineIndent < checkIndent) {
    throwWarning(state, 'deficient indentation');
  }

  return lineBreaks;
}

function testDocumentSeparator(state) {
  var _position = state.position,
      ch;

  ch = state.input.charCodeAt(_position);

  // Condition state.position === state.lineStart is tested
  // in parent on each call, for efficiency. No needs to test here again.
  if ((ch === 0x2D/* - */ || ch === 0x2E/* . */) &&
      ch === state.input.charCodeAt(_position + 1) &&
      ch === state.input.charCodeAt(_position + 2)) {

    _position += 3;

    ch = state.input.charCodeAt(_position);

    if (ch === 0 || is_WS_OR_EOL(ch)) {
      return true;
    }
  }

  return false;
}

function writeFoldedLines(state, count) {
  if (count === 1) {
    state.result += ' ';
  } else if (count > 1) {
    state.result += common.repeat('\n', count - 1);
  }
}


function readPlainScalar(state, nodeIndent, withinFlowCollection) {
  var preceding,
      following,
      captureStart,
      captureEnd,
      hasPendingContent,
      _line,
      _lineStart,
      _lineIndent,
      _kind = state.kind,
      _result = state.result,
      ch;

  ch = state.input.charCodeAt(state.position);

  if (is_WS_OR_EOL(ch)      ||
      is_FLOW_INDICATOR(ch) ||
      ch === 0x23/* # */    ||
      ch === 0x26/* & */    ||
      ch === 0x2A/* * */    ||
      ch === 0x21/* ! */    ||
      ch === 0x7C/* | */    ||
      ch === 0x3E/* > */    ||
      ch === 0x27/* ' */    ||
      ch === 0x22/* " */    ||
      ch === 0x25/* % */    ||
      ch === 0x40/* @ */    ||
      ch === 0x60/* ` */) {
    return false;
  }

  if (ch === 0x3F/* ? */ || ch === 0x2D/* - */) {
    following = state.input.charCodeAt(state.position + 1);

    if (is_WS_OR_EOL(following) ||
        withinFlowCollection && is_FLOW_INDICATOR(following)) {
      return false;
    }
  }

  state.kind = 'scalar';
  state.result = '';
  captureStart = captureEnd = state.position;
  hasPendingContent = false;

  while (ch !== 0) {
    if (ch === 0x3A/* : */) {
      following = state.input.charCodeAt(state.position + 1);

      if (is_WS_OR_EOL(following) ||
          withinFlowCollection && is_FLOW_INDICATOR(following)) {
        break;
      }

    } else if (ch === 0x23/* # */) {
      preceding = state.input.charCodeAt(state.position - 1);

      if (is_WS_OR_EOL(preceding)) {
        break;
      }

    } else if ((state.position === state.lineStart && testDocumentSeparator(state)) ||
               withinFlowCollection && is_FLOW_INDICATOR(ch)) {
      break;

    } else if (is_EOL(ch)) {
      _line = state.line;
      _lineStart = state.lineStart;
      _lineIndent = state.lineIndent;
      skipSeparationSpace(state, false, -1);

      if (state.lineIndent >= nodeIndent) {
        hasPendingContent = true;
        ch = state.input.charCodeAt(state.position);
        continue;
      } else {
        state.position = captureEnd;
        state.line = _line;
        state.lineStart = _lineStart;
        state.lineIndent = _lineIndent;
        break;
      }
    }

    if (hasPendingContent) {
      captureSegment(state, captureStart, captureEnd, false);
      writeFoldedLines(state, state.line - _line);
      captureStart = captureEnd = state.position;
      hasPendingContent = false;
    }

    if (!is_WHITE_SPACE(ch)) {
      captureEnd = state.position + 1;
    }

    ch = state.input.charCodeAt(++state.position);
  }

  captureSegment(state, captureStart, captureEnd, false);

  if (state.result) {
    return true;
  }

  state.kind = _kind;
  state.result = _result;
  return false;
}

function readSingleQuotedScalar(state, nodeIndent) {
  var ch,
      captureStart, captureEnd;

  ch = state.input.charCodeAt(state.position);

  if (ch !== 0x27/* ' */) {
    return false;
  }

  state.kind = 'scalar';
  state.result = '';
  state.position++;
  captureStart = captureEnd = state.position;

  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
    if (ch === 0x27/* ' */) {
      captureSegment(state, captureStart, state.position, true);
      ch = state.input.charCodeAt(++state.position);

      if (ch === 0x27/* ' */) {
        captureStart = state.position;
        state.position++;
        captureEnd = state.position;
      } else {
        return true;
      }

    } else if (is_EOL(ch)) {
      captureSegment(state, captureStart, captureEnd, true);
      writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
      captureStart = captureEnd = state.position;

    } else if (state.position === state.lineStart && testDocumentSeparator(state)) {
      throwError(state, 'unexpected end of the document within a single quoted scalar');

    } else {
      state.position++;
      captureEnd = state.position;
    }
  }

  throwError(state, 'unexpected end of the stream within a single quoted scalar');
}

function readDoubleQuotedScalar(state, nodeIndent) {
  var captureStart,
      captureEnd,
      hexLength,
      hexResult,
      tmp,
      ch;

  ch = state.input.charCodeAt(state.position);

  if (ch !== 0x22/* " */) {
    return false;
  }

  state.kind = 'scalar';
  state.result = '';
  state.position++;
  captureStart = captureEnd = state.position;

  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
    if (ch === 0x22/* " */) {
      captureSegment(state, captureStart, state.position, true);
      state.position++;
      return true;

    } else if (ch === 0x5C/* \ */) {
      captureSegment(state, captureStart, state.position, true);
      ch = state.input.charCodeAt(++state.position);

      if (is_EOL(ch)) {
        skipSeparationSpace(state, false, nodeIndent);

        // TODO: rework to inline fn with no type cast?
      } else if (ch < 256 && simpleEscapeCheck[ch]) {
        state.result += simpleEscapeMap[ch];
        state.position++;

      } else if ((tmp = escapedHexLen(ch)) > 0) {
        hexLength = tmp;
        hexResult = 0;

        for (; hexLength > 0; hexLength--) {
          ch = state.input.charCodeAt(++state.position);

          if ((tmp = fromHexCode(ch)) >= 0) {
            hexResult = (hexResult << 4) + tmp;

          } else {
            throwError(state, 'expected hexadecimal character');
          }
        }

        state.result += charFromCodepoint(hexResult);

        state.position++;

      } else {
        throwError(state, 'unknown escape sequence');
      }

      captureStart = captureEnd = state.position;

    } else if (is_EOL(ch)) {
      captureSegment(state, captureStart, captureEnd, true);
      writeFoldedLines(state, skipSeparationSpace(state, false, nodeIndent));
      captureStart = captureEnd = state.position;

    } else if (state.position === state.lineStart && testDocumentSeparator(state)) {
      throwError(state, 'unexpected end of the document within a double quoted scalar');

    } else {
      state.position++;
      captureEnd = state.position;
    }
  }

  throwError(state, 'unexpected end of the stream within a double quoted scalar');
}

function readFlowCollection(state, nodeIndent) {
  var readNext = true,
      _line,
      _lineStart,
      _pos,
      _tag     = state.tag,
      _result,
      _anchor  = state.anchor,
      following,
      terminator,
      isPair,
      isExplicitPair,
      isMapping,
      overridableKeys = Object.create(null),
      keyNode,
      keyTag,
      valueNode,
      ch;

  ch = state.input.charCodeAt(state.position);

  if (ch === 0x5B/* [ */) {
    terminator = 0x5D;/* ] */
    isMapping = false;
    _result = [];
  } else if (ch === 0x7B/* { */) {
    terminator = 0x7D;/* } */
    isMapping = true;
    _result = {};
  } else {
    return false;
  }

  if (state.anchor !== null) {
    state.anchorMap[state.anchor] = _result;
  }

  ch = state.input.charCodeAt(++state.position);

  while (ch !== 0) {
    skipSeparationSpace(state, true, nodeIndent);

    ch = state.input.charCodeAt(state.position);

    if (ch === terminator) {
      state.position++;
      state.tag = _tag;
      state.anchor = _anchor;
      state.kind = isMapping ? 'mapping' : 'sequence';
      state.result = _result;
      return true;
    } else if (!readNext) {
      throwError(state, 'missed comma between flow collection entries');
    } else if (ch === 0x2C/* , */) {
      // "flow collection entries can never be completely empty", as per YAML 1.2, section 7.4
      throwError(state, "expected the node content, but found ','");
    }

    keyTag = keyNode = valueNode = null;
    isPair = isExplicitPair = false;

    if (ch === 0x3F/* ? */) {
      following = state.input.charCodeAt(state.position + 1);

      if (is_WS_OR_EOL(following)) {
        isPair = isExplicitPair = true;
        state.position++;
        skipSeparationSpace(state, true, nodeIndent);
      }
    }

    _line = state.line; // Save the current line.
    _lineStart = state.lineStart;
    _pos = state.position;
    composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
    keyTag = state.tag;
    keyNode = state.result;
    skipSeparationSpace(state, true, nodeIndent);

    ch = state.input.charCodeAt(state.position);

    if ((isExplicitPair || state.line === _line) && ch === 0x3A/* : */) {
      isPair = true;
      ch = state.input.charCodeAt(++state.position);
      skipSeparationSpace(state, true, nodeIndent);
      composeNode(state, nodeIndent, CONTEXT_FLOW_IN, false, true);
      valueNode = state.result;
    }

    if (isMapping) {
      storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos);
    } else if (isPair) {
      _result.push(storeMappingPair(state, null, overridableKeys, keyTag, keyNode, valueNode, _line, _lineStart, _pos));
    } else {
      _result.push(keyNode);
    }

    skipSeparationSpace(state, true, nodeIndent);

    ch = state.input.charCodeAt(state.position);

    if (ch === 0x2C/* , */) {
      readNext = true;
      ch = state.input.charCodeAt(++state.position);
    } else {
      readNext = false;
    }
  }

  throwError(state, 'unexpected end of the stream within a flow collection');
}

function readBlockScalar(state, nodeIndent) {
  var captureStart,
      folding,
      chomping       = CHOMPING_CLIP,
      didReadContent = false,
      detectedIndent = false,
      textIndent     = nodeIndent,
      emptyLines     = 0,
      atMoreIndented = false,
      tmp,
      ch;

  ch = state.input.charCodeAt(state.position);

  if (ch === 0x7C/* | */) {
    folding = false;
  } else if (ch === 0x3E/* > */) {
    folding = true;
  } else {
    return false;
  }

  state.kind = 'scalar';
  state.result = '';

  while (ch !== 0) {
    ch = state.input.charCodeAt(++state.position);

    if (ch === 0x2B/* + */ || ch === 0x2D/* - */) {
      if (CHOMPING_CLIP === chomping) {
        chomping = (ch === 0x2B/* + */) ? CHOMPING_KEEP : CHOMPING_STRIP;
      } else {
        throwError(state, 'repeat of a chomping mode identifier');
      }

    } else if ((tmp = fromDecimalCode(ch)) >= 0) {
      if (tmp === 0) {
        throwError(state, 'bad explicit indentation width of a block scalar; it cannot be less than one');
      } else if (!detectedIndent) {
        textIndent = nodeIndent + tmp - 1;
        detectedIndent = true;
      } else {
        throwError(state, 'repeat of an indentation width identifier');
      }

    } else {
      break;
    }
  }

  if (is_WHITE_SPACE(ch)) {
    do { ch = state.input.charCodeAt(++state.position); }
    while (is_WHITE_SPACE(ch));

    if (ch === 0x23/* # */) {
      do { ch = state.input.charCodeAt(++state.position); }
      while (!is_EOL(ch) && (ch !== 0));
    }
  }

  while (ch !== 0) {
    readLineBreak(state);
    state.lineIndent = 0;

    ch = state.input.charCodeAt(state.position);

    while ((!detectedIndent || state.lineIndent < textIndent) &&
           (ch === 0x20/* Space */)) {
      state.lineIndent++;
      ch = state.input.charCodeAt(++state.position);
    }

    if (!detectedIndent && state.lineIndent > textIndent) {
      textIndent = state.lineIndent;
    }

    if (is_EOL(ch)) {
      emptyLines++;
      continue;
    }

    // End of the scalar.
    if (state.lineIndent < textIndent) {

      // Perform the chomping.
      if (chomping === CHOMPING_KEEP) {
        state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
      } else if (chomping === CHOMPING_CLIP) {
        if (didReadContent) { // i.e. only if the scalar is not empty.
          state.result += '\n';
        }
      }

      // Break this `while` cycle and go to the funciton's epilogue.
      break;
    }

    // Folded style: use fancy rules to handle line breaks.
    if (folding) {

      // Lines starting with white space characters (more-indented lines) are not folded.
      if (is_WHITE_SPACE(ch)) {
        atMoreIndented = true;
        // except for the first content line (cf. Example 8.1)
        state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);

      // End of more-indented block.
      } else if (atMoreIndented) {
        atMoreIndented = false;
        state.result += common.repeat('\n', emptyLines + 1);

      // Just one line break - perceive as the same line.
      } else if (emptyLines === 0) {
        if (didReadContent) { // i.e. only if we have already read some scalar content.
          state.result += ' ';
        }

      // Several line breaks - perceive as different lines.
      } else {
        state.result += common.repeat('\n', emptyLines);
      }

    // Literal style: just add exact number of line breaks between content lines.
    } else {
      // Keep all line breaks except the header line break.
      state.result += common.repeat('\n', didReadContent ? 1 + emptyLines : emptyLines);
    }

    didReadContent = true;
    detectedIndent = true;
    emptyLines = 0;
    captureStart = state.position;

    while (!is_EOL(ch) && (ch !== 0)) {
      ch = state.input.charCodeAt(++state.position);
    }

    captureSegment(state, captureStart, state.position, false);
  }

  return true;
}

function readBlockSequence(state, nodeIndent) {
  var _line,
      _tag      = state.tag,
      _anchor   = state.anchor,
      _result   = [],
      following,
      detected  = false,
      ch;

  // there is a leading tab before this token, so it can't be a block sequence/mapping;
  // it can still be flow sequence/mapping or a scalar
  if (state.firstTabInLine !== -1) return false;

  if (state.anchor !== null) {
    state.anchorMap[state.anchor] = _result;
  }

  ch = state.input.charCodeAt(state.position);

  while (ch !== 0) {
    if (state.firstTabInLine !== -1) {
      state.position = state.firstTabInLine;
      throwError(state, 'tab characters must not be used in indentation');
    }

    if (ch !== 0x2D/* - */) {
      break;
    }

    following = state.input.charCodeAt(state.position + 1);

    if (!is_WS_OR_EOL(following)) {
      break;
    }

    detected = true;
    state.position++;

    if (skipSeparationSpace(state, true, -1)) {
      if (state.lineIndent <= nodeIndent) {
        _result.push(null);
        ch = state.input.charCodeAt(state.position);
        continue;
      }
    }

    _line = state.line;
    composeNode(state, nodeIndent, CONTEXT_BLOCK_IN, false, true);
    _result.push(state.result);
    skipSeparationSpace(state, true, -1);

    ch = state.input.charCodeAt(state.position);

    if ((state.line === _line || state.lineIndent > nodeIndent) && (ch !== 0)) {
      throwError(state, 'bad indentation of a sequence entry');
    } else if (state.lineIndent < nodeIndent) {
      break;
    }
  }

  if (detected) {
    state.tag = _tag;
    state.anchor = _anchor;
    state.kind = 'sequence';
    state.result = _result;
    return true;
  }
  return false;
}

function readBlockMapping(state, nodeIndent, flowIndent) {
  var following,
      allowCompact,
      _line,
      _keyLine,
      _keyLineStart,
      _keyPos,
      _tag          = state.tag,
      _anchor       = state.anchor,
      _result       = {},
      overridableKeys = Object.create(null),
      keyTag        = null,
      keyNode       = null,
      valueNode     = null,
      atExplicitKey = false,
      detected      = false,
      ch;

  // there is a leading tab before this token, so it can't be a block sequence/mapping;
  // it can still be flow sequence/mapping or a scalar
  if (state.firstTabInLine !== -1) return false;

  if (state.anchor !== null) {
    state.anchorMap[state.anchor] = _result;
  }

  ch = state.input.charCodeAt(state.position);

  while (ch !== 0) {
    if (!atExplicitKey && state.firstTabInLine !== -1) {
      state.position = state.firstTabInLine;
      throwError(state, 'tab characters must not be used in indentation');
    }

    following = state.input.charCodeAt(state.position + 1);
    _line = state.line; // Save the current line.

    //
    // Explicit notation case. There are two separate blocks:
    // first for the key (denoted by "?") and second for the value (denoted by ":")
    //
    if ((ch === 0x3F/* ? */ || ch === 0x3A/* : */) && is_WS_OR_EOL(following)) {

      if (ch === 0x3F/* ? */) {
        if (atExplicitKey) {
          storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
          keyTag = keyNode = valueNode = null;
        }

        detected = true;
        atExplicitKey = true;
        allowCompact = true;

      } else if (atExplicitKey) {
        // i.e. 0x3A/* : */ === character after the explicit key.
        atExplicitKey = false;
        allowCompact = true;

      } else {
        throwError(state, 'incomplete explicit mapping pair; a key node is missed; or followed by a non-tabulated empty line');
      }

      state.position += 1;
      ch = following;

    //
    // Implicit notation case. Flow-style node as the key first, then ":", and the value.
    //
    } else {
      _keyLine = state.line;
      _keyLineStart = state.lineStart;
      _keyPos = state.position;

      if (!composeNode(state, flowIndent, CONTEXT_FLOW_OUT, false, true)) {
        // Neither implicit nor explicit notation.
        // Reading is done. Go to the epilogue.
        break;
      }

      if (state.line === _line) {
        ch = state.input.charCodeAt(state.position);

        while (is_WHITE_SPACE(ch)) {
          ch = state.input.charCodeAt(++state.position);
        }

        if (ch === 0x3A/* : */) {
          ch = state.input.charCodeAt(++state.position);

          if (!is_WS_OR_EOL(ch)) {
            throwError(state, 'a whitespace character is expected after the key-value separator within a block mapping');
          }

          if (atExplicitKey) {
            storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
            keyTag = keyNode = valueNode = null;
          }

          detected = true;
          atExplicitKey = false;
          allowCompact = false;
          keyTag = state.tag;
          keyNode = state.result;

        } else if (detected) {
          throwError(state, 'can not read an implicit mapping pair; a colon is missed');

        } else {
          state.tag = _tag;
          state.anchor = _anchor;
          return true; // Keep the result of `composeNode`.
        }

      } else if (detected) {
        throwError(state, 'can not read a block mapping entry; a multiline key may not be an implicit key');

      } else {
        state.tag = _tag;
        state.anchor = _anchor;
        return true; // Keep the result of `composeNode`.
      }
    }

    //
    // Common reading code for both explicit and implicit notations.
    //
    if (state.line === _line || state.lineIndent > nodeIndent) {
      if (atExplicitKey) {
        _keyLine = state.line;
        _keyLineStart = state.lineStart;
        _keyPos = state.position;
      }

      if (composeNode(state, nodeIndent, CONTEXT_BLOCK_OUT, true, allowCompact)) {
        if (atExplicitKey) {
          keyNode = state.result;
        } else {
          valueNode = state.result;
        }
      }

      if (!atExplicitKey) {
        storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, valueNode, _keyLine, _keyLineStart, _keyPos);
        keyTag = keyNode = valueNode = null;
      }

      skipSeparationSpace(state, true, -1);
      ch = state.input.charCodeAt(state.position);
    }

    if ((state.line === _line || state.lineIndent > nodeIndent) && (ch !== 0)) {
      throwError(state, 'bad indentation of a mapping entry');
    } else if (state.lineIndent < nodeIndent) {
      break;
    }
  }

  //
  // Epilogue.
  //

  // Special case: last mapping's node contains only the key in explicit notation.
  if (atExplicitKey) {
    storeMappingPair(state, _result, overridableKeys, keyTag, keyNode, null, _keyLine, _keyLineStart, _keyPos);
  }

  // Expose the resulting mapping.
  if (detected) {
    state.tag = _tag;
    state.anchor = _anchor;
    state.kind = 'mapping';
    state.result = _result;
  }

  return detected;
}

function readTagProperty(state) {
  var _position,
      isVerbatim = false,
      isNamed    = false,
      tagHandle,
      tagName,
      ch;

  ch = state.input.charCodeAt(state.position);

  if (ch !== 0x21/* ! */) return false;

  if (state.tag !== null) {
    throwError(state, 'duplication of a tag property');
  }

  ch = state.input.charCodeAt(++state.position);

  if (ch === 0x3C/* < */) {
    isVerbatim = true;
    ch = state.input.charCodeAt(++state.position);

  } else if (ch === 0x21/* ! */) {
    isNamed = true;
    tagHandle = '!!';
    ch = state.input.charCodeAt(++state.position);

  } else {
    tagHandle = '!';
  }

  _position = state.position;

  if (isVerbatim) {
    do { ch = state.input.charCodeAt(++state.position); }
    while (ch !== 0 && ch !== 0x3E/* > */);

    if (state.position < state.length) {
      tagName = state.input.slice(_position, state.position);
      ch = state.input.charCodeAt(++state.position);
    } else {
      throwError(state, 'unexpected end of the stream within a verbatim tag');
    }
  } else {
    while (ch !== 0 && !is_WS_OR_EOL(ch)) {

      if (ch === 0x21/* ! */) {
        if (!isNamed) {
          tagHandle = state.input.slice(_position - 1, state.position + 1);

          if (!PATTERN_TAG_HANDLE.test(tagHandle)) {
            throwError(state, 'named tag handle cannot contain such characters');
          }

          isNamed = true;
          _position = state.position + 1;
        } else {
          throwError(state, 'tag suffix cannot contain exclamation marks');
        }
      }

      ch = state.input.charCodeAt(++state.position);
    }

    tagName = state.input.slice(_position, state.position);

    if (PATTERN_FLOW_INDICATORS.test(tagName)) {
      throwError(state, 'tag suffix cannot contain flow indicator characters');
    }
  }

  if (tagName && !PATTERN_TAG_URI.test(tagName)) {
    throwError(state, 'tag name cannot contain such characters: ' + tagName);
  }

  try {
    tagName = decodeURIComponent(tagName);
  } catch (err) {
    throwError(state, 'tag name is malformed: ' + tagName);
  }

  if (isVerbatim) {
    state.tag = tagName;

  } else if (_hasOwnProperty$1.call(state.tagMap, tagHandle)) {
    state.tag = state.tagMap[tagHandle] + tagName;

  } else if (tagHandle === '!') {
    state.tag = '!' + tagName;

  } else if (tagHandle === '!!') {
    state.tag = 'tag:yaml.org,2002:' + tagName;

  } else {
    throwError(state, 'undeclared tag handle "' + tagHandle + '"');
  }

  return true;
}

function readAnchorProperty(state) {
  var _position,
      ch;

  ch = state.input.charCodeAt(state.position);

  if (ch !== 0x26/* & */) return false;

  if (state.anchor !== null) {
    throwError(state, 'duplication of an anchor property');
  }

  ch = state.input.charCodeAt(++state.position);
  _position = state.position;

  while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
    ch = state.input.charCodeAt(++state.position);
  }

  if (state.position === _position) {
    throwError(state, 'name of an anchor node must contain at least one character');
  }

  state.anchor = state.input.slice(_position, state.position);
  return true;
}

function readAlias(state) {
  var _position, alias,
      ch;

  ch = state.input.charCodeAt(state.position);

  if (ch !== 0x2A/* * */) return false;

  ch = state.input.charCodeAt(++state.position);
  _position = state.position;

  while (ch !== 0 && !is_WS_OR_EOL(ch) && !is_FLOW_INDICATOR(ch)) {
    ch = state.input.charCodeAt(++state.position);
  }

  if (state.position === _position) {
    throwError(state, 'name of an alias node must contain at least one character');
  }

  alias = state.input.slice(_position, state.position);

  if (!_hasOwnProperty$1.call(state.anchorMap, alias)) {
    throwError(state, 'unidentified alias "' + alias + '"');
  }

  state.result = state.anchorMap[alias];
  skipSeparationSpace(state, true, -1);
  return true;
}

function composeNode(state, parentIndent, nodeContext, allowToSeek, allowCompact) {
  var allowBlockStyles,
      allowBlockScalars,
      allowBlockCollections,
      indentStatus = 1, // 1: this>parent, 0: this=parent, -1: this<parent
      atNewLine  = false,
      hasContent = false,
      typeIndex,
      typeQuantity,
      typeList,
      type,
      flowIndent,
      blockIndent;

  if (state.listener !== null) {
    state.listener('open', state);
  }

  state.tag    = null;
  state.anchor = null;
  state.kind   = null;
  state.result = null;

  allowBlockStyles = allowBlockScalars = allowBlockCollections =
    CONTEXT_BLOCK_OUT === nodeContext ||
    CONTEXT_BLOCK_IN  === nodeContext;

  if (allowToSeek) {
    if (skipSeparationSpace(state, true, -1)) {
      atNewLine = true;

      if (state.lineIndent > parentIndent) {
        indentStatus = 1;
      } else if (state.lineIndent === parentIndent) {
        indentStatus = 0;
      } else if (state.lineIndent < parentIndent) {
        indentStatus = -1;
      }
    }
  }

  if (indentStatus === 1) {
    while (readTagProperty(state) || readAnchorProperty(state)) {
      if (skipSeparationSpace(state, true, -1)) {
        atNewLine = true;
        allowBlockCollections = allowBlockStyles;

        if (state.lineIndent > parentIndent) {
          indentStatus = 1;
        } else if (state.lineIndent === parentIndent) {
          indentStatus = 0;
        } else if (state.lineIndent < parentIndent) {
          indentStatus = -1;
        }
      } else {
        allowBlockCollections = false;
      }
    }
  }

  if (allowBlockCollections) {
    allowBlockCollections = atNewLine || allowCompact;
  }

  if (indentStatus === 1 || CONTEXT_BLOCK_OUT === nodeContext) {
    if (CONTEXT_FLOW_IN === nodeContext || CONTEXT_FLOW_OUT === nodeContext) {
      flowIndent = parentIndent;
    } else {
      flowIndent = parentIndent + 1;
    }

    blockIndent = state.position - state.lineStart;

    if (indentStatus === 1) {
      if (allowBlockCollections &&
          (readBlockSequence(state, blockIndent) ||
           readBlockMapping(state, blockIndent, flowIndent)) ||
          readFlowCollection(state, flowIndent)) {
        hasContent = true;
      } else {
        if ((allowBlockScalars && readBlockScalar(state, flowIndent)) ||
            readSingleQuotedScalar(state, flowIndent) ||
            readDoubleQuotedScalar(state, flowIndent)) {
          hasContent = true;

        } else if (readAlias(state)) {
          hasContent = true;

          if (state.tag !== null || state.anchor !== null) {
            throwError(state, 'alias node should not have any properties');
          }

        } else if (readPlainScalar(state, flowIndent, CONTEXT_FLOW_IN === nodeContext)) {
          hasContent = true;

          if (state.tag === null) {
            state.tag = '?';
          }
        }

        if (state.anchor !== null) {
          state.anchorMap[state.anchor] = state.result;
        }
      }
    } else if (indentStatus === 0) {
      // Special case: block sequences are allowed to have same indentation level as the parent.
      // http://www.yaml.org/spec/1.2/spec.html#id2799784
      hasContent = allowBlockCollections && readBlockSequence(state, blockIndent);
    }
  }

  if (state.tag === null) {
    if (state.anchor !== null) {
      state.anchorMap[state.anchor] = state.result;
    }

  } else if (state.tag === '?') {
    // Implicit resolving is not allowed for non-scalar types, and '?'
    // non-specific tag is only automatically assigned to plain scalars.
    //
    // We only need to check kind conformity in case user explicitly assigns '?'
    // tag, for example like this: "!<?> [0]"
    //
    if (state.result !== null && state.kind !== 'scalar') {
      throwError(state, 'unacceptable node kind for !<?> tag; it should be "scalar", not "' + state.kind + '"');
    }

    for (typeIndex = 0, typeQuantity = state.implicitTypes.length; typeIndex < typeQuantity; typeIndex += 1) {
      type = state.implicitTypes[typeIndex];

      if (type.resolve(state.result)) { // `state.result` updated in resolver if matched
        state.result = type.construct(state.result);
        state.tag = type.tag;
        if (state.anchor !== null) {
          state.anchorMap[state.anchor] = state.result;
        }
        break;
      }
    }
  } else if (state.tag !== '!') {
    if (_hasOwnProperty$1.call(state.typeMap[state.kind || 'fallback'], state.tag)) {
      type = state.typeMap[state.kind || 'fallback'][state.tag];
    } else {
      // looking for multi type
      type = null;
      typeList = state.typeMap.multi[state.kind || 'fallback'];

      for (typeIndex = 0, typeQuantity = typeList.length; typeIndex < typeQuantity; typeIndex += 1) {
        if (state.tag.slice(0, typeList[typeIndex].tag.length) === typeList[typeIndex].tag) {
          type = typeList[typeIndex];
          break;
        }
      }
    }

    if (!type) {
      throwError(state, 'unknown tag !<' + state.tag + '>');
    }

    if (state.result !== null && type.kind !== state.kind) {
      throwError(state, 'unacceptable node kind for !<' + state.tag + '> tag; it should be "' + type.kind + '", not "' + state.kind + '"');
    }

    if (!type.resolve(state.result, state.tag)) { // `state.result` updated in resolver if matched
      throwError(state, 'cannot resolve a node with !<' + state.tag + '> explicit tag');
    } else {
      state.result = type.construct(state.result, state.tag);
      if (state.anchor !== null) {
        state.anchorMap[state.anchor] = state.result;
      }
    }
  }

  if (state.listener !== null) {
    state.listener('close', state);
  }
  return state.tag !== null ||  state.anchor !== null || hasContent;
}

function readDocument(state) {
  var documentStart = state.position,
      _position,
      directiveName,
      directiveArgs,
      hasDirectives = false,
      ch;

  state.version = null;
  state.checkLineBreaks = state.legacy;
  state.tagMap = Object.create(null);
  state.anchorMap = Object.create(null);

  while ((ch = state.input.charCodeAt(state.position)) !== 0) {
    skipSeparationSpace(state, true, -1);

    ch = state.input.charCodeAt(state.position);

    if (state.lineIndent > 0 || ch !== 0x25/* % */) {
      break;
    }

    hasDirectives = true;
    ch = state.input.charCodeAt(++state.position);
    _position = state.position;

    while (ch !== 0 && !is_WS_OR_EOL(ch)) {
      ch = state.input.charCodeAt(++state.position);
    }

    directiveName = state.input.slice(_position, state.position);
    directiveArgs = [];

    if (directiveName.length < 1) {
      throwError(state, 'directive name must not be less than one character in length');
    }

    while (ch !== 0) {
      while (is_WHITE_SPACE(ch)) {
        ch = state.input.charCodeAt(++state.position);
      }

      if (ch === 0x23/* # */) {
        do { ch = state.input.charCodeAt(++state.position); }
        while (ch !== 0 && !is_EOL(ch));
        break;
      }

      if (is_EOL(ch)) break;

      _position = state.position;

      while (ch !== 0 && !is_WS_OR_EOL(ch)) {
        ch = state.input.charCodeAt(++state.position);
      }

      directiveArgs.push(state.input.slice(_position, state.position));
    }

    if (ch !== 0) readLineBreak(state);

    if (_hasOwnProperty$1.call(directiveHandlers, directiveName)) {
      directiveHandlers[directiveName](state, directiveName, directiveArgs);
    } else {
      throwWarning(state, 'unknown document directive "' + directiveName + '"');
    }
  }

  skipSeparationSpace(state, true, -1);

  if (state.lineIndent === 0 &&
      state.input.charCodeAt(state.position)     === 0x2D/* - */ &&
      state.input.charCodeAt(state.position + 1) === 0x2D/* - */ &&
      state.input.charCodeAt(state.position + 2) === 0x2D/* - */) {
    state.position += 3;
    skipSeparationSpace(state, true, -1);

  } else if (hasDirectives) {
    throwError(state, 'directives end mark is expected');
  }

  composeNode(state, state.lineIndent - 1, CONTEXT_BLOCK_OUT, false, true);
  skipSeparationSpace(state, true, -1);

  if (state.checkLineBreaks &&
      PATTERN_NON_ASCII_LINE_BREAKS.test(state.input.slice(documentStart, state.position))) {
    throwWarning(state, 'non-ASCII line breaks are interpreted as content');
  }

  state.documents.push(state.result);

  if (state.position === state.lineStart && testDocumentSeparator(state)) {

    if (state.input.charCodeAt(state.position) === 0x2E/* . */) {
      state.position += 3;
      skipSeparationSpace(state, true, -1);
    }
    return;
  }

  if (state.position < (state.length - 1)) {
    throwError(state, 'end of the stream or a document separator is expected');
  } else {
    return;
  }
}


function loadDocuments(input, options) {
  input = String(input);
  options = options || {};

  if (input.length !== 0) {

    // Add tailing `\n` if not exists
    if (input.charCodeAt(input.length - 1) !== 0x0A/* LF */ &&
        input.charCodeAt(input.length - 1) !== 0x0D/* CR */) {
      input += '\n';
    }

    // Strip BOM
    if (input.charCodeAt(0) === 0xFEFF) {
      input = input.slice(1);
    }
  }

  var state = new State$1(input, options);

  var nullpos = input.indexOf('\0');

  if (nullpos !== -1) {
    state.position = nullpos;
    throwError(state, 'null byte is not allowed in input');
  }

  // Use 0 as string terminator. That significantly simplifies bounds check.
  state.input += '\0';

  while (state.input.charCodeAt(state.position) === 0x20/* Space */) {
    state.lineIndent += 1;
    state.position += 1;
  }

  while (state.position < (state.length - 1)) {
    readDocument(state);
  }

  return state.documents;
}


function loadAll$1(input, iterator, options) {
  if (iterator !== null && typeof iterator === 'object' && typeof options === 'undefined') {
    options = iterator;
    iterator = null;
  }

  var documents = loadDocuments(input, options);

  if (typeof iterator !== 'function') {
    return documents;
  }

  for (var index = 0, length = documents.length; index < length; index += 1) {
    iterator(documents[index]);
  }
}


function load$1(input, options) {
  var documents = loadDocuments(input, options);

  if (documents.length === 0) {
    /*eslint-disable no-undefined*/
    return undefined;
  } else if (documents.length === 1) {
    return documents[0];
  }
  throw new exception('expected a single document in the stream, but found more');
}


var loadAll_1 = loadAll$1;
var load_1    = load$1;

var loader = {
	loadAll: loadAll_1,
	load: load_1
};

/*eslint-disable no-use-before-define*/





var _toString       = Object.prototype.toString;
var _hasOwnProperty = Object.prototype.hasOwnProperty;

var CHAR_BOM                  = 0xFEFF;
var CHAR_TAB                  = 0x09; /* Tab */
var CHAR_LINE_FEED            = 0x0A; /* LF */
var CHAR_CARRIAGE_RETURN      = 0x0D; /* CR */
var CHAR_SPACE                = 0x20; /* Space */
var CHAR_EXCLAMATION          = 0x21; /* ! */
var CHAR_DOUBLE_QUOTE         = 0x22; /* " */
var CHAR_SHARP                = 0x23; /* # */
var CHAR_PERCENT              = 0x25; /* % */
var CHAR_AMPERSAND            = 0x26; /* & */
var CHAR_SINGLE_QUOTE         = 0x27; /* ' */
var CHAR_ASTERISK             = 0x2A; /* * */
var CHAR_COMMA                = 0x2C; /* , */
var CHAR_MINUS                = 0x2D; /* - */
var CHAR_COLON                = 0x3A; /* : */
var CHAR_EQUALS               = 0x3D; /* = */
var CHAR_GREATER_THAN         = 0x3E; /* > */
var CHAR_QUESTION             = 0x3F; /* ? */
var CHAR_COMMERCIAL_AT        = 0x40; /* @ */
var CHAR_LEFT_SQUARE_BRACKET  = 0x5B; /* [ */
var CHAR_RIGHT_SQUARE_BRACKET = 0x5D; /* ] */
var CHAR_GRAVE_ACCENT         = 0x60; /* ` */
var CHAR_LEFT_CURLY_BRACKET   = 0x7B; /* { */
var CHAR_VERTICAL_LINE        = 0x7C; /* | */
var CHAR_RIGHT_CURLY_BRACKET  = 0x7D; /* } */

var ESCAPE_SEQUENCES = {};

ESCAPE_SEQUENCES[0x00]   = '\\0';
ESCAPE_SEQUENCES[0x07]   = '\\a';
ESCAPE_SEQUENCES[0x08]   = '\\b';
ESCAPE_SEQUENCES[0x09]   = '\\t';
ESCAPE_SEQUENCES[0x0A]   = '\\n';
ESCAPE_SEQUENCES[0x0B]   = '\\v';
ESCAPE_SEQUENCES[0x0C]   = '\\f';
ESCAPE_SEQUENCES[0x0D]   = '\\r';
ESCAPE_SEQUENCES[0x1B]   = '\\e';
ESCAPE_SEQUENCES[0x22]   = '\\"';
ESCAPE_SEQUENCES[0x5C]   = '\\\\';
ESCAPE_SEQUENCES[0x85]   = '\\N';
ESCAPE_SEQUENCES[0xA0]   = '\\_';
ESCAPE_SEQUENCES[0x2028] = '\\L';
ESCAPE_SEQUENCES[0x2029] = '\\P';

var DEPRECATED_BOOLEANS_SYNTAX = [
  'y', 'Y', 'yes', 'Yes', 'YES', 'on', 'On', 'ON',
  'n', 'N', 'no', 'No', 'NO', 'off', 'Off', 'OFF'
];

var DEPRECATED_BASE60_SYNTAX = /^[-+]?[0-9_]+(?::[0-9_]+)+(?:\.[0-9_]*)?$/;

function compileStyleMap(schema, map) {
  var result, keys, index, length, tag, style, type;

  if (map === null) return {};

  result = {};
  keys = Object.keys(map);

  for (index = 0, length = keys.length; index < length; index += 1) {
    tag = keys[index];
    style = String(map[tag]);

    if (tag.slice(0, 2) === '!!') {
      tag = 'tag:yaml.org,2002:' + tag.slice(2);
    }
    type = schema.compiledTypeMap['fallback'][tag];

    if (type && _hasOwnProperty.call(type.styleAliases, style)) {
      style = type.styleAliases[style];
    }

    result[tag] = style;
  }

  return result;
}

function encodeHex(character) {
  var string, handle, length;

  string = character.toString(16).toUpperCase();

  if (character <= 0xFF) {
    handle = 'x';
    length = 2;
  } else if (character <= 0xFFFF) {
    handle = 'u';
    length = 4;
  } else if (character <= 0xFFFFFFFF) {
    handle = 'U';
    length = 8;
  } else {
    throw new exception('code point within a string may not be greater than 0xFFFFFFFF');
  }

  return '\\' + handle + common.repeat('0', length - string.length) + string;
}


var QUOTING_TYPE_SINGLE = 1,
    QUOTING_TYPE_DOUBLE = 2;

function State(options) {
  this.schema        = options['schema'] || _default;
  this.indent        = Math.max(1, (options['indent'] || 2));
  this.noArrayIndent = options['noArrayIndent'] || false;
  this.skipInvalid   = options['skipInvalid'] || false;
  this.flowLevel     = (common.isNothing(options['flowLevel']) ? -1 : options['flowLevel']);
  this.styleMap      = compileStyleMap(this.schema, options['styles'] || null);
  this.sortKeys      = options['sortKeys'] || false;
  this.lineWidth     = options['lineWidth'] || 80;
  this.noRefs        = options['noRefs'] || false;
  this.noCompatMode  = options['noCompatMode'] || false;
  this.condenseFlow  = options['condenseFlow'] || false;
  this.quotingType   = options['quotingType'] === '"' ? QUOTING_TYPE_DOUBLE : QUOTING_TYPE_SINGLE;
  this.forceQuotes   = options['forceQuotes'] || false;
  this.replacer      = typeof options['replacer'] === 'function' ? options['replacer'] : null;

  this.implicitTypes = this.schema.compiledImplicit;
  this.explicitTypes = this.schema.compiledExplicit;

  this.tag = null;
  this.result = '';

  this.duplicates = [];
  this.usedDuplicates = null;
}

// Indents every line in a string. Empty lines (\n only) are not indented.
function indentString(string, spaces) {
  var ind = common.repeat(' ', spaces),
      position = 0,
      next = -1,
      result = '',
      line,
      length = string.length;

  while (position < length) {
    next = string.indexOf('\n', position);
    if (next === -1) {
      line = string.slice(position);
      position = length;
    } else {
      line = string.slice(position, next + 1);
      position = next + 1;
    }

    if (line.length && line !== '\n') result += ind;

    result += line;
  }

  return result;
}

function generateNextLine(state, level) {
  return '\n' + common.repeat(' ', state.indent * level);
}

function testImplicitResolving(state, str) {
  var index, length, type;

  for (index = 0, length = state.implicitTypes.length; index < length; index += 1) {
    type = state.implicitTypes[index];

    if (type.resolve(str)) {
      return true;
    }
  }

  return false;
}

// [33] s-white ::= s-space | s-tab
function isWhitespace(c) {
  return c === CHAR_SPACE || c === CHAR_TAB;
}

// Returns true if the character can be printed without escaping.
// From YAML 1.2: "any allowed characters known to be non-printable
// should also be escaped. [However,] This isn’t mandatory"
// Derived from nb-char - \t - #x85 - #xA0 - #x2028 - #x2029.
function isPrintable(c) {
  return  (0x00020 <= c && c <= 0x00007E)
      || ((0x000A1 <= c && c <= 0x00D7FF) && c !== 0x2028 && c !== 0x2029)
      || ((0x0E000 <= c && c <= 0x00FFFD) && c !== CHAR_BOM)
      ||  (0x10000 <= c && c <= 0x10FFFF);
}

// [34] ns-char ::= nb-char - s-white
// [27] nb-char ::= c-printable - b-char - c-byte-order-mark
// [26] b-char  ::= b-line-feed | b-carriage-return
// Including s-white (for some reason, examples doesn't match specs in this aspect)
// ns-char ::= c-printable - b-line-feed - b-carriage-return - c-byte-order-mark
function isNsCharOrWhitespace(c) {
  return isPrintable(c)
    && c !== CHAR_BOM
    // - b-char
    && c !== CHAR_CARRIAGE_RETURN
    && c !== CHAR_LINE_FEED;
}

// [127]  ns-plain-safe(c) ::= c = flow-out  ⇒ ns-plain-safe-out
//                             c = flow-in   ⇒ ns-plain-safe-in
//                             c = block-key ⇒ ns-plain-safe-out
//                             c = flow-key  ⇒ ns-plain-safe-in
// [128] ns-plain-safe-out ::= ns-char
// [129]  ns-plain-safe-in ::= ns-char - c-flow-indicator
// [130]  ns-plain-char(c) ::=  ( ns-plain-safe(c) - “:” - “#” )
//                            | ( /* An ns-char preceding */ “#” )
//                            | ( “:” /* Followed by an ns-plain-safe(c) */ )
function isPlainSafe(c, prev, inblock) {
  var cIsNsCharOrWhitespace = isNsCharOrWhitespace(c);
  var cIsNsChar = cIsNsCharOrWhitespace && !isWhitespace(c);
  return (
    // ns-plain-safe
    inblock ? // c = flow-in
      cIsNsCharOrWhitespace
      : cIsNsCharOrWhitespace
        // - c-flow-indicator
        && c !== CHAR_COMMA
        && c !== CHAR_LEFT_SQUARE_BRACKET
        && c !== CHAR_RIGHT_SQUARE_BRACKET
        && c !== CHAR_LEFT_CURLY_BRACKET
        && c !== CHAR_RIGHT_CURLY_BRACKET
  )
    // ns-plain-char
    && c !== CHAR_SHARP // false on '#'
    && !(prev === CHAR_COLON && !cIsNsChar) // false on ': '
    || (isNsCharOrWhitespace(prev) && !isWhitespace(prev) && c === CHAR_SHARP) // change to true on '[^ ]#'
    || (prev === CHAR_COLON && cIsNsChar); // change to true on ':[^ ]'
}

// Simplified test for values allowed as the first character in plain style.
function isPlainSafeFirst(c) {
  // Uses a subset of ns-char - c-indicator
  // where ns-char = nb-char - s-white.
  // No support of ( ( “?” | “:” | “-” ) /* Followed by an ns-plain-safe(c)) */ ) part
  return isPrintable(c) && c !== CHAR_BOM
    && !isWhitespace(c) // - s-white
    // - (c-indicator ::=
    // “-” | “?” | “:” | “,” | “[” | “]” | “{” | “}”
    && c !== CHAR_MINUS
    && c !== CHAR_QUESTION
    && c !== CHAR_COLON
    && c !== CHAR_COMMA
    && c !== CHAR_LEFT_SQUARE_BRACKET
    && c !== CHAR_RIGHT_SQUARE_BRACKET
    && c !== CHAR_LEFT_CURLY_BRACKET
    && c !== CHAR_RIGHT_CURLY_BRACKET
    // | “#” | “&” | “*” | “!” | “|” | “=” | “>” | “'” | “"”
    && c !== CHAR_SHARP
    && c !== CHAR_AMPERSAND
    && c !== CHAR_ASTERISK
    && c !== CHAR_EXCLAMATION
    && c !== CHAR_VERTICAL_LINE
    && c !== CHAR_EQUALS
    && c !== CHAR_GREATER_THAN
    && c !== CHAR_SINGLE_QUOTE
    && c !== CHAR_DOUBLE_QUOTE
    // | “%” | “@” | “`”)
    && c !== CHAR_PERCENT
    && c !== CHAR_COMMERCIAL_AT
    && c !== CHAR_GRAVE_ACCENT;
}

// Simplified test for values allowed as the last character in plain style.
function isPlainSafeLast(c) {
  // just not whitespace or colon, it will be checked to be plain character later
  return !isWhitespace(c) && c !== CHAR_COLON;
}

// Same as 'string'.codePointAt(pos), but works in older browsers.
function codePointAt(string, pos) {
  var first = string.charCodeAt(pos), second;
  if (first >= 0xD800 && first <= 0xDBFF && pos + 1 < string.length) {
    second = string.charCodeAt(pos + 1);
    if (second >= 0xDC00 && second <= 0xDFFF) {
      // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
    }
  }
  return first;
}

// Determines whether block indentation indicator is required.
function needIndentIndicator(string) {
  var leadingSpaceRe = /^\n* /;
  return leadingSpaceRe.test(string);
}

var STYLE_PLAIN   = 1,
    STYLE_SINGLE  = 2,
    STYLE_LITERAL = 3,
    STYLE_FOLDED  = 4,
    STYLE_DOUBLE  = 5;

// Determines which scalar styles are possible and returns the preferred style.
// lineWidth = -1 => no limit.
// Pre-conditions: str.length > 0.
// Post-conditions:
//    STYLE_PLAIN or STYLE_SINGLE => no \n are in the string.
//    STYLE_LITERAL => no lines are suitable for folding (or lineWidth is -1).
//    STYLE_FOLDED => a line > lineWidth and can be folded (and lineWidth != -1).
function chooseScalarStyle(string, singleLineOnly, indentPerLevel, lineWidth,
  testAmbiguousType, quotingType, forceQuotes, inblock) {

  var i;
  var char = 0;
  var prevChar = null;
  var hasLineBreak = false;
  var hasFoldableLine = false; // only checked if shouldTrackWidth
  var shouldTrackWidth = lineWidth !== -1;
  var previousLineBreak = -1; // count the first line correctly
  var plain = isPlainSafeFirst(codePointAt(string, 0))
          && isPlainSafeLast(codePointAt(string, string.length - 1));

  if (singleLineOnly || forceQuotes) {
    // Case: no block styles.
    // Check for disallowed characters to rule out plain and single.
    for (i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++) {
      char = codePointAt(string, i);
      if (!isPrintable(char)) {
        return STYLE_DOUBLE;
      }
      plain = plain && isPlainSafe(char, prevChar, inblock);
      prevChar = char;
    }
  } else {
    // Case: block styles permitted.
    for (i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++) {
      char = codePointAt(string, i);
      if (char === CHAR_LINE_FEED) {
        hasLineBreak = true;
        // Check if any line can be folded.
        if (shouldTrackWidth) {
          hasFoldableLine = hasFoldableLine ||
            // Foldable line = too long, and not more-indented.
            (i - previousLineBreak - 1 > lineWidth &&
             string[previousLineBreak + 1] !== ' ');
          previousLineBreak = i;
        }
      } else if (!isPrintable(char)) {
        return STYLE_DOUBLE;
      }
      plain = plain && isPlainSafe(char, prevChar, inblock);
      prevChar = char;
    }
    // in case the end is missing a \n
    hasFoldableLine = hasFoldableLine || (shouldTrackWidth &&
      (i - previousLineBreak - 1 > lineWidth &&
       string[previousLineBreak + 1] !== ' '));
  }
  // Although every style can represent \n without escaping, prefer block styles
  // for multiline, since they're more readable and they don't add empty lines.
  // Also prefer folding a super-long line.
  if (!hasLineBreak && !hasFoldableLine) {
    // Strings interpretable as another type have to be quoted;
    // e.g. the string 'true' vs. the boolean true.
    if (plain && !forceQuotes && !testAmbiguousType(string)) {
      return STYLE_PLAIN;
    }
    return quotingType === QUOTING_TYPE_DOUBLE ? STYLE_DOUBLE : STYLE_SINGLE;
  }
  // Edge case: block indentation indicator can only have one digit.
  if (indentPerLevel > 9 && needIndentIndicator(string)) {
    return STYLE_DOUBLE;
  }
  // At this point we know block styles are valid.
  // Prefer literal style unless we want to fold.
  if (!forceQuotes) {
    return hasFoldableLine ? STYLE_FOLDED : STYLE_LITERAL;
  }
  return quotingType === QUOTING_TYPE_DOUBLE ? STYLE_DOUBLE : STYLE_SINGLE;
}

// Note: line breaking/folding is implemented for only the folded style.
// NB. We drop the last trailing newline (if any) of a returned block scalar
//  since the dumper adds its own newline. This always works:
//    • No ending newline => unaffected; already using strip "-" chomping.
//    • Ending newline    => removed then restored.
//  Importantly, this keeps the "+" chomp indicator from gaining an extra line.
function writeScalar(state, string, level, iskey, inblock) {
  state.dump = (function () {
    if (string.length === 0) {
      return state.quotingType === QUOTING_TYPE_DOUBLE ? '""' : "''";
    }
    if (!state.noCompatMode) {
      if (DEPRECATED_BOOLEANS_SYNTAX.indexOf(string) !== -1 || DEPRECATED_BASE60_SYNTAX.test(string)) {
        return state.quotingType === QUOTING_TYPE_DOUBLE ? ('"' + string + '"') : ("'" + string + "'");
      }
    }

    var indent = state.indent * Math.max(1, level); // no 0-indent scalars
    // As indentation gets deeper, let the width decrease monotonically
    // to the lower bound min(state.lineWidth, 40).
    // Note that this implies
    //  state.lineWidth ≤ 40 + state.indent: width is fixed at the lower bound.
    //  state.lineWidth > 40 + state.indent: width decreases until the lower bound.
    // This behaves better than a constant minimum width which disallows narrower options,
    // or an indent threshold which causes the width to suddenly increase.
    var lineWidth = state.lineWidth === -1
      ? -1 : Math.max(Math.min(state.lineWidth, 40), state.lineWidth - indent);

    // Without knowing if keys are implicit/explicit, assume implicit for safety.
    var singleLineOnly = iskey
      // No block styles in flow mode.
      || (state.flowLevel > -1 && level >= state.flowLevel);
    function testAmbiguity(string) {
      return testImplicitResolving(state, string);
    }

    switch (chooseScalarStyle(string, singleLineOnly, state.indent, lineWidth,
      testAmbiguity, state.quotingType, state.forceQuotes && !iskey, inblock)) {

      case STYLE_PLAIN:
        return string;
      case STYLE_SINGLE:
        return "'" + string.replace(/'/g, "''") + "'";
      case STYLE_LITERAL:
        return '|' + blockHeader(string, state.indent)
          + dropEndingNewline(indentString(string, indent));
      case STYLE_FOLDED:
        return '>' + blockHeader(string, state.indent)
          + dropEndingNewline(indentString(foldString(string, lineWidth), indent));
      case STYLE_DOUBLE:
        return '"' + escapeString(string) + '"';
      default:
        throw new exception('impossible error: invalid scalar style');
    }
  }());
}

// Pre-conditions: string is valid for a block scalar, 1 <= indentPerLevel <= 9.
function blockHeader(string, indentPerLevel) {
  var indentIndicator = needIndentIndicator(string) ? String(indentPerLevel) : '';

  // note the special case: the string '\n' counts as a "trailing" empty line.
  var clip =          string[string.length - 1] === '\n';
  var keep = clip && (string[string.length - 2] === '\n' || string === '\n');
  var chomp = keep ? '+' : (clip ? '' : '-');

  return indentIndicator + chomp + '\n';
}

// (See the note for writeScalar.)
function dropEndingNewline(string) {
  return string[string.length - 1] === '\n' ? string.slice(0, -1) : string;
}

// Note: a long line without a suitable break point will exceed the width limit.
// Pre-conditions: every char in str isPrintable, str.length > 0, width > 0.
function foldString(string, width) {
  // In folded style, $k$ consecutive newlines output as $k+1$ newlines—
  // unless they're before or after a more-indented line, or at the very
  // beginning or end, in which case $k$ maps to $k$.
  // Therefore, parse each chunk as newline(s) followed by a content line.
  var lineRe = /(\n+)([^\n]*)/g;

  // first line (possibly an empty line)
  var result = (function () {
    var nextLF = string.indexOf('\n');
    nextLF = nextLF !== -1 ? nextLF : string.length;
    lineRe.lastIndex = nextLF;
    return foldLine(string.slice(0, nextLF), width);
  }());
  // If we haven't reached the first content line yet, don't add an extra \n.
  var prevMoreIndented = string[0] === '\n' || string[0] === ' ';
  var moreIndented;

  // rest of the lines
  var match;
  while ((match = lineRe.exec(string))) {
    var prefix = match[1], line = match[2];
    moreIndented = (line[0] === ' ');
    result += prefix
      + (!prevMoreIndented && !moreIndented && line !== ''
        ? '\n' : '')
      + foldLine(line, width);
    prevMoreIndented = moreIndented;
  }

  return result;
}

// Greedy line breaking.
// Picks the longest line under the limit each time,
// otherwise settles for the shortest line over the limit.
// NB. More-indented lines *cannot* be folded, as that would add an extra \n.
function foldLine(line, width) {
  if (line === '' || line[0] === ' ') return line;

  // Since a more-indented line adds a \n, breaks can't be followed by a space.
  var breakRe = / [^ ]/g; // note: the match index will always be <= length-2.
  var match;
  // start is an inclusive index. end, curr, and next are exclusive.
  var start = 0, end, curr = 0, next = 0;
  var result = '';

  // Invariants: 0 <= start <= length-1.
  //   0 <= curr <= next <= max(0, length-2). curr - start <= width.
  // Inside the loop:
  //   A match implies length >= 2, so curr and next are <= length-2.
  while ((match = breakRe.exec(line))) {
    next = match.index;
    // maintain invariant: curr - start <= width
    if (next - start > width) {
      end = (curr > start) ? curr : next; // derive end <= length-2
      result += '\n' + line.slice(start, end);
      // skip the space that was output as \n
      start = end + 1;                    // derive start <= length-1
    }
    curr = next;
  }

  // By the invariants, start <= length-1, so there is something left over.
  // It is either the whole string or a part starting from non-whitespace.
  result += '\n';
  // Insert a break if the remainder is too long and there is a break available.
  if (line.length - start > width && curr > start) {
    result += line.slice(start, curr) + '\n' + line.slice(curr + 1);
  } else {
    result += line.slice(start);
  }

  return result.slice(1); // drop extra \n joiner
}

// Escapes a double-quoted string.
function escapeString(string) {
  var result = '';
  var char = 0;
  var escapeSeq;

  for (var i = 0; i < string.length; char >= 0x10000 ? i += 2 : i++) {
    char = codePointAt(string, i);
    escapeSeq = ESCAPE_SEQUENCES[char];

    if (!escapeSeq && isPrintable(char)) {
      result += string[i];
      if (char >= 0x10000) result += string[i + 1];
    } else {
      result += escapeSeq || encodeHex(char);
    }
  }

  return result;
}

function writeFlowSequence(state, level, object) {
  var _result = '',
      _tag    = state.tag,
      index,
      length,
      value;

  for (index = 0, length = object.length; index < length; index += 1) {
    value = object[index];

    if (state.replacer) {
      value = state.replacer.call(object, String(index), value);
    }

    // Write only valid elements, put null instead of invalid elements.
    if (writeNode(state, level, value, false, false) ||
        (typeof value === 'undefined' &&
         writeNode(state, level, null, false, false))) {

      if (_result !== '') _result += ',' + (!state.condenseFlow ? ' ' : '');
      _result += state.dump;
    }
  }

  state.tag = _tag;
  state.dump = '[' + _result + ']';
}

function writeBlockSequence(state, level, object, compact) {
  var _result = '',
      _tag    = state.tag,
      index,
      length,
      value;

  for (index = 0, length = object.length; index < length; index += 1) {
    value = object[index];

    if (state.replacer) {
      value = state.replacer.call(object, String(index), value);
    }

    // Write only valid elements, put null instead of invalid elements.
    if (writeNode(state, level + 1, value, true, true, false, true) ||
        (typeof value === 'undefined' &&
         writeNode(state, level + 1, null, true, true, false, true))) {

      if (!compact || _result !== '') {
        _result += generateNextLine(state, level);
      }

      if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
        _result += '-';
      } else {
        _result += '- ';
      }

      _result += state.dump;
    }
  }

  state.tag = _tag;
  state.dump = _result || '[]'; // Empty sequence if no valid values.
}

function writeFlowMapping(state, level, object) {
  var _result       = '',
      _tag          = state.tag,
      objectKeyList = Object.keys(object),
      index,
      length,
      objectKey,
      objectValue,
      pairBuffer;

  for (index = 0, length = objectKeyList.length; index < length; index += 1) {

    pairBuffer = '';
    if (_result !== '') pairBuffer += ', ';

    if (state.condenseFlow) pairBuffer += '"';

    objectKey = objectKeyList[index];
    objectValue = object[objectKey];

    if (state.replacer) {
      objectValue = state.replacer.call(object, objectKey, objectValue);
    }

    if (!writeNode(state, level, objectKey, false, false)) {
      continue; // Skip this pair because of invalid key;
    }

    if (state.dump.length > 1024) pairBuffer += '? ';

    pairBuffer += state.dump + (state.condenseFlow ? '"' : '') + ':' + (state.condenseFlow ? '' : ' ');

    if (!writeNode(state, level, objectValue, false, false)) {
      continue; // Skip this pair because of invalid value.
    }

    pairBuffer += state.dump;

    // Both key and value are valid.
    _result += pairBuffer;
  }

  state.tag = _tag;
  state.dump = '{' + _result + '}';
}

function writeBlockMapping(state, level, object, compact) {
  var _result       = '',
      _tag          = state.tag,
      objectKeyList = Object.keys(object),
      index,
      length,
      objectKey,
      objectValue,
      explicitPair,
      pairBuffer;

  // Allow sorting keys so that the output file is deterministic
  if (state.sortKeys === true) {
    // Default sorting
    objectKeyList.sort();
  } else if (typeof state.sortKeys === 'function') {
    // Custom sort function
    objectKeyList.sort(state.sortKeys);
  } else if (state.sortKeys) {
    // Something is wrong
    throw new exception('sortKeys must be a boolean or a function');
  }

  for (index = 0, length = objectKeyList.length; index < length; index += 1) {
    pairBuffer = '';

    if (!compact || _result !== '') {
      pairBuffer += generateNextLine(state, level);
    }

    objectKey = objectKeyList[index];
    objectValue = object[objectKey];

    if (state.replacer) {
      objectValue = state.replacer.call(object, objectKey, objectValue);
    }

    if (!writeNode(state, level + 1, objectKey, true, true, true)) {
      continue; // Skip this pair because of invalid key.
    }

    explicitPair = (state.tag !== null && state.tag !== '?') ||
                   (state.dump && state.dump.length > 1024);

    if (explicitPair) {
      if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
        pairBuffer += '?';
      } else {
        pairBuffer += '? ';
      }
    }

    pairBuffer += state.dump;

    if (explicitPair) {
      pairBuffer += generateNextLine(state, level);
    }

    if (!writeNode(state, level + 1, objectValue, true, explicitPair)) {
      continue; // Skip this pair because of invalid value.
    }

    if (state.dump && CHAR_LINE_FEED === state.dump.charCodeAt(0)) {
      pairBuffer += ':';
    } else {
      pairBuffer += ': ';
    }

    pairBuffer += state.dump;

    // Both key and value are valid.
    _result += pairBuffer;
  }

  state.tag = _tag;
  state.dump = _result || '{}'; // Empty mapping if no valid pairs.
}

function detectType(state, object, explicit) {
  var _result, typeList, index, length, type, style;

  typeList = explicit ? state.explicitTypes : state.implicitTypes;

  for (index = 0, length = typeList.length; index < length; index += 1) {
    type = typeList[index];

    if ((type.instanceOf  || type.predicate) &&
        (!type.instanceOf || ((typeof object === 'object') && (object instanceof type.instanceOf))) &&
        (!type.predicate  || type.predicate(object))) {

      if (explicit) {
        if (type.multi && type.representName) {
          state.tag = type.representName(object);
        } else {
          state.tag = type.tag;
        }
      } else {
        state.tag = '?';
      }

      if (type.represent) {
        style = state.styleMap[type.tag] || type.defaultStyle;

        if (_toString.call(type.represent) === '[object Function]') {
          _result = type.represent(object, style);
        } else if (_hasOwnProperty.call(type.represent, style)) {
          _result = type.represent[style](object, style);
        } else {
          throw new exception('!<' + type.tag + '> tag resolver accepts not "' + style + '" style');
        }

        state.dump = _result;
      }

      return true;
    }
  }

  return false;
}

// Serializes `object` and writes it to global `result`.
// Returns true on success, or false on invalid object.
//
function writeNode(state, level, object, block, compact, iskey, isblockseq) {
  state.tag = null;
  state.dump = object;

  if (!detectType(state, object, false)) {
    detectType(state, object, true);
  }

  var type = _toString.call(state.dump);
  var inblock = block;
  var tagStr;

  if (block) {
    block = (state.flowLevel < 0 || state.flowLevel > level);
  }

  var objectOrArray = type === '[object Object]' || type === '[object Array]',
      duplicateIndex,
      duplicate;

  if (objectOrArray) {
    duplicateIndex = state.duplicates.indexOf(object);
    duplicate = duplicateIndex !== -1;
  }

  if ((state.tag !== null && state.tag !== '?') || duplicate || (state.indent !== 2 && level > 0)) {
    compact = false;
  }

  if (duplicate && state.usedDuplicates[duplicateIndex]) {
    state.dump = '*ref_' + duplicateIndex;
  } else {
    if (objectOrArray && duplicate && !state.usedDuplicates[duplicateIndex]) {
      state.usedDuplicates[duplicateIndex] = true;
    }
    if (type === '[object Object]') {
      if (block && (Object.keys(state.dump).length !== 0)) {
        writeBlockMapping(state, level, state.dump, compact);
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + state.dump;
        }
      } else {
        writeFlowMapping(state, level, state.dump);
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
        }
      }
    } else if (type === '[object Array]') {
      if (block && (state.dump.length !== 0)) {
        if (state.noArrayIndent && !isblockseq && level > 0) {
          writeBlockSequence(state, level - 1, state.dump, compact);
        } else {
          writeBlockSequence(state, level, state.dump, compact);
        }
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + state.dump;
        }
      } else {
        writeFlowSequence(state, level, state.dump);
        if (duplicate) {
          state.dump = '&ref_' + duplicateIndex + ' ' + state.dump;
        }
      }
    } else if (type === '[object String]') {
      if (state.tag !== '?') {
        writeScalar(state, state.dump, level, iskey, inblock);
      }
    } else if (type === '[object Undefined]') {
      return false;
    } else {
      if (state.skipInvalid) return false;
      throw new exception('unacceptable kind of an object to dump ' + type);
    }

    if (state.tag !== null && state.tag !== '?') {
      // Need to encode all characters except those allowed by the spec:
      //
      // [35] ns-dec-digit    ::=  [#x30-#x39] /* 0-9 */
      // [36] ns-hex-digit    ::=  ns-dec-digit
      //                         | [#x41-#x46] /* A-F */ | [#x61-#x66] /* a-f */
      // [37] ns-ascii-letter ::=  [#x41-#x5A] /* A-Z */ | [#x61-#x7A] /* a-z */
      // [38] ns-word-char    ::=  ns-dec-digit | ns-ascii-letter | “-”
      // [39] ns-uri-char     ::=  “%” ns-hex-digit ns-hex-digit | ns-word-char | “#”
      //                         | “;” | “/” | “?” | “:” | “@” | “&” | “=” | “+” | “$” | “,”
      //                         | “_” | “.” | “!” | “~” | “*” | “'” | “(” | “)” | “[” | “]”
      //
      // Also need to encode '!' because it has special meaning (end of tag prefix).
      //
      tagStr = encodeURI(
        state.tag[0] === '!' ? state.tag.slice(1) : state.tag
      ).replace(/!/g, '%21');

      if (state.tag[0] === '!') {
        tagStr = '!' + tagStr;
      } else if (tagStr.slice(0, 18) === 'tag:yaml.org,2002:') {
        tagStr = '!!' + tagStr.slice(18);
      } else {
        tagStr = '!<' + tagStr + '>';
      }

      state.dump = tagStr + ' ' + state.dump;
    }
  }

  return true;
}

function getDuplicateReferences(object, state) {
  var objects = [],
      duplicatesIndexes = [],
      index,
      length;

  inspectNode(object, objects, duplicatesIndexes);

  for (index = 0, length = duplicatesIndexes.length; index < length; index += 1) {
    state.duplicates.push(objects[duplicatesIndexes[index]]);
  }
  state.usedDuplicates = new Array(length);
}

function inspectNode(object, objects, duplicatesIndexes) {
  var objectKeyList,
      index,
      length;

  if (object !== null && typeof object === 'object') {
    index = objects.indexOf(object);
    if (index !== -1) {
      if (duplicatesIndexes.indexOf(index) === -1) {
        duplicatesIndexes.push(index);
      }
    } else {
      objects.push(object);

      if (Array.isArray(object)) {
        for (index = 0, length = object.length; index < length; index += 1) {
          inspectNode(object[index], objects, duplicatesIndexes);
        }
      } else {
        objectKeyList = Object.keys(object);

        for (index = 0, length = objectKeyList.length; index < length; index += 1) {
          inspectNode(object[objectKeyList[index]], objects, duplicatesIndexes);
        }
      }
    }
  }
}

function dump$1(input, options) {
  options = options || {};

  var state = new State(options);

  if (!state.noRefs) getDuplicateReferences(input, state);

  var value = input;

  if (state.replacer) {
    value = state.replacer.call({ '': value }, '', value);
  }

  if (writeNode(state, 0, value, true, true)) return state.dump + '\n';

  return '';
}

var dump_1 = dump$1;

var dumper = {
	dump: dump_1
};

function renamed(from, to) {
  return function () {
    throw new Error('Function yaml.' + from + ' is removed in js-yaml 4. ' +
      'Use yaml.' + to + ' instead, which is now safe by default.');
  };
}


var Type                = type;
var Schema              = schema;
var FAILSAFE_SCHEMA     = failsafe;
var JSON_SCHEMA         = json;
var CORE_SCHEMA         = core;
var DEFAULT_SCHEMA      = _default;
var load                = loader.load;
var loadAll             = loader.loadAll;
var dump                = dumper.dump;
var YAMLException       = exception;

// Re-export all types in case user wants to create custom schema
var types = {
  binary:    binary,
  float:     float,
  map:       map,
  null:      _null,
  pairs:     pairs,
  set:       set,
  timestamp: timestamp,
  bool:      bool,
  int:       int,
  merge:     merge,
  omap:      omap,
  seq:       seq,
  str:       str
};

// Removed functions from JS-YAML 3.0.x
var safeLoad            = renamed('safeLoad', 'load');
var safeLoadAll         = renamed('safeLoadAll', 'loadAll');
var safeDump            = renamed('safeDump', 'dump');

var jsYaml = {
	Type: Type,
	Schema: Schema,
	FAILSAFE_SCHEMA: FAILSAFE_SCHEMA,
	JSON_SCHEMA: JSON_SCHEMA,
	CORE_SCHEMA: CORE_SCHEMA,
	DEFAULT_SCHEMA: DEFAULT_SCHEMA,
	load: load,
	loadAll: loadAll,
	dump: dump,
	YAMLException: YAMLException,
	types: types,
	safeLoad: safeLoad,
	safeLoadAll: safeLoadAll,
	safeDump: safeDump
};

/* harmony default export */ __webpack_exports__["a"] = (jsYaml);



/***/ }),

/***/ "QMpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddExhibition_vue__ = __webpack_require__("rtH7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_240449ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddExhibition_vue__ = __webpack_require__("05WY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("DM5G")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-240449ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddExhibition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_240449ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddExhibition_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_240449ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddExhibition_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QOtO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"elevation-0 mx-3 py-0 my-0"},[_c('v-card-title',{class:{ black: _vm.add_new }},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.add_new == true)?_c('v-list-tile',[_c('v-layout',{attrs:{"row":"","my-0":"","py-0":"","mr-3":""}},[_c('v-flex',{attrs:{"xs12":"","md3":"","my-0":"","py-0":"","mr-2":""}},[_c('v-text-field',{staticClass:"input-group dark mt-4 py-0",attrs:{"color":"white","dark":"","label":"First Name","value":""},model:{value:(_vm.artist.first_name),callback:function ($$v) {_vm.$set(_vm.artist, "first_name", $$v)},expression:"artist.first_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","my-0":"","py-0":"","mr-2":""}},[_c('v-text-field',{staticClass:"input-group dark mt-4 py-0",attrs:{"color":"white","dark":"","label":"Last Name","value":""},model:{value:(_vm.artist.last_name),callback:function ($$v) {_vm.$set(_vm.artist, "last_name", $$v)},expression:"artist.last_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","my-0":"","py-0":""}},[_c('v-text-field',{staticClass:"input-group dark mt-4 py-0",attrs:{"color":"white","dark":"","label":"Name","value":""},model:{value:(_vm.artist.name),callback:function ($$v) {_vm.$set(_vm.artist, "name", $$v)},expression:"artist.name"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"green","disabled":!_vm.artist.first_name.length > 0},on:{"click":_vm.create_artist}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"white"},on:{"click":function($event){_vm.add_new = false}}},[_vm._v("Cancel")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-title',{staticClass:"mr-4 ml-2 pr-0 pb-0",staticStyle:{"position":"fixed","top":"130px","right":"17px","background-color":"#fff","opacity":"0.8"}},[_c('v-spacer'),_vm._v(" "),(this.$store.state.showSearch)?_c('v-text-field',{staticStyle:{"background-color":"#fff"},attrs:{"prepend-inner-icon":"search","label":"Search Artists ","single-line":"","hide-details":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","my-3":"","ml-4":""}},[_c('span',[_c('v-menu',{staticClass:"text-xs-right mx-4 my-0 py-0 align-center",attrs:{"offset-y":"","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-2 my-0 py-0",attrs:{"small":"","icon":"","color":"black","dark":""}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("supervisor_account")])],1)]}}])},[_vm._v(" "),_c('v-list',{attrs:{"value":"1"}},_vm._l((_vm.ownerships),function(item,index){return _c('v-list-tile',{key:index.id,on:{"click":function($event){return _vm.toggleOwnership(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)}),1)],1)],1),_vm._v(" "),_c('span',{staticClass:"text-xs-left mt-2 pt-1 title"},[_vm._v("\n        "+_vm._s(_vm.selectedOwnership)+"\n      ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-data-table',{ref:"dTable",staticClass:"elevation-0 mx-4",attrs:{"pagination":_vm.pagination2,"headers":_vm.headers,"hide-headers":"","items":_vm.filtered,"search":_vm.search,"item-key":"id","item-value":"last_name","must-sort":"","expand":"","expanded":_vm.filtered,"rows-per-page-text":"Artists per page","no-results-text":"No Artists match the criteria."},on:{"update:pagination":function($event){_vm.pagination2=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:{ black: props.expanded, 'white--text': props.expanded },staticStyle:{"border-top":"#eee solid 1px"}},[_c('td',{staticClass:"mx-0 px-0"},[_c('v-flex',{staticClass:"layout pt-2 pr-0"},[_c('router-link',{staticClass:"title pt-2 font-weight-light mx-1",class:{
                  black: props.expanded,
                  'white--text': props.expanded
                },attrs:{"to":{
                  name: 'EditArtist',
                  params: { id: props.item.id, artist: props.item },
                  path: ("/artists/edit/" + (props.item.id))
                }},domProps:{"innerHTML":_vm._s(props.item.name)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){props.expanded = !props.expanded}}},[(!props.expanded)?_c('v-icon',{class:{ 'white--text': props.expanded }},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(props.expanded)?_c('v-icon',{class:{ 'white--text': props.expanded }},[_vm._v("expand_less")]):_vm._e()],1)],1)],1)])]}},{key:"expand",fn:function(props){return [_c('view-artworks',{staticClass:"mx-3 py-0 my-0",attrs:{"artist":props.item}})]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" "),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("Your search for \""+_vm._s(_vm.search)+"\" found no results.")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "Qi+p":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Qi9S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R4KG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NonElectrical_vue__ = __webpack_require__("Th9A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf3c69a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NonElectrical_vue__ = __webpack_require__("oFIt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("SKFP")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8bf3c69a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NonElectrical_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf3c69a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NonElectrical_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8bf3c69a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NonElectrical_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R5aN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mt-4 mx-4 elevation-0"},[_c('v-dialog',{attrs:{"width":"900"},model:{value:(_vm.view_dialog),callback:function ($$v) {_vm.view_dialog=$$v},expression:"view_dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("\n          "+_vm._s(_vm.view.title)+"\n        ")]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.view.content)}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.view_dialog = false}}},[_vm._v("\n            Close\n          ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"590"},model:{value:(_vm.delete_dialog),callback:function ($$v) {_vm.delete_dialog=$$v},expression:"delete_dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are your sure to delete \""),_c('strong',[_vm._v(_vm._s(_vm.text_to_delete.title))]),_vm._v("\" Text?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          This Text will be deleted.\n        ")]),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('div',{staticClass:"flex-grow-1"}),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","text":""},on:{"click":_vm.delete_dialog_close}},[_vm._v("\n            Cancel\n          ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","text":""},on:{"click":function($event){return _vm.deleteText(_vm.text_to_delete)}}},[_vm._v("\n            Delete Text\n          ")])],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mx-3 elevation-0"},[_c('v-card-title',{staticClass:"mx-0 px-0"},[_c('v-layout',{attrs:{"row":"","mt-3":"","mx-1":""}},[_c('span',[_c('v-menu',{staticClass:"text-xs-right mx-4 my-0 py-0 align-center",attrs:{"offset-y":"","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-2 my-0 py-0",attrs:{"small":"","icon":"","color":"black","dark":""}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("supervisor_account")])],1)]}}])},[_vm._v(" "),_c('v-list',{attrs:{"value":"3"}},_vm._l((this.local_text_categories),function(item,index){return _c('v-list-tile',{key:index.id,on:{"click":function($event){return _vm.toggleCategory(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)}),1)],1)],1),_vm._v(" "),_c('span',{staticClass:"text-xs-left mt-2 pt-1 title"},[_vm._v("\n            "+_vm._s(_vm.selectedCategory.name)+"\n          ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn-toggle',{staticClass:"mt-3",model:{value:(_vm.tba21),callback:function ($$v) {_vm.tba21=$$v},expression:"tba21"}},[_c('v-btn',{key:"group0",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"uploads","value":"uploads"}},[_c('span',[_vm._v(" Uploads ")])]),_vm._v(" "),_c('v-btn',{key:"group1",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"all","value":"2"}},[_c('span',[_vm._v(" All ")])]),_vm._v(" "),_c('v-btn',{key:"group2",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"1","value":"1"}},[_c('span',[_vm._v(" TBA21 ")])]),_vm._v(" "),_c('v-btn',{key:"group3",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"0","value":"0"}},[_c('span',[_vm._v(" NON TBA21 ")])])],1),_vm._v(" "),(this.$store.state.showSearch)?_c('v-text-field',{staticClass:"ml-5",attrs:{"prepend-inner-icon":"search","background-color":_vm.search && _vm.search.length > 0 ? '#fee' : '',"clearable":"","label":"Search ","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0 pl-0",staticStyle:{"border-top":"1px solid #ccc"},attrs:{"hide-headers":"","pagination":_vm.pagination,"headers":_vm.headers,"items":_vm.filtered_texts,"search":_vm.search,"item-key":"id","must-sort":"","expand":"","rows-per-page-text":"Texts per page","no-results-text":"No Texts match the criteria."},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:{editBG: props.expanded}},[_c('td',{staticClass:"px-0",attrs:{"colspan":"10"}},[_c('table',{staticClass:"px-0",attrs:{"width":"100%"}},[_c('tr',{staticClass:"px-0"},[_c('td',{class:{
                      subheading: true,
                      editBG: props.expanded,
                      title: true,
                      'text-no-wrap px-0': true
                    },staticStyle:{"padding-bottom":"0px","margin-bottom":"0px","width":"50px"},attrs:{"rowspan":"2"}},[(props.item.show_in_texts != 1)?_c('v-flex',[_c('v-btn',{staticClass:"ml-0 pl-0",attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.viewText(props.item.id)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mr-1",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.download_text(props.item)}}},[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("mdi-download")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":"","disabled":!props.item.artworks.length > 0},on:{"click":function($event){return _vm.showArtworks(props)}}},[_c('v-icon',{attrs:{"small":"","color":props.expanded && _vm.showingArtworks
                              ? 'red'
                              : props.item.artworks &&
                                props.item.artworks.length > 0
                              ? 'black'
                              : 'grey'}},[_vm._v("photo_library")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","disabled":!props.item.artists.length > 0},on:{"click":function($event){return _vm.showArtists(props)}}},[_c('v-icon',{attrs:{"small":"","color":props.expanded && !_vm.showingArtworks
                              ? 'red'
                              : props.item.artists &&
                                props.item.artists.length > 0
                              ? 'black'
                              : 'grey'}},[_vm._v("people")])],1)],1):_c('v-flex',[_c('a',{attrs:{"href":((_vm.$globals.fileserver) + "/" + (_vm.controller(props.item.category)) + "/send_file_auth?path=/data/" + (props.item.category) + "/" + (_vm.id(props.item)) + "/" + (props.item.fname) + "&dtoken=IZcomzYtIPKvPPQWuyENLKmVkeNclv1e5"),"target":"_blank"}},[_c('v-btn',{attrs:{"small":"","icon":""}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("download")])],1)],1)])],1),_vm._v(" "),_c('td',{class:{ 'layout align-end justify-space-between pr-1 fill-height': true, editBG: props.expanded },attrs:{"colspan":"2"}},[_c('span',{staticClass:"mt-0 title"},[(props.item.show_in_texts)?_c('a',{staticStyle:{"font-weight":"500","color":"#392939"},attrs:{"href":((_vm.$globals.fileserver) + "/" + (_vm.controller(props.item.category)) + "/send_file_auth?path=/data/" + (props.item.category) + "/" + (_vm.id(props.item)) + "/" + (props.item.fname) + "&dtoken=IZcomzYtIPKvPPQWuyENLKmVkeNclv1e5"),"download":props.item.fname,"target":"_blank"}},[_vm._v(_vm._s(props.item.name ? props.item.name : props.item.fname))]):_c('router-link',{staticClass:"mr-3 multi-line",attrs:{"to":{
                          name: 'EditText',
                          params: {
                            id: props.item.id,
                            editedItem: props.item
                          },
                          path: ("/texts/edit/" + (props.item.id))
                        }}},[(props.item.given_filename)?_c('span',[_vm._v("\n                          "+_vm._s(_vm.stripHtml(props.item.given_filename))+" \n                        ")]):_c('span',[_vm._v(" NO TITLE ")])])],1),_vm._v(" "),_c('span',{staticClass:"grey--text right pb-1 pr-0"},[_c('small',[_vm._v(_vm._s(_vm.format_date(props.item.created_at)))]),_vm._v(" "),(props.item.created_by)?_c('small',[_vm._v("BY "),_c('b',[_vm._v(_vm._s(_vm.get_abb(props.item.created_by)))])]):_vm._e()])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"layout  align-center justify-space-between fill-height pr-0",attrs:{"colspan":"3"}},[(props.item.show_in_texts == 1)?_c('span',[_vm._v(_vm._s(_vm.getRelatedTitle(props.item)))]):_c('span',[_c('small',[_vm._v(_vm._s(_vm.snake2title( _vm.categoryName(props.item.category) ).toUpperCase()))])]),_vm._v(" "),_c('span',{class:{
                      'right': true,
                      subheading: true,
                      editBG: props.expanded
                    }},[(props.item.publication)?_c('v-chip',{attrs:{"small":"","right":""}},[_vm._v("publication")]):_vm._e(),_vm._v(" "),(props.item.article)?_c('v-chip',{attrs:{"small":"","right":""}},[_vm._v("article")]):_vm._e(),_vm._v(" "),(props.item.artwork_text)?_c('v-chip',{attrs:{"small":"","right":""}},[_vm._v("text on artwork")]):_vm._e(),_vm._v(" "),(props.item.artist_documents)?_c('v-chip',{attrs:{"small":"","right":""}},[_vm._v("artist documents")]):_vm._e(),_vm._v(" "),(props.item.pr)?_c('v-chip',{attrs:{"small":"","right":""}},[_vm._v("PR")]):_vm._e(),_vm._v(" "),(props.item.transcript)?_c('v-chip',{attrs:{"small":"","right":""}},[_vm._v("transcript")]):_vm._e(),_vm._v(" "),(props.item.work_text)?_c('v-chip',{attrs:{"small":"","right":""}},[_vm._v("work text")]):_vm._e()],1)])])])])])]}},{key:"expand",fn:function(props){return [_c('v-flex',{staticClass:"px-3 py-1 my-0 elevation-0 xs12",staticStyle:{"background-color":"#eee","color":"#444"}},[(_vm.showingArtworks)?_c('h3',{staticClass:"font-weight-bold red--text subtitle xs12 pl-1 ml-0 pb-0 flex"},[_vm._v("\n              ARTWORKS\n            ")]):_c('h3',{staticClass:"font-weight-bold red--text subtitle xs12 pl-1 ml-0 pb-0 flex"},[_vm._v("\n              ARTISTS\n            ")])]),_vm._v(" "),(_vm.showingArtworks)?_c('ListRelated',{attrs:{"artworks":props.item.artworks,"text_id":props.item.id}}):_c('ListRelatedArtists',{attrs:{"artists":props.item.artists,"text_id":props.item.id}}),_vm._v(" "),_c('v-flex',{staticClass:"px-3 py-1 my-0 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("   ")])])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" "),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n          Your search for \""+_vm._s(_vm.search)+"\" found no results.\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "RF7d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RKLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiArtist_vue__ = __webpack_require__("HuDx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cd41fca_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiArtist_vue__ = __webpack_require__("VHCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("h/wv")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cd41fca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiArtist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cd41fca_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiArtist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cd41fca_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiArtist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RVzw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Labels_vue__ = __webpack_require__("g7NG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602ec0e3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Labels_vue__ = __webpack_require__("MBU1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ox/d")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-602ec0e3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Labels_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602ec0e3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Labels_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602ec0e3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Labels_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Rehu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RgRh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__main__ = __webpack_require__("NHnr");






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function dynamicSort(property, property2) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    if (a[property] > b[property]) return 1;
    if (a[property] < b[property]) return -1;
    if (a[property2] && b[property2]) {
      if (a[property2] > b[property2]) return 1;
      if (a[property2] < b[property2]) return -1;
    }
    return result * sortOrder;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      saveDialog: false,
      selectedFilter: 'artwork',
      selectedPackingFilter: 'all',
      // historyFilter: 'artwork',
      changeArtworkLocation: false,
      changeAllParts: false,
      editDialog: false,
      menu_time: false,
      time: null,
      editedLocationLog: {},
      selectedPackings: [],
      menu2: false,
      menu2a: false,
      showUpload: false,
      showList: false,
      show: false,
      errors: '',
      artwork_location_log: {
        created_by: '',
        storage: 'in',
        note: '',
        change_date: '',
        artwork_location_id: '',
        copy: 'artwork',
        artwork_packing_id: '',
        shipper: '',
        reason: ''
      }
    };
  },
  computed: {
    old_location_from_date_and_copy: function old_location_from_date_and_copy() {
      var _this = this;

      // var current = { change_date: this.artwork_location_log.change_date, copy: this.artwork_location_log.copy, artwork_id: this.artwork.id }
      if (this.artwork_location_log.change_date && this.artwork_location_log.copy) {
        // this.artwork_location_log.old_location = this.get_old_location(current)
        if (this.artwork_location_log.copy == 'packings') {
          this.artwork_location_log.artwork_id = '';
          return 'Previous Location cannot be calculated for packings';
        } else if (['artwork', 'master_physical', 'archive_master'].includes(this.artwork_location_log.copy)) {
          this.artwork_location_log.artwork_id = this.artwork.id;
          var olderArtworkLogs = this.sorted_artwork_location_logs.filter(function (l) {
            return l.copy == _this.artwork_location_log.copy && l.change_date < _this.artwork_location_log.change_date;
          });
          console.log(olderArtworkLogs);
          if (olderArtworkLogs.length > 1) {
            // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_location_log')
            var previous = olderArtworkLogs[0];
            if (previous) {
              this.artwork_location_log.old_location = previous.artwork_location_id;
              return previous.artwork_location_id;
            } else {
              this.artwork_location_log.old_location = 465;
              return 465;
            }
          } else {
            this.artwork_location_log.old_location = 465;
            return 465;
          }
        }
      } else {
        return 'Copy and Change Date must be selected before calculating old Location';
      }
    },
    sorted_artwork_location_logs: function sorted_artwork_location_logs() {
      return this.artwork.artwork_location_logs.sort(dynamicSort('change_date', 'change_time')).reverse();
    },
    filtered_artwork_location_logs: function filtered_artwork_location_logs() {
      var _this2 = this;

      var o = this.sorted_artwork_location_logs.filter(function (l) {
        return l.copy == _this2.selectedFilter;
      });
      console.log(this.selectedPackingFilter);
      console.log(o);
      if (this.selectedPackingFilter != 'all') {
        console.log('this.selectedPackingFilter');
        console.log(this.selectedPackingFilter.id);
        o = o.filter(function (l) {
          return l.artwork_packing_id == _this2.selectedPackingFilter.id;
        });
      }
      console.log(o);
      return o;
    },
    locations: function locations() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()([], this.$store.getters.enabled_locations).sort(dynamicSort('name'));
    },
    lastLocationLogArtwork: function lastLocationLogArtwork() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'artwork');
    },
    lastLocationLogMasterPhysical: function lastLocationLogMasterPhysical() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'master_physical');
    },
    lastLocationLogArchiveMaster: function lastLocationLogArchiveMaster() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'archive_master');
    },
    lastLocationLogAccessCopy: function lastLocationLogAccessCopy() {
      return this.getLastLog(this.artwork.artwork_location_logs, 'access_copy');
    },
    shouldUpdateArtworksLocation: function shouldUpdateArtworksLocation() {
      return !this.lastLocationLogArtwork || this.artwork_location_log.change_date > this.lastLocationLogArtwork.change_date;
    }
  },
  watch: {
    changeAllParts: function changeAllParts() {
      this.selectAllParts();
    },
    artwork_location_log: {
      handler: function handler(val) {
        console.log('watch');
        if (this.artwork_location_log.change_date) {
          this.artwork_location_log.old_location == this.old_location_from_date_and_copy;
        }
      },

      deep: true
    }
  },
  methods: {
    lastLocationLogArtworkPacking: function lastLocationLogArtworkPacking(id) {
      return this.getLastLog(this.artwork.artwork_location_logs, 'packings', id);
    },
    switch_change_dialog: function switch_change_dialog() {
      this.showUpload = !this.showUpload;
      if (this.showUpload) {
        this.artwork_location_log.old_location = this.old_location_from_date_and_copy;
      }
    },

    // get_old_location_from_date_and_copy() {
    //   // var current = { change_date: this.artwork_location_log.change_date, copy: this.artwork_location_log.copy, artwork_id: this.artwork.id }
    //   if(this.artwork_location_log.change_date && this.artwork_location_log.copy) {
    //     // this.artwork_location_log.old_location = this.get_old_location(current)
    //     if (this.artwork_location_log.copy == 'packings') {
    //         return 'Previous Location cannot be calculated for packings'
    //     } else if (['artwork','master_physical','archive_master'].includes(this.artwork_location_log.copy)) {
    //       var olderArtworkLogs = this.sorted_artwork_location_logs
    //         .filter(l => l.artwork_id = this.artwork_location_log.artwork_id
    //           && l.copy == this.artwork_location_log.copy
    //           && l.change_date < this.artwork_location_log.change_date)
    //       if (olderArtworkLogs.length > 1) {
    //         // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_location_log')
    //         var previous = olderArtworkLogs[0]
    //         if(previous) {
    //           this.artwork_location_log.old_location = previous.artwork_location_id
    //           return  previous.artwork_location_id
    //         } else {
    //           return 'no previous log for this packing'
    //         }
    //       } else {
    //         return 'no previous log for this packing'
    //       }
    //     }
    //   } else {
    //     return 'Copy and Change Date must be selected before calculating old Location'
    //   }
    // },
    get_old_location: function get_old_location(log) {
      if (log.copy == 'packings') {
        var packingLogs = this.sorted_artwork_location_logs.filter(function (l) {
          return l.artwork_packing_id = log.artwork_packing_id;
        });
        if (packingLogs.length > 1) {
          var indexOfcurrent = packingLogs.indexOf(log);
          var previous = packingLogs[indexOfcurrent + 1];
          return previous ? this.get_location_name(previous.artwork_location_id) : 'no previous log for this packing';
        } else {
          return 'no previous log for this packing';
        }
      } else if (['artwork', 'master_physical', 'archive_master'].includes(log.copy)) {
        var artworkLogs = this.sorted_artwork_location_logs.filter(function (l) {
          return l.artwork_id = log.artwork_id && l.copy == log.copy;
        });
        if (artworkLogs.length > 1) {
          var indexOfcurrent = artworkLogs.indexOf(log);
          var previous = artworkLogs[indexOfcurrent + 1];
          return previous ? this.get_location_name(previous.artwork_location_id) : 'no previous log for this packing';
        } else {
          return 'no previous log for this packing';
        }
      }
      // artwork_location_id
    },
    toggleCopyFilter: function toggleCopyFilter(c) {
      console.log(c);
      this.selectedFilter = c;
      if (c == 'packings') {
        this.selectedPackingFilter = 'all';
      }
    },
    togglePackingFilter: function togglePackingFilter(c) {
      this.selectedPackingFilter = c;
    },
    selectAllParts: function selectAllParts() {
      var _this3 = this;

      if (this.changeAllParts) {
        this.artwork.artwork_packings.forEach(function (p) {
          if (!_this3.selectedPackings.includes(p)) {
            _this3.selectedPackings.push(p);
          }
        });
      } else {
        this.selectedPackings = [];
      }
    },
    getLastLog: function getLastLog(logs, copy, id) {
      if (copy == 'packings') {
        if (logs && logs.length > 0) {
          var out = logs.filter(function (ll) {
            return ll.artwork_packing_id === id;
          }).sort(function (a, b) {
            if (a.change_date > b.change_date) {
              return -1;
            }
            if (a.change_date < b.change_date) {
              return 1;
            }
            return 0;
          })[0];
          if (out) {
            return out;
          } else {
            return '';
          }
        } else {
          return '';
        }
      } else {
        if (logs && logs.length > 0) {
          var out = logs.filter(function (ll) {
            return ll.copy === copy;
          }).sort(function (a, b) {
            if (a.change_date > b.change_date) {
              return -1;
            }
            if (a.change_date < b.change_date) {
              return 1;
            }
            return 0;
          })[0];
          if (out) {
            return out;
          } else {
            return '';
          }
        } else {
          return '';
        }
      }
    },
    getPacking: function getPacking(id) {
      console.log(id);
      console.log(this.artwork.artwork_packings);
      // get an array of all ids in this.artwork.artwork_packings
      var ids = this.artwork.artwork_packings.map(function (p) {
        return p.id;
      });
      // check if id is in the array
      if (ids.includes(id)) {
        // if yes, return the packing
        return this.artwork.artwork_packings.find(function (p) {
          return p.id === id;
        });
      } else {
        // if not, return empty packing
        return { packing: 'Not existing packing.', colli: 'Deleted?' };
      }
      // return this.artwork.artwork_packings.find((ap) => ap.id === id)
    },
    editLocation: function editLocation(l) {
      this.editedLocationLog = l;
      this.editDialog = true;
    },

    // location_name (id) {
    //   // console.log(id)
    //   if (id > 0) {
    //     var a = this.$store.state.locations.find(l => l.id === id)
    //     if (a) {
    //       return a.name
    //     } else {
    //       return 'Location not found in CMS.'
    //     }
    //   } else {
    //     return 'Location not found in CMS.'
    //   }
    // },
    download: function download() {},
    delete_log: function delete_log(item) {
      var r = confirm('Are you sure you want to delete this Location History entry?');
      if (r) {
        this.delete_log_action(item);
      }
    },
    delete_log_action: function delete_log_action(item) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_7__main__["serverBus"].$emit('showSnackbar', 'Deleting Location history.', 'black');
      var url = this.$globals.apiserver + '/artwork_location_logs/' + item.id + '.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(url, item).then(function (response) {
        _this4.$store.dispatch('updateArtwork', _this4.artwork.id);
        __WEBPACK_IMPORTED_MODULE_7__main__["serverBus"].$emit('showSnackbar', 'Location history Deleted.', 'green');
        _this4.errors = {};
        var index = _this4.artwork.artwork_location_logs.indexOf(item);
        if (index >= 0) _this4.artwork.artwork_location_logs.splice(index, 1);
        // const index = this.artwork.artwork_costs.indexOf(item)
        // this.artwork.artwork_location_logs.push(response.data);
        // @artwork.artwork_location_id = @artwork_location_log.id
        // elsif @artwork_location_log.copy = 'master_physical'
        // @artwork.master_physical_location_id = @artwork_location_log.id
        // elsif @artwork_location_log.copy = 'archive_master'
        // @artwork.archive_master_location_id = @artwork_location_log.id
        // elsif @artwork_location_log.copy = 'access_copy'
        // @artwork.access_copy_location_id = @artwork_location_log.id
        // this.active_artwork_location_logs = this.artwork.artwork_location_logs
        // this.$store.commit('DELETE_LOG', response.data)
        _this4.active_artwork_location_logs = _this4.$store.state.artwork_location_logs;
        // this.showUpload = !this.showUpload
        return false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_7__main__["serverBus"].$emit('showSnackbar', 'There was an Error deleting Cost.', 'red');
        // console.log(error)
        _this4.errors = error.response.data;
      });
    },
    showSaveDialog: function showSaveDialog() {
      this.saveDialog = true;
    },

    // save_artwork_location_log() {
    //   this.saveDialog = false
    //   // console.log('save_artwork_location_log')
    //   serverBus.$emit('showSnackbar', `Saving Location History Entry…`, 'green')

    //   // NASETUJEM LOG BASICS
    //   this.artwork_location_log.created_by = this.c_user.id
    //   this.artwork_location_log.artwork_id = this.artwork.id
    //   this.artwork_location_log.location_id = this.artwork_location_log.artwork_location_id

    //   if (this.artwork_location_log.storage === 'in') {
    //     this.artwork_location_log.storage_in = this.artwork_location_log.change_date
    //   } else {
    //     this.artwork_location_log.storage_out = this.artwork_location_log.change_date
    //   }

    //   // ZMENIM LOGS ARTWORKU NA POLE, AK BOLO NULL, ABY SOM MOHOL OD NEHO PRIDAVAT
    //   if (!this.artwork.artwork_location_logs) {
    //     this.artwork.artwork_location_logs = []
    //   }

    //   // this.all_artwork_location_logs.push(this.artwork_location_log)

    //   // IF I AM CHANGING PACKINGS - MUST BE SOME SELECTED
    //   if (
    //     this.artwork_location_log.copy === 'packings' &&
    //     this.selectedPackings &&
    //     this.selectedPackings.length > 0
    //   ) {

    //     // FOR EACH PACKING CREATE LOG AND CHANGE ITS LOCATION
    //     for (const sp in this.selectedPackings) {
    //       // console.log(this.selectedPackings[sp].id)
    //       this.artwork_location_log.artwork_packing_id = this.selectedPackings[sp].id

    //       // ADD LOG FOR THIS PACKING - PACKING ITSELF IS CHANGED ON THE SERVER
    //       // console.log(this.artwork_location_log)
    //       axios
    //         .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
    //           artwork_location_log: this.artwork_location_log,
    //         })
    //         .then((response) => {
    //           this.errors = {}
    //           // this.artwork.artwork_location_logs.push(response.data);
    //           // @artwork.artwork_location_id = @artwork_location_log.id
    //           // elsif @artwork_location_log.copy = 'master_physical'
    //           // @artwork.master_physical_location_id = @artwork_location_log.id
    //           // elsif @artwork_location_log.copy = 'archive_master'
    //           // @artwork.archive_master_location_id = @artwork_location_log.id
    //           // elsif @artwork_location_log.copy = 'access_copy'
    //           // @artwork.access_copy_location_id = @artwork_location_log.id
    //           // this.active_artwork_location_logs = this.artwork.artwork_location_logs
    //           // this.$store.commit('ADD_LOG', response.data)
    //           // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
    //           this.showUpload = !this.showUpload
    //         })
    //         .catch((error) => {
    //           console.log(error)
    //           // this.errors = error.response.data;
    //         })
    //       this.artwork_location_log.artwork_packing_id = null
    //     }

    //     // IF ALSO ARTWORK LOCATION IS SELECTED TO BE CHANGED
    //     if (this.changeArtworkLocation) {
    //       // console.log('changeArtworkLocation')

    //       // SAVE NEW ARTWORK LOCATION - only if change_date is later than latest log
    //       if (this.artwork_location_log.change_date > this.lastLocationLogArtwork.change_date) {
    //         // console.log(this.artwork_location_log.change_date)
    //         // console.log(this.lastLocationLogArtwork.change_date)
    //         axios
    //           .put(
    //             `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`,
    //             {
    //               artwork: {
    //                 artwork_location_id:
    //                   this.artwork_location_log.artwork_location_id,
    //               },
    //             }
    //           )
    //           .then((response) => {
    //             console.log('changeArtworkLocation response change artwork')

    //             this.errors = {}
    //             this.artwork.artwork_location_logs.push(response.data)

    //             // ON SAVE SUCCESS SET CURRENT ARTWORK'S LOCATION TO NEW LOCATION
    //             // if (this.artwork_location_log.copy === 'artwork') {
    //             //   this.artwork.artwork_location_id = this.artwork_location_log.artwork_location_id
    //             // } else if (this.artwork_location_log.copy === 'master_physical') {
    //             //   this.artwork.master_physical_location_id = this.artwork_location_log.artwork_location_id
    //             // } else if (this.artwork_location_log.copy === 'archive_master') {
    //             //   this.artwork.archive_master_location_id = this.artwork_location_log.artwork_location_id
    //             // } else if (this.artwork_location_log.copy === 'access_copy') {
    //             //   this.artwork.access_copy_location_id = this.artwork_location_log.artwork_location_id
    //             // }
    //             // this.$store.commit('ADD_LOG', response.data)
    //             // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
    //             this.changeArtworkLocation = false
    //           })
    //       }

    //       // ADD LOG FOR ARTWORK
    //       this.artwork_location_log.copy = 'artwork'
    //       axios
    //         .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
    //           artwork_location_log: this.artwork_location_log,
    //         })
    //         .then((response) => {
    //           console.log('changeArtworkLocation response add log')

    //           this.errors = {}
    //           this.artwork.artwork_location_logs.push(response.data)
    //           this.artwork.artwork_location_id = this.artwork_location_log.artwork_location_id
    //           this.$store.commit('ADD_LOG', response.data)
    //           this.active_artwork_location_logs = this.$store.state.artwork_location_logs
    //           // this.showUpload = !this.showUpload
    //           this.artwork_location_log = {
    //             created_by: this.c_user.id,
    //             storage: 'in',
    //             note: '',
    //             change_date: '',
    //             copy: 'artwork',
    //             shipper: '',
    //             reason: '',
    //             artwork_location_id: '',
    //             artwork_packing_id: '',
    //           }
    //         })
    //         .catch((error) => {
    //           // console.log(error)
    //         })
    //       this.changeAllParts = false
    //     }

    //     this.artwork_location_log = {
    //       created_by: this.c_user.id,
    //       storage: 'in',
    //       note: '',
    //       change_date: '',
    //       copy: 'artwork',
    //       shipper: '',
    //       reason: '',
    //       artwork_location_id: '',
    //       artwork_packing_id: '',
    //     }
    //     this.$store.dispatch('loadPackings')
    //     this.$emit('getArtwork')
    //   } else {
    //     console.log('single')
    //     // ADD LOG FOR ARTWORK
    //     axios
    //       .post(`${this.$globals.apiserver}/artwork_location_logs.json`, {
    //         artwork_location_log: this.artwork_location_log,
    //       })
    //       .then((response) => {
    //         this.errors = {}
    //         this.artwork.artwork_location_logs.push(response.data)
    //         if (this.artwork_location_log.copy === 'artwork') {
    //           this.artwork.artwork_location_id =
    //             this.artwork_location_log.artwork_location_id
    //         } else if (this.artwork_location_log.copy === 'master_physical') {
    //           this.artwork.master_physical_location_id =
    //             this.artwork_location_log.artwork_location_id
    //         } else if (this.artwork_location_log.copy === 'archive_master') {
    //           this.artwork.archive_master_location_id =
    //             this.artwork_location_log.artwork_location_id
    //         } else if (this.artwork_location_log.copy === 'access_copy') {
    //           this.artwork.access_copy_location_id =
    //             this.artwork_location_log.artwork_location_id
    //         }
    //         this.$store.commit('ADD_LOG', response.data)
    //         this.active_artwork_location_logs =
    //           this.$store.state.artwork_location_logs
    //         this.showUpload = !this.showUpload
    //         this.artwork_location_log = {
    //           created_by: this.c_user.id,
    //           storage: 'in',
    //           note: '',
    //           change_date: '',
    //           copy: 'artwork',
    //           shipper: '',
    //           reason: '',
    //           artwork_location_id: '',
    //           artwork_packing_id: '',
    //         }
    //       })
    //       .catch((error) => {
    //         // console.log(error)
    //       })

    //     this.$emit('getArtwork')
    //   }
    //   this.selectedPackings = []
    //   this.editDialog = false
    //   // var aartwork_location_log = Object.keys(this.artwork_location_log).forEach(k => this.artwork_location_log[k]='')
    //   // console.log(aartwork_location_log)
    // },
    save_artwork_location_log: function save_artwork_location_log() {
      this.saveDialog = false;
      __WEBPACK_IMPORTED_MODULE_7__main__["serverBus"].$emit('showSnackbar', 'Saving Location History Entry\u2026', 'green');

      this.setupLogBasics();

      if (this.artwork_location_log.copy === 'packings') {
        if (this.selectedPackings && this.selectedPackings.length > 0) {
          this.handlePackingsUpdate();
          if (this.changeArtworkLocation) {
            this.handleArtworkLocationChange();
          }
        } else {
          console.log('no packings');
        }
      } else if (this.artwork_location_log.copy === 'artwork') {
        this.handleArtworkLocationChange();
      }

      this.resetStateAfterSave();
      this.$store.dispatch('loadPackings');
      this.$emit('getArtwork');
    },
    setupLogBasics: function setupLogBasics() {
      // Setting up basic log details
      console.log('setupLogBasics');
      this.artwork_location_log.created_by = this.c_user.id;
      this.artwork_location_log.artwork_id = this.artwork.id;
      // this.artwork_location_log.location_id = this.artwork_location_log.artwork_location_id;
      this.artwork_location_log.storage_in = this.artwork_location_log.storage === 'in' ? this.artwork_location_log.change_date : null;
      this.artwork_location_log.storage_out = this.artwork_location_log.storage !== 'in' ? this.artwork_location_log.change_date : null;
      this.artwork.artwork_location_logs = this.artwork.artwork_location_logs || [];
      // update vuex state
      // this.$store.commit('ADD_LOG', this.artwork_location_log);
      //update vuex artworks state
      // this.$store.dispatch('updateArtwork', this.artwork.id);
    },
    handlePackingsUpdate: function handlePackingsUpdate() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var updatePromises;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log('handlePackingsUpdate');

                if (!(_this5.artwork_location_log.copy === 'packings' && _this5.selectedPackings && _this5.selectedPackings.length > 0)) {
                  _context.next = 5;
                  break;
                }

                updatePromises = _this5.selectedPackings.map(function (packing) {
                  return _this5.createPackingLog(packing);
                });
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all(updatePromises);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    createPackingLog: function createPackingLog(packing) {
      console.log('createPackingLog');
      var log = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.artwork_location_log, { artwork_packing_id: packing.id });
      return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(this.$globals.apiserver + '/artwork_location_logs.json', { artwork_location_log: log });
    },
    handleArtworkLocationChange: function handleArtworkLocationChange() {
      console.log('handleArtworkLocationChange');
      if (this.artwork_location_log.change_date > this.lastLocationLogArtwork.change_date) {
        this.updateArtworkLocation();
        this.addArtworkLog();
      }
    },
    updateArtworkLocation: function updateArtworkLocation() {
      var _this6 = this;

      console.log('updateArtworkLocation');
      // API call to update artwork location
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(this.$globals.apiserver + '/artworks/' + this.artwork.id + '.json', {
        artwork: {
          artwork_location_id: this.artwork_location_log.artwork_location_id
        }
      }).then(function (response) {
        console.log('changeArtworkLocation response change artwork');

        _this6.errors = {};
        _this6.artwork.artwork_location_logs.push(response.data);

        // ON SAVE SUCCESS SET CURRENT ARTWORK'S LOCATION TO NEW LOCATION
        // if (this.artwork_location_log.copy === 'artwork') {
        //   this.artwork.artwork_location_id = this.artwork_location_log.artwork_location_id
        // } else if (this.artwork_location_log.copy === 'master_physical') {
        //   this.artwork.master_physical_location_id = this.artwork_location_log.artwork_location_id
        // } else if (this.artwork_location_log.copy === 'archive_master') {
        //   this.artwork.archive_master_location_id = this.artwork_location_log.artwork_location_id
        // } else if (this.artwork_location_log.copy === 'access_copy') {
        //   this.artwork.access_copy_location_id = this.artwork_location_log.artwork_location_id
        // }
        // this.$store.commit('ADD_LOG', response.data)
        // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
        _this6.changeArtworkLocation = false;
      }).catch(function (error) {
        _this6.errors = error.response.data;
        console.log(error);
      });
    },
    addArtworkLog: function addArtworkLog() {
      var _this7 = this;

      console.log('addArtworkLog');
      // API call to add a log for artwork
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(this.$globals.apiserver + '/artwork_location_logs.json', {
        artwork_location_log: this.artwork_location_log
      }).then(function (response) {
        _this7.errors = {};
        // this.artwork.artwork_location_logs.push(response.data);
        // @artwork.artwork_location_id = @editedLocationLog.id
        // elsif @editedLocationLog.copy = 'master_physical'
        // @artwork.master_physical_location_id = @editedLocationLog.id
        // elsif @editedLocationLog.copy = 'archive_master'
        // @artwork.archive_master_location_id = @editedLocationLog.id
        // elsif @editedLocationLog.copy = 'access_copy'
        // @artwork.access_copy_location_id = @editedLocationLog.id
        // this.active_artwork_location_logs = this.artwork.artwork_location_logs
        _this7.$store.commit('ADD_LOG', response.data);
        _this7.active_artwork_location_logs = _this7.$store.state.artwork_location_logs;
        _this7.showUpload = !_this7.showUpload;
      }).catch(function (error) {
        // console.log(error)
        // this.errors = error.response.data;
      });
    },
    resetStateAfterSave: function resetStateAfterSave() {
      this.artwork_location_log = this.getDefaultLogObject();
      this.selectedPackings = [];
      this.editDialog = false;
    },
    getDefaultLogObject: function getDefaultLogObject() {
      return {
        created_by: this.c_user.id,
        storage: 'in',
        note: '',
        change_date: '',
        copy: 'artwork',
        shipper: '',
        reason: '',
        artwork_location_id: '',
        artwork_packing_id: ''
      };
    },


    // END OF GENERATED CODE


    save_edited_artwork_location_log: function save_edited_artwork_location_log() {
      var _this8 = this;

      this.editedLocationLog.last_update_by = this.c_user.id;
      this.editedLocationLog.artwork_id = this.artwork.id;
      if (this.editedLocationLog.storage === 'in') {
        this.editedLocationLog.storage_in = this.editedLocationLog.change_date;
      } else {
        this.editedLocationLog.storage_out = this.editedLocationLog.change_date;
      }
      __WEBPACK_IMPORTED_MODULE_7__main__["serverBus"].$emit('showSnackbar', 'Saving Location History Entry\u2026', 'green');

      if (this.editedLocationLog.copy === 'packings' && this.selectedPackings && this.selectedPackings.length > 0) {
        for (var sp in this.selectedPackings) {
          this.editedLocationLog.artwork_packing_id = this.selectedPackings[sp].id;
          __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(this.$globals.apiserver + '/artwork_location_logs.json', {
            artwork_location_log: this.editedLocationLog
          }).then(function (response) {
            _this8.errors = {};
            // this.artwork.artwork_location_logs.push(response.data);
            // @artwork.artwork_location_id = @editedLocationLog.id
            // elsif @editedLocationLog.copy = 'master_physical'
            // @artwork.master_physical_location_id = @editedLocationLog.id
            // elsif @editedLocationLog.copy = 'archive_master'
            // @artwork.archive_master_location_id = @editedLocationLog.id
            // elsif @editedLocationLog.copy = 'access_copy'
            // @artwork.access_copy_location_id = @editedLocationLog.id
            // this.active_artwork_location_logs = this.artwork.artwork_location_logs
            _this8.$store.commit('UPDATE_LOG', response.data);
            _this8.active_artwork_location_logs = _this8.$store.state.artwork_location_logs;
            _this8.showUpload = !_this8.showUpload;
          }).catch(function (error) {
            // console.log(error)
            // this.errors = error.response.data;
          });
        }
        this.artwork_location_log = {
          storage: 'in',
          note: '',
          change_date: '',
          copy: 'artwork',
          shipper: '',
          reason: '',
          artwork_location_id: '',
          artwork_packing_id: ''
        };
      } else {
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(this.$globals.apiserver + '/artwork_location_logs/' + this.editedLocationLog.id + '.json', {
          artwork_location_log: this.editedLocationLog
        }).then(function (response) {
          _this8.$emit('getArtwork');
          _this8.errors = {};
          _this8.artwork.artwork_location_logs = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this8.artwork.artwork_location_logs.filter(function (element) {
            return element.id !== response.data.id;
          })), [response.data]);
          if (_this8.editedLocationLog.copy === 'artwork') {
            _this8.artwork.artwork_location_id = _this8.editedLocationLog.artwork_location_id;
          } else if (_this8.editedLocationLog.copy === 'master_physical') {
            _this8.artwork.master_physical_location_id = _this8.editedLocationLog.artwork_location_id;
          } else if (_this8.editedLocationLog.copy === 'archive_master') {
            _this8.artwork.archive_master_location_id = _this8.editedLocationLog.artwork_location_id;
          } else if (_this8.editedLocationLog.copy === 'access_copy') {
            _this8.artwork.access_copy_location_id = _this8.editedLocationLog.artwork_location_id;
          }
          // this.$store.commit("UPDATE_LOG", response.data);
          _this8.active_artwork_location_logs = _this8.$store.state.artwork_location_logs;
          // this.showUpload = !this.showUpload;
          _this8.editedLocationLog = {
            storage: 'in',
            note: '',
            change_date: '',
            change_time: '',
            copy: 'artwork',
            shipper: '',
            reason: '',
            artwork_location_id: '',
            artwork_packing_id: ''
          };
          _this8.editDialog = false;
        }).catch(function (error) {
          // console.log(error)
        });
      }
      // var aartwork_location_log = Object.keys(this.artwork_location_log).forEach(k => this.artwork_location_log[k]='')
      // console.log(aartwork_location_log)
    }
  }
});

/***/ }),

/***/ "RtTc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-snackbar',{attrs:{"right":"","timeout":2500,"color":_vm.snackbar_color,"top":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(_vm._s(_vm.snackbar_text))]),_vm._v(" "),_c('v-layout',{staticClass:"mt-4 ml-4",attrs:{"column":""}},[_c('header-elements',{attrs:{"icon":"mdi-information-variant","title":"Information Carriers"},on:{"showUpload":function($event){_vm.showUpload = !_vm.showUpload}}}),_vm._v(" "),(this.information_carriers)?_c('elements-table',{attrs:{"items":_vm.ics,"showUpload":_vm.showUpload,"title":"Information Carrier"},on:{"showUpload":function($event){_vm.showUpload = !_vm.showUpload}}}):_vm._e(),_vm._v(" "),(_vm.showUpload)?_c('v-flex',[_c('v-container',{staticClass:"elevation-2",attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('h4',{staticClass:"headline xs12"},[_vm._v("Add new Information Carrier")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.showUpload),expression:"showUpload"}],staticClass:"pt-0 mt-0 mb-0 xs12 right"},[_c('v-btn',{staticClass:"pt-0 mt-0 mb-3",attrs:{"icon":""},on:{"click":function($event){_vm.showUpload = !_vm.showUpload}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"label":"Title"},model:{value:(_vm.information_carrier.title),callback:function ($$v) {_vm.$set(_vm.information_carrier, "title", $$v)},expression:"information_carrier.title"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6"},[_c('v-text-field',{attrs:{"label":"Brand"},model:{value:(_vm.information_carrier.brand),callback:function ($$v) {_vm.$set(_vm.information_carrier, "brand", $$v)},expression:"information_carrier.brand"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6"},[_c('v-text-field',{attrs:{"label":"Type and Model"},model:{value:(_vm.information_carrier.type_and_model),callback:function ($$v) {_vm.$set(_vm.information_carrier, "type_and_model", $$v)},expression:"information_carrier.type_and_model"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('h3',{staticClass:"subheadline xs12"},[_vm._v("\n              Type of Information Carrier | Specifications | Technology\n            ")])]),_vm._v(" "),_c('v-flex',{staticClass:"xs12 my-0 mt-3 pb-0 mb-0"},[_c('v-select',{staticClass:"ml-1",attrs:{"label":"","items":[
                'optical_films',
                'optical_discs',
                'mechanical',
                'magnetic',
                'electronical',
                'unknown',
                'other'
              ]},model:{value:(_vm.information_carrier.ic_type),callback:function ($$v) {_vm.$set(_vm.information_carrier, "ic_type", $$v)},expression:"information_carrier.ic_type"}})],1),_vm._v(" "),(_vm.information_carrier.ic_type == 'optical_films')?_c('v-flex',{staticClass:"xs12 my-0 py-02 mx-5"},[_c('v-select',{staticClass:"ml-3",attrs:{"label":"Optical Film","items":_vm.constants.OPTICAL_FILMS,"item-value":"id","item-text":"name"},model:{value:(_vm.information_carrier.optical_films),callback:function ($$v) {_vm.$set(_vm.information_carrier, "optical_films", $$v)},expression:"information_carrier.optical_films"}})],1):_vm._e(),_vm._v(" "),(_vm.type == 'optical_discs')?_c('v-flex',{attrs:{"xs122":"","mx-5":""}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.information_carrier.optical_disc),callback:function ($$v) {_vm.$set(_vm.information_carrier, "optical_disc", $$v)},expression:"information_carrier.optical_disc"}},_vm._l((_vm.constants.OPTICAL_DISCS),function(vs){return _c('v-radio',{key:vs.id,staticClass:"ml-3",attrs:{"value":vs.id,"label":vs.name,"color":"black"}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.type == 'mechanical')?_c('v-flex',{attrs:{"xs122":"","mx-5":""}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.information_carrier.mechanical),callback:function ($$v) {_vm.$set(_vm.information_carrier, "mechanical", $$v)},expression:"information_carrier.mechanical"}},_vm._l((_vm.constants.MECHANICAL),function(vs){return _c('v-radio',{key:vs.id,staticClass:"ml-3",attrs:{"value":vs.id,"label":vs.name,"color":"black"}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.type == 'magnetic')?_c('v-flex',{attrs:{"xs122":"","mx-5":""}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.information_carrier.magnetic),callback:function ($$v) {_vm.$set(_vm.information_carrier, "magnetic", $$v)},expression:"information_carrier.magnetic"}},_vm._l((_vm.constants.MAGNETIC),function(vs){return _c('v-radio',{key:vs.id,staticClass:"ml-3",attrs:{"value":vs.id,"label":vs.name,"color":"black"}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.type == 'electronical')?_c('v-flex',{attrs:{"xs12":"","mx-5":""}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.information_carrier.electronical),callback:function ($$v) {_vm.$set(_vm.information_carrier, "electronical", $$v)},expression:"information_carrier.electronical"}},_vm._l((_vm.constants.ELECTRONICAL),function(vs){return _c('v-radio',{key:vs.id,staticClass:"ml-3",attrs:{"value":vs.id,"label":vs.name,"color":"black"}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.type == 'unknown')?_c('v-flex',{staticClass:"xs12 mx-5"},[_c('v-text-field',{attrs:{"label":"Unknown"},model:{value:(_vm.information_carrier.unknown),callback:function ($$v) {_vm.$set(_vm.information_carrier, "unknown", $$v)},expression:"information_carrier.unknown"}})],1):_vm._e(),_vm._v(" "),(_vm.type == 'other')?_c('v-flex',{staticClass:"xs12 mx-5"},[_c('v-text-field',{attrs:{"label":"Other"},model:{value:(_vm.information_carrier.other),callback:function ($$v) {_vm.$set(_vm.information_carrier, "other", $$v)},expression:"information_carrier.other"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{staticClass:"ml-2",attrs:{"label":"Material | Carrier Base"},model:{value:(_vm.information_carrier.material),callback:function ($$v) {_vm.$set(_vm.information_carrier, "material", $$v)},expression:"information_carrier.material"}},_vm._l((_vm.constants.MATERIALS),function(vs){return _c('v-radio',{key:vs.id,staticClass:"ml-5 pl-2",attrs:{"value":vs.id,"label":vs.name,"color":"black"}})}),1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Specifications"},model:{value:(_vm.information_carrier.specifications),callback:function ($$v) {_vm.$set(_vm.information_carrier, "specifications", $$v)},expression:"information_carrier.specifications"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6 pr-3"},[_c('v-text-field',{attrs:{"label":"Length"},model:{value:(_vm.information_carrier.length),callback:function ($$v) {_vm.$set(_vm.information_carrier, "length", $$v)},expression:"information_carrier.length"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 md6"},[_c('v-text-field',{attrs:{"label":"Number of Parts"},model:{value:(_vm.information_carrier.number_of_parts),callback:function ($$v) {_vm.$set(_vm.information_carrier, "number_of_parts", $$v)},expression:"information_carrier.number_of_parts"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"label":"Associated Devices"},model:{value:(_vm.information_carrier.associated_devices),callback:function ($$v) {_vm.$set(_vm.information_carrier, "associated_devices", $$v)},expression:"information_carrier.associated_devices"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-btn',{staticClass:"right",attrs:{"dark":""},on:{"click":_vm.add}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{staticClass:"right",on:{"click":function($event){_vm.showUpload = !_vm.showUpload}}},[_vm._v("cancel")])],1)],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "RwQT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5 mx-0 px-4 editBG",staticStyle:{"border-top":"solid 1px"}},[_c('h2',{staticClass:"mt-3 mx-2"},[_vm._v("Create a Todo ")]),_vm._v(" "),_c('v-layout',{staticClass:"mx-0 mt-0 px-0 pt-2 mb-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":"","p-2":""}},[_c('v-text-field',{staticClass:"ml-2",attrs:{"name":"description","label":"Description *"},model:{value:(_vm.todo.title),callback:function ($$v) {_vm.$set(_vm.todo, "title", $$v)},expression:"todo.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":"","px-2":""}},[_c('v-menu',{ref:"menu2",attrs:{"return-value":_vm.todo.deadline,"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","nudge-right":0,"lazy":""},on:{"update:returnValue":function($event){return _vm.$set(_vm.todo, "deadline", $event)},"update:return-value":function($event){return _vm.$set(_vm.todo, "deadline", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","prepend-inner-icon":"event","readonly":"","label":"Deadline"},slot:"activator",model:{value:(_vm.todo.deadline),callback:function ($$v) {_vm.$set(_vm.todo, "deadline", $$v)},expression:"todo.deadline"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"min":_vm.format_date(Date.now()),"color":"black","first-day-of-week":"1"},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.todo.deadline)}},model:{value:(_vm.todo.deadline),callback:function ($$v) {_vm.$set(_vm.todo, "deadline", $$v)},expression:"todo.deadline"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":"","pl-1":"","pr-2":""}},[_c('v-menu',{ref:"menu3",attrs:{"return-value":_vm.todo.reminder,"close-on-content-click":false,"transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","nudge-right":30,"lazy":"","landscape":""},on:{"update:returnValue":function($event){return _vm.$set(_vm.todo, "reminder", $event)},"update:return-value":function($event){return _vm.$set(_vm.todo, "reminder", $event)}},model:{value:(_vm.menu3),callback:function ($$v) {_vm.menu3=$$v},expression:"menu3"}},[_c('v-text-field',{attrs:{"slot":"activator","prepend-inner-icon":"event","readonly":"","label":"Reminder"},slot:"activator",model:{value:(_vm.todo.reminder),callback:function ($$v) {_vm.$set(_vm.todo, "reminder", $$v)},expression:"todo.reminder"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"color":"black","min":_vm.format_date(Date.now()),"scrollable":"","first-day-of-week":"1"},on:{"input":function($event){return _vm.$refs.menu3.save(_vm.todo.reminder)}},model:{value:(_vm.todo.reminder),callback:function ($$v) {_vm.$set(_vm.todo, "reminder", $$v)},expression:"todo.reminder"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{staticClass:"mx-2 my-0",attrs:{"auto-grow":"","box":"","rows":"1","name":"note","label":"Note"},model:{value:(_vm.todo.description),callback:function ($$v) {_vm.$set(_vm.todo, "description", $$v)},expression:"todo.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-2":""}},[_c('v-autocomplete',{attrs:{"prepend-inner-icon":"person","background-color":"grey lighten-2","items":_vm.team_d,"chips":"","box":"","clearable":"","multiple":"","deletable-chips":"","label":"Assigned to","item-text":"abb","item-value":"id"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi",attrs:{"selected":data.selected,"color":"white","close":"","small":""},on:{"input":function($event){return _vm.remove(data.item)}}},[_c('v-avatar',{attrs:{"color":"black"}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(data.item.abb))])]),_vm._v("\n              "+_vm._s(data.item.firstname)+" "+_vm._s(data.item.lastname)+"\n            ")],1)]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(data.item.abb)+" - "+_vm._s(data.item.firstname)+" "+_vm._s(data.item.lastname))])],1)]]}}]),model:{value:(_vm.todo.user_ids),callback:function ($$v) {_vm.$set(_vm.todo, "user_ids", $$v)},expression:"todo.user_ids"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":"","mt-2":""}},[_c('v-text-field',{staticClass:"ml-2 xs2",attrs:{"name":"frequency","label":"Repeat every …","prepend-inner-icon":"loop","hide-details":""},model:{value:(_vm.todo.frequency),callback:function ($$v) {_vm.$set(_vm.todo, "frequency", $$v)},expression:"todo.frequency"}}),_vm._v(" "),(_vm.todo.repeat)?_c('div',{staticClass:"pl-2 red--text"},[_vm._v("Must be filled!")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":"","mt-4":"","ml-3":""}},[_c('v-btn-toggle',{staticClass:"mt-0",attrs:{"small":""},model:{value:(_vm.todo.repeat),callback:function ($$v) {_vm.$set(_vm.todo, "repeat", $$v)},expression:"todo.repeat"}},[_c('v-btn',{key:"group1",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"day","value":"day"}},[_c('span',[_vm._v("Days")])]),_vm._v(" "),_c('v-btn',{key:"group2",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"month","value":"month"}},[_c('span',[_vm._v("Months")])]),_vm._v(" "),_c('v-btn',{key:"group3",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"year","value":"year"}},[_c('span',[_vm._v("Years")])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"pl-2":"","mt-3":"","xs12":""}},[_c('v-autocomplete',{attrs:{"search-input":_vm.search,"prepend-inner-icon":"photo_library","background-color":"grey lighten-2","color":"black","chips":"","box":"","clearable":"","multiple":"","deletable-chips":"","items":_vm.artworks,"item-text":function (item) { return item.title +
              ', ' +
              item.accession_number +
              ', ' +
              item.name; },"item-value":"id","label":"Select Artworks related to this Todo *","menu-props":"{\"closeOnClick\":true, \"closeOnContentClick\":false, \"openOnClick\":false, \"maxHeight\":600}"},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi white--text chip--select-multi",attrs:{"selected":data.selected,"close":"","small":"","color":"black"},on:{"input":function($event){return _vm.remove_artwork(data.item)}}},[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.title)}}),_vm._v(" \n              "),_c('span',[_vm._v(_vm._s(data.item.accession_number)+" ")]),_vm._v(" \n              "),_c('strong',{domProps:{"innerHTML":_vm._s(
                  data.item.artist
                    ? data.item.artist.name
                    : data.item.name
                )}})])]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.title)}}),_vm._v(" \n                "),_c('span',[_vm._v(_vm._s(data.item.accession_number)+" ")]),_vm._v(" \n                "),_c('strong',{domProps:{"innerHTML":_vm._s(data.item.name)}})]),_vm._v(" "),_c('v-list-tile-sub-title')],1)]}}]),model:{value:(_vm.selected_artworks),callback:function ($$v) {_vm.selected_artworks=$$v},expression:"selected_artworks"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 layout my-2"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mb-3",attrs:{"small":"","flat":""},on:{"click":function($event){}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"small":"","color":"black","disabled":_vm.selected_artworks.length == 0 || _vm.todo.title == ''},on:{"click":_vm.save_todo}},[_vm._v("create todo for selected artworks")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "RyBy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions_auth__ = __webpack_require__("+4WN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import { AUTH_LOGOUT } from '@/store/actions/auth'

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'login',
  data: function data() {
    return {
      username: '',
      password: '',
      e1: true,
      overlay: false,
      error: false
    };
  },

  methods: {
    login: function login() {
      var _this = this;

      this.error = false;
      this.overlay = true;
      var username = this.username,
          password = this.password;

      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_1__store_actions_auth__["c" /* AUTH_REQUEST */], { username: username, password: password }).then(function (r) {
        // console.log(r)
        _this.overlay = false;
        // this.$router.push('/facts')
        var u = r.user;
        // console.log(u)
        if (u.after_login_page) {
          _this.$router.push({ path: u.after_login_page });
        } else {
          _this.$router.push({ path: '/artworks/ownership/collection' });
        }
      }).catch(function () {
        _this.overlay = false;
        _this.error = 'Wrong Login. Please check your credentials and keyboard layout.';
      });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === 'loading';
    },
    name: function name(state) {
      return state.user.profile.title + ' ' + state.user.profile.name;
    }
  }), {
    canLogin: function canLogin() {
      return !(!!this.username && !!this.password);
    }
  })
});

/***/ }),

/***/ "Rzgd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "Rzkq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.f_field.headline)?_c('div',{staticClass:"mt-1 pt-0 mb-2"},[_c('v-flex',{staticClass:"pl-3 xs12",staticStyle:{"background-color":"#222","color":"#eee","line-height":"28px"}},[_c('h3',{staticClass:"xs12 flex",staticStyle:{"font-size":"16px","text-weigth":"100","height":"28px"}},[_c('span',[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),(!_vm.f_field.no_dynamic)?_c('v-menu',{staticClass:"right mb-0",attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"mt-0 mb-0 pt-0",attrs:{"slot":"activator","icon":"","small":"","dark":""},slot:"activator"},[_c('v-icon',{staticClass:"mt-0 pt-0",attrs:{"dark":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.dynamic_field_list),function(item){return _c('div',{key:item.name},[_c('v-list-tile',{on:{"click":function($event){return _vm.add_field(item.name)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}})],1),_vm._v(" "),(item.separator)?_c('v-divider',{staticClass:"mx-3",attrs:{"color":"black"}}):_vm._e()],1)}),0)],1):_vm._e()],1)])],1):(_vm.f_field.subheadline)?_c('div',{staticClass:"mt-2 mb-1"},[_c('v-flex',{staticClass:"px-3 pb-0 xs12",staticStyle:{"background-color":"#ccc","color":"222","line-height":"24px"}},[_c('h3',{staticClass:"xs12 flex font-weight-normal subheading",staticStyle:{"text-size":"10px !important","text-weigth":"100"}},[_vm._v("\n        "+_vm._s(_vm.f_field.title)+"\n      ")])])],1):_vm._e(),_vm._v(" "),(_vm.f_field.component &&
    ([
      'deaccession_date',
      'comment_on_deaccession',
      'new_ownership',
      'deaccession_price_offer',
      'deaccession_price_paid',
      'invoice_deaccession_papers' ].includes(_vm.f_field.name)
      ? _vm.f_artwork.deaccessioned == 1
      : true)
    )?_c('div',{staticClass:"mt-2 mb-2 mx-0"},[_c(_vm.f_field.component,{tag:"component",attrs:{"uploadCategory":_vm.f_field.category,"artwork":_vm.f_artwork,"name":_vm.f_field.name,"field":_vm.f_field,"film":_vm.film},on:{"getArtwork":_vm.getArtwork}})],1):_c('div',[(_vm.field_type == 'text-short')?_c('v-flex',{attrs:{"px-3":"","my-0":"","py-0":""}},[_c('v-flex',{attrs:{"my-0":"","py-0":""}},[_c('label',{staticClass:"labelClass"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('v-text-field',{ref:_vm.f_field.name,attrs:{"error":_vm.f_field.obligatory && _vm.current_value == '',"browser-autocomplete":"off","readonly":!_vm.isEditing,"name":_vm.f_field.name,"value":_vm.f_artwork[_vm.f_field.name] ? _vm.f_artwork[_vm.f_field.name] : '',"hint":_vm.hint,"hide-details":"","suffix":_vm.f_field.suffix,"mask":_vm.f_field.mask},on:{"keyup":[function($event){return _vm.check_an($event.target.value)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.saveOrEdit.apply(null, arguments)}]},nativeOn:{"input":function($event){return _vm.$emit('input', $event.target.value)}},scopedSlots:_vm._u([{key:"append",fn:function(){return [(_vm.isEditing && !_vm.an_exists)?_c('v-btn',{staticClass:"mb-0 py-0",staticStyle:{"width":"10px !important","height":"10px !important"},attrs:{"flat":"","small":"","icon":"","color":"green"},on:{"click":_vm.saveOrEdit}},[_c('v-icon',{staticClass:"ma-0 pa-0",staticStyle:{"width":"10px !important","height":"10px !important"},attrs:{"small":""}},[_vm._v("save")])],1):_vm._e(),_vm._v(" "),(_vm.isEditing)?_c('v-btn',{staticClass:"mb-0 py-0",staticStyle:{"width":"10px !important","height":"10px !important"},attrs:{"flat":"","small":"","icon":"","color":"red"},on:{"click":_vm.cancel}},[_c('v-icon',{staticClass:"my-0 py-0",staticStyle:{"height":"10px !important"},attrs:{"small":""}},[_vm._v("cancel")])],1):_c('v-btn',{staticClass:"mb-0 py-0",staticStyle:{"width":"10px !important","height":"10px !important"},attrs:{"flat":"","small":"","icon":"","color":"grey darken-2"},on:{"click":_vm.saveOrEdit}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit")])],1)]},proxy:true}],null,false,4195187427)}),_vm._v(" "),_c('label',{staticClass:"labelClass"},[_vm._v(_vm._s(_vm.f_field.title)),(_vm.f_field.obligatory)?_c('span',[_vm._v(" *")]):_vm._e()]),_vm._v(" "),(_vm.f_field.hint)?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_c('v-icon',_vm._g({staticClass:"mr-3",attrs:{"small":""}},data.on),[_vm._v("error_outline")])]}}],null,false,4273919000)},[_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.f_field.hint)}})]):_vm._e(),_vm._v(" "),(_vm.an_exists)?_c('div',{staticClass:"red--text"},[_vm._v("\n          This accession number already exists!\n        ")]):_vm._e(),_vm._v(" "),(_vm.saved)?_c('div',{staticClass:"ml-3"},[_vm._v("Value was saved!")]):_vm._e(),_vm._v(" "),(_vm.cannotSave)?_c('div',{staticClass:"ml-3"},[_vm._v("\n          Value already exists! Cannot save!\n        ")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.field_type == 'text-auto')?_c('v-flex',{attrs:{"px-3":"","my-0":"","py-0":""}},[(_vm.f_artwork[_vm.f_field.name] != '' && _vm.f_artwork[_vm.f_field.name])?_c('v-flex',{attrs:{"my-0":"","py-0":""}},[_c('label',{staticClass:"labelClass"},[_vm._v(_vm._s(_vm.f_field.title)+": ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.f_artwork[_vm.f_field.name]))])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.field_type == 'currency')?_c('v-flex',{attrs:{"px-3":"","d-flex":""}},[_c('v-flex',{attrs:{"xs6":""}},[(!_vm.isEditing)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{staticClass:"subheading border mt-3 pb-1 mr-3 xs12",staticStyle:{"padding-top":"3px","margin-bottom":"2px"}},[_c('span',[_vm._v(_vm._s(_vm.formatMoney(
                _vm.f_artwork[_vm.f_field.name] ? _vm.f_artwork[_vm.f_field.name] : ''
              )))]),_vm._v(" "),(!_vm.f_field.disabled)?_c('span',[_c('v-btn',{staticClass:"right mr-0 mb-3 mt-0 pt-0",attrs:{"flat":"","small":"","icon":""},on:{"click":_vm.saveOrEdit}},[(_vm.isEditing)?_c('v-icon',{attrs:{"small":"","color":"green darken-1"}},[_vm._v("save")]):_vm._e(),_vm._v(" "),(!_vm.isEditing)?_c('v-icon',{attrs:{"small":"","color":"grey darken-1"}},[_vm._v("edit")]):_vm._e()],1)],1):_vm._e()]),_vm._v(" "),_c('label',{staticClass:"labelClass"},[_vm._v(_vm._s(_vm.f_field.title))])],1):_c('v-flex',{attrs:{"xs12":"","pr-3":""}},[_c('v-text-field',{ref:_vm.f_field.name,attrs:{"mask":_vm.f_field.mask,"readonly":!_vm.isEditing || _vm.f_field.disabled,"name":_vm.f_field.name,"value":_vm.f_artwork[_vm.f_field.name] ? _vm.f_artwork[_vm.f_field.name] : '',"hint":("" + (_vm.f_field.title)),"loading":_vm.saving,"suffix":_vm.f_field.suffix,"append-outer-icon":_vm.isEditing ? 'save' : 'edit'},on:{"keyup":function($event){return _vm.update_value($event.target.value)},"click:append-outer":_vm.saveOrEdit},nativeOn:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{ref:_vm.f_field.name + '_currency',attrs:{"readonly":_vm.f_field.disabled,"hide-details":"","name":_vm.f_field.name + '_currency',"items":[
            'EUR',
            'USD',
            'GBP',
            'AUD',
            'CHF',
            'YEN',
            'MYR',
            'SIT',
            'ATS (obsolete)',
            'DEM (obsolete)',
            'ESP (obsolete)',
            'FRF (obsolete)',
            'ITL (obsolete)',
            'NLG (obsolete)',
            'RM (obsolete)',
            'Gift' ],"value":_vm.f_artwork[((_vm.f_field.name) + "_currency")]},on:{"change":function($event){return _vm.saveCurrency($event)}}}),_vm._v(" "),_c('label',{staticClass:"labelClass"},[_vm._v("Currency")]),_vm._v(" "),(_vm.an_exists)?_c('div',[_vm._v("This accession number already exists!")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.field_type == 'currency_only')?_c('v-flex',{attrs:{"px-3":"","d-flex":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{ref:_vm.f_field.name,attrs:{"name":_vm.f_field.name + '_currency',"items":[
            'EUR',
            'USD',
            'GBP',
            'AUD',
            'CHF',
            'YEN',
            'MYR',
            'SIT',
            'ATS (obsolete)',
            'DEM (obsolete)',
            'ESP (obsolete)',
            'FRF (obsolete)',
            'ITL (obsolete)',
            'NLG (obsolete)',
            'RM (obsolete)',
            'Gift' ],"value":_vm.f_artwork[_vm.f_field.name],"persistent-hint":"","hint":"Currency"},on:{"change":function($event){return _vm.saveCurrencyOnly($event)}}})],1)],1):(this.field_type == 'text-long')?_c('v-flex',{staticClass:"mb-0 mt-4 py-0 px-3"},[(!_vm.isEditing)?_c('v-flex',[_c('v-flex',{class:{
            'subheading border pb-1': true,
            'mt-4': _vm.f_artwork[_vm.f_field.name] == null,
          }},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.f_artwork[_vm.f_field.name] ? _vm.nl2br(_vm.f_artwork[_vm.f_field.name]) : ''
            )}})])],1):_c('v-flex',[_c('v-textarea',{ref:_vm.f_field.name,staticClass:"my-0",attrs:{"auto-grow":"","autofocus":"","readonly":!_vm.isEditing,"name":_vm.f_field.name,"rows":"1","hide-details":"","value":_vm.f_artwork[_vm.f_field.name],"hint":((_vm.f_field.title) + " - " + (_vm.f_field.hint ? _vm.f_field.hint : '')),"persistent-hint":""},on:{"keyup":function($event){return _vm.update_value($event.target.value)}},nativeOn:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})],1),_vm._v(" "),_c('label',{staticClass:"labelClass"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),(_vm.f_field.hint)?_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_c('v-icon',_vm._g({staticClass:"mr-3",attrs:{"small":""}},data.on),[_vm._v("error_outline")])]}}],null,false,4273919000)},[_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.f_field.hint)}})]):_vm._e(),_vm._v(" "),(_vm.isEditing)?_c('v-btn',{staticClass:"right mr-0",attrs:{"flat":"","small":"","icon":""},on:{"click":_vm.cancel}},[_c('v-icon',{attrs:{"small":"","color":"red darken-1"}},[_vm._v("cancel")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"right mr-0",attrs:{"flat":"","small":"","icon":""},on:{"click":_vm.saveOrEdit}},[(_vm.isEditing)?_c('v-icon',{attrs:{"color":"green darken-1","small":""}},[_vm._v("save")]):_vm._e(),_vm._v(" "),(!_vm.isEditing)?_c('v-icon',{attrs:{"color":"grey darken-1","small":""}},[_vm._v("edit")]):_vm._e()],1),_vm._v(" "),(_vm.f_artwork[_vm.f_field.name])?_c('v-btn',{staticClass:"right mr-0",attrs:{"color":"primary","flat":"","small":"","icon":""},on:{"click":function($event){return _vm.copy2c(_vm.f_artwork[_vm.f_field.name])}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-content-copy")])],1):_vm._e(),_vm._v(" "),(_vm.an_exists)?_c('div',[_vm._v("This accession number already exists!")]):_vm._e(),_vm._v(" "),(_vm.saved)?_c('div',{staticClass:"ml-3"},[_vm._v("Value was saved!")]):_vm._e(),_vm._v(" "),(_vm.cannotSave)?_c('div',{staticClass:"ml-3"},[_vm._v("\n        Value already exists! Cannot save!\n      ")]):_vm._e()],1):(this.field_type == 'date')?_c('v-flex',{class:((_vm.f_field.class) + " mt-3 py-0 px-3"),attrs:{"xs12":"","md12":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":32,"nudge-top":18,"lazy":"","hide-details":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","prepend-inner-icon":"event","readonly":"","hide-details":""},slot:"activator",model:{value:(_vm.select_value),callback:function ($$v) {_vm.select_value=$$v},expression:"select_value"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"color":"black","hide-details":""},on:{"input":function($event){_vm.menu2 = false},"change":function($event){return _vm.update_value(_vm.select_value)}},model:{value:(_vm.select_value),callback:function ($$v) {_vm.select_value=$$v},expression:"select_value"}})],1),_vm._v(" "),_c('label',{staticClass:"labelClass"},[_vm._v(_vm._s(_vm.f_field.title))])],1):(this.field_type == 'date_separated')?_c('v-flex',{class:((_vm.f_field.class) + " mt-3 py-0 mx-3"),attrs:{"xs12":""}},[_c('v-flex',{attrs:{"row":"","d-flex":"","wrap":"","xs12":"","mb-0":"","pb-0":""}},[_c('v-flex',{attrs:{"xs4":"","mt-0":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"Year","placeholder":"XXXX","mask":"####","readonly":!_vm.isEditing,"type":"number","maxlength":4,"hide-details":""},model:{value:(_vm.separated_date.year),callback:function ($$v) {_vm.$set(_vm.separated_date, "year", $$v)},expression:"separated_date.year"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","mt-0":"","pr-3":""}},[_c('v-text-field',{attrs:{"hide-details":"","label":"Month","readonly":!_vm.isEditing,"mask":"##","placeholder":"XX","type":"number"},model:{value:(_vm.separated_date.month),callback:function ($$v) {_vm.$set(_vm.separated_date, "month", $$v)},expression:"separated_date.month"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","mt-0":""}},[_c('v-text-field',{attrs:{"label":"Day","mask":"##","hide-details":"","placeholder":"XX","type":"number","readonly":!_vm.isEditing},model:{value:(_vm.separated_date.day),callback:function ($$v) {_vm.$set(_vm.separated_date, "day", $$v)},expression:"separated_date.day"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('label',{staticClass:"labelClass"},[_vm._v(_vm._s(_vm.f_field.title)+" ("+_vm._s(_vm.f_artwork[_vm.f_field.name])+")")]),_vm._v(" "),_c('v-btn',{staticClass:"mb-0 py-0 right",staticStyle:{"width":"10px !important","height":"10px !important"},attrs:{"flat":"","small":"","icon":"","color":"grey darken-2"},on:{"click":_vm.saveOrEdit}},[(_vm.isEditing)?_c('v-icon',{attrs:{"small":""}},[_vm._v("save")]):_c('v-icon',{attrs:{"small":""}},[_vm._v("edit")])],1)],1)],1):(this.field_type == 'bool')?_c('v-flex',{attrs:{"px-3":"","mt-3":"","d-flex":""}},[_c('span',{staticClass:"black--text caption"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_c('v-switch',{attrs:{"color":"black"},on:{"change":function($event){return _vm.update_value(_vm.switch_value)}},scopedSlots:_vm._u([{key:"label",fn:function(){return [(_vm.progress)?_c('v-progress-circular',{staticClass:"ml-2",attrs:{"indeterminate":"","value":"0","size":"14","width":"2","background-color":"white","color":"black"}}):_vm._e()]},proxy:true}]),model:{value:(_vm.switch_value),callback:function ($$v) {_vm.switch_value=$$v},expression:"switch_value"}})],1):(this.field_type == 'radio')?_c('v-flex',{attrs:{"px-3":""}},[_c('v-radio-group',{attrs:{"label":("" + (_vm.f_field.title)),"column":_vm.f_field.column ? _vm.f_field.column : false,"value":_vm.value_radio,"refs":_vm.f_field.name}},_vm._l((_vm.f_field.selection),function(s){return _c('v-radio',{key:s.id ? s.id : s,staticClass:"ml-3",attrs:{"label":s.name ? s.name : s,"value":s.value ? s.value : s,"color":"black"}})}),1),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',{staticClass:"xs12 elevation-3 py-3 px-3"},[_c('v-flex',{attrs:{"c":""}},[_c('v-text-field',{attrs:{"label":"Audio Codec","hint":"MP3, AAC, AC3 etc."},model:{value:(_vm.film.audio_codec),callback:function ($$v) {_vm.$set(_vm.film, "audio_codec", $$v)},expression:"film.audio_codec"}})],1),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('v-select',{staticClass:"ml-0",attrs:{"items":['32 kHz', '44,1 kHz', '48 kHz', '96 kHz', '192 kHz'],"label":"Audio Resolution"}})],1):_vm._e(),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Audio Bit","column":""},model:{value:(_vm.film.audio_bit),callback:function ($$v) {_vm.$set(_vm.film, "audio_bit", $$v)},expression:"film.audio_bit"}},_vm._l((['16 Bit', '20 Bit', '24 Bit']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s,"color":"black"}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('v-select',{ref:_vm.fvs_channel_id,staticClass:"ml-0",attrs:{"items":_vm.constants.CHANNELS,"item-value":"id","item-text":"name","label":"Channels"}})],1):_vm._e(),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('v-select',{staticClass:"ml-0",attrs:{"items":[
              'light optical tone',
              'magnetic',
              'digital',
              'unknown',
              'other' ],"label":"Audio Specs"}})],1):_vm._e()],1):_vm._e()],1):(this.field_type == 'checkbox')?_c('v-flex',{attrs:{"px-3":""}},[_c('v-flex',[_c('h4',{staticClass:"sub-headline mt-3 ml-3"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_vm._l((_vm.f_field.selection),function(s){return _c('v-checkbox',{key:s.id ? s.id : s,staticClass:"left mr-3 ml-3",attrs:{"hide-details":"","label":s.name ? s.name : s,"color":"black","refs":_vm.f_field.name}},[_vm._v(_vm._s(s.name ? s.name : s))])})],2)],1):(this.field_type == 'toggle')?_c('v-flex',{attrs:{"px-3":"","mb-2":""}},[_c('div',{staticClass:"labelClass mt-3 ml-1"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_c('v-flex',{staticClass:"py-2",attrs:{"xs12":"","sm6":""}},[_c('v-btn-toggle',{on:{"change":function($event){return _vm.saveField(_vm.toggle)}},model:{value:(_vm.toggle),callback:function ($$v) {_vm.toggle=$$v},expression:"toggle"}},_vm._l((_vm.f_field.selection),function(s){return _c('v-btn',{key:s.id ? s.value : s,staticClass:"px-2",attrs:{"disabled":_vm.f_field.name == 'acquisition_method' &&
            _vm.artwork.acquired != 'acquired',"small":"","flat":"","value":s.value}},[_c('span',[_vm._v(_vm._s(s.name))])])}),1)],1),_vm._v(" "),_c('v-divider',{attrs:{"color":"white"}})],1):(_vm.f_field.etype === 'select')?_c('v-layout',{attrs:{"px-3":"","mt-3":"","mb-3":"","row":"","wrap":""}},[(_vm.f_field.name != 'fvs_channel_id' ||
        (_vm.f_field.name == 'fvs_channel_id' &&
          _vm.f_artwork['including_film'] == '1') ||
        [7, 9].includes(_vm.f_artwork['type_of_work_id'])
        )?_c('v-flex',[(!_vm.f_field.just_text)?_c('v-select',{ref:_vm.f_field.related_field,attrs:{"hide-details":"","value":_vm.value2,"items":_vm.selection_items,"item-text":"name","item-value":"id","name":_vm.f_field.name,"preppend-icon":_vm.f_field.preicon,"readonly":!_vm.isEditing},on:{"change":function($event){return _vm.checkSubfields($event)}},scopedSlots:_vm._u([{key:"append-outer",fn:function(){return [_c('v-btn',{staticClass:"my-0 py-0",staticStyle:{"height":"26px !important"},attrs:{"flat":"","small":"","icon":"","color":"grey darken-2"},on:{"click":_vm.saveOrEdit}},[(_vm.isEditing)?_c('v-icon',{staticClass:"my-0 py-0",staticStyle:{"height":"26px !important"},attrs:{"small":""}},[_vm._v("save")]):_c('v-icon',{staticClass:"my-0 py-0",staticStyle:{"height":"26px !important"},attrs:{"small":""}},[_vm._v("edit")])],1)]},proxy:true}],null,false,4008661981)}):_c('div',[_vm._v("\n          "+_vm._s(_vm.f_artwork[_vm.f_field.name]
            ? _vm.f_artwork[_vm.f_field.name].name
            : 'NOT FOUND')+"\n        ")]),_vm._v(" "),_c('label',{staticClass:"labelClass"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),(_vm.f_field.name == 'ownership' &&
          [12, 15, 16].includes(this.select_value)
          )?_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn-toggle',{on:{"change":function($event){return _vm.saveSubfield('ownership_gemini', $event)}},model:{value:(_vm.ownership_gemini),callback:function ($$v) {_vm.ownership_gemini=$$v},expression:"ownership_gemini"}},_vm._l((['Baron Thyssen', 'FTB']),function(s){return _c('v-btn',{key:s,staticClass:"px-2",attrs:{"small":"","flat":"","value":s,"input-value":s}},[_c('span',[_vm._v(_vm._s(s))])])}),1)],1):_vm._e(),_vm._v(" "),(_vm.f_field.name == 'type_of_work_id' && this.select_value == 7)?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Select Film Type","value":_vm.f_artwork['including_film_type'],"row":""},on:{"change":function($event){return _vm.saveSubfield('including_film_type', $event)}}},_vm._l((['tape', 'film', 'digital_born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s,"color":"black"}})}),1)],1):_vm._e(),_vm._v(" "),(this.f_field.name == 'type_of_work_id' &&
          this.artwork.type_of_work_id == 6
          )?_c('v-flex',{staticClass:"xs12 mx-0 px-0"},[_c('v-flex',{staticClass:"xs12 mx-0 px-0 mb-3"},[_c('v-container',{staticStyle:{"background-color":"#ddd"},attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"subheadline mt-0 xs12 body-2"},[_vm._v("Includes")]),_vm._v(" "),_vm._l((this.$store.state.includes),function(s){return _c('v-flex',{key:s.field,attrs:{"xs12":"","md6":"","lg4":"","py-0":"","my-0":""}},[_c('v-checkbox',{attrs:{"label":s.title,"false-value":0,"true-value":1,"hide-details":"","color":"black"},on:{"change":function($event){return _vm.saveSubfield(s.field, _vm.f_artwork[s.field])}},model:{value:(_vm.f_artwork[s.field]),callback:function ($$v) {_vm.$set(_vm.f_artwork, s.field, $$v)},expression:"f_artwork[s.field]"}})],1)})],2)],1)],1),_vm._v(" "),(this.instalation_includes.indexOf('FilmVideoAV') >= 0)?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-radio-group',{attrs:{"label":"Select Film Type","row":""},model:{value:(_vm.film.film_type),callback:function ($$v) {_vm.$set(_vm.film, "film_type", $$v)},expression:"film.film_type"}},_vm._l((['tape', 'film', 'digital born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s,"color":"black"}})}),1)],1):_vm._e(),_vm._v(" "),(this.instalation_includes.indexOf('Other') >= 0)?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-text-field',{staticClass:"ml-3",attrs:{"name":"including_other","label":"Other","row":""},model:{value:(_vm.film.film_type),callback:function ($$v) {_vm.$set(_vm.film, "film_type", $$v)},expression:"film.film_type"}})],1):_vm._e()],1):_vm._e()],1):_vm._e()],1):(_vm.f_field.etype === 'autocomplete')?_c('v-flex',{attrs:{"mt-2":"","mb-2":"","px-3":""}},[_c('v-autocomplete',{attrs:{"hide-details":"","readonly":!_vm.isEditing,"value":_vm.value2,"items":this.selection_items,"item-text":function (item) { return item.name
              ? item.name
              : item.company
                ? item.company
                : item.first_name + ' ' + item.last_name; },"item-value":"id","chips":_vm.f_field.chips,"clearable":"","multiple":_vm.f_field.multiple},on:{"change":function($event){return _vm.checkSubfields($event)}},scopedSlots:_vm._u([{key:"append-outer",fn:function(){return [_c('v-btn',{staticClass:"my-0 py-0",staticStyle:{"height":"26px !important"},attrs:{"flat":"","small":"","icon":"","color":"grey darken-2"},on:{"click":_vm.saveOrEdit}},[(_vm.isEditing)?_c('v-icon',{staticClass:"my-0 py-0",staticStyle:{"height":"26px !important"},attrs:{"small":""}},[_vm._v("save")]):_c('v-icon',{staticClass:"my-0 py-0",staticStyle:{"height":"26px !important"},attrs:{"small":""}},[_vm._v("edit")])],1)]},proxy:true}])}),_vm._v(" "),_c('label',{staticClass:"labelClass"},[_vm._v(_vm._s(_vm.f_field.title))])],1):_vm._e(),_vm._v(" "),(this.showingAddForm && _vm.f_field.addNew)?_c('v-flex',[(_vm.f_field.table == 'artists')?_c('add-artist',{attrs:{"itemToAdd":"f_field"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(this.showingAddForm && _vm.f_field.addNew)?_c('v-flex',[(_vm.f_field.table == 'artwork_locations')?_c('add-location',{attrs:{"itemToAdd":"f_field"}}):_vm._e()],1):_vm._e()],1)])}
var staticRenderFns = []


/***/ }),

/***/ "S5f9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


function nl2br(str, is_xhtml) {
  var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },

  props: ['field', 'artist'],
  methods: {
    format_date: function format_date(date, format) {
      var moment = __webpack_require__("PJh5");
      var ndate = new Date(date);
      return moment(ndate).format(format);
    }
  },
  computed: {
    f_field: function f_field() {
      return this.field;
    },
    f_artist: function f_artist() {
      return this.artist;
    },
    value_calculated: function value_calculated() {
      var output = '';
      switch (this.f_field.table) {
        case 'artists':
          if (this.f_field.name) output = nl2br(this.f_artist[this.field.name]);else output = 'no artist name entered in cms';
          break;
        case 'artist_locations':
          output = nl2br(this.f_artist[this.f_field.association][this.f_field.name]);
          break;
        case 'contacts':
          output = nl2br(this.f_artist[this.f_field.association][this.f_field.name]);
          break;
        default:
          output = nl2br(this.f_artist[this.f_field.name]);
          if (this.f_field.suffix) {
            output += this.f_field.suffix;
          }
        // console.log(this.f_artist)
      }
      return output;
    },
    value_from_array: function value_from_array() {
      var v = this.value_calculated;
      return this.f_field.options[v];
    },
    value_calculated_empty: function value_calculated_empty() {
      var output = '';
      // let a = this.f_artist.id
      // console.log(this.f_artist)
      switch (this.f_field.table) {
        case 'artists':
          if (typeof this.f_artist !== 'undefined') {
            output = this.f_artist[this.f_field.name];
          } else {
            output = '';
          }
          break;
        case 'artist_locations':
          if (typeof this.f_artist[this.f_field.association] !== 'undefined') {
            output = this.f_artist[this.f_field.association][this.f_field.name];
          } else {
            output = '';
          }
          break;
        case 'contacts':
          if (typeof this.f_artist[this.f_field.association] !== 'undefined') {
            output = this.f_artist[this.f_field.association][this.f_field.name];
          } else {
            output = '';
          }
          break;
        default:
          output = this.f_artist[this.f_field.name];
      }
      var o = false;
      if (output == '' || output == undefined || output == null) {
        o = false;
      } else {
        o = true;
      }
      return o;
    }
  }
});

/***/ }),

/***/ "SCHX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewExhibitionHistory_vue__ = __webpack_require__("hmKP");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395e3014_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewExhibitionHistory_vue__ = __webpack_require__("Z0FH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("XqU9")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-395e3014"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewExhibitionHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395e3014_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewExhibitionHistory_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_395e3014_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NewExhibitionHistory_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SKFP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SWdK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conservation_vue__ = __webpack_require__("WD8M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94595326_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conservation_vue__ = __webpack_require__("wxhR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("1Nha")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-94595326"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Conservation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94595326_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conservation_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_94595326_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Conservation_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sbrr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Sh4X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mb-0 px-0 mt-2 pt-0 elevation-0"},[_c('v-card-title',{staticClass:"px-0 mx-0"},[_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"sm6":"","md4":"","lg3":""}},[(this.$store.state.showSearch)?_c('v-text-field',{attrs:{"append-icon":"search","clearable":"","label":"Search ","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"text-xs-right mr-0 mt-2 py-0",attrs:{"xs1":""}},[_c('v-menu',{staticClass:"text-xs-right mx-4 my-0 py-0 align-center",attrs:{"offset-y":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-2 my-0 py-0",attrs:{"small":"","icon":"","color":"black","dark":""}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("sort")])],1)]}}])},[_vm._v(" "),_c('v-list',{attrs:{"value":"first_name"}},_vm._l((_vm.sortingItemsArtworks),function(item,index){return _c('v-list-tile',{key:index.column,on:{"click":function($event){return _vm.changeSort(item.column)}}},[(item.column == _vm.sorting)?_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("mdi-sort-ascending")])],1):_c('v-list-tile-avatar',[_c('v-icon')],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"ml-2 mr-2"}),_vm._v(" "),(_vm.use_current_selection && _vm.artworks.length == 0)?_c('h3',{staticClass:"pa-5 ma-2 grey ligthen-3"},[_vm._v("\n      You have selected \"Use artworks in current selection\" but there are no\n      artworks currently selected.\n    ")]):_vm._e(),_vm._v(" "),(_vm.artworks.length > 0)?_c('v-data-table',{staticClass:"elevation-0",attrs:{"hide-headers":"","search":_vm.search,"items":_vm.filtered,"item-key":"id","item-value":"id","custom-filter":_vm.customFilter,"width":"100%","disable-initial-sort":"","light":"","rows-per-page-text":"Artworks per page","no-data-text":"No Artworks match the filter criteria.","pagination":_vm.p},on:{"update:pagination":function($event){_vm.p=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{staticClass:"pb-0 mb-0"},[_c('td',{staticStyle:{"width":"20px !important","margin":"0px !important","padding":"0px !important"}},[_c('v-flex',{attrs:{"align-start":"","justify-start":"","fill-height":""}},[_c('v-btn',{staticClass:"my-3 py-0 mx-0 px-0",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.removeArtwork(props.item)}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center","vertical-align":"text-top","width":"140px","padding":"7px 0 0 0"}},[(props.item.top_photo && props.item.top_photo_id > 0)?_c('img',{class:{
                redBorder:
                  props.item.top_photo.width < 500 ||
                  props.item.top_photo.height < 500,
              },staticStyle:{"width":"120px","margin":"10px"},attrs:{"src":((_vm.$globals.fileserver) + "/data/artwork/" + (props.item.id) + "/" + (props.item.top_photo_id) + "_th_big.jpg")},on:{"error":_vm.imageUrlAlt}}):([12, 15, 16].includes(props.item.ownership))?_c('img',{staticStyle:{"width":"120px","margin":"10px"},attrs:{"src":((this.$globals.oldserver) + "/data/artwork/gemini/" + (props.item.accession_number) + ".jpg")},on:{"error":_vm.imageUrlAlt}}):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"my-0 py-0 body-1 align-start justify-start row fill-height",staticStyle:{"vertical-align":"top","padding":"7px 0 0 0"},attrs:{"colspan":"7"}},[_c('table',{staticClass:"my-2 py-0 body-1 align-start justify-start row",staticStyle:{"padding-top":"25px"},attrs:{"width":"100%"}},[_c('tr',[_c('td',{staticClass:"\n                    body-1\n                    align-start\n                    justify-start\n                    row\n                    fill-height\n                    pt-2\n                    pb-0\n                    mb-0\n                    mx-0\n                    px-1\n                  "},[_c('div',{staticClass:"title black--text text-xs-left mb-1"},[_vm._v("\n                    "+_vm._s(props.item.artist
                        ? props.item.artist.name
                        : props.item.name)+"\n                  ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{
                      name: 'EditArtwork',
                      params: { id: props.item.id, artwork: props.item },
                      path: ("/artworks/edit/" + (props.item.id)),
                    }}},[_c('span',{class:[
                        { 'red--text': props.item.deaccessioned },
                        'subheading' ]},[_c('b',[_vm._v(_vm._s(props.item.title)+",\n                        "+_vm._s(props.item.production_date_new))])])]),_vm._v(" "),_c('v-spacer',{staticClass:"mb-2"}),_vm._v(" "),(props.item.dim_f_json)?_c('div',[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("square_foot")]),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(props.item.dim_f_json))])],1):_vm._e(),_vm._v(" "),(
                      props.item.artwork_location_id &&
                      props.item.artwork_location_id != 465
                    )?_c('div',[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("edit_location")]),_vm._v(" "),_c('span',[_vm._v("\n                      "+_vm._s(_vm.get_location_name(props.item.artwork_location_id)))])],1):_vm._e()],1)]),_vm._v(" "),_c('tr',{staticClass:"my-0 py-0"},[_c('td',{staticClass:"my-0 py-0 mx-0 px-1 text-xs-left"},[_c('span',[_vm._v(_vm._s(props.item.accession_number))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(props.item.visa_status == 3)?_c('v-chip',{attrs:{"text-color":"white","color":"red","small":""}},[_vm._v("F\n                  ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"right"},[(
                        props.item.artwork_todos.filter(function (at) { return at.done != 1; })
                          .length > 0
                      )?_c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_c('v-chip',_vm._g({attrs:{"dark":"","small":""}},data.on),[_c('v-icon',{staticClass:"mr-3 small"},[_vm._v("mdi-format-list-numbered")]),_vm._v("\n                          "+_vm._s(props.item.artwork_todos.filter(
                              function (at) { return at.done != 1; }
                            ).length)+"\n                        ")],1)]}}],null,true)},[_vm._v(" "),_c('div',_vm._l((props.item.artwork_todos.filter(
                            function (at) { return at.done != 1; }
                          )),function(a){return _c('div',{key:a.id},[_vm._v("\n                          – "+_vm._s(a.title)+"\n                          "),_c('br')])}),0)]):_vm._e()],1)],1)])])])])]}}],null,false,1455905011),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}}):_vm._e(),_vm._v(" "),(this.selected.length > 0)?_c('div',[(_vm.save_selection_form_display == false)?_c('span',[_c('v-btn',{attrs:{"flat":"","outline":"","color":"red"},on:{"click":function($event){return _vm.clear_selection()}}},[_vm._v("\n          Clear Selection")])],1):_vm._e(),_vm._v(" "),(_vm.save_selection_form_display == false)?_c('span',[_c('v-btn',{attrs:{"flat":"","outline":"","color":"green"},on:{"click":function($event){_vm.save_selection_form_display = true}}},[_vm._v("Save Selection")])],1):_c('div',[_c('h3',{staticClass:"ml-4"},[_vm._v("SAVE SELECTION")])])]):_vm._e(),_vm._v(" "),(_vm.save_selection_form_display)?_c('div',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"mx-4":"","my-3":""}},[_c('v-text-field',{attrs:{"label":"Selection Title","value":""},model:{value:(_vm.selection_title),callback:function ($$v) {_vm.selection_title=$$v},expression:"selection_title"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","outline":"","color":"green"},on:{"click":_vm.saveCurrentSelectionToUser}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","outline":"","color":"red"},on:{"click":function($event){_vm.save_selection_form_display = false}}},[_vm._v("Cancel")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "SwzB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Location_vue__ = __webpack_require__("kfWA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68a7d9de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__ = __webpack_require__("6Qpy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Ml6F")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68a7d9de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Location_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68a7d9de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68a7d9de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Location_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "T+xc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T2Xd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T7Bm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Insurance_vue__ = __webpack_require__("O8mt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd3d7d6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Insurance_vue__ = __webpack_require__("4bG1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("KUt5")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3dd3d7d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Insurance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd3d7d6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Insurance_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dd3d7d6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Insurance_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TNoC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TOgl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import CommonMixin from '@/mixins/CommonMixin'


function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
/* harmony default export */ __webpack_exports__["a"] = ({
  // mixins: [ CommonMixin ],
  props: ['artwork'],
  data: function data() {
    return {
      showDialog: false,
      editing: false,
      selected: [],
      dialog: false,
      dialog2: false,
      headers: [
      // {
      //   text: 'Colli',
      //   align: 'left',
      //   sortable: true,
      //   value: 'colli'
      // },
      { text: 'What for', value: 'what_for', sortable: true },
      // { text: 'Created by', value: 'created_by', sortable: true },
      { text: 'Date', value: 'transaction_date', sortable: true }, { text: 'Income', value: 'income', sortable: true }, { text: 'Expense', value: 'expense', sortable: true },
      // { text: 'Content', value: 'content', sortable: true },
      // { text: 'Note', value: 'note', sortable: true },
      { text: false, sortable: false }],
      editedIndex: -1,
      show: false,
      showUpload: false,
      artwork_cost: {
        what_for: '',
        transaction_date: '',
        income: '',
        expense: '',
        content: '',
        // note: '',
        artwork_id: ''
      }
    };
  },
  computed: {
    // c_user() {
    //   return this.$store.state.user.profile;
    // },
    incomeSummary: function incomeSummary() {
      // console.log('income')
      // console.log(this.artwork.artwork_costs)
      // console.log(this.artwork.artwork_costs.length)
      if (this.artwork.artwork_costs && this.artwork.artwork_costs.length > 0) {
        var out = this.artwork.artwork_costs.filter(function (ac) {
          if (ac.income) {
            // console.log(ac.expense)
            return ac.income > 0;
          } else {
            return 0;
          }
        });
        // console.log(out)
        if (out && out.length > 0) {
          return out.map(function (o) {
            return o.income;
          }).reduce(function (a, c) {
            return a + c;
          });
        } else {
          return 0;
        }
      }
      // .reduce((a,b) => a + b, 0)
    },
    expenseSummary: function expenseSummary() {
      // console.log('expense')
      // console.log(this.artwork.artwork_costs)
      // console.log(this.artwork.artwork_costs.length)
      if (this.artwork.artwork_costs && this.artwork.artwork_costs.length > 0) {
        var out = this.artwork.artwork_costs.filter(function (ac) {
          if (ac.expense) {
            // console.log(ac.expense)
            return ac.expense > 0;
          } else {
            return 0;
          }
        });
        // console.log(out.map(o=>o.expense).reduce((a,c)=>a+c))
        if (out && out.length > 0) {
          return out.map(function (o) {
            return o.expense;
          }).reduce(function (a, c) {
            return a + c;
          });
        } else {
          return 0;
        }
      }
      // .reduce((a,b) => a + b, 0)
    },

    // visa_status () {
    //   this.constants.VISA_STATUSES.find(this.artwork.visa_status)
    // },
    all_artwork_costs: function all_artwork_costs() {
      return this.$store.state.artwork_costs;
      // console.log(todos)
      // return todos
    }
  },
  methods: {
    edit_cost: function edit_cost(c) {
      this.artwork_cost = {
        what_for: '',
        transaction_date: '',
        income: '',
        expense: '',
        content: '',
        artwork_id: ''
      };
      this.editing = true;
      try {
        this.artwork_cost = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.artwork.artwork_costs.find(function (t) {
          return t.id == c.id;
        }));
        this.artwork_cost.transaction_date = this.format_date(this.artwork_cost.transaction_date ? this.artwork_cost.transaction_date : Date.now);
        this.showDialog = true;
      } catch (error) {
        // console.log(error.message)
      }
    },
    initialize: function initialize() {},
    deleteItem: function deleteItem(item) {
      confirm('Are you sure you want to delete this Cost?');
      this.deleteCost(item);
    },
    deleteCost: function deleteCost(c) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Deleting Cost.', 'black');
      var url = this.$globals.apiserver + '/artwork_costs/' + c.id + '.json';
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url, c).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Cost Deleted.', 'green');
        _this.errors = {};
        var index = _this.artwork.artwork_costs.indexOf(c);
        if (index >= 0) _this.artwork.artwork_costs.splice(index, 1);
        _this.$store.dispatch('updateArtwork', _this.artwork.id);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'There was an Error deleting Cost.', 'red');
        _this.errors = error.response.data;
      });
    },

    // get_visa_status (artworkCost) {
    //   var vss = this.constants.VISA_STATUSES.filter(
    //     vs => vs.id === artworkCost.visa_status
    //   )
    //   if (vss[0] != undefined) {
    //     // console.log(vss[0].id)
    //     return vss[0].id > 0 ? vss[0].name : ''
    //   } else {
    //     return ''
    //   }
    // },
    // getUser (userId) {
    //   var l = this.$store.state.users.find(u => u.id === userId)
    //   return l ? l : ''
    // },
    save: function save() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Saving Cost.', 'black');
      this.artwork_cost.artwork_id = this.artwork.id;
      this.artwork_cost.created_by = this.c_user.id;
      // this.artwork_cost.id = this.findMinMax(this.all_artwork_costs)+1
      if (!this.artwork.artwork_costs) {
        this.artwork.artwork_costs = [];
      }
      // this.artwork.artwork_artwork_costs.push(this.artwork_cost)
      if (!this.editing) {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.$globals.apiserver + '/artwork_costs.json', {
          artwork_cost: this.artwork_cost
        }).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Cost Saved.', 'green');
          _this2.errors = {};
          _this2.artwork.artwork_costs.push(response.data);
          _this2.editing = false;
          // this.$store.commit('ADD_COST', response.data)
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'There was an Error saving Cost.', 'red');
          _this2.errors = error.response.data;
        });
      } else {
        var url = this.$globals.apiserver + '/artwork_costs/' + this.artwork_cost.id + '.json';
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, {
          artwork_cost: this.artwork_cost
        }).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Cost Saved.', 'green');
          _this2.errors = {};
          _this2.artwork.artwork_costs = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this2.artwork.artwork_costs.map(function (item) {
            return item.id !== response.data.id ? item : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, response.data);
          })));
          _this2.editing = false;
          // this.$store.commit("SAVE_COST", response.data);
          // this.$store.commit('ADD_COST', response.data)
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'There was an Error saving Cost.', 'red');
          _this2.errors = error.response.data;
        });
      }
      // console.log(this.artwork_cost)
      // this.all_artwork_costs.push(this.artwork_cost)
      // this.showUpload=!this.showUpload
      this.showDialog = false;
      this.artwork_cost = {
        what_for: '',
        transaction_date: '',
        artwork_id: '',
        income: '',
        expense: '',
        content: ''
      };
    }

    // NEPOUZIVANE
    // findMinMax(arr) {
    //   let max = arr[0].id;
    //   for (let i = 1, len = arr.length; i < len; i++) {
    //     let v = arr[i].id;
    //     max = v > max ? v : max;
    //   }
    //   return max;
    // }

  }
});

/***/ }),

/***/ "TOiM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TQDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"my-0 mx-0 px-0 py-0",attrs:{"fluid":""}},[_c('v-layout',{staticClass:"my-0 mx-2 px-0 py-0",attrs:{"row":"","wrap":""}},[_c('v-card',{staticClass:"my-0 mx-2",staticStyle:{"width":"100%"}},[_c('v-card-title',{staticClass:"pb-0 mb-0"},[_c('span',{staticClass:"headline"},[_vm._v("Bibliography Details")])]),_vm._v(" "),(!_vm.edit_bio_dialog)?_c('v-card-text',{staticClass:"py-0 my-0 bio",domProps:{"innerHTML":_vm._s(
            this.artwork.bibliography_details != null
              ? this.artwork.bibliography_details
              : 'No text filled-in yet'
          )}}):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"width":"80%"},model:{value:(_vm.edit_bio_dialog),callback:function ($$v) {_vm.edit_bio_dialog=$$v},expression:"edit_bio_dialog"}},[_c('v-card',{staticStyle:{"width":"100%"},attrs:{"elevation-2":"","mx-3":"","mt-4":""}},[_c('v-container',{attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('text-editor',{attrs:{"value":_vm.bibliography_details},on:{"input":function($event){_vm.bibliography_details = $event}}}),_vm._v(" "),_c('v-layout',{staticClass:"pl-3 pb-3 mt-2 justify-end"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.edit_bio_dialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":_vm.save_bio}},[_vm._v("save")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"mx-1"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.copy2c(_vm.artwork.bibliography_details)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("file_copy")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mr-1",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.download_text(_vm.p)}}},[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("mdi-download")])],1),_vm._v(" "),(_vm.c_user.edit)?_c('v-btn',{staticClass:"mr-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.edit_bio()}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{staticClass:"mr-1",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.delete_text(_vm.p)}}},[_c('v-icon',{attrs:{"color":"red","small":""}},[_vm._v("delete")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('div',[_c('upload',{staticClass:"xs12 mx-0 px-0 mt-5",staticStyle:{"width":"100%"},attrs:{"artwork":_vm.artwork,"field":{ title: 'Text uploads' },"uploadCategory":"artwork_literature"}})],1),_vm._v(" "),(_vm.add_text)?_c('div',[(_vm.showUpload)?_c('v-flex',{attrs:{"elevation-2":"","mx-3":"","mt-4":""}},[_c('v-container',{attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-text-field',{staticClass:"flex xs12 ml-2",attrs:{"name":"Title","label":"Title"},model:{value:(_vm.text.title),callback:function ($$v) {_vm.$set(_vm.text, "title", $$v)},expression:"text.title"}}),_vm._v(" "),_c('text-editor',{on:{"input":function($event){_vm.text.content = $event}}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-3 pb-3"},[_c('v-btn',{on:{"click":_vm.save_text}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.showUpload = !_vm.showUpload}}},[_vm._v("cancel")])],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"width":"80%"},model:{value:(_vm.edit_dialog),callback:function ($$v) {_vm.edit_dialog=$$v},expression:"edit_dialog"}},[_c('v-card',{attrs:{"elevation-2":"","mx-3":"","mt-4":""}},[_c('v-container',{attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-text-field',{staticClass:"flex xs12 ml-2",attrs:{"name":"Title","label":"Title"},model:{value:(_vm.edited_text.title),callback:function ($$v) {_vm.$set(_vm.edited_text, "title", $$v)},expression:"edited_text.title"}}),_vm._v(" "),_c('text-editor',{attrs:{"value":_vm.edited_text.content},on:{"input":function($event){_vm.edited_text.content = $event}}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-3 pb-3 text-xs-right"},[_c('v-btn',{staticClass:"mr-4",on:{"click":function($event){_vm.edit_dialog = !_vm.edit_dialog}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","right":""},on:{"click":_vm.save_edited_text}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),(
      this.local_artwork.artwork_texts &&
      this.local_artwork.artwork_texts.length > 0
    )?_c('v-container',{staticClass:"my-0 mx-0 px-0 py-0",attrs:{"fluid":""}},[_c('v-layout',{staticClass:"my-0 mx-2 px-0 py-0",attrs:{"row":"","wrap":""}},_vm._l((this.local_artwork.artwork_texts),function(p){return _c('v-card',{key:p.id,staticClass:"my-2 mx-2",staticStyle:{"width":"100%"},attrs:{"elevation-0":""}},[_c('v-card-title',{staticClass:"pb-0 mb-0"},[_c('span',{staticClass:"headline",domProps:{"innerHTML":_vm._s(p.title)}})]),_vm._v(" "),_c('v-card-text',{staticClass:"py-0 my-0 bio",domProps:{"innerHTML":_vm._s(p.content)}}),_vm._v(" "),_c('v-card-actions',{staticClass:"mx-0 mt-3"},[(p.publication)?_c('v-chip',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("publication")]):_vm._e(),_vm._v(" "),(p.article)?_c('v-chip',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("article")]):_vm._e(),_vm._v(" "),(p.artwork_text)?_c('v-chip',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("text on artwork")]):_vm._e(),_vm._v(" "),(p.artist_documents)?_c('v-chip',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("artist documents")]):_vm._e(),_vm._v(" "),(p.pr)?_c('v-chip',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("PR")]):_vm._e(),_vm._v(" "),(p.transcript)?_c('v-chip',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("transcript")]):_vm._e(),_vm._v(" "),(p.work_text)?_c('v-chip',{staticClass:"ml-2",attrs:{"small":""}},[_vm._v("work text")]):_vm._e()],1),_vm._v(" "),_c('v-card-actions',{staticClass:"mx-2"},[_c('small',{staticClass:"ml-1"},[_vm._v("CREATED: "),_c('b',[_vm._v(_vm._s(_vm.format_date(p.created_at)))])]),_vm._v(" "),(p.written_by)?_c('small',{staticClass:"ml-4"},[_vm._v("WRITTEN BY: "),_c('b',[_vm._v(_vm._s(_vm.get_abb(p.written_by)))])]):_vm._e(),_vm._v(" "),(p.created_by)?_c('small',{staticClass:"ml-4"},[_vm._v("CREATED BY: "),_c('b',[_vm._v(_vm._s(_vm.get_abb(p.created_by)))])]):_vm._e(),_vm._v(" "),_c('small',{staticClass:"ml-4"},[_vm._v("LAST UPDATE: "),_c('b',[_vm._v(_vm._s(_vm.format_date(p.updated_at)))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.copy2c(p.content)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("file_copy")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mr-1",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.download_text(p)}}},[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("mdi-download")])],1),_vm._v(" "),(_vm.c_user.edit)?_c('v-btn',{staticClass:"mr-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.edit_text(p)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.delete_text(p)}}},[_c('v-icon',{attrs:{"color":"red","small":""}},[_vm._v("delete")])],1):_vm._e()],1)],1)}),1)],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "Tdwg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Th9A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeaderElements__ = __webpack_require__("oiZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ElementsTable__ = __webpack_require__("vCKh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork', 'field'],
  data: function data() {
    return {
      title: 'Non-Electric Device',
      non_electricals: [{ id: 1, title: ' 1', bulb_origin: 1, bulb_specification: 'test specs' }, { id: 3, title: ' 2', bulb_origin: 1, bulb_specification: 'test specs' }, { id: 2, title: ' 3', bulb_origin: 1, bulb_specification: 'test specs' }],
      categories: ['monitor', 'projector', 'motor', 'bulb', 'switch'],
      fields: [{
        'ctype': 'radio',
        // 'selection': [{id: 1, title: 'Unique'}, {id: 2, title: 'Dedicated'}, {id: 3, title: 'Historic Dedicated'}, {id: 4, title: 'Non-dedicated'}],
        // selection: ['Unique','Dedicated','Historic Dedicated','Non-dedicated'],
        selection: [{ id: 1, name: 'Unique' }, { id: 2, name: 'Dedicated' }, { id: 3, name: 'Historic Dedicated' }, { id: 4, name: 'Non-dedicated' }],
        // selection: [{id: 1, name: 'Unique/Existing'}, {id: 2, name: 'Dedicated/Existing'}, {id: 3, name: 'Historic Dedicated/Existing'}, {id: 4, name: 'Non-dedicated/Required'}],
        name: 'origin',
        title: 'Origin',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      },
      // {
      //   name: 'switch',
      //   title: 'Switch, Counter - Specification',
      //   ctype: 'text-long',
      //   category: 'switch',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_rights: ['admin', 'manager']
      // },
      // {
      //   name: 'other',
      //   title: 'Other - Specification',
      //   ctype: 'text-long',
      //   category: 'other',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_rights: ['admin', 'manager']
      // },
      {
        name: 'brand',
        title: 'Brand',
        ctype: 'text-short',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_rights: ['admin', 'manager']
      }],
      showUpload: false,
      show: false,
      showme: false,
      non_electrical: {
        title: '',
        associated_items: '',
        brand: '',
        origin: ''
      }
    };
  },
  computed: {
    all_non_electricals: function all_non_electricals() {
      return this.$store.state.non_electricals;
      // console.log(todos)
      // return todos
    }
  },
  methods: {
    origin_title: function origin_title(id) {
      // console.log(id)
      if (id > 0 && id < 5) {
        // console.log(id)
        // console.log(constants.ORIGINS)
        // console.log(constants.ORIGINS.find(o => o.id == id).title)
        return constants.ORIGINS.find(function (o) {
          return o.id == id;
        }).title;
      }
    },

    // show_field (f) {
    //   if (f.condition) {
    //     this.showme = true
    //     var a = f.condition
    //     // console.log(a)
    //     return eval(a)
    //   } else {
    //     return true
    //   }
    // return Function('"use strict";return (a)')()
    // },
    download: function download() {},

    // add () {
    //   this.non_electricals.push(this.non_electrical)
    //   this.showUpload=!this.showUpload
    // },
    delete_non_electrical: function delete_non_electrical() {},
    done_non_electrical: function done_non_electrical() {},
    save_non_electrical: function save_non_electrical() {
      this.non_electrical.artwork_id = this.artwork.id;
      this.non_electrical.done = false;
      this.non_electrical.id = this.findMinMax(this.all_non_electricals) + 1;
      this.$store.commit('ADD_NON_ELECTRICAL', this.non_electrical);
      // this.all_non_electricals.push(this.non_electrical)
      this.showUpload = !this.showUpload;
      this.non_electrical = {
        description: '',
        title: '',
        deadline: '',
        done: false
        // var anon_electrical = Object.keys(this.non_electrical).forEach(k => this.non_electrical[k]='')
        // console.log(anon_electrical)
      };
    },
    findMinMax: function findMinMax(arr) {
      if (arr === undefined || arr.length === 0) {
        return 1;
      } else {
        var max = arr[0].id;
        for (var i = 1, len = arr.length; i < len; i++) {
          var v = arr[i].id;
          max = v > max ? v : max;
        }
        // console.log(max)
        return max;
      }
    }
  },
  components: { HeaderElements: __WEBPACK_IMPORTED_MODULE_0__HeaderElements__["a" /* default */], ElementsTable: __WEBPACK_IMPORTED_MODULE_1__ElementsTable__["a" /* default */] }
});

/***/ }),

/***/ "Tshf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Solo_vue__ = __webpack_require__("Ja8h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c48095c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Solo_vue__ = __webpack_require__("7NJ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("TNoC")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c48095c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Solo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c48095c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Solo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c48095c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Solo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U39T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.f_field.headline)?_c('div',{staticClass:"mt-5 mb-3"},[_c('v-flex',{staticClass:"px-3 py-2 elevation-0 xs12",staticStyle:{"background-color":"#eaeaea","color":"#444444"}},[_c('h3',{staticClass:"font-weight-bold body-2 text-uppercase xs12 flex"},[_vm._v("\n        "+_vm._s(_vm.f_field.title)+"\n        "),(!_vm.f_field.no_dynamic)?_c('v-menu',{staticClass:"right mb-1",attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"mt-0 mb-0",attrs:{"slot":"activator","color":"grey lighten-3","small":"","icon":""},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("add")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.dynamic_field_list),function(item){return _c('v-list-tile',{key:item.name,on:{"click":function($event){return _vm.add_field(item.name)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)}),1)],1):_vm._e()],1)])],1):(_vm.f_field.subheadline)?_c('div',{staticClass:"mt-2 mb-1"},[_c('v-flex',{staticClass:"px-3 pb-0 xs12"},[_c('h3',{staticClass:"xs12 flex"},[_vm._v("\n        "+_vm._s(_vm.f_field.title)+"\n        ")])])],1):_vm._e(),_vm._v(" "),(_vm.f_field.component)?_c('div',{staticClass:"mt-2 mb-2 mx-0"},[_c(_vm.f_field.component,{tag:"component",attrs:{"uploadCategory":_vm.f_field.title,"artwork":_vm.f_artwork,"name":_vm.f_field.name,"field":_vm.f_field,"film":_vm.film}})],1):_c('div',[(_vm.field_type == 'text-short')?_c('v-flex',{attrs:{"px-3":""}},[_c('v-flex',[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('v-text-field',{attrs:{"value":("" + (_vm.f_field.name)),"hint":_vm.hint,"persistent-hint":"","suffix":_vm.f_field.suffix},on:{"keyup":function($event){_vm.f_field.name == 'acquisition_number'
              ? _vm.check_an($event.target.value)
              : ''}},nativeOn:{"input":function($event){return _vm.$emit('input', $event.target.value)}},model:{value:(_vm.parent[_vm.f_field.name]),callback:function ($$v) {_vm.$set(_vm.parent, _vm.f_field.name, $$v)},expression:"parent[f_field.name]"}}),_vm._v(" "),(_vm.an_exists)?_c('div',[_vm._v("This accession number already exists!")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),(_vm.field_type == 'currency')?_c('v-flex',{attrs:{"px-3":"","xs12":"","sm6":"","md4":"","d-flex":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('v-text-field',{ref:_vm.f_field.name,attrs:{"readonly":!_vm.isEditing,"name":_vm.f_field.name,"value":("" + (_vm.f_artwork[_vm.f_field.name])),"hint":("" + (_vm.f_field.title)),"persistent-hint":"","suffix":_vm.f_field.suffix,"append-outer-icon":_vm.f_field.no_edit ? '' : _vm.isEditing ? 'save' : 'edit'},on:{"keyup":function($event){return _vm.check_an($event.target.value)},"click:append-outer":_vm.saveOrEdit},nativeOn:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{ref:_vm.f_field.name,staticClass:"ml-0",attrs:{"name":"f_field.name+'_currency'","items":['EUR', 'USD', 'GBP', 'AUD', 'CHF', 'YEN', 'SIT'],"label":"","append-outer-icon":_vm.isEditing ? 'save' : 'edit',"value":_vm.f_artwork[((_vm.f_field.name) + "_currency")],"hint":"Currency","persistent-hint":""},on:{"click:append-outer":_vm.saveOrEdit}}),_vm._v(" "),(_vm.an_exists)?_c('div',[_vm._v("This accession number already exists!")]):_vm._e(),_vm._v(" "),(_vm.saved)?_c('div',{staticClass:"ml-3"},[_vm._v("Value was saved!")]):_vm._e(),_vm._v(" "),(_vm.cannotSave)?_c('div',{staticClass:"ml-3"},[_vm._v("\n          Value already exists! Cannot save!\n        ")]):_vm._e()],1)],1):(this.field_type == 'text-long')?_c('v-flex',{staticClass:"my-0 py-0 px-3"},[_c('v-textarea',{ref:_vm.f_field.name,staticClass:"my-0",attrs:{"auto-grow":"","readonly":!_vm.isEditing,"name":_vm.f_field.name,"rows":"1","value":("" + (_vm.f_artwork[_vm.f_field.name])),"hint":((_vm.f_field.title) + " - " + (_vm.f_field.hint ? _vm.f_field.hint : '')),"persistent-hint":"","append-outer-icon":_vm.f_field.no_edit ? '' : _vm.isEditing ? 'save' : 'edit'},on:{"click:append-outer":_vm.saveOrEdit},nativeOn:{"input":function($event){return _vm.$emit('input', $event.target.value)}}}),_vm._v(" "),(_vm.an_exists)?_c('div',[_vm._v("This accession number already exists!")]):_vm._e(),_vm._v(" "),(_vm.saved)?_c('div',{staticClass:"ml-3"},[_vm._v("Value was saved!")]):_vm._e(),_vm._v(" "),(_vm.cannotSave)?_c('div',{staticClass:"ml-3"},[_vm._v("\n        Value already exists! Cannot save!\n      ")]):_vm._e()],1):(this.field_type == 'date')?_c('v-flex',{class:((_vm.f_field.class) + " mt-3 py-0 px-3"),attrs:{"xs12":"","md12":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":32,"nudge-top":18,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.f_field.title,"prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1):(this.field_type == 'bool')?_c('v-flex',{attrs:{"px-3":""}},[_c('v-switch',{attrs:{"value":("" + (_vm.f_artwork[_vm.f_field.name])),"label":("" + (_vm.f_field.title)),"color":"black"}})],1):(this.field_type == 'radio')?_c('v-flex',{attrs:{"px-3":""}},[_c('v-radio-group',{attrs:{"label":("" + (_vm.f_field.title)),"column":_vm.f_field.column ? _vm.f_field.column : false},model:{value:(_vm.parent[_vm.f_field.name]),callback:function ($$v) {_vm.$set(_vm.parent, _vm.f_field.name, $$v)},expression:"parent[f_field.name]"}},_vm._l((_vm.f_field.selection),function(s){return _c('v-radio',{key:s.id ? s.id : s,staticClass:"ml-3",attrs:{"label":s.name ? s.name : s,"value":s.id ? s.id : s}})}),1),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',{staticClass:"xs12 elevation-3 py-3 px-3"},[_c('v-flex',{attrs:{"c":""}},[_c('v-text-field',{attrs:{"label":"Audio Codec","hint":"MP3, AAC, AC3 etc."},model:{value:(_vm.film.audio_codec),callback:function ($$v) {_vm.$set(_vm.film, "audio_codec", $$v)},expression:"film.audio_codec"}})],1),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('v-select',{staticClass:"ml-0",attrs:{"items":['32 kHz', '44,1 kHz', '48 kHz', '96 kHz', '192 kHz'],"label":"Audio Resolution"}})],1):_vm._e(),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Audio Bit","column":""},model:{value:(_vm.film.audio_bit),callback:function ($$v) {_vm.$set(_vm.film, "audio_bit", $$v)},expression:"film.audio_bit"}},_vm._l((['16 Bit', '20 Bit', '24 Bit']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('v-select',{staticClass:"ml-0",attrs:{"items":_vm.channels,"item-value":"id","item-text":"name","label":"Channels"}})],1):_vm._e(),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('v-select',{staticClass:"ml-0",attrs:{"items":[
              'light optical tone',
              'magnetic',
              'digital',
              'unknown',
              'other' ],"label":"Audio Specs"}})],1):_vm._e()],1):_vm._e()],1):(this.field_type == 'checkbox')?_c('v-flex',{attrs:{"px-3":""}},[_c('v-flex',[_c('h4',{staticClass:"sub-headline mt-3 ml-3"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_vm._l((_vm.f_field.selection),function(s){return _c('v-checkbox',{key:s.id ? s.id : s,staticClass:"left mr-3 ml-3",attrs:{"hide-details":"","label":s.name ? s.name : s,"refs":_vm.f_field.name}},[_vm._v(_vm._s(s.name ? s.name : s))])})],2)],1):(this.field_type == 'toggle')?_c('v-flex',{attrs:{"px-3":"","mb-2":""}},[_c('h4',{staticClass:"body-2 mt-3 ml-1"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_c('v-flex',{staticClass:"py-2",attrs:{"xs12":"","sm6":""}},[_c('v-btn-toggle',{on:{"change":_vm.save},model:{value:(_vm.toggle),callback:function ($$v) {_vm.toggle=$$v},expression:"toggle"}},_vm._l((_vm.f_field.selection),function(s){return _c('v-btn',{key:s.id ? s.value : s,staticClass:"px-2",attrs:{"small":"","flat":"","value":s.value}},[_c('span',[_vm._v(" "+_vm._s(s.name)+" ")])])}),1)],1)],1):(_vm.f_field.etype === 'select')?_c('v-layout',{attrs:{"px-3":"","mt-3":"","row":"","wrap":""}},[_c('v-flex',[(!_vm.f_field.just_text)?_c('v-select',{ref:_vm.f_field.related_field,attrs:{"items":_vm.selection_items,"label":("" + (_vm.f_field.title)),"item-text":"name","item-value":"id","name":_vm.f_field.name,"append-outer-icon":_vm.f_field.addNew ? 'add' : '',"preppend-icon":_vm.f_field.preicon},on:{"click:append-outer":_vm.showAddForm},model:{value:(_vm.select_value),callback:function ($$v) {_vm.select_value=$$v},expression:"select_value"}}):_c('div',[_vm._v("\n          "+_vm._s(_vm.f_artwork[_vm.f_field.name]
              ? _vm.f_artwork[_vm.f_field.name].name
              : 'NOT FOUND')+"\n        ")]),_vm._v(" "),(
            _vm.f_field.name == 'classification_new_id' &&
            this.select_value == 'film'
          )?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Select Film Type","row":""},model:{value:(_vm.film.film_type),callback:function ($$v) {_vm.$set(_vm.film, "film_type", $$v)},expression:"film.film_type"}},_vm._l((['tape', 'film', 'digital born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e(),_vm._v(" "),(
            _vm.f_field.name == 'classification_new_id' &&
            this.select_value == 'inst'
          )?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-flex',{staticClass:"subheadline mt-4"},[_vm._v("Includes")]),_vm._v(" "),_vm._l(([
                'Objects',
                'Sound',
                'FilmVideoAV',
                'Slide',
                'Computer Program / Software / File',
                'Performance',
                'Light',
                'Other' ]),function(s){return _c('v-checkbox',{key:s,attrs:{"label":s,"value":s,"hide-details":"","xs12":"","md6":"","lg4":""},model:{value:(_vm.instalation_includes),callback:function ($$v) {_vm.instalation_includes=$$v},expression:"instalation_includes"}})})],2),_vm._v(" "),(this.instalation_includes.indexOf('FilmVideoAV') >= 0)?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-radio-group',{attrs:{"label":"Select Film Type","row":""},model:{value:(_vm.film.film_type),callback:function ($$v) {_vm.$set(_vm.film, "film_type", $$v)},expression:"film.film_type"}},_vm._l((['tape', 'film', 'digital born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e(),_vm._v(" "),(this.instalation_includes.indexOf('Other') >= 0)?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-text-field',{staticClass:"ml-3",attrs:{"name":"including_other","label":"Other","row":""},model:{value:(_vm.film.film_type),callback:function ($$v) {_vm.$set(_vm.film, "film_type", $$v)},expression:"film.film_type"}})],1):_vm._e()],1):_vm._e()],1)],1):(_vm.f_field.etype === 'autocomplete')?_c('v-flex',{attrs:{"mt-3":"","px-3":""}},[_c('v-autocomplete',{attrs:{"solo":"","items":this.selection_items,"label":("" + (_vm.f_field.title)),"item-text":"name","item-value":"id","chips":_vm.f_field.chips,"multiple":_vm.f_field.multiple,"append-outer-icon":_vm.f_field.addNew ? 'add' : 'remove'},on:{"click:append-outer":_vm.showAddForm},model:{value:(_vm.value_new),callback:function ($$v) {_vm.value_new=$$v},expression:"value_new"}})],1):_vm._e(),_vm._v(" "),(this.showingAddForm && _vm.f_field.addNew)?_c('v-flex',[(_vm.f_field.table == 'artists')?_c('add-artist',{attrs:{"itemToAdd":"f_field"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(this.showingAddForm && _vm.f_field.addNew)?_c('v-flex',[(_vm.f_field.table == 'artwork_locations')?_c('add-location',{attrs:{"itemToAdd":"f_field"}}):_vm._e()],1):_vm._e()],1)])}
var staticRenderFns = []


/***/ }),

/***/ "U54s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UBmN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"small":_vm.small,"type":"button"},on:{"click":_vm.onexport}},[_vm._v("Excel download")])],1)}
var staticRenderFns = []


/***/ }),

/***/ "UM8A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UTi9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_axios_js__ = __webpack_require__("81r7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_locations_Location_vue__ = __webpack_require__("SwzB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_artworks_FilterBox__ = __webpack_require__("h4Ft");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_locations_LocationsTable__ = __webpack_require__("WoQN");
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      displayedData: [],
      location: {
        name: ''
      },
      locations: [],
      results: []
    };
  },
  // beforeRouteEnter (to, from, next) {
  //   // getPost(to.params.id, (err, post) => {
  //     next(vm => vm.switchOwnership(to))
  //     // console.log('beforeRouteEnter')
  //   // })
  // },
  // when route changes and this component is already rendered,
  // the logic will be slightly different.
  // beforeRouteUpdate(to, from, next) {
  //   // console.log('beforeRouteUpdate')
  //   this.displayedData = null
  //   // getPost(to.params.id, (err, post) => {
  //   this.switchOwnership(to)
  //   next()
  //   // })
  // },
  created: function created() {
    this.$store.dispatch('loadLocations');
  },
  methods: {
    // switchOwnershipTop(switchStatus) {
    //   // console.log(switchStatus)
    //   if (switchStatus) {
    //   } else {
    //     this.switchOwnership(this.$route)
    //   }

    // // switchCategory (to) {
    // //   switch (to.params.location_categories) {
    // //     case 'artwork_acquisition_source':
    // //       this.displayedData = this.$store.state.collection
    // //       break
    // //     case 'device_acquisition_company':
    // //       this.displayedData = this.$store.state.pac_fvh
    // //       break
    // //   }
    // },
    // filterLocations (category) {
    //   locations = this.results.filter(function(c)  {
    //       return results.filter(function(c) {
    //         return c.category == category
    //     }).length > 1
    //   })
    //   this.displayedData = locations

    //   for (location in this.results) {
    //     if (location.category == category) {
    //         this.results[artist].artworks[artwork].splice(1,1)
    //     }
    //   }
    //   let artists = ''
    //   artists = this.storedData.filter(function(artist)  {
    //     return artist.artworks.filter(function(artwork) {
    //       return artwork.ownership == ownership
    //     }).length > 1
    //   })
    //   this.displayedData = artists
    // },
    switchOwnership: function switchOwnership(to) {
      // console.log('switchOwnership')
      // console.log(to.params.ownership)
      // this.displayedData = this.$store.state.collection

      this.displayedData = this.$store.state.locations.filter(function (a) {
        return a.cateogory == to.params.ownership;
      });
      // switch (to.params.ownership) {
      //   case 'artwork_acquisition_source':
      //     // console.log(to.params.ownership)
      //     this.displayedData = this.$store.state.locations
      //     // console.log(this.displayedData)
      //     break
      //   case 'artwork_acquisition_source':
      //     // console.log(to.params.ownership)
      //     this.displayedData = this.$store.state.artworks.filter(function(a) {
      //       return a.cateogory == to.params.ownership
      //     })
      //     break
      //   case 'pdcFvh':
      //     // console.log(to.params.ownership)
      //     this.displayedData = this.$store.state.artworks.filter(function(a) {
      //       return a.ownership == 7
      //     })
      //     break
      //   case 'pacMr':
      //     // console.log(to.params.ownership)
      //     this.displayedData = this.$store.state.artworks.filter(function(a) {
      //       return a.ownership == 10
      //     })
      //     break
      //   case 'oldMasters':
      //     // console.log('case=' + to.params.ownership)
      //     // console.log(this.$store.state.oldMasters.length)
      //     this.displayedData = this.$store.state.artworks.filter(function(a) {
      //       return a.ownership == 9
      //     })
      //     break
      //   case 'deaccession':
      //     // console.log(to.params.ownership)
      //     this.displayedData = this.$store.state.artworks.filter(function(a) {
      //       return a.ownership == 5
      //     })
      //     break
      //   default:
      //   this.displayedData = this.$store.state.deaccession
    }
  },

  computed: {
    // title() {
    //   let title = 'Artwork Locations'
    //   // if (this.$route.fullPath == '/locations/oldMasters') {
    //   //   title = 'Old Masters'
    //   // } else if (this.$route.fullPath == '/locations/deaccession') {
    //   //   title = 'Deaccessioned'
    //   // } else if (this.$route.fullPath == '/locations/collection') {
    //   //   title = 'TBA21 Collection'
    //   // } else if (this.$route.fullPath == '/locations/pacFvh') {
    //   //   title = 'Private Art Collection FTB'
    //   // } else if (this.$route.fullPath == '/locations/pdcFvh') {
    //   //   title = 'Private Design Collection FTB'
    //   // } else if (this.$route.fullPath == '/locations/pacMr') {
    //   //   title = 'Private Art Collection MR'
    //   // }
    //   return title
    // },
    // processedLocations () {
    //   let locations = this.results
    //   // this.locations.map(location => {
    //   //   let a = location
    //   //   location.first_name = a ? a.first_name : 'nema meno'
    //   // })
    //   return locations
    // }
  },

  // filters: {
  //   capitalize: function (a) {
  //     if (!a) return ''
  //     a = a.toString()
  //     return a.charAt(0).toUpperCase() + a.slice(1)
  //   }
  // },
  components: {
    Location: __WEBPACK_IMPORTED_MODULE_1__components_locations_Location_vue__["a" /* default */],
    LocationsTable: __WEBPACK_IMPORTED_MODULE_3__components_locations_LocationsTable__["a" /* default */]
  }
});

/***/ }),

/***/ "Upkr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are you sure you want to delete this exhibition?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n            This Exhibition will be deleted from all artworks.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n              No\n            ")]),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.deleteExhibition}},[_vm._v("\n              Yes\n            ")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),(_vm.show_form)?_c('new-exhibition-history',{attrs:{"loan":"1"},on:{"show_form":function($event){_vm.show_form=$event}}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(this.exhibitions.length>0)?_c('v-switch',{attrs:{"label":"Advanced","value":"advanced","color":"black"},model:{value:(_vm.view),callback:function ($$v) {_vm.view=$$v},expression:"view"}}):_vm._e(),_vm._v(" "),(_vm.show_form==false)?_c('v-btn',{staticClass:"right small",attrs:{"fab":"","dark":"","color":"grey","outline":""},on:{"click":function($event){_vm.show_form=true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),(this.exhibitions.length==0)?_c('h3',{staticClass:"pl-4"},[_vm._v("No Loans for this artwork yet.")]):_vm._e(),_vm._v(" "),(this.exhibitions)?_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[(this.exhibitions.length>0)?_c('v-data-iterator',{attrs:{"items":_vm.exhibitions,"content-tag":"v-layout","row":"","wrap":"","hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-flex',{attrs:{"xs12":"","sm12":"","md6":"","lg6":""}},[(_vm.view=='advanced')?_c('v-card',[_c('v-card-title',[_c('h4',[_vm._v(_vm._s(props.item.show_type == 0 ? "Solo show" : "Group show")+": "+_vm._s(props.item.title))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v(_vm._s(props.item.institution)+" "+_vm._s(props.item.city)+" "+_vm._s(props.item.country))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v(_vm._s(props.item.duration_start)+" - "+_vm._s(props.item.duration_end))])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.view!='advanced')?_c('v-card',[_c('v-card-title',[_c('h4',[_vm._v(_vm._s(props.item.show_type == 0 ? "Solo show" : "Group show")+": "+_vm._s(props.item.title))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v(_vm._s(props.item.institution)+", "+_vm._s(props.item.city)+", "+_vm._s(props.item.country)+" ")])],1)],1)],1):_vm._e()],1)}}],null,false,3876610987)}):_vm._e()],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "UuKG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      costs: [],
      other: [],
      editing: false,
      showDialog: false,
      selected: [],
      dialog: false,
      dialog2: false,
      headers: [{ text: 'What for', value: 'what_for', sortable: true }, { text: 'Cost', value: 'cost', sortable: true }, { text: 'Notes', value: 'content', sortable: true }, { text: 'Created by', value: 'created_by', sortable: true }, { text: 'Transaction Date', value: 'transaction_date', sortable: true }, { text: false, sortable: false }],
      headers_other: [{ text: 'What for', value: 'what_for', sortable: true }, { text: 'Notes', value: 'content', sortable: true }, { text: 'Created by', value: 'created_by', sortable: true }, { text: 'Transaction Date', value: 'transaction_date', sortable: true }, { text: false, sortable: false }],
      editedIndex: -1,
      show: false,
      showUpload: false,
      loan_condition: {
        what_for: '',
        transaction_date: '',
        cost: '',
        content: '',
        category: 'cost',
        artwork_id: ''
      }
    };
  },
  computed: {
    c_user: function c_user() {
      return this.$store.state.user.profile;
    },
    incomeSummary: function incomeSummary() {
      // console.log('income')
      // console.log(this.artwork.loan_conditions)
      // console.log(this.artwork.loan_conditions.length)
      if (this.artwork.loan_conditions && this.artwork.loan_conditions.length > 0) {
        var out = this.artwork.artwork_costs.filter(function (ac) {
          if (ac.cost) {
            // console.log(ac.cost)
            return ac.cost > 0;
          } else {
            return '';
          }
        });
        // console.log(out)
        if (out && out.length > 0) {
          return out.map(function (o) {
            return o.income;
          }).reduce(function (a, c) {
            return a + c;
          });
        } else {
          return 0;
        }
      }
      // .reduce((a,b) => a + b, 0)
    },
    expenseSummary: function expenseSummary() {
      // console.log('cost')
      // console.log(this.artwork.loan_conditions)
      // console.log(this.artwork.loan_conditions.length)
      if (this.artwork.loan_conditions && this.artwork.loan_conditions.length > 0) {
        var out = this.artwork.loan_conditions.filter(function (ac) {
          if (ac.cost) {
            // console.log(ac.cost)
            return ac.cost > 0;
          } else {
            return '';
          }
        });
        // console.log(out.map(o=>o.cost).reduce((a,c)=>a+c))
        if (out && out.length > 0) {
          return out.map(function (o) {
            return o.cost;
          }).reduce(function (a, c) {
            return a + c;
          });
        } else {
          return 0;
        }
      }
      // .reduce((a,b) => a + b, 0)
    },
    all_loan_conditions: function all_loan_conditions() {
      return this.$store.state.loan_conditions;
      // console.log(todos)
      // return todos
    }
    // selection_items () {
    //   var artworkLocations = Object.assign([], this.$store.getters.current_locations)
    //   return artworkLocations.sort(dynamicSort('name'))
    // }

  },
  methods: {
    editCost: function editCost(c) {
      this.loan_condition = {
        what_for: '',
        transaction_date: '',
        income: '',
        expense: '',
        content: '',
        artwork_id: ''
      };
      this.editing = true;
      try {
        this.loan_condition = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, this.artwork.artwork_costs.find(function (t) {
          return t.id === c.id;
        }));
        this.loan_condition.transaction_date = this.format_date(this.loan_condition.transaction_date ? this.loan_condition.transaction_date : Date.now);
        this.showDialog = true;
      } catch (error) {
        // console.log(error.message)
      }
    },
    load_costs: function load_costs() {
      this.costs = this.artwork.artwork_costs.filter(function (c) {
        return c.category === 'costs';
      });
    },
    load_other: function load_other() {
      this.other = this.artwork.artwork_costs.filter(function (c) {
        return c.category === 'other';
      });
    },
    initialize: function initialize() {},
    deleteItem: function deleteItem(item) {
      confirm('Are you sure you want to delete this Loan Condition?');
      this.delete_loan_condition(item);
    },
    delete_loan_condition: function delete_loan_condition(item) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Deleting Cost.', 'black');
      var url = this.$globals.apiserver + '/artwork_costs/' + item.id + '.json';
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.delete(url, item).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Cost Deleted.', 'green');
        _this.errors = {};
        var index = _this.artwork.artwork_costs.indexOf(item);
        if (index >= 0) _this.artwork.artwork_costs.splice(index, 1);
        _this.$store.dispatch('updateArtwork', _this.artwork.id);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'There was an Error deleting Cost.', 'red');
        _this.errors = error.response.data;
      });
    },

    // get_visa_status (loanCondition) {
    //   var vss = this.constants.VISA_STATUSES.filter(vs => vs.id === loanCondition.visa_status)
    //   if (vss[0] !== undefined) {
    //     return vss[0].id > 0 ? vss[0].name : ''
    //   } else {
    //     return ''
    //   }
    // },
    getUser: function getUser(userId) {
      var l = this.$store.state.users.find(function (u) {
        return u.id === userId;
      });
      return l ? l : '';
    },
    save: function save() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Saving Loan Condition ...', 'green');
      this.loan_condition.artwork_id = this.artwork.id;
      this.loan_condition.created_by = this.c_user.id;
      // this.loan_condition.id = this.findMinMax(this.all_loan_conditions)+1
      if (!this.artwork.artwork_costs) {
        this.artwork.artwork_costs = [];
      }
      // this.artwork.artwork_loan_conditions.push(this.loan_condition)
      if (!this.editing) {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.$globals.apiserver + '/artwork_costs.json', {
          artwork_cost: this.loan_condition
          // loan_condition: this.loan_condition
        }).then(function (response) {
          _this2.errors = {};
          _this2.artwork.artwork_costs.push(response.data);
          // this.$store.commit('ADD_COST', response.data)
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'There was an Error saving Loan Condition.', 'red');
          _this2.errors = error.response.data;
        });
        // this.all_loan_conditions.push(this.loan_condition)
        // this.showUpload=!this.showUpload
        this.showDialog = false;
        this.loan_condition = {
          what_for: '',
          transaction_date: '',
          // cost: '',
          cost: '',
          content: ''
        };
      } else {
        var url = this.$globals.apiserver + '/artwork_costs/' + this.loan_condition.id + '.json';
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, {
          artwork_cost: this.loan_condition
        }).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'Loan Condition Saved.', 'green');
          _this2.errors = {};
          _this2.artwork.artwork_costs = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this2.artwork.artwork_costs.map(function (item) {
            return item.id !== response.data.id ? item : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, response.data);
          })));
          _this2.editing = false;
          _this2.showDialog = false;
          // this.$store.commit("SAVE_COST", response.data);
          // this.$store.commit('ADD_COST', response.data)
        }).catch(function (error) {
          __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$emit('showSnackbar', 'There was an Error saving Cost.', 'red');
          _this2.errors = error.response.data;
        });
      }
    }
  }
});

/***/ }),

/***/ "VDCb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditExhibition_vue__ = __webpack_require__("j4mB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1982ed04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditExhibition_vue__ = __webpack_require__("jNYR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("uuDu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1982ed04"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditExhibition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1982ed04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditExhibition_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1982ed04_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditExhibition_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VHCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"fluid":"","xs12":""}},[_c('v-layout',{staticClass:"xs12 mx-0 px-0 my-2 row wrap"},[_c('v-flex',{attrs:{"xs12":"","px-2":""}},[_c('v-text-field',{attrs:{"xs12":"","name":_vm.collective_name,"placeholder":"Collective Name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-2":""}},[_c('v-autocomplete',{attrs:{"xs12":"","items":_vm.artists,"label":"Select artists who belong to this multi artist","item-text":"name","item-value":"id","chips":"","deletable-chips":"","multiple":""},model:{value:(_vm.multi_artists),callback:function ($$v) {_vm.multi_artists=$$v},expression:"multi_artists"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-iterator',{attrs:{"items":_vm.multi_artists,"item-key":"id","item-value":"id","row":"","wrap":"","hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-card',{staticClass:"elevation-0 mb-3 mx-4"},[_c('v-card-title',{staticClass:"title"},[_vm._v(_vm._s((_vm.ids2o ([props.item]))[0].name))]),_vm._v(" "),(_vm.ids2o ([props.item])[0].artworks)?_c('v-card-text',[_vm._v(_vm._s(_vm.ids2o ([props.item])[0].artworks.length)+" artworks.")]):_vm._e()],1)}}])})],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "VPhs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-2"},[(_vm.table_artworks.length > 0)?_c('v-list',{staticClass:"mx-0 px-0 mb-2",attrs:{"two-line":""}},[_vm._l((_vm.table_artworks),function(item,index){return [_c('v-list-tile',{key:item.id},[_vm._v(_vm._s(item.key)+"\n        "),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-list-tile-avatar',[_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_c('span',_vm._g({},data.on),[_c('v-btn',{staticStyle:{"width":"20px","height":"20px"},attrs:{"round":"","color":"red","icon":"","small":"","dense":"","hint":"Remove Artwork from Exhibition"},on:{"click":function($event){return _vm.remove_from_exhibition(item.id)}}},[_c('v-icon',{attrs:{"small":"","dense":"","color":"white"}},[_vm._v("remove")])],1)],1)]}}],null,true)},[_vm._v("\n            Remove Artwork from Exhibition\n          ")])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',{staticClass:"ml-2 pl-0"},[_c('v-list-tile-sub-title',{staticClass:"subheading"},[_c('router-link',{attrs:{"to":{ name: 'EditArtwork', params: {id: item.id, artwork: item}, path: ("/artworks/edit/" + (item.id))}}},[_vm._v("\n              "+_vm._s(item.accession_number)+" "),_c('b',[_vm._v(_vm._s(item.title))]),_vm._v(", "+_vm._s(item.production_date_new)+", "+_vm._s((item.artist ? item.artist.name : item.name))+"\n              ")])],1),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n            "+_vm._s(_vm.get_location_name(item.artwork_location_id))+"\n            ")])],1)],1)]})],2):[_c('p',{staticClass:"my-0 mx-0 px-0 text-xs-left align-left justify-left"},[_vm._v("No Artworks")])]],2)}
var staticRenderFns = []


/***/ }),

/***/ "Vc8Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedOwnership: {},
      ownerships: [],
      filtered: [],
      dialog: false,
      artworks: [],
      artworks2: [],
      location: {},
      selectedLocation: {},
      afilter: '2',
      locations: [],
      search_related: '',
      selected_related: [],
      pagination2: {
        rowsPerPage: 10,
        sortBy: 'name'
      },
      pagination_related: {
        descending: true,
        // rowsPerPage: 10,
        sortBy: 'title'
      },
      show_tag_filter: false,
      show_classifications: false,
      filter: {
        selected_classifications: [],
        selected_classification_negations: []
      },
      ta: [],
      selected_tags: [],
      // selected_categories: [],
      // location_categories: [
      //   {id:1, name: 'loan_borrower', color: 'red', position: 2},
      //   {id:3, name: 'loan_contact_person', color: 'blue', position: 1},
      //   {id:7, name: 'loan_insurance_company', color: 'purple', position: 7},
      //   {id:2, name: 'artwork_acquisition_source', color: 'green', position: 3},
      //   {id:4, name: 'registrar', color: 'yellow', position: 4},
      //   {id:5, name: 'staff', color: 'pink', position: 5},
      //   {id:6, name: 'device_acquisition_company', color: 'grey', position: 6},
      //   {id:8, name: 'staff_external', color: 'grey', position: 8},
      //   {id:9, name: 'trustee', color: 'grey', position: 9}
      // ],
      selected: [],
      search: '',
      headers: [{ text: '', sortable: false, value: '' }, { text: 'Location', value: 'name', align: 'left' }, { text: 'City', value: 'city', align: 'left' }, { text: 'Country', value: 'country_id', align: 'left' }, {
        text: 'Number of artworks at location',
        value: 'artworks.length',
        align: 'right'
        // { text: '', value:'',align: 'right' }
      }]
    };
  },

  props: ['items'],
  created: function created() {
    ;this.selectedOwnership.id = 2, this.locations = this.$store.state.locations;
    this.ownerships = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.getters.my_ownerships);
    this.ownerships.unshift({ id: 'all', name: 'All' });
    this.toggleOwnership(this.$store.state.filters['locations'] ? this.$store.state.filters['locations'] : this.ownerships[0]);
    // this.toggleOwnership(this.ownerships[0]);
  },
  methods: {
    getNoOfArtworksAtLocation: function getNoOfArtworksAtLocation(as) {
      var _this = this;

      if (this.selectedOwnership.id != 'all') {
        return as.filter(function (a) {
          return _this.selectedOwnership.id == a.ownership;
        }).length;
      } else {
        return as.length;
      }
    },
    toggleOwnership: function toggleOwnership(o) {
      // var array = [];
      // for (var i in ownerships) {
      //   // array.push(i);
      //   array.push(ownerships[i]);
      // }
      // console.log(array);
      // console.log(this.ownerships);
      // console.log(array.indexOf(this.s_ownership));
      // console.log(this.s_ownership);
      // console.log(this.ownerships.indexOf(this.s_ownership));
      this.$store.dispatch('setFilter', { section: 'locations', ownership: o });
      this.selectedOwnership = o;
    },
    imageUrlAlt: function imageUrlAlt(event) {
      event.target.src = '/static/no_image.jpg';
    },
    setLocation2: function setLocation2() {
      var _this2 = this;

      this.location2 = this.$store.state.locations.find(function (c) {
        return c.id === _this2.selectedLocation;
      });
      this.artworks2 = this.$store.state.artworks.filter(function (a) {
        return a.artwork_location_id === _this2.location2.id;
      });
    },
    resetSelected: function resetSelected() {
      this.selected = [];
      this.artworks = [];
      this.artworks2 = [];
    },
    deleteLocation: function deleteLocation(c) {
      this.selected = [];
      this.selected.push(c);
      this.dialog = true;
      this.location = c;
      this.artworks = this.$store.state.artworks.filter(function (a) {
        return c.id == a.artwork_location_id;
      });
    },
    deleteLocations: function deleteLocations() {
      var _this3 = this;

      this.dialog = true;
      // this.location = c;
      this.artworks = this.$store.state.artworks.filter(function (a) {
        return _this3.selected.map(function (a) {
          return a.id;
        }).includes(a.artwork_location_id);
      });
    },
    deleteLocation2: function deleteLocation2() {
      var _this4 = this;

      if (this.artworks.length > 0) {
        this.artworks.forEach(function (c) {
          // this.$emit("showSnackbar", "Moving Artwork to a New Location: " + c.title);
          __WEBPACK_IMPORTED_MODULE_2__main__["serverBus"].$emit('showSnackbar', 'Moving Artwork: "' + c.title + '" to a New Location: "' + _this4.selected.name + '".', 'black');
          var artwork_location_log = {};
          artwork_location_log.created_by = _this4.c_user.id;
          artwork_location_log.artwork_id = c.id;
          artwork_location_log.old_location = _this4.selected.id;
          artwork_location_log.artwork_location_id = _this4.selectedLocation;
          artwork_location_log.storage = 'in';
          artwork_location_log.copy = 'artwork';
          artwork_location_log.reason = 'Deleting Old location';
          artwork_location_log.note = 'Deleting Old location';
          artwork_location_log.storage_in = new Date().toISOString().substr(0, 10);
          artwork_location_log.change_date = new Date().toISOString().substr(0, 10);
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(_this4.$globals.apiserver + '/artwork_location_logs.json', {
            artwork_location_log: artwork_location_log
          }).then(function (response) {
            _this4.errors = {};
            _this4.$store.commit('ADD_LOG', response.data);
            _this4.$store.dispatch('loadLocations');
            _this4.$store.dispatch('loadArtworks');
            _this4.showUpload = !_this4.showUpload;
            __WEBPACK_IMPORTED_MODULE_2__main__["serverBus"].$emit('showSnackbar', 'Artwork "' + c.title + '" successfully moved to a new location: "' + _this4.selected.name + '".', 'green');
            _this4.selected = [];
            _this4.selectedLocation = {};
            _this4.artwork_location_log = {
              storage: 'in',
              note: '',
              change_date: '',
              copy: 'artwork',
              shipper: '',
              reason: '',
              artwork_location_id: '',
              artwork_packing_id: ''
            };
          }).catch(function (error) {
            __WEBPACK_IMPORTED_MODULE_2__main__["serverBus"].$emit('showSnackbar', 'There was a problem moving Artwork "' + c.title + '" to a new location: "' + _this4.selected.name + '".', 'red');
            // console.log(error);
          });
        });
      } else {
        this.selected.forEach(function (l) {
          _this4.deleteLocationFromServer(l);
        });
      }
      this.dialog = false;
      this.location = '';
      this.artworks = [];
      this.artworks2 = [];
      this.selected = [];
    },
    deleteLocationFromServer: function deleteLocationFromServer(l) {
      var _this5 = this;

      l.updated_by = this.c_user.id;
      var url = this.$globals.apiserver + '/artwork_locations/' + l.id + '.json';
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url, l).then(function (response) {
        // this.$emit('getArtwork')
        __WEBPACK_IMPORTED_MODULE_2__main__["serverBus"].$emit('showSnackbar', 'Location ' + l.name + ' deleted.', 'rgba(0, 125, 0, 0.8)');
        _this5.$store.dispatch('loadLocations');
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__main__["serverBus"].$emit('showSnackbar', 'Error occuredd while deleting Location.', 'rgba(125, 0, 0, 0.8)');
        // console.log(error)
      });
    },
    location_artworks: function location_artworks(id) {
      var a = this.$store.state.artworks.filter(function (artwork) {
        return artwork.artwork_location_id == id;
      });
      return a;
    },
    switchSwitch: function switchSwitch() {
      this.show_tag_filter = !this.show_tag_filter;
      this.$emit('switchOwnershipTop', this.show_tag_filter);
    },
    clearFilters: function clearFilters() {
      this.selected_tags = [];
      this.selected_tag_categories = [];
    },
    clear_selection: function clear_selection() {
      this.$store.dispatch('clearCurrentSelection');
      this.selected = [];
    },
    select_all: function select_all() {
      this.selected = this.table_locations;
      var temp_selection = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      this.table_locations.forEach(function (a) {
        if (!temp_selection.includes(a)) {
          temp_selection.push(a);
        }
      });
      this.$store.dispatch('saveCurrentSelection', temp_selection);
    },
    save_selection: function save_selection() {
      this.$store.dispatch('clearCurrentSelection');
    },
    save_currently_selected: function save_currently_selected(a, b) {
      setTimeout(function () {
        var temp_selection = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
        //// console.log(temp_selection)
        if (!a) {
          // console.log('a true')
          if (!temp_selection.includes(b)) {
            // console.log('doesnt include')
            temp_selection.push(b);
          }
        } else {
          // console.log('false')
          var index = temp_selection.indexOf(b);
          // console.log('index = ' + index)
          temp_selection.splice(index, 1);
        }
        this.$store.dispatch('saveCurrentSelection', temp_selection);
      }.bind(this), 1000);
    },
    save_currently_selected_all: function save_currently_selected_all(a) {
      // console.log('///////////')
      // console.log('a = ' + a)
      var temp_selection = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(temp_selection)
      if (!a) {
        // console.log('a true')
        if (!temp_selection.includes(b)) {
          // console.log('doesnt include')
          temp_selection.push(b);
        }
      } else {
        // console.log('false')
        var index = temp_selection.indexOf(b);
        // console.log('index = ' + index)
        temp_selection.splice(index, 1);
      }
      // this.$store.state.currentSelection
      // console.log(temp_selection)
      // this.selected.forEach(s => {
      //   if (!temp_selection.includes(s)) {
      //     temp_selection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', temp_selection);
    },
    save_currently_selected_tags: function save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags);
      this.ta = this.tagged_locations;
    }
  },
  computed: {
    // currrent_path() {
    //   return this.$route.params.ownership;
    // },
    // saved_lists() {
    //   return [
    //     { id: 1, title: "list1" },
    //     { id: 2, title: "list2" }
    //   ];
    // },
    // selected_locations() {
    //   return this.$store.state.currentSelection;
    // },
    table_locations_with_artworks: function table_locations_with_artworks() {
      var _this6 = this;

      var out = this.$store.state.locations.filter(function (l) {
        return l.disabled != 1;
      });
      out.forEach(function (item) {
        return item.artworks = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this6.location_artworks(item.id)));
      });
      if (this.selectedOwnership.id != 'all') {
        out = out.filter(function (a) {
          return a.artworks.some(function (ea) {
            return ea.ownership == _this6.selectedOwnership.id;
          });
        });
      }

      // .map(l => {
      //   l.artworks = this.location_artworks(l.id);
      //   return l;
      // });

      // if (this.afilter == '1') {
      //   console.log('1')
      //   return out.filter(l => this.location_artworks(l.id).length > 0)
      // } else if (this.afilter == '0') {
      //   console.log('0')
      //   return out.filter(l => this.location_artworks(l.id).length == 0)
      // } else {
      //   console.log('000')
      return out;
      // }
    },
    sorted_locations: function sorted_locations() {
      var ls = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.locations);
      return ls.sort(function (a, b) {
        return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
      });
    }
    // table_contacts() {
    //   return this.$store.state.contacts.filter(
    //     c =>
    //       c.category == "artwork_acquisition_source" ||
    //       c.category == "registrar"
    //   );
    //   // }
    // },
    // table_locations() {
    //   if (this.afilter == 1) {
    //     // var cst = this.selected_categories
    //     var a = this.locations.filter(function(location) {
    //       // console.log(location)
    //       return cst.indexOf(location.category) > -1;
    //     });
    //     // console.log(a)
    //     return this.locations.filter(function(location) {
    //       // console.log(cst)
    //       // console.log(cst.indexOf(location.category))
    //       return cst.indexOf(location.category) > -1;
    //     });
    //   } else {
    //     return this.items;
    //   }
    // },
    // tagged_locations() {
    //   var cst = this.$store.state.currentSelectionTags;
    //   return this.table_locations.filter(function(location) {
    //     return location.tags.some(a_tag => cst.indexOf(a_tag.id) > -1);
    //   });
    // },
    // select_categories() {
    //   var stc = this.selected_tag_categories;
    //   var tc = this.tag_categories;
    //   var tags = Object.assign([], this.$store.state.tags);
    //   var out = [];
    //   // console.log(tags)
    //   tags.forEach(tag => {
    //     var a = tc.filter(function(tagc) {
    //       return tagc.id == tag.tag_category_id;
    //     });
    //     // console.log(a[0].color)
    //     tag.color = a[0].color;
    //     out.push(tag);
    //   });
    //   // console.log(out)
    //   return out.filter(function(tag) {
    //     return stc.some(st => tag.tag_category_id == st);
    //   });
    // }

  }
});

/***/ }),

/***/ "VcEo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_artworks_TextEditor__ = __webpack_require__("JslP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // article: null,
      editedIndex: -1,
      article: {
        title: '',
        version: '',
        subtitle: '',
        updates: '',
        help: '',
        at_work: '',
        support: '',
        show_in_route: '',
        group: ''
      },
      defaultItem: {
        title: '',
        version: '',
        subtitle: '',
        updates: '',
        help: '',
        at_work: '',
        support: '',
        show_in_route: '',
        group: ''
        // new_article: { title: '', version: '' },
      } };
  },

  props: ['editedItem'],
  beforeMount: function beforeMount() {
    // console.log(this.editedItem)
    if (this.editedItem) {
      this.article = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.editedItem);
    }
    this.getArticle();
  },

  methods: {
    getArticle: function getArticle() {
      var _this = this;

      // console.log('getArtist')
      var url = this.$globals.apiserver + '/support_articles/' + this.$route.params.id + '.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
        // this.loading = false;
        // this.result = response.data[0]
        _this.article = response.data;
        // this.artist = response.data.artist
        // console.log(response.data)
        // console.log(response.data[0])
        // console.log(this.article)
        // console.log(this.artwork)
      }).catch(function (error) {
        console.log(error);
      });
    },
    createArticle: function createArticle() {
      var _this2 = this;

      // this.snackbar = true
      var url = this.$globals.apiserver + '/support_articles.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, this.newItem).then(function (response) {
        // this.result = response.data
        var o = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ name: _this2.newItem.title });
        _this2.$store.dispatch('createArticle', o);
        _this2.save_user_form_display = false;
        _this2.snackbar = false;
        _this2.newItem = _this2.defaultItem;
        // this.$router.push({path:`/users/edit/${this.result.id}`, params: {user: this.result}})
      }).catch(function (error) {
        console.log(error);
      });
    },

    // close () {
    //   this.dialog = false
    //   setTimeout(() => {
    //     this.editedItem = Object.assign({}, this.defaultItem)
    //     this.editedIndex = -1
    //   }, 300)
    // },
    save: function save() {
      var url = this.$globals.apiserver + '/support_articles/' + this.editedItem.id + '.json';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.put(url, { article: this.article }).then(function (response) {
        // this.result = response.data
        // console.log(response.data)
        // this.$store.dispatch('updateArticle', this.result)
        // this.snackbar = true
      }).catch(function (error) {
        console.log(error);
      });
      // if (this.editedIndex > -1) {
      //   Object.assign(this.$store.state.support_articles[this.editedIndex], this.editedItem)
      // } else {
      //   this.$store.state.support_articles.push(this.editedItem)
      // }
      // this.close()
    }
  },
  components: { TextEditor: __WEBPACK_IMPORTED_MODULE_1__components_artworks_TextEditor__["a" /* default */] }
});

/***/ }),

/***/ "VedM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRelatedArtists_vue__ = __webpack_require__("/rCi");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89929b6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelatedArtists_vue__ = __webpack_require__("8hqa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Tdwg")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a89929b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListRelatedArtists_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89929b6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelatedArtists_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a89929b6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListRelatedArtists_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VsUZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__("7+uW");

// import store from 'vuex'




// const mocks = {
//   'lists': { 'POST': { token: 'This-is-a-mocked-token' } },
//   'lists': { 'GET': { name: 'doggo', title: 'sir' } }
// }

var apiCall = function apiCall(_ref) {
  var url = _ref.url,
      method = _ref.method,
      user = _ref.user;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var url2 = '' + __WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype.$globals.apiserver + url;
    var okresponse = '';
    // let errresponse = ''
    // console.log(url)
    // console.log(method)
    // console.log('apiCall')
    // console.log(url)
    // console.log(method)

    setTimeout(function () {
      try {
        if (method === 'POST') {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url2, { user: user }).then(function (response) {
            // console.log('response POST')
            // console.log(response.data)
            okresponse = response.data;
            resolve(okresponse);
          }).catch(function (err) {
            // errresponse = err
            // console.log('err POST')
            // console.log(err)
            reject(new Error(err));
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url2, { user: user }).then(function (response) {
            // console.log('response GET')
            // console.log(response)
            okresponse = response.data;
            resolve(okresponse);
          }).catch(function (err) {
            // errresponse = err
            // console.log('err GET')
            // console.log(err)
            reject(new Error(err));
          });
        }
        // console.log(url)
        // console.log(store)
        // console.log(mocks)
        // console.log(mocks[url][method || 'GET'])
        // this.loginFailed())

        // var u = this.$store.state.users.find(u => user.login === user.username)
        // console.log('test')
        // console.log(this.$store.state.users)
        // if (u && u.id > 0) {
        //   this.$router.push({path: `/lists`})
        //   this.$store.commit('LOGIN_USER', u)
        // } else {
        //   this.error = 'Wrong login.'
        //   console.log('Wrong login.')
        // }
        // resolve(okresponse)
        // console.log(okresponse)
      } catch (err) {
        // console.log(errresponse)
        // console.log('error in api resolve')
        reject(new Error(err));
      }
    }, 2000);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (apiCall);

/***/ }),

/***/ "VwPy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabelsSmall_vue__ = __webpack_require__("ZMio");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0942704b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabelsSmall_vue__ = __webpack_require__("XLiS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("1wD+")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0942704b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LabelsSmall_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0942704b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabelsSmall_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0942704b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LabelsSmall_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WCQA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WD8M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      menu2: false,
      showUpload: false,
      edit: false,
      showOld: false,
      saving: false,
      showList: false,
      show: false,
      errors: '',
      conservation: {
        reason: '',
        created_by: '',
        link: '',
        basic_condition_notes: '',
        conservator: '',
        last_condition_check: ''
      }
    };
  },
  // beforeCreate() {
  //   setTimeout(
  //     function() {
  //       // this.$store.dispatch("saveCurrentTab", tab)
  //     }.bind(this),
  //     3000
  //   );
  // },
  computed: {
    artwork_conservations: function artwork_conservations() {
      var out = this.artwork.conservations.sort(function (a, b) {
        if (b.last_condition_check > a.last_condition_check) {
          return 1;
        } else {
          return -1;
        }
      });
      return out;
    }
  },
  methods: {
    cancelAddEdit: function cancelAddEdit() {
      this.showUpload = false;
      this.edit = false;
      this.conservation = {
        reason: '',
        conservator: '',
        created_by: '',
        link: '',
        basic_condition_notes: '',
        last_condition_check: ''
      };
    },

    // location_name(id) {
    //   // console.log(id)
    //   if (id > 0) {
    //     var a = this.$store.state.locations.find(l => l.id === id);
    //     if (a) {
    //       return a.name;
    //     } else {
    //       return "Location not found in CMS.";
    //     }
    //   } else {
    //     return "Location not found in CMS.";
    //   }
    // },
    download: function download() {},
    delete_log: function delete_log(l) {
      var _this = this;

      var url = this.$globals.apiserver + '/conservations/' + l.id + '.json';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(url, l).then(function (response) {
        _this.$emit('getArtwork');
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Conservation deleted.', 'rgba(0, 125, 0, 0.8)');
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Error occuredd while deleting Conservation.', 'rgba(125, 0, 0, 0.8)');
        // console.log(error)
      });
    },
    edit_log: function edit_log(c) {
      console.log(c);
      this.conservation = c;
      this.edit = true;
      // serverBus.$emit('showSnackbar', 'not implemented yet', "rgba(125, 0, 0, 0.8)")
    },
    update_conservation: function update_conservation() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Saving ...', 'rgba(0, 0, 0, 0.9)');
      this.saving = true;
      // this.conservation.artwork_id = this.artwork.id;
      // console.log(this.c_user.id);
      // this.conservation.created_by = this.c_user.id;
      // if (!this.artwork.conservations) {
      //   this.artwork.conservations = [];
      // }
      // this.$store.commit('ADD_TODO', this.conservation)
      // this.all_conservations.push(this.conservation)
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(this.$globals.apiserver + '/conservations/' + this.conservation.id + '.json', {
        conservation: this.conservation
      }).then(function (response) {
        _this2.$emit('getArtwork');
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Saved.', 'rgba(0, 125, 0, 0.9)');
        _this2.errors = {};
        // this.artwork.conservations.push(response.data);
        // console.log(this.conservation.artwork_location_id)
        // this.$store.commit("ADD_CONSERVATION", response.data);
        // this.active_conservations = this.$store.state.conservations;
        _this2.showUpload = false;
        _this2.edit = false;
        // this.artwork.last_media_check = this.conservation.last_condition_check
        _this2.conservation = {
          reason: '',
          conservator: '',
          created_by: '',
          link: '',
          basic_condition_notes: '',
          last_condition_check: ''
        };
        _this2.saving = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Problem while saving.', 'rgba(125, 0, 0, 0.8)');
        console.log(error);
        _this2.saving = false;
        // this.errors = error.response.data;
      });
      // var aconservation = Object.keys(this.conservation).forEach(k => this.conservation[k]='')
      // console.log(aconservation)
    },
    save_conservation: function save_conservation() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Saving ...', 'rgba(0, 0, 0, 0.8)');
      this.saving = true;
      this.conservation.artwork_id = this.artwork.id;
      // console.log(this.c_user.id);
      this.conservation.created_by = this.c_user.id;
      if (!this.artwork.conservations) {
        this.artwork.conservations = [];
      }
      // this.$store.commit('ADD_TODO', this.conservation)
      // this.all_conservations.push(this.conservation)
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.$globals.apiserver + '/conservations.json', {
        conservation: this.conservation
      }).then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Saved.', 'rgba(0, 125, 0, 0.8)');
        _this3.errors = {};
        _this3.artwork.conservations.push(response.data);
        // console.log(this.conservation.artwork_location_id)
        _this3.$store.commit('ADD_CONSERVATION', response.data);
        // this.active_conservations = this.$store.state.conservations;
        _this3.showUpload = !_this3.showUpload;
        _this3.artwork.last_media_check = _this3.conservation.last_condition_check;
        _this3.conservation = {
          reason: '',
          conservator: '',
          created_by: '',
          link: '',
          basic_condition_notes: '',
          last_condition_check: ''
        };
        _this3.$emit('getArtwork');
        _this3.saving = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Problem while saving.', 'rgba(125, 0, 0, 0.8)');
        console.log(error);
        _this3.saving = false;
        // this.errors = error.response.data;
      });
      // var aconservation = Object.keys(this.conservation).forEach(k => this.conservation[k]='')
      // console.log(aconservation)
    }
  }
});

/***/ }),

/***/ "WV97":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"mt-2",attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","mx-4":"","mb-5":""}},[_c('h2',[_vm._v("Tags assigned to this artwork")]),_vm._v(" "),_vm._l((['cataloguing','concept','relation','private']),function(c){return _c('v-flex',{key:c,attrs:{"subheading":"","my-3":""}},[_c('h3',{staticClass:"mb-2"},[_vm._v(_vm._s(c))]),_vm._v(" "),_vm._l((_vm.artwork.tags),function(t){return (t.section == c)?_c('v-chip',{key:t.id,attrs:{"color":t.color,"close":"","disabled":!_vm.c_user.edit},on:{"input":function($event){return _vm.deleteTag(t.id)}}},[(t.subcategory)?_c('span',[_vm._v(_vm._s(((t.subcategory) + "::")))]):_vm._e(),_vm._v(" "),_c('b',[_vm._v(_vm._s(t.name))])]):_vm._e()})],2)}),_vm._v(" "),_c('v-divider')],2),_vm._v(" "),(_vm.c_user.edit)?_c('v-flex',{attrs:{"align":"center","sm":"6","mx-4":""}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mx-3":""}},[(_vm.showUpload)?_c('v-flex',[_c('v-text-field',{staticClass:"ml-2",attrs:{"name":"note","label":"Note"},model:{value:(_vm.tag.title),callback:function ($$v) {_vm.$set(_vm.tag, "title", $$v)},expression:"tag.title"}}),_vm._v(" "),_c('v-text-field',{staticClass:"ml-2",attrs:{"name":"description","label":"Description"},model:{value:(_vm.tag.description),callback:function ($$v) {_vm.$set(_vm.tag, "description", $$v)},expression:"tag.description"}}),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.showUpload = !_vm.showUpload}}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.showUpload = !_vm.showUpload}}},[_vm._v("cancel")])],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "WWEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExhibitionHistory_vue__ = __webpack_require__("3pbx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ac4990_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExhibitionHistory_vue__ = __webpack_require__("efMv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("nFuI")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-20ac4990"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExhibitionHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ac4990_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExhibitionHistory_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20ac4990_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExhibitionHistory_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "WoQN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationsTable_vue__ = __webpack_require__("Vc8Q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffa2bfee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationsTable_vue__ = __webpack_require__("5sV0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("s9Mf")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ffa2bfee"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffa2bfee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationsTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffa2bfee_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationsTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Wv9D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{staticClass:"ml-0 mb-1"},[_c('b',[_vm._v("Total Expense:")]),_vm._v("\n    "+_vm._s(_vm.formatMoney(_vm.expenseSummary))+" EUR -\n    "),_c('b',[_vm._v("Total Income:")]),_vm._v("\n    "+_vm._s(_vm.formatMoney(_vm.incomeSummary))+" EUR\n  ")]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 mx-0",attrs:{"headers":_vm.headers,"items":_vm.artwork.artwork_costs ? _vm.artwork.artwork_costs.filter(function (c) { return c.category == '' || c.category == null; }) : [],"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{staticClass:"py-0 my-0"},[_c('td',{attrs:{"colspan":"5"}},[_c('v-container',{attrs:{"grid-list-xs":"","text-xs-start":"","xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","xs12":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('span',{staticClass:"subheadline pl-2"},[_c('b',[_vm._v(_vm._s(props.item.what_for))])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","py-0":"","my-0":"","text-xs-right":""}},[_c('v-btn',{attrs:{"flat":"","small":"","icon":"","ma-0":""}},[_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.edit_cost(props.item)}}},[_vm._v("edit")])],1),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{attrs:{"flat":"","small":"","icon":"","ma-0":""}},[_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_vm._v("delete")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('span',{staticClass:"subheadline pl-3"},[_vm._v("\n                    "+_vm._s(props.item.transaction_date ? props.item.transaction_date : 'no date set')+"\n                  ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('span',{staticClass:"subheadline pl-3"},[_vm._v("\n                    "+_vm._s(props.item.income ? _vm.formatMoney(props.item.income) : ' - ')+" "+_vm._s(props.item.income ? 'EUR' : '')+"\n                  ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('span',{staticClass:"subheadline pl-3"},[_vm._v("\n                    "+_vm._s(props.item.expense ? _vm.formatMoney(props.item.expense) : ' - ')+" "+_vm._s(props.item.expense ? 'EUR' : '')+"\n                  ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}})],1)],1)],1)])]}}])}),_vm._v(" "),(_vm.c_user.edit && !_vm.showDialog)?_c('v-btn',{staticClass:"mx-3 mt-3 mb-0 right",attrs:{"small":"","color":"primary"},on:{"click":function($event){_vm.showDialog=true}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("add")]),_vm._v("Add Cost\n  ")],1):_vm._e(),_vm._v(" "),(_vm.showDialog)?_c('v-card',{staticClass:"mb-3 mx-3 pt-0 mt-3 elevation-2",staticStyle:{"background-color":"#fff"}},[_c('v-card-title',{staticClass:"px-3 pb-0 mb-0 pt-1"},[_c('span',{staticClass:"headline pt-2 pb-0 mb-0 pl-2",domProps:{"innerHTML":_vm._s(!_vm.editing ? 'New Cost' : 'Editing Cost')}})]),_vm._v(" "),_c('v-card-text',{staticClass:"mx-0 px-0 my-2 py-0"},[_c('v-container',{attrs:{"grid-list-xs":"","pb-0":"","pt-0":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","ml-0":"","mb-1":""}},[_c('v-date-picker',{staticClass:"mb-3 elevation-0",attrs:{"color":"black","full-width":"","name":"transaction_date","label":"Transaction Date"},model:{value:(_vm.artwork_cost.transaction_date),callback:function ($$v) {_vm.$set(_vm.artwork_cost, "transaction_date", $$v)},expression:"artwork_cost.transaction_date"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-2":""}},[_c('v-text-field',{staticClass:"flex pl-2",attrs:{"name":"what_for","label":"What for"},model:{value:(_vm.artwork_cost.what_for),callback:function ($$v) {_vm.$set(_vm.artwork_cost, "what_for", $$v)},expression:"artwork_cost.what_for"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","mb-0":""}},[_c('v-text-field',{staticClass:"flex pl-2",attrs:{"type":"number","suffix":" EUR","name":"income","label":"Income"},model:{value:(_vm.artwork_cost.income),callback:function ($$v) {_vm.$set(_vm.artwork_cost, "income", $$v)},expression:"artwork_cost.income"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","mb-0":""}},[_c('v-text-field',{staticClass:"flex pl-2",attrs:{"type":"number","suffix":" EUR","name":"expense","label":"Expense"},model:{value:(_vm.artwork_cost.expense),callback:function ($$v) {_vm.$set(_vm.artwork_cost, "expense", $$v)},expression:"artwork_cost.expense"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pr-4 pb-4"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","outline":""},nativeOn:{"click":function($event){_vm.showDialog=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[(!_vm.editing)?_c('span',[_vm._v("Add ")]):_vm._e(),_vm._v(" "),(_vm.editing)?_c('span',[_vm._v("Save ")]):_vm._e(),_vm._v(" cost\n      ")])],1)],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "WyIz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lists_vue__ = __webpack_require__("mUHq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b871d22e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lists_vue__ = __webpack_require__("+KYf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("YTwl")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b871d22e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Lists_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b871d22e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lists_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b871d22e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Lists_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XBeV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XJLE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XLiS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-0",attrs:{"small":_vm.small,"light":_vm.light,"loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.pdfLabelsCall.apply(null, arguments)}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":_vm.small}},[_vm._v("mdi-file-pdf")]),_vm._v(" Small LABELS")],1)}
var staticRenderFns = []


/***/ }),

/***/ "XNgJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XNw2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Audio_vue__ = __webpack_require__("DHjl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5159538_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Audio_vue__ = __webpack_require__("9++d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("xo4a")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c5159538"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Audio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5159538_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Audio_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c5159538_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Audio_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "XUYi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-4 px-3 pt-5"},[_c('v-container',{attrs:{"fluid":"","px-0":"","py-0":"","ma-4":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"outline":"","label":"Location Name"},on:{"keyup":function($event){return _vm.check_location($event.target.value)}},nativeOn:{"input":function($event){return _vm.$emit('input',$event.target.value)}},model:{value:(_vm.artwork_location.name),callback:function ($$v) {_vm.$set(_vm.artwork_location, "name", $$v)},expression:"artwork_location.name"}}),_vm._v(" "),(_vm.location_exists)?_c('div',[_vm._v("This Location already exists!")]):_vm._e(),_vm._v(" "),(_vm.saved)?_c('div',[_vm._v("Location was saved!")]):_vm._e(),_vm._v(" "),(_vm.cannotSave)?_c('div',[_vm._v("Location already exists! Cannot save!")]):_vm._e()],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.saveLocation.apply(null, arguments)}}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""}},[_vm._v("Cancel")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "Xaup":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('v-toolbar',{attrs:{"color":"indigo","dark":""}},[_c('v-toolbar-side-icon'),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Discover")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("search")])],1)],1),_vm._v(" "),_c('v-container',{staticClass:"grey lighten-4",attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.cards),function(card){return _c('v-flex',_vm._b({key:card.title},'v-flex',( _obj = {}, _obj[("xs" + (card.flex))] = true, _obj ),false),[_c('v-card',[_c('v-card-media',{attrs:{"src":card.src,"height":"200px"}},[_c('v-container',{attrs:{"fill-height":"","fluid":""}},[_c('v-layout',{attrs:{"fill-height":""}},[_c('v-flex',{attrs:{"xs12":"","align-end":"","flexbox":""}},[_c('span',{staticClass:"headline white--text",domProps:{"textContent":_vm._s(card.title)}})])],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"white"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("favorite")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("bookmark")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',[_vm._v("share")])],1)],1)],1)],1)
var _obj;}),1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "Xfr6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('h2',[_vm._v("Current Artist")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-3":""}},[_vm._v("\n        "+_vm._s(_vm.artwork.artist.full_name)+"\n        "+_vm._s(this.f_artist)+"\n    ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-3":""}},[_c('v-select',{attrs:{"items":_vm.artists,"label":"Select artists who belong to this multi artist","item-text":"name","item-value":"id","autocomplete":"","chips":"","deletable-chips":"","multiple":""},model:{value:(_vm.multi_artists),callback:function ($$v) {_vm.multi_artists=$$v},expression:"multi_artists"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-iterator',{attrs:{"items":_vm.multi_artists,"item-key":"id","item-value":"id","row":"","wrap":"","hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-card',{staticClass:"elevation-2 mb-3 mx-3"},[_c('v-card-title',{staticClass:"title"},[_vm._v(_vm._s((_vm.ids2o ([props.item]))[0].name))]),_vm._v(" "),(_vm.ids2o ([props.item])[0].artworks)?_c('v-card-text',[_vm._v(_vm._s(_vm.ids2o ([props.item])[0].artworks.length)+" artwork.")]):_vm._e()],1)}}])})],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "XkcQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__ = __webpack_require__("lHA8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__ = __webpack_require__("c/Tr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__main__ = __webpack_require__("NHnr");








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['showDialog', 'selected'],
  watch: {
    selected: function selected() {
      this.getPackings();
      this.getLocationLogs();
    }
  },
  created: function created() {
    this.getPackings();
    this.getLocationLogs();
  },
  data: function data() {
    return {
      selectedPackings: [],
      selectedArtworks: [],
      moveAllPackingsSwitch: null,
      packings: [],
      menu2a: false,
      artwork_location_log: {
        storage: 'in',
        note: '',
        change_date: '',
        copy: 'artwork',
        storage_in: '',
        storage_out: '',
        shipper: '',
        reason: '',
        artwork_location_id: '',
        artwork_packing_id: '',
        artwork_id: ''
      }
    };
  },

  methods: {
    removeArtworkFromSelection: function removeArtworkFromSelection(artwork) {
      var index = this.selected.indexOf(artwork);
      if (index > -1) {
        this.selected.splice(index, 1);
      }
    },
    lastArtworkChangeDate: function lastArtworkChangeDate(artwork_id) {
      var last = this.lastLocationLogArtwork(artwork_id).change_date;
      if (last) {
        return last;
      } else {
        return '1900-01-01';
      }
    },
    lastArtworkPackingChangeDate: function lastArtworkPackingChangeDate(packing_id) {
      var last = this.lastLocationLogArtworkPacking(packing_id).change_date;
      if (last) {
        return last;
      } else {
        return '1900-01-01';
      }
    },
    lastLocationLogArtworkPacking: function lastLocationLogArtworkPacking(id) {
      return this.getLastLog(this.logs, 'packings', id);
    },
    lastLocationLogArtwork: function lastLocationLogArtwork(id) {
      return this.getLastLog(this.logs, 'artwork', id);
    },
    getLastLog: function getLastLog(logs, copy, id) {
      if (copy == 'packings') {
        if (logs && logs.length > 0) {
          var out = logs.filter(function (ll) {
            return ll.artwork_packing_id === id;
          }).sort(function (a, b) {
            if (a.change_date > b.change_date) {
              return -1;
            }
            if (a.change_date < b.change_date) {
              return 1;
            }
            return 0;
          })[0];
          if (out) {
            return out;
          } else {
            return '';
          }
        } else {
          return '';
        }
      } else {
        if (logs && logs.length > 0) {
          var out = logs.filter(function (ll) {
            return ll.copy === copy && ll.artwork_id == id;
          }).sort(function (a, b) {
            if (a.change_date > b.change_date) {
              return -1;
            }
            if (a.change_date < b.change_date) {
              return 1;
            }
            return 0;
          })[0];
          if (out) {
            return out;
          } else {
            return '';
          }
        } else {
          return '';
        }
      }
    },


    /**
     * Toggles the selection of all packings for a specific artwork.
     * Adds all packings of the artwork to selectedPackings if checked, otherwise removes them.
     * @param {Boolean} isChecked - Whether the checkbox is checked.
     * @param {Number} artworkId - The ID of the artwork.
     */
    // moveOrRemoveAllPackingsforArtwork(checkboxValue, artworkId) {
    //   const artworkPackingsIds = this.packings
    //     .filter(packing => packing.artwork_id === artworkId)
    //     .map(packing => packing.id);
    //     console.log(artworkPackingsIds)
    //   if (checkboxValue === artworkId) {
    //   console.log(this.selectedPackings)
    //       // Add all packings for this artwork, avoiding duplicates
    //       this.selectedPackings = [...new Set([...this.selectedPackings, ...artworkPackingsIds])];

    //   } else {
    //   console.log(this.selectedPackings)
    //       // Remove all packings for this artwork
    //       this.selectedPackings = this.selectedPackings.filter(id => !artworkPackingsIds.includes(id));
    //   }
    // },

    /**
     * Toggles the selection of all packings for a specific artwork based on the checkbox state.
     * Adds all packings of the artwork to selectedPackings if checked, otherwise removes them.
     * @param {Array} checkboxValue - The value from the checkbox, either an empty array or an array with packing IDs.
     * @param {Number} artworkId - The ID of the artwork.
     */
    moveOrRemoveAllPackingsforArtwork: function moveOrRemoveAllPackingsforArtwork(checkboxValue, artworkId) {
      var artworkPackingsIds = this.packings.filter(function (packing) {
        return packing.artwork_id === artworkId;
      }).map(function (packing) {
        return packing.id;
      });

      if (checkboxValue.includes(artworkId)) {
        // Add all packings for this artwork, avoiding duplicates
        this.selectedPackings = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_set___default.a([].concat(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(this.selectedPackings), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_toConsumableArray___default()(artworkPackingsIds))));
      } else {
        // Remove all packings for this artwork
        this.selectedPackings = this.selectedPackings.filter(function (id) {
          return !artworkPackingsIds.includes(id);
        });
      }
    },


    // NOT USED
    moveAllPackingsforArtwork: function moveAllPackingsforArtwork(e, id) {
      var _this = this;

      // console.log(id)
      // console.log(this.selectedPackings)
      this.selectedPackings = this.selectedPackings.filter(function (p) {
        return _this.packings.find(function (pp) {
          return pp.id == p;
        }).artwork_id != id;
      });
      console.log(this.selectedPackings);
      if (e.includes(id)) {
        // console.log('e')
        // console.log(e[0])
        // console.log('e')
        // console.log(id)
        this.selectedPackings = this.selectedPackings.concat(this.packings.filter(function (p) {
          return p.artwork_id == id;
        }).map(function (ppp) {
          return ppp.id;
        }));
      }
      if (!this.selectedPackings) {
        this.selectedPackings = [];
      }
      // console.log(this.selectedPackings)
    },

    /**
     * Moves all packings.
     *
     * @param {Event} e - The event object.
     * @return {void} This function does not return a value.
     */
    moveAllPackings: function moveAllPackings(e) {
      if (e) {
        this.selectedPackings = this.packings.map(function (p) {
          return p.id;
        });
      } else {
        this.selectedPackings = [];
      }
    },
    getPackings: function getPackings() {
      var _this2 = this;

      var ids = this.selected.map(function (a) {
        return a.id;
      });
      console.log(this.selected);
      console.log(ids);
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(this.$globals.apiserver + '/artwork_packings.json', {
        params: {
          // user_id: localStorage.getItem('user-token'),
          artwork_ids: ids
        }
      }).then(function (r) {
        return _this2.packings = r.data;
      });
      console.log('Packings loaded');
    },
    getLocationLogs: function getLocationLogs() {
      var _this3 = this;

      var ids = this.selected.map(function (a) {
        return a.id;
      });
      console.log(this.selected);
      console.log(ids);
      __WEBPACK_IMPORTED_MODULE_8_axios___default.a.get(this.$globals.apiserver + '/artwork_location_logs.json', {
        params: {
          // user_id: localStorage.getItem('user-token'),
          artwork_ids: ids
        }
      }).then(function (r) {
        return _this3.logs = r.data;
      });
      console.log('Logs loaded');
    },
    getArtworkPackings: function getArtworkPackings(id) {
      return this.packings.filter(function (p) {
        return p.artwork_id == id;
      });
      // console.log('Artwork Packings filtered')
    },
    closeChangeLocationDialog: function closeChangeLocationDialog() {
      this.artwork_location_log = {
        storage: 'in',
        storage_in: '',
        storage_out: '',
        note: '',
        change_date: '',
        copy: 'artwork',
        shipper: '',
        reason: '',
        artwork_location_id: '',
        artwork_packing_id: '',
        artwork_id: ''
      };
      this.$emit('hideDialog');
    },


    /**
     * Batch change of artwork and packings location and creating a new log entry.
     */
    changeLocation: function changeLocation() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this4.setupLogBasics();
                __WEBPACK_IMPORTED_MODULE_9__main__["serverBus"].$emit('showSnackbar', 'Adding Location History Entry/Changing locations - ' + _this4.selected + ' artworks \u2026', 'green');

                _context.next = 4;
                return _this4.handleArtworksUpdate();

              case 4:
                _context.next = 6;
                return _this4.handlePackingsUpdate();

              case 6:

                _this4.resetStateAfterSave();
                _this4.$emit('hideDialog');

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },

    /**
     * Sets up the basic configuration for the artwork location log.
     */
    setupLogBasics: function setupLogBasics() {
      this.artwork_location_log.created_by = this.c_user.id;
      this.artwork_location_log.last_update_by = this.c_user.id;
      this.artwork_location_log.location_id = this.artwork_location_log.artwork_location_id;

      if (this.artwork_location_log.storage === 'in') {
        this.artwork_location_log.storage_in = this.artwork_location_log.change_date;
      } else {
        this.artwork_location_log.storage_out = this.artwork_location_log.change_date;
      }

      // Handling a case where the country_id might be undefined
      // this.artwork_location_log.country_id = this.artwork_location_log.country_id || '';
    },

    /**
     * Processes the update for selected artworks.
     */
    handleArtworksUpdate: function handleArtworksUpdate() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, artwork;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 3;
                _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this5.selected);

              case 5:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context2.next = 12;
                  break;
                }

                artwork = _step.value;
                _context2.next = 9;
                return _this5.updateArtwork(artwork);

              case 9:
                _iteratorNormalCompletion = true;
                _context2.next = 5;
                break;

              case 12:
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](3);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 18:
                _context2.prev = 18;
                _context2.prev = 19;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 21:
                _context2.prev = 21;

                if (!_didIteratorError) {
                  _context2.next = 24;
                  break;
                }

                throw _iteratorError;

              case 24:
                return _context2.finish(21);

              case 25:
                return _context2.finish(18);

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5, [[3, 14, 18, 26], [19,, 21, 25]]);
      }))();
    },

    /**
     * Updates an individual artwork's location and creates a log entry.
     * @param {Object} artwork - The artwork object to be updated.
     */
    updateArtwork: function updateArtwork(artwork) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var lastLog, updateResponse, logResponse;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                // Check if the artwork location needs to be updated
                lastLog = _this6.lastLocationLogArtwork(artwork.id);

                if (!(_this6.artwork_location_log.artwork_location_id !== artwork.artwork_location_id && _this6.artwork_location_log.change_date > lastLog.change_date)) {
                  _context3.next = 11;
                  break;
                }

                _context3.next = 5;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.put(_this6.$globals.apiserver + '/artworks/' + artwork.id + '.json', {
                  artwork: {
                    artwork_location_id: _this6.artwork_location_log.artwork_location_id
                  }
                });

              case 5:
                updateResponse = _context3.sent;
                _context3.next = 8;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(_this6.$globals.apiserver + '/artwork_location_logs.json', {
                  artwork_location_log: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this6.artwork_location_log, {
                    artwork_id: artwork.id,
                    copy: 'artwork'
                  })
                });

              case 8:
                logResponse = _context3.sent;


                // Update local state with new log
                _this6.$store.commit('ADD_LOG', logResponse.data);
                __WEBPACK_IMPORTED_MODULE_9__main__["serverBus"].$emit('showSnackbar', 'Location of ' + artwork.title + ' saved.', 'green');

              case 11:
                _context3.next = 17;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](0);

                console.error('Failed to update location for artwork ' + artwork.title + ':', _context3.t0);
                __WEBPACK_IMPORTED_MODULE_9__main__["serverBus"].$emit('showSnackbar', 'Error occurred while updating location.', 'red');
                // You might want to handle different types of errors differently
                // this.errors = error.response.data; // Uncomment this if you need to handle specific error data

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this6, [[0, 13]]);
      }))();
    },

    /**
     * Processes the update for selected packings.
     */
    handlePackingsUpdate: function handlePackingsUpdate() {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, packingId;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context4.prev = 3;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(_this7.selectedPackings);

              case 5:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context4.next = 12;
                  break;
                }

                packingId = _step2.value;
                _context4.next = 9;
                return _this7.updatePacking(packingId);

              case 9:
                _iteratorNormalCompletion2 = true;
                _context4.next = 5;
                break;

              case 12:
                _context4.next = 18;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4['catch'](3);
                _didIteratorError2 = true;
                _iteratorError2 = _context4.t0;

              case 18:
                _context4.prev = 18;
                _context4.prev = 19;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 21:
                _context4.prev = 21;

                if (!_didIteratorError2) {
                  _context4.next = 24;
                  break;
                }

                throw _iteratorError2;

              case 24:
                return _context4.finish(21);

              case 25:
                return _context4.finish(18);

              case 26:
                _this7.selectedPackings = []; // Reset selected packings after processing

              case 27:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this7, [[3, 14, 18, 26], [19,, 21, 25]]);
      }))();
    },

    /**
     * Updates the location of an individual packing and creates a log entry.
     * @param {Number} packingId - The ID of the packing to be updated.
     */
    updatePacking: function updatePacking(packingId) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var packing, lastLog, updateResponse, log, logResponse;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;

                // Find the selected packing
                packing = _this8.packings.find(function (p) {
                  return p.id === packingId;
                });

                if (packing) {
                  _context5.next = 5;
                  break;
                }

                console.warn('Packing with ID ' + packingId + ' not found.');
                return _context5.abrupt('return');

              case 5:

                // Check if the packing location needs to be updated
                lastLog = _this8.lastLocationLogArtworkPacking(packing.id);

                if (!(_this8.artwork_location_log.artwork_location_id !== packing.artwork_location_id && _this8.artwork_location_log.change_date > lastLog.change_date)) {
                  _context5.next = 16;
                  break;
                }

                _context5.next = 9;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.put(_this8.$globals.apiserver + '/artwork_packings/' + packing.id + '.json', {
                  artwork_packing: {
                    artwork_location_id: _this8.artwork_location_log.artwork_location_id
                  }
                });

              case 9:
                updateResponse = _context5.sent;


                // Create a new log entry for the packing
                log = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this8.artwork_location_log, {
                  artwork_id: packing.artwork_id,
                  artwork_packing_id: packing.id,
                  copy: 'packings'
                });
                _context5.next = 13;
                return __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(_this8.$globals.apiserver + '/artwork_location_logs.json', {
                  artwork_location_log: log
                });

              case 13:
                logResponse = _context5.sent;


                // Update local state with new log
                _this8.$store.commit('ADD_LOG', logResponse.data);
                __WEBPACK_IMPORTED_MODULE_9__main__["serverBus"].$emit('showSnackbar', 'Location of packing ID ' + packing.id + ' saved.', 'green');

              case 16:
                _context5.next = 22;
                break;

              case 18:
                _context5.prev = 18;
                _context5.t0 = _context5['catch'](0);

                console.error('Failed to update location for packing ID ' + packingId + ':', _context5.t0);
                __WEBPACK_IMPORTED_MODULE_9__main__["serverBus"].$emit('showSnackbar', 'Error occurred while updating packing location.', 'red');
                // You might want to handle different types of errors differently
                // this.errors = error.response.data; // Uncomment this if you need to handle specific error data

              case 22:
                _context5.prev = 22;
                return _context5.finish(22);

              case 24:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8, [[0, 18, 22, 24]]);
      }))();
    },

    /**
     * Resets the component state after saving updates.
     * This includes clearing the artwork location log, resetting selected packings and artworks, and other relevant states.
     */
    resetStateAfterSave: function resetStateAfterSave() {
      // Reset artwork location log to its default state
      this.artwork_location_log = this.getDefaultLogObject();

      // Clear selected artworks and packings
      this.selected = [];
      this.selectedPackings = [];
      this.selectedArtworks = [];

      // Reset any additional states as required
      // For example, if you have flags like 'changeArtworkLocation', reset them here
      this.changeArtworkLocation = false;
      this.moveAllPackingsSwitch = null;

      // Reload artworks and packings if needed
      this.$store.dispatch('loadArtworks');
      // Add similar dispatch for packings if there's a specific state or list for them

      // Emit an event or perform any other cleanup actions
      // this.$emit('updateComplete'); // Uncomment or modify based on your event handling needs
    },
    getDefaultLogObject: function getDefaultLogObject() {
      return {
        created_by: this.c_user.id,
        storage: 'in',
        note: '',
        change_date: '',
        copy: 'artwork',
        shipper: '',
        reason: '',
        artwork_location_id: '',
        artwork_packing_id: ''
      };
    },

    // END OF GENERATED CODE

    // BATCH CHANGE OF ARTWORK AND PACKINGS LOCATION AND CREATING A NEW LOG ENTRY
    changeLocation_old: function changeLocation_old() {
      var _this9 = this;

      this.artwork_location_log.created_by = this.c_user.id;
      this.artwork_location_log.last_update_by = this.c_user.id;
      this.artwork_location_log.location_id = this.artwork_location_log.artwork_location_id;
      if (this.artwork_location_log.storage === 'in') {
        this.artwork_location_log.storage_in = this.artwork_location_log.change_date;
      } else {
        this.artwork_location_log.storage_out = this.artwork_location_log.change_date;
      }

      __WEBPACK_IMPORTED_MODULE_9__main__["serverBus"].$emit('showSnackbar', 'Adding Location History Entry/Changing locations - ' + this.selected + ' artworks \u2026', 'green');

      /// kvoli mazaniu aktualnej hodnoty - autocomplete totiz vracia undefined ak je prazdny a potom neposle field vobec a preto nevymaze v rails hodnotu
      // this.artwork_location_log.country_id = this.artwork_location_log
      //   .country_id
      //   ? this.artwork_location_log.country_id
      //   : ''

      // LOOPUJEM CEZ ARTWORKY
      console.log(this.selected);
      this.selected.forEach(function (a) {

        // NASETUJEM BASICS FOR NEW ARTWORK LOG
        _this9.artwork_location_log.artwork_id = a.id;
        _this9.artwork_location_log.copy = 'artwork';

        // CREATE LOG FOR ALL SELECTED ARTWORKS
        console.log('Starting location update --------- ' + a.title);

        __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(_this9.$globals.apiserver + '/artwork_location_logs.json', {
          artwork_location_log: _this9.artwork_location_log
        }).then(function (response) {
          console.log('Location update SUCCESSFUL --------- ' + a.title);
          _this9.errors = {};
          __WEBPACK_IMPORTED_MODULE_9__main__["serverBus"].$emit('showSnackbar', 'Location of ' + a.title + ' saved.', 'green');
          _this9.$store.commit('ADD_LOG', response.data);
          // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
          // this.showUpload = !this.showUpload
        }).catch(function (error) {
          console.log('Location update FAILED --------- ' + a.title);
          console.log(error);
          __WEBPACK_IMPORTED_MODULE_9__main__["serverBus"].$emit('showSnackbar', 'Error occured while updating location.', 'red');
          // this.errors = error.response.data;
        });

        // ARTWORK SAMOTNY MENIM LEN AK NEEXISTUJE LOG S ROVNAKYM ALEBO NOVSIM CHANGE_DATE
        // AND NEW LOCATION IS DIFFERENT FROM CURRENT ONE
        var lastLog = _this9.lastLocationLogArtwork(a.id);
        if (_this9.artwork_location_log.artwork_location_id != a.artwork_location_id && _this9.artwork_location_log.change_date > lastLog.change_date) {

          // console.log(this.artwork_location_log.change_date)
          // console.log(this.lastLocationLogArtwork.change_date)
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.put(_this9.$globals.apiserver + '/artworks/' + a.id + '.json', {
            artwork: {
              artwork_location_id: _this9.artwork_location_log.artwork_location_id
            }
          }).then(function (response) {
            console.log('changeArtworkLocation response change artwork');

            _this9.errors = {};
            // this.artwork.artwork_location_logs.push(response.data)

            // ON SAVE SUCCESS SET CURRENT ARTWORK'S LOCATION TO NEW LOCATION
            // if (this.artwork_location_log.copy === 'artwork') {
            //   this.artwork.artwork_location_id = this.artwork_location_log.artwork_location_id
            // } else if (this.artwork_location_log.copy === 'master_physical') {
            //   this.artwork.master_physical_location_id = this.artwork_location_log.artwork_location_id
            // } else if (this.artwork_location_log.copy === 'archive_master') {
            //   this.artwork.archive_master_location_id = this.artwork_location_log.artwork_location_id
            // } else if (this.artwork_location_log.copy === 'access_copy') {
            //   this.artwork.access_copy_location_id = this.artwork_location_log.artwork_location_id
            // }
            // this.$store.commit('ADD_LOG', response.data)
            // this.active_artwork_location_logs = this.$store.state.artwork_location_logs
            _this9.changeArtworkLocation = false;
          });
        }
      });

      // LOOPUJEM CEZ SELECTED PACKINGS
      // FOR EACH SELECTED PACKING CREATE A HISTORY LOG AND CHANGE IT'S LOCATION
      // IF NEW CHANGE_DATE > AKO LAST LOG CHANGE DATE AND LOCATION IS NEW
      if (this.selectedPackings.length > 0) {
        var log = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.artwork_location_log);

        log.copy = 'packings';

        // LOOP THROUGH SELECTED PACKING IDs
        this.selectedPackings.forEach(function (p) {

          // FIND SELECTED PACKING
          var pack = _this9.packings.find(function (ap) {
            return ap.id == p;
          });
          console.log(pack);

          // CREATE A NEW LOCATION HISTORY ENTRY FOR PACKING
          // this.artwork_location_log.artwork_packing_id = a.id
          log.artwork_id = pack.artwork_id;
          log.artwork_packing_id = p;
          __WEBPACK_IMPORTED_MODULE_8_axios___default.a.post(_this9.$globals.apiserver + '/artwork_location_logs.json', {
            artwork_location_log: log
          }).then(function (response) {
            _this9.errors = {};
            var log = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this9.artwork_location_log);

            // this.artwork.artwork_location_logs.push(response.data)
            _this9.$store.commit('ADD_LOG', response.data);
            // this.active_artwork_location_logs =
            //   this.$store.state.artwork_location_logs
            // this.showUpload = !this.showUpload
          }).catch(function (error) {
            console.log(error);
          });

          // UPDATE PACKING IF:
          //   LOG CHANGE DATE IS NEWER THEN LAST PACKING LOG, 
          //   AND LOCATION_ID IS DIFFERENT FROM THE CURRENT ONE
          //   AND NEW LOCATION IS DIFFERENT FROM CURRENT ONE 
          //   -- UPDATE PACKING LOCATION
          if (log.artwork_location_id != pack.artwork_location_id && _this9.artwork_location_log.change_date > _this9.lastLocationLogArtworkPacking(pack.id).change_date) {

            __WEBPACK_IMPORTED_MODULE_8_axios___default.a.put(_this9.$globals.apiserver + '/artwork_packings/' + pack.id + '.json', {
              artwork_packing: {
                artwork_location_id: _this9.artwork_location_log.artwork_location_id
              }
            }).then(function (response) {
              console.log('changeArtworkLocation response change artwork');
              _this9.errors = {};
              // this.artwork.artwork_location_logs.push(response.data)
              _this9.changeArtworkLocation = false;
            });
          }
          _this9.selectedPackings = [];
          _this9.moveAllPackingsSwitch = null;
        });
      }

      this.$store.dispatch('loadArtworks');

      this.artwork_location_log = {
        storage: 'in',
        note: '',
        change_date: '',
        copy: 'artwork',
        storage_in: '',
        storage_out: '',
        shipper: '',
        reason: '',
        artwork_location_id: '',
        artwork_packing_id: '',
        artwork_id: ''
      };
      this.$emit('hideDialog');
    },

    /**
     * Check if there are any packings selected for a given artwork ID.
     * @param {number} id - The artwork ID to check against.
     * @returns {boolean} - True if there are selected packings, false otherwise.
     */
    hasSomePackingsSelected: function hasSomePackingsSelected(id) {
      // Get the IDs of packings that have the given ID as artwork_id
      var apids = this.packings.filter(function (p) {
        return p.artwork_id == id;
      }).map(function (p) {
        return p.id;
      });

      // Filter the selectedPackings array to include only IDs that are in apids
      var selectedPackingsWithId = this.selectedPackings.filter(function (pp) {
        return apids.includes(pp);
      });

      // Return true if there are any selected packings with the given ID, false otherwise
      return selectedPackingsWithId.length > 0;
    }
  },
  computed: {
    // selectedWithPackings() {
    //   return this.selected.filter((a) =>
    //     this.packings.find((p) => p.artwork_id == a.id)
    //   )
    // },
    locations: function locations() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.getters.enabled_locations).sort(dynamicSort('name'));
    }
  }
});

/***/ }),

/***/ "XqU9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xz4u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xs12 flex mx-1"},[_c('v-flex',{staticClass:"white--text text-uppercase body-2 elevation-0 pl-3 mx-1 pt-1",staticStyle:{"background-color":"#392939","line-height":"23px","height":"30px","border-radius":"4px"}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),_c('v-btn',{staticClass:"black--text right mt-0 mr-2 mb-0 pl-1 pr-2 xs12",staticStyle:{"text-decoration":"none !important","height":"30px","background-color":"#392939"},attrs:{"round":"","light":"","target":"_blank","small":"","flat":"","color":"white","rel":"noopener noreferrer"},on:{"click":_vm.showAdd}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"white"}},[_vm._v("add")]),_vm._v("\n        Add new Link\n      ")],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "Y0J/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YBR5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditFieldComp_vue__ = __webpack_require__("bKzt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13456b0e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFieldComp_vue__ = __webpack_require__("U39T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ApVW")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-13456b0e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditFieldComp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13456b0e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFieldComp_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13456b0e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFieldComp_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YJbu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YSMR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizzard_vue__ = __webpack_require__("0mR+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9ffc6aa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizzard_vue__ = __webpack_require__("7mOJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("jTo1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f9ffc6aa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Wizzard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9ffc6aa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizzard_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9ffc6aa_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Wizzard_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YSSe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YTmu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExcelPackings_vue__ = __webpack_require__("Pucp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_578e2b4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExcelPackings_vue__ = __webpack_require__("UBmN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("loos")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-578e2b4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExcelPackings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_578e2b4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExcelPackings_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_578e2b4c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExcelPackings_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YTwl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YZqf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // users: [],
      show_disabled: false,
      snackbar: false,
      snackbarFieldName: "",
      timeout: 3000,
      ta: [],
      new_user: { firstname: "", lastname: "", login: "", password: "" },
      save_user_form_display: false,
      selected_users: [],
      selected: [],
      search: "",
      headers: [
      // { text: 'Selection', align: 'center', sortable: false },
      { text: "First Name", value: "firstname", align: "left" }, { text: "Login", value: "login", align: "left" },
      // { text: 'Last Name', value: 'lastname', align: 'left' },
      { text: "Send E-mail", value: "email", align: "left" }, { text: "Abb", value: "abb", align: "right" },
      // { text: 'Last login', align: 'right' },
      { text: " Actions", align: "right", sortable: false }]
    };
  },

  // beforeUpdate() {
  //   console.log('beforeUpdate')
  // },
  beforeMount: function beforeMount() {
    // this.users = this.$store.state.users
    this.$store.dispatch("loadUsers");
    this.add_new = false;
  },

  computed: {
    add_new: {
      get: function get() {
        return this.$store.state.add_new;
      },
      set: function set(value) {
        this.$store.dispatch("addNew", value);
      }
    },
    table_users: function table_users() {
      if (this.show_disabled) {
        return this.$store.state.users;
      } else {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.users).filter(function (u) {
          return u.enable == "Y";
        });
      }
    }
  },
  methods: {
    addAllRights: function addAllRights(user) {
      this.$store.dispatch("addAllRolesToUser", user.id);
    },
    inverseDeleteRights: function inverseDeleteRights(user) {
      this.$store.dispatch("inverseDeleteRights", user.id);
    },
    inverseDisable: function inverseDisable(user) {
      this.$store.dispatch("inverseDisable", user.id);
    },
    removeAllRights: function removeAllRights(user) {
      this.$store.dispatch("removeAllRolesFromUser", user.id);
    },
    toggleAdmin: function toggleAdmin(user) {
      this.$store.commit("TOGGLE_ADMIN", user.id);
    },
    show_create_user_form: function show_create_user_form() {
      this.save_user_form_display = true;
      return null;
    },
    create_user: function create_user() {
      var _this = this;

      this.snackbar = true;
      var url = this.$globals.apiserver + "/users.json";
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(url, this.new_user).then(function (response) {
        _this.result = response.data;
        // var o = Object.assign({ name: this.new_user.login})
        // this.$store.dispatch('createUser', o)
        _this.$store.dispatch("loadUsers");
        _this.save_user_form_display = false;
        _this.snackbar = false;
        _this.new_user = { login: "", password: "" };
        // console.log(this.result)
        _this.$router.push({
          name: "EditUser",
          params: { id: _this.result.id, user: _this.result }
        });
      }).catch(function (error) {
        // console.log(error);
      });
    },
    delete_user: function delete_user(t) {
      // console.log(t)
      this.$store.dispatch("deleteUser", t);
    },
    add_artworks_to_selection: function add_artworks_to_selection(user) {
      var artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
      var artworks_with_selected_user = artworks.filter(function (artwork) {
        if (artwork.users.length > 0) {
          // if (artwork.users.length > 1) {
          //   // console.log(artwork.users.length)
          // }
          return artwork.users.some(function (a_user) {
            return a_user.id == user;
          });
        } else {
          return false;
        }
      });
      var selected = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(artworks_with_selected_user)
      // console.log(selected)
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(artworks_with_selected_user), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var at = _step.value;
        }
        // console.log(at.id)
        // for (let a of selected) {
        //   if (at.id != a.id) {
        //     selected.push(at)
        //   }
        // }


        // artworks_with_selected_user = this.$store.state.artwork_users.filter(function(at){ return artwork_id == user})
        // new_selection =
        // console.log(selected)
        // this.$store.dispatch('addToCurrentSelection',artworks_with_selected_user)
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    },
    show_artworks_with_user: function show_artworks_with_user() {
      this.$store.dispatch("setCurrentSelection", temp_selection);
      return null;
    }
  }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_artworks_Artworks__ = __webpack_require__("1tVI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_artworks_EditArtwork__ = __webpack_require__("hD92");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_artworks_ViewArtwork__ = __webpack_require__("fw0Q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_artworks_AddArtwork__ = __webpack_require__("tF94");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_artworks_LocationOverview__ = __webpack_require__("bPIR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artists_Artists__ = __webpack_require__("l848");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_artists_EditArtist__ = __webpack_require__("jukP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_artists_ViewArtist__ = __webpack_require__("2yJh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_artists_AddArtist__ = __webpack_require__("AnAQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_locations_Locations__ = __webpack_require__("apj/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_locations_AddLocation__ = __webpack_require__("CODS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_locations_EditLocation__ = __webpack_require__("7rwU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_contacts_Contacts__ = __webpack_require__("cEmV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_contacts_EditContact__ = __webpack_require__("a6yn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_contacts_ViewContact__ = __webpack_require__("cazW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_contacts_AddContact__ = __webpack_require__("FaVa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_login__ = __webpack_require__("0HId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_users_Logout__ = __webpack_require__("Ly+y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_users_ForgottenPassword__ = __webpack_require__("E5Zb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_users_Notifications__ = __webpack_require__("QJDQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_users_SettingsHome__ = __webpack_require__("k19S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_lists_Lists__ = __webpack_require__("WyIz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_users_Users__ = __webpack_require__("NhnZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_users_EditUser__ = __webpack_require__("hBhP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_tags_Tags__ = __webpack_require__("IyLy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_layout_Dashboard__ = __webpack_require__("EIYF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_reports_Wizzard__ = __webpack_require__("YSMR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_layout_Facts__ = __webpack_require__("/pOa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_support_Articles__ = __webpack_require__("5yTA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_support_EditArticle__ = __webpack_require__("fRaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_support_AddArticle__ = __webpack_require__("uwcO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_selections_Index__ = __webpack_require__("4aNr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_todos_Index__ = __webpack_require__("lh22");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_todos_AddTodo__ = __webpack_require__("9Wdk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_exhibitions_Index__ = __webpack_require__("++Hh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_exhibitions_AddExhibition__ = __webpack_require__("QMpY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_exhibitions_EditExhibition__ = __webpack_require__("VDCb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_texts_Index__ = __webpack_require__("eGOg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_texts_AddText__ = __webpack_require__("ckKv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_texts_EditText__ = __webpack_require__("nzMO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__store__ = __webpack_require__("IcnI");


// import HelloWorld from '@/components/layout/HelloWorld'
















// import ViewLocation from '@/components/locations/ViewLocation'







// import Login from '@/components/users/Login'


// import Settings from '@/components/users/Settings'































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// const isNotAuthenticated = (to, from, next) => {
//   if (!store.getters.isAuthenticated) {
//     next()
//     return
//   }
//   next('/')
// }

var ifNotAuthenticated = function ifNotAuthenticated(to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_42__store__["a" /* default */].getters.isAuthenticated) {
    // console.log('store.getters.isAuthenticated')
    // console.log(store.getters.isAuthenticated)
    next();
    return;
  }
  next('/');
};

var ifAuthenticated = function ifAuthenticated(to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_42__store__["a" /* default */].getters.isAuthenticated) {
    next();
    return;
  }
  next('/login');
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Artworks',
    component: __WEBPACK_IMPORTED_MODULE_2__components_artworks_Artworks__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_18__components_login__["a" /* default */],
    beforeEnter: ifNotAuthenticated
  }, {
    path: '/logout',
    name: 'Logout',
    component: __WEBPACK_IMPORTED_MODULE_19__components_users_Logout__["a" /* default */]
  }, {
    path: '/dashboard',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_27__components_layout_Dashboard__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/articles',
    name: 'Articles',
    component: __WEBPACK_IMPORTED_MODULE_30__components_support_Articles__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/articles/edit/:id',
    name: 'EditArticle',
    props: true,
    component: __WEBPACK_IMPORTED_MODULE_31__components_support_EditArticle__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/articles/new',
    name: 'AddArticle',
    component: __WEBPACK_IMPORTED_MODULE_32__components_support_AddArticle__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/artworks',
    name: 'Artworks',
    component: __WEBPACK_IMPORTED_MODULE_2__components_artworks_Artworks__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/location_overview',
    name: 'LocationOverview',
    component: __WEBPACK_IMPORTED_MODULE_6__components_artworks_LocationOverview__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/reports/new',
    name: 'Wizzard',
    component: __WEBPACK_IMPORTED_MODULE_28__components_reports_Wizzard__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/users',
    name: 'Users',
    component: __WEBPACK_IMPORTED_MODULE_24__components_users_Users__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/users/edit/:id',
    name: 'EditUser',
    component: __WEBPACK_IMPORTED_MODULE_25__components_users_EditUser__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/artworks/ownership/:ownership',
    name: 'Collection',
    component: __WEBPACK_IMPORTED_MODULE_2__components_artworks_Artworks__["a" /* default */],
    beforeEnter: ifAuthenticated
  },
  // {
  //   path: '/artworks/ownership/commissions',
  //   name: 'Commissions',
  //   component: Artworks,
  //   beforeEnter: ifAuthenticated
  // },
  {
    path: '/artworks/filter/:work_type',
    name: 'Collection Filtered',
    component: __WEBPACK_IMPORTED_MODULE_2__components_artworks_Artworks__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/contacts/:contact_category',
    name: 'ContactCategories',
    component: __WEBPACK_IMPORTED_MODULE_14__components_contacts_Contacts__["a" /* default */],
    beforeEnter: ifAuthenticated
  },
  // {
  //   path: '/artworks/pacFvh',
  //   name: 'pac_fvh',
  //   component: Artworks
  // },
  // {
  //   path: '/artworks/pdcFvh',
  //   name: 'pdc_fvh',
  //   component: Artworks
  // },
  // {
  //   path: '/artworks/pacMr',
  //   name: 'pac_mr',
  //   component: Artworks
  // },
  // {
  //   path: '/artworks/oldMasters',
  //   name: 'oldMasters',
  //   component: Artworks
  // },
  // {
  //   path: '/artworks/deaccession',
  //   name: 'Deaccession',
  //   component: Artworks
  // },
  {
    path: '/contacts/edit/:id',
    name: 'EditContact',
    component: __WEBPACK_IMPORTED_MODULE_15__components_contacts_EditContact__["a" /* default */],
    props: true,
    beforeEnter: ifAuthenticated
  }, {
    path: '/contacts/view/:id',
    component: __WEBPACK_IMPORTED_MODULE_16__components_contacts_ViewContact__["a" /* default */],
    name: 'ViewContact',
    props: true,
    beforeEnter: ifAuthenticated
  }, {
    path: '/artworks/new',
    name: 'AddArtwork',
    component: __WEBPACK_IMPORTED_MODULE_5__components_artworks_AddArtwork__["a" /* default */],
    props: true,
    beforeEnter: ifAuthenticated
  }, {
    path: '/artists/new',
    name: 'AddArtist',
    component: __WEBPACK_IMPORTED_MODULE_10__components_artists_AddArtist__["a" /* default */],
    props: true,
    beforeEnter: ifAuthenticated
  }, {
    path: '/artworks/edit/:id',
    name: 'EditArtwork',
    component: __WEBPACK_IMPORTED_MODULE_3__components_artworks_EditArtwork__["a" /* default */],
    props: true,
    beforeEnter: ifAuthenticated
  }, {
    path: '/artworks/view/:id',
    component: __WEBPACK_IMPORTED_MODULE_4__components_artworks_ViewArtwork__["a" /* default */],
    name: 'ViewArtwork',
    props: true,
    beforeEnter: ifAuthenticated
  }, {
    path: '/selections',
    name: 'SelectionIndex',
    component: __WEBPACK_IMPORTED_MODULE_33__components_selections_Index__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/todos',
    name: 'TodoIndex',
    component: __WEBPACK_IMPORTED_MODULE_34__components_todos_Index__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/exhibitions',
    name: 'ExhibitionIndex',
    component: __WEBPACK_IMPORTED_MODULE_36__components_exhibitions_Index__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/exhibitions/new',
    name: 'AddExhibition',
    component: __WEBPACK_IMPORTED_MODULE_37__components_exhibitions_AddExhibition__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/todos/new',
    name: 'AddTodo',
    component: __WEBPACK_IMPORTED_MODULE_35__components_todos_AddTodo__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/exhibitions/edit/:id',
    name: 'EditExhibition',
    component: __WEBPACK_IMPORTED_MODULE_38__components_exhibitions_EditExhibition__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/artists',
    name: 'Artists',
    component: __WEBPACK_IMPORTED_MODULE_7__components_artists_Artists__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/artists/edit/:id',
    name: 'EditArtist',
    component: __WEBPACK_IMPORTED_MODULE_8__components_artists_EditArtist__["a" /* default */],
    props: true,
    beforeEnter: ifAuthenticated
  }, {
    path: '/artists/view/:id',
    name: 'ViewArtist',
    component: __WEBPACK_IMPORTED_MODULE_9__components_artists_ViewArtist__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/contacts',
    name: 'Contacts',
    component: __WEBPACK_IMPORTED_MODULE_14__components_contacts_Contacts__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/contacts/new',
    name: 'AddContact',
    component: __WEBPACK_IMPORTED_MODULE_17__components_contacts_AddContact__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/locations',
    name: 'Locations',
    component: __WEBPACK_IMPORTED_MODULE_11__components_locations_Locations__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/locations/edit/:id',
    name: 'EditLocation',
    component: __WEBPACK_IMPORTED_MODULE_13__components_locations_EditLocation__["a" /* default */],
    props: true,
    beforeEnter: ifAuthenticated
  },
  // {
  //   path: '/locations/:id',
  //   name: 'ViewLocation',
  //   component: ViewLocation,
  //   beforeEnter: ifAuthenticated
  // },
  {
    path: '/locations/new',
    name: 'AddLocation',
    component: __WEBPACK_IMPORTED_MODULE_12__components_locations_AddLocation__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/texts',
    name: 'Texts',
    component: __WEBPACK_IMPORTED_MODULE_39__components_texts_Index__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/texts/edit/:id',
    name: 'EditText',
    component: __WEBPACK_IMPORTED_MODULE_41__components_texts_EditText__["a" /* default */],
    props: true,
    beforeEnter: ifAuthenticated
  },
  // {
  //   path: '/locations/:id',
  //   name: 'ViewLocation',
  //   component: ViewLocation,
  //   beforeEnter: ifAuthenticated
  // },
  {
    path: '/texts/new',
    name: 'AddText',
    component: __WEBPACK_IMPORTED_MODULE_40__components_texts_AddText__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/lists',
    props: true,
    name: 'Lists',
    component: __WEBPACK_IMPORTED_MODULE_23__components_lists_Lists__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/tags',
    name: 'Tags',
    component: __WEBPACK_IMPORTED_MODULE_26__components_tags_Tags__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/facts',
    name: 'Facts',
    component: __WEBPACK_IMPORTED_MODULE_29__components_layout_Facts__["a" /* default */],
    beforeEnter: ifAuthenticated
  },
  // {
  //   path: '/login',
  //   component: Login,
  //   beforeEnter: ifNotAuthenticated
  // },
  {
    path: '/users/lostPassword',
    component: __WEBPACK_IMPORTED_MODULE_20__components_users_ForgottenPassword__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/account_settings',
    name: 'Account Settings',
    component: __WEBPACK_IMPORTED_MODULE_25__components_users_EditUser__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/notification_settings',
    name: 'Notifications Settings',
    component: __WEBPACK_IMPORTED_MODULE_21__components_users_Notifications__["a" /* default */],
    beforeEnter: ifAuthenticated
  }, {
    path: '/home_page_settings',
    name: 'Home Page Settings',
    component: __WEBPACK_IMPORTED_MODULE_22__components_users_SettingsHome__["a" /* default */],
    beforeEnter: ifAuthenticated
  }]
}));

/***/ }),

/***/ "YsD7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  // mixins: [ CommonMixin ],
  props: ["artwork"],
  data: function data() {
    return {
      selected: [],
      search: "",
      menu_storage_out: false,
      menu_storage_in: false,
      dialog: false,
      deleteDialog: false,
      itemToDelete: null,
      dialog2: false,
      headers: [{ text: "Title", align: "left", sortable: true, value: "name" }, {
        text: "Selection Artworks Count",
        align: "center",
        sortable: true,
        value: "artworks.length"
      }, {
        text: "Created by",
        align: "center",
        value: "created_by",
        sortable: true
      }, {
        text: "Created at",
        align: "center",
        value: "created_at",
        sortable: true
      }, {
        text: "Updated at",
        align: "center",
        value: "updated_at",
        sortable: true
        // { text: "Actions", align: "right", sortable: false, align: "center" }
      }],
      editedIndex: -1,
      show: false,
      showUpload: false,
      p: {
        descending: true,
        rowsPerPage: 10,
        sortBy: "created_at"
      }
    };
  },
  computed: {
    selections: function selections() {
      var _this = this;

      return this.$store.state.lists.filter(function (s) {
        return s.artworks.includes(_this.artwork.id);
      });
    },

    // visa_status () {
    //   this.constants.VISA_STATUSES.find(this.artwork.visa_status)
    // },
    all_packings: function all_packings() {
      return this.$store.state.packings;
      // console.log(todos)
      // return todos
    },
    selection_items: function selection_items() {
      var artwork_locations = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()([], this.$store.state.locations);
      return artwork_locations.sort(dynamicSort("name"));
    }
  },
  methods: {
    newItem: function newItem() {
      this.dialog = true;
      this.packing = {
        packing: "",
        height: "",
        lenght: "",
        width: "",
        weight: "",
        contents: "",
        colli: "",
        visa_status: "",
        artwork_id: "",
        artwork_location_id: ""
      };
    },
    editItem: function editItem(i) {
      this.packing = {
        packing: "",
        height: "",
        lenght: "",
        width: "",
        weight: "",
        contents: "",
        colli: "",
        visa_status: "",
        artwork_id: "",
        artwork_location_id: ""
      };
      this.saving = false;
      this.editing = true;
      this.dialog = true;
      try {
        this.packing = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.artwork.artwork_packings.find(function (t) {
          return t.id == i.id;
        }));
      } catch (error) {
        // console.log(error.message);
      }
    },
    saveField: function saveField() {
      var _this2 = this;

      setTimeout(function () {
        var url = _this2.$globals.apiserver + "/artworks/" + _this2.artwork.id + ".json";
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, {
          field_name: "transport_history",
          field_value: _this2.artwork.transport_history
        }).then(function (response) {
          _this2.progress = false;
        }).catch(function (error) {
          // console.log(error)
        });
      }, 1000);
    },
    close: function close() {
      this.dialog = false;
    },

    // initialize () {},
    showDeleteDialog: function showDeleteDialog(p) {
      this.itemToDelete = p;
      this.deleteDialog = true;
    },
    deleteItem: function deleteItem() {
      var index = this.artwork.artwork_packings.indexOf(this.itemToDelete);
      var i = this.artwork.artwork_packings.indexOf(this.itemToDelete);
      if (i != -1) {
        this.artwork.artwork_packings.splice(i, 1);
      }
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      this.$store.dispatch("deletePacking", this.itemToDelete);
      this.itemToDelete = null;
      this.deleteDialog = false;
    },
    cancelDelete: function cancelDelete() {
      this.deleteDialog = false;
      this.itemToDelete = null;
    },

    // delete_packing () {},
    get_visa_status: function get_visa_status(packing) {
      var vss = this.constants.VISA_STATUSES.filter(function (vs) {
        return vs.id === packing.visa_status;
      });
      if (vss[0] != undefined) {
        // console.log(vss[0].id)
        return vss[0].id > 0 ? vss[0].name : "";
      } else {
        return "";
      }
    },

    // get_location_name(packing) {
    //   var l = this.$store.state.locations.find(
    //     l => l.id === packing.artwork_location_id
    //   );
    //   return l ? l.name : "";
    // },
    duplicateItem: function duplicateItem(p) {
      var _this3 = this,
          _packing;

      // console.log(p)
      var packing = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, p);
      delete packing.id;
      // console.log(this.packing)
      packing.artwork_id = this.artwork.id;
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      // this.packing.reject { |k,v| k == :id }
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.$globals.apiserver + "/artwork_packings.json", {
        packing: packing
      }).then(function (response) {
        _this3.errors = {};
        _this3.artwork.artwork_packings.push(response.data);
        _this3.$store.commit("ADD_PACKING", response.data);
      }).catch(function (error) {
        _this3.errors = error.response.data;
      });
      // console.log(this.packing)
      // this.all_packings.push(this.packing)
      this.showUpload = !this.showUpload;
      this.dialog = false;
      this.packing = (_packing = {
        packing: "",
        height: "",
        width: ""
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing, "packing", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing, "lenght", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing, "weight", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing, "contents", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing, "note", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing, "visa_status", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing, "colli", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing, "visa_status", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing, "artwork_location_id", ""), _packing);
    },
    save: function save() {
      var _this4 = this;

      this.saving = true;
      this.packing.artwork_id = this.artwork.id;
      // this.packing.id = this.findMinMax(this.all_packings)+1
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      // this.artwork.artwork_packings.push(this.packing)
      if (this.editing) {
        var url = this.$globals.apiserver + "/artwork_packings/" + this.packing.id + ".json";
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, {
          packing: this.packing
        }).then(function (response) {
          var _this4$packing;

          _this4.errors = {};
          _this4.artwork.artwork_packings = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this4.artwork.artwork_packings.map(function (item) {
            return item.id !== response.data.id ? item : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, response.data);
          })));
          _this4.$store.commit("SAVE_PACKING", response.data);
          _this4.dialog = false;
          _this4.packing = (_this4$packing = {
            packing: "",
            height: "",
            width: ""
          }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_this4$packing, "packing", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_this4$packing, "lenght", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_this4$packing, "weight", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_this4$packing, "contents", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_this4$packing, "note", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_this4$packing, "visa_status", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_this4$packing, "colli", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_this4$packing, "visa_status", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_this4$packing, "artwork_location_id", ""), _this4$packing);
          _this4.saving = false;
          _this4.editing = false;
        }).catch(function (error) {
          _this4.save_error = true;
        });
      } else {
        var _packing2;

        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.$globals.apiserver + "/artwork_packings.json", {
          packing: this.packing
        }).then(function (response) {
          _this4.errors = {};
          _this4.artwork.artwork_packings.push(response.data);
          _this4.$store.commit("ADD_PACKING", response.data);
        }).catch(function (error) {
          _this4.errors = error.response.data;
        });
        // console.log(this.packing)
        // this.all_packings.push(this.packing)
        this.dialog = false;
        this.packing = (_packing2 = {
          packing: "",
          height: "",
          width: ""
        }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing2, "packing", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing2, "lenght", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing2, "weight", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing2, "contents", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing2, "note", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing2, "visa_status", 0), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing2, "colli", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing2, "visa_status", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_packing2, "artwork_location_id", ""), _packing2);
      }
    },
    update_multiple: function update_multiple() {
      var _this5 = this,
          _updated_packing;

      this.updated_packing.artwork_id = this.artwork.id;
      if (!this.artwork.artwork_packings) {
        this.artwork.artwork_packings = [];
      }
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(this.$globals.apiserver + "/artwork_packings/update_multiple.json", {
        updated_packing: this.updated_packing,
        selected: this.selected
      }).then(function (response) {
        _this5.errors = {};
        _this5.artwork.artwork_packings = [];
        _this5.artwork.artwork_packings.push(response.data);
        // this.$store.commit('REPLACE_PACKING', response.data)
      }).catch(function (error) {
        _this5.errors = error.response.data;
      });
      this.dialog2 = !this.dialog2;
      // this.dialog = false
      this.updated_packing = (_updated_packing = {
        packing: "",
        height: "",
        width: ""
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_updated_packing, "packing", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_updated_packing, "length", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_updated_packing, "weigth", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_updated_packing, "contents", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_updated_packing, "note", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_updated_packing, "visa_status", 0), _updated_packing);
    }
  }
});

/***/ }),

/***/ "Z/ya":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditFieldHeader_vue__ = __webpack_require__("+UUQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7375bf52_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFieldHeader_vue__ = __webpack_require__("DVzf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Rehu")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7375bf52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditFieldHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7375bf52_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFieldHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7375bf52_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFieldHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Z0FH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mt-3 mx-2 mb-5 elevation-2",attrs:{"color":"grey lighten-4"}},[_c('v-card-text',{staticClass:"mt-0 pt-0 pt-4"},[_c('p',{staticClass:"text-xs-center headline"},[_vm._v("New Exhibition")]),_vm._v(" "),_c('v-form',{staticClass:"mt-0 pt-0",attrs:{"xs12":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-radio-group',{attrs:{"column":""},model:{value:(_vm.exhibition.show_type),callback:function ($$v) {_vm.$set(_vm.exhibition, "show_type", $$v)},expression:"exhibition.show_type"}},[_c('v-radio',{attrs:{"label":"Group Show","value":"2"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Solo Show","value":"1"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"align-end",attrs:{"xs12":"","sm6":"","md6":"","pt-3":""}},[_c('v-switch',{attrs:{"label":"Loan TBA21","value":"1","color":"black"},model:{value:(_vm.exhibition.loan),callback:function ($$v) {_vm.$set(_vm.exhibition, "loan", $$v)},expression:"exhibition.loan"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-3",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"title","required":"","rules":[_vm.rules.required]},model:{value:(_vm.exhibition.title),callback:function ($$v) {_vm.$set(_vm.exhibition, "title", $$v)},expression:"exhibition.title"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-3",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"institution","required":""},model:{value:(_vm.exhibition.institution),callback:function ($$v) {_vm.$set(_vm.exhibition, "institution", $$v)},expression:"exhibition.institution"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-3",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"city","required":""},model:{value:(_vm.exhibition.city),callback:function ($$v) {_vm.$set(_vm.exhibition, "city", $$v)},expression:"exhibition.city"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-autocomplete',{attrs:{"items":this.countries,"label":"Select Country"},model:{value:(_vm.exhibition.country),callback:function ($$v) {_vm.$set(_vm.exhibition, "country", $$v)},expression:"exhibition.country"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md2":"","lg2":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"Start Year","placeholder":"XXXX","type":"number","maxlength":4,"rules":[_vm.rules.required]},model:{value:(_vm.exhibition.duration_start_year),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_start_year", $$v)},expression:"exhibition.duration_start_year"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":"","lg2":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"Month","placeholder":"XX","type":"number"},model:{value:(_vm.exhibition.duration_start_month),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_start_month", $$v)},expression:"exhibition.duration_start_month"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":"","lg2":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"Day","placeholder":"XX","type":"number"},model:{value:(_vm.exhibition.duration_start_day),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_start_day", $$v)},expression:"exhibition.duration_start_day"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md2":"","lg2":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"End Year","placeholder":"XXXX","type":"number"},model:{value:(_vm.exhibition.duration_end_year),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_end_year", $$v)},expression:"exhibition.duration_end_year"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":"","lg2":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"Month","placeholder":"XX","type":"number"},model:{value:(_vm.exhibition.duration_end_month),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_end_month", $$v)},expression:"exhibition.duration_end_month"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":"","lg2":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"Day","placeholder":"XX","type":"number"},model:{value:(_vm.exhibition.duration_end_day),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_end_day", $$v)},expression:"exhibition.duration_end_day"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","pr-3":""}},[_c('v-textarea',{attrs:{"label":"Note","auto-grow":"","clearable":"","rows":"1"},model:{value:(_vm.exhibition.admin_note),callback:function ($$v) {_vm.$set(_vm.exhibition, "admin_note", $$v)},expression:"exhibition.admin_note"}})],1),_vm._v(" "),_c('v-card-actions',{staticClass:"my-3"},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-btn',{attrs:{"color":"success"},on:{"click":function($event){_vm.save();_vm.$emit('show_form',false)}}},[_vm._v("SAVE")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"error"},on:{"click":function($event){return _vm.$emit('show_form',false)}}},[_vm._v("CANCEL")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "ZMio":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake__ = __webpack_require__("EWlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts__ = __webpack_require__("u1n8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts__);


//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      outputFields: ['classification'],
      output_fields: [],
      outputFieldsParams: [],
      valid: true,
      view: 'table',
      sort: 'full_name',
      title: 'LIST TITLE',
      subtitle: 'List description',
      pdf_artworks: []
    };
  },
  props: {
    light: Boolean,
    small: Boolean,
    item: Object,
    use_current_selection: Boolean
  },
  created: function created() {
    // this.pdfLabels()
  },


  methods: {
    // o2ids (array,prop) {
    //   return array.map(a => a[prop])
    // },
    // ids2o (array) {
    //   var objs = Object.assign([], this.$store.state.artworks)
    //   var out = objs.filter(a => {
    //     // console.log(array.includes(a.id))
    //     return (array.includes(a.id))
    //   })
    //   return out
    // },
    pdfLabelsCall: function pdfLabelsCall() {
      this.loading = true;
      setTimeout(function () {
        setTimeout(function () {
          this.pdfLabels();
          this.loading = false;
        }.bind(this), 0);
      }.bind(this), 500);
    },
    pdfLabels: function pdfLabels() {
      var _this = this;

      // var margins = [0,10,0,10]
      var use_current_selection = this.use_current_selection;
      var output_fields = this.output_fields;
      var img = 'data:image/jpeg;base64,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'.split('\n');

      function dynamicSort(property) {
        var sortOrder = 1;
        if (property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function (a, b) {
          var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
          return result * sortOrder;
        };
      }

      // console.log('labels small')
      // console.log(this.item)
      if (this.item && this.item.artworks.length > 0) {
        // this.pdf_artworks = this.ids2o(this.item.artworks)
        this.pdf_artworks = this.item.artworks;
      } else {
        // console.log(this.use_current_selection)
        if (use_current_selection == true) {
          // this.pdf_artworks = Object.assign([], this.$store.state.currentSelection)
          if (this.$store.state.currentSelection.length > 0) {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.ids2o(this.$store.state.currentSelection)).sort(dynamicSort(this.sort));
          } else {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks).sort(dynamicSort(this.sort));
          }
        } else {
          if (this.$store.state.filterResults) {
            var objs = this.ids2o(this.$store.state.filterResults);
            this.pdf_artworks = objs.sort(dynamicSort(this.sort));
          } else {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks).sort(dynamicSort(this.sort));
          }
        }
      }
      // console.log(this.pdf_artworks)

      // let transformedULSData = this.pdf_artworks.map((textRow) => {
      //   return {
      //     "title": textRow.title,
      //     "full_name": textRow.artist.full_name,
      //     "accession_number": textRow.accession_number,
      //     "production_date_new": textRow.production_date_new ? textRow.production_date_new : ''
      //   }
      // })
      var transformedULSData = [];
      this.pdf_artworks.forEach(function (a) {
        // if (a.artwork_packings != undefined) {
        // console.log('a.artwork_packings')
        var o = '';
        if (typeof a == 'number') {
          o = _this.$store.state.artworks.find(function (f) {
            return f.id == a;
          });
        } else {
          o = a;
        }
        if (o.artwork_packings && o.artwork_packings.length > 1) {
          o.artwork_packings.forEach(function (ap) {
            transformedULSData.push({
              "title": o.title,
              "full_name": o.full_name,
              "accession_number": o.accession_number,
              "production_date_new": o.production_date_new ? o.production_date_new : '',
              "colli": 'Colli ' + ap.colli
            });
          });
        } else {
          // console.log(o)
          transformedULSData.push({
            "title": o.title,
            "full_name": o.full_name,
            "accession_number": o.accession_number,
            "production_date_new": o.production_date_new ? o.production_date_new : '',
            "colli": 'Colli'
          });
        }
        // }
      });

      var asMoney = function asMoney(rawMoney) {
        return rawMoney.round(2, 1).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      };
      var makeCell = function makeCell(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ text: content }, options);
      };
      // -- Format the table cells for presentation.
      var thl = function thl(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'left', fontSize: 9 }, options));
      };
      var thr = function thr(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'right', fontSize: 9 }, options));
      };
      var tdl = function tdl(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'left', fontSize: 9 }, options));
      };
      var tdr = function tdr(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'right', fontSize: 9 }, options));
      };
      var reportDate = function reportDate() {
        return new Date();
      };

      var createDocumentDefinition = function createDocumentDefinition(reportDate, subHeading) {
        for (var _len = arguments.length, contentParts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          contentParts[_key - 2] = arguments[_key];
        }

        var _docDefinition$conten;

        var baseDocDefinition = {
          pageSize: 'A4',
          pageMargins: [22, 0, 0, 0],
          info: {
            title: 'Small Labels A4',
            subject: 'Small Labels A4'
          },
          styles: {
            // title: { fontSize: 11, all_caps: true },
            // titleSub: { fontSize: 11 },
            // bold: { fontSize: 11, bold: true, margin: [50,0,0,0] },
            // normal: { fontSize: 11, bold: false },
            artwork_title: { fontSize: 11, bold: false, margin: [45, 0, 0, 0], width: 150 },
            artwork_title2: { fontSize: 11, bold: false, margin: [300, 0, 0, 0], width: 150 },
            // an: { fontSize: 11, bold: true, margin: [10,0,0,0] },
            // artist_name: { fontSize: 11, bold: false, margin: [0,25,0,0]  },
            // colli: { fontSize: 11, bold: true, alignment: 'right', margin: [0,10,10,0] },
            image: { margin: [0, 45, 0, 20] },
            image2: { margin: [300, 0, 0, 10] }
          },
          content: [{
            columns: []
          }]
        };
        var docDefinition = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(baseDocDefinition));
        docDefinition.footer = baseDocDefinition.footer;
        (_docDefinition$conten = docDefinition.content).push.apply(_docDefinition$conten, contentParts);
        return docDefinition;
      };

      var rowData = function rowData(a) {
        // return a.title
        var stack = {
          stack: []
        };
        // var columns = output_fields; //['title','full_name','accession_number'];
        var title_and_year = a['title'] + ", " + a['production_date_new'];

        stack.stack.push({ image: img, fit: [180, 100], style: 'image' });
        stack.stack.push({ text: a['accession_number'], style: 'artwork_title' });
        stack.stack.push({ text: a['full_name'], style: 'artwork_title' });
        stack.stack.push({ text: title_and_year, style: 'artwork_title' });
        // stack.stack.push({text: a['colli'], style: 'colli'});
        // stack.stack.push({text: a['production_date_new'], style: 'artwork_title'});

        // columns.forEach((column,index) => {
        //   var columnData = a[column];
        //   var cp = [];
        //   // console.log(a)
        //   // console.log(column)
        //   if (columnData == undefined) {
        //     stack.stack.push({text: 'no "' + column + '" data entered', style: 'normal'});
        //   } else {
        //     stack.stack.push({text: columnData, style: 'normal'});
        //   }
        // })
        // console.log(JSON.stringify(stack))
        return stack;
      };

      var rowData2 = function rowData2(a, c) {
        if (c == 1) {
          var x = 10;
          var y = 0;
        } else {
          var x = 300;
          var y = 0;
        }
        var stack = {
          // absolutePosition: {x: x, y: y},
          stack: []
        };
        var title_and_year = a['title'] + ", " + a['production_date_new'];
        if (c == 2) {
          var style = 'artwork_title2';
          var istyle = 'image2';
        } else {
          var style = 'artwork_title';
          var istyle = 'image';
        }

        stack.stack.push({ image: img, fit: [180, 50], style: 'image' });
        stack.stack.push({ text: a['accession_number'], style: 'artwork_title' });
        stack.stack.push({ text: a['full_name'], style: 'artwork_title' });
        stack.stack.push({ text: title_and_year, style: 'artwork_title' });

        return stack;
      };

      makeUnderlyingLoanSummaryDoc();

      function makeUnderlyingLoanSummaryDoc() {
        var tableBody = function tableBody(dataRows) {
          var body = [];
          dataRows.forEach(function (row, index) {
            var tableRow = [];
            // console.log(row)
            // if (row.artwork_packings.length > 1) {
            // row.artwork_packings.forEach(ap => {
            // tableRow.push(rowData(row))
            // })
            // } else {
            tableRow.push(rowData(row));
            // }
            body.push(tableRow);
          });
          return body;
        };
        var averyBody = function averyBody(dataRows) {
          var c = 1;
          var rows = [];
          var cols = [];
          dataRows.forEach(function (row, index) {
            // if (row.artwork_packings.length > 1) {
            // row.artwork_packings.forEach(ap => {
            // tableRow.push(rowData(row))
            // })
            // } else {
            cols.push(rowData2(row, c));
            c = c + 1;
            if (dataRows.length == 1) {
              c = 1;
              rows.push(cols);
              cols = [];
            } else {
              if (c == 3) {
                c = 1;
                rows.push(cols);
                cols = [];
              }
            }
            // }
          });
          return rows;
        };

        var tableColumnWidths = [293, 250];
        // console.log(transformedULSData)
        var tableData = {
          layout: 'noBorders',
          table: {
            heights: 196,
            dontBreakRows: true,
            // margins: margins,
            widths: tableColumnWidths,
            body: averyBody(transformedULSData)
          }

          // console.log(tableData)
          // console.log('labels small')

        };var docDefinition = createDocumentDefinition(reportDate(), 'Summary', tableData);
        // pdfMake.createPdf(docDefinition).download('underlyingLoanSummary-' + reportDate() + '.pdf');
        // pdfMake.createPdf(docDefinition).open({},'pdfV')
        // document.getElementById('pdfV').src = data;

        // const pdfDocGenerator = pdfMake.createPdf(docDefinition)
        // console.log(pdfDocGenerator)
        __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download('A4-small-labels.pdf');

        // pdfDocGenerator.getDataUrl((dataUrl) => {
        //   const targetElement = document.querySelector('#pdfLabels')
        //   // const iframe = document.createElement('iframe')
        //   targetElement.src = dataUrl
        //   // targetElement.appendChild(iframe)
        // });
        // const docDefinition = createDocumentDefinition(reportDate(), 'LIST', ' ', tableData)
        // console.log(docDefinition)
        // pdfMake.createPdf(docDefinition).download(`LISTa-${reportDate()}.pdf`)
      }
    }
  }
});

/***/ }),

/***/ "ZUyF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mx-3"},[_c('locations-table',{attrs:{"items":this.displayedData}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "ZjmU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "a6yn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditContact_vue__ = __webpack_require__("PzvK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf37e02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditContact_vue__ = __webpack_require__("tDbg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ldH3")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7bf37e02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditContact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf37e02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditContact_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7bf37e02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditContact_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aSf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("Ji5s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6319557a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("GbdC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("P/By")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6319557a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6319557a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6319557a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "aepb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_axios_js__ = __webpack_require__("81r7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__static_axios_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__static_axios_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Upload__ = __webpack_require__("e4A6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TextEditor__ = __webpack_require__("JslP");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import * as clipboard from "clipboard-polyfill/text";



// async function copy2c2(t) {
//   console.log('Previous clipboard contents:', clipboard.read())
//   async function handler() {
//     console.log('Previous clipboard contents:', await clipboard.read())

//     const item = new clipboard.ClipboardItem({
//       'text/html': new Blob(
//         ['<i>Markup</i> <b>text</b>. Paste me into a rich text editor.'],
//         { type: 'text/html' }
//       ),
//       'text/plain': new Blob(
//         ['Fallback markup text. Paste me into a rich text editor.'],
//         { type: 'text/plain' }
//       ),
//     })
//     await clipboard.write([item])
// }
// }

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    artwork: Object,
    no_upload: Boolean,
    category: String,
    add_text: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      // editor: null,
      local_artwork: {},
      edit_dialog: false,
      bibliography_details: '',
      edit_bio_dialog: false,
      edited_text: Object,
      show: false,
      showUpload: false,
      artwork_texts: [],
      text: {
        content: '',
        title: '',
        category: '',
        artwork_id: ''
      }
    };
  },
  watch: {
    artwork: function artwork() {
      // console.log('text artwork updated');
      this.local_artwork = this.artwork;
      this.artwork_texts = this.local_artwork.artwork_texts;
    }
  },
  mounted: function mounted() {
    this.local_artwork = this.artwork;
    this.artwork_texts = this.local_artwork.artwork_texts;
  },

  // mounted() {
  //   this.editor = this.editor
  //  Editor({
  //   content: '<p>This is just a boring <b>paragraph</b></p>',
  // })
  // },
  computed: {
    // c_user() {
    //   return this.$store.state.user.profile;
    // }
    // visa_status () {
    //   this.constants.VISA_STATUSES.find(this.artwork.visa_status)
    // },
    // all_texts () {
    // console.log(this.$store.getters)
    // if (this.category) {
    //   return this.$store.getters.texts.filter(t => t.category == this.category)
    // } else {
    //   return this.$store.getters.texts
    // }
    // },
    // selection_items () {
    //   var artwork_locations = Object.assign([],this.$store.state.locations)
    //   return artwork_locations.sort(dynamicSort('name'))
    // },
    // artwork_texts () {
    //   //  out = this.all_texts.filter(t => { return this.artwork.id==t.artwork_id})
    //   // return out
    //   if (this.artwork.artwork_texts) {
    //     var out = this.artwork.artwork_texts
    //   } else {
    //     var out = []
    //   }
    //   return out
    // }
  },
  methods: {
    // copyToClipboard() {
    //   this.$refs.generator.focus();
    //   document.execCommand('copy');
    //   this.$buefy.toast.open('Copied!');
    // },

    copy2c: function copy2c(text) {
      var tempDivElement = document.createElement('div');

      // Set the HTML content with the given value
      tempDivElement.innerHTML = text;

      // Retrieve the text property of the element
      var tt = tempDivElement.textContent || tempDivElement.innerText;
      // copy2c2()
      // console.log(text)
      // const listener = function (ev) {
      //   console.log(ev)
      //   ev.preventDefault()
      //   ev.clipboardData.setData('text/html', text)
      //   // ev.clipboardData.setData('text/plain', text)
      // navigator.clipboard.writeText(ev.clipboardData)
      // }
      navigator.clipboard.writeText(tt);
      // document.addEventListener('copy', listener)
      // document.execCommand('copy')

      // document.removeEventListener('copy', listener)
    },

    // const item = new clipboard.ClipboardItem({
    //     "text/html": new Blob(
    //       [t],
    //       { type: "text/html" }
    //     ),
    //     "text/plain": new Blob(
    //       [t],
    //       { type: "text/plain" }
    //     ),
    //   });
    //   clipboard.write([item]);
    // navigator.clipboard.writeText(t).then(
    //   function() {
    //     // console.log('Async: Copying to clipboard was successful!');
    //   },
    //   function(err) {
    //     console.error("Async: Could not copy text: ", err);
    //   }
    // );
    // },
    download_text: function download_text(text) {
      // console.log(text)
      // this.exportHTML(text, this.artwork)
      this.exportHTML(text.content, text.title);
    },
    delete_text: function delete_text(t) {
      var _this = this;

      // console.log(this.artwork.artwork_texts)
      __WEBPACK_IMPORTED_MODULE_1__static_axios_js___default.a.delete(this.$globals.apiserver + '/artwork_texts/' + t.id + '.json', {
        id: t
      }).then(function (response) {
        _this.errors = {};
        _this.$store.commit('REMOVE_TEXT', t);
        _this.local_artwork.artwork_texts = _this.artwork.artwork_texts.filter(function (at) {
          return at.id != t.id;
        });
        _this.$emit('getArtwork');
        // console.log(this.artwork.artwork_texts)
      }).catch(function (error) {
        _this.errors = error.response.data;
      });
    },
    edit_text: function edit_text(et) {
      this.edit_dialog = true;
      this.edited_text = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.artwork.artwork_texts.find(function (at) {
        return at.id == et.id;
      }));
    },
    edit_bio: function edit_bio() {
      this.edit_bio_dialog = true;
      this.bibliography_details = this.artwork.bibliography_details;
    },
    save_bio: function save_bio(a) {
      var _this2 = this;

      this.$emit('showSnackbar', 'Saving bio … ');
      // setTimeout(() => {
      var url = this.$globals.apiserver + '/artworks/' + this.artwork.id + '.json';
      __WEBPACK_IMPORTED_MODULE_1__static_axios_js___default.a.put(url, {
        field_name: 'bibliography_details',
        field_value: this.bibliography_details,
        updated_by: this.c_user.id
      }).then(function (response) {
        _this2.edit_bio_dialog = false;
        _this2.$emit('showSnackbar', 'Bio saved.', 'green');
        _this2.$emit('getArtwork');
      }).catch(function (error) {
        _this2.$emit('showSnackbar', 'Error Saving  ' + _this2.f_field.name, 'red');
      });
      // }, 1000);
    },
    save_edited_text: function save_edited_text() {
      var _this3 = this;

      this.edited_text.artwork_id = this.artwork.id;
      this.edited_text.category = 'artwork_text';
      __WEBPACK_IMPORTED_MODULE_1__static_axios_js___default.a.put(this.$globals.apiserver + '/artwork_texts/' + this.edited_text.id + '.json', {
        artwork_text: this.edited_text
      }).then(function (response) {
        _this3.errors = {};
        // this.$store.commit('REMOVE_TEXT', this.edited_text)
        // console.log('then')
        // console.log(this.artwork.artwork_texts)
        _this3.artwork.artwork_texts = _this3.artwork.artwork_texts.filter(function (at) {
          return at.id != response.data.id;
        });
        // console.log(this.artwork.artwork_texts)
        _this3.artwork.artwork_texts.push(response.data);
        // console.log(this.artwork.artwork_texts)
        // this.$store.commit('ADD_TEXT', this.edited_text)
        _this3.edit_dialog = false;
        _this3.edited_text = Object;
      }).catch(function (error) {
        // console.log("error");
        // this.errors = error.response.data;
      });
      this.edited_text = {
        content: '',
        title: '',
        category: '',
        artwork_id: ''
      };
    },
    save_text: function save_text() {
      var _this4 = this;

      this.text.artwork_id = this.artwork.id;
      // if (!this.artwork.artwork_texts) {
      //   this.artwork.artwork_texts = []
      // }
      // this.all_texts.push(this.text)
      // console.log(this.text);
      __WEBPACK_IMPORTED_MODULE_1__static_axios_js___default.a.post(this.$globals.apiserver + '/artwork_texts.json', {
        artwork_text: this.text
      }).then(function (response) {
        _this4.errors = {};
        _this4.local_artwork.artwork_texts = response.data;
        // this.active_texts = this.artwork.artwork_texts
        _this4.$store.commit('ADD_TEXT', response.data);
        _this4.showUpload = !_this4.showUpload;
        // this.active_todos.push(response.data);
        // this.todos.push(response.data);
      }).catch(function (error) {
        _this4.errors = error.response.data;
      });
      this.text = {
        content: '',
        category: '',
        title: '',
        artwork_id: ''
        // var atodo = Object.keys(this.text).forEach(k => this.text[k]='')
        // console.log(atodo)
      };
    }
  },
  components: { TextEditor: __WEBPACK_IMPORTED_MODULE_3__TextEditor__["a" /* default */], Upload: __WEBPACK_IMPORTED_MODULE_2__Upload__["a" /* default */] }
});

/***/ }),

/***/ "ajOj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      view: 'advanced',
      show_form: false,
      show: true,
      dialog: false
      // exhibitions: this.exhibitions2
    };
  },
  // created () {
  //   this.reset_view()
  // },
  methods: {
    deleteExhibition: function deleteExhibition(e) {
      // var index = exhibition_artworks.indexOf(e);
      // console.log('index = ' + index)
      // exhibition_artworks.splice(index,1)
      this.$store.dispatch('deleteExhibition', e);
      this.dialog = false;
    },

    // reset_view () {
    //   var ee = this.store_e
    //   this.exhibitions = this.exhibitions2
    //   // console.log('reset_view')
    //   // console.log(this.exhibitions2)
    // }
    start_date: function start_date(e) {
      var out = e.duration_start_year;
      var options = { day: 'numeric', month: 'long', year: 'numeric' };
      if (e.duration_start_month) {
        out = out + '-' + e.duration_start_month.toString().padStart(2, "0");
      }
      if (e.duration_start_day) {
        out = out + '-' + e.duration_start_day.toString().padStart(2, "0");
      }
      out = new Date(out).toLocaleDateString("en-US", options);

      return out;
    },
    end_date: function end_date(e) {
      var out = e.duration_end_year;
      var options = { day: 'numeric', month: 'long', year: 'numeric' };

      if (e.duration_end_month) {
        out = out + '-' + e.duration_end_month.toString().padStart(2, "0");
        // out = e.duration_end_month.toLocaleDateString("en-US", options)
      }
      if (e.duration_end_day) {
        out = out + '-' + e.duration_end_day.toString().padStart(2, "0");
      }
      out = new Date(out).toLocaleDateString("en-US", options);
      return out;
    },
    full_date: function full_date(e) {
      var out = this.start_date(e);
      if (this.end_date(e)) {
        out = out + ' - ' + this.end_date(e);
      }
      return out;
    }
  },
  computed: {
    advanced_years: function advanced_years() {
      return this.exhibitions.map(function (a) {
        return a = a.duration_start_year;
      }).sort(function (a, b) {
        return a - b;
      }).reverse().filter(function (value, index, self) {
        return self.indexOf(value) === index;
      });
    },
    store_e: function store_e() {
      // console.log('store_e')
      return this.$store.state.exhibitions;
    },
    exhibitions: function exhibitions() {
      var _this = this;

      // console.log('exa')
      return this.store_e.filter(function (t) {
        return t.artworks.map(function (a) {
          return a = a.artwork_id;
        }).includes(_this.artwork.id);
      }).sort(function (a, b) {
        return a.duration_start - b.duration_start;
      });
    }
  }
});

/***/ }),

/***/ "apj/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Locations_vue__ = __webpack_require__("UTi9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23334e9e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Locations_vue__ = __webpack_require__("ZUyF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("RF7d")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-23334e9e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Locations_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23334e9e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Locations_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23334e9e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Locations_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ayPc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"mt-4 ml-4",attrs:{"column":""}},[_c('header-elements',{attrs:{"icon":"mdi-track-light","title":"Lights"},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),_c('elements-table',{attrs:{"items":_vm.lights,"showUpload":_vm.showUpload,"title":"Light"},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showUpload),expression:"showUpload"}],staticClass:"mt-0 mb-0 xs12"},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" Cancel\n      ")],1),_vm._v(" "),(_vm.showUpload)?_c('v-flex',[_c('v-container',{staticClass:"elevation-3",attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('h4',{staticClass:"headline"},[_vm._v("Add new light")]),_vm._v(" "),_vm._l((_vm.fields),function(field){return _c('edit-field-comp',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_field_c(field)),expression:"show_field_c(field)"}],key:field.key,class:'flex ' + (field.class ? field.class : 'xs12'),attrs:{"id":field.name,"name":field.name,"artwork":_vm.artwork,"field":field,"parent":_vm.light},model:{value:(field.name),callback:function ($$v) {_vm.$set(field, "name", $$v)},expression:"field.name"}})})],2)],1),_vm._v(" "),_c('v-btn',{on:{"click":_vm.add}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_vm._v("cancel")])],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "b7zL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditField_vue__ = __webpack_require__("cA3P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_163df4a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditField_vue__ = __webpack_require__("Rzkq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("EmY/")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-163df4a0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_163df4a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditField_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_163df4a0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditField_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bKzt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_artists_ViewArtworks__ = __webpack_require__("eZui");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_full_user_fields__ = __webpack_require__("LKPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_artists_AddArtist__ = __webpack_require__("AnAQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_locations_AddLocation__ = __webpack_require__("CODS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_artworks_Upload__ = __webpack_require__("e4A6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_artworks_Location__ = __webpack_require__("KK+U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artworks_Electrical__ = __webpack_require__("sHT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_artworks_NonElectrical__ = __webpack_require__("R4KG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_artworks_Films__ = __webpack_require__("iuSU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_artworks_Audio__ = __webpack_require__("XNw2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_artworks_Programme__ = __webpack_require__("5cyT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artworks_InformationCarrier__ = __webpack_require__("qSBE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_artworks_Light__ = __webpack_require__("D2Yk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_artworks_ReadingDevices__ = __webpack_require__("54WG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_artworks_Links__ = __webpack_require__("dpcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_artworks_Costs__ = __webpack_require__("7EMl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_artworks_LoanConditions__ = __webpack_require__("P7M7");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EditFieldHeader from '@/components/artists/EditFieldHeader'

// import dynamic_fields from '@/data/dynamic_fields'
















// import EditField from './EditField'

function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
function nl2br(str, is_xhtml) {
  var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-field',
  channels: [{ id: 1, value: '1', name: 'Single-channel' }, { id: 2, value: '2', name: 'Two-channel' }, { id: 3, value: '3', name: 'Three-channel' }, { id: 4, value: '4', name: 'Four-channel' }, { id: 5, value: '5', name: 'Five-channel' }, { id: 6, value: '6', name: 'Six-channel' }, { id: 7, value: '7', name: 'Seven-channel' }, { id: 8, value: '8', name: 'Eight-channel' }, { id: 9, value: '9', name: 'Nine-channel' }, { id: 10, value: '10', name: 'Ten-channel' }, { id: 11, value: '11', name: '11-channel' }, { id: 12, value: '12', name: '12-channel' }, { id: 13, value: '13', name: '13-channel' }, { id: 14, value: '14', name: '14-channel' }, { id: 15, value: '15', name: '15-channel' }],
  data: function data() {
    return {
      // parent: [],
      toggle: 0,
      toggle_exclusive: 2,
      count: 0,
      showingAddForm: false,
      showUpload: false,
      instalation_includes: [],
      film_type: '',
      isEditing: false,
      an_exists: false,
      saved: false,
      cannotSave: false,
      value_new: '',
      select_value: '',
      show: true,
      model: {},
      menu2: '',
      date: ''
      // model: "artwork_location"
      // this.f_field.show
    };
  },

  props: ['field', 'artwork', 'placeholder', 'label', 'name', 'value', 'selection', 'title', 'film', 'electrical', 'report', 'fields_parent', 'parent', 'light'],
  mounted: function mounted() {
    this.select_value = this.f_artwork[this.f_field.name];
    this.toggle = this.f_artwork[this.f_field.name];
  },

  methods: {
    showAddForm: function showAddForm() {
      this.showingAddForm = !this.showingAddForm;
    },
    add_field: function add_field(field) {
      // console.log('sub')
      // console.log(document.getElementById(field.name))
      this.$emit('show', field);
      // var a = document.getElementById(field.name)
      // console.log(this.$el.style.display)
      // this.$el.style.display = 'block'
      // console.log(this.$children)
      // this.$children.find(a => a.name['name'] == field).styles.display = 'block'
      // console.log(this.$children.find(a => a.name['name'] == field).styles.display)
      // a.style.display = 'block'
      // a.style.backgroundColor = "green"
      // console.log(this.$el.style.display)
      // this.$forceUpdate()
    },
    save: function save() {
      // this.toggle
    },
    saveOrEdit: function saveOrEdit() {
      var _this = this;

      this.isEditing = !this.isEditing;
      this.$refs[this.f_field['name']].isFocused = true;
      // var a = document.getElementByName(this.f_field['name']).focus()
      // console.log(a)
      if (this.an_exists == false) {
        if (this.isEditing == false) {
          this.saved = true;
          setTimeout(function () {
            _this.saved = false;
          }, 2000);
        }
      } else {
        this.cannotSave = true;
        setTimeout(function () {
          _this.cannotSave = false;
        }, 4000);
      }
    },

    // nefunguje tak ako chcem
    // format_date (date,format) {
    //   var moment = require('moment')
    //   var ndate = new Date(date)
    //   return moment(ndate).format(format)
    // },
    check_an: function check_an(value) {
      // console.log(value)
      if (this.f_field.name == 'accession_number' && this.isEditing == true) {
        var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
        var b = a.filter(function (aa) {
          return aa.accession_number == value;
        });
        this.an_exists = b.length > 0;
        // console.log(this.an_exists)
        // console.log(value)
        // console.log(b)
        // console.log(a)
        // console.log(an)
      }
    },
    location_name: function location_name(id) {
      if (id > 0) {
        return this.$store.state.locations.find(function (l) {
          return l.id === id;
        }).name;
      } else {
        return 'Location not found. Probably deleted from CMS.';
      }
    }
  },
  computed: {
    hint: function hint() {
      var out = this.f_field.title;
      out = out + (this.f_field.hint ? ' - ' + this.f_field.hint : '');
      return out;
    },
    value2: function value2() {
      // console.log(parseInt(this.f_artwork[this.f_field.related_field],10))
      return parseInt(this.f_artwork[this.f_field.related_field], 10);
    },
    value_radio: function value_radio() {
      // console.log(this.f_artwork[this.f_field.name])
      return this.f_artwork[this.f_field.name];
    },
    dynamic_field_list: function dynamic_field_list() {
      var _this2 = this;

      if (this.f_field.headline) {
        // console.log('test1')
        // console.log(dynamic_fields.dynamic_fields)
        // console.log(this.f_artwork.classification)
        // console.log(this.f_field.h)
        // console.log(dynamic_fields.dynamic_fields[this.f_artwork.classification])
        // var a = dynamic_fields['dynamic_fields'][this.f_artwork.classification]
        var c = [];
        if (this.report) {
          var fields2 = this.fields_parent;
        } else {
          var fields2 = __WEBPACK_IMPORTED_MODULE_2__data_full_user_fields__["a" /* default */]['tabs'][this.$store.state.currentTab.substr(4)]['fields'];
        }
        // console.log(fields2)
        // console.log('fields2')
        // var fields2 = Object.values(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification])
        // console.log('test')
        // if (fields2.length > 0) {
        // var class_fields = fields2[this.f_artwork.classification]
        c = fields2.filter(function (f) {
          return f.dynamic && f.section === _this2.f_field.section;
        });
        c = c.filter(function (f) {
          return f.work_types && f.work_types.includes(_this2.artwork.classification);
        });
        // console.log(c)
        // }
        // console.log(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artwork.classification].filter(f => f.dynamic))
        return c;
        // Object.values(a).filter(f => f.section === this.f_field.section)
        // console.log('test')
      } else {
        // console.log('not headline')
        return [];
      }
      // return dynamic_fields[this.f_artwork.ownership][this.f_field.title]
    },

    // split_date () {
    // var moment = require('moment')
    // var date = this.f_artwork[this.f_field.name]
    // var ndate = moment(this.f_artwork[this.f_field.name],'YYYY')
    // var out = [ndate.year,ndate.month,ndate.day]
    // var out = [date.getFullYear,date.getMonth,date.getDay]
    // return ndate
    // },
    // field_value () {
    //   return this.f_artwork[this.f_field.name]
    // },
    // is_field_value () {
    //   // console.log(typeof this.field_value)
    //   // console.log(this.field_value)
    //   if (this.field_value == null) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    field_type: function field_type() {
      return this.f_field.etype ? this.f_field.etype : this.f_field.ctype;
    },
    selection_items: function selection_items() {
      var _this3 = this;

      if (this.f_field.table) {
        if (this.f_field.table == 'contacts') {
          var contacts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.contacts);
          if (this.f_field.column) {
            // console.log(this.f_field.column)
            // console.log(this.f_field.association)
            // console.log(contacts.filter(c => c[this.f_field.column] == this.f_field.association))
            return contacts.filter(function (c) {
              return c[_this3.f_field.column] == _this3.f_field.association;
            });
          } else {
            return contacts;
          }
        }
        if (this.f_field.table == 'artists') {
          var artists = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
          if (this.f_field.column) {
            return artists.filter(function (c) {
              return c[_this3.f_field.column] == c[_this3.f_field.association];
            });
          } else {
            return artists.sort(dynamicSort('name'));
          }
        }
        if (this.f_field.table == 'artwork_locations') {
          // console.log(this.f_field.table)
          // console.log('this.f_field.table')
          var artwork_locations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.getters.enabled_locations);
          if (this.f_field.column) {
            return artwork_locations.filter(function (c) {
              return c[_this3.f_field.column] == c[_this3.f_field.association];
            });
          } else {
            return artwork_locations.sort(dynamicSort('name'));
          }
        }
      }
      if (this.f_field.selection && this.f_field.selection.length > 0) {
        return this.f_field.selection;
      }
    },
    f_field: function f_field() {
      var f = this.field;
      f.model_string = this.field.model_string ? this.field.model_string : this.field.name;
      f.column = this.field.column ? this.field.column : false;
      // console.log(this.f_artwork[this.field.name])
      f.value_string = this.field['model_string'] ? this[this.field.model_string] : this.f_artwork[this.field.name];
      return f;
    },
    f_artwork: function f_artwork() {
      return this.artwork;
    }
  },
  components: {
    AddLocation: __WEBPACK_IMPORTED_MODULE_4__components_locations_AddLocation__["a" /* default */],
    AddArtist: __WEBPACK_IMPORTED_MODULE_3__components_artists_AddArtist__["a" /* default */],
    Costs: __WEBPACK_IMPORTED_MODULE_16__components_artworks_Costs__["a" /* default */],
    ViewArtworks: __WEBPACK_IMPORTED_MODULE_1__components_artists_ViewArtworks__["a" /* default */],
    Upload: __WEBPACK_IMPORTED_MODULE_5__components_artworks_Upload__["a" /* default */],
    Location: __WEBPACK_IMPORTED_MODULE_6__components_artworks_Location__["a" /* default */],
    Films: __WEBPACK_IMPORTED_MODULE_9__components_artworks_Films__["a" /* default */],
    Audio: __WEBPACK_IMPORTED_MODULE_10__components_artworks_Audio__["a" /* default */],
    Light: __WEBPACK_IMPORTED_MODULE_13__components_artworks_Light__["a" /* default */],
    Programme: __WEBPACK_IMPORTED_MODULE_11__components_artworks_Programme__["a" /* default */],
    InformationCarrier: __WEBPACK_IMPORTED_MODULE_12__components_artworks_InformationCarrier__["a" /* default */],
    Electrical: __WEBPACK_IMPORTED_MODULE_7__components_artworks_Electrical__["a" /* default */],
    ReadingDevices: __WEBPACK_IMPORTED_MODULE_14__components_artworks_ReadingDevices__["a" /* default */],
    Links: __WEBPACK_IMPORTED_MODULE_15__components_artworks_Links__["a" /* default */],
    NonElectrical: __WEBPACK_IMPORTED_MODULE_8__components_artworks_NonElectrical__["a" /* default */],
    LoanConditions: __WEBPACK_IMPORTED_MODULE_17__components_artworks_LoanConditions__["a" /* default */]
  }
});

/***/ }),

/***/ "bPIR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationOverview_vue__ = __webpack_require__("OYT2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d70911_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationOverview_vue__ = __webpack_require__("Eq8m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("yo4V")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74d70911"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationOverview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d70911_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationOverview_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74d70911_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationOverview_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "bPpd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-0 py-0 px-2 mx-3"},[_c('v-container',{attrs:{"grid-list-xs":"","fluid":"","my-0":"","px-0":"","py-2":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","mx-2":"","py-0":"","my-0":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{staticClass:"mx-0 mt-0 py-0 mb-1 grey"})],1),_vm._v(" "),_c('v-flex',{class:{
          underline: _vm.show != 'facts',
          'menu mx-0 mb-1 display-1 px-2 pt-1': true,
        },staticStyle:{"cursor":"pointer"},attrs:{"xs4":""},on:{"click":function($event){_vm.show = 'facts'}}},[_vm._v("\n        Facts and Figures\n      ")]),_vm._v(" "),_c('v-flex',{class:{
          underline: _vm.show != 'info',
          'menu mx-0 mb-1 display-1 px-2 pt-1': true,
        },staticStyle:{"cursor":"pointer"},attrs:{"xs4":""},on:{"click":function($event){_vm.show = 'info'}}},[_vm._v("\n        System Info")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-divider',{staticClass:"mx-0 my-0 py-0 grey"})],1),_vm._v(" "),(_vm.show == 'facts')?_c('v-flex',{attrs:{"xs12":"","lg4":"","md6":"","mb-4":"","mt-5":""}},[_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('div',{staticClass:"display-1"},[_vm._v("Artworks over years 1950-2020")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-sparkline',{attrs:{"line-width":"2","padding":"4","smooth":"3","value":_vm.value_artworks,"auto-draw":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('div',{staticClass:"display-1"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.$store.getters.collection.length)+"\n            ")]),_vm._v("\n            Artworks in total\n          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('a',{staticClass:"display-1",on:{"click":function($event){return _vm.$router.push({ path: '/artworks/filter/paintings' })}}},[_c('span',{staticClass:"value"},[_vm._v("\n                "+_vm._s(this.$store.getters.paintings.length)+"\n              ")]),_vm._v("\n              Paintings\n            ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('a',{staticClass:"display-1",on:{"click":function($event){return _vm.$router.push({ path: '/artworks/filter/drawings' })}}},[_c('span',{staticClass:"value"},[_vm._v("\n                "+_vm._s(this.$store.getters.drawings.length)+"\n              ")]),_vm._v("\n              Drawings\n            ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('a',{staticClass:"display-1",on:{"click":function($event){return _vm.$router.push({ path: '/artworks/filter/photographs' })}}},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.$store.getters.photographs.length))]),_vm._v("\n              Photos | Prints | Collages\n            ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('a',{staticClass:"display-1",on:{"click":function($event){return _vm.$router.push({ path: '/artworks/filter/videos' })}}},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.$store.getters.videos.length))]),_vm._v("\n              Video Installations\n            ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('a',{staticClass:"display-1",on:{"click":function($event){return _vm.$router.push({ path: '/artworks/filter/sound' })}}},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.$store.getters.sound.length))]),_vm._v("\n              Sound Installations\n            ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('a',{staticClass:"display-1",on:{"click":function($event){return _vm.$router.push({
                  path: '/artworks/filter/objectsAndSculptures',
                })}}},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.$store.getters.objectsAndSculptures.length))]),_vm._v("\n              Objects | Sculptures\n            ")])])],1)],1):_vm._e(),_vm._v(" "),(_vm.show == 'facts')?_c('v-flex',{attrs:{"xs12":"","lg4":"","md6":"","mb-4":"","mt-5":""}},[_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('div',{staticClass:"display-1"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.$store.state.artists.length))]),_vm._v("\n              Artists in total\n            ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('div',{staticClass:"display-1"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.$store.getters.artistsYoung.length))]),_vm._v("\n              under 30 years old\n            ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('div',{staticClass:"display-1"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.$store.getters.artistsMid.length))]),_vm._v("\n              30 to 50 years old\n            ")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('div',{staticClass:"display-1"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.$store.getters.artistsapi.length))]),_vm._v("\n              over 50 years old\n            ")])])],1)],1):_vm._e(),_vm._v(" "),(_vm.show == 'facts')?_c('v-flex',{attrs:{"xs12":"","lg4":"","md6":"","mb-4":"","mt-5":""}},[_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('div',{staticClass:"display-1"},[_vm._v("Exhibitions over years 2000-2020")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-sparkline',{attrs:{"line-width":"2","padding":"4","smooth":"3","value":_vm.value_exhibitions,"labels":_vm.years,"auto-draw":""},scopedSlots:_vm._u([{key:"label",fn:function(item){return [_vm._v("\n              "+_vm._s(item.value)+"\n            ")]}}],null,false,1216312127)})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('div',{staticClass:"display-1"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.$store.getters.exhibitions.length))]),_vm._v("\n              Exhibitions in total\n            ")])])],1),_vm._v(" "),_vm._l(([2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012]),function(y){return _c('v-flex',{key:y,attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('div',{staticClass:"display-1"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.exhibitionsInYear(y).length))]),_vm._v(" in\n              "+_vm._s(y)+"\n            ")])])],1)})],2):_vm._e(),_vm._v(" "),(_vm.show == 'facts')?_c('v-flex',{attrs:{"xs12":"","lg4":"","md6":"","mb-4":"","mt-5":""}},[_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('div',{staticClass:"display-1"},[_vm._v("Loans over years 2000-2020")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-sparkline',{attrs:{"line-width":"2","padding":"4","smooth":"3","value":_vm.value_loans,"labels":_vm.years,"auto-draw":""},scopedSlots:_vm._u([{key:"label",fn:function(item){return [_vm._v("\n              "+_vm._s(item.value)+"\n            ")]}}],null,false,1216312127)})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('div',{staticClass:"display-1"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(this.$store.getters.loans.length))]),_vm._v("\n              Loans in total\n            ")])])],1),_vm._v(" "),_vm._l(([2019, 2018, 2017, 2016, 2015, 2014, 2013, 2012]),function(y){return _c('v-flex',{key:y,attrs:{"xs12":""}},[_c('v-card',{staticClass:"elevation-0 px-2"},[_c('div',{staticClass:"display-1"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.loansInYear(y).length))]),_vm._v(" in\n              "+_vm._s(y)+"\n            ")])])],1)})],2):_vm._e(),_vm._v(" "),(_vm.show == 'info')?_c('v-flex',{attrs:{"xs12":"","lg6":"","mb-2":"","mt-5":""}},[_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('div',{staticClass:"display-1 mb-4 mx-1"},[_vm._v("CMS Updates")]),_vm._v(" "),_vm._l((_vm.support_articles),function(sa){return _c('v-card',{key:'sa_' + sa.id,staticClass:"elevation-0 mb-3",class:{ atWork: sa.at_work },staticStyle:{"border-bottom":"solid 1px #ddd"},attrs:{"outlined":"","loading":""}},[(sa.at_work)?_c('v-progress-linear',{attrs:{"height":"2","indeterminate":""}}):_vm._e(),_vm._v(" "),_c('v-card-title',{staticClass:"title px-2 py-0"},[_c('v-flex',[_vm._v(_vm._s(sa.version)+" | "+_vm._s(sa.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticClass:"body-1 text-xs-right"},[_vm._v("\n                "+_vm._s(sa.publish_date)+"\n              ")])],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"body-1",domProps:{"innerHTML":_vm._s(sa.body)}})])],1)})],2)],1):_vm._e(),_vm._v(" "),(_vm.show == 'info')?_c('v-flex',{attrs:{"xs12":"","lg6":"","mb-4":"","mt-5":""}},[_c('v-flex',{attrs:{"xs12":"","mb-4":""}},[_c('v-flex',{staticClass:"display-1 mx-3 xs12",staticStyle:{"margin-bottom":"17px"}},[_vm._v("\n            User Activity\n            "),_vm._v(" "),_c('v-switch',{staticClass:"right",attrs:{"label":"Only my activity","color":"black"},model:{value:(_vm.myJournal),callback:function ($$v) {_vm.myJournal=$$v},expression:"myJournal"}})],1),_vm._v(" "),_vm._l((_vm.journals.slice(0, 30)),function(item,index){return (_vm.journals.length > 0)?_c('v-card',{key:'j_' + item.id,staticClass:"ml-3 py-2 elevation-0 pt-3",staticStyle:{"border-top":"1px solid #ddd"}},[_c('v-card-title',{staticClass:"title px-3 py-0"},[_c('v-flex',[_vm._v(_vm._s(_vm.format_date(item.created_at))+" |\n                "+_vm._s(item.value_name)+" changed")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticClass:"body-1 text-xs-right"},[_c('v-list-tile-action-text',[_vm._v("\n                  In "+_vm._s(item.cms)+" CMS by\n                  "+_vm._s(_vm.format_journal_user(item)))]),_vm._v(" "),(item.user_id != _vm.c_user.id)?_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("\n                  star_border\n                ")]):_c('v-icon',{attrs:{"color":"yellow darken-2"}},[_vm._v(" star ")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"body-1",domProps:{"innerHTML":_vm._s(_vm.format_journal_artwork(item))}}),_vm._v(" "),_c('div',{staticClass:"body-1 my-2",domProps:{"innerHTML":_vm._s(
                  '<b>OLD VALUE:</b> ' +
                  (item.old_value == null ? '' : item.old_value)
                )}}),_vm._v(" "),_c('div',{staticClass:"body-1",domProps:{"innerHTML":_vm._s('<b>NEW VALUE:</b> ' + item.new_value)}})])],1):_vm._e()}),_vm._v(" "),(!_vm.journals.length > 0)?_c('div',{staticClass:"subheading mt-4 ml-4"},[_vm._v("\n            No updates recorded for this user.\n          ")]):_vm._e()],2)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "bREw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_user__ = __webpack_require__("yLEp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_api__ = __webpack_require__("VsUZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_auth__ = __webpack_require__("+4WN");



var _mutations;






var state = { status: '', profile: {}
  // const userId = localStorage.getItem('user-id')

};var getters = {
  getProfile: function getProfile(state) {
    return state.profile;
  },
  isProfileLoaded: function isProfileLoaded(state) {
    return !!state.profile.name;
  }
};

var actions = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_2__actions_user__["b" /* USER_REQUEST */], function (_ref) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  // console.log('USER_REQUEST action')
  commit(__WEBPACK_IMPORTED_MODULE_2__actions_user__["b" /* USER_REQUEST */]);
  Object(__WEBPACK_IMPORTED_MODULE_3__utils_api__["a" /* default */])({ url: '/users/' + localStorage.getItem('user-id') + '.json', method: 'GET' }).then(function (resp) {
    // console.log('USER_SUCCESS action')
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_user__["c" /* USER_SUCCESS */], resp);
  }).catch(function (resp) {
    // console.log('USER_ERROR action')
    commit(__WEBPACK_IMPORTED_MODULE_2__actions_user__["a" /* USER_ERROR */]);
    // if resp is unauthorized, logout, to
    dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_auth__["b" /* AUTH_LOGOUT */]);
  });
});

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_user__["b" /* USER_REQUEST */], function (state) {
  // console.log('USER_REQUEST mutation')
  state.status = 'loading';
  state.loading_users = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_user__["c" /* USER_SUCCESS */], function (state, resp) {
  state.status = 'success';
  // state.loading_users = false
  localStorage.setItem('profile', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(resp));
  __WEBPACK_IMPORTED_MODULE_4_vue__["default"].set(state, 'profile', resp);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_user__["a" /* USER_ERROR */], function (state) {
  state.status = 'error';
  // state.loading_user = false
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_auth__["b" /* AUTH_LOGOUT */], function (state) {
  state.profile = {};
  localStorage.removeItem('profile');
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "bWPW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "bXxC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bgEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{staticClass:"ml-1 mb-0"},[_c('h3',{staticClass:"xs12 flex"},[_vm._v("Costs")])]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 mx-0",attrs:{"headers":_vm.headers,"items":this.artwork.artwork_costs ? this.artwork.artwork_costs.filter(function (c) { return c.category === 'cost'; }) : [],"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"py-2 text-xs-left"},[_vm._v(_vm._s(props.item.what_for))]),_vm._v(" "),_c('td',{staticClass:"py-2 text-xs-left"},[_vm._v(_vm._s(props.item.cost ? _vm.formatMoney(props.item.cost) : ' - ')+" "+_vm._s(props.item.cost ? 'EUR' : ''))]),_vm._v(" "),_c('td',{staticClass:"py-2 text-xs-left"},[_vm._v(_vm._s(props.item.content))]),_vm._v(" "),_c('td',{staticClass:"py-2 text-xs-left"},[_vm._v(_vm._s(_vm.getUser(props.item.created_by).abb))]),_vm._v(" "),_c('td',{staticClass:"py-2 text-xs-left"},[_vm._v(_vm._s(props.item.transaction_date))]),_vm._v(" "),_c('td',{},[_c('v-btn',{attrs:{"small":"","flat":"","icon":"","ma-0":""}},[_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.editCost(props.item)}}},[_vm._v("edit")])],1),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{attrs:{"small":"","flat":"","icon":""}},[_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_vm._v("delete")])],1):_vm._e()],1)]}}])}),_vm._v(" "),_c('v-flex',{staticClass:"ml-1 mt-4 mb-0"},[_c('h3',{staticClass:"xs12 flex"},[_vm._v("Other")])]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 mx-0",attrs:{"headers":_vm.headers_other,"items":this.artwork.artwork_costs ? this.artwork.artwork_costs.filter(function (c) { return c.category === 'other'; }) : [],"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"py-2 text-xs-left"},[_vm._v(_vm._s(props.item.what_for))]),_vm._v(" "),_c('td',{staticClass:"py-2 text-xs-left"},[_vm._v(_vm._s(props.item.content))]),_vm._v(" "),_c('td',{staticClass:"py-2 text-xs-left"},[_vm._v(_vm._s(_vm.getUser(props.item.created_by).abb))]),_vm._v(" "),_c('td',{staticClass:"py-2 text-xs-left"},[_vm._v(_vm._s(props.item.transaction_date))]),_vm._v(" "),_c('td',{},[_c('v-btn',{attrs:{"flat":"","icon":""}},[_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.editCost(props.item)}}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","icon":""}},[_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_vm._v("delete")])],1)],1)]}}])}),_vm._v(" "),_c('v-btn',{staticClass:"right mx-3 mt-3 mb-0",attrs:{"color":"primary","small":""},on:{"click":function($event){_vm.showDialog=true}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("add")]),_vm._v(" Add Cost or Conditions")],1),_vm._v(" "),(_vm.showDialog)?_c('v-card',{staticClass:"my-3 mx-4 pr-3 pt-0 elevation-1",staticStyle:{"background-color":"#eee"}},[_c('v-card-title',{staticClass:"px-4 pb-0 mb-0"},[_c('span',{staticClass:"headline pt-1"},[_vm._v("New Cost/Conditions")])]),_vm._v(" "),_c('v-card-text',{staticClass:"mx-0 px-0 my-0 py-0"},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","mb-1":""}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.loan_condition.category),callback:function ($$v) {_vm.$set(_vm.loan_condition, "category", $$v)},expression:"loan_condition.category"}},[_c('v-radio',{staticClass:"flex pl-2",attrs:{"value":"cost","color":"black","name":"Cost","label":"Cost"}}),_vm._v(" "),_c('v-radio',{staticClass:"flex pl-2",attrs:{"value":"other","color":"black","name":"Other","label":"Conditions"}})],1)],1),_vm._v(" "),(_vm.loan_condition.category!='other')?_c('v-flex',{attrs:{"xs6":"","mb-2":""}},[_c('v-text-field',{staticClass:"flex pl-2",attrs:{"type":"number","suffix":" EUR","name":"cost","label":"Cost"},model:{value:(_vm.loan_condition.cost),callback:function ($$v) {_vm.$set(_vm.loan_condition, "cost", $$v)},expression:"loan_condition.cost"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-2":""}},[_c('v-text-field',{staticClass:"flex pl-2",attrs:{"name":"what_for","label":"What for"},model:{value:(_vm.loan_condition.what_for),callback:function ($$v) {_vm.$set(_vm.loan_condition, "what_for", $$v)},expression:"loan_condition.what_for"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{staticClass:"flex xs12 ml-2",attrs:{"rows":"1","auto-grow":"","name":"content","label":"Note"},model:{value:(_vm.loan_condition.content),callback:function ($$v) {_vm.$set(_vm.loan_condition, "content", $$v)},expression:"loan_condition.content"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pr-3 pb-4"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","outline":"","color":"black"},nativeOn:{"click":function($event){_vm.showDialog=false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","color":"black","dark":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("Save")])],1)],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "bnwI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListRelated__ = __webpack_require__("C2KG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListRelatedArtists__ = __webpack_require__("VedM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_constants__ = __webpack_require__("K30H");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      constants: __WEBPACK_IMPORTED_MODULE_5__data_constants__["a" /* default */],
      filtered: [],
      // selectedCategoryName: '',
      selectedCategory: {},
      local_text_categories: [],
      progress: false,
      showingArtworks: false,
      showingArtists: false,
      view_dialog: false,
      view: {},
      table_texts: [],
      text_to_delete: '',
      delete_dialog: false,
      delete_step: 0,
      pagination: {
        descending: false,
        rowsPerPage: 10,
        sortBy: 'given_filename'
      },
      relatedShown: [],
      fields: ['artwork_location_id', 'type_of_work_id'],
      dialog: false,
      ta: [],
      selected: [],
      tba21: '1',
      search: 'dd', // this.$store.state.searchString['texts'],
      headers: [
      // { text: "", sortable: false, value: "" },
      { text: 'File Name', sortable: true, value: 'given_filename' },
      // { text: "File Name", sortable: true, value: "fname" },
      // { text: "Title", align: "left", sortable: true, value: "title" },
      { text: '', value: 'artwork_text', sortable: false }, { text: 'Date Created', sortable: true, value: 'created_at' }, { text: 'Created by', sortable: true, value: 'created_by' }, { text: 'Date Last Modified', sortable: true, value: 'updated_at' }, { text: 'Type of text', sortable: true, value: 'category' }, { text: '', value: 'fname', sortable: false }, { text: '', value: 'given_filename', sortable: false }, { text: '', value: 'artwork_text', sortable: false
        // { text: "Artwork", sortable: true, value: "artwork_id" },
        // { text: "PR", sortable: true, value: "pr" },
        // { text: "Article", sortable: true, value: "article" },
        // { text: "Artw. Text", sortable: true, value: "artwork_text" },
        // { text: "Artist Doc.", sortable: true, value: "artist_documents" },
        // { text: "Transcript", sortable: true, value: "transcript" },
        // { text: "", sortable: false }
      }]
    };
  },

  // props: ["items"],
  // watch: {
  //   search: function() {
  //   }
  // },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    // this.$store.commit('routeChange')
    this.$store.dispatch('setSearchString', {
      string: this.search,
      section: 'texts'
    });
    next();
  },

  created: function created() {
    // console.log('created')
    // console.log(this.$store.state.searchString['texts'])
    this.setsearchvalue();
    this.$store.dispatch('loadTexts');
    this.table_texts = this.$store.state.texts;
    this.local_text_categories = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.constants.TEXT_CATEGORIES);
    this.local_text_categories.unshift({ id: 'all', name: 'All' });
    this.toggleCategory(this.local_text_categories[0]);
  },
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted')
    // console.log(this.$store.state.searchString['texts'])
    this.setsearchvalue();
    __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$on('setSorting', function (a) {
      _this.pagination.sortBy = a;
      _this.pagination.descending = !_this.pagination.descending;
    });
    // this.$store.dispatch("loadTexts");
    this.table_texts = this.$store.state.texts;
  },
  methods: {
    download_text: function download_text(text) {
      console.log(text);
      // this.exportHTML(text, this.artwork)
      this.exportHTML(text.content, text.given_filename ? text.given_filename : text.title);
    },
    getRelatedTitle: function getRelatedTitle(text) {
      // console.log(text)
      switch (text.category) {
        case 'artwork_literature' || 'artwork_text':
          var o = this.$store.state.artworks.find(function (a) {
            return a.id == text.artwork_id;
          });
          return o ? o.title + ', ' + o.accession_number : 'Artwork not found';
          break;
        case 'artist_interview' || 'artist_press' || 'artist_text':
          var o = this.$store.state.artists.find(function (a) {
            return a.id == text.artist_id;
          });
          return o ? o.name : 'Artist not found';
          break;
        default:
          return 'Article File from Old TBA21 Website';
          break;
      }
    },
    controller: function controller(category) {
      return ['artist_interview', 'artist_press', 'artist_text'].includes(category) ? 'artists' : category == 'artwork_literature' ? 'artworks' : 'articles';
    },
    id: function id(item) {
      return ['artist_interview', 'artist_press', 'artist_text'].includes(item.category) ? item.artist_id : item.category == 'artwork_literature' ? item.artwork_id : item.article_id;
    },
    setsearchvalue: function setsearchvalue() {
      this.search = this.$store.state.searchString['texts'];
    },
    toggleCategory: function toggleCategory(o) {
      // this.selectedCategoryName = o.name;
      this.selectedCategory = o;
      // if(o.id != 'all') {
      //   this.filtered = this.filtered_texts.filter(a => a[o.id] == 1);
      // } else {
      //   this.filtered = this.filtered_texts;
      // }
    },
    categoryName: function categoryName(c) {
      var cs = {
        artwork_literature: 'ARTWORK TEXT OLD CMS',
        artwork_text: 'ARTWORK TEXT NEW CMS'
        // console.log(cs[c])
      };if (cs) {
        return cs[c] ? cs[c] : c;
      } else {
        return '';
      }
    },
    showArtworks: function showArtworks(props) {
      props.expanded = !props.expanded;
      this.showingArtworks = true;
    },
    showArtists: function showArtists(props) {
      props.expanded = !props.expanded;
      this.showingArtworks = false;
    },
    viewText: function viewText(id) {
      var _this2 = this;

      this.progress = true;
      var url = this.$globals.apiserver + '/artwork_texts/' + id + '.json';
      var atext = {};
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url).then(function (response) {
        atext = response.data;
        _this2.progress = false;
        // console.log(atext)

        RegExp.escape = function (atext) {
          return atext.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
        };
        if (_this2.search) {
          var content = atext.content.replace(new RegExp(_this2.search, 'gi'), function (match) {
            return '<mark>' + match + '</mark>';
          });
          var title = atext.title.replace(new RegExp(_this2.search, 'gi'), function (match) {
            return '<mark>' + match + '</mark>';
          });
          _this2.view.title = title;
          _this2.view.content = content;
        } else {
          _this2.view = atext;
        }
        _this2.view_dialog = true;
      }).catch(function (error) {
        console.log(error);
      });
      this.progress = false;
    },
    delete_dialog_close: function delete_dialog_close() {
      this.delete_dialog = false;
      this.delete_step = 0;
    },
    deleteText: function deleteText(e) {
      if (this.delete_step == 0) {
        this.delete_dialog = true;
        this.delete_step = 1;
        this.text_to_delete = e;
      } else {
        this.$store.dispatch('deleteText', e);
        this.delete_dialog = false;
        this.delete_step = 0;
        // console.log('deleted')
      }
    },
    showRelated: function showRelated(id) {
      if (this.relatedShown[id] == true) {
        this.relatedShown[id] = false;
      } else {
        this.relatedShown[id] = true;
      }
      // console.log(this.relatedShown)
    },
    addField: function addField() {},
    switchSwitch: function switchSwitch() {
      // this.show_tag_filter = !this.show_tag_filter
      this.$emit('switchOwnershipTop', this.show_tag_filter);
    },
    clearFilters: function clearFilters() {
      this.selected_tags = [];
      this.selected_tag_categories = [];
    }
  },
  computed: {
    filtered_texts: function filtered_texts() {
      var _this3 = this;

      var filtered = [];
      if (this.tba21 == 'uploads') {
        filtered = this.$store.state.file_uploads.filter(function (fu) {
          return fu.show_in_texts == 1;
        });
      } else {
        filtered = this.$store.state.texts.filter(function (t) {
          return t.category != 'artwork_exhibition';
        });
      }
      if (this.selectedCategory.id != 'all') {
        filtered = filtered.filter(function (a) {
          return a[_this3.selectedCategory.id] == 1;
        });
      }
      if (this.tba21 == 1) {
        filtered = filtered.filter(function (e) {
          return e.tba == 'tba';
        });
      } else if (this.tba21 == 0) {
        filtered = filtered.filter(function (e) {
          return e.tba == 'nontba';
        });
      }
      // let out = [];
      // console.log(filtered)
      // console.log(filtered[0])
      // filtered.forEach(te => {
      //   te = Object.assign({}, te);
      //   let aids = te.artworks.map(tea => tea.id);
      //   let sas = Object.assign([], this.$store.state.artworks);
      //   // console.log('aidss')
      //   // console.log(aids)
      //   let as = Object.assign(
      //     [],
      //     sas.filter(a => aids.includes(a.id))
      //   );
      //   // let artistsids = te.artists.map(tea => tea.id);
      //   // let sars = Object.assign([], this.$store.state.artists)
      //   // // console.log('aidss')
      //   // // console.log(aids)
      //   // let ars = Object.assign(
      //   //   [],
      //   //   sars.filter(a => artistsids.includes(a.id))
      //   // );
      //   // console.log('as')
      //   // console.log(as)
      //   te.artwork_text = as
      //     .map(
      //       aa =>
      //         `${aa.accession_number} ${aa.title} ${aa.name} ${aa.artist_name}`
      //     )
      //     .toString();
      //   // console.log('te.artwork_text')
      //   // console.log(te.artwork_text)
      //   out.push(te);
      // });
      // console.log(out)
      return filtered;
      // return filtered;
    },

    add_new: {
      get: function get() {
        return this.$store.state.add_new;
      },
      set: function set(value) {
        this.$store.dispatch('addNew', value);
      }
    },
    currrent_path: function currrent_path() {
      return this.$route.params.ownership;
    }
    // table_texts () {
    //   // if (this.selected_tags.length > 0) {
    //   //   var cst = this.selected_tags
    //     return this.$store.state.texts
    //     // .filter(function(artwork) {
    //   //     return artwork.tags.some(a_tag => cst.indexOf(a_tag.id) > -1)
    //   //   })
    //   // } else {
    //     // console.log('items')
    //     // return this.items
    //     // $store.state.artworks
    //   // }
    // },

  },
  components: { ListRelated: __WEBPACK_IMPORTED_MODULE_3__ListRelated__["a" /* default */], ListRelatedArtists: __WEBPACK_IMPORTED_MODULE_4__ListRelatedArtists__["a" /* default */] }
});

/***/ }),

/***/ "bpR0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListRelated__ = __webpack_require__("+hVl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__artworks_ListActionMenu__ = __webpack_require__("O429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__main__ = __webpack_require__("NHnr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import axios from 'axios'



// import IndexTable from '@/components/selections/IndexTable'
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__main__["serverBus"].$on('setSorting', function (a) {
      _this.pagination.sortBy = a;
      _this.pagination.descending = !_this.pagination.descending;
    });
    // this.toggleOwnership(this.ownerships[0]);
  },
  data: function data() {
    return {
      itemToDelete: {},
      deleteDialog: false,
      // selection_store: [],
      mySelections: false,
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'created_at'
      },
      pagination_related: {
        descending: false,
        // rowsPerPage: 10,
        sortBy: 'last_name'
      },
      search: '',
      search_related: '',
      selected: [],
      selected_related: [],
      headers: [{ text: 'Title', value: 'name' }, { text: 'Artworks', value: 'artworks.length', align: 'center' }, { text: 'Date Created', value: 'created_at', align: 'center' }, { text: 'Created By', value: 'created_by', align: 'center' }, { text: '', align: 'right' }],
      headers_related: [{ text: 'Artwork Title', sortable: true, value: 'title' }, { text: 'Accession Number', value: 'accession_number', align: 'right' }],
      table_lists: this.$store.state.lists,
      loading: false,
      displayedData: [],
      filteredTextArtwork: '',
      filteredTextArtist: '',
      selectedFilter: '',
      artwork: {
        name: ''
      },
      artists: [],
      artworks: [],
      resultsArtworks: [],
      resultsArtists: [],
      editArtwork: false,
      filterText: ''
    };
  },
  created: function created() {
    this.$store.dispatch('loadLists');
    // this.selection_store = this.$store.state.lists
  },
  methods: {
    goToList: function goToList() {
      this.$router.push({
        name: 'Lists',
        params: { loadCurrent: '1' }
      });
    },
    loadSelection: function loadSelection(e) {
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      this.$store.dispatch('saveCurrentSelection', e);
      // } else {
      //   // console.log('no add')
      //   this.$store.dispatch('addToCurrentSelection',e)
      // }
    },
    addToSelection: function addToSelection(e) {
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      // this.$store.dispatch('saveCurrentSelection',e)
      // } else {
      //   // console.log('no add')
      this.$store.dispatch('addToCurrentSelection', e);
      // }
    },
    showDeleteDialog: function showDeleteDialog(p) {
      this.itemToDelete = p;
      this.deleteDialog = true;
    },
    deleteItem: function deleteItem() {
      var index = this.selections.indexOf(this.itemToDelete);
      var i = this.selections.indexOf(this.itemToDelete);
      // if (i != -1) {
      //   this.selections.splice(i, 1);
      // }
      // confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
      this.$store.dispatch('deleteSelection', this.itemToDelete);
      this.itemToDelete = null;
      this.deleteDialog = false;
    },
    cancelDelete: function cancelDelete() {
      this.deleteDialog = false;
      this.itemToDelete = null;
    },
    remove_from_selection: function remove_from_selection(list_id, artwork_id) {
      var list = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.lists.find(function (list) {
        return list.id == list_id;
      }));
      list.artworks = list.artworks.filter(function (a) {
        return a != artwork_id;
      });
      this.$store.dispatch('removeArtworkFromList', {
        l: list_id,
        a: artwork_id
      });
    },
    table_artworks: function table_artworks(as) {
      console.log('table_artworks');
      console.log(as);
      console.log(as);
      var out = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks.filter(function (a) {
        return as.includes(a.id);
      }));
      // console.log(out)
      // out = out.sort(dynamicSort('last_name'))
      // console.log(out)
      return out;
    }
  },
  computed: {
    selections: function selections() {
      // this.c_user.id
      if (this.mySelections) {
        // return this.selection_store.filter(j => j.created_by === this.c_user.id)
        return this.$store.getters.user_lists;
      } else {
        return this.$store.state.lists;
      }
    },

    // table_lists () {
    // return this.selection_store
    // return this.$store.state.lists
    // },
    filtered: function filtered() {
      return this.$store.state.filterResults;
    },
    title: function title() {
      var title = '';
      // if (this.$route.fullPath == '/artworks/oldMasters') {
      //   title = 'Old Masters'
      // } else
      if (this.$route.fullPath == '/artworks/deaccession') {
        title = 'Deaccessioned';
      } else if (this.$route.fullPath == '/artworks/collection') {
        title = 'TBA21 Collection';
      } else if (this.$route.fullPath == '/artworks/pacFvh') {
        title = 'Private Art Collection FTB';
      } else if (this.$route.fullPath == '/artworks/pdcFvh') {
        title = 'Private Design Collection FTB';
      } else if (this.$route.fullPath == '/artworks/pcFT') {
        title = 'Private Collection FT';
      } else if (this.$route.fullPath == '/artworks/pacMr') {
        title = 'Private Art Collection MR';
      }
      return title;
    },
    columns: function columns() {
      return this.$store.state.artworkColumns;
    },
    processedArtists: function processedArtists() {
      var artists = this.resultsArtists;
      this.artists.map(function (artist) {
        var a = artist;
        artist.first_name = a ? a.first_name : 'nema meno';
      });
      return artists;
    },
    storedData: function storedData() {
      var sdata = '';
      if (this.$store.state.filterResults) {
        sdata = this.$store.state.filterResults;
      } else {
        sdata = this.filteredData;
        // console.log(sdata)
        this.$store.dispatch('postFilterResults', sdata);
      }
      this.displayedData = sdata;
      return sdata;
    },
    filteredData: function filteredData() {
      var searchString = this.filteredTextArtwork;

      if (this.filteredTextArtwork != '') {
        // vráť z "this.processedArtists" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "this.processedArtists"
        return this.processedArtists.filter(function (artist) {
          // vráť z "artist.artworks" dáta odfiltrované funkciou, ktorej odovzdáš každú položku poľa "artist.artworks" v premennej "q"
          return artist.artworks.filter(function (artwork) {
            // vráť (čítať odzadu) true - ak "title" atribút obsahuje "search" string
            return artwork.title.toLowerCase().indexOf(searchString.toLowerCase()) > -1;
          }).length > 0;
        });
      } else {
        return this.processedArtists;
      }
    },

    filteredArtworks: function filteredArtworks() {
      var self = this;
      // console.log(self)
      // return self.artworks.filter(function (artwork) {
      //   return artwork.ownership.indexOf(self.searchQuery) == -1
      // })
      // var self = this
      self.artworks.filter(function (artwork) {
        // console.log(artwork)
        var searchRegex = new RegExp(4, 'i');
        // console.log(searchRegex)
        return searchRegex.test(artwork.ownership);
      });
    }

    // processedArtworks () {
    //   let artworks = this.resultsArtworks
    //   this.artworks.map(artwork => {
    //     let a = artwork
    //     artwork.first_name = a ? a.first_name : 'nema meno'
    //   })
    //   return artworks
    // },
    // filteredArtworks () {
    //   return this.artworks
    //     .filter(this.artworkPassesOwnershipFilter)
    // },

    // return this.processedArtists.filter(function(obj) {
    //   return obj.artworks.title(function(item){
    //     return item.indexOf('a') >= 0;
    //   });
    // });
    // function getResult(filterBy, objList) {
    //   return objList.hightlights.filter(function(obj) {
    //   return obj.queries.some(function(item){
    //     return item.indexOf(filterBy) >= 0;
    //   });
    // });
    // }
    //   const x = 'title',
    //     filter = new RegExp(this.filteredText, 'i')
    //   return this.processedArtists.filter(el => {
    //     if (el[x] !== undefined) { return el[x].match(filter) }
    //     else return true;
    //   })
    // }
  },
  // filters: {
  //   capitalize: function (a) {
  //     if (!a) return ''
  //     a = a.toString()
  //     return a.charAt(0).toUpperCase() + a.slice(1)
  //   }
  // },
  components: {
    ListRelated: __WEBPACK_IMPORTED_MODULE_1__ListRelated__["a" /* default */],
    ListActionMenu: __WEBPACK_IMPORTED_MODULE_2__artworks_ListActionMenu__["a" /* default */]
  }
});

/***/ }),

/***/ "bwCk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cA3P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_artists_ViewArtworks__ = __webpack_require__("eZui");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_artworks_OwnershipHistory__ = __webpack_require__("QBky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_full_user_fields__ = __webpack_require__("LKPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_artists_AddArtist__ = __webpack_require__("AnAQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_locations_AddLocation__ = __webpack_require__("CODS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_artworks_Upload__ = __webpack_require__("e4A6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artworks_Location__ = __webpack_require__("KK+U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_artworks_Insurance__ = __webpack_require__("T7Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_artworks_MarketValueHistory__ = __webpack_require__("sXdf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_artworks_Electrical__ = __webpack_require__("sHT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_artworks_NonElectrical__ = __webpack_require__("R4KG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artworks_Films__ = __webpack_require__("iuSU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_artworks_Audio__ = __webpack_require__("XNw2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_artworks_Programme__ = __webpack_require__("5cyT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_artworks_InformationCarrier__ = __webpack_require__("qSBE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_artworks_Light__ = __webpack_require__("D2Yk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_artworks_ReadingDevices__ = __webpack_require__("54WG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_artworks_Links__ = __webpack_require__("dpcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_artworks_Costs__ = __webpack_require__("7EMl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_artworks_Conservation__ = __webpack_require__("SWdK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_artworks_LoanConditions__ = __webpack_require__("P7M7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__data_constants__ = __webpack_require__("K30H");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EditFieldHeader from '@/components/artists/EditFieldHeader'


// import dynamic_fields from '@/data/dynamic_fields'





















// import * as qs from 'querystring'

function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
// function nl2br (str, isXhtml) {
//   var breakTag =
//     isXhtml || typeof isXhtml === 'undefined' ? '<br />' : '<br>'
//   return (str + '').replace(
//     /([^>\r\n]?)(\r\n|\n\r|\r|\n)/g,
//     '$1' + breakTag + '$2'
//   )
// }

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-field',
  data: function data() {
    return {
      current_value: '',
      valueBeforeEdit: '',
      separated_date: {
        day: Number,
        month: Number,
        year: Number
      },
      constants: __WEBPACK_IMPORTED_MODULE_23__data_constants__["a" /* default */],
      saving: false,
      ownership_gemini: '',
      f_artwork: {},
      included_artwork: {
        including_objects: false,
        including_sound: false,
        including_film: false,
        including_slide: false,
        including_computer: false,
        including_performance: false,
        including_light: false,
        including_other: false
      },
      // includes: [
      //   { title: 'Objects', field: 'including_objects' },
      //   { title: 'Sound', field: 'including_sound' },
      //   { title: 'Film / Video / AV', field: 'including_film' },
      //   { title: 'Slide', field: 'including_slide' },
      //   {
      //     title: 'Computer Program / Software / File',
      //     field: 'including_computer'
      //   },
      //   { title: 'Performance', field: 'including_performance' },
      //   { title: 'Light', field: 'including_light' },
      //   { title: 'Other', field: 'including_other' }
      // ],
      timeout: 2500,
      snackbar: false,
      progress: false,
      toggle: 0,
      switch_value: false,
      toggle_exclusive: 2,
      count: 0,
      showingAddForm: false,
      showUpload: false,
      instalation_includes: [],
      film_type: '',
      fields: __WEBPACK_IMPORTED_MODULE_3__data_full_user_fields__["a" /* default */],
      isEditing: false,
      an_exists: false,
      saved: false,
      cannotSave: false,
      value_new: '',
      select_value: '',
      field_value: '',
      show: true,
      showSnackbar: false,
      model: {},
      menu2: '',
      date: ''
      // model: "artwork_location"
      // this.f_field.show
    };
  },

  props: ['field', 'artwork', 'placeholder', 'label', 'name', 'value', 'selection', 'title', 'film', 'report', 'fields_parent'],
  watch: {
    artwork: function artwork() {
      this.f_artwork = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.artwork);
      this.ownership_gemini = this.f_artwork['ownership_gemini'];
      this.select_value = this.f_artwork[this.f_field.name];
    }
  },
  mounted: function mounted() {
    // this.valueBeforeEdit = Object.assign(
    //   this.valueBeforeEdit,
    //   this.f_artwork[this.f_field.name]
    // )
    this.f_artwork = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.artwork);
    this.current_value = this.f_artwork[this.f_field.name];
    this.ownership_gemini = this.f_artwork['ownership_gemini'];
    this.select_value = this.f_artwork[this.f_field.name];
    this.switch_value = this.f_artwork[this.f_field.name] === 1;
    this.field_value = this.f_artwork[this.f_field.name] ? this.f_artwork[this.f_field.name] : '';
    this.toggle = this.f_artwork[this.f_field.name];
    this.included_artwork.including_objects = this.f_artwork['including_objects'];
    this.included_artwork.including_sound = this.f_artwork['including_sound'];
    this.included_artwork.including_film = this.f_artwork['including_film'];
    this.included_artwork.including_slide = this.f_artwork['including_slide'];
    this.included_artwork.including_computer = this.f_artwork['including_computer'];
    this.included_artwork.including_performance = this.f_artwork['including_performance'];
    this.included_artwork.including_light = this.f_artwork['including_light'];
    this.included_artwork.including_other = this.f_artwork['including_other'];
    this.separated_date.year = this.f_artwork[this.f_field.name + '_year'];
    this.separated_date.month = this.f_artwork[this.f_field.name + '_month'];
    this.separated_date.day = this.f_artwork[this.f_field.name + '_day'];
  },

  methods: {
    getArtwork: function getArtwork() {
      this.$emit('getArtwork');
    },
    nl2br: function nl2br(str, isXhtml) {
      var breakTag = isXhtml || typeof isXhtml === 'undefined' ? '<br />' : '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    copy2c: function copy2c(t) {
      navigator.clipboard.writeText(t).then(function () {
        // console.log('Async: Copying to clipboard was successful!');
      }, function (err) {
        console.error('Async: Could not copy text: ', err);
      });
    },
    saveCurrency: function saveCurrency(event) {
      // console.log('saveCurrency')
      // console.log(event)
      // console.log(this.f_field.name)
      // this.select_value = event;
      this.saveField(event, this.f_field.name + '_currency');
    },
    saveCurrencyOnly: function saveCurrencyOnly(event) {
      // console.log('saveCurrency')
      // console.log(event)
      // console.log(this.f_field.name)
      // this.select_value = event;
      this.saveField(event, this.f_field.name);
    },
    checkSubfields: function checkSubfields(event) {
      // console.log('checkSubfields')
      // console.log(event)
      this.select_value = event;
      this.saveField(this.select_value);
    },
    showAddForm: function showAddForm() {
      this.showingAddForm = !this.showingAddForm;
    },
    add_field: function add_field(field) {
      // console.log('sub')
      // console.log(document.getElementById(field.name))
      this.$emit('show', field);
      // var a = document.getElementById(field.name)
      // console.log(this.$el.style.display)
      // this.$el.style.display = 'block'
      // console.log(this.$children)
      // this.$children.find(a => a.name['name'] == field).styles.display = 'block'
      // console.log(this.$children.find(a => a.name['name'] == field).styles.display)
      // a.style.display = 'block'
      // a.style.backgroundColor = "green"
      // console.log(this.$el.style.display)
      // this.$forceUpdate()
    },
    saveOrEdit: function saveOrEdit() {
      var _this = this;

      console.log('/////// saveOrEdit A /////////');
      // CHANGE EDITING STATUS
      this.isEditing = !this.isEditing;

      // IF NOW NOT EDITING ANYMORE, SHOW PROGRESS & SAVE
      if (!this.isEditing) {
        this.progress = true;

        // TOGGLE FIELD NEEDS FALSE & TRUE BE SUBMIT RIGHT VALUE
        if (!this.field_type === 'toggle') {
          if (this.isEditing) {
            this.$refs[this.f_field['name']].isFocused = true;
          } else {
            this.$refs[this.f_field['name']].isFocused = false;
          }
        }

        // CHECKING READINESS FOR SAVE
        // CHECKING ACCESSION NUMBER
        var saveOK = false;
        if (this.f_field.name === 'accession_number') {
          this.check_an(this.current_value);
          // this.check_an(this.f_artwork['accession_number'])
          if (this.an_exists === false) {
            saveOK = true;
          }
        } else {
          saveOK = true;
        }
        console.log('this.current_value');
        console.log(this.current_value);
        console.log(this.field_value);
        // console.log(this.f_artwork['accession_number'])
        // console.log(this.an_exists)
        // console.log(saveOK)

        var valueToSave = this.current_value;

        // COMMENTED BECAUSE OTHERWISE EMPTY VALUE WAS NOT SAVED
        // if (!valueToSave || !valueToSave.trim()) {
        //   valueToSave = this.field_value
        // }

        // TOGGLE FIELD NEED PREVIOUSLY CALCULATED TOGGLE VALUE
        if (this.field_type === 'toggle') {
          valueToSave = this.toggle;
        }

        // DATE_SEPARATED FIELD REQUIRES TO SAVE EACH FIELD / YEAR, MONTH, DAY SEPARATELY
        if (this.field_type === 'date_separated') {
          // console.log(this.separated_date)
          this.saveField(this.separated_date.year, this.f_field.name + '_year');
          this.saveField(this.separated_date.month, this.f_field.name + '_month');
          this.saveField(this.separated_date.day, this.f_field.name + '_day');
        }

        // FOR OTHER FIELD TYPES
        if (saveOK) {
          this.saveField(valueToSave);
        } else {
          this.cannotSave = true;
          setTimeout(function () {
            _this.cannotSave = false;
          }, 4000);
        }
      }
      console.log('/////// saveOrEdit B /////////');
    },
    cancel: function cancel() {
      // this.f_artwork[this.f_field.name] = this.select_value
      this.isEditing = false;
    },
    saveSubfield: function saveSubfield(field, value) {
      var _this2 = this;

      this.$emit('showSnackbar', 'Saving ' + field + '… ');
      setTimeout(function () {
        var url = _this2.$globals.apiserver + '/artworks/' + _this2.artwork.id + '.json';
        __WEBPACK_IMPORTED_MODULE_22_axios___default.a.put(url, {
          field_name: field,
          field_value: value,
          updated_by: _this2.c_user.id
        }).then(function (response) {
          // console.log("axios");
          _this2.$emit('getArtwork', 'test');
          // console.log("axios2");
          _this2.$emit('showSnackbar', 'Saved ' + field, 'green');
          _this2.progress = false;
          _this2.isEditing = false;
        }).catch(function (error) {
          _this2.$emit('showSnackbar', 'Error Saving  ' + field, 'red');
          // console.log(error)
          _this2.progress = false;
          _this2.isEditing = false;
        });
      }, 1000);
    },

    // saveField (valueToSave) {
    //   this.$emit('showSnackbar', 'Saving… ')
    //   console.log('saveField')
    //   console.log(valueToSave)
    //   setTimeout(() => {
    //     let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`
    //     axios.put(url, {
    //       'field_name': this.f_field.name,
    //       'field_value': valueToSave,
    //       'updated_by': this.c_user.id
    //       })
    //       .then((response) => {
    //         // console.log('saveField THEN')
    //         // console.log(this.f_field.name)
    //         this.$emit('showSnackbar', 'Saved ' + this.f_field.name)
    //         this.progress = false
    //         this.isEditing = false
    //         // this.$store.dispatch('addArtwork',response.data)
    //       }).catch((error) => {
    //         // console.log(error)
    //       })
    //       // this.saved = false
    //   }, 1000);
    // },
    saveField: function saveField(valueToSave, field) {
      var _this3 = this;

      console.log('//valueToSave');
      console.log(valueToSave);
      this.saving = true;
      this.$emit('showSnackbar', 'Saving ' + this.f_field.name + '… ');
      var f = '';
      if (field) {
        f = field;
      } else {
        f = this.f_field.name;
      }
      console.log('//saveField');
      console.log(f);
      setTimeout(function () {
        var url = _this3.$globals.apiserver + '/artworks/' + _this3.artwork.id + '.json';
        __WEBPACK_IMPORTED_MODULE_22_axios___default.a.put(url, {
          field_name: f,
          field_value: valueToSave,
          updated_by: _this3.c_user.id
        }).then(function (response) {
          _this3.$emit('showSnackbar', 'Saved ' + _this3.f_field.name, 'green');
          _this3.progress = false;
          if (['accession_number', 'acquired', 'acquisition_method', 'acquisition_source_id', 'artist_id', 'credit', 'fvs_channel_id', 'fvs_subtitle', 'gender', 'production_date_new, century', 'registrar_id', 'signature, not_signed', 'signature_new - signed, not_signed', 'subtitle', 'title', 'series', 'type_of_work_id', 'visa_status', 'ownership'].includes(_this3.f_field.name)) {
            _this3.updateTag(f, _this3.artwork.id, valueToSave);
          }
          _this3.$emit('getArtwork');
          _this3.saving = false;
          _this3.isEditing = false;
          // this.$store.dispatch('loadArtworks', null);
        }).catch(function (error) {
          _this3.$emit('showSnackbar', 'Error Saving  ' + _this3.f_field.name + ' - ' + error, 'red');
          _this3.progress = false;
          _this3.saving = false;
          _this3.isEditing = false;
        });
      }, 1000);
    },
    updateTag: function updateTag(field, artwork_id, value) {
      var _this4 = this;

      // console.log('updateTags')
      // var tag = value
      var url = this.$globals.apiserver + '/tags.json';
      __WEBPACK_IMPORTED_MODULE_22_axios___default.a.post(url, {
        tag: {
          name: value,
          category: field.name,
          created_by: this.c_user.id
        }
      }).then(function (response) {
        _this4.$store.dispatch('loadTags');
      }).catch(function (error) {
        // console.log(error)
      });
    },
    update_value: function update_value(value) {
      console.log('update_value');
      this.current_value = value;
      this.field_value = value;
      if (this.field_type === 'bool') {
        var val = '';
        if (this.switch_value === true) {
          val = 1;
        }
        if (this.switch_value === false) {
          val = 0;
        }
        this.field_value = val; // this.switch_value;
        this.saveField(this.field_value);
      }
      if (this.field_type === 'date') {
        this.field_value = this.switch_value;
        this.saveField(value);
      }
    },
    check_an: function check_an(value) {
      console.log('check_an');
      console.log(this.current_value);
      this.current_value = value;
      console.log(this.current_value);
      console.log('check_an');
      // this.field_value = value
      if (this.f_field.name === 'accession_number' && this.isEditing === true && value != this.f_artwork[this.f_field.name]) {
        var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
        var b = a.find(function (aa) {
          return aa.accession_number == value;
        });
        this.an_exists = b;
      } else {
        this.an_exists = false;
      }
    },
    location_name: function location_name(id) {
      if (id > 0) {
        return this.$store.state.locations.find(function (l) {
          return l.id === id;
        }).name;
      } else {
        return 'Location not found. Probably deleted from CMS.';
      }
    }
  },
  computed: {
    show_if_parent_true: function show_if_parent_true() {
      // if (this.f_field.show_on_parent_true) {
      //   return this.artwork[this.parent_conditional_field] == this.f_field.conditional_field_true_value
      // } else {
      return true;
      // }
    },
    hint: function hint() {
      var out = this.f_field.title;
      out = out + (this.f_field.hint ? ' - ' + this.f_field.hint : '');
      return out;
    },
    value2: function value2() {
      if (this.f_field.related_field) {
        return parseInt(this.f_artwork[this.f_field.related_field], 10);
      } else {
        // if (this.f_field.name !== 'paid_in_country') {
        return this.f_artwork[this.f_field.name];
        // } else {
        //   return this.f_artwork[this.f_field]
      }
    },
    value_radio: function value_radio() {
      return this.f_artwork[this.f_field.name];
    },
    dynamic_field_list: function dynamic_field_list() {
      var _this5 = this;

      if (this.f_field.headline) {
        var c = [];
        var fields2;
        if (this.report) {
          fields2 = this.fields_parent;
        } else {
          fields2 = this.fields['tabs'][this.$store.state.currentTab]['fields'];
        }
        c = fields2.filter(function (f) {
          return f.dynamic && f.section === _this5.f_field.section;
        });
        c = c.filter(function (f) {
          return f.work_types_new && f.work_types_new.includes(_this5.artwork.type_of_work_id);
        });
        return c;
      } else {
        return [];
      }
    },

    // split_date () {
    // var moment = require('moment')
    // var date = this.f_artwork[this.f_field.name]
    // var ndate = moment(this.f_artwork[this.f_field.name],'YYYY')
    // var out = [ndate.year,ndate.month,ndate.day]
    // var out = [date.getFullYear,date.getMonth,date.getDay]
    // return ndate
    // },
    // field_value () {
    //   return this.f_artwork[this.f_field.name]
    // },
    // is_field_value () {
    //   // console.log(typeof this.field_value)
    //   // console.log(this.field_value)
    //   if (this.field_value == null) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    field_type: function field_type() {
      return this.f_field.etype ? this.f_field.etype : this.f_field.ctype;
    },
    selection_items: function selection_items() {
      var _this6 = this;

      if (this.f_field.constant_selection) {
        // console.log(this.f_field.constant_selection)
        // console.log(constants)
        return __WEBPACK_IMPORTED_MODULE_23__data_constants__["a" /* default */][this.f_field.constant_selection];
      } else {
        if (this.f_field.table) {
          if (this.f_field.table === 'contacts') {
            var contacts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.contacts);
            if (this.f_field.column) {
              return contacts.filter(function (c) {
                return c[_this6.f_field.column] === _this6.f_field.association;
              }).sort(dynamicSort('name'));
            } else {
              return contacts.sort(dynamicSort('name'));
            }
          }
          if (this.f_field.table === 'languages') {
            var languages = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], __WEBPACK_IMPORTED_MODULE_23__data_constants__["a" /* default */].LANGUAGES);
            if (this.f_field.column) {
              // console.log(contacts);
              return languages.filter(function (c) {
                return c[_this6.f_field.column] === _this6.f_field.association;
              }).sort(dynamicSort('name'));
            } else {
              return languages.sort(dynamicSort('name'));
            }
          }
          if (this.f_field.table === 'countries') {
            var countries = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], __WEBPACK_IMPORTED_MODULE_23__data_constants__["a" /* default */].COUNTRIES);
            // if (this.f_field.column) {
            //   // console.log(contacts);
            //   return countries
            //     .filter(c => c[this.f_field.column] == this.f_field.association)
            //     .sort(dynamicSort("name"));
            // } else {
            return countries.map(function (c) {
              return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ id: c, name: c });
            });
            // .sort(dynamicSort("name"));
            // }
          }
          if (this.f_field.table === 'artists') {
            var artists = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
            if (this.f_field.column) {
              return artists.filter(function (c) {
                return c[_this6.f_field.column] === c[_this6.f_field.association];
              });
            } else {
              return artists.sort(dynamicSort('name'));
            }
          }
          if (this.f_field.table === 'artwork_locations') {
            // console.log(this.f_field.table)
            // console.log('this.f_field.table')
            var artworkLocations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.getters.enabled_locations);
            if (this.f_field.column) {
              return artworkLocations.filter(function (c) {
                return c[_this6.f_field.column] === c[_this6.f_field.association];
              });
            } else {
              return artworkLocations.sort(dynamicSort('name'));
            }
          }
        }
        if (this.f_field.selection && this.f_field.selection.length > 0) {
          return this.f_field.selection;
        }
      }
    },
    f_field: function f_field() {
      var f = this.field;
      f.model_string = this.field.model_string ? this.field.model_string : this.field.name;
      f.column = this.field.column ? this.field.column : false;
      // console.log(this.f_artwork[this.field.name])
      f.value_string = this.field['model_string'] ? this[this.field.model_string] : this.f_artwork[this.field.name];
      return f;
    }
  },
  components: {
    Conservation: __WEBPACK_IMPORTED_MODULE_20__components_artworks_Conservation__["a" /* default */],
    OwnershipHistory: __WEBPACK_IMPORTED_MODULE_2__components_artworks_OwnershipHistory__["a" /* default */],
    AddLocation: __WEBPACK_IMPORTED_MODULE_5__components_locations_AddLocation__["a" /* default */],
    AddArtist: __WEBPACK_IMPORTED_MODULE_4__components_artists_AddArtist__["a" /* default */],
    Costs: __WEBPACK_IMPORTED_MODULE_19__components_artworks_Costs__["a" /* default */],
    ViewArtworks: __WEBPACK_IMPORTED_MODULE_1__components_artists_ViewArtworks__["a" /* default */],
    Upload: __WEBPACK_IMPORTED_MODULE_6__components_artworks_Upload__["a" /* default */],
    Location: __WEBPACK_IMPORTED_MODULE_7__components_artworks_Location__["a" /* default */],
    Insurance: __WEBPACK_IMPORTED_MODULE_8__components_artworks_Insurance__["a" /* default */],
    MarketValueHistory: __WEBPACK_IMPORTED_MODULE_9__components_artworks_MarketValueHistory__["a" /* default */],
    Films: __WEBPACK_IMPORTED_MODULE_12__components_artworks_Films__["a" /* default */],
    Audio: __WEBPACK_IMPORTED_MODULE_13__components_artworks_Audio__["a" /* default */],
    Light: __WEBPACK_IMPORTED_MODULE_16__components_artworks_Light__["a" /* default */],
    Programme: __WEBPACK_IMPORTED_MODULE_14__components_artworks_Programme__["a" /* default */],
    InformationCarrier: __WEBPACK_IMPORTED_MODULE_15__components_artworks_InformationCarrier__["a" /* default */],
    Electrical: __WEBPACK_IMPORTED_MODULE_10__components_artworks_Electrical__["a" /* default */],
    ReadingDevices: __WEBPACK_IMPORTED_MODULE_17__components_artworks_ReadingDevices__["a" /* default */],
    Links: __WEBPACK_IMPORTED_MODULE_18__components_artworks_Links__["a" /* default */],
    NonElectrical: __WEBPACK_IMPORTED_MODULE_11__components_artworks_NonElectrical__["a" /* default */],
    LoanConditions: __WEBPACK_IMPORTED_MODULE_21__components_artworks_LoanConditions__["a" /* default */]
  }
});

/***/ }),

/***/ "cAN7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"400px"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are you sure you want to delete this Todo?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Todo "),(_vm.itemToDelete)?_c('strong',[_vm._v(_vm._s(_vm.itemToDelete.name))]):_vm._e(),_vm._v(" will\n        be deleted.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"flat"},on:{"click":_vm.cancelDelete}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"flat"},on:{"click":_vm.deleteItem}},[_vm._v("Yes")])],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mx-4 px-3 mt-2 pt-5 elevation-0"},[_c('v-card-title',{staticClass:"pl-0 my-0 py-0"},[_c('span',[_c('v-menu',{staticClass:"text-xs-right mx-4 my-0 py-0 align-center",attrs:{"offset-y":"","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-2 my-0 py-0",attrs:{"small":"","icon":"","color":"black","dark":""}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("supervisor_account")])],1)]}}])},[_vm._v(" "),_c('v-list',{attrs:{"value":"3"}},_vm._l((_vm.assignedUsers),function(item,index){return _c('v-list-tile',{key:item.id,on:{"click":function($event){return _vm.toggleUser(item.id)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.abb))])],1)}),1)],1)],1),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedUser),expression:"selectedUser"}],staticClass:"text-xs-left mt-2 pt-1 title"},[_vm._v("\n        "+_vm._s(_vm.selectedUser.abb)+"\n      ")]),_vm._v(" "),_c('v-btn-toggle',{staticClass:"mt-0 ml-0",attrs:{"small":""},model:{value:(_vm.myTodos),callback:function ($$v) {_vm.myTodos=$$v},expression:"myTodos"}},[_c('v-btn',{key:"group1",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":true,"value":true}},[_c('span',[_vm._v("My")])]),_vm._v(" "),_c('v-btn',{key:"group2",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":false,"value":false}},[_c('span',[_vm._v("All")])])],1),_vm._v(" "),_c('v-btn-toggle',{staticClass:"mt-0 ml-3",attrs:{"small":""},model:{value:(_vm.visibility),callback:function ($$v) {_vm.visibility=$$v},expression:"visibility"}},[_c('v-btn',{key:"group1",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"active","value":"active"}},[_c('span',[_vm._v("Active")])]),_vm._v(" "),_c('v-btn',{key:"group2",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"all","value":"all"}},[_c('span',[_vm._v("All")])]),_vm._v(" "),_c('v-btn',{key:"group3",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":"completed","value":"completed"}},[_c('span',[_vm._v("Done")])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.$store.state.showSearch)?_c('v-text-field',{staticClass:"mb-3",attrs:{"prepend-inner-icon":"search","label":"Search ","single-line":"","hide-details":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0",staticStyle:{"border-top":"1px solid #ccc"},attrs:{"pagination":_vm.pagination,"hide-headers":"","headers":_vm.headers,"items":_vm.filteredTodos,"search":_vm.search,"item-key":"id","must-sort":"","expand":"","rows-per-page-text":"Todos per page","no-results-text":"No Todos match the criteria."},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{staticClass:"pb-0 mb-0"},[_c('td',{staticStyle:{"padding":"0px"},attrs:{"colspan":"5"}},[_c('table',{staticStyle:{"width":"100%","margin":"0px"}},[_c('tr',{class:{
                  black: props.expanded,
                  'white--text': props.expanded,
                }},[_c('td',{staticClass:"py-0 my-0 title",attrs:{"colspan":"4"}},[_vm._v("\n                  "+_vm._s(props.item.title)+"\n                ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-xs-left",staticStyle:{"padding-top":"0px !important","padding-right":"0px !important","height":"30px","width":"30px !important"}},[_c('v-checkbox',{staticClass:"\n                      pt-1\n                      px-0\n                      mx-0\n                      align-start\n                      justify-start\n                      row\n                      fill-height\n                    ",attrs:{"color":"black","hide-details":""},on:{"change":function($event){return _vm.done_todo(props.item)}},model:{value:(props.item.done),callback:function ($$v) {_vm.$set(props.item, "done", $$v)},expression:"props.item.done"}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left",staticStyle:{"padding-top":"0px !important","height":"30px"}},[(props.item.artwork)?_c('b',[_vm._v(_vm._s(props.item.artwork.title))]):_vm._e(),_vm._v(",\n                  "),(props.item.artwork)?_c('span',[_vm._v(_vm._s(props.item.artwork.accession_number))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"width":"130px","padding-top":"0px !important","height":"30px"}},[_c('span',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.format_date(props.item.created_at)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-center",staticStyle:{"width":"50px","padding-top":"0px !important","height":"30px"}},[(props.item.created_by && props.item.created_by > 0)?_c('span',[_vm._v(_vm._s(_vm.get_abb(props.item.created_by)))]):_c('span',{staticClass:"px-1"},[_vm._v(" – ")])])])])]),_vm._v(" "),_c('td',{staticClass:"text-xs-right pt-1",staticStyle:{"width":"20px","padding-top":"0px !important","height":"30px"}},[(_vm.c_user.edit || _vm.c_user.delete_rights)?_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.delete_todo(props.item)}}},[_c('v-icon',{attrs:{"color":"red","small":""}},[_vm._v("delete")])],1):_vm._e()],1)])]}}])},[_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Your search for \""+_vm._s(_vm.search)+"\" found no results.\n      ")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "cBl8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.items && _vm.items.length>0)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-list',{staticClass:"xs12 mt-0 pt-0",attrs:{"two-line":""}},[_vm._l((_vm.items),function(e,index){return [_c('v-list-tile',{key:e.id},[(_vm.icons)?_c('v-list-tile-avatar',{key:("icon_" + (e.id))},[(e.category=='monitor')?_c('v-icon',[_vm._v("mdi-monitor")]):_vm._e(),_vm._v(" "),(e.category=='projector')?_c('v-icon',[_vm._v("mdi-projector")]):_vm._e(),_vm._v(" "),(e.category=='motor')?_c('v-icon',[_vm._v("mdi-engine")]):_vm._e(),_vm._v(" "),(e.category=='bulb')?_c('v-icon',[_vm._v("mdi-lightbulb")]):_vm._e(),_vm._v(" "),(e.category=='switch')?_c('v-icon',[_vm._v("mdi-nintendo-switch")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',{key:("title_" + (e.id))},[_c('v-list-tile-title',[_vm._v(_vm._s(e.brand)+" "+_vm._s(e.title)+" "+_vm._s(e.type))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(e.category)+" "+_vm._s(e.brand)+" "+_vm._s(_vm.category(e)))])],1)],1),_vm._v(" "),(index+1 < _vm.items.length)?_c('v-divider',{key:("div" + (e.id))}):_vm._e()]})],2)],1):_vm._e(),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showUpload),expression:"!showUpload"}],staticClass:"mr-0 mt-0 mb-0 xs12"},[_c('v-btn',{staticClass:"right elevation-0",attrs:{"small":""},on:{"click":function($event){return _vm.showUploadForm()}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("add")]),_vm._v(" Add new "+_vm._s(_vm.title))],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are you sure you want to delete this device?")]),_vm._v(" "),_c('v-card-text',[_vm._v(" This "+_vm._s(_vm.title)+" will be deleted. ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1"},on:{"click":function($event){_vm.dialog=false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1"},on:{"click":function($event){return _vm.deleteItem(_vm.deletingItem)}}},[_vm._v(" Yes")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "cEmV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__ = __webpack_require__("qczp");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d9547b4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__ = __webpack_require__("4PWi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("YSSe")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7d9547b4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contacts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d9547b4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d9547b4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Contacts_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cazW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewContact_vue__ = __webpack_require__("2VO/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0419e1c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewContact_vue__ = __webpack_require__("M8Lx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("PGjU")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0419e1c6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewContact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0419e1c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewContact_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0419e1c6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewContact_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "chLi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tags_vue__ = __webpack_require__("+nr0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f9eb86_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tags_vue__ = __webpack_require__("WV97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("FbSb")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14f9eb86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tags_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f9eb86_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tags_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14f9eb86_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tags_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ckKv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddText_vue__ = __webpack_require__("rczA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224366de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddText_vue__ = __webpack_require__("i0Bb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("ZjmU")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-224366de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224366de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddText_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_224366de_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddText_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cq8u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "csSS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d0Kb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.f_field.headline)?_c('div',{staticClass:"mt-2 pt-0 mb-1"},[_c('v-flex',{staticClass:"px-2 py-0 xs12",staticStyle:{"background-color":"#292929","color":"#ddd","line-height":"30px"}},[_c('h3',{staticClass:"font-weight-bold body-2 xs12 flex"},[_vm._v("\n        "+_vm._s(_vm.f_field.title)+"\n      ")])])],1):(_vm.f_field.subheadline)?_c('div',{staticClass:"mt-2 mb-1"},[_c('v-flex',{staticClass:"px-2 pb-0 xs12"},[_c('h3',{staticClass:"xs12 flex"},[_vm._v("\n        "+_vm._s(_vm.f_field.title)+"\n      ")])])],1):_vm._e(),_vm._v(" "),(
      _vm.f_field.component &&
        ([
          'deaccession_date',
          'comment_on_deaccession',
          'new_ownership',
          'deaccession_price_offer',
          'deaccession_price_paid',
          'invoice_deaccession_papers'
        ].includes(_vm.f_field.name)
          ? _vm.f_artwork.deaccessioned == 1
          : true)
    )?_c('div',{staticClass:"mt-2 mb-2 mx-0"},[_c(_vm.f_field.component,{tag:"component",attrs:{"uploadCategory":_vm.f_field.title,"artwork":_vm.f_artwork,"name":_vm.f_field.name,"field":_vm.f_field,"film":_vm.film}})],1):(_vm.f_artwork[_vm.f_field.name])?_c('div',{staticClass:"mt-0 py-0 mb-1 pl-2"},[(_vm.field_type == 'text-short')?_c('v-flex',[_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.f_artwork[_vm.f_field.name])+_vm._s(_vm.f_field.suffix))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v(_vm._s(_vm.f_field.title))])])],1):_vm._e(),_vm._v(" "),(_vm.field_type == 'currency')?_c('v-flex',{attrs:{"xs12":"","d-flex":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('code',[_vm._v(_vm._s(_vm.f_artwork[_vm.f_field.name])+" "+_vm._s(_vm.f_artwork[((_vm.f_field.name) + "_currency")]))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.hint))])])],1):(this.field_type == 'text-long')?_c('v-flex',[_c('code',{staticStyle:{"vertical-align":"bottom"}},[_vm._v(_vm._s(_vm.f_artwork[_vm.f_field.name].trim())+" "+_vm._s(_vm.f_artwork[((_vm.f_field.name) + "_currency")]))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.f_field.title))])]):(this.field_type == 'date')?_c('v-flex',{attrs:{"xs12":""}},[_c('code',[_vm._v(_vm._s(_vm.f_artwork[_vm.f_field.name])+" ")]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),(_vm.f_field.title == '')?_c('label',[_vm._v(_vm._s(_vm.label))]):_vm._e()]):(this.field_type == 'bool')?_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.f_artwork[_vm.f_field.name] ? 'Yes' : 'No'))]),_vm._v(" "),_c('label',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.f_field.title))])]):(this.field_type == 'radio')?_c('v-flex',[_c('v-radio-group',{attrs:{"label":("" + (_vm.f_field.title)),"column":_vm.f_field.column ? _vm.f_field.column : false,"value":_vm.value_radio,"refs":_vm.f_field.name}},_vm._l((_vm.f_field.selection),function(s){return _c('v-radio',{key:s.id ? s.id : s,staticClass:"ml-3",attrs:{"label":s.name ? s.name : s,"value":s.value ? s.value : s}})}),1),_vm._v(" "),_c('label',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v("\n      "+_vm._s(_vm.f_field.selection[_vm.value_radio])+"\n\n      "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',{staticClass:"xs12 elevation-3 py-3 px-3"},[_c('v-flex',{attrs:{"c":""}},[_vm._v("\n          Audio Codec\n          "),_c('code',[_vm._v(_vm._s(_vm.film.audio_codec))])]),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('v-label',[_vm._v("Audio Resolution")])],1):_vm._e(),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('v-label',[_vm._v("Audio Bit")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.film.audio_bit)+" ")])],1):_vm._e(),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('label',[_vm._v("Channels")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.channels[_vm.id]))])]):_vm._e(),_vm._v(" "),(_vm.f_field.name == 'sound' && this.value_new == '1')?_c('v-flex',[_c('label',[_vm._v("Audio Specs")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.f_artwork.sound))])]):_vm._e()],1):_vm._e()],1):(this.field_type == 'checkbox')?_c('v-flex',[_c('v-flex',[_c('label',{staticClass:"sub-headline mt-3 ml-3"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_vm._l((_vm.f_field.selection),function(s){return _c('v-checkbox',{key:s.id ? s.id : s,staticClass:"left mr-3 ml-3",attrs:{"hide-details":"","label":s.name ? s.name : s,"disabled":"","refs":_vm.f_field.name}},[_vm._v(_vm._s(s.name ? s.name : s))])})],2)],1):(this.field_type == 'toggle')?_c('v-flex',[_c('v-flex',{staticClass:"pt-0",attrs:{"xs12":"","sm6":""}},[_c('code',[_vm._v(_vm._s(_vm.toggle_value))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.f_field.title))])])],1):(_vm.f_field.etype === 'select')?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.select_item))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),(
            _vm.f_field.name == 'classification_new_id' &&
              this.select_value == 'film'
          )?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Select Film Type","row":""},model:{value:(_vm.film.film_type),callback:function ($$v) {_vm.$set(_vm.film, "film_type", $$v)},expression:"film.film_type"}},_vm._l((['tape', 'film', 'digital born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e(),_vm._v(" "),(
            _vm.f_field.name == 'classification_new_id' &&
              this.select_value == 'inst'
          )?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-flex',{staticClass:"subheadline mt-4"},[_vm._v("Includes")]),_vm._v(" "),_vm._l(([
                'Objects',
                'Sound',
                'FilmVideoAV',
                'Slide',
                'Computer Program / Software / File',
                'Performance',
                'Light',
                'Other'
              ]),function(s){return _c('v-checkbox',{key:s,attrs:{"label":s,"value":s,"hide-details":"","xs12":"","md6":"","lg4":""},model:{value:(_vm.instalation_includes),callback:function ($$v) {_vm.instalation_includes=$$v},expression:"instalation_includes"}})})],2),_vm._v(" "),(this.instalation_includes.indexOf('FilmVideoAV') >= 0)?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-radio-group',{attrs:{"label":"Select Film Type","row":""},model:{value:(_vm.film.film_type),callback:function ($$v) {_vm.$set(_vm.film, "film_type", $$v)},expression:"film.film_type"}},_vm._l((['tape', 'film', 'digital born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e(),_vm._v(" "),(this.instalation_includes.indexOf('Other') >= 0)?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-text-field',{staticClass:"ml-3",attrs:{"name":"including_other","label":"Other","row":""},model:{value:(_vm.film.film_type),callback:function ($$v) {_vm.$set(_vm.film, "film_type", $$v)},expression:"film.film_type"}})],1):_vm._e()],1):_vm._e()],1)],1):(_vm.f_field.etype === 'autocomplete')?_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.select_item))]),_vm._v(" "),_c('label',[_vm._v(_vm._s(_vm.f_field.title))])]):_vm._e()],1):_vm._e()])}
var staticRenderFns = []


/***/ }),

/***/ "dEZz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldBox__ = __webpack_require__("1wRZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_artists_ViewArtworks_vue__ = __webpack_require__("eZui");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_artists_MultiArtist_vue__ = __webpack_require__("RKLh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      result: '',
      currentTab: this.$store.state.currentTabArtist
      // artwork: '',
      // artist: ''
    };
  },

  props: ['field', 'artist', 'artwork'],
  // components: {HeaderArtist},
  beforeMount: function beforeMount() {
    // console.log(this.$route.params.artist)
    this.result = this.$route.params.artist;
    this.getArtist();
  },

  // updated () {
  //   this.getArtist()
  // },
  // beforeRouteEnter (to, from, next) {
  // getPost(to.params.id, (err, post) => {
  // next(vm => vm.getArtist())
  // console.log('beforeRouteEnter')
  // })
  // },
  methods: {
    saveCurrentTab: function saveCurrentTab(tab) {
      this.$store.dispatch("saveCurrentTabArtist", tab);
    },
    getArtist: function getArtist() {
      var _this = this;

      // console.log('getArtist')
      var url = this.$globals.apiserver + '/artists/' + this.$route.params.id + '.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (response) {
        // this.loading = false;
        _this.result = response.data;
        // this.artwork = response.data
        // this.artist = response.data.artist
        // console.log(this.artist)
        // console.log(this.artwork)
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  computed: {
    processedArtist: function processedArtist() {
      var processedArtist = this.result;
      // this.artwork.map(artwork => {
      //   let a = artwork
      //   artwork.first_name = a ? a.first_name : 'nema meno'
      // })
      // console.log(processedArtist)
      return processedArtist;
    }
  },
  components: { FieldBox: __WEBPACK_IMPORTED_MODULE_0__FieldBox__["a" /* default */], ViewArtworks: __WEBPACK_IMPORTED_MODULE_3__components_artists_ViewArtworks_vue__["a" /* default */], MultiArtist: __WEBPACK_IMPORTED_MODULE_4__components_artists_MultiArtist_vue__["a" /* default */] }
});

/***/ }),

/***/ "dGlE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lists_Labels__ = __webpack_require__("RVzw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lists_LabelsSmall__ = __webpack_require__("VwPy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lists_LabelsSmallText__ = __webpack_require__("6gSs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_artworks_Excel__ = __webpack_require__("mLuL");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        light: Boolean,
        small: Boolean,
        item: Object,
        ids: Boolean,
        useCurrentSelection: Boolean
    },
    data: function data() {
        return {};
    },
    computed: {
        varid: function varid() {
            if (!isNaN(this.item)) {
                return this.item;
            } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.item) === 'object') {
                return this.item.id;
            } else {
                return 'a';
            }
        },

        // labelId() { 
        //     return `label${id}`
        // }
        itemsFromObjects: function itemsFromObjects() {
            // console.log('itemsFromObjects111')
            // console.log(this.useCurrentSelection)
            // console.log(this.small)
            // console.log(this.ids)
            // console.log(this.item)
            // console.log(this.$store.state.currentSelection)
            var item = [];
            // item.artworks = []
            if (this.useCurrentSelection) {
                item = this.$store.state.currentSelection;
                // item.artworks = this.ids2o(this.item)
            } else {
                if (this.ids) {
                    if (this.item.artworks) {
                        item = this.ids2o(this.item.artworks);
                        // } else {
                        // item = this.item.map(i => i.id)
                    } else {
                        console.error('no data in itemsFromObjects item prop');
                    }
                } else {
                    if (isNaN(this.item.artworks[0])) {
                        item = this.item.artworks;
                    } else {
                        item = this.ids2o(this.item.artworks);
                        // console.error('no data in itemsFromObjects item prop')
                    }
                }
            }
            // console.log(item)
            // console.log('itemsFromObjects2223s')
            return item;
        },
        itemsFromIds: function itemsFromIds() {
            // console.log('itemsFromIds112')
            // console.log(this.useCurrentSelection)
            // console.log(this.small)
            // console.log(this.ids)
            // console.log(this.item)
            // console.log(this.$store.state.currentSelection)
            var item = {};
            item.artworks = [];
            if (this.useCurrentSelection) {
                item.artworks = this.ids2o(this.$store.state.currentSelection);
                // item.artworks = this.ids2o(this.item)
            } else {
                if (this.ids) {
                    if (this.item.artworks) {
                        item = this.item;
                    } else {
                        item.artworks = this.item.map(function (i) {
                            return i.id;
                        });
                    }
                } else {
                    item = this.item;
                }
            }
            // console.log(item)
            // console.log('itemsFromIds2')
            return item;
        }
    },
    components: {
        LabelsSmallText: __WEBPACK_IMPORTED_MODULE_3__lists_LabelsSmallText__["a" /* default */], Labels: __WEBPACK_IMPORTED_MODULE_1__lists_Labels__["a" /* default */], LabelsSmall: __WEBPACK_IMPORTED_MODULE_2__lists_LabelsSmall__["a" /* default */], Excel: __WEBPACK_IMPORTED_MODULE_4__components_artworks_Excel__["a" /* default */]
    }
});

/***/ }),

/***/ "dpcb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Links_vue__ = __webpack_require__("xAzJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f12cf84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Links_vue__ = __webpack_require__("JTfk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("kMiU")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9f12cf84"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Links_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f12cf84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Links_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f12cf84_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Links_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e4A6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__ = __webpack_require__("/ZRI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8bbcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__ = __webpack_require__("79ZT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("pdpo")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0a8bbcc1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8bbcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a8bbcc1_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Upload_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "e9Of":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mt-4 mx-4 elevation-0"},[_c('v-card-title',{staticClass:"pl-4 pt-3"}),_vm._v(" "),_c('index-table')],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "eA6M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// function ids2o (array) {
//   var objs = Object.assign([], this.$store.state.artists)
//   var out = objs.filter(a => {
//     // console.log(array.includes(a.id))
//     return (array.includes(a.id))
//   })
//   return out
// }

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['field', 'artist', 'artwork'],
  data: function data() {
    return {
      multi_artists: [],
      artists: this.$store.state.artists,
      f_artist: this.artist

    };
  },
  methods: {
    ids2o: function ids2o(array) {
      // console.log(array)
      if (array.length > 0) {
        var objs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
        var out = objs.filter(function (a) {
          // console.log(array.includes(a.id))
          return array.includes(a.id);
        });
        // console.log(out)
        return out;
      }
    }
  }
});

/***/ }),

/***/ "eGOg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("bnwI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_baa8497c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("R5aN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("giHm")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-baa8497c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_baa8497c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_baa8497c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eP6s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditField__ = __webpack_require__("b7zL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeaderElements__ = __webpack_require__("oiZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_languages__ = __webpack_require__("r1I/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElementsTable__ = __webpack_require__("vCKh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var show_field = function show_field(field, film) {
  if (field.condition && film) {
    // return true
    //   var a = f.condition
    // console.log(film)
    // console.log(field.condition)
    //   return eval(a)
    var theInstructions = field.condition;
    var F = function F(theInstructions) {};
    return F();
  } else {
    return true;
  }
};
// function show_field(field, film) {
//   // console.log(field)
//   // console.log(film)
//   if (field.condition && film) {
//     // return true
//     //   var a = f.condition
//     //   // console.log(a)
//     //   return eval(a)
//     var theInstructions = field.condition;
//     var F = new Function (theInstructions);
//     return(F());
//   } else {
//     return true
//   }
//   // return Function('"use strict";return ("alert()")')()
// };




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork', 'film'],
  data: function data() {
    return {
      films: [
        // { id:1, title: 'Film 1', duration_min: '12 min', duration_timecode: '00:12:00:00'},
        // { id:2, title: 'Film 2', duration_min: '12 min', duration_timecode: '00:12:00:00'},
        // { id:3, title: 'Film 3', duration_min: '12 min', duration_timecode: '00:12:00:00'},
        // { id:4, title: 'Film 4', duration_min: '12 min', duration_timecode: '00:12:00:00'},
      ],
      showUpload: false,
      show: false,
      // film: {
      //   status: '',
      //   film_type: '',
      //   duration_min: '',
      //   duration_timecode: '',
      //   title: '',
      //   definition: '',
      //   color: '',
      //   sound: '',
      //   loop: '',
      //   language: '',
      //   subtitles: '',
      //   norm: '',
      //   aspect_ratio: '',
      //   fps: '',
      //   scan_type: '',
      //   vbr: '',
      //   file_size: '',
      //   audio: '',
      //   date_of_creation: '',
      //   format_migration_story: '',
      //   film_controlling_master: '',
      //   film_controlling_archive_submaster: '',
      //   operator: '',
      //   controlling_date: '',
      //   controlling_software_2: '',
      //   controlling_software_1: '',
      //   operating_system: '',
      //   controlling_computer_2: '',
      //   controlling_computer_1: '',
      //   controling_device: '',
      //   format_migration_story: '',
      //   creation_date: ''
      // },
      fields: [
      // {
      //   'ctype': 'radio',
      //   'selection': [{id: 1, name: 'monitor'},{id:2, name:'projector'},{id:3, name:'motor'}, {id:4, name:'bulb'}, {id:5, name:'switch'}],
      //   'name': 'category',
      //   'title': 'Category',
      //   column: false,
      //   class: 'xs12',
      //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
      //   user_groups: ['admin', 'manager']
      // },
      {
        'ctype': 'radio',
        'selection': [{ id: 1, name: 'Master' }, { id: 2, name: 'Archive Submaster' }, { id: 3, name: 'Master Physical' }, { id: 4, name: 'Archival Copy' }, { id: 5, name: 'Access Copy' }, { id: 6, name: 'Other' }],
        'name': 'film.status',
        'title': 'Status',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'selection': [{ id: 1, name: 'High' }, { id: 2, name: 'Standard' }],
        'name': 'definition',
        'title': 'Definition',
        column: true,
        class: 'xs12 md4',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'selection': [{ id: 1, name: 'Color' }, { id: 2, name: 'B/W' }, { id: 3, name: 'Color & B/W' }, { id: 4, name: 'Other' }],
        'name': 'color',
        'title': 'Color',
        column: true,
        class: 'xs12 md4',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'name': 'norm',
        'title': 'Norm',
        selection: [{ id: 1, name: 'PAL' }, { id: 2, name: 'NTSC' }, { id: 3, name: 'NTSC 4,43' }, { id: 4, name: 'SECAM' }],
        column: true,
        class: 'xs12 md4',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'selection': [{ id: 1, name: '4:3' }, { id: 2, name: '4:3 anamorphic' }, { id: 3, name: '16:9' }, { id: 4, name: 'IMAX' }, { id: 5, name: 'HD 720 (1280 x 720)' }, { id: 6, name: 'HD 1080 (1920x1080)' }, { id: 7, name: '2K (2048x1080)' }, { id: 8, name: 'Other' }],
        'name': 'aspect_ratio',
        'title': 'Aspect Ratio',
        column: true,
        class: 'xs12 md4',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'selection': [{ id: 1, name: 'Progressive' }, { id: 2, name: 'Interlaced' }],
        'name': 'scan_type',
        'title': 'Scan type',
        column: true,
        class: 'xs12 md4',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'selection': [{ id: 1, name: '24' }, { id: 2, name: '25' }, { id: 3, name: '23,97' }, { id: 4, name: '29,97' }, { id: 5, name: '50' }, { id: 6, name: '60' }],
        'name': 'fps',
        'title': 'FPS',
        column: true,
        class: 'xs12 md4',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'bool',
        'name': 'loop',
        'title': 'Loop',
        column: true,
        class: 'xs4 md6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'selection': [{ id: 1, name: 'Sound' }, { id: 2, name: 'No Sound' }],
        'name': 'sound',
        'title': 'Sound',
        column: true,
        class: 'xs12 md4',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'etype': 'autocomplete',
        'selection': __WEBPACK_IMPORTED_MODULE_2__data_languages__["a" /* default */],
        'name': 'language',
        'title': 'Language',
        chips: true,
        multiple: true,
        column: true,
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'bool',
        'name': 'subtitles',
        'title': 'Subtitles',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'vbr',
        'title': 'Video Bit Rate in Mbps',
        column: true,
        suffix: 'Mbps',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'filesize',
        'title': 'File Size',
        column: true,
        suffix: 'MB',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'audio',
        'title': 'Audio',
        column: true,
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'creation_date',
        'title': 'Date of Creation',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-long',
        'selection': [{ id: 1, name: 'Master' }, { id: 2, name: 'Archive Submaster' }, { id: 3, name: 'Master Physical' }, { id: 4, name: 'Archival Copy' }, { id: 5, name: 'Access Copy' }, { id: 6, name: 'Other' }],
        'name': 'format_migration_story',
        'title': 'Format Migration Story (Associated information carriers)',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        name: 'headline_conservation',
        headline: true,
        no_dynamic: true,
        title: 'Conservation',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'controling_device',
        'title': 'Controling Device',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'controlling_computer_1',
        'title': 'Controlling Computer I',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'controlling_computer_2',
        'title': 'Controlling Computer II',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'operating_system',
        'title': 'Operating System',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'controlling_software_1',
        'title': 'Controlling Software I',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'controlling_software_2',
        'title': 'Controlling Software II',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'controlling_date',
        'title': 'Controling Date',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'operator',
        'title': 'Operator',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }],
      fields_tape: [{
        'ctype': 'text-short',
        'name': 'player_interface_out',
        'title': 'Player | Interface Out',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'sync_generator',
        'title': 'Sync Generator',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'time_based_corrector_interface_out',
        'title': 'Time Based Corrector | Interface out',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'capture_hardware',
        'title': 'Capture Hardware',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'capture_computer',
        'title': 'Capture  Computer',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'operating_system',
        'title': 'Operating System',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'capture_software',
        'title': 'Capture Software',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'editing_software',
        'title': 'Editing Software',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'encoder',
        'title': 'Encoder',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'capture_software',
        'title': 'Control Date',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'operator',
        'title': 'Operator',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }]
    };
  },
  methods: {
    set_input: function set_input(f) {
      film[f] = f;
    },
    download: function download() {},
    add: function add() {
      this.films.push(this.film);
      this.showUpload = !this.showUpload;
    },
    delete_film: function delete_film() {},
    done_film: function done_film() {},
    show_field_c: function show_field_c(field) {
      // console.log(this.film)
      return show_field(field, this.film);
    }
  },
  computed: {},
  components: {
    EditField: __WEBPACK_IMPORTED_MODULE_0__EditField__["a" /* default */], HeaderElements: __WEBPACK_IMPORTED_MODULE_1__HeaderElements__["a" /* default */], ElementsTable: __WEBPACK_IMPORTED_MODULE_3__ElementsTable__["a" /* default */]
  }
});

/***/ }),

/***/ "eZui":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewArtworks_vue__ = __webpack_require__("KVRz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44aadf9b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewArtworks_vue__ = __webpack_require__("Ik33");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Nl7g")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44aadf9b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewArtworks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44aadf9b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewArtworks_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44aadf9b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewArtworks_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "efMv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":"","mx-3":""}},[_c('v-flex',{staticClass:"mb-3 row  px-3 py-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#ddd"}},[_c('span',{staticClass:"font-weight-bold left subheading"},[_vm._v("Exhibition History  ")])]),_vm._v(" "),(this.exhibitions)?_c('v-container',{staticClass:"xs12 pl-0 ml-0",attrs:{"fluid":"","grid-list-xs":""}},[(_vm.view=='advanced' && this.advanced_years.length>0)?_c('v-data-iterator',{attrs:{"items":this.advanced_years,"content-tag":"v-layout","row":"","wrap":"","hide-actions":"","item-key":"id","item-value":"id"},scopedSlots:_vm._u([{key:"item",fn:function(props){return _c('v-flex',{attrs:{"xs12":"","py-3":""}},[_c('h3',{staticClass:"mx-2 pb-0"},[_vm._v(_vm._s(props.item))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticClass:"px-0 mx-0",attrs:{"xs12":""}},[_c('v-divider',{staticClass:"mx-1 pb-0 mb-3 black"})],1),_vm._v(" "),_vm._l((_vm.exhibitions.filter(function (a) { return a.duration_start_year == props.item })),function(e){return _c('v-flex',{key:e.id},[_c('v-card',{staticClass:"elevation-0",attrs:{"color":"grey lighten-3"}},[_c('v-card-title',{staticClass:"ml-0 pl-2"},[_c('h4',{staticClass:"ml-0 pl-0"},[_vm._v(_vm._s(e.show_type == 0 ? "Solo show" : "Group show")+": "+_vm._s(e.title))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("\n                    "+_vm._s(_vm.get_contact(e.institution_id))+", "+_vm._s(e.city)+", "+_vm._s(e.country)+" "),_c('br'),_vm._v("\n                    "+_vm._s(_vm.full_date(e))+" \n                  ")])],1)],1)],1)],1)})],2)}}],null,false,20958585)}):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"540"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are you sure you want to delete this exhibition?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n            This Exhibition will be deleted from all artworks.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.deleteExhibition}},[_vm._v(" Yes")])],1)],1)],1)],1),_vm._v(" "),(_vm.show_form)?_c('new-exhibition-history',{on:{"show_form":function($event){_vm.show_form=$event}}}):_vm._e(),_vm._v(" "),(this.exhibitions.length==0)?_c('h3',{staticClass:"pl-4"},[_vm._v("No Exhibitions for this artwork yet.")]):_vm._e(),_vm._v(" "),(this.exhibitions)?_c('v-container',{staticClass:"xs12",attrs:{"fluid":"","grid-list-md":""}}):_vm._e()],1),_vm._v(" "),([12,15,16].includes(this.artwork.ownership))?_c('v-container',{staticClass:"my-0 mx-0 px-0 py-0",attrs:{"fluid":""}},[_c('v-layout',{staticClass:"my-0 mx-2 px-0 py-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mb-3 row  px-3 py-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#ddd"}},[_c('span',{staticClass:"font-weight-bold left subheading"},[_vm._v("Exhibition History Vernon")])]),_vm._v(" "),_c('v-card',{staticClass:"my-2 mx-2 elevation-0",staticStyle:{"width":"100%"}},[(!_vm.edit_bio_dialog)?_c('v-card-text',{domProps:{"innerHTML":_vm._s(this.artwork.exhibition_history != null ? this.artwork.exhibition_history : 'No exhibition history')}}):_vm._e()],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "ejqX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-5 mx-3"},[_c('v-snackbar',{attrs:{"auto-height":"","right":"","top":"","timeout":_vm.timeout,"vertical":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    User saved.\n  ")]),_vm._v(" "),(_vm.c_user.edit && _vm.add_new)?_c('v-card',{staticClass:"black"},[_c('v-flex',[_c('v-form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();}}},[_c('v-layout',{attrs:{"pa-3":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","pr-3":""}},[_c('v-text-field',{attrs:{"autocomplete":"off","readonly":"","onfocus":"this.removeAttribute('readonly');","hide-details":"","label":"login","solo":""},model:{value:(_vm.new_user.login),callback:function ($$v) {_vm.$set(_vm.new_user, "login", $$v)},expression:"new_user.login"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{staticClass:"input-group",attrs:{"autocomplete":"off","readonly":"","onfocus":"this.removeAttribute('readonly');","hide-details":"","label":"Password","type":"password","solo":""},model:{value:(_vm.new_user.password),callback:function ($$v) {_vm.$set(_vm.new_user, "password", $$v)},expression:"new_user.password"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":"","mt-1":"","ml-3":""}},[_c('v-btn',{attrs:{"outline":"","color":"white","disabled":!(_vm.new_user.login.length > 0 && _vm.new_user.password.length > 0)},on:{"click":_vm.create_user}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","color":"white"},on:{"click":function($event){_vm.add_new = false}}},[_vm._v("Cancel")])],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"elevation-0 mt-5 pt-4 mx-3"},[(this.$store.state.showSearch)?_c('v-layout',{attrs:{"xs12":"","mr-4":"","right":"","row":""}},[_c('v-flex',{attrs:{"mt-2":""}},[_c('v-checkbox',{staticClass:"pt-4",attrs:{"label":"Show Disabled","value":"0","color":"black"},model:{value:(_vm.show_disabled),callback:function ($$v) {_vm.show_disabled=$$v},expression:"show_disabled"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"ma-4":"","pl-5":""}},[_c('v-text-field',{attrs:{"append-icon":"search","clearable":"","label":"Search ","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0 px-0 mt-3 mx-0",attrs:{"headers":_vm.headers,"items":_vm.table_users,"search":_vm.search,"item-key":"id","must-sort":"","rows-per-page-text":"Users per page:","rows-per-page":"10","no-results-text":"No users match the search text.","rows-per-page-items":[
        10,
        20,
        { text: '$vuetify.dataIterator.rowsPerPageAll', value: -1 } ]},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{style:(props.item.roles.length > 0 ? 'border-bottom:none;' : '')},[_c('td',{staticClass:"title ml-0 pl-3"},[_c('router-link',{staticClass:"text-xs-left",attrs:{"to":{
                name: 'EditUser',
                params: { id: props.item.id, user: props.item },
                path: ("/users/edit/" + (props.item.id)),
              }}},[_c('span',{class:{ 'red--text': props.item.enable === 'N' }},[_vm._v(_vm._s(props.item.firstname)+" "+_vm._s(props.item.lastname)+"\n              ")])])],1),_vm._v(" "),_c('td',{},[_c('router-link',{staticClass:"text-xs-left",attrs:{"to":{
                name: 'EditUser',
                params: { id: props.item.id, user: props.item },
                path: ("/users/edit/" + (props.item.id)),
              }}},[_c('span',{class:{ 'red--text': props.item.enable === 'N' }},[_vm._v(_vm._s(props.item.login))])])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('a',{attrs:{"href":("mailto: " + (props.item.email))}},[_vm._v(_vm._s(props.item.email))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.abb))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right pr-0 mr-0"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","alt":props.item.edit == 1
                      ? 'User can Edit data'
                      : 'User can\'t Edit data'},on:{"click":function($event){return _vm.toggleAdmin(props.item)}}},on),[_c('v-icon',{attrs:{"small":"","color":props.item.edit == 1 ? 'yellow' : 'black'}},[_vm._v("star")])],1)]}}],null,true)},[_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(
                  props.item.edit == 1
                    ? 'User can Edit data'
                    : 'User can\'t Edit data'
                )}})]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                var on = ref.on;
return [(props.item.roles.length != _vm.$store.state.roles.length)?_c('v-btn',_vm._g({attrs:{"icon":"","alt":"Add all rights to User"},on:{"click":function($event){return _vm.addAllRights(props.item)}}},on),[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("mdi-key-outline")])],1):_vm._e()]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Add all rights to User")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                var on = ref.on;
return [(
                    props.item.roles.length > 0 &&
                    props.item.roles.length === _vm.$store.state.roles.length
                  )?_c('v-btn',_vm._g({attrs:{"icon":"","alt":"Add all rights to User"},on:{"click":function($event){return _vm.removeAllRights(props.item)}}},on),[_c('v-icon',{attrs:{"small":"","color":"yellow"}},[_vm._v("mdi-key-outline")])],1):_vm._e()]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Add all rights to User")])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                  var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","alt":"Inverse Delete Rights"},on:{"click":function($event){return _vm.inverseDeleteRights(props.item)}}},on),[_c('v-icon',{attrs:{"small":"","color":props.item.delete_rights ? 'red' : 'black'}},[_vm._v("mdi-delete-sweep")])],1)]}}],null,true)},[_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(
                  props.item.delete_rights
                    ? 'Has Delete Rights'
                    : 'No Delete Rights'
                )}})]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","alt":"Inverse Disable"},on:{"click":function($event){return _vm.inverseDisable(props.item)}}},on),[_c('v-icon',{attrs:{"small":"","color":props.item.enable === 'Y' ? 'green' : 'red'}},[_vm._v("mdi-account-off")])],1)]}}],null,true)},[_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(props.item.enable === 'Y' ? 'Enabled' : 'Disabled')}})])],1)])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Your search for \""+_vm._s(_vm.search)+"\" found no results.\n      ")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "euaP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "evhW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldBox__ = __webpack_require__("NfPN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Images__ = __webpack_require__("lT+D");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ExhibitionHistory__ = __webpack_require__("WWEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LoanHistory__ = __webpack_require__("lKkF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tags__ = __webpack_require__("chLi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Packings__ = __webpack_require__("57cu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Todos__ = __webpack_require__("MNJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_full_user_fields__ = __webpack_require__("LKPg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fields: __WEBPACK_IMPORTED_MODULE_9__data_full_user_fields__["a" /* default */],
      result: '',
      currentTab: this.$store.state.currentTab
      // artwork: '',
      // artist: ''
    };
  },

  props: ['field', 'artist', 'artwork'],
  // components: {HeaderArtwork},
  mounted: function mounted() {
    this.getArtwork();
  },

  // updated () {
  //   this.getArtwork()
  // },
  methods: {
    saveCurrentTab: function saveCurrentTab(tab) {
      setTimeout(function () {
        this.$store.dispatch("saveCurrentTab", tab);
      }.bind(this), 1000);
    },
    getArtwork: function getArtwork() {
      var _this = this;

      var url = this.$globals.apiserver + '/artworks/' + this.$route.params.id + '.json';
      __WEBPACK_IMPORTED_MODULE_7_axios___default.a.get(url).then(function (response) {
        // this.loading = false;
        _this.result = response.data;
        // this.artwork = response.data
        // this.artist = response.data.artist
        // console.log(this.artist)
        // console.log(this.artwork)
      }).catch(function (error) {
        console.log(error);
      });
    }
  },
  computed: {
    processedArtwork: function processedArtwork() {
      // let processedArtwork = this.artwork
      // setTimeout(function () {
      var processedArtwork = this.result;
      // }.bind(this),0)

      // this.artwork.map(artwork => {
      //   let a = artwork
      //   artwork.first_name = a ? a.first_name : 'nema meno'
      // })
      // console.log(processedArtwork)
      return processedArtwork;
    },
    processedArtist: function processedArtist() {
      var processedArtist = this.result.artist;
      // let artist = this.result.artist
      // this.artist = this.result.artist
      // this.artwork.map(artwork => {
      //   let a = artwork
      //   artwork.first_name = a ? a.first_name : 'nema meno'
      // })
      // console.log(processedArtist)
      return processedArtist;
    }
  },
  components: { FieldBox: __WEBPACK_IMPORTED_MODULE_0__FieldBox__["a" /* default */], Images: __WEBPACK_IMPORTED_MODULE_1__Images__["a" /* default */], ExhibitionHistory: __WEBPACK_IMPORTED_MODULE_2__ExhibitionHistory__["a" /* default */], LoanHistory: __WEBPACK_IMPORTED_MODULE_3__LoanHistory__["a" /* default */], Packings: __WEBPACK_IMPORTED_MODULE_5__Packings__["a" /* default */], Todos: __WEBPACK_IMPORTED_MODULE_6__Todos__["a" /* default */], Tags: __WEBPACK_IMPORTED_MODULE_4__Tags__["a" /* default */] }
});

/***/ }),

/***/ "fNUv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fOOw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{staticClass:"px-2 navbar",staticStyle:{"top":"80px"},attrs:{"width":"520","temporary":"","fixed":"","right":"","hide-overlay":"","dark":""},model:{value:(_vm.options_c),callback:function ($$v) {_vm.options_c=$$v},expression:"options_c"}},[_c('v-layout',{attrs:{"row":"","pt-3":"","pb-2":""}},[_c('v-flex',[_c('v-subheader',{staticClass:"font-weight-regular display-1 white--text"},[_vm._v("\n            Options\n            "),_c('v-spacer'),_vm._v(" "),_c('a',{staticClass:"font-weight-regular display-1 white--text",on:{"click":function($event){return _vm.closeOptions()}}},[_vm._v("x")])],1),_vm._v(" "),_c('v-divider')],1)],1),_vm._v(" "),_c('tag-filter',{on:{"updateFilterTags":_vm.updateFilterTags}}),_vm._v(" "),_c('v-divider',{staticClass:"mx-3 pb-0 mb-0 white"}),_vm._v(" "),_c('v-list',[_c('v-list-tile',{staticClass:"pl-0 ml-4 white--text"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{staticClass:"white--text",on:{"click":_vm.addAllToSelection}},[_vm._v("Add all shown Artworks to Selection")])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3 pb-0 mb-0 white"}),_vm._v(" "),(this.selected.length > 0)?_c('v-list-tile',{staticClass:"pl-0 ml-4 white--text"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{staticClass:"white--text",on:{"click":_vm.clear_selection}},[_vm._v("Clear Selection")])])],1)],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{staticClass:"pl-0 ml-4 white--text"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{staticClass:"white--text",on:{"click":_vm.addFilteredToSelection}},[_vm._v("Add Search Results to Selection")])])],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3 pb-0 mb-0 white"})],1),_vm._v(" "),(_vm.show_tag_filter)?_c('v-card',{staticClass:"mt-0 mb-3 mx-4 py-0 elevation-1"},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":"","pt-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((this.$store.state.tag_categories),function(tc){return _c('v-flex',{key:tc.id,attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-checkbox',{attrs:{"small":"","label":tc.name,"value":tc.id,"color":tc.color,"hide-details":""},model:{value:(_vm.selected_tag_categories),callback:function ($$v) {_vm.selected_tag_categories=$$v},expression:"selected_tag_categories"}})],1)}),1)],1),_vm._v(" "),(this.selected_tag_categories.length > 0)?_c('v-flex',{staticClass:"mx-4",attrs:{"xs12":""}},[_c('v-select',{attrs:{"label":"Select Tags","items":_vm.select_tags,"item-text":"name","item-value":"id","multiple":"","chips":"","max-height":"auto","autocomplete":""},on:{"change":_vm.save_currently_selected_tags},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{key:JSON.stringify(data.item),staticClass:"chip--select-multi",attrs:{"close":"","selected":data.selected,"color":((data.item.color) + " lighten-5")},on:{"input":function($event){return data.parent.selectItem(data.item)}}},[(data.item.concept_tag == 1)?_c('span',{staticClass:"mx-0 px-0"},[_vm._v("★")]):_vm._e(),_vm._v(_vm._s(data.item.name))])]}},{key:"item",fn:function(data){return [(typeof data.item !== 'object')?[_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item)}})]:[_c('v-list-tile-avatar',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"color":data.item.color}},[_vm._v("people")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(data.item.name)}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(data.item.group)}})],1)]]}}],null,false,3133769667),model:{value:(_vm.selected_tags),callback:function ($$v) {_vm.selected_tags=$$v},expression:"selected_tags"}})],1):_vm._e()],1),_vm._v(" "),_c('v-card-title',{staticClass:"mt-0",attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v(" "),(_vm.selected_tag_categories.length > 0)?_c('v-btn',{attrs:{"right":""},on:{"click":_vm.clearFilters}},[_vm._v("Reset Filters")]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"},on:{"beforeLeave":_vm.beforeLeave,"enter":_vm.enter,"afterEnter":_vm.afterEnter}},[(_vm.showTags && this.selected.length > 1)?_c('div',{staticClass:"mx-2 mt-0 dark"},[_c('v-layout',{staticClass:"mx-3 pa-4 mb-5",attrs:{"column":"","elevation-1":""}},[(_vm.save_tag_form_display == true)?_c('v-flex',{staticStyle:{"background-color":"#f3fff5"},attrs:{"pb-3":"","px-3":"","pt-0":""}},[_c('div',{staticClass:"green--text text--darken-1 headline pl-3 mt-4"},[_vm._v("\n              Add a New Tag\n            ")]),_vm._v(" "),_c('v-flex',{attrs:{"mx-2":"","mb-0":""}},[_c('v-layout',{attrs:{"row":"","mt-4":""}},[_c('v-flex',{attrs:{"xs12":"","mx-2":""}},[_c('v-text-field',{staticClass:"input-group",attrs:{"box":"","label":"Tag Title"},model:{value:(_vm.tag_title),callback:function ($$v) {_vm.tag_title=$$v},expression:"tag_title"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"mt-3":"","right":""}},[_c('v-btn',{attrs:{"color":"success","disabled":!this.tag_title.length > 0},on:{"click":_vm.create_tag}},[_vm._v("Save")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"fail"},on:{"click":function($event){return _vm.close_save_tag_form()}}},[_vm._v("Cancel")])],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"mx-2":"","align":"center"}},[_c('v-autocomplete',{attrs:{"filter":_vm.customFilter,"multiple":"","chips":"","items":_vm.select_tags_assign,"item-text":function (item) { return ((item.name) + " / " + (item.category ? item.category : 'General')); },"label":"Click to select Tags ","item-text":"name","item-value":"id","hint":"Select tags to assign to selected artworks"},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('v-icon',{staticClass:"ml-2",on:{"click":function($event){_vm.showFilter = false}}},[_vm._v("style")])]},proxy:true},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',[(data.item.concept_tag == 1)?_c('span',{staticClass:"mr-2 px-0"},[_vm._v("★")]):_vm._e(),_vm._v(_vm._s(data.item.name))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"text-xs-right",domProps:{"innerHTML":_vm._s(data.item.category ? data.item.category : 'General')}}),_vm._v(" "),_c('v-divider')],1)]}}],null,false,3525476237),model:{value:(_vm.selected_tags_assign),callback:function ($$v) {_vm.selected_tags_assign=$$v},expression:"selected_tags_assign"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"mx-0":"","my-3":""}},[_c('v-btn',{attrs:{"dark":"","disabled":!(_vm.selected_tags_assign.length > 0 && _vm.selected.length > 0)},on:{"click":function($event){return _vm.assignTagsToArtworks()}}},[_vm._v("Assign "+_vm._s(_vm.selected_tags_assign.length)+" tags to\n              "+_vm._s(_vm.selected.length)+" selected artworks")])],1)],1)],1):_vm._e()]),_vm._v(" "),(this.$store.state.view == 'gallery')?_c('div',{staticClass:"mx-4 pt-0 mt-5 elevation-0",staticStyle:{"column-count":"4"}},_vm._l((_vm.table_artworks),function(a){return _c('div',{key:a.id,staticClass:"carda"},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
                  var hover = ref.hover;
return _c('v-card',{staticClass:"mx-auto elevation-0",attrs:{"max-width":"600"}},[_c('v-img',{attrs:{"src":((_vm.$globals.fileserver) + "/data/artwork/" + (a.id) + "/" + (a.top_photo_id) + "_th_middle.jpg")}},[(hover)?_c('div',{staticClass:"\n                  px-4\n                  py-3\n                  subheading\n                  transition-fast-in-fast-out\n                  grey\n                  darken-4\n                  v-card--reveal\n                  white--text\n                "},[_c('div',{staticClass:"font-weight-regular white--text mb-0 text-xs-left"},[_vm._v("\n                  "+_vm._s(a.artist ? a.artist.name : a.name)+"\n                ")]),_vm._v(" "),_c('router-link',{staticClass:"\n                    font-weight-regular\n                    body-2\n                    mb-2\n                    white--text\n                    text-xs-left\n                  ",attrs:{"to":{
                    name: 'EditArtwork',
                    params: { id: a.id, artwork: a },
                    path: ("/artworks/edit/" + (a.id)),
                  }}},[_c('span',{class:{ 'red--text': a.deaccessioned },domProps:{"innerHTML":_vm._s(((a.title) + ", " + (a.production_date_new)))}})]),_vm._v(" "),(a.dim_f_json)?_c('div',{staticClass:"body-2 mb-2",domProps:{"innerHTML":_vm._s(a.dim_f_json)}}):_vm._e(),_vm._v(" "),(a.artwork_location_id && a.artwork_location_id != 465)?_c('div',{staticClass:"body-2"},[_vm._v("\n                  "+_vm._s(_vm.get_location_name(a.artwork_location_id))+"\n                ")]):_vm._e()],1):_vm._e()])],1)}}],null,true)})],1)}),0):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"900px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticStyle:{"background":"linear-gradient("},attrs:{"dark":""}},[_c('v-card-title',{staticClass:"mb-0 pb-0 px-4 mx-1 title"},[_vm._v("\n          Batch change parameters of\n          "+_vm._s(this.selected.length > 1 ? 'these' : 'this')+"\n          "+_vm._s(this.selected.length)+" Artwork"+_vm._s(this.selected.length > 1 ? 's' : '')+":\n        ")]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0 mt-0 px-0"},[_c('v-container',{attrs:{"grid-list-xs":"","pt-2":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"height":"100px","overflow":"auto","clear":"both","background-color":"#222222"},attrs:{"elevation-0":"","xs12":"","pl-2":"","pt-3":"","mt-2":"","px-2":"","mx-1":"","mb-2":""}},[_c('ul',_vm._l((this.selected),function(a){return _c('li',{key:a.id},[_c('b',[_vm._v(_vm._s(a.title))]),_vm._v("\n                    - "+_vm._s(a.full_name)+" -\n                    "),_c('b',[_vm._v(_vm._s(a.accession_number))])])}),0)]),_vm._v(" "),_c('v-flex',{staticStyle:{"background-color":"#444"},attrs:{"xs12":"","my-1":"","mx-1":"","elevation-0":""}},[_c('v-expansion-panel',{staticClass:"elevation-5",attrs:{"xs12":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel-content',{staticClass:"px-1 py-1",style:(_vm.panel == 0 ? 'background-color: #333' : ''),attrs:{"xs12":""}},[_c('div',{staticClass:"title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                      Type of Work\n                      "),(_vm.edited_artwork.type_of_work_id)?_c('span',{staticClass:"right mr-4"},[_vm._v(_vm._s(_vm.get_type_of_work(_vm.edited_artwork.type_of_work_id)))]):_vm._e()]),_vm._v(" "),_c('v-radio-group',{staticClass:"pt-0 mt-0 pl-4",model:{value:(_vm.edited_artwork.type_of_work_id),callback:function ($$v) {_vm.$set(_vm.edited_artwork, "type_of_work_id", $$v)},expression:"edited_artwork.type_of_work_id"}},_vm._l((_vm.constants['TYPES_OF_WORK']),function(vs){return _c('v-radio',{key:vs.id,attrs:{"color":"#aaa","value":vs.id,"label":vs.name}})}),1)],1),_vm._v(" "),_c('v-expansion-panel-content',{staticClass:"px-1 py-1",style:(_vm.panel == 2 ? 'background-color: #333' : ''),attrs:{"xs12":""}},[_c('div',{staticClass:"title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                      Location Notes\n                      "),(_vm.edited_artwork.location_notes)?_c('span',{staticClass:"right mr-4"},[_vm._v(_vm._s(_vm.edited_artwork.location_notes))]):_vm._e()]),_vm._v(" "),_c('v-textarea',{staticClass:"mx-4",attrs:{"clearable":"","auto-grow":"","rows":"1"},model:{value:(_vm.edited_artwork.location_notes),callback:function ($$v) {_vm.$set(_vm.edited_artwork, "location_notes", $$v)},expression:"edited_artwork.location_notes"}}),_vm._v(" "),_c('v-checkbox',{staticClass:"ml-4",attrs:{"color":"white","label":"Append to current content of the field, if any"},model:{value:(_vm.append_notes),callback:function ($$v) {_vm.append_notes=$$v},expression:"append_notes"}})],1),_vm._v(" "),_c('v-expansion-panel-content',{staticClass:"px-1 py-1",style:(_vm.panel == 3 ? 'background-color: #333' : ''),attrs:{"xs12":""}},[_c('div',{staticClass:"title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                      Credit\n                      "),(_vm.edited_artwork.credit)?_c('span',{staticClass:"right mr-4 overflow-hidden"},[_vm._v(_vm._s(_vm.edited_artwork.credit))]):_vm._e()]),_vm._v(" "),_c('v-textarea',{staticClass:"mx-4",attrs:{"clearable":"","auto-grow":"","rows":"1"},model:{value:(_vm.edited_artwork.credit),callback:function ($$v) {_vm.$set(_vm.edited_artwork, "credit", $$v)},expression:"edited_artwork.credit"}}),_vm._v(" "),_c('v-checkbox',{staticClass:"ml-4",attrs:{"color":"white","label":"Append to current content of the field, if any"},model:{value:(_vm.append_credit),callback:function ($$v) {_vm.append_credit=$$v},expression:"append_credit"}})],1),_vm._v(" "),_c('v-expansion-panel-content',{staticClass:"px-1 py-1",style:(_vm.panel == 4 ? 'background-color: #333' : ''),attrs:{"xs12":""}},[_c('div',{staticClass:"title",attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                      Visa Status\n                      "),(_vm.edited_artwork.visa_status)?_c('span',{staticClass:"right mr-4"},[_vm._v(_vm._s(_vm.get_visa_status(_vm.edited_artwork.visa_status)))]):_vm._e()]),_vm._v(" "),_c('v-radio-group',{staticClass:"mx-4",attrs:{"column":false},model:{value:(_vm.edited_artwork.visa_status),callback:function ($$v) {_vm.$set(_vm.edited_artwork, "visa_status", $$v)},expression:"edited_artwork.visa_status"}},_vm._l((this.constants.VISA_STATUSES),function(vs){return _c('v-radio',{key:vs.id,attrs:{"color":"black","value":vs.id,"label":vs.name}})}),1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pr-5 pb-4"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"black","flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"white","flat":"","disabled":!Object.values(_vm.edited_artwork).some(function (x) { return x !== null && x !== ''; })},nativeOn:{"click":function($event){return _vm.updateArtworks.apply(null, arguments)}}},[_vm._v("Modify all selected Artworks")])],1)],1)],1),_vm._v(" "),_c('location-change-dialog',{attrs:{"showDialog":_vm.show_change_location_dialog,"selected":_vm.selected},on:{"hideDialog":function($event){_vm.show_change_location_dialog = false}}}),_vm._v(" "),(_vm.show_attach_tag_dialog)?_c('attach-tag-to-artworks-dialog',{attrs:{"selected":_vm.selected}}):_vm._e(),_vm._v(" "),(this.$store.state.view == 'list')?_c('v-card',{staticClass:"mx-2 py-0 elevation-0"},[(this.$store.state.showSearch && !this.showFilter)?_c('v-layout',{staticClass:"fill-height row mr-0 mb-2 justify-end"},[_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"mr-2 ml-3 pl-2 round",staticStyle:{"width":"550px","border":"1px solid rgba(0, 0, 0, 0.7)"}},[_c('v-autocomplete',{attrs:{"items":_vm.tagNames,"item-value":"id","placeholder":"Search by tags","filter":_vm.customTagFilter,"multiple":"","chips":"","clearable":"","flat":"","hide-details":"","single-line":"","full-width":"","hide-selected":"","prepend-inner-icon":"tags"},scopedSlots:_vm._u([{key:"item",fn:function(ref){
                  var item = ref.item;
return [_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(item.section)+" - "+_vm._s(item.subcategory)+" "),_c('b',[_vm._v("#"+_vm._s(item.name))])])],1)]}},{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi",attrs:{"selected":data.selected,"small":"","dense":"","color":"primary","text-color":"white","close":""},on:{"input":function($event){return _vm.remove(data.item.id)}}},[_vm._v("\n                "+_vm._s(data.item.label)+"\n              ")])]}}],null,false,12721004),model:{value:(_vm.selectedTags),callback:function ($$v) {_vm.selectedTags=$$v},expression:"selectedTags"}})],1),_vm._v(" "),_c('div',{staticStyle:{"width":"350px","height":"58px","border":"1px solid rgba(0, 0, 0, 0.7)"}},[(this.$store.state.showSearch && !this.showFilter)?_c('v-text-field',{staticStyle:{"height":"20px"},attrs:{"placeholder":"Search by title, acq.no., artist, ID, etc.","prepend-inner-icon":"search","background-color":_vm.selected_filter_tags.length > 0 || (_vm.search && _vm.search.length > 0)
              ? '#f5f5f5'
              : '',"clearable":"","hide-details":"","single-line":"","flat":"","dense":"","full-width":""},on:{"click:prepend-inner":function($event){_vm.showFilter = true}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),(this.$store.state.showSearch)?_c('div',{staticClass:" mx-2 mt-1 py-0",staticStyle:{"width":"40px"}},[_c('v-btn',{staticClass:"mx-0 py-0",attrs:{"icon":""},on:{"click":_vm.searchAllToggle}},[(_vm.searchAll)?_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("check_circle")]):_c('v-icon',{attrs:{"color":"black","small":"","dark":""}},[_vm._v("check_circle_outline")])],1)],1):_vm._e(),_vm._v(" "),(
          this.$store.state.currentSelection.length > 0 || this.table_artworks.length == 0
        )?_c('div',{staticClass:" mt-1 pr-0 mr-0",staticStyle:{"width":"60px"}},[_c('v-btn',{staticClass:"mx-0 py-0",attrs:{"icon":""},on:{"click":_vm.toggleSelection}},[(_vm.showSelection)?_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("auto_awesome_motion")]):_c('v-icon',{attrs:{"color":"black","small":"","dark":""}},[_vm._v("auto_awesome_motion")]),_vm._v("\n            "+_vm._s(this.$store.state.currentSelection.length)+"\n          ")],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.selected.length > 0)?_c('v-btn',{staticClass:"ml-3 mr-0 mb-4 pr-3",attrs:{"small":"","color":"black","dark":""},on:{"click":_vm.toggleShowAttachTagDialog}},[_c('v-icon',{staticClass:"mr-2",attrs:{"left":"","small":""}},[_vm._v("mdi-autorenew")]),_vm._v("\n        Assign Tags to \n        "+_vm._s(this.selected.length)+" Artwork"+_vm._s(this.selected.length > 1 ? 's' : '')+":\n      ")],1):_vm._e(),_vm._v(" "),(_vm.selected.length > 0)?_c('v-btn',{staticClass:"ml-3 mr-0 mb-4 pr-3",attrs:{"small":"","color":"black","dark":""},on:{"click":_vm.showBatchUpdateDialog}},[_c('v-icon',{staticClass:"mr-2",attrs:{"left":"","small":""}},[_vm._v("mdi-autorenew")]),_vm._v("\n        Batch update \n        "+_vm._s(this.selected.length)+" Artwork"+_vm._s(this.selected.length > 1 ? 's' : '')+":\n      ")],1):_vm._e(),_vm._v(" "),(_vm.selected.length > 0)?_c('v-btn',{staticClass:"ml-3 mr-0 mb-4 pr-3",attrs:{"dark":"","small":""},on:{"click":function($event){_vm.show_change_location_dialog = true}}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("edit_location")]),_vm._v("Change location of\n        selected\n      ")],1):_vm._e(),_vm._v(" "),(_vm.selected.length > 0)?_c('v-btn',{staticClass:"ml-3 mr-0 mb-4 pr-3",attrs:{"small":"","color":"red","dark":""},on:{"click":_vm.resetSelected}},[_c('v-icon',{staticClass:"mr-1",attrs:{"left":"","small":""}},[_vm._v("mdi-close")]),_vm._v("Clear Selection\n      ")],1):_vm._e(),_vm._v(" "),(this.$route.fullPath == '/artworks/ownership/deaccession')?_c('v-layout',{attrs:{"row":"","mt-3":"","mx-2":""}},[_c('span',[_c('v-menu',{staticClass:"text-xs-right mx-4 my-0 py-0 align-center",attrs:{"offset-y":"","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-2 my-0 py-0",attrs:{"small":"","icon":"","color":"black","dark":""}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("supervisor_account")])],1)]}}],null,false,4146457725)},[_vm._v(" "),_c('v-list',{attrs:{"value":"1"}},_vm._l((_vm.ownerships),function(item,index){return _c('v-list-tile',{key:index.id,on:{"click":function($event){return _vm.toggleOwnership(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)}),1)],1)],1),_vm._v(" "),_c('span',{staticClass:"text-xs-left mt-2 pt-1 title"},[_vm._v("\n          "+_vm._s(_vm.selectedOwnership.name)+"\n        ")]),_vm._v(" "),_c('v-spacer')],1):_vm._e(),_vm._v(" "),(this.$route.fullPath == '/artworks/ownership/commissions')?_c('v-flex',{staticClass:"mt-0 mr-3 ml-3 mb-2"},[_c('v-btn-toggle',{model:{value:(_vm.commissions),callback:function ($$v) {_vm.commissions=$$v},expression:"commissions"}},[_c('v-btn',{key:"group1",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"all","value":"all"}},[_c('span',[_vm._v(" All ")])]),_vm._v(" "),_c('v-btn',{key:"group2",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"tba","value":"tba"}},[_c('span',[_vm._v(" TBA21 Commissions ")])]),_vm._v(" "),_c('v-btn',{key:"group3",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"com_academy","value":"com_academy"}},[_c('span',[_vm._v(" TBA21 Academy Commissions ")])]),_vm._v(" "),_c('v-btn',{key:"group4",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"not","value":"not"}},[_c('span',[_vm._v(" NOT Acquired ")])])],1)],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(this.$store.state.showSearch && _vm.showFilter)?_c('span',{staticClass:"px-2 flex xs10"},[(_vm.selected_filter_tags.length > 1)?_c('span',{staticClass:"pt-3 my-0 text-xs-left xs1"},[(_vm.and)?_c('v-btn',{attrs:{"small":"","flat":"","icon":"","color":"black","py-0":"","my-0":""},on:{"click":function($event){_vm.and = !_vm.and}}},[_vm._v("AND")]):_vm._e(),_vm._v(" "),(!_vm.and)?_c('v-btn',{attrs:{"small":"","flat":"","icon":"","color":"black","py-0":"","my-0":""},on:{"click":function($event){_vm.and = !_vm.and}}},[_vm._v("OR")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-autocomplete',{attrs:{"xs10":"","background-color":_vm.search && _vm.search.length > 0 ? '#fee' : '',"items":_vm.tags,"item-text":function (item) { return ((item.name) + " / " + (item.category ? item.category : 'General')); },"item-value":"id","label":"Filter by Tags","multiple":"","chips":"","clearable":"","deletable-chips":"","dense":"","hide-details":"","small-chips":""},scopedSlots:_vm._u([{key:"prepend-inner",fn:function(){return [_c('v-icon',{staticClass:"ml-2",on:{"click":function($event){_vm.showFilter = false}}},[_vm._v("style")])]},proxy:true},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',[(data.item.concept_tag == 1)?_c('span',{staticClass:"mr-2 px-0"},[_vm._v("★")]):_vm._e(),_vm._v(_vm._s(data.item.name))]),_vm._v(" "),(data.item.concept_tag != 1)?_c('v-list-tile-sub-title',{staticClass:"text-xs-right grey--text",domProps:{"innerHTML":_vm._s(data.item.category ? data.item.category : '')}}):_vm._e(),_vm._v(" "),_c('v-divider')],1)]}}],null,false,133104053),model:{value:(_vm.selected_filter_tags),callback:function ($$v) {_vm.selected_filter_tags=$$v},expression:"selected_filter_tags"}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ml-2 mr-3",staticStyle:{"border-bottom":"1px solid rgba(0, 0, 0, 0.1)"}}),_vm._v(" "),_c('v-data-table',{ref:"dTable",staticClass:"elevation-0 mx-3",attrs:{"loading":true,"headers-length":5,"hide-headers":"","headers":_vm.headers,"items":_vm.table_artworks,"search":_vm.search,"item-key":"id","rows-per-page-text":"Artworks per page","no-results-text":"No Artworks match the criteria.","no-data-text":"No Artworks loaded.","pagination":_vm.p},on:{"update:pagination":function($event){_vm.p=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{staticClass:"pb-0 mb-0",staticStyle:{"border-top":"1px solid rgba(0, 0, 0, 0.5)"}},[_c('td',{staticStyle:{"width":"20px !important","margin":"0px !important","padding":"0px !important"}},[_c('v-checkbox',{staticClass:"pt-3 px-0 mx-0 align-start justify-start row fill-height",attrs:{"color":"black","hide-details":""},on:{"change":function($event){return _vm.save_currently_selected(props.selected, props.item)}},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center","vertical-align":"text-top","width":"140px","padding":"7px 0 0 0"}},[(props.item.top_photo_id > 0)?_c('img',{class:{
  redBorder:
    props.item.top_photo &&
    (props.item.top_photo.width < 500 ||
      props.item.top_photo.height < 500),
},staticStyle:{"width":"120px","margin":"10px"},attrs:{"src":_vm.$globals.fileserver +
                '/data/artwork/' +
                props.item.id +
                '/' +
                props.item.top_photo_id +
                '_th_big.jpg'},on:{"error":_vm.imageUrlAlt}}):_c('img',{staticStyle:{"width":"120px","margin":"10px"},attrs:{"src":_vm.imageUrlAlt},on:{"error":_vm.imageUrlAlt}})]),_vm._v(" "),_c('td',{staticClass:"my-0 py-0 body-1 align-start justify-start row fill-height",staticStyle:{"vertical-align":"top","padding":"7px 0 0 0"},attrs:{"colspan":"7"}},[_c('table',{staticClass:"my-2 py-0 body-1 align-start justify-start row",staticStyle:{"padding-top":"25px"},attrs:{"width":"100%"}},[_c('tr',[_c('td',{staticClass:"\n                      body-1\n                      align-start\n                      justify-space-between\n                      column\n                      fill-height\n                      pt-2\n                      pb-0\n                      mb-0\n                      pl-2\n                      pr-0\n                    "},[_c('div',{staticClass:"\n                        title\n                        black--text\n                        text-xs-left\n                        mb-1\n                        font-weight-thin\n                      "},[_vm._v("\n                      "+_vm._s(props.item.artist
                          ? props.item.artist.name
                          : props.item.name
                            ? props.item.name
                            : props.item.artist_name)+"\n                    ")]),_vm._v(" "),_c('router-link',{attrs:{"to":{
                      name: 'EditArtwork',
                      params: { id: props.item.id, artwork: props.item },
                      path: ("/artworks/edit/" + (props.item.id)),
                    }}},[_c('span',{class:[
                        { 'red--text': props.item.deaccessioned },
                        'subheading' ],domProps:{"innerHTML":_vm._s(("<b>" + (props.item.title) + "</b>"))}}),(props.item.subtitle)?_c('span',{class:[
  { 'red--text': props.item.deaccessioned },
  'subheading' ],domProps:{"innerHTML":_vm._s(("" + (props.item.subtitle)))}}):_vm._e(),(props.item.production_date_new)?_c('span',{class:[
                          { 'red--text': props.item.deaccessioned },
                          'subheading' ],domProps:{"innerHTML":_vm._s(("<b>, " + (props.item.production_date_new) + "</b>"))}}):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"mr-3"},[_vm._v(_vm._s(props.item.accession_number))]),_vm._v(" "),_c('v-spacer',{staticClass:"mb-2"}),_vm._v(" "),(props.item.dim_f_json)?_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("square_foot")]):_vm._e(),_vm._v(" "),(props.item.dim_f_json)?_c('span',[_vm._v("\n                      "+_vm._s(props.item.dim_f_json))]):_vm._e(),_c('br'),_vm._v(" "),(
                      props.item.artwork_location_id &&
                      props.item.artwork_location_id != 465
                    )?_c('div',[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("edit_location")]),_vm._v(" "),_c('span',[_vm._v("\n                        "+_vm._s(_vm.get_location_name(props.item.artwork_location_id)))])],1):_vm._e(),_vm._v(" "),(props.item.tags && props.item.tags.length > 0)?_c('div',[_c('div',{staticClass:"pt-3 ml-0 pl-0"},_vm._l((props.item.tags),function(t){return _c('v-chip',{key:t.id,attrs:{"color":"black","text-color":"white","small":""}},[_vm._v("#"+_vm._s(t.name))])}),1)]):_vm._e()],1)]),_vm._v(" "),((props.item.artwork_todos && props.item.artwork_todos.filter(
                          function (at) { return at.done != 1; }
                        ).length > 0) || props.item.visa_status == 3)?_c('tr',{staticClass:"my-0 py-0"},[_c('td',{staticClass:"my-0 py-0 pr-0",staticStyle:{"text-align":"right","width":"30px"}},[(props.item.visa_status == 3)?_c('v-chip',{attrs:{"text-color":"white","color":"red","small":""}},[_vm._v("F")]):_vm._e(),_vm._v(" "),(
                      props.item.artwork_todos &&
                      props.item.artwork_todos.filter(function (at) { return at.done != 1; })
                        .length > 0
                    )?_c('v-tooltip',{attrs:{"left":"","color":"black"},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_c('v-chip',_vm._g({attrs:{"color":"#eee","small":""}},data.on),[_c('v-icon',{staticClass:"mr-3 small"},[_vm._v("mdi-format-list-numbered")]),_vm._v("\n                          "+_vm._s(props.item.artwork_todos.filter(
                              function (at) { return at.done != 1; }
                            ).length)+"\n                        ")],1)]}}],null,true)},[_vm._v(" "),_c('div',_vm._l((props.item.artwork_todos.filter(
                          function (at) { return at.done != 1; }
                        )),function(a){return _c('div',{key:a.id},[_vm._v("\n                          – "+_vm._s(a.title)+"\n                          "),_c('br')])}),0)]):_vm._e()],1)]):_vm._e()])])])]}}],null,false,3739724271),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('v-progress-linear',{attrs:{"color":"blue","indeterminate":""},scopedSlots:_vm._u([{key:"progress",fn:function(){return undefined},proxy:true}],null,false,63074868)}),_vm._v(" "),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("Your search for \""+_vm._s(_vm.search)+"\" found no\n          results.")]),_vm._v(" "),_c('template',{attrs:{"text-xs-center":""},slot:"no-data"},[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","py-5":""}},[_c('v-flex',{attrs:{"xs12":"","py-5":""}},[_c('center',{staticClass:"mb-5"},[(this.$store.state.loading_artworks)?_c('div',[_c('v-progress-circular',{attrs:{"indeterminate":"","width":"20","size":"250","color":"grey lighten-4"}})],1):_c('div',[_c('h3',[_vm._v("\n                      No Artworks Found\n                    ")])])]),_vm._v(" "),_c('center',[_vm._v("\n                  Loading Artworks…\n                ")])],1)],1)],1)],1)],2)],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "fPbq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fRaQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArticle_vue__ = __webpack_require__("VcEo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c426cb02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArticle_vue__ = __webpack_require__("KKja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Qi9S")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c426cb02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArticle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c426cb02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArticle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c426cb02_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArticle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "fRjm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__main__ = __webpack_require__("NHnr");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function dynamicSort(property, property2) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    if (a[property] > b[property]) return 1 * sortOrder;
    if (a[property] < b[property]) return -1 * sortOrder;

    // Secondary sort using property2
    if (property2 && a[property2] && b[property2]) {
      if (a[property2] > b[property2]) return 1;
      if (a[property2] < b[property2]) return -1;
    }

    return 0;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MarketValueHistory',
  props: ['artwork'],
  data: function data() {
    var _artwork_insurance_lo;

    return {
      saveDialog: false,
      selectedFilter: 'artwork',
      // selectedPackingFilter: 'all',
      // historyFilter: 'artwork',
      changeArtworkInsurance: false,
      // changeAllParts: false,
      editDialog: false,
      menu_time: false,
      time: null,
      editedInsuranceLog: {},
      selectedPackings: [],
      menu2: false,
      menu2a: false,
      showUpload: false,
      showList: false,
      show: false,
      errors: '',
      artwork_insurance_log: (_artwork_insurance_lo = {
        created_by: '',
        christies_2022_LOWER_MARKET_value: '',
        insurance_value_currency: '',
        insurance_value_note: '',
        insurance_value_date: ''
      }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_artwork_insurance_lo, 'christies_2022_LOWER_MARKET_value', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_artwork_insurance_lo, 'market_insurance', 'market'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_artwork_insurance_lo, 'copy', 'artwork'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_artwork_insurance_lo, 'artwork_packing_id', ''), _artwork_insurance_lo)
    };
  },
  computed: {
    old_insurance_table: function old_insurance_table() {
      var a1 = this.artwork.Valuation_Type_all.split(', ');
      var a2 = this.artwork.Valuation_Method_all.split(', ');
      var a3 = this.artwork.Valuation_Date_all.split(', ');

      var result_array = a1.map(function (item, index) {
        return {
          id: index,
          type: a1[index],
          method: a2[index],
          date: a3[index]
        };
      });
      return result_array;
    },
    old_insurance_from_date_and_copy: function old_insurance_from_date_and_copy() {
      var _this = this;

      // var current = { insurance_value_date: this.artwork_insurance_log.insurance_value_date, copy: this.artwork_insurance_log.copy, artwork_id: this.artwork.id }
      if (this.artwork_insurance_log.insurance_value_date && this.artwork_insurance_log.copy) {
        // this.artwork_insurance_log.old_insurance = this.get_old_insurance(current)
        if (this.artwork_insurance_log.copy == 'packings') {
          this.artwork_insurance_log.artwork_id = '';
          return 'Previous Insurance cannot be calculated for packings';
        } else if (['artwork', 'master_physical', 'archive_master'].includes(this.artwork_insurance_log.copy)) {
          this.artwork_insurance_log.artwork_id = this.artwork.id;
          var olderArtworkLogs = this.sorted_artwork_insurance_logs.filter(function (l) {
            return l.copy == _this.artwork_insurance_log.copy && l.insurance_value_date < _this.artwork_insurance_log.insurance_value_date;
          });
          console.log(olderArtworkLogs);
          if (olderArtworkLogs.length > 1) {
            // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_insurance_log')
            var previous = olderArtworkLogs[0];
            if (previous) {
              this.artwork_insurance_log.old_insurance = previous.christies_2022_LOWER_MARKET_value;
              return previous.christies_2022_LOWER_MARKET_value;
            } else {
              this.artwork_insurance_log.old_insurance = 465;
              return 465;
            }
          } else {
            this.artwork_insurance_log.old_insurance = 465;
            return 465;
          }
        }
      } else {
        return 'Copy and Change Date must be selected before calculating old Insurance';
      }
    },
    sorted_artwork_insurance_logs: function sorted_artwork_insurance_logs() {
      if (this.artwork && Array.isArray(this.artwork.artwork_insurance_logs)) {
        return this.artwork.artwork_insurance_logs
        // .filter((l) => l.market == '1')
        .sort(dynamicSort('insurance_value_date')).reverse();
      }
      return [];
    },
    filtered_artwork_insurance_logs: function filtered_artwork_insurance_logs() {
      var o = this.sorted_artwork_insurance_logs.filter(function (l) {
        return l.market_insurance == 'market';
      });
      // console.log(o)
      return o;
    },
    insurances: function insurances() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.getters.enabled_insurances).sort(dynamicSort('name'));
    },
    lastInsuranceLogArtwork: function lastInsuranceLogArtwork() {
      return this.getLastLog(this.artwork.artwork_insurance_logs, 'artwork');
    }
  },
  watch: {
    // changeAllParts: function () {
    //   this.selectAllParts()
    // },
    artwork_insurance_log: {
      handler: function handler(val) {
        console.log('watch');
        if (this.artwork_insurance_log.insurance_value_date) {
          this.artwork_insurance_log.old_insurance == this.old_insurance_from_date_and_copy;
        }
      },

      deep: true
    }
  },
  methods: {
    // lastInsuranceLogArtworkPacking(id) {
    //   return this.getLastLog(this.artwork.artwork_insurance_logs, 'packings', id)
    // },
    switch_change_dialog: function switch_change_dialog() {
      this.showUpload = !this.showUpload;
      if (this.showUpload) {
        this.artwork_insurance_log.old_insurance = this.old_insurance_from_date_and_copy;
      }
    },

    // get_old_insurance_from_date_and_copy() {
    //   // var current = { insurance_value_date: this.artwork_insurance_log.insurance_value_date, copy: this.artwork_insurance_log.copy, artwork_id: this.artwork.id }
    //   if(this.artwork_insurance_log.insurance_value_date && this.artwork_insurance_log.copy) {
    //     // this.artwork_insurance_log.old_insurance = this.get_old_insurance(current)
    //     if (this.artwork_insurance_log.copy == 'packings') {
    //         return 'Previous Insurance cannot be calculated for packings'
    //     } else if (['artwork','master_physical','archive_master'].includes(this.artwork_insurance_log.copy)) {
    //       var olderArtworkLogs = this.sorted_artwork_insurance_logs
    //         .filter(l => l.artwork_id = this.artwork_insurance_log.artwork_id
    //           && l.copy == this.artwork_insurance_log.copy
    //           && l.insurance_value_date < this.artwork_insurance_log.insurance_value_date)
    //       if (olderArtworkLogs.length > 1) {
    //         // var indexOfcurrent = this.findPositionByAtribute(artworkLogs,'this.artwork_insurance_log')
    //         var previous = olderArtworkLogs[0]
    //         if(previous) {
    //           this.artwork_insurance_log.old_insurance = previous.artwork_insurance_id
    //           return  previous.artwork_insurance_id
    //         } else {
    //           return 'no previous log for this packing'
    //         }
    //       } else {
    //         return 'no previous log for this packing'
    //       }
    //     }
    //   } else {
    //     return 'Copy and Change Date must be selected before calculating old Insurance'
    //   }
    // },
    // get_old_insurance(log) {
    //   if (log.copy == 'packings') {
    //     var packingLogs = this.sorted_artwork_insurance_logs.filter(
    //       (l) => (l.artwork_packing_id = log.artwork_packing_id)
    //     )
    //     if (packingLogs.length > 1) {
    //       var indexOfcurrent = packingLogs.indexOf(log)
    //       var previous = packingLogs[indexOfcurrent + 1]
    //       return previous
    //         ? previous.artwork_insurance_id
    //         : 'no previous log for this packing'
    //     } else {
    //       return 'no previous log for this packing'
    //     }
    //   } else if (
    //     ['artwork', 'master_physical', 'archive_master'].includes(log.copy)
    //   ) {
    //     var artworkLogs = this.sorted_artwork_insurance_logs.filter(
    //       (l) => (l.artwork_id = log.artwork_id && l.copy == log.copy)
    //     )
    //     if (artworkLogs.length > 1) {
    //       var indexOfcurrent = artworkLogs.indexOf(log)
    //       var previous = artworkLogs[indexOfcurrent + 1]
    //       return previous
    //         ? previous.artwork_insurance_id
    //         : 'no previous log for this packing'
    //     } else {
    //       return 'no previous log for this packing'
    //     }
    //   }
    //   // christies_2022_LOWER_MARKET_value
    // },
    // toggleCopyFilter(c) {
    //   console.log(c)
    //   this.selectedFilter = c
    //   if (c == 'packings') {
    //     this.selectedPackingFilter = 'all'
    //   }
    // },
    // togglePackingFilter(c) {
    //   this.selectedPackingFilter = c
    // },
    // selectAllParts() {
    //   if (this.changeAllParts) {
    //     this.artwork.artwork_packings.forEach((p) => {
    //       if (!this.selectedPackings.includes(p)) {
    //         this.selectedPackings.push(p)
    //       }
    //     })
    //   } else {
    //     this.selectedPackings = []
    //   }
    // },
    getLastLog: function getLastLog(logs, copy, id) {
      if (logs && logs.length > 0) {
        // .filter((ll) => true)
        var out = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], logs).sort(function (a, b) {
          if (a.insurance_value_date > b.insurance_value_date) {
            return -1;
          }
          if (a.insurance_value_date < b.insurance_value_date) {
            return 1;
          }
          return 0;
        })[0];
        if (out) {
          return out;
        } else {
          return '';
        }
      } else {
        return '';
      }
    },

    // getPacking(id) {
    //   return this.artwork.artwork_packings.find((ap) => ap.id === id)
    // },
    editInsurance: function editInsurance(l) {
      console.log(l);
      this.editedInsuranceLog = l;
      this.editDialog = true;
    },

    // insurance_name (id) {
    //   // console.log(id)
    //   if (id > 0) {
    //     var a = this.$store.state.insurances.find(l => l.id === id)
    //     if (a) {
    //       return a.name
    //     } else {
    //       return 'Insurance not found in CMS.'
    //     }
    //   } else {
    //     return 'Insurance not found in CMS.'
    //   }
    // },
    download: function download() {},
    delete_log: function delete_log(item) {
      var r = confirm('Are you sure you want to delete this Insurance History entry?');
      if (r) {
        this.delete_log_action(item);
      }
    },
    delete_log_action: function delete_log_action(item) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'Deleting Insurance history.', 'black');
      var url = this.$globals.apiserver + '/artwork_insurance_logs/' + item.id + '.json';
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url, item).then(function (response) {
        _this2.$store.dispatch('updateArtwork', _this2.artwork.id);
        __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'Insurance history Deleted.', 'green');
        _this2.errors = {};
        var index = _this2.artwork.artwork_insurance_logs.indexOf(item);
        if (index >= 0) _this2.artwork.artwork_insurance_logs.splice(index, 1);
        // const index = this.artwork.artwork_costs.indexOf(item)
        // this.artwork.artwork_insurance_logs.push(response.data);
        // @artwork.christies_2022_LOWER_MARKET_value = @artwork_insurance_log.id
        // elsif @artwork_insurance_log.copy = 'master_physical'
        // @artwork.master_physical_insurance_id = @artwork_insurance_log.id
        // elsif @artwork_insurance_log.copy = 'archive_master'
        // @artwork.archive_master_insurance_id = @artwork_insurance_log.id
        // elsif @artwork_insurance_log.copy = 'access_copy'
        // @artwork.access_copy_insurance_id = @artwork_insurance_log.id
        // this.active_artwork_insurance_logs = this.artwork.artwork_insurance_logs
        // this.$store.commit('DELETE_LOG', response.data)
        _this2.active_artwork_insurance_logs = _this2.$store.state.artwork_insurance_logs;
        // this.showUpload = !this.showUpload
        return false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'There was an Error deleting Cost.', 'red');
        // console.log(error)
        _this2.errors = error.response.data;
      });
    },
    showSaveDialog: function showSaveDialog() {
      this.saveDialog = true;
    },
    save_artwork_insurance_log: function save_artwork_insurance_log() {
      var _this3 = this;

      this.saveDialog = false;
      // console.log('save_artwork_insurance_log')
      __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'Saving Insurance History Entry\u2026', 'green');

      // NASETUJEM LOG BASICS
      this.artwork_insurance_log.created_by = this.c_user.id;
      this.artwork_insurance_log.artwork_id = this.artwork.id;
      this.artwork_insurance_log.market_insurance = 'market';
      // ZMENIM LOGS ARTWORKU NA POLE, AK BOLO NULL, ABY SOM MOHOL OD NEHO PRIDAVAT
      if (!this.artwork.artwork_insurance_logs) {
        this.artwork.artwork_insurance_logs = [];
      }

      // IF I AM CHANGING PACKINGS - MUST BE SOME SELECTED
      // if (
      //   this.artwork_insurance_log.copy === 'packings' &&
      //   this.selectedPackings &&
      //   this.selectedPackings.length > 0
      // ) {

      //   // FOR EACH PACKING CREATE LOG AND CHANGE ITS INSURANCE
      //   for (const sp in this.selectedPackings) {
      //     // console.log(this.selectedPackings[sp].id)
      //     this.artwork_insurance_log.artwork_packing_id = this.selectedPackings[sp].id

      //     // ADD LOG FOR THIS PACKING - PACKING ITSELF IS CHANGED ON THE SERVER
      //     // console.log(this.artwork_insurance_log)
      //     axios
      //       .post(`${this.$globals.apiserver}/artwork_insurance_logs.json`, {
      //         artwork_insurance_log: this.artwork_insurance_log,
      //       })
      //       .then((response) => {
      //         this.errors = {}
      //         // this.artwork.artwork_insurance_logs.push(response.data);
      //         // @artwork.christies_2022_LOWER_MARKET_value = @artwork_insurance_log.id
      //         // elsif @artwork_insurance_log.copy = 'master_physical'
      //         // @artwork.master_physical_insurance_id = @artwork_insurance_log.id
      //         // elsif @artwork_insurance_log.copy = 'archive_master'
      //         // @artwork.archive_master_insurance_id = @artwork_insurance_log.id
      //         // elsif @artwork_insurance_log.copy = 'access_copy'
      //         // @artwork.access_copy_insurance_id = @artwork_insurance_log.id
      //         // this.active_artwork_insurance_logs = this.artwork.artwork_insurance_logs
      //         // this.$store.commit('ADD_LOG', response.data)
      //         // this.active_artwork_insurance_logs = this.$store.state.artwork_insurance_logs
      //         this.showUpload = !this.showUpload
      //       })
      //       .catch((error) => {
      //         console.log(error)
      //         // this.errors = error.response.data;
      //       })
      //     this.artwork_insurance_log.artwork_packing_id = null
      //   }

      // IF ALSO ARTWORK INSURANCE IS SELECTED TO BE CHANGED
      // if (this.changeArtworkInsurance) {
      // console.log('changeArtworkInsurance')

      // SAVE NEW ARTWORK INSURANCE - only if insurance_value_date is later than latest log
      // if (this.artwork_insurance_log.insurance_value_date > this.lastInsuranceLogArtwork.insurance_value_date) {
      //   // console.log(this.artwork_insurance_log.insurance_value_date)
      //   // console.log(this.lastInsuranceLogArtwork.insurance_value_date)
      //   axios
      //     .put(
      //       `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`,
      //       {
      //         artwork: {
      //           christies_2022_LOWER_MARKET_value:
      //             this.artwork_insurance_log.christies_2022_LOWER_MARKET_value,
      //         },
      //       }
      //     )
      //     .then((response) => {
      //       console.log('changeArtworkInsurance response change artwork')

      //       this.errors = {}
      //       this.artwork.artwork_insurance_logs.push(response.data)

      //       // ON SAVE SUCCESS SET CURRENT ARTWORK'S INSURANCE TO NEW INSURANCE
      //       // if (this.artwork_insurance_log.copy === 'artwork') {
      //       //   this.artwork.christies_2022_LOWER_MARKET_value = this.artwork_insurance_log.christies_2022_LOWER_MARKET_value
      //       // } else if (this.artwork_insurance_log.copy === 'master_physical') {
      //       //   this.artwork.master_physical_insurance_id = this.artwork_insurance_log.christies_2022_LOWER_MARKET_value
      //       // } else if (this.artwork_insurance_log.copy === 'archive_master') {
      //       //   this.artwork.archive_master_insurance_id = this.artwork_insurance_log.christies_2022_LOWER_MARKET_value
      //       // } else if (this.artwork_insurance_log.copy === 'access_copy') {
      //       //   this.artwork.access_copy_insurance_id = this.artwork_insurance_log.christies_2022_LOWER_MARKET_value
      //       // }
      //       // this.$store.commit('ADD_LOG', response.data)
      //       // this.active_artwork_insurance_logs = this.$store.state.artwork_insurance_logs
      //       this.changeArtworkInsurance = false
      //     })
      // }

      // ADD LOG FOR ARTWORK
      this.artwork_insurance_log.copy = 'artwork';
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$globals.apiserver + '/artwork_insurance_logs.json', {
        artwork_insurance_log: this.artwork_insurance_log
      }).then(function (response) {
        console.log('changeArtworkInsurance response add log');

        _this3.errors = {};
        _this3.artwork.artwork_insurance_logs.push(response.data);
        _this3.artwork.christies_2022_LOWER_MARKET_value = _this3.artwork_insurance_log.christies_2022_LOWER_MARKET_value;
        _this3.$store.commit('ADD_INSURANCE_LOG', response.data);
        _this3.active_artwork_insurance_logs = _this3.$store.state.artwork_insurance_logs;
        // this.showUpload = !this.showUpload
        _this3.artwork_insurance_log = {
          christies_2022_LOWER_MARKET_value: '',
          insurance_value_currency: '',
          insurance_value_note: '',
          insurance_value_date: '',
          insurance_valuer: '',
          market_insurance: 'market',
          reason: '',
          created_by: _this3.c_user.id
        };
      }).catch(function (error) {
        // console.log(error)
      });
      this.changeAllParts = false;
      // }

      // this.$store.dispatch('loadPackings')
      this.$emit('getArtwork');
      // } else {
      //   console.log('single')
      //   // ADD LOG FOR ARTWORK
      //   axios
      //     .post(`${this.$globals.apiserver}/artwork_insurance_logs.json`, {
      //       artwork_insurance_log: this.artwork_insurance_log,
      //     })
      //     .then((response) => {
      //       this.errors = {}
      //       this.artwork.artwork_insurance_logs.push(response.data)
      //       this.artwork.christies_2022_LOWER_MARKET_value =
      //           this.artwork_insurance_log.christies_2022_LOWER_MARKET_value

      //       this.$store.commit('ADD_LOG', response.data)
      //       this.active_artwork_insurance_logs =
      //         this.$store.state.artwork_insurance_logs
      //       this.showUpload = !this.showUpload
      //       this.artwork_insurance_log = {
      //         created_by: this.c_user.id,
      //         storage: 'in',
      //         insurance_value_note: '',
      //         insurance_value_date: '',
      //         copy: 'artwork',
      //         valuer: '',
      //         reason: '',
      //         christies_2022_LOWER_MARKET_value: '',
      //         artwork_packing_id: '',
      //       }
      //     })
      //     .catch((error) => {
      //       // console.log(error)
      //     })

      // this.$emit('getArtwork')
      // }
      // this.selectedPackings = []
      this.editDialog = false;
      this.saveDialog = false;
      this.showUpload = false;
      // var aartwork_insurance_log = Object.keys(this.artwork_insurance_log).forEach(k => this.artwork_insurance_log[k]='')
      // console.log(aartwork_insurance_log)
    },
    save_edited_artwork_insurance_log: function save_edited_artwork_insurance_log() {
      var _this4 = this;

      this.editedInsuranceLog.last_update_by = this.c_user.id;
      this.editedInsuranceLog.artwork_id = this.artwork.id;
      if (this.editedInsuranceLog.storage === 'in') {
        this.editedInsuranceLog.storage_in = this.editedInsuranceLog.insurance_value_date;
      } else {
        this.editedInsuranceLog.storage_out = this.editedInsuranceLog.insurance_value_date;
      }
      __WEBPACK_IMPORTED_MODULE_4__main__["serverBus"].$emit('showSnackbar', 'Saving Insurance History Entry\u2026', 'green');

      if (this.editedInsuranceLog.copy === 'packings' && this.selectedPackings && this.selectedPackings.length > 0) {
        for (var sp in this.selectedPackings) {
          this.editedInsuranceLog.artwork_packing_id = this.selectedPackings[sp].id;
          __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(this.$globals.apiserver + '/artwork_insurance_logs.json', {
            artwork_insurance_log: this.editedInsuranceLog
          }).then(function (response) {
            _this4.errors = {};
            // this.artwork.artwork_insurance_logs.push(response.data);
            // @artwork.christies_2022_LOWER_MARKET_value = @editedInsuranceLog.id
            // elsif @editedInsuranceLog.copy = 'master_physical'
            // @artwork.master_physical_insurance_id = @editedInsuranceLog.id
            // elsif @editedInsuranceLog.copy = 'archive_master'
            // @artwork.archive_master_insurance_id = @editedInsuranceLog.id
            // elsif @editedInsuranceLog.copy = 'access_copy'
            // @artwork.access_copy_insurance_id = @editedInsuranceLog.id
            // this.active_artwork_insurance_logs = this.artwork.artwork_insurance_logs
            _this4.$store.commit('UPDATE_LOG', response.data);
            _this4.active_artwork_insurance_logs = _this4.$store.state.artwork_insurance_logs;
            _this4.showUpload = !_this4.showUpload;
          }).catch(function (error) {
            // console.log(error)
            // this.errors = error.response.data;
          });
        }
        this.artwork_insurance_log = {
          storage: 'in',
          insurance_value_note: '',
          insurance_value_date: '',
          copy: 'artwork',
          insurance_valuer: '',
          reason: '',
          christies_2022_LOWER_MARKET_value: '',
          artwork_packing_id: ''
        };
      } else {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(this.$globals.apiserver + '/artwork_insurance_logs/' + this.editedInsuranceLog.id + '.json', {
          artwork_insurance_log: this.editedInsuranceLog
        }).then(function (response) {
          _this4.$emit('getArtwork');
          _this4.errors = {};
          _this4.artwork.artwork_insurance_logs = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(_this4.artwork.artwork_insurance_logs.filter(function (element) {
            return element.id !== response.data.id;
          })), [response.data]);
          _this4.artwork.christies_2022_LOWER_MARKET_value = _this4.editedInsuranceLog.christies_2022_LOWER_MARKET_value;
          // this.$store.commit("UPDATE_LOG", response.data);
          _this4.active_artwork_insurance_logs = _this4.$store.state.artwork_insurance_logs;
          // this.showUpload = !this.showUpload;
          _this4.editedInsuranceLog = {
            storage: 'in',
            insurance_value_note: '',
            insurance_value_date: '',
            change_time: '',
            copy: 'artwork',
            insurance_valuer: '',
            reason: '',
            christies_2022_LOWER_MARKET_value: '',
            artwork_packing_id: ''
          };
          _this4.editDialog = false;
        }).catch(function (error) {
          // console.log(error)
        });
      }
      // var aartwork_insurance_log = Object.keys(this.artwork_insurance_log).forEach(k => this.artwork_insurance_log[k]='')
      // console.log(aartwork_insurance_log)
    }
  }
});

/***/ }),

/***/ "fcqs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ffj8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['icon', 'title'],
  data: function data() {
    return {
      // showUpload2: this.showUpload
    };
  }
});

/***/ }),

/***/ "flFZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_artists_ViewArtworks__ = __webpack_require__("eZui");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_full_user_fields__ = __webpack_require__("LKPg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_artists_AddArtist__ = __webpack_require__("AnAQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_locations_AddLocation__ = __webpack_require__("CODS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_artworks_Upload__ = __webpack_require__("e4A6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_artworks_Location__ = __webpack_require__("KK+U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_artworks_Electrical__ = __webpack_require__("sHT9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_artworks_MarketValueHistory__ = __webpack_require__("sXdf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_artworks_NonElectrical__ = __webpack_require__("R4KG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_artworks_Films__ = __webpack_require__("iuSU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_artworks_Audio__ = __webpack_require__("XNw2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_artworks_Programme__ = __webpack_require__("5cyT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_artworks_InformationCarrier__ = __webpack_require__("qSBE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_artworks_Light__ = __webpack_require__("D2Yk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_artworks_ReadingDevices__ = __webpack_require__("54WG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_artworks_Links__ = __webpack_require__("dpcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_artworks_Costs__ = __webpack_require__("7EMl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_artworks_LoanConditions__ = __webpack_require__("P7M7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_artworks_OwnershipHistory__ = __webpack_require__("QBky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Conservation__ = __webpack_require__("SWdK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_artworks_Insurance__ = __webpack_require__("T7Bm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_querystring__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EditFieldHeader from '@/components/artists/EditFieldHeader'

// import dynamic_fields from '@/data/dynamic_fields'

























// import EditField from './EditField'

function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
function nl2br(str, is_xhtml) {
  var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'read-field',
  channels: [{ id: 1, value: '1', name: 'Single-channel' }, { id: 2, value: '2', name: 'Two-channel' }, { id: 3, value: '3', name: 'Three-channel' }, { id: 4, value: '4', name: 'Four-channel' }, { id: 5, value: '5', name: 'Five-channel' }, { id: 6, value: '6', name: 'Six-channel' }, { id: 7, value: '7', name: 'Seven-channel' }, { id: 8, value: '8', name: 'Eight-channel' }, { id: 9, value: '9', name: 'Nine-channel' }, { id: 10, value: '10', name: 'Ten-channel' }, { id: 11, value: '11', name: '11-channel' }, { id: 12, value: '12', name: '12-channel' }, { id: 13, value: '13', name: '13-channel' }, { id: 14, value: '14', name: '14-channel' }, { id: 15, value: '15', name: '15-channel' }],
  data: function data() {
    return {
      constants: __WEBPACK_IMPORTED_MODULE_21__data_constants__["a" /* default */],
      timeout: 2500,
      snackbar: false,
      progress: false,
      toggle: 0,
      switch_value: false,
      toggle_exclusive: 2,
      count: 0,
      showingAddForm: false,
      showUpload: false,
      instalation_includes: [],
      film_type: '',
      fields: __WEBPACK_IMPORTED_MODULE_2__data_full_user_fields__["a" /* default */],
      isEditing: false,
      an_exists: false,
      saved: false,
      cannotSave: false,
      value_new: '',
      select_value: '',
      field_value: '',
      show: true,
      showSnackbar: false,
      model: {},
      menu2: '',
      date: ''
      // model: "artwork_location"
      // this.f_field.show
    };
  },

  props: ['field', 'artwork', 'placeholder', 'label', 'name', 'value', 'selection', 'title', 'film', 'report', 'fields_parent'],
  mounted: function mounted() {
    this.select_value = this.f_artwork[this.f_field.name];
    if (this.f_field == 'type_of_work_id') {
      this.select_value = this.constants.TYPES_OF_WORK(this.f_artwork[this.f_field.name]).name;
    }
    this.toggle = this.f_artwork[this.f_field.name];
  },

  methods: {
    checkSubfields: function checkSubfields(event) {
      // console.log('checkSubfields')
      // console.log(event)
      this.select_value = event;
      this.saveField(this.select_value);
    },
    location_name: function location_name(id) {
      if (id > 0) {
        return this.$store.state.locations.find(function (l) {
          return l.id === id;
        }).name;
      } else {
        return 'Location not found. Probably deleted from CMS.';
      }
    }
  },
  computed: {
    toggle_value: function toggle_value() {
      var _this = this;

      var found = this.f_field.selection.find(function (f) {
        return f.value == _this.f_artwork[_this.f_field.name];
      });
      return found['name'];
    },
    select_item: function select_item() {
      var _this2 = this;

      var item = '';
      if (this.selection_items) {
        item = this.selection_items.find(function (s) {
          return s.id == _this2.value2;
        });
      }
      return item ? item.name : '';
    },

    // c_user () {
    //   return this.$store.state.user.profile
    // },
    hint: function hint() {
      var out = this.f_field.title;
      out = out + (this.f_field.hint ? ' - ' + this.f_field.hint : '');
      return out;
    },
    value2: function value2() {
      // console.log(parseInt(this.f_artwork[this.f_field.related_field],10))
      if (this.f_field.related_field) {
        return parseInt(this.f_artwork[this.f_field.related_field], 10);
      } else {
        return this.f_artwork[this.f_field.name];
      }
    },
    value_radio: function value_radio() {
      // console.log(this.f_artwork[this.f_field.name])
      return this.f_artwork[this.f_field.name];
    },
    dynamic_field_list: function dynamic_field_list() {
      var _this3 = this;

      if (this.f_field.headline) {
        var c = [];
        if (this.report) {
          var fields2 = this.fields_parent;
        } else {
          var fields2 = this.fields['tabs'][this.$store.state.currentTab]['fields'];
        }
        c = fields2.filter(function (f) {
          return f.dynamic && f.section === _this3.f_field.section;
        });
        c = c.filter(function (f) {
          return f.work_types && f.work_types.includes(_this3.artwork.classification);
        });
        return c;
      } else {
        return [];
      }
    },
    field_type: function field_type() {
      return this.f_field.etype ? this.f_field.etype : this.f_field.ctype;
    },
    selection_items: function selection_items() {
      var _this4 = this;

      if (this.f_field.table) {
        if (this.f_field.table == 'contacts') {
          var contacts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.contacts);
          if (this.f_field.column) {
            return contacts.filter(function (c) {
              return c[_this4.f_field.column] == _this4.f_field.association;
            });
          } else {
            return contacts;
          }
        } else if (this.f_field.table == 'artists') {
          var artists = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
          if (this.f_field.column) {
            return artists.filter(function (c) {
              return c[_this4.f_field.column] == c[_this4.f_field.association];
            });
          } else {
            return artists.sort(dynamicSort('name'));
          }
        } else if (this.f_field.table == 'artwork_locations') {
          var artwork_locations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.locations);
          if (this.f_field.column) {
            return artwork_locations.filter(function (c) {
              return c[_this4.f_field.column] == c[_this4.f_field.association];
            });
          } else {
            return artwork_locations.sort(dynamicSort('name'));
          }
        }
      } else if (this.f_field.constant_selection) {
        console.log('constant');
        var items = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.constants[this.f_field.constant_selection]);
        return items;
      }
      if (this.f_field.selection && this.f_field.selection.length > 0) {
        return this.f_field.selection;
      }
    },
    f_field: function f_field() {
      var f = this.field;
      f.model_string = this.field.model_string ? this.field.model_string : this.field.name;
      f.column = this.field.column ? this.field.column : false;
      // console.log(this.f_artwork[this.field.name])
      f.value_string = this.field['model_string'] ? this[this.field.model_string] : this.f_artwork[this.field.name];
      return f;
    },
    f_artwork: function f_artwork() {
      return this.artwork;
    }
  },
  components: {
    OwnershipHistory: __WEBPACK_IMPORTED_MODULE_19__components_artworks_OwnershipHistory__["a" /* default */],
    AddLocation: __WEBPACK_IMPORTED_MODULE_4__components_locations_AddLocation__["a" /* default */],
    AddArtist: __WEBPACK_IMPORTED_MODULE_3__components_artists_AddArtist__["a" /* default */],
    Costs: __WEBPACK_IMPORTED_MODULE_17__components_artworks_Costs__["a" /* default */],
    ViewArtworks: __WEBPACK_IMPORTED_MODULE_1__components_artists_ViewArtworks__["a" /* default */],
    Upload: __WEBPACK_IMPORTED_MODULE_5__components_artworks_Upload__["a" /* default */],
    Location: __WEBPACK_IMPORTED_MODULE_6__components_artworks_Location__["a" /* default */],
    Films: __WEBPACK_IMPORTED_MODULE_10__components_artworks_Films__["a" /* default */],
    Audio: __WEBPACK_IMPORTED_MODULE_11__components_artworks_Audio__["a" /* default */],
    Light: __WEBPACK_IMPORTED_MODULE_14__components_artworks_Light__["a" /* default */],
    Programme: __WEBPACK_IMPORTED_MODULE_12__components_artworks_Programme__["a" /* default */],
    InformationCarrier: __WEBPACK_IMPORTED_MODULE_13__components_artworks_InformationCarrier__["a" /* default */],
    Electrical: __WEBPACK_IMPORTED_MODULE_7__components_artworks_Electrical__["a" /* default */],
    ReadingDevices: __WEBPACK_IMPORTED_MODULE_15__components_artworks_ReadingDevices__["a" /* default */],
    Links: __WEBPACK_IMPORTED_MODULE_16__components_artworks_Links__["a" /* default */],
    Insurance: __WEBPACK_IMPORTED_MODULE_22__components_artworks_Insurance__["a" /* default */],
    NonElectrical: __WEBPACK_IMPORTED_MODULE_9__components_artworks_NonElectrical__["a" /* default */],
    LoanConditions: __WEBPACK_IMPORTED_MODULE_18__components_artworks_LoanConditions__["a" /* default */],
    Conservation: __WEBPACK_IMPORTED_MODULE_20__Conservation__["a" /* default */],
    MarketValueHistory: __WEBPACK_IMPORTED_MODULE_8__components_artworks_MarketValueHistory__["a" /* default */]
  }
});

/***/ }),

/***/ "fw0Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewArtwork_vue__ = __webpack_require__("evhW");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0378a3be_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewArtwork_vue__ = __webpack_require__("AAWU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("9PtX")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0378a3be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViewArtwork_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0378a3be_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewArtwork_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0378a3be_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViewArtwork_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "g6m4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g7NG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake__ = __webpack_require__("EWlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts__ = __webpack_require__("u1n8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts__);


//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      outputFields: ['classification'],
      output_fields: [],
      outputFieldsParams: [],
      valid: true,
      view: 'table',
      sort: 'full_name',
      title: 'LIST TITLE',
      subtitle: 'List description',
      pdf_artworks: []
    };
  },
  props: {
    light: Boolean,
    small: Boolean,
    item: Object,
    use_current_selection: Boolean
  },
  created: function created() {
    // this.pdfLabels()
  },


  methods: {
    // o2ids (array,prop) {
    //   return array.map(a => a[prop])
    // },
    // ids2o (array) {
    //   var objs = Object.assign([], this.$store.state.artworks)
    //   var out = objs.filter(a => {
    //     // console.log(array.includes(a.id))
    //     return (array.includes(a.id))
    //   })
    //   return out
    // },
    pdfLabelsCall: function pdfLabelsCall() {
      this.loading = true;
      setTimeout(function () {
        setTimeout(function () {
          this.pdfLabels();
          this.loading = false;
        }.bind(this), 0);
      }.bind(this), 500);
    },
    pdfLabels: function pdfLabels() {
      var _this = this;

      var margins = [0, 10, 0, 10];
      var output_fields = this.output_fields;
      var use_current_selection = this.use_current_selection;
      var img = 'data:image/jpeg;base64,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'.split('\n');

      function dynamicSort(property) {
        var sortOrder = 1;
        if (property[0] === '-') {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function (a, b) {
          var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
          return result * sortOrder;
        };
      }
      // console.log('labels ')
      // console.log(this.item)

      if (this.item && this.item.artworks.length > 0) {
        this.pdf_artworks = this.item.artworks;
      } else {
        // console.log(this.use_current_selection)
        if (use_current_selection == true) {
          // this.pdf_artworks = Object.assign([], this.$store.state.currentSelection)
          if (this.$store.state.currentSelection.length > 0) {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.ids2o(this.$store.state.currentSelection)).sort(dynamicSort(this.sort));
          } else {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks).sort(dynamicSort(this.sort));
          }
        } else {
          if (this.$store.state.filterResults) {
            var objs = this.ids2o(this.$store.state.filterResults);
            this.pdf_artworks = objs.sort(dynamicSort(this.sort));
          } else {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks).sort(dynamicSort(this.sort));
          }
        }
      }
      // console.log(this.pdf_artworks)

      var transformedULSData = [];
      this.pdf_artworks.forEach(function (a) {
        var o = '';
        if (typeof a == 'number') {
          o = _this.$store.state.artworks.find(function (f) {
            return f.id == a;
          });
        } else {
          o = a;
        }

        // if (a.artwork_packings != undefined) {
        var artwork_packings = _this.$store.state.packings.filter(function (p) {
          return p.artwork_id == a.id;
        });
        // console.log('artwork_packings')
        // console.log(artwork_packings)
        if (artwork_packings && artwork_packings.length > 1) {
          artwork_packings.forEach(function (ap) {
            transformedULSData.push({
              title: o.title,
              full_name: o.full_name,
              accession_number: o.accession_number,
              production_date_new: o.production_date_new ? o.production_date_new : '',
              colli: 'Colli ' + ap.colli
              // "collies": a.artwork_packings ? a.artwork_packings.length : 0
            });
          });
        } else {
          // console.log(a.artwork_packings)
          transformedULSData.push({
            title: o.title,
            full_name: o.full_name,
            accession_number: o.accession_number,
            production_date_new: o.production_date_new ? o.production_date_new : '',
            colli: 'Colli 01/01'
            // "collies": a.artwork_packings ? a.artwork_packings.length : 0
          });
        }
        // }
      });

      var asMoney = function asMoney(rawMoney) {
        return rawMoney.round(2, 1).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      };
      var makeCell = function makeCell(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ text: content }, options);
      };
      // -- Format the table cells for presentation.
      var thl = function thl(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'left', fontSize: 9 }, options));
      };
      var thr = function thr(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'right', fontSize: 9 }, options));
      };
      var tdl = function tdl(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'left', fontSize: 9 }, options));
      };
      var tdr = function tdr(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'right', fontSize: 9 }, options));
      };
      var reportDate = function reportDate() {
        return new Date();
      };

      var createDocumentDefinition = function createDocumentDefinition(reportDate, subHeading) {
        for (var _len = arguments.length, contentParts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          contentParts[_key - 2] = arguments[_key];
        }

        var _docDefinition$conten;

        var baseDocDefinition = {
          pageSize: 'A5',
          pageOrientation: 'landscape',
          info: {
            title: 'Labels A5',
            subject: 'Labels A5'
          },
          styles: {
            title: { fontSize: 33, all_caps: true },
            titleSub: { fontSize: 33 },
            bold: { fontSize: 33, bold: true, margin: [50, 0, 0, 0] },
            normal: { fontSize: 33, bold: false },
            artwork_title: { fontSize: 23, bold: false, margin: [50, 0, 0, 0] },
            an: { fontSize: 33, bold: true, margin: [50, 0, 0, 10] },
            artist_name: { fontSize: 33, bold: false, margin: [0, 25, 0, 0] },
            colli: {
              fontSize: 33,
              bold: true,
              alignment: 'right',
              margin: [0, 10, 10, 0]
            },
            image: { alignment: 'left', margin: [0, 0, 0, 40] }
          },
          content: [{
            columns: []
          }]
        };
        var docDefinition = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(baseDocDefinition));
        docDefinition.footer = baseDocDefinition.footer;
        (_docDefinition$conten = docDefinition.content).push.apply(_docDefinition$conten, contentParts);
        return docDefinition;
      };

      var rowData = function rowData(a) {
        // return a.title
        var stack = {
          stack: []
          // var columns = output_fields; //['title','full_name','accession_number'];
        };var title_and_year = a['title'] + ', ' + a['production_date_new'];

        stack.stack.push({ image: img, fit: [220, 100], style: 'image' });
        stack.stack.push({ text: a['accession_number'], style: 'an' });
        stack.stack.push({ text: a['full_name'], style: 'artwork_title' });
        stack.stack.push({ text: title_and_year, style: 'artwork_title' });
        stack.stack.push({ text: a['colli'], style: 'colli' });
        // stack.stack.push({text: a['production_date_new'], style: 'artwork_title'});

        // columns.forEach((column,index) => {
        //   var columnData = a[column];
        //   var cp = [];
        //   // console.log(a)
        //   // console.log(column)
        //   if (columnData == undefined) {
        //     stack.stack.push({text: 'no "' + column + '" data entered', style: 'normal'});
        //   } else {
        //     stack.stack.push({text: columnData, style: 'normal'});
        //   }
        // })
        // console.log(JSON.stringify(stack))
        return stack;
      };

      makeUnderlyingLoanSummaryDoc();

      function makeUnderlyingLoanSummaryDoc() {
        var tableBody = function tableBody(dataRows) {
          var body = [];
          // console.log('dataRows')
          // console.log(dataRows)

          dataRows.forEach(function (row, index) {
            var tableRow = [];
            // if (row.artwork_packings.length > 1) {
            // row.artwork_packings.forEach(ap => {
            // tableRow.push(rowData(row))
            // })
            // } else {
            tableRow.push(rowData(row));
            // }
            body.push(tableRow);
          });
          // console.log('body')
          // console.log(body)
          return body;
        };
        var tableColumnWidths = ['auto'];
        // console.log(transformedULSData)
        var tableData = {
          layout: 'noBorders',
          table: {
            heights: 300,
            dontBreakRows: false,
            margins: margins,
            widths: tableColumnWidths,
            body: tableBody(transformedULSData)
          }
          // console.log(tableData)
          // console.log('labels ')

        };var docDefinition = createDocumentDefinition(reportDate(), 'Summary', tableData);
        // pdfMake.createPdf(docDefinition).download('underlyingLoanSummary-' + reportDate() + '.pdf');
        // pdfMake.createPdf(docDefinition).open({},'pdfV')
        // document.getElementById('pdfV').src = data;

        // const pdfDocGenerator = pdfMake.createPdf(docDefinition)
        // console.log(pdfDocGenerator)
        // console.log('docDefinition')
        // console.log(docDefinition)

        __WEBPACK_IMPORTED_MODULE_2_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download('A5-labels.pdf');

        // pdfDocGenerator.getDataUrl((dataUrl) => {
        //   const targetElement = document.querySelector('#pdfLabels')
        //   // const iframe = document.createElement('iframe')
        //   targetElement.src = dataUrl
        //   // targetElement.appendChild(iframe)
        // });
        // const docDefinition = createDocumentDefinition(reportDate(), 'LIST', ' ', tableData)
        // console.log(docDefinition)
        // pdfMake.createPdf(docDefinition).download(`LISTa-${reportDate()}.pdf`)
      }
    }
  }
});

/***/ }),

/***/ "gC1K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__("NHnr");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      p: { sortBy: 'sort_name', descending: false },
      sortingStore: '',
      add_to_selection_form: false,
      search: '',
      selection_title: '',
      save_selection_form_display: false,
      selected: [],
      // artworks: Object.assign([],this.$store.state.artworks),
      // all_artworks_for_filter:  Object.assign([], this.$store.state.artworks),
      // artworks_data: this.artworks,
      query_array: [],
      menu_acq_from: false,
      menu_acq_to: false,
      query_from: '',
      query_to: '',
      text_properties: [{ name: 'Edition', value: 'edition_state' }, { name: 'Title', value: 'title' }, { name: 'Artist Name', value: 'artist' }, {
        name: 'Media material description',
        value: 'media_material_description'
      }],
      bool_properties: [{ name: 'Certificate', value: 'certificate_new' }, { name: 'Deaccessioned', value: 'deaccessioned' }, { name: 'Signature', value: 'signature_new' }, { name: 'To-Dos', value: 'todos' }],
      tableData: [],
      sortingItemsArtworks: [{ column: 'title', name: 'Title' }, { column: 'sort_name', name: 'Artist' },
      // { column: 'last_name', name: 'Last Name' },
      { column: 'accession_number_for_sorting', name: 'Accession No.' }, { column: 'acquisition_date', name: 'Acquisition Date' }, { column: 'created_at', name: 'Date added to CMS' }, { column: 'production_date_new', name: 'Production Date' }, { column: 'type_of_work_id', name: 'Type of Work' }, { column: 'visa_status', name: 'Freeport' }, { column: 'artwork_todos.length', name: 'Todos' }, { column: 'location_name', name: 'Location' }, { column: 'id', name: 'ID' }],
      headers: [
      // { sortable: false },
      { sortable: false }, { text: 'Artist', value: 'name', align: 'center' }, { text: '', value: 'full_name', align: 'center' }, { text: '', value: 'sort_name', align: 'center' }, { text: '', value: 'title', align: 'center' }, { text: 'Accession No.', value: 'accession_number', align: 'center' }, { text: 'Classification', value: 'classification', align: 'center' }, { text: 'Freeport', value: 'visa_status', align: 'center' }, {
        text: 'Todos',
        value: 'artwork_todos.filter(at => at.done != 1)',
        align: 'center'
      }],
      // headers: [
      //   { sortable: false, width: '20px'},
      //   { sortable: false, width: '20px'},
      //   {
      //     text: 'Artist',
      //     align: 'left',
      //     sortable: true,
      //     value: 'last_name'
      //   },
      //   { text: 'Acc. No.', value: 'accession_number', align: 'center' },
      //   { text: 'Class.', value: 'classification', align: 'center'},
      //   { text: 'Freeport', value: 'visa_status', align: 'center' }

      // ],
      filteredProperty: 'title',
      query: '',
      anquery1: '',
      anquery2: '',
      anquery3: '',
      anquery4: '',
      query1: '',
      activeFilters: [],
      data: []
      // inverse: false
    };
  },

  props: ['use_current_selection', 'artworks'],
  computed: {
    sorting: function sorting() {
      return this.sortingStore;
    },

    // docasne vynute
    // exhibitions () {
    //   var o = Object.assign([], this.$store.state.exhibitions)
    //   o = o.map((a) => {a.select_text = `${a.duration_start_year ? a.duration_start_year + ' - ' : ''} ${a.title.replace(/<\/?[^>]+(>|$)/g, " ")}`; return a})
    //   o = o.sort(function(a, b){ if (a.select_text < b.select_text) { return -1; } if (a.select_text > b.select_text) { return 1; } return 0})
    //   return o
    // },
    ans: function ans() {
      var o = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
      o = o.map(function (a) {
        return a = a.accession_number;
      });
      // console.log (o)
      o = o.sort(function (a, b) {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      });
      return o;
    },
    artists: function artists() {
      return this.$store.state.artists;
    },

    // artworks () { return this.$store.state.artworks },
    all_properties: function all_properties() {
      var all = this.text_properties.concat(this.bool_properties).concat([{ name: 'Production Date', value: 'production_date_new' }, { name: 'Deaccession Date', value: 'deaccession_date' }, { name: 'Acquisition Date', value: 'acquisition_date' }, { name: 'Classification', value: 'classification' }, { name: 'Classification New', value: 'classification_new_id' }, { name: 'Customs', value: 'visa_status' }, { name: 'Location', value: 'artwork_location_id' }, { name: 'Todos', value: 'todos' }, { name: 'Acquisition Method', value: 'acquisition_method' },
      // {name: 'Exhibitions', value: 'exhibitions'},
      { name: 'Ownership', value: 'ownership' }, { name: 'Aquired', value: 'acquired' }, { name: 'Accession No.', value: 'accession_number' }]);
      all.sort(function (a, b) {
        var nameA = a.name.toUpperCase();
        var nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      return all;
    },
    select_tags: function select_tags() {
      return this.$store.state.tags;
    },

    /// returns passed artworks minus deaccessioned and filtered by active filters
    filtered: function filtered() {
      var _this = this;

      // if (this.use_current_selection == true) {
      //   if (this.$store.state.currentSelection.length > 0) {
      //     var filtered = Object.assign([], this.$store.state.currentSelection)
      //   } else {
      //     var filtered = this.artworks.filter(function(a) {
      //       return (a.ownership != 6 && a.ownership != 7 && a.ownership != 8 && a.ownership != 9 && a.ownership != 10)
      //     })
      //   }
      // } else {
      //   var filtered = this.artworks.filter(function(a) {
      //       return (a.ownership != 6 && a.ownership != 7 && a.ownership != 8 && a.ownership != 9 && a.ownership != 10)
      //   })
      //     // var filtered = Object.assign([], this.$store.state.artworks)
      // }
      // console.log('FILTERBOX - filtered - artworks before filtered = ' + this.artworks.length.toString())
      if (this.c_user.roles && this.c_user.roles.find(function (f) {
        return f.shortcut == 'deac';
      })) {
        var filtered = this.artworks;
      } else {
        var filtered = this.artworks.filter(function (a) {
          return a.deaccessioned != 1;
        });
      }
      // deaccessioned=0 and (ownership is NULL or (ownership<>6 and ownership<>7 and ownership<>8 and ownership<>9 and ownership<>10))')

      // OVERIM CI DOSTAVAM ID ALEBO OBJEKT A NATIAHNEM OBJEKTY AK TREBA
      if (typeof filtered[0].id != 'number') {
        filtered = this.ids2o(this.$store.state.currentSelection);
      }

      var anquery1 = this.anquery1 ? this.anquery1 : 'xxxxxxxx';
      var anquery2 = this.anquery2 ? this.anquery2 : 'xxxxxxxx';
      var anquery3 = this.anquery3 ? this.anquery3 : 'xxxxxxxx';
      var anquery4 = this.anquery4 ? this.anquery4 : 'xxxxxxxx';

      this.activeFilters.forEach(function (filter) {
        // console.log(filter)
        filtered = filtered.filter(function (record) {
          var teststring = '';
          if (filter.name == 'artist') {
            teststring = 'record.name';
          } else {
            teststring = 'record[filter.name]';
          }
          var boolFilter = true;
          if (_this.text_properties.some(function (tp) {
            return tp.value == filter.name;
          })) {
            boolFilter = _this.text_properties.some(function (tp) {
              return tp.value == filter.name;
            }) ? filter.inverse ? !new RegExp(filter.value, 'i').test(eval(teststring)) : new RegExp(filter.value, 'i').test(eval(teststring)) : filter.inverse ? record[filter.name] == filter.value : record[filter.name] != filter.value;
          } else if (filter.name == 'classification') {
            boolFilter = filter.value_array.includes(record[filter.name]);
          } else if (filter.name == 'visa_status') {
            boolFilter = filter.value_array.includes(record[filter.name]);
          } else if (filter.name == 'ownership') {
            var boolFilter2 = filter.value_array.includes(record['ownership']);
            if (filter.value_array.includes('de')) {
              // console.log('de')
              var boolFilter1 = record['deaccessioned'] == 1;
              boolFilter = boolFilter1 || boolFilter2;
              // console.log(boolFilter1)
            } else {
              // console.log('de else')
              var boolFilter1 = record['deaccessioned'] != 1;
              boolFilter = boolFilter1 && boolFilter2;
            }
            // console.log(boolFilter2)
          } else if (filter.name == 'acquired') {
            boolFilter = filter.value_array.includes(record[filter.name]);
          } else if (filter.name == 'acquisition_method') {
            boolFilter = filter.value_array.includes(record[filter.name]);
          } else if (filter.name == 'artwork_location_id') {
            boolFilter = filter.value_array.includes(record[filter.name]);
          } else if (filter.name == 'classification_new_id') {
            boolFilter = filter.value_array.includes(record[filter.name]);
          } else if (filter.name == 'type_of_work_id') {
            boolFilter = filter.value_array.includes(record[filter.name]);
          } else if (filter.name == 'accession_number') {
            boolFilter =
            // filter.anquery1 && filter.anquery1 == record['accession_number']
            (filter.anquery1 ? new RegExp(filter.anquery1, 'i').test(record['accession_number']) : false) || (
            // filter.anquery2 && filter.anquery2 == record['accession_number']
            filter.anquery2 ? new RegExp(filter.anquery2, 'i').test(record['accession_number']) : false) || (
            // filter.anquery3 && filter.anquery3 == record['accession_number']
            filter.anquery3 ? new RegExp(filter.anquery3, 'i').test(record['accession_number']) : false) || (
            // filter.anquery4 && filter.anquery4 == record['accession_number']
            filter.anquery4 ? new RegExp(filter.anquery4, 'i').test(record['accession_number']) : false);
            console.log('boolFilter');
            // console.log(record['accession_number'])
            // console.log(this.anquery1)
            // console.log(this.anquery2)
            // console.log(this.anquery3)
            // console.log(this.anquery4)
            // console.log(boolFilter)
            // console.log(teststring)
            // console.log((new RegExp(this.query, 'i').test(record['accession_number'])))
            // console.log((new RegExp(this.query1, 'i').test(record['accession_number'])))
            // console.log((new RegExp(this.query2, 'i').test(record['accession_number'])))
            // console.log((new RegExp(this.query3, 'i').test(record['accession_number'])))
            // boolFilter = (filter.value_array.includes(record[filter.name]))
          } else if (filter.name == 'tags') {
            // POTREBUJEM ZISTIT CI ARTWORK (record.tags) MA NIEKTORU ZO ZVOLENYCH TAGOV (filter.value_array)
            // natiahnem si ID tagov pre tento artwork
            var at = record.tags.map(function (t) {
              return t.id;
            });
            boolFilter = at.some(function (t) {
              return filter.value_array.includes(t);
            });
            // var artwork_tags = Object.assign([], this.$store.state.tags.filter(t => {
            //   return t.artworks.map(a => a = a.artwork_id ).includes(record.id)
            // }))
            // artwork_tags = artwork_tags.map(a => a = a.id)
            // boolFilter = artwork_tags.filter(value => -1 !== filter.value_array.indexOf(value)).length > 0
          } else if (filter.name == 'exhibitions') {
            // console.log('filter')
            // potrebuje bool ci aktualna artwork (record) je v niektorej zo zvolenych exhibitions (filter.value_array)
            // 1. dam do noveho array vsetky artworks zo zvolenych exhibitions
            var eas = _this.$store.state.exhibitions.filter(function (e) {
              return filter.value_array.includes(e.id);
            }).map(function (e) {
              return e = e.artworks.map(function (ea) {
                return ea = ea.id;
              });
            }).flat();
            // console.log('eas')
            // console.log(eas)
            // console.log(record.id)
            // 2. zistim ci pole obsahuje aktualnu artwork (record)
            // console.log(this.$store.state.exhibitions.length)
            // natiahnem si exhibitions pre tuto artwork
            // var artworks_exhibitions = Object.assign([], this.$store.state.exhibitions.filter(e => {
            //   return e.artworks.includes(record.id)
            // }))
            // console.log(artworks_exhibitions)
            // artworks_exhibitions = artworks_exhibitions.map(a => a = a.id)
            // boolFilter = artworks_exhibitions.filter(value => -1 !== filter.value_array.indexOf(value)).length > 0
            boolFilter = eas.some(function (a) {
              return a == record.id;
            });
            // if (artworks_exhibitions.length > 0 ) {
            // console.log(artworks_exhibitions)
            // }
            // if (boolFilter){
            // console.log(filter.value_array)
            // }
            // console.log(boolFilter)

            // zistim ci je medzi nimi niektora z vybratych vo filtri
            // boolFilter = (filter.value_array.includes(record[filter.name]))
          } else if (filter.name == 'production_date_new') {
            var qf = filter.value_from == '' ? 1900 : parseInt(filter.value_from) - 1;
            var qt = filter.value_to == '' ? 2100 : parseInt(filter.value_to) + 1;
            boolFilter = record.production_date_new > qf && record.production_date_new < qt;
            if (filter.inverse) {
              boolFilter = !boolFilter;
            }
          } else if (filter.name == 'deaccession_date') {
            var qf = '';
            var qt = '';
            filter.value_from == '' ? qf = '2100-01-01' : qf = filter.value_from;
            filter.value_to == '' ? qt = '2100-01-01' : qt = filter.value_to;
            var r = new Date(record.deaccession_date);
            var f = new Date(qf);
            var t = new Date(qt);
            boolFilter = r > f && r < t;
            if (filter.inverse) {
              boolFilter = !boolFilter;
            }
          } else if (filter.name == 'acquisition_date' || filter.name == 'import_date') {
            var qf = '';
            var qt = '';
            filter.value_from == '' ? qf = '2100-01-01' : qf = filter.value_from;
            filter.value_to == '' ? qt = '2100-01-01' : qt = filter.value_to;
            var r = new Date(record[filter.name]);
            // r = r.setDate(r.getDate() + 1)
            // console.log(r)
            var f = new Date(qf);
            f = f.setDate(f.getDate() - 1);
            var t = new Date(qt);
            t = t.setDate(t.getDate() + 1);
            boolFilter = r > f && r < t;
            if (filter.inverse) {
              boolFilter = !boolFilter;
            }
          } else if (filter.name == 'location_history') {
            var qf = '';
            var qt = '';
            // filter.value_from == '' ? qf = '2100-01-01' :
            qf = filter.value_from;
            // filter.value_to == '' ? qt = '2100-01-01' :
            qt = filter.value_to;
            // var r = new Date(record.acquisition_date)
            // var f = new Date(qf)
            // var t = new Date(qt)
            boolFilter = _this.$store.state.artwork_location_logs.find(function (a) {
              return a.artwork_id == record.id && a.storage_in > qf && a.storage_out < qt;
            });
            if (filter.inverse) {
              boolFilter = !boolFilter;
            }
          } else if (_this.bool_properties.some(function (tp) {
            return tp.value == filter.name;
          })) {
            if (filter.name == 'todos') {
              boolFilter = _this.$store.state.todos.find(function (a) {
                return a.artwork_id == record.id;
              });
              if (filter.value) {
                return boolFilter;
              } else {
                return !boolFilter;
              }
            } else {
              var db2bool = false;
              if (record[filter.name] == '0' || record[filter.name] == undefined || record[filter.name] == null) {
                db2bool = false;
              } else {
                db2bool = true;
              }
              var bool2string = filter.value ? '0' : '1';
              boolFilter = db2bool == filter.value;
            }
            if (filter.inverse) {
              boolFilter = !boolFilter;
            }
          }
          return boolFilter;
        });
      });
      var arr = this.o2ids(filtered, 'id');
      // this.$store.dispatch('saveCurrentSelection',filtered)
      // var test= filtered.map(a => a=a.id)
      // console.log(arr)
      // console.log(arr)
      // console.log('FILTERBOX - filtered - artworks AFTER filtered = ' + filtered.length.toString())

      this.$store.dispatch('postFilterResults', arr);
      this.updateFilteredF(filtered);
      return filtered;
    }
  },
  methods: {
    imageUrlAlt: function imageUrlAlt(event) {
      event.target.src = '/static/no_image.jpg';
    },
    changeSort: function changeSort(a) {
      this.sortingStore = a;
      this.$store.dispatch('setSorting', {
        sorting: { section: 'lists', column: a }
      });
      this.p.sortBy = a;
      this.p.descending = !this.p.descending;
    },
    customFilter: function customFilter(items, search, filter) {
      search = search.toString().toLowerCase();
      return items.filter(function (row) {
        return filter(row['title'] + row['name'], search);
      });
    },

    // get_location_name (id) {
    //   var l = this.$store.state.locations.find(l => l.id === id)
    //   return l ? l.name : ''
    // },
    saveCurrentSelectionToUser: function saveCurrentSelectionToUser() {
      // console.log(this.selection_title)
      this.$store.dispatch('saveCurrentSelectionToUser', {
        artworks: this.$store.state.currentSelection,
        title: this.selection_title,
        created_at: new Date().toISOString().substring(0, 19).replace('T', ' ')
      });
      this.save_selection_form_display = false;
      this.selection_title = '';
    },
    clear_selection: function clear_selection() {
      this.$store.dispatch('clearCurrentSelection');
      this.selected = [];
    },

    // addToSelection (e) {
    //   this.$store.dispatch('addToCurrentSelection',e)
    // },
    save_currently_selected: function save_currently_selected(isSelected, b) {
      // console.log('--- save_currently_selected')
      // console.log('isSelected = ' + isSelected)
      // console.log('b = ' + b.id)
      setTimeout(function () {
        var tempSelection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
        // console.log(tempSelection)
        if (!isSelected) {
          // console.log('isSelected true')
          if (!tempSelection.includes(b.id)) {
            // console.log('doesnt include')
            tempSelection.push(b.id);
          }
        } else {
          // console.log('isSelected false')
          var index = tempSelection.indexOf(b.id);
          // console.log('index = ' + index)
          tempSelection.splice(index, 1);
        }
        // this.$store.state.currentSelection
        // console.log(tempSelection)
        // this.selected.forEach(s => {
        //   if (!tempSelection.includes(s)) {
        //     tempSelection.push(s)
        //   }
        // })
        // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
        this.$store.dispatch('saveCurrentSelection', tempSelection);
      }.bind(this), 1000);
    },
    o2ids: function o2ids(array, prop) {
      return array.map(function (a) {
        return a[prop];
      });
    },
    ids2o: function ids2o(array) {
      var objs = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
      var out = objs.filter(function (a) {
        // console.log(array.includes(a.id))
        return array.includes(a.id);
      });
      return out;
    },

    // function related: target_array, target_id_value, target_id_key
    related: function related(target_id_value, target_id_key) {
      var out = this.artworks.filter(function (a) {
        return a[target_id_key] == target_id_value;
      });
      return out;
    },
    keys2sentence: function keys2sentence(ks, fn) {
      // console.log(ks)
      // console.log(fn)
      var out = [];
      for (var k in ks) {
        if (fn == 'acquisition_method') {
          for (var s in this.constants.ACQUISITION_METHODS) {
            if (ks[k] == this.constants.ACQUISITION_METHODS[s].id) {
              out.push(this.constants.ACQUISITION_METHODS[s].name);
            }
          }
          // return out.join(', ')
        } else if (fn == 'visa_status') {
          for (var s in this.constants.VISA_STATUSES) {
            if (ks[k] == this.constants.VISA_STATUSES[s].id) {
              out.push(this.constants.VISA_STATUSES[s].name);
            }
          }
          // return out.join(', ')
        } else if (fn == 'artwork_location_id') {
          for (var s in this.$store.state.locations) {
            // console.log('ks[k]')
            // console.log(ks[k])
            // console.log('this.$store.state.locations[s].id')
            // console.log(this.$store.state.locations[s].id)
            if (ks[k] == this.$store.state.locations[s].id) {
              out.push(this.$store.state.locations[s].name);
            }
          }
          // console.log(out)
          // return out.join(', ')
        } else if (fn == 'accession_number') {
          out.push(ks[k]);
          // return out.join(', ')
        }
      }
      return out;
    },
    save: function save(date) {
      this.$refs.menu_acq_from.save(date);
    },
    removeArtwork: function removeArtwork(e) {
      if (this.use_current_selection == true) {
        if (this.$store.state.currentSelection.length == 1) {
          __WEBPACK_IMPORTED_MODULE_2__main__["serverBus"].$emit('setUseCurrentSelectionCheckboxToFalse', false);
        }
        this.$store.dispatch('removeFromCurrentSelection', e.id);
      } else {
        var i = this.artworks.indexOf(e);
        this.artworks.splice(i, 1);
      }
    },
    loadCurrentSelection: function loadCurrentSelection() {
      this.tableData = this.$store.state.currentSelection;
    },
    addFilter: function addFilter() {
      this.activeFilters.push({
        name: this.filteredProperty,
        value: this.query,
        value_from: this.query_from,
        value_to: this.query_to,
        value_array: this.query_array
      });
      this.query = '';
      this.query_from = '';
      this.query_to = '';
      this.query_array = [];
      this.filteredProperty = 'title';
    },
    updateFilteredF: function updateFilteredF(s) {
      // console.log(s)
      __WEBPACK_IMPORTED_MODULE_2__main__["serverBus"].$emit('updateFiltered', s);
    },
    inverse: function inverse(idx) {
      this.activeFilters.push({
        name: this.activeFilters[idx].name,
        value: this.activeFilters[idx].value,
        value_from: this.activeFilters[idx].value_from,
        value_to: this.activeFilters[idx].value_to,
        value_array: this.activeFilters[idx].value_array,
        inverse: this.activeFilters[idx].inverse ? false : true
      });
      this.activeFilters.splice(idx, 1);
      // this.query = ''
    },
    removeFilter: function removeFilter(idx) {
      this.activeFilters.splice(idx, 1);
    }
  },
  watch: {
    menu_acq_from: function menu_acq_from(val) {
      var _this2 = this;

      val && this.$nextTick(function () {
        return _this2.$refs.picker.activePicker = 'YEAR';
      });
    },
    menu_acq_to: function menu_acq_to(val) {
      var _this3 = this;

      val && this.$nextTick(function () {
        return _this3.$refs.picker.activePicker = 'YEAR';
      });
    }
  },
  created: function created() {
    var _this4 = this;

    // console.log(this.artworks.length)
    this.sortingStore = this.$store.state.sorting.lists;
    __WEBPACK_IMPORTED_MODULE_2__main__["serverBus"].$on('updateFilters', function (activeFilters) {
      _this4.activeFilters = activeFilters;
    });
  }
});

/***/ }),

/***/ "giHm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gjj0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_js_yaml__ = __webpack_require__("QKd8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_actions_auth__ = __webpack_require__("+4WN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__toolbar_items_LocationChangeDialog_vue__ = __webpack_require__("uYtP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__artworks_ListActionMenu__ = __webpack_require__("O429");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_constants__ = __webpack_require__("K30H");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import detectNetwork from 'v-offline'
// import Labels from "../lists/Labels";
// import Login from '@/components/users/Login'
// import LabelsSmall from "../lists/LabelsSmall";









function dynamicSort(property, property2) {
  console.log(property);
  console.log(property2);
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  // console.log(sortOrder)
  return function (a, b) {
    var out;
    // var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    if (new Date(a[property]) - new Date(b[property])) {
      console.log('A1');
      return 1 * sortOrder;
    }
    if (new Date(b[property]) - new Date(a[property])) {
      console.log('A-1');
      return -1 * sortOrder;
    }
    if (new Date(a[property2]) - new Date(b[property2])) {
      console.log('B1');
      return 1 * sortOrder;
    }
    if (new Date(b[property2]) - new Date(a[property2])) {
      console.log('B-1');
      return -1 * sortOrder;
    }
    // console.log(out)
    // return out
    // * sortOrder
  };
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'toolbar',
  constants: __WEBPACK_IMPORTED_MODULE_9__data_constants__["a" /* default */],
  // mounted: function () {

  // window.addEventListener('load', function() {
  // var status = document.getElementById("status");
  // var log = document.getElementById("log");

  // function updateOnlineStatus() {
  //   var condition = navigator.onLine ? "online" : "offline";

  //   this.online = navigator.onLine;
  //   // console.log('condition = ' + condition)
  //   // console.log('this.online = ' + this.online)
  // }

  // window.addEventListener('online',  updateOnlineStatus);
  // window.addEventListener('offline', updateOnlineStatus);
  // });
  // return navigator.onLine

  // },
  data: function data() {
    return {
      busTitle: '',
      progressON: false,
      savingTodo: false,
      messages: [],
      showAllTodos: false,
      sortingStore: '',
      ps: { sortBy: 'created_at', descending: true },
      tp: { sortBy: 'deadline', descending: true },
      listItems: [],
      selectionSearch: '',
      todoSearch: '',
      todoHeaders: [{ text: 'Name', value: 'title' }, { text: 'Artwork', value: 'artwork_id' }, { text: 'Deadline', value: 'deadline' }, { text: 'Created at', value: 'created_at' }],
      listHeaders: [{ text: 'Selection Name', value: 'name', align: 'left' }, { text: 'No. of Artworks', value: 'artworks.length', align: 'left' }, { text: 'Created at', value: 'created_at', align: 'right' }],
      snackbar: false,
      sTimeout: 5000,
      sColor: 'black',
      sText: 'Working on it …',
      sTextLink: '',
      sParams: '',
      sPath: '',
      todos: [],
      // sortingItems: [],
      sortingItemsArtworks: [{ column: 'title', name: 'Title' },
      // { column: "name", name: "Artist" },
      { column: 'sort_name', name: 'Artist' }, { column: 'accession_number_for_sorting', name: 'Accession No.' }, { column: 'acquisition_date', name: 'Acquisition Date' }, { column: 'created_at', name: 'Date added to CMS' }, { column: 'production_date_new', name: 'Production Date' }, { column: 'type_of_work_id', name: 'Type of Work' }, { column: 'visa_status', name: 'Freeport' }, { column: 'artwork_todos.length', name: 'Todos' }, { column: 'location_name', name: 'Location' },
      // { column: 'ownership', name: 'Collection' },
      { column: 'id', name: 'ID' }],
      sortingItemsArtists: [{ column: 'name', name: 'Name' }, { column: 'first_name', name: 'First Name' }, { column: 'last_name', name: 'Last Name' }, { column: 'sort_name', name: 'Sort Name' }, { column: 'id', name: 'ID' }],
      sortingItemsContacts: [{ column: 'name', name: 'Name' }, { column: 'company', name: 'Company' }, { column: 'category', name: 'Category' }, { column: 'artworks.length', name: 'Artworks' }],
      sortingItemsSelections: [{ column: 'name', name: 'Title' }, { column: 'artworks.length', name: 'Artworks' }, { column: 'created_at', name: 'Date Created' }, { column: 'created_by', name: 'Created By' }],
      sortingItemsTexts: [{ column: 'given_filename', name: 'Title' }, { column: 'artworks.length', name: 'Artworks' }, { column: 'category', name: 'Type of text' }, { column: 'created_at', name: 'Date Created' }, { column: 'updated_at', name: 'Date Last Modified' }, { column: 'created_by', name: 'Created By' }],
      sortingItemsTodos: [{ column: 'title', name: 'Todo' }, { column: 'artwork.title', name: 'Artwork Title' }, { column: 'artwork.accession_number', name: 'Accession No.' }, { column: 'created_at', name: 'Date Created' }, { column: 'created_by', name: 'Created By' }],
      sortingItemsExhibitions: [{ column: 'duration_start', name: 'Start Year' }, { column: 'duration_end', name: 'End Year' }, { column: 'title', name: 'Title' }, { column: 'institution', name: 'Institution' }],
      new_user: { firstname: '', lastname: '', login: '', password: '' },
      save_user_form_display: false,
      add_new: false,
      homePage: false,
      // account_menu: false,
      save_selection_error: false,
      fav: false,
      question: '',
      message_success: '',
      message_error: '',
      // c_user: {},
      loading: false,
      show: 'help',
      sections: ['Artworks', 'Artists', 'Contacts', 'Users', 'Exhibitions', 'Locations', 'Lists', 'Tags', 'Artwork Todos', 'Artwork Texts', 'Roles', 'SupportArticles', 'Journals'],
      view: 'list',
      // selected: [],
      // selection_for_adding: '',
      selections_dialog: false,
      show_change_location_dialog: false,
      selection_title: '',
      save_selection_form_display: false,
      // choose_selection_form_display: false,
      online: true,
      menu: false,
      saved_artworks: [],
      dialog: false,
      drawer: false,
      drawer2: null,
      options: this.$store.state.options,
      list: null,
      showSearch: false,
      sheet: false,
      collectionPageTitles: ['Collection', 'All Collections', 'Private Art Collection FTB', 'Private Design Collection FTB', 'Private Art Collection MR', 'Deaccessioned',
      // "Old Masters",
      'Gemini Masters', 'Gemini Collections Limited', 'Gemini Collections Deaccessioned', 'Private Design Casa Austria', 'Foreign'],
      artistPageTitles: ['Artists']
    };
  },

  props: {
    source: String
  },
  methods: {
    changeSortSelection: function changeSortSelection(column) {
      if (this.ps.sortBy === column) {
        this.ps.descending = !this.ps.descending;
      } else {
        this.ps.sortBy = column;
        this.ps.descending = false;
      }
    },
    showSnackbar: function showSnackbar(f, c) {
      var _this = this;

      // console.log("showSnackbar toolbar");
      this.snackbar = true;
      this.sText = f;
      // this.snackbarFieldName = f;
      if (c) {
        this.sColor = c;
      }
      setTimeout(function () {
        _this.sColor = 'black';
      }, 5000);
    },
    openSelectionsdialog: function openSelectionsdialog() {
      this.listItems = this.$store.state.lists;
      this.selections_dialog = true;
    },
    getColor: function getColor(t) {
      // console.log(this.format_date(Date.now()))
      // console.log(t.deadline)
      return t.deadline < this.format_date(Date.now()) ? 'red' : 'black';
    },

    // loadTodos() {
    //   // this.todos = this.$store.state.todos.map(t => t)
    //   this.todos = this.$store.state.todos
    //   this.listItems = this.$store.state.lists
    //   // .filter(item => item.created_by === this.c_user.id)
    //   //  {
    //   //     this.todos.push({
    //   //       id: item.id,
    //   //       title: item.title,
    //   //       created_by: item.created_by,
    //   //       done: item.done,
    //   //       done_at: item.done_at,
    //   //       created_at: item.created_at,
    //   //       artwork_id: item.artwork_id
    //   //     });
    //   //   }
    //   // });

    //   // this.todos = [{ id: "1147", done: null, title: "test", created_by: 1 }];
    //   // console.log("loadTodos toolbar");
    // },
    toggleTodo: function toggleTodo(tt) {
      var _this2 = this;

      this.progressON = true;
      var t = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, tt);
      // const todoIndex = this.todos.indexOf(tt);
      // this.my_todos[todoIndex].done = t.done;
      if (t.done == 0 || t.done == '') {
        t.done = 1;
        t.done_at = this.format_date(Date.now());
      } else {
        t.done = 0;
        t.done_at = null;
      }
      // console.log(t.done);
      // t.done = !t.done;
      // console.log(this.all_todos)
      // console.log(todoIndex);
      // console.log(t);
      // this.editing = true;
      // this.save_todo()
      var url = this.$globals.apiserver + '/artwork_todos/' + t.id + '.json';
      // var todoDone = {t.}
      // console.log(this.todos);
      // this.$store.dispatch('toggleTodo', tt)
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url, {
        todo: { done: t.done, done_at: t.done_at }
      }).then(function (response) {
        _this2.errors = {};
        // this.artwork.artwork_todos.push(response.data);
        // this.todos = [
        //   ...this.todos.map(item =>
        //     item.id !== t.id ? item : { ...item, ...t }
        //   )
        // ];
        _this2.showSnackbar('Todo Updated.', 'green');
        _this2.$store.dispatch('loadTodos');
        _this2.progressON = false;
        // console.log(this.artwork.artwork_todos);
        // this.todos = this.artwork.artwork_todos;
        // this.all_todos = Object.assign([],this.artwork.artwork_todos)
        // this.active_todos.push(response.data);
        // this.todos.push(response.data);
        // this.editing = false;
        // this.$store.dispatch('updateArtwork', this.artwork.id)
        // this.artwork = this.$store.state.artworks.find(
        //   a => (a.id = this.artwork.id)
        // );
      }).catch(function (error) {
        _this2.errors = error;
      });
    },
    changeSort: function changeSort(item) {
      this.sortingStore = item;
      // if (this.showViewButton) {
      //   this.sortingStore = this.$store.state.sorting.artworks;
      // } else {
      //   this.sortingStore = this.$store.state.sorting.artists;
      // }
      var section = this.$route.fullPath === '/artists' ? 'artists' : 'artworks';
      this.$store.dispatch('setSorting', {
        sorting: { section: section, column: item }
      });
      // console.log('sender')
      // console.log(item)
      __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$emit('setSorting', item);
    },
    create_user: function create_user() {
      var _this3 = this;

      this.sColor = 'black';
      this.snackbar = true;
      this.sText = 'Saving user...';
      var url = this.$globals.apiserver + '/users.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, this.new_user).then(function (response) {
        _this3.sPath = '/users/edit/' + response.data.id;
        _this3.snackbar = false;
        _this3.snackbar = true;
        _this3.sColor = 'green';
        _this3.sText = 'User Saved.';
        _this3.sTextLink = 'Edit new User.';
        _this3.result = response.data;
        // var o = Object.assign({ name: this.new_user.login})
        // this.$store.dispatch('createUser', o)
        _this3.$store.dispatch('loadUsers');
        _this3.save_user_form_display = false;
        // this.snackbar = false;
        _this3.new_user = { login: '', password: '' };
        _this3.add_new = false;
        // console.log(this.result)
        _this3.$router.push({
          name: 'EditUser',
          params: { id: _this3.result.id, user: _this3.result }
        });
      }).catch(function (error) {
        _this3.sColor = 'red';
        // console.log(error)
      });
    },
    saveAsHomePage: function saveAsHomePage() {
      // console.log(this.$route.path)
      // this.c_user.after_login_page = this.$route.path
      this.$store.dispatch('saveHomePage', this.$route.path);
    },

    // openUserSettings () {
    //   this.account_menu = false
    //   this.$router.push('/account_settings')
    // },
    send_question: function send_question() {
      var _this4 = this;

      this.loading = true;
      var question = {
        question: {
          question: this.question,
          user_id: this.c_user.id,
          url: this.$route.path
        }
      };
      var url = this.$globals.apiserver + '/questions.json';
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, question).then(function (response) {
        // console.log(response.data)
        // this.result = response.data
        _this4.question = _this4.question_c;
        _this4.message_success = 'Message sent!';
        setTimeout(function () {
          this.message_success = '';
        }.bind(_this4), 5000);
        // this.$router.push({path:`/artists/edit/${this.artist.id}`, params: {artist: this.artist}})
        _this4.loading = false;
      }).catch(function (error) {
        // console.log(error);
        _this4.message_error = 'Problem sending the question. Please use e-mail: <a href="mailto:miro.zahorak@gmail.com" >miro.zahorak@gmail.com</a>';
        setTimeout(function () {
          this.message_error = '';
        }.bind(_this4), 5000);
        _this4.loading = false;
      });
    },

    logout: function logout() {
      var _this5 = this;

      // console.log("logout");
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_4__store_actions_auth__["b" /* AUTH_LOGOUT */]).then(function () {
        // console.log("logout then");
        _this5.$router.push('/login');
      });
    },
    // all items from A will be removed if they are also in B
    // subtract_from_selection (a, b) {
    //   // console.log(a.length);
    //   // console.log(b.length);
    //   c = a.filter((n) => !b.includes(n))
    //   // console.log(c.length);
    //   return c
    // },
    clearFilters: function clearFilters() {
      this.selected_tags = [];
      this.selected_tag_categories = [];
    },
    format_date: function format_date(date, format) {
      var moment = __webpack_require__("PJh5");
      var ndate = new Date(date);
      return moment(ndate).format('YYYY-MM-DD');
    },
    getUser: function getUser(user_id) {
      var l = this.$store.state.users.find(function (u) {
        return u.id === user_id;
      });
      return l ? l : '';
    },
    ids2o: function ids2o(array) {
      var objs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
      var out = objs.filter(function (a) {
        // console.log(array.includes(a.id))
        return array.includes(a.id);
      });
      return out;
    },
    reset_store: function reset_store() {
      localStorage.clear();
      localStorage.setItem('last-reset', Date.now());
      this.$router.go('/artworks/ownership/collection');
      return false;
    },
    reload_data: function reload_data(s) {
      // console.log("load artwork texts");
      if (s === 'Users') {
        this.$store.dispatch('loadUsers');
      } else if (s === 'Artworks') {
        this.$store.dispatch('loadArtworks');
      } else if (s === 'Artwork Texts') {
        // console.log("load artwork texts");
        this.$store.dispatch('loadTexts');
      } else if (s === 'Artists') {
        this.$store.dispatch('loadArtists');
      } else if (s === 'Contacts') {
        this.$store.dispatch('loadContacts');
      } else if (s === 'Exhibitions') {
        this.$store.dispatch('loadExhibitions');
      } else if (s === 'Locations') {
        this.$store.dispatch('loadLocations');
      } else if (s === 'Lists') {
        this.$store.dispatch('loadLists');
      } else if (s === 'Tags') {
        this.$store.dispatch('loadTags');
      } else if (s === 'Artwork Todos') {
        this.$store.dispatch('loadTodos');
      } else if (s === 'Roles') {
        this.$store.dispatch('loadRoles');
      } else if (s === 'SupportArticles') {
        this.$store.dispatch('loadSupportArticles');
      } else if (s === 'Journals') {
        this.$store.dispatch('loadJournals');
      }
      return false;
    },
    test: function test() {},
    test2: function test2() {},

    // addFilteredToSelectedSelection () {
    //   this.$store.dispatch('addFilteredToSelectedSelection', { artworks: this.filtered_artworks, title: this.selection_for_adding, updated_at: (new Date()).toISOString().substring(0, 19).replace('T', ' ') })
    // },
    saveCurrentSelectionToUser: function saveCurrentSelectionToUser() {
      var _this6 = this;

      this.sColor = 'black';
      this.snackbar = true;
      this.sText = 'Saving Selection...';
      this.sTextLink = '';
      // console.log(this.selection_title)
      // console.log(this.$store.state.currentSelection)
      var url = this.$globals.apiserver + '/lists.json';
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, {
        artworks: this.$store.state.currentSelection,
        title: this.selection_title,
        user_id: this.c_user.id
      }).then(function (response) {
        _this6.snackbar = false;
        _this6.snackbar = true;
        _this6.save_selection_error = null;
        _this6.result = response.data;
        _this6.sColor = 'green';
        _this6.sPath = '/selections';
        _this6.sText = 'Selection Saved.';
        _this6.sTextLink = ' Go to Selections.';
        // console.log(this.result)
        _this6.$store.dispatch('saveCurrentSelectionToUser', {
          artworks: _this6.$store.state.currentSelection,
          name: _this6.selection_title,
          id: _this6.result['id'],
          created_at: _this6.result['created_at'],
          created_by: _this6.result['created_by']
          // new Date()
          //   .toISOString()
          //   .substring(0, 19)
          //   .replace("T", " ")
        });
        _this6.save_selection_form_display = false;
        _this6.selection_title = '';
      }).catch(function (error) {
        _this6.save_selection_error = error;
        // console.log(error);
      });
    },
    showOptions: function showOptions() {
      this.$store.dispatch('saveOptions', !this.options);
    },
    addNew: function addNew() {
      var cond = this.$route.fullPath.indexOf('exhibition');
      if (cond > 0) {
        this.$router.push('/exhibitions/new');
      } else {
        this.$store.dispatch('addNew', !this.$store.state.add_new);
      }
    },
    setShowSearch: function setShowSearch() {
      // console.log(this.$store.state.showSearch);
      // this.showSearch = !this.showSearch
      this.$store.dispatch('setShowSearch', !this.$store.state.showSearch);
    },
    switchView: function switchView() {
      // console.log(this.view)
      if (this.view === 'gallery') {
        this.$store.dispatch('saveView', 'list');
        this.view = 'list';
      } else {
        this.$store.dispatch('saveView', 'gallery');
        this.view = 'gallery';
      }
    },
    clear_selection: function clear_selection() {
      this.$store.dispatch('clearCurrentSelection');
      this.saved_artworks = [];
      __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$emit('clearCurrentSelection', true);
    },
    removeArtwork: function removeArtwork(e) {
      // console.log(e.title)
      this.$store.dispatch('removeFromCurrentSelection', e);
    },
    removeFromSelections: function removeFromSelections(e) {
      // console.log(e)
      this.$store.dispatch('removeFromSelections', e);
    },
    view_current_artworks: function view_current_artworks() {
      return this.$store.state.currentSelection;
    },
    loadSelection: function loadSelection(e) {
      // console.log(e)
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      this.$store.dispatch('saveCurrentSelection', e);
      // } else {
      //   // console.log('no add')
      //   this.$store.dispatch('addToCurrentSelection',e)
      // }
    },
    addToSelection: function addToSelection(e) {
      console.log(e);
      // console.log(add)
      // if (add) {
      //   // console.log('add')
      // this.$store.dispatch('saveCurrentSelection',e)
      // } else {
      //   // console.log('no add')
      this.$store.dispatch('addToCurrentSelection', e);
      // }
    },

    // view_current_artworks() {
    //   return this.$store.state.currentSelection
    // },
    save_artworks: function save_artworks() {
      this.saved_artworks.push(this.selected);
    }
  },
  // created() {
  // this.listItems = this.$store.getters.user_lists
  // this.setSort();
  // },
  created: function created() {
    var _this7 = this;

    __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$on('setTitle', function (a) {
      _this7.busTitle = a;
    });
    __WEBPACK_IMPORTED_MODULE_6__main__["serverBus"].$on('showSnackbar', function (a, b) {
      _this7.showSnackbar(a, b);
    });
    // if (this.c_user.roles.includes('todos')) {
    // console.log('created')
    // this.loadTodos()
    // }
    // this.c_user = this.$store.state.user.profile
    this.listItems = this.$store.state.lists;
    this.todos = this.$store.state.todos;
    // console.log(this.todos)
    this.question = this.question_c;
    if (this.showViewButton) {
      this.sortingStore = this.$store.state.sorting.artworks;
    } else {
      this.sortingStore = this.$store.state.sorting.artists;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    selections: function selections() {
      return this.listItems;
    },
    my_todos: function my_todos() {
      var _this8 = this;

      // console.log('my_todos')
      if (this.showAllTodos) {
        return this.$store.state.todos.filter(function (item) {
          return item.done !== 1;
        });
        // .sort(function(a, b) {
        //   return a.deadline ? a.deadline.localeCompare(b.deadline) : -1
        // })
      } else {
        return this.$store.state.todos.filter(function (item) {
          return item.created_by === _this8.c_user.id && item.done !== 1;
        });
        // .sort(dynamicSort('deadline', 'created_at'))
      }
      // item.created_by == this.c_user.id &&
    },
    my_late_todos: function my_late_todos() {
      // console.log('my_late_todos')
      var d = new Date();
      var currentDate = d.toISOString().split('T')[0] + ' ' + d.toTimeString().split(' ')[0];
      return this.my_todos.filter(function (item) {
        // if(item.deadline) {
        // console.log('item')
        // console.log(item.deadline)
        // console.log(Date.now())
        // console.log(currentDate)
        // console.log(item.deadline < currentDate)
        // }
        return item.deadline != null && item.deadline < currentDate;
      });
    },

    // userTodos() {
    //   return Object.assign([], this.$store.state.todos).filter(
    //     t => t.created_by == this.c_user.id
    //   );
    // },
    sortingItems: function sortingItems() {
      var _this9 = this;

      // console.log(this.page_title)
      if (this.showViewButton || ['Commissions', 'Non-TBA'].some(function (x) {
        return x == _this9.page_title;
      })) {
        return this.sortingItemsArtworks;
      } else if (this.page_title == 'Artists') {
        return this.sortingItemsArtists;
      } else if (this.page_title == 'Contacts') {
        return this.sortingItemsContacts;
      } else if (this.page_title == 'Selections') {
        return this.sortingItemsSelections;
      } else if (this.page_title == 'Todos') {
        return this.sortingItemsTodos;
      } else if (this.page_title == 'Texts') {
        return this.sortingItemsTexts;
      } else if (this.page_title == 'Exhibitions') {
        return this.sortingItemsExhibitions;
      }
    },
    showOptionsButton: function showOptionsButton() {
      var _this10 = this;

      return !['Exhibitions - Add New', 'Reports', 'Artworks', 'Facts', 'Artists', 'Exhibitions', 'Contacts', 'Contacts - Add New', 'Texts - Add New', 'Articles', 'Locations', 'CMS Users', 'Facts, Figures and System'].some(function (x) {
        return x === _this10.page_title;
      });
    },
    showViewButton: function showViewButton() {
      var _this11 = this;

      return this.collectionPageTitles.some(function (x) {
        return x === _this11.page_title;
      });
    },
    showSearchButton: function showSearchButton() {
      var _this12 = this;

      return !['Reports', 'Edit Artist', 'Facts', 'Artworks - Add New', 'Exhibitions - Add New', 'Locations - Add New', 'CMS Users - Add New', 'Contacts - Add New', 'Texts - Add New', 'CMS Users Edit', 'Artworks'].some(function (x) {
        return x == _this12.page_title;
      });
    },
    showSortButton: function showSortButton() {
      var _this13 = this;

      return this.collectionPageTitles.some(function (x) {
        return x == _this13.page_title;
      }) || this.artistPageTitles.some(function (x) {
        return x == _this13.page_title;
      }) || ['Commissions', 'Non-TBA', 'Contacts', 'Selections', 'Todos', 'Exhibitions', 'Texts'].some(function (x) {
        return x == _this13.page_title;
      });
      // 'Exhibitions','Tags','Contacts','Locations','CMS Users',
    },
    sorting: function sorting() {
      return this.sortingStore;
    },
    homePage_c: function homePage_c() {
      return this.c_user.after_login_page === this.$route.path;
    },

    // my_todos() {
    //   console.log(this.c_user.id )
    //   console.log(this.todos)
    //   return this.todos.filter(
    //     t => t.created_by == this.c_user.id && (t.done === false || t.done === null)
    //   )
    //   // console.log(filtered)
    //   .sort(function(a, b) {
    //     return new Date(b.created_at) - new Date(a.created_at);
    //   });
    //   // sort((a,b) => { return a.deadline < b.deadline}).
    //   // console.log(sorted)
    //   // return sorted.slice(0, 10);
    //   // return sorted
    // },
    question_c: function question_c() {
      var q = 'Hello, developer, I have a question regarding section "' + this.page_title + '".\r\r … describe question here … \r\r' + this.c_user.firstname;
      this.question = q;
      return q;
    },
    site_support_article: function site_support_article() {
      var sas = this.$store.state.support_articles.filter(function (sa) {
        return sa.show_in_route;
      });
      // REMOVE TRAILING ID FROM PATH
      var p = this.$route.path.replace(/\d+$/, '');
      var a = sas.find(function (sa) {
        return __WEBPACK_IMPORTED_MODULE_2_js_yaml__["a" /* default */].load(sa.show_in_route).some(function (s) {
          return s.includes(p);
        });
      });
      return a;
    },
    user_items: function user_items() {
      // if (!this.c_user) {
      // this.c_user = this.$store.state.user.profile
      // }
      var newitems = [];
      // let items2 = Object.entries(this.items)
      var cu = this.c_user;
      var items_temp = __WEBPACK_IMPORTED_MODULE_9__data_constants__["a" /* default */].TOOLBAR_MENU_ITEMS.filter(function (i) {
        return cu.roles && cu.roles.some(function (rs) {
          return rs.shortcut == i.role;
        }) || i.text == 'Collections';
      });

      items_temp.forEach(function (item, index, array) {
        if (cu.edit || !item.edit_only && !cu.edit) {
          if (item.children && cu.roles) {
            item.children = item.children.filter(function (ic) {
              return cu.roles.some(function (ur) {
                return ur.shortcut == ic.role;
              });
            });
          }
          // else {
          //   item.children = null
          // }
          newitems.push(item);
        }
        // newitems.push(this.items[item].children = children)
        // var a = newitems
      });
      // let newitems = this.items.filter(i => i.children.filter(ic => this.$store.state.user.roles.some(i.role)) this.$store.state.user.roles.some(i.role))
      // let newitems = this.items.filter(i => i.children.filter(ic => ic.icon == 'people'))
      return newitems;
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['getProfile', 'isAuthenticated', 'isProfileLoaded']), Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["c" /* mapState */])({
    authLoading: function authLoading(state) {
      return state.auth.status === 'loading';
    },
    name: function name(state) {
      return state.user.profile.title + ' ' + state.user.profile.name;
    }
  }), {
    page_title: function page_title() {
      var title = '';
      if (this.busTitle) {
        title = this.busTitle;
      } else {
        // if (this.$route.fullPath == "/artworks/ownership/oldMasters") {
        //   title = "Old Masters";
        // } else
        if (this.$route.fullPath === '/artworks/ownership/deaccession') {
          title = 'Deaccessioned';
        } else if (this.$route.fullPath === '/artworks/ownership/collection') {
          title = 'Collection';
        } else if (this.$route.fullPath === '/artworks/ownership/all') {
          title = 'All Collections';
        } else if (this.$route.fullPath === '/artworks/ownership/pacFvh') {
          title = 'Private Art Collection FTB';
        } else if (this.$route.fullPath === '/artworks/ownership/gemini') {
          title = 'Gemini Masters';
        } else if (this.$route.fullPath === '/artworks/ownership/geminiCL') {
          title = 'Gemini Collections Limited';
        } else if (this.$route.fullPath === '/artworks/ownership/geminiCD') {
          title = 'Gemini Collections Deaccessioned';
        } else if (this.$route.fullPath === '/artworks/ownership/pdcFvh') {
          title = 'Private Design Collection FTB';
        } else if (this.$route.fullPath === '/artworks/ownership/pcCA') {
          title = 'Private Design Casa Austria';
        } else if (this.$route.fullPath === '/artworks/ownership/pacMr') {
          title = 'Private Art Collection MR';
        } else if (this.$route.fullPath === '/artworks/ownership/pcFT') {
          title = 'Private Collection FT';
        } else if (this.$route.fullPath === '/artworks/ownership/pacEh') {
          title = 'Private Art Collection EH';
        } else if (this.$route.fullPath === '/artworks/ownership/foreign') {
          title = 'Foreign';
        } else if (this.$route.fullPath === '/artworks/ownership/commissions') {
          title = 'Commissions';
        } else if (this.$route.fullPath === '/artworks/ownership/nonTba') {
          title = 'Non-TBA';
        } else if (this.$route.fullPath === '/artworks/ownership/com_academy') {
          title = 'Academy Commissions';
        } else if (this.$route.fullPath === '/artworks/filter/drawings') {
          title = 'Drawings';
        } else if (this.$route.fullPath === '/artworks/filter/paintings') {
          title = 'Paintings';
        } else if (this.$route.fullPath === '/artworks/filter/photographs') {
          title = 'Photo | Print';
        } else if (this.$route.fullPath === '/artworks/filter/videos') {
          title = 'Film / Video';
        } else if (this.$route.fullPath === '/artworks/filter/objectsAndSculptures') {
          title = 'Objects/Sculptures';
        } else if (this.$route.fullPath === '/artworks/filter/sound') {
          title = 'Sound';
        } else if (this.$route.fullPath === '/artists') {
          title = 'Artists';
        } else if (this.$route.name === 'EditArtist') {
          title = 'Edit Artist';
        } else if (this.$route.fullPath === '/tags') {
          title = 'Tags';
        } else if (this.$route.fullPath === '/facts') {
          title = 'Facts';
        } else if (this.$route.fullPath === '/contacts') {
          title = 'Contacts';
        } else if (this.$route.fullPath === '/exhibitions') {
          title = 'Exhibitions';
        } else if (this.$route.name === 'EditExhibition') {
          title = 'Exhibitions';
        } else if (this.$route.name === 'EditArtwork') {
          title = 'Artworks';
        } else if (this.$route.name === 'EditUser') {
          title = 'CMS Users Edit';
        } else if (this.$route.name === 'EditArtwork') {
          title = 'Artworks';
        } else if (this.$route.name === 'EditContact') {
          title = 'Contacts';
        } else if (this.$route.name === 'EditArticle') {
          title = 'Article';
        } else if (this.$route.name === 'AddExhibition') {
          title = 'Exhibitions - Add New';
        } else if (this.$route.name === 'AddArtwork') {
          title = 'Artworks - Add New';
        } else if (this.$route.name === 'AddLocation') {
          title = 'Locations - Add New';
        } else if (this.$route.name === 'AddContact') {
          title = 'Contacts - Add New';
        } else if (this.$route.name === 'AddText') {
          title = 'Texts - Add New';
        } else if (this.$route.name === 'AddArtist') {
          title = 'Artists - Add New';
        } else if (this.$route.fullPath === '/lists') {
          title = 'Lists';
        } else if (this.$route.fullPath === '/users') {
          title = 'CMS Users';
        } else if (this.$route.fullPath === '/users/new') {
          title = 'CMS Users - Add New';
        } else if (this.$route.fullPath === '/reports/new') {
          title = 'Reports';
        } else if (this.$route.fullPath === '/locations') {
          title = 'Locations';
        } else if (this.$route.name === 'EditLocation') {
          title = 'Locations';
        } else if (this.$route.fullPath === '/selections') {
          title = 'Selections';
        } else if (this.$route.fullPath === '/todos') {
          title = 'Todos';
        } else if (this.$route.fullPath === '/todos/new') {
          title = 'Todos - Create New';
        } else if (this.$route.fullPath === '/articles') {
          title = 'Articles';
        } else if (this.$route.fullPath === '/texts') {
          title = 'Texts';
        } else if (this.$route.fullPath === '/texts/new') {
          title = 'Texts';
        } else if (this.$route.name === 'EditText') {
          title = 'Texts';
        } else if (this.$route.fullPath === '/artworks/ownership/collection') {
          title = 'Collection';
        }
      }
      return title;
    },
    page_link: function page_link() {
      var link = '';
      if (this.$route.name === 'EditExhibition') {
        link = '/exhibitions';
      } else if (this.$route.name === 'EditArtwork') {
        link = '/artworks/ownership/collection';
      } else if (this.$route.name === 'EditArtist') {
        link = '/artists';
      } else if (this.$route.name === 'EditLocation') {
        link = '/locations';
      } else if (this.$route.name === 'AddExhibition') {
        link = '/exhibitions';
      } else if (this.$route.name === 'AddArtwork') {
        link = '/artworks/ownership/collection';
      } else if (this.$route.name === 'AddLocation') {
        link = '/locations';
      } else if (this.$route.fullPath === '/users/new') {
        link = '/users';
      } else if (this.$route.name === 'EditUser') {
        link = '/users';
      } else if (this.$route.fullPath === '/reports/new') {
        link = '/reports';
      } else if (this.$route.name === 'EditText') {
        link = '/texts';
      } else if (this.$route.name === 'AddContact') {
        link = '/contacts';
      } else if (this.$route.name === 'EditContact') {
        link = '/contacts';
      } else if (this.$route.fullPath === '/texts/new') {
        link = '/texts';
      } else if (this.$route.fullPath === '/') {
        link = '/artworks/ownership/collection';
      }
      return link;
    },
    select_tags: function select_tags() {
      var stc = this.selected_tag_categories;
      var tc = this.tag_categories;
      var tags = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.tags);
      var out = [];
      // console.log(tags)
      tags.forEach(function (tag) {
        var a = tc.filter(function (tagc) {
          return tagc.id == tag.tag_category_id;
        });
        // console.log(a[0].color)
        tag.color = a[0].color;
        out.push(tag);
      });
      // console.log(out)
      return out.filter(function (tag) {
        return stc.some(function (st) {
          return tag.tag_category_id == st;
        });
      });

      // return out
    },
    artworks_selections: function artworks_selections() {
      // for (var b in this.$store.state.artworks_selections) {
      // console.log(this.$store.state.artworks_selections[b])
      // }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.getters.user_lists).reverse();
    },
    selected: function selected() {
      return this.ids2o(this.$store.state.currentSelection);
      // },
      // filtered() {
      //   return this.ids2o(this.$store.state.filterResults)
    }
  }),
  components: { ListActionMenu: __WEBPACK_IMPORTED_MODULE_8__artworks_ListActionMenu__["a" /* default */], LocationChangeDialog: __WEBPACK_IMPORTED_MODULE_7__toolbar_items_LocationChangeDialog_vue__["a" /* default */] }
});

/***/ }),

/***/ "gr3N":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h/wv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h4Ft":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBox_vue__ = __webpack_require__("+lYf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b4002a3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBox_vue__ = __webpack_require__("JkNV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("L642")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6b4002a3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FilterBox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b4002a3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBox_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b4002a3_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FilterBox_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "h7z0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":_vm.generatePDF}},[_vm._v("TEST")])}
var staticRenderFns = []


/***/ }),

/***/ "h8q7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.f_field.headline)?_c('div',{staticClass:"mt-4 mb-3"},[_c('v-flex',{staticClass:"px-3 py-2 elevation-3 xs12",staticStyle:{"background-color":"#e2e2e2"}},[_c('h3',{staticClass:"subtitle xs12 flex"},[_vm._v("\n        "+_vm._s(_vm.f_field.title)+" \n        "),_c('v-menu',{staticClass:"right mb-1",attrs:{"offset-y":""}},[_c('v-btn',{staticClass:"mt-0 mb-0",attrs:{"slot":"activator","color":"grey lighten-2","small":"","icon":""},slot:"activator"},[_c('v-icon',{attrs:{"small":"","color":"grey lighten-5"}},[_vm._v("add")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.dynamic_field_list),function(item){return _c('v-list-tile',{key:item.name,on:{"click":function($event){return _vm.add_field(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)}),1)],1)],1)])],1):_vm._e(),_vm._v(" "),(_vm.f_field.component)?_c('div',{staticClass:"mt-2 mb-2 mx-0"},[_c('v-flex',{staticClass:"px-3 py-2 elevation-1 xs12",staticStyle:{"background-color":"#fafafa"}},[_c('h3',{staticClass:"subtitle xs12 flex"},[_vm._v(_vm._s(_vm.f_field.title)+"  ("+_vm._s(_vm.count)+")\n          "),_c('v-btn',{staticClass:"right mt-0 mb-0",attrs:{"color":"grey lighten-5","small":"","icon":""},on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[(!_vm.showUpload)?_c('v-icon',{attrs:{"small":""}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.showUpload)?_c('v-icon',{attrs:{"small":"","dark":""}},[_vm._v("expand_less")]):_vm._e()],1)],1),_vm._v(" "),(_vm.showUpload)?_c(_vm.f_field.component,{tag:"component",attrs:{"uploadCategory":_vm.f_field.title,"artwork":_vm.f_artwork,"name":_vm.f_field.name}}):_vm._e()],1)],1):_c('div',[(_vm.field_type=='text-short')?_c('v-flex',[_c('v-flex',[_c('label',[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('v-text-field',{ref:_vm.f_field.name,attrs:{"solo":"","name":_vm.f_field.name,"hint":("" + (_vm.f_field.title)),"persistent-hint":"","suffix":_vm.f_field.suffix,"append-outer-icon":"remove"},on:{"click:append-outer":function($event){return _vm.removeField(_vm.f_field)}},nativeOn:{"input":function($event){return _vm.$emit('input',$event.target.value)}},model:{value:(_vm.electrical.production_date),callback:function ($$v) {_vm.$set(_vm.electrical, "production_date", $$v)},expression:"electrical.production_date"}}),_vm._v(" "),(_vm.an_exists)?_c('div',[_vm._v("This accession number already exists!")]):_vm._e(),_vm._v(" "),(_vm.saved)?_c('div',{staticClass:"ml-3"},[_vm._v("Value was saved!")]):_vm._e(),_vm._v(" "),(_vm.cannotSave)?_c('div',{staticClass:"ml-3"},[_vm._v("Value already exists! Cannot save!")]):_vm._e()],1)],1):(this.field_type=='text-long')?_c('v-flex',{staticClass:"my-0 py-0"},[_c('v-textarea',{ref:_vm.f_field.name,staticClass:"my-0",attrs:{"auto-grow":"","solo":"","name":_vm.f_field.name,"rows":"1","value":("" + (_vm.f_artwork[_vm.f_field.name])),"hint":_vm.f_field.title,"persistent-hint":"","append-outer-icon":"remove"},on:{"click:append-outer":function($event){return _vm.removeField(_vm.f_field)}},nativeOn:{"input":function($event){return _vm.$emit('input',$event.target.value)}}})],1):(this.field_type=='date')?_c('v-container',{class:((_vm.f_field.class) + " my-0 py-0"),attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"xs12":"","md6":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{ref:_vm.f_field.name,attrs:{"solo":"","type":"number","mask":"####","max":"2019","min":"1900","name":_vm.f_field.name,"value":("" + (_vm.f_artwork[_vm.f_field.name])),"label":"Year","placeholder":"Year","hint":"Year"},nativeOn:{"input":function($event){return _vm.$emit('input',$event.target.value)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{ref:_vm.f_field.name,attrs:{"solo":"","type":"number","mask":"##","max":"12","name":_vm.f_field.name,"value":("" + (_vm.f_artwork[_vm.f_field.name])),"label":"Month","placeholder":"Month","hint":"Month"},nativeOn:{"input":function($event){return _vm.$emit('input',$event.target.value)}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"solo":"","type":"number","mask":"##","max":"31","name":_vm.name,"value":("" + (_vm.f_artwork[_vm.f_field.name])),"label":"Day","placeholder":"Day","hint":"Day"},nativeOn:{"input":function($event){return _vm.$emit('input',$event.target.value)}}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"my-0 py-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"my-0 py-0",attrs:{"xs12":""}},[_c('label',{staticClass:"my-0 py-0 pl-2"},[_vm._v(_vm._s(_vm.f_field.title)+"  "+_vm._s(_vm.f_artwork[_vm.f_field.name])+" ")]),_vm._v(" "),(_vm.f_field.dynamic)?_c('v-btn',{staticClass:"ml-3",attrs:{"icon":""},on:{"click":function($event){return _vm.removeField(_vm.f_field)}}},[_c('v-icon',[_vm._v("remove")])],1):_vm._e()],1)],1)],1):(this.field_type=='bool')?_c('v-flex',{staticClass:"pl-4 pr-4"},[_c('v-switch',{attrs:{"v-model":("" + (_vm.f_field.name)),"label":("" + (_vm.f_field.title)),"color":"black","append-icon":"remove"},on:{"click:append":function($event){return _vm.removeField(_vm.f_field)}}})],1):(this.field_type=='radio')?_c('v-flex',[_c('v-radio-group',{attrs:{"label":("" + (_vm.f_field.title)),"column":_vm.f_field.column ? _vm.f_field.column : false,"refs":_vm.f_field.name,"append-icon":"remove"},on:{"click:append":function($event){return _vm.removeField(_vm.f_field)}},model:{value:(_vm.value_new),callback:function ($$v) {_vm.value_new=$$v},expression:"value_new"}},_vm._l((_vm.f_field.selection),function(s){return _c('v-radio',{key:s.id,staticClass:"ml-3",attrs:{"label":s.name,"value":s.id}})}),1),_vm._v(" "),(_vm.f_field.name=='sound' && this.value_new=='1')?_c('v-flex',{staticClass:"elevation-3 py-3 px-3"},[_c('v-flex',{attrs:{"c":""}},[_c('v-text-field',{attrs:{"label":"Audio Codec","row":""},model:{value:(_vm.audio_codec),callback:function ($$v) {_vm.audio_codec=$$v},expression:"audio_codec"}})],1),_vm._v(" "),(_vm.f_field.name=='sound' && this.value_new=='1')?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Audio Resolution","row":""},model:{value:(_vm.audio_resolution),callback:function ($$v) {_vm.audio_resolution=$$v},expression:"audio_resolution"}},_vm._l((['32 kHz','44,1 kHz','48 kHz','96 kHz','192 kHz']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.f_field.name=='sound' && this.value_new=='1')?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Audio Bit","row":""},model:{value:(_vm.audio_bit),callback:function ($$v) {_vm.audio_bit=$$v},expression:"audio_bit"}},_vm._l((['16 Bit','20 Bit','24 Bit']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.f_field.name=='sound' && this.value_new=='1')?_c('v-flex',[_c('v-select',{staticClass:"ml-3",attrs:{"items":_vm.channels,"item-value":"id","item-text":"name","label":"Channels"}})],1):_vm._e(),_vm._v(" "),(_vm.f_field.name=='sound' && this.value_new=='1')?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Audio Specs","row":""},model:{value:(_vm.audio_specs),callback:function ($$v) {_vm.audio_specs=$$v},expression:"audio_specs"}},_vm._l((['light optical tone','magnetic','digital','unknown','other']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e()],1):_vm._e()],1):(_vm.f_field.etype==='select')?_c('v-flex',[_c('v-select',{attrs:{"solo":"","items":this.selection_items,"label":("" + (_vm.f_field.title)),"item-text":"name","item-value":"id","append-outer-icon":_vm.f_field.addNew ? 'add' : '',"preppend-icon":_vm.f_field.preicon,"append-icon":"remove"},on:{"click:append-outer":_vm.showAddForm,"click:append":function($event){return _vm.removeField(_vm.f_field)}},model:{value:(_vm.value_new),callback:function ($$v) {_vm.value_new=$$v},expression:"value_new"}}),_vm._v(" "),(_vm.f_field.name=='classification_new_id' && this.value_new=='film')?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Select Film Type","row":""},model:{value:(_vm.film_type),callback:function ($$v) {_vm.film_type=$$v},expression:"film_type"}},_vm._l((['tape','film','digital born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.f_field.name=='classification_new_id' && this.value_new=='inst')?_c('v-flex',[_vm._l((['Objects','Sound','FilmVideoAV','Slide','ComputerProgramSoftwareFile','Performance','Light','Other']),function(s){return _c('v-checkbox',{key:s,attrs:{"label":s,"value":s,"hide-details":""},model:{value:(_vm.instalation_includes),callback:function ($$v) {_vm.instalation_includes=$$v},expression:"instalation_includes"}})}),_vm._v(" "),(this.instalation_includes.indexOf('FilmVideoAV')>=0)?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Select Film Type","row":""},model:{value:(_vm.film_type),callback:function ($$v) {_vm.film_type=$$v},expression:"film_type"}},_vm._l((['tape','film','digital born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s}})}),1)],1):_vm._e()],2):_vm._e()],1):(_vm.f_field.etype==='autocomplete')?_c('v-flex',[_c('v-autocomplete',{attrs:{"solo":"","items":this.selection_items,"label":("" + (_vm.f_field.title)),"item-text":"name","item-value":"id","chips":_vm.f_field.chips,"multiple":_vm.f_field.multiple,"append-icon":"remove"},on:{"click:append":function($event){return _vm.removeField(_vm.f_field)}},model:{value:(_vm.value_new),callback:function ($$v) {_vm.value_new=$$v},expression:"value_new"}})],1):_vm._e(),_vm._v(" "),(this.showingAddForm && _vm.f_field.addNew)?_c('v-flex',[(_vm.f_field.table=='artists')?_c('add-artist',{attrs:{"itemToAdd":"f_field"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(this.showingAddForm && _vm.f_field.addNew)?_c('v-flex',[(_vm.f_field.table=='artwork_locations')?_c('add-location',{attrs:{"itemToAdd":"f_field"}}):_vm._e()],1):_vm._e()],1)])}
var staticRenderFns = []


/***/ }),

/***/ "hBhP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUser_vue__ = __webpack_require__("IWvq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ad3a98c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUser_vue__ = __webpack_require__("yAI7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("T+xc")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1ad3a98c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ad3a98c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUser_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ad3a98c_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUser_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hD92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArtwork_vue__ = __webpack_require__("6d6P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63706bf2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArtwork_vue__ = __webpack_require__("AS+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("TOiM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-63706bf2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArtwork_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63706bf2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArtwork_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63706bf2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArtwork_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "hDkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artist', 'artworks', 'exhibition_id'],
  computed: {
    table_artworks: function table_artworks() {
      // console.log('this.artworks')
      // console.log(this.artworks)
      // console.log(this.artworks.map(am => am.id))
      // console.log(this.$store.state.artworks.filter(a => (this.artworks.map(am => am.id)).includes(a.id)))
      var eas = this.artworks.map(function (am) {
        return am.id;
      });
      // console.log(eas)
      var o = this.$store.state.artworks.filter(function (a) {
        return eas.includes(a.id);
      });
      // console.log(o)
      return o;
    }
  },
  methods: {
    remove_from_exhibition: function remove_from_exhibition(artwork_id) {
      var _this = this;

      // console.log(list_id)
      // console.log(artwork_id)
      var exhibition = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.exhibitions.find(function (e) {
        return e.id == _this.exhibition_id;
      }));
      // console.log(list)
      exhibition.artworks = exhibition.artworks.filter(function (a) {
        return a != artwork_id;
      });
      // let url = `${this.$globals.apiserver}/lists.json`
      // axios.post(url).then((response) => {
      //   this.loading = false;
      // this.resultsArtists = response.data
      this.$store.dispatch('removeArtworkFromExhibition', { e: this.exhibition_id, a: artwork_id });
      // this.displayedData = response.data

      // }).catch((error) => { console.log(error) })
      // console.log(exhibition)
    },
    artist_artworks: function artist_artworks(artist_id) {
      var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
      // console.log('artist_id')
      // console.log(artist_id)
      // console.log(a.artist_id == artist_id)
      var aa = a.filter(function (a) {
        // console.log('a.artist_id')
        // console.log(a.artist_id)
        // console.log(artist_id)
        return a.artist_id === artist_id;
      });
      // console.log(aa)
      return aa;
    },
    clear_selection: function clear_selection() {
      this.$store.dispatch('clearCurrentSelection');
      this.selected = [];
    },
    select_all: function select_all() {},
    save_currently_selected: function save_currently_selected(a, b) {
      // console.log('///////////')
      // console.log('a = ' + a)
      // console.log('b = ' + b.id)
      setTimeout(function () {
        var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
        //// console.log(temp_selection)
        if (!a) {
          // console.log('a true')
          if (!temp_selection.includes(b)) {
            // console.log('doesnt include')
            temp_selection.push(b);
          }
        } else {
          // console.log('false')
          var index = temp_selection.indexOf(b);
          // console.log('index = ' + index)
          temp_selection.splice(index, 1);
        }
        // this.$store.state.currentSelection
        // console.log(temp_selection)
        // this.selected.forEach(s => {
        //   if (!temp_selection.includes(s)) {
        //     temp_selection.push(s)
        //   }
        // })
        // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
        this.$store.dispatch('saveCurrentSelection', temp_selection);
      }.bind(this), 1000);
    },
    save_currently_selected_all: function save_currently_selected_all(a) {
      // console.log('///////////')
      // console.log('a = ' + a)
      var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(temp_selection)
      if (!a) {
        // console.log('a true')
        if (!temp_selection.includes(b)) {
          // console.log('doesnt include')
          temp_selection.push(b);
        }
      } else {
        // console.log('false')
        var index = temp_selection.indexOf(b);
        // console.log('index = ' + index)
        temp_selection.splice(index, 1);
      }
      // this.$store.state.currentSelection
      // console.log(temp_selection)
      // this.selected.forEach(s => {
      //   if (!temp_selection.includes(s)) {
      //     temp_selection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', temp_selection);
    },
    save_currently_selected_tags: function save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags);
      this.ta = this.tagged_artworks;
    }
  }
});

/***/ }),

/***/ "hK9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.artist.full_name)+" "+_vm._s(_vm.artist.last_name))]),_vm._v(" "),_c('div',{staticClass:"deactivate_btn"},[_c('a',{staticClass:"pri_btn d_btn",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm._toggle.apply(null, arguments)}}},[_vm._v("Edit")])])],1)])])}
var staticRenderFns = []


/***/ }),

/***/ "hPAF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__ = __webpack_require__("EWlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_ListsMixin__ = __webpack_require__("ml9J");


//
//
//
//
//
//
//
//
//
//
//
//



// import pdfFonts from 'pdfmake/build/vfs_fonts'
// import { serverBus } from '../../main'



// pdfMake.vfs = pdfFonts.pdfMake.vfs

function dynamicSort(property, property2) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    // var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    if (a[property] > b[property]) return 1;
    if (a[property] < b[property]) return -1;
    if (a[property2] > b[property2]) return 1;
    if (a[property2] < b[property2]) return -1;
    // return result * sortOrder;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_ListsMixin__["a" /* default */]],
  props: ['item', 'small', 'light', 'title', 'subtitle', 'created_by', 'created_at', 'page_no', 'showNoOfArtworks', 'sort', 'subsort', 'columns'],
  data: function data() {
    return {
      // output_fields: [],
      constants: __WEBPACK_IMPORTED_MODULE_2__data_constants__["a" /* default */],
      loading: false,
      outputFields: ['classification', 'ownership'],
      output_fields: [],
      list_settings: {
        use_current_selection: false,
        use_current_list_selection: false,
        financial_information: false,
        image: false,
        compact: false,
        table: true,
        view: 'table',
        sort: 'sort_name',
        add_empty_column: false
      },
      add_empty_column: false,
      imageSize1: '240',
      imageSize2: '240',
      pdf_artworks: []
    };
  },
  // props: ['list', 'index', 'se', 'disable'],
  // created () {
  //   this.pdf(false)
  // },
  mounted: function mounted() {
    this.output_fields = this.columns;
    // Object.assign(
    //   [],
    //   this.$store.state.currentOutputFieldsSelection
    // )
  },

  methods: {
    pdfSoloCall: function pdfSoloCall(full) {
      this.loading = true;
      setTimeout(function () {
        setTimeout(function () {
          this.pdf(full);
          this.loading = false;
        }.bind(this), 0);
      }.bind(this), 500);
    },
    pdf: function pdf(full) {
      // console.log(this.columns)
      if (!full) {
        this.show_preview_pane = true;
      }
      var heights = 700;
      var margins = [0, 0, 0, 0];
      var image = this.image;
      var created = new Date().toISOString().slice(0, 10);
      var username = this.c_user.abb;
      var list_name = this.title ? this.title.toUpperCase() : 'LIST';
      var subtitle = this.subtitle ? this.subtitle.toUpperCase() : '';
      var full_title = list_name + (subtitle != '' ? '\n' + subtitle : '');
      var full_title_style = subtitle != '' ? 'titleS' : 'title';
      var image_size = [this.imageSize1, this.imageSize2];
      var output_fields = this.columns;
      var imageSize3 = parseInt(this.imageSize2);
      // var rectPosX = 220 - imageSize3
      var use_current_selection = this.use_current_selection;
      // var noOfArtworks = 0
      var logoImage = this.getLogo();
      logoImage = logoImage.split('\n');
      var tempArtworks = [];

      if (this.item && this.item.artworks.length > 0) {
        this.pdf_artworks = this.item.artworks;
      } else {
        // console.log(this.use_current_selection)
        if (use_current_selection == true) {
          // this.pdf_artworks = Object.assign([], this.$store.state.currentSelection)
          if (this.$store.state.currentSelection.length > 0) {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.ids2o(this.$store.state.currentSelection)).sort(dynamicSort(this.sort));
          } else {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks).sort(dynamicSort(this.sort));
          }
        } else {
          if (this.$store.state.filterResults) {
            var objs = this.ids2o(this.$store.state.filterResults);
            this.pdf_artworks = objs.sort(dynamicSort(this.sort));
          } else {
            this.pdf_artworks = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks).sort(dynamicSort(this.sort));
          }
        }
      }

      // this.pdf_artworks = this.pdf_artworks.slice(0,5)
      var artworks = this.pdf_artworks;

      if (this.sort == 'collection') {
        var collectionsIds = [1, 12, 15, 6, 7, 17, 10];
        this.pdf_artworks = this.customDoubleSort(this.pdf_artworks, collectionsIds, 'ownership', this.subsort);
      } else {
        this.pdf_artworks = this.pdf_artworks.sort(dynamicSort(this.sort, this.subsort));
      }
      var transformedData = this.formatListData(this.pdf_artworks, output_fields);
      // console.log(transformedData)

      // console.log(transformedData)

      var creationDate = function creationDate() {
        return new Date();
      };

      function getImagefromAPI(top_photo_id, id) {
        var request = new XMLHttpRequest();
        var requestER = new XMLHttpRequest();
        var src = '';
        // console.log('id')
        // console.log(id)
        // console.log(top_photo_id)
        // console.log('id')
        if (id) {
          // console.log(id)
          src = 'https://api.tb-cms.org/vueimages/' + id + '_big.txt';
          request.open('GET', src, false);
          request.send(null);
          if (request.readyState === 4) {
            if (request.status === 200 && request.statusText === 'OK') {
              // console.log('status OK')
              var type = request.getResponseHeader('Content-Type');
              if (type.indexOf('text') !== 1) {
                // console.log('text OK')
                return request.responseText;
              }
            } else {
              // console.log('status not OK')
              requestER.open('GET', 'https://api.tb-cms.org/vueimages/ir.txt', false);
              requestER.send(null);
              if (requestER.readyState === 4) {
                // console.log('status not OK - 4')
                if (requestER.status === 200 && requestER.statusText === 'OK') {
                  // console.log('status not OK - 4 - OK')
                  var type = requestER.getResponseHeader('Content-Type');
                  if (type.indexOf('text') !== 1) {
                    return requestER.responseText;
                  }
                } else {
                  return '';
                }
              }
            }
          }
        } else {
          // console.log('ir')
          requestER.open('GET', 'https://api.tb-cms.org/vueimages/ir.txt', false);
          requestER.send(null);
          if (requestER.readyState === 4) {
            // console.log('status not OK - 4')
            if (requestER.status === 200 && requestER.statusText === 'OK') {
              // console.log('status not OK - 4 - OK')
              var type = requestER.getResponseHeader('Content-Type');
              if (type.indexOf('text') !== 1) {
                return requestER.responseText;
              }
            } else {
              return '';
            }
          }
        }
      }

      var createDocumentDefinition = function createDocumentDefinition() {
        var _docDefinition$conten;

        var baseDocDefinition = {
          pageMargins: [40, 40, 40, 40],
          defaultFileName: 'list.pdf',
          pageSize: 'A4',
          // footer: (currentPage, pageCount) => {
          //   return {
          //     ...(this.page_no == true && {
          //       text:
          //         'Page ' +
          //         currentPage.toString() +
          //         ' of ' +
          //         pageCount.toString(),
          //       alignment: 'center',
          //       fontSize: 7
          //     })
          //     // text: `Page ${currentPage.toString()} of ${pageCount.toString()}`, alignment: 'center', fontSize: 7
          //   }
          // },
          info: {
            title: list_name,
            author: username,
            subject: list_name,
            keywords: 'artwork names, artist names',
            creationDate: created
          },
          styles: {
            title: {
              fontSize: 14,
              all_caps: true,
              alignment: 'right',
              bold: true,
              margin: [0, 33, 0, 0]
            },
            titleS: {
              fontSize: 14,
              all_caps: true,
              alignment: 'right',
              margin: [0, 33, 0, 0]
            },
            titleSub: { fontSize: 9, all_caps: true, alignment: 'right' },
            titleDate: { fontSize: 9, alignment: 'right', bold: false },
            createdAt: { fontSize: 9, alignment: 'right' },
            createdBy: { fontSize: 9, alignment: 'right' },
            bold: { fontSize: 9, bold: false },
            normal: { fontSize: 9, bold: false },
            artwork_title: { fontSize: 9, bold: true, margin: [0, 0, 0, 0] },
            artwork_title_top: {
              fontSize: 9,
              bold: false,
              margin: [0, 0, 0, 0]
            },
            artist_name: { fontSize: 9, italic: true, margin: [0, 25, 0, 0] },
            image: { alignment: 'center', margin: [0, 0, 0, 0] },
            logo: { alignment: 'left', margin: [0, 0, 0, 40] }
          },
          content: [
            // {
            //   columns: [
            //     // { text: list_name, style: 'title', width: 'auto' },
            //     // {
            //     //   text:
            //     //     (this.created_by == true
            //     //       ? 'Created by : ' + username
            //     //       : '') +
            //     //     (this.created_at == true ? '\n' + created : '') ,
            //     //   style: 'createdBy'
            //     // }
            //     // { text: ((this.showNoOfArtworks == true) ? 'No. of Artworks: '  + this.pdf_artworks.length : ''), style: 'createdBy'}
            //     // {...(this.created_by == true) && { text: '\nCreated by ' + username, style: 'createdBy'}},
            //     // {...(this.created_at == true) && { text: created, style: 'createdAt'}}
            //   ]
            // },
            // { text: `${this.subtitle}\n\n`, style: 'titleSub' }
          ]
        };
        var docDefinition = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(baseDocDefinition));
        // docDefinition.footer = baseDocDefinition.footer
        (_docDefinition$conten = docDefinition.content).push.apply(_docDefinition$conten, arguments);
        // console.log(contentParts)
        // console.log(docDefinition)
        return docDefinition;
      };

      var rowData = function rowData(a) {
        var stack = {
          stack: [],
          stack2: []
          // var stacks = {
          //   stack: []
          // }
          // stacks.stack.push({
          //   text: list_name, style: 'title', width: '*'
          // }),
          // stacks.stack.push({
          //   text: subtitle, style: 'title', width: '*'
          // })
        };var columns = output_fields;
        // this.$store.state.selected_columns_for_pdf
        // ['title','accession_number'];
        // console.log(artworks[0]['title'])
        // console.log(a['title'])
        stack.stack.push(
        // { image: logoImage, fit: [170, 90], style: 'logo', width: '*' }
        {
          columns: [{ image: logoImage, fit: [180, 80], style: 'logo', width: '*' }, {
            text: a['title'] === artworks[0]['title'] + ', ' + artworks[0]['production_date_new'] ? full_title : '',
            style: full_title_style,
            width: '*'
          }]
          // text: `${subtitle}\n\n`, style: 'titleSub'
        }), stack.stack.push({
          text: a['accession_number'],
          style: 'artwork_title_top'
        });
        stack.stack.push({ text: a['full_name'], style: 'artwork_title' });
        stack.stack.push({ text: a['title'], style: 'artwork_title' });
        stack.stack.push({ text: a['subtitle'], style: 'artwork_title' });
        // stack.stack.push({ text: currentPage, style: 'artwork_title' })

        // console.log('columns')
        // console.log(columns)
        columns.forEach(function (column, index) {
          var columnData = a[column.id];
          var cp = [];
          if (columnData != null && columnData.trim().length != 0) {
            stack.stack.push({ text: columnData, style: 'artwork_title' });
          }
        });

        var imagefromAPI = getImagefromAPI(a.top_photo, a.top_photo_id);
        imagefromAPI = imagefromAPI.split('\n');
        if (imagefromAPI.length == 2) {
          imagefromAPI = imagefromAPI.filter(function (el) {
            return el != '';
          });
        }
        stack.stack.push({
          margins: [0, 0, 0, 0],
          image: imagefromAPI,
          fit: image_size,
          style: 'image',
          absolutePosition: { x: 290, y: 0 }
        });

        return stack;
      };

      createPdfDoc();

      function createPdfDoc() {
        var fontSize = 6;

        var tableBody = function tableBody(dataRows) {
          // console.log(currentPage)
          var body = [];
          dataRows.forEach(function (row, index) {
            var tableRow = [];

            tableRow.push(rowData(row, transformedData));
            // console.log(tableRow)

            body.push(tableRow);
          });
          return body;
        };
        var tableColumnWidths = ['*'];
        var tableData = {
          layout: 'noBorders',
          table: {
            heights: heights,
            dontBreakRows: true,
            margins: margins,
            widths: tableColumnWidths,
            body: tableBody(transformedData)
          }
        };
        var docDefinition = createDocumentDefinition(tableData);

        if (full == false) {
          var pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(docDefinition);

          // function download() {
          //   pdfDocGenerator.download('A4-list.pdf');
          // }
          pdfDocGenerator.getDataUrl(function (dataUrl) {
            var targetElement = document.querySelector('#pdfV');
            // const iframe = document.createElement('iframe')
            targetElement.src = dataUrl;
            // targetElement.appendChild(iframe)
            // this.loading = false
          });
        } else {
          if (list_name) {
            var t = list_name;
          } else {
            var t = 'listSolo.pdf';
          }
          // this.loading = false
          __WEBPACK_IMPORTED_MODULE_3_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download(t);
        }
        // this.loading = false
      }
      // this.loading = false
    }
  }
});

/***/ }),

/***/ "hmKP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns__ = __webpack_require__("wuJz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_date_fns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_date_fns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['loan'],
  created: function created() {
    this.exhibition.loan = '';
    this.exhibition.loan = toString(this.loan);
  },
  data: function data() {
    return {
      valid: false,
      exhibition: {
        loan: false,
        title: '',
        institution: '',
        show_type: 1,
        city: '',
        country: '',
        duration_start_year: null,
        duration_start_month: null,
        duration_start_day: null,
        duration_end_year: null,
        duration_end_month: null,
        duration_end_day: null,
        admin_note: ''
        // menu_duration_start: false,
        // menu_duration_end: false,
        // range: []
      },
      dateRangeOptions: {
        startDate: Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["subDays"])(new Date(), 7), 'YYYY-MM-DD'),
        endDate: Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
        format: 'YYYY-MM-DD'
      },
      dateRangeOptionsWithMinDate: {
        startDate: Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["subDays"])(new Date(), 7), 'YYYY-MM-DD'),
        endDate: Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(new Date(), 'YYYY-MM-DD'),
        minDate: Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["format"])(Object(__WEBPACK_IMPORTED_MODULE_0_date_fns__["subDays"])(new Date(), 15), 'YYYY-MM-DD'),
        format: 'YYYY-MM-DD'
      },
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        email: function email(value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        }
      }
    };
  },

  // watch: {
  //   menu_duration_start (val) {
  //     val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
  //   },
  //   menu_duration_end (val) {
  //     val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
  //   }
  // },
  computed: {
    countries: function countries() {
      return constants.COUNTRIES;
    }
    // exhibitions () {
    //   // console.log('exa')
    //   return this.store_e.filter(t => {
    //     return t.exhibition_artworks.map(a => a = a.artwork_id).includes(this.artwork.id)
    // })

  },
  methods: {
    save: function save() {
      var _this = this;

      this.exhibition.duration_start_year = parseInt(this.exhibition.duration_start_year);
      this.exhibition.duration_start_month = parseInt(this.exhibition.duration_start_month);
      this.exhibition.duration_start_day = parseInt(this.exhibition.duration_start_day);
      this.exhibition.duration_end_year = parseInt(this.exhibition.duration_end_year);
      this.exhibition.duration_end_month = parseInt(this.exhibition.duration_end_month);
      this.exhibition.duration_end_day = parseInt(this.exhibition.duration_end_day);
      this.exhibition.artwork_id = this.$route.params.id;
      // var id = this.findMinMax(this.$store.state.exhibitions)
      // this.exhibition.id = id
      // this.exhibition.exhibition_artworks = [{artwork_id: this.$route.params.id}]
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(this.$globals.apiserver + '/exhibitions.json', {
        exhibition: this.exhibition
      }).then(function (response) {
        _this.errors = {};
        // this.exhibitions.push(response.data);
        _this.$store.commit('ADD_EXHIBITION', response.data);
        // console.log(response)
        _this.exhibition = {
          loan: false,
          title: '',
          institution: '',
          show_type: 1,
          city: '',
          country: '',
          duration_start_year: null,
          duration_start_month: null,
          duration_start_day: null,
          duration_end_year: null,
          duration_end_month: null,
          duration_end_day: null,
          admin_note: ''
          // menu_duration_start: false,
          // menu_duration_end: false,
          // range: []

          // this.$store.dispatch('addExhibition', this.exhibition)
        };
      }).catch(function (error) {
        // console.log(error)
        _this.errors = error.response.data;
      });
    },
    onDateRangeChange: function onDateRangeChange(range) {
      this.exhibition.range = range;
      this.exhibition.duration_start = range[0];
      this.exhibition.duration_end = range[1];
    },
    findMinMax: function findMinMax(arr) {
      var max = arr[0].id;
      for (var i = 1, len = arr.length; i < len; i++) {
        var v = arr[i].id;
        max = v > max ? v : max;
      }
      // console.log(max)
      return max;
    }
    // save_menu_duration_start (date) {
    //   this.$refs.menu_duration_start.save(date)
    // },
    // save_menu_duration_end (date) {
    //   this.$refs.menu_duration_end.save(date)
    // },

  }
});

/***/ }),

/***/ "hmyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      myJournal: false,
      show: 'facts',
      journals_store: this.$store.state.journals,
      sa_store: this.$store.state.support_articles
    };
  },

  methods: {
    format_journal_artwork: function format_journal_artwork(j) {
      if (j.class_name == 'Artwork') {
        var a = this.$store.state.artworks.find(function (a) {
          return a.id == j.journaled_id;
        });
        // var u = this.$store.state.users.find(u => u.id == j.user_id)
        // console.log(a)
        if (a) {
          return j.class_name + ':<b> ' + a.title + '</b>, ' + a.full_name;
        } else {
          return '';
        }
      } else if (j.class_name == 'ArtworkLocation') {
        var a = this.$store.state.locations.find(function (a) {
          return a.id == j.journaled_id;
        });
        return 'Artwork Location: ' + (a ? a.name : 'DELETED');
      }
    },
    format_journal_journal: function format_journal_journal(j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      // var u = this.$store.state.users.find(u => u.id == j.user_id)
      return '"' + j.value_name + '" changed from "' + j.old_value + '" to "' + j.new_value;
    },
    format_journal_user: function format_journal_user(j) {
      // var a = this.$store.state.artworks.find(a => a.id == j.journaled_id)
      if (j.user_id) {
        var u = this.$store.state.users.find(function (u) {
          return u.id == j.user_id;
        });
        return u.firstname + ' ' + u.lastname;
      } else {
        return 'unknown';
      }
    },
    format_date: function format_date(date) {
      var moment = __webpack_require__("PJh5");
      var ndate = new Date(date);
      return moment(ndate).format('YYYY-MM-DD hh:mm');
    },
    exhibitionsInYear: function exhibitionsInYear(y) {
      return this.$store.getters.exhibitions.filter(function (e) {
        return y == e.duration_start_year || y == e.duration_end_year;
      });
    },
    loansInYear: function loansInYear(y) {
      return this.$store.getters.loans.filter(function (e) {
        return y == e.duration_start_year || y == e.duration_end_year;
      });
    },
    artworksInYear: function artworksInYear(y) {
      // console.log(this.$store.state.artworks[2].production_date_new.substring(0,4))
      return this.$store.state.artworks.filter(function (e) {
        return y >= (e.production_date_new != null ? e.production_date_new : '    ').substring(0, 4);
      });
    }
  },
  computed: {
    years: function years() {
      var end = 2020;
      var start = 2000;
      return Array(end - start + 1).fill().map(function (_, idx) {
        return start + idx;
      });
      // return [2019,2018,2017,2016,2015,2014,2013,2001]
    },
    labels: function labels() {
      var _this = this;

      return this.years.map(function (y) {
        return y + ' (' + _this.exhibitionsInYear(y).length + ')';
      });
    },
    value_exhibitions: function value_exhibitions() {
      var _this2 = this;

      return this.years.map(function (y) {
        return _this2.exhibitionsInYear(y).length;
      });
    },
    value_loans: function value_loans() {
      var _this3 = this;

      return this.years.map(function (y) {
        return _this3.loansInYear(y).length;
      });
    },
    years_artworks: function years_artworks() {
      var end = 2020;
      var start = 1950;
      return Array(end - start + 1).fill().map(function (_, idx) {
        return start + idx;
      });
    },

    // labels_artworks () {
    //   return this.years.map(y => { return `${y} (${this.exhibitionsInYear(y).length})` })
    // },
    value_artworks: function value_artworks() {
      var _this4 = this;

      return this.years_artworks.map(function (y) {
        return _this4.artworksInYear(y).length;
      });
    },

    // c_user  () {
    //   return this.$store.state.user.profile
    // },
    journals: function journals() {
      var _this5 = this;

      if (this.myJournal) {
        return this.journals_store.filter(function (j) {
          return j.user_id === _this5.c_user.id;
        });
      } else {
        return this.journals_store;
      }
    },
    support_articles: function support_articles() {
      return this.sa_store.filter(function (sa) {
        return sa.updates == 1;
      });
    }
  }
});

/***/ }),

/***/ "hoPK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoloExt_vue__ = __webpack_require__("hPAF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_215924e6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SoloExt_vue__ = __webpack_require__("6tmr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("/OND")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-215924e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SoloExt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_215924e6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SoloExt_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_215924e6_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SoloExt_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "i0Bb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grey lighten-3 py-5 px-5"},[_c('h1',[_vm._v("Add new Text")]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":"","mb-3":""}}),_vm._v(" "),_c('v-stepper',{staticClass:"elevation-1",model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',[_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 1,"step":"1"}},[_vm._v("\n        Basic Text Info\n      ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 2,"step":"2"}},[_vm._v("\n        Write/Upload Text")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 3,"step":"3"}},[_vm._v("\n        Assign Artworks & Artists")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"4"}},[_vm._v("Summary")])],1),_vm._v(" "),_c('v-stepper-items',[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-3 elevation-0"},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-3 py-1 my-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("Basic")])]),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"File Name"},model:{value:(_vm.text.given_filename),callback:function ($$v) {_vm.$set(_vm.text, "given_filename", $$v)},expression:"text.given_filename"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Title Publication"},model:{value:(_vm.text.title),callback:function ($$v) {_vm.$set(_vm.text, "title", $$v)},expression:"text.title"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Editor"},model:{value:(_vm.text.editor),callback:function ($$v) {_vm.$set(_vm.text, "editor", $$v)},expression:"text.editor"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Author(s)"},model:{value:(_vm.text.authors),callback:function ($$v) {_vm.$set(_vm.text, "authors", $$v)},expression:"text.authors"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Year","mask":"####"},model:{value:(_vm.text.year),callback:function ($$v) {_vm.$set(_vm.text, "year", $$v)},expression:"text.year"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Place"},model:{value:(_vm.text.place),callback:function ($$v) {_vm.$set(_vm.text, "place", $$v)},expression:"text.place"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Publisher"},model:{value:(_vm.text.publisher),callback:function ($$v) {_vm.$set(_vm.text, "publisher", $$v)},expression:"text.publisher"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-2",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"URL (link)"},model:{value:(_vm.text.url),callback:function ($$v) {_vm.$set(_vm.text, "url", $$v)},expression:"text.url"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","px-2":""}},[_c('v-textarea',{attrs:{"label":"Notes","auto-grow":"","clearable":"","rows":"1"},model:{value:(_vm.text.notes),callback:function ($$v) {_vm.$set(_vm.text, "notes", $$v)},expression:"text.notes"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-0 pb-4",attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-flex',{staticClass:"py-2",attrs:{"xs12":"","sm6":""}},[_c('h4',{staticClass:"body-2 mt-0 mb-1 ml-2 grey--text text--darken-2"},[_vm._v("\n                      Format\n                    ")]),_vm._v(" "),_c('v-btn-toggle',{model:{value:(_vm.text.text_type),callback:function ($$v) {_vm.$set(_vm.text, "text_type", $$v)},expression:"text.text_type"}},[_c('v-btn',{key:"print",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"print","value":"print"}},[_c('span',[_vm._v(" Print ")])]),_vm._v(" "),_c('v-btn',{key:"online",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"online","value":"online"}},[_c('span',[_vm._v(" Online ")])])],1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"py-4",attrs:{"xs12":"","md6":""}},[_c('h4',{staticClass:"body-2 mt-0 mb-1 ml-2 grey--text text--darken-2"},[_vm._v("\n                    Ownership\n                  ")]),_vm._v(" "),_c('v-btn-toggle',{model:{value:(_vm.text.tba),callback:function ($$v) {_vm.$set(_vm.text, "tba", $$v)},expression:"text.tba"}},[_c('v-btn',{key:"tba",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"tba","value":"tba"}},[_c('span',[_vm._v(" TBA ")])]),_vm._v(" "),_c('v-btn',{key:"nontba",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"nontba","value":"nontba"}},[_c('span',[_vm._v(" NON TBA ")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"px-3 py-1 my-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("\n                    Type of text / resource\n                  ")])]),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","my-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Article (magazine, journal, etc)"},model:{value:(_vm.text.article),callback:function ($$v) {_vm.$set(_vm.text, "article", $$v)},expression:"text.article"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","my-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Text on artwork (exhibition, website, social media etc)"},model:{value:(_vm.text.artwork_text),callback:function ($$v) {_vm.$set(_vm.text, "artwork_text", $$v)},expression:"text.artwork_text"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","my-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Press release"},model:{value:(_vm.text.pr),callback:function ($$v) {_vm.$set(_vm.text, "pr", $$v)},expression:"text.pr"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","my-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Documents received from artist, gallery, etc"},model:{value:(_vm.text.artist_documents),callback:function ($$v) {_vm.$set(_vm.text, "artist_documents", $$v)},expression:"text.artist_documents"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","my-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Transcription"},model:{value:(_vm.text.transcript),callback:function ($$v) {_vm.$set(_vm.text, "transcript", $$v)},expression:"text.transcript"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","mb-0":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Work inherent text (part of artwork)"},model:{value:(_vm.text.work_text),callback:function ($$v) {_vm.$set(_vm.text, "work_text", $$v)},expression:"text.work_text"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4",attrs:{"xs12":"","md6":"","lg4":"","py-0":"","mb-5":""}},[_c('v-checkbox',{attrs:{"color":"black","hide-details":"","label":"Publication"},model:{value:(_vm.text.publication),callback:function ($$v) {_vm.$set(_vm.text, "publication", $$v)},expression:"text.publication"}})],1),_vm._v(" "),(_vm.valid)?_c('v-layout',{attrs:{"align-center":"","justify-end":"","mt-5":""}},[_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.saveText.apply(null, arguments)}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","flat":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Cancel")])],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-3 elevation-0"},[_c('v-flex',{attrs:{"xs12":"","mx-3":"","mt-4":""}},[_c('upload',{attrs:{"uploadCategory":"text","id":_vm.text.id,"field":{
                title: 'Uploaded Artwork Text',
                name: 'artwork_text',
                category: 'artwork_text'
              }}})],1),_vm._v(" "),_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('v-container',{attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","mx-0":"","mt-2":""}},[_c('v-container',{attrs:{"grid-list-xs":"","fluid":"","px-0":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('text-editor',{on:{"input":function($event){_vm.text.content = $event}}})],1)],1)],1),_vm._v(" "),(_vm.valid)?_c('v-layout',{attrs:{"align-center":"","justify-end":"","mt-5":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.updateText()}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Cancel")])],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-5 pb-1",attrs:{"color":"grey lighten-4"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-autocomplete',{attrs:{"search-input":_vm.search,"box":"","color":"grey lighten-1","chips":"","multiple":"","items":_vm.artworks,"item-text":function (item) { return item.title +
                      ', ' +
                      item.accession_number +
                      ', ' +
                      item.name; },"item-value":"id","label":"Select Artworks related to this Text","menu-props":"{\"closeOnClick\":true, \"closeOnContentClick\":false, \"openOnClick\":false, \"maxHeight\":600}"},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi white--text chip--select-multi",attrs:{"selected":data.selected,"close":"","color":"black"},on:{"input":function($event){return _vm.remove(data.item.id)}}},[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.title)}}),_vm._v(" \n                      "),_c('span',[_vm._v(_vm._s(data.item.accession_number)+" ")]),_vm._v(" \n                      "),_c('strong',{domProps:{"innerHTML":_vm._s(
                          data.item.artist
                            ? data.item.artist.name
                            : data.item.name
                        )}})])]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.title)}}),_vm._v(" \n                        "),_c('span',[_vm._v(_vm._s(data.item.accession_number)+" ")]),_vm._v(" \n                        "),_c('strong',{domProps:{"innerHTML":_vm._s(data.item.name)}})]),_vm._v(" "),_c('v-list-tile-sub-title')],1)]}}]),model:{value:(_vm.text.artworks),callback:function ($$v) {_vm.$set(_vm.text, "artworks", $$v)},expression:"text.artworks"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-list',{staticClass:"mx-0 mb-4 xs12",attrs:{"two-line":""}},_vm._l((_vm.text_artworks),function(item){return _c('v-list-tile',{key:item.id},[_c('v-list-tile-avatar',[(item.top_photo_id > 0)?_c('img',{attrs:{"src":((this.$globals.apiserver) + "/data/artwork/" + (item.id) + "/" + (item.top_photo_id) + "_th_big.jpg")}}):_vm._e()]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((item.title) + " (" + (item.production_date_new) + ")"))}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(item.full_name)}})],1)],1)}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-autocomplete',{attrs:{"multiple":"","open-on-clear":"","box":"","chips":"","color":"grey lighten-1","items":_vm.artists,"item-text":function (item) { return item.name + ', ' + item.full_name + ', ' + item.company; },"item-value":"id","label":"Select Artists to add to this Text","menu-props":"{\"closeOnClick\":true, \"closeOnContentClick\":false, \"openOnClick\":false, \"maxHeight\":600}"},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi white--text chip--select-multi",attrs:{"selected":data.selected,"color":"black","close":""},on:{"input":function($event){return _vm.removeArtist(data.item.id)}}},[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.name)}}),_vm._v(" \n                      "),_c('span',[_vm._v(_vm._s(data.item.full_name)+" ")]),_vm._v(" \n                      "),_c('strong',{domProps:{"innerHTML":_vm._s(data.item.company)}})])]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.name)}}),_vm._v(" \n                        ")]),_vm._v(" "),_c('v-list-tile-sub-title')],1)]}}]),model:{value:(_vm.text.artists),callback:function ($$v) {_vm.$set(_vm.text, "artists", $$v)},expression:"text.artists"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-list',{staticClass:"mx-0 mb-4 xs12",attrs:{"two-line":""}},_vm._l((_vm.text_artists),function(item){return _c('v-list-tile',{key:item.id},[_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(item.name)}})],1)],1)}),1)],1)],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_c('v-icon',{staticClass:"pr-2"},[_vm._v("mdi-arrow-left-bold-box")]),_vm._v("Back to\n          Basic")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.valid},on:{"click":function($event){return _vm.updateText()}}},[_vm._v("Save and Continue")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.$router.push('/texts')}}},[_vm._v("Cancel & go to Text List")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',{staticClass:"mb-5 pl-3 pr-3 pb-3",attrs:{"color":"grey lighten-4 elevation-0"}},[_c('v-flex',{attrs:{"xs12":""}},[_c('br'),_vm._v(" "),_c('h3',{staticClass:"title mb-3"},[_vm._v("\n              "+_vm._s(_vm.text.title)+"\n              ")]),_vm._v(" "),_c('table',{staticClass:"mb-0 main"},[_c('tr',[_c('td',[_vm._v("Text Type:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.text.text_type))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Author(s):")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.text.authors))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Year:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.text.year))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Place:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.text.place))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Publisher:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.text.publisher))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("URL:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.text.url))])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Note:")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.text.admin_note))])])]),_vm._v(" "),_c('table',{staticClass:"mt-3"},[_c('tr',[_c('td',{attrs:{"colspan":"2"}},[_c('b',[_vm._v("Type of text / resource:")])])]),_vm._v(" "),(_vm.text.tba == 1)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"small":""}},[_vm._v("check_circle")]),_vm._v(" TBA21 publication")],1)]):_vm._e(),_vm._v(" "),(_vm.text.nontba == 1)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"small":""}},[_vm._v("check_circle")]),_vm._v(" NON TBA21 publication\n                ")],1)]):_vm._e(),_vm._v(" "),(_vm.text.article == 1)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"small":""}},[_vm._v("check_circle")]),_vm._v(" Article (magazine,\n                  journal, etc)\n                ")],1)]):_vm._e(),_vm._v(" "),(_vm.text.artwork_text == 1)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"small":""}},[_vm._v("check_circle")]),_vm._v(" Text on artwork\n                  (exhibition, website, social media etc)\n                ")],1)]):_vm._e(),_vm._v(" "),(_vm.text.publication == 1)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"small":""}},[_vm._v("check_circle")]),_vm._v(" Publication")],1)]):_vm._e(),_vm._v(" "),(_vm.text.pr == 1)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"small":""}},[_vm._v("check_circle")]),_vm._v(" Press release")],1)]):_vm._e(),_vm._v(" "),(_vm.text.artist_documents == 1)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"small":""}},[_vm._v("check_circle")]),_vm._v(" Documents received from\n                  artist, gallery, etc\n                ")],1)]):_vm._e(),_vm._v(" "),(_vm.text.transcript == 1)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"small":""}},[_vm._v("check_circle")]),_vm._v(" Transcription")],1)]):_vm._e(),_vm._v(" "),(_vm.text.work_text == 1)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"small":""}},[_vm._v("check_circle")]),_vm._v(" Work inherent text (part\n                  of artwork)\n                ")],1)]):_vm._e(),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td')])]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 3}}},[_c('v-icon',{staticClass:"mr-2"},[_vm._v("mdi-arrow-left-bold-box")]),_vm._v("\n              Back to Artwork Selection\n            ")],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.$router.push('/texts')}}},[_vm._v("go to Text List")])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.push({
              name: 'EditText',
              params: { id: _vm.text.id, text: _vm.text },
              path: ("/texts/edit/" + (_vm.text.id))
            })}}},[_vm._v("\n          Go to Text Edit Page\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "i9hz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iGlC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx-2"},[(_vm.table_artworks.length > 0)?_c('v-list',{staticClass:"mx-0 px-0 mb-2",attrs:{"two-line":""}},[_vm._l((_vm.table_artworks),function(item,index){return [_c('v-list-tile',{key:item.id},[_vm._v(_vm._s(item.key)+"\n        "),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-list-tile-avatar',[_c('v-tooltip',{attrs:{"right":""},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_c('span',_vm._g({},data.on),[_c('v-btn',{staticStyle:{"width":"20px","height":"20px"},attrs:{"round":"","color":"red","icon":"","small":"","dense":"","hint":"Remove Artwork from Exhibition"},on:{"click":function($event){return _vm.remove_from_exhibition(item.id)}}},[_c('v-icon',{attrs:{"small":"","dense":"","color":"white"}},[_vm._v("remove")])],1)],1)]}}],null,true)},[_vm._v("\n            Remove Artwork from Exhibition\n          ")])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',{staticClass:"ml-0 pl-0"},[_c('v-list-tile-sub-title',[_c('router-link',{attrs:{"to":{ name: 'EditArtwork', params: {id: item.id, artwork: item}, path: ("/artworks/edit/" + (item.id))}}},[_vm._v("\n              "+_vm._s(item.accession_number)+" "),_c('b',[_vm._v(_vm._s(item.title))]),_vm._v(", "+_vm._s(item.production_date_new)+", "+_vm._s((item.artist ? item.artist.name : item.name))+"\n              ")])],1),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n            "+_vm._s(_vm.get_location_name(item.artwork_location_id))+"\n            ")])],1)],1)]})],2):[_c('p',{staticClass:"my-0 mx-0 px-0 text-xs-left align-left justify-left"},[_vm._v("No Artworks")])]],2)}
var staticRenderFns = []


/***/ }),

/***/ "iuG8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iuSU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Films_vue__ = __webpack_require__("eP6s");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c73c7e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Films_vue__ = __webpack_require__("szXu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("1Dzk")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7c73c7e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Films_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c73c7e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Films_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c73c7e4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Films_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "j4mB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_constants__ = __webpack_require__("K30H");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      autoUpdate: true,
      isUpdating: false,
      snackbar: false,
      color: 'black',
      snackbar_text: '',
      timeout: 3500,
      valid: true,
      countries: [],
      dialog: false,
      exhibition: {
        loan: '',
        title: 'loading...',
        institution: '',
        show_type: '',
        city: '',
        country: '',
        duration_start_year: null,
        duration_start_month: null,
        duration_start_day: null,
        duration_end_year: null,
        duration_end_month: null,
        duration_end_day: null,
        admin_note: ''
      },
      // artworks: [],
      constants: __WEBPACK_IMPORTED_MODULE_2__data_constants__["a" /* default */]
    };
  },
  created: function created() {
    this.countries = this.constants.COUNTRIES;
  },

  watch: {
    isUpdating: function isUpdating(val) {
      var _this = this;

      if (val) {
        setTimeout(function () {
          return _this.isUpdating = false;
        }, 3000);
      }
    }
  },
  methods: {
    // remove (item) {
    //   this.exhibition.artworks.splice(this.exhibition.artworks.indexOf(item), 1)
    //   this.exhibition.artworks = [...this.exhibition.artworks]
    // },
    remove: function remove(item) {
      // this.exhibition.artworks.splice(this.exhibition.artworks.indexOf(item), 1)
      // this.exhibition.artworks = [...this.exhibition.artworks]
      // console.log(item)
      // console.log(this.exhibition.artworks)
      var index = this.exhibition.artworks.indexOf(item);
      // console.log(index)
      if (index >= 0) this.exhibition.artworks.splice(index, 1);
    },
    saveExhibition: function saveExhibition() {
      var _this2 = this;

      this.exhibition.duration_end = this.exhibition_duration_end;
      // this.format_date(new Date(this.exhibition.duration_end_year, this.exhibition.duration_end_month-1, this.exhibition.duration_end_day),'YYYY-MM-DD');
      this.exhibition.duration_start = this.exhibition_duration_start;
      // this.format_date(new Date(this.exhibition.duration_start_year, this.exhibition.duration_start_month-1, this.exhibition.duration_start_day),'YYYY-MM-DD');

      // this.exhibition.duration_end = this.format_date(new Date(this.exhibition.duration_end_year, this.exhibition.duration_end_month-1, this.exhibition.duration_end_day),'YYYY-MM-DD');
      // this.exhibition.duration_start = this.format_date(new Date(this.exhibition.duration_start_year, this.exhibition.duration_start_month-1, this.exhibition.duration_start_day),'YYYY-MM-DD');
      // this.exhibition.artworks = this.artwork_ids
      // console.log(this.exhibition.artworks)

      this.exhibition.artwork_ids = this.exhibition.artworks;
      // .map(a => a.id)
      // console.log(this.exhibition)
      // this.exhibition.artworks = this.exhibition.artwork_ids
      var url = this.$globals.apiserver + '/exhibitions/' + this.exhibition.id + '.json';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(url, { exhibition: this.exhibition }).then(function (response) {
        _this2.result = response.data;
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Exhibition was saved.', 'green');
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Exhibition was NOT saved. Error occured.', 'red');
        // console.log(error)
      });
    },
    deleteExhibition: function deleteExhibition() {
      var _this3 = this;

      var url = this.$globals.apiserver + '/exhibitions/' + this.exhibition.id + '.json';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(url, this.exhibition).then(function (response) {
        _this3.result = response.data;
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Exhibition was deleted.', 'green');
        _this3.$router.push({ name: 'ExhibitionIndex' });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Exhibition was NOT deleted. Error occured.', 'red');
        // console.log(error)
      });
    },
    getExhibition: function getExhibition() {
      var _this4 = this;

      var url = this.$globals.apiserver + '/exhibitions/' + this.$route.params.id + '.json';
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
        _this4.exhibition = response.data;
        // MUSIM ZMENIT VALUE PRE RADIO GROUP NA STRING LEBO INAK TO NEFUNGUJE
        if (_this4.exhibition.show_type) {
          _this4.exhibition.show_type = _this4.exhibition.show_type.toString();
        }
        // console.log('this.exhibition')
        // console.log(this.exhibition)
        _this4.exhibition.artworks = _this4.exhibition.artworks.map(function (a) {
          return a.id;
        });
        // console.log(this.exhibition.artworks)
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Exhibition could NOT be loaded. Error occured.', 'red');
        // console.log(error)
      });
    }
  },
  computed: {
    institutions: function institutions() {
      return this.$store.state.contacts.filter(function (c) {
        return c.category == 'exhibition_institution';
      });
    },
    artworks_store: function artworks_store() {
      return this.$store.state.artworks;
    },
    exhibition_duration_end: function exhibition_duration_end() {
      return this.exhibition.duration_end_year + '-' + this.exhibition.duration_end_month + '-' + this.exhibition.duration_end_day;
    },
    exhibition_duration_start: function exhibition_duration_start() {
      return this.exhibition.duration_start_year + '-' + this.exhibition.duration_start_month + '-' + this.exhibition.duration_start_day;
    },
    artwork_ids: function artwork_ids() {
      var mm = [];
      this.exhibition.artworks.forEach(function (a) {
        return mm.push({ id: a.id });
      });
      return mm;
    }
  },
  beforeMount: function beforeMount() {
    // this.exhibition = Object.assign({},this.$route.params.exhibition)
    this.getExhibition();
  }
});

/***/ }),

/***/ "jNYR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grey lighten-3 pt-3 mt-5",staticStyle:{"min-height":"100%","margin":"0 auto"}},[_c('v-layout',{staticStyle:{"background-color":"white","height":"50px","width":"100%","top":"135px","position":"fixed","z-index":"1"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}})],1),_vm._v(" "),_c('v-toolbar',{staticClass:"elevation-1  mt-3",staticStyle:{"z-index":"1","top":"135px","position":"fixed","width":"100%","border-bottom":"1px solid #999","background-color":"#fff"},attrs:{"mx-0":"","px-3":"","ml-0":"","pt-0":"","pb-3":"","color":"white","tabs":""}},[_c('v-flex',{staticClass:"xs8 pl-1 ml-0 mr-0"},[_c('h4',{staticClass:"pl-3 headline font-weight-light",domProps:{"innerHTML":_vm._s(_vm.exhibition.title)}})]),_vm._v(" "),_c('v-layout',{staticClass:"xs4 my-0 pr-2 pt-1 justify-end column"},[_c('v-flex',{staticClass:"xs4 pl-3 ml-0 mr-0 text-xs-right"},[(_vm.c_user.delete_rights)?_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.deleteExhibition()}}},[_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("close")])],1),_vm._v(" "),(_vm.c_user.edit)?_c('v-btn',{attrs:{"icon":"","small":"","disabled":!_vm.valid,"right":""},on:{"click":_vm.saveExhibition}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("save")])],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{staticClass:"px-3 pt-0 mt-3 elevation-0 editBG"},[_c('v-container',{attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-3 py-0 my-3 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("Basic")])]),_vm._v(" "),_c('v-flex',{staticClass:"px-4",attrs:{"xs12":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Title"},model:{value:(_vm.exhibition.title),callback:function ($$v) {_vm.$set(_vm.exhibition, "title", $$v)},expression:"exhibition.title"}}):_c('v-flex',{attrs:{"mt-4":""}},[_c('code',[_vm._v(_vm._s(_vm.exhibition.title))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Title")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"px-4 mb-3",attrs:{"xs12":""}},[(_vm.c_user.edit)?_c('v-autocomplete',{attrs:{"hide-details":"","label":"Institution","items":_vm.institutions,"item-value":"id","item-text":"name"},model:{value:(_vm.exhibition.institution_id),callback:function ($$v) {_vm.$set(_vm.exhibition, "institution_id", $$v)},expression:"exhibition.institution_id"}}):_c('v-flex',{attrs:{"mt-3":""}},[_c('code',[_vm._v(_vm._s(_vm.getInstitutionName(_vm.exhibition.institution_id)))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Institution")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"px-4",attrs:{"xs12":"","sm6":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"City"},model:{value:(_vm.exhibition.city),callback:function ($$v) {_vm.$set(_vm.exhibition, "city", $$v)},expression:"exhibition.city"}}):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.exhibition.city))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("City")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"px-4",attrs:{"xs12":"","sm6":""}},[(_vm.c_user.edit)?_c('v-autocomplete',{attrs:{"items":_vm.countries,"label":"Country"},model:{value:(_vm.exhibition.country),callback:function ($$v) {_vm.$set(_vm.exhibition, "country", $$v)},expression:"exhibition.country"}}):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.exhibition.country))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Country")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-4 pr-3",attrs:{"xs12":"","sm4":"","md2":"","lg2":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Start Year","placeholder":"XXXX","type":"number","maxlength":4},model:{value:(_vm.exhibition.duration_start_year),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_start_year", $$v)},expression:"exhibition.duration_start_year"}}):_c('v-flex',{attrs:{"mt-3":""}},[_c('code',[_vm._v(_vm._s(_vm.exhibition.duration_start_year))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Start Year")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":"","lg2":"","pr-3":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Month","placeholder":"XX","type":"number"},model:{value:(_vm.exhibition.duration_start_month),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_start_month", $$v)},expression:"exhibition.duration_start_month"}}):_c('v-flex',{attrs:{"mt-3":""}},[_c('code',[_vm._v(_vm._s(_vm.exhibition.duration_start_month))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Month")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-4",attrs:{"xs6":"","sm4":"","md2":"","lg2":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Day","placeholder":"XX","type":"number"},model:{value:(_vm.exhibition.duration_start_day),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_start_day", $$v)},expression:"exhibition.duration_start_day"}}):_c('v-flex',{attrs:{"mt-3":""}},[_c('code',[_vm._v(_vm._s(_vm.exhibition.duration_start_day))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Day")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"px-4",attrs:{"xs12":"","sm4":"","md2":"","lg2":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"End Year","placeholder":"XXXX","type":"number"},model:{value:(_vm.exhibition.duration_end_year),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_end_year", $$v)},expression:"exhibition.duration_end_year"}}):_c('v-flex',{attrs:{"mt-3":""}},[_c('code',[_vm._v(_vm._s(_vm.exhibition.duration_end_year))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("End Year")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":"","lg2":"","pr-3":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Month","placeholder":"XX","type":"number"},model:{value:(_vm.exhibition.duration_end_month),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_end_month", $$v)},expression:"exhibition.duration_end_month"}}):_c('v-flex',{attrs:{"mt-3":""}},[_c('code',[_vm._v(_vm._s(_vm.exhibition.duration_end_month))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Month")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm4":"","md2":"","lg2":"","pr-4":""}},[(_vm.c_user.edit)?_c('v-text-field',{attrs:{"label":"Day","placeholder":"XX","type":"number"},model:{value:(_vm.exhibition.duration_end_day),callback:function ($$v) {_vm.$set(_vm.exhibition, "duration_end_day", $$v)},expression:"exhibition.duration_end_day"}}):_c('v-flex',{attrs:{"mt-3":""}},[_c('code',[_vm._v(_vm._s(_vm.exhibition.duration_end_day))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Day")])])],1),_vm._v(" "),_c('v-flex',{staticClass:"py-2 px-4 pt-4",attrs:{"xs12":"","sm6":""}},[(_vm.c_user.edit)?_c('v-btn-toggle',{model:{value:(_vm.exhibition.show_type),callback:function ($$v) {_vm.$set(_vm.exhibition, "show_type", $$v)},expression:"exhibition.show_type"}},[_c('v-btn',{key:"group",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"2","value":"2"}},[_c('span',[_vm._v(" Group Show ")])]),_vm._v(" "),_c('v-btn',{key:"solo",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"1","value":"1"}},[_c('span',[_vm._v(" Solo Show ")])])],1):_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.exhibition.show_type == 2 ? 'Group Show' : 'Solo Show'))])],1),_vm._v(" "),_c('v-flex',{staticClass:"px-4",attrs:{"xs12":"","sm6":"","md6":"","pt-3":""}},[(_vm.c_user.edit)?_c('v-switch',{attrs:{"label":"Loan","color":"black","input-value":"1"},model:{value:(_vm.exhibition.loan),callback:function ($$v) {_vm.$set(_vm.exhibition, "loan", $$v)},expression:"exhibition.loan"}}):_c('v-flex',[_c('code',[_vm._v(_vm._s(_vm.exhibition.loan == 1 ? 'Yes' : 'No'))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Loan")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","px-4":""}},[(_vm.c_user.edit)?_c('v-textarea',{attrs:{"outline":"","label":"Note","auto-grow":"","clearable":"","rows":"1"},model:{value:(_vm.exhibition.admin_note),callback:function ($$v) {_vm.$set(_vm.exhibition, "admin_note", $$v)},expression:"exhibition.admin_note"}}):_c('v-flex',{attrs:{"mt-3":""}},[_c('code',[_vm._v(_vm._s(_vm.exhibition.admin_note))]),_vm._v(" "),_c('label',{staticStyle:{"color":"#999"}},[_vm._v("Note")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-4":"","mt-4":""}},[(_vm.exhibition.artworks)?_c('div',[_vm._v("\n              "+_vm._s(_vm.exhibition.artworks.length)+" Artworks:\n            ")]):_vm._e(),_vm._v(" "),_c('v-autocomplete',{attrs:{"disabled":!_vm.c_user.edit ||_vm.isUpdating,"items":_vm.artworks_store,"multiple":"","box":"","chips":"","small-chips":"","hide-no-data":"","hide-selected":"","label":_vm.artworks_store.length > 0
                  ? 'Select Artworks'
                  : 'Artwoks not yet loaded. Please wait...',"item-value":"id","item-text":function (item) { return item.title + ', ' + item.accession_number + ', ' + item.name; },"loading":!_vm.artworks_store.length > 0},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{staticClass:"chip--select-multi white--text chip--select-multi",attrs:{"selected":data.selected,"close":"","color":"black"},on:{"input":function($event){return _vm.remove(data.item.id)}}},[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.title)}}),_vm._v(" \n                  "),_c('span',[_vm._v(_vm._s(data.item.accession_number)+" ")]),_vm._v(" \n                  "),_c('strong',{domProps:{"innerHTML":_vm._s(data.item.name)}})])]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',[_c('strong',{domProps:{"innerHTML":_vm._s(data.item.title)}}),_vm._v(" \n                    "),_c('span',[_vm._v(_vm._s(data.item.accession_number)+" ")]),_vm._v(" \n                    "),_c('strong',{domProps:{"innerHTML":_vm._s(data.item.name)}})]),_vm._v(" "),_c('v-list-tile-sub-title')],1)]}}]),model:{value:(_vm.exhibition.artworks),callback:function ($$v) {_vm.$set(_vm.exhibition, "artworks", $$v)},expression:"exhibition.artworks"}})],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "jTEo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.f_field.headline)?_c('div'):_c('div',[(_vm.value_calculated_empty)?_c('v-container',{attrs:{"grid-list-md":""}},[(_vm.f_field.ctype=='text-short')?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs3":"","text-xs-right":"","dark":""}},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs9":"","text-xs-left":""},domProps:{"innerHTML":_vm._s(_vm.value_calculated)}})],1)],1):(_vm.f_field.ctype=='text-long')?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-left":""}},[_c('div',[_vm._v(_vm._s(_vm.f_field.title))])])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","text-xs-left":""},domProps:{"innerHTML":_vm._s(_vm.value_calculated)}})],1)],1):(_vm.f_field.ctype=='date')?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs3":"","text-xs-right":"","dark":""}},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs9":"","text-xs-left":""},domProps:{"innerHTML":_vm._s(_vm.format_date(_vm.value_calculated,_vm.f_field.format))}})],1)],1):(_vm.f_field.ctype=='bool')?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs3":"","text-xs-right":"","dark":""}},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs9":"","text-xs-left":""},domProps:{"innerHTML":_vm._s(_vm.value_from_array)}})],1)],1):_vm._e()]):_vm._e()],1)])}
var staticRenderFns = []


/***/ }),

/***/ "jTo1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jUyp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jukP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArtist_vue__ = __webpack_require__("Bxt4");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca5b70b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArtist_vue__ = __webpack_require__("JWtN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("U54s")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ca5b70b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditArtist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca5b70b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArtist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ca5b70b_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditArtist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k19S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsHome_vue__ = __webpack_require__("BU/u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26acdc1a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsHome_vue__ = __webpack_require__("PmKx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("0KmK")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26acdc1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsHome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26acdc1a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsHome_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26acdc1a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsHome_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "k5cb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artist', 'artworks', 'text_id'],
  computed: {
    table_artworks: function table_artworks() {
      var _this = this;

      var out = [];
      if (this.artworks.length && this.artworks.length > 0) {
        // console.log('this.artworks')
        // console.log(this.artworks)
        // console.log(this.artworks.map(am => am.id))
        // console.log(this.$store.state.artworks.filter(a => (this.artworks.map(am => am.id)).includes(a.id)))
        var filtered = this.$store.state.artworks.filter(function (a) {
          return _this.artworks.map(function (am) {
            return am.id;
          }).includes(a.id);
        });
        // console.log('filtered')
        // console.log(filtered)
        // filtered.forEach(te => {
        //   te = Object.assign({}, te);
        //   let aids = te.artworks.map(tea => tea.id);
        //   let sas = Object.assign([], this.$store.state.artworks);
        //   // console.log('aidss')
        //   // console.log(aids)
        //   let as = Object.assign(
        //     [],
        //     sas.filter(a => aids.includes(a.id))
        //   );
        //   // let artistsids = te.artists.map(tea => tea.id);
        //   // let sars = Object.assign([], this.$store.state.artists)
        //   // // console.log('aidss')
        //   // // console.log(aids)
        //   // let ars = Object.assign(
        //   //   [],
        //   //   sars.filter(a => artistsids.includes(a.id))
        //   // );
        //   // console.log('as')
        //   // console.log(as)
        //   te.artwork_text = as
        //     .map(
        //       aa =>
        //         `${aa.accession_number} ${aa.title} ${aa.name} ${aa.artist_name}`
        //     )
        //     .toString();
        //   // console.log('te.artwork_text')
        //   // console.log(te.artwork_text)
        //   out.push(te);
        // });
      }
      return filtered;
    }
  },
  methods: {
    remove_from_exhibition: function remove_from_exhibition(artwork_id) {
      var _this2 = this;

      // console.log(list_id)
      // console.log(artwork_id)
      var exhibition = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.exhibitions.find(function (e) {
        return e.id == _this2.text_id;
      }));
      // console.log(list)
      exhibition.artworks = exhibition.artworks.filter(function (a) {
        return a != artwork_id;
      });
      // let url = `${this.$globals.apiserver}/lists.json`
      // axios.post(url).then((response) => {
      //   this.loading = false;
      // this.resultsArtists = response.data
      this.$store.dispatch('removeArtworkFromExhibition', { e: this.text_id, a: artwork_id });
      // this.displayedData = response.data

      // }).catch((error) => { console.log(error) })
      // console.log(exhibition)
    },
    artist_artworks: function artist_artworks(artist_id) {
      var a = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
      // console.log('artist_id')
      // console.log(artist_id)
      // console.log(a.artist_id == artist_id)
      var aa = a.filter(function (a) {
        // console.log('a.artist_id')
        // console.log(a.artist_id)
        // console.log(artist_id)
        return a.artist_id === artist_id;
      });
      // console.log(aa)
      return aa;
    },
    clear_selection: function clear_selection() {
      this.$store.dispatch('clearCurrentSelection');
      this.selected = [];
    },
    select_all: function select_all() {},
    save_currently_selected: function save_currently_selected(a, b) {
      // console.log('///////////')
      // console.log('a = ' + a)
      // console.log('b = ' + b.id)
      setTimeout(function () {
        var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
        //// console.log(temp_selection)
        if (!a) {
          // console.log('a true')
          if (!temp_selection.includes(b)) {
            // console.log('doesnt include')
            temp_selection.push(b);
          }
        } else {
          // console.log('false')
          var index = temp_selection.indexOf(b);
          // console.log('index = ' + index)
          temp_selection.splice(index, 1);
        }
        // this.$store.state.currentSelection
        // console.log(temp_selection)
        // this.selected.forEach(s => {
        //   if (!temp_selection.includes(s)) {
        //     temp_selection.push(s)
        //   }
        // })
        // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
        this.$store.dispatch('saveCurrentSelection', temp_selection);
      }.bind(this), 1000);
    },
    save_currently_selected_all: function save_currently_selected_all(a) {
      // console.log('///////////')
      // console.log('a = ' + a)
      var temp_selection = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(temp_selection)
      if (!a) {
        // console.log('a true')
        if (!temp_selection.includes(b)) {
          // console.log('doesnt include')
          temp_selection.push(b);
        }
      } else {
        // console.log('false')
        var index = temp_selection.indexOf(b);
        // console.log('index = ' + index)
        temp_selection.splice(index, 1);
      }
      // this.$store.state.currentSelection
      // console.log(temp_selection)
      // this.selected.forEach(s => {
      //   if (!temp_selection.includes(s)) {
      //     temp_selection.push(s)
      //   }
      // })
      // this.$store.dispatch('saveCurrentSelection',this.$store.state.currentSelection.concat(this.selected).filter((el, i, a) => i === a.indexOf(el)))
      this.$store.dispatch('saveCurrentSelection', temp_selection);
    },
    save_currently_selected_tags: function save_currently_selected_tags() {
      this.$store.dispatch('saveCurrentSelectionTags', this.selected_tags);
      this.ta = this.tagged_artworks;
    }
  }
});

/***/ }),

/***/ "kMiU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kWtg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"mt-4 ml-4",attrs:{"column":""}},[_c('header-elements',{attrs:{"icon":"mdi-code-not-equal-variant","title":"Programmes"},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),_c('elements-table',{attrs:{"items":_vm.programmes,"showUpload":_vm.showUpload,"title":"Programme"},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showUpload),expression:"showUpload"}],staticClass:"mt-0 mb-0 xs12"},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" Cancel\n        ")],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showUpload),expression:"showUpload"}]},[_c('v-container',{staticClass:"elevation-3",attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('h4',{staticClass:"headline"},[_vm._v("Add new programme")]),_vm._v(" "),_vm._l((_vm.fields),function(field){return _c('edit-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_field_c(field)),expression:"show_field_c(field)"}],key:field.key,class:'flex ' + (field.class ? field.class : 'xs12'),attrs:{"id":field.name,"name":field.name,"artwork":_vm.artwork,"field":field,"programme":_vm.programme},model:{value:(field.name),callback:function ($$v) {_vm.$set(field, "name", $$v)},expression:"field.name"}})})],2)],1),_vm._v(" "),_c('v-btn',{on:{"click":_vm.add}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_vm._v("cancel")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "kfWA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['location'],
  computed: {
    full_name: function full_name() {
      return this.location.first_name + ' ' + this.location.last_name;
    },

    link: function link() {
      return '/locations/edit/' + this.location.id;
    }
  }
});

/***/ }),

/***/ "khgZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// const FILTERS = {
//   all(all_todos) {
//     return all_todos;
//   },
//   active(all_todos) {
//     return all_todos.filter(todo => todo.done != 1);
//   },
//   completed(all_todos) {
//     return all_todos.filter(todo => todo.done == 1);
//   }
// };


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      editing: false,
      // editedTodo: {},
      visibility: 'active',
      active_todos: [],
      loading: false,
      showUpload: false,
      showUpload2: false,
      show: false,
      menu2: false,
      menu3: false,
      todo: {
        description: '',
        title: '',
        deadline: '',
        reminder: '',
        done: false,
        done_at: '',
        repeat: '',
        user_ids: [],
        notify: []
      },
      todos: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    // if (this.artwork.artwork_todos && this.artwork.artwork_todos.length > 0) {
    if (this.artwork) {
      this.todos = this.$store.state.todos.filter(function (t) {
        return t.artwork_id === _this.artwork.id;
      });
      // this.todo.users = this.todo.users.map(u => this.$store.state.users.find(us => us.id == u.id))
      // console.log('this.artwork.id')
      // console.log(this.$store.state.todos)
      // console.log(this.todos.length)
      // console.log(this.artwork.id)
    } else {
      this.todos = this.$store.state.todos.filter(function (t) {
        return t.artwork_id === _this.$route.query.id;
      });
      // console.log('this.$route.query.id')
      // console.log(this.$route.query.id)
    }
    // artwork.artwork_todos;
    // } else {
    //   return [];
    // }
  },

  computed: {
    // all_todos() {
    //   return this.todos;
    // },
    team_d: function team_d() {
      var f = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.$store.state.users);
      return f.filter(function (u) {
        return u.enable == 'Y' && u.edit == 1;
      });
    },

    filteredTodos: function filteredTodos() {
      var _this2 = this;

      var todos = this.$store.state.todos.filter(function (t) {
        return t.artwork_id === _this2.artwork.id;
      });
      //if (this.artwork) {
      //  todos = todos.filter(t => t.artwork_id === this.artwork.id)
      //} else {
      //  todos = todos.filter(t => t.artwork_id === this.$route.query.id)
      //}
      if (this.visibility == 'all') {
        return todos;
      } else if (this.visibility == 'active') {
        return todos.filter(function (t) {
          return t.done != 1;
        });
      } else if (this.visibility == 'completed') {
        return todos.filter(function (t) {
          return t.done == 1;
        });
      }
      // }
      // return FILTERS[this.visibility](this.todos);
      // }
      // remaining: function() {
      //   return filters.active(this.todos).length;
      // },
      // allDone: {
      //   get: function() {
      //     return this.remaining === 0;
      //   },
      //   set: function(value) {
      //     this.todos.forEach(function(todo) {
      //     a  todo.completed = value;
      //     });
      //   }
    }
  },
  methods: {
    getColor: function getColor(t) {
      // console.log(this.format_date(Date.now()))
      // console.log(t.deadline)
      return t.deadline < this.format_date(Date.now()) ? 'red' : 'black';
    },
    new_todo: function new_todo() {
      this.editing = false;
      this.todo.deadline = ''; // this.format_date(Date.now())
      this.todo.reminder = ''; // this.format_date(Date.now())
      this.showUpload = true;
      this.todo.user_ids = [];
      this.todo.user_ids.push(this.c_user.id);
      this.todo.notify = [];
      this.todo.notify.push(this.c_user);
      this.todo.created_by = this.c_user.id;
    },
    remove: function remove(item) {
      var index = this.todo.user_ids.indexOf(item.id);
      if (index >= 0) this.todo.user_ids.splice(index, 1);
    },

    // download() {},
    delete_todo: function delete_todo(todo) {
      var _this3 = this;

      var url = this.$globals.apiserver + '/artwork_todos/' + todo.id + '.json';
      __WEBPACK_IMPORTED_MODULE_6_axios___default.a.delete(url, todo).then(function (response) {
        _this3.errors = {};
        var index = _this3.todos.indexOf(todo);
        if (index >= 0) _this3.todos.splice(index, 1);
        // this.artwork.artwork_todos.push(response.data);
        // this.artwork.artwork_todos = [
        //   ...this.artwork.artwork_todos.map(item =>
        //     item.id !== this.todo.id ? item : { ...item, ...this.todo }
        //   )
        // ];
        // console.log(this.artwork.artwork_todos);
        // this.todos = this.artwork.artwork_todos;
        // this.all_todos = Object.assign([],this.artwork.artwork_todos)
        // this.active_todos.push(response.data);
        // this.todos.push(response.data);
        // this.editing = false;
        _this3.$emit('getArtwork');
        _this3.$store.dispatch('loadTodos');
        _this3.$store.dispatch('updateArtwork', _this3.artwork.id);
        // this.artwork = this.$store.state.artworks.find(
        //   a => (a.id = this.artwork.id)
        // );
      }).catch(function (error) {
        _this3.errors = error.response.data;
      });
    },
    edit_todo: function edit_todo(id) {
      this.editing = true;
      try {
        this.todo = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.todos.find(function (t) {
          return t.id == id;
        }));
        this.todo.user_ids = this.todo.users.map(function (u) {
          return u.id;
        });
        this.todo.deadline = this.todo.deadline ? this.format_date(this.todo.deadline) : null;
        this.todo.reminder = this.todo.reminder ? this.format_date(this.todo.reminder) : null;
        this.showUpload = true;
      } catch (error) {
        // console.log(error.message)
      }
    },
    done_todo: function done_todo(tt) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var t, url;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // const todoIndex = this.todos.indexOf(t);
                // console.log(t);
                t = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, tt);
                // const todoIndex = this.todos.indexOf(tt);

                if (t.done == 0 || t.done == '') {
                  t.done = 1;
                  t.done_at = _this4.format_date(Date.now());
                } else {
                  t.done = 0;
                  t.done_at = null;
                }
                url = _this4.$globals.apiserver + '/artwork_todos/' + t.id + '.json';
                // var todoDone = {t.}
                // this.$store.dispatch('toggleTodo', tt)

                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, {
                  todo: { done: t.done, done_at: t.done_at }
                }).then(function (response) {
                  _this4.errors = {};
                  _this4.$emit('showSnackbar', 'Todo saved.', 'green');
                  // this.artwork.artwork_todos.push(response.data);
                  // this.todos = [
                  //   ...this.todos.map(item =>
                  //     item.id !== this.todo.id ? item : { ...item, ...this.todo }
                  //   )
                  // ];
                  // console.log(this.artwork.artwork_todos);
                  // this.todos = this.artwork.artwork_todos;
                  // this.all_todos = Object.assign([],this.artwork.artwork_todos)
                  // this.active_todos.push(response.data);
                  // this.todos.push(response.data);
                  _this4.editing = false;
                  // this.$store.dispatch("updateArtwork", this.artwork.id);
                  // this.artwork = this.$store.state.artworks.find(
                  //   a => (a.id = this.artwork.id)
                  // );
                }).catch(function (error) {
                  _this4.errors = error.response.data;
                });

              case 5:
                // this.editing = false;
                _this4.$store.dispatch('loadTodos');
                _this4.$emit('getArtwork');

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    save_todo: function save_todo() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_5__main__["serverBus"].$emit('showSnackbar', 'Adding new Todo …');
      // console.log(this.editing);
      // console.log(this.todo);
      // this.todo.id = this.findMinMax(this.all_todos)+1
      // if (!this.artwork.artwork_todos) {
      //   this.artwork.artwork_todos = [];
      // }

      if (this.editing) {
        // SAVING EDITED TODO
        var url = this.$globals.apiserver + '/artwork_todos/' + this.todo.id + '.json';
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.put(url, {
          todo: this.todo
        }).then(function (response) {
          __WEBPACK_IMPORTED_MODULE_5__main__["serverBus"].$emit('showSnackbar', 'Todo saved.', 'green');
          _this5.errors = {};
          // console.log(response.data);
          // console.log(this.todo);
          _this5.$store.dispatch('saveTodo', _this5.editing);
          // this.artwork.artwork_todos.push(response.data);
          _this5.todos = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(_this5.todos.map(function (item) {
            return item.id !== response.data.id ? item : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, item, response.data);
          })));
          // this.todos = [
          // console.log(this.todos);
          //   ...this.todos.map(item =>
          //     item.id !== this.todo.id ? item : { ...item, ...this.todo }
          //   )
          // ];
          // this.todos = this.artwork.artwork_todos;
          // console.log(this.todos);
          // this.artwork.artwork_todos = this.todos;
          // this.all_todos = Object.assign([],this.artwork.artwork_todos)
          // this.active_todos.push(response.data);
          // this.todos.push(response.data);
          _this5.editing = false;
          _this5.$store.dispatch('updateArtwork', _this5.artwork.id);
        }).catch(function (error) {
          _this5.errors = error.response.data;
          __WEBPACK_IMPORTED_MODULE_5__main__["serverBus"].$emit('showSnackbar', 'Problem occured while saving Todo. Try again or contact support.');
          // console.log(this.errors)
        });
      } else {
        // SAVING NEW TODO
        this.todo.artwork_id = this.artwork.id;
        this.todo.done = false;
        this.todo.created_by = this.c_user.id;
        __WEBPACK_IMPORTED_MODULE_6_axios___default.a.post(this.$globals.apiserver + '/artwork_todos.json', {
          todo: this.todo
        }).then(function (response) {
          _this5.errors = {};
          _this5.$store.dispatch('updateArtwork', _this5.artwork.id);
          _this5.$store.dispatch('loadTodos');
          // this.todos.push(response.data);
          // this.active_todos = this.artwork.artwork_todos
          _this5.$store.dispatch('addTodo', response.data);
          // this.active_todos.push(response.data);
          _this5.todos.push(response.data);
        }).catch(function (error) {
          _this5.errors = error.response.data;
        });
      }
      this.showUpload = !this.showUpload;
      this.todo = {
        description: '',
        title: '',
        deadline: '',
        done: false,
        done_at: '',
        team: [],
        notify: ''
      };
    },
    cancel: function cancel() {
      this.showUpload = false;
      this.todo = {
        description: '',
        title: '',
        deadline: '',
        reminder: '',
        done: false,
        done_at: '',
        repeat: '',
        user_ids: [],
        notify: []
      };
    }
  }
});

/***/ }),

/***/ "l7Zr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "l848":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artists_vue__ = __webpack_require__("H/o8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f534620_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artists_vue__ = __webpack_require__("QOtO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("gr3N")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f534620"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Artists_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f534620_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artists_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f534620_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Artists_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lE9Q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: '',
      check: [],
      tagCheck: [],
      conceptualSectionCheck: [],
      sectionCheck: []
    };
  },

  watch: {
    tagCheck: function tagCheck(val) {
      // console.log(val)
      this.$emit('updateFilterTags', val);
    }
  },
  props: ['artwork'],
  computed: {
    conceptual_tag_categories: function conceptual_tag_categories() {
      if (this.search && this.search[0] == '#') {
        console.log(this.search);
        var s = this.search.substring(1);
        return this.$store.getters.conceptual_tag_categories.filter(function (ctg) {
          return ctg.name.match(s);
        });
      } else {
        return this.$store.getters.conceptual_tag_categories;
      }
    },
    conceptual_tags: function conceptual_tags() {
      var _this = this;

      if (this.search && this.search.length > 2) {
        var foundTags = this.$store.getters.conceptual_tags.filter(function (ct) {
          return ct.name.match(_this.search);
        });
        // var conceptualToTurnOn = []
        this.conceptualSectionCheck = [];
        foundTags.forEach(function (ft) {
          var cc = _this.$store.getters.conceptual_tags.find(function (ct) {
            return ct.name == ft.category && ct.concept_tag == 1;
          });
          if (cc) {
            _this.conceptualSectionCheck.indexOf(cc.name) === -1 ? _this.conceptualSectionCheck.push(cc.name) : console.log('This item already exists');
          }
        });
      } else {
        var foundTags = this.conceptualSectionCheck;
        foundTags.forEach(function (ft) {
          var cc = _this.$store.getters.conceptual_tags.find(function (ct) {
            return ct.name == ft.category && ct.concept_tag == 1;
          });
          if (cc) {
            _this.conceptualSectionCheck.indexOf(cc.name) === -1 ? _this.conceptualSectionCheck.push(cc.name) : console.log('This item already exists');
          }
        });
      }
      // console.log(conceptualToTurnOn)
      // console.log(this.search)
      return this.$store.getters.conceptual_tags.filter(function (ct) {
        return ct.name.match(_this.search);
      });
    },
    cataloguing_tags: function cataloguing_tags() {
      return this.$store.getters.cataloguing_tags;
    },
    tag_names: function tag_names() {
      var _this2 = this;

      return this.tagCheck.map(function (id) {
        return _this2.$store.state.tags.find(function (st) {
          return id == st.id;
        }).name;
      });
    }
    // tag_categories () {
    //     var array = Object.assign([],this.$store.state.tags)
    //     console.log(array.length)
    //     var unique = [];
    //     var distinct = [];
    //     for( let i = 0; i < array.length; i++ ){
    //         if( !unique[array[i].category]){
    //             if (array[i].category != null) {
    //                 distinct.push(array[i].category);
    //                 unique[array[i].category] = 1;
    //             }
    //         }
    //     }
    //     return distinct.sort()
    // }

  },
  methods: {
    getTags: function getTags(tc) {
      return this.$store.state.tags.filter(function (t) {
        return t.category == tc;
      }).sort(function (a, b) {
        return a.name < b.name ? -1 : 0;
      });
    },
    getSubcategoryTags: function getSubcategoryTags(tc) {
      return this.$store.state.tags.filter(function (t) {
        return t.subcategory == tc;
      }).sort(function (a, b) {
        return a.name < b.name ? -1 : 0;
      });
    }
  }
});

/***/ }),

/***/ "lKkF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoanHistory_vue__ = __webpack_require__("93eS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d648304_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanHistory_vue__ = __webpack_require__("Upkr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("FOKY")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d648304"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoanHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d648304_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanHistory_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d648304_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoanHistory_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lMmx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lPLT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lT+D":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Images_vue__ = __webpack_require__("KDuV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae3353a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Images_vue__ = __webpack_require__("MCIr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("5g8X")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4ae3353a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Images_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae3353a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Images_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ae3353a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Images_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ldH3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lh22":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("HexB");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f09b8f2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("cAN7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Iie8")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f09b8f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f09b8f2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f09b8f2_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "loos":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lsII":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"800px","transition":"dialog-transition"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-flex',{staticClass:"xs12 ml-0 pl-4 pr-4 pt-4 pb-3 layout row wrap elevation-0 white"},[_c('v-flex',{staticClass:"xs12"},[_c('v-autocomplete',{attrs:{"label":"New Ownership","items":_vm.ownerships,"item-text":"name","item-value":"id","cache-items":"","dense":""},model:{value:(_vm.editedOwnershipHistory.artwork_ownership_id),callback:function ($$v) {_vm.$set(_vm.editedOwnershipHistory, "artwork_ownership_id", $$v)},expression:"editedOwnershipHistory.artwork_ownership_id"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"note","label":"Note"},model:{value:(_vm.editedOwnershipHistory.note),callback:function ($$v) {_vm.$set(_vm.editedOwnershipHistory, "note", $$v)},expression:"editedOwnershipHistory.note"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-menu',{ref:"menu2",attrs:{"return-value":_vm.editedOwnershipHistory.change_date,"close-on-content-click":true,"nudge-right":40,"lazy":"","landscape":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.editedOwnershipHistory, "change_date", $event)},"update:return-value":function($event){return _vm.$set(_vm.editedOwnershipHistory, "change_date", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.editedOwnershipHistory.change_date),callback:function ($$v) {_vm.$set(_vm.editedOwnershipHistory, "change_date", $$v)},expression:"editedOwnershipHistory.change_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"persistent":"","color":"black"},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.editedOwnershipHistory.change_date)}},model:{value:(_vm.editedOwnershipHistory.change_date),callback:function ($$v) {_vm.$set(_vm.editedOwnershipHistory, "change_date", $$v)},expression:"editedOwnershipHistory.change_date"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"}),_vm._v(" "),_c('v-flex',{staticClass:"xs12 pr-0 mr-0 mt-3",attrs:{"text-xs-right":""}},[_c('v-btn',{on:{"click":function($event){_vm.editDialog = !_vm.editDialog}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{on:{"click":_vm.save_edited_artwork_ownership_history}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-0",attrs:{"column":""}},[(_vm.c_user.edit)?_c('v-layout',{attrs:{"row":"","wrap":"","xs12":"","sm12":"","md12":"","mt-4":"","ml-0":"","mr-0":"","px-0":""}},[(
          _vm.artwork.artwork_ownership_logs &&
            _vm.artwork.artwork_ownership_logs.length > 0
        )?_c('v-flex',{attrs:{"text-xs-center":"","ml-2":"","mr-2":""}},[_vm._v("\n        Show Ownership History\n        "),_c('v-btn',{staticClass:"my-0 py-0",attrs:{"icon":"","small":""},on:{"click":function($event){_vm.showList = !_vm.showList}}},[(!_vm.showList)?_c('v-icon',[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.showList)?_c('v-icon',[_vm._v("expand_less")]):_vm._e()],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.c_user.edit && _vm.showList)?_c('v-flex',{attrs:{"row":"","xs12":"","sm12":"","md12":"","mt-0":"","ml-2":"","mr-2":""}},[(
          _vm.artwork.artwork_ownership_logs &&
            _vm.artwork.artwork_ownership_logs.length > 0
        )?_c('v-list',{staticClass:"xs12"},[_vm._l((_vm.artwork.artwork_ownership_logs),function(l){return [_c('v-list-tile',{key:l.id},[_c('v-list-tile-content',[_c('v-list-tile-title',[(l.artwork_ownership_id)?_c('span',{staticClass:"subheading font-weight-bold"},[_vm._v(_vm._s(_vm.getOwnershipName(l.artwork_ownership_id))+" ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"right"},[(l.change_date != null)?_c('span',[_vm._v(_vm._s(_vm.format_date(l.change_date)))]):_vm._e()])]),_vm._v(" "),(l.note)?_c('v-list-tile-sub-title',[_c('span',[_vm._v(_vm._s(l.note))])]):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"right"},[_c('v-btn',{key:l.id+'b',staticClass:"mr-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.editExhibitionHistory(l)}}},[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("edit")])],1)],1)],1),_vm._v(" "),_c('v-divider',{key:("a" + (l.id)),staticClass:"my-2"})]})],2):_vm._e()],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "mBTR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.f_field.headline)?_c('div',[_c('h1',{staticClass:"headline"},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}})],1):_c('div',[(_vm.value_calculated_empty)?_c('v-container',{attrs:{"grid-list-md":""}},[(_vm.f_field.ctype=='text-short')?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs3":"","text-xs-right":"","dark":""}},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs9":"","text-xs-left":""},domProps:{"innerHTML":_vm._s(_vm.value_calculated)}})],1)],1):(_vm.f_field.ctype=='text-long')?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","text-xs-left":""}},[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.f_field.title))])])],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","text-xs-left":""},domProps:{"innerHTML":_vm._s(_vm.value_calculated)}})],1)],1):(_vm.f_field.ctype=='date')?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs3":"","text-xs-right":"","dark":""}},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs9":"","text-xs-left":""},domProps:{"innerHTML":_vm._s(_vm.format_date(_vm.value_calculated,_vm.f_field.format))}})],1)],1):(_vm.f_field.ctype=='bool')?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","xs3":"","text-xs-right":"","dark":""}},[_vm._v(_vm._s(_vm.f_field.title))]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs9":"","text-xs-left":""},domProps:{"innerHTML":_vm._s(_vm.value_from_array)}})],1)],1):_vm._e()]):_vm._e()],1)])}
var staticRenderFns = []


/***/ }),

/***/ "mLuL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Excel_vue__ = __webpack_require__("0rFo");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004d18b0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Excel_vue__ = __webpack_require__("OUKN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("G+NM")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-004d18b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Excel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004d18b0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Excel_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004d18b0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Excel_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mUHq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_weak_map__ = __webpack_require__("XFB5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__ = __webpack_require__("EWlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__ = __webpack_require__("u1n8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FilterBox__ = __webpack_require__("M21a");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Labels__ = __webpack_require__("RVzw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LabelsSmall__ = __webpack_require__("VwPy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LabelsSmallText__ = __webpack_require__("6gSs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Solo__ = __webpack_require__("Tshf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SoloExt__ = __webpack_require__("hoPK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TestList__ = __webpack_require__("Gk4k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_artworks_Excel__ = __webpack_require__("mLuL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mixins_ListsMixin__ = __webpack_require__("ml9J");




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















__WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_6_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;

function dynamicSort(property, property2) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    // var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    if (a[property] > b[property]) return 1;
    if (a[property] < b[property]) return -1;
    if (a[property2] > b[property2]) return 1;
    if (a[property2] < b[property2]) return -1;
    // return result * sortOrder;
  };
}

/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_17__mixins_ListsMixin__["a" /* default */]],
  data: function data() {
    return {
      // show_advanced: false,
      show_preview_pane: false,
      constants: __WEBPACK_IMPORTED_MODULE_4__data_constants__["a" /* default */],
      filteredArtworks: [],
      options: false,
      filter_view: 'data', // musí byť data lebo inak nefunguje sorting of output fields
      filteredProperty: '0',
      query: '',
      anquery1: '',
      anquery2: '',
      anquery3: '',
      anquery4: '',
      query1: '',
      activeFilters: [],
      query_array: [],
      menu_acq_from: false,
      menu_acq_to: false,
      query_from: '',
      query_to: '',
      // filteredProperty: [],
      selection_for_adding: '',
      add_current_selection: '',
      // loader: null,
      loading: false,
      itemKeys: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_weak_map___default.a(),
      currentItemKey: 0,
      headers: [{
        sortable: false
      }, {
        text: 'title',
        align: 'left',
        sortable: false,
        value: 'name'
      }],
      advanced: [{ title: 'Technicians, Contacts …', id: 'technician' }, { title: 'Space (max/min)', id: 'space_max_min' }, { title: 'Technical Equipment', id: 'required_equipment' }, { title: 'Existing Equipment', id: 'installation_requirements' }, { title: 'Tools & Gear', id: 'tools_and_gear' }, { title: 'Light', id: 'light' }, { title: 'Climate & Conditions', id: 'climate_and_conditions' }, { title: 'Power', id: 'power' }, { title: 'Spare or replacement parts', id: 'spare_or_replacement_parts' }, {
        title: 'Other / Special',
        id: 'display_notes_and_other_special_merged'
      }, { title: 'Projection', id: 'projection' }, { title: 'Sound and acoustic', id: 'sound_and_acoustic' }, { title: 'On-and Off-Procedure', id: 'on_off_procedure' }, { title: 'Maintenance', id: 'maintenance' }, {
        title: 'Security and Safety Details',
        id: 'security_and_safety_details'
      }, {
        title: 'Regular inspection/ Pay attention to',
        id: 'regular_inspection'
      }, { title: 'Cleaning Artwork', id: 'cleaning_artwork' }, { title: 'Contacts / Producers', id: 'contacts_producers' }, { title: 'Hanging Devices', id: 'hanging_devices' }, { title: 'Specification on space', id: 'specifications_on_space' }],
      items: [
      // { title: "Accession Number", id: "accession_number"},
      { title: 'Acquisition Date', id: 'acquisition_date' }, { title: 'Acquisition Method', id: 'acquisition_method_text' }, { title: 'Acquisition Price', id: 'purchase_price_text' }, { title: 'Acquisition Source', id: 'acquisition_source_text' },
      // { title: "Artist", id:"name"},
      { title: 'Certificate', id: 'certificate_new' }, { title: 'Classification', id: 'classification' },
      // { title: 'Conservator', id: 'conservator' },
      { title: 'Credit', id: 'credit' }, { title: 'Deaccession Date', id: 'deaccession_date' }, { title: 'Deaccessioned', id: 'deaccessioned' }, { title: 'Dimensions', id: 'dim' }, { title: 'Dimensions (Detail)', id: 'dim_detail' }, { title: 'Edition State', id: 'edition_state' }, { title: 'Exhibitions', id: 'exhibitions' }, { title: 'Import Date', id: 'import_date' }, { title: 'Import Taxes', id: 'import_taxes' }, { title: 'Import Export History', id: 'import_export_history' }, { title: 'Import Export Notes', id: 'import_export_notes' }, { title: 'Insurrance Value (Legacy)', id: 'insurance_value_text' }, { title: 'Insurrance Value Latest from History Log', id: 'insurance_value_latest' }, { title: 'Last Media Check', id: 'last_media_check' }, { title: 'Location', id: 'location_name' }, { title: 'Location Notes', id: 'location_notes' }, { title: 'Media/Material/Description', id: 'media_material_description' }, { title: 'Ownership', id: 'ownership_info' }, { title: 'ToDos', id: 'todos' }, { title: 'Packings', id: 'packings' }, { title: 'Paid in Country', id: 'paid_in_country' },
      // { title: "Production date", id:"production_date_new"},
      { title: 'Signature', id: 'signature_new' }, { title: 'Type of Work', id: 'type_of_work_id' },
      // { title: "Title", id:"title"},
      { title: 'Visa status', id: 'visa_status_text' }],
      selected: [],
      selected_settings: [],
      // output_list: [{name:'test',order:1,fixed:false},{name:'test2',order:2,fixed:false},{name:'test3',order:3,fixed:false}],
      searchFields: ['classification', 'ownership'],
      search_fields: [],
      searchtFieldsParams: [],
      search: '',
      outputFields: ['classification', 'ownership'],
      output_fields: [],
      outputFieldsParams: [],
      valid: true,
      list_settings: {
        use_current_selection: false,
        use_current_list_selection: false,
        financial_information: false,
        image: false,
        compact: false,
        table: true,
        view: 'table',
        sort: 'sort_name',
        add_empty_column: false
      },
      use_current_selection: false,
      use_current_list_selection: false,
      financial_information: false,
      image: true,
      compact: false,
      table: true,
      view: 'table',
      sort: 'sort_name',
      subsort: 'accession_number',
      add_empty_column: false,
      xls: false,
      title: '',
      subtitle: '',
      imageSize2: '170',
      imageQuality: 'normal',
      pdf_artworks: [],
      created_by: false,
      created_at: false,
      page_no: true,
      text_properties: [{ name: 'Credit', value: 'credit' }, { name: 'Edition', value: 'edition_state' }, { name: 'Title', value: 'title' }, { name: 'Artist Name', value: 'artist' }, {
        name: 'Media material description',
        value: 'media_material_description'
      }],
      bool_properties: [{ name: 'Certificate', value: 'certificate_new' }, { name: 'Deaccessioned', value: 'deaccessioned' }, { name: 'Signature', value: 'signature_new' }, { name: 'To-Dos', value: 'todos' }],
      showNoOfArtworks: true,
      tag_categories: [{ id: 1, name: 'TBA21 Exhibition', color: 'red', position: 2 }, { id: 2, name: 'TBA21 Production', color: 'green', position: 3 }, { id: 3, name: 'FTB Sorting', color: 'blue', position: 1 }, { id: 4, name: 'TBA21 Projects', color: 'yellow', position: 4 }, { id: 5, name: 'TBA21 Events', color: 'pink', position: 5 }, { id: 6, name: 'Exhibitions', color: 'grey', position: 6 }, { id: 7, name: 'Institutions', color: 'purple', position: 7 }]
    };
  },
  // props: ['list', 'index', 'se', 'disable'],
  // created () {
  //   this.pdf(false)
  // },
  computed: {
    items_calc: function items_calc() {
      // return this.show_advanced ? this.items : this.items_advanced
      return this.items_advanced;
    },
    items_advanced: function items_advanced() {
      return this.items.concat(this.advanced).sort(function (a, b) {
        return a.title > b.title ? 1 : b.title > a.title ? -1 : 0;
      });
    },
    select_tags_assign: function select_tags_assign() {
      // var stc = this.selected_tag_categories
      var tc = this.tag_categories;
      var tags = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.tags);
      var out = [];
      tags.forEach(function (tag) {
        var a = tc.filter(function (tagc) {
          return tagc.id == tag.tag_category_id;
        });
        if (a[0] > 0) {
          tag.color = a[0].color;
        }
        out.push(tag);
      });
      out = out.sort(function (a, b) {
        var nameA = a.name ? a.name.toUpperCase() : '0'; // ignore upper and lowercase
        var nameB = b.name ? b.name.toUpperCase() : '0'; // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      // return out.filter(function(tag) { return stc.some(st => tag.tag_category_id==st)})
      return out;
    },
    locations: function locations() {
      var a = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.getters.enabled_locations);
      return a.sort(function (a, b) {
        return a.name.toUpperCase().localeCompare(b.name.toUpperCase());
      });
    },

    options_c: {
      get: function get() {
        // if (this.$store.state.options) {
        //   this.selected = Object.assign([], this.$store.state.currentOutputFieldsSelection)
        //   new Sortable(
        //     this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0],
        //     {
        //       draggable: '.sortableRow',
        //       handle: '.sortHandle',
        //       onEnd: this.dragReorder
        //     }
        //   )
        // }
        return this.$store.state.options;
      },
      set: function set(value) {
        this.$store.dispatch('saveOptions', value);
      }
    },
    exhibitions: function exhibitions() {
      var o = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.exhibitions);
      o = o.map(function (a) {
        a.select_text = (a.duration_start_year ? a.duration_start_year + ' - ' : '') + ' ' + a.title.replace(/<\/?[^>]+(>|$)/g, ' ');
        return a;
      });
      // o = o.sort(function(a, b){ if (a.select_text < b.select_text) { return -1; } if (a.select_text > b.select_text) { return 1; } return 0})
      o = o.sort(function (a, b) {
        a.id < b.id;
      });
      return o;
    },
    all_properties: function all_properties() {
      var all = this.text_properties.concat(this.bool_properties).concat([{ name: 'Production Date', value: 'production_date_new' }, { name: 'Location History', value: 'location_history' }, { name: 'Deaccession Date', value: 'deaccession_date' }, { name: 'Acquisition Date', value: 'acquisition_date' },
      // { name: 'Classification', value: 'classification' },
      // { name: 'Classification New', value: 'classification_new_id' },
      { name: 'Type of Work', value: 'type_of_work_id' }, { name: 'Customs', value: 'visa_status' }, { name: 'Location', value: 'artwork_location_id' }, { name: 'Todos', value: 'todos' }, { name: 'Packings', value: 'packings' }, { name: 'Import Date', value: 'import_date' }, { name: 'Acquisition Method', value: 'acquisition_method' }, { name: 'Exhibitions', value: 'exhibitions' }, { name: 'Ownership', value: 'ownership' }, { name: 'Ownership Status', value: 'acquired' }, { name: 'Tags', value: 'tags' }, { name: 'Accession No.', value: 'accession_number' }]);
      all = all.concat([{ name: 'Select a Field to Filter by', value: '0' }]);
      all.sort(function (a, b) {
        var nameA = a.name.toUpperCase();
        var nameB = b.name.toUpperCase();
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        return 0;
      });
      return all;
    },

    // dblists() {
    //   return yaml.load(this.$store.state.lists[0].artworks)
    // },

    // TOTO sa POUZIVA V EXCELI ? ?
    excelArtworks: function excelArtworks() {
      var _this = this;

      var tempArtworks = [];
      // DEFAULT - LOADS ARTWORKS FROM FILTER TABLE
      if (this.$store.state.filterResults) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        tempArtworks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.filterResults);
        // console.log('filtered')
        // console.log(tempArtworks)
      } else {
        tempArtworks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.unfiltered_artworks_for_list);
      }
      // IF SELECTION IS CHOSEN, LOADS ARTWORKS FROM SELECTION
      if (this.selection_for_adding) {
        var selections = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks_selections);
        var sel = selections.find(function (s) {
          return s.title === _this.selection_for_adding;
        });
        var s = this.o2ids(sel.artworks, 'id');
        // console.log('from selection')
        // console.log(s)
        // console.log(tempArtworks)
        tempArtworks = tempArtworks.concat(s);
      }
      // ADDS ARTWORKS SELECTED IN COLLECTION TO LIST TOO
      if (this.add_current_selection) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        var objs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
        var s = this.o2ids(objs, 'id');
        // console.log('currently selected')
        // console.log(s)
        tempArtworks = tempArtworks.concat(s);
        // console.log(tempArtworks)
      }
      // ADDS ONLY ARTWORKS CHECKED IN FILTERED RESULTS
      if (this.use_current_list_selection) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        var objs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentListSelection);
        var s = this.o2ids(objs, 'id');
        // console.log('currently selected in list')
        // console.log(s)
        tempArtworks = objs;
        // console.log(tempArtworks)
      }

      tempArtworks = this.ids2o(tempArtworks);

      if (this.sort == 'collection') {
        var collectionsIds = [1, 12, 15, 6, 7, 17, 10];
        tempArtworks = this.customDoubleSort(tempArtworks, collectionsIds, 'ownership', this.subsort);
      } else {
        tempArtworks = tempArtworks.sort(dynamicSort(this.sort, this.subsort));
      }

      return tempArtworks;
    },

    // use_current_selection_computed() {
    //   if (this.currentSelection.length == 0 || this.currentSelection.length == null) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    artworks_selections: function artworks_selections() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks_selections).reverse();
    },

    // selected() {
    //   return this.$store.state.currentSelection
    // },
    currentSelection: function currentSelection() {
      return this.$store.state.currentSelection;
    },
    currentListSelection: function currentListSelection() {
      return this.$store.state.currentListSelection;
    },
    unfiltered_artworks_for_list: function unfiltered_artworks_for_list() {
      if (this.use_current_selection == true) {
        // this.$store.dispatch('saveArtworksForPdf',this.$store.state.currentSelection)
        // console.log('use_current_selection TRUE')
        // console.log(this.$store.state.currentSelection)
        // console.log(this.ids2o(this.$store.state.currentSelection))
        return this.ids2o(this.$store.state.currentSelection);
      } else {
        // console.log('use_current_selection FALSE')
        // console.log(this.$store.state.artworks.length)
        var filtered = this.$store.state.artworks;
        // .filter(function(a) {
        //   return (a.ownership != 6 && a.ownership != 7 && a.ownership != 8 && a.ownership != 9 && a.ownership != 10)
        // })
        // this.$store.dispatch('saveArtworksForPdf',filtered)
        return filtered;
      }
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.$route.params.loadCurrent) {
      this.use_current_selection = true;
    }
    __WEBPACK_IMPORTED_MODULE_14__main__["serverBus"].$on('setUseCurrentSelectionCheckboxToFalse', function (value) {
      _this2.use_current_selection = value;
    });
    __WEBPACK_IMPORTED_MODULE_14__main__["serverBus"].$on('updateFiltered', function (value) {
      _this2.filteredArtworks = value;
    });
    this.$store.dispatch('loadArtworks');
  },
  mounted: function mounted() {
    this.selected = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentOutputFieldsSelection);
    // console.log(this.selected)
    /* eslint-disable no-new */
    new Sortable(this.$refs.sortableTable.$el.getElementsByTagName('tbody')[0], {
      draggable: '.sortableRow',
      handle: '.sortHandle',
      onEnd: this.dragReorder
    });
  },

  methods: {
    addToSelection: function addToSelection(s) {
      var ss = this.o2ids(s, 'id');
      this.$store.dispatch('addToCurrentSelection', ss);
    },
    closeOptions: function closeOptions() {
      this.options = !this.options;
      this.$store.dispatch('saveOptions', !this.$store.state.options);
    },

    // updateFilters () {
    //   this.activeFilters
    // },
    updateFilters: function updateFilters() {
      __WEBPACK_IMPORTED_MODULE_14__main__["serverBus"].$emit('updateFilters', this.activeFilters);
    },
    keys2sentence: function keys2sentence(ks, fn) {
      var out = [];
      for (var k in ks) {
        if (fn == 'acquisition_method') {
          for (var s in this.constants.ACQUISITION_METHODS) {
            if (ks[k] == this.constants.ACQUISITION_METHODS[s].id) {
              out.push(this.constants.ACQUISITION_METHODS[s].name);
            }
          }
          // return out.join(', ')
        } else if (fn == 'visa_status') {
          for (var s in this.constants.VISA_STATUSES) {
            if (ks[k] == this.constants.VISA_STATUSES[s].id) {
              out.push(this.constants.VISA_STATUSES[s].name);
            }
          }
          // return out.join(', ')
        } else if (fn == 'artwork_location_id') {
          for (var s in this.$store.state.locations) {
            if (ks[k] == this.$store.state.locations[s].id) {
              out.push(this.$store.state.locations[s].name);
            }
          }
        } else if (fn == 'tags') {
          for (var s in this.select_tags_assign) {
            if (ks[k] == this.select_tags_assign[s].id) {
              out.push(this.select_tags_assign[s].name);
            }
          }
          // return out.join(', ')
        } else if (fn == 'accession_number') {
          out.push(ks[k]);
          // return out.join(', ')
        }
      }
      return out;
    },
    addFilter: function addFilter() {
      // console.log('filter added lists')
      this.activeFilters.push({
        name: this.filteredProperty,
        value: this.query,
        value_from: this.query_from,
        value_to: this.query_to,
        value_array: this.query_array,
        anquery1: this.anquery1,
        anquery2: this.anquery2,
        anquery3: this.anquery3,
        anquery4: this.anquery4
      });
      this.query = '';
      this.query_from = '';
      this.query_to = '';
      this.query_array = [];
      this.filteredProperty = '0';
      this.updateFilters();
    },
    inverse: function inverse(idx) {
      this.activeFilters.push({
        name: this.activeFilters[idx].name,
        value: this.activeFilters[idx].value,
        value_from: this.activeFilters[idx].value_from,
        value_to: this.activeFilters[idx].value_to,
        value_array: this.activeFilters[idx].value_array,
        inverse: this.activeFilters[idx].inverse ? false : true
      });
      this.activeFilters.splice(idx, 1);
      // this.query = ''
    },
    removeFilter: function removeFilter(idx) {
      this.activeFilters.splice(idx, 1);
    },
    o2ids: function o2ids(array, prop) {
      return array.map(function (a) {
        return a[prop];
      });
    },
    ids2o: function ids2o(array) {
      var objs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
      var out = objs.filter(function (a) {
        return array.includes(a.id);
      });
      return out;
    },
    saveCurrentSelectionToUser: function saveCurrentSelectionToUser() {
      this.$store.dispatch('saveOutputFieldsToUser', {
        artworks: this.$store.state.currentSelection,
        title: this.selection_title,
        created_at: new Date().toISOString().substring(0, 19).replace('T', ' ')
      });
      this.save_selection_form_display = false;
      this.selection_title = '';
    },
    loadSelection: function loadSelection(e) {
      this.$store.dispatch('saveCurrentSelection', e);
    },
    saveToStore: function saveToStore() {
      // this.selected  = []
      this.$store.dispatch('saveCurrentOutputFieldsSelection', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.selected));
    },
    resetFields: function resetFields() {
      this.selected = [];
      this.$store.dispatch('saveCurrentOutputFieldsSelection', []);
    },

    // format_date (date) {
    //   var moment = require('moment')
    //   var ndate = new Date(date)
    //   return moment(ndate).format('YYYY-MM-DD')
    // },
    dragReorder: function dragReorder(_ref) {
      var oldIndex = _ref.oldIndex,
          newIndex = _ref.newIndex;

      // nacitam si do premennej item ktory treba presunut
      var movedItem = this.selected.splice(oldIndex, 1)[0];
      // vsuniem item na novy index
      this.selected.splice(newIndex, 0, movedItem);
      this.$store.dispatch('saveCurrentOutputFieldsSelection', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.selected));
    },
    itemKey: function itemKey(item) {
      if (!this.itemKeys.has(item)) this.itemKeys.set(item, ++this.currentItemKey);
      return this.itemKeys.get(item);
    },
    toggle: function toggle(index, field) {
      var i = this.selected.indexOf(index);
      if (i > -1) {
        this.selected.splice(i, 1);
        this.output_fields.splice(i, 1);
      } else {
        this.selected.push(index);
        this.output_fields.push(field.id);
      }
      // this.$store.dispatch("saveSelectedColumnsForPdf",this.selected)
    },
    pdf_call: function pdf_call(full) {
      this.loading = true;
      setTimeout(function () {
        setTimeout(function () {
          this.pdf(full);
          this.loading = false;
        }.bind(this), 0);
      }.bind(this), 500);
    },
    pdf: function pdf(full) {
      var _this3 = this;

      // if (full == true) {
      //   this.loading = true
      // }
      if (!full) {
        this.show_preview_pane = true;
      }
      if (this.view == 'compact') {
        var heights = 50;
        var margins = [0, 10, 0, 10];
      } else if (this.view == 'table') {
        var heights = 20;
        var margins = [0, 10, 0, 10];
      } else {
        var heights = 150;
        var margins = [0, 10, 0, 10];
      }
      var image = this.image;
      var created = new Date().toISOString().slice(0, 10);
      var username = this.c_user.abb;
      var list_name = this.title ? this.title.toUpperCase() : 'LIST';
      var image_size = [this.imageSize2, this.imageSize2];
      var output_fields = this.selected;
      var imageSize3 = parseInt(this.imageSize2);
      var rectPosX = 220 - imageSize3;
      var use_current_selection = this.use_current_selection;
      var noOfArtworks = 0;
      var logoImage = this.getLogo();
      logoImage = logoImage.split('\n');

      // if (this.item && this.item.artworks.length > 0) {
      //   this.pdf_artworks = this.item.artworks
      // } else {
      // if (use_current_selection == true) {
      //   // this.pdf_artworks = Object.assign([], this.$store.state.currentSelection)
      //   if (this.$store.state.currentSelection.length > 0) {
      //     this.pdf_artworks = Object.assign([], this.$store.state.currentSelection)
      //   } else {
      //     this.pdf_artworks = Object.assign([], this.$store.state.artworks)
      //   }
      // } else {
      var tempArtworks = [];
      // DEFAULT - LOADS ARTWORKS FROM FILTER TABLE
      if (this.$store.state.filterResults) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        tempArtworks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.filterResults);
      } else {
        tempArtworks = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.unfiltered_artworks_for_list);
      }
      // IF SELECTION IS CHOSEN, LOADS ARTWORKS FROM SELECTION
      if (this.selection_for_adding) {
        var selections = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks_selections);
        var sel = selections.find(function (s) {
          return s.title === _this3.selection_for_adding;
        });
        var s = this.o2ids(sel.artworks, 'id');
        tempArtworks = tempArtworks.concat(s);
      }
      // ADDS ARTWORKS SELECTED IN COLLECTION TO LIST TOO
      if (this.add_current_selection) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        var objs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
        var s = this.o2ids(objs, 'id');
        tempArtworks = tempArtworks.concat(s);
      }
      // ADDS ONLY ARTWORKS CHECKED IN FILTERED RESULTS
      if (this.use_current_list_selection) {
        // var objs = this.ids2o(this.$store.state.filterResults)
        var objs = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentListSelection);
        var s = this.o2ids(objs, 'id');
        tempArtworks = objs;
      }
      this.pdf_artworks = this.ids2o(tempArtworks);
      // }
      // }
      console.log(this.pdf_artworks);
      if (this.sort == 'collection') {
        var collectionsIds = [1, 12, 15, 6, 7, 17, 10];
        this.pdf_artworks = this.customDoubleSort(this.pdf_artworks, collectionsIds, 'ownership', this.subsort);
      } else {
        this.pdf_artworks = this.pdf_artworks.sort(dynamicSort(this.sort, this.subsort));
      }
      // console.log(this.pdf_artworks)

      if (full == false) {
        this.pdf_artworks = this.pdf_artworks.splice(0, 1);
      }

      var transformedData = this.formatListData(this.pdf_artworks, output_fields);

      // var asMoney = function asMoney (rawMoney) {
      //   return rawMoney
      //     .round(2, 1)
      //     .toFixed(2)
      //     .toString()
      //     .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      // }
      var makeCell = function makeCell(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ text: content }, options);
      };
      // -- Format the table cells for presentation.
      var thl = function thl(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'left', fontSize: 9 }, options));
      };
      var thr = function thr(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'right', fontSize: 9 }, options));
      };
      var tdl = function tdl(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'left', fontSize: 9 }, options));
      };
      var tdr = function tdr(content) {
        var rowIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        return makeCell(content, rowIndex, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({ bold: false, alignment: 'right', fontSize: 9 }, options));
      };
      var creationDate = function creationDate() {
        return new Date();
      };

      function getImagefromAPI(top_photo, id, image_size) {
        var request = new XMLHttpRequest();
        var requestER = new XMLHttpRequest();
        // request.open('GET', 'http://tb-cms.org/artworks/send_datauri/'+id, false);
        // if (image_size == [170,170]) {
        // console.log(accession_number)
        var src = '';
        console.log(image_size);
        if (id) {
          // if (top_photo && id > 0) {
          // if (image_size == ['170', '170']) {
          src = 'https://api.tb-cms.org/vueimages/' + id + '_big.txt';
          // } else {
          // src = 'http://api.tb-cms.org/vueimages/' + id + '.txt'
          // }
          //     //'http://tb-cms.org/data/artwork/' + id + '/' + top_photo_id + '_th_big.jpg'
          // } else if ([12,15,16].includes(ownership)) {
          //   src = 'http://tb-cms.org/vueimages/' + accession_number + '_big.txt'
          // }
          request.open('GET', src,
          //"http://tb-cms.org/vueimages/" + id + "_big.txt",
          false);
          // console.log(src)
          // } else {
          // request.open('GET', 'http://tb-cms.org/vueimages/'+id+'.txt', false);
          // }
          // request.open('GET', 'http://tb-cms.org:8080/static/images/'+id, false);
          request.send(null);
          // request.onreadystatechange = function() {
          if (request.readyState === 4) {
            // console.log('readyState = 4')
            // var response = JSON.parse(request.responseText);
            if (request.status === 200 && request.statusText === 'OK') {
              // console.log('status OK')
              var type = request.getResponseHeader('Content-Type');
              if (type.indexOf('text') !== 1) {
                // console.log('text OK')
                return request.responseText;
              }
            } else {
              // console.log('status not OK')
              requestER.open('GET', 'https://api.tb-cms.org/vueimages/ir.txt', false);
              requestER.send(null);
              if (requestER.readyState === 4) {
                // console.log('status not OK - 4')
                if (requestER.status === 200 && requestER.statusText === 'OK') {
                  // console.log('status not OK - 4 - OK')
                  var type = requestER.getResponseHeader('Content-Type');
                  if (type.indexOf('text') !== 1) {
                    return requestER.responseText;
                  }
                } else {
                  return '';
                }
              }
            }
          }
        } else {
          // console.log('ir')
          requestER.open('GET', 'https://api.tb-cms.org/vueimages/ir.txt', false);
          requestER.send(null);
          if (requestER.readyState === 4) {
            // console.log('status not OK - 4')
            if (requestER.status === 200 && requestER.statusText === 'OK') {
              // console.log('status not OK - 4 - OK')
              var type = requestER.getResponseHeader('Content-Type');
              if (type.indexOf('text') !== 1) {
                return requestER.responseText;
              }
            } else {
              return '';
            }
          }
        }
        // }
        // request.onreadystatechange = function () {
        //  if (request.readyState === 4 && request.status === 200) {
        // var type = request.getResponseHeader('Content-Type');
        // if (type.indexOf("text") !== 1) {
        // return request.responseText;
        // }
        // }
        // }
      }

      // function getLogo () {
      //   var request = new XMLHttpRequest()
      //   request.open('GET', 'http://tb-cms.org/vueimages/logo.txt', false)
      //   request.send(null)
      //   return request.responseText
      // }

      var createDocumentDefinition = function createDocumentDefinition(creationDate, subHeading) {
        for (var _len = arguments.length, contentParts = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          contentParts[_key - 2] = arguments[_key];
        }

        var _docDefinition$conten;

        var baseDocDefinition = {
          defaultFileName: 'list.pdf',
          pageSize: 'A4',
          footer: function footer(currentPage, pageCount) {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.page_no == true && {
              text: 'Page ' + currentPage.toString() + ' of ' + pageCount.toString(),
              alignment: 'center',
              fontSize: 7
            });
          },
          info: {
            title: list_name,
            author: username,
            subject: list_name,
            keywords: 'artwork names, artist names',
            creationDate: created
          },
          styles: {
            title: { fontSize: 20, all_caps: true },
            titleSub: { fontSize: 9 },
            titleDate: { fontSize: 9, alignment: 'right', bold: false },
            createdAt: { fontSize: 9, alignment: 'right' },
            createdBy: { fontSize: 9, alignment: 'right' },
            bold: { fontSize: 9, bold: false },
            normal: { fontSize: 9, bold: false },
            artwork_title: { fontSize: 9, bold: false },
            artwork_title_top: {
              fontSize: 9,
              bold: false,
              margin: [0, 13, 0, 0]
            },
            artist_name: { fontSize: 9, italic: true, margin: [0, 25, 0, 0] },
            image: { alignment: 'right', margin: [0, 0, 0, 30] },
            logo: { alignment: 'left', margin: [0, 0, 0, 40] }
          },
          content: [{ image: logoImage, fit: [180, 80], style: 'logo', width: '*' }, {
            columns: [{ text: list_name, style: 'title', width: '*' }, {
              text: (_this3.created_by == true ? 'Created by : ' + username : '') + (_this3.created_at == true ? '\n' + created : '') + (_this3.showNoOfArtworks == true ? '\nNo. of Artworks: ' + _this3.pdf_artworks.length : ''),
              style: 'createdBy'
            }]
          }, { text: _this3.subtitle + '\n\n', style: 'titleSub' }]
        };
        var docDefinition = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(baseDocDefinition));
        docDefinition.footer = baseDocDefinition.footer;
        (_docDefinition$conten = docDefinition.content).push.apply(_docDefinition$conten, contentParts);
        // console.log(contentParts)
        // console.log(docDefinition)
        return docDefinition;
      };

      var rowData = function rowData(a) {
        var stack = {
          stack: [],
          stack2: []
        };
        var columns = output_fields;
        // this.$store.state.selected_columns_for_pdf
        // ['title','accession_number'];

        stack.stack.push({
          text: a['accession_number'],
          style: 'artwork_title_top'
        });
        stack.stack.push({ text: a['full_name'], style: 'artwork_title' });
        stack.stack.push({ text: a['title'], style: 'artwork_title' });
        stack.stack.push({ text: a['subtitle'], style: 'artwork_title' });

        columns.forEach(function (column, index) {
          // unformattedData = pdf_artworks.find(b => b.id === a['id'])
          // if (unformattedData[column.id]) {
          var columnData = a[column.id];
          var cp = [];
          // if (columnData == undefined) {
          //   stack.stack.push({text: 'no "' + column.title + '" data entered', style: 'normal'});
          // } else {
          // console.log('columnData')
          // console.log(columnData)
          if (columnData != null && columnData.trim().length != 0) {
            stack.stack.push({ text: columnData, style: 'normal' });
          } else {}
          // console.log(column.id)
          // console.log(columnData)

          // }
        });
        return stack;
      };

      createPdfDoc();

      function createPdfDoc() {
        var fontSize = 6;

        var tableBody = function tableBody(dataRows) {
          var body = [];
          dataRows.forEach(function (row, index) {
            var tableRow = [];
            // obldznik namiesto obrazku zatial
            // var rect = {
            //   canvas: [
            //     {
            //       type: 'rect',
            //       x: rectPosX,
            //       y: 20,
            //       w: imageSize3,
            //       h: imageSize3,
            //       // r: 5,
            //       // dash: {length: 5},
            //       // lineWidth: 10,
            //       lineColor: 'grey',
            //     }]
            // }

            if (image == true) {
              var imagefromAPI = getImagefromAPI(row.top_photo, row.top_photo_id, image_size);
              imagefromAPI = imagefromAPI.split('\n');
              if (imagefromAPI.length == 2) {
                imagefromAPI = imagefromAPI.filter(function (el) {
                  return el != '';
                });
              }
              // imagefromAPI = imagefromAPI[0].replace("image/jpg","image/jpeg");
            }
            // console.log (row.accession_number);
            // console.log (row);

            tableRow.push(rowData(row));

            if (image == true) {
              tableRow.push({
                image: imagefromAPI,
                fit: image_size,
                style: 'image'
              });
            }

            // tableRow.push(rect)

            body.push(tableRow);
          });
          return body;
        };
        if (image == true) {
          var tableColumnWidths = [290, 222];
        } else {
          var tableColumnWidths = [480, 20];
        }
        var tableData = {
          layout: 'noBorders',
          table: {
            heights: heights,
            dontBreakRows: true,
            margins: margins,
            widths: tableColumnWidths,
            body: tableBody(transformedData)
          }
        };
        var docDefinition = createDocumentDefinition(creationDate(), 'Summary', tableData);
        // pdfMake.createPdf(docDefinition).download('underlyingLoanSummary-' + creationDate() + '.pdf');
        // pdfMake.createPdf(docDefinition).open({},'pdfV')
        // document.getElementById('pdfV').src = data;

        if (full == false) {
          var pdfDocGenerator = __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.createPdf(docDefinition);

          // function download() {
          //   pdfDocGenerator.download('A4-list.pdf');
          // }
          pdfDocGenerator.getDataUrl(function (dataUrl) {
            var targetElement = document.querySelector('#pdfV');
            // const iframe = document.createElement('iframe')
            targetElement.src = dataUrl;
            // targetElement.appendChild(iframe)
            // this.loading = false
          });
        } else {
          if (list_name) {
            var t = list_name + '.pdf';
          } else {
            var t = 'list.pdf';
          }
          // this.loading = false
          __WEBPACK_IMPORTED_MODULE_5_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download(t);
        }
        // this.loading = false
        // const docDefinition = createDocumentDefinition(creationDate(), 'LIST', ' ', tableData)
        // pdfMake.createPdf(docDefinition).download(`LISTa-${creationDate()}.pdf`)
      }
      // this.loading = false
    },
    getDataUri: function getDataUri(url, callback) {
      var image = new Image();
      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = this.naturalWidth; // or 'width' if you want a special/scaled size
        canvas.height = this.naturalHeight; // or 'height' if you want a special/scaled size
        canvas.getContext('2d').drawImage(this, 0, 0);
        callback(canvas.toDataURL('image/jpg').replace(/^data:image\/(png|jpg);base64,/, ''));
        callback(canvas.toDataURL('image/jpg'));
      };
      image.src = url;
    }
  },
  components: {
    FilterBox: __WEBPACK_IMPORTED_MODULE_7__FilterBox__["a" /* default */],
    Labels: __WEBPACK_IMPORTED_MODULE_8__Labels__["a" /* default */],
    LabelsSmall: __WEBPACK_IMPORTED_MODULE_9__LabelsSmall__["a" /* default */],
    LabelsSmallText: __WEBPACK_IMPORTED_MODULE_10__LabelsSmallText__["a" /* default */],
    Solo: __WEBPACK_IMPORTED_MODULE_11__Solo__["a" /* default */],
    SoloExt: __WEBPACK_IMPORTED_MODULE_12__SoloExt__["a" /* default */],
    // TestList,
    Excel: __WEBPACK_IMPORTED_MODULE_15__components_artworks_Excel__["a" /* default */]
  }
});

/***/ }),

/***/ "mdkl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mjKb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ml9J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ListsMixin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommonMixin_js__ = __webpack_require__("P+z9");

/// helper functions for PDF generation




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_4__CommonMixin_js__["a" /* default */]);

var ListsMixin = {
    methods: {
        getImagefromAPI: function getImagefromAPI(id) {
            var request = new XMLHttpRequest();
            var requestER = new XMLHttpRequest();
            var src = '';
            // if (top_photo && id > 0) {
            src = 'https://api.tb-cms.org/vueimages/' + id + '_big.txt';
            request.open('GET', src, false);
            request.send(null);
            // request.onreadystatechange = function() {
            if (request.readyState === 4) {
                // var response = JSON.parse(request.responseText);
                if (request.status === 200 && request.statusText === 'OK') {
                    var type = request.getResponseHeader('Content-Type');
                    if (type.indexOf('text') !== 1) {
                        return request.responseText;
                    }
                } else {
                    requestER.open('GET', 'https://api.tb-cms.org/vueimages/ir.txt', false);
                    requestER.send(null);
                    if (requestER.readyState === 4) {
                        if (requestER.status === 200 && requestER.statusText === 'OK') {
                            var type = requestER.getResponseHeader('Content-Type');
                            if (type.indexOf('text') !== 1) {
                                return requestER.responseText;
                            }
                        } else {
                            return '';
                        }
                    }
                }
            }
            // }
            // request.onreadystatechange = function () {
            //  if (request.readyState === 4 && request.status === 200) {
            // var type = request.getResponseHeader('Content-Type');
            // if (type.indexOf("text") !== 1) {
            // return request.responseText;
            // }
            // }
            // }
        },
        getLogo: function getLogo() {
            var request = new XMLHttpRequest();
            request.open('GET', 'https://api.tb-cms.org/vueimages/logo.txt', false);
            request.send(null);
            if (request.readyState === 4) {
                if (request.status === 200 && request.statusText === 'OK') {
                    var type = request.getResponseHeader('Content-Type');
                    if (type.indexOf('text') !== 1) {
                        return request.responseText;
                    }
                } else {
                    return '';
                }
            }
            return request.responseText;
        },
        formatExhibitionData: function formatExhibitionData(exhibitions) {
            // console.log('HELPER');
            // console.log(exhibitions.length);
            return exhibitions.map(function (a) {
                return 'Exhibition period: ' + a.duration_start + ' – ' + a.duration_end + '\n' + 'Exhibition title: ' + a.title + '\n' + 'Institution: ' + a.institution + '\n' + 'City: ' + a.city + '\n' + (a.show_type == '0' || a.show_type == 0 || a.show_type == null ? 'Solo\n' : 'Group\n') + (a.note != null ? 'Note: ' + a.note + '\n' : '');
            });
        },
        formatListData: function formatListData(artworks, output_fields) {
            var _this = this;

            return artworks.map(function (textRow) {

                var todos = [];
                var packings = [];
                var exhibitions = [];

                var output_fields_ids = output_fields.map(function (of) {
                    return of.id;
                });

                if (output_fields_ids.includes('todos')) {
                    todos = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this.$store.state.todos.filter(function (t) {
                        return textRow.id == t.artwork_id;
                    }));
                    todos = todos.map(function (a) {
                        return a.title;
                    });
                }

                if (output_fields_ids.includes('packings')) {
                    // console.log('PACKINGS')
                    packings = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this.$store.state.packings.filter(function (t) {
                        return t.artwork_id == textRow.id;
                    }));
                    // console.log(this.$store.state.packings.length)
                    // console.log('packingss')
                    // console.log(packings)
                    packings = packings.map(function (a) {
                        // console.log(a)
                        // var width = a.width ? (a.width) : ''
                        // // console.log(width)
                        // var lenght = a.lenght ? (a.lenght) : ''
                        // // console.log(lenght)
                        // var height = a.height ? (a.height) : ''
                        // // console.log(height)
                        // var cm = width || lenght || height ? ' cm' : ''
                        // // console.log(cm)

                        // var xAfterwidth = a.width & a.lenght ? ' x ' : ''
                        // // console.log(xAfterwidth)
                        // var xAfterlenght = a.height & a.lenght ? ' x ' : ''
                        // // console.log(xAfterlenght)

                        var comma = a.width || a.lenght || a.height ? ', ' : '';

                        var dims = [];

                        if (a.height) {
                            dims.push(a.height + ' (h)');
                        }

                        if (a.lenght) {
                            dims.push(a.lenght);
                        }

                        if (a.width) {
                            dims.push(a.width);
                        }

                        var dimsall = dims.join(" x ") + " cm";

                        var weight = a.weight ? ', ' + a.weight + ' kg' : '';
                        // console.log(weight)
                        // var kg = weight ? ' kg' : ''
                        // console.log(`${a.colli} - ${a.packing}${a.width}${xAfterwidth}${a.lenght}${xAfterlenght}${a.height}${cm}${a.weight}`)
                        // console.log(`${a.colli} - ${a.packing}${comma}${width}${xAfterwidth}${lenght}${xAfterlenght}${height}${cm}${weight}`)

                        return a.colli + ' - ' + a.packing + comma + dimsall + weight;
                    });
                }

                if (output_fields_ids.includes('exhibitions')) {
                    exhibitions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], _this.$store.state.exhibitions.filter(function (t) {
                        return t.artworks.map(function (a) {
                            return a = a.id;
                        }).includes(textRow.id);
                    }));
                    if (exhibitions && exhibitions.length > 0) {
                        exhibitions = _this.formatExhibitionData(exhibitions);
                    }
                }
                return _this.formatListRowData(textRow, todos, exhibitions, packings);
            });
        },
        getLastLog: function getLastLog(id) {
            var logs = this.$store.state.artwork_location_logs;
            // if (copy == 'packings') {
            //   if (logs && logs.length > 0) {
            //     var out = logs
            //       .filter((ll) => ll.artwork_packing_id === id)
            //       .sort(function (a, b) {
            //         if (a.change_date > b.change_date) {
            //           return -1
            //         }
            //         if (a.change_date < b.change_date) {
            //           return 1
            //         }
            //         return 0
            //       })[0]
            //     if (out) {
            //       return out
            //     } else {
            //       return ''
            //     }
            //   } else {
            //     return ''
            //   }
            // } else {
            if (logs && logs.length > 0) {
                var out = logs.filter(function (ll) {
                    return ll.copy === 'artwork' && ll.artwork_id === id;
                }).sort(function (a, b) {
                    if (a.change_date > b.change_date) {
                        return -1;
                    }
                    if (a.change_date < b.change_date) {
                        return 1;
                    }
                    return 0;
                })[0];
                //   console.log(out['artwork_location_id'])
                if (out && out['artwork_location_id'] > 0) {
                    var l = this.$store.state.locations.find(function (al) {
                        return al.id === out['artwork_location_id'];
                    });
                    if (l) {
                        return l.name;
                    } else {
                        return '';
                    }
                } else {
                    return '';
                }
            } else {
                return '';
            }
            // }
        },
        formatListRowData: function formatListRowData(textRow, todos, exhibitions, packings) {
            var latest_insurance = this.getLatestInsuranceValueText(textRow.id);
            var locationFromHistory = this.getLastLog(textRow.id);
            var locationFromArtwork = this.get_location_name(textRow.artwork_location_id);
            if (locationFromArtwork == locationFromHistory) {
                var location_name = locationFromArtwork;
            } else {
                // show locationFromArtwork only if locationFromHistory is empty
                if (locationFromHistory == '') {
                    var location_name = locationFromArtwork;
                } else {
                    var location_name = locationFromHistory;
                }
                // var location_name = locationFromArtwork === locationFromHistory ? locationFromArtwork : locationFromHistory;
            }

            return {
                type_of_work_id: textRow.type_of_work_id ? this.constants.TYPES_OF_WORK.find(function (tow) {
                    return tow.id === textRow.type_of_work_id;
                }).name : '',
                technician: textRow.technician ? 'Technician: ' + textRow.technician : '',
                space_max_min: textRow.space_max_min ? 'Space (max/min): ' + textRow.space_max_min : '',
                required_equipment: textRow.required_equipment ? 'Technical Equipment: ' + textRow.required_equipment : '',
                installation_requirements: textRow.installation_requirements ? 'Existing Equipment: ' + textRow.installation_requirements : '',
                tools_and_gear: textRow.tools_and_gear ? 'Tools & Gear: ' + textRow.tools_and_gear : '',
                light: textRow.light ? 'Light: ' + textRow.light : '',
                climate_and_conditions: textRow.climate_and_conditions ? 'Climate & Conditions: ' + textRow.climate_and_conditions : '',
                power: textRow.power ? 'Power: ' + textRow.power : '',
                spare_or_replacement_parts: textRow.spare_or_replacement_parts ? 'Spare or replacement parts: ' + textRow.spare_or_replacement_parts : '',
                display_notes_and_other_special_merged: textRow.display_notes_and_other_special_merged ? 'Other / Special: ' + textRow.display_notes_and_other_special_merged : '',
                projection: textRow.projection ? 'Projection (Size, height, distance, screens): ' + textRow.projection : '',
                sound_and_acoustic: textRow.sound_and_acoustic ? 'Sound and acoustic specifications: ' + textRow.sound_and_acoustic : '',
                on_off_procedure: textRow.on_off_procedure ? 'On-and Off-Procedure: ' + textRow.on_off_procedure : '',
                maintenance: textRow.maintenance ? 'Maintenance: ' + textRow.maintenance : '',
                security_and_safety_details: textRow.security_and_safety_details ? 'Security and Safety Details: ' + textRow.security_and_safety_details : '',
                regular_inspection: textRow.regular_inspection ? 'Regular inspection/ Pay attention to: ' + textRow.regular_inspection : '',
                cleaning_artwork: textRow.cleaning_artwork ? 'Cleaning Artwork (how/ what products/ how often): ' + textRow.cleaning_artwork : '',
                contacts_producers: textRow.contacts_producers ? 'Contacts / Producers: ' + textRow.contacts_producers : '',
                hanging_devices: textRow.hanging_devices ? 'Hanging Devices: ' + textRow.hanging_devices : '',
                specifications_on_space: textRow.specifications_on_space ? 'Specification on hanging/display/ presentation in space: ' + textRow.specifications_on_space : '',
                // conservator: textRow.conservator ? `XXX: ${textRow.conservator}` : '',
                // conservator: `Consevator: ${textRow.conservator}`,
                last_media_check: textRow.last_media_check ? 'Last Condition Check: ' + textRow.last_media_check : '',
                // last_media_check: `Last Media Check: ${textRow.last_media_check}`,
                paid_in_country: textRow.paid_in_country ? 'Paid in country: ' + textRow.paid_in_country : '',
                import_export_notes: textRow.import_export_notes ? 'Import Notes: ' + textRow.import_export_notes : '',
                import_export_history: textRow.import_export_history ? 'Import Export History: ' + textRow.import_export_history : '',
                import_date: textRow.import_date ? 'Import Date: ' + textRow.import_date : '',
                top_photo_id: textRow.top_photo_id,
                top_photo: textRow.top_photo,
                import_taxes: textRow.import_taxes ? 'Import Taxes: ' + textRow.import_taxes : '',
                title: textRow.production_date_new ? textRow.title + ', ' + textRow.production_date_new : textRow.title,
                subtitle: textRow.subtitle,
                full_name: textRow.name,
                classification: textRow.classification ? textRow.classification.toUpperCase() : '',
                accession_number: textRow.accession_number ? textRow.accession_number : '',
                production_date_new: textRow.production_date_new,
                acquisition_date: 'Acquisition Date: ' + this.format_date(textRow.acquisition_date),
                deaccession_date: 'Deaccession Date: ' + this.format_date(textRow.deaccession_date),
                acquisition_source_text: 'Acquisition Source: ' + this.get_contact(textRow.acquisition_source_id),
                acquisition_method_text: textRow.acquisition_method_text,
                visa_status_text: textRow.visa_status ? 'Visa Status: ' + this.get_visa_status(textRow.visa_status) : '',
                ownership_info: this.getOwnershipName(textRow.ownership),
                ownership: textRow.ownership,
                edition_state: textRow.edition_state,
                certificate_new: 'Certificate: ' + (textRow.certificate_new == 1 ? 'Yes' : 'No'),
                media_material_description: textRow.media_material_description,
                dim: textRow.dim_f_json,
                location_name: location_name,
                location_notes: textRow.location_notes,
                deaccessioned: 'Deaccessioned: ' + (textRow.deaccessioned == 1 ? 'Yes' : 'No'),
                credit: textRow.credit,
                insurance_value_text: textRow.insurance_value_text,
                insurance_value_latest: latest_insurance ? 'Insurance Value: ' + latest_insurance : textRow.insurance_value_text,
                purchase_price_text: textRow.purchase_price_text,
                signature_new: 'Signature: ' + (textRow.signature_new == 1 ? 'Yes' : 'No'),
                todos: todos.length > 0 ? 'ToDos: ' + todos.join(', ') : '',
                exhibitions: exhibitions.length > 0 ? 'Exhibitions: \n ' + exhibitions.join('\n ') : '',
                packings: packings.length > 0 ? 'Packings: \n ' + packings.join('\n ') : ''
            };
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ListsMixin);

// location_name: this.get_location_name(textRow.artwork_location_id) ? 'Location: ' + this.get_location_name(textRow.artwork_location_id) : '',

/***/ }),

/***/ "n36t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xs12 flex mt-2"},[_c('v-flex',{staticClass:"pl-3 xs12 ",staticStyle:{"background-color":"#222","color":"#eee","line-height":"28px"}},[_c('h3',{staticClass:"xs12",staticStyle:{"font-size":"16px","text-weigth":"100","height":"28px"}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.showAddLink)?_c('v-btn',{staticClass:"black--text right mr-2 mb-0 pl-1 mt-1 pr-2 xs12",staticStyle:{"text-decoration":"none !important","background-color":"#392939"},attrs:{"round":"","light":"","target":"_blank","small":"","flat":"","color":"white","rel":"noopener noreferrer"},on:{"click":_vm.showAdd}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"white"}},[_vm._v("add")]),_vm._v(" "),_c('span',{staticClass:"mt-0"},[_vm._v("Add new Link")])],1):_vm._e()],1)])],1)}
var staticRenderFns = []


/***/ }),

/***/ "nFuI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "njj+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","small":"","color":"black","icon":""},slot:"activator"},[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("file_download")])],1),_vm._v(" "),_c('v-list',{staticClass:"py-3"},[_c('v-list-tile',{key:("labels" + _vm.varid)},[_c('v-list-tile-content',[_c('labels',{attrs:{"item":_vm.itemsFromIds,"small":"","light":""}})],1)],1),_vm._v(" "),_c('v-list-tile',{key:("labelsSmall" + _vm.varid)},[_c('v-list-tile-content',[_c('labels-small',{attrs:{"item":_vm.itemsFromIds,"small":"","light":""}})],1)],1),_vm._v(" "),_c('v-list-tile',{key:("labelsSmallText" + _vm.varid)},[_c('v-list-tile-content',[_c('labels-small-text',{attrs:{"item":_vm.itemsFromIds,"small":"","light":""}})],1)],1),_vm._v(" "),_c('v-list-tile',{key:("excel" + _vm.varid)},[_c('v-list-tile-content',[_c('excel',{attrs:{"data":_vm.itemsFromObjects,"small":"","light":"","name":("Current Selection List of " + (_vm.itemsFromObjects.length)),"fileName":"current_selection_list"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "nzMO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditText_vue__ = __webpack_require__("BUio");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e57dd32_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditText_vue__ = __webpack_require__("MH8t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("29mE")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e57dd32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditText_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e57dd32_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditText_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e57dd32_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditText_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oEbX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNew_vue__ = __webpack_require__("HlYC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2d40c6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNew_vue__ = __webpack_require__("+B1h");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("bwCk")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2d40c6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNew_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e2d40c6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddNew_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oFIt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"mt-0 ml-4",attrs:{"column":""}},[_c('header-elements',{attrs:{"icon":"mdi-power-plug-off","title":"Non-Electrical"},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),_c('elements-table',{attrs:{"items":_vm.all_non_electricals,"showUpload":_vm.showUpload,"title":_vm.title},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),(_vm.showUpload)?_c('v-card',{staticClass:"px-5 pt-0 elevation-1"},[_c('v-card-title',{staticClass:"px-0"},[_c('span',{staticClass:"subbheadline xs12"},[_vm._v("Add new "+_vm._s(_vm.title)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"pr-0 mr-0",attrs:{"small":""},on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("close")]),_vm._v(" CANCEL")],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"label":"Brand"},model:{value:(_vm.non_electrical.brand),callback:function ($$v) {_vm.$set(_vm.non_electrical, "brand", $$v)},expression:"non_electrical.brand"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mx-0":""}},[_c('v-radio-group',{attrs:{"row":"","label":"Origin"},model:{value:(_vm.non_electrical.origin),callback:function ($$v) {_vm.$set(_vm.non_electrical, "origin", $$v)},expression:"non_electrical.origin"}},_vm._l((_vm.constants.ORIGINS),function(vs){return _c('v-radio',{key:vs.id,staticClass:"ml-3",attrs:{"value":vs.id,"label":vs.title}})}),1)],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 ml-3 mb-3"},[_c('v-btn',{on:{"click":_vm.save_non_electrical}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_vm._v("cancel")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "oJE0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditField__ = __webpack_require__("b7zL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HeaderElements__ = __webpack_require__("oiZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ElementsTable__ = __webpack_require__("vCKh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var show_field = function show_field(field) {
  if (field.condition && programme) {
    var theInstructions = field.condition;
    var F = function F(theInstructions) {};
    return F();
  } else {
    return true;
  }
};




/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork'],
  data: function data() {
    return {
      programmes: [],
      programme: {
        title: '',
        content: '',
        behaviour: '',
        appearance: '',
        context: '',
        concept: '',
        structure: '',
        input_output: '',
        filesize: '',
        associated_devices: '',
        other_associated_devices: '',
        associated_information_carriers: '',
        creation_date: '',
        notes: ''
      },
      showUpload: false,
      show: false,
      fields: [{
        'ctype': 'text-short',
        'name': 'programme.title',
        'title': 'Title',
        column: true,
        class: 'xs12',
        edit: true,
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'programme.content',
        'title': 'Content',
        class: 'xs6',
        work_types: ['fvs'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'programme.behaviour',
        'title': 'Behaviour (duration | sound | interaction',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'programme.appearance',
        'title': 'Appearance (color | color space | resolution)',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'programme.context',
        'title': 'Context (application software environment operating system hardware environment proprietary – custom-built commercial)',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'programme.concept',
        'title': 'Concept',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'radio',
        'etype': 'radio',
        'selection': [{ id: '1', value: '1', name: 'Single File' }, { id: '2', value: '2', name: 'Multiple Files' }, { id: '3', value: '3', name: 'Programme' }, { id: '4', value: '4', name: 'Network' }, { id: '5', value: '5', name: 'Pure Code' }, { id: '6', value: '6', name: 'Other' }],
        'name': 'programme.structure',
        'title': 'Structure',
        class: 'xs12',
        work_types: ['fvs'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'programme.input_output',
        'title': 'Input/Output devices',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-short',
        'name': 'programme.filesize',
        'title': 'File Size',
        suffix: 'MB',
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-long',
        'name': 'programme.associated_devices',
        'title': 'Associated Devices to read data',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-long',
        'name': 'programme.other_associated_devices',
        'title': 'Other Associated Devices',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-long',
        'name': 'programme.associated_information',
        'title': 'Associated Information carriers (format migration story)',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'date',
        'name': 'programme.creation_date',
        'title': 'Creation Date)',
        column: true,
        class: 'xs6',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        'ctype': 'text-long',
        'name': 'programme.notes',
        'title': 'Notes)',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }]
    };
  },
  methods: {
    set_input: function set_input(f) {
      programme[f] = f;
    },
    download: function download() {},
    add: function add() {
      this.programmes.push(this.programme);
      this.showUpload = !this.showUpload;
    },
    delete_programme: function delete_programme() {},
    done_programme: function done_programme() {},
    show_field_c: function show_field_c(field) {
      // console.log(this.programme)
      return show_field(field, this.programme);
    }
  },
  computed: {},
  components: {
    EditField: __WEBPACK_IMPORTED_MODULE_0__EditField__["a" /* default */], HeaderElements: __WEBPACK_IMPORTED_MODULE_1__HeaderElements__["a" /* default */], ElementsTable: __WEBPACK_IMPORTED_MODULE_2__ElementsTable__["a" /* default */]
  }
});

/***/ }),

/***/ "oZsD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__HeaderElements__ = __webpack_require__("oiZ/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ElementsTable__ = __webpack_require__("vCKh");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var show_field = function show_field(field) {
  if (field.condition && information_carrier) {
    var theInstructions = field.condition;
    var F = function F(theInstructions) {};
    return F();
  } else {
    return true;
  }
};
// import EditField from "./EditField";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["artwork"],
  data: function data() {
    return {
      snackbar_color: "black",
      snackbar_text: "",
      snackbar: false,
      information_carriers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.artwork.artwork_elements),
      // information_carriers: [],
      type: "",
      information_carrier: {},
      //   title: "",
      //   optical_film: "",
      //   optical_disc: "",
      //   mechanical: "",
      //   magnetic: "",
      //   electronical: "",
      //   unknown: "",
      //   other: "",
      //   material: "",
      //   brand: "",
      //   type: "",
      //   specifications: "",
      //   length: "",
      //   number_of_parts: "",
      //   associated_devices: "",
      //   audio_signal: "",
      //   video_signal: "",
      //   generation: "",
      //   status: "",
      //   production_date: "",
      //   installation_specs: "",
      //   shell: "",
      //   modifications: "",
      //   specs_on_installation: "",
      //   attached_documents: "",
      //   associated_peripherals: "",
      //   content: "",
      //   behaviour: "",
      //   appearance: "",
      //   context: "",
      //   concept: "",
      //   structure: "",
      //   input_output: "",
      //   filesize: "",
      //   associated_devices: "",
      //   other_associated_devices: "",
      //   associated_information_carriers: "",
      //   creation_date: "",
      //   notes: ""
      // },
      showUpload: false,
      show: false
    };
  },

  // created() { 
  //   console.log('created'); 
  //   console.log(this.artwork);
  // },
  // updated() { console.log('updated'); 
  //   console.log(this.artwork);
  // },
  beforeUpdate: function beforeUpdate() {
    // console.log('beforeUpdate'); 
    // console.log(this.artwork);
    this.information_carriers = this.artwork.artwork_elements;
  },

  // mounted() {
  //   // this.getElements()
  //   // console.log("this.artwork.artwork_elements");
  //   console.log('mounted');
  //   console.log(this.artwork);
  //   // this.information_carriers = this.artwork.artwork_elements;
  //   //.filter((ic) => ic.category == 'information_carrier');
  //   // this.journals_store = this.$store.state.journals.filter(
  //   //   j => j.journaled_id == this.artwork.id
  //   // );
  // },
  methods: {
    // getElements() {
    //   setTimeout(() => {
    // this.information_carriers = this.artwork.information_carriers.filter((ic) => ic.category == 'information_carrier');

    //   let url = `${this.$globals.apiserver}/artwork_elements/index_artwork/${this.artwork.id}.json`;
    //   axios
    //     .get(url)
    //     .then(response => {
    //       this.information_carriers = response.data
    //       this.progress = false;
    //     })
    //     .catch(error => {
    //       // console.log(error)
    //     });
    //   }, 1000);
    // },
    // set_input(f) {
    //   information_carrier[f] = f;
    // },
    // download() {},
    add: function add() {
      var _this = this;

      this.information_carrier.artwork_id = this.artwork.id;
      this.information_carrier.category = "information_carrier";
      var url = this.$globals.apiserver + "/artwork_elements.json";
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, { artwork_element: this.information_carrier }).then(function (response) {
        // console.log(response.data);
        // this.artwork = response.data;
        // this.$store.dispatch("addArtwork", response.data);
        _this.snackbar_color = "green";
        _this.snackbar_text = "Information Carrier saved.";
        // this.$store.dispatch("loadUsers");
        _this.snackbar = true;
        _this.information_carriers.push(response.data);
        _this.showUpload = !_this.showUpload;
        // if (a == 1) {
        // console.log(this.artwork);
        // this.$router.push({
        //   path: `/artworks/edit/${this.artwork.id}`,
        //   params: { artwork: this.artwork }
        // });
        // }
        // this.$store.dispatch('addArtwork',response.data)
        // this.artwork = response.data
        // this.artist = response.data.artist
        // this.e1 = 3
        // console.log(this.artwork)
      }).catch(function (error) {
        _this.snackbar_color = "red";
        _this.snackbar_text = "Error occured while saving Information Carrier.";
        // this.$store.dispatch("loadUsers");
        _this.snackbar = true;
        // console.log(error);
        // console.log(response.data);
      });
      // }
    },
    delete_information_carrier: function delete_information_carrier() {}
    // done_information_carrier() {},
    // show_field_c(field) {
    //   // console.log(this.information_carrier)
    //   return show_field(field, this.information_carrier);
    // }

  },
  computed: {
    ics: function ics() {
      // console.log("ics");
      // console.log(this.artwork);
      // console.log(this.artwork.artwork_elements);
      this.information_carriers = this.artwork.artwork_elements;
      // console.log(this.information_carriers);
      // if(this.information_carriers && this.information_carriers.length > 0) {
      return this.information_carriers;
      //.filter((ic) => ic.category == 'information_carrier');
      // } else {
      //   return []
      // }
    }
  },
  components: {
    // "edit-field-p": EditField,
    HeaderElements: __WEBPACK_IMPORTED_MODULE_2__HeaderElements__["a" /* default */],
    ElementsTable: __WEBPACK_IMPORTED_MODULE_3__ElementsTable__["a" /* default */]
  }
});

/***/ }),

/***/ "oiZ/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderElements_vue__ = __webpack_require__("ffj8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a79cd0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderElements_vue__ = __webpack_require__("rqZQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Y0J/")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06a79cd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderElements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a79cd0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderElements_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06a79cd0_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderElements_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ox/d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pX8A":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_full_user_fields__ = __webpack_require__("LKPg");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EditFieldHeader from '@/components/artists/EditFieldHeader'
// import dynamic_fields from '@/data/dynamic_fields'

// import axios from 'axios'
// import * as qs from "querystring";

// import EditField from './EditField'

function dynamicSort(property) {
  var sortOrder = 1;
  if (property[0] === '-') {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
}
function nl2br(str, is_xhtml) {
  var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'edit-field',
  // name: 'EditField',
  data: function data() {
    return {
      toggle: 0,
      toggle_exclusive: 2,
      count: 0,
      showingAddForm: false,
      showUpload: false,
      instalation_includes: [],
      film_type: '',
      fields: __WEBPACK_IMPORTED_MODULE_1__data_full_user_fields__["a" /* default */],
      isEditing: false,
      an_exists: false,
      saved: false,
      cannotSave: false,
      value_new: '',
      select_value: '',
      field_value: '',
      show: true,
      model: {},
      menu2: '',
      date: ''
      // model: "artist_location"
      // this.f_field.show
    };
  },

  props: ['field', 'artist', 'placeholder', 'label', 'name', 'value', 'selection', 'title', 'fields_parent'],
  mounted: function mounted() {
    this.select_value = this.f_artist[this.f_field.name];
    this.toggle = this.f_artist[this.f_field.name];
  },

  methods: {
    checkSubfields: function checkSubfields(event) {
      // console.log(event)
      this.select_value = event;
    },
    showAddForm: function showAddForm() {
      this.showingAddForm = !this.showingAddForm;
    },
    save: function save() {
      // this.toggle
    },
    saveOrEdit: function saveOrEdit() {
      var _this = this;

      this.isEditing = !this.isEditing;
      this.$refs[this.f_field['name']].isFocused = true;
      // console.log(this.f_field.name)
      // console.log(this.field_value)
      if (this.isEditing == false) {
        this.saved = true;
        setTimeout(function () {
          var url = _this.$globals.apiserver + '/artists/' + _this.artist.id + '.json';
          // axios.patch(url,{ 'field_name': this.f_field.name, 'field_value': this.field_value })
          //   .then((response) => {
          //     // console.log(response.data)
          //   })
          //   .catch((error) => { console.log(error) })
          _this.saved = false;
        }, 2000);
      }
    },

    // nefunguje tak ako chcem
    // format_date (date,format) {
    //   var moment = require('moment')
    //   var ndate = new Date(date)
    //   return moment(ndate).format(format)
    // },
    location_name: function location_name(id) {
      if (id > 0) {
        return this.$store.state.locations.find(function (l) {
          return l.id === id;
        }).name;
      } else {
        return 'Location not found. Probably deleted from CMS.';
      }
    }
  },
  computed: {
    hint: function hint() {
      var out = this.f_field.title;
      out = out + (this.f_field.hint ? ' - ' + this.f_field.hint : '');
      return out;
    },
    value2: function value2() {
      // console.log(parseInt(this.f_artist[this.f_field.related_field],10))
      return parseInt(this.f_artist[this.f_field.related_field], 10);
    },
    value_radio: function value_radio() {
      // console.log(this.f_artist[this.f_field.name])
      return this.f_artist[this.f_field.name];
    },

    // dynamic_field_list () {
    //   if (this.f_field.headline) {
    //     // console.log('test1')
    //     // console.log(dynamic_fields.dynamic_fields)
    //     // console.log(this.f_artist.classification)
    //     // console.log(this.fields)
    //     // console.log(dynamic_fields.dynamic_fields[this.f_artist.classification])
    //     // var a = dynamic_fields['dynamic_fields'][this.f_artist.classification]
    //     var c = []
    //     if (this.report) {
    //       var fields2 = this.fields_parent
    //     } else {
    //       var fields2 = this.fields['tabs'][this.$store.state.currentTab]['fields']
    //       // this.currentFields = this.fields.tabs[tab].fields

    //     }
    //     // console.log(fields2)
    //     // console.log('fields2')
    //     // var fields2 = Object.values(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artist.classification])
    //     // console.log('test')
    //     // if (fields2.length > 0) {
    //       // var class_fields = fields2[this.f_artist.classification]
    //       c = fields2.filter(f => (f.dynamic && f.section === this.f_field.section))
    //       c = c.filter(f => (f.work_types && f.work_types.includes(this.artist.classification)))
    //       // console.log(c)
    //     // }
    //       // console.log(fields['tabs'][this.$store.state.currentTab.substr(4)]['fields'][this.f_artist.classification].filter(f => f.dynamic))
    //     return c
    //     // Object.values(a).filter(f => f.section === this.f_field.section)
    //     // console.log('test')
    //   } else {
    //     // console.log('not headline')
    //     return []
    //   }
    //   // return dynamic_fields[this.f_artist.ownership][this.f_field.title]
    // },
    // split_date () {
    // var moment = require('moment')
    // var date = this.f_artist[this.f_field.name]
    // var ndate = moment(this.f_artist[this.f_field.name],'YYYY')
    // var out = [ndate.year,ndate.month,ndate.day]
    // var out = [date.getFullYear,date.getMonth,date.getDay]
    // return ndate
    // },
    // field_value () {
    //   return this.f_artist[this.f_field.name]
    // },
    // is_field_value () {
    //   // console.log(typeof this.field_value)
    //   // console.log(this.field_value)
    //   if (this.field_value == null) {
    //     return false
    //   } else {
    //     return true
    //   }
    // },
    field_type: function field_type() {
      return this.f_field.etype ? this.f_field.etype : this.f_field.ctype;
    },
    selection_items: function selection_items() {
      var _this2 = this;

      if (this.f_field.table) {
        if (this.f_field.table == 'contacts') {
          var contacts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.contacts);
          if (this.f_field.column) {
            // console.log(this.f_field.column)
            // console.log(this.f_field.association)
            // console.log(contacts.filter(c => c[this.f_field.column] == this.f_field.association))
            return contacts.filter(function (c) {
              return c[_this2.f_field.column] == _this2.f_field.association;
            });
          } else {
            return contacts;
          }
        }
        if (this.f_field.table == 'artists') {
          var artists = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
          if (this.f_field.column) {
            return artists.filter(function (c) {
              return c[_this2.f_field.column] == c[_this2.f_field.association];
            });
          } else {
            return artists.sort(dynamicSort('name'));
          }
        }
        if (this.f_field.table == 'artist_locations') {
          // console.log(this.f_field.table)
          // console.log('this.f_field.table')
          var artist_locations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.getters.enabled_locations);
          if (this.f_field.column) {
            return artist_locations.filter(function (c) {
              return c[_this2.f_field.column] == c[_this2.f_field.association];
            });
          } else {
            return artist_locations.sort(dynamicSort('name'));
          }
        }
      }
      if (this.f_field.selection && this.f_field.selection.length > 0) {
        return this.f_field.selection;
      }
    },
    f_field: function f_field() {
      var f = this.field;
      f.model_string = this.field.model_string ? this.field.model_string : this.field.name;
      f.column = this.field.column ? this.field.column : false;
      // console.log(this.f_artist[this.field.name])
      f.value_string = this.field['model_string'] ? this[this.field.model_string] : this.f_artist[this.field.name];
      return f;
    },
    f_artist: function f_artist() {
      return this.artist;
    }
  }
  // components: {AddLocation,AddArtist,Costs,ViewArtworks,Upload,Location,Films,Audio,Light,Programme,InformationCarrier,Electrical,ReadingDevices,Links,NonElectrical,LoanConditions}
});

/***/ }),

/***/ "paWh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditField_vue__ = __webpack_require__("pX8A");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b18093e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditField_vue__ = __webpack_require__("0erb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("xPdV")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b18093e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditField_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b18093e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditField_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b18093e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditField_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pdpo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pwbj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"400px"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are you sure you want to delete this Selection?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Selection\n        "),(_vm.itemToDelete)?_c('strong',[_vm._v(_vm._s(_vm.itemToDelete.name))]):_vm._e(),_vm._v(" will be\n        deleted.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"flat"},on:{"click":_vm.cancelDelete}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"flat"},on:{"click":_vm.deleteItem}},[_vm._v("Yes")])],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mx-4 px-3 mt-2 pt-5 elevation-0"},[_c('v-card-title',[_c('v-spacer'),_vm._v(" "),(this.$store.state.showSearch)?_c('v-text-field',{attrs:{"append-icon":"search","label":"Search ","single-line":"","hide-details":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"display-1 mb-3 mx-0 xs12"},[_c('v-btn-toggle',{staticClass:"mt-0 ml-0 small",model:{value:(_vm.mySelections),callback:function ($$v) {_vm.mySelections=$$v},expression:"mySelections"}},[_c('v-btn',{key:"group1",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":true,"value":true}},[_c('span',[_vm._v("My")])]),_vm._v(" "),_c('v-btn',{key:"group2",staticClass:"px-3",attrs:{"flat":"","small":"","input-value":false,"value":false}},[_c('span',[_vm._v("All")])])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0",staticStyle:{"border-top":"1px solid #ccc"},attrs:{"pagination":_vm.pagination,"headers":_vm.headers,"items":_vm.selections,"hide-headers":"","search":_vm.search,"item-key":"id","must-sort":"","expand":"","rows-per-page-text":"Selections per page","no-results-text":"No Selections match the criteria."},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:{ black: props.expanded, 'white--text': props.expanded }},[_c('td',{staticClass:"py-0 my-2 title"},[_vm._v("\n            "+_vm._s(props.item.name)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("\n            "+_vm._s(props.item.artworks.length)+"\n            ")]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_c('span',{staticClass:"ml-3 body-1"},[_vm._v(_vm._s(_vm.format_date(props.item.created_at)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[(props.item.created_by)?_c('span',[_vm._v(_vm._s(_vm.get_user(props.item.created_by)))]):_c('span',[_vm._v("NO USER")])]),_vm._v(" "),_c('td',{staticClass:"layout right text-xs-right pt-1 pr-0"},[_c('v-tooltip',{staticClass:"mr-0",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"black","icon":"","small":""},on:{"click":function($event){return _vm.loadSelection(props.item.artworks)}}},on),[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("apps")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Replace Current Selection with this saved Selection")])]),_vm._v(" "),_c('v-tooltip',{staticClass:"mr-4",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"black","icon":"","small":""},on:{"click":function($event){return _vm.addToSelection(props.item.artworks)}}},on),[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("add")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Add Artworks in this Selection to current Selection")])]),_vm._v(" "),_c('v-tooltip',{staticClass:"mr-4",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"black","icon":"","small":""},on:{"click":function($event){return _vm.goToList()}}},on),[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("list")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Go to List and load Current Selection")])]),_vm._v(" "),_c('list-action-menu',{attrs:{"item":props.item}}),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){props.expanded = !props.expanded}}},[(!props.expanded)?_c('v-icon',{class:{ 'white--text': props.expanded }},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(props.expanded)?_c('v-icon',{class:{ 'white--text': props.expanded }},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),(_vm.c_user.edit || _vm.c_user.delete_rights)?_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.showDeleteDialog(props.item)}}},[_c('v-icon',{attrs:{"color":"red","small":""}},[_vm._v("delete")])],1):_vm._e()],1)])]}},{key:"expand",fn:function(props){return [_c('v-data-table',{staticClass:"elevation-0",attrs:{"must-sort":"","pagination":_vm.pagination_related,"headers":_vm.headers_related,"items":_vm.table_artworks(props.item.artworks),"search":_vm.search_related,"item-key":"id","no-results-text":"No Artworks match the criteria."},on:{"update:pagination":function($event){_vm.pagination_related=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props_related){return [_c('tr',[_c('td',[_c('v-btn',{staticStyle:{"width":"20px","height":"20px"},attrs:{"round":"","color":"red","icon":"","small":"","dense":"","hint":"Remove From the Selection"},on:{"click":function($event){return _vm.remove_from_selection(
                      props.item.id,
                      props_related.item.id
                    )}}},[_c('v-icon',{attrs:{"small":"","dense":"","color":"white"}},[_vm._v("remove")])],1),_vm._v(" "),_c('router-link',{staticClass:"body-1",attrs:{"to":{
                    name: 'EditArtwork',
                    params: {
                      id: props_related.item.id,
                      artwork: props_related.item,
                    },
                    path: ("/artworks/edit/" + (props_related.item.id)),
                  }}},[_vm._v("\n                  "+_vm._s(props_related.item.name)+",\n                  "),_c('strong',[_vm._v(_vm._s(props_related.item.title))]),_vm._v(", "+_vm._s(props_related.item.accession_number)+"\n                ")])],1),_vm._v(" "),_c('td',{attrs:{"align":"right"}},[_vm._v(_vm._s(props_related.item.accession_number))])])]}}],null,true),model:{value:(_vm.selected_related),callback:function ($$v) {_vm.selected_related=$$v},expression:"selected_related"}}),_vm._v(" "),_c('v-flex',{staticClass:"px-3 py-1 my-0 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("   ")])])]}}])},[_vm._v(" "),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Your search for \""+_vm._s(_vm.search)+"\" found no results.\n      ")])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mt-4 mx-4 elevation-0"},[_c('v-card-title',{staticClass:"pl-4 pt-3"})],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "qGBU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Texts_vue__ = __webpack_require__("aepb");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1268eab8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Texts_vue__ = __webpack_require__("TQDS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fcqs")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Texts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1268eab8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Texts_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1268eab8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Texts_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qSBE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationCarrier_vue__ = __webpack_require__("oZsD");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f8437c7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationCarrier_vue__ = __webpack_require__("RtTc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("fNUv")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f8437c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InformationCarrier_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f8437c7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationCarrier_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f8437c7_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InformationCarrier_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qczp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_contacts_Contact_vue__ = __webpack_require__("aSf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_contacts_ContactsTable__ = __webpack_require__("yuQp");
//
//
//
//
//
//
//

// import axios from '../../../static/axios.js' 

// import FilterBox from '@/components/artworks/FilterBox'


/* harmony default export */ __webpack_exports__["a"] = ({

  data: function data() {
    return {
      displayedData: [],
      contact: {
        name: ''
      },
      contacts: [],
      results: []
    };
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // console.log('beforeRouteEnter')
    next(function (vm) {
      return vm.switchOwnership(to);
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // console.log('beforeRouteUpdate')
    this.displayedData = null;
    this.switchOwnership(to);
    next();
  },


  created: function created() {
    // console.log('created')
    this.$store.dispatch('loadContacts');
    this.displayedData = this.$store.state.contacts;
  },

  updated: function updated() {
    // console.log('updated')
    this.$store.dispatch('loadContacts');
    this.displayedData = this.$store.state.contacts;
  },

  methods: {
    switchOwnershipTop: function switchOwnershipTop(switchStatus) {
      // console.log('switchOwnershipTop')
      // console.log(switchStatus)
      if (switchStatus) {} else {
        this.switchOwnership(this.$route);
      }
    },
    switchOwnership: function switchOwnership(to) {
      // console.log('switchOwnership')
      this.displayedData = this.processedContacts.filter(function (a) {
        return a.cateogory == to.params.ownership;
      });
    }
  },

  computed: {
    title: function title() {
      var title = 'Contacts';
      // if (this.$route.fullPath == '/contacts/oldMasters') {
      //   title = 'Old Masters'
      // } else 
      if (this.$route.fullPath == '/contacts/deaccession') {
        title = 'Deaccessioned';
      } else if (this.$route.fullPath == '/contacts/collection') {
        title = 'TBA21 Collection';
      } else if (this.$route.fullPath == '/contacts/pacFvh') {
        title = 'Private Art Collection FTB';
      } else if (this.$route.fullPath == '/contacts/pdcFvh') {
        title = 'Private Design Collection FTB';
      } else if (this.$route.fullPath == '/contacts/pacMr') {
        title = 'Private Art Collection MR';
      }
      return title;
    },
    processedContacts: function processedContacts() {
      var contacts = this.results;
      this.contacts.map(function (contact) {
        var a = contact;
        contact.first_name = a ? a.first_name : 'nema meno';
      });
      return contacts;
    }
  },

  filters: {
    capitalize: function capitalize(a) {
      if (!a) return '';
      a = a.toString();
      return a.charAt(0).toUpperCase() + a.slice(1);
    }
  },

  components: {
    Contact: __WEBPACK_IMPORTED_MODULE_0__components_contacts_Contact_vue__["a" /* default */], ContactsTable: __WEBPACK_IMPORTED_MODULE_1__components_contacts_ContactsTable__["a" /* default */]
  }

  // switchCategory (to) {
  //   switch (to.params.contact_categories) {
  //     case 'artwork_acquisition_source':
  //       this.displayedData = this.$store.state.collection
  //       break
  //     case 'device_acquisition_company':
  //       this.displayedData = this.$store.state.pac_fvh
  //       break
  //   }
  // },
  // filterContacts (category) {
  //   contacts = this.results.filter(function(c)  {
  //       return results.filter(function(c) {
  //         return c.category == category
  //     }).length > 1
  //   })
  //   this.displayedData = contacts

  //   for (contact in this.results) {
  //     if (contact.category == category) {
  //         this.results[artist].artworks[artwork].splice(1,1)
  //     }
  //   }
  //   let artists = ''
  //   artists = this.storedData.filter(function(artist)  {
  //     return artist.artworks.filter(function(artwork) {
  //       return artwork.ownership == ownership
  //     }).length > 1
  //   })
  //   this.displayedData = artists
  // },

});

/***/ }),

/***/ "r1I/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__("u2KI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()([{
    'name': 'Abkhaz',
    'nativeName': 'аҧсуа'
}, {
    'name': 'Afar',
    'nativeName': 'Afaraf'
}, {
    'name': 'Afrikaans',
    'nativeName': 'Afrikaans'
}, {
    'name': 'Akan',
    'nativeName': 'Akan'
}, {
    'name': 'Albanian',
    'nativeName': 'Shqip'
}, {
    'name': 'Amharic',
    'nativeName': 'አማርኛ'
}, {
    'name': 'Arabic',
    'nativeName': 'العربية'
}, {
    'name': 'Aragonese',
    'nativeName': 'Aragonés'
}, {
    'name': 'Armenian',
    'nativeName': 'Հայերեն'
}, {
    'name': 'Assamese',
    'nativeName': 'অসমীয়া'
}, {
    'name': 'Avaric',
    'nativeName': 'авар мацӀ, магӀарул мацӀ'
}, {
    'name': 'Avestan',
    'nativeName': 'avesta'
}, {
    'name': 'Aymara',
    'nativeName': 'aymar aru'
}, {
    'name': 'Azerbaijani',
    'nativeName': 'azərbaycan dili'
}, {
    'name': 'Bambara',
    'nativeName': 'bamanankan'
}, {
    'name': 'Bashkir',
    'nativeName': 'башҡорт теле'
}, {
    'name': 'Basque',
    'nativeName': 'euskara, euskera'
}, {
    'name': 'Belarusian',
    'nativeName': 'Беларуская'
}, {
    'name': 'Bengali',
    'nativeName': 'বাংলা'
}, {
    'name': 'Bihari',
    'nativeName': 'भोजपुरी'
}, {
    'name': 'Bislama',
    'nativeName': 'Bislama'
}, {
    'name': 'Bosnian',
    'nativeName': 'bosanski jezik'
}, {
    'name': 'Breton',
    'nativeName': 'brezhoneg'
}, {
    'name': 'Bulgarian',
    'nativeName': 'български език'
}, {
    'name': 'Burmese',
    'nativeName': 'ဗမာစာ'
}, {
    'name': 'Catalan; Valencian',
    'nativeName': 'Català'
}, {
    'name': 'Chamorro',
    'nativeName': 'Chamoru'
}, {
    'name': 'Chechen',
    'nativeName': 'нохчийн мотт'
}, {
    'name': 'Chichewa; Chewa; Nyanja',
    'nativeName': 'chiCheŵa, chinyanja'
}, {
    'name': 'Chinese',
    'nativeName': '中文 (Zhōngwén), 汉语, 漢語'
}, {
    'name': 'Chuvash',
    'nativeName': 'чӑваш чӗлхи'
}, {
    'name': 'Cornish',
    'nativeName': 'Kernewek'
}, {
    'name': 'Corsican',
    'nativeName': 'corsu, lingua corsa'
}, {
    'name': 'Cree',
    'nativeName': 'ᓀᐦᐃᔭᐍᐏᐣ'
}, {
    'name': 'Croatian',
    'nativeName': 'hrvatski'
}, {
    'name': 'Czech',
    'nativeName': 'česky, čeština'
}, {
    'name': 'Danish',
    'nativeName': 'dansk'
}, {
    'name': 'Divehi; Dhivehi; Maldivian;',
    'nativeName': 'ދިވެހި'
}, {
    'name': 'Dutch',
    'nativeName': 'Nederlands, Vlaams'
}, {
    'name': 'English',
    'nativeName': 'English'
}, {
    'name': 'Esperanto',
    'nativeName': 'Esperanto'
}, {
    'name': 'Estonian',
    'nativeName': 'eesti, eesti keel'
}, {
    'name': 'Ewe',
    'nativeName': 'Eʋegbe'
}, {
    'name': 'Faroese',
    'nativeName': 'føroyskt'
}, {
    'name': 'Fijian',
    'nativeName': 'vosa Vakaviti'
}, {
    'name': 'Finnish',
    'nativeName': 'suomi, suomen kieli'
}, {
    'name': 'French',
    'nativeName': 'français, langue française'
}, {
    'name': 'Fula; Fulah; Pulaar; Pular',
    'nativeName': 'Fulfulde, Pulaar, Pular'
}, {
    'name': 'Galician',
    'nativeName': 'Galego'
}, {
    'name': 'Georgian',
    'nativeName': 'ქართული'
}, {
    'name': 'German',
    'nativeName': 'Deutsch'
}, {
    'name': 'Greek, Modern',
    'nativeName': 'Ελληνικά'
}, {
    'name': 'Guaraní',
    'nativeName': 'Avañeẽ'
}, {
    'name': 'Gujarati',
    'nativeName': 'ગુજરાતી'
}, {
    'name': 'Haitian; Haitian Creole',
    'nativeName': 'Kreyòl ayisyen'
}, {
    'name': 'Hausa',
    'nativeName': 'Hausa, هَوُسَ'
}, {
    'name': 'Hebrew (modern)',
    'nativeName': 'עברית'
}, {
    'name': 'Herero',
    'nativeName': 'Otjiherero'
}, {
    'name': 'Hindi',
    'nativeName': 'हिन्दी, हिंदी'
}, {
    'name': 'Hiri Motu',
    'nativeName': 'Hiri Motu'
}, {
    'name': 'Hungarian',
    'nativeName': 'Magyar'
}, {
    'name': 'Interlingua',
    'nativeName': 'Interlingua'
}, {
    'name': 'Indonesian',
    'nativeName': 'Bahasa Indonesia'
}, {
    'name': 'Interlingue',
    'nativeName': 'Originally called Occidental; then Interlingue after WWII'
}, {
    'name': 'Irish',
    'nativeName': 'Gaeilge'
}, {
    'name': 'Igbo',
    'nativeName': 'Asụsụ Igbo'
}, {
    'name': 'Inupiaq',
    'nativeName': 'Iñupiaq, Iñupiatun'
}, {
    'name': 'Ido',
    'nativeName': 'Ido'
}, {
    'name': 'Icelandic',
    'nativeName': 'Íslenska'
}, {
    'name': 'Italian',
    'nativeName': 'Italiano'
}, {
    'name': 'Inuktitut',
    'nativeName': 'ᐃᓄᒃᑎᑐᑦ'
}, {
    'name': 'Japanese',
    'nativeName': '日本語 (にほんご／にっぽんご)'
}, {
    'name': 'Javanese',
    'nativeName': 'basa Jawa'
}, {
    'name': 'Kalaallisut, Greenlandic',
    'nativeName': 'kalaallisut, kalaallit oqaasii'
}, {
    'name': 'Kannada',
    'nativeName': 'ಕನ್ನಡ'
}, {
    'name': 'Kanuri',
    'nativeName': 'Kanuri'
}, {
    'name': 'Kashmiri',
    'nativeName': 'कश्मीरी, كشميري‎'
}, {
    'name': 'Kazakh',
    'nativeName': 'Қазақ тілі'
}, {
    'name': 'Khmer',
    'nativeName': 'ភាសាខ្មែរ'
}, {
    'name': 'Kikuyu, Gikuyu',
    'nativeName': 'Gĩkũyũ'
}, {
    'name': 'Kinyarwanda',
    'nativeName': 'Ikinyarwanda'
}, {
    'name': 'Kirghiz, Kyrgyz',
    'nativeName': 'кыргыз тили'
}, {
    'name': 'Komi',
    'nativeName': 'коми кыв'
}, {
    'name': 'Kongo',
    'nativeName': 'KiKongo'
}, {
    'name': 'Korean',
    'nativeName': '한국어 (韓國語), 조선말 (朝鮮語)'
}, {
    'name': 'Kurdish',
    'nativeName': 'Kurdî, كوردی‎'
}, {
    'name': 'Kwanyama, Kuanyama',
    'nativeName': 'Kuanyama'
}, {
    'name': 'Latin',
    'nativeName': 'latine, lingua latina'
}, {
    'name': 'Luxembourgish, Letzeburgesch',
    'nativeName': 'Lëtzebuergesch'
}, {
    'name': 'Luganda',
    'nativeName': 'Luganda'
}, {
    'name': 'Limburgish, Limburgan, Limburger',
    'nativeName': 'Limburgs'
}, {
    'name': 'Lingala',
    'nativeName': 'Lingála'
}, {
    'name': 'Lao',
    'nativeName': 'ພາສາລາວ'
}, {
    'name': 'Lithuanian',
    'nativeName': 'lietuvių kalba'
}, {
    'name': 'Luba-Katanga',
    'nativeName': ''
}, {
    'name': 'Latvian',
    'nativeName': 'latviešu valoda'
}, {
    'name': 'Manx',
    'nativeName': 'Gaelg, Gailck'
}, {
    'name': 'Macedonian',
    'nativeName': 'македонски јазик'
}, {
    'name': 'Malagasy',
    'nativeName': 'Malagasy fiteny'
}, {
    'name': 'Malay',
    'nativeName': 'bahasa Melayu, بهاس ملايو‎'
}, {
    'name': 'Malayalam',
    'nativeName': 'മലയാളം'
}, {
    'name': 'Maltese',
    'nativeName': 'Malti'
}, {
    'name': 'Māori',
    'nativeName': 'te reo Māori'
}, {
    'name': 'Marathi (Marāṭhī)',
    'nativeName': 'मराठी'
}, {
    'name': 'Marshallese',
    'nativeName': 'Kajin M̧ajeļ'
}, {
    'name': 'Mongolian',
    'nativeName': 'монгол'
}, {
    'name': 'Nauru',
    'nativeName': 'Ekakairũ Naoero'
}, {
    'name': 'Navajo, Navaho',
    'nativeName': 'Diné bizaad, Dinékʼehǰí'
}, {
    'name': 'Norwegian Bokmål',
    'nativeName': 'Norsk bokmål'
}, {
    'name': 'North Ndebele',
    'nativeName': 'isiNdebele'
}, {
    'name': 'Nepali',
    'nativeName': 'नेपाली'
}, {
    'name': 'Ndonga',
    'nativeName': 'Owambo'
}, {
    'name': 'Norwegian Nynorsk',
    'nativeName': 'Norsk nynorsk'
}, {
    'name': 'Norwegian',
    'nativeName': 'Norsk'
}, {
    'name': 'Nuosu',
    'nativeName': 'ꆈꌠ꒿ Nuosuhxop'
}, {
    'name': 'South Ndebele',
    'nativeName': 'isiNdebele'
}, {
    'name': 'Occitan',
    'nativeName': 'Occitan'
}, {
    'name': 'Ojibwe, Ojibwa',
    'nativeName': 'ᐊᓂᔑᓈᐯᒧᐎᓐ'
}, {
    'name': 'Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic',
    'nativeName': 'ѩзыкъ словѣньскъ'
}, {
    'name': 'Oromo',
    'nativeName': 'Afaan Oromoo'
}, {
    'name': 'Oriya',
    'nativeName': 'ଓଡ଼ିଆ'
}, {
    'name': 'Ossetian, Ossetic',
    'nativeName': 'ирон æвзаг'
}, {
    'name': 'Panjabi, Punjabi',
    'nativeName': 'ਪੰਜਾਬੀ, پنجابی‎'
}, {
    'name': 'Pāli',
    'nativeName': 'पाऴि'
}, {
    'name': 'Persian',
    'nativeName': 'فارسی'
}, {
    'name': 'Polish',
    'nativeName': 'polski'
}, {
    'name': 'Pashto, Pushto',
    'nativeName': 'پښتو'
}, {
    'name': 'Portuguese',
    'nativeName': 'Português'
}, {
    'name': 'Quechua',
    'nativeName': 'Runa Simi, Kichwa'
}, {
    'name': 'Romansh',
    'nativeName': 'rumantsch grischun'
}, {
    'name': 'Kirundi',
    'nativeName': 'kiRundi'
}, {
    'name': 'Romanian, Moldavian, Moldovan',
    'nativeName': 'română'
}, {
    'name': 'Russian',
    'nativeName': 'русский язык'
}, {
    'name': 'Sanskrit (Saṁskṛta)',
    'nativeName': 'संस्कृतम्'
}, {
    'name': 'Sardinian',
    'nativeName': 'sardu'
}, {
    'name': 'Sindhi',
    'nativeName': 'सिन्धी, سنڌي، سندھی‎'
}, {
    'name': 'Northern Sami',
    'nativeName': 'Davvisámegiella'
}, {
    'name': 'Samoan',
    'nativeName': 'gagana faa Samoa'
}, {
    'name': 'Sango',
    'nativeName': 'yângâ tî sängö'
}, {
    'name': 'Serbian',
    'nativeName': 'српски језик'
}, {
    'name': 'Scottish Gaelic; Gaelic',
    'nativeName': 'Gàidhlig'
}, {
    'name': 'Shona',
    'nativeName': 'chiShona'
}, {
    'name': 'Sinhala, Sinhalese',
    'nativeName': 'සිංහල'
}, {
    'name': 'Slovak',
    'nativeName': 'slovenčina'
}, {
    'name': 'Slovene',
    'nativeName': 'slovenščina'
}, {
    'name': 'Somali',
    'nativeName': 'Soomaaliga, af Soomaali'
}, {
    'name': 'Southern Sotho',
    'nativeName': 'Sesotho'
}, {
    'name': 'Spanish; Castilian',
    'nativeName': 'español, castellano'
}, {
    'name': 'Sundanese',
    'nativeName': 'Basa Sunda'
}, {
    'name': 'Swahili',
    'nativeName': 'Kiswahili'
}, {
    'name': 'Swati',
    'nativeName': 'SiSwati'
}, {
    'name': 'Swedish',
    'nativeName': 'svenska'
}, {
    'name': 'Tamil',
    'nativeName': 'தமிழ்'
}, {
    'name': 'Telugu',
    'nativeName': 'తెలుగు'
}, {
    'name': 'Tajik',
    'nativeName': 'тоҷикӣ, toğikī, تاجیکی‎'
}, {
    'name': 'Thai',
    'nativeName': 'ไทย'
}, {
    'name': 'Tigrinya',
    'nativeName': 'ትግርኛ'
}, {
    'name': 'Tibetan Standard, Tibetan, Central',
    'nativeName': 'བོད་ཡིག'
}, {
    'name': 'Turkmen',
    'nativeName': 'Türkmen, Түркмен'
}, {
    'name': 'Tagalog',
    'nativeName': 'Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔'
}, {
    'name': 'Tswana',
    'nativeName': 'Setswana'
}, {
    'name': 'Tonga (Tonga Islands)',
    'nativeName': 'faka Tonga'
}, {
    'name': 'Turkish',
    'nativeName': 'Türkçe'
}, {
    'name': 'Tsonga',
    'nativeName': 'Xitsonga'
}, {
    'name': 'Tatar',
    'nativeName': 'татарча, tatarça, تاتارچا‎'
}, {
    'name': 'Twi',
    'nativeName': 'Twi'
}, {
    'name': 'Tahitian',
    'nativeName': 'Reo Tahiti'
}, {
    'name': 'Uighur, Uyghur',
    'nativeName': 'Uyƣurqə, ئۇيغۇرچە‎'
}, {
    'name': 'Ukrainian',
    'nativeName': 'українська'
}, {
    'name': 'Urdu',
    'nativeName': 'اردو'
}, {
    'name': 'Uzbek',
    'nativeName': 'zbek, Ўзбек, أۇزبېك‎'
}, {
    'name': 'Venda',
    'nativeName': 'Tshivenḓa'
}, {
    'name': 'Vietnamese',
    'nativeName': 'Tiếng Việt'
}, {
    'name': 'Volapük',
    'nativeName': 'Volapük'
}, {
    'name': 'Walloon',
    'nativeName': 'Walon'
}, {
    'name': 'Welsh',
    'nativeName': 'Cymraeg'
}, {
    'name': 'Wolof',
    'nativeName': 'Wollof'
}, {
    'name': 'Western Frisian',
    'nativeName': 'Frysk'
}, {
    'name': 'Xhosa',
    'nativeName': 'isiXhosa'
}, {
    'name': 'Yiddish',
    'nativeName': 'ייִדיש'
}, {
    'name': 'Yoruba',
    'nativeName': 'Yorùbá'
}, {
    'name': 'Zhuang, Chuang',
    'nativeName': 'Saɯ cueŋƅ, Saw cuengh'
}]));

/***/ }),

/***/ "rETx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"persistent":"","max-width":"800px","transition":"dialog-transition"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-flex',{staticClass:"xs12 ml-0 pl-4 pr-4 pt-4 pb-3 layout row wrap elevation-0 white"},[_c('v-flex',{staticClass:"xs12  "},[(_vm.adding == true)?_c('h2',[_vm._v("Add new Customs")]):_vm._e(),_vm._v(" "),(_vm.adding==false)?_c('h2',[_vm._v("Editing Customs")]):_vm._e()]),_vm._v(" "),_c('v-flex',{staticClass:"xs12 my-4 "},[_c('label',{staticClass:"grey--text",attrs:{"for":"main_visa_status"}},[_vm._v("Main visa status")]),_c('br'),_vm._v(" "),_c('v-btn-toggle',{attrs:{"mandatory":""},model:{value:(_vm.editedCustomsHistory.main_visa_status),callback:function ($$v) {_vm.$set(_vm.editedCustomsHistory, "main_visa_status", $$v)},expression:"editedCustomsHistory.main_visa_status"}},[_c('v-btn',{attrs:{"small":"","flat":"","value":"non-eu"}},[_vm._v(" Non eu ")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","value":"eu"}},[_vm._v(" eu ")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","value":"freeport"}},[_vm._v("freeport ")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-menu',{ref:"menu2",attrs:{"return-value":_vm.editedCustomsHistory.import_date,"close-on-content-click":true,"nudge-right":40,"lazy":"","landscape":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.editedCustomsHistory, "import_date", $event)},"update:return-value":function($event){return _vm.$set(_vm.editedCustomsHistory, "import_date", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Import Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.editedCustomsHistory.import_date),callback:function ($$v) {_vm.$set(_vm.editedCustomsHistory, "import_date", $$v)},expression:"editedCustomsHistory.import_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"persistent":"","color":"black"},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.editedCustomsHistory.import_date)}},model:{value:(_vm.editedCustomsHistory.import_date),callback:function ($$v) {_vm.$set(_vm.editedCustomsHistory, "import_date", $$v)},expression:"editedCustomsHistory.import_date"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"import_taxes","label":"Import Taxes","prepend-icon":"euro_symbol"},model:{value:(_vm.editedCustomsHistory.import_taxes),callback:function ($$v) {_vm.$set(_vm.editedCustomsHistory, "import_taxes", $$v)},expression:"editedCustomsHistory.import_taxes"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"mover_importer","label":"Mover Importer"},model:{value:(_vm.editedCustomsHistory.mover_importer),callback:function ($$v) {_vm.$set(_vm.editedCustomsHistory, "mover_importer", $$v)},expression:"editedCustomsHistory.mover_importer"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-textarea',{attrs:{"name":"import_export_notes","label":"Import Export Notes"},model:{value:(_vm.editedCustomsHistory.import_export_notes),callback:function ($$v) {_vm.$set(_vm.editedCustomsHistory, "import_export_notes", $$v)},expression:"editedCustomsHistory.import_export_notes"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"}),_vm._v(" "),_c('v-flex',{staticClass:"xs12 pr-0 mr-0 mt-3",attrs:{"text-xs-right":""}},[_c('v-btn',{attrs:{"small":""},on:{"click":_vm.cancelAddDialog}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":""},on:{"click":_vm.save_edited_artwork_customs_history}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-0",attrs:{"column":""}},[(_vm.c_user.edit)?_c('v-layout',{attrs:{"row":"","wrap":"","xs12":"","sm12":"","md12":"","mt-0":"","ml-0":"","mr-0":"","px-0":""}}):_vm._e(),_vm._v(" "),(_vm.c_user.edit )?_c('v-flex',{attrs:{"row":"","xs12":"","sm12":"","md12":"","mt-0":"","ml-2":"","mr-2":""}},[(
          _vm.artwork.artwork_customs_logs &&
            _vm.artwork.artwork_customs_logs.length > 0
        )?_c('v-list',{staticClass:"xs12"},[_vm._l((_vm.artwork.artwork_customs_logs),function(l){return [_c('div',{key:l.id,staticClass:"mx-4 py-2"},[_c('div',{},[_c('span',{staticClass:"left"},[(l.import_date != null)?_c('span',{staticClass:"font-weight-bold title"},[_vm._v(_vm._s(_vm.format_date(l.import_date)))]):_vm._e()]),_vm._v(" "),(l.import_taxes != null)?_c('span',{staticClass:"right"},[_vm._v("\n                    Import Taxes:\n                    "),_c('span',{staticClass:"text-uppercase font-weight-bold"},[_vm._v(" "+_vm._s(l.import_taxes)+" EUR\n                    ")])]):_vm._e()]),_vm._v(" "),_c('div',[_c('v-list-tile-title',[(l.main_visa_status != null)?_c('div',[_vm._v("\n                    Main Visa Status:\n                    "),_c('span',{staticClass:"text-uppercase font-weight-bold"},[_vm._v(" \n                      "+_vm._s(l.main_visa_status)+"\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',[(l.mover_importer != null)?_c('span',[_vm._v("Mover Importer: "+_vm._s(l.mover_importer))]):_vm._e()])]),_vm._v(" "),(l.import_export_notes)?_c('div',{staticClass:"caption"},[_c('span',[_vm._v(_vm._s(l.import_export_notes))])]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-action',{staticClass:"right pr-0 mr-0"},[_c('span',[_c('v-btn',{key:l.id+'b',staticClass:"mr-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.editCustomsHistory(l)}}},[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("edit")])],1)],1)])],1),_vm._v(" "),_c('v-divider',{key:("a" + (l.id)),staticClass:"mt-4"})]})],2):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"my-0 py-0 ",attrs:{"icon":"","small":""},on:{"click":_vm.showAddDialog}},[_c('v-icon',[_vm._v("+")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "rRb3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"590"},model:{value:(_vm.delete_dialog),callback:function ($$v) {_vm.delete_dialog=$$v},expression:"delete_dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are your sure to delete \""),_c('strong',[_vm._v(_vm._s(_vm.exhibition_to_delete.title))]),_vm._v("\" Exhibition?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        This Exhibition will be deleted.\n      ")]),_vm._v(" "),_c('v-card-actions',{staticClass:"pa-3"},[_c('div',{staticClass:"flex-grow-1"}),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","text":""},on:{"click":_vm.delete_dialog_close}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","text":""},on:{"click":function($event){return _vm.deleteExhibition(_vm.exhibition_to_delete)}}},[_vm._v("\n          Delete Exhibition\n        ")])],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mx-3 elevation-0"},[_c('v-card-title',{staticClass:"mx-0 px-0"},[_c('v-layout',{attrs:{"row":"","my-3":"","mx-1":""}},[_c('span',[_c('v-menu',{staticClass:"text-xs-right mx-4 my-0 py-0 align-center",attrs:{"offset-y":"","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-2 my-0 py-0",attrs:{"small":"","icon":"","color":"black","dark":""}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("supervisor_account")])],1)]}}])},[_vm._v(" "),_c('v-list',{attrs:{"value":"3"}},_vm._l((_vm.ownerships),function(item,index){return _c('v-list-tile',{key:index.id,on:{"click":function($event){return _vm.toggleOwnership(item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(item.name))])],1)}),1)],1)],1),_vm._v(" "),_c('span',{staticClass:"text-xs-left mt-2 pt-1 title"},[_vm._v("\n          "+_vm._s(_vm.selectedOwnership.name)+"\n        ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn-toggle',{staticClass:"mt-3 elevation-0",model:{value:(_vm.loan),callback:function ($$v) {_vm.loan=$$v},expression:"loan"}},[_c('v-btn',{key:"group1",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"2","value":"2"}},[_c('span',[_vm._v(" All ")])]),_vm._v(" "),_c('v-btn',{key:"group2",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"0","value":"0"}},[_c('span',[_vm._v(" Exhibitions ")])]),_vm._v(" "),_c('v-btn',{key:"group3",staticClass:"px-2",attrs:{"small":"","flat":"","input-value":"1","value":"1"}},[_c('span',[_vm._v(" Loans ")])])],1),_vm._v(" "),(this.$store.state.showSearch)?_c('v-text-field',{staticClass:"ml-5",attrs:{"append-icon":"search","clearable":"","label":"Search ","single-line":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}):_vm._e()],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-0",staticStyle:{"border-top":"1px solid #ccc"},attrs:{"pagination":_vm.pagination,"hide-headers":"","headers":_vm.headers,"items":_vm.filtered_exhibitions,"search":_vm.search,"item-key":"id","must-sort":"","expand":"","rows-per-page-text":"Exhibitions per page","no-results-text":"No Exhibitions match the criteria."},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{class:{ subheading: true, editBG: props.expanded },staticStyle:{"padding-left":"0px","margin-left":"0px"},attrs:{"colspan":"6"}},[_c('table',{staticClass:"pa-0 ma-0"},[_c('tr',[_c('td',{staticStyle:{"padding-left":"0px","margin-left":"0px","padding-top":"5px","padding-bottom":"0px","height":"20px !important"}},[(props.item.duration_start || props.item.duration_end)?_c('small',{staticClass:"ml-0"},[_vm._v(_vm._s(props.item.duration_start)+" –\n                  "+_vm._s(props.item.duration_end))]):_vm._e(),_vm._v(" "),(props.item.institution_id)?_c('small',{staticClass:"ml-0"},[_vm._v("\n                  – "+_vm._s(_vm.getInstitutionName(props.item.institution_id)))]):_c('small',{staticClass:"ml-0"},[_vm._v("\n                  – "+_vm._s(props.item.institution))])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"py-0",class:{ editBG: props.expanded },staticStyle:{"padding-left":"0px","margin-left":"0px","padding-bottom":"0px","margin-bottom":"0px"}},[_c('span',{staticClass:"my-0 title font-weight-light"},[_c('router-link',{staticClass:"mr-3",attrs:{"to":{
                      name: 'EditExhibition',
                      params: { id: props.item.id, exhibition: props.item },
                      path: ("/exhibitions/edit/" + (props.item.id))
                    }},domProps:{"innerHTML":_vm._s(_vm.stripHtml(props.item.title))}})],1)])])])]),_vm._v(" "),_c('td',{class:{
            'text-xs-right': true,
            editBG: props.expanded,
            'pr-0': true,
            'mr-0': true
          },staticStyle:{"width":"30px"}},[_c('v-layout',{staticClass:"px-4 pb-2"},[_c('v-tooltip',{staticClass:"mr-3",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"black","icon":"","small":""},on:{"click":function($event){return _vm.loadSelection(props.item.artworks)}}},on),[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("apps")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Replace Current Selection with this saved Selection")])]),_vm._v(" "),_c('v-tooltip',{staticClass:"mr-3",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"black","icon":"","small":""},on:{"click":function($event){return _vm.addToSelection(props.item.artworks)}}},on),[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("add")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Add Artworks in this Exhibition to current Selection")])]),_vm._v(" "),_c('v-tooltip',{staticClass:"mr-3",attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"black","icon":"","small":""},on:{"click":function($event){return _vm.addSelectionToExhibition(props.item)}}},on),[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("add")])],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v("Add Artworks in current Selection to this Exhibition")])]),_vm._v(" "),_c('list-action-menu',{attrs:{"item":props.item,"ids":""}})],1)],1),_vm._v(" "),_c('td',{class:{
            'text-xs-right': true,
            editBG: props.expanded,
            'pr-0': true,
            'mr-0': true
          },staticStyle:{"width":"30px"}},[(props.item.artworks.length > 0)?_c('v-btn',{staticClass:"pl-3",attrs:{"small":"","round":"","outline":""},on:{"click":function($event){props.expanded = !props.expanded}}},[_vm._v("\n            show "+_vm._s(props.item.artworks.length)+" artworks\n            "),(props.expanded)?_c('v-icon',[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(!props.expanded)?_c('v-icon',[_vm._v("expand_less")]):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"pr-0 mr-0"},[(_vm.c_user.delete_rights)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(data){return [_c('span',_vm._g({},data.on),[_c('v-btn',{staticStyle:{"width":"20px","height":"20px"},attrs:{"round":"","color":"red","icon":"","small":"","dense":"","hint":"Delete exhibition"},on:{"click":function($event){return _vm.deleteExhibition(props.item)}}},[_c('v-icon',{attrs:{"small":"","dense":"","color":"white"}},[_vm._v("remove")])],1)],1)]}}],null,true)},[_vm._v("\n            Delete Exhibition\n          ")]):_vm._e()],1)]}},{key:"expand",fn:function(props){return [_c('v-flex',{staticClass:"px-3 py-1 my-0 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("ARTWORKS")])]),_vm._v(" "),_c('ListRelated',{attrs:{"artworks":props.item.artworks,"exhibition_id":props.item.id}}),_vm._v(" "),_c('v-flex',{staticClass:"px-3 py-1 my-0 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("   ")])])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" "),_vm._v(" "),_c('v-alert',{attrs:{"slot":"no-results","value":true,"color":"error","icon":"warning"},slot:"no-results"},[_vm._v("\n        Your search for \""+_vm._s(_vm.search)+"\" found no results.\n      ")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "rczA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__("NHnr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_artworks_Upload__ = __webpack_require__("e4A6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__artworks_TextEditor__ = __webpack_require__("JslP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_constants__ = __webpack_require__("K30H");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      search: '',
      constants: __WEBPACK_IMPORTED_MODULE_4__data_constants__["a" /* default */],
      e1: 1,
      progress: false,
      countries: __WEBPACK_IMPORTED_MODULE_4__data_constants__["a" /* default */].COUNTRIES,
      temp_artwork: '',
      text_artworks: [],
      text_artists: [],
      // fields: fields,
      text: {
        id: '',
        content: '',
        artists: [],
        artist_ids: [],
        artworks: [],
        artwork_ids: [],
        title: '',
        institution: '',
        city: '',
        duration_start_year: '',
        duration_start_month: '',
        duration_start_day: '',
        country: '',
        duration_end_year: '',
        duration_end_month: '',
        duration_end_day: '',
        show_type: [],
        admin_note: '',
        created_by: '',
        last_update_by: '',
        loan: ''
      },
      report: {
        date: ''
      },
      success: false,
      menu: false,
      modal: false,
      menu2: false,
      autosave: true,
      result: '',
      result_a: ''
    };
  },
  created: function created() {
    this.$store.dispatch('loadArtworks');
    this.$store.dispatch('loadArtists');
  },

  methods: {
    remove: function remove(item) {
      // this.text.artworks.splice(this.text.artworks.indexOf(item), 1)
      // this.text.artworks = [...this.text.artworks]
      // console.log(item)
      // console.log(this.text.artworks)
      var index = this.text.artworks.indexOf(item);
      // console.log(index)
      if (index >= 0) this.text.artworks.splice(index, 1);
    },
    removeArtist: function removeArtist(item) {
      // this.text.artworks.splice(this.text.artworks.indexOf(item), 1)
      // this.text.artworks = [...this.text.artworks]
      // console.log(item)
      // console.log(this.text.artworks)
      var index = this.text.artists.indexOf(item);
      // console.log(index)
      if (index >= 0) this.text.artists.splice(index, 1);
    },


    // format_date (date,format="YYYY-MM-DD") {
    //   var moment = require('moment')
    //   var ndate = new Date(date)
    //   return moment(ndate).format(format)
    // },
    // addArtwork(id) {
    //   var a = this.$store.state.artworks.find(a => a.id == id);
    //   if (!this.text_artworks.includes(a)) {
    //     this.text_artworks.push(a);
    //   }
    //   this.temp_artwork = "";
    //   this.result_a = "";
    // },
    getArwork: function getArwork(id) {
      var _this = this;

      this.progress = true;
      var url = this.$globals.apiserver + '/artworks/' + id + '.json';
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get(url).then(function (response) {
        _this.result_a = response.data;
        _this.progress = false;
      }).catch(function (error) {
        // console.log(error);
      });
    },
    saveText: function saveText() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Saving text', 'black');
      if (this.text.duration_end_year && this.text.duration_end_month && this.text.duration_end_day) {
        this.text.duration_end = this.format_date(new Date(this.text.duration_end_year, this.text.duration_end_month - 1, this.text.duration_end_day), 'YYYY-MM-DD');
      }
      if (this.text.duration_start_year && this.text.duration_start_month && this.text.duration_start_day) {
        this.text.duration_start = this.format_date(new Date(this.text.duration_start_year, this.text.duration_start_month - 1, this.text.duration_start_day), 'YYYY-MM-DD');
      }
      this.text.category = 'artwork_text';
      this.text.created_by = this.c_user.id;
      var url = this.$globals.apiserver + '/artwork_texts.json';
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(url, { artwork_text: this.text }).then(function (response) {
        _this2.result = response.data;
        _this2.text = response.data;
        // this.$store.dispatch("addText", response.data);
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Text saved.', 'green');
        _this2.e1 = 2;
      }).catch(function (error) {
        // console.log(error);
      });
    },
    updateText: function updateText() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Updating text', 'black');
      // delete this.text.text_artworks;
      // delete this.text.text_artists;
      if (this.text.duration_end_year && this.text.duration_end_month && this.text.duration_end_day) {
        this.text.duration_end = this.format_date(new Date(this.text.duration_end_year, this.text.duration_end_month - 1, this.text.duration_end_day), 'YYYY-MM-DD');
      }
      if (this.text.duration_start_year && this.text.duration_start_month && this.text.duration_start_day) {
        this.text.duration_start = this.format_date(new Date(this.text.duration_start_year, this.text.duration_start_month - 1, this.text.duration_start_day), 'YYYY-MM-DD');
      }
      // console.log(this.text_artworks);
      // this.text.artwork_ids = this.text_artworks.map(ea => ea.id);
      this.text.artwork_ids = this.text.artworks;
      this.text.artworks = this.text.artwork_ids;
      this.text.last_update_by = this.c_user.id;
      // this.text.artist_ids = this.text_artists.map(ea => ea.id);
      this.text.artist_ids = this.text.artists;
      // this.text.artists = this.text.artist_ids;
      // console.log(this.text)
      var url = this.$globals.apiserver + '/artwork_texts/' + this.text.id + '.json';
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.put(url, { artwork_text: this.text }).then(function (response) {
        _this3.result = response.data;
        _this3.text = response.data;
        // this.$store.dispatch('updateText',response.data)
        __WEBPACK_IMPORTED_MODULE_1__main__["serverBus"].$emit('showSnackbar', 'Text saved.', 'green');
        _this3.e1 = _this3.e1 + 1;
      }).catch(function (error) {
        // console.log(error);
      });
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    pdf: function pdf() {
      // download PDF
    }
  },
  computed: {
    start_date: function start_date() {
      return this.text.duration_start_year + '. ' + this.text.duration_start_month + '. ' + this.text.duration_start_day;
    },
    end_date: function end_date() {
      return this.text.duration_end_year + '. ' + this.text.duration_end_month + '. ' + this.text.duration_end_day;
    },
    valid: function valid() {
      return true; //this.text.title;
    },
    processedArtwork: function processedArtwork() {
      var processedArtwork = this.result_a;
      return processedArtwork;
    },
    artworks: function artworks() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
    },
    artists: function artists() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artists);
    }
  },
  components: {
    Upload: __WEBPACK_IMPORTED_MODULE_2__components_artworks_Upload__["a" /* default */],
    TextEditor: __WEBPACK_IMPORTED_MODULE_3__artworks_TextEditor__["a" /* default */]
  }
});

/***/ }),

/***/ "rjPQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"editor xs12"},[(_vm.editor)?_c('div',{staticClass:"menubar"},[_c('button',{class:{ 'is-active': _vm.editor.isActive('bold') },on:{"click":function($event){_vm.editor.chain().toggleBold().focus().run()}}},[_vm._v("\n          Bold\n        ")]),_vm._v(" "),_c('button',{class:{ 'is-active': _vm.editor.isActive('italic') },on:{"click":function($event){_vm.editor.chain().toggleItalic().focus().run()}}},[_vm._v("\n          Italic\n        ")]),_vm._v(" "),_c('button',{staticClass:"menubar__button",class:{ 'is-active': _vm.editor.isActive('underline') },on:{"click":function($event){_vm.editor.chain().toggleUnderline().focus().run()}}},[_vm._v("\n          U\n        ")]),_vm._v(" "),_c('button',{staticClass:"menubar__button",class:{ 'is-active': _vm.editor.isActive('code') },on:{"click":function($event){_vm.editor.chain().toggleCode().focus().run()}}},[_vm._v("\n          C\n        ")]),_vm._v(" "),_c('button',{staticClass:"menubar__button",class:{ 'is-active': _vm.editor.isActive('bullet_list') },on:{"click":function($event){_vm.editor.chain().toggleBullet_list().focus().run()}}},[_vm._v("\n          UL\n        ")]),_vm._v(" "),_c('button',{staticClass:"menubar__button",class:{ 'is-active': _vm.editor.isActive('ordered_list') },on:{"click":function($event){_vm.editor.chain().toggleOrdered_list().focus().run()}}},[_vm._v("\n          OL\n        ")])]):_vm._e(),_vm._v(" "),_c('editor-content',{staticClass:"xs12 pa-0 editor__content",attrs:{"editor":_vm.editor}})],1),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-right":""}},[_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":_vm.copy2c}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("file_copy")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":_vm.download_text}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("download")])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "rqVn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{staticClass:"rounded-card",attrs:{"max-width":"900px","persistent":""},model:{value:(_vm.showDialog),callback:function ($$v) {_vm.showDialog=$$v},expression:"showDialog"}},[_c('v-card',{staticClass:"pt-0 rounded-card"},[_c('v-card-title',{staticClass:"title red white--text px-4 mb-4 pt-3 pb-2"},[_vm._v("Add Location History Entry and Change Location\n          of\n          "+_vm._s(_vm.selected.length)+" Artworks\n          "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","small":"","color":"white"},on:{"click":_vm.closeChangeLocationDialog}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","mx-4":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.locations,"item-text":"name","item-value":"id","label":"New Location","clearable":""},model:{value:(_vm.artwork_location_log.artwork_location_id),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "artwork_location_id", $$v)},expression:"artwork_location_log.artwork_location_id"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6 pr-3"},[_c('v-text-field',{attrs:{"name":"reason","label":"Reason","clearable":""},model:{value:(_vm.artwork_location_log.reason),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "reason", $$v)},expression:"artwork_location_log.reason"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6"},[_c('v-text-field',{attrs:{"name":"shipper","label":"Shipper","clearable":""},model:{value:(_vm.artwork_location_log.shipper),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "shipper", $$v)},expression:"artwork_location_log.shipper"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"pr-0",attrs:{"label":"Note","clearable":""},model:{value:(_vm.artwork_location_log.note),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "note", $$v)},expression:"artwork_location_log.note"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs6 mb-0 pl-3 mt-1 pt-3"},[_c('v-btn-toggle',{attrs:{"mandatory":"","active-class":"activeToggle"},model:{value:(_vm.artwork_location_log.storage),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "storage", $$v)},expression:"artwork_location_log.storage"}},[_c('v-btn',{staticClass:"px-3",attrs:{"value":"in","small":"","flat":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("call_received")]),_vm._v(" IN\n              ")],1),_vm._v(" "),_c('v-btn',{staticClass:"px-3",attrs:{"value":"out","small":"","flat":""}},[_vm._v("\n                OUT "),_c('v-icon',{attrs:{"small":""}},[_vm._v("call_made")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-menu',{ref:"menu2a",attrs:{"close-on-content-click":true,"nudge-right":40,"lazy":"","landscape":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu2a),callback:function ($$v) {_vm.menu2a=$$v},expression:"menu2a"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Change Date","prepend-inner-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.artwork_location_log.change_date),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "change_date", $$v)},expression:"artwork_location_log.change_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"persistent":"","color":"black"},model:{value:(_vm.artwork_location_log.change_date),callback:function ($$v) {_vm.$set(_vm.artwork_location_log, "change_date", $$v)},expression:"artwork_location_log.change_date"}})],1)],1)],1),_vm._v(" "),(_vm.artwork_location_log.artwork_location_id && _vm.artwork_location_log.change_date)?_c('div',[_c('v-card-title',{staticClass:"subheading font-weight-medium pl-4 py-2 my-1 black white--text"},[_vm._v("\n            Select Artwork Packings to include in this action\n        ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xs":"","text-xs-start":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","mx-0":"","pl-0":"","pt-0":""}},[_c('v-flex',{attrs:{"xs12":"","pt-0":""}},[_c('v-checkbox',{staticClass:"ml-2 mt-0 pt-0 pb-2",attrs:{"label":"Include all Packings of All Artworks","value":"1","hide-details":"","color":"black","indeterminate":this.selectedPackings.length != 0 &&
                    this.selectedPackings.length != this.packings.length},on:{"change":function($event){return _vm.moveAllPackings($event)}},model:{value:(_vm.moveAllPackingsSwitch),callback:function ($$v) {_vm.moveAllPackingsSwitch=$$v},expression:"moveAllPackingsSwitch"}}),_vm._v(" "),_c('div',{staticClass:"ml-2 mt-2 title",staticStyle:{"font-weight":"500"}},[_vm._v("\n                    "+_vm._s(this.selectedPackings.length)+" of "+_vm._s(this.packings.length)+" Packings selected for update."),_c('br'),_vm._v("\n                    "+_vm._s(this.selected.length)+" Artworks selected for update.\n                  ")]),_vm._v(" "),_vm._l((this.selected),function(a){return _c('v-card',{key:a.id,staticClass:"rounded-card-small",attrs:{"xs12":"","my-0":"","pb-0":"","pt-0":"","pl-2":""}},[_c('v-card-title',{staticClass:"title mt-3 pt-3 grey lighten-3 pb-3 justify-space-between ",attrs:{"xs12":""}},[_vm._v("\n                    "+_vm._s(a.title)+", "+_vm._s(a.accession_number)+"\n                    "),_c('v-btn',{attrs:{"color":"white","icon":""},on:{"click":function($event){return _vm.removeArtworkFromSelection(a)}}},[_vm._v("X")])],1),_vm._v(" "),_c('v-card-title',{staticClass:"title my-0 pt-0 pb-3 grey lighten-3",attrs:{"xs12":""}},[_c('small',[_vm._v(" "+_vm._s(a.name))])]),_vm._v(" "),_c('v-card-title',{staticClass:"subtitle mt-0 pb-2 pt-2 grey lighten-5",attrs:{"xs12":""}},[_vm._v("\n                    Current Artwork Location\n                    "),_c('v-icon',{staticClass:"mx-2",attrs:{"small":"","color":"black"}},[_vm._v("adjust")]),_vm._v("\n                    "+_vm._s(_vm.get_location_name(a.artwork_location_id))+"\n                  ")],1),_vm._v(" "),_c('v-flex',{attrs:{"green--text":"","mx-3":""}},[_vm._v("\n                    Location History entry for this Artwork will be created.\n                  ")]),_vm._v(" "),((_vm.artwork_location_log.change_date > (_vm.lastArtworkChangeDate(a.id)))
                    && _vm.artwork_location_log.artwork_location_id != a.artwork_location_id)?_c('v-flex',{attrs:{"green--text":"","font-weight-medium":"","pb-2":"","mx-3":""}},[_vm._v("\n                    Current Artwork Location will be also changed:"),_c('br'),_vm._v(" "),_vm._v("\n                    "+_vm._s(_vm.get_location_name(a.artwork_location_id))+" =>\n                    "),_c('b',[_vm._v(_vm._s(_vm.get_location_name(_vm.artwork_location_log.artwork_location_id)))])]):_c('v-flex',[(_vm.artwork_location_log.artwork_location_id == a.artwork_location_id)?_c('div',{staticClass:"red--text mx-3 pb-2"},[_vm._v("\n                      This artwork's current location will "),_c('b',[_vm._v("NOT")]),_vm._v(" be changed, because artwork's location is the same\n                      as selected location.\n                    ")]):_vm._e(),_vm._v(" "),(_vm.artwork_location_log.change_date <= _vm.lastArtworkChangeDate(a.id))?_c('div',{staticClass:"mx-3 pb-2 red--text"},[_vm._v("\n                    This artwork's current location will "),_c('b',[_vm._v("NOT")]),_vm._v(" be changed, because a location\n                    history entry with newer Change Date exists.\n                  ")]):_vm._e()]),_vm._v(" "),(_vm.getArtworkPackings(a.id) && _vm.getArtworkPackings(a.id).length > 0)?_c('v-flex',{attrs:{"mx-0":"","mb-2":"","pb-2":""}},[_c('v-card-title',{staticClass:"pt-0 mt-0 pb-2",attrs:{"xs12":""}},[_c('v-checkbox',{staticClass:"py-0 small mb-1 mt-2",attrs:{"color":"black","hide-details":"","label":"Include all Artwork packings","indeterminate":_vm.selectedPackings.length != 0 &&
                          _vm.hasSomePackingsSelected(a.id),"value":a.id},on:{"change":function($event){return _vm.moveOrRemoveAllPackingsforArtwork($event, a.id)}},model:{value:(_vm.selectedArtworks),callback:function ($$v) {_vm.selectedArtworks=$$v},expression:"selectedArtworks"}})],1),_vm._v(" "),_vm._l((_vm.packings.filter(function (aap) { return aap.artwork_id == a.id; })),function(ap){return _c('v-layout',{key:ap.id,attrs:{"xs12":"","align-center":"","row":"","wrap":"","fill-height":"","px-3":"","pb-1":""}},[_c('div',{staticStyle:{"width":"100%"}},[_c('v-checkbox',{staticClass:"my-0 py-0 shorten-text",attrs:{"color":"black","hide-details":"","label":((ap.colli) + ", " + (ap.packing) + ", " + (ap.contents)),"value":ap.id},model:{value:(_vm.selectedPackings),callback:function ($$v) {_vm.selectedPackings=$$v},expression:"selectedPackings"}}),_vm._v(" "),(_vm.selectedPackings.includes(ap.id))?_c('v-flex',{attrs:{"green--text":"","ml-4":""}},[_vm._v("\n                          Location History entry for this Packing will be created.\n                        ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"ml-4 mt-1 mb-1"},[_c('v-icon',{staticClass:"mx-2",attrs:{"small":"","color":"black"}},[_vm._v("adjust")]),_vm._v(" "+_vm._s(_vm.get_location_name(ap.artwork_location_id))+"\n                        "),(!ap.artwork_location_id)?_c('span',[_vm._v("\n                          No Packing Location entered.\n                        ")]):_vm._e()],1),_vm._v(" "),(_vm.selectedPackings.includes(ap.id))?_c('v-flex',[((_vm.artwork_location_log.change_date >
                            _vm.lastLocationLogArtworkPacking(ap.id).change_date) && _vm.artwork_location_log.artwork_location_id != _vm.lastLocationLogArtworkPacking(ap.id).artwork_location_id)?_c('div',{staticClass:"green--text"},[_c('span',{staticClass:"ml-2 mr-1"},[_vm._v(" => ")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.get_location_name(_vm.artwork_location_log.artwork_location_id)))])]):_c('v-flex',[(_vm.artwork_location_log.artwork_location_id == _vm.lastLocationLogArtworkPacking(ap.id).artwork_location_id)?_c('div',{staticClass:"red--text mx-3 pb-2"},[_vm._v("\n                            This packing's current location will "),_c('b',[_vm._v("NOT")]),_vm._v(" be changed, because it's location is the same\n                            as selected new location.\n                          ")]):_vm._e(),_vm._v(" "),(_vm.artwork_location_log.change_date <= _vm.lastArtworkPackingChangeDate(ap.id))?_c('div',{staticClass:"mx-3 pb-2 red--text"},[_vm._v("\n                            This packing's current location will "),_c('b',[_vm._v("NOT")]),_vm._v(" be changed, because a location\n                            history entry with newer Change Date exists.\n                          ")]):_vm._e()])],1):_vm._e()],1)})],2):_vm._e()],1)})],2)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"pb-4 justify-end mr-4 pr-0"},[_c('v-btn',{attrs:{"outline":"","small":""},on:{"click":_vm.closeChangeLocationDialog}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":!(
                _vm.artwork_location_log.artwork_location_id == null ||
                _vm.artwork_location_log.artwork_location_id == ''
              ) &&
              !(
                _vm.artwork_location_log.change_date == null ||
                _vm.artwork_location_log.change_date == ''
              ),"disabled":_vm.artwork_location_log.artwork_location_id == null ||
  _vm.artwork_location_log.artwork_location_id == '' ||
  _vm.artwork_location_log.change_date == null ||
  _vm.artwork_location_log.change_date == ''},on:{"click":_vm.changeLocation}},[_vm._v("Change")])],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "rqZQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-1 mb-0"},[_c('v-flex',{staticClass:"px-3 pt-1 pb-2 py-2 elevation-0 xs12",staticStyle:{"background-color":"#f6f6f6"}},[_c('h3',{staticClass:"subtitle xs12 flex"},[_c('v-icon',{staticClass:"mt-0 mr-2",attrs:{"color":"#444"}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('span',{staticClass:"mt-0 pt-0 pb-3"},[_vm._v(_vm._s(_vm.title))])],1)])],1)}
var staticRenderFns = []


/***/ }),

/***/ "rtH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_constants__ = __webpack_require__("K30H");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      progress: false,
      constants: __WEBPACK_IMPORTED_MODULE_2__data_constants__["a" /* default */],
      countries: __WEBPACK_IMPORTED_MODULE_2__data_constants__["a" /* default */].COUNTRIES,
      temp_artwork: '',
      exhibition_artworks_ori: [],
      // fields: fields,
      exhibition: {
        id: '',
        artworks: [],
        artwork_ids: [],
        title: '',
        institution: '',
        institution_id: '',
        city: '',
        duration_start_year: '',
        duration_start_month: '',
        duration_start_day: '',
        country: '',
        duration_end_year: '',
        duration_end_month: '',
        duration_end_day: '',
        show_type: [],
        admin_note: '',
        loan: ''
      },
      report: {
        date: ''
      },
      success: false,
      menu: false,
      modal: false,
      menu2: false,
      e1: 0,
      autosave: true,
      result: '',
      result_a: ''
    };
  },

  methods: {
    // format_date (date,format="YYYY-MM-DD") {
    //   var moment = require('moment')
    //   var ndate = new Date(date)
    //   return moment(ndate).format(format)
    // },
    addArtwork: function addArtwork(id) {
      var a = this.$store.state.artworks.find(function (a) {
        return a.id == id;
      });
      if (!this.exhibition_artworks.includes(a)) {
        this.exhibition_artworks.push(a);
      }
      this.temp_artwork = '';
      this.result_a = '';
    },
    getArwork: function getArwork(id) {
      var _this = this;

      this.progress = true;
      var url = this.$globals.apiserver + '/artworks/' + id + '.json';
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(url).then(function (response) {
        _this.result_a = response.data;
        _this.progress = false;
      }).catch(function (error) {
        console.log(error);
      });
      this.progress = false;
    },
    saveExhibition: function saveExhibition() {
      var _this2 = this;

      this.progress = true;
      this.exhibition.duration_end = this.exhibition_duration_end;
      // this.format_date(new Date(this.exhibition.duration_end_year, this.exhibition.duration_end_month-1, this.exhibition.duration_end_day),'YYYY-MM-DD');
      this.exhibition.duration_start = this.exhibition_duration_start;
      // this.format_date(new Date(this.exhibition.duration_start_year, this.exhibition.duration_start_month-1, this.exhibition.duration_start_day),'YYYY-MM-DD');
      var url = this.$globals.apiserver + '/exhibitions.json';
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(url, this.exhibition).then(function (response) {
        _this2.result = response.data;
        _this2.exhibition = response.data;
        _this2.$store.dispatch('addExhibition', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, response.data));
        _this2.progress = false;
        _this2.e1 = 2;
      }).catch(function (error) {
        console.log(error);
      });
    },
    updateExhibition: function updateExhibition() {
      var _this3 = this;

      this.progress = true;
      delete this.exhibition.exhibition_artworks;
      this.exhibition.duration_end = this.exhibition_duration_end;
      // this.format_date(new Date(this.exhibition.duration_end_year, this.exhibition.duration_end_month-1, this.exhibition.duration_end_day),'YYYY-MM-DD');
      this.exhibition.duration_start = this.exhibition_duration_start;
      // this.format_date(new Date(this.exhibition.duration_start_year, this.exhibition.duration_start_month-1, this.exhibition.duration_start_day),'YYYY-MM-DD');
      this.exhibition.artwork_ids = this.exhibition_artworks.map(function (ea) {
        return ea.id;
      });
      this.exhibition.artworks = this.exhibition.artwork_ids;
      // console.log(this.exhibition)
      var url = this.$globals.apiserver + '/exhibitions/' + this.exhibition.id + '.json';
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.put(url, { exhibition: this.exhibition }).then(function (response) {
        _this3.result = response.data;
        _this3.exhibition = response.data;
        // this.$store.dispatch('updateExhibition',response.data)
        _this3.progress = false;
        _this3.e1 = 3;
      }).catch(function (error) {
        console.log(error);
      });
      this.progress = false;
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    pdf: function pdf() {
      // download PDF
    }
  },
  computed: {
    institutions: function institutions() {
      return this.$store.state.contacts.filter(function (c) {
        return c.category == 'exhibition_institution';
      });
    },
    exhibition_artworks: function exhibition_artworks() {
      var _this4 = this;

      return this.exhibition_artworks_ori.map(function (ea) {
        return _this4.$store.state.artworks.find(function (a) {
          return a.id == ea;
        });
      });
    },
    exhibition_duration_end: function exhibition_duration_end() {
      return this.exhibition.duration_end_year + '-' + this.exhibition.duration_end_month + '-' + this.exhibition.duration_end_day;
    },
    exhibition_duration_start: function exhibition_duration_start() {
      return this.exhibition.duration_start_year + '-' + this.exhibition.duration_start_month + '-' + this.exhibition.duration_start_day;
    },
    start_date: function start_date() {
      return this.exhibition.duration_start_year + '. ' + this.exhibition.duration_start_month + '. ' + this.exhibition.duration_start_day;
    },
    end_date: function end_date() {
      return this.exhibition.duration_end_year + '. ' + this.exhibition.duration_end_month + '. ' + this.exhibition.duration_end_day;
    },
    valid: function valid() {
      return this.exhibition.title;
    },
    processedArtwork: function processedArtwork() {
      var processedArtwork = this.result_a;
      return processedArtwork;
    },
    artworks: function artworks() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()([], this.$store.state.artworks);
    }
  }
});

/***/ }),

/***/ "s486":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring__ = __webpack_require__("1nuA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_querystring__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      contact: {},
      contactFormData: {},
      snackbar: false,
      snackbarFieldName: '',
      timeout: 3000,
      result: '',
      valid: true
    };
  },

  methods: {
    humanize: function humanize(t) {
      return t.replace(/_/g, ' ').replace(/(?: |\b)(\w)/g, function (t) {
        return t.toUpperCase();
      });
    },
    getContact: function getContact() {
      var _this = this;

      // console.log('test output getcontact')
      var url = this.$globals.apiserver + '/contacts/' + this.contact.id + '.json';
      // let url = `http://www.tba21.org/contact.json?id={{contact.id}}`
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
        // this.loading = false;
        _this.contact = response.data;
      }).catch(function (error) {
        // console.log(error);
      });
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    submit: function submit() {
      var _this2 = this;

      // const c = this.contactFormData
      // const requestConfig = {
      //     url     : `${this.$globals.apiserver}/contacts/api_update/${this.$route.params.id}`,
      //     method  : "POST",
      //     data : qs.stringify(c)
      // }
      // const response = axios.request(requestConfig)

      var url = this.$globals.apiserver + '/contacts.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(url, this.contact)
      // {
      //   name: this.contact.name,
      //   category: this.contact.category,
      //   company: this.contact.company,
      //   first_name: this.contact.first_name,
      //   last_name: this.contact.last_name,
      //   id: this.contact.id
      // }
      .then(function (response) {
        _this2.$store.dispatch('loadContacts');
        // console.log(response.data)
        // this.$router.push({
        //   name: "EditContact",
        //   params: { id: response.data.id, contact: response.data }
        // // contact: response.data, id: response.data.id
        // });
        _this2.$router.push({ name: 'Contacts' });
        // this.loading = false;
        // this.result = response.data
        // this.artwork = response.data
        // this.artwork = response.data
        // this.artist = response.data.artist
        // this.e1 = 3
        // console.log(this.artwork)
      }).catch(function (error) {
        // console.log(error);
      });
    }
  },
  computed: {}
});

/***/ }),

/***/ "s9Mf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sHT9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Electrical_vue__ = __webpack_require__("5vjN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a40f6198_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Electrical_vue__ = __webpack_require__("88K4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("zGT2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a40f6198"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Electrical_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a40f6198_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Electrical_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a40f6198_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Electrical_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "sKaU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sXdf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketValueHistory_vue__ = __webpack_require__("fRjm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c3d7019_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketValueHistory_vue__ = __webpack_require__("y4E9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("CqVZ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c3d7019"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketValueHistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c3d7019_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketValueHistory_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c3d7019_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarketValueHistory_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "srZm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__ = __webpack_require__("gjj0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_301cc497_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__ = __webpack_require__("7IY2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("mdkl")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Toolbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_301cc497_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_301cc497_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Toolbar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "szXu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"mt-4 ml-4",attrs:{"column":""}},[_c('header-elements',{attrs:{"icon":"mdi-filmstrip","showUpload":_vm.showUpload,"title":"Films"}}),_vm._v(" "),_c('elements-table',{attrs:{"items":_vm.films,"showUpload":_vm.showUpload,"title":"Film"},on:{"showUpload":function($event){_vm.showUpload=!_vm.showUpload}}}),_vm._v(" "),(_vm.showUpload)?_c('v-flex',[_c('v-container',{staticClass:"elevation-3",attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('h4',{staticClass:"headline"},[_vm._v("Add new film")]),_vm._v(" "),_vm._l((_vm.fields),function(field){return _c('edit-field',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_field_c(field)),expression:"show_field_c(field)"}],key:field.key,class:'flex ' + (field.class ? field.class : 'xs12') + (field.dynamic ? ' red' : ''),attrs:{"id":field.name,"name":field.name,"artwork":_vm.artwork,"field":field,"film":_vm.film},model:{value:(field.name),callback:function ($$v) {_vm.$set(field, "name", $$v)},expression:"field.name"}})})],2)],1),_vm._v(" "),_c('v-btn',{on:{"click":_vm.add}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.showUpload=!_vm.showUpload}}},[_vm._v("cancel")])],1):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "tCMm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx__ = __webpack_require__("uXZL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tags_AddNew_vue__ = __webpack_require__("oEbX");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import ArtworkListButtons from '../layout/ArtworkListButtons.vue';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { AddNew: __WEBPACK_IMPORTED_MODULE_5__tags_AddNew_vue__["a" /* default */] },
  // components: { ArtworkListButtons },
  data: function data() {
    var _ref;

    return _ref = {
      selectedCategory: 'all',
      tag_filter: 'all',
      // selectedCategory: '',
      filtered: [],
      snack: false,
      snackColor: '',
      snackText: '',
      pagination: {
        descending: true,
        rowsPerPage: 10,
        sortBy: 'name'
      },
      pagination_related: {
        descending: true,
        // rowsPerPage: 10,
        sortBy: 'title'
      },
      ta: [],
      showConf: false,
      dialog: false,
      edit_dialog: false,
      editedIndex: -1,
      editedItem: {},
      tag_title: '',
      tag_category_name: '',
      tag_category_id: 0,
      tagToDelete: {},
      save_tag_form_display: false,
      save_tag_category_form_display: false,
      selected_tags: [],
      selected: [],
      search: '',
      headers: [
      // { align: 'center', sortable: false },
      { text: 'Tag name', value: 'name', align: 'left' },
      // { text: 'Alternatives', value: 'alternatives', align: 'left' },
      { text: 'Subcategory', value: 'subcategory', align: 'left' },
      // { text: 'Section', value: 'section', align: 'left' },
      { text: 'Category', value: 'tag_category_id', align: 'left' },
      // { text: 'Artworks', align: 'left', sortable: false },
      // { text: '' },
      { text: '' }]
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'pagination_related', {
      descending: true,
      // rowsPerPage: 10,
      sortBy: 'title'
    }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'search_related', ''), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'selected_related', []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, 'headers_related', [{ text: 'Artwork Title', sortable: true, value: 'title' }, { text: 'Accession Number', value: 'accession_number', align: 'right'
      // { text: '', sortable:false, align: 'right' },
      // { text: 'Artist', value: 'artist_name', align: 'right' }
      // { text: 'End', value: 'duration_end', align: 'center', }
      // { text: 'Tags', value: 'tags', sortable: false }
    }]), _ref;
  },

  created: function created() {
    this.$store.dispatch('loadTags');
    // this.$store.dispatch('loadTagCategories')
    this.toggleCategory(this.computed_categories[0]);
    // this.tag_categories = this.$store.state.tag_categories
  },
  mounted: function mounted() {
    this.toggleCategory(this.computed_categories[0]);
    // this.tag_categories = this.$store.state.tag_categories
  },
  computed: {
    filteredArtworks: function filteredArtworks() {
      var _this = this;

      return function (as) {
        return _this.$store.state.artworks.filter(function (a) {
          return Array.isArray(a.tags) && a.tags.some(function (t) {
            return t.id === as;
          });
        });
      };
    },
    filteredTags: function filteredTags() {
      var _this2 = this;

      console.log(this.tag_filter);
      if (this.selectedCategory != this.computed_categories[0]) {
        console.log('1');
        return this.$store.state.tags
        // .slice(0, 2)
        .filter(function (a) {
          switch (_this2.tag_filter) {
            case 'concept':
              return a.section == 'concept';
              break;
            case 'cataloguing':
              return a.section == 'cataloguing';
              // return a.category != '' && !a.section
              break;
            case 'private':
              return a.section == 'private';
              // return a.category != '' && !a.section
              break;
            default:
              return true;
              break;
          }
        });
      } else {
        console.log('2');
        return this.$store.state.tags;
      }
      // return this.$store.state.tags.filter
    },
    computed_categories: function computed_categories() {
      var a = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.all_categories);
      a.unshift({ id: 'all', name: 'All' });
      return a;
    },
    currentSelection: function currentSelection() {
      return this.$store.state.currentSelection;
    },
    anySelected: function anySelected() {
      return this.$store.state.currentSelection.length > 0;
    },
    tags: function tags() {
      return this.$store.state.tags;
    },

    options_c: {
      get: function get() {
        return this.$store.state.options;
      },
      set: function set(value) {
        this.$store.dispatch('saveOptions', value);
      }
    }
  },
  methods: {
    toggleCategory: function toggleCategory(o) {
      var _this3 = this;

      this.selectedCategory = o.name;
      if (o != this.computed_categories[0]) {
        this.filtered = this.tags.filter(function (a) {
          return a.tag_category_id == o.id && a.category == _this3.tag_filter;
        });
      } else {
        this.filtered = this.tags;
      }
    },
    editItem: function editItem(item) {
      this.editedIndex = this.tags.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
      this.edit_dialog = true;
    },

    // deleteItem (item) {
    //   const index = this.tags.indexOf(item)
    //   confirm('Are you sure you want to delete this Tag?') && this.desserts.splice(index, 1)
    // },
    close: function close() {
      var _this4 = this;

      this.edit_dialog = false;
      setTimeout(function () {
        _this4.editedItem = {};
        // Object.assign({}, this.defaultItem)
        _this4.editedIndex = -1;
      }, 300);
    },

    // save () {
    //   if (this.editedIndex > -1) {
    //     Object.assign(this.desserts[this.editedIndex], this.editedItem)
    //   } else {
    //     this.desserts.push(this.editedItem)
    //   }
    //   this.close()
    // },
    tag_category: function tag_category(id) {
      if (id > 0) {
        var tg = this.$store.state.tag_categories.find(function (tc) {
          return tc.id === id;
        });
        if (tg) {
          return tg.name;
        } else {
          return '–';
        }
      } else {
        return ' - ';
      }
    },
    save: function save() {
      var _this5 = this;

      var url = this.$globals.apiserver + '/tags/' + this.editedItem.id + '.json';
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.put(url, { tag: this.editedItem, user_id: this.$store.state.user_id }).then(function (response) {
        _this5.result = response.data;
      }).catch(function (error) {
        // console.log(error)
      });
      this.close();
      this.$store.dispatch('loadTags');
    },
    cancel: function cancel() {
      this.snack = true;
      this.snackColor = 'error';
      this.snackText = 'Canceled';
    },
    open: function open() {
      this.snack = true;
      this.snackColor = 'info';
      this.snackText = 'Dialog opened';
    },
    remove_tag_from_artwork: function remove_tag_from_artwork(tag_id, artwork_id) {
      var list = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.$store.state.lists.find(function (list) {
        return list.id == tag_id;
      }));
      list.artworks = list.artworks.filter(function (a) {
        return a != artwork_id;
      });
      this.$store.dispatch('removeTagFromArtwork', {
        l: tag_id,
        a: artwork_id
      });
    },
    exportExcel: function exportExcel() {
      var _this6 = this;

      // var col = ['id','name'].concat(this.columns)
      var settings = {
        // skipHeader: true,
        origin: 'A2'
      };
      var transformedData = this.$store.state.artworks.map(function (textRow) {
        var tm = textRow.tags.map(function (a) {
          return a.id;
        });
        var ts = _this6.tags.filter(function (t) {
          return tm.includes(t.id);
        });
        // console.log(ts)
        return {
          ID: textRow.id,
          Title: textRow.title + ', ' + (textRow.production_date_new ? textRow.production_date_new : ''),
          Artist: textRow.full_name,
          Tags: ts.map(function (t) {
            return t.name;
          }).join(', ')
        };
      });
      var sheet = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.utils.json_to_sheet(transformedData, settings);
      // var sheet = XLSX.utils.json_to_sheet(this.data)

      // A workbook is the name given to an Excel file
      var wb = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      // XLSX.utils.book_append_sheet(wb, animalWS, 'animals')
      // sheetAName is name of Worksheet
      __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.utils.book_append_sheet(wb, sheet, this.name);

      // export Excel file
      function appendLeadingZeroes(n) {
        if (n <= 9) {
          return '0' + n;
        }
        return n;
      }
      var current_datetime = new Date();
      var formatted_date = current_datetime.getFullYear() + '-' + appendLeadingZeroes(current_datetime.getMonth() + 1) + '-' + appendLeadingZeroes(current_datetime.getDate()) + '-' + appendLeadingZeroes(current_datetime.getHours()) + '_' + appendLeadingZeroes(current_datetime.getMinutes()) + '_' + appendLeadingZeroes(current_datetime.getSeconds());
      // console.log(formatted_date)
      __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.writeFile(wb, 'ArtworksWithTags-' + formatted_date + '.xlsx'); // name of the file is 'book.xlsx'
    },
    show_create_tag_form: function show_create_tag_form() {
      this.save_tag_form_display = true;
      return null;
    },
    showConfDeleteTag: function showConfDeleteTag(id) {
      this.dialog = true;
      this.tagToDelete = this.tags.find(function (t) {
        return t.id == id;
      });
    },
    create_tag: function create_tag() {
      var _this7 = this;

      // var o = Object.assign({ name: this.tag_title})
      // if (this.$refs.form.validate()) {
      // console.log(this.artwork)
      var url = this.$globals.apiserver + '/tags.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post(url, {
        tag: {
          name: this.tag_title,
          tag_category_id: this.tag_category_id,
          created_by: this.$store.state.user_id
        }
      }).then(function (response) {
        // this.result = response.data
        // this.artist = response.data
        _this7.$store.dispatch('loadTags');
        // this.$store.dispatch('createTag',response.data)
        _this7.save_tag_form_display = false;
        _this7.tag_title = '';
        // this.artwork = response.data
        // this.artist = response.data.artist
        // this.e1 = 3
        // console.log(this.artwork)
        // this.$router.push({
        //   name: 'EditTag',
        //   // path: `/artists/edit/${this.artist.id}`,
        //   params: { id: this.tag.id, artist: this.artist }
        // });
      }).catch(function (error) {
        // console.log(error)
      });
      // }
      // },
      // this.$store.dispatch('createTag', o)
      // console.log(o)
    },

    // create_tag_category() {
    //   let url = `${this.$globals.apiserver}/tag_categories.json`
    //   axios
    //     .post(url, {
    //       tag_category: {
    //         name: this.tag_category_name,
    //         created_by: this.$store.state.user_id
    //       }
    //     })
    //     .then(response => {
    //       this.$store.dispatch('loadTagCategories')
    //       // this.$store.dispatch('createTag',response.data)
    //       this.save_tag_category_form_display = false
    //       this.tag_category_name = ''
    //     })
    //     .catch(error => {
    //       // console.log(error)
    //     })
    // },
    deleteTag: function deleteTag(t) {
      var _this8 = this;

      // console.log(t)
      // console.log(this.tagToDelete)
      var url = this.$globals.apiserver + '/tags/' + t + '.json';
      // console.log(url)
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.delete(url, { tag: { id: t } }).then(function (response) {
        _this8.$store.dispatch('loadTags');
        _this8.dialog = false;
        // this.$store.dispatch('deleteTag',t)
        // this.$router.push({path:`/artists/edit/${this.artist.id}`, params: {artist: this.artist}})
      }).catch(function (error) {
        // console.log(error)
      });
    },
    add_tag_to_current_selection: function add_tag_to_current_selection(tag) {
      // var selected = Object.assign([],this.$store.state.currentSelection)
      // for (a in selected) {
      this.$store.dispatch('addTagToCurrentSelection', tag);
      // }
    },
    add_artworks_to_selection: function add_artworks_to_selection(artworks) {
      // var artworks = Object.assign([],this.$store.state.artworks)
      // var artworks_with_selected_tag = artworks.filter(function(artwork) {
      //   if (artwork.tags.length > 0) {
      //     // if (artwork.tags.length > 1) {
      //     //   // console.log(artwork.tags.length)
      //     // }
      //     return artwork.tags.some(a_tag => a_tag.id == tag)
      //   } else {
      //     return false
      //   }
      // })
      var selected = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.$store.state.currentSelection);
      // console.log(artworks_with_selected_tag)
      // console.log(artworks)
      // console.log(selected)
      var out = selected;

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(artworks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var at = _step.value;

          // console.log(at.id)
          if (!selected.includes(at.id)) {
            out.push(at.id);
          }
          // if (selected.length > 0) {
          //   for (let a of selected) {
          //     if (at.id != a.id) {
          //       out.push(at.id)
          //     }
          //   }
          // } else {
          //   out = artworks.map(a => a.id)
          // }
        }

        // artworks_with_selected_tag = this.$store.state.artwork_tags.filter(function(at){ return artwork_id == tag})
        // new_selection =
        // console.log(selected)
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$store.dispatch('addToCurrentSelection', out);
    },
    show_artworks_with_tag: function show_artworks_with_tag() {
      this.$store.dispatch('setCurrentSelection', temp_selection);
      return null;
    }
  }
});

/***/ }),

/***/ "tDbg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editBG pt-3 mt-4",staticStyle:{"min-height":"100%","margin":"0 auto"}},[_c('v-snackbar',{attrs:{"color":_vm.snackbarColor,"auto-height":"","right":"","top":"","timeout":_vm.timeout,"vertical":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(this.snackbarText)+"\n  ")]),_vm._v(" "),_c('v-layout',{staticStyle:{"background-color":"white","height":"50px","width":"100%","top":"135px","position":"fixed","z-index":"1"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}})],1),_vm._v(" "),_c('v-toolbar',{staticClass:"elevation-1 editBG mt-2",staticStyle:{"top":"155px","position":"fixed","z-index":"1"},attrs:{"tabs":""}},[_c('v-toolbar-title',{staticClass:"pl-3 headline",domProps:{"innerHTML":_vm._s(_vm.contactFormData.name)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.deleteText()}}},[_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":"","dark":_vm.contactFormData.category != null && _vm.contactFormData.name != null && _vm.contactFormData.name  != '',"disabled":_vm.contactFormData.category == null || (_vm.contactFormData.name == null || _vm.contactFormData.name == ''),"right":""},on:{"click":_vm.submit}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("save")])],1)],1),_vm._v(" "),_c('v-form',{ref:"form",staticStyle:{"min-height":"100%","margin":"0 auto"},attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{staticClass:"px-3 pt-5 mt-0 elevation-0 editBG",staticStyle:{"height":"100%"}},[_c('v-container',{staticStyle:{"height":"100%"},attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{staticStyle:{"height":"100%"},attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-3 py-0 my-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("Basic")])]),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","xs12":""}},[_c('v-text-field',{attrs:{"label":"Name"},model:{value:(_vm.contactFormData.name),callback:function ($$v) {_vm.$set(_vm.contactFormData, "name", $$v)},expression:"contactFormData.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","xs6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.contactFormData.category == 'artwork_acquisition_source',"label":"First Name"},model:{value:(_vm.contactFormData.first_name),callback:function ($$v) {_vm.$set(_vm.contactFormData, "first_name", $$v)},expression:"contactFormData.first_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","xs6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.contactFormData.category == 'artwork_acquisition_source',"label":"Last Name"},model:{value:(_vm.contactFormData.last_name),callback:function ($$v) {_vm.$set(_vm.contactFormData, "last_name", $$v)},expression:"contactFormData.last_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","xs6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.contactFormData.category == 'artwork_acquisition_source',"label":"Company"},model:{value:(_vm.contactFormData.company),callback:function ($$v) {_vm.$set(_vm.contactFormData, "company", $$v)},expression:"contactFormData.company"}})],1),_vm._v(" "),_c('v-select',{staticClass:"px-3",attrs:{"items":['artwork_acquisition_source', 'registrar', 'exhibition_institution'],"label":"Category * "},model:{value:(_vm.contactFormData.category),callback:function ($$v) {_vm.$set(_vm.contactFormData, "category", $$v)},expression:"contactFormData.category"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(
                _vm.contactFormData.category == null ||
                  _vm.contactFormData.name == null
              )?_c('v-flex',{staticClass:"left",attrs:{"mt-3":"","ml-2":""}},[_vm._v("* Obligatory fields")]):_vm._e(),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "tF94":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddArtwork_vue__ = __webpack_require__("AvzG");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b0e044e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArtwork_vue__ = __webpack_require__("yadK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Djl1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0b0e044e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddArtwork_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b0e044e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArtwork_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b0e044e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArtwork_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "toVw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tpMB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5 editBG mx-0 px-0"},[_c('v-form',{staticClass:"px-3 px-0",staticStyle:{"border-top":"solid 1px"}},[_c('v-card',{staticClass:"px-0 mx-0 mt-3 pt-2 editBG elevation-0"},[_c('v-layout',{attrs:{"row":"","pt-1":"","pl-3":"","pb-0":""}},[_c('v-flex',[_c('v-subheader',{staticClass:"headline black--text pl-3 ml-0 font-weight-light"},[_vm._v("Add New Artist\n            "),(_vm.artist.name)?_c('span',[_vm._v(" - "+_vm._s(_vm.artist.name))]):_vm._e(),_vm._v(" "),_c('v-btn-toggle',{staticClass:"ml-5",attrs:{"small":"","mandatory":"","label":"Collective"},model:{value:(_vm.artist.collective),callback:function ($$v) {_vm.$set(_vm.artist, "collective", $$v)},expression:"artist.collective"}},[_c('v-btn',{attrs:{"small":"","flat":"","value":"0"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("person")]),_vm._v("Single\n              ")],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":"","value":"1"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("people")]),_vm._v(" Collective\n              ")],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.options = false
                _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"color":"black"}},[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-xs":"","fluid":"","py-0":"","my-0":"","px-4":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","px-1":""}},[_c('v-card-text',{staticClass:"px-0 mt-0 pt-0"},[_c('v-container',{staticStyle:{"width":"100%","max-width":"1900px"},attrs:{"grid-list-xs":"","px-0":"","py-0":"","my-0":"","mx-0":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticClass:"pr-3",attrs:{"xs12":""}},[(_vm.artist.collective == 1)?_c('small',[_vm._v("\n                    Create each artist which is part of this collective first.\n                    "),_c('br'),_vm._v("Information entered below is related only to group\n                    of artists. It does'nt change info about each solo artist.\n                  ")]):_vm._e()]),_vm._v(" "),_c('section-header',{staticClass:"mb-3",attrs:{"text":"Basic"}}),_vm._v(" "),_c('v-flex',{staticClass:"mb-3 px-3",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"hide-details":"","hint":"used for all views","label":_vm.artist.collective == 1 ? 'Collective Name' : 'Full Name'},on:{"keyup":function($event){return _vm.check_name($event.target.value)}},model:{value:(_vm.artist.name),callback:function ($$v) {_vm.$set(_vm.artist, "name", $$v)},expression:"artist.name"}}),_vm._v(" "),(_vm.name_exists)?_c('div',{staticClass:"red--text"},[_vm._v("\n                    Artist with this name already exists!\n                  ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"pr-3",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Sort Name","hint":"used for sorting in list views"},model:{value:(_vm.artist.sort_name),callback:function ($$v) {_vm.$set(_vm.artist, "sort_name", $$v)},expression:"artist.sort_name"}})],1),_vm._v(" "),(_vm.artist.collective != 1)?_c('v-flex',{staticClass:"px-3",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"First Name"},model:{value:(_vm.artist.first_name),callback:function ($$v) {_vm.$set(_vm.artist, "first_name", $$v)},expression:"artist.first_name"}})],1):_vm._e(),_vm._v(" "),(_vm.artist.collective != 1)?_c('v-flex',{staticClass:"pr-0",attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Last Name"},model:{value:(_vm.artist.last_name),callback:function ($$v) {_vm.$set(_vm.artist, "last_name", $$v)},expression:"artist.last_name"}})],1):_vm._e(),_vm._v(" "),(_vm.artist.collective != 1)?_c('v-flex',{attrs:{"px-3":"","pb-3":"","xs12":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Birth Name","hide-details":""},model:{value:(_vm.artist.birth_name),callback:function ($$v) {_vm.$set(_vm.artist, "birth_name", $$v)},expression:"artist.birth_name"}})],1):_vm._e(),_vm._v(" "),_c('section-header',{staticClass:"mb-3",attrs:{"text":"Birth & Death / Formation"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":"","pl-0":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","pl-3":"","py-3":""}},[_c('v-text-field',{attrs:{"label":"Year","placeholder":"0000","mask":"####","type":"number","maxlength":4},model:{value:(_vm.artist.birth_date_year),callback:function ($$v) {_vm.$set(_vm.artist, "birth_date_year", $$v)},expression:"artist.birth_date_year"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","mt-0":"","py-3":"","px-2":""}},[_c('v-text-field',{attrs:{"label":"Month","mask":"##","placeholder":"00","type":"number"},model:{value:(_vm.artist.birth_date_month),callback:function ($$v) {_vm.$set(_vm.artist, "birth_date_month", $$v)},expression:"artist.birth_date_month"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","mt-0":"","py-3":"","pr-3":""}},[_c('v-text-field',{attrs:{"label":"Day","mask":"##","placeholder":"00","type":"number"},model:{value:(_vm.artist.birth_date_day),callback:function ($$v) {_vm.$set(_vm.artist, "birth_date_day", $$v)},expression:"artist.birth_date_day"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","d-flex":""}},[(
                      _vm.artist.death_date_only_year == 1 ||
                      _vm.artist.collective == 1
                    )?_c('v-flex',{staticClass:"mt-3 py-0 pl-3",attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"clearable":"","mask":"####","label":"Death Year","prepend-inner-icon":"event"},model:{value:(_vm.artist.death_date_year),callback:function ($$v) {_vm.$set(_vm.artist, "death_date_year", $$v)},expression:"artist.death_date_year"}})],1):_c('v-flex',{staticClass:"mt-3 py-0 pl-3",attrs:{"xs6":""}},[(
                        !_vm.artist.death_date_only_year ||
                        _vm.artist.death_date_only_year == 0 ||
                        _vm.artist.death_date_only_year == '' ||
                        _vm.artist.death_date_only_year == false ||
                        _vm.artist.collective != 1
                      )?_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":32,"nudge-top":18,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[(
                          _vm.artist.death_date_only_year ||
                          _vm.artist.death_date_only_year == 0 ||
                          _vm.artist.death_date_only_year == '' ||
                          _vm.artist.death_date_only_year == false ||
                          _vm.artist.collective != 1
                        )?_c('v-text-field',{attrs:{"slot":"activator","label":"Death Date","prepend-inner-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.artist.death_date),callback:function ($$v) {_vm.$set(_vm.artist, "death_date", $$v)},expression:"artist.death_date"}}):_vm._e(),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.artist.death_date),callback:function ($$v) {_vm.$set(_vm.artist, "death_date", $$v)},expression:"artist.death_date"}})],1):_vm._e()],1),_vm._v(" "),(_vm.artist.collective != 1)?_c('v-flex',{staticClass:"mt-3 py-0 px-3",attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"color":"black","label":"Only Year"},model:{value:(_vm.artist.death_date_only_year),callback:function ($$v) {_vm.$set(_vm.artist, "death_date_only_year", $$v)},expression:"artist.death_date_only_year"}})],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"pl-3":"","pr-2":"","xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":_vm.artist.collective == 1
                        ? 'Formation place'
                        : 'Birth place',"hide-details":""},model:{value:(_vm.artist.birthplace),callback:function ($$v) {_vm.$set(_vm.artist, "birthplace", $$v)},expression:"artist.birthplace"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","pr-0":"","mt-0":"","mb-4":""}},[_c('v-autocomplete',{attrs:{"hide-details":"","items":this.countries,"label":_vm.artist.collective == 1
                        ? 'Formation country'
                        : 'Nationality',"item-value":function (item) { return item.name.common; },"item-text":function (item) { return item.name.common; }},model:{value:(_vm.artist.nationality),callback:function ($$v) {_vm.$set(_vm.artist, "nationality", $$v)},expression:"artist.nationality"}}),_vm._v(" "),(
                      !_vm.artist.nationality &&
                      _vm.artist.nationality != 0 &&
                      _vm.artist.nationality != '' &&
                      _vm.artist.nationality != null
                    )?_c('small',{staticClass:"pt-1 grey--text"},[_vm._v("\n                    "+_vm._s(this.countries.find(
                        function (c) { return c.name.common === _vm.artist.nationality; }
                      ).region)+"\n                    /\n                    "+_vm._s(this.countries.find(
                        function (c) { return c.name.common === _vm.artist.nationality; }
                      ).subregion)+"\n                  ")]):_vm._e()],1),_vm._v(" "),(!_vm.artist.collective == 1)?_c('v-flex',{attrs:{"xs12":"","mt-5":"","mb-0":"","pl-0":"","ml-0":""}},[_c('v-btn-toggle',{model:{value:(_vm.artist.gender),callback:function ($$v) {_vm.$set(_vm.artist, "gender", $$v)},expression:"artist.gender"}},_vm._l((_vm.constants.GENDERS),function(s){return _c('v-btn',{key:s.name,staticClass:"px-2",attrs:{"small":"","flat":"","value":s.name}},[_c('span',[_vm._v(" "+_vm._s(s.name)+" ")])])}),1)],1):_vm._e(),_vm._v(" "),_c('section-header',{attrs:{"text":"Other"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","pr-0":"","pl-0":"","mt-4":""}},[_c('v-textarea',{attrs:{"label":"Lives and works","auto-grow":"","box":"","hide-details":"","clearable":"","rows":"1"},model:{value:(_vm.artist.livesandworks),callback:function ($$v) {_vm.$set(_vm.artist, "livesandworks", $$v)},expression:"artist.livesandworks"}})],1),_vm._v(" "),(_vm.artist.collective != 1)?_c('v-flex',{attrs:{"px-0":"","mt-4":"","xs12":""}},[_c('v-textarea',{staticClass:"my-0",attrs:{"auto-grow":"","box":"","rows":"1","hide-details":"","label":"Bio"},model:{value:(_vm.artist.bio),callback:function ($$v) {_vm.$set(_vm.artist, "bio", $$v)},expression:"artist.bio"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":"","pr-0":"","pl-0":"","mt-4":""}},[_c('v-textarea',{attrs:{"label":"Note","auto-grow":"","box":"","hide-details":"","clearable":"","rows":"1"},model:{value:(_vm.artist.birth_date_text),callback:function ($$v) {_vm.$set(_vm.artist, "birth_date_text", $$v)},expression:"artist.birth_date_text"}})],1),_vm._v(" "),(_vm.artist.collective != 1)?_c('v-flex',{staticClass:"mx-3 mt-3 py-2",attrs:{"xs6":""}},[_c('v-btn-toggle',{model:{value:(_vm.artist.gender),callback:function ($$v) {_vm.$set(_vm.artist, "gender", $$v)},expression:"artist.gender"}},_vm._l((_vm.constants.GENDERS),function(s){return _c('v-btn',{key:s.name,staticClass:"px-2",attrs:{"small":"","flat":"","value":s.name}},[_c('span',[_vm._v(" "+_vm._s(s.name)+" ")])])}),1)],1):_vm._e(),_vm._v(" "),(_vm.artist.collective == 1)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.artists,"label":"Artists in this collective","item-text":"name","item-value":"id","multiple":"","chips":""},model:{value:(_vm.artist.artists),callback:function ($$v) {_vm.$set(_vm.artist, "artists", $$v)},expression:"artist.artists"}})],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"ml-3 mr-0 pr-0 mb-3 justify-end align-center"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"right":"","small":"","color":"black","flat":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("CANCEL")]),_vm._v(" "),_c('v-btn',{staticClass:"mr-0",attrs:{"right":"","small":"","color":"primary"},on:{"click":_vm.saveArtist}},[_vm._v("SAVE")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "u0d4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiArtist_vue__ = __webpack_require__("eA6M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47639b88_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiArtist_vue__ = __webpack_require__("Xfr6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("zrJT")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-47639b88"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiArtist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47639b88_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiArtist_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47639b88_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiArtist_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "u3wA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionHeader_vue__ = __webpack_require__("AEQ5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9252bf24_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionHeader_vue__ = __webpack_require__("n36t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("g6m4")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9252bf24"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9252bf24_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9252bf24_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uQG6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uYtP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationChangeDialog_vue__ = __webpack_require__("XkcQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c54a150e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationChangeDialog_vue__ = __webpack_require__("rqVn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("iuG8")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c54a150e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LocationChangeDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c54a150e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationChangeDialog_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c54a150e_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LocationChangeDialog_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn-bd": "1C9R",
	"./bn-bd.js": "1C9R",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-mx": "USNP",
	"./es-mx.js": "USNP",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "uuDu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uwcO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddArticle_vue__ = __webpack_require__("NEcE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1f23ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArticle_vue__ = __webpack_require__("1mgw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("mjKb")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e1f23ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddArticle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1f23ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArticle_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e1f23ce_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddArticle_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vBUG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timeline_vue__ = __webpack_require__("ajOj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f2a9ec_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timeline_vue__ = __webpack_require__("MS0j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("OxAN")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-79f2a9ec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Timeline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f2a9ec_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timeline_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f2a9ec_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Timeline_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vCKh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElementsTable_vue__ = __webpack_require__("8prl");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e7bcad_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ElementsTable_vue__ = __webpack_require__("cBl8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("euaP")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34e7bcad"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ElementsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e7bcad_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ElementsTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34e7bcad_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ElementsTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wBgt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wEtE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wIw6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tiptap_vue_2__ = __webpack_require__("6/Ck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tiptap_starter_kit__ = __webpack_require__("B+DS");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { defaultExtensions } from '@tiptap/starter-kit'


/* harmony default export */ __webpack_exports__["a"] = ({

  methods: {
    copy2c: function copy2c() {
      var t = this.value;
      var listener = function listener(ev) {
        // console.log(ev)
        ev.preventDefault();
        ev.clipboardData.setData('text/html', t);
        ev.clipboardData.setData('text/plain', t);
      };
      document.addEventListener('copy', listener);
      document.execCommand('copy');
      document.removeEventListener('copy', listener);
    },
    download_text: function download_text() {
      var text_title = '';
      if (this.text) {
        text_title = this.text.title;
      }
      this.exportHTML(this.value, text_title);
    }
  },

  components: { EditorContent: __WEBPACK_IMPORTED_MODULE_0__tiptap_vue_2__["b" /* EditorContent */] },

  props: ['value', 'text', 'artwork'],

  data: function data() {
    return {
      editor: null
      // editor: new Editor({
      //   extensions: [
      //     new Heading({ levels: [1, 2, 3] }),
      //     new BulletList(),
      //     new OrderedList(),
      //     new ListItem(),
      //     new Bold(),
      //     new Code(),
      //     new Italic(),
      //     new Link(),
      //     new Underline(),
      //     new History()
      //   ],
      //   content: this.value,
      //   onUpdate: ( { editor.state, getHTML, getJSON, transaction } ) => {
      //     // console.log(getHTML())
      //     this.$emit('input', getHTML())
      //   }              
      // }),
    };
  },
  mounted: function mounted() {
    var _this = this;

    console.log(this.value);
    this.editor = new __WEBPACK_IMPORTED_MODULE_0__tiptap_vue_2__["a" /* Editor */]({
      extensions: [__WEBPACK_IMPORTED_MODULE_1__tiptap_starter_kit__["a" /* default */]],
      content: this.value,
      onUpdate: function onUpdate(_ref) {
        var editor = _ref.editor;

        // console.log(editor.getHTML())
        _this.$emit('input', editor.getHTML());
      }
    });
  },

  watch: {
    value: function value(_value) {
      // HTML
      var isSame = this.editor.getHTML() === _value;

      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

      if (isSame) {
        return;
      }

      this.editor.commands.setContent(_value, false);
    }
    // value (val) {
    //     // so cursor doesn't jump to start on typing
    //     if (val !== this.editor.getHTML()) {
    //     this.editor.setContent(val)
    //     }
    // }

  },
  beforeDestroy: function beforeDestroy() {
    this.editor.destroy();
  }
});

// console.log(state, transaction)
// console.log(getHTML(), getJSON())
//         new Strike(),
// new TodoItem(),
// new TodoList(),
// new Blockquote(),
// new CodeBlock(),
// new HardBreak(),

// mounted() {
//   this.editor = new Editor({
//     extensions: [],
//     onUpdate: ({ getHTML }) => {
//       this.$emit('input', getHTML())
//     },

//   })
//   this.editor.setContent(this.value)
// },
// components: { Editor, EditorContent, EditorMenuBar}
// import Document from '@tiptap/extension-document'
// import Paragraph from '@tiptap/extension-paragraph'
// import Text from '@tiptap/extension-text'
// CodeBlock,
// HorizontalRule,
// import {
//   Code,
//   // Blockquote,
//   // HardBreak,
//   Heading,
//   OrderedList,
//   BulletList,
//   ListItem,
//   // T odoItem,
//   // T odoList,
//   Bold,
//   Italic,
//   Link,
//   // Strike,
//   Underline,
//   History
// } from 'tiptap-extensions'

/***/ }),

/***/ "wn6m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editBG mt-5 pt-3"},[_c('v-snackbar',{attrs:{"auto-height":"","right":"","top":"","timeout":_vm.timeout,"vertical":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.humanize(this.snackbarFieldName))+" saved.\n  ")]),_vm._v(" "),_c('v-layout',{staticClass:"editBG",attrs:{"mx-0":"","pl-4":"","ml-0":"","mt-0":"","pb-0":""}},[_c('v-flex',{staticClass:"xs12 pl-3"},[_c('v-flex',{staticClass:"pb-0 mb-0 xs8 "},[_c('h5',{staticClass:"font-weight-light headline pt-2 my-0"},[_vm._v("\n          New Contact\n          "),_c('span',{staticClass:"font-weight-regular"},[_vm._v(_vm._s(_vm.contact.name))]),_vm._v(" "),(_vm.contact.category)?_c('span',{staticClass:"font-weight-light"},[_vm._v("("+_vm._s(_vm.contact.category)+")")]):_vm._e()])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-5",attrs:{"icon":"","small":"","color":"#999"},on:{"click":function($event){_vm.options = false
        _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"small":"","color":"white"}},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{staticClass:"px-3 pt-0 mt-0 elevation-0 editBG"},[_c('v-container',{staticClass:"pt-2 mt-0",attrs:{"grid-list-md":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-3 py-1 my-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("Basic")])]),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","xs12":""}},[_c('v-text-field',{attrs:{"label":"Name * "},model:{value:(_vm.contact.name),callback:function ($$v) {_vm.$set(_vm.contact, "name", $$v)},expression:"contact.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","xs6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.contact.category == 'artwork_acquisition_source',"label":"First Name"},model:{value:(_vm.contact.first_name),callback:function ($$v) {_vm.$set(_vm.contact, "first_name", $$v)},expression:"contact.first_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","xs6":""}},[_c('v-text-field',{attrs:{"disabled":_vm.contact.category == 'artwork_acquisition_source',"label":"Last Name"},model:{value:(_vm.contact.last_name),callback:function ($$v) {_vm.$set(_vm.contact, "last_name", $$v)},expression:"contact.last_name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"px-3":"","xs6":""}},[_c('v-text-field',{attrs:{"label":"Company","disabled":_vm.contact.category == 'artwork_acquisition_source'},model:{value:(_vm.contact.company),callback:function ($$v) {_vm.$set(_vm.contact, "company", $$v)},expression:"contact.company"}})],1),_vm._v(" "),_c('v-select',{staticClass:"px-3",attrs:{"items":[
              'artwork_acquisition_source',
              'registrar',
              'exhibition_institution'
            ],"label":"Category * "},model:{value:(_vm.contact.category),callback:function ($$v) {_vm.$set(_vm.contact, "category", $$v)},expression:"contact.category"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.contact.category == null || _vm.contact.name == null)?_c('v-flex',{staticClass:"left",attrs:{"mt-3":"","ml-2":""}},[_vm._v("* Obligatory fields")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"right",attrs:{"dark":_vm.contact.category != null &&
                  _vm.contact.name != null &&
                  _vm.contact.name != '',"disabled":_vm.contact.category == null ||
                  _vm.contact.name == null || _vm.contact.name == ''},on:{"click":_vm.submit}},[_vm._v("\n              save\n            ")]),_vm._v(" "),_c('v-btn',{staticClass:"right",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("cancel")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "wpdr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wxhR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{staticClass:"mt-0",attrs:{"column":""}},[_c('v-flex',{attrs:{"xs12":"","mt-1":"","mx-2":""}},[(!_vm.showUpload && _vm.c_user.edit)?_c('v-btn',{staticClass:"mt-0 mb-0 ml-0 xs12",attrs:{"small":""},on:{"click":function($event){_vm.showUpload = !_vm.showUpload}}},[_vm._v("Add Conservation")]):_vm._e(),_vm._v(" "),(_vm.showUpload || _vm.edit)?_c('v-card',{staticClass:"mx-0 px-0 pt-0 mb-2 elevation-2"},[_c('v-card-text',{staticClass:"px-4"},[_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"prepend-inner-icon":"person","name":"conservator","label":"Conservator"},model:{value:(_vm.conservation.conservator),callback:function ($$v) {_vm.$set(_vm.conservation, "conservator", $$v)},expression:"conservation.conservator"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-menu',{ref:"menu2",attrs:{"return-value":_vm.conservation.last_condition_check,"close-on-content-click":true,"nudge-right":30,"nudge-top":20,"lazy":"","landscape":"","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.conservation, "last_condition_check", $event)},"update:return-value":function($event){return _vm.$set(_vm.conservation, "last_condition_check", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Last Condition Check","prepend-inner-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.conservation.last_condition_check),callback:function ($$v) {_vm.$set(_vm.conservation, "last_condition_check", $$v)},expression:"conservation.last_condition_check"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"persistent":"","color":"black"},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.conservation.last_condition_check)}},model:{value:(_vm.conservation.last_condition_check),callback:function ($$v) {_vm.$set(_vm.conservation, "last_condition_check", $$v)},expression:"conservation.last_condition_check"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"reason","label":"Reason for Condition Report"},model:{value:(_vm.conservation.reason),callback:function ($$v) {_vm.$set(_vm.conservation, "reason", $$v)},expression:"conservation.reason"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"basic_condition_notes","label":"Basic Conservation Description"},model:{value:(_vm.conservation.basic_condition_notes),callback:function ($$v) {_vm.$set(_vm.conservation, "basic_condition_notes", $$v)},expression:"conservation.basic_condition_notes"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"prepend-inner-icon":"link","name":"link","label":"Link"},model:{value:(_vm.conservation.link),callback:function ($$v) {_vm.$set(_vm.conservation, "link", $$v)},expression:"conservation.link"}})],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"px-4"},[_c('v-flex',{staticClass:"xs12"}),_vm._v(" "),_c('v-flex',{staticClass:"xs12 mb-3"},[(!_vm.edit)?_c('v-btn',{staticClass:"right",attrs:{"small":"","dark":"","disabled":_vm.saving},on:{"click":_vm.save_conservation}},[_vm._v("save")]):_c('v-btn',{staticClass:"right",attrs:{"small":"","dark":"","disabled":_vm.saving},on:{"click":_vm.update_conservation}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{attrs:{"small":""},on:{"click":_vm.cancelAddEdit}},[_vm._v("cancel")])],1)],1),_vm._v(" "),(_vm.saving)?_c('v-progress-linear',{attrs:{"width":"2","indeterminate":""}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.artwork.conservations && _vm.artwork.conservations.length > 0)?_c('v-flex',{staticClass:"xs12 my-3 pt-0"},_vm._l((_vm.artwork_conservations),function(l){return _c('v-card',{key:l.id,staticClass:"pa-3 my-0 elevation-1"},[_c('span',[_vm._v("LAST CONDITION CHECK:\n            "),_c('b',[_vm._v(_vm._s(l.last_condition_check ? l.last_condition_check : 'NOT ENTERED'))])]),_vm._v(" "),_c('v-flex',{staticClass:"py-1 my-0"},[_vm._v("\n            REASON: "),_c('b',[_vm._v(_vm._s(l.reason ? l.reason : 'NOT ENTERED'))])]),_vm._v(" "),_c('v-flex',{staticClass:"py-1 my-0"},[_vm._v("\n            CONSERVATOR:\n            "),_c('b',[_vm._v(_vm._s(l.conservator ? l.conservator : 'NOT ENTERED'))])]),_vm._v(" "),_c('v-flex',{staticClass:"py-1 my-0"},[_vm._v("\n            BASIC CONSERVATION DESCRIPTION:\n            "),_c('b',[_vm._v(_vm._s(l.basic_condition_notes
                ? l.basic_condition_notes
                : 'NOT ENTERED'))])]),_vm._v(" "),(l.link)?_c('v-flex',{staticClass:"py-0 my-0"},[_c('a',{attrs:{"href":l.link}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("link")]),_vm._v("\n              Conservation Folder")],1)]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":""}},[(l.created_by)?_c('v-flex',[_vm._v(_vm._s(_vm.get_abb(l.created_by))+" "+_vm._s(_vm.format_date(l.created_at))+"\n            ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{attrs:{"icon":"","small":"","red":""},on:{"click":function($event){return _vm.delete_log(l)}}},[_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),(_vm.c_user.edit)?_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){return _vm.edit_log(l)}}},[_c('v-icon',{attrs:{"small":"","red":""}},[_vm._v("edit")])],1):_vm._e()],1)],1)}),1):_vm._e()],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "xAzJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("Gu7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditFieldSub__ = __webpack_require__("yDEy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_SectionHeader_vue__ = __webpack_require__("u3wA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__layout_SubSectionHeader_vue__ = __webpack_require__("8NsR");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import languages from '@/data/languages'




// const show_field = (field, link) => {
//   if (field.condition && link) {
//     var theInstructions = field.condition
//     var F = theInstructions => {}
//     return F()
//   } else {
//     return true
//   }
// }
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artwork', 'field'],
  data: function data() {
    return {
      // links: [],
      saving: false,
      editing: false,
      save_error: false,
      // links: [
      //   { id:1, title: 'Link 1', url: 'www.google.com', description: 'link description text'},
      //   { id:2, title: 'Link 2', url: 'www.google.com', description: 'link description text'},
      //   { id:3, title: 'Link 3', url: 'www.google.com', description: 'link description text'},
      // ],
      showEditDialog: false,
      show: false,
      link: {
        title: '',
        www: '',
        description: ''
      },
      fields: [{
        ctype: 'text-short',
        name: 'link.title',
        title: 'Title',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-short',
        name: 'www',
        title: 'URL',
        column: true,
        preffix: 'http://',
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }, {
        ctype: 'text-long',
        name: 'description',
        title: 'Description',
        column: true,
        class: 'xs12',
        work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        user_groups: ['admin', 'manager']
      }]
    };
  },
  methods: {
    save_link: function save_link() {
      var _this = this;

      if (!this.link.www.match(/^[a-zA-Z]+:\/\//)) {
        this.link.www = 'http://' + this.link.www;
      }
      this.saving = true;
      this.link.created_by = this.c_user.id;
      this.link.category = this.field.category;
      this.link.artwork_id = this.artwork.id;
      if (!this.artwork.links) {
        this.artwork.links = [];
      }
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post(this.$globals.apiserver + '/links.json', {
        link: this.link
      }).then(function (response) {
        _this.errors = {};
        _this.artwork.links.push(response.data);
        _this.$store.commit('ADD_LINK', response.data);
        _this.showEditDialog = !_this.showEditDialog;
        _this.link = {
          title: '',
          www: '',
          description: ''
        };
        _this.saving = false;
      }).catch(function (error) {
        // console.log(error)
        _this.save_error = true;
      });
    },
    save_edited_link: function save_edited_link() {
      var _this2 = this;

      // console.log('save_edited_link')
      if (this.link.created_by == null) {
        this.link.created_by = this.c_user.id;
      }
      if (!this.link.www.match(/^[a-zA-Z]+:\/\//)) {
        this.link.www = 'http://' + this.link.www;
      }
      this.saving = true;
      // this.link.artwork_id = this.artwork.id;
      // if (!this.artwork.links) {
      //   this.artwork.links = [];
      // }
      var url = this.$globals.apiserver + '/links/' + this.link.id + '.json';
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.put(url, {
        link: this.link
      }).then(function (response) {
        _this2.errors = {};
        _this2.artwork.links = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this2.artwork.links.map(function (item) {
          return item.id !== response.data.id ? item : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item, response.data);
        })));
        _this2.$store.commit('SAVE_LINK', response.data);
        _this2.showEditDialog = !_this2.showEditDialog;
        _this2.link = {
          title: '',
          www: '',
          description: ''
        };
        _this2.saving = false;
        _this2.editing = false;
      }).catch(function (error) {
        _this2.save_error = true;
      });
    },

    // set_input (f) {
    //   link[f] = f
    // },
    // download () {},
    delete_link: function delete_link(link) {
      var i = this.artwork.links.indexOf(link);
      if (i != -1) {
        this.artwork.links.splice(i, 1);
      }
      this.$store.dispatch('deleteLink', link);
    },
    edit_link: function edit_link(l) {
      this.saving = false;
      this.editing = true;
      this.showEditDialog = true;
      try {
        this.link = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.artwork.links.find(function (t) {
          return t.id == l.id;
        }));
      } catch (error) {
        // console.log(error.message)
      }
    }
    // show_field_c (field) {
    //   // console.log(this.link)
    //   return show_field(field, this.link)
    // }

  },
  computed: {
    links: function links() {
      var _this3 = this;

      if (this.artwork.links && this.artwork.links.length > 0) {
        return this.artwork.links.filter(function (l) {
          return l.category === _this3.field.category;
        });
      } else {
        return null;
      }
    }
    // c_user () {
    //   return this.$store.state.user.profile
    // }

  },
  components: {
    'edit-field-a': __WEBPACK_IMPORTED_MODULE_3__EditFieldSub__["a" /* default */],
    'section-header': __WEBPACK_IMPORTED_MODULE_5__layout_SectionHeader_vue__["a" /* default */],
    'subsection-header': __WEBPACK_IMPORTED_MODULE_6__layout_SubSectionHeader_vue__["a" /* default */]
  }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_actions_auth__ = __webpack_require__("+4WN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_login__ = __webpack_require__("0HId");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_Toolbar_vue__ = __webpack_require__("srZm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_artists_Artists_vue__ = __webpack_require__("l848");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contacts_Contacts_vue__ = __webpack_require__("cEmV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_actions_user__ = __webpack_require__("yLEp");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Router from 'vue-router'
// import { mapGetters } from 'vuex'



//import Login from '@/components/users/Login.vue'








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      dialog: false,
      transitionName: 'slide-left'
      // drawer: null,
      // sheet: false,
      // currentUser: ''
      // currentUser: this.$store.state.currentUser
    };
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var toDepth = to.path.split('/').length;
    var fromDepth = from.path.split('/').length;
    this.transitionName = toDepth < fromDepth ? 'slide-right' : 'slide-left';
    next();
  },

  computed: {
    token: function token() {
      // console.log(localStorage.getItem('user-token'))
      return localStorage.getItem('user-token');
    }
  },
  props: {
    source: String,
    filters: []
  },
  components: {
    Login: __WEBPACK_IMPORTED_MODULE_2__components_login__["a" /* default */],
    Toolbar: __WEBPACK_IMPORTED_MODULE_3__components_layout_Toolbar_vue__["a" /* default */],
    Artists: __WEBPACK_IMPORTED_MODULE_4__components_artists_Artists_vue__["a" /* default */],
    Contacts: __WEBPACK_IMPORTED_MODULE_5__components_contacts_Contacts_vue__["a" /* default */]
  },
  // computed: {
  //   ...mapGetters({ currentUser: 'currentUser' })
  // },
  created: function created() {
    // savedResetDate = localStorage.getItem('last-reset')
    // if (savedResetDate && savedResetDate > Date.now()) {
    //   localStorage.clear()
    // }
    if (this.$store.getters.isAuthenticated) {
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_7__store_actions_user__["b" /* USER_REQUEST */]);
    } else {
      this.$router.push('/login');
    }
  },

  // created () {
  // this.checkCurrentLogin()
  // this.currentUser = this.$store.state.users[2]
  // this.currentUser = Object.assign({},this.$store.state.currentUser)

  // },
  updated: function updated() {
    // this.checkCurrentLogin()
  },

  methods: {}
  // checkCurrentLogin () {
  //   if (!this.currentUser && this.$route.path !== '/') {
  //     this.$router.push('/?redirect=' + this.$route.path)
  //   }
  // }

  // data: {
  //   currentRoute: window.location.pathname
  // },
  // computed: {
  //   ViewComponent () {
  //     return routes[this.currentRoute] || NotFound
  //   }
  // },
  // render (h) { return h(this.ViewComponent) }
});

/***/ }),

/***/ "xPPZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['artist'],
  computed: {
    full_name: function full_name() {
      return this.artist.first_name + ' ' + this.artist.last_name;
    },

    link: function link() {
      return '/artists/edit/' + this.artist.id;
    }
  },
  components: {},
  methods: {
    _toggle: function _toggle() {
      this.editArtist = true;
    }
  }
});

/***/ }),

/***/ "xPdV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xo4a":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "y4E9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blue-grey lighten-4"},[_c('v-dialog',{attrs:{"persistent":"","max-width":"800px","transition":"dialog-transition"},model:{value:(_vm.editDialog),callback:function ($$v) {_vm.editDialog=$$v},expression:"editDialog"}},[_c('v-flex',{staticClass:"xs12 ml-0 pl-4 pr-4 pt-4 pb-3 layout row wrap elevation-0 white"},[_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"christies_2022_LOWER_MARKET_value","label":"Market Value"},model:{value:(_vm.editedInsuranceLog.christies_2022_LOWER_MARKET_value),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "christies_2022_LOWER_MARKET_value", $$v)},expression:"editedInsuranceLog.christies_2022_LOWER_MARKET_value"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6 pr-3"},[_c('v-text-field',{attrs:{"name":"insurance_value_currency","label":"Currency"},model:{value:(_vm.editedInsuranceLog.insurance_value_currency),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "insurance_value_currency", $$v)},expression:"editedInsuranceLog.insurance_value_currency"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6"},[_c('v-text-field',{attrs:{"name":"insurance_valuer","label":"Valuer"},model:{value:(_vm.editedInsuranceLog.insurance_valuer),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "insurance_valuer", $$v)},expression:"editedInsuranceLog.insurance_valuer"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"insurance_value_note","label":"Note"},model:{value:(_vm.editedInsuranceLog.insurance_value_note),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "insurance_value_note", $$v)},expression:"editedInsuranceLog.insurance_value_note"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs6 mb-0 pl-3 mt-1 pt-3"},[_c('v-btn-toggle',{attrs:{"disabled":_vm.c_user.id != 67 && _vm.c_user.id != 1,"mandatory":"","active-class":"activeToggle"},model:{value:(_vm.editedInsuranceLog.storage),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "storage", $$v)},expression:"editedInsuranceLog.storage"}},[_c('v-btn',{staticClass:"px-3",attrs:{"value":"in","small":"","flat":""}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("call_received")]),_vm._v(" IN\n          ")],1),_vm._v(" "),_c('v-btn',{staticClass:"px-3",attrs:{"value":"out","small":"","flat":""}},[_vm._v("\n            OUT "),_c('v-icon',{attrs:{"small":""}},[_vm._v("call_made")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","d-flex":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-menu',{ref:"menu2a",attrs:{"disabled":_vm.c_user.id != 67 && _vm.c_user.id != 1,"close-on-content-click":true,"nudge-right":40,"lazy":"","landscape":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu2a),callback:function ($$v) {_vm.menu2a=$$v},expression:"menu2a"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.editedInsuranceLog.insurance_value_date),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "insurance_value_date", $$v)},expression:"editedInsuranceLog.insurance_value_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"persistent":"","color":"black"},model:{value:(_vm.editedInsuranceLog.insurance_value_date),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "insurance_value_date", $$v)},expression:"editedInsuranceLog.insurance_value_date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-menu',{ref:"menu",attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":_vm.editedInsuranceLog.change_time,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.editedInsuranceLog, "change_time", $event)},"update:return-value":function($event){return _vm.$set(_vm.editedInsuranceLog, "change_time", $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"label":"Picker time if needed","prepend-inner-icon":"access_time","readonly":""},model:{value:(_vm.editedInsuranceLog.change_time),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "change_time", $$v)},expression:"editedInsuranceLog.change_time"}},on))]}}]),model:{value:(_vm.menu_time),callback:function ($$v) {_vm.menu_time=$$v},expression:"menu_time"}},[_vm._v(" "),(_vm.menu_time)?_c('v-time-picker',{attrs:{"full-width":"","format":"24hr"},on:{"click:minute":function($event){return _vm.$refs.menu.save(_vm.editedInsuranceLog.change_time)}},model:{value:(_vm.editedInsuranceLog.change_time),callback:function ($$v) {_vm.$set(_vm.editedInsuranceLog, "change_time", $$v)},expression:"editedInsuranceLog.change_time"}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mt-3":"","mb-0":""}},[_vm._v(_vm._s(_vm.editedInsuranceLog.copy)+"\n        ")]),_vm._v(" "),_c('v-flex',{staticClass:"xs12"}),_vm._v(" "),_c('v-flex',{staticClass:"xs12 pr-0 mr-0 mt-3",attrs:{"text-xs-right":""}},[_c('v-btn',{attrs:{"small":"","dark":!(
            _vm.editedInsuranceLog.christies_2022_LOWER_MARKET_value == null ||
            _vm.editedInsuranceLog.christies_2022_LOWER_MARKET_value == ''
          ) &&
          !(
            _vm.editedInsuranceLog.insurance_value_date == null ||
            _vm.editedInsuranceLog.insurance_value_date == ''
          ),"disabled":_vm.editedInsuranceLog.christies_2022_LOWER_MARKET_value == null ||
              _vm.editedInsuranceLog.christies_2022_LOWER_MARKET_value == '' ||
              _vm.editedInsuranceLog.insurance_value_date == null ||
              _vm.editedInsuranceLog.insurance_value_date == ''},on:{"click":_vm.save_edited_artwork_insurance_log}},[_vm._v("save")]),_vm._v(" "),_c('v-btn',{attrs:{"small":""},on:{"click":function($event){_vm.editDialog = !_vm.editDialog}}},[_vm._v("cancel")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-0",attrs:{"column":""}},[_c('v-flex',{attrs:{"ml-3":"","mt-1":""}},[(_vm.artwork.christies_2022_LOWER_MARKET_value)?_c('v-flex',{attrs:{"xs12":""}},[_c('b',[_vm._v("Latest Artwork Market Valuation")])]):_vm._e(),_vm._v(" "),(_vm.lastInsuranceLogArtwork)?_c('v-flex',{attrs:{"xs12":"","pt-2":""}},[_c('div',[_c('v-icon',{staticClass:"ml-0 mt-1",attrs:{"color":"black","small":""}},[_vm._v("verified")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.formatMoney(_vm.lastInsuranceLogArtwork.christies_2022_LOWER_MARKET_value))+" "+_vm._s(_vm.lastInsuranceLogArtwork.insurance_value_currency))]),_vm._v(" on \n          "),_c('b',[_vm._v(_vm._s(_vm.lastInsuranceLogArtwork.insurance_value_date)+" ")]),_vm._v("\n          by "),_c('b',[_vm._v(_vm._s(_vm.lastInsuranceLogArtwork.insurance_valuer)+" ")]),_c('br'),_vm._v(" "),(_vm.lastInsuranceLogArtwork.insurance_value_note)?_c('span',[_vm._v("("+_vm._s(_vm.lastInsuranceLogArtwork.insurance_value_note)+" )"),_c('br')]):_vm._e(),_vm._v(" "),(_vm.lastInsuranceLogArtwork.reason)?_c('span',[_vm._v("("+_vm._s(_vm.lastInsuranceLogArtwork.reason)+" )")]):_vm._e()],1)]):_c('v-flex',{attrs:{"xs12":"","pt-2":""}},[_c('v-icon',{staticClass:"ml-0",attrs:{"color":"black","small":""}},[_vm._v("verified")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.formatMoney(_vm.artwork.christies_2022_LOWER_MARKET_value))+" "+_vm._s(_vm.artwork.insurance_value_currency))]),_vm._v(" "),_c('b',[_vm._v("("+_vm._s(_vm.artwork.insurance_value_date_year)+"-"+_vm._s(_vm.artwork.insurance_value_date_month)+"-"+_vm._s(_vm.artwork.insurance_value_date_day)+") ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"xs12":"","sm12":"","md12":"","mt-2":"","ml-0":"","mr-0":"","px-0":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs12":"","row":"","layout":""}},[(_vm.c_user.edit)?_c('v-btn',{staticClass:"mt-2 mb-0 ml-3 mr-0",attrs:{"round":"","flat":"","small":""},on:{"click":_vm.switch_change_dialog}},[_vm._v("\n            "+_vm._s(_vm.showUpload ? 'Cancel ' : 'Add Market Valuation'))]):_vm._e(),_vm._v(" "),_c('v-spacer',{staticClass:"pb-0 mb-0"}),_vm._v(" "),_c('v-btn',{staticClass:"pl-3 pr-2 mx-3",attrs:{"small":"","round":"","flat":""},on:{"click":function($event){_vm.showList = !_vm.showList}}},[_vm._v("\n            "+_vm._s(_vm.showList ? 'Hide' : 'Show')+" History\n            "),(!_vm.showList)?_c('v-icon',{staticClass:"pl-3"},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.showList)?_c('v-icon',{staticClass:"pl-3"},[_vm._v("expand_less")]):_vm._e()],1)],1),_vm._v(" "),(_vm.showUpload)?_c('v-card',{staticClass:"\n                            xs12\n                            ml-0\n                            mr-0\n                            mt-2\n                            mb-2\n                            elevation-0\n                            "},[_c('v-card-title',{staticClass:"blue-grey lighten-3 white--text xs12 py-2"},[_c('h3',[_vm._v("Add Market Valuation")])]),_vm._v(" "),_c('v-card-text',{staticClass:"pl-4\n                            pr-4\n                            pt-3\n                            pb-3 wrap row layout"},[_c('v-flex',{staticClass:"sm8 xs12 pr-3"},[_c('v-text-field',{attrs:{"name":"christies_2022_LOWER_MARKET_value","label":"Market Value"},model:{value:(_vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "christies_2022_LOWER_MARKET_value", $$v)},expression:"artwork_insurance_log.christies_2022_LOWER_MARKET_value"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm4 xs12"},[_c('v-select',{attrs:{"name":"insurance_value_currency","items":[
                    'EUR',
                    'USD',
                    'GBP',
                    'AUD',
                    'CHF',
                    'YEN',
                    'MYR',
                    'SIT',
                    'ATS (obsolete)',
                    'DEM (obsolete)',
                    'ESP (obsolete)',
                    'FRF (obsolete)',
                    'ITL (obsolete)',
                    'NLG (obsolete)',
                    'RM (obsolete)',
                    'Gift' ],"label":"Currency","hint":"Currency"},model:{value:(_vm.artwork_insurance_log.insurance_value_currency),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "insurance_value_currency", $$v)},expression:"artwork_insurance_log.insurance_value_currency"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 "},[_c('v-text-field',{staticClass:"mr-0",attrs:{"name":"reason","label":"Reason"},model:{value:(_vm.artwork_insurance_log.reason),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "reason", $$v)},expression:"artwork_insurance_log.reason"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"sm12 md6"},[_c('v-text-field',{staticClass:"mr-3",attrs:{"name":"insurance_valuer","label":"Valuer"},model:{value:(_vm.artwork_insurance_log.insurance_valuer),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "insurance_valuer", $$v)},expression:"artwork_insurance_log.insurance_valuer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","mb-0":"","pb-0":""}},[_c('v-menu',{ref:"menu2",attrs:{"disabled":!_vm.c_user.edit,"return-value":_vm.artwork_insurance_log.insurance_value_date,"close-on-content-click":true,"nudge-right":40,"lazy":"","landscape":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.artwork_insurance_log, "insurance_value_date", $event)},"update:return-value":function($event){return _vm.$set(_vm.artwork_insurance_log, "insurance_value_date", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Market Value Date","prepend-inner-icon":"event","readonly":"","persistent-hint":""},slot:"activator",model:{value:(_vm.artwork_insurance_log.insurance_value_date),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "insurance_value_date", $$v)},expression:"artwork_insurance_log.insurance_value_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"color":"black","persistent":""},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.artwork_insurance_log.insurance_value_date)}},model:{value:(_vm.artwork_insurance_log.insurance_value_date),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "insurance_value_date", $$v)},expression:"artwork_insurance_log.insurance_value_date"}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"},[_c('v-text-field',{attrs:{"name":"insurance_value_note","label":"Note"},model:{value:(_vm.artwork_insurance_log.insurance_value_note),callback:function ($$v) {_vm.$set(_vm.artwork_insurance_log, "insurance_value_note", $$v)},expression:"artwork_insurance_log.insurance_value_note"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12"}),_vm._v(" "),_c('v-flex',{staticClass:"xs12 pr-0 mr-0 mt-3",attrs:{"text-xs-right":""}},[_c('v-btn',{attrs:{"small":"","flat":""},on:{"click":_vm.switch_change_dialog}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":!(
                  _vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value == null ||
                  _vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value == '' ||
                  _vm.artwork_insurance_log.insurance_value_currency == null ||
                  _vm.artwork_insurance_log.insurance_value_currency == ''
                ) &&
                !(
                  _vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value == null ||
                  _vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value == ''
                ),"disabled":_vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value == null ||
                    _vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value == '' ||
                    _vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value == null ||
                    _vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value == ''},on:{"click":_vm.showSaveDialog}},[_vm._v("save")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","overlay":true,"max-width":"500px","transition":"dialog-transition"},model:{value:(_vm.saveDialog),callback:function ($$v) {_vm.saveDialog=$$v},expression:"saveDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"red white--text pb-2 pt-2",attrs:{"primary-title":""}},[_c('h2',[_vm._v("Review Changes")])]),_vm._v(" "),_c('v-card-text',[_c('h3',{staticClass:"mb-3"},[_vm._v(" New Market Value History entry will be created for:"),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-uppercase"},[_vm._v(_vm._s(_vm.artwork.title))])]),_vm._v(" "),_c('div',[_vm._v("\n                Market Value Date: "),_c('b',[_vm._v(_vm._s(_vm.artwork_insurance_log.insurance_value_date))])]),_vm._v(" "),_c('div',[_vm._v("\n                Market Value: "),_c('b',[_vm._v(_vm._s(_vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value)+" "+_vm._s(_vm.artwork_insurance_log.insurance_value_currency))])]),_vm._v(" "),_c('div',[_vm._v("\n                Market Valuer: "),_c('b',[_vm._v(_vm._s(_vm.artwork_insurance_log.insurance_valuer)+" ")])]),_vm._v(" "),_c('div',[_vm._v("\n                Reason: "),_c('b',[_vm._v(_vm._s(_vm.artwork_insurance_log.reason))])]),_vm._v(" "),_c('div',[_vm._v("\n                Note: "),_c('b',[_vm._v(_vm._s(_vm.artwork_insurance_log.insurance_value_note))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"cancel","small":""},on:{"click":function($event){_vm.saveDialog = false}}},[_vm._v("cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":"","disabled":_vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value == null ||
                    _vm.artwork_insurance_log.christies_2022_LOWER_MARKET_value == '' ||
                    _vm.artwork_insurance_log.insurance_value_currency == '' ||
                    _vm.artwork_insurance_log.insurance_value_date == null ||
                    _vm.artwork_insurance_log.insurance_value_date == ''},on:{"click":_vm.save_artwork_insurance_log}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),(_vm.showList && (_vm.filtered_artwork_insurance_logs &&
          _vm.filtered_artwork_insurance_logs.length > 0))?_c('v-flex',{attrs:{"row":"","xs12":"","sm12":"","md12":"","mt-0":"","ml-0":"","mr-0":""}},[_c('v-list',{staticClass:"xs12 py-0 grey lighten-4",attrs:{"three-line":""}},[_c('v-flex',{attrs:{"my-0":"","pb-0":"","pt-2":""}},[_vm._l((_vm.filtered_artwork_insurance_logs),function(l){return [_c('v-flex',{key:l.id},[_c('v-flex',{attrs:{"px-3":"","py-0":""}},[_c('v-list-tile-title',{staticClass:"subheading font-weight-bold"},[_c('span',[_vm._v(_vm._s(l.insurance_value_date))]),_vm._v(" by "),_c('b',[_vm._v(_vm._s(l.insurance_valuer)+" ")]),_vm._v(" "),_c('small',{staticClass:"right font-weight-thin"},[(l.created_by != null)?_c('span',[_vm._v(_vm._s(_vm.get_abb(l.created_by))+" -")]):_vm._e(),_vm._v(" "),(l.created_at != null || l.created_at != '')?_c('span',[_vm._v(_vm._s(_vm.format_date(l.created_at)))]):_vm._e()])]),_vm._v(" "),_c('v-list-tile-title',[(_vm.c_user.edit)?_c('span',{staticClass:"right"},[_c('v-btn',{staticClass:"mt-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.delete_log(l)}}},[_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-btn',{key:l.id + 'b',staticClass:"mr-0 mt-0",attrs:{"small":"","icon":""},on:{"click":function($event){return _vm.editInsurance(l)}}},[_c('v-icon',{attrs:{"small":"","color":"black"}},[_vm._v("edit")])],1)],1):(l.insurance_value_note == 'Created at Artwork record creation in CMS'
                      )?_c('span',[_vm._v("\n                    Created at Artwork record creation in CMS\n                  ")]):_vm._e(),_vm._v(" "),_c('span',{},[_vm._v("Market Value:")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.formatMoney(l.christies_2022_LOWER_MARKET_value))+" "+_vm._s(l.insurance_value_currency))]),_c('br')]),_vm._v(" "),(l.reason)?_c('v-list-tile-sub-title',{staticClass:"body-2"},[_c('span',{},[_vm._v("REASON:")]),_vm._v("\n                  "+_vm._s(l.reason)+"\n                ")]):_vm._e(),_vm._v(" "),(l.insurance_value_note &&
                  l.insurance_value_note != 'Created at Artwork record creation in CMS'
                  )?_c('v-list-tile-sub-title',{staticClass:"body-2"},[_c('span',{},[_vm._v("NOTE:")]),_vm._v("\n                  "+_vm._s(l.insurance_value_note)+"\n                ")]):_vm._e()],1)],1),_vm._v(" "),_c('v-divider',{key:("a" + (l.id)),staticClass:"my-2"})]})],2)],1)],1):_vm._e(),_vm._v(" "),(_vm.showList && _vm.artwork.Valuation_Date_all)?_c('table',{staticClass:"mx-3 pa-2 mt-0 pa-0 mb-3 white"},[_c('tr',[_c('th',{staticStyle:{"text-align":"left"}},[_vm._v("Legacy")])]),_vm._v(" "),_vm._l((_vm.old_insurance_table),function(item){return _c('tr',{key:item.id},[_c('td',[_vm._v(_vm._s(item.date)+" ")]),_c('td',[_vm._v(" "+_vm._s(item.type)+" ")]),_c('td',[_vm._v(" "+_vm._s(item.method)+" ")])])})],2):_vm._e()],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "yAI7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editBG pt-3 mt-4"},[_c('v-dialog',{attrs:{"width":"400px"},model:{value:(_vm.dialogImage),callback:function ($$v) {_vm.dialogImage=$$v},expression:"dialogImage"}},[_c('v-card',[(_vm.dialogJpg)?_c('v-img',{attrs:{"src":("/static/" + _vm.dialogJpg + ".jpg")}}):_vm._e()],1)],1),_vm._v(" "),_c('v-navigation-drawer',{staticClass:"px-2 navbar",staticStyle:{"margin-top":"8px"},attrs:{"width":"420","temporary":"","absolute":"","right":"","dark":"","hide-overlay":""},model:{value:(_vm.options_c),callback:function ($$v) {_vm.options_c=$$v},expression:"options_c"}},[_c('h1',{staticClass:"pl-3 pt-3 pb-2 font-weight-regular display-1 white--text"},[_vm._v("\n      Options\n    ")]),_vm._v(" "),_c('v-divider',{staticClass:"mx-3 pb-0 mb-0 white"}),_vm._v(" "),_c('v-list',_vm._l((['Details', 'History']),function(tab){return _c('v-list-tile',{key:tab,staticClass:"pl-0 ml-4 ml-0 pl-0",on:{"click":function($event){return _vm.setCurrentTab(tab)}}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(tab))])],1)],1)}),1),_vm._v(" "),_c('v-divider',{staticClass:"mx-3 pb-0 mb-0 white"})],1),_vm._v(" "),_c('v-layout',{staticStyle:{"background-color":"white","height":"50px","width":"100%","top":"135px","position":"fixed","z-index":"1"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}})],1),_vm._v(" "),_c('v-toolbar',{staticClass:"elevation-1 mt-2",staticStyle:{"top":"155px","position":"fixed","z-index":"1"},attrs:{"tabs":"","color":"white"}},[_c('h4',{staticClass:"pl-3 headline font-weight-light"},[_vm._v("\n      "+_vm._s(_vm.userFormData.firstname)+" "+_vm._s(_vm.userFormData.lastname)+"\n      "),(_vm.userFormData.enable == 'N')?_c('span',{staticClass:"pl-3 red--text"},[_vm._v("\n        – DISABLED")]):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"small":"","color":"red"}},[_vm._v("delete")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"mr-3",attrs:{"small":"","icon":"","right":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("close")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":"","disabled":!_vm.valid,"right":""},on:{"click":_vm.save}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("save")])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"editBG elevation-0"},[_c('v-layout',{staticClass:"row wrap xs12 ml-3 mr-4 pl-1 mt-4 pt-5 pr-4",staticStyle:{"top":"155px","z-index":"1"}},[_c('v-flex',{staticClass:"pl-5 py-0 xs12 md5 mb-0 mt-2"},[_c('v-avatar',{attrs:{"size":"136px","color":"white"}},[_c('v-icon',{attrs:{"size":"116px","color":"black"}},[_vm._v("person")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"pl-3 xs12 md7 mb-0 mt-3"},[_c('v-layout',{attrs:{"row":"","wrap":"","xs12":""}},[_c('v-flex',{staticClass:"bleft",attrs:{"xs6":"","pl-2":"","pb-4":""}},[_c('b',[_vm._v("Login:")])]),_vm._v(" "),_c('v-flex',{staticClass:"bleft",attrs:{"xs6":"","pl-2":""}},[_c('b',[_vm._v(_vm._s(_vm.userFormData.login))])]),_vm._v(" "),_c('v-flex',{staticClass:"bleft",attrs:{"xs6":"","pl-2":"","pb-2":""}},[_vm._v("Account Created on:")]),_vm._v(" "),_c('v-flex',{staticClass:"bleft",attrs:{"xs6":"","pl-2":""}},[_vm._v(_vm._s(_vm.formatDate(_vm.userFormData.created_at)))]),_vm._v(" "),_c('v-flex',{staticClass:"bleft",attrs:{"xs6":"","pl-2":"","pb-2":""}},[_vm._v("Last Update:")]),_vm._v(" "),_c('v-flex',{staticClass:"bleft",attrs:{"xs6":"","pl-2":""}},[_vm._v(_vm._s(_vm.formatDate(_vm.userFormData.updated_at)))]),_vm._v(" "),_c('v-flex',{staticClass:"bleft",attrs:{"xs6":"","pl-2":""}},[_vm._v("Account Abbreviation:")]),_vm._v(" "),_c('v-flex',{staticClass:"bleft",attrs:{"xs6":"","pl-2":""}},[_vm._v(_vm._s(_vm.userFormData.abb))])],1)],1)],1)],1),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"id":"form","lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{staticClass:"editBG px-3 pt-0 elevation-0 pb-4"},[_c('v-container',{attrs:{"grid-list-xs":"","fluid":""}},[(_vm.currentTab == 'Details')?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"px-3 py-1 my-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("Basic")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","pl-3":"","my-2":""}},[_c('v-text-field',{staticClass:"black--text dark",attrs:{"browser-autocomplete":"off","label":"First Name","color":"black","hide-details":""},model:{value:(_vm.userFormData.firstname),callback:function ($$v) {_vm.$set(_vm.userFormData, "firstname", $$v)},expression:"userFormData.firstname"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","pl-3":"","my-2":""}},[_c('v-text-field',{staticClass:"black--text dark",attrs:{"browser-autocomplete":"off","label":"Last Name","color":"black","hide-details":""},model:{value:(_vm.userFormData.lastname),callback:function ($$v) {_vm.$set(_vm.userFormData, "lastname", $$v)},expression:"userFormData.lastname"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","pl-3":"","mt-2":""}},[_c('v-text-field',{staticClass:"black--text dark",attrs:{"browser-autocomplete":"off","label":"Shortcut","color":"black","hint":"Shows in tables and at places wher full name of user doesn't fit"},model:{value:(_vm.userFormData.abb),callback:function ($$v) {_vm.$set(_vm.userFormData, "abb", $$v)},expression:"userFormData.abb"}})],1),_vm._v(" "),(_vm.userFormData.id == _vm.c_user.id)?_c('v-flex',{staticClass:"px-2 py-1 mt-3 mb-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("Login")])]):_vm._e(),_vm._v(" "),(_vm.userFormData.id == _vm.c_user.id)?_c('v-flex',{attrs:{"xs12":"","sm6":"","pl-3":""}},[_c('v-text-field',{staticClass:"black--text dark",attrs:{"browser-autocomplete":"off","label":"Login","color":"black","hide-details":""},model:{value:(_vm.userFormData.login),callback:function ($$v) {_vm.$set(_vm.userFormData, "login", $$v)},expression:"userFormData.login"}})],1):_vm._e(),_vm._v(" "),(
              _vm.userFormData.id == _vm.c_user.id ||
              _vm.c_user.admin == 1 ||
              (_vm.c_user.roles &&
                _vm.c_user.roles.find(function (f) { return f.shortcut == 'edit_password'; }))
            )?_c('v-flex',{attrs:{"xs12":"","sm6":"","pl-3":""}},[_c('v-text-field',{staticClass:"black--text dark",attrs:{"browser-autocomplete":"off","label":"Password (fill in only if you want to change it)","type":_vm.show3 ? 'password' : 'text',"color":"black","placeholder":"*********","append-icon":_vm.show3 ? 'visibility' : 'visibility_off'},on:{"click:append":function($event){_vm.show3 = !_vm.show3}},model:{value:(_vm.userFormData.password),callback:function ($$v) {_vm.$set(_vm.userFormData, "password", $$v)},expression:"userFormData.password"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"px-3 py-1 mt-3 mb-3 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("Contact")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","pl-3":""}},[_c('v-text-field',{staticClass:"black--text dark",attrs:{"browser-autocomplete":"off","label":"E-mail","color":"black","hide-details":""},model:{value:(_vm.userFormData.email),callback:function ($$v) {_vm.$set(_vm.userFormData, "email", $$v)},expression:"userFormData.email"}})],1),_vm._v(" "),(_vm.c_user.edit)?_c('v-flex',{staticClass:"px-3 py-1 mt-4 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("User Rights")])]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","px-0":""}},[_c('v-container',{attrs:{"fluid":"","pa-0":"","ma-0":"","grid-list-xs":"","text-xs-left":""}},[_c('v-layout',{staticClass:"grey lighten-2 pb-4",attrs:{"row":"","wrap":"","pa-0":"","ma-0":""}},_vm._l((_vm.formatted_roles),function(r){return _c('v-flex',{key:r.id,class:{
                    xs12: r.header || r.divider,
                    'xs12 sm6 md4 lg3': !(r.header || r.divider),
                    'px-2 py-0 my-0': true,
                  }},[(r.header || r.divider)?_c('v-flex',{attrs:{"xs12":"","pt-3":"","pl-3":"","pb-0":"","mb-0":"","mt-4":""}},[_c('h2',[_c('span',[_vm._v(_vm._s(r.header))]),_vm._v(" "),(r.image)?_c('v-btn',{staticClass:"right mt-0 pt-0 pb-2",attrs:{"icon":""},on:{"click":function($event){return _vm.showHelp(r.image)}}},[_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v("help")])],1):_vm._e()],1),_vm._v(" "),_c('v-divider',{staticClass:"py-0 my-0"})],1):_c('v-flex',{attrs:{"xs12":"","py-0":"","pt-0":"","my-0":"","pl-3":""}},[_c('v-checkbox',{attrs:{"color":r.color,"label":r.title,"value":r.id,"hide-details":""},on:{"change":function($event){return _vm.remove(r.id)}},model:{value:(_vm.roles_array),callback:function ($$v) {_vm.roles_array=$$v},expression:"roles_array"}})],1)],1)}),1)],1)],1),_vm._v(" "),(_vm.c_user.edit)?_c('v-flex',{staticClass:"px-3 py-1 my-2 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("\n              New User Rights\n            ")])]):_vm._e(),_vm._v(" "),(_vm.c_user.edit)?_c('v-flex',{attrs:{"xs12":"","sm6":"","pl-3":""}},[_c('v-checkbox',{staticClass:"black--text dark",attrs:{"label":_vm.userFormData.edit ? 'Can Edit data' : 'Can\'t Edit data',"color":"red","hide-details":""},model:{value:(_vm.userFormData.edit),callback:function ($$v) {_vm.$set(_vm.userFormData, "edit", $$v)},expression:"userFormData.edit"}})],1):_vm._e(),_vm._v(" "),(_vm.c_user.edit)?_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-checkbox',{attrs:{"label":_vm.userFormData.delete_rights
                  ? 'Can Delete data'
                  : 'Can\'t Delete Data',"false-value":"0","true-value":"1","color":"red","hide-details":""},model:{value:(_vm.userFormData.delete_rights),callback:function ($$v) {_vm.$set(_vm.userFormData, "delete_rights", $$v)},expression:"userFormData.delete_rights"}})],1):_vm._e(),_vm._v(" "),(_vm.c_user.edit)?_c('v-flex',{attrs:{"xs12":"","sm6":"","pl-3":""}},[_c('v-checkbox',{attrs:{"label":_vm.userFormData.admin
                  ? 'Is Admin (Full access to all features)'
                  : 'Isn\'t Admin (Full access to all features)',"color":"red","hide-details":""},model:{value:(_vm.userFormData.admin),callback:function ($$v) {_vm.$set(_vm.userFormData, "admin", $$v)},expression:"userFormData.admin"}})],1):_vm._e(),_vm._v(" "),(_vm.c_user.edit)?_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-checkbox',{attrs:{"label":_vm.userFormData.enable ? 'User Enabled' : 'User Disabled',"false-value":"N","true-value":"Y","color":"red","hide-details":""},model:{value:(_vm.userFormData.enable),callback:function ($$v) {_vm.$set(_vm.userFormData, "enable", $$v)},expression:"userFormData.enable"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"px-3 py-1 my-2 mt-4 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("\n              Notifications Settings\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pl-3":""}},[_c('v-checkbox',{attrs:{"label":"New artwork added","color":"black","hide-details":""},model:{value:(_vm.userFormData.new_artwork_added),callback:function ($$v) {_vm.$set(_vm.userFormData, "new_artwork_added", $$v)},expression:"userFormData.new_artwork_added"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"label":"New artist added","color":"black","hide-details":""},model:{value:(_vm.userFormData.new_artist_added),callback:function ($$v) {_vm.$set(_vm.userFormData, "new_artist_added", $$v)},expression:"userFormData.new_artist_added"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pl-3":""}},[_c('v-checkbox',{attrs:{"label":"Artwork modified","color":"black","hide-details":""},model:{value:(_vm.userFormData.artwork_modified),callback:function ($$v) {_vm.$set(_vm.userFormData, "artwork_modified", $$v)},expression:"userFormData.artwork_modified"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-checkbox',{attrs:{"label":"Artist modified","color":"black","hide-details":""},model:{value:(_vm.userFormData.artist_modified),callback:function ($$v) {_vm.$set(_vm.userFormData, "artist_modified", $$v)},expression:"userFormData.artist_modified"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"px-3 py-1 my-2 mt-4 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("\n              Personal Settings\n            ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","pl-3":""}},[_c('v-checkbox',{attrs:{"label":"Expand Artist Artworks","color":"black","hide-details":""},model:{value:(_vm.userFormData.expand_artist_artworks),callback:function ($$v) {_vm.$set(_vm.userFormData, "expand_artist_artworks", $$v)},expression:"userFormData.expand_artist_artworks"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pl-3":"","pt-3":""}},[_c('v-select',{attrs:{"items":_vm.links,"label":"Where to go after login?"},model:{value:(_vm.userFormData.after_login_page),callback:function ($$v) {_vm.$set(_vm.userFormData, "after_login_page", $$v)},expression:"userFormData.after_login_page"}})],1),_vm._v(" "),(_vm.c_user.edit)?_c('v-flex',{staticClass:"px-3 py-1 my-2 mt-5 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("\n              Old CMS User Rights\n            ")])]):_vm._e(),_vm._v(" "),(_vm.c_user.edit)?_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"px-3",domProps:{"innerHTML":_vm._s(_vm.domains_to_string)}})]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.currentTab == 'History')?_c('v-layout',{attrs:{"row":"","wrap":""}},[[[_c('v-flex',{staticClass:"px-2 py-1 my-4 elevation-0 xs12",staticStyle:{"background-color":"#292929","color":"#eee"}},[_c('h3',{staticClass:"font-weight-bold subtitle xs12 flex"},[_vm._v("\n                  Updates by this user\n                ")])]),_vm._v(" "),_c('v-flex',{staticClass:"px-0 py-1 my-4 elevation-0 xs12"},[_c('v-card-title',[_c('v-toolbar-title',{staticClass:"elevation-0 ml-3 pt-3 pb-0"},[_vm._v("\n                    History of changes by this User\n                  ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{staticClass:"mr-3",attrs:{"append-icon":"search","label":"Search ","single-line":"","clearable":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-2 mx-4",attrs:{"search":_vm.search,"headers":_vm.headers,"items":_vm.user_journal,"item-key":"id","pagination":_vm.p},on:{"update:pagination":function($event){_vm.p=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticStyle:{"width":"100%","padding":"0px","margin":"0px","height":"100px !important"},attrs:{"colspan":"6"}},[_c('v-layout',{staticClass:"mx-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"subheading py-3 pl-4 text-xs-left xs2"},[_c('b',{staticClass:"title"},[_vm._v(_vm._s(_vm.format_date(props.item.created_at)))]),_c('br'),_vm._v(" "),_c('div',{staticClass:"body-1",domProps:{"innerHTML":_vm._s(_vm.format_journal_artwork(props.item))}}),_vm._v("\n                          in "+_vm._s(props.item.cms.toUpperCase())+" CMS"),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.value_name.split('_').join(' ')))])]),_vm._v(" "),_c('v-flex',{staticClass:"xs5"},[_c('v-layout',{staticClass:"content pr-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"xs1 pt-2"},[_c('v-btn',{staticClass:"ml-0 pl-0",attrs:{"disabled":!props.item.old_value,"icon":"","small":""},on:{"click":function($event){return _vm.viewText(props.item.old_value, 'Old')}}},[_c('v-icon',{attrs:{"color":props.item.old_value ? 'black' : 'grey',"small":""}},[_vm._v("remove_red_eye")])],1),_c('br'),_vm._v(" "),(_vm.c_user.edit)?_c('v-btn',{staticClass:"ml-0 pl-0",attrs:{"disabled":!props.item.old_value,"icon":"","small":""},on:{"click":function($event){return _vm.restoreValue(props.item, 'old_value')}}},[_c('v-icon',{attrs:{"color":"black","small":""}},[_vm._v("settings_backup_restore")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","py-3":""}},[_c('span',{staticClass:"multi-line",domProps:{"innerHTML":_vm._s(
                                  props.item.old_value == null
                                    ? ' &nbsp; &nbsp; &nbsp; '
                                    : props.item.old_value
                                )}})])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs5"},[_c('v-layout',{staticClass:"content pr-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"xs1 pt-2"},[_c('v-btn',{staticClass:"ml-0 pl-0",attrs:{"small":"","disabled":!props.item.new_value,"icon":""},on:{"click":function($event){return _vm.viewText(props.item.new_value, 'New')}}},[_c('v-icon',{attrs:{"color":props.item.new_value ? 'black' : 'grey',"small":""}},[_vm._v("remove_red_eye")])],1),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"ml-0 pl-0",attrs:{"disabled":!props.item.new_value,"icon":"","small":""},on:{"click":function($event){return _vm.restoreValue(props.item, 'new_value')}}},[_c('v-icon',{attrs:{"color":"black","small":""}},[_vm._v("settings_backup_restore")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","py-3":""}},[_c('span',{staticClass:"multi-line",domProps:{"innerHTML":_vm._s(
                                  props.item.new_value == null
                                    ? ' &nbsp; &nbsp; &nbsp; '
                                    : props.item.new_value
                                )}})])],1)],1)],1)],1)]}}],null,false,1899373216),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('center',[_vm._v("No data available")])],1)],2)],1),_vm._v(" "),(_vm.user_journal.length > 0)?_c('v-flex',{attrs:{"xs12":""}},_vm._l((_vm.user_journal.slice(0, 130)),function(item,index){return (_vm.journals.length > 0)?_c('v-card',{key:'j_' + item.id,staticClass:"mx-1 py-2 xs12 elevation-0 pt-3",staticStyle:{"border-top":"1px solid #ddd"}},[_c('v-card-title',{staticClass:"title px-3 py-0"},[_c('v-flex',[_vm._v(_vm._s(_vm.format_date(item.created_at))+" |\n                      "+_vm._s(item.value_name)+" changed")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticClass:"body-2 text-xs-right"},[_c('v-list-tile-action-text',[_vm._v("\n                        In "+_vm._s(item.cms)+" CMS")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('div',{staticClass:"body-1",domProps:{"innerHTML":_vm._s(_vm.format_journal_artwork(item))}}),_vm._v(" "),_c('div',{staticClass:"body-1 my-2",domProps:{"innerHTML":_vm._s(
                        '<b>OLD VALUE:</b> ' +
                        (item.old_value == null ? '' : item.old_value)
                      )}}),_vm._v(" "),_c('div',{staticClass:"body-1",domProps:{"innerHTML":_vm._s('<b>NEW VALUE:</b> ' + item.new_value)}})])],1):_vm._e()}),1):_vm._e()]]],2):_vm._e()],1),_vm._v(" "),_c('v-snackbar',{attrs:{"right":"","timeout":2500,"color":_vm.snackbar_color,"top":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(_vm._s(_vm.snackbar_text))])],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "yDEy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditFieldSub_vue__ = __webpack_require__("50M9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_678ad078_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFieldSub_vue__ = __webpack_require__("h8q7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("6ITe")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-678ad078"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditFieldSub_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_678ad078_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFieldSub_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_678ad078_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditFieldSub_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yLEp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return USER_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return USER_ERROR; });
var USER_REQUEST = 'USER_REQUEST';
var USER_SUCCESS = 'USER_SUCCESS';
var USER_ERROR = 'USER_ERROR';

/***/ }),

/***/ "yO6x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"width":"900"},model:{value:(_vm.view_dialog),callback:function ($$v) {_vm.view_dialog=$$v},expression:"view_dialog"}},[_c('v-card',{staticClass:"rounded-card"},[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("\n        "+_vm._s(_vm.oldNew)+" value preview\n      ")]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.view)}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},on:{"click":function($event){_vm.view_dialog = false}}},[_vm._v("\n          Close\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"490"},model:{value:(_vm.restore_dialog),callback:function ($$v) {_vm.restore_dialog=$$v},expression:"restore_dialog"}},[_c('v-card',{staticClass:"rounded-card px-2"},[(
          _vm.artwork[_vm.journal_to_restore.value_name] ==
            _vm.journal_to_restore[_vm.version_to_restore]
        )?_c('v-card-title',{staticClass:"headline"},[_vm._v("Current value is the same as the value you want to replace field\n        with.")]):_c('v-card-title',{staticClass:"headline"},[_vm._v("Are you sure to restore this field's value?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n        Current value: "),_c('br'),_c('b',[_vm._v(_vm._s(_vm.artwork[_vm.journal_to_restore.value_name]))]),_c('br'),_c('br'),_vm._v("\n        Restore this value: "),_c('br'),_c('b',[_vm._v(_vm._s(_vm.journal_to_restore[_vm.version_to_restore]))]),_c('br')]),_vm._v(" "),_c('v-card-actions',{staticClass:"pb-3"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"black darken-1","outline":""},on:{"click":function($event){_vm.restore_dialog = false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"dark":""},on:{"click":function($event){_vm.restore_dialog = false}}},[_vm._v("\n          Proceed\n        ")])],1)],1)],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"elevation-0 ml-4 pt-3 pb-0"},[_vm._v("\n      History of changes of this Artwork\n  ")]),_vm._v(" "),_c('v-card-title',[_c('v-layout',{attrs:{"row":"","mt-3":"","mx-2":""}},[_c('span',[_c('v-menu',{staticClass:"text-xs-left mx-0 my-0 py-0 align-left",attrs:{"offset-y":"","close-on-content-click":true},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
        var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-2 my-0 py-0",attrs:{"small":"","icon":"","color":"black","dark":""}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("supervisor_account")])],1)]}}])},[_vm._v(" "),_c('v-list',{attrs:{"value":"1"}},_vm._l((_vm.headers),function(header,index){return _c('v-list-tile',{key:index.id,on:{"click":function($event){return _vm.changeSort(header.value)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(header.text))])],1)}),1)],1)],1),_vm._v(" "),_c('span',{staticClass:"text-xs-left mt-1 pt-2 ml-3 subheading"},[_vm._v("\n        "+_vm._s(_vm.selectedSorting.toUpperCase().split("_").join(" "))+"\n      ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{staticClass:"mr-3",attrs:{"append-icon":"search","label":"Search ","single-line":"","clearable":"","hide-details":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 mx-4",attrs:{"search":_vm.search,"items":_vm.journals_store,"item-key":"id","pagination":_vm.p},on:{"update:pagination":function($event){_vm.p=$event}},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('v-layout',{staticClass:"my-2",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":"","pl-4":""}},[_vm._v("\n          Change date/Author/Field\n        ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","pl-2":""}},[_vm._v("\n          Old Value/Restore/Copy value\n        ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","pl-2":""}},[_vm._v("\n          New Value/Restore/Copy value\n        ")])],1),_vm._v(" "),_c('v-divider')]}},{key:"items",fn:function(props){return [_c('td',{staticStyle:{"width":"100%","padding":"0px","margin":"0px","height":"100px !important"},attrs:{"colspan":"6"}},[_c('v-layout',{staticClass:"mx-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"subheading py-3 pl-4 text-xs-left xs3"},[_c('b',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.format_date(props.item.created_at)))]),_c('br'),_vm._v(" "),(props.item.user_id)?_c('small',[_vm._v(_vm._s(_vm.get_abb(props.item.user_id))+" in\n              "+_vm._s(props.item.cms.toUpperCase())+" CMS")]):_vm._e(),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(props.item.value_name.split("_").join(" ")))])]),_vm._v(" "),_c('v-flex',{staticClass:"xs4"},[_c('v-layout',{staticClass:"content pr-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"xs1 pt-2"},[_c('v-btn',{staticClass:"ml-0 pl-0 mt-0 pt-0",attrs:{"icon":"","small":"","disabled":!props.item.old_value},on:{"click":function($event){return _vm.viewText(props.item.old_value, 'Old')}}},[_c('v-icon',{attrs:{"color":props.item.old_value ? 'black' : 'grey',"small":""}},[_vm._v("remove_red_eye")])],1),_c('br'),_vm._v(" "),(_vm.c_user.edit)?_c('v-btn',{staticClass:"ml-0 pl-0 mt-0 pt-0",attrs:{"icon":"","small":"","disabled":!props.item.old_value},on:{"click":function($event){return _vm.restoreValue(props.item, 'old_value')}}},[_c('v-icon',{attrs:{"color":"black","small":""}},[_vm._v("settings_backup_restore")])],1):_vm._e(),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"ml-0 pl-0 mt-0 pt-0",attrs:{"color":"primary","flat":"","icon":"","small":"","disabled":!props.item.old_value,"small":"","icon":""},on:{"click":function($event){return _vm.copy2c(props.item.old_value)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-content-copy")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pt-2":"","mt-1":"","pl-2":""}},[_c('span',{staticClass:"multi-line",domProps:{"innerHTML":_vm._s(
                    props.item.old_value == null
                      ? ' &nbsp; &nbsp; &nbsp; '
                      : _vm.value2string(props.item.old_value, props.item.value_name)
                  )}})])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs5"},[_c('v-layout',{staticClass:"content pr-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"xs1 pt-2"},[_c('v-btn',{staticClass:"ml-0 pl-0 mt-0 pt-0",attrs:{"small":"","disabled":!props.item.new_value,"icon":""},on:{"click":function($event){return _vm.viewText(props.item.new_value, 'New')}}},[_c('v-icon',{attrs:{"color":props.item.new_value ? 'black' : 'grey',"small":""}},[_vm._v("remove_red_eye")])],1),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"ml-0 pl-0 mt-0 pt-0",attrs:{"disabled":!props.item.new_value,"icon":"","small":""},on:{"click":function($event){return _vm.restoreValue(props.item, 'new_value')}}},[_c('v-icon',{attrs:{"color":"black","small":""}},[_vm._v("settings_backup_restore")])],1),_vm._v(" "),_c('v-btn',{staticClass:"ml-0 pl-0 mt-0 pt-0",attrs:{"color":"primary","flat":"","icon":"","small":"","disabled":!props.item.new_value,"small":"","icon":""},on:{"click":function($event){return _vm.copy2c(props.item.new_value)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-content-copy")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs11":"","pt-2":"","mt-1":"","pl-2":""}},[_c('span',{staticClass:"multi-line",domProps:{"innerHTML":_vm._s(
                    props.item.new_value == null
                      ? ' &nbsp; &nbsp; &nbsp; '
                      : _vm.value2string(props.item.new_value, props.item.value_name)
                  )}})])],1)],1)],1)],1)]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_c('center',[_vm._v("No data available")])],1)],2)],1)}
var staticRenderFns = []


/***/ }),

/***/ "yadK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-5 mx-2 px-0"},[_c('v-stepper',{staticClass:"elevation-0 mx-0",model:{value:(_vm.e1),callback:function ($$v) {_vm.e1=$$v},expression:"e1"}},[_c('v-stepper-header',{staticClass:"elevation-0 px-4 mb-0 pb-0"},[_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 1,"step":"1"}},[_vm._v("Select Artist")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 2,"step":"2"}},[_vm._v("Basic Info")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.e1 > 3,"step":"3"}},[_vm._v("Artwork Details")])],1),_vm._v(" "),_c('v-stepper-items',{staticClass:"mx-0"},[_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-4 elevation-0 mx-0"},[_c('v-card-title',{staticClass:"headline font-weight-medium pl-4"},[_vm._v("Add Artwork "+_vm._s(_vm.artwork.title.toUpperCase())+" to\n            Collection/Commission")]),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"item-text":"name","item-value":"id","label":"Select Artist","items":_vm.artists},on:{"input":function($event){return _vm.getArtist(_vm.artwork.artist_id)}},model:{value:(_vm.artwork.artist_id),callback:function ($$v) {_vm.$set(_vm.artwork, "artist_id", $$v)},expression:"artwork.artist_id"}})],1)],1)],1),_vm._v(" "),(_vm.processedArtist)?_c('div',{staticClass:"ml-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.processedArtist.name))]),_vm._v(" "),_c('div',[(_vm.processedArtist.birth_date)?_c('span',[_vm._v("Birthdate: "+_vm._s(_vm.processedArtist.birth_date)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.processedArtist.birthplace)?_c('span',[_vm._v("Birth place: "+_vm._s(_vm.processedArtist.birthplace)),_c('br')]):_vm._e(),_vm._v(" "),(_vm.processedArtist.bio)?_c('span',[_vm._v("Bio: "+_vm._s(_vm.processedArtist.bio)),_c('br')]):_vm._e()])])]),_vm._v(" "),_c('v-card-actions',[_c('v-checkbox',{staticClass:"ml-2",attrs:{"label":"Yes, this is the one","color":"black"},model:{value:(_vm.approved),callback:function ($$v) {_vm.approved=$$v},expression:"approved"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-btn',{staticClass:"mr-4 mb-3 right white--text",attrs:{"disabled":!_vm.approved || !_vm.processedArtist,"color":"black"},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{staticClass:"ml-4 mb-3",attrs:{"outline":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('v-stepper-content',{staticClass:"mb-2 mt-0 pt-0",attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-2 elevation-0 mt-0 pt-0",attrs:{"color":"white"}},[_c('v-container',{attrs:{"px-0":""}},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-xs":"","px-0":"","mx-0":"","xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"required":"","label":"Title *"},model:{value:(_vm.artwork.title),callback:function ($$v) {_vm.$set(_vm.artwork, "title", $$v)},expression:"artwork.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{staticClass:"ml-1",attrs:{"required":"","label":"Type of Work *","items":_vm.constants['TYPES_OF_WORK'],"item-value":"id","item-text":"name"},on:{"change":_vm.get_all_an},model:{value:(_vm.artwork.type_of_work_id),callback:function ($$v) {_vm.$set(_vm.artwork, "type_of_work_id", $$v)},expression:"artwork.type_of_work_id"}}),_vm._v(" "),(_vm.artwork.type_of_work_id == '3')?_c('v-flex',[_c('v-radio-group',{attrs:{"label":"Select Film Type","row":""},model:{value:(_vm.artwork.film_type),callback:function ($$v) {_vm.$set(_vm.artwork, "film_type", $$v)},expression:"artwork.film_type"}},_vm._l((['tape', 'film', 'digital born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s,"color":"black"}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.artwork.type_of_work_id == '6')?_c('v-flex',{staticClass:"xs12 mx-3 mb-5"},[_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-flex',{staticClass:"subheadline mt-4"},[_vm._v("Includes")]),_vm._v(" "),_vm._l((this.$store.state.includes),function(s){return _c('v-checkbox',{key:s.field,staticClass:"my-0 py-0",attrs:{"label":s.title,"false-value":0,"true-value":1,"hide-details":"","color":"black"},model:{value:(_vm.artwork[s.field]),callback:function ($$v) {_vm.$set(_vm.artwork, s.field, $$v)},expression:"artwork[s.field]"}})})],2),_vm._v(" "),(
                            _vm.artwork.instalation_includes.indexOf(
                              'FilmVideoAV'
                            ) >= 0
                          )?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-radio-group',{attrs:{"label":"Select Film Type","row":""},model:{value:(_vm.artwork.film_type),callback:function ($$v) {_vm.$set(_vm.artwork, "film_type", $$v)},expression:"artwork.film_type"}},_vm._l((['tape', 'film', 'digital born']),function(s){return _c('v-radio',{key:s,staticClass:"ml-3",attrs:{"label":s,"value":s,"color":"black"}})}),1)],1):_vm._e(),_vm._v(" "),(
                            _vm.artwork.instalation_includes.indexOf('Other') >= 0
                          )?_c('v-flex',{staticClass:"xs12 mx-3"},[_c('v-text-field',{staticClass:"ml-3",attrs:{"name":"including_other","label":"Other","row":""},model:{value:(_vm.artwork.instalation_includes_other),callback:function ($$v) {_vm.$set(_vm.artwork, "instalation_includes_other", $$v)},expression:"artwork.instalation_includes_other"}})],1):_vm._e()],1):_vm._e()],1),_vm._v(" "),(
                        _vm.artwork.type_of_work_id == '7' ||
                        (_vm.artwork.type_of_work_id == '6' &&
                          this.artwork.including_film == '1')
                      )?_c('v-flex',[_c('v-select',{staticClass:"ml-0",attrs:{"items":this.constants.CHANNELS,"item-value":"id","item-text":"name","label":"Channels"},model:{value:(_vm.artwork.fvs_channel_id),callback:function ($$v) {_vm.$set(_vm.artwork, "fvs_channel_id", $$v)},expression:"artwork.fvs_channel_id"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","mb-3":"","mt-3":""}},[_c('h3',{staticClass:"body-2 ml-1 pb-2 grey--text text--darken-1"},[_vm._v("\n                        Ownership Status\n                      ")]),_vm._v(" "),_c('v-btn-toggle',{attrs:{"required":"","small":""},on:{"change":_vm.get_all_an},model:{value:(_vm.artwork.acquired),callback:function ($$v) {_vm.$set(_vm.artwork, "acquired", $$v)},expression:"artwork.acquired"}},_vm._l(([
                            {
                              id: 'nontba',
                              value: 'nontba',
                              name: 'Non-TBA',
                            },
                            {
                              id: 'commission',
                              value: 'commission',
                              name: 'Commission',
                            },
                            {
                              id: 'acquired',
                              value: 'acquired',
                              name: 'Acquired',
                            },
                            {
                              id: 'com_academy',
                              value: 'com_academy',
                              name: 'TBA21-Academy Commission',
                            } ]),function(o){return _c('v-btn',{key:o.id,staticClass:"ml-1",attrs:{"flat":"","small":"","label":o.name,"value":o.id,"color":"black"}},[_vm._v("\n                          "+_vm._s(o.name)+"\n                        ")])}),1)],1),_vm._v(" "),(_vm.artwork.acquired == 'acquired')?_c('v-flex',{attrs:{"xs12":"","md6":"","mt-3":"","grey--text":"","text--darken-1":""}},[_c('h3',{staticClass:"body-2 ml-1"},[_vm._v("Ownership")]),_vm._v(" "),_c('v-radio-group',{attrs:{"required":"","column":"","label":""},on:{"change":_vm.get_all_an},model:{value:(_vm.artwork.ownership),callback:function ($$v) {_vm.$set(_vm.artwork, "ownership", $$v)},expression:"artwork.ownership"}},_vm._l((_vm.constants.OWNERSHIPS),function(o){return _c('v-radio',{key:o.id,staticClass:"ml-1",attrs:{"label":o.name,"value":o.id,"color":"black"}})}),1)],1):_vm._e()],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","px-0":"","mx-4":""}},[_c('v-flex',{attrs:{"text-xs-left":"","xs2":""}},[_c('v-btn',{staticClass:"ml-0 mb-3",attrs:{"outline":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Cancel")])],1),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-center pt-3 xs8"},[(!_vm.isValid)?_c('span',[_vm._v("Title and Type of Work must be filled in !")]):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-right":"","xs2":""}},[_c('v-btn',{staticClass:"mr-0 mb-3 white--text",attrs:{"disabled":!_vm.isValid,"color":"black"},nativeOn:{"click":function($event){_vm.e1 = 3}}},[_vm._v("Next")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-2 elevation-0 mt-0 pt-0",attrs:{"color":"white"}},[_c('v-container',{attrs:{"px-0":""}},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-container',{attrs:{"grid-list-xs":"","px-0":"","mx-0":"","xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","pr-3":"","grid":""}},[_c('v-text-field',{attrs:{"required":"","label":"Accession Number"},on:{"keyup":function($event){return _vm.check_an($event.target.value)}},scopedSlots:_vm._u([{key:"append-outer",fn:function(){return [_c('v-menu',{attrs:{"offset-x":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","small":"","dark":"","icon":""},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v("menu")])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.all_an_limited),function(item,i){return _c('v-list-tile',{key:item + i},[_c('v-list-tile-title',[_vm._v(_vm._s(item))])],1)}),1)],1)]},proxy:true}]),model:{value:(_vm.artwork.accession_number),callback:function ($$v) {_vm.$set(_vm.artwork, "accession_number", $$v)},expression:"artwork.accession_number"}}),_vm._v(" "),(_vm.an_exists)?_c('div',{staticClass:"red--text"},[_vm._v("\n                        This accession number already exists!\n                      ")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"required":"","label":"Production Year"},model:{value:(_vm.artwork.production_date_new),callback:function ($$v) {_vm.$set(_vm.artwork, "production_date_new", _vm._n($$v))},expression:"artwork.production_date_new"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"required":"","rows":"1","auto-grow":"","label":"Credit"},model:{value:(_vm.artwork.credit),callback:function ($$v) {_vm.$set(_vm.artwork, "credit", $$v)},expression:"artwork.credit"}})],1),_vm._v(" "),(
                        _vm.artwork.acquired != 'com_academy' &&
                        _vm.artwork.acquired != 'commission' &&
                        _vm.artwork.acquired != 'nontba'
                      )?_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('h3',{staticClass:"body-2 ml-1"},[_vm._v("Acquisition Method")]),_vm._v(" "),_c('v-radio-group',{attrs:{"required":"","column":"","label":""},model:{value:(_vm.artwork.acquisition_method),callback:function ($$v) {_vm.$set(_vm.artwork, "acquisition_method", $$v)},expression:"artwork.acquisition_method"}},_vm._l((this.constants.ACQUISITION_METHODS),function(o){return _c('v-radio',{key:o.id,staticClass:"ml-1",attrs:{"label":o.name,"value":o.id,"color":"black"}})}),1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{attrs:{"rows":"1","auto-grow":"","label":"Media Material Description"},model:{value:(_vm.artwork.media_material_description),callback:function ($$v) {_vm.$set(_vm.artwork, "media_material_description", $$v)},expression:"artwork.media_material_description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"label":"Location","items":_vm.locations,"item-value":"id","item-text":"name"},model:{value:(_vm.artwork.artwork_location_id),callback:function ($$v) {_vm.$set(_vm.artwork, "artwork_location_id", $$v)},expression:"artwork.artwork_location_id"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-menu',{ref:"menu2",attrs:{"disabled":!_vm.c_user.edit,"return-value":_vm.artwork.initial_change_date,"close-on-content-click":true,"nudge-right":40,"lazy":"","landscape":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(_vm.artwork, "initial_change_date", $event)},"update:return-value":function($event){return _vm.$set(_vm.artwork, "initial_change_date", $event)}},model:{value:(_vm.menu2),callback:function ($$v) {_vm.menu2=$$v},expression:"menu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Location Change Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.artwork.initial_change_date),callback:function ($$v) {_vm.$set(_vm.artwork, "initial_change_date", $$v)},expression:"artwork.initial_change_date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"color":"black","persistent":""},on:{"input":function($event){return _vm.$refs.menu2.save(_vm.artwork.initial_change_date)}},model:{value:(_vm.artwork.initial_change_date),callback:function ($$v) {_vm.$set(_vm.artwork, "initial_change_date", $$v)},expression:"artwork.initial_change_date"}})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mx-4"}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":"","px-0":"","mx-4":""}},[_c('v-flex',{attrs:{"text-xs-left":"","xs6":""}},[_c('v-btn',{staticClass:"ml-0 mb-3",attrs:{"outline":""},on:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Back")])],1),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-right":"","xs6":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"color":"black","disabled":!_vm.isValid},nativeOn:{"click":function($event){return _vm.saveArtwork(1)}}},[_vm._v("Save and Go to Artwork's page")])],1)],1)],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('h3',{staticClass:"title mb-2"},[_vm._v("\n          Please link images from cloud.tba21.org storage to this artwork:\n        ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5 pl-3 pr-3 pb-3",attrs:{"color":"grey lighten-4"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('br'),_vm._v(" "),_c('h3',{staticClass:"title mb-3"},[_vm._v("\n              Select Artist from Cloud TBA21 (Photo station -\n              "),_c('a',{attrs:{"href":"http://cloud.tba21.org"}},[_c('u',[_vm._v("cloud.tba21.org")])]),_vm._v(")\n            ")]),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":this.$store.state.artists,"item-value":"name","item-text":"name"},model:{value:(_vm.cloud_artist_folder_name),callback:function ($$v) {_vm.cloud_artist_folder_name=$$v},expression:"cloud_artist_folder_name"}}),_vm._v(" "),(!_vm.cloud_artist_folder_name == '')?_c('h3',{staticClass:"title mb-3"},[_vm._v("\n              Select Artwork\n            ")]):_vm._e(),_vm._v(" "),(!_vm.cloud_artist_folder_name == '')?_c('v-autocomplete',{attrs:{"items":this.$store.state.artworks,"item-value":"title","item-text":"title"},model:{value:(_vm.cloud_artwork_folder_name),callback:function ($$v) {_vm.cloud_artwork_folder_name=$$v},expression:"cloud_artwork_folder_name"}}):_vm._e()],1)],1),_vm._v(" "),_c('h3',{staticClass:"title mb-2"},[_vm._v("\n          No images in for this artwork in cloud yet? Upload temporary and\n          link cloud ones later:\n        ")]),_vm._v(" "),_c('v-card',{staticClass:"mb-5 pl-3 pr-3 pb-3",attrs:{"color":"grey lighten-4"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('br'),_vm._v(" "),_c('h3',{staticClass:"title mb-3"},[_vm._v("\n              Upload temporary images to \""+_vm._s(_vm.artwork.title)+"\"\n            ")])])],1),_vm._v(" "),_c('v-btn',{staticClass:"ml-2 black--text",attrs:{"color":"black","flat":""},nativeOn:{"click":function($event){_vm.e1 = 2}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{staticClass:"ml-3 white--text",attrs:{"color":"black","disabled":!_vm.isValid},nativeOn:{"click":function($event){return _vm.saveArtwork.apply(null, arguments)}}},[_vm._v("Save and Continue")])],1),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-card',{staticClass:"mb-5 pl-3 pr-3 pb-3",attrs:{"color":"grey lighten-4"}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('br'),_vm._v(" "),_c('h3',{staticClass:"title mb-3"},[_vm._v(_vm._s(_vm.artwork.title)+" - Actions")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.pdf.apply(null, arguments)}}},[_vm._v("Download PDF")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.push({
                  path: ("/artworks/edit/" + (_vm.artwork.id)),
                  params: _vm.artwork,
                })}}},[_vm._v("Go to Artwork Details Page")])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){_vm.e1 = 3}}},[_vm._v("Back")])],1)],1)],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "yo4V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yoWb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yuQp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactsTable_vue__ = __webpack_require__("0JL3");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7219576d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactsTable_vue__ = __webpack_require__("FNi1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("jUyp")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7219576d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7219576d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactsTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7219576d_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactsTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "yxwD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yzwb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"column":"","ma-3":""}},[(_vm.tagCheck.length > 0 && _vm.tag_names.length > 0)?_c('span',{staticClass:"black--text mr-3 mb-3"},_vm._l((_vm.tag_names),function(tn){return _c('span',{key:tn,staticClass:"white mr-3"},[_vm._v("#"+_vm._s(tn))])}),0):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"name":"search","label":"Search","id":"search","color":"white"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('h4',{staticClass:"white--text font-weight-thin mb-1"},[_vm._v("\n      Concept Tags "+_vm._s(_vm.conceptualSectionCheck.length)+" of "+_vm._s(_vm.conceptual_tags.length)+" selected\n    ")]),_vm._v(" "),_vm._l((_vm.conceptual_tag_categories),function(ts,index){return (_vm.conceptual_tag_categories.length > 0)?_c('v-flex',{key:ts.id,attrs:{"row":""}},[_c('p-check',{attrs:{"name":"checkSection$index","value":ts.name,"color":"white"},model:{value:(_vm.conceptualSectionCheck),callback:function ($$v) {_vm.conceptualSectionCheck=$$v},expression:"conceptualSectionCheck"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v(" "+_vm._s(ts.name))])]),_vm._v(" "),_vm._l((_vm.conceptual_tags.filter(function (c) { return c.subcategory === ts.name; })),function(tc){return (_vm.conceptual_tags.length > 0)?_c('v-flex',{key:tc['id'],attrs:{"ml-3":"","row":""}},[(_vm.conceptualSectionCheck.includes(tc['subcategory']))?_c('div',[_c('p-check',{attrs:{"name":"check$index","value":tc.id,"color":"white"},model:{value:(_vm.tagCheck),callback:function ($$v) {_vm.tagCheck=$$v},expression:"tagCheck"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[(tc.concept_tag == 1)?_c('span',{staticClass:"mx-0 px-0"},[_vm._v("★")]):_vm._e(),_vm._v("\n              "+_vm._s(tc['name'])+" ")])]),_vm._v(" "),_vm._l((_vm.getTags(tc.subcategory)),function(tag,tagindex){return _c('v-flex',{key:("t" + (tag.id)),attrs:{"ml-5":""}},[(_vm.check.includes(tag.subcategory))?_c('div',[_c('p-check',{attrs:{"name":"tagCheck$tagindex","value":tag.id,"color":"white"},model:{value:(_vm.tagCheck),callback:function ($$v) {_vm.tagCheck=$$v},expression:"tagCheck"}},[_c('label',{attrs:{"slot":"default"},slot:"default"},[_vm._v(_vm._s(tag.name))])])],1):_vm._e()])})],2):_vm._e()]):_vm._e()})],2):_vm._e()}),_vm._v(" "),_c('h4',{staticClass:"white--text font-weight-thin mt-3 mb-1"},[_vm._v("\n      Cataloguing tags "+_vm._s(_vm.sectionCheck.length)+" of "+_vm._s(_vm.cataloguing_tags.length)+" selected\n    ")]),_vm._v(" "),_vm._l((_vm.$store.getters.cataloguing_tag_subcategories),function(ts,index){return (_vm.$store.getters.cataloguing_tag_subcategories.length > 0)?_c('v-flex',{key:index,attrs:{"row":""}},[_c('p-check',{attrs:{"name":"checkSection$index","value":ts.subcategory,"color":"white"},model:{value:(_vm.sectionCheck),callback:function ($$v) {_vm.sectionCheck=$$v},expression:"sectionCheck"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v(_vm._s(ts.subcategory == '' ? 'NO SUBCATEGORY' : ts.subcategory))])]),_vm._v(" "),_vm._l((_vm.getSubcategoryTags(ts.subcategory)),function(tag,tagindex){return _c('v-flex',{key:("t" + (tag.id)),attrs:{"ml-3":""}},[(_vm.sectionCheck.includes(tag.subcategory))?_c('div',[_c('p-check',{attrs:{"name":"tagCheck$tagindex","value":tag.id,"color":"white"},model:{value:(_vm.tagCheck),callback:function ($$v) {_vm.tagCheck=$$v},expression:"tagCheck"}},[_c('label',{attrs:{"slot":"default"},slot:"default"},[_vm._v(_vm._s(tag.name))])])],1):_vm._e()])})],2):_vm._e()}),_vm._v(" "),_c('h4',{staticClass:"white--text font-weight-thin mt-3 mb-1"},[_vm._v("Relation tags")]),_vm._v(" "),_vm._l((_vm.$store.getters.tag_sections_relation),function(ts,index){return (_vm.$store.getters.tag_sections_relation.length > 0)?_c('v-flex',{key:"rt$index",attrs:{"row":""}},[_c('p-check',{attrs:{"name":"checkSection$index","value":ts,"color":"white"},model:{value:(_vm.sectionCheck),callback:function ($$v) {_vm.sectionCheck=$$v},expression:"sectionCheck"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v(_vm._s(ts))])]),_vm._v(" "),_vm._l((_vm.$store.getters.tag_categories.filter(
          function (c) { return c.section === ts; }
        )),function(tc){return (_vm.$store.getters.tag_categories.length > 0)?_c('v-flex',{key:tc['category'],attrs:{"ml-0":"","row":""}},[(_vm.sectionCheck.includes(tc['section']))?_c('div',{staticClass:"ml-4"},[_c('p-check',{attrs:{"name":"check$index","value":tc['category'],"color":"white"},model:{value:(_vm.check),callback:function ($$v) {_vm.check=$$v},expression:"check"}},[_c('label',{attrs:{"slot":"default","color":"white"},slot:"default"},[_vm._v(_vm._s(tc['category']))])]),_vm._v(" "),_vm._l((_vm.getTags(tc.category)),function(tag,tagindex){return _c('v-flex',{key:("t" + (tag.id)),attrs:{"ml-3":""}},[(_vm.check.includes(tag.category))?_c('div',[_c('p-check',{attrs:{"name":"tagCheck$tagindex","value":tag.id,"color":"white"},model:{value:(_vm.tagCheck),callback:function ($$v) {_vm.tagCheck=$$v},expression:"tagCheck"}},[_c('label',{attrs:{"slot":"default"},slot:"default"},[_vm._v(_vm._s(tag.name)+"::"+_vm._s(tag.field_value))])])],1):_vm._e()])})],2):_vm._e()]):_vm._e()})],2):_vm._e()})],2)],1)}
var staticRenderFns = []


/***/ }),

/***/ "z8t4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Selections_vue__ = __webpack_require__("YsD7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01aa04ea_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Selections_vue__ = __webpack_require__("E5D/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("l7Zr")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01aa04ea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = Object(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Selections_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01aa04ea_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Selections_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01aa04ea_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Selections_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zGT2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zdkS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake__ = __webpack_require__("EWlk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts__ = __webpack_require__("u1n8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_ListsMixin__ = __webpack_require__("ml9J");
//
//
//
//




__WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default.a.vfs = __WEBPACK_IMPORTED_MODULE_1_pdfmake_build_vfs_fonts___default.a.pdfMake.vfs;

function getLogo() {
    var request = new XMLHttpRequest();
    request.open('GET', 'https://api.tb-cms.org/vueimages/logo.txt', false);
    request.send(null);
    if (request.readyState === 4) {
        if (request.status === 200 && request.statusText === 'OK') {
            var type = request.getResponseHeader('Content-Type');
            if (type.indexOf('text') !== 1) {
                return request.responseText;
            }
        } else {
            return '';
        }
    }
    return request.responseText;
};

var logoImage = getLogo();
logoImage = logoImage.split('\n');

function dynamicSort(property, property2) {
    var sortOrder = 1;
    if (property[0] === '-') {
        sortOrder = -1;
        property = property.substr(1);
    }
    return function (a, b) {
        // var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
        if (a[property] > b[property]) return 1;
        if (a[property] < b[property]) return -1;
        if (a[property2] > b[property2]) return 1;
        if (a[property2] < b[property2]) return -1;
        // return result * sortOrder;
    };
}

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PDFGenerator',
    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_ListsMixin__["a" /* default */]],
    props: ['item', 'small', 'light', 'title', 'subtitle', 'created_by', 'created_at', 'page_no', 'showNoOfArtworks', 'sort', 'subsort', 'columns'],
    data: function data() {
        return {
            logo: logoImage, // Base64 encoded image data for logo
            docName: 'Document Name',
            artworks: [// Dummy array of artwork objects
            { number: '1', name: 'Artwork 1', artist: 'Artist 1', image: logoImage }, { number: '2', name: 'Artwork 2', artist: 'Artist 2', image: logoImage }, { number: '3', name: 'Artwork 3', artist: 'Artist 3', image: logoImage }],
            constants: constants,
            loading: false,
            outputFields: ['classification', 'ownership'],
            output_fields: [],
            list_settings: {
                use_current_selection: false,
                use_current_list_selection: false,
                financial_information: false,
                image: false,
                compact: false,
                table: true,
                view: 'table',
                sort: 'sort_name',
                add_empty_column: false
            },
            add_empty_column: false,
            imageSize1: '240',
            imageSize2: '240',
            pdf_artworks: []

        };
    },
    mounted: function mounted() {
        this.output_fields = this.columns;
        // Object.assign(
        //   [],
        //   this.$store.state.currentOutputFieldsSelection
        // )
    },

    methods: {
        pdfSoloCall: function pdfSoloCall(full) {
            this.loading = true;
            setTimeout(function () {
                setTimeout(function () {
                    this.pdf(full);
                    this.loading = false;
                }.bind(this), 0);
            }.bind(this), 500);
        },
        pdf: function pdf(full) {
            var _this = this;

            var docDefinition = {
                pageSize: 'A4',
                pageMargins: [40, 40, 40, 40],
                header: function header(currentPage, pageCount) {
                    if (currentPage !== 1) {
                        return [{
                            table: {
                                widths: ['66.66%', '33.33%'],
                                body: [[{ text: '', border: [false, false, false, false] }, { image: _this.logo, width: 200, height: 50, border: [false, false, false, false] }]]
                            },
                            layout: 'noBorders',
                            margin: [0, 0, 0, 40]
                        }];
                    }
                    return [];
                },
                footer: function footer(currentPage, pageCount) {
                    return { text: currentPage.toString() + ' of ' + pageCount, alignment: 'center' };
                },
                info: {
                    title: list_name,
                    author: username,
                    subject: list_name,
                    keywords: 'artwork names, artist names',
                    creationDate: created
                },
                styles: {
                    title: {
                        fontSize: 14,
                        all_caps: true,
                        alignment: 'right',
                        bold: true,
                        margin: [0, 33, 0, 0]
                    },
                    titleS: {
                        fontSize: 14,
                        all_caps: true,
                        alignment: 'right',
                        margin: [0, 33, 0, 0]
                    },
                    titleSub: { fontSize: 9, all_caps: true, alignment: 'right' },
                    titleDate: { fontSize: 9, alignment: 'right', bold: false },
                    createdAt: { fontSize: 9, alignment: 'right' },
                    createdBy: { fontSize: 9, alignment: 'right' },
                    bold: { fontSize: 9, bold: false },
                    normal: { fontSize: 9, bold: false },
                    artwork_title: { fontSize: 9, bold: true, margin: [0, 0, 0, 0] },
                    artwork_title_top: {
                        fontSize: 9,
                        bold: false,
                        margin: [0, 0, 0, 0]
                    },
                    artist_name: { fontSize: 9, italic: true, margin: [0, 25, 0, 0] },
                    image: { alignment: 'center', margin: [0, 0, 0, 0] },
                    logo: { alignment: 'left', margin: [0, 0, 0, 40] }
                },

                content: [{
                    image: this.logo,
                    width: 200,
                    height: 50
                }, {
                    text: this.docName,
                    fontSize: 20,
                    margin: [0, 0, 0, 10]
                }, {
                    text: 'Number of items: ' + this.artworks.length,
                    fontSize: 12,
                    margin: [0, 0, 0, 40]
                }]
            };

            var artworksData = [];
            this.artworks.forEach(function (artwork, index) {
                var page = Math.floor(index / (index < 3 ? 3 : 4)) + 1;
                if (!artworksData[page]) artworksData[page] = [];

                artworksData[page].push([{ text: artwork.number + '\n' + artwork.name + '\n' + artwork.artist, border: [false, false, false, false], alignment: 'top' }, { image: logoImage, fit: [100, 100], border: [false, false, false, false], alignment: 'top' }]);

                if ((index + 1) % (index < 3 ? 3 : 4) === 0) artworksData[page].push([]);
            });

            artworksData.forEach(function (artworks, index) {
                if (index === 0) docDefinition.content.push({ table: { widths: ['66.66%', '33.33%'], body: artworks }, layout: 'noBorders' });else docDefinition.content.push({ table: { widths: ['66.66%', '33.33%'], body: [[{ text: artwork.number + '\n' + artwork.name + '\n' + artwork.artist, border: [false, false, false, false] }, { image: artwork.image, fit: [100, 100], border: [false, false, false, false] }]] }, layout: 'noBorders', pageBreak: 'before' });
            });

            //     artworksData[page].push({
            //       table: {
            //         widths: ['66.66%', '33.33%'],
            //         body: [
            //           [{ text: artwork.number + '\n' + artwork.name + '\n' + artwork.artist, border: [false, false, false, false] }, { image: artwork.image, fit: [100, 100], border: [false, false, false, false] }]
            //         ]
            //       },
            //       layout: 'noBorders',
            //       margin: [0, 0, 0, 40],
            //     });

            //     if ((index + 1) % (index < 3 ? 3 : 4) === 0) artworksData[page].push({ text: '', pageBreak: 'after' });
            //   });

            //   artworksData.forEach((artworks, index) => {
            //     if (index === 0) docDefinition.content.push(...artworks);
            //     else docDefinition.content.push({ stack: artworks, pageBreak: 'before' });
            //   });
            __WEBPACK_IMPORTED_MODULE_0_pdfmake_build_pdfmake___default.a.createPdf(docDefinition).download();
        }
    }
});

/***/ }),

/***/ "zheF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-flex',{staticClass:"white",attrs:{"elevation-1":"","mx-4":"","mb-3":"","mt-2":""}},[_c('v-container',{attrs:{"grid-list-xs":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","pt-4":""}},[_c('v-textarea',{staticClass:"mr-4",attrs:{"disabled":!_vm.c_user.edit,"rows":"1","label":"Packing Specifications","value":_vm.artwork.transport_history,"auto-grow":""},on:{"input":function($event){_vm.artwork.transport_history = $event}}}),_vm._v(" "),(_vm.c_user.edit)?_c('v-btn',{staticClass:"mt-3 right",attrs:{"small":"","dark":""},on:{"click":_vm.saveField}},[_vm._v("save")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"editBG pl-2",attrs:{"flat":""}},[_c('v-menu',{staticClass:"text-xs-left ml-5 my-0 py-0 align-left left",attrs:{"offset-y":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"text-xs-right mx-0 mt-1 my-0 py-0",attrs:{"small":"","icon":"","color":"black","dark":""}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("sort")])],1)]}}])},[_vm._v(" "),_c('v-list',{attrs:{"value":"last_name"}},_vm._l(([
            'colli',
            'packing',
            'height',
            'width',
            'depth',
            'weight',
            'contents',
            'visa_status'
          ]),function(item,index){return _c('v-list-tile',{key:index,on:{"click":function($event){return _vm.setSorting(item)}}},[(item == _vm.sorting)?_c('v-list-tile-avatar',[(_vm.p.descending)?_c('v-icon',[_vm._v("mdi-sort-ascending")]):_c('v-icon',[_vm._v("mdi-sort-descending")])],1):_c('v-list-tile-avatar',[_c('v-icon')],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(item))])],1)}),1)],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"elevation-0 px-0 mx-0 left"},[_c('span',{staticClass:"left mx-0 px-0"},[_vm._v("Packings")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('excel-packings',{attrs:{"data":_vm.artwork,"small":"small","name":"Packings","fileName":"packings"}}),_vm._v(" "),(_vm.c_user.edit)?_c('v-btn',{staticClass:"mb-2",attrs:{"color":"black","dark":"","small":""},on:{"click":_vm.newItem}},[_vm._v("New Packing")]):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"600px","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-title',[(_vm.editing)?_c('span',{staticClass:"headline pl-4 pt-3 pb-0"},[_vm._v("Edit Packing")]):_c('span',{staticClass:"headline pl-4 pt-3 pb-0"},[_vm._v("Add Packing")])]),_vm._v(" "),_c('v-card-text',{staticClass:"pt-0"},[_c('v-container',{attrs:{"grid-list-xs":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"flex xs12 ",attrs:{"name":"colli","label":"Colli"},model:{value:(_vm.packing.colli),callback:function ($$v) {_vm.$set(_vm.packing, "colli", $$v)},expression:"packing.colli"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{staticClass:"flex xs12",attrs:{"name":"packing","label":"Packing"},model:{value:(_vm.packing.packing),callback:function ($$v) {_vm.$set(_vm.packing, "packing", $$v)},expression:"packing.packing"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{staticClass:"flex",attrs:{"suffix":" cm","name":"height","label":"Height"},model:{value:(_vm.packing.height),callback:function ($$v) {_vm.$set(_vm.packing, "height", $$v)},expression:"packing.height"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{staticClass:"flex pl-2",attrs:{"suffix":" cm","name":"width","label":"Width"},model:{value:(_vm.packing.width),callback:function ($$v) {_vm.$set(_vm.packing, "width", $$v)},expression:"packing.width"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{staticClass:"flex",attrs:{"suffix":" cm","name":"lenght","label":"Length"},model:{value:(_vm.packing.lenght),callback:function ($$v) {_vm.$set(_vm.packing, "lenght", $$v)},expression:"packing.lenght"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{staticClass:"flex pl-2",attrs:{"suffix":" kg","name":"weight","label":"Weigth"},model:{value:(_vm.packing.weight),callback:function ($$v) {_vm.$set(_vm.packing, "weight", $$v)},expression:"packing.weight"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-textarea',{staticClass:"flex xs12 ",attrs:{"rows":"1","auto-grow":"","name":"contents","label":"Contents"},model:{value:(_vm.packing.contents),callback:function ($$v) {_vm.$set(_vm.packing, "contents", $$v)},expression:"packing.contents"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","pl-3":""}},[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.packing.visa_status),callback:function ($$v) {_vm.$set(_vm.packing, "visa_status", $$v)},expression:"packing.visa_status"}},_vm._l((_vm.constants.VISA_STATUSES),function(vs){return _c('v-radio',{key:vs.id,staticClass:"pr-3",attrs:{"color":"black","value":vs.id,"label":vs.name}})}),1)],1),_vm._v(" "),(!_vm.editing)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{staticClass:"xs12 mt-3",attrs:{"clearable":"","items":this.selection_items,"label":("Select Location " + (this.artwork.artwork_location_id == this.packing.artwork_location_id ? ' - taken from main Artwork' : '(Artwork is at: ' + _vm.get_location_name(this.artwork.artwork_location_id) + ')')),"item-text":"name","item-value":"id"},model:{value:(_vm.packing.artwork_location_id),callback:function ($$v) {_vm.$set(_vm.packing, "artwork_location_id", $$v)},expression:"packing.artwork_location_id"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu_storage_in),callback:function ($$v) {_vm.menu_storage_in=$$v},expression:"menu_storage_in"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Storage in","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.packing.storage_in),callback:function ($$v) {_vm.$set(_vm.packing, "storage_in", $$v)},expression:"packing.storage_in"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.menu_storage_in = false}},model:{value:(_vm.packing.storage_in),callback:function ($$v) {_vm.$set(_vm.packing, "storage_in", $$v)},expression:"packing.storage_in"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.menu_storage_out),callback:function ($$v) {_vm.menu_storage_out=$$v},expression:"menu_storage_out"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Storage out","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.packing.storage_out),callback:function ($$v) {_vm.$set(_vm.packing, "storage_out", $$v)},expression:"packing.storage_out"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.menu_storage_out = false}},model:{value:(_vm.packing.storage_out),callback:function ($$v) {_vm.$set(_vm.packing, "storage_out", $$v)},expression:"packing.storage_out"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"mr-3 pr-4 pb-5"},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"small":"","flat":""},nativeOn:{"click":function($event){return _vm.close.apply(null, arguments)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","dark":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("Save")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400px"},model:{value:(_vm.deleteDialog),callback:function ($$v) {_vm.deleteDialog=$$v},expression:"deleteDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Are you sure you want to delete this Packing?")]),_vm._v(" "),_c('v-card-text',[_vm._v("This Packing will be deleted.")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"flat"},on:{"click":_vm.cancelDelete}},[_vm._v("No")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red darken-1","flat":"flat"},on:{"click":_vm.deleteItem}},[_vm._v("Yes")])],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 mx-4",attrs:{"headers":_vm.headers,"hide-headers":"","pagination":_vm.p,"items":_vm.artwork.artwork_packings,"item-key":"id","hide-actions":""},on:{"update:pagination":function($event){_vm.p=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{staticClass:"py-0 my-0"},[_c('td',{attrs:{"colspan":"2"}},[_c('span',{staticClass:"subheadline pl-0"},[_c('b',[_vm._v(_vm._s(props.item.colli)+" / "+_vm._s(props.item.packing))]),_vm._v(" "),(props.item.artwork_location_id)?_c('i',[_c('br'),_vm._v(_vm._s(_vm.get_location_name(props.item.artwork_location_id)))]):_vm._e()])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"subheadline pl-0"},[_vm._v("\n            "+_vm._s(props.item.contents)+"\n          ")])]),_vm._v(" "),_c('td',{staticClass:"px-0 text-xs-center"},[_c('span',{staticClass:"subheadline pl-0"},[_vm._v("\n            "+_vm._s(_vm.get_visa_status(props.item.visa_status))+"\n          ")])]),_vm._v(" "),_c('td',{staticClass:"px-0 text-xs-center"},[_c('span',{staticClass:"subheadline"},[_vm._v("\n            "+_vm._s(props.item.height)+" x "+_vm._s(props.item.width)+" x\n            "+_vm._s(props.item.lenght)+" cm\n          ")])]),_vm._v(" "),_c('td',{staticClass:"px-0 text-xs-center"},[(props.item.weight)?_c('span',{staticClass:"subheadline pl-0"},[_vm._v("\n            "+_vm._s(props.item.weight)+" kg\n          ")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"px-2 text-xs-right"},[(_vm.c_user.edit)?_c('v-btn',{staticClass:"pa-0 ma-0",attrs:{"flat":"","icon":"","small":""}},[_c('v-icon',{attrs:{"small":"","pa-0":"","ma-0":""},on:{"click":function($event){return _vm.duplicateItem(props.item)}}},[_vm._v("file_copy")])],1):_vm._e(),_vm._v(" "),(_vm.c_user.edit)?_c('v-btn',{staticClass:"pa-0 ma-0",attrs:{"flat":"","icon":"","small":""}},[_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),(_vm.c_user.delete_rights)?_c('v-btn',{staticClass:"pa-0 ma-0",attrs:{"flat":"","icon":"","small":""}},[_c('v-icon',{attrs:{"small":""},on:{"click":function($event){return _vm.showDeleteDialog(props.item)}}},[_vm._v("delete")])],1):_vm._e()],1)])]}}]),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('center',[_vm._v("No data available.")])],1)],2)],1)}
var staticRenderFns = []


/***/ }),

/***/ "zrJT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.6b556df841801775e9d9.js